/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 228);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(234);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(257)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var cov_253yn4d5u8=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\index.js',hash='abb12433e27fc5257060e8f75fb3eeda0208fd89',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\index.js',statementMap:{'0':{start:{line:1,column:12},end:{line:1,column:70}},'1':{start:{line:3,column:0},end:{line:6,column:2}},'2':{start:{line:4,column:24},end:{line:4,column:68}},'3':{start:{line:5,column:2},end:{line:5,column:50}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:19},end:{line:3,column:20}},loc:{start:{line:3,column:28},end:{line:6,column:1}},line:3}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var req=(cov_253yn4d5u8.s[0]++,__webpack_require__(380));cov_253yn4d5u8.s[1]++;req.keys().forEach(function(key){cov_253yn4d5u8.f[0]++;var componentName=(cov_253yn4d5u8.s[2]++,key.replace(/^.+\/([^/]+)\/index\.js/,'$1'));cov_253yn4d5u8.s[3]++;module.exports[componentName]=req(key).default;});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return HELPERS_MENU_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return HELPERS_MENU_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return HELPERS_BLUR_APPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return HELPERS_BLUR_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return HELPERS_NOTIFICATIONS_MACHINES_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return HELPERS_COUNTRIES_STATES_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return HELPERS_COUNTRIES_STATES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return HELPERS_COUNTRIES_STATES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return HELPERS_DESIGNUPLOAD_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return HELPERS_DESIGNUPLOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return HELPERS_DESIGNUPLOAD_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return HELPERS_DESIGNUPLOAD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return HELPERS_DESIGNUPLOAD_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AUTH_SET_MELCO_ACCOUNT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTH_REMOVE_MELCO_ACCOUNT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_CHANGE_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTH_LOGOUT_ON_SERVER_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTH_LOGOUT_ON_SERVER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTH_LOGOUT_ON_SERVER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return TOKEN_RESTORE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return TOKEN_RESTORE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return TOKEN_RESTORE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_STARTUP_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_STARTUP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_STARTUP_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return TRANSLATION_LOAD_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return TRANSLATION_LOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return TRANSLATION_LOAD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return DEFAULTS_GET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return DEFAULTS_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return DEFAULTS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return DEFAULTS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SETTINGS_COMPANY_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return SETTINGS_COMPANY_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SETTINGS_COMPANY_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return SETTINGS_COMPANY_UPDATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return SETTINGS_COMPANY_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return SETTINGS_COMPANY_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return SETTINGS_COMPANY_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return SETTINGS_COMPANY_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CALCULATOR_JOBS_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CALCULATOR_JOBS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CALCULATOR_JOBS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CALCULATOR_JOBS_DEFAULTS_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CALCULATOR_JOBS_DEFAULTS_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CALCULATOR_JOB_CREATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CALCULATOR_JOB_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CALCULATOR_JOB_CREATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CALCULATOR_JOB_CREATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CALCULATOR_JOB_DUPLICATECHECK_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CALCULATOR_JOB_DUPLICATECHECK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CALCULATOR_JOB_DUPLICATECHECK_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CALCULATOR_JOB_DUPLICATECHECK_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return CALCULATOR_JOB_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return CALCULATOR_JOB_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CALCULATOR_JOB_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CALCULATOR_JOB_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return CALCULATOR_JOB_MESSAGE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return CALCULATOR_JOB_MESSAGE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return CALCULATOR_JOB_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return CALCULATOR_JOB_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CALCULATOR_JOB_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return CALCULATOR_JOB_UPDATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return CALCULATOR_JOB_MACHINE_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CALCULATOR_JOB_MACHINE_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CALCULATOR_JOB_MACHINE_UPDATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return CALCULATOR_JOB_MACHINE_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CALCULATOR_JOB_MACHINE_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return CALCULATOR_JOB_MACHINE_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return CALCULATOR_JOB_MACHINE_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CALCULATOR_JOB_CALCULATIONS_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CALCULATOR_JOB_CALCULATIONS_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CALCULATOR_JOB_EXPORT_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CALCULATOR_JOB_EXPORT_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CALCULATOR_JOB_EXPORT_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CALCULATOR_JOB_EXPORT_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CALCULATOR_JOB_DELETE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CALCULATOR_JOB_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CALCULATOR_JOB_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CALCULATOR_JOB_DELETE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CALCULATOR_JOB_CHANGEACTIVE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CALCULATOR_JOB_CHANGEACTIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CALCULATOR_JOB_CHANGEACTIVE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CALCULATOR_JOB_CHANGEACTIVE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return CALCULATOR_JOB_RECALCULATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CALCULATOR_JOB_RECALCULATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return CALCULATOR_JOB_RECALCULATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return CALCULATOR_JOB_RECALCULATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CALCULATOR_JOB_DETAILED_CALCULATION_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CALCULATOR_JOB_DETAILED_CALCULATION_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CALCULATOR_JOB_DETAILED_CALCULATION_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return CALCULATOR_MACHINES_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return CALCULATOR_MACHINES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CALCULATOR_MACHINES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CALCULATOR_MACHINES_DEFAULTS_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return CALCULATOR_MACHINE_CREATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return CALCULATOR_MACHINE_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return CALCULATOR_MACHINE_CREATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return CALCULATOR_MACHINE_CREATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return CALCULATOR_MACHINE_FETCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return CALCULATOR_MACHINE_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return CALCULATOR_MACHINE_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return CALCULATOR_MACHINE_FETCH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return CALCULATOR_MACHINE_UPDATE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return CALCULATOR_MACHINE_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return CALCULATOR_MACHINE_UPDATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return CALCULATOR_MACHINE_UPDATE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return CALCULATOR_MACHINE_DELETE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return CALCULATOR_MACHINE_DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return CALCULATOR_MACHINE_DELETE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return CALCULATOR_MACHINE_DELETE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return CALCULATOR_MACHINE_DUPLICATECHECK_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return CALCULATOR_MACHINE_DUPLICATECHECK_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return CALCULATOR_MACHINE_DUPLICATECHECK_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return FETCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return NOT_FETCHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return PRINTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return NOT_PRINTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return VISUALMESSAGE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return VISUALMESSAGE_SET; });
var cov_143fy6wmj4=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\actionTypes.js',hash='464775ac1eab03df712e00d1cfc72fab325a040e',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\actionTypes.js',statementMap:{'0':{start:{line:1,column:33},end:{line:1,column:52}},'1':{start:{line:2,column:34},end:{line:2,column:54}},'2':{start:{line:3,column:35},end:{line:3,column:56}},'3':{start:{line:4,column:35},end:{line:4,column:56}},'4':{start:{line:6,column:58},end:{line:6,column:102}},'5':{start:{line:7,column:60},end:{line:7,column:106}},'6':{start:{line:8,column:57},end:{line:8,column:100}},'7':{start:{line:10,column:52},end:{line:10,column:90}},'8':{start:{line:11,column:54},end:{line:11,column:94}},'9':{start:{line:12,column:51},end:{line:12,column:88}},'10':{start:{line:14,column:42},end:{line:14,column:70}},'11':{start:{line:15,column:44},end:{line:15,column:74}},'12':{start:{line:16,column:42},end:{line:16,column:70}},'13':{start:{line:17,column:41},end:{line:17,column:68}},'14':{start:{line:18,column:45},end:{line:18,column:76}},'15':{start:{line:20,column:43},end:{line:20,column:72}},'16':{start:{line:21,column:46},end:{line:21,column:78}},'17':{start:{line:22,column:40},end:{line:22,column:66}},'18':{start:{line:23,column:43},end:{line:23,column:72}},'19':{start:{line:24,column:45},end:{line:24,column:76}},'20':{start:{line:25,column:42},end:{line:25,column:70}},'21':{start:{line:27,column:35},end:{line:27,column:56}},'22':{start:{line:28,column:37},end:{line:28,column:60}},'23':{start:{line:29,column:34},end:{line:29,column:54}},'24':{start:{line:31,column:33},end:{line:31,column:52}},'25':{start:{line:32,column:35},end:{line:32,column:56}},'26':{start:{line:33,column:32},end:{line:33,column:50}},'27':{start:{line:35,column:38},end:{line:35,column:62}},'28':{start:{line:36,column:40},end:{line:36,column:66}},'29':{start:{line:37,column:37},end:{line:37,column:60}},'30':{start:{line:39,column:28},end:{line:39,column:42}},'31':{start:{line:40,column:36},end:{line:40,column:58}},'32':{start:{line:41,column:38},end:{line:41,column:62}},'33':{start:{line:42,column:35},end:{line:42,column:56}},'34':{start:{line:44,column:45},end:{line:44,column:76}},'35':{start:{line:45,column:47},end:{line:45,column:80}},'36':{start:{line:46,column:44},end:{line:46,column:74}},'37':{start:{line:47,column:45},end:{line:47,column:76}},'38':{start:{line:48,column:44},end:{line:48,column:74}},'39':{start:{line:49,column:46},end:{line:49,column:78}},'40':{start:{line:50,column:43},end:{line:50,column:72}},'41':{start:{line:51,column:44},end:{line:51,column:74}},'42':{start:{line:53,column:43},end:{line:53,column:72}},'43':{start:{line:54,column:45},end:{line:54,column:76}},'44':{start:{line:55,column:42},end:{line:55,column:70}},'45':{start:{line:56,column:52},end:{line:56,column:90}},'46':{start:{line:57,column:54},end:{line:57,column:94}},'47':{start:{line:58,column:51},end:{line:58,column:88}},'48':{start:{line:59,column:53},end:{line:59,column:92}},'49':{start:{line:60,column:55},end:{line:60,column:96}},'50':{start:{line:61,column:52},end:{line:61,column:90}},'51':{start:{line:62,column:53},end:{line:62,column:92}},'52':{start:{line:64,column:43},end:{line:64,column:72}},'53':{start:{line:65,column:45},end:{line:65,column:76}},'54':{start:{line:66,column:42},end:{line:66,column:70}},'55':{start:{line:67,column:43},end:{line:67,column:72}},'56':{start:{line:68,column:51},end:{line:68,column:88}},'57':{start:{line:69,column:53},end:{line:69,column:92}},'58':{start:{line:70,column:50},end:{line:70,column:86}},'59':{start:{line:71,column:51},end:{line:71,column:88}},'60':{start:{line:72,column:42},end:{line:72,column:70}},'61':{start:{line:73,column:44},end:{line:73,column:74}},'62':{start:{line:74,column:41},end:{line:74,column:68}},'63':{start:{line:75,column:42},end:{line:75,column:70}},'64':{start:{line:76,column:42},end:{line:76,column:70}},'65':{start:{line:77,column:44},end:{line:77,column:74}},'66':{start:{line:78,column:43},end:{line:78,column:72}},'67':{start:{line:79,column:45},end:{line:79,column:76}},'68':{start:{line:80,column:42},end:{line:80,column:70}},'69':{start:{line:81,column:43},end:{line:81,column:72}},'70':{start:{line:82,column:51},end:{line:82,column:88}},'71':{start:{line:83,column:53},end:{line:83,column:92}},'72':{start:{line:84,column:50},end:{line:84,column:86}},'73':{start:{line:85,column:51},end:{line:85,column:88}},'74':{start:{line:86,column:50},end:{line:86,column:86}},'75':{start:{line:87,column:52},end:{line:87,column:90}},'76':{start:{line:88,column:49},end:{line:88,column:84}},'77':{start:{line:89,column:50},end:{line:89,column:86}},'78':{start:{line:90,column:55},end:{line:90,column:96}},'79':{start:{line:91,column:57},end:{line:91,column:100}},'80':{start:{line:92,column:54},end:{line:92,column:94}},'81':{start:{line:93,column:55},end:{line:93,column:96}},'82':{start:{line:94,column:49},end:{line:94,column:84}},'83':{start:{line:95,column:51},end:{line:95,column:88}},'84':{start:{line:96,column:48},end:{line:96,column:82}},'85':{start:{line:97,column:49},end:{line:97,column:84}},'86':{start:{line:98,column:43},end:{line:98,column:72}},'87':{start:{line:99,column:45},end:{line:99,column:76}},'88':{start:{line:100,column:42},end:{line:100,column:70}},'89':{start:{line:101,column:43},end:{line:101,column:72}},'90':{start:{line:102,column:49},end:{line:102,column:84}},'91':{start:{line:103,column:51},end:{line:103,column:88}},'92':{start:{line:104,column:48},end:{line:104,column:82}},'93':{start:{line:105,column:49},end:{line:105,column:84}},'94':{start:{line:106,column:48},end:{line:106,column:82}},'95':{start:{line:107,column:50},end:{line:107,column:86}},'96':{start:{line:108,column:47},end:{line:108,column:80}},'97':{start:{line:109,column:48},end:{line:109,column:82}},'98':{start:{line:110,column:57},end:{line:110,column:100}},'99':{start:{line:111,column:59},end:{line:111,column:104}},'100':{start:{line:112,column:56},end:{line:112,column:98}},'101':{start:{line:113,column:57},end:{line:113,column:100}},'102':{start:{line:115,column:47},end:{line:115,column:80}},'103':{start:{line:116,column:49},end:{line:116,column:84}},'104':{start:{line:117,column:46},end:{line:117,column:78}},'105':{start:{line:118,column:56},end:{line:118,column:98}},'106':{start:{line:119,column:58},end:{line:119,column:102}},'107':{start:{line:120,column:55},end:{line:120,column:96}},'108':{start:{line:121,column:47},end:{line:121,column:80}},'109':{start:{line:122,column:49},end:{line:122,column:84}},'110':{start:{line:123,column:46},end:{line:123,column:78}},'111':{start:{line:124,column:47},end:{line:124,column:80}},'112':{start:{line:125,column:46},end:{line:125,column:78}},'113':{start:{line:126,column:48},end:{line:126,column:82}},'114':{start:{line:127,column:45},end:{line:127,column:76}},'115':{start:{line:128,column:46},end:{line:128,column:78}},'116':{start:{line:129,column:47},end:{line:129,column:80}},'117':{start:{line:130,column:49},end:{line:130,column:84}},'118':{start:{line:131,column:46},end:{line:131,column:78}},'119':{start:{line:132,column:47},end:{line:132,column:80}},'120':{start:{line:133,column:47},end:{line:133,column:80}},'121':{start:{line:134,column:49},end:{line:134,column:84}},'122':{start:{line:135,column:46},end:{line:135,column:78}},'123':{start:{line:136,column:47},end:{line:136,column:80}},'124':{start:{line:137,column:55},end:{line:137,column:96}},'125':{start:{line:138,column:57},end:{line:138,column:100}},'126':{start:{line:139,column:54},end:{line:139,column:94}},'127':{start:{line:140,column:55},end:{line:140,column:96}},'128':{start:{line:142,column:24},end:{line:142,column:34}},'129':{start:{line:143,column:28},end:{line:143,column:42}},'130':{start:{line:145,column:24},end:{line:145,column:34}},'131':{start:{line:146,column:28},end:{line:146,column:42}},'132':{start:{line:148,column:35},end:{line:148,column:56}},'133':{start:{line:149,column:33},end:{line:149,column:52}}},fnMap:{},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0,'115':0,'116':0,'117':0,'118':0,'119':0,'120':0,'121':0,'122':0,'123':0,'124':0,'125':0,'126':0,'127':0,'128':0,'129':0,'130':0,'131':0,'132':0,'133':0},f:{},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var HELPERS_MENU_OPEN=(cov_143fy6wmj4.s[0]++,'HELPERS_MENU_OPEN');var HELPERS_MENU_CLOSE=(cov_143fy6wmj4.s[1]++,'HELPERS_MENU_CLOSE');var HELPERS_BLUR_APPEND=(cov_143fy6wmj4.s[2]++,'HELPERS_BLUR_APPEND');var HELPERS_BLUR_REMOVE=(cov_143fy6wmj4.s[3]++,'HELPERS_BLUR_REMOVE');var HELPERS_NOTIFICATIONS_MACHINES_FETCH_START=(cov_143fy6wmj4.s[4]++,'HELPERS_NOTIFICATIONS_MACHINES_FETCH_START');var HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS=(cov_143fy6wmj4.s[5]++,'HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS');var HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL=(cov_143fy6wmj4.s[6]++,'HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL');var HELPERS_COUNTRIES_STATES_FETCH_START=(cov_143fy6wmj4.s[7]++,'HELPERS_COUNTRIES_STATES_FETCH_START');var HELPERS_COUNTRIES_STATES_FETCH_SUCCESS=(cov_143fy6wmj4.s[8]++,'HELPERS_COUNTRIES_STATES_FETCH_SUCCESS');var HELPERS_COUNTRIES_STATES_FETCH_FAIL=(cov_143fy6wmj4.s[9]++,'HELPERS_COUNTRIES_STATES_FETCH_FAIL');var HELPERS_DESIGNUPLOAD_START=(cov_143fy6wmj4.s[10]++,'HELPERS_DESIGNUPLOAD_START');var HELPERS_DESIGNUPLOAD_SUCCESS=(cov_143fy6wmj4.s[11]++,'HELPERS_DESIGNUPLOAD_SUCCESS');var HELPERS_DESIGNUPLOAD_RESET=(cov_143fy6wmj4.s[12]++,'HELPERS_DESIGNUPLOAD_RESET');var HELPERS_DESIGNUPLOAD_FAIL=(cov_143fy6wmj4.s[13]++,'HELPERS_DESIGNUPLOAD_FAIL');var HELPERS_DESIGNUPLOAD_PROGRESS=(cov_143fy6wmj4.s[14]++,'HELPERS_DESIGNUPLOAD_PROGRESS');var AUTH_SET_MELCO_ACCOUNT_DATA=(cov_143fy6wmj4.s[15]++,'AUTH_SET_MELCO_ACCOUNT_DATA');var AUTH_REMOVE_MELCO_ACCOUNT_DATA=(cov_143fy6wmj4.s[16]++,'AUTH_REMOVE_MELCO_ACCOUNT_DATA');var AUTH_CHANGE_CURRENT_USER=(cov_143fy6wmj4.s[17]++,'AUTH_CHANGE_CURRENT_USER');var AUTH_LOGOUT_ON_SERVER_START=(cov_143fy6wmj4.s[18]++,'AUTH_LOGOUT_ON_SERVER_START');var AUTH_LOGOUT_ON_SERVER_SUCCESS=(cov_143fy6wmj4.s[19]++,'AUTH_LOGOUT_ON_SERVER_SUCCESS');var AUTH_LOGOUT_ON_SERVER_FAIL=(cov_143fy6wmj4.s[20]++,'AUTH_LOGOUT_ON_SERVER_FAIL');var TOKEN_RESTORE_START=(cov_143fy6wmj4.s[21]++,'TOKEN_RESTORE_START');var TOKEN_RESTORE_SUCCESS=(cov_143fy6wmj4.s[22]++,'TOKEN_RESTORE_SUCCESS');var TOKEN_RESTORE_FAIL=(cov_143fy6wmj4.s[23]++,'TOKEN_RESTORE_FAIL');var APP_STARTUP_START=(cov_143fy6wmj4.s[24]++,'APP_STARTUP_START');var APP_STARTUP_SUCCESS=(cov_143fy6wmj4.s[25]++,'APP_STARTUP_SUCCESS');var APP_STARTUP_FAIL=(cov_143fy6wmj4.s[26]++,'APP_STARTUP_FAIL');var TRANSLATION_LOAD_START=(cov_143fy6wmj4.s[27]++,'TRANSLATION_LOAD_START');var TRANSLATION_LOAD_SUCCESS=(cov_143fy6wmj4.s[28]++,'TRANSLATION_LOAD_SUCCESS');var TRANSLATION_LOAD_FAIL=(cov_143fy6wmj4.s[29]++,'TRANSLATION_LOAD_FAIL');var DEFAULTS_GET=(cov_143fy6wmj4.s[30]++,'DEFAULTS_GET');var DEFAULTS_FETCH_START=(cov_143fy6wmj4.s[31]++,'DEFAULTS_FETCH_START');var DEFAULTS_FETCH_SUCCESS=(cov_143fy6wmj4.s[32]++,'DEFAULTS_FETCH_SUCCESS');var DEFAULTS_FETCH_FAIL=(cov_143fy6wmj4.s[33]++,'DEFAULTS_FETCH_FAIL');var SETTINGS_COMPANY_UPDATE_START=(cov_143fy6wmj4.s[34]++,'SETTINGS_COMPANY_UPDATE_START');var SETTINGS_COMPANY_UPDATE_SUCCESS=(cov_143fy6wmj4.s[35]++,'SETTINGS_COMPANY_UPDATE_SUCCESS');var SETTINGS_COMPANY_UPDATE_FAIL=(cov_143fy6wmj4.s[36]++,'SETTINGS_COMPANY_UPDATE_FAIL');var SETTINGS_COMPANY_UPDATE_RESET=(cov_143fy6wmj4.s[37]++,'SETTINGS_COMPANY_UPDATE_RESET');var SETTINGS_COMPANY_FETCH_START=(cov_143fy6wmj4.s[38]++,'SETTINGS_COMPANY_FETCH_START');var SETTINGS_COMPANY_FETCH_SUCCESS=(cov_143fy6wmj4.s[39]++,'SETTINGS_COMPANY_FETCH_SUCCESS');var SETTINGS_COMPANY_FETCH_FAIL=(cov_143fy6wmj4.s[40]++,'SETTINGS_COMPANY_FETCH_FAIL');var SETTINGS_COMPANY_FETCH_RESET=(cov_143fy6wmj4.s[41]++,'SETTINGS_COMPANY_FETCH_RESET');var CALCULATOR_JOBS_FETCH_START=(cov_143fy6wmj4.s[42]++,'CALCULATOR_JOBS_FETCH_START');var CALCULATOR_JOBS_FETCH_SUCCESS=(cov_143fy6wmj4.s[43]++,'CALCULATOR_JOBS_FETCH_SUCCESS');var CALCULATOR_JOBS_FETCH_FAIL=(cov_143fy6wmj4.s[44]++,'CALCULATOR_JOBS_FETCH_FAIL');var CALCULATOR_JOBS_DEFAULTS_FETCH_START=(cov_143fy6wmj4.s[45]++,'CALCULATOR_JOBS_DEFAULTS_FETCH_START');var CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS=(cov_143fy6wmj4.s[46]++,'CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS');var CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL=(cov_143fy6wmj4.s[47]++,'CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL');var CALCULATOR_JOBS_DEFAULTS_UPDATE_START=(cov_143fy6wmj4.s[48]++,'CALCULATOR_JOBS_DEFAULTS_UPDATE_START');var CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS=(cov_143fy6wmj4.s[49]++,'CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS');var CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL=(cov_143fy6wmj4.s[50]++,'CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL');var CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET=(cov_143fy6wmj4.s[51]++,'CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET');var CALCULATOR_JOB_CREATE_START=(cov_143fy6wmj4.s[52]++,'CALCULATOR_JOB_CREATE_START');var CALCULATOR_JOB_CREATE_SUCCESS=(cov_143fy6wmj4.s[53]++,'CALCULATOR_JOB_CREATE_SUCCESS');var CALCULATOR_JOB_CREATE_FAIL=(cov_143fy6wmj4.s[54]++,'CALCULATOR_JOB_CREATE_FAIL');var CALCULATOR_JOB_CREATE_RESET=(cov_143fy6wmj4.s[55]++,'CALCULATOR_JOB_CREATE_RESET');var CALCULATOR_JOB_DUPLICATECHECK_START=(cov_143fy6wmj4.s[56]++,'CALCULATOR_JOB_DUPLICATECHECK_START');var CALCULATOR_JOB_DUPLICATECHECK_SUCCESS=(cov_143fy6wmj4.s[57]++,'CALCULATOR_JOB_DUPLICATECHECK_SUCCESS');var CALCULATOR_JOB_DUPLICATECHECK_FAIL=(cov_143fy6wmj4.s[58]++,'CALCULATOR_JOB_DUPLICATECHECK_FAIL');var CALCULATOR_JOB_DUPLICATECHECK_RESET=(cov_143fy6wmj4.s[59]++,'CALCULATOR_JOB_DUPLICATECHECK_RESET');var CALCULATOR_JOB_FETCH_START=(cov_143fy6wmj4.s[60]++,'CALCULATOR_JOB_FETCH_START');var CALCULATOR_JOB_FETCH_SUCCESS=(cov_143fy6wmj4.s[61]++,'CALCULATOR_JOB_FETCH_SUCCESS');var CALCULATOR_JOB_FETCH_FAIL=(cov_143fy6wmj4.s[62]++,'CALCULATOR_JOB_FETCH_FAIL');var CALCULATOR_JOB_FETCH_RESET=(cov_143fy6wmj4.s[63]++,'CALCULATOR_JOB_FETCH_RESET');var CALCULATOR_JOB_MESSAGE_SET=(cov_143fy6wmj4.s[64]++,'CALCULATOR_JOB_MESSAGE_SET');var CALCULATOR_JOB_MESSAGE_RESET=(cov_143fy6wmj4.s[65]++,'CALCULATOR_JOB_MESSAGE_RESET');var CALCULATOR_JOB_UPDATE_START=(cov_143fy6wmj4.s[66]++,'CALCULATOR_JOB_UPDATE_START');var CALCULATOR_JOB_UPDATE_SUCCESS=(cov_143fy6wmj4.s[67]++,'CALCULATOR_JOB_UPDATE_SUCCESS');var CALCULATOR_JOB_UPDATE_FAIL=(cov_143fy6wmj4.s[68]++,'CALCULATOR_JOB_UPDATE_FAIL');var CALCULATOR_JOB_UPDATE_RESET=(cov_143fy6wmj4.s[69]++,'CALCULATOR_JOB_UPDATE_RESET');var CALCULATOR_JOB_MACHINE_UPDATE_START=(cov_143fy6wmj4.s[70]++,'CALCULATOR_JOB_MACHINE_UPDATE_START');var CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS=(cov_143fy6wmj4.s[71]++,'CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS');var CALCULATOR_JOB_MACHINE_UPDATE_FAIL=(cov_143fy6wmj4.s[72]++,'CALCULATOR_JOB_MACHINE_UPDATE_FAIL');var CALCULATOR_JOB_MACHINE_UPDATE_RESET=(cov_143fy6wmj4.s[73]++,'CALCULATOR_JOB_MACHINE_UPDATE_RESET');var CALCULATOR_JOB_MACHINE_FETCH_START=(cov_143fy6wmj4.s[74]++,'CALCULATOR_JOB_MACHINE_FETCH_START');var CALCULATOR_JOB_MACHINE_FETCH_SUCCESS=(cov_143fy6wmj4.s[75]++,'CALCULATOR_JOB_MACHINE_FETCH_SUCCESS');var CALCULATOR_JOB_MACHINE_FETCH_FAIL=(cov_143fy6wmj4.s[76]++,'CALCULATOR_JOB_MACHINE_FETCH_FAIL');var CALCULATOR_JOB_MACHINE_FETCH_RESET=(cov_143fy6wmj4.s[77]++,'CALCULATOR_JOB_MACHINE_FETCH_RESET');var CALCULATOR_JOB_CALCULATIONS_FETCH_START=(cov_143fy6wmj4.s[78]++,'CALCULATOR_JOB_CALCULATIONS_FETCH_START');var CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS=(cov_143fy6wmj4.s[79]++,'CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS');var CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL=(cov_143fy6wmj4.s[80]++,'CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL');var CALCULATOR_JOB_CALCULATIONS_FETCH_RESET=(cov_143fy6wmj4.s[81]++,'CALCULATOR_JOB_CALCULATIONS_FETCH_RESET');var CALCULATOR_JOB_EXPORT_FETCH_START=(cov_143fy6wmj4.s[82]++,'CALCULATOR_JOB_EXPORT_FETCH_START');var CALCULATOR_JOB_EXPORT_FETCH_SUCCESS=(cov_143fy6wmj4.s[83]++,'CALCULATOR_JOB_EXPORT_FETCH_SUCCESS');var CALCULATOR_JOB_EXPORT_FETCH_FAIL=(cov_143fy6wmj4.s[84]++,'CALCULATOR_JOB_EXPORT_FETCH_FAIL');var CALCULATOR_JOB_EXPORT_FETCH_RESET=(cov_143fy6wmj4.s[85]++,'CALCULATOR_JOB_EXPORT_FETCH_RESET');var CALCULATOR_JOB_DELETE_START=(cov_143fy6wmj4.s[86]++,'CALCULATOR_JOB_DELETE_START');var CALCULATOR_JOB_DELETE_SUCCESS=(cov_143fy6wmj4.s[87]++,'CALCULATOR_JOB_DELETE_SUCCESS');var CALCULATOR_JOB_DELETE_FAIL=(cov_143fy6wmj4.s[88]++,'CALCULATOR_JOB_DELETE_FAIL');var CALCULATOR_JOB_DELETE_RESET=(cov_143fy6wmj4.s[89]++,'CALCULATOR_JOB_DELETE_RESET');var CALCULATOR_JOB_CHANGEACTIVE_START=(cov_143fy6wmj4.s[90]++,'CALCULATOR_JOB_CHANGEACTIVE_START');var CALCULATOR_JOB_CHANGEACTIVE_SUCCESS=(cov_143fy6wmj4.s[91]++,'CALCULATOR_JOB_CHANGEACTIVE_SUCCESS');var CALCULATOR_JOB_CHANGEACTIVE_FAIL=(cov_143fy6wmj4.s[92]++,'CALCULATOR_JOB_CHANGEACTIVE_FAIL');var CALCULATOR_JOB_CHANGEACTIVE_RESET=(cov_143fy6wmj4.s[93]++,'CALCULATOR_JOB_CHANGEACTIVE_RESET');var CALCULATOR_JOB_RECALCULATE_START=(cov_143fy6wmj4.s[94]++,'CALCULATOR_JOB_RECALCULATE_START');var CALCULATOR_JOB_RECALCULATE_SUCCESS=(cov_143fy6wmj4.s[95]++,'CALCULATOR_JOB_RECALCULATE_SUCCESS');var CALCULATOR_JOB_RECALCULATE_FAIL=(cov_143fy6wmj4.s[96]++,'CALCULATOR_JOB_RECALCULATE_FAIL');var CALCULATOR_JOB_RECALCULATE_RESET=(cov_143fy6wmj4.s[97]++,'CALCULATOR_JOB_RECALCULATE_RESET');var CALCULATOR_JOB_DETAILED_CALCULATION_START=(cov_143fy6wmj4.s[98]++,'CALCULATOR_JOB_DETAILED_CALCULATION_START');var CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS=(cov_143fy6wmj4.s[99]++,'CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS');var CALCULATOR_JOB_DETAILED_CALCULATION_FAIL=(cov_143fy6wmj4.s[100]++,'CALCULATOR_JOB_DETAILED_CALCULATION_FAIL');var CALCULATOR_JOB_DETAILED_CALCULATION_RESET=(cov_143fy6wmj4.s[101]++,'CALCULATOR_JOB_DETAILED_CALCULATION_RESET');var CALCULATOR_MACHINES_FETCH_START=(cov_143fy6wmj4.s[102]++,'CALCULATOR_MACHINES_FETCH_START');var CALCULATOR_MACHINES_FETCH_SUCCESS=(cov_143fy6wmj4.s[103]++,'CALCULATOR_MACHINES_FETCH_SUCCESS');var CALCULATOR_MACHINES_FETCH_FAIL=(cov_143fy6wmj4.s[104]++,'CALCULATOR_MACHINES_FETCH_FAIL');var CALCULATOR_MACHINES_DEFAULTS_FETCH_START=(cov_143fy6wmj4.s[105]++,'CALCULATOR_MACHINES_DEFAULTS_FETCH_START');var CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS=(cov_143fy6wmj4.s[106]++,'CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS');var CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL=(cov_143fy6wmj4.s[107]++,'CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL');var CALCULATOR_MACHINE_CREATE_START=(cov_143fy6wmj4.s[108]++,'CALCULATOR_MACHINE_CREATE_START');var CALCULATOR_MACHINE_CREATE_SUCCESS=(cov_143fy6wmj4.s[109]++,'CALCULATOR_MACHINE_CREATE_SUCCESS');var CALCULATOR_MACHINE_CREATE_FAIL=(cov_143fy6wmj4.s[110]++,'CALCULATOR_MACHINE_CREATE_FAIL');var CALCULATOR_MACHINE_CREATE_RESET=(cov_143fy6wmj4.s[111]++,'CALCULATOR_MACHINE_CREATE_RESET');var CALCULATOR_MACHINE_FETCH_START=(cov_143fy6wmj4.s[112]++,'CALCULATOR_MACHINE_FETCH_START');var CALCULATOR_MACHINE_FETCH_SUCCESS=(cov_143fy6wmj4.s[113]++,'CALCULATOR_MACHINE_FETCH_SUCCESS');var CALCULATOR_MACHINE_FETCH_FAIL=(cov_143fy6wmj4.s[114]++,'CALCULATOR_MACHINE_FETCH_FAIL');var CALCULATOR_MACHINE_FETCH_RESET=(cov_143fy6wmj4.s[115]++,'CALCULATOR_MACHINE_FETCH_RESET');var CALCULATOR_MACHINE_UPDATE_START=(cov_143fy6wmj4.s[116]++,'CALCULATOR_MACHINE_UPDATE_START');var CALCULATOR_MACHINE_UPDATE_SUCCESS=(cov_143fy6wmj4.s[117]++,'CALCULATOR_MACHINE_UPDATE_SUCCESS');var CALCULATOR_MACHINE_UPDATE_FAIL=(cov_143fy6wmj4.s[118]++,'CALCULATOR_MACHINE_UPDATE_FAIL');var CALCULATOR_MACHINE_UPDATE_RESET=(cov_143fy6wmj4.s[119]++,'CALCULATOR_MACHINE_UPDATE_RESET');var CALCULATOR_MACHINE_DELETE_START=(cov_143fy6wmj4.s[120]++,'CALCULATOR_MACHINE_DELETE_START');var CALCULATOR_MACHINE_DELETE_SUCCESS=(cov_143fy6wmj4.s[121]++,'CALCULATOR_MACHINE_DELETE_SUCCESS');var CALCULATOR_MACHINE_DELETE_FAIL=(cov_143fy6wmj4.s[122]++,'CALCULATOR_MACHINE_DELETE_FAIL');var CALCULATOR_MACHINE_DELETE_RESET=(cov_143fy6wmj4.s[123]++,'CALCULATOR_MACHINE_DELETE_RESET');var CALCULATOR_MACHINE_DUPLICATECHECK_START=(cov_143fy6wmj4.s[124]++,'CALCULATOR_MACHINE_DUPLICATECHECK_START');var CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS=(cov_143fy6wmj4.s[125]++,'CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS');var CALCULATOR_MACHINE_DUPLICATECHECK_FAIL=(cov_143fy6wmj4.s[126]++,'CALCULATOR_MACHINE_DUPLICATECHECK_FAIL');var CALCULATOR_MACHINE_DUPLICATECHECK_RESET=(cov_143fy6wmj4.s[127]++,'CALCULATOR_MACHINE_DUPLICATECHECK_RESET');var FETCHING=(cov_143fy6wmj4.s[128]++,'FETCHING');var NOT_FETCHING=(cov_143fy6wmj4.s[129]++,'NOT_FETCHING');var PRINTING=(cov_143fy6wmj4.s[130]++,'PRINTING');var NOT_PRINTING=(cov_143fy6wmj4.s[131]++,'NOT_PRINTING');var VISUALMESSAGE_RESET=(cov_143fy6wmj4.s[132]++,'VISUALMESSAGE_RESET');var VISUALMESSAGE_SET=(cov_143fy6wmj4.s[133]++,'VISUALMESSAGE_SET');

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)(module)))

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODIFIER_KEY_NAMES = exports.DEFAULT_VERTICAL_SPACING = exports.FANG_HEIGHT_PX = exports.FANG_WIDTH_PX = exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.INFO_POSITION_AFTER = exports.INFO_POSITION_BEFORE = exports.INFO_POSITION_BOTTOM = exports.INFO_POSITION_TOP = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.NAV_POSITION_TOP = exports.NAV_POSITION_BOTTOM = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = void 0;
var DISPLAY_FORMAT = 'L';
exports.DISPLAY_FORMAT = DISPLAY_FORMAT;
var ISO_FORMAT = 'YYYY-MM-DD';
exports.ISO_FORMAT = ISO_FORMAT;
var ISO_MONTH_FORMAT = 'YYYY-MM'; // TODO delete this line of dead code on next breaking change

exports.ISO_MONTH_FORMAT = ISO_MONTH_FORMAT;
var START_DATE = 'startDate';
exports.START_DATE = START_DATE;
var END_DATE = 'endDate';
exports.END_DATE = END_DATE;
var HORIZONTAL_ORIENTATION = 'horizontal';
exports.HORIZONTAL_ORIENTATION = HORIZONTAL_ORIENTATION;
var VERTICAL_ORIENTATION = 'vertical';
exports.VERTICAL_ORIENTATION = VERTICAL_ORIENTATION;
var VERTICAL_SCROLLABLE = 'verticalScrollable';
exports.VERTICAL_SCROLLABLE = VERTICAL_SCROLLABLE;
var NAV_POSITION_BOTTOM = 'navPositionBottom';
exports.NAV_POSITION_BOTTOM = NAV_POSITION_BOTTOM;
var NAV_POSITION_TOP = 'navPositionTop';
exports.NAV_POSITION_TOP = NAV_POSITION_TOP;
var ICON_BEFORE_POSITION = 'before';
exports.ICON_BEFORE_POSITION = ICON_BEFORE_POSITION;
var ICON_AFTER_POSITION = 'after';
exports.ICON_AFTER_POSITION = ICON_AFTER_POSITION;
var INFO_POSITION_TOP = 'top';
exports.INFO_POSITION_TOP = INFO_POSITION_TOP;
var INFO_POSITION_BOTTOM = 'bottom';
exports.INFO_POSITION_BOTTOM = INFO_POSITION_BOTTOM;
var INFO_POSITION_BEFORE = 'before';
exports.INFO_POSITION_BEFORE = INFO_POSITION_BEFORE;
var INFO_POSITION_AFTER = 'after';
exports.INFO_POSITION_AFTER = INFO_POSITION_AFTER;
var ANCHOR_LEFT = 'left';
exports.ANCHOR_LEFT = ANCHOR_LEFT;
var ANCHOR_RIGHT = 'right';
exports.ANCHOR_RIGHT = ANCHOR_RIGHT;
var OPEN_DOWN = 'down';
exports.OPEN_DOWN = OPEN_DOWN;
var OPEN_UP = 'up';
exports.OPEN_UP = OPEN_UP;
var DAY_SIZE = 39;
exports.DAY_SIZE = DAY_SIZE;
var BLOCKED_MODIFIER = 'blocked';
exports.BLOCKED_MODIFIER = BLOCKED_MODIFIER;
var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
exports.WEEKDAYS = WEEKDAYS;
var FANG_WIDTH_PX = 20;
exports.FANG_WIDTH_PX = FANG_WIDTH_PX;
var FANG_HEIGHT_PX = 10;
exports.FANG_HEIGHT_PX = FANG_HEIGHT_PX;
var DEFAULT_VERTICAL_SPACING = 22;
exports.DEFAULT_VERTICAL_SPACING = DEFAULT_VERTICAL_SPACING;
var MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);
exports.MODIFIER_KEY_NAMES = MODIFIER_KEY_NAMES;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var cov_1sd62gwcuk=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_services\\api\\axios.js',hash='5d094c916442a7f2d9fda1c73b99e2095fd72c09',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_services\\api\\axios.js',statementMap:{'0':{start:{line:3,column:17},end:{line:6,column:2}}},fnMap:{},branchMap:{},s:{'0':0},f:{},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var instance=(cov_1sd62gwcuk.s[0]++,__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({baseURL:"https://test-apis.melcocloud.com",headers:{'x-api-key':"0ATiqUzfRHuB3uMmyfD1Wlj"}}));/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Localize__ = __webpack_require__(321);
/* unused harmony reexport localize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Translate__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Translate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["h"]; });
/* unused harmony reexport addTranslation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["a"]; });
/* unused harmony reexport setLanguages */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__locale__["c"]; });
/* unused harmony reexport getLanguages */
/* unused harmony reexport getTranslations */
/* unused harmony reexport getOptions */





/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(278);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(280);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(283);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(286);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(87);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(294);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(298);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_menu__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__helpers_menu__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__helpers_menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_blur__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_1__helpers_blur__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_1__helpers_blur__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_countriesstates__ = __webpack_require__(361);
/* unused harmony reexport helpersCountriesStatesFetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_notifications__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers_notifications__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_design__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_4__helpers_design__["a"]; });
/* unused harmony reexport helpersDesignuploadReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fetching__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_5__fetching__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_5__fetching__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__printing__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_6__printing__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_6__printing__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__visualMessage__ = __webpack_require__(366);
/* unused harmony reexport visualMessageSet */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_7__visualMessage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__auth__ = __webpack_require__(144);
/* unused harmony reexport authSetMelcoAccountData */
/* unused harmony reexport authRemoveMelcoAccountData */
/* unused harmony reexport authChangeCurrentUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__auth__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tokenRestore__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_9__tokenRestore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__appStartup__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__appStartup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translationLoad__ = __webpack_require__(145);
/* unused harmony reexport translationLoad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaults__ = __webpack_require__(372);
/* unused harmony reexport defaultsGet */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_12__defaults__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__calculator_settings_company__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_13__calculator_settings_company__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_13__calculator_settings_company__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_13__calculator_settings_company__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__calculator_jobs_jobs__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_14__calculator_jobs_jobs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__calculator_jobs_defaults__ = __webpack_require__(375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_15__calculator_jobs_defaults__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_15__calculator_jobs_defaults__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_15__calculator_jobs_defaults__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_16__calculator_jobs_job__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__calculator_machines_machines__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_17__calculator_machines_machines__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__calculator_machines_defaults__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_18__calculator_machines_defaults__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__ = __webpack_require__(379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_19__calculator_machines_machine__["f"]; });
var cov_94k4j95j1=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\index.js',hash='a80c3d4dd4843cfddd8915866d1e6cc432f88dec',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\index.js',statementMap:{},fnMap:{},branchMap:{},s:{},f:{},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =  true ? __webpack_require__(456) : require('./build');

//# sourceMappingURL=index.js.map

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateObject; });
var cov_1meh6q8hij=function(){var path="D:\\a\\1\\s\\app\\browser\\src\\_store\\utility.js",hash="c2907ce74645daa7d8c96484b88f5c75bba0e838",Function=function(){}.constructor,global=new Function('return this')(),gcv="__coverage__",coverageData={path:"D:\\a\\1\\s\\app\\browser\\src\\_store\\utility.js",statementMap:{"0":{start:{line:1,column:28},end:{line:6,column:1}},"1":{start:{line:2,column:4},end:{line:5,column:5}}},fnMap:{"0":{name:"(anonymous_0)",decl:{start:{line:1,column:28},end:{line:1,column:29}},loc:{start:{line:1,column:58},end:{line:6,column:1}},line:1}},branchMap:{},s:{"0":0,"1":0},f:{"0":0},b:{},_coverageSchema:"332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1meh6q8hij.s[0]++;var updateObject=function updateObject(oldObject,updatedValues){cov_1meh6q8hij.f[0]++;cov_1meh6q8hij.s[1]++;return Object.assign({},oldObject,updatedValues);};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(452);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Error = __webpack_require__(395);
var $EvalError = __webpack_require__(396);
var $RangeError = __webpack_require__(151);
var $ReferenceError = __webpack_require__(397);
var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(8);
var $URIError = __webpack_require__(398);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(152)();
var hasProto = __webpack_require__(153)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(93);
var hasOwn = __webpack_require__(37);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = exports["default"] = void 0;
var calendarLabel = 'Calendar';
var roleDescription = 'datepicker';
var closeDatePicker = 'Close';
var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
var clearDate = 'Clear Date';
var clearDates = 'Clear Dates';
var jumpToPrevMonth = 'Move backward to switch to the previous month.';
var jumpToNextMonth = 'Move forward to switch to the next month.';
var keyboardShortcuts = 'Keyboard Shortcuts';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
var openThisPanel = 'Open this panel.';
var enterKey = 'Enter key';
var leftArrowRightArrow = 'Right and left arrow keys';
var upArrowDownArrow = 'up and down arrow keys';
var pageUpPageDown = 'page up and page down keys';
var homeEnd = 'Home and end keys';
var escape = 'Escape key';
var questionMark = 'Question mark';
var selectFocusedDate = 'Select the date in focus.';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
var moveFocusByOneMonth = 'Switch months.';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
var returnFocusToInput = 'Return to the date input field.';
var keyboardForwardNavigationInstructions = 'Navigate forward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
var keyboardBackwardNavigationInstructions = 'Navigate backward to interact with the calendar and select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';

var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return "Choose ".concat(date, " as your check-in date. It\u2019s available.");
};

var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return "Choose ".concat(date, " as your check-out date. It\u2019s available.");
};

var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};

var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return "Not available. ".concat(date);
};

var dateIsSelected = function dateIsSelected(_ref5) {
  var date = _ref5.date;
  return "Selected. ".concat(date);
};

var dateIsSelectedAsStartDate = function dateIsSelectedAsStartDate(_ref6) {
  var date = _ref6.date;
  return "Selected as start date. ".concat(date);
};

var dateIsSelectedAsEndDate = function dateIsSelectedAsEndDate(_ref7) {
  var date = _ref7.date;
  return "Selected as end date. ".concat(date);
};

var _default = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  focusStartDate: focusStartDate,
  clearDate: clearDate,
  clearDates: clearDates,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports["default"] = _default;
var DateRangePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDates: clearDates,
  focusStartDate: focusStartDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DateRangePickerPhrases = DateRangePickerPhrases;
var DateRangePickerInputPhrases = {
  focusStartDate: focusStartDate,
  clearDates: clearDates,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.DateRangePickerInputPhrases = DateRangePickerInputPhrases;
var SingleDatePickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  closeDatePicker: closeDatePicker,
  clearDate: clearDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected
};
exports.SingleDatePickerPhrases = SingleDatePickerPhrases;
var SingleDatePickerInputPhrases = {
  clearDate: clearDate,
  keyboardForwardNavigationInstructions: keyboardForwardNavigationInstructions,
  keyboardBackwardNavigationInstructions: keyboardBackwardNavigationInstructions
};
exports.SingleDatePickerInputPhrases = SingleDatePickerInputPhrases;
var DayPickerPhrases = {
  calendarLabel: calendarLabel,
  roleDescription: roleDescription,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.DayPickerPhrases = DayPickerPhrases;
var DayPickerKeyboardShortcutsPhrases = {
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput
};
exports.DayPickerKeyboardShortcutsPhrases = DayPickerKeyboardShortcutsPhrases;
var DayPickerNavigationPhrases = {
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth
};
exports.DayPickerNavigationPhrases = DayPickerNavigationPhrases;
var CalendarDayPhrases = {
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable,
  dateIsSelected: dateIsSelected,
  dateIsSelectedAsStartDate: dateIsSelectedAsStartDate,
  dateIsSelectedAsEndDate: dateIsSelectedAsEndDate
};
exports.CalendarDayPhrases = CalendarDayPhrases;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 19;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(148);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(150);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(95)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Aux__ = __webpack_require__(31);
var cov_q33ql8uyy=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_hoc\\withErrorHandler\\index.js',hash='65428b18cd9c9a3e963c7296d374f966da11f25a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_hoc\\withErrorHandler\\index.js',statementMap:{'0':{start:{line:8,column:25},end:{line:82,column:1}},'1':{start:{line:14,column:12},end:{line:14,column:24}},'2':{start:{line:15,column:12},end:{line:34,column:16}},'3':{start:{line:16,column:16},end:{line:21,column:17}},'4':{start:{line:17,column:20},end:{line:17,column:72}},'5':{start:{line:19,column:21},end:{line:21,column:17}},'6':{start:{line:20,column:20},end:{line:20,column:84}},'7':{start:{line:22,column:16},end:{line:27,column:17}},'8':{start:{line:23,column:20},end:{line:23,column:82}},'9':{start:{line:25,column:21},end:{line:27,column:17}},'10':{start:{line:26,column:20},end:{line:26,column:94}},'11':{start:{line:28,column:16},end:{line:31,column:17}},'12':{start:{line:29,column:20},end:{line:29,column:82}},'13':{start:{line:30,column:20},end:{line:30,column:79}},'14':{start:{line:32,column:16},end:{line:32,column:83}},'15':{start:{line:33,column:16},end:{line:33,column:27}},'16':{start:{line:35,column:12},end:{line:52,column:16}},'17':{start:{line:36,column:16},end:{line:36,column:44}},'18':{start:{line:37,column:16},end:{line:37,column:27}},'19':{start:{line:39,column:16},end:{line:39,column:44}},'20':{start:{line:40,column:62},end:{line:40,column:74}},'21':{start:{line:42,column:16},end:{line:45,column:17}},'22':{start:{line:44,column:20},end:{line:44,column:126}},'23':{start:{line:46,column:16},end:{line:51,column:17}},'24':{start:{line:47,column:20},end:{line:47,column:63}},'25':{start:{line:50,column:20},end:{line:50,column:49}},'26':{start:{line:56,column:12},end:{line:56,column:68}},'27':{start:{line:57,column:12},end:{line:57,column:69}},'28':{start:{line:61,column:12},end:{line:65,column:14}},'29':{start:{line:68,column:28},end:{line:73,column:5}},'30':{start:{line:69,column:8},end:{line:72,column:10}},'31':{start:{line:75,column:31},end:{line:80,column:1}},'32':{start:{line:76,column:4},end:{line:79,column:5}},'33':{start:{line:77,column:48},end:{line:77,column:105}},'34':{start:{line:78,column:30},end:{line:78,column:69}},'35':{start:{line:81,column:4},end:{line:81,column:69}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:25},end:{line:8,column:26}},loc:{start:{line:8,column:56},end:{line:82,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:13,column:8},end:{line:13,column:9}},loc:{start:{line:13,column:28},end:{line:53,column:9}},line:13},'2':{name:'(anonymous_2)',decl:{start:{line:15,column:66},end:{line:15,column:67}},loc:{start:{line:15,column:73},end:{line:34,column:13}},line:15},'3':{name:'(anonymous_3)',decl:{start:{line:35,column:67},end:{line:35,column:68}},loc:{start:{line:35,column:74},end:{line:38,column:13}},line:35},'4':{name:'(anonymous_4)',decl:{start:{line:38,column:15},end:{line:38,column:16}},loc:{start:{line:38,column:24},end:{line:52,column:13}},line:38},'5':{name:'(anonymous_5)',decl:{start:{line:55,column:8},end:{line:55,column:9}},loc:{start:{line:55,column:32},end:{line:58,column:9}},line:55},'6':{name:'(anonymous_6)',decl:{start:{line:60,column:8},end:{line:60,column:9}},loc:{start:{line:60,column:18},end:{line:66,column:9}},line:60},'7':{name:'(anonymous_7)',decl:{start:{line:68,column:28},end:{line:68,column:29}},loc:{start:{line:68,column:37},end:{line:73,column:5}},line:68},'8':{name:'(anonymous_8)',decl:{start:{line:75,column:31},end:{line:75,column:32}},loc:{start:{line:75,column:43},end:{line:80,column:1}},line:75},'9':{name:'(anonymous_9)',decl:{start:{line:77,column:25},end:{line:77,column:26}},loc:{start:{line:77,column:48},end:{line:77,column:105}},line:77},'10':{name:'(anonymous_10)',decl:{start:{line:78,column:24},end:{line:78,column:25}},loc:{start:{line:78,column:30},end:{line:78,column:69}},line:78}},branchMap:{'0':{loc:{start:{line:16,column:16},end:{line:21,column:17}},type:'if',locations:[{start:{line:16,column:16},end:{line:21,column:17}},{start:{line:16,column:16},end:{line:21,column:17}}],line:16},'1':{loc:{start:{line:19,column:21},end:{line:21,column:17}},type:'if',locations:[{start:{line:19,column:21},end:{line:21,column:17}},{start:{line:19,column:21},end:{line:21,column:17}}],line:19},'2':{loc:{start:{line:22,column:16},end:{line:27,column:17}},type:'if',locations:[{start:{line:22,column:16},end:{line:27,column:17}},{start:{line:22,column:16},end:{line:27,column:17}}],line:22},'3':{loc:{start:{line:25,column:21},end:{line:27,column:17}},type:'if',locations:[{start:{line:25,column:21},end:{line:27,column:17}},{start:{line:25,column:21},end:{line:27,column:17}}],line:25},'4':{loc:{start:{line:28,column:16},end:{line:31,column:17}},type:'if',locations:[{start:{line:28,column:16},end:{line:31,column:17}},{start:{line:28,column:16},end:{line:31,column:17}}],line:28},'5':{loc:{start:{line:32,column:43},end:{line:32,column:80}},type:'cond-expr',locations:[{start:{line:32,column:68},end:{line:32,column:72}},{start:{line:32,column:75},end:{line:32,column:80}}],line:32},'6':{loc:{start:{line:42,column:16},end:{line:45,column:17}},type:'if',locations:[{start:{line:42,column:16},end:{line:45,column:17}},{start:{line:42,column:16},end:{line:45,column:17}}],line:42},'7':{loc:{start:{line:42,column:19},end:{line:42,column:129}},type:'binary-expr',locations:[{start:{line:42,column:19},end:{line:42,column:33}},{start:{line:42,column:37},end:{line:42,column:58}},{start:{line:42,column:62},end:{line:42,column:91}},{start:{line:42,column:95},end:{line:42,column:129}}],line:42},'8':{loc:{start:{line:46,column:16},end:{line:51,column:17}},type:'if',locations:[{start:{line:46,column:16},end:{line:51,column:17}},{start:{line:46,column:16},end:{line:51,column:17}}],line:46},'9':{loc:{start:{line:46,column:19},end:{line:46,column:56}},type:'binary-expr',locations:[{start:{line:46,column:19},end:{line:46,column:33}},{start:{line:46,column:37},end:{line:46,column:56}}],line:46}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0,0,0],'8':[0,0],'9':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}cov_q33ql8uyy.s[0]++;var withErrorHandler=function withErrorHandler(WrappedComponent,axios){cov_q33ql8uyy.f[0]++;var errorHandler=function(_ref){_inherits(errorHandler,_ref);function errorHandler(props){_classCallCheck(this,errorHandler);cov_q33ql8uyy.f[1]++;cov_q33ql8uyy.s[1]++;var _this=_possibleConstructorReturn(this,(errorHandler.__proto__||Object.getPrototypeOf(errorHandler)).call(this,props));_this.state={needsLogout:false};cov_q33ql8uyy.s[2]++;_this.reqInterceptor=axios.interceptors.request.use(function(req){cov_q33ql8uyy.f[2]++;cov_q33ql8uyy.s[3]++;if(req.token){cov_q33ql8uyy.b[0][0]++;cov_q33ql8uyy.s[4]++;req.headers["Authorization"]="melco "+req.token;}else{cov_q33ql8uyy.b[0][1]++;cov_q33ql8uyy.s[5]++;if(_this.props.auth.isAuthenticated){cov_q33ql8uyy.b[1][0]++;cov_q33ql8uyy.s[6]++;req.headers["Authorization"]="melco "+_this.props.auth.token;}else{cov_q33ql8uyy.b[1][1]++;}}cov_q33ql8uyy.s[7]++;if(req.impersonation_for_id){cov_q33ql8uyy.b[2][0]++;cov_q33ql8uyy.s[8]++;req.headers["x-melco-impersonate"]=req.impersonation_for_id;}else{cov_q33ql8uyy.b[2][1]++;cov_q33ql8uyy.s[9]++;if(_this.props.auth.impersonation_for_id){cov_q33ql8uyy.b[3][0]++;cov_q33ql8uyy.s[10]++;req.headers["x-melco-impersonate"]=_this.props.auth.impersonation_for_id;}else{cov_q33ql8uyy.b[3][1]++;}}cov_q33ql8uyy.s[11]++;if(_this.props.currentLanguage){cov_q33ql8uyy.b[4][0]++;cov_q33ql8uyy.s[12]++;req.headers["x-display-culture"]=_this.props.currentLanguage;cov_q33ql8uyy.s[13]++;req.headers["x-user-culture"]=_this.props.currentLanguage;}else{cov_q33ql8uyy.b[4][1]++;}cov_q33ql8uyy.s[14]++;_this.props.onFetchingStart(!req.hideGlobalSpinner?(cov_q33ql8uyy.b[5][0]++,true):(cov_q33ql8uyy.b[5][1]++,false));cov_q33ql8uyy.s[15]++;return req;});cov_q33ql8uyy.s[16]++;_this.resInterceptor=axios.interceptors.response.use(function(res){cov_q33ql8uyy.f[3]++;cov_q33ql8uyy.s[17]++;_this.props.onFetchingStop();cov_q33ql8uyy.s[18]++;return res;},function(error){cov_q33ql8uyy.f[4]++;cov_q33ql8uyy.s[19]++;_this.props.onFetchingStop();var _ref2=(cov_q33ql8uyy.s[20]++,error.config),skipRedirectToLoginIfUnauthorized=_ref2.skipRedirectToLoginIfUnauthorized;//Unauthorized?
cov_q33ql8uyy.s[21]++;if((cov_q33ql8uyy.b[7][0]++,error.response)&&(cov_q33ql8uyy.b[7][1]++,error.response.status)&&(cov_q33ql8uyy.b[7][2]++,error.response.status===401)&&(cov_q33ql8uyy.b[7][3]++,!skipRedirectToLoginIfUnauthorized)){cov_q33ql8uyy.b[6][0]++;cov_q33ql8uyy.s[22]++;// redirect to account app
window.location.href="https://test-account.melcocloud.com/"+'?error=expired&redirectTo='+window.location;}else{cov_q33ql8uyy.b[6][1]++;}cov_q33ql8uyy.s[23]++;if((cov_q33ql8uyy.b[9][0]++,error.response)&&(cov_q33ql8uyy.b[9][1]++,error.response.data)){cov_q33ql8uyy.b[8][0]++;cov_q33ql8uyy.s[24]++;return Promise.reject(error.response.data);}else{cov_q33ql8uyy.b[8][1]++;cov_q33ql8uyy.s[25]++;return Promise.reject(error);}});return _this;}_createClass(errorHandler,[{key:'componentWillUnmount',value:function componentWillUnmount(){cov_q33ql8uyy.f[5]++;cov_q33ql8uyy.s[26]++;axios.interceptors.request.eject(this.reqInterceptor);cov_q33ql8uyy.s[27]++;axios.interceptors.response.eject(this.resInterceptor);}},{key:'render',value:function render(){cov_q33ql8uyy.f[6]++;cov_q33ql8uyy.s[28]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,this.props));}}]);return errorHandler;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_q33ql8uyy.s[29]++;var mapStateToProps=function mapStateToProps(state){cov_q33ql8uyy.f[7]++;cov_q33ql8uyy.s[30]++;return{auth:state.auth,currentLanguage:Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["c" /* getActiveLanguage */])(state.locale).code};};cov_q33ql8uyy.s[31]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_q33ql8uyy.f[8]++;cov_q33ql8uyy.s[32]++;return{onFetchingStart:function onFetchingStart(showGlobalSpinner){cov_q33ql8uyy.f[9]++;cov_q33ql8uyy.s[33]++;return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_index__["S" /* fetchingStart */](showGlobalSpinner));},onFetchingStop:function onFetchingStop(){cov_q33ql8uyy.f[10]++;cov_q33ql8uyy.s[34]++;return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_index__["T" /* fetchingStop */]());}};};cov_q33ql8uyy.s[35]++;return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(errorHandler);};/* harmony default export */ __webpack_exports__["a"] = (withErrorHandler);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(451);
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrasePropTypes;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return _objectSpread({}, phrases, (0, _defineProperty2["default"])({}, key, _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node])));
  }, {});
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = shallowEqual;
var _objectIs = _interopRequireDefault(__webpack_require__(449));
var _hasown = _interopRequireDefault(__webpack_require__(37));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// adapted from https://github.com/facebook/react/blob/144328fe81719e916b946e22660479e31561bb0b/packages/shared/shallowEqual.js#L36-L68
function shallowEqual(objA, objB) {
  if ((0, _objectIs["default"])(objA, objB)) {
    return true;
  }
  if (!objA || !objB || _typeof(objA) !== 'object' || _typeof(objB) !== 'object') {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  keysA.sort();
  keysB.sort();

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i += 1) {
    if (!(0, _hasown["default"])(objB, keysA[i]) || !(0, _objectIs["default"])(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
//# sourceMappingURL=index.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports) {

function _extends() {
  return (module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(139);
var isBuffer = __webpack_require__(134);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(176);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = withStyles;
Object.defineProperty(exports, "withStylesPropTypes", {
  enumerable: true,
  get: function get() {
    return _withStylesPropTypes.withStylesPropTypes;
  }
});
exports.css = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(457));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(459));

var _getComponentName = _interopRequireDefault(__webpack_require__(177));

var _ref3 = _interopRequireDefault(__webpack_require__(464));

var _emptyStylesFn = _interopRequireDefault(__webpack_require__(471));

var _perf = _interopRequireDefault(__webpack_require__(472));

var _WithStylesContext = _interopRequireWildcard(__webpack_require__(473));

var _ThemedStyleSheet = _interopRequireWildcard(__webpack_require__(172));

var _withStylesPropTypes = __webpack_require__(480);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A higher order function that returns a higher order class component that injects
 * CSS-in-JS props derived from the react-with-styles theme, interface, and
 * direction provided through the WithStylesContext provider.
 *
 * The function should be used as follows:
 * `withStyles((theme) => styles, options)(Component)`
 *
 * Options can be used to rename the injected props, memoize the component, and flush
 * the styles to the styles tag (or whatever the interface implements as flush) before
 * rendering.
 *
 * @export
 * @param {Function|null|undefined} [stylesFn=EMPTY_STYLES_FN]
 * @param {Object} [{
 *     stylesPropName = 'styles',
 *     themePropName = 'theme',
 *     cssPropName = 'css',
 *     flushBefore = false,
 *     pureComponent = false,
 *   }={}]
 * @returns a higher order component that wraps the provided component and injects
 * the react-with-styles css, styles, and theme props.
 */
function withStyles() {
  var stylesFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emptyStylesFn["default"];

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stylesPropName = _ref.stylesPropName,
      stylesPropName = _ref$stylesPropName === void 0 ? 'styles' : _ref$stylesPropName,
      _ref$themePropName = _ref.themePropName,
      themePropName = _ref$themePropName === void 0 ? 'theme' : _ref$themePropName,
      _ref$cssPropName = _ref.cssPropName,
      cssPropName = _ref$cssPropName === void 0 ? 'css' : _ref$cssPropName,
      _ref$flushBefore = _ref.flushBefore,
      flushBefore = _ref$flushBefore === void 0 ? false : _ref$flushBefore,
      _ref$pureComponent = _ref.pureComponent,
      pureComponent = _ref$pureComponent === void 0 ? false : _ref$pureComponent;

  stylesFn = stylesFn || _emptyStylesFn["default"];
  var BaseClass = pureComponent ? _react["default"].PureComponent : _react["default"].Component;
  /** Cache for storing the result of stylesFn(theme) for all themes. */

  var stylesFnResultCacheMap = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getOrCreateStylesFnResultCache(theme) {
    // Get and store the result in the stylesFnResultsCache for the component
    // -- not the instance -- so we only apply the theme to the stylesFn
    // once per theme for this component.
    var cachedResultForTheme = stylesFnResultCacheMap.get(theme);
    var stylesFnResult = cachedResultForTheme || stylesFn(theme) || {};
    stylesFnResultCacheMap.set(theme, stylesFnResult); // cache the result of stylesFn(theme)

    return stylesFnResult;
  }
  /**
   * Cache for storing the results of computations:
   * `WeakMap<Theme, WeakMap<typeof WithStyles, { ltr: {}, rtl: {} }>>`
   * Falling back to `Map` whenever `WeakMap` is not supported
   */


  var withStylesCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();

  function getComponentCache(theme, component, direction) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      return null;
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      return null;
    }

    return componentCache[direction];
  }

  function updateComponentCache(theme, component, direction, results) {
    var themeCache = withStylesCache.get(theme);

    if (!themeCache) {
      themeCache = typeof WeakMap === 'undefined' ? new Map() : new WeakMap();
      withStylesCache.set(theme, themeCache);
    }

    var componentCache = themeCache.get(component);

    if (!componentCache) {
      componentCache = {
        ltr: {},
        rtl: {}
      };
      themeCache.set(component, componentCache);
    }

    componentCache[direction] = results;
  }
  /** Derive the create function from the interface and direction */


  function makeCreateFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var create = stylesInterface["create".concat(directionSelector)] || stylesInterface.create;
    var original = create;

    if (false) {
      create = (0, _perf["default"])('create')(create);
    }

    return {
      create: create,
      original: original
    };
  }
  /** Derive the resolve function from the interface and direction */


  function makeResolveFn(direction, stylesInterface) {
    var directionSelector = direction === _WithStylesContext.DIRECTIONS.RTL ? 'RTL' : 'LTR';
    var resolve = stylesInterface["resolve".concat(directionSelector)] || stylesInterface.resolve;
    var original = resolve;

    if (false) {
      resolve = (0, _perf["default"])('resolve')(resolve);
    }

    return {
      resolve: resolve,
      original: original
    };
  } // The function that wraps the provided component in a wrapper
  // component that injects the withStyles props


  return function withStylesHOC(WrappedComponent) {
    var wrappedComponentName = (0, _getComponentName["default"])(WrappedComponent); // The wrapper component that injects the withStyles props

    var WithStyles = /*#__PURE__*/function (_BaseClass) {
      (0, _inheritsLoose2["default"])(WithStyles, _BaseClass);

      function WithStyles() {
        return _BaseClass.apply(this, arguments) || this;
      }

      var _proto = WithStyles.prototype;

      _proto.getCurrentInterface = function getCurrentInterface() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesInterface || (0, _ThemedStyleSheet._getInterface)();
      };

      _proto.getCurrentTheme = function getCurrentTheme() {
        // Fallback to the singleton implementation
        return this.context && this.context.stylesTheme || (0, _ThemedStyleSheet._getTheme)();
      };

      _proto.getCurrentDirection = function getCurrentDirection() {
        return this.context && this.context.direction || _WithStylesContext.DIRECTIONS.LTR;
      };

      _proto.getProps = function getProps() {
        // Get the styles interface, theme, and direction from context
        var stylesInterface = this.getCurrentInterface();
        var theme = this.getCurrentTheme();
        var direction = this.getCurrentDirection(); // Use a cache to store the interface methods and created styles by direction.
        // This way, if the theme and the interface don't change, we do not recalculate
        // styles or any other interface derivations. They are effectively only calculated
        // once per direction, until the theme or interface change.
        // Assume: always an object.

        var componentCache = getComponentCache(theme, WithStyles, direction); // Determine what's changed

        var interfaceChanged = !componentCache || !componentCache.stylesInterface || stylesInterface && componentCache.stylesInterface !== stylesInterface;
        var themeChanged = !componentCache || componentCache.theme !== theme; // If the interface and theme haven't changed for this direction,
        // we return the cached props immediately.

        if (!interfaceChanged && !themeChanged) {
          return componentCache.props;
        } // If the theme or the interface changed, then there are some values
        // we need to recalculate. We avoid recalculating the ones we already
        // calculated in the past if the objects they're derived from have not
        // changed.


        var createFn = interfaceChanged && makeCreateFn(direction, stylesInterface) || componentCache.create;
        var resolveFn = interfaceChanged && makeResolveFn(direction, stylesInterface) || componentCache.resolve;
        var create = createFn.create;
        var resolve = resolveFn.resolve; // Determine if create or resolve functions have changed, which will then
        // determine if we need to create new styles or css props

        var createChanged = !componentCache || !componentCache.create || createFn.original !== componentCache.create.original;
        var resolveChanged = !componentCache || !componentCache.resolve || resolveFn.original !== componentCache.resolve.original; // Derive the css function prop: recalculate it if resolve changed

        var css = resolveChanged && function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return resolve(args);
        } || componentCache.props.css; // Get or calculate the themed styles from the stylesFn:
        // Uses a separate cache at the component level, not at the instance level,
        // to only apply the theme to the stylesFn once per component class per theme.


        var stylesFnResult = getOrCreateStylesFnResultCache(theme); // Derive the styles prop: recalculate it if create changed, or stylesFnResult changed

        var styles = (createChanged || stylesFnResult !== componentCache.stylesFnResult) && create(stylesFnResult) || componentCache.props.styles; // Put the new props together

        var props = {
          css: css,
          styles: styles,
          theme: theme
        }; // Update the cache with all the new values

        updateComponentCache(theme, WithStyles, direction, {
          stylesInterface: stylesInterface,
          theme: theme,
          create: createFn,
          resolve: resolveFn,
          stylesFnResult: stylesFnResult,
          props: props
        });
        return props;
      };

      _proto.flush = function flush() {
        var stylesInterface = this.getCurrentInterface();

        if (stylesInterface && stylesInterface.flush) {
          stylesInterface.flush();
        }
      };

      _proto.render = function render() {
        var _ref2;

        // We only want to re-render if the theme, stylesInterface, or direction change.
        // These values are in context so we're listening for their updates.
        // this.getProps() derives the props from the theme, stylesInterface, and direction in
        // context, and memoizes them on the instance per direction.
        var _this$getProps = this.getProps(),
            theme = _this$getProps.theme,
            styles = _this$getProps.styles,
            css = _this$getProps.css; // Flush if specified


        if (flushBefore) {
          this.flush();
        }

        var _this$props = this.props,
            forwardedRef = _this$props.forwardedRef,
            rest = (0, _objectWithoutProperties2["default"])(_this$props, ["forwardedRef"]);
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent // TODO: remove conditional once breaking change to only support React 16.3+
        // ref: https://github.com/airbnb/react-with-styles/pull/240#discussion_r533497857
        , (0, _extends2["default"])({
          ref: typeof _react["default"].forwardRef === 'undefined' ? undefined : forwardedRef
        }, typeof _react["default"].forwardRef === 'undefined' ? this.props : rest, (_ref2 = {}, (0, _defineProperty2["default"])(_ref2, themePropName, theme), (0, _defineProperty2["default"])(_ref2, stylesPropName, styles), (0, _defineProperty2["default"])(_ref2, cssPropName, css), _ref2)));
      };

      return WithStyles;
    }(BaseClass); // TODO: remove conditional once breaking change to only support React 16.3+
    // ref: https://github.com/airbnb/react-with-styles/pull/240#discussion_r533497857


    if (typeof _react["default"].forwardRef !== 'undefined') {
      WithStyles.propTypes = {
        forwardedRef: (0, _ref3["default"])()
      };
    } // TODO: remove conditional once breaking change to only support React 16.3+
    // ref: https://github.com/airbnb/react-with-styles/pull/240#discussion_r533497857


    var ForwardedWithStyles = typeof _react["default"].forwardRef === 'undefined' ? WithStyles : /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
      return /*#__PURE__*/_react["default"].createElement(WithStyles, (0, _extends2["default"])({}, props, {
        forwardedRef: forwardedRef
      }));
    }); // Copy the wrapped component's prop types and default props on WithStyles

    if (WrappedComponent.propTypes) {
      ForwardedWithStyles.propTypes = _objectSpread({}, WrappedComponent.propTypes);
      delete ForwardedWithStyles.propTypes[stylesPropName];
      delete ForwardedWithStyles.propTypes[themePropName];
      delete ForwardedWithStyles.propTypes[cssPropName];
    }

    if (WrappedComponent.defaultProps) {
      ForwardedWithStyles.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }

    WithStyles.contextType = _WithStylesContext["default"];
    ForwardedWithStyles.WrappedComponent = WrappedComponent;
    ForwardedWithStyles.displayName = "withStyles(".concat(wrappedComponentName, ")");
    return (0, _hoistNonReactStatics["default"])(ForwardedWithStyles, WrappedComponent);
  };
}

var _default = withStyles;
/**
 * Deprecated: Do not use directly. Please wrap your component in `withStyles` and use the `css`
 * prop injected via props instead.
 */

exports["default"] = _default;
var css = _ThemedStyleSheet["default"].resolveLTR;
exports.css = css;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

/* Decoraters */


/* Utils */


/* CSS */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(41);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__(624);

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__(625);

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__(626);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__(627);

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__(628);

var _getEffect2 = _interopRequireDefault(_getEffect);

var _trackRemoval = __webpack_require__(629);

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__(630);

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__(631);

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__(632);

var _nodeListToArray = __webpack_require__(633);

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__(634);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: 'top', // Direction of tooltip
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }
      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ariaProps = this.state.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(props);

      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (isChanged) {
        this.setState({ ariaProps: newAriaProps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        var isCaptureMode = _this3.isCapture(target);
        var effect = _this3.getEffect(target);
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customBindListener(target);
          return;
        }

        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
        if (effect === 'float') {
          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
        }
        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
      });

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, false);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        _this4.unbindBasicListener(target);
        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
      });

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and ummount the compont
     * it is necessary to invloke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'getTooltipContent',
    value: function getTooltipContent() {
      var _props4 = this.props,
          getContent = _props4.getContent,
          children = _props4.children;

      // Generate tooltip content

      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: 'isEmptyTip',
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      var _this5 = this;

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props5 = this.props,
          multiline = _props5.multiline,
          getContent = _props5.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it needs to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // To prevent previously created timers from triggering
      this.clearTimer();

      this.setState({
        originTooltip: originTooltip,
        isMultiline: isMultiline,
        desiredPlace: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false,
        currentTarget: e.currentTarget
      }, function () {
        if (scrollHide) _this5.addScrollListener(_this5.state.currentTarget);
        _this5.updateTooltip(e);

        if (getContent && Array.isArray(getContent)) {
          _this5.intervalUpdateContent = setInterval(function () {
            if (_this5.mount) {
              var _getContent = _this5.props.getContent;

              var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
              var isEmptyTip = _this5.isEmptyTip(placeholder);
              _this5.setState({
                isEmptyTip: isEmptyTip
              });
              _this5.updatePosition();
            }
          }, getContent[1]);
        }
      });
    }

    /**
     * When mouse hover, updatetooltip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this6 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          show = _state.show,
          disable = _state.disable;
      var afterShow = this.props.afterShow;

      var placeholder = this.getTooltipContent();
      var delayTime = show ? 0 : parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target;

      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this6.state.show;
          _this6.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this6.updatePosition();
            if (isInvisible && afterShow) afterShow();
          });
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this7 = this;

      var _state2 = this.state,
          delayHide = _state2.delayHide,
          disable = _state2.disable;
      var afterHide = this.props.afterHide;

      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      var resetState = function resetState() {
        var isVisible = _this7.state.show;
        _this7.setState({
          show: false
        }, function () {
          _this7.removeScrollListener();
          if (isVisible && afterHide) afterHide();
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * Add scroll eventlistener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltip);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this8 = this;

      var _state3 = this.state,
          currentEvent = _state3.currentEvent,
          currentTarget = _state3.currentTarget,
          place = _state3.place,
          desiredPlace = _state3.desiredPlace,
          effect = _state3.effect,
          offset = _state3.offset;

      var node = _reactDom2.default.findDOMNode(this);
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this8.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      var head = document.getElementsByTagName('head')[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        head.insertBefore(tag, head.firstChild);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          extraClass = _state4.extraClass,
          html = _state4.html,
          ariaProps = _state4.ariaProps,
          disable = _state4.disable;

      var placeholder = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(placeholder);
      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass,
          id: this.props.id
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(
          Wrapper,
          _extends({ className: tooltipClass + ' ' + extraClass,
            id: this.props.id
          }, ariaProps, {
            'data-id': 'tooltip' }),
          placeholder
        );
      }
    }
  }]);

  return ReactTooltip;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div'
}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */


module.exports = ReactTooltip;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cov_2mqhfl4l9a=function(){var path="D:\\a\\1\\s\\app\\browser\\src\\_hoc\\_Aux\\index.js",hash="4750e7874519edbc6f850e587dee9de5af88ee1a",Function=function(){}.constructor,global=new Function('return this')(),gcv="__coverage__",coverageData={path:"D:\\a\\1\\s\\app\\browser\\src\\_hoc\\_Aux\\index.js",statementMap:{"0":{start:{line:1,column:12},end:{line:1,column:37}},"1":{start:{line:1,column:23},end:{line:1,column:37}}},fnMap:{"0":{name:"(anonymous_0)",decl:{start:{line:1,column:12},end:{line:1,column:13}},loc:{start:{line:1,column:23},end:{line:1,column:37}},line:1}},branchMap:{},s:{"0":0,"1":0},f:{"0":0},b:{},_coverageSchema:"332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2mqhfl4l9a.s[0]++;var aux=function aux(props){cov_2mqhfl4l9a.f[0]++;cov_2mqhfl4l9a.s[1]++;return props.children;};/* harmony default export */ __webpack_exports__["a"] = (aux);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(405);

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var callBind = __webpack_require__(42);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(5);
var momentValidationWrapper = __webpack_require__(454);
var core = __webpack_require__(455);

module.exports = {

  momentObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : core.createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(moment(value));
    },
    'Moment'
  ),

  momentDurationObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return moment.isDuration(value);
    },
    'Duration'
  ),

};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastr = exports.reducer = exports.actions = undefined;

var _ReduxToastr = __webpack_require__(256);

var _ReduxToastr2 = _interopRequireDefault(_ReduxToastr);

var _actions = __webpack_require__(124);

var ReduxToastrActions = _interopRequireWildcard(_actions);

var _reducer = __webpack_require__(125);

var _reducer2 = _interopRequireDefault(_reducer);

var _toastrEmitter = __webpack_require__(126);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ReduxToastr2.default;
var actions = exports.actions = ReduxToastrActions;
var reducer = exports.reducer = _reducer2.default;
var toastr = exports.toastr = _toastrEmitter.toastrEmitter;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(93);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var hasOwn = __webpack_require__(37);

var allowed = {
	__proto__: null,
	'[[Configurable]]': true,
	'[[Enumerable]]': true,
	'[[Get]]': true,
	'[[Set]]': true,
	'[[Value]]': true,
	'[[Writable]]': true
};

// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type

module.exports = function isPropertyDescriptor(Desc) {
	if (!Desc || typeof Desc !== 'object') {
		return false;
	}

	for (var key in Desc) { // eslint-disable-line
		if (hasOwn(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	var isData = hasOwn(Desc, '[[Value]]') || hasOwn(Desc, '[[Writable]]');
	var IsAccessor = hasOwn(Desc, '[[Get]]') || hasOwn(Desc, '[[Set]]');
	if (isData && IsAccessor) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = noflip;
var NOFLIP = '/* @noflip */'; // Appends a noflip comment to a style rule in order to prevent it from being automatically
// flipped in RTL contexts. This should be used only in situations where the style must remain
// unflipped regardless of direction context. See: https://github.com/kentcdodds/rtl-css-js#usage

function noflip(value) {
  if (typeof value === 'number') return "".concat(value, "px ").concat(NOFLIP);
  if (typeof value === 'string') return "".concat(value, " ").concat(NOFLIP);
  throw new TypeError('noflip expects a string or a number');
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(235);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(93);
var GetIntrinsic = __webpack_require__(17);
var setFunctionLength = __webpack_require__(400);

var $TypeError = __webpack_require__(8);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(67);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

function isSameDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf(_constants.WEEKDAYS);

exports["default"] = _default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

exports["default"] = _default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toastrWarn = toastrWarn;
exports.createReducer = createReducer;
exports.isBrowser = isBrowser;
exports.keyCode = keyCode;
exports.mapToToastrMessage = mapToToastrMessage;
exports.guid = guid;
exports.onCSSTransitionEnd = onCSSTransitionEnd;
exports.preventDuplication = preventDuplication;
exports.updateConfig = updateConfig;
exports._bind = _bind;

var _config = __webpack_require__(83);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whichAnimationEvent() {
  var t = void 0;
  var el = document.createElement('fakeelement');

  var transitions = {
    animation: 'animationend',
    oanimation: 'oanimationend',
    MSAnimation: 'MSAnimationEnd',
    webkitAnimation: 'webkitAnimationEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function isString(obj) {
  if (typeof obj == 'string') {
    return true;
  }
  return false;
}

function toastrWarn(message) {
  if (true) {
    return null;
  }
  console.warn('[react-redux-toastr] ' + message);
}

function createReducer(initialState, fnMap) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    var handle = fnMap[type];
    return handle ? handle(state, payload) : state;
  };
}

function isBrowser() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

function keyCode(e) {
  return e.which ? e.which : e.keyCode;
}

function mapToToastrMessage(type, array) {
  var obj = {};
  obj.type = type;
  obj.position = _config2.default.position;

  obj.options = array.filter(function (item) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object';
  })[0] || {};

  if (obj.options.hasOwnProperty('position')) {
    obj.position = obj.options.position;
  }

  if (!obj.options.hasOwnProperty('removeOnHover')) {
    obj.options.removeOnHover = true;
    if (type === 'message') {
      obj.options.removeOnHover = false;
    }
  }

  if (!obj.options.hasOwnProperty('showCloseButton')) {
    obj.options.showCloseButton = true;
  }

  if (type === 'message' && !obj.options.hasOwnProperty('timeOut')) {
    obj.options.timeOut = 0;
  }

  if (isString(array[0]) && isString(array[1])) {
    obj.title = array[0];
    obj.message = array[1];
  } else if (isString(array[0]) && !isString(array[1])) {
    obj.title = array[0];
  } else {
    obj.message = array[0];
  }

  return obj;
}

function guid() {
  var r = function r() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  return r() + r() + r() + '-' + r() + '_' + r() + '-' + r() + '_' + r() + r() + r();
}

function onCSSTransitionEnd(node, callback) {
  // if css animation is failed - dispatch event manually
  var animationEnd = whichAnimationEvent();
  var timeoutId = setTimeout(function () {
    var e = new Event(animationEnd);
    toastrWarn('The toastr box was closed automatically, please check \'transitionOut\' prop value');
    node.dispatchEvent(e);
  }, _config2.default.maxAnimationDelay);

  var runOnce = function runOnce(e) {
    clearTimeout(timeoutId);
    // stopPropagation is not working in IE11 and Edge, the transitionend from the Button.js is waiting
    // on the confirm animation to end first and not the Button.js
    e.stopPropagation();
    node.removeEventListener(animationEnd, runOnce);
    callback && callback(e);
  };
  node.addEventListener(animationEnd, runOnce);
}

function preventDuplication(currentData, newObjec) {
  var hasDuplication = false;
  currentData.forEach(function (item) {
    // If the toastr options implicitly specify not to prevent duplicates then skip
    if (item.options.preventDuplicates === false) return;
    // Because the toastr has a unic id we will check by the title and message.
    if (item.title === newObjec.title && item.message === newObjec.message && item.type === newObjec.type) {
      hasDuplication = true;
    }
  });
  return hasDuplication;
}

function updateConfig(obj) {
  Object.keys(_config2.default).forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      _config2.default[key] = obj[key];
    }
  });
}

function _bind(strinOrAray, scope) {
  var array = strinOrAray;
  if (!Array.isArray(strinOrAray)) {
    array = strinOrAray.split(' ');
  }
  return array.map(function (item) {
    return scope[item] = scope[item].bind(scope);
  });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toMomentObject;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(7);

function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
  var date = (0, _moment["default"])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

exports["default"] = _default;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

exports["default"] = _default;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.NAV_POSITION_BOTTOM, _constants.NAV_POSITION_TOP]);

exports["default"] = _default;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyAfterDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isBeforeDay = _interopRequireDefault(__webpack_require__(60));

function isInclusivelyAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b);
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateFields;
var cov_28rc33ygzc=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_helpers\\Form.js',hash='e1e8396db598360f9ee602a7f7f1b3a9384a2dcb',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_helpers\\Form.js',statementMap:{'0':{start:{line:2,column:16},end:{line:2,column:20}},'1':{start:{line:3,column:1},end:{line:256,column:7}},'2':{start:{line:4,column:22},end:{line:4,column:26}},'3':{start:{line:5,column:17},end:{line:5,column:31}},'4':{start:{line:6,column:2},end:{line:80,column:6}},'5':{start:{line:7,column:7},end:{line:47,column:8}},'6':{start:{line:8,column:9},end:{line:13,column:10}},'7':{start:{line:9,column:11},end:{line:12,column:12}},'8':{start:{line:10,column:12},end:{line:10,column:29}},'9':{start:{line:11,column:12},end:{line:11,column:34}},'10':{start:{line:14,column:9},end:{line:19,column:10}},'11':{start:{line:15,column:11},end:{line:18,column:12}},'12':{start:{line:16,column:12},end:{line:16,column:29}},'13':{start:{line:17,column:12},end:{line:17,column:34}},'14':{start:{line:20,column:9},end:{line:46,column:10}},'15':{start:{line:21,column:10},end:{line:45,column:14}},'16':{start:{line:22,column:13},end:{line:33,column:20}},'17':{start:{line:22,column:41},end:{line:33,column:18}},'18':{start:{line:36,column:13},end:{line:44,column:20}},'19':{start:{line:36,column:41},end:{line:44,column:18}},'20':{start:{line:49,column:10},end:{line:80,column:6}},'21':{start:{line:50,column:22},end:{line:50,column:64}},'22':{start:{line:51,column:6},end:{line:79,column:7}},'23':{start:{line:52,column:12},end:{line:52,column:29}},'24':{start:{line:53,column:12},end:{line:53,column:34}},'25':{start:{line:54,column:10},end:{line:78,column:11}},'26':{start:{line:55,column:16},end:{line:66,column:20}},'27':{start:{line:55,column:44},end:{line:66,column:18}},'28':{start:{line:69,column:16},end:{line:77,column:20}},'29':{start:{line:69,column:44},end:{line:77,column:18}},'30':{start:{line:81,column:5},end:{line:117,column:6}},'31':{start:{line:82,column:3},end:{line:82,column:20}},'32':{start:{line:83,column:3},end:{line:83,column:25}},'33':{start:{line:84,column:9},end:{line:116,column:10}},'34':{start:{line:85,column:10},end:{line:100,column:16}},'35':{start:{line:85,column:38},end:{line:100,column:14}},'36':{start:{line:103,column:10},end:{line:115,column:16}},'37':{start:{line:103,column:38},end:{line:115,column:14}},'38':{start:{line:118,column:5},end:{line:146,column:6}},'39':{start:{line:119,column:9},end:{line:119,column:26}},'40':{start:{line:120,column:9},end:{line:120,column:31}},'41':{start:{line:121,column:9},end:{line:145,column:13}},'42':{start:{line:122,column:12},end:{line:133,column:19}},'43':{start:{line:122,column:40},end:{line:133,column:17}},'44':{start:{line:136,column:12},end:{line:144,column:19}},'45':{start:{line:136,column:40},end:{line:144,column:17}},'46':{start:{line:147,column:5},end:{line:183,column:6}},'47':{start:{line:149,column:25},end:{line:149,column:292}},'48':{start:{line:150,column:6},end:{line:182,column:8}},'49':{start:{line:151,column:18},end:{line:151,column:26}},'50':{start:{line:152,column:7},end:{line:181,column:8}},'51':{start:{line:153,column:8},end:{line:153,column:25}},'52':{start:{line:154,column:5},end:{line:154,column:27}},'53':{start:{line:155,column:5},end:{line:179,column:15}},'54':{start:{line:156,column:14},end:{line:167,column:21}},'55':{start:{line:156,column:42},end:{line:167,column:19}},'56':{start:{line:170,column:14},end:{line:178,column:21}},'57':{start:{line:170,column:42},end:{line:178,column:19}},'58':{start:{line:180,column:8},end:{line:180,column:20}},'59':{start:{line:184,column:5},end:{line:255,column:6}},'60':{start:{line:185,column:6},end:{line:254,column:10}},'61':{start:{line:186,column:7},end:{line:222,column:14}},'62':{start:{line:187,column:8},end:{line:204,column:15}},'63':{start:{line:188,column:14},end:{line:203,column:21}},'64':{start:{line:188,column:42},end:{line:203,column:19}},'65':{start:{line:207,column:8},end:{line:221,column:15}},'66':{start:{line:208,column:14},end:{line:220,column:21}},'67':{start:{line:208,column:42},end:{line:220,column:19}},'68':{start:{line:225,column:7},end:{line:253,column:14}},'69':{start:{line:226,column:8},end:{line:239,column:15}},'70':{start:{line:227,column:14},end:{line:238,column:21}},'71':{start:{line:227,column:42},end:{line:238,column:19}},'72':{start:{line:242,column:8},end:{line:252,column:15}},'73':{start:{line:243,column:14},end:{line:251,column:21}},'74':{start:{line:243,column:42},end:{line:251,column:19}},'75':{start:{line:257,column:4},end:{line:257,column:19}}},fnMap:{'0':{name:'validateFields',decl:{start:{line:1,column:16},end:{line:1,column:30}},loc:{start:{line:1,column:54},end:{line:258,column:1}},line:1},'1':{name:'(anonymous_1)',decl:{start:{line:3,column:12},end:{line:3,column:13}},loc:{start:{line:3,column:28},end:{line:256,column:5}},line:3},'2':{name:'(anonymous_2)',decl:{start:{line:22,column:27},end:{line:22,column:28}},loc:{start:{line:22,column:41},end:{line:33,column:18}},line:22},'3':{name:'(anonymous_3)',decl:{start:{line:36,column:27},end:{line:36,column:28}},loc:{start:{line:36,column:41},end:{line:44,column:18}},line:36},'4':{name:'(anonymous_4)',decl:{start:{line:55,column:30},end:{line:55,column:31}},loc:{start:{line:55,column:44},end:{line:66,column:18}},line:55},'5':{name:'(anonymous_5)',decl:{start:{line:69,column:30},end:{line:69,column:31}},loc:{start:{line:69,column:44},end:{line:77,column:18}},line:69},'6':{name:'(anonymous_6)',decl:{start:{line:85,column:24},end:{line:85,column:25}},loc:{start:{line:85,column:38},end:{line:100,column:14}},line:85},'7':{name:'(anonymous_7)',decl:{start:{line:103,column:24},end:{line:103,column:25}},loc:{start:{line:103,column:38},end:{line:115,column:14}},line:103},'8':{name:'(anonymous_8)',decl:{start:{line:122,column:26},end:{line:122,column:27}},loc:{start:{line:122,column:40},end:{line:133,column:17}},line:122},'9':{name:'(anonymous_9)',decl:{start:{line:136,column:26},end:{line:136,column:27}},loc:{start:{line:136,column:40},end:{line:144,column:17}},line:136},'10':{name:'(anonymous_10)',decl:{start:{line:150,column:51},end:{line:150,column:52}},loc:{start:{line:150,column:69},end:{line:182,column:7}},line:150},'11':{name:'(anonymous_11)',decl:{start:{line:156,column:28},end:{line:156,column:29}},loc:{start:{line:156,column:42},end:{line:167,column:19}},line:156},'12':{name:'(anonymous_12)',decl:{start:{line:170,column:28},end:{line:170,column:29}},loc:{start:{line:170,column:42},end:{line:178,column:19}},line:170},'13':{name:'(anonymous_13)',decl:{start:{line:188,column:28},end:{line:188,column:29}},loc:{start:{line:188,column:42},end:{line:203,column:19}},line:188},'14':{name:'(anonymous_14)',decl:{start:{line:208,column:28},end:{line:208,column:29}},loc:{start:{line:208,column:42},end:{line:220,column:19}},line:208},'15':{name:'(anonymous_15)',decl:{start:{line:227,column:28},end:{line:227,column:29}},loc:{start:{line:227,column:42},end:{line:238,column:19}},line:227},'16':{name:'(anonymous_16)',decl:{start:{line:243,column:28},end:{line:243,column:29}},loc:{start:{line:243,column:42},end:{line:251,column:19}},line:243}},branchMap:{'0':{loc:{start:{line:6,column:2},end:{line:80,column:6}},type:'if',locations:[{start:{line:6,column:2},end:{line:80,column:6}},{start:{line:6,column:2},end:{line:80,column:6}}],line:6},'1':{loc:{start:{line:6,column:5},end:{line:6,column:58}},type:'binary-expr',locations:[{start:{line:6,column:5},end:{line:6,column:24}},{start:{line:6,column:28},end:{line:6,column:58}}],line:6},'2':{loc:{start:{line:7,column:7},end:{line:47,column:8}},type:'if',locations:[{start:{line:7,column:7},end:{line:47,column:8}},{start:{line:7,column:7},end:{line:47,column:8}}],line:7},'3':{loc:{start:{line:8,column:9},end:{line:13,column:10}},type:'if',locations:[{start:{line:8,column:9},end:{line:13,column:10}},{start:{line:8,column:9},end:{line:13,column:10}}],line:8},'4':{loc:{start:{line:9,column:11},end:{line:12,column:12}},type:'if',locations:[{start:{line:9,column:11},end:{line:12,column:12}},{start:{line:9,column:11},end:{line:12,column:12}}],line:9},'5':{loc:{start:{line:14,column:9},end:{line:19,column:10}},type:'if',locations:[{start:{line:14,column:9},end:{line:19,column:10}},{start:{line:14,column:9},end:{line:19,column:10}}],line:14},'6':{loc:{start:{line:15,column:11},end:{line:18,column:12}},type:'if',locations:[{start:{line:15,column:11},end:{line:18,column:12}},{start:{line:15,column:11},end:{line:18,column:12}}],line:15},'7':{loc:{start:{line:20,column:9},end:{line:46,column:10}},type:'if',locations:[{start:{line:20,column:9},end:{line:46,column:10}},{start:{line:20,column:9},end:{line:46,column:10}}],line:20},'8':{loc:{start:{line:21,column:10},end:{line:45,column:14}},type:'if',locations:[{start:{line:21,column:10},end:{line:45,column:14}},{start:{line:21,column:10},end:{line:45,column:14}}],line:21},'9':{loc:{start:{line:29,column:97},end:{line:29,column:150}},type:'cond-expr',locations:[{start:{line:29,column:123},end:{line:29,column:146}},{start:{line:29,column:149},end:{line:29,column:150}}],line:29},'10':{loc:{start:{line:29,column:157},end:{line:29,column:210}},type:'cond-expr',locations:[{start:{line:29,column:183},end:{line:29,column:206}},{start:{line:29,column:209},end:{line:29,column:210}}],line:29},'11':{loc:{start:{line:41,column:96},end:{line:41,column:149}},type:'cond-expr',locations:[{start:{line:41,column:122},end:{line:41,column:145}},{start:{line:41,column:148},end:{line:41,column:149}}],line:41},'12':{loc:{start:{line:41,column:156},end:{line:41,column:209}},type:'cond-expr',locations:[{start:{line:41,column:182},end:{line:41,column:205}},{start:{line:41,column:208},end:{line:41,column:209}}],line:41},'13':{loc:{start:{line:49,column:10},end:{line:80,column:6}},type:'if',locations:[{start:{line:49,column:10},end:{line:80,column:6}},{start:{line:49,column:10},end:{line:80,column:6}}],line:49},'14':{loc:{start:{line:49,column:14},end:{line:49,column:71}},type:'binary-expr',locations:[{start:{line:49,column:14},end:{line:49,column:33}},{start:{line:49,column:37},end:{line:49,column:71}}],line:49},'15':{loc:{start:{line:51,column:6},end:{line:79,column:7}},type:'if',locations:[{start:{line:51,column:6},end:{line:79,column:7}},{start:{line:51,column:6},end:{line:79,column:7}}],line:51},'16':{loc:{start:{line:51,column:9},end:{line:51,column:90}},type:'binary-expr',locations:[{start:{line:51,column:9},end:{line:51,column:47}},{start:{line:51,column:51},end:{line:51,column:90}}],line:51},'17':{loc:{start:{line:54,column:10},end:{line:78,column:11}},type:'if',locations:[{start:{line:54,column:10},end:{line:78,column:11}},{start:{line:54,column:10},end:{line:78,column:11}}],line:54},'18':{loc:{start:{line:81,column:5},end:{line:117,column:6}},type:'if',locations:[{start:{line:81,column:5},end:{line:117,column:6}},{start:{line:81,column:5},end:{line:117,column:6}}],line:81},'19':{loc:{start:{line:81,column:8},end:{line:81,column:264}},type:'binary-expr',locations:[{start:{line:81,column:8},end:{line:81,column:21}},{start:{line:81,column:25},end:{line:81,column:51}},{start:{line:81,column:55},end:{line:81,column:93}},{start:{line:81,column:97},end:{line:81,column:164}},{start:{line:81,column:168},end:{line:81,column:264}}],line:81},'20':{loc:{start:{line:84,column:9},end:{line:116,column:10}},type:'if',locations:[{start:{line:84,column:9},end:{line:116,column:10}},{start:{line:84,column:9},end:{line:116,column:10}}],line:84},'21':{loc:{start:{line:91,column:34},end:{line:91,column:90}},type:'cond-expr',locations:[{start:{line:91,column:75},end:{line:91,column:82}},{start:{line:91,column:85},end:{line:91,column:90}}],line:91},'22':{loc:{start:{line:95,column:34},end:{line:95,column:119}},type:'cond-expr',locations:[{start:{line:95,column:104},end:{line:95,column:111}},{start:{line:95,column:114},end:{line:95,column:119}}],line:95},'23':{loc:{start:{line:107,column:33},end:{line:107,column:89}},type:'cond-expr',locations:[{start:{line:107,column:74},end:{line:107,column:81}},{start:{line:107,column:84},end:{line:107,column:89}}],line:107},'24':{loc:{start:{line:111,column:33},end:{line:111,column:118}},type:'cond-expr',locations:[{start:{line:111,column:103},end:{line:111,column:110}},{start:{line:111,column:113},end:{line:111,column:118}}],line:111},'25':{loc:{start:{line:118,column:5},end:{line:146,column:6}},type:'if',locations:[{start:{line:118,column:5},end:{line:146,column:6}},{start:{line:118,column:5},end:{line:146,column:6}}],line:118},'26':{loc:{start:{line:118,column:8},end:{line:118,column:93}},type:'binary-expr',locations:[{start:{line:118,column:8},end:{line:118,column:21}},{start:{line:118,column:25},end:{line:118,column:50}},{start:{line:118,column:54},end:{line:118,column:93}}],line:118},'27':{loc:{start:{line:121,column:9},end:{line:145,column:13}},type:'if',locations:[{start:{line:121,column:9},end:{line:145,column:13}},{start:{line:121,column:9},end:{line:145,column:13}}],line:121},'28':{loc:{start:{line:147,column:5},end:{line:183,column:6}},type:'if',locations:[{start:{line:147,column:5},end:{line:183,column:6}},{start:{line:147,column:5},end:{line:183,column:6}}],line:147},'29':{loc:{start:{line:147,column:8},end:{line:147,column:48}},type:'binary-expr',locations:[{start:{line:147,column:8},end:{line:147,column:21}},{start:{line:147,column:25},end:{line:147,column:48}}],line:147},'30':{loc:{start:{line:152,column:7},end:{line:181,column:8}},type:'if',locations:[{start:{line:152,column:7},end:{line:181,column:8}},{start:{line:152,column:7},end:{line:181,column:8}}],line:152},'31':{loc:{start:{line:152,column:10},end:{line:152,column:80}},type:'binary-expr',locations:[{start:{line:152,column:10},end:{line:152,column:26}},{start:{line:152,column:30},end:{line:152,column:80}}],line:152},'32':{loc:{start:{line:155,column:5},end:{line:179,column:15}},type:'if',locations:[{start:{line:155,column:5},end:{line:179,column:15}},{start:{line:155,column:5},end:{line:179,column:15}}],line:155},'33':{loc:{start:{line:184,column:5},end:{line:255,column:6}},type:'if',locations:[{start:{line:184,column:5},end:{line:255,column:6}},{start:{line:184,column:5},end:{line:255,column:6}}],line:184},'34':{loc:{start:{line:185,column:6},end:{line:254,column:10}},type:'if',locations:[{start:{line:185,column:6},end:{line:254,column:10}},{start:{line:185,column:6},end:{line:254,column:10}}],line:185},'35':{loc:{start:{line:186,column:7},end:{line:222,column:14}},type:'if',locations:[{start:{line:186,column:7},end:{line:222,column:14}},{start:{line:186,column:7},end:{line:222,column:14}}],line:186},'36':{loc:{start:{line:187,column:8},end:{line:204,column:15}},type:'if',locations:[{start:{line:187,column:8},end:{line:204,column:15}},{start:{line:187,column:8},end:{line:204,column:15}}],line:187},'37':{loc:{start:{line:187,column:11},end:{line:187,column:104}},type:'binary-expr',locations:[{start:{line:187,column:11},end:{line:187,column:70}},{start:{line:187,column:74},end:{line:187,column:104}}],line:187},'38':{loc:{start:{line:194,column:39},end:{line:194,column:97}},type:'cond-expr',locations:[{start:{line:194,column:80},end:{line:194,column:89}},{start:{line:194,column:92},end:{line:194,column:97}}],line:194},'39':{loc:{start:{line:198,column:39},end:{line:198,column:126}},type:'cond-expr',locations:[{start:{line:198,column:109},end:{line:198,column:118}},{start:{line:198,column:121},end:{line:198,column:126}}],line:198},'40':{loc:{start:{line:207,column:8},end:{line:221,column:15}},type:'if',locations:[{start:{line:207,column:8},end:{line:221,column:15}},{start:{line:207,column:8},end:{line:221,column:15}}],line:207},'41':{loc:{start:{line:207,column:11},end:{line:207,column:89}},type:'binary-expr',locations:[{start:{line:207,column:11},end:{line:207,column:55}},{start:{line:207,column:59},end:{line:207,column:89}}],line:207},'42':{loc:{start:{line:212,column:38},end:{line:212,column:96}},type:'cond-expr',locations:[{start:{line:212,column:79},end:{line:212,column:88}},{start:{line:212,column:91},end:{line:212,column:96}}],line:212},'43':{loc:{start:{line:216,column:38},end:{line:216,column:125}},type:'cond-expr',locations:[{start:{line:216,column:108},end:{line:216,column:117}},{start:{line:216,column:120},end:{line:216,column:125}}],line:216},'44':{loc:{start:{line:225,column:7},end:{line:253,column:14}},type:'if',locations:[{start:{line:225,column:7},end:{line:253,column:14}},{start:{line:225,column:7},end:{line:253,column:14}}],line:225},'45':{loc:{start:{line:226,column:8},end:{line:239,column:15}},type:'if',locations:[{start:{line:226,column:8},end:{line:239,column:15}},{start:{line:226,column:8},end:{line:239,column:15}}],line:226},'46':{loc:{start:{line:226,column:11},end:{line:226,column:104}},type:'binary-expr',locations:[{start:{line:226,column:11},end:{line:226,column:70}},{start:{line:226,column:74},end:{line:226,column:104}}],line:226},'47':{loc:{start:{line:242,column:8},end:{line:252,column:15}},type:'if',locations:[{start:{line:242,column:8},end:{line:252,column:15}},{start:{line:242,column:8},end:{line:252,column:15}}],line:242},'48':{loc:{start:{line:242,column:11},end:{line:242,column:89}},type:'binary-expr',locations:[{start:{line:242,column:11},end:{line:242,column:55}},{start:{line:242,column:59},end:{line:242,column:89}}],line:242}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0,0,0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0],'48':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function validateFields(fields,stateLocation){var _this=this;cov_28rc33ygzc.f[0]++;var returner=(cov_28rc33ygzc.s[0]++,true);cov_28rc33ygzc.s[1]++;fields.map(function(key,index){cov_28rc33ygzc.f[1]++;var curFieldValid=(cov_28rc33ygzc.s[2]++,true);var curField=(cov_28rc33ygzc.s[3]++,_this.refs[key]);cov_28rc33ygzc.s[4]++;if((cov_28rc33ygzc.b[1][0]++,curField.props.type)&&(cov_28rc33ygzc.b[1][1]++,curField.props.type==="number")){cov_28rc33ygzc.b[0][0]++;cov_28rc33ygzc.s[5]++;if(curField.props.value){cov_28rc33ygzc.b[2][0]++;cov_28rc33ygzc.s[6]++;if(curField.props.minValue.toString().length){cov_28rc33ygzc.b[3][0]++;cov_28rc33ygzc.s[7]++;if(Number.parseInt(curField.props.value)<Number.parseInt(curField.props.minValue)){cov_28rc33ygzc.b[4][0]++;cov_28rc33ygzc.s[8]++;returner=false;cov_28rc33ygzc.s[9]++;curFieldValid=false;}else{cov_28rc33ygzc.b[4][1]++;}}else{cov_28rc33ygzc.b[3][1]++;}cov_28rc33ygzc.s[10]++;if(curField.props.maxValue.toString().length){cov_28rc33ygzc.b[5][0]++;cov_28rc33ygzc.s[11]++;if(Number.parseInt(curField.props.value)>Number.parseInt(curField.props.maxValue)){cov_28rc33ygzc.b[6][0]++;cov_28rc33ygzc.s[12]++;returner=false;cov_28rc33ygzc.s[13]++;curFieldValid=false;}else{cov_28rc33ygzc.b[6][1]++;}}else{cov_28rc33ygzc.b[5][1]++;}cov_28rc33ygzc.s[14]++;if(!curFieldValid){cov_28rc33ygzc.b[7][0]++;cov_28rc33ygzc.s[15]++;if(stateLocation){cov_28rc33ygzc.b[8][0]++;cov_28rc33ygzc.s[16]++;_this.setState(function(prevState){cov_28rc33ygzc.f[2]++;cov_28rc33ygzc.s[17]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.invalid.number',{min:curField.props.minValue?(cov_28rc33ygzc.b[9][0]++,curField.props.minValue):(cov_28rc33ygzc.b[9][1]++,0),max:curField.props.maxValue?(cov_28rc33ygzc.b[10][0]++,curField.props.maxValue):(cov_28rc33ygzc.b[10][1]++,0)})}))))};});}else{cov_28rc33ygzc.b[8][1]++;cov_28rc33ygzc.s[18]++;_this.setState(function(prevState){cov_28rc33ygzc.f[3]++;cov_28rc33ygzc.s[19]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.invalid.number',{min:curField.props.minValue?(cov_28rc33ygzc.b[11][0]++,curField.props.minValue):(cov_28rc33ygzc.b[11][1]++,0),max:curField.props.maxValue?(cov_28rc33ygzc.b[12][0]++,curField.props.maxValue):(cov_28rc33ygzc.b[12][1]++,0)})}))};});}}else{cov_28rc33ygzc.b[7][1]++;}}else{cov_28rc33ygzc.b[2][1]++;}}else{cov_28rc33ygzc.b[0][1]++;cov_28rc33ygzc.s[20]++;if((cov_28rc33ygzc.b[14][0]++,curField.props.type)&&(cov_28rc33ygzc.b[14][1]++,curField.props.type==="password")){cov_28rc33ygzc.b[13][0]++;var regexCheck=(cov_28rc33ygzc.s[21]++,/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/g);cov_28rc33ygzc.s[22]++;if((cov_28rc33ygzc.b[16][0]++,curField.props.value.toString().length)&&(cov_28rc33ygzc.b[16][1]++,!curField.props.value.match(regexCheck))){cov_28rc33ygzc.b[15][0]++;cov_28rc33ygzc.s[23]++;returner=false;cov_28rc33ygzc.s[24]++;curFieldValid=false;cov_28rc33ygzc.s[25]++;if(stateLocation){cov_28rc33ygzc.b[17][0]++;cov_28rc33ygzc.s[26]++;_this.setState(function(prevState){cov_28rc33ygzc.f[4]++;cov_28rc33ygzc.s[27]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.invalid.password')}))))};});}else{cov_28rc33ygzc.b[17][1]++;cov_28rc33ygzc.s[28]++;_this.setState(function(prevState){cov_28rc33ygzc.f[5]++;cov_28rc33ygzc.s[29]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.invalid.password')}))};});}}else{cov_28rc33ygzc.b[15][1]++;}}else{cov_28rc33ygzc.b[13][1]++;}}cov_28rc33ygzc.s[30]++;if((cov_28rc33ygzc.b[19][0]++,curFieldValid)&&(cov_28rc33ygzc.b[19][1]++,curField.props.shouldMatch)&&(cov_28rc33ygzc.b[19][2]++,curField.props.value.toString().length)&&(cov_28rc33ygzc.b[19][3]++,_this.refs[curField.props.shouldMatch].props.value.toString().length)&&(cov_28rc33ygzc.b[19][4]++,curField.props.value.toString()!==_this.refs[curField.props.shouldMatch].props.value.toString())){cov_28rc33ygzc.b[18][0]++;cov_28rc33ygzc.s[31]++;returner=false;cov_28rc33ygzc.s[32]++;curFieldValid=false;cov_28rc33ygzc.s[33]++;if(stateLocation){cov_28rc33ygzc.b[20][0]++;cov_28rc33ygzc.s[34]++;_this.setState(function(prevState){var _Object$assign7;cov_28rc33ygzc.f[6]++;cov_28rc33ygzc.s[35]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],(_Object$assign7={},_defineProperty(_Object$assign7,key,{state:curField.props.value.toString().length?(cov_28rc33ygzc.b[21][0]++,'error'):(cov_28rc33ygzc.b[21][1]++,false),message:_this.props.translate('global.error.match.'+curField.props.type)}),_defineProperty(_Object$assign7,curField.props.shouldMatch,{state:_this.refs[curField.props.shouldMatch].props.value.toString().length?(cov_28rc33ygzc.b[22][0]++,'error'):(cov_28rc33ygzc.b[22][1]++,false),message:_this.props.translate('global.error.match.'+curField.props.type)}),_Object$assign7))))};});}else{cov_28rc33ygzc.b[20][1]++;cov_28rc33ygzc.s[36]++;_this.setState(function(prevState){var _Object$assign9;cov_28rc33ygzc.f[7]++;cov_28rc33ygzc.s[37]++;return{form_state:Object.assign({},prevState.form_state,(_Object$assign9={},_defineProperty(_Object$assign9,key,{state:curField.props.value.toString().length?(cov_28rc33ygzc.b[23][0]++,'error'):(cov_28rc33ygzc.b[23][1]++,false),message:_this.props.translate('global.error.match.'+curField.props.type)}),_defineProperty(_Object$assign9,curField.props.shouldMatch,{state:_this.refs[curField.props.shouldMatch].props.value.toString().length?(cov_28rc33ygzc.b[24][0]++,'error'):(cov_28rc33ygzc.b[24][1]++,false),message:_this.props.translate('global.error.match.'+curField.props.type)}),_Object$assign9))};});}}else{cov_28rc33ygzc.b[18][1]++;}cov_28rc33ygzc.s[38]++;if((cov_28rc33ygzc.b[26][0]++,curFieldValid)&&(cov_28rc33ygzc.b[26][1]++,curField.props.isRequired)&&(cov_28rc33ygzc.b[26][2]++,!curField.props.value.toString().length)){cov_28rc33ygzc.b[25][0]++;cov_28rc33ygzc.s[39]++;returner=false;cov_28rc33ygzc.s[40]++;curFieldValid=false;cov_28rc33ygzc.s[41]++;if(stateLocation){cov_28rc33ygzc.b[27][0]++;cov_28rc33ygzc.s[42]++;_this.setState(function(prevState){cov_28rc33ygzc.f[8]++;cov_28rc33ygzc.s[43]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.required.default')}))))};});}else{cov_28rc33ygzc.b[27][1]++;cov_28rc33ygzc.s[44]++;_this.setState(function(prevState){cov_28rc33ygzc.f[9]++;cov_28rc33ygzc.s[45]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.required.default')}))};});}}else{cov_28rc33ygzc.b[25][1]++;}cov_28rc33ygzc.s[46]++;if((cov_28rc33ygzc.b[29][0]++,curFieldValid)&&(cov_28rc33ygzc.b[29][1]++,curField.props.shouldBe)){cov_28rc33ygzc.b[28][0]++;/* Returns true if a test is failed. With this function it will only test until it fails */var regexEmail=(cov_28rc33ygzc.s[47]++,/^(([\w-]+\.)+[\w-]+|([a-zA-Z]{1}|[\w-]{2,}))@((([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])\.([0-1]?[0-9]{1,2}|25[0-5]|2[0-4][0-9])){1}|([a-zA-Z0-9]+[\w-]+\.)+[a-zA-Z]{1}[a-zA-Z0-9-]{1,23})$/g);cov_28rc33ygzc.s[48]++;Object.entries(curField.props.shouldBe).some(function(entry,index){cov_28rc33ygzc.f[10]++;var type=(cov_28rc33ygzc.s[49]++,entry[0]);cov_28rc33ygzc.s[50]++;if((cov_28rc33ygzc.b[31][0]++,type==='email')&&(cov_28rc33ygzc.b[31][1]++,!curField.props.value.toString().match(regexEmail))){cov_28rc33ygzc.b[30][0]++;cov_28rc33ygzc.s[51]++;returner=false;cov_28rc33ygzc.s[52]++;curFieldValid=false;cov_28rc33ygzc.s[53]++;if(stateLocation){cov_28rc33ygzc.b[32][0]++;cov_28rc33ygzc.s[54]++;_this.setState(function(prevState){cov_28rc33ygzc.f[11]++;cov_28rc33ygzc.s[55]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.shouldbe.email')}))))};});}else{cov_28rc33ygzc.b[32][1]++;cov_28rc33ygzc.s[56]++;_this.setState(function(prevState){cov_28rc33ygzc.f[12]++;cov_28rc33ygzc.s[57]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},key,{state:'error',message:_this.props.translate('global.error.shouldbe.email')}))};});}cov_28rc33ygzc.s[58]++;return true;}else{cov_28rc33ygzc.b[30][1]++;}});}else{cov_28rc33ygzc.b[28][1]++;}cov_28rc33ygzc.s[59]++;if(curFieldValid){cov_28rc33ygzc.b[33][0]++;cov_28rc33ygzc.s[60]++;if(curField.props.shouldMatch){cov_28rc33ygzc.b[34][0]++;cov_28rc33ygzc.s[61]++;if(stateLocation){cov_28rc33ygzc.b[35][0]++;cov_28rc33ygzc.s[62]++;if((cov_28rc33ygzc.b[37][0]++,_this.state.form_state[stateLocation][key].state==='error')||(cov_28rc33ygzc.b[37][1]++,curField.props.showValidAlways)){cov_28rc33ygzc.b[36][0]++;cov_28rc33ygzc.s[63]++;_this.setState(function(prevState){var _Object$assign16;cov_28rc33ygzc.f[13]++;cov_28rc33ygzc.s[64]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],(_Object$assign16={},_defineProperty(_Object$assign16,key,{state:curField.props.value.toString().length?(cov_28rc33ygzc.b[38][0]++,'success'):(cov_28rc33ygzc.b[38][1]++,false),message:null}),_defineProperty(_Object$assign16,curField.props.shouldMatch,{state:_this.refs[curField.props.shouldMatch].props.value.toString().length?(cov_28rc33ygzc.b[39][0]++,'success'):(cov_28rc33ygzc.b[39][1]++,false),message:null}),_Object$assign16))))};});}else{cov_28rc33ygzc.b[36][1]++;}}else{cov_28rc33ygzc.b[35][1]++;cov_28rc33ygzc.s[65]++;if((cov_28rc33ygzc.b[41][0]++,_this.state.form_state[key].state==='error')||(cov_28rc33ygzc.b[41][1]++,curField.props.showValidAlways)){cov_28rc33ygzc.b[40][0]++;cov_28rc33ygzc.s[66]++;_this.setState(function(prevState){var _Object$assign18;cov_28rc33ygzc.f[14]++;cov_28rc33ygzc.s[67]++;return{form_state:Object.assign({},prevState.form_state,(_Object$assign18={},_defineProperty(_Object$assign18,key,{state:curField.props.value.toString().length?(cov_28rc33ygzc.b[42][0]++,'success'):(cov_28rc33ygzc.b[42][1]++,false),message:null}),_defineProperty(_Object$assign18,curField.props.shouldMatch,{state:_this.refs[curField.props.shouldMatch].props.value.toString().length?(cov_28rc33ygzc.b[43][0]++,'success'):(cov_28rc33ygzc.b[43][1]++,false),message:null}),_Object$assign18))};});}else{cov_28rc33ygzc.b[40][1]++;}}}else{cov_28rc33ygzc.b[34][1]++;cov_28rc33ygzc.s[68]++;if(stateLocation){cov_28rc33ygzc.b[44][0]++;cov_28rc33ygzc.s[69]++;if((cov_28rc33ygzc.b[46][0]++,_this.state.form_state[stateLocation][key].state==='error')||(cov_28rc33ygzc.b[46][1]++,curField.props.showValidAlways)){cov_28rc33ygzc.b[45][0]++;cov_28rc33ygzc.s[70]++;_this.setState(function(prevState){cov_28rc33ygzc.f[15]++;cov_28rc33ygzc.s[71]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},stateLocation,Object.assign({},prevState.form_state[stateLocation],_defineProperty({},key,{state:'success',message:null}))))};});}else{cov_28rc33ygzc.b[45][1]++;}}else{cov_28rc33ygzc.b[44][1]++;cov_28rc33ygzc.s[72]++;if((cov_28rc33ygzc.b[48][0]++,_this.state.form_state[key].state==='error')||(cov_28rc33ygzc.b[48][1]++,curField.props.showValidAlways)){cov_28rc33ygzc.b[47][0]++;cov_28rc33ygzc.s[73]++;_this.setState(function(prevState){cov_28rc33ygzc.f[16]++;cov_28rc33ygzc.s[74]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},key,{state:'success',message:null}))};});}else{cov_28rc33ygzc.b[47][1]++;}}}}else{cov_28rc33ygzc.b[33][1]++;}});cov_28rc33ygzc.s[75]++;return returner;}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISODateString;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

function toISODateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0') + '-' + String(dateObj.date()).padStart(2, '0');
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf([_constants.START_DATE, _constants.END_DATE])]);

exports["default"] = _default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.INFO_POSITION_TOP, _constants.INFO_POSITION_BOTTOM, _constants.INFO_POSITION_BEFORE, _constants.INFO_POSITION_AFTER]);

exports["default"] = _default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBeforeDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

function isBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var aYear = a.year();
  var aMonth = a.month();
  var bYear = b.year();
  var bMonth = b.month();
  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;
  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var CloseButton = function CloseButton(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"
  }));
};

CloseButton.defaultProps = {
  focusable: "false",
  viewBox: "0 0 12 12"
};
var _default = CloseButton;
exports["default"] = _default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIALIZE */
/* unused harmony export ADD_TRANSLATION */
/* unused harmony export ADD_TRANSLATION_FOR_LANGUGE */
/* unused harmony export SET_LANGUAGES */
/* unused harmony export SET_ACTIVE_LANGUAGE */
/* unused harmony export TRANSLATE */
/* unused harmony export languages */
/* unused harmony export translations */
/* unused harmony export options */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultTranslateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return localeReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return initialize; });
/* unused harmony export addTranslation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTranslationForLanguage; });
/* unused harmony export setLanguages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setActiveLanguage; });
/* unused harmony export getTranslations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getActiveLanguage; });
/* unused harmony export translationsEqualSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTranslationsForActiveLanguage; });
/* unused harmony export getTranslationsForSpecificLanguage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTranslate; });
/* unused harmony export getTranslateComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(135);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * TYPES
 */


/**
 * ACTIONS
 */
var INITIALIZE = '@@localize/INITIALIZE';
var ADD_TRANSLATION = '@@localize/ADD_TRANSLATION';
var ADD_TRANSLATION_FOR_LANGUGE = '@@localize/ADD_TRANSLATION_FOR_LANGUGE';
var SET_LANGUAGES = '@@localize/SET_LANGUAGES';
var SET_ACTIVE_LANGUAGE = '@@localize/SET_ACTIVE_LANGUAGE';
var TRANSLATE = '@@localize/TRANSLATE';

/**
 * REDUCERS
 */
function languages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case INITIALIZE:
    case SET_LANGUAGES:
      var _options = action.payload.options || {};
      var _activeLanguage = action.payload.activeLanguage || _options.defaultLanguage;
      return action.payload.languages.map(function (language, index) {
        var isActive = function isActive(code) {
          return _activeLanguage !== undefined ? code === _activeLanguage : index === 0;
        };
        // check if it's using array of Language objects, or array of languge codes
        return typeof language === 'string' ? { code: language, active: isActive(language) // language codes
        } : _extends({}, language, { active: isActive(language.code) }); // language objects
      });
    case SET_ACTIVE_LANGUAGE:
      return state.map(function (language) {
        return language.code === action.payload.languageCode ? _extends({}, language, { active: true }) : _extends({}, language, { active: false });
      });
    default:
      return state;
  }
}

function translations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case ADD_TRANSLATION:
      // apply transformation if set in options
      var _translations = action.translationTransform !== undefined ? action.translationTransform(action.payload.translation, action.languageCodes) : action.payload.translation;
      return _extends({}, state, Object(__WEBPACK_IMPORTED_MODULE_2_flat__["flatten"])(_translations, { safe: true }));
    case ADD_TRANSLATION_FOR_LANGUGE:
      var languageIndex = action.languageCodes.indexOf(action.payload.language);
      var flattenedTranslations = languageIndex >= 0 ? Object(__WEBPACK_IMPORTED_MODULE_2_flat__["flatten"])(action.payload.translation) : {};
      // convert single translation data into multiple
      var languageTranslations = Object.keys(flattenedTranslations).reduce(function (prev, cur) {
        // loop through each language, and for languages that don't match active language 
        // keep existing translation data, and for active language store new translation data
        var translationValues = action.languageCodes.map(function (code, index) {
          var existingValues = state[cur] || [];
          return index === languageIndex ? flattenedTranslations[cur] : existingValues[index];
        });
        return _extends({}, prev, _defineProperty({}, cur, translationValues));
      }, {});

      return _extends({}, state, languageTranslations);
    default:
      return state;
  }
}

function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultTranslateOptions;
  var action = arguments[1];

  switch (action.type) {
    case INITIALIZE:
      var _options2 = action.payload.options || {};
      return _extends({}, state, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* validateOptions */])(_options2));
    default:
      return state;
  }
};

var defaultTranslateOptions = {
  renderInnerHtml: true,
  showMissingTranslationMsg: true,
  missingTranslationMsg: 'Missing translation key ${ key } for language ${ code }',
  ignoreTranslateChildren: false
};

var initialState = {
  languages: [],
  translations: {},
  options: defaultTranslateOptions
};

var localeReducer = function localeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var languageCodes = state.languages.map(function (language) {
    return language.code;
  });
  var translationTransform = state.options.translationTransform;
  return {
    languages: languages(state.languages, action),
    translations: translations(state.translations, _extends({}, action, { languageCodes: languageCodes, translationTransform: translationTransform })),
    options: options(state.options, action)
  };
};

/**
 * ACTION CREATORS
 */
var initialize = function initialize(languages) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTranslateOptions;
  return {
    type: INITIALIZE,
    payload: { languages: languages, options: options }
  };
};

var addTranslation = function addTranslation(translation) {
  return {
    type: ADD_TRANSLATION,
    payload: { translation: translation }
  };
};

var addTranslationForLanguage = function addTranslationForLanguage(translation, language) {
  return {
    type: ADD_TRANSLATION_FOR_LANGUGE,
    payload: { translation: translation, language: language }
  };
};

var setLanguages = function setLanguages(languages, activeLanguage) {
  Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* warning */])('The setLanguages action will be removed in the next major version. ' + 'Please use initialize action instead https://ryandrewjohnson.github.io/react-localize-redux/api/action-creators/#initializelanguages-options');
  return {
    type: SET_LANGUAGES,
    payload: { languages: languages, activeLanguage: activeLanguage }
  };
};

var setActiveLanguage = function setActiveLanguage(languageCode) {
  return {
    type: SET_ACTIVE_LANGUAGE,
    payload: { languageCode: languageCode }
  };
};

/**
 * SELECTORS
 */
var getTranslations = function getTranslations(state) {
  return state.translations;
};

var getLanguages = function getLanguages(state) {
  return state.languages;
};

var getOptions = function getOptions(state) {
  return state.options;
};

var getActiveLanguage = function getActiveLanguage(state) {
  var languages = getLanguages(state);
  return languages.filter(function (language) {
    return language.active === true;
  })[0];
};

/**
 * A custom equality checker that checker that compares an objects keys and values instead of === comparison
 * e.g. {name: 'Ted', sport: 'hockey'} would result in 'name,sport - Ted,hocker' which would be used for comparison
 * 
 * NOTE: This works with activeLanguage, languages, and translations data types.
 * If a new data type is added to selector this would need to be updated to accomodate
 */
var translationsEqualSelector = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelectorCreator"])(__WEBPACK_IMPORTED_MODULE_3_reselect__["defaultMemoize"], function (cur, prev) {
  var prevKeys = (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) === "object" ? Object.keys(prev).toString() : undefined;
  var curKeys = (typeof cur === 'undefined' ? 'undefined' : _typeof(cur)) === "object" ? Object.keys(cur).toString() : undefined;

  var prevValues = (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) === "object" ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* objectValuesToString */])(prev) : undefined;
  var curValues = (typeof cur === 'undefined' ? 'undefined' : _typeof(cur)) === "object" ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* objectValuesToString */])(cur) : undefined;

  var prevCacheValue = !prevKeys || !prevValues ? prevKeys + ' - ' + prevValues : prev;

  var curCacheValue = !curKeys || !curValues ? curKeys + ' - ' + curValues : cur;

  return prevCacheValue === curCacheValue;
});

var getTranslationsForActiveLanguage = translationsEqualSelector(getActiveLanguage, getLanguages, getTranslations, __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getTranslationsForLanguage */]);

var getTranslationsForSpecificLanguage = translationsEqualSelector(getLanguages, getTranslations, function (languages, translations) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["defaultMemoize"])(function (languageCode) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getTranslationsForLanguage */])(languageCode, languages, translations);
  });
});

var getTranslate = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getTranslationsForActiveLanguage, getTranslationsForSpecificLanguage, getActiveLanguage, getOptions, function (translationsForActiveLanguage, getTranslationsForLanguage, activeLanguage, options) {
  return function (value) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var optionsOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var defaultLanguage = optionsOverride.defaultLanguage,
        rest = _objectWithoutProperties(optionsOverride, ['defaultLanguage']);

    var translateOptions = _extends({}, options, rest);
    var translations = defaultLanguage !== undefined ? getTranslationsForLanguage({ code: defaultLanguage, active: false }) : translationsForActiveLanguage;
    if (typeof value === 'string') {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getLocalizedElement */])(value, translations, data, activeLanguage, translateOptions);
    } else if (Array.isArray(value)) {
      return value.reduce(function (prev, cur) {
        return _extends({}, prev, _defineProperty({}, cur, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* getLocalizedElement */])(cur, translations, data, activeLanguage, translateOptions)));
      }, {});
    } else {
      throw new Error('react-localize-redux: Invalid key passed to getTranslate.');
    }
  };
});


var getTranslateComponent = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getTranslate, function (translate) {
  return function (props) {
    return translate(props.id, props.data, props.options);
  };
});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(368);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var inspect = __webpack_require__(403);

var IsPropertyKey = __webpack_require__(38);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/6.0/#sec-get-o-p

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

/** @type {import('./RequireObjectCoercible')} */
module.exports = function RequireObjectCoercible(value) {
	if (value == null) {
		throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var callBind = __webpack_require__(42);

var implementation = __webpack_require__(184);
var getPolyfill = __webpack_require__(185);
var shim = __webpack_require__(479);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(102));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _default = (0, _airbnbPropTypes.and)([_propTypes["default"].instanceOf(Set), function modifiers(props, propName) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  var propValue = props[propName];
  var firstError;
  (0, _toConsumableArray2["default"])(propValue).some(function (v, i) {
    var _PropTypes$string;

    var fakePropName = "".concat(propName, ": index ").concat(i);
    firstError = (_PropTypes$string = _propTypes["default"].string).isRequired.apply(_PropTypes$string, [(0, _defineProperty2["default"])({}, fakePropName, v), fakePropName].concat(rest));
    return firstError != null;
  });
  return firstError == null ? null : firstError;
}], 'Modifiers (Set of Strings)');

exports["default"] = _default;

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEventListener", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toISOMonthString;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

function toISOMonthString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null; // Template strings compiled in strict mode uses concat, which is slow. Since
  // this code is in a hot path and we want it to be as fast as possible, we
  // want to use old-fashioned +.
  // eslint-disable-next-line prefer-template

  return dateObj.year() + '-' + String(dateObj.month() + 1).padStart(2, '0');
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAfterDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isBeforeDay = _interopRequireDefault(__webpack_require__(60));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

function isAfterDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isBeforeDay["default"])(a, b) && !(0, _isSameDay["default"])(a, b);
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(249);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toastr = {
  maxAnimationDelay: 6000,
  newestOnTop: true,
  position: 'top-right',
  preventDuplicates: true
};

exports.default = toastr;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TOASTR = exports.ADD_TOASTR = '@ReduxToastr/toastr/ADD';
var REMOVE_TOASTR = exports.REMOVE_TOASTR = '@ReduxToastr/toastr/REMOVE';
var CLEAN_TOASTR = exports.CLEAN_TOASTR = '@ReduxToastr/toastr/CLEAN';
var SHOW_CONFIRM = exports.SHOW_CONFIRM = '@ReduxToastr/confirm/SHOW';
var HIDE_CONFIRM = exports.HIDE_CONFIRM = '@ReduxToastr/confirm/HIDE';
var REMOVE_BY_TYPE = exports.REMOVE_BY_TYPE = '@ReduxToastr/toastr/REMOVE_BY_TYPE';
// before add a new transition - check its presence in src/styles/animations.scss
var TRANSITIONS = exports.TRANSITIONS = {
  in: ['bounceIn', 'bounceInDown', 'fadeIn'],
  out: ['bounceOut', 'bounceOutUp', 'fadeOut']
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(127);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(128);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(88);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(27);
var normalizeHeaderName = __webpack_require__(344);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(140);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(140);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(399);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(67);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/6.0/#sec-isarray
module.exports = __webpack_require__(157);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var hasOwn = __webpack_require__(37);

var isPropertyDescriptor = __webpack_require__(39);

// https://262.ecma-international.org/5.1/#sec-8.10.2

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!hasOwn(Desc, '[[Value]]') && !hasOwn(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(69);

// http://262.ecma-international.org/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var hasOwn = __webpack_require__(37);

var isPropertyDescriptor = __webpack_require__(39);

// https://262.ecma-international.org/5.1/#sec-8.10.1

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!hasOwn(Desc, '[[Get]]') && !hasOwn(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(460);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(485);
var iterableToArray = __webpack_require__(486);
var unsupportedIterableToArray = __webpack_require__(187);
var nonIterableSpread = __webpack_require__(487);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isSameMonth;

var _moment = _interopRequireDefault(__webpack_require__(5));

function isSameMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false; // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow

  return a.month() === b.month() && a.year() === b.year();
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
module.exports = __webpack_require__(499);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInputHeight;

/* eslint-disable camelcase */
function getPadding(vertical, top, bottom) {
  var isTopDefined = typeof top === 'number';
  var isBottomDefined = typeof bottom === 'number';
  var isVerticalDefined = typeof vertical === 'number';

  if (isTopDefined && isBottomDefined) {
    return top + bottom;
  }

  if (isTopDefined && isVerticalDefined) {
    return top + vertical;
  }

  if (isTopDefined) {
    return top;
  }

  if (isBottomDefined && isVerticalDefined) {
    return bottom + vertical;
  }

  if (isBottomDefined) {
    return bottom;
  }

  if (isVerticalDefined) {
    return 2 * vertical;
  }

  return 0;
}

function getInputHeight(_ref, small) {
  var _ref$font$input = _ref.font.input,
      lineHeight = _ref$font$input.lineHeight,
      lineHeight_small = _ref$font$input.lineHeight_small,
      _ref$spacing = _ref.spacing,
      inputPadding = _ref$spacing.inputPadding,
      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
  var calcLineHeight = small ? lineHeight_small : lineHeight;
  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toLocalizedDateString;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

var _constants = __webpack_require__(7);

function toLocalizedDateString(date, currentFormat) {
  var dateObj = _moment["default"].isMoment(date) ? date : (0, _toMomentObject["default"])(date, currentFormat);
  if (!dateObj) return null;
  return dateObj.format(_constants.DISPLAY_FORMAT);
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isDayVisible;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isBeforeDay = _interopRequireDefault(__webpack_require__(60));

var _isAfterDay = _interopRequireDefault(__webpack_require__(76));

var _toISOMonthString = _interopRequireDefault(__webpack_require__(75));

var startCacheOutsideDays = new Map();
var endCacheOutsideDays = new Map();
var startCacheInsideDays = new Map();
var endCacheInsideDays = new Map();

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  if (!_moment["default"].isMoment(day)) return false; // Cloning is a little expensive, so we want to do it as little as possible.

  var startKey = (0, _toISOMonthString["default"])(month); // eslint-disable-next-line prefer-template

  var endKey = startKey + '+' + numberOfMonths;

  if (enableOutsideDays) {
    if (!startCacheOutsideDays.has(startKey)) {
      startCacheOutsideDays.set(startKey, month.clone().startOf('month').startOf('week'));
    }

    if ((0, _isBeforeDay["default"])(day, startCacheOutsideDays.get(startKey))) return false;

    if (!endCacheOutsideDays.has(endKey)) {
      endCacheOutsideDays.set(endKey, month.clone().endOf('week').add(numberOfMonths - 1, 'months').endOf('month').endOf('week'));
    }

    return !(0, _isAfterDay["default"])(day, endCacheOutsideDays.get(endKey));
  } // !enableOutsideDays


  if (!startCacheInsideDays.has(startKey)) {
    startCacheInsideDays.set(startKey, month.clone().startOf('month'));
  }

  if ((0, _isBeforeDay["default"])(day, startCacheInsideDays.get(startKey))) return false;

  if (!endCacheInsideDays.has(endKey)) {
    endCacheInsideDays.set(endKey, month.clone().add(numberOfMonths - 1, 'months').endOf('month'));
  }

  return !(0, _isAfterDay["default"])(day, endCacheInsideDays.get(endKey));
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(176);

var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDayPicker = exports.defaultProps = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(102));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _throttle = _interopRequireDefault(__webpack_require__(206));

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(104));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _CalendarMonthGrid = _interopRequireDefault(__webpack_require__(190));

var _DayPickerNavigation = _interopRequireDefault(__webpack_require__(519));

var _DayPickerKeyboardShortcuts = _interopRequireWildcard(__webpack_require__(522));

var _getNumberOfCalendarMonthWeeks = _interopRequireDefault(__webpack_require__(524));

var _getCalendarMonthWidth = _interopRequireDefault(__webpack_require__(191));

var _calculateDimension = _interopRequireDefault(__webpack_require__(189));

var _getActiveElement = _interopRequireDefault(__webpack_require__(525));

var _isDayVisible = _interopRequireDefault(__webpack_require__(108));

var _isSameMonth = _interopRequireDefault(__webpack_require__(103));

var _ModifiersShape = _interopRequireDefault(__webpack_require__(73));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(59));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MONTH_PADDING = 23;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';
var MONTH_SELECTION_TRANSITION = 'month_selection';
var YEAR_SELECTION_TRANSITION = 'year_selection';
var PREV_NAV = 'prev_nav';
var NEXT_NAV = 'next_nav';
var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  // calendar presentation props
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  onOutsideClick: _propTypes["default"].func,
  hidden: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func,
  // navigation props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  disablePrev: _propTypes["default"].bool,
  disableNext: _propTypes["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  onGetNextScrollableMonths: _propTypes["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  onGetPrevScrollableMonths: _propTypes["default"].func,
  // VERTICAL_SCROLLABLE daypickers only
  // month props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  // day props
  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  // accessibility props
  isFocused: _propTypes["default"].bool,
  getFirstFocusableDay: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // internationalization
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function onOutsideClick() {},
  hidden: false,
  initialVisibleMonth: function initialVisibleMonth() {
    return (0, _moment["default"])();
  },
  firstDayOfWeek: null,
  renderCalendarInfo: null,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  // navigation props
  dayPickerNavigationInlineStyles: null,
  disablePrev: false,
  disableNext: false,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onGetNextScrollableMonths: function onGetNextScrollableMonths() {},
  onGetPrevScrollableMonths: function onGetPrevScrollableMonths() {},
  // month props
  renderMonthText: null,
  renderMonthElement: null,
  renderWeekHeaderElement: null,
  // day props
  modifiers: {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  // accessibility props
  isFocused: false,
  getFirstFocusableDay: null,
  onBlur: function onBlur() {},
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // internationalization
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined
};
exports.defaultProps = defaultProps;

var DayPicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPicker, _ref);
  var _proto = DayPicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var currentMonth = props.hidden ? (0, _moment["default"])() : props.initialVisibleMonth();
    var focusedDate = currentMonth.clone().startOf('month');

    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var horizontalMonthPadding = props.horizontalMonthPadding;
    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding) : 0;
    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonthScrollTop: null,
      currentMonth: currentMonth,
      monthTransition: null,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(props.daySize, horizontalMonthPadding),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
      nextFocusedDate: null,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function onKeyboardShortcutsPanelClose() {},
      isTouchDevice: (0, _isTouchDevice["default"])(),
      withMouseInteractions: true,
      calendarInfoWidth: 0,
      monthTitleHeight: null,
      hasSetHeight: false
    };

    _this.setCalendarMonthWeeks(currentMonth);

    _this.calendarMonthGridHeight = 0;
    _this.setCalendarInfoWidthTimeout = null;
    _this.setCalendarMonthGridHeightTimeout = null;
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 200, {
      trailing: false
    });
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthTransition = _this.onPrevMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthTransition = _this.onNextMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNextScrollableMonths = _this.getNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPrevScrollableMonths = _this.getPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    var orientation = this.props.orientation;
    var currentMonth = this.state.currentMonth;
    var calendarInfoWidth = this.calendarInfo ? (0, _calculateDimension["default"])(this.calendarInfo, 'width', true, true) : 0;
    var currentMonthScrollTop = this.transitionContainer && orientation === _constants.VERTICAL_SCROLLABLE ? this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop : null;
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])(),
      calendarInfoWidth: calendarInfoWidth,
      currentMonthScrollTop: currentMonthScrollTop
    });
    this.setCalendarMonthWeeks(currentMonth);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
    var hidden = nextProps.hidden,
        isFocused = nextProps.isFocused,
        showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
        onBlur = nextProps.onBlur,
        orientation = nextProps.orientation,
        renderMonthText = nextProps.renderMonthText,
        horizontalMonthPadding = nextProps.horizontalMonthPadding;
    var currentMonth = this.state.currentMonth;
    var nextCurrentMonth = nextState.currentMonth;

    if (!hidden) {
      if (!this.hasSetInitialVisibleMonth) {
        this.hasSetInitialVisibleMonth = true;
        this.setState({
          currentMonth: nextProps.initialVisibleMonth()
        });
      }
    }

    var _this$props = this.props,
        daySize = _this$props.daySize,
        prevIsFocused = _this$props.isFocused,
        prevRenderMonthText = _this$props.renderMonthText;

    if (nextProps.daySize !== daySize) {
      this.setState({
        calendarMonthWidth: (0, _getCalendarMonthWidth["default"])(nextProps.daySize, horizontalMonthPadding)
      });
    }

    if (isFocused !== prevIsFocused) {
      if (isFocused) {
        var focusedDate = this.getFocusedDay(currentMonth);
        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

        if (nextProps.showKeyboardShortcuts) {
          // the ? shortcut came from the input and we should return input there once it is close
          onKeyboardShortcutsPanelClose = onBlur;
        }

        this.setState({
          showKeyboardShortcuts: showKeyboardShortcuts,
          onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
          focusedDate: focusedDate,
          withMouseInteractions: false
        });
      } else {
        this.setState({
          focusedDate: null
        });
      }
    }

    if (renderMonthText !== prevRenderMonthText) {
      this.setState({
        monthTitleHeight: null
      });
    } // Capture the scroll position so when previous months are rendered above the current month
    // we can adjust scroll after the component has updated and the previous current month
    // stays in view.


    if (orientation === _constants.VERTICAL_SCROLLABLE && this.transitionContainer && !(0, _isSameMonth["default"])(currentMonth, nextCurrentMonth)) {
      this.setState({
        currentMonthScrollTop: this.transitionContainer.scrollHeight - this.transitionContainer.scrollTop
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    var _this2 = this;

    var transitionDuration = this.props.transitionDuration; // Calculating the dimensions trigger a DOM repaint which
    // breaks the CSS transition.
    // The setTimeout will wait until the transition ends.

    if (this.calendarInfo) {
      this.setCalendarInfoWidthTimeout = setTimeout(function () {
        var calendarInfoWidth = _this2.state.calendarInfoWidth;
        var calendarInfoPanelWidth = (0, _calculateDimension["default"])(_this2.calendarInfo, 'width', true, true);

        if (calendarInfoWidth !== calendarInfoPanelWidth) {
          _this2.setState({
            calendarInfoWidth: calendarInfoPanelWidth
          });
        }
      }, transitionDuration);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props2 = this.props,
        orientation = _this$props2.orientation,
        daySize = _this$props2.daySize,
        isFocused = _this$props2.isFocused,
        numberOfMonths = _this$props2.numberOfMonths;
    var _this$state = this.state,
        currentMonth = _this$state.currentMonth,
        currentMonthScrollTop = _this$state.currentMonthScrollTop,
        focusedDate = _this$state.focusedDate,
        monthTitleHeight = _this$state.monthTitleHeight;

    if (this.isHorizontal() && (orientation !== prevProps.orientation || daySize !== prevProps.daySize)) {
      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
      var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
      var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    if (!prevProps.isFocused && isFocused && !focusedDate) {
      this.container.focus();
    } // If orientation is VERTICAL_SCROLLABLE and currentMonth has changed adjust scrollTop so the
    // new months rendered above the current month don't push the current month out of view.


    if (orientation === _constants.VERTICAL_SCROLLABLE && !(0, _isSameMonth["default"])(prevState.currentMonth, currentMonth) && currentMonthScrollTop && this.transitionContainer) {
      this.transitionContainer.scrollTop = this.transitionContainer.scrollHeight - currentMonthScrollTop;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.setCalendarInfoWidthTimeout);
    clearTimeout(this.setCalendarMonthGridHeightTimeout);
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    this.setState({
      withMouseInteractions: false
    });
    var _this$props3 = this.props,
        onBlur = _this$props3.onBlur,
        onTab = _this$props3.onTab,
        onShiftTab = _this$props3.onShiftTab,
        isRTL = _this$props3.isRTL;
    var _this$state2 = this.state,
        focusedDate = _this$state2.focusedDate,
        showKeyboardShortcuts = _this$state2.showKeyboardShortcuts;
    if (!focusedDate) return;
    var newFocusedDate = focusedDate.clone();
    var didTransitionMonth = false; // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
    // return it to wherever it was before when the panel was opened

    var activeElement = (0, _getActiveElement["default"])();

    var onKeyboardShortcutsPanelClose = function onKeyboardShortcutsPanelClose() {
      if (activeElement) activeElement.focus();
    };

    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowLeft':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.add(1, 'day');
        } else {
          newFocusedDate.subtract(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'Home':
        e.preventDefault();
        newFocusedDate.startOf('week');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'PageUp':
        e.preventDefault();
        newFocusedDate.subtract(1, 'month');
        didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
        break;

      case 'ArrowDown':
        e.preventDefault();
        newFocusedDate.add(1, 'week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'ArrowRight':
        e.preventDefault();

        if (isRTL) {
          newFocusedDate.subtract(1, 'day');
        } else {
          newFocusedDate.add(1, 'day');
        }

        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'End':
        e.preventDefault();
        newFocusedDate.endOf('week');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case 'PageDown':
        e.preventDefault();
        newFocusedDate.add(1, 'month');
        didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
        break;

      case '?':
        this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
        break;

      case 'Escape':
        if (showKeyboardShortcuts) {
          this.closeKeyboardShortcutsPanel();
        } else {
          onBlur(e);
        }

        break;

      case 'Tab':
        if (e.shiftKey) {
          onShiftTab();
        } else {
          onTab(e);
        }

        break;

      default:
        break;
    } // If there was a month transition, do not update the focused date until the transition has
    // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
    // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition


    if (!didTransitionMonth) {
      this.setState({
        focusedDate: newFocusedDate
      });
    }
  };

  _proto.onPrevMonthClick = function onPrevMonthClick(e) {
    if (e) e.preventDefault();
    this.onPrevMonthTransition();
  };

  _proto.onPrevMonthTransition = function onPrevMonthTransition(nextFocusedDate) {
    var _this$props4 = this.props,
        daySize = _this$props4.daySize,
        isRTL = _this$props4.isRTL,
        numberOfMonths = _this$props4.numberOfMonths;
    var _this$state3 = this.state,
        calendarMonthWidth = _this$state3.calendarMonthWidth,
        monthTitleHeight = _this$state3.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var calendarMonthWeeksHeight = this.calendarMonthWeeks[0] * (daySize - 1);
      translationValue = monthTitleHeight + calendarMonthWeeksHeight + 1;
    } else if (this.isHorizontal()) {
      translationValue = calendarMonthWidth;

      if (isRTL) {
        translationValue = -2 * calendarMonthWidth;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(0, numberOfMonths);

      var _calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: PREV_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.onMonthChange = function onMonthChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: MONTH_SELECTION_TRANSITION,
      translationValue: 0.00001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onYearChange = function onYearChange(currentMonth) {
    this.setCalendarMonthWeeks(currentMonth);
    this.calculateAndSetDayPickerHeight(); // Translation value is a hack to force an invisible transition that
    // properly rerenders the CalendarMonthGrid

    this.setState({
      monthTransition: YEAR_SELECTION_TRANSITION,
      translationValue: 0.0001,
      focusedDate: null,
      nextFocusedDate: currentMonth,
      currentMonth: currentMonth
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick(e) {
    if (e) e.preventDefault();
    this.onNextMonthTransition();
  };

  _proto.onNextMonthTransition = function onNextMonthTransition(nextFocusedDate) {
    var _this$props5 = this.props,
        isRTL = _this$props5.isRTL,
        numberOfMonths = _this$props5.numberOfMonths,
        daySize = _this$props5.daySize;
    var _this$state4 = this.state,
        calendarMonthWidth = _this$state4.calendarMonthWidth,
        monthTitleHeight = _this$state4.monthTitleHeight;
    var translationValue;

    if (this.isVertical()) {
      var firstVisibleMonthWeeks = this.calendarMonthWeeks[1];
      var calendarMonthWeeksHeight = firstVisibleMonthWeeks * (daySize - 1);
      translationValue = -(monthTitleHeight + calendarMonthWeeksHeight + 1);
    }

    if (this.isHorizontal()) {
      translationValue = -calendarMonthWidth;

      if (isRTL) {
        translationValue = 0;
      }

      var visibleCalendarWeeks = this.calendarMonthWeeks.slice(2, numberOfMonths + 2);

      var _calendarMonthWeeksHeight2 = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);

      var newMonthHeight = monthTitleHeight + _calendarMonthWeeksHeight2 + 1;
      this.adjustDayPickerHeight(newMonthHeight);
    }

    this.setState({
      monthTransition: NEXT_TRANSITION,
      translationValue: translationValue,
      focusedDate: null,
      nextFocusedDate: nextFocusedDate
    });
  };

  _proto.getFirstDayOfWeek = function getFirstDayOfWeek() {
    var firstDayOfWeek = this.props.firstDayOfWeek;

    if (firstDayOfWeek == null) {
      return _moment["default"].localeData().firstDayOfWeek();
    }

    return firstDayOfWeek;
  };

  _proto.getWeekHeaders = function getWeekHeaders() {
    var weekDayFormat = this.props.weekDayFormat;
    var currentMonth = this.state.currentMonth;
    var firstDayOfWeek = this.getFirstDayOfWeek();
    var weekHeaders = [];

    for (var i = 0; i < 7; i += 1) {
      weekHeaders.push(currentMonth.clone().day((i + firstDayOfWeek) % 7).format(weekDayFormat));
    }

    return weekHeaders;
  };

  _proto.getFirstVisibleIndex = function getFirstVisibleIndex() {
    var orientation = this.props.orientation;
    var monthTransition = this.state.monthTransition;
    if (orientation === _constants.VERTICAL_SCROLLABLE) return 0;
    var firstVisibleMonthIndex = 1;

    if (monthTransition === PREV_TRANSITION) {
      firstVisibleMonthIndex -= 1;
    } else if (monthTransition === NEXT_TRANSITION) {
      firstVisibleMonthIndex += 1;
    }

    return firstVisibleMonthIndex;
  };

  _proto.getFocusedDay = function getFocusedDay(newMonth) {
    var _this$props6 = this.props,
        getFirstFocusableDay = _this$props6.getFirstFocusableDay,
        numberOfMonths = _this$props6.numberOfMonths;
    var focusedDate;

    if (getFirstFocusableDay) {
      focusedDate = getFirstFocusableDay(newMonth);
    }

    if (newMonth && (!focusedDate || !(0, _isDayVisible["default"])(focusedDate, newMonth, numberOfMonths))) {
      focusedDate = newMonth.clone().startOf('month');
    }

    return focusedDate;
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight(monthTitleHeight) {
    var _this3 = this;

    this.setState({
      monthTitleHeight: monthTitleHeight
    }, function () {
      _this3.calculateAndSetDayPickerHeight();
    });
  };

  _proto.setCalendarMonthWeeks = function setCalendarMonthWeeks(currentMonth) {
    var numberOfMonths = this.props.numberOfMonths;
    this.calendarMonthWeeks = [];
    var month = currentMonth.clone().subtract(1, 'months');
    var firstDayOfWeek = this.getFirstDayOfWeek();

    for (var i = 0; i < numberOfMonths + 2; i += 1) {
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(month, firstDayOfWeek);
      this.calendarMonthWeeks.push(numberOfWeeks);
      month = month.add(1, 'months');
    }
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.setCalendarInfoRef = function setCalendarInfoRef(ref) {
    this.calendarInfo = ref;
  };

  _proto.setTransitionContainerRef = function setTransitionContainerRef(ref) {
    this.transitionContainer = ref;
  };

  _proto.getNextScrollableMonths = function getNextScrollableMonths(e) {
    var onGetNextScrollableMonths = this.props.onGetNextScrollableMonths;
    if (e) e.preventDefault();
    if (onGetNextScrollableMonths) onGetNextScrollableMonths(e);
    this.setState(function (_ref2) {
      var scrollableMonthMultiple = _ref2.scrollableMonthMultiple;
      return {
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.getPrevScrollableMonths = function getPrevScrollableMonths(e) {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        onGetPrevScrollableMonths = _this$props7.onGetPrevScrollableMonths;
    if (e) e.preventDefault();
    if (onGetPrevScrollableMonths) onGetPrevScrollableMonths(e);
    this.setState(function (_ref3) {
      var currentMonth = _ref3.currentMonth,
          scrollableMonthMultiple = _ref3.scrollableMonthMultiple;
      return {
        currentMonth: currentMonth.clone().subtract(numberOfMonths, 'month'),
        scrollableMonthMultiple: scrollableMonthMultiple + 1
      };
    });
  };

  _proto.maybeTransitionNextMonth = function maybeTransitionNextMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        focusedDate = _this$state5.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onNextMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.maybeTransitionPrevMonth = function maybeTransitionPrevMonth(newFocusedDate) {
    var numberOfMonths = this.props.numberOfMonths;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        focusedDate = _this$state6.focusedDate;
    var newFocusedDateMonth = newFocusedDate.month();
    var focusedDateMonth = focusedDate.month();
    var isNewFocusedDateVisible = (0, _isDayVisible["default"])(newFocusedDate, currentMonth, numberOfMonths);

    if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
      this.onPrevMonthTransition(newFocusedDate);
      return true;
    }

    return false;
  };

  _proto.isHorizontal = function isHorizontal() {
    var orientation = this.props.orientation;
    return orientation === _constants.HORIZONTAL_ORIENTATION;
  };

  _proto.isVertical = function isVertical() {
    var orientation = this.props.orientation;
    return orientation === _constants.VERTICAL_ORIENTATION || orientation === _constants.VERTICAL_SCROLLABLE;
  };

  _proto.updateStateAfterMonthTransition = function updateStateAfterMonthTransition() {
    var _this4 = this;

    var _this$props8 = this.props,
        onPrevMonthClick = _this$props8.onPrevMonthClick,
        onNextMonthClick = _this$props8.onNextMonthClick,
        numberOfMonths = _this$props8.numberOfMonths,
        onMonthChange = _this$props8.onMonthChange,
        onYearChange = _this$props8.onYearChange,
        isRTL = _this$props8.isRTL;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        monthTransition = _this$state7.monthTransition,
        focusedDate = _this$state7.focusedDate,
        nextFocusedDate = _this$state7.nextFocusedDate,
        withMouseInteractions = _this$state7.withMouseInteractions,
        calendarMonthWidth = _this$state7.calendarMonthWidth;
    if (!monthTransition) return;
    var newMonth = currentMonth.clone();
    var firstDayOfWeek = this.getFirstDayOfWeek();

    if (monthTransition === PREV_TRANSITION) {
      newMonth.subtract(1, 'month');
      if (onPrevMonthClick) onPrevMonthClick(newMonth);
      var newInvisibleMonth = newMonth.clone().subtract(1, 'month');
      var numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(newInvisibleMonth, firstDayOfWeek);
      this.calendarMonthWeeks = [numberOfWeeks].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(0, -1)));
    } else if (monthTransition === NEXT_TRANSITION) {
      newMonth.add(1, 'month');
      if (onNextMonthClick) onNextMonthClick(newMonth);

      var _newInvisibleMonth = newMonth.clone().add(numberOfMonths, 'month');

      var _numberOfWeeks = (0, _getNumberOfCalendarMonthWeeks["default"])(_newInvisibleMonth, firstDayOfWeek);

      this.calendarMonthWeeks = [].concat((0, _toConsumableArray2["default"])(this.calendarMonthWeeks.slice(1)), [_numberOfWeeks]);
    } else if (monthTransition === MONTH_SELECTION_TRANSITION) {
      if (onMonthChange) onMonthChange(newMonth);
    } else if (monthTransition === YEAR_SELECTION_TRANSITION) {
      if (onYearChange) onYearChange(newMonth);
    }

    var newFocusedDate = null;

    if (nextFocusedDate) {
      newFocusedDate = nextFocusedDate;
    } else if (!focusedDate && !withMouseInteractions) {
      newFocusedDate = this.getFocusedDay(newMonth);
    }

    this.setState({
      currentMonth: newMonth,
      monthTransition: null,
      translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
      nextFocusedDate: null,
      focusedDate: newFocusedDate
    }, function () {
      // we don't want to focus on the relevant calendar day after a month transition
      // if the user is navigating around using a mouse
      if (withMouseInteractions) {
        var activeElement = (0, _getActiveElement["default"])();

        if (activeElement && activeElement !== document.body && _this4.container.contains(activeElement) && activeElement.blur) {
          activeElement.blur();
        }
      }
    });
  };

  _proto.adjustDayPickerHeight = function adjustDayPickerHeight(newMonthHeight) {
    var _this5 = this;

    var monthHeight = newMonthHeight + MONTH_PADDING;

    if (monthHeight !== this.calendarMonthGridHeight) {
      this.transitionContainer.style.height = "".concat(monthHeight, "px");

      if (!this.calendarMonthGridHeight) {
        this.setCalendarMonthGridHeightTimeout = setTimeout(function () {
          _this5.setState({
            hasSetHeight: true
          });
        }, 0);
      }

      this.calendarMonthGridHeight = monthHeight;
    }
  };

  _proto.calculateAndSetDayPickerHeight = function calculateAndSetDayPickerHeight() {
    var _this$props9 = this.props,
        daySize = _this$props9.daySize,
        numberOfMonths = _this$props9.numberOfMonths;
    var monthTitleHeight = this.state.monthTitleHeight;
    var visibleCalendarWeeks = this.calendarMonthWeeks.slice(1, numberOfMonths + 1);
    var calendarMonthWeeksHeight = Math.max.apply(Math, [0].concat((0, _toConsumableArray2["default"])(visibleCalendarWeeks))) * (daySize - 1);
    var newMonthHeight = monthTitleHeight + calendarMonthWeeksHeight + 1;

    if (this.isHorizontal()) {
      this.adjustDayPickerHeight(newMonthHeight);
    }
  };

  _proto.openKeyboardShortcutsPanel = function openKeyboardShortcutsPanel(onCloseCallBack) {
    this.setState({
      showKeyboardShortcuts: true,
      onKeyboardShortcutsPanelClose: onCloseCallBack
    });
  };

  _proto.closeKeyboardShortcutsPanel = function closeKeyboardShortcutsPanel() {
    var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

    if (onKeyboardShortcutsPanelClose) {
      onKeyboardShortcutsPanelClose();
    }

    this.setState({
      onKeyboardShortcutsPanelClose: null,
      showKeyboardShortcuts: false
    });
  };

  _proto.renderNavigation = function renderNavigation(navDirection) {
    var _this$props10 = this.props,
        dayPickerNavigationInlineStyles = _this$props10.dayPickerNavigationInlineStyles,
        disablePrev = _this$props10.disablePrev,
        disableNext = _this$props10.disableNext,
        navPosition = _this$props10.navPosition,
        navPrev = _this$props10.navPrev,
        navNext = _this$props10.navNext,
        noNavButtons = _this$props10.noNavButtons,
        noNavNextButton = _this$props10.noNavNextButton,
        noNavPrevButton = _this$props10.noNavPrevButton,
        orientation = _this$props10.orientation,
        phrases = _this$props10.phrases,
        renderNavPrevButton = _this$props10.renderNavPrevButton,
        renderNavNextButton = _this$props10.renderNavNextButton,
        isRTL = _this$props10.isRTL;

    if (noNavButtons) {
      return null;
    }

    var onPrevMonthClick = orientation === _constants.VERTICAL_SCROLLABLE ? this.getPrevScrollableMonths : this.onPrevMonthClick;
    var onNextMonthClick = orientation === _constants.VERTICAL_SCROLLABLE ? this.getNextScrollableMonths : this.onNextMonthClick;
    return _react["default"].createElement(_DayPickerNavigation["default"], {
      disablePrev: disablePrev,
      disableNext: disableNext,
      inlineStyles: dayPickerNavigationInlineStyles,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      orientation: orientation,
      phrases: phrases,
      isRTL: isRTL,
      showNavNextButton: !(noNavNextButton || orientation === _constants.VERTICAL_SCROLLABLE && navDirection === PREV_NAV),
      showNavPrevButton: !(noNavPrevButton || orientation === _constants.VERTICAL_SCROLLABLE && navDirection === NEXT_NAV)
    });
  };

  _proto.renderWeekHeader = function renderWeekHeader(index) {
    var _this$props11 = this.props,
        daySize = _this$props11.daySize,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding,
        orientation = _this$props11.orientation,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        styles = _this$props11.styles;
    var calendarMonthWidth = this.state.calendarMonthWidth;
    var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
    var horizontalStyle = {
      left: index * calendarMonthWidth
    };
    var verticalStyle = {
      marginLeft: -calendarMonthWidth / 2
    };
    var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation

    if (this.isHorizontal()) {
      weekHeaderStyle = horizontalStyle;
    } else if (this.isVertical() && !verticalScrollable) {
      weekHeaderStyle = verticalStyle;
    }

    var weekHeaders = this.getWeekHeaders();
    var header = weekHeaders.map(function (day) {
      return _react["default"].createElement("li", (0, _extends2["default"])({
        key: day
      }, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_li, {
        width: daySize
      })), renderWeekHeaderElement ? renderWeekHeaderElement(day) : _react["default"].createElement("small", null, day));
    });
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      key: "week-".concat(index)
    }), _react["default"].createElement("ul", (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_ul), header));
  };

  _proto.render = function render() {
    var _this6 = this;

    var _this$state8 = this.state,
        calendarMonthWidth = _this$state8.calendarMonthWidth,
        currentMonth = _this$state8.currentMonth,
        monthTransition = _this$state8.monthTransition,
        translationValue = _this$state8.translationValue,
        scrollableMonthMultiple = _this$state8.scrollableMonthMultiple,
        focusedDate = _this$state8.focusedDate,
        showKeyboardShortcuts = _this$state8.showKeyboardShortcuts,
        isTouch = _this$state8.isTouchDevice,
        hasSetHeight = _this$state8.hasSetHeight,
        calendarInfoWidth = _this$state8.calendarInfoWidth,
        monthTitleHeight = _this$state8.monthTitleHeight;
    var _this$props12 = this.props,
        enableOutsideDays = _this$props12.enableOutsideDays,
        numberOfMonths = _this$props12.numberOfMonths,
        orientation = _this$props12.orientation,
        modifiers = _this$props12.modifiers,
        withPortal = _this$props12.withPortal,
        onDayClick = _this$props12.onDayClick,
        onDayMouseEnter = _this$props12.onDayMouseEnter,
        onDayMouseLeave = _this$props12.onDayMouseLeave,
        firstDayOfWeek = _this$props12.firstDayOfWeek,
        renderMonthText = _this$props12.renderMonthText,
        renderCalendarDay = _this$props12.renderCalendarDay,
        renderDayContents = _this$props12.renderDayContents,
        renderCalendarInfo = _this$props12.renderCalendarInfo,
        renderMonthElement = _this$props12.renderMonthElement,
        renderKeyboardShortcutsButton = _this$props12.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props12.renderKeyboardShortcutsPanel,
        calendarInfoPosition = _this$props12.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props12.hideKeyboardShortcutsPanel,
        onOutsideClick = _this$props12.onOutsideClick,
        monthFormat = _this$props12.monthFormat,
        daySize = _this$props12.daySize,
        isFocused = _this$props12.isFocused,
        isRTL = _this$props12.isRTL,
        styles = _this$props12.styles,
        theme = _this$props12.theme,
        phrases = _this$props12.phrases,
        verticalHeight = _this$props12.verticalHeight,
        dayAriaLabelFormat = _this$props12.dayAriaLabelFormat,
        noBorder = _this$props12.noBorder,
        transitionDuration = _this$props12.transitionDuration,
        verticalBorderSpacing = _this$props12.verticalBorderSpacing,
        horizontalMonthPadding = _this$props12.horizontalMonthPadding,
        navPosition = _this$props12.navPosition;
    var dayPickerHorizontalPadding = theme.reactDates.spacing.dayPickerHorizontalPadding;
    var isHorizontal = this.isHorizontal();
    var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
    var weekHeaders = [];

    for (var i = 0; i < numOfWeekHeaders; i += 1) {
      weekHeaders.push(this.renderWeekHeader(i));
    }

    var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
    var height;

    if (isHorizontal) {
      height = this.calendarMonthGridHeight;
    } else if (this.isVertical() && !verticalScrollable && !withPortal) {
      // If the user doesn't set a desired height,
      // we default back to this kind of made-up value that generally looks good
      height = verticalHeight || 1.75 * calendarMonthWidth;
    }

    var isCalendarMonthGridAnimating = monthTransition !== null;
    var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
    var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;

    if (this.isVertical()) {
      keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
    }

    var shouldAnimateHeight = isHorizontal && hasSetHeight;
    var calendarInfoPositionTop = calendarInfoPosition === _constants.INFO_POSITION_TOP;
    var calendarInfoPositionBottom = calendarInfoPosition === _constants.INFO_POSITION_BOTTOM;
    var calendarInfoPositionBefore = calendarInfoPosition === _constants.INFO_POSITION_BEFORE;
    var calendarInfoPositionAfter = calendarInfoPosition === _constants.INFO_POSITION_AFTER;
    var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;

    var calendarInfo = renderCalendarInfo && _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCalendarInfoRef
    }, (0, _reactWithStyles.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)), renderCalendarInfo());

    var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
    var firstVisibleMonthIndex = this.getFirstVisibleIndex();
    var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * dayPickerHorizontalPadding; // Adding `1px` because of whitespace between 2 inline-block

    var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
    var transitionContainerStyle = {
      width: isHorizontal && wrapperHorizontalWidth,
      height: height
    };
    var dayPickerWrapperStyle = {
      width: isHorizontal && wrapperHorizontalWidth
    };
    var dayPickerStyle = {
      width: isHorizontal && fullHorizontalWidth,
      // These values are to center the datepicker (approximately) on the page
      marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
      marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
    };
    return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !monthTitleHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder), _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: onOutsideClick
    }, (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo, _react["default"].createElement("div", (0, _reactWithStyles.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
      "aria-hidden": "true",
      role: "presentation"
    }), weekHeaders), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPicker_focusRegion), {
      ref: this.setContainerRef,
      onClick: function onClick(e) {
        e.stopPropagation();
      },
      onKeyDown: this.onKeyDown,
      onMouseUp: function onMouseUp() {
        _this6.setState({
          withMouseInteractions: true
        });
      },
      tabIndex: -1,
      role: "application",
      "aria-roledescription": phrases.roleDescription,
      "aria-label": phrases.calendarLabel
    }), !verticalScrollable && navPosition === _constants.NAV_POSITION_TOP && this.renderNavigation(), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPicker_transitionContainer, shouldAnimateHeight && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
      ref: this.setTransitionContainerRef
    }), verticalScrollable && this.renderNavigation(PREV_NAV), _react["default"].createElement(_CalendarMonthGrid["default"], {
      setMonthTitleHeight: !monthTitleHeight ? this.setMonthTitleHeight : undefined,
      translationValue: translationValue,
      enableOutsideDays: enableOutsideDays,
      firstVisibleMonthIndex: firstVisibleMonthIndex,
      initialMonth: currentMonth,
      isAnimating: isCalendarMonthGridAnimating,
      modifiers: modifiers,
      orientation: orientation,
      numberOfMonths: numberOfMonths * scrollableMonthMultiple,
      onDayClick: onDayClick,
      onDayMouseEnter: onDayMouseEnter,
      onDayMouseLeave: onDayMouseLeave,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      renderMonthText: renderMonthText,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderMonthElement: renderMonthElement,
      onMonthTransitionEnd: this.updateStateAfterMonthTransition,
      monthFormat: monthFormat,
      daySize: daySize,
      firstDayOfWeek: firstDayOfWeek,
      isFocused: shouldFocusDate,
      focusedDate: focusedDate,
      phrases: phrases,
      isRTL: isRTL,
      dayAriaLabelFormat: dayAriaLabelFormat,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    }), verticalScrollable && this.renderNavigation(NEXT_NAV)), !verticalScrollable && navPosition === _constants.NAV_POSITION_BOTTOM && this.renderNavigation(), !isTouch && !hideKeyboardShortcutsPanel && _react["default"].createElement(_DayPickerKeyboardShortcuts["default"], {
      block: this.isVertical() && !withPortal,
      buttonLocation: keyboardShortcutButtonLocation,
      showKeyboardShortcutsPanel: showKeyboardShortcuts,
      openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
      closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
      phrases: phrases,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel
    }))), (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo));
  };

  return DayPicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDayPicker = DayPicker;
DayPicker.propTypes =  false ? propTypes : {};
DayPicker.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref4) {
  var _ref4$reactDates = _ref4.reactDates,
      color = _ref4$reactDates.color,
      font = _ref4$reactDates.font,
      noScrollBarOnVerticalScrollable = _ref4$reactDates.noScrollBarOnVerticalScrollable,
      spacing = _ref4$reactDates.spacing,
      zIndex = _ref4$reactDates.zIndex;
  return {
    DayPicker: {
      background: color.background,
      position: 'relative',
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker__horizontal: {
      background: color.background
    },
    DayPicker__verticalScrollable: {
      height: '100%'
    },
    DayPicker__hidden: {
      visibility: 'hidden'
    },
    DayPicker__withBorder: {
      boxShadow: (0, _noflip["default"])('0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)'),
      borderRadius: 3
    },
    DayPicker_portal__horizontal: {
      boxShadow: 'none',
      position: 'absolute',
      left: (0, _noflip["default"])('50%'),
      top: '50%'
    },
    DayPicker_portal__vertical: {
      position: 'initial'
    },
    DayPicker_focusRegion: {
      outline: 'none'
    },
    DayPicker_calendarInfo__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_wrapper__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    DayPicker_weekHeaders: {
      position: 'relative'
    },
    DayPicker_weekHeaders__horizontal: {
      marginLeft: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    DayPicker_weekHeader: {
      color: color.placeholderText,
      position: 'absolute',
      top: 62,
      zIndex: zIndex + 2,
      textAlign: (0, _noflip["default"])('left')
    },
    DayPicker_weekHeader__vertical: {
      left: (0, _noflip["default"])('50%')
    },
    DayPicker_weekHeader__verticalScrollable: {
      top: 0,
      display: 'table-row',
      borderBottom: "1px solid ".concat(color.core.border),
      background: color.background,
      marginLeft: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      width: '100%',
      textAlign: 'center'
    },
    DayPicker_weekHeader_ul: {
      listStyle: 'none',
      margin: '1px 0',
      paddingLeft: (0, _noflip["default"])(0),
      paddingRight: (0, _noflip["default"])(0),
      fontSize: font.size
    },
    DayPicker_weekHeader_li: {
      display: 'inline-block',
      textAlign: 'center'
    },
    DayPicker_transitionContainer: {
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 3
    },
    DayPicker_transitionContainer__horizontal: {
      transition: 'height 0.2s ease-in-out'
    },
    DayPicker_transitionContainer__vertical: {
      width: '100%'
    },
    DayPicker_transitionContainer__verticalScrollable: _objectSpread({
      paddingTop: 20,
      height: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: (0, _noflip["default"])(0),
      left: (0, _noflip["default"])(0),
      overflowY: 'scroll'
    }, noScrollBarOnVerticalScrollable && {
      '-webkitOverflowScrolling': 'touch',
      '::-webkit-scrollbar': {
        '-webkit-appearance': 'none',
        display: 'none'
      }
    })
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPicker);

exports["default"] = _default;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = extend

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cov_nnfbbznhz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_util\\newId.js',hash='a85f39ad6f2952b9d7a4b3f0389f7fc6d76328f4',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_util\\newId.js',statementMap:{'0':{start:{line:1,column:13},end:{line:1,column:14}},'1':{start:{line:4,column:4},end:{line:4,column:13}},'2':{start:{line:5,column:4},end:{line:5,column:32}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:15},end:{line:3,column:16}},loc:{start:{line:3,column:37},end:{line:6,column:1}},line:3}},branchMap:{'0':{loc:{start:{line:3,column:24},end:{line:3,column:35}},type:'default-arg',locations:[{start:{line:3,column:31},end:{line:3,column:35}}],line:3}},s:{'0':0,'1':0,'2':0},f:{'0':0},b:{'0':[0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var lastId=(cov_nnfbbznhz.s[0]++,0);/* harmony default export */ __webpack_exports__["a"] = (function(){var prefix=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_nnfbbznhz.b[0][0]++,'id');cov_nnfbbznhz.f[0]++;cov_nnfbbznhz.s[1]++;lastId++;cov_nnfbbznhz.s[2]++;return''+prefix+lastId;});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = secondsFormatter;
/* harmony export (immutable) */ __webpack_exports__["a"] = dateFormatter;
/* harmony export (immutable) */ __webpack_exports__["c"] = toIsoDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_duration_format__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_duration_format__);
var cov_2qymq6h5wz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_helpers\\DateTime.js',hash='b763a7f7a4628f2f29b3325b0a1225b74c0db93a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_helpers\\DateTime.js',statementMap:{'0':{start:{line:4,column:0},end:{line:4,column:34}},'1':{start:{line:8,column:1},end:{line:44,column:2}},'2':{start:{line:9,column:2},end:{line:20,column:3}},'3':{start:{line:11,column:3},end:{line:16,column:7}},'4':{start:{line:12,column:7},end:{line:12,column:65}},'5':{start:{line:15,column:7},end:{line:15,column:75}},'6':{start:{line:19,column:3},end:{line:19,column:13}},'7':{start:{line:22,column:6},end:{line:44,column:2}},'8':{start:{line:23,column:2},end:{line:34,column:3}},'9':{start:{line:25,column:3},end:{line:30,column:7}},'10':{start:{line:26,column:7},end:{line:26,column:65}},'11':{start:{line:29,column:7},end:{line:29,column:71}},'12':{start:{line:33,column:3},end:{line:33,column:13}},'13':{start:{line:37,column:2},end:{line:42,column:3}},'14':{start:{line:38,column:6},end:{line:38,column:69}},'15':{start:{line:41,column:3},end:{line:41,column:13}},'16':{start:{line:47,column:1},end:{line:47,column:32}},'17':{start:{line:50,column:1},end:{line:50,column:42}}},fnMap:{'0':{name:'secondsFormatter',decl:{start:{line:7,column:16},end:{line:7,column:32}},loc:{start:{line:7,column:65},end:{line:45,column:1}},line:7},'1':{name:'dateFormatter',decl:{start:{line:46,column:16},end:{line:46,column:29}},loc:{start:{line:46,column:35},end:{line:48,column:1}},line:46},'2':{name:'toIsoDate',decl:{start:{line:49,column:16},end:{line:49,column:25}},loc:{start:{line:49,column:32},end:{line:51,column:1}},line:49}},branchMap:{'0':{loc:{start:{line:8,column:1},end:{line:44,column:2}},type:'if',locations:[{start:{line:8,column:1},end:{line:44,column:2}},{start:{line:8,column:1},end:{line:44,column:2}}],line:8},'1':{loc:{start:{line:9,column:2},end:{line:20,column:3}},type:'if',locations:[{start:{line:9,column:2},end:{line:20,column:3}},{start:{line:9,column:2},end:{line:20,column:3}}],line:9},'2':{loc:{start:{line:11,column:3},end:{line:16,column:7}},type:'if',locations:[{start:{line:11,column:3},end:{line:16,column:7}},{start:{line:11,column:3},end:{line:16,column:7}}],line:11},'3':{loc:{start:{line:11,column:6},end:{line:11,column:35}},type:'binary-expr',locations:[{start:{line:11,column:6},end:{line:11,column:18}},{start:{line:11,column:22},end:{line:11,column:35}}],line:11},'4':{loc:{start:{line:22,column:6},end:{line:44,column:2}},type:'if',locations:[{start:{line:22,column:6},end:{line:44,column:2}},{start:{line:22,column:6},end:{line:44,column:2}}],line:22},'5':{loc:{start:{line:23,column:2},end:{line:34,column:3}},type:'if',locations:[{start:{line:23,column:2},end:{line:34,column:3}},{start:{line:23,column:2},end:{line:34,column:3}}],line:23},'6':{loc:{start:{line:25,column:3},end:{line:30,column:7}},type:'if',locations:[{start:{line:25,column:3},end:{line:30,column:7}},{start:{line:25,column:3},end:{line:30,column:7}}],line:25},'7':{loc:{start:{line:25,column:6},end:{line:25,column:35}},type:'binary-expr',locations:[{start:{line:25,column:6},end:{line:25,column:18}},{start:{line:25,column:22},end:{line:25,column:35}}],line:25},'8':{loc:{start:{line:37,column:2},end:{line:42,column:3}},type:'if',locations:[{start:{line:37,column:2},end:{line:42,column:3}},{start:{line:37,column:2},end:{line:42,column:3}}],line:37}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2qymq6h5wz.s[0]++;__WEBPACK_IMPORTED_MODULE_1_moment_duration_format___default()(__WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__);//moment.locale(window.navigator.userLanguage || window.navigator.language);
function secondsFormatter(seconds,detailed,superdetailed){cov_2qymq6h5wz.f[0]++;cov_2qymq6h5wz.s[1]++;if(superdetailed){cov_2qymq6h5wz.b[0][0]++;cov_2qymq6h5wz.s[2]++;if(seconds!=0){cov_2qymq6h5wz.b[1][0]++;cov_2qymq6h5wz.s[3]++;//Kleiner als eine Minute?
if((cov_2qymq6h5wz.b[3][0]++,seconds<60)&&(cov_2qymq6h5wz.b[3][1]++,seconds>-60)){cov_2qymq6h5wz.b[2][0]++;cov_2qymq6h5wz.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__["duration"]({seconds:seconds}).format("ss _");}else{cov_2qymq6h5wz.b[2][1]++;cov_2qymq6h5wz.s[5]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__["duration"]({seconds:seconds}).format("hh _ mm _ ss _");}}else{cov_2qymq6h5wz.b[1][1]++;cov_2qymq6h5wz.s[6]++;return'-';}}else{cov_2qymq6h5wz.b[0][1]++;cov_2qymq6h5wz.s[7]++;if(detailed){cov_2qymq6h5wz.b[4][0]++;cov_2qymq6h5wz.s[8]++;if(seconds!=0){cov_2qymq6h5wz.b[5][0]++;cov_2qymq6h5wz.s[9]++;//Kleiner als eine Minute?
if((cov_2qymq6h5wz.b[7][0]++,seconds<60)&&(cov_2qymq6h5wz.b[7][1]++,seconds>-60)){cov_2qymq6h5wz.b[6][0]++;cov_2qymq6h5wz.s[10]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__["duration"]({seconds:seconds}).format("ss _");}else{cov_2qymq6h5wz.b[6][1]++;cov_2qymq6h5wz.s[11]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__["duration"]({seconds:seconds}).format("hh _ mm _ ");}}else{cov_2qymq6h5wz.b[5][1]++;cov_2qymq6h5wz.s[12]++;return'-';}}else{cov_2qymq6h5wz.b[4][1]++;cov_2qymq6h5wz.s[13]++;if(seconds!=0){cov_2qymq6h5wz.b[8][0]++;cov_2qymq6h5wz.s[14]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__["duration"]({seconds:seconds}).format("hh _ mm _");}else{cov_2qymq6h5wz.b[8][1]++;cov_2qymq6h5wz.s[15]++;return'-';}}}}function dateFormatter(utc){cov_2qymq6h5wz.f[1]++;cov_2qymq6h5wz.s[16]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__(utc).format("L");}function toIsoDate(date){cov_2qymq6h5wz.f[2]++;cov_2qymq6h5wz.s[17]++;return __WEBPACK_IMPORTED_MODULE_0_moment_min_moment_with_locales__(date).format("YYYY-MM-DD");}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(231);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "availableLanguages", function() { return availableLanguages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_reducers_helpers_menu__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_reducers_helpers_blur__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_reducers_helpers_countriesstates__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_reducers_helpers_notifications__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_reducers_helpers_design__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_reducers_fetching__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_reducers_printing__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_reducers_tokenRestore__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_reducers_appStartup__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_reducers_translationLoad__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_reducers_auth__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__store_reducers_defaults__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_reducers_calculator_settings_company__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__store_reducers_calculator_jobs_jobs__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store_reducers_calculator_jobs_defaults__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store_reducers_calculator_jobs_job__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_reducers_calculator_machines_machines__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_reducers_calculator_machines_defaults__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store_reducers_calculator_machines_machine__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__store_reducers_visualMessage__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_config__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_RestoreToken__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__index_scss__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__index_scss__);
var cov_1u3s16wd8c=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\index.js',hash='d171b04418b21a4e4232450d197e1da9fb2df687',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\index.js',statementMap:{'0':{start:{line:38,column:20},end:{line:61,column:2}},'1':{start:{line:74,column:25},end:{line:74,column:79}},'2':{start:{line:76,column:14},end:{line:76,column:80}},'3':{start:{line:79,column:34},end:{line:79,column:76}},'4':{start:{line:80,column:0},end:{line:80,column:76}},'5':{start:{line:82,column:18},end:{line:86,column:1}},'6':{start:{line:83,column:1},end:{line:85,column:12}},'7':{start:{line:88,column:13},end:{line:88,column:43}},'8':{start:{line:89,column:0},end:{line:89,column:25}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:82,column:18},end:{line:82,column:19}},loc:{start:{line:83,column:1},end:{line:85,column:12}},line:83}},branchMap:{'0':{loc:{start:{line:74,column:25},end:{line:74,column:79}},type:'binary-expr',locations:[{start:{line:74,column:25},end:{line:74,column:68}},{start:{line:74,column:72},end:{line:74,column:79}}],line:74}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},f:{'0':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var rootReducer=(cov_1u3s16wd8c.s[0]++,Object(__WEBPACK_IMPORTED_MODULE_2_redux__["c" /* combineReducers */])({helpersMenu:__WEBPACK_IMPORTED_MODULE_7__store_reducers_helpers_menu__["a" /* default */],helpersBlur:__WEBPACK_IMPORTED_MODULE_8__store_reducers_helpers_blur__["a" /* default */],helpersCountriesStates:__WEBPACK_IMPORTED_MODULE_9__store_reducers_helpers_countriesstates__["a" /* default */],helpersNotifications:__WEBPACK_IMPORTED_MODULE_10__store_reducers_helpers_notifications__["a" /* default */],helpersDesign:__WEBPACK_IMPORTED_MODULE_11__store_reducers_helpers_design__["a" /* default */],fetching:__WEBPACK_IMPORTED_MODULE_12__store_reducers_fetching__["a" /* default */],printing:__WEBPACK_IMPORTED_MODULE_13__store_reducers_printing__["a" /* default */],visualMessage:__WEBPACK_IMPORTED_MODULE_26__store_reducers_visualMessage__["a" /* default */],tokenRestore:__WEBPACK_IMPORTED_MODULE_14__store_reducers_tokenRestore__["a" /* default */],appStartup:__WEBPACK_IMPORTED_MODULE_15__store_reducers_appStartup__["a" /* default */],translationLoad:__WEBPACK_IMPORTED_MODULE_16__store_reducers_translationLoad__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_17__store_reducers_auth__["a" /* default */],defaults:__WEBPACK_IMPORTED_MODULE_18__store_reducers_defaults__["a" /* default */],calculatorSettingsCompany:__WEBPACK_IMPORTED_MODULE_19__store_reducers_calculator_settings_company__["a" /* default */],calculatorJobs:__WEBPACK_IMPORTED_MODULE_20__store_reducers_calculator_jobs_jobs__["a" /* default */],calculatorJobsDefaults:__WEBPACK_IMPORTED_MODULE_21__store_reducers_calculator_jobs_defaults__["a" /* default */],calculatorJob:__WEBPACK_IMPORTED_MODULE_22__store_reducers_calculator_jobs_job__["a" /* default */],calculatorMachines:__WEBPACK_IMPORTED_MODULE_23__store_reducers_calculator_machines_machines__["a" /* default */],calculatorMachinesDefaults:__WEBPACK_IMPORTED_MODULE_24__store_reducers_calculator_machines_defaults__["a" /* default */],calculatorMachine:__WEBPACK_IMPORTED_MODULE_25__store_reducers_calculator_machines_machine__["a" /* default */],toastr:__WEBPACK_IMPORTED_MODULE_3_react_redux_toastr__["reducer"],locale:__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["f" /* localeReducer */]}));/*const logger = store => {
    return next => {
        return action => {
            console.log('[Middleware] Dispatching', action);
            const result = next(action);
            console.log('[Middleware] next state', store.getState());
            return result;
        }
    }
};*/var composeEnhancers=(cov_1u3s16wd8c.s[1]++,(cov_1u3s16wd8c.b[0][0]++,window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)||(cov_1u3s16wd8c.b[0][1]++,__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */]));var store=(cov_1u3s16wd8c.s[2]++,Object(__WEBPACK_IMPORTED_MODULE_2_redux__["e" /* createStore */])(rootReducer,composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_2_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_4_redux_thunk___default.a))));//store.dispatch(actionCreators.defaultsFetch());
var availableLanguages=(cov_1u3s16wd8c.s[3]++,['en','de','nl','es','fr','it','pt']);cov_1u3s16wd8c.s[4]++;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_27_react_localize_redux__["e" /* initialize */])(availableLanguages,{missingTranslationMsg:'-'}));cov_1u3s16wd8c.s[5]++;var renderApp=function renderApp(){cov_1u3s16wd8c.f[0]++;cov_1u3s16wd8c.s[6]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_RestoreToken__["a" /* default */],null));};var root=(cov_1u3s16wd8c.s[7]++,document.getElementById('app'));cov_1u3s16wd8c.s[8]++;Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(renderApp(),root);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(250);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(243);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(119);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(123);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(82);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeByType = exports.hideConfirm = exports.showConfirm = exports.remove = exports.clean = undefined;
exports.add = add;

var _constants = __webpack_require__(84);

var _utils = __webpack_require__(46);

var _reducer = __webpack_require__(125);

var _config = __webpack_require__(83);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function add(toastr) {
  if (_config2.default.preventDuplicates && (0, _utils.preventDuplication)(_reducer.toastrsCache, toastr)) {
    return {
      type: _constants.ADD_TOASTR,
      payload: {
        ignoreToastr: true
      }
    };
  }
  return {
    type: _constants.ADD_TOASTR,
    payload: toastr
  };
}

var clean = exports.clean = function clean() {
  return { type: _constants.CLEAN_TOASTR };
};

var remove = exports.remove = function remove(payload) {
  return {
    type: _constants.REMOVE_TOASTR,
    payload: payload
  };
};

var showConfirm = exports.showConfirm = function showConfirm(payload) {
  return {
    type: _constants.SHOW_CONFIRM,
    payload: payload
  };
};

var hideConfirm = exports.hideConfirm = function hideConfirm() {
  return { type: _constants.HIDE_CONFIRM };
};

var removeByType = exports.removeByType = function removeByType(payload) {
  return {
    type: _constants.REMOVE_BY_TYPE,
    payload: payload
  };
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrsCache = undefined;

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(46);

var _config = __webpack_require__(83);

var _config2 = _interopRequireDefault(_config);

var _constants = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// TOTO: find a better way of handling this issue
// We will cache data so we can check for duplicated before fire the add action.
var toastrsCache = exports.toastrsCache = [];

var initialState = {
  toastrs: [],
  confirm: null
};

exports.default = (0, _utils.createReducer)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _constants.ADD_TOASTR, function (state, toastr) {
  if (toastr.ignoreToastr) {
    return state;
  }

  var newToastr = _extends({
    id: (0, _utils.guid)(),
    position: _config2.default.position
  }, toastr);

  var newState = {};
  if (!_config2.default.newestOnTop) {
    newState = _extends({}, state, {
      toastrs: [].concat(_toConsumableArray(state.toastrs), [newToastr])
    });
  } else {
    newState = _extends({}, state, {
      toastrs: [newToastr].concat(_toConsumableArray(state.toastrs))
    });
  }
  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_TOASTR, function (state, id) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.id !== id;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.REMOVE_BY_TYPE, function (state, type) {
  var newState = _extends({}, state, {
    toastrs: state.toastrs.filter(function (toastr) {
      return toastr.type !== type;
    })
  });

  exports.toastrsCache = toastrsCache = newState.toastrs;
  return newState;
}), _defineProperty(_createReducer, _constants.CLEAN_TOASTR, function (state) {
  exports.toastrsCache = toastrsCache = [];
  return _extends({}, state, {
    toastrs: []
  });
}), _defineProperty(_createReducer, _constants.SHOW_CONFIRM, function (state, _ref) {
  var id = _ref.id,
      message = _ref.message,
      options = _ref.options;

  return _extends({}, state, {
    confirm: {
      id: id || (0, _utils.guid)(),
      show: true,
      message: message,
      options: options || {}
    }
  });
}), _defineProperty(_createReducer, _constants.HIDE_CONFIRM, function (state) {
  return _extends({}, state, {
    confirm: null
  });
}), _createReducer));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrEmitter = exports.EE = undefined;

var _utils = __webpack_require__(46);

var _eventemitter = __webpack_require__(274);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _eventemitter2.default();

var addToToastr = function addToToastr(type, array) {
  return emitter.emit('add/toastr', (0, _utils.mapToToastrMessage)(type, array));
};

var actions = {};
['light', 'message', 'info', 'success', 'warning', 'error'].forEach(function (item) {
  actions[item] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return addToToastr(item, args);
  };
});

actions.clean = function () {
  return emitter.emit('clean/toastr');
};

/**
 * @params: can be a ID or a object that with a property type: 'success'
 * and by passing this we will remove all toastr with that type.
 */
actions.removeByType = function (type) {
  return emitter.emit('removeByType/toastr', type);
};

actions.remove = function (id) {
  return emitter.emit('remove/toastr', id);
};

actions.confirm = function () {
  emitter.emit('toastr/confirm', {
    message: arguments.length <= 0 ? undefined : arguments[0],
    options: (arguments.length <= 1 ? undefined : arguments[1]) || {}
  });
};

var EE = exports.EE = emitter;
var toastrEmitter = exports.toastrEmitter = actions;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocalizedElement; });
/* unused harmony export hasHtmlTags */
/* unused harmony export templater */
/* unused harmony export getIndexForLanguageCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return objectValuesToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validateOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTranslationsForLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storeDidChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(65);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var getLocalizedElement = function getLocalizedElement(key, translations, data, activeLanguage) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : __WEBPACK_IMPORTED_MODULE_1__locale__["b" /* defaultTranslateOptions */];

  var onMissingTranslation = function onMissingTranslation() {
    if (options.missingTranslationCallback) {
      options.missingTranslationCallback(key, activeLanguage.code);
    }
    return options.showMissingTranslationMsg === false ? '' : templater(options.missingTranslationMsg || '', { key: key, code: activeLanguage.code });
  };
  var localizedString = translations[key] || onMissingTranslation();
  var translatedValue = templater(localizedString, data);
  return options.renderInnerHtml && hasHtmlTags(translatedValue) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: translatedValue } }) : translatedValue;
};

var hasHtmlTags = function hasHtmlTags(value) {
  var pattern = /(&[^\s]*;|<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[\^'">\s]+))?)+\s*|\s*)\/?>)/;
  return value.search(pattern) >= 0;
};

/**
 * @func templater
 * @desc A poor mans template parser 
 * @param {string} strings The template string
 * @param {object} data The data that should be inserted in template
 * @return {string} The template string with the data merged in
 */
var templater = function templater(strings) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var prop in data) {
    var pattern = '\\${\\s*' + prop + '\\s*}';
    var regex = new RegExp(pattern, 'gmi');
    strings = strings.replace(regex, data[prop]);
  }
  return strings;
};

var getIndexForLanguageCode = function getIndexForLanguageCode(code, languages) {
  return languages.map(function (language) {
    return language.code;
  }).indexOf(code);
};

var objectValuesToString = function objectValuesToString(data) {
  return !Object.values ? Object.keys(data).map(function (key) {
    return data[key].toString();
  }).toString() : Object.values(data).toString();
};

var validateOptions = function validateOptions(options) {
  if (options.translationTransform !== undefined && typeof options.translationTransform !== 'function') {
    throw new Error('react-localize-redux: Invalid translationTransform function.');
  }
  return options;
};

var getTranslationsForLanguage = function getTranslationsForLanguage(language, languages, translations) {
  // no language! return no translations 
  if (!language) {
    return {};
  }

  var languageCode = language.code;

  var languageIndex = getIndexForLanguageCode(languageCode, languages);
  return Object.keys(translations).reduce(function (prev, key) {
    return _extends({}, prev, _defineProperty({}, key, translations[key][languageIndex]));
  }, {});
};

var storeDidChange = function storeDidChange(store, onChange) {
  var currentState = void 0;

  function handleChange() {
    var nextState = store.getState();
    if (nextState !== currentState) {
      onChange(currentState);
      currentState = nextState;
    }
  }

  var unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};

// Thanks react-redux for utility function
// https://github.com/reactjs/react-redux/blob/master/src/utils/warning.js
var warning = function warning(message) {
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {}
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {// config.js (c) 2010-2015 Loren West and other contributors
// May be freely distributed under the MIT license.
// For further details and documentation:
// http://lorenwest.github.com/node-config

// Dependencies
var Yaml = null,    // External libraries are lazy-loaded
    VisionmediaYaml = null,  // only if these file types exist.
    Coffee = null,
    Iced = null,
    CSON = null,
    PPARSER = null,
    JSON5 = null,
    TOML = null,
    HJSON = null,
    XML = null,
    deferConfig = __webpack_require__(137).deferConfig,
    DeferredConfig = __webpack_require__(137).DeferredConfig,
    RawConfig = __webpack_require__(334).RawConfig,
    Utils = __webpack_require__(335),
    Path = __webpack_require__(338),
    FileSystem = __webpack_require__(339);

// Static members
var DEFAULT_CLONE_DEPTH = 20,
    NODE_CONFIG, CONFIG_DIR, RUNTIME_JSON_FILENAME, NODE_ENV, APP_INSTANCE,
    HOST, HOSTNAME, ALLOW_CONFIG_MUTATIONS, CONFIG_SKIP_GITCRYPT,
    env = {},
    privateUtil = {},
    deprecationWarnings = {},
    configSources = [],          // Configuration sources - array of {name, original, parsed}
    checkMutability = true,      // Check for mutability/immutability on first get
    gitCryptTestRegex = /^.GITCRYPT/; // regular expression to test for gitcrypt files.

// Define soft dependencies so transpilers don't include everything
var COFFEE_DEP = "coffee-script",
ICED_DEP = "iced-coffee-script",
JS_YAML_DEP = "js-yaml",
YAML_DEP = "yaml",
JSON5_DEP = "json5",
HJSON_DEP = "hjson",
TOML_DEP = "toml",
CSON_DEP = "cson",
PPARSER_DEP = "properties",
XML_DEP = "x2js",
TS_DEP = "ts-node";

/**
 * <p>Application Configurations</p>
 *
 * <p>
 * The config module exports a singleton object representing all
 * configurations for this application deployment.
 * </p>
 *
 * <p>
 * Application configurations are stored in files within the config directory
 * of your application.  The default configuration file is loaded, followed
 * by files specific to the deployment type (development, testing, staging,
 * production, etc.).
 * </p>
 *
 * <p>
 * For example, with the following config/default.yaml file:
 * </p>
 *
 * <pre>
 *   ...
 *   customer:
 *     &nbsp;&nbsp;initialCredit: 500
 *     &nbsp;&nbsp;db:
 *       &nbsp;&nbsp;&nbsp;&nbsp;name: customer
 *       &nbsp;&nbsp;&nbsp;&nbsp;port: 5984
 *   ...
 * </pre>
 *
 * <p>
 * The following code loads the customer section into the CONFIG variable:
 * <p>
 *
 * <pre>
 *   var CONFIG = require('config').customer;
 *   ...
 *   newCustomer.creditLimit = CONFIG.initialCredit;
 *   database.open(CONFIG.db.name, CONFIG.db.port);
 *   ...
 * </pre>
 *
 * @module config
 * @class Config
 */

/**
 * <p>Get the configuration object.</p>
 *
 * <p>
 * The configuration object is a shared singleton object within the application,
 * attained by calling require('config').
 * </p>
 *
 * <p>
 * Usually you'll specify a CONFIG variable at the top of your .js file
 * for file/module scope. If you want the root of the object, you can do this:
 * </p>
 * <pre>
 * var CONFIG = require('config');
 * </pre>
 *
 * <p>
 * Sometimes you only care about a specific sub-object within the CONFIG
 * object.  In that case you could do this at the top of your file:
 * </p>
 * <pre>
 * var CONFIG = require('config').customer;
 * or
 * var CUSTOMER_CONFIG = require('config').customer;
 * </pre>
 *
 * <script type="text/javascript">
 *   document.getElementById("showProtected").style.display = "block";
 * </script>
 *
 * @method constructor
 * @return CONFIG {object} - The top level configuration object
 */
var Config = function() {
  var t = this;

  // Bind all utility functions to this
  for (var fnName in util) {
    util[fnName] = util[fnName].bind(t);
  }

  // Merge configurations into this
  util.extendDeep(t, util.loadFileConfigs());
  util.attachProtoDeep(t);

  // Perform strictness checks and possibly throw an exception.
  util.runStrictnessChecks(t);
};

/**
 * Utilities are under the util namespace vs. at the top level
 */
var util = Config.prototype.util = {};

/**
 * Underlying get mechanism
 *
 * @private
 * @method getImpl
 * @param object {object} - Object to get the property for
 * @param property {string | array[string]} - The property name to get (as an array or '.' delimited string)
 * @return value {*} - Property value, including undefined if not defined.
 */
var getImpl= function(object, property) {
  var t = this,
      elems = Array.isArray(property) ? property : property.split('.'),
      name = elems[0],
      value = object[name];
  if (elems.length <= 1) {
    return value;
  }
  // Note that typeof null === 'object'
  if (value === null || typeof value !== 'object') {
    return undefined;
  }
  return getImpl(value, elems.slice(1));
};


/**
 * <p>Get a configuration value</p>
 *
 * <p>
 * This will return the specified property value, throwing an exception if the
 * configuration isn't defined.  It is used to assure configurations are defined
 * before being used, and to prevent typos.
 * </p>
 *
 * @method get
 * @param property {string} - The configuration property to get. Can include '.' sub-properties.
 * @return value {*} - The property value
 */
Config.prototype.get = function(property) {
  if(property === null || property === undefined){
    throw new Error("Calling config.get with null or undefined argument");
  }

  // Make configurations immutable after first get (unless disabled)
  if (checkMutability) {
    if (!util.initParam('ALLOW_CONFIG_MUTATIONS', false)) {
      util.makeImmutable(config);
    }
    checkMutability = false;
  }
  var t = this,
      value = getImpl(t, property);

  // Produce an exception if the property doesn't exist
  if (value === undefined) {
    throw new Error('Configuration property "' + property + '" is not defined');
  }

  // Return the value
  return value;
};

/**
 * Test that a configuration parameter exists
 *
 * <pre>
 *    var config = require('config');
 *    if (config.has('customer.dbName')) {
 *      console.log('Customer database name: ' + config.customer.dbName);
 *    }
 * </pre>
 *
 * @method has
 * @param property {string} - The configuration property to test. Can include '.' sub-properties.
 * @return isPresent {boolean} - True if the property is defined, false if not defined.
 */
Config.prototype.has = function(property) {
  // While get() throws an exception for undefined input, has() is designed to test validity, so false is appropriate
  if(property === null || property === undefined){
    return false;
  }
  var t = this;
  return (getImpl(t, property) !== undefined);
};

/**
 * <p>Monitor a javascript property for runtime changes.</p>
 *
 * <p>
 * This method was built for an earlier version of node-config that allowed
 * configuration value mutations.  Since version 1.0.0, node-config no longer
 * allows configuration mutations, and is no longer used in node-config.
 * </p>
 *
 * <p>
 * It is deprecated, and will be removed in the next semver incompatible release 2.0.0.
 * </p>
 *
 * @method watch
 * @deprecated
 * @param object {object} - The object to watch.
 * @param property {string} - The property name to watch.  Watch all object properties if null.
 * @param handler {function(object, propertyName, priorValue, newValue)} - Handler called when a property change is detected.
 *   The handler is run along with other handlers registered for notification.
 *   If your handler changes the value of the property, that change is applied after all handlers have finished processing the current change.
 *   Then all handlers (including this one) will be called again with the newly changed value.
 * @param depth {integer} (optional) - If watching all object properties or if the specified property is an object, this specifies the depth of the object graph to watch for changes.  Default 6.
 * @return object {object} - The original object is returned - for chaining.
 */
util.watch = function(object, property, handler, depth) {

  // Initialize
  var t = this, o = object;
  var allProperties = property ? [property] : Object.keys(o);

  // Deprecation warning
  if (!deprecationWarnings.watch) {
    console.error('WARNING: config.' + fnName + '() is deprecated, and will not be supported in release 2.0.');
    console.error('WARNING: See https://github.com/lorenwest/node-config/wiki/Future-Compatibility#upcoming-incompatibilities');
    deprecationWarnings.watch = true;
  }

  // Depth detection
  depth = (depth === null ? DEFAULT_CLONE_DEPTH : depth);
  if (depth < 0) {
    return;
  }

  // Create hidden properties on the object
  if (!o.__watchers)
    util.makeHidden(o, '__watchers', {});
  if (!o.__propertyValues)
    util.makeHidden(o, '__propertyValues', {});

  // Attach watchers to all requested properties
  allProperties.forEach(function(prop){

    // Setup the property for watching (first time only)
    if (typeof(o.__propertyValues[prop]) === 'undefined') {

      // Don't error re-defining the property if immutable
      var descriptor = Object.getOwnPropertyDescriptor(o, prop);
      if (descriptor && descriptor.writable === false)
        return;

      // Copy the value to the hidden field, and add the property to watchers
      o.__propertyValues[prop] = [o[prop]];
      o.__watchers[prop] = [];

      // Attach the property watcher
      Object.defineProperty(o, prop, {
        enumerable : true,

        get : function(){
          // If more than 1 item is in the values array,
          // then we're currently processing watchers.
          if (o.__propertyValues[prop].length === 1)
            // Current value
            return o.__propertyValues[prop][0];
          else
            // [0] is prior value, [1] is new value being processed
            return o.__propertyValues[prop][1];
        },

        set : function(newValue) {

          // Return early if no change
          var origValue = o[prop];
          if (util.equalsDeep(origValue, newValue))
            return;

          // Remember the new value, and return if we're in another setter
          o.__propertyValues[prop].push(newValue);
          if (o.__propertyValues[prop].length > 2)
            return;

          // Call all watchers for each change requested
          var numIterations = 0;
          while (o.__propertyValues[prop].length > 1) {

            // Detect recursion
            if (++numIterations > 20) {
              o.__propertyValues[prop] = [origValue];
              throw new Error('Recursion detected while setting [' + prop + ']');
            }

            // Call each watcher for the current values
            var oldValue = o.__propertyValues[prop][0];
            newValue = o.__propertyValues[prop][1];
            o.__watchers[prop].forEach(function(watcher) {
              try {
                watcher(o, prop, oldValue, newValue);
              } catch (e) {
                // Log an error and continue with subsequent watchers
                console.error("Exception in object watcher for " + prop, e);
              }
            });

            // Done processing this value
            o.__propertyValues[prop].splice(0,1);
          }
        }
      });

    } // Done setting up the property for watching (first time)

    // Add the watcher to the property
    o.__watchers[prop].push(handler);

    // Recurs if this is an object...
    if (o[prop] && typeof(o[prop]) === 'object') {
      util.watch(o[prop], null, handler, depth - 1);
    }

  }); // Done processing each property

  // Return the original object - for chaining
  return o;
};

/**
 * <p>
 * Set default configurations for a node.js module.
 * </p>
 *
 * <p>
 * This allows module developers to attach their configurations onto the
 * default configuration object so they can be configured by the consumers
 * of the module.
 * </p>
 *
 * <p>Using the function within your module:</p>
 * <pre>
 *   var CONFIG = require("config");
 *   CONFIG.util.setModuleDefaults("MyModule", {
 *   &nbsp;&nbsp;templateName: "t-50",
 *   &nbsp;&nbsp;colorScheme: "green"
 *   });
 * <br>
 *   // Template name may be overridden by application config files
 *   console.log("Template: " + CONFIG.MyModule.templateName);
 * </pre>
 *
 * <p>
 * The above example results in a "MyModule" element of the configuration
 * object, containing an object with the specified default values.
 * </p>
 *
 * @method setModuleDefaults
 * @param moduleName {string} - Name of your module.
 * @param defaultProperties {object} - The default module configuration.
 * @return moduleConfig {object} - The module level configuration object.
 */
util.setModuleDefaults = function (moduleName, defaultProperties) {

  // Copy the properties into a new object
  var t = this,
    moduleConfig = util.cloneDeep(defaultProperties);

  // Set module defaults into the first sources element
  if (configSources.length === 0 || configSources[0].name !== 'Module Defaults') {
    configSources.splice(0, 0, {
      name: 'Module Defaults',
      parsed: {}
    });
  }
  configSources[0].parsed[moduleName] = {};
  util.extendDeep(configSources[0].parsed[moduleName], defaultProperties);

  // Create a top level config for this module if it doesn't exist
  t[moduleName] = t[moduleName] || {};

  // Extend local configurations into the module config
  util.extendDeep(moduleConfig, t[moduleName]);

  // Merge the extended configs without replacing the original
  util.extendDeep(t[moduleName], moduleConfig);

  // reset the mutability check for "config.get" method.
  // we are not making t[moduleName] immutable immediately,
  // since there might be more modifications before the first config.get
  if (!util.initParam('ALLOW_CONFIG_MUTATIONS', false)) {
    checkMutability = true;
  }

  // Attach handlers & watchers onto the module config object
  return util.attachProtoDeep(t[moduleName]);
};

/**
 * <p>Make a configuration property hidden so it doesn't appear when enumerating
 * elements of the object.</p>
 *
 * <p>
 * The property still exists and can be read from and written to, but it won't
 * show up in for ... in loops, Object.keys(), or JSON.stringify() type methods.
 * </p>
 *
 * <p>
 * If the property already exists, it will be made hidden.  Otherwise it will
 * be created as a hidden property with the specified value.
 * </p>
 *
 * <p><i>
 * This method was built for hiding configuration values, but it can be applied
 * to <u>any</u> javascript object.
 * </i></p>
 *
 * <p>Example:</p>
 * <pre>
 *   var CONFIG = require('config');
 *   ...
 *
 *   // Hide the Amazon S3 credentials
 *   CONFIG.util.makeHidden(CONFIG.amazonS3, 'access_id');
 *   CONFIG.util.makeHidden(CONFIG.amazonS3, 'secret_key');
 * </pre>
 *
 * @method makeHidden
 * @param object {object} - The object to make a hidden property into.
 * @param property {string} - The name of the property to make hidden.
 * @param value {*} - (optional) Set the property value to this (otherwise leave alone)
 * @return object {object} - The original object is returned - for chaining.
 */
util.makeHidden = function(object, property, value) {

  // If the new value isn't specified, just mark the property as hidden
  if (typeof value === 'undefined') {
    Object.defineProperty(object, property, {
      enumerable : false
    });
  }
  // Otherwise set the value and mark it as hidden
  else {
    Object.defineProperty(object, property, {
      value      : value,
      enumerable : false
    });
  }

  return object;
}

/**
 * <p>Make a javascript object property immutable (assuring it cannot be changed
 * from the current value).</p>
 * <p>
 * If the specified property is an object, all attributes of that object are
 * made immutable, including properties of contained objects, recursively.
 * If a property name isn't supplied, all properties of the object are made
 * immutable.
 * </p>
 * <p>
 *
 * </p>
 * <p>
 * New properties can be added to the object and those properties will not be
 * immutable unless this method is called on those new properties.
 * </p>
 * <p>
 * This operation cannot be undone.
 * </p>
 *
 * <p>Example:</p>
 * <pre>
 *   var config = require('config');
 *   var myObject = {hello:'world'};
 *   config.util.makeImmutable(myObject);
 * </pre>
 *
 * @method makeImmutable
 * @param object {object} - The object to specify immutable properties for
 * @param [property] {string | [string]} - The name of the property (or array of names) to make immutable.
 *        If not provided, all owned properties of the object are made immutable.
 * @param [value] {* | [*]} - Property value (or array of values) to set
 *        the property to before making immutable. Only used when setting a single
 *        property. Retained for backward compatibility.
 * @return object {object} - The original object is returned - for chaining.
 */
util.makeImmutable = function(object, property, value) {
  var properties = null;

  // Backwards compatibility mode where property/value can be specified
  if (typeof property === 'string') {
    return Object.defineProperty(object, property, {
      value : (typeof value === 'undefined') ? object[property] : value,
      writable : false,
      configurable: false
    });
  }

  // Get the list of properties to work with
  if (Array.isArray(property)) {
    properties = property;
  }
  else {
    properties = Object.keys(object);
  }

  // Process each property
  for (var i = 0; i < properties.length; i++) {
    var propertyName = properties[i],
        value = object[propertyName];

    if (value instanceof RawConfig) {
      Object.defineProperty(object, propertyName, {
        value: value.resolve(),
        writable: false,
        configurable: false
      });
    } else {
      Object.defineProperty(object, propertyName, {
        value: value,
        writable : false,
        configurable: false
      });

      // Call recursively if an object.
      if (util.isObject(value)) {
        util.makeImmutable(value);
      }
    }
  }

  return object;
};

/**
 * Return the sources for the configurations
 *
 * <p>
 * All sources for configurations are stored in an array of objects containing
 * the source name (usually the filename), the original source (as a string),
 * and the parsed source as an object.
 * </p>
 *
 * @method getConfigSources
 * @return configSources {Array[Object]} - An array of objects containing
 *    name, original, and parsed elements
 */
util.getConfigSources = function() {
  var t = this;
  return configSources.slice(0);
};

/**
 * Load the individual file configurations.
 *
 * <p>
 * This method builds a map of filename to the configuration object defined
 * by the file.  The search order is:
 * </p>
 *
 * <pre>
 *   default.EXT
 *   (deployment).EXT
 *   (hostname).EXT
 *   (hostname)-(deployment).EXT
 *   local.EXT
 *   local-(deployment).EXT
 *   runtime.json
 * </pre>
 *
 * <p>
 * EXT can be yml, yaml, coffee, iced, json, cson or js signifying the file type.
 * yaml (and yml) is in YAML format, coffee is a coffee-script, iced is iced-coffee-script,
 * json is in JSON format, cson is in CSON format, properties is in .properties format
 * (http://en.wikipedia.org/wiki/.properties), and js is a javascript executable file that is
 * require()'d with module.exports being the config object.
 * </p>
 *
 * <p>
 * hostname is the $HOST environment variable (or --HOST command line parameter)
 * if set, otherwise the $HOSTNAME environment variable (or --HOSTNAME command
 * line parameter) if set, otherwise the hostname found from
 * require('os').hostname().
 * </p>
 *
 * <p>
 * Once a hostname is found, everything from the first period ('.') onwards
 * is removed. For example, abc.example.com becomes abc
 * </p>
 *
 * <p>
 * (deployment) is the deployment type, found in the $NODE_ENV environment
 * variable (which can be overriden by using $NODE_CONFIG_ENV
 * environment variable). Defaults to 'development'.
 * </p>
 *
 * <p>
 * The runtime.json file contains configuration changes made at runtime either
 * manually, or by the application setting a configuration value.
 * </p>
 *
 * <p>
 * If the $NODE_APP_INSTANCE environment variable (or --NODE_APP_INSTANCE
 * command line parameter) is set, then files with this appendage will be loaded.
 * See the Multiple Application Instances section of the main documentaion page
 * for more information.
 * </p>
 *
 * @protected
 * @method loadFileConfigs
 * @return config {Object} The configuration object
 */
util.loadFileConfigs = function(configDir) {

  // Initialize
  var t = this,
      config = {};

  // Initialize parameters from command line, environment, or default
  NODE_ENV = util.initParam('NODE_ENV', 'development');

  // Override, NODE_ENV if NODE_CONFIG_ENV is specified.
  NODE_ENV = util.initParam('NODE_CONFIG_ENV', NODE_ENV);

  CONFIG_DIR = configDir || util.initParam('NODE_CONFIG_DIR', Path.join( process.cwd(), 'config') );
  if (CONFIG_DIR.indexOf('.') === 0) {
    CONFIG_DIR = Path.join(process.cwd() , CONFIG_DIR);
  }

  APP_INSTANCE = util.initParam('NODE_APP_INSTANCE');
  HOST = util.initParam('HOST');
  HOSTNAME = util.initParam('HOSTNAME');
  CONFIG_SKIP_GITCRYPT = util.initParam('CONFIG_SKIP_GITCRYPT');

  // This is for backward compatibility
  RUNTIME_JSON_FILENAME = util.initParam('NODE_CONFIG_RUNTIME_JSON', Path.join(CONFIG_DIR , 'runtime.json') );

  // Determine the host name from the OS module, $HOST, or $HOSTNAME
  // Remove any . appendages, and default to null if not set
  try {
    var hostName = HOST || HOSTNAME;

    if (!hostName) {
        var OS = __webpack_require__(340);
        hostName = OS.hostname();
    }
  } catch (e) {
    hostName = '';
  }

  // Store the hostname that won.
  env.HOSTNAME = hostName;

  // Read each file in turn
  var baseNames = ['default', NODE_ENV];

  // #236: Also add full hostname when they are different.
  if ( hostName ) {
    var firstDomain = hostName.split('.')[0];

    // Backward compatibility
    baseNames.push(firstDomain, firstDomain + '-' + NODE_ENV);

    // Add full hostname when it is not the same
    if ( hostName != firstDomain ) {
      baseNames.push(hostName, hostName + '-' + NODE_ENV);
    }
  }

  baseNames.push('local', 'local-' + NODE_ENV);

  var extNames = ['js', 'ts', 'json', 'json5', 'hjson', 'toml', 'coffee', 'iced', 'yaml', 'yml', 'cson', 'properties', 'xml'];
  baseNames.forEach(function(baseName) {
    extNames.forEach(function(extName) {

      // Try merging the config object into this object
      var fullFilename = Path.join(CONFIG_DIR , baseName + '.' + extName);
      var configObj = util.parseFile(fullFilename);
      if (configObj) {
        util.extendDeep(config, configObj);
      }

      // See if the application instance file is available
      if (APP_INSTANCE) {
        fullFilename = Path.join(CONFIG_DIR, baseName + '-' + APP_INSTANCE + '.' + extName);
        configObj = util.parseFile(fullFilename);
        if (configObj) {
          util.extendDeep(config, configObj);
        }
      }
    });
  });

  // Override configurations from the $NODE_CONFIG environment variable
  // NODE_CONFIG only applies to the base config
  if (!configDir) {
    var envConfig = {};
    if (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"}).NODE_CONFIG) {
      try {
        envConfig = JSON.parse(Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"}).NODE_CONFIG);
      } catch(e) {
        console.error('The $NODE_CONFIG environment variable is malformed JSON');
      }
      util.extendDeep(config, envConfig);
      configSources.push({
        name: "$NODE_CONFIG",
        parsed: envConfig,
      });
    }

    // Override configurations from the --NODE_CONFIG command line
    var cmdLineConfig = util.getCmdLineArg('NODE_CONFIG');
    if (cmdLineConfig) {
      try {
        cmdLineConfig = JSON.parse(cmdLineConfig);
      } catch(e) {
        console.error('The --NODE_CONFIG={json} command line argument is malformed JSON');
      }
      util.extendDeep(config, cmdLineConfig);
      configSources.push({
        name: "--NODE_CONFIG argument",
        parsed: cmdLineConfig,
      });
    }

    // Place the mixed NODE_CONFIG into the environment
    env['NODE_CONFIG'] = JSON.stringify(util.extendDeep(envConfig, cmdLineConfig, {}));
  }

  // Override with environment variables if there is a custom-environment-variables.EXT mapping file
  var customEnvVars = util.getCustomEnvVars(CONFIG_DIR, extNames);
  util.extendDeep(config, customEnvVars);

  // Extend the original config with the contents of runtime.json (backwards compatibility)
  var runtimeJson = util.parseFile(RUNTIME_JSON_FILENAME) || {};
  util.extendDeep(config, runtimeJson);

  util.resolveDeferredConfigs(config);

  // Return the configuration object
  return config;
};

// Using basic recursion pattern, find all the deferred values and resolve them.
util.resolveDeferredConfigs = function (config) {
  var completeConfig = config;


  function _iterate (prop) {

    // We put the properties we are going to look it in an array to keep the order predictable
    var propsToSort = [];

    // First step is to put the properties of interest in an array
    for (var property in prop) {
      if (prop.hasOwnProperty(property) && prop[property] != null) {
        propsToSort.push(property);
      }
    }

    // Second step is to iterate of the elements in a predictable (sorted) order
    propsToSort.sort().forEach(function (property) {
      if (prop[property].constructor == Object) {
        _iterate(prop[property]);
      } else if (prop[property].constructor == Array) {
        for (var i = 0; i < prop[property].length; i++) {
          _iterate(prop[property][i]);
        }
      } else {
        if (prop[property] instanceof DeferredConfig ) {
          prop[property]= prop[property].resolve.call(completeConfig,completeConfig, prop[property]._original);
        }
        else {
          // Nothing to do. Keep the property how it is.
        }
      }
    });
  }

    _iterate(config);
}

/**
 * Parse and return the specified configuration file.
 *
 * If the file exists in the application config directory, it will
 * parse and return it as a JavaScript object.
 *
 * The file extension determines the parser to use.
 *
 * .js = File to run that has a module.exports containing the config object
 * .coffee = File to run that has a module.exports with coffee-script containing the config object
 * .iced = File to run that has a module.exports with iced-coffee-script containing the config object
 * All other supported file types (yaml, toml, json, cson, hjson, json5, properties, xml)
 * are parsed with util.parseString.
 *
 * If the file doesn't exist, a null will be returned.  If the file can't be
 * parsed, an exception will be thrown.
 *
 * This method performs synchronous file operations, and should not be called
 * after synchronous module loading.
 *
 * @protected
 * @method parseFile
 * @param fullFilename {string} The full file path and name
 * @return {configObject} The configuration object parsed from the file
 */
util.parseFile = function(fullFilename) {

  // Initialize
  var t = this,
      extension = fullFilename.substr(fullFilename.lastIndexOf('.') + 1),
      configObject = null,
      fileContent = null,
      stat = null;

  // Return null if the file doesn't exist.
  // Note that all methods here are the Sync versions.  This is appropriate during
  // module loading (which is a synchronous operation), but not thereafter.
  try {
    stat = FileSystem.statSync(fullFilename);
    if (!stat || stat.size < 1) {
      return null;
    }
  } catch (e1) {
    return null
  }

  // Try loading the file.
  try {
    fileContent = FileSystem.readFileSync(fullFilename, 'UTF-8');
    fileContent = fileContent.replace(/^\uFEFF/, '');
  }
  catch (e2) {
    throw new Error('Config file ' + fullFilename + ' cannot be read');
  }

  // Parse the file based on extension
  try {

    // skip if it's a gitcrypt file and CONFIG_SKIP_GITCRYPT is true
    if (CONFIG_SKIP_GITCRYPT) {
      if (gitCryptTestRegex.test(fileContent)) {
        console.error('WARNING: ' + fullFilename + ' is a git-crypt file and CONFIG_SKIP_GITCRYPT is set. skipping.');
        return null;
      }
    }

    if (extension === 'js') {
      // Use the built-in parser for .js files
      configObject = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }
    else if (extension === 'ts') {
      if (!(void 0)['.ts']) {
        !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()).register({
          lazy: true,
          compilerOptions: {
            allowJs: true,
          }
        });
      }

      // Because of ES6 modules usage, `default` is treated as named export (like any other)
      // Therefore config is a value of `default` key.
      configObject = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()).default;
    }
    else if (extension === 'coffee') {
      // .coffee files can be loaded with either coffee-script or iced-coffee-script.
      // Prefer iced-coffee-script, if it exists.
      // Lazy load the appropriate extension
      if (!Coffee) {
        Coffee = {};

        // The following enables iced-coffee-script on .coffee files, if iced-coffee-script is available.
        // This is commented as per a decision on a pull request.
        //try {
        //  Coffee = require("iced-coffee-script");
        //}
        //catch (e) {
        //  Coffee = require("coffee-script");
        //}

        Coffee = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());

        // coffee-script >= 1.7.0 requires explicit registration for require() to work
        if (Coffee.register) {
          Coffee.register();
        }
      }
      // Use the built-in parser for .coffee files with coffee-script
      configObject = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }
    else if (extension === 'iced') {
      Iced = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());

      // coffee-script >= 1.7.0 requires explicit registration for require() to work
      if (Iced.register) {
        Iced.register();
      }
    }
    else {
      configObject = util.parseString(fileContent, extension);
    }
  }
  catch (e3) {
    if (gitCryptTestRegex.test(fileContent)) {
      console.error('ERROR: ' + fullFilename + ' is a git-crypt file and CONFIG_SKIP_GITCRYPT is not set.');
    }
    throw new Error("Cannot parse config file: '" + fullFilename + "': " + e3);
  }

  // Keep track of this configuration sources, including empty ones
  if (typeof configObject === 'object') {
    configSources.push({
      name: fullFilename,
      original: fileContent,
      parsed: configObject,
    });
  }

  return configObject;
};

/**
 * Parse and return the specied string with the specified format.
 *
 * The format determines the parser to use.
 *
 * json = File is parsed using JSON.parse()
 * yaml (or yml) = Parsed with a YAML parser
 * toml = Parsed with a TOML parser
 * cson = Parsed with a CSON parser
 * hjson = Parsed with a HJSON parser
 * json5 = Parsed with a JSON5 parser
 * properties = Parsed with the 'properties' node package
 * xml = Parsed with a XML parser
 *
 * If the file doesn't exist, a null will be returned.  If the file can't be
 * parsed, an exception will be thrown.
 *
 * This method performs synchronous file operations, and should not be called
 * after synchronous module loading.
 *
 * @protected
 * @method parseString
 * @param content {string} The full content
 * @param format {string} The format to be parsed
 * @return {configObject} The configuration object parsed from the string
 */
util.parseString = function (content, format) {
  // Initialize
  var configObject = null;

  // Parse the file based on extension
  if (format === 'yaml' || format === 'yml') {
    if (!Yaml && !VisionmediaYaml) {
      // Lazy loading
      try {
        // Try to load the better js-yaml module
        Yaml = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
      }
      catch (e) {
        try {
          // If it doesn't exist, load the fallback visionmedia yaml module.
          VisionmediaYaml = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
        }
        catch (e) { }
      }
    }

    if (Yaml) {
      configObject = Yaml.load(content);
    }
    else if (VisionmediaYaml) {
      // The yaml library doesn't like strings that have newlines but don't
      // end in a newline: https://github.com/visionmedia/js-yaml/issues/issue/13
      content += '\n';
      configObject = VisionmediaYaml.eval(util.stripYamlComments(content));
    }
    else {
      console.error("No YAML parser loaded.  Suggest adding js-yaml dependency to your package.json file.")
    }
  }
  else if (format === 'json') {
    try {
      configObject = JSON.parse(content);
    }
    catch (e) {
      // All JS Style comments will begin with /, so all JSON parse errors that
      // encountered a syntax error will complain about this character.
      if (e.name !== 'SyntaxError' || e.message.indexOf('Unexpected token /') !== 0) {
        throw e;
      }

      if (!JSON5) {
        JSON5 = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
      }

      configObject = JSON5.parse(content);
    }
  }
  else if (format === 'json5') {

    if (!JSON5) {
      JSON5 = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }

    configObject = JSON5.parse(content);

  } else if (format === 'hjson') {

    if (!HJSON) {
      HJSON = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }

    configObject = HJSON.parse(content);

  } else if (format === 'toml') {

    if(!TOML) {
      TOML = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }

    configObject = TOML.parse(content);
  }
  else if (format === 'cson') {
    if (!CSON) {
      CSON = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }
    // Allow comments in CSON files
    if (typeof CSON.parseSync === 'function') {
      configObject = CSON.parseSync(util.stripComments(content));
    } else {
      configObject = CSON.parse(util.stripComments(content));
    }
  }
  else if (format === 'properties') {
    if (!PPARSER) {
      PPARSER = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }
    configObject = PPARSER.parse(content, { namespaces: true, variables: true, sections: true });
  } else if (format === 'xml') {

    if (!XML) {
      XML = !(function webpackMissingModule() { var e = new Error("Cannot find module \".\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    }

    var x2js = new XML();
    configObject = x2js.xml2js(content);
    var rootKeys = Object.keys(configObject);
    if(rootKeys.length == 1) {
      configObject = configObject[rootKeys[0]];
    }
  }

  return configObject;
};

/**
 * Attach the Config class prototype to all config objects recursively.
 *
 * <p>
 * This allows you to do anything with CONFIG sub-objects as you can do with
 * the top-level CONFIG object.  It's so you can do this:
 * </p>
 *
 * <pre>
 *   var CUST_CONFIG = require('config').Customer;
 *   CUST_CONFIG.get(...)
 * </pre>
 *
 * @protected
 * @method attachProtoDeep
 * @param toObject
 * @param depth
 * @return toObject
 */
util.attachProtoDeep = function(toObject, depth) {
  if (toObject instanceof RawConfig) {
    return toObject;
  }

  // Recursion detection
  var t = this;
  depth = (depth === null ? DEFAULT_CLONE_DEPTH : depth);
  if (depth < 0) {
    return toObject;
  }

  // Adding Config.prototype methods directly to toObject as hidden properties
  // because adding to toObject.__proto__ exposes the function in toObject
  for (var fnName in Config.prototype) {
    if (!toObject[fnName]) {
      util.makeHidden(toObject, fnName, Config.prototype[fnName]);
    }
  }

  // Add prototypes to sub-objects
  for (var prop in toObject) {
    if (util.isObject(toObject[prop])) {
      util.attachProtoDeep(toObject[prop], depth - 1);
    }
  }

  // Return the original object
  return toObject;
};

/**
 * Return a deep copy of the specified object.
 *
 * This returns a new object with all elements copied from the specified
 * object.  Deep copies are made of objects and arrays so you can do anything
 * with the returned object without affecting the input object.
 *
 * @protected
 * @method cloneDeep
 * @param parent {object} The original object to copy from
 * @param [depth=20] {Integer} Maximum depth (default 20)
 * @return {object} A new object with the elements copied from the copyFrom object
 *
 * This method is copied from https://github.com/pvorb/node-clone/blob/17eea36140d61d97a9954c53417d0e04a00525d9/clone.js
 *
 * Copyright © 2011-2014 Paul Vorbach and contributors.
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the “Software”), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
 * of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions: The above copyright notice and this permission
 * notice shall be included in all copies or substantial portions of the Software.
 */
util.cloneDeep = function cloneDeep(parent, depth, circular, prototype) {
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular === 'undefined')
    circular = true;

  if (typeof depth === 'undefined')
    depth = 20;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    if (typeof parent != 'object') {
      return parent;
    }

    if (Utils.isArray(parent)) {
      child = [];
    } else if (Utils.isRegExp(parent)) {
      child = new RegExp(parent.source, util.getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (Utils.isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      child = new Buffer(parent.length);
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype === 'undefined') child = Object.create(Object.getPrototypeOf(parent));
      else child = Object.create(prototype);
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var propDescriptor  = Object.getOwnPropertyDescriptor(parent,i);
      var hasGetter = ((propDescriptor !== undefined) && (propDescriptor.get !== undefined));

      if (hasGetter){
        Object.defineProperty(child,i,propDescriptor);
      } else {
        child[i] = _clone(parent[i], depth - 1);
      }
    }

    return child;
  }

  return _clone(parent, depth);
};

/**
 * Set objects given a path as a string list
 *
 * @protected
 * @method setPath
 * @param object {object} - Object to set the property on
 * @param path {array[string]} - Array path to the property
 * @param value {*} - value to set, ignoring null
 */
util.setPath = function (object, path, value) {
  var nextKey = null;
  if (value === null || path.length === 0) {
    return;
  }
  else if (path.length === 1) { // no more keys to make, so set the value
    object[path.shift()] = value;
  }
  else {
    nextKey = path.shift();
    if (!object.hasOwnProperty(nextKey)) {
      object[nextKey] = {};
    }
    util.setPath(object[nextKey], path, value);
  }
};

/**
 * Create a new object patterned after substitutionMap, where:
 * 1. Terminal string values in substitutionMap are used as keys
 * 2. To look up values in a key-value store, variables
 * 3. And parent keys are created as necessary to retain the structure of substitutionMap.
 *
 * @protected
 * @method substituteDeep
 * @param substitionMap {object} - an object whose terminal (non-subobject) values are strings
 * @param variables {object[string:value]} - usually process.env, a flat object used to transform
 *      terminal values in a copy of substititionMap.
 * @returns {object} - deep copy of substitutionMap with only those paths whose terminal values
 *      corresponded to a key in `variables`
 */
util.substituteDeep = function (substitutionMap, variables) {
  var result = {};

  function _substituteVars(map, vars, pathTo) {
    for (var prop in map) {
      var value = map[prop];
      if (typeof(value) === 'string') { // We found a leaf variable name
        if (vars[value]) { // if the vars provide a value set the value in the result map
          util.setPath(result, pathTo.concat(prop), vars[value]);
        }
      }
      else if (util.isObject(value)) { // work on the subtree, giving it a clone of the pathTo
        if('__name' in value && '__format' in value && vars[value.__name]) {
          var parsedValue = util.parseString(vars[value.__name], value.__format);
          util.setPath(result, pathTo.concat(prop), parsedValue);
        } else {
          _substituteVars(value, vars, pathTo.concat(prop));
        }
      }
      else {
        msg = "Illegal key type for substitution map at " + pathTo.join('.') + ': ' + typeof(value);
        throw Error(msg);
      }
    }
  }

  _substituteVars(substitutionMap, variables, []);
  return result;

};

/* Map environment variables into the configuration if a mapping file,
 * `custom-environment-variables.EXT` exists.
 *
 * @protected
 * @method getCustomEnvVars
 * @param CONFIG_DIR {string} - the passsed configuration directory
 * @param extNames {Array[string]} - acceptable configuration file extension names.
 * @returns {object} - mapped environment variables or {} if there are none
 */
util.getCustomEnvVars = function (CONFIG_DIR, extNames) {
  var result = {};
  extNames.forEach(function (extName) {
    var fullFilename = Path.join(CONFIG_DIR , 'custom-environment-variables' + '.' + extName);
    var configObj = util.parseFile(fullFilename);
    if (configObj) {
      var environmentSubstitutions = util.substituteDeep(configObj, Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"}));
      util.extendDeep(result, environmentSubstitutions);
    }
  });
  return result;
};

/**
 * Return true if two objects have equal contents.
 *
 * @protected
 * @method equalsDeep
 * @param object1 {object} The object to compare from
 * @param object2 {object} The object to compare with
 * @param depth {integer} An optional depth to prevent recursion.  Default: 20.
 * @return {boolean} True if both objects have equivalent contents
 */
util.equalsDeep = function(object1, object2, depth) {

  // Recursion detection
  var t = this;
  depth = (depth === null ? DEFAULT_CLONE_DEPTH : depth);
  if (depth < 0) {
    return {};
  }

  // Fast comparisons
  if (!object1 || !object2) {
    return false;
  }
  if (object1 === object2) {
    return true;
  }
  if (typeof(object1) != 'object' || typeof(object2) != 'object') {
    return false;
  }

  // They must have the same keys.  If their length isn't the same
  // then they're not equal.  If the keys aren't the same, the value
  // comparisons will fail.
  if (Object.keys(object1).length != Object.keys(object2).length) {
    return false;
  }

  // Compare the values
  for (var prop in object1) {

    // Call recursively if an object or array
    if (object1[prop] && typeof(object1[prop]) === 'object') {
      if (!util.equalsDeep(object1[prop], object2[prop], depth - 1)) {
        return false;
      }
    }
    else {
      if (object1[prop] !== object2[prop]) {
        return false;
      }
    }
  }

  // Test passed.
  return true;
};

/**
 * Returns an object containing all elements that differ between two objects.
 * <p>
 * This method was designed to be used to create the runtime.json file
 * contents, but can be used to get the diffs between any two Javascript objects.
 * </p>
 * <p>
 * It works best when object2 originated by deep copying object1, then
 * changes were made to object2, and you want an object that would give you
 * the changes made to object1 which resulted in object2.
 * </p>
 *
 * @protected
 * @method diffDeep
 * @param object1 {object} The base object to compare to
 * @param object2 {object} The object to compare with
 * @param depth {integer} An optional depth to prevent recursion.  Default: 20.
 * @return {object} A differential object, which if extended onto object1 would
 *                  result in object2.
 */
util.diffDeep = function(object1, object2, depth) {

  // Recursion detection
  var t = this, diff = {};
  depth = (depth === null ? DEFAULT_CLONE_DEPTH : depth);
  if (depth < 0) {
    return {};
  }

  // Process each element from object2, adding any element that's different
  // from object 1.
  for (var parm in object2) {
    var value1 = object1[parm];
    var value2 = object2[parm];
    if (value1 && value2 && util.isObject(value2)) {
      if (!(util.equalsDeep(value1, value2))) {
        diff[parm] = util.diffDeep(value1, value2, depth - 1);
      }
    }
    else if (Array.isArray(value1) && Array.isArray(value2)) {
      if(!util.equalsDeep(value1, value2)) {
        diff[parm] = value2;
      }
    }
    else if (value1 !== value2){
      diff[parm] = value2;
    }
  }

  // Return the diff object
  return diff;

};

/**
 * Extend an object, and any object it contains.
 *
 * This does not replace deep objects, but dives into them
 * replacing individual elements instead.
 *
 * @protected
 * @method extendDeep
 * @param mergeInto {object} The object to merge into
 * @param mergeFrom... {object...} - Any number of objects to merge from
 * @param depth {integer} An optional depth to prevent recursion.  Default: 20.
 * @return {object} The altered mergeInto object is returned
 */
util.extendDeep = function(mergeInto) {

  // Initialize
  var t = this;
  var vargs = Array.prototype.slice.call(arguments, 1);
  var depth = vargs.pop();
  if (typeof(depth) != 'number') {
    vargs.push(depth);
    depth = DEFAULT_CLONE_DEPTH;
  }

  // Recursion detection
  if (depth < 0) {
    return mergeInto;
  }

  // Cycle through each object to extend
  vargs.forEach(function(mergeFrom) {

    // Cycle through each element of the object to merge from
    for (var prop in mergeFrom) {

      // save original value in deferred elements
      var fromIsDeferredFunc = mergeFrom[prop] instanceof DeferredConfig;
      var isDeferredFunc = mergeInto[prop] instanceof DeferredConfig;

      if (fromIsDeferredFunc && mergeInto.hasOwnProperty(prop)) {
        mergeFrom[prop]._original = isDeferredFunc ? mergeInto[prop]._original : mergeInto[prop];
      }
      // Extend recursively if both elements are objects and target is not really a deferred function
      if (mergeFrom[prop] instanceof Date) {
        mergeInto[prop] = mergeFrom[prop];
      } if (mergeFrom[prop] instanceof RegExp) {
        mergeInto[prop] = mergeFrom[prop];
      } else if (util.isObject(mergeInto[prop]) && util.isObject(mergeFrom[prop]) && !isDeferredFunc) {
        util.extendDeep(mergeInto[prop], mergeFrom[prop], depth - 1);
      }

      // Copy recursively if the mergeFrom element is an object (or array or fn)
      else if (mergeFrom[prop] && typeof mergeFrom[prop] === 'object') {
        mergeInto[prop] = util.cloneDeep(mergeFrom[prop], depth -1);
      }

      // Copy property descriptor otherwise, preserving accessors
      else if (Object.getOwnPropertyDescriptor(Object(mergeFrom), prop)){
          Object.defineProperty(mergeInto, prop, Object.getOwnPropertyDescriptor(Object(mergeFrom), prop));
      } else {
          mergeInto[prop] = mergeFrom[prop];
      }
    }
  });

  // Chain
  return mergeInto;

};

/**
 * Strip YAML comments from the string
 *
 * The 2.0 yaml parser doesn't allow comment-only or blank lines.  Strip them.
 *
 * @protected
 * @method stripYamlComments
 * @param fileString {string} The string to strip comments from
 * @return {string} The string with comments stripped.
 */
util.stripYamlComments = function(fileStr) {
  // First replace removes comment-only lines
  // Second replace removes blank lines
  return fileStr.replace(/^\s*#.*/mg,'').replace(/^\s*[\n|\r]+/mg,'');
}

/**
 * Strip all Javascript type comments from the string.
 *
 * The string is usually a file loaded from the O/S, containing
 * newlines and javascript type comments.
 *
 * Thanks to James Padolsey, and all who contributed to this implementation.
 * http://james.padolsey.com/javascript/javascript-comment-removal-revisted/
 *
 * @protected
 * @method stripComments
 * @param fileString {string} The string to strip comments from
 * @param stringRegex {RegExp} Optional regular expression to match strings that
 *   make up the config file
 * @return {string} The string with comments stripped.
 */
util.stripComments = function(fileStr, stringRegex) {
  stringRegex = stringRegex || /(['"])(\\\1|.)+?\1/g;

  var uid = '_' + +new Date(),
      primitives = [],
      primIndex = 0;

  return (
    fileStr

    /* Remove strings */
    .replace(stringRegex, function(match){
      primitives[primIndex] = match;
      return (uid + '') + primIndex++;
    })

    /* Remove Regexes */
    .replace(/([^\/])(\/(?!\*|\/)(\\\/|.)+?\/[gim]{0,3})/g, function(match, $1, $2){
      primitives[primIndex] = $2;
      return $1 + (uid + '') + primIndex++;
    })

    /*
    - Remove single-line comments that contain would-be multi-line delimiters
        E.g. // Comment /* <--
    - Remove multi-line comments that contain would be single-line delimiters
        E.g. /* // <--
   */
    .replace(/\/\/.*?\/?\*.+?(?=\n|\r|$)|\/\*[\s\S]*?\/\/[\s\S]*?\*\//g, '')

    /*
    Remove single and multi-line comments,
    no consideration of inner-contents
   */
    .replace(/\/\/.+?(?=\n|\r|$)|\/\*[\s\S]+?\*\//g, '')

    /*
    Remove multi-line comments that have a replaced ending (string/regex)
    Greedy, so no inner strings/regexes will stop it.
   */
    .replace(RegExp('\\/\\*[\\s\\S]+' + uid + '\\d+', 'g'), '')

    /* Bring back strings & regexes */
    .replace(RegExp(uid + '(\\d+)', 'g'), function(match, n){
      return primitives[n];
    })
  );

};

/**
 * Is the specified argument a regular javascript object?
 *
 * The argument is an object if it's a JS object, but not an array.
 *
 * @protected
 * @method isObject
 * @param arg {*} An argument of any type.
 * @return {boolean} TRUE if the arg is an object, FALSE if not
 */
util.isObject = function(obj) {
  return (obj !== null) && (typeof obj === 'object') && !(Array.isArray(obj));
};

/**
 * <p>Initialize a parameter from the command line or process environment</p>
 *
 * <p>
 * This method looks for the parameter from the command line in the format
 * --PARAMETER=VALUE, then from the process environment, then from the
 * default specified as an argument.
 * </p>
 *
 * @method initParam
 * @param paramName {String} Name of the parameter
 * @param [defaultValue] {Any} Default value of the parameter
 * @return {Any} The found value, or default value
 */
util.initParam = function (paramName, defaultValue) {
  var t = this;

  // Record and return the value
  var value = util.getCmdLineArg(paramName) || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"})[paramName] || defaultValue;
  env[paramName] = value;
  return value;
}

/**
 * <p>Get Command Line Arguments</p>
 *
 * <p>
 * This method allows you to retrieve the value of the specified command line argument.
 * </p>
 *
 * <p>
 * The argument is case sensitive, and must be of the form '--ARG_NAME=value'
 * </p>
 *
 * @method getCmdLineArg
 * @param searchFor {String} The argument name to search for
 * @return {*} false if the argument was not found, the argument value if found
 */
util.getCmdLineArg = function (searchFor) {
    var cmdLineArgs = process.argv.slice(2, process.argv.length),
        argName = '--' + searchFor + '=';

    for (var argvIt = 0; argvIt < cmdLineArgs.length; argvIt++) {
      if (cmdLineArgs[argvIt].indexOf(argName) === 0) {
        return cmdLineArgs[argvIt].substr(argName.length);
      }
    }

    return false;
}

/**
 * <p>Get a Config Environment Variable Value</p>
 *
 * <p>
 * This method returns the value of the specified config environment variable,
 * including any defaults or overrides.
 * </p>
 *
 * @method getEnv
 * @param varName {String} The environment variable name
 * @return {String} The value of the environment variable
 */
util.getEnv = function (varName) {
  return env[varName];
}



/**
 * Returns a string of flags for regular expression `re`.
 *
 * @param {RegExp} re Regular expression
 * @returns {string} Flags
 */
util.getRegExpFlags = function (re) {
  var flags = '';
  re.global && (flags += 'g');
  re.ignoreCase && (flags += 'i');
  re.multiline && (flags += 'm');
  return flags;
};

/**
 * Returns a new deep copy of the current config object, or any part of the config if provided.
 *
 * @param {Object} config The part of the config to copy and serialize. Omit this argument to return the entire config.
 * @returns {Object} The cloned config or part of the config
 */
util.toObject = function(config) {
  return JSON.parse(JSON.stringify(config || this));
};

// Run strictness checks on NODE_ENV and NODE_APP_INSTANCE and throw an error if there's a problem.
util.runStrictnessChecks = function (config) {
  var sources = config.util.getConfigSources();

  var sourceFilenames = sources.map(function (src) {
    return Path.basename(src.name);
  });


  // Throw an exception if there's no explicit config file for NODE_ENV
  var anyFilesMatchEnv = sourceFilenames.some(function (filename) {
      return filename.match(NODE_ENV);
  });
  // development is special-cased because it's the default value
  if (NODE_ENV && (NODE_ENV !== 'development') && !anyFilesMatchEnv) {
    _warnOrThrow("NODE_ENV value of '"+NODE_ENV+"' did not match any deployment config file names.");
  }

  // Throw an exception if there's no explict config file for NODE_APP_INSTANCE
  var anyFilesMatchInstance = sourceFilenames.some(function (filename) {
      return filename.match(APP_INSTANCE);
  });
  if (APP_INSTANCE && !anyFilesMatchInstance) {
    _warnOrThrow("NODE_APP_INSTANCE value of '"+APP_INSTANCE+"' did not match any instance config file names.");
  }

  // Throw if NODE_ENV matches' default' or 'local'
  if ((NODE_ENV === 'default') || (NODE_ENV === 'local')) {
    _warnOrThrow("NODE_ENV value of '"+NODE_ENV+"' is ambiguous.");
  }

  function _warnOrThrow (msg) {
    var beStrict = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"}).NODE_CONFIG_STRICT_MODE;
    var prefix = beStrict ? 'FATAL: ' : 'WARNING: ';
    var seeURL = 'See https://github.com/lorenwest/node-config/wiki/Strict-Mode';

    console.error(prefix+msg);
    console.error(prefix+seeURL);

    // Accept 1 and true as truthy values. When set via process.env, Node.js casts them to strings.
    if (["true", "1"].indexOf(beStrict) >= 0) {
      throw new Error(prefix+msg+' '+seeURL);
    }
  }
}

// Process pre-1.0 utility names
var utilWarnings = {};
['watch', 'setModuleDefaults', 'makeHidden', 'makeImmutable', 'getConfigSources', '_loadFileConfigs',
 '_parseFile', '_attachProtoDeep', '_cloneDeep', '_equalsDeep', '_diffDeep', '_extendDeep', '_stripYamlComments',
 '_stripComments', '_isObject', '_initParam', '_getCmdLineArg'].forEach(function(oldName) {

  // Config.util names don't have underscores
  var newName = oldName;
  if (oldName.indexOf('_') === 0) {
    newName = oldName.substr(1);
  }

  // Build the wrapper with warning
  Config.prototype[oldName] = function(){

    // Produce the warning
    if (!utilWarnings[oldName]) {
      console.error('WARNING: config.' + oldName + '() is deprecated.  Use config.util.' + newName + '() instead.');
      console.error('WARNING: See https://github.com/lorenwest/node-config/wiki/Future-Compatibility#upcoming-incompatibilities');
      utilWarnings[oldName] = true;
    }

    // Forward the call
    return util[newName].apply(this, arguments);
  }
});



// Instantiate and export the configuration
var config = module.exports = new Config();

// Produce warnings if the configuration is empty
var showWarnings = !(util.initParam('SUPPRESS_NO_CONFIG_WARNING'));
if (showWarnings && Object.keys(config).length === 0) {
  console.error('WARNING: No configurations found in configuration directory:' +CONFIG_DIR);
  console.error('WARNING: To disable this warning set SUPPRESS_NO_CONFIG_WARNING in the environment.');
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(330).Buffer))

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// Create a deferredConfig prototype so that we can check for it when reviewing the configs later.
function DeferredConfig () {
}
DeferredConfig.prototype.resolve = function (config, original) {};

// Accept a function that we'll use to resolve this value later and return a 'deferred' configuration value to resolve it later.
function deferConfig (func) {
  var obj = Object.create(DeferredConfig.prototype);
  obj.resolve = func;
  return obj;
}

module.exports.deferConfig = deferConfig;
module.exports.DeferredConfig = DeferredConfig;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(342);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);
var settle = __webpack_require__(345);
var buildURL = __webpack_require__(347);
var parseHeaders = __webpack_require__(348);
var isURLSameOrigin = __webpack_require__(349);
var createError = __webpack_require__(141);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(350);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(351);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(346);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return authSetMelcoAccountData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authRemoveMelcoAccountData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authChangeCurrentUser; });
/* unused harmony export authLogoutOnServerSuccess */
/* unused harmony export authLogoutOnServerFail */
/* unused harmony export authLogoutOnServerStart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authLogoutOnServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_1346lrf7vr=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\auth.js',hash='336eed42c9573a90874b81e1062d754d72f8ea8f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\auth.js',statementMap:{'0':{start:{line:5,column:39},end:{line:12,column:1}},'1':{start:{line:6,column:4},end:{line:6,column:41}},'2':{start:{line:7,column:4},end:{line:7,column:45}},'3':{start:{line:9,column:4},end:{line:11,column:6}},'4':{start:{line:14,column:42},end:{line:21,column:1}},'5':{start:{line:15,column:4},end:{line:15,column:37}},'6':{start:{line:16,column:4},end:{line:16,column:39}},'7':{start:{line:18,column:4},end:{line:20,column:6}},'8':{start:{line:23,column:37},end:{line:36,column:1}},'9':{start:{line:25,column:4},end:{line:35,column:6}},'10':{start:{line:38,column:41},end:{line:42,column:1}},'11':{start:{line:39,column:4},end:{line:41,column:6}},'12':{start:{line:44,column:38},end:{line:49,column:1}},'13':{start:{line:45,column:4},end:{line:48,column:6}},'14':{start:{line:51,column:39},end:{line:55,column:1}},'15':{start:{line:52,column:4},end:{line:54,column:6}},'16':{start:{line:57,column:34},end:{line:71,column:1}},'17':{start:{line:58,column:4},end:{line:70,column:6}},'18':{start:{line:59,column:8},end:{line:59,column:44}},'19':{start:{line:60,column:8},end:{line:69,column:16}},'20':{start:{line:62,column:16},end:{line:62,column:57}},'21':{start:{line:63,column:16},end:{line:63,column:58}},'22':{start:{line:65,column:16},end:{line:65,column:137}},'23':{start:{line:68,column:16},end:{line:68,column:60}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:39},end:{line:5,column:40}},loc:{start:{line:5,column:82},end:{line:12,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:42},end:{line:14,column:43}},loc:{start:{line:14,column:48},end:{line:21,column:1}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:23,column:37},end:{line:23,column:38}},loc:{start:{line:23,column:132},end:{line:36,column:1}},line:23},'3':{name:'(anonymous_3)',decl:{start:{line:38,column:41},end:{line:38,column:42}},loc:{start:{line:38,column:47},end:{line:42,column:1}},line:38},'4':{name:'(anonymous_4)',decl:{start:{line:44,column:38},end:{line:44,column:39}},loc:{start:{line:44,column:51},end:{line:49,column:1}},line:44},'5':{name:'(anonymous_5)',decl:{start:{line:51,column:39},end:{line:51,column:40}},loc:{start:{line:51,column:45},end:{line:55,column:1}},line:51},'6':{name:'(anonymous_6)',decl:{start:{line:57,column:34},end:{line:57,column:35}},loc:{start:{line:57,column:42},end:{line:71,column:1}},line:57},'7':{name:'(anonymous_7)',decl:{start:{line:58,column:11},end:{line:58,column:12}},loc:{start:{line:58,column:23},end:{line:70,column:5}},line:58},'8':{name:'(anonymous_8)',decl:{start:{line:61,column:19},end:{line:61,column:20}},loc:{start:{line:61,column:31},end:{line:66,column:13}},line:61},'9':{name:'(anonymous_9)',decl:{start:{line:67,column:20},end:{line:67,column:21}},loc:{start:{line:67,column:29},end:{line:69,column:13}},line:67}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ----------------- Auth ------------------ */cov_1346lrf7vr.s[0]++;var authSetMelcoAccountData=function authSetMelcoAccountData(token,user_id,first_name,last_name){cov_1346lrf7vr.f[0]++;cov_1346lrf7vr.s[1]++;localStorage.setItem('token',token);cov_1346lrf7vr.s[2]++;localStorage.setItem('user_id',user_id);cov_1346lrf7vr.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* AUTH_SET_MELCO_ACCOUNT_DATA */]};};cov_1346lrf7vr.s[4]++;var authRemoveMelcoAccountData=function authRemoveMelcoAccountData(){cov_1346lrf7vr.f[1]++;cov_1346lrf7vr.s[5]++;localStorage.removeItem('token');cov_1346lrf7vr.s[6]++;localStorage.removeItem('user_id');cov_1346lrf7vr.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* AUTH_REMOVE_MELCO_ACCOUNT_DATA */]};};cov_1346lrf7vr.s[8]++;var authChangeCurrentUser=function authChangeCurrentUser(token,user_id,first_name,last_name,account_name,parent_user_id,impersonation_for_id){cov_1346lrf7vr.f[2]++;cov_1346lrf7vr.s[9]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["d" /* AUTH_CHANGE_CURRENT_USER */],token:token,user_id:user_id,warning:false,first_name:first_name,last_name:last_name,account_name:account_name,parent_user_id:parent_user_id,impersonation_for_id:impersonation_for_id};};cov_1346lrf7vr.s[10]++;var authLogoutOnServerSuccess=function authLogoutOnServerSuccess(){cov_1346lrf7vr.f[3]++;cov_1346lrf7vr.s[11]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* AUTH_LOGOUT_ON_SERVER_SUCCESS */]};};cov_1346lrf7vr.s[12]++;var authLogoutOnServerFail=function authLogoutOnServerFail(error){cov_1346lrf7vr.f[4]++;cov_1346lrf7vr.s[13]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["e" /* AUTH_LOGOUT_ON_SERVER_FAIL */],error:error};};cov_1346lrf7vr.s[14]++;var authLogoutOnServerStart=function authLogoutOnServerStart(){cov_1346lrf7vr.f[5]++;cov_1346lrf7vr.s[15]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* AUTH_LOGOUT_ON_SERVER_START */]};};cov_1346lrf7vr.s[16]++;var authLogoutOnServer=function authLogoutOnServer(id){cov_1346lrf7vr.f[6]++;cov_1346lrf7vr.s[17]++;return function(dispatch){cov_1346lrf7vr.f[7]++;cov_1346lrf7vr.s[18]++;dispatch(authLogoutOnServerStart());cov_1346lrf7vr.s[19]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].delete('/auth/melco/logoff').then(function(response){cov_1346lrf7vr.f[8]++;cov_1346lrf7vr.s[20]++;dispatch(authLogoutOnServerSuccess());cov_1346lrf7vr.s[21]++;dispatch(authRemoveMelcoAccountData());cov_1346lrf7vr.s[22]++;window.location.href="https://test-account.melcocloud.com/"+'?logout-success&redirectTo='+"https://test-calculator.melcocloud.com/";}).catch(function(error){cov_1346lrf7vr.f[9]++;cov_1346lrf7vr.s[23]++;dispatch(authLogoutOnServerFail(error));});};};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export translationLoadStart */
/* unused harmony export translationLoadSuccess */
/* unused harmony export translationLoadFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return translationLoad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_min_moment_with_locales__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_min_moment_with_locales___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_min_moment_with_locales__);
var cov_o4hjlczc6=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\translationLoad.js',hash='2130bf2dc61aae52ba68327fe49b68bfd96478f1',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\translationLoad.js',statementMap:{'0':{start:{line:7,column:36},end:{line:11,column:1}},'1':{start:{line:8,column:4},end:{line:10,column:6}},'2':{start:{line:13,column:38},end:{line:17,column:1}},'3':{start:{line:14,column:4},end:{line:16,column:6}},'4':{start:{line:19,column:35},end:{line:23,column:1}},'5':{start:{line:20,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:27},end:{line:25,column:41}},'7':{start:{line:26,column:26},end:{line:26,column:30}},'8':{start:{line:28,column:25},end:{line:30,column:1}},'9':{start:{line:29,column:1},end:{line:29,column:58}},'10':{start:{line:32,column:40},end:{line:39,column:1}},'11':{start:{line:33,column:21},end:{line:33,column:65}},'12':{start:{line:34,column:4},end:{line:36,column:5}},'13':{start:{line:34,column:39},end:{line:34,column:84}},'14':{start:{line:35,column:8},end:{line:35,column:52}},'15':{start:{line:38,column:4},end:{line:38,column:29}},'16':{start:{line:41,column:35},end:{line:47,column:1}},'17':{start:{line:42,column:16},end:{line:42,column:45}},'18':{start:{line:43,column:4},end:{line:45,column:5}},'19':{start:{line:43,column:39},end:{line:43,column:51}},'20':{start:{line:44,column:8},end:{line:44,column:20}},'21':{start:{line:46,column:4},end:{line:46,column:17}},'22':{start:{line:49,column:60},end:{line:56,column:1}},'23':{start:{line:50,column:16},end:{line:50,column:45}},'24':{start:{line:51,column:4},end:{line:53,column:5}},'25':{start:{line:52,column:8},end:{line:52,column:18}},'26':{start:{line:55,column:4},end:{line:55,column:45}},'27':{start:{line:58,column:31},end:{line:75,column:1}},'28':{start:{line:59,column:4},end:{line:74,column:6}},'29':{start:{line:60,column:8},end:{line:60,column:41}},'30':{start:{line:61,column:8},end:{line:73,column:9}},'31':{start:{line:62,column:22},end:{line:62,column:55}},'32':{start:{line:63,column:12},end:{line:65,column:13}},'33':{start:{line:64,column:16},end:{line:64,column:91}},'34':{start:{line:66,column:34},end:{line:66,column:61}},'35':{start:{line:67,column:12},end:{line:67,column:73}},'36':{start:{line:68,column:12},end:{line:68,column:46}},'37':{start:{line:69,column:12},end:{line:69,column:31}},'38':{start:{line:70,column:12},end:{line:70,column:49}},'39':{start:{line:72,column:12},end:{line:72,column:62}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:36},end:{line:7,column:37}},loc:{start:{line:7,column:42},end:{line:11,column:1}},line:7},'1':{name:'(anonymous_1)',decl:{start:{line:13,column:38},end:{line:13,column:39}},loc:{start:{line:13,column:44},end:{line:17,column:1}},line:13},'2':{name:'(anonymous_2)',decl:{start:{line:19,column:35},end:{line:19,column:36}},loc:{start:{line:19,column:41},end:{line:23,column:1}},line:19},'3':{name:'(anonymous_3)',decl:{start:{line:28,column:25},end:{line:28,column:26}},loc:{start:{line:28,column:34},end:{line:30,column:1}},line:28},'4':{name:'(anonymous_4)',decl:{start:{line:32,column:40},end:{line:32,column:41}},loc:{start:{line:32,column:46},end:{line:39,column:1}},line:32},'5':{name:'(anonymous_5)',decl:{start:{line:34,column:31},end:{line:34,column:32}},loc:{start:{line:34,column:39},end:{line:34,column:84}},line:34},'6':{name:'(anonymous_6)',decl:{start:{line:41,column:35},end:{line:41,column:36}},loc:{start:{line:41,column:56},end:{line:47,column:1}},line:41},'7':{name:'(anonymous_7)',decl:{start:{line:43,column:31},end:{line:43,column:32}},loc:{start:{line:43,column:39},end:{line:43,column:51}},line:43},'8':{name:'(anonymous_8)',decl:{start:{line:49,column:60},end:{line:49,column:61}},loc:{start:{line:49,column:81},end:{line:56,column:1}},line:49},'9':{name:'(anonymous_9)',decl:{start:{line:58,column:31},end:{line:58,column:32}},loc:{start:{line:58,column:52},end:{line:75,column:1}},line:58},'10':{name:'(anonymous_10)',decl:{start:{line:59,column:11},end:{line:59,column:12}},loc:{start:{line:59,column:31},end:{line:74,column:5}},line:59}},branchMap:{'0':{loc:{start:{line:33,column:21},end:{line:33,column:65}},type:'binary-expr',locations:[{start:{line:33,column:21},end:{line:33,column:39}},{start:{line:33,column:43},end:{line:33,column:65}}],line:33},'1':{loc:{start:{line:34,column:4},end:{line:36,column:5}},type:'if',locations:[{start:{line:34,column:4},end:{line:36,column:5}},{start:{line:34,column:4},end:{line:36,column:5}}],line:34},'2':{loc:{start:{line:43,column:4},end:{line:45,column:5}},type:'if',locations:[{start:{line:43,column:4},end:{line:45,column:5}},{start:{line:43,column:4},end:{line:45,column:5}}],line:43},'3':{loc:{start:{line:51,column:4},end:{line:53,column:5}},type:'if',locations:[{start:{line:51,column:4},end:{line:53,column:5}},{start:{line:51,column:4},end:{line:53,column:5}}],line:51},'4':{loc:{start:{line:63,column:12},end:{line:65,column:13}},type:'if',locations:[{start:{line:63,column:12},end:{line:65,column:13}},{start:{line:63,column:12},end:{line:65,column:13}}],line:63}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}cov_o4hjlczc6.s[0]++;var translationLoadStart=function translationLoadStart(){cov_o4hjlczc6.f[0]++;cov_o4hjlczc6.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_78" /* TRANSLATION_LOAD_START */]};};cov_o4hjlczc6.s[2]++;var translationLoadSuccess=function translationLoadSuccess(){cov_o4hjlczc6.f[1]++;cov_o4hjlczc6.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_79" /* TRANSLATION_LOAD_SUCCESS */]};};cov_o4hjlczc6.s[4]++;var translationLoadFail=function translationLoadFail(){cov_o4hjlczc6.f[2]++;cov_o4hjlczc6.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_2__actionTypes__["_77" /* TRANSLATION_LOAD_FAIL */]};};var localAxiosInstance=(cov_o4hjlczc6.s[6]++,__WEBPACK_IMPORTED_MODULE_3_axios___default.a.create());var FALLBACK_LANGUAGE=(cov_o4hjlczc6.s[7]++,"en");cov_o4hjlczc6.s[8]++;var getLocaleStrings=function getLocaleStrings(lng){cov_o4hjlczc6.f[3]++;cov_o4hjlczc6.s[9]++;return localAxiosInstance.get('/js/locale/'+lng+'.json');};cov_o4hjlczc6.s[10]++;var detectBrowserLanguageOrFallback=function detectBrowserLanguageOrFallback(){cov_o4hjlczc6.f[4]++;var userLang=(cov_o4hjlczc6.s[11]++,(cov_o4hjlczc6.b[0][0]++,navigator.language)||(cov_o4hjlczc6.b[0][1]++,navigator.userLanguage));cov_o4hjlczc6.s[12]++;if(__WEBPACK_IMPORTED_MODULE_4____["availableLanguages"].find(function(lang){cov_o4hjlczc6.f[5]++;cov_o4hjlczc6.s[13]++;return lang===userLang.split("-")[0].toLowerCase();})){cov_o4hjlczc6.b[1][0]++;cov_o4hjlczc6.s[14]++;return userLang.split("-")[0].toLowerCase();}else{cov_o4hjlczc6.b[1][1]++;}cov_o4hjlczc6.s[15]++;return FALLBACK_LANGUAGE;};cov_o4hjlczc6.s[16]++;var isDefaultLanguageAvailable=function isDefaultLanguageAvailable(defaultLanguage){cov_o4hjlczc6.f[6]++;var lng=(cov_o4hjlczc6.s[17]++,defaultLanguage.split("-")[0]);//Default language can be in format of de-DE, we only use the first two characters
cov_o4hjlczc6.s[18]++;if(__WEBPACK_IMPORTED_MODULE_4____["availableLanguages"].find(function(lang){cov_o4hjlczc6.f[7]++;cov_o4hjlczc6.s[19]++;return lang===lng;})){cov_o4hjlczc6.b[2][0]++;cov_o4hjlczc6.s[20]++;return true;}else{cov_o4hjlczc6.b[2][1]++;}cov_o4hjlczc6.s[21]++;return false;};cov_o4hjlczc6.s[22]++;var getApplicationLanguagefromDefaultLangaugeOrFallback=function getApplicationLanguagefromDefaultLangaugeOrFallback(defaultLanguage){cov_o4hjlczc6.f[8]++;var lng=(cov_o4hjlczc6.s[23]++,defaultLanguage.split("-")[0]);//Default language can be in format of de-DE, we only use the first two characters
cov_o4hjlczc6.s[24]++;if(isDefaultLanguageAvailable(lng)){cov_o4hjlczc6.b[3][0]++;cov_o4hjlczc6.s[25]++;return lng;}else{cov_o4hjlczc6.b[3][1]++;}cov_o4hjlczc6.s[26]++;return detectBrowserLanguageOrFallback();};cov_o4hjlczc6.s[27]++;var translationLoad=function translationLoad(defaultLanguage){cov_o4hjlczc6.f[9]++;cov_o4hjlczc6.s[28]++;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var lng,localeStrings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cov_o4hjlczc6.f[10]++;cov_o4hjlczc6.s[29]++;dispatch(translationLoadStart());cov_o4hjlczc6.s[30]++;_context.prev=4;lng=(cov_o4hjlczc6.s[31]++,detectBrowserLanguageOrFallback());cov_o4hjlczc6.s[32]++;if(defaultLanguage){cov_o4hjlczc6.b[4][0]++;cov_o4hjlczc6.s[33]++;lng=getApplicationLanguagefromDefaultLangaugeOrFallback(defaultLanguage);}else{cov_o4hjlczc6.b[4][1]++;}cov_o4hjlczc6.s[34]++;_context.next=11;return getLocaleStrings(lng);case 11:localeStrings=_context.sent;cov_o4hjlczc6.s[35]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["b" /* addTranslationForLanguage */])(localeStrings.data,lng));cov_o4hjlczc6.s[36]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["g" /* setActiveLanguage */])(lng));cov_o4hjlczc6.s[37]++;__WEBPACK_IMPORTED_MODULE_5_moment_min_moment_with_locales__["locale"](lng);cov_o4hjlczc6.s[38]++;dispatch(translationLoadSuccess());_context.next=26;break;case 22:_context.prev=22;_context.t0=_context['catch'](4);cov_o4hjlczc6.s[39]++;dispatch(translationLoadFail(_context.t0.response));case 26:case'end':return _context.stop();}}},_callee,_this,[[4,22]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    //! moment.js locale configuration

    hooks.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$1 = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-dz', {
        months: months$1,
        monthsShort: months$1,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm$1 = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals$1 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$1 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$1(number),
                    str = plurals$1[u][pluralForm$1(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$2 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar-ly', {
        months: months$2,
        monthsShort: months$2,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$1('s'),
            ss: pluralize$1('s'),
            m: pluralize$1('m'),
            mm: pluralize$1('m'),
            h: pluralize$1('h'),
            hh: pluralize$1('h'),
            d: pluralize$1('d'),
            dd: pluralize$1('d'),
            M: pluralize$1('M'),
            MM: pluralize$1('M'),
            y: pluralize$1('y'),
            yy: pluralize$1('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$1 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    hooks.defineLocale('ar-ps', {
        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
            '_'
        ),
        monthsShort:
            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .split('') // reversed since negative lookbehind not supported everywhere
                .reverse()
                .join('')
                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
                    return numberMap[match];
                })
                .split('')
                .reverse()
                .join('')
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$1[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$2 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$1 = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    hooks.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$1[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$2[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$3 = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$2 = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm$2 = function (n) {
            return n === 0
                ? 0
                : n === 1
                  ? 1
                  : n === 2
                    ? 2
                    : n % 100 >= 3 && n % 100 <= 10
                      ? 3
                      : n % 100 >= 11
                        ? 4
                        : 5;
        },
        plurals$2 = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize$2 = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm$2(number),
                    str = plurals$2[u][pluralForm$2(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months$3 = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    hooks.defineLocale('ar', {
        months: months$3,
        monthsShort: months$3,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize$2('s'),
            ss: pluralize$2('s'),
            m: pluralize$2('m'),
            mm: pluralize$2('m'),
            h: pluralize$2('h'),
            hh: pluralize$2('h'),
            d: pluralize$2('d'),
            dd: pluralize$2('d'),
            M: pluralize$2('M'),
            MM: pluralize$2('M'),
            y: pluralize$2('y'),
            yy: pluralize$2('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$2[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$3[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    hooks.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    hooks.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$4 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$3 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$3[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$4[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$5 = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap$4 = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    hooks.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap$4[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$5[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$6 = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap$5 = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    hooks.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap$5[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$6[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex$1 =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    hooks.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex$1,
        monthsShortRegex: monthsRegex$1,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 'm':
                return withoutSuffix
                    ? 'jedna minuta'
                    : isFuture
                      ? 'jednu minutu'
                      : 'jedne minute';
        }
    }

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jedan sat';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: processRelativeTime,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$4 = {
            standalone:
                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                    '_'
                ),
            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                '_'
            ),
            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse$1 = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex$2 =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural$1(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate$1(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$1(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    hooks.defineLocale('cs', {
        months: months$4,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex$2,
        monthsShortRegex: monthsRegex$2,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse$1,
        longMonthsParse: monthsParse$1,
        shortMonthsParse: monthsParse$1,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate$1,
            ss: translate$1,
            m: translate$1,
            mm: translate$1,
            h: translate$1,
            hh: translate$1,
            d: translate$1,
            dd: translate$1,
            M: translate$1,
            MM: translate$1,
            y: translate$1,
            yy: translate$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                      ? 'тан'
                      : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$1,
            mm: '%d Minuten',
            h: processRelativeTime$1,
            hh: '%d Stunden',
            d: processRelativeTime$1,
            dd: processRelativeTime$1,
            w: processRelativeTime$1,
            ww: '%d Wochen',
            M: processRelativeTime$1,
            MM: processRelativeTime$1,
            y: processRelativeTime$1,
            yy: processRelativeTime$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$2,
            mm: '%d Minuten',
            h: processRelativeTime$2,
            hh: '%d Stunden',
            d: processRelativeTime$2,
            dd: processRelativeTime$2,
            w: processRelativeTime$2,
            ww: '%d Wochen',
            M: processRelativeTime$2,
            MM: processRelativeTime$2,
            y: processRelativeTime$2,
            yy: processRelativeTime$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime$3,
            mm: '%d Minuten',
            h: processRelativeTime$3,
            hh: '%d Stunden',
            d: processRelativeTime$3,
            dd: processRelativeTime$3,
            w: processRelativeTime$3,
            ww: '%d Wochen',
            M: processRelativeTime$3,
            MM: processRelativeTime$3,
            y: processRelativeTime$3,
            yy: processRelativeTime$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$5 = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    hooks.defineLocale('dv', {
        months: months$5,
        monthsShort: months$5,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function isFunction$1(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    hooks.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction$1(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$2 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$3 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$1[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex$3,
        monthsShortRegex: monthsRegex$3,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$2,
        longMonthsParse: monthsParse$2,
        shortMonthsParse: monthsParse$2,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$1 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$3 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$4 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$2[m.month()];
            } else {
                return monthsShortDot$1[m.month()];
            }
        },
        monthsRegex: monthsRegex$4,
        monthsShortRegex: monthsRegex$4,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$3,
        longMonthsParse: monthsParse$3,
        shortMonthsParse: monthsParse$3,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    var monthsShortDot$2 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$4 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$5 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$3[m.month()];
            } else {
                return monthsShortDot$2[m.month()];
            }
        },
        monthsRegex: monthsRegex$5,
        monthsShortRegex: monthsRegex$5,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$4,
        longMonthsParse: monthsParse$4,
        shortMonthsParse: monthsParse$4,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortDot$3 =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort$4 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse$5 = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex$6 =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    hooks.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot$3;
            } else if (/-MMM-/.test(format)) {
                return monthsShort$4[m.month()];
            } else {
                return monthsShortDot$3[m.month()];
            }
        },
        monthsRegex: monthsRegex$6,
        monthsShortRegex: monthsRegex$6,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse$5,
        longMonthsParse: monthsParse$5,
        shortMonthsParse: monthsParse$5,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    //! moment.js locale configuration

    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime$4,
            ss: processRelativeTime$4,
            m: processRelativeTime$4,
            mm: processRelativeTime$4,
            h: processRelativeTime$4,
            hh: processRelativeTime$4,
            d: processRelativeTime$4,
            dd: '%d päeva',
            M: processRelativeTime$4,
            MM: processRelativeTime$4,
            y: processRelativeTime$4,
            yy: processRelativeTime$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$7 = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap$6 = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    hooks.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap$6[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$7[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate$2(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    hooks.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate$2,
            ss: translate$2,
            m: translate$2,
            mm: translate$2,
            h: translate$2,
            hh: translate$2,
            d: translate$2,
            dd: translate$2,
            M: translate$2,
            MM: translate$2,
            y: translate$2,
            yy: translate$2,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsStrictRegex$1 =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex$1 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex$7 =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse$6 = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    hooks.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex$7,
        monthsShortRegex: monthsRegex$7,
        monthsStrictRegex: monthsStrictRegex$1,
        monthsShortStrictRegex: monthsShortStrictRegex$1,
        monthsParse: monthsParse$6,
        longMonthsParse: monthsParse$6,
        shortMonthsParse: monthsParse$6,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    hooks.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$6 = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort$5 = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays$1 = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    hooks.defineLocale('ga', {
        months: months$6,
        monthsShort: monthsShort$5,
        monthsParseExact: true,
        weekdays: weekdays$1,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$7 = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort$6 = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays$2 = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort$1 = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin$1 = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    hooks.defineLocale('gd', {
        months: months$7,
        monthsShort: monthsShort$6,
        monthsParseExact: true,
        weekdays: weekdays$2,
        weekdaysShort: weekdaysShort$1,
        weekdaysMin: weekdaysMin$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime$5,
            ss: processRelativeTime$5,
            m: processRelativeTime$5,
            mm: processRelativeTime$5,
            h: processRelativeTime$5,
            hh: processRelativeTime$5,
            d: processRelativeTime$5,
            dd: processRelativeTime$5,
            M: processRelativeTime$5,
            MM: processRelativeTime$5,
            y: processRelativeTime$5,
            yy: processRelativeTime$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    hooks.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime$6,
            ss: processRelativeTime$6,
            m: processRelativeTime$6,
            mm: processRelativeTime$6,
            h: processRelativeTime$6,
            hh: processRelativeTime$6,
            d: processRelativeTime$6,
            dd: processRelativeTime$6,
            M: processRelativeTime$6,
            MM: processRelativeTime$6,
            y: processRelativeTime$6,
            yy: processRelativeTime$6,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$8 = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap$7 = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    hooks.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap$7[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$8[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$9 = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$8 = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse$7 = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    hooks.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse$7,
        longMonthsParse: monthsParse$7,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$8[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$9[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function translate$3(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    hooks.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate$3,
            m: translate$3,
            mm: translate$3,
            h: translate$3,
            hh: translate$3,
            d: 'dan',
            dd: translate$3,
            M: 'mjesec',
            MM: translate$3,
            y: 'godinu',
            yy: translate$3,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate$4(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    hooks.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate$4,
            ss: translate$4,
            m: translate$4,
            mm: translate$4,
            h: translate$4,
            hh: translate$4,
            d: translate$4,
            dd: translate$4,
            M: translate$4,
            MM: translate$4,
            y: translate$4,
            yy: translate$4,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$2(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate$5(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural$2(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural$2(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural$2(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural$2(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    hooks.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate$5,
            ss: translate$5,
            m: translate$5,
            mm: translate$5,
            h: 'klukkustund',
            hh: translate$5,
            d: translate$5,
            dd: translate$5,
            M: translate$5,
            MM: translate$5,
            y: translate$5,
            yy: translate$5,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    //! moment.js locale configuration

    var suffixes$1 = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    hooks.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$a = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap$9 = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    hooks.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap$9[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$a[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$b = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap$a = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    hooks.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap$a[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$b[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$7(num, withoutSuffix, key, isFuture) {
        var format = {
            s: ['çend sanîye', 'çend sanîyeyan'],
            ss: [num + ' sanîye', num + ' sanîyeyan'],
            m: ['deqîqeyek', 'deqîqeyekê'],
            mm: [num + ' deqîqe', num + ' deqîqeyan'],
            h: ['saetek', 'saetekê'],
            hh: [num + ' saet', num + ' saetan'],
            d: ['rojek', 'rojekê'],
            dd: [num + ' roj', num + ' rojan'],
            w: ['hefteyek', 'hefteyekê'],
            ww: [num + ' hefte', num + ' hefteyan'],
            M: ['mehek', 'mehekê'],
            MM: [num + ' meh', num + ' mehan'],
            y: ['salek', 'salekê'],
            yy: [num + ' sal', num + ' salan'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    // function obliqueNumSuffix(num) {
    //     if(num.includes(':'))
    //         num = parseInt(num.split(':')[0]);
    //     else
    //         num = parseInt(num);
    //     return num == 0 || num % 10 == 1 ? 'ê'
    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
    // }
    function ezafeNumSuffix(num) {
        num = '' + num;
        var l = num.substring(num.length - 1),
            ll = num.length > 1 ? num.substring(num.length - 2) : '';
        if (
            !(ll == 12 || ll == 13) &&
            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
        )
            return 'yê';
        return 'ê';
    }

    hooks.defineLocale('ku-kmr', {
        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
        // But the names below are more well known and handy
        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
            '_'
        ),
        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
        monthsParseExact: true,
        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'bn' : 'BN';
            } else {
                return isLower ? 'pn' : 'PN';
            }
        },
        meridiemParse: /bn|BN|pn|PN/,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[a] YYYY[an]',
            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
            ll: 'Do MMM[.] YYYY[an]',
            lll: 'Do MMM[.] YYYY[an] HH:mm',
            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
        },
        calendar: {
            sameDay: '[Îro di saet] LT [de]',
            nextDay: '[Sibê di saet] LT [de]',
            nextWeek: 'dddd [di saet] LT [de]',
            lastDay: '[Duh di saet] LT [de]',
            lastWeek: 'dddd[a borî di saet] LT [de]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'di %s de',
            past: 'berî %s',
            s: processRelativeTime$7,
            ss: processRelativeTime$7,
            m: processRelativeTime$7,
            mm: processRelativeTime$7,
            h: processRelativeTime$7,
            hh: processRelativeTime$7,
            d: processRelativeTime$7,
            dd: processRelativeTime$7,
            w: processRelativeTime$7,
            ww: processRelativeTime$7,
            M: processRelativeTime$7,
            MM: processRelativeTime$7,
            y: processRelativeTime$7,
            yy: processRelativeTime$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
        ordinal: function (num, period) {
            var p = period.toLowerCase();
            if (p.includes('w') || p.includes('m')) return num + '.';

            return num + ezafeNumSuffix(num);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$c = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap$b = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months$8 = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    hooks.defineLocale('ku', {
        months: months$8,
        monthsShort: months$8,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap$b[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap$c[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$2 = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    hooks.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$8(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    hooks.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime$8,
            mm: '%d Minutten',
            h: processRelativeTime$8,
            hh: '%d Stonnen',
            d: processRelativeTime$8,
            dd: '%d Deeg',
            M: processRelativeTime$8,
            MM: '%d Méint',
            y: processRelativeTime$8,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
              ? forms(key)[1]
              : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate$6(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    hooks.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate$6,
            m: translateSingular,
            mm: translate$6,
            h: translateSingular,
            hh: translate$6,
            d: translateSingular,
            dd: translate$6,
            M: translateSingular,
            MM: translate$6,
            y: translateSingular,
            yy: translate$6,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var units$1 = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format$1(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
        return number + ' ' + format$1(units$1[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format$1(units$1[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    hooks.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural$1,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural$1,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural$1,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural$1,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural$1,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural$1,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                  ? wordKey[1]
                  : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    hooks.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    //! moment.js locale configuration

    function translate$7(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    hooks.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate$7,
            ss: translate$7,
            m: translate$7,
            mm: translate$7,
            h: translate$7,
            hh: translate$7,
            d: translate$7,
            dd: translate$7,
            M: translate$7,
            MM: translate$7,
            y: translate$7,
            yy: translate$7,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    //! moment.js locale configuration

    var symbolMap$d = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$c = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    hooks.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$c[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$d[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$e = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap$d = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    hooks.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap$d[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$e[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'én time',
            hh: '%d timer',
            d: 'én dag',
            dd: '%d dager',
            w: 'én uke',
            ww: '%d uker',
            M: 'én måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$f = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap$e = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    hooks.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap$e[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$f[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$1 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$1 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$8 = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$8 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$1;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$1[m.month()];
            } else {
                return monthsShortWithDots$1[m.month()];
            }
        },

        monthsRegex: monthsRegex$8,
        monthsShortRegex: monthsRegex$8,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$8,
        longMonthsParse: monthsParse$8,
        shortMonthsParse: monthsParse$8,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsShortWithDots$2 =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots$2 =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse$9 = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex$9 =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    hooks.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots$2;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots$2[m.month()];
            } else {
                return monthsShortWithDots$2[m.month()];
            }
        },

        monthsRegex: monthsRegex$9,
        monthsShortRegex: monthsRegex$9,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse$9,
        longMonthsParse: monthsParse$9,
        shortMonthsParse: monthsParse$9,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                      ? 'n'
                      : number === 3
                        ? 'r'
                        : number === 4
                          ? 't'
                          : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    //! moment.js locale configuration

    var symbolMap$g = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap$f = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    hooks.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap$f[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$g[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse$a = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural$3(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate$8(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural$3(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural$3(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural$3(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural$3(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural$3(number) ? 'lata' : 'lat');
        }
    }

    hooks.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse$a,
        longMonthsParse: monthsParse$a,
        shortMonthsParse: monthsParse$a,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate$8,
            m: translate$8,
            mm: translate$8,
            h: translate$8,
            hh: translate$8,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate$8,
            M: 'miesiąc',
            MM: translate$8,
            y: 'rok',
            yy: translate$8,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    //! moment.js locale configuration

    hooks.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    hooks.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural$2,
            m: 'un minut',
            mm: relativeTimeWithPlural$2,
            h: 'o oră',
            hh: relativeTimeWithPlural$2,
            d: 'o zi',
            dd: relativeTimeWithPlural$2,
            w: 'o săptămână',
            ww: relativeTimeWithPlural$2,
            M: 'o lună',
            MM: relativeTimeWithPlural$2,
            y: 'un an',
            yy: relativeTimeWithPlural$2,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$4(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural$4(format[key], +number);
        }
    }
    var monthsParse$b = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    hooks.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse$b,
        longMonthsParse: monthsParse$b,
        shortMonthsParse: monthsParse$b,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural$3,
            m: relativeTimeWithPlural$3,
            mm: relativeTimeWithPlural$3,
            h: 'час',
            hh: relativeTimeWithPlural$3,
            d: 'день',
            dd: relativeTimeWithPlural$3,
            w: 'неделя',
            ww: relativeTimeWithPlural$3,
            M: 'месяц',
            MM: relativeTimeWithPlural$3,
            y: 'год',
            yy: relativeTimeWithPlural$3,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$9 = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days$1 = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    hooks.defineLocale('sd', {
        months: months$9,
        monthsShort: months$9,
        weekdays: days$1,
        weekdaysShort: days$1,
        weekdaysMin: days$1,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    /*jshint -W100*/
    hooks.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    //! moment.js locale configuration

    var months$a =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort$7 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural$5(n) {
        return n > 1 && n < 5;
    }
    function translate$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural$5(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    hooks.defineLocale('sk', {
        months: months$a,
        monthsShort: monthsShort$7,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate$9,
            ss: translate$9,
            m: translate$9,
            mm: translate$9,
            h: translate$9,
            hh: translate$9,
            d: translate$9,
            dd: translate$9,
            M: translate$9,
            MM: translate$9,
            y: translate$9,
            yy: translate$9,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function processRelativeTime$9(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    hooks.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime$9,
            ss: processRelativeTime$9,
            m: processRelativeTime$9,
            mm: processRelativeTime$9,
            h: processRelativeTime$9,
            hh: processRelativeTime$9,
            d: processRelativeTime$9,
            dd: processRelativeTime$9,
            M: processRelativeTime$9,
            MM: processRelativeTime$9,
            y: processRelativeTime$9,
            yy: processRelativeTime$9,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$1 = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$1.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$1.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator$1.translate,
            m: translator$1.translate,
            mm: translator$1.translate,
            h: translator$1.translate,
            hh: translator$1.translate,
            d: translator$1.translate,
            dd: translator$1.translate,
            M: translator$1.translate,
            MM: translator$1.translate,
            y: translator$1.translate,
            yy: translator$1.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var translator$2 = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator$2.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator$2.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    hooks.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator$2.translate,
            m: translator$2.translate,
            mm: translator$2.translate,
            h: translator$2.translate,
            hh: translator$2.translate,
            d: translator$2.translate,
            dd: translator$2.translate,
            M: translator$2.translate,
            MM: translator$2.translate,
            y: translator$2.translate,
            yy: translator$2.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                          ? ':a'
                          : b === 2
                            ? ':a'
                            : b === 3
                              ? ':e'
                              : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var symbolMap$h = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap$g = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    hooks.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap$g[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap$h[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$3 = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    hooks.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    //! moment.js locale configuration

    var suffixes$4 = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    hooks.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'waQ'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'nem'
                    : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                  ? time.slice(0, -3) + 'wen'
                  : output.indexOf('DIS') !== -1
                    ? time.slice(0, -3) + 'ben'
                    : time + ' ret';
        return time;
    }

    function translate$a(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    hooks.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate$a,
            m: 'wa’ tup',
            mm: translate$a,
            h: 'wa’ rep',
            hh: translate$a,
            d: 'wa’ jaj',
            dd: translate$a,
            M: 'wa’ jar',
            MM: translate$a,
            y: 'wa’ DIS',
            yy: translate$a,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var suffixes$5 = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    hooks.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes$5[a] || suffixes$5[b] || suffixes$5[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    hooks.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime$a,
            ss: processRelativeTime$a,
            m: processRelativeTime$a,
            mm: processRelativeTime$a,
            h: processRelativeTime$a,
            hh: processRelativeTime$a,
            d: processRelativeTime$a,
            dd: processRelativeTime$a,
            M: processRelativeTime$a,
            MM: processRelativeTime$a,
            y: processRelativeTime$a,
            yy: processRelativeTime$a,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime$a(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
              ? format[key][0]
              : format[key][1];
    }

    //! moment.js locale configuration

    hooks.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    //! moment.js locale configuration

    function plural$6(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
              ? forms[1]
              : forms[2];
    }
    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural$6(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
              ? 'genitive'
              : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    hooks.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural$4,
            m: relativeTimeWithPlural$4,
            mm: relativeTimeWithPlural$4,
            h: 'годину',
            hh: relativeTimeWithPlural$4,
            d: 'день',
            dd: relativeTimeWithPlural$4,
            M: 'місяць',
            MM: relativeTimeWithPlural$4,
            y: 'рік',
            yy: relativeTimeWithPlural$4,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    var months$b = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days$2 = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    hooks.defineLocale('ur', {
        months: months$b,
        monthsShort: months$b,
        weekdays: days$2,
        weekdaysShort: days$2,
        weekdaysMin: days$2,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    //! moment.js locale configuration

    hooks.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    hooks.locale('en');

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147)(module)))

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(149);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(394);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(67);

var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(8);

var gopd = __webpack_require__(94);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(92);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ArraySpeciesCreate = __webpack_require__(401);
var FlattenIntoArray = __webpack_require__(411);
var Get = __webpack_require__(70);
var ToIntegerOrInfinity = __webpack_require__(166);
var ToLength = __webpack_require__(165);
var ToObject = __webpack_require__(436);

module.exports = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $abs = GetIntrinsic('%Math.abs%');
var $floor = GetIntrinsic('%Math.floor%');

var $isNaN = __webpack_require__(69);
var $isFinite = __webpack_require__(156);

module.exports = function isInteger(argument) {
	if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = $abs(argument);
	return $floor(absValue) === absValue;
};



/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(69);

module.exports = function (x) { return (typeof x === 'number' || typeof x === 'bigint') && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(33)('Object.prototype.toString');

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(95);

var $defineProperty = __webpack_require__(67);

var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray = hasArrayLengthDefineBug && __webpack_require__(157);

var callBound = __webpack_require__(33);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var isPropertyDescriptor = __webpack_require__(39);
var fromPropertyDescriptor = __webpack_require__(409);

// https://262.ecma-international.org/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined' && !isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
	}

	return fromPropertyDescriptor(Desc);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = __webpack_require__(37);

var $TypeError = __webpack_require__(8);

var Type = __webpack_require__(32);
var ToBoolean = __webpack_require__(410);
var IsCallable = __webpack_require__(161);

// https://262.ecma-international.org/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (hasOwn(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (hasOwn(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (hasOwn(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (hasOwn(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (hasOwn(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (hasOwn(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((hasOwn(desc, '[[Get]]') || hasOwn(desc, '[[Set]]')) && (hasOwn(desc, '[[Value]]') || hasOwn(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = __webpack_require__(162);


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.MAX_SAFE_INTEGER || 9007199254740991; // Math.pow(2, 53) - 1;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MAX_SAFE_INTEGER = __webpack_require__(163);

var ToIntegerOrInfinity = __webpack_require__(166);

module.exports = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(422);
var truncate = __webpack_require__(433);

var $isNaN = __webpack_require__(69);
var $isFinite = __webpack_require__(156);

// https://262.ecma-international.org/14.0/#sec-tointegerorinfinity

module.exports = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0) { return 0; }
	if (!$isFinite(number)) { return number; }
	return truncate(number);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(92);

/** @type {import('.')} */
module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(152)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(71);
var ToString = __webpack_require__(431);
var callBound = __webpack_require__(33);
var $replace = callBound('String.prototype.replace');

var mvsIsWS = (/^\s$/).test('\u180E');
/* eslint-disable no-control-regex */
var leftWhitespace = mvsIsWS
	? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/
	: /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = mvsIsWS
	? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/
	: /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

module.exports = function trim() {
	var S = ToString(RequireObjectCoercible(this));
	return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(169);

var zeroWidthSpace = '\u200b';
var mongolianVowelSeparator = '\u180E';

module.exports = function getPolyfill() {
	if (
		String.prototype.trim
		&& zeroWidthSpace.trim() === zeroWidthSpace
		&& mongolianVowelSeparator.trim() === mongolianVowelSeparator
		&& ('_' + mongolianVowelSeparator).trim() === ('_' + mongolianVowelSeparator)
		&& (mongolianVowelSeparator + '_').trim() === (mongolianVowelSeparator + '_')
	) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(154);

module.exports = function getPolyfill() {
	return Array.prototype.flat || implementation;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._getInterface = _getInterface;
exports._getTheme = get;
exports["default"] = void 0;
var styleInterface;
var styleTheme;
var START_MARK = 'react-with-styles.resolve.start';
var END_MARK = 'react-with-styles.resolve.end';
var MEASURE_MARK = "\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]";

function registerTheme(theme) {
  styleTheme = theme;
}

function registerInterface(interfaceToRegister) {
  styleInterface = interfaceToRegister;
}

function create(makeFromTheme, createWithDirection) {
  var styles = createWithDirection(makeFromTheme(styleTheme));
  return function () {
    return styles;
  };
}

function createLTR(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
}

function createRTL(makeFromTheme) {
  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
}

function get() {
  return styleTheme;
}

function resolve() {
  if (false) {
    performance.clearMarks(START_MARK);
    performance.mark(START_MARK);
  }

  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var result = styleInterface.resolve(styles);

  if (false) {
    performance.clearMarks(END_MARK);
    performance.mark(END_MARK);
    performance.measure(MEASURE_MARK, START_MARK, END_MARK);
    performance.clearMarks(MEASURE_MARK);
  }

  return result;
}

function resolveLTR() {
  for (var _len2 = arguments.length, styles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    styles[_key2] = arguments[_key2];
  }

  if (styleInterface.resolveLTR) {
    return styleInterface.resolveLTR(styles);
  }

  return resolve(styles);
}

function resolveRTL() {
  for (var _len3 = arguments.length, styles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    styles[_key3] = arguments[_key3];
  }

  if (styleInterface.resolveRTL) {
    return styleInterface.resolveRTL(styles);
  }

  return resolve(styles);
}

function flush() {
  if (styleInterface.flush) {
    styleInterface.flush();
  }
} // Exported until we deprecate this API completely
// eslint-disable-next-line no-underscore-dangle


function _getInterface() {
  return styleInterface;
} // Exported until we deprecate this API completely


var _default = {
  registerTheme: registerTheme,
  registerInterface: registerInterface,
  create: createLTR,
  createLTR: createLTR,
  createRTL: createRTL,
  get: get,
  resolve: resolveLTR,
  resolveLTR: resolveLTR,
  resolveRTL: resolveRTL,
  flush: flush
};
exports["default"] = _default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureCalendarDay = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _raf = _interopRequireDefault(__webpack_require__(481));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _getCalendarDaySettings = _interopRequireDefault(__webpack_require__(483));

var _ModifiersShape = _interopRequireDefault(__webpack_require__(73));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  day: _reactMomentProptypes["default"].momentObj,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isOutsideDay: _propTypes["default"].bool,
  modifiers: _ModifiersShape["default"],
  isFocused: _propTypes["default"].bool,
  tabIndex: _propTypes["default"].oneOf([0, -1]),
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  ariaLabelFormat: _propTypes["default"].string,
  // internationalization
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases))
})) : {};
var defaultProps = {
  day: (0, _moment["default"])(),
  daySize: _constants.DAY_SIZE,
  isOutsideDay: false,
  modifiers: new Set(),
  isFocused: false,
  tabIndex: -1,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  renderDayContents: null,
  ariaLabelFormat: 'dddd, LL',
  // internationalization
  phrases: _defaultPhrases.CalendarDayPhrases
};

var CalendarDay =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarDay, _ref);
  var _proto = CalendarDay.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarDay() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    _this.setButtonRef = _this.setButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var _this$props = this.props,
        isFocused = _this$props.isFocused,
        tabIndex = _this$props.tabIndex;

    if (tabIndex === 0) {
      if (isFocused || tabIndex !== prevProps.tabIndex) {
        (0, _raf["default"])(function () {
          if (_this2.buttonRef) {
            _this2.buttonRef.focus();
          }
        });
      }
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var onDayClick = this.props.onDayClick;
    onDayClick(day, e);
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day, e) {
    var onDayMouseEnter = this.props.onDayMouseEnter;
    onDayMouseEnter(day, e);
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day, e) {
    var onDayMouseLeave = this.props.onDayMouseLeave;
    onDayMouseLeave(day, e);
  };

  _proto.onKeyDown = function onKeyDown(day, e) {
    var onDayClick = this.props.onDayClick;
    var key = e.key;

    if (key === 'Enter' || key === ' ') {
      onDayClick(day, e);
    }
  };

  _proto.setButtonRef = function setButtonRef(ref) {
    this.buttonRef = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        day = _this$props2.day,
        ariaLabelFormat = _this$props2.ariaLabelFormat,
        daySize = _this$props2.daySize,
        isOutsideDay = _this$props2.isOutsideDay,
        modifiers = _this$props2.modifiers,
        renderDayContents = _this$props2.renderDayContents,
        tabIndex = _this$props2.tabIndex,
        styles = _this$props2.styles,
        phrases = _this$props2.phrases;
    if (!day) return _react["default"].createElement("td", null);

    var _getCalendarDaySettin = (0, _getCalendarDaySettings["default"])(day, ariaLabelFormat, daySize, modifiers, phrases),
        daySizeStyles = _getCalendarDaySettin.daySizeStyles,
        useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
        selected = _getCalendarDaySettin.selected,
        hoveredSpan = _getCalendarDaySettin.hoveredSpan,
        isOutsideRange = _getCalendarDaySettin.isOutsideRange,
        ariaLabel = _getCalendarDaySettin.ariaLabel;

    return _react["default"].createElement("td", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('hovered-start-first-possible-end') && styles.CalendarDay__hovered_start_first_possible_end, modifiers.has('hovered-start-blocked-minimum-nights') && styles.CalendarDay__hovered_start_blocked_min_nights, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('after-hovered-start') && styles.CalendarDay__after_hovered_start, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && !modifiers.has('selected-span') && styles.CalendarDay__selected, modifiers.has('before-hovered-end') && styles.CalendarDay__before_hovered_end, modifiers.has('no-selected-start-before-selected-end') && styles.CalendarDay__no_selected_start_before_selected_end, modifiers.has('selected-start-in-hovered-span') && styles.CalendarDay__selected_start_in_hovered_span, modifiers.has('selected-end-in-hovered-span') && styles.CalendarDay__selected_end_in_hovered_span, modifiers.has('selected-start-no-selected-end') && styles.CalendarDay__selected_start_no_selected_end, modifiers.has('selected-end-no-selected-start') && styles.CalendarDay__selected_end_no_selected_start, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
      role: "button" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
      ,
      ref: this.setButtonRef,
      "aria-disabled": modifiers.has('blocked'),
      "aria-label": ariaLabel,
      onMouseEnter: function onMouseEnter(e) {
        _this3.onDayMouseEnter(day, e);
      },
      onMouseLeave: function onMouseLeave(e) {
        _this3.onDayMouseLeave(day, e);
      },
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      },
      onClick: function onClick(e) {
        _this3.onDayClick(day, e);
      },
      onKeyDown: function onKeyDown(e) {
        _this3.onKeyDown(day, e);
      },
      tabIndex: tabIndex
    }), renderDayContents ? renderDayContents(day, modifiers) : day.format('D'));
  };

  return CalendarDay;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureCalendarDay = CalendarDay;
CalendarDay.propTypes =  false ? propTypes : {};
CalendarDay.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font;
  return {
    CalendarDay: {
      boxSizing: 'border-box',
      cursor: 'pointer',
      fontSize: font.size,
      textAlign: 'center',
      ':active': {
        outline: 0
      }
    },
    CalendarDay__defaultCursor: {
      cursor: 'default'
    },
    CalendarDay__default: {
      border: "1px solid ".concat(color.core.borderLight),
      color: color.text,
      background: color.background,
      ':hover': {
        background: color.core.borderLight,
        border: "1px solid ".concat(color.core.borderLight),
        color: 'inherit'
      }
    },
    CalendarDay__hovered_offset: {
      background: color.core.borderBright,
      border: "1px double ".concat(color.core.borderLight),
      color: 'inherit'
    },
    CalendarDay__outside: {
      border: 0,
      background: color.outside.backgroundColor,
      color: color.outside.color,
      ':hover': {
        border: 0
      }
    },
    CalendarDay__blocked_minimum_nights: {
      background: color.minimumNights.backgroundColor,
      border: "1px solid ".concat(color.minimumNights.borderColor),
      color: color.minimumNights.color,
      ':hover': {
        background: color.minimumNights.backgroundColor_hover,
        color: color.minimumNights.color_active
      },
      ':active': {
        background: color.minimumNights.backgroundColor_active,
        color: color.minimumNights.color_active
      }
    },
    CalendarDay__highlighted_calendar: {
      background: color.highlighted.backgroundColor,
      color: color.highlighted.color,
      ':hover': {
        background: color.highlighted.backgroundColor_hover,
        color: color.highlighted.color_active
      },
      ':active': {
        background: color.highlighted.backgroundColor_active,
        color: color.highlighted.color_active
      }
    },
    CalendarDay__selected_span: {
      background: color.selectedSpan.backgroundColor,
      border: "1px double ".concat(color.selectedSpan.borderColor),
      color: color.selectedSpan.color,
      ':hover': {
        background: color.selectedSpan.backgroundColor_hover,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      },
      ':active': {
        background: color.selectedSpan.backgroundColor_active,
        border: "1px double ".concat(color.selectedSpan.borderColor),
        color: color.selectedSpan.color_active
      }
    },
    CalendarDay__selected: {
      background: color.selected.backgroundColor,
      border: "1px double ".concat(color.selected.borderColor),
      color: color.selected.color,
      ':hover': {
        background: color.selected.backgroundColor_hover,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      },
      ':active': {
        background: color.selected.backgroundColor_active,
        border: "1px double ".concat(color.selected.borderColor),
        color: color.selected.color_active
      }
    },
    CalendarDay__hovered_span: {
      background: color.hoveredSpan.backgroundColor,
      border: "1px double ".concat(color.hoveredSpan.borderColor),
      color: color.hoveredSpan.color,
      ':hover': {
        background: color.hoveredSpan.backgroundColor_hover,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      },
      ':active': {
        background: color.hoveredSpan.backgroundColor_active,
        border: "1px double ".concat(color.hoveredSpan.borderColor),
        color: color.hoveredSpan.color_active
      }
    },
    CalendarDay__blocked_calendar: {
      background: color.blocked_calendar.backgroundColor,
      border: "1px solid ".concat(color.blocked_calendar.borderColor),
      color: color.blocked_calendar.color,
      ':hover': {
        background: color.blocked_calendar.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      },
      ':active': {
        background: color.blocked_calendar.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_calendar.borderColor),
        color: color.blocked_calendar.color_active
      }
    },
    CalendarDay__blocked_out_of_range: {
      background: color.blocked_out_of_range.backgroundColor,
      border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
      color: color.blocked_out_of_range.color,
      ':hover': {
        background: color.blocked_out_of_range.backgroundColor_hover,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      },
      ':active': {
        background: color.blocked_out_of_range.backgroundColor_active,
        border: "1px solid ".concat(color.blocked_out_of_range.borderColor),
        color: color.blocked_out_of_range.color_active
      }
    },
    CalendarDay__hovered_start_first_possible_end: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLighter)
    },
    CalendarDay__hovered_start_blocked_min_nights: {
      background: color.core.borderLighter,
      border: "1px double ".concat(color.core.borderLight)
    },
    CalendarDay__selected_start: {},
    CalendarDay__selected_end: {},
    CalendarDay__today: {},
    CalendarDay__firstDayOfWeek: {},
    CalendarDay__lastDayOfWeek: {},
    CalendarDay__after_hovered_start: {},
    CalendarDay__before_hovered_end: {},
    CalendarDay__no_selected_start_before_selected_end: {},
    CalendarDay__selected_start_in_hovered_span: {},
    CalendarDay__selected_end_in_hovered_span: {},
    CalendarDay__selected_start_no_selected_end: {},
    CalendarDay__selected_end_no_selected_start: {}
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarDay);

exports["default"] = _default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(174);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(100)["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getComponentName;

var _functionPrototype = _interopRequireDefault(__webpack_require__(461));

var _reactIs = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getComponentName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return Component.displayName || (0, _functionPrototype["default"])(Component);
  }

  if ((0, _reactIs.isForwardRef)({
    type: Component,
    $$typeof: _reactIs.Element
  })) {
    return Component.displayName;
  }

  if ((0, _reactIs.isMemo)(Component)) {
    return getComponentName(Component.type);
  }

  return null;
}
//# sourceMappingURL=getComponentName.js.map

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IsCallable = __webpack_require__(161);
var HasOwnProperty = __webpack_require__(462);
var functionsHaveNames = __webpack_require__(179)();
var callBound = __webpack_require__(33);
var $functionToString = callBound('Function.prototype.toString');
var $stringMatch = callBound('String.prototype.match');
var toStr = callBound('Object.prototype.toString');

var classRegex = /^class /;

var isClass = function isClassConstructor(fn) {
	if (IsCallable(fn)) {
		return false;
	}
	if (typeof fn !== 'function') {
		return false;
	}
	try {
		var match = $stringMatch($functionToString(fn), classRegex);
		return !!match;
	} catch (e) {}
	return false;
};

var regex = /\s*function\s+([^(\s]*)\s*/;

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var objectClass = '[object Object]';
var ddaClass = '[object HTMLAllCollection]';

var functionProto = Function.prototype;

var isDDA = function isDocumentDotAll() {
	return false;
};
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr(all) === toStr(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr(value);
					// IE 6-8 uses `objectClass`
					return (str === ddaClass || str === objectClass) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = function getName() {
	if (isDDA(this) || (!isClass(this) && !IsCallable(this))) {
		throw new TypeError('Function.prototype.name sham getter called on non-function');
	}
	if (functionsHaveNames && HasOwnProperty(this, 'name')) {
		return this.name;
	}
	if (this === functionProto) {
		return '';
	}
	var str = $functionToString(this);
	var match = $stringMatch(str, regex);
	var name = match && match[1];
	return name;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(178);

module.exports = function getPolyfill() {
	return implementation;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var objectKeys = __webpack_require__(148);
var hasSymbols = __webpack_require__(92)();
var callBound = __webpack_require__(33);
var toObject = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = toObject(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = toObject(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(181);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHANNEL = exports.CHANNEL = '__direction__';

var DIRECTIONS = exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(71);
var callBound = __webpack_require__(33);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $push = callBound('Array.prototype.push');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			$push(vals, obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(184);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(186);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _CalendarWeek = _interopRequireDefault(__webpack_require__(488));

var _CalendarDay = _interopRequireDefault(__webpack_require__(173));

var _calculateDimension = _interopRequireDefault(__webpack_require__(189));

var _getCalendarMonthWeeks = _interopRequireDefault(__webpack_require__(489));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

var _toISODateString = _interopRequireDefault(__webpack_require__(57));

var _ModifiersShape = _interopRequireDefault(__webpack_require__(73));

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  month: _reactMomentProptypes["default"].momentObj,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  isVisible: _propTypes["default"].bool,
  enableOutsideDays: _propTypes["default"].bool,
  modifiers: _propTypes["default"].objectOf(_ModifiersShape["default"]),
  orientation: _ScrollableOrientationShape["default"],
  daySize: _airbnbPropTypes.nonNegativeInteger,
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  onMonthSelect: _propTypes["default"].func,
  onYearSelect: _propTypes["default"].func,
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes["default"].func,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes["default"].bool,
  // indicates whether or not to move focus to focusable day
  // i18n
  monthFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  month: (0, _moment["default"])(),
  horizontalMonthPadding: 13,
  isVisible: true,
  enableOutsideDays: false,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  daySize: _constants.DAY_SIZE,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthSelect: function onMonthSelect() {},
  onYearSelect: function onYearSelect() {},
  renderMonthText: null,
  renderCalendarDay: function renderCalendarDay(props) {
    return _react["default"].createElement(_CalendarDay["default"], props);
  },
  renderDayContents: null,
  renderMonthElement: null,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  focusedDate: null,
  isFocused: false,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: _defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined,
  verticalBorderSpacing: undefined
};

var CalendarMonth =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonth, _ref);
  var _proto = CalendarMonth.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonth(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      weeks: (0, _getCalendarMonthWeeks["default"])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : props.firstDayOfWeek)
    };
    _this.setCaptionRef = _this.setCaptionRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setMonthTitleHeight = _this.setMonthTitleHeight.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setMonthTitleHeightTimeout = setTimeout(this.setMonthTitleHeight, 0);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var month = nextProps.month,
        enableOutsideDays = nextProps.enableOutsideDays,
        firstDayOfWeek = nextProps.firstDayOfWeek;
    var _this$props = this.props,
        prevMonth = _this$props.month,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevFirstDayOfWeek = _this$props.firstDayOfWeek;

    if (!month.isSame(prevMonth) || enableOutsideDays !== prevEnableOutsideDays || firstDayOfWeek !== prevFirstDayOfWeek) {
      this.setState({
        weeks: (0, _getCalendarMonthWeeks["default"])(month, enableOutsideDays, firstDayOfWeek == null ? _moment["default"].localeData().firstDayOfWeek() : firstDayOfWeek)
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.setMonthTitleHeightTimeout) {
      clearTimeout(this.setMonthTitleHeightTimeout);
    }
  };

  _proto.setMonthTitleHeight = function setMonthTitleHeight() {
    var setMonthTitleHeight = this.props.setMonthTitleHeight;

    if (setMonthTitleHeight) {
      var captionHeight = (0, _calculateDimension["default"])(this.captionRef, 'height', true, true);
      setMonthTitleHeight(captionHeight);
    }
  };

  _proto.setCaptionRef = function setCaptionRef(ref) {
    this.captionRef = ref;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        dayAriaLabelFormat = _this$props2.dayAriaLabelFormat,
        daySize = _this$props2.daySize,
        focusedDate = _this$props2.focusedDate,
        horizontalMonthPadding = _this$props2.horizontalMonthPadding,
        isFocused = _this$props2.isFocused,
        isVisible = _this$props2.isVisible,
        modifiers = _this$props2.modifiers,
        month = _this$props2.month,
        monthFormat = _this$props2.monthFormat,
        onDayClick = _this$props2.onDayClick,
        onDayMouseEnter = _this$props2.onDayMouseEnter,
        onDayMouseLeave = _this$props2.onDayMouseLeave,
        onMonthSelect = _this$props2.onMonthSelect,
        onYearSelect = _this$props2.onYearSelect,
        orientation = _this$props2.orientation,
        phrases = _this$props2.phrases,
        renderCalendarDay = _this$props2.renderCalendarDay,
        renderDayContents = _this$props2.renderDayContents,
        renderMonthElement = _this$props2.renderMonthElement,
        renderMonthText = _this$props2.renderMonthText,
        styles = _this$props2.styles,
        verticalBorderSpacing = _this$props2.verticalBorderSpacing;
    var weeks = this.state.weeks;
    var monthTitle = renderMonthText ? renderMonthText(month) : month.format(monthFormat);
    var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.CalendarMonth, {
      padding: "0 ".concat(horizontalMonthPadding, "px")
    }), {
      "data-visible": isVisible
    }), _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setCaptionRef
    }, (0, _reactWithStyles.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)), renderMonthElement ? renderMonthElement({
      month: month,
      onMonthSelect: onMonthSelect,
      onYearSelect: onYearSelect,
      isVisible: isVisible
    }) : _react["default"].createElement("strong", null, monthTitle)), _react["default"].createElement("table", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && {
      borderSpacing: "0px ".concat(verticalBorderSpacing, "px")
    }), {
      role: "presentation"
    }), _react["default"].createElement("tbody", null, weeks.map(function (week, i) {
      return _react["default"].createElement(_CalendarWeek["default"], {
        key: i
      }, week.map(function (day, dayOfWeek) {
        return renderCalendarDay({
          key: dayOfWeek,
          day: day,
          daySize: daySize,
          isOutsideDay: !day || day.month() !== month.month(),
          tabIndex: isVisible && (0, _isSameDay["default"])(day, focusedDate) ? 0 : -1,
          isFocused: isFocused,
          onDayMouseEnter: onDayMouseEnter,
          onDayMouseLeave: onDayMouseLeave,
          onDayClick: onDayClick,
          renderDayContents: renderDayContents,
          phrases: phrases,
          modifiers: modifiers[(0, _toISODateString["default"])(day)],
          ariaLabelFormat: dayAriaLabelFormat
        });
      }));
    }))));
  };

  return CalendarMonth;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonth.propTypes =  false ? propTypes : {};
CalendarMonth.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      font = _ref2$reactDates.font,
      spacing = _ref2$reactDates.spacing;
  return {
    CalendarMonth: {
      background: color.background,
      textAlign: 'center',
      verticalAlign: 'top',
      userSelect: 'none'
    },
    CalendarMonth_table: {
      borderCollapse: 'collapse',
      borderSpacing: 0
    },
    CalendarMonth_verticalSpacing: {
      borderCollapse: 'separate'
    },
    CalendarMonth_caption: {
      color: color.text,
      fontSize: font.captionSize,
      textAlign: 'center',
      paddingTop: spacing.captionPaddingTop,
      paddingBottom: spacing.captionPaddingBottom,
      captionSide: 'initial'
    },
    CalendarMonth_caption__verticalScrollable: {
      paddingTop: 12,
      paddingBottom: 7
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonth);

exports["default"] = _default;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculateDimension;

function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom'; // Only read styles if we need to

  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null; // Offset includes border and padding

  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;
  var size = axis === 'width' ? offsetWidth : offsetHeight; // Get the inner size

  if (!borderBox) {
    size -= parseFloat(style["padding".concat(axisStart)]) + parseFloat(style["padding".concat(axisEnd)]) + parseFloat(style["border".concat(axisStart, "Width")]) + parseFloat(style["border".concat(axisEnd, "Width")]);
  } // Apply margin


  if (withMargin) {
    size += parseFloat(style["margin".concat(axisStart)]) + parseFloat(style["margin".concat(axisEnd)]);
  }

  return size;
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _consolidatedEvents = __webpack_require__(74);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _CalendarMonth = _interopRequireDefault(__webpack_require__(188));

var _isTransitionEndSupported = _interopRequireDefault(__webpack_require__(490));

var _getTransformStyles = _interopRequireDefault(__webpack_require__(491));

var _getCalendarMonthWidth = _interopRequireDefault(__webpack_require__(191));

var _toISOMonthString = _interopRequireDefault(__webpack_require__(75));

var _isPrevMonth = _interopRequireDefault(__webpack_require__(492));

var _isNextMonth = _interopRequireDefault(__webpack_require__(493));

var _ModifiersShape = _interopRequireDefault(__webpack_require__(73));

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  enableOutsideDays: _propTypes["default"].bool,
  firstVisibleMonthIndex: _propTypes["default"].number,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  initialMonth: _reactMomentProptypes["default"].momentObj,
  isAnimating: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  modifiers: _propTypes["default"].objectOf(_propTypes["default"].objectOf(_ModifiersShape["default"])),
  orientation: _ScrollableOrientationShape["default"],
  onDayClick: _propTypes["default"].func,
  onDayMouseEnter: _propTypes["default"].func,
  onDayMouseLeave: _propTypes["default"].func,
  onMonthTransitionEnd: _propTypes["default"].func,
  onMonthChange: _propTypes["default"].func,
  onYearChange: _propTypes["default"].func,
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  translationValue: _propTypes["default"].number,
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  daySize: _airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes["default"].momentObj,
  // indicates focusable day
  isFocused: _propTypes["default"].bool,
  // indicates whether or not to move focus to focusable day
  firstDayOfWeek: _DayOfWeekShape["default"],
  setMonthTitleHeight: _propTypes["default"].func,
  isRTL: _propTypes["default"].bool,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  // i18n
  monthFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.CalendarDayPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
})) : {};
var defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  horizontalMonthPadding: 13,
  initialMonth: (0, _moment["default"])(),
  isAnimating: false,
  numberOfMonths: 1,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  onDayClick: function onDayClick() {},
  onDayMouseEnter: function onDayMouseEnter() {},
  onDayMouseLeave: function onDayMouseLeave() {},
  onMonthChange: function onMonthChange() {},
  onYearChange: function onYearChange() {},
  onMonthTransitionEnd: function onMonthTransitionEnd() {},
  renderMonthText: null,
  renderCalendarDay: undefined,
  renderDayContents: null,
  translationValue: null,
  renderMonthElement: null,
  daySize: _constants.DAY_SIZE,
  focusedDate: null,
  isFocused: false,
  firstDayOfWeek: null,
  setMonthTitleHeight: null,
  isRTL: false,
  transitionDuration: 200,
  verticalBorderSpacing: undefined,
  // i18n
  monthFormat: 'MMMM YYYY',
  // english locale
  phrases: _defaultPhrases.CalendarDayPhrases,
  dayAriaLabelFormat: undefined
};

function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
  var months = [];

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
}

var CalendarMonthGrid =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(CalendarMonthGrid, _ref);
  var _proto = CalendarMonthGrid.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function CalendarMonthGrid(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
    _this.state = {
      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
    };
    _this.isTransitionEndSupported = (0, _isTransitionEndSupported["default"])();
    _this.onTransitionEnd = _this.onTransitionEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.locale = _moment["default"].locale();
    _this.onMonthSelect = _this.onMonthSelect.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearSelect = _this.onYearSelect.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var initialMonth = nextProps.initialMonth,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation;
    var months = this.state.months;
    var _this$props = this.props,
        prevInitialMonth = _this$props.initialMonth,
        prevNumberOfMonths = _this$props.numberOfMonths;
    var hasMonthChanged = !prevInitialMonth.isSame(initialMonth, 'month');
    var hasNumberOfMonthsChanged = prevNumberOfMonths !== numberOfMonths;
    var newMonths = months;

    if (hasMonthChanged && !hasNumberOfMonthsChanged) {
      if ((0, _isNextMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(1);
        newMonths.push(months[months.length - 1].clone().add(1, 'month'));
      } else if ((0, _isPrevMonth["default"])(prevInitialMonth, initialMonth)) {
        newMonths = months.slice(0, months.length - 1);
        newMonths.unshift(months[0].clone().subtract(1, 'month'));
      } else {
        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
      }
    }

    if (hasNumberOfMonthsChanged) {
      var _withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;

      newMonths = getMonths(initialMonth, numberOfMonths, _withoutTransitionMonths);
    }

    var momentLocale = _moment["default"].locale();

    if (this.locale !== momentLocale) {
      this.locale = momentLocale;
      newMonths = newMonths.map(function (m) {
        return m.locale(_this2.locale);
      });
    }

    this.setState({
      months: newMonths
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props2 = this.props,
        isAnimating = _this$props2.isAnimating,
        transitionDuration = _this$props2.transitionDuration,
        onMonthTransitionEnd = _this$props2.onMonthTransitionEnd; // For IE9, immediately call onMonthTransitionEnd instead of
    // waiting for the animation to complete. Similarly, if transitionDuration
    // is set to 0, also immediately invoke the onMonthTransitionEnd callback

    if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
      onMonthTransitionEnd();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeEventListener) this.removeEventListener();
  };

  _proto.onTransitionEnd = function onTransitionEnd() {
    var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
    onMonthTransitionEnd();
  };

  _proto.onMonthSelect = function onMonthSelect(currentMonth, newMonthVal) {
    var newMonth = currentMonth.clone();
    var _this$props3 = this.props,
        onMonthChange = _this$props3.onMonthChange,
        orientation = _this$props3.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('month', newMonthVal).subtract(initialMonthSubtraction, 'months');
    onMonthChange(newMonth);
  };

  _proto.onYearSelect = function onYearSelect(currentMonth, newYearVal) {
    var newMonth = currentMonth.clone();
    var _this$props4 = this.props,
        onYearChange = _this$props4.onYearChange,
        orientation = _this$props4.orientation;
    var months = this.state.months;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var initialMonthSubtraction = months.indexOf(currentMonth);

    if (!withoutTransitionMonths) {
      initialMonthSubtraction -= 1;
    }

    newMonth.set('year', newYearVal).subtract(initialMonthSubtraction, 'months');
    onYearChange(newMonth);
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props5 = this.props,
        enableOutsideDays = _this$props5.enableOutsideDays,
        firstVisibleMonthIndex = _this$props5.firstVisibleMonthIndex,
        horizontalMonthPadding = _this$props5.horizontalMonthPadding,
        isAnimating = _this$props5.isAnimating,
        modifiers = _this$props5.modifiers,
        numberOfMonths = _this$props5.numberOfMonths,
        monthFormat = _this$props5.monthFormat,
        orientation = _this$props5.orientation,
        translationValue = _this$props5.translationValue,
        daySize = _this$props5.daySize,
        onDayMouseEnter = _this$props5.onDayMouseEnter,
        onDayMouseLeave = _this$props5.onDayMouseLeave,
        onDayClick = _this$props5.onDayClick,
        renderMonthText = _this$props5.renderMonthText,
        renderCalendarDay = _this$props5.renderCalendarDay,
        renderDayContents = _this$props5.renderDayContents,
        renderMonthElement = _this$props5.renderMonthElement,
        onMonthTransitionEnd = _this$props5.onMonthTransitionEnd,
        firstDayOfWeek = _this$props5.firstDayOfWeek,
        focusedDate = _this$props5.focusedDate,
        isFocused = _this$props5.isFocused,
        isRTL = _this$props5.isRTL,
        styles = _this$props5.styles,
        phrases = _this$props5.phrases,
        dayAriaLabelFormat = _this$props5.dayAriaLabelFormat,
        transitionDuration = _this$props5.transitionDuration,
        verticalBorderSpacing = _this$props5.verticalBorderSpacing,
        setMonthTitleHeight = _this$props5.setMonthTitleHeight;
    var months = this.state.months;
    var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
    var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
    var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
    var calendarMonthWidth = (0, _getCalendarMonthWidth["default"])(daySize, horizontalMonthPadding);
    var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
    var transformType = isVertical || isVerticalScrollable ? 'translateY' : 'translateX';
    var transformValue = "".concat(transformType, "(").concat(translationValue, "px)");
    return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
      transition: "transform ".concat(transitionDuration, "ms ease-in-out")
    }, _objectSpread({}, (0, _getTransformStyles["default"])(transformValue), {
      width: width
    })), {
      ref: this.setContainerRef,
      onTransitionEnd: onMonthTransitionEnd
    }), months.map(function (month, i) {
      var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
      var hideForAnimation = i === 0 && !isVisible;
      var showForAnimation = i === 0 && isAnimating && isVisible;
      var monthString = (0, _toISOMonthString["default"])(month);
      return _react["default"].createElement("div", (0, _extends2["default"])({
        key: monthString
      }, (0, _reactWithStyles.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
        position: 'absolute',
        left: -calendarMonthWidth
      }, showForAnimation && !isVertical && isRTL && {
        position: 'absolute',
        right: 0
      }, showForAnimation && isVertical && {
        position: 'absolute',
        top: -translationValue
      }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)), _react["default"].createElement(_CalendarMonth["default"], {
        month: month,
        isVisible: isVisible,
        enableOutsideDays: enableOutsideDays,
        modifiers: modifiers[monthString],
        monthFormat: monthFormat,
        orientation: orientation,
        onDayMouseEnter: onDayMouseEnter,
        onDayMouseLeave: onDayMouseLeave,
        onDayClick: onDayClick,
        onMonthSelect: _this3.onMonthSelect,
        onYearSelect: _this3.onYearSelect,
        renderMonthText: renderMonthText,
        renderCalendarDay: renderCalendarDay,
        renderDayContents: renderDayContents,
        renderMonthElement: renderMonthElement,
        firstDayOfWeek: firstDayOfWeek,
        daySize: daySize,
        focusedDate: isVisible ? focusedDate : null,
        isFocused: isFocused,
        phrases: phrases,
        setMonthTitleHeight: setMonthTitleHeight,
        dayAriaLabelFormat: dayAriaLabelFormat,
        verticalBorderSpacing: verticalBorderSpacing,
        horizontalMonthPadding: horizontalMonthPadding
      }));
    }));
  };

  return CalendarMonthGrid;
}(_react["default"].PureComponent || _react["default"].Component);

CalendarMonthGrid.propTypes =  false ? propTypes : {};
CalendarMonthGrid.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      spacing = _ref2$reactDates.spacing,
      zIndex = _ref2$reactDates.zIndex;
  return {
    CalendarMonthGrid: {
      background: color.background,
      textAlign: (0, _noflip["default"])('left'),
      zIndex: zIndex
    },
    CalendarMonthGrid__animating: {
      zIndex: zIndex + 1
    },
    CalendarMonthGrid__horizontal: {
      position: 'absolute',
      left: (0, _noflip["default"])(spacing.dayPickerHorizontalPadding)
    },
    CalendarMonthGrid__vertical: {
      margin: '0 auto'
    },
    CalendarMonthGrid__vertical_scrollable: {
      margin: '0 auto'
    },
    CalendarMonthGrid_month__horizontal: {
      display: 'inline-block',
      verticalAlign: 'top',
      minHeight: '100%'
    },
    CalendarMonthGrid_month__hideForAnimation: {
      position: 'absolute',
      zIndex: zIndex - 1,
      opacity: 0,
      pointerEvents: 'none'
    },
    CalendarMonthGrid_month__hidden: {
      visibility: 'hidden'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(CalendarMonthGrid);

exports["default"] = _default;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;

function getCalendarMonthWidth(daySize) {
  var calendarMonthPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return 7 * daySize + 2 * calendarMonthPadding + 1;
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortalCompat__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PortalWithState__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_0__PortalCompat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PortalWithState", function() { return __WEBPACK_IMPORTED_MODULE_1__PortalWithState__["a"]; });





/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Portal__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__ = __webpack_require__(497);





var Portal = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.createPortal) {
  Portal = __WEBPACK_IMPORTED_MODULE_1__Portal__["a" /* default */];
} else {
  Portal = __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function contains(other) {
	if (arguments.length < 1) {
		throw new TypeError('1 argument is required');
	}
	if (typeof other !== 'object') {
		throw new TypeError('Argument 1 (”other“) to Node.contains must be an instance of Node');
	}

	var node = other;
	do {
		if (this === node) {
			return true;
		}
		if (node) {
			node = node.parentNode;
		}
	} while (node);

	return false;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(194);

module.exports = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			try {
				if (typeof document.body.contains.call(document, '') === 'boolean') {
					return document.body.contains;
				}
			} catch (e) { /**/ }
		}
	}
	return implementation;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _FocusedInputShape = _interopRequireDefault(__webpack_require__(197));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _OrientationShape = _interopRequireDefault(__webpack_require__(198));

var _DisabledShape = _interopRequireDefault(__webpack_require__(58));

var _AnchorDirectionShape = _interopRequireDefault(__webpack_require__(199));

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(59));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _default = {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes["default"].func.isRequired,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func,
  // input related props
  startDateId: _propTypes["default"].string.isRequired,
  startDatePlaceholderText: _propTypes["default"].string,
  startDateOffset: _propTypes["default"].func,
  endDateOffset: _propTypes["default"].func,
  endDateId: _propTypes["default"].string.isRequired,
  endDatePlaceholderText: _propTypes["default"].string,
  startDateAriaLabel: _propTypes["default"].string,
  endDateAriaLabel: _propTypes["default"].string,
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  screenReaderInputMessage: _propTypes["default"].string,
  showClearDates: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  keepFocusOnInput: _propTypes["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes["default"].number,
  withPortal: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  appendToBody: _propTypes["default"].bool,
  disableScroll: _propTypes["default"].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  firstDayOfWeek: _DayOfWeekShape["default"],
  initialVisibleMonth: _propTypes["default"].func,
  numberOfMonths: _propTypes["default"].number,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDates: _propTypes["default"].bool,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  minimumNights: _propTypes["default"].number,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  enableOutsideDays: _propTypes["default"].bool,
  isDayBlocked: _propTypes["default"].func,
  isOutsideRange: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // internationalization props
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
};
exports["default"] = _default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.START_DATE, _constants.END_DATE]);

exports["default"] = _default;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

exports["default"] = _default;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _constants = __webpack_require__(7);

var _default = _propTypes["default"].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

exports["default"] = _default;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getResponsiveContainerStyles;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _constants = __webpack_require__(7);

function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
  var calculatedMargin = margin || 0;
  return (0, _defineProperty2["default"])({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getDetachedContainerStyles;

var _constants = __webpack_require__(7);

/**
 * Calculate and return a CSS transform style to position a detached element
 * next to a reference element. The open and anchor direction indicate wether
 * it should be positioned above/below and/or to the left/right of the
 * reference element.
 *
 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
 * corners of the reference and detached elements, respectively:
 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
 *
 * By using a CSS transform, we allow to further position it using
 * top/bottom CSS properties for the anchor gutter.
 *
 * @param {string} openDirection The vertical positioning of the popup
 * @param {string} anchorDirection The horizontal position of the popup
 * @param {HTMLElement} referenceEl The reference element
 */
function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
  var referenceRect = referenceEl.getBoundingClientRect();
  var offsetX = referenceRect.left;
  var offsetY = referenceRect.top;

  if (openDirection === _constants.OPEN_UP) {
    offsetY = -(window.innerHeight - referenceRect.bottom);
  }

  if (anchorDirection === _constants.ANCHOR_RIGHT) {
    offsetX = -(window.innerWidth - referenceRect.right);
  }

  return {
    transform: "translate3d(".concat(Math.round(offsetX), "px, ").concat(Math.round(offsetY), "px, 0)")
  };
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = getScrollParent;
exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
exports["default"] = disableScroll;

var getScrollingRoot = function getScrollingRoot() {
  return document.scrollingElement || document.documentElement;
};
/**
 * Recursively finds the scroll parent of a node. The scroll parrent of a node
 * is the closest node that is scrollable. A node is scrollable if:
 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
 *  - and its children/content are "bigger" than the node's box height.
 *
 * The root of the document always scrolls by default.
 *
 * @param {HTMLElement} node Any DOM element.
 * @return {HTMLElement} The scroll parent element.
 */


function getScrollParent(node) {
  var parent = node.parentElement;
  if (parent == null) return getScrollingRoot();

  var _window$getComputedSt = window.getComputedStyle(parent),
      overflowY = _window$getComputedSt.overflowY;

  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';

  if (canScroll && parent.scrollHeight > parent.clientHeight) {
    return parent;
  }

  return getScrollParent(parent);
}
/**
 * Recursively traverses the tree upwards from the given node, capturing all
 * ancestor nodes that scroll along with their current 'overflow-y' CSS
 * property.
 *
 * @param {HTMLElement} node Any DOM element.
 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
 */


function getScrollAncestorsOverflowY(node) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  var scrollingRoot = getScrollingRoot();
  var scrollParent = getScrollParent(node);
  acc.set(scrollParent, scrollParent.style.overflowY);
  if (scrollParent === scrollingRoot) return acc;
  return getScrollAncestorsOverflowY(scrollParent, acc);
}
/**
 * Disabling the scroll on a node involves finding all the scrollable ancestors
 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
 * 'overflow-y: hidden' (up to the document element) there is no scroll
 * container, thus all the scroll outside of the node is disabled. In order to
 * enable scroll again, we store the previous value of the 'overflow-y' for
 * every ancestor in a closure and reset it back.
 *
 * @param {HTMLElement} node Any DOM element.
 */


function disableScroll(node) {
  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);

  var toggle = function toggle(on) {
    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
    });
  };

  toggle(true);
  return function () {
    return toggle(false);
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _moment = _interopRequireDefault(__webpack_require__(5));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _DateRangePickerInput = _interopRequireDefault(__webpack_require__(204));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _DisabledShape = _interopRequireDefault(__webpack_require__(58));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(107));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _isBeforeDay = _interopRequireDefault(__webpack_require__(60));

var _constants = __webpack_require__(7);

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node,
  startDate: _reactMomentProptypes["default"].momentObj,
  startDateId: _propTypes["default"].string,
  startDatePlaceholderText: _propTypes["default"].string,
  isStartDateFocused: _propTypes["default"].bool,
  startDateAriaLabel: _propTypes["default"].string,
  endDate: _reactMomentProptypes["default"].momentObj,
  endDateId: _propTypes["default"].string,
  endDatePlaceholderText: _propTypes["default"].string,
  isEndDateFocused: _propTypes["default"].bool,
  endDateAriaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  showClearDates: _propTypes["default"].bool,
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDates: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  minimumNights: _airbnbPropTypes.nonNegativeInteger,
  isOutsideRange: _propTypes["default"].func,
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onDatesChange: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  children: null,
  startDate: null,
  startDateId: _constants.START_DATE,
  startDatePlaceholderText: 'Start Date',
  isStartDateFocused: false,
  startDateAriaLabel: undefined,
  endDate: null,
  endDateId: _constants.END_DATE,
  endDatePlaceholderText: 'End Date',
  isEndDateFocused: false,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  showClearDates: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  withFullScreenPortal: false,
  minimumNights: 1,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  onDatesChange: function onDatesChange() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

var DateRangePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePickerInputController, _ref);
  var _proto = DateRangePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateChange = _this.onStartDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartDateFocus = _this.onStartDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateChange = _this.onEndDateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEndDateFocus = _this.onEndDateFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDates = _this.clearDates.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onClearFocus = function onClearFocus() {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onEndDateChange = function onEndDateChange(endDateString) {
    var _this$props2 = this.props,
        startDate = _this$props2.startDate,
        isOutsideRange = _this$props2.isOutsideRange,
        minimumNights = _this$props2.minimumNights,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onDatesChange = _this$props2.onDatesChange;
    var endDate = (0, _toMomentObject["default"])(endDateString, this.getDisplayFormat());
    var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days')));

    if (isEndDateValid) {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      if (!keepOpenOnDateSelect) this.onClearFocus();
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: null
      });
    }
  };

  _proto.onEndDateFocus = function onEndDateFocus() {
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        onFocusChange = _this$props3.onFocusChange,
        withFullScreenPortal = _this$props3.withFullScreenPortal,
        disabled = _this$props3.disabled;

    if (!startDate && withFullScreenPortal && (!disabled || disabled === _constants.END_DATE)) {
      // When the datepicker is full screen, we never want to focus the end date first
      // because there's no indication that that is the case once the datepicker is open and it
      // might confuse the user
      onFocusChange(_constants.START_DATE);
    } else if (!disabled || disabled === _constants.START_DATE) {
      onFocusChange(_constants.END_DATE);
    }
  };

  _proto.onStartDateChange = function onStartDateChange(startDateString) {
    var endDate = this.props.endDate;
    var _this$props4 = this.props,
        isOutsideRange = _this$props4.isOutsideRange,
        minimumNights = _this$props4.minimumNights,
        onDatesChange = _this$props4.onDatesChange,
        onFocusChange = _this$props4.onFocusChange,
        disabled = _this$props4.disabled;
    var startDate = (0, _toMomentObject["default"])(startDateString, this.getDisplayFormat());
    var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay["default"])(endDate, startDate.clone().add(minimumNights, 'days'));
    var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === _constants.END_DATE && isEndDateBeforeStartDate);

    if (isStartDateValid) {
      if (isEndDateBeforeStartDate) {
        endDate = null;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
      onFocusChange(_constants.END_DATE);
    } else {
      onDatesChange({
        startDate: null,
        endDate: endDate
      });
    }
  };

  _proto.onStartDateFocus = function onStartDateFocus() {
    var _this$props5 = this.props,
        disabled = _this$props5.disabled,
        onFocusChange = _this$props5.onFocusChange;

    if (!disabled || disabled === _constants.END_DATE) {
      onFocusChange(_constants.START_DATE);
    }
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDates = function clearDates() {
    var _this$props6 = this.props,
        onDatesChange = _this$props6.onDatesChange,
        reopenPickerOnClearDates = _this$props6.reopenPickerOnClearDates,
        onFocusChange = _this$props6.onFocusChange;
    onDatesChange({
      startDate: null,
      endDate: null
    });

    if (reopenPickerOnClearDates) {
      onFocusChange(_constants.START_DATE);
    }
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        children = _this$props7.children,
        startDate = _this$props7.startDate,
        startDateId = _this$props7.startDateId,
        startDatePlaceholderText = _this$props7.startDatePlaceholderText,
        isStartDateFocused = _this$props7.isStartDateFocused,
        startDateAriaLabel = _this$props7.startDateAriaLabel,
        endDate = _this$props7.endDate,
        endDateId = _this$props7.endDateId,
        endDatePlaceholderText = _this$props7.endDatePlaceholderText,
        endDateAriaLabel = _this$props7.endDateAriaLabel,
        isEndDateFocused = _this$props7.isEndDateFocused,
        screenReaderMessage = _this$props7.screenReaderMessage,
        showClearDates = _this$props7.showClearDates,
        showCaret = _this$props7.showCaret,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customInputIcon = _this$props7.customInputIcon,
        customArrowIcon = _this$props7.customArrowIcon,
        customCloseIcon = _this$props7.customCloseIcon,
        disabled = _this$props7.disabled,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        isFocused = _this$props7.isFocused,
        phrases = _this$props7.phrases,
        onKeyDownArrowDown = _this$props7.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props7.onKeyDownQuestionMark,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing;
    var startDateString = this.getDateString(startDate);
    var endDateString = this.getDateString(endDate);
    return _react["default"].createElement(_DateRangePickerInput["default"], {
      startDate: startDateString,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: isStartDateFocused,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDateString,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: isEndDateFocused,
      endDateAriaLabel: endDateAriaLabel,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      phrases: phrases,
      onStartDateChange: this.onStartDateChange,
      onStartDateFocus: this.onStartDateFocus,
      onStartDateShiftTab: this.onClearFocus,
      onEndDateChange: this.onEndDateChange,
      onEndDateFocus: this.onEndDateFocus,
      showClearDates: showClearDates,
      onClearDates: this.clearDates,
      screenReaderMessage: screenReaderMessage,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return DateRangePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DateRangePickerInputController;
DateRangePickerInputController.propTypes =  false ? propTypes : {};
DateRangePickerInputController.defaultProps = defaultProps;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _DateInput = _interopRequireDefault(__webpack_require__(205));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _DisabledShape = _interopRequireDefault(__webpack_require__(58));

var _RightArrow = _interopRequireDefault(__webpack_require__(209));

var _LeftArrow = _interopRequireDefault(__webpack_require__(210));

var _CloseButton = _interopRequireDefault(__webpack_require__(61));

var _CalendarIcon = _interopRequireDefault(__webpack_require__(211));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  children: _propTypes["default"].node,
  startDateId: _propTypes["default"].string,
  startDatePlaceholderText: _propTypes["default"].string,
  startDateAriaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  endDateId: _propTypes["default"].string,
  endDatePlaceholderText: _propTypes["default"].string,
  endDateAriaLabel: _propTypes["default"].string,
  onStartDateFocus: _propTypes["default"].func,
  onEndDateFocus: _propTypes["default"].func,
  onStartDateChange: _propTypes["default"].func,
  onEndDateChange: _propTypes["default"].func,
  onStartDateShiftTab: _propTypes["default"].func,
  onEndDateTab: _propTypes["default"].func,
  onClearDates: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  isStartDateFocused: _propTypes["default"].bool,
  isEndDateFocused: _propTypes["default"].bool,
  showClearDates: _propTypes["default"].bool,
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  customArrowIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // describes actual DOM focus
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DateRangePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
})) : {};
var defaultProps = {
  children: null,
  startDateId: _constants.START_DATE,
  endDateId: _constants.END_DATE,
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  screenReaderMessage: '',
  onStartDateFocus: function onStartDateFocus() {},
  onEndDateFocus: function onEndDateFocus() {},
  onStartDateChange: function onStartDateChange() {},
  onEndDateChange: function onEndDateChange() {},
  onStartDateShiftTab: function onStartDateShiftTab() {},
  onEndDateTab: function onEndDateTab() {},
  onClearDates: function onClearDates() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  startDate: '',
  endDate: '',
  isStartDateFocused: false,
  isEndDateFocused: false,
  showClearDates: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  // accessibility
  isFocused: false,
  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,
  isRTL: false
};

function DateRangePickerInput(_ref) {
  var children = _ref.children,
      startDate = _ref.startDate,
      startDateId = _ref.startDateId,
      startDatePlaceholderText = _ref.startDatePlaceholderText,
      screenReaderMessage = _ref.screenReaderMessage,
      isStartDateFocused = _ref.isStartDateFocused,
      onStartDateChange = _ref.onStartDateChange,
      onStartDateFocus = _ref.onStartDateFocus,
      onStartDateShiftTab = _ref.onStartDateShiftTab,
      startDateAriaLabel = _ref.startDateAriaLabel,
      endDate = _ref.endDate,
      endDateId = _ref.endDateId,
      endDatePlaceholderText = _ref.endDatePlaceholderText,
      isEndDateFocused = _ref.isEndDateFocused,
      onEndDateChange = _ref.onEndDateChange,
      onEndDateFocus = _ref.onEndDateFocus,
      onEndDateTab = _ref.onEndDateTab,
      endDateAriaLabel = _ref.endDateAriaLabel,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      onClearDates = _ref.onClearDates,
      showClearDates = _ref.showClearDates,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      openDirection = _ref.openDirection,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      customInputIcon = _ref.customInputIcon,
      customArrowIcon = _ref.customArrowIcon,
      customCloseIcon = _ref.customCloseIcon,
      isFocused = _ref.isFocused,
      phrases = _ref.phrases,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      verticalSpacing = _ref.verticalSpacing,
      small = _ref.small,
      regular = _ref.regular,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon_svg));

  var arrowIcon = customArrowIcon || _react["default"].createElement(_RightArrow["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));

  if (isRTL) arrowIcon = _react["default"].createElement(_LeftArrow["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
  if (small) arrowIcon = '-';

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));

  var screenReaderStartDateText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;
  var screenReaderEndDateText = screenReaderMessage || phrases.keyboardBackwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onKeyDownArrowDown
  }), calendarIcon);

  var startDateDisabled = disabled === _constants.START_DATE || disabled === true;
  var endDateDisabled = disabled === _constants.END_DATE || disabled === true;
  return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates), inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: startDateId,
    placeholder: startDatePlaceholderText,
    ariaLabel: startDateAriaLabel,
    displayValue: startDate,
    screenReaderMessage: screenReaderStartDateText,
    focused: isStartDateFocused,
    isFocused: isFocused,
    disabled: startDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onStartDateChange,
    onFocus: onStartDateFocus,
    onKeyDownShiftTab: onStartDateShiftTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), children, _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow), {
    "aria-hidden": "true",
    role: "presentation"
  }), arrowIcon), _react["default"].createElement(_DateInput["default"], {
    id: endDateId,
    placeholder: endDatePlaceholderText,
    ariaLabel: endDateAriaLabel,
    displayValue: endDate,
    screenReaderMessage: screenReaderEndDateText,
    focused: isEndDateFocused,
    isFocused: isFocused,
    disabled: endDateDisabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    openDirection: openDirection,
    onChange: onEndDateChange,
    onFocus: onEndDateFocus,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    onKeyDownTab: onEndDateTab,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular
  }), showClearDates && _react["default"].createElement("button", (0, _extends2["default"])({
    type: "button",
    "aria-label": phrases.clearDates
  }, (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
    onClick: onClearDates,
    disabled: disabled
  }), closeIcon), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
}

DateRangePickerInput.propTypes =  false ? propTypes : {};
DateRangePickerInput.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing;
  return {
    DateRangePickerInput: {
      backgroundColor: color.background,
      display: 'inline-block'
    },
    DateRangePickerInput__disabled: {
      background: color.disabled
    },
    DateRangePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    DateRangePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePickerInput__block: {
      display: 'block'
    },
    DateRangePickerInput__showClearDates: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_arrow: {
      display: 'inline-block',
      verticalAlign: 'middle',
      color: color.text
    },
    DateRangePickerInput_arrow_svg: {
      verticalAlign: 'middle',
      fill: color.text,
      height: sizing.arrowWidth,
      width: sizing.arrowWidth
    },
    DateRangePickerInput_clearDates: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    DateRangePickerInput_clearDates__small: {
      padding: 6
    },
    DateRangePickerInput_clearDates_default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    DateRangePickerInput_clearDates__hide: {
      visibility: 'hidden'
    },
    DateRangePickerInput_clearDates_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    DateRangePickerInput_clearDates_svg__small: {
      height: 9
    },
    DateRangePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    DateRangePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePickerInput);

exports["default"] = _default;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _throttle = _interopRequireDefault(__webpack_require__(206));

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _getInputHeight = _interopRequireDefault(__webpack_require__(105));

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FANG_PATH_TOP = "M0,".concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX, ",").concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX / 2, ",0z");
var FANG_STROKE_TOP = "M0,".concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX / 2, ",0 ").concat(_constants.FANG_WIDTH_PX, ",").concat(_constants.FANG_HEIGHT_PX);
var FANG_PATH_BOTTOM = "M0,0 ".concat(_constants.FANG_WIDTH_PX, ",0 ").concat(_constants.FANG_WIDTH_PX / 2, ",").concat(_constants.FANG_HEIGHT_PX, "z");
var FANG_STROKE_BOTTOM = "M0,0 ".concat(_constants.FANG_WIDTH_PX / 2, ",").concat(_constants.FANG_HEIGHT_PX, " ").concat(_constants.FANG_WIDTH_PX, ",0");
var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  displayValue: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  focused: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  small: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDownShiftTab: _propTypes["default"].func,
  onKeyDownTab: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  // accessibility
  isFocused: _propTypes["default"].bool // describes actual DOM focus

})) : {};
var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  ariaLabel: undefined,
  screenReaderMessage: '',
  focused: false,
  disabled: false,
  required: false,
  readOnly: null,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
  small: false,
  block: false,
  regular: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // accessibility
  isFocused: false
};

var DateInput =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateInput, _ref);
  var _proto = DateInput.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateInput(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dateString: '',
      isTouchDevice: false
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setInputRef = _this.setInputRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.throttledKeyDown = (0, _throttle["default"])(_this.onFinalKeyDown, 300, {
      trailing: false
    });
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      isTouchDevice: (0, _isTouchDevice["default"])()
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var dateString = this.state.dateString;

    if (dateString && nextProps.displayValue) {
      this.setState({
        dateString: ''
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        focused = _this$props.focused,
        isFocused = _this$props.isFocused;
    if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

    if (focused && isFocused) {
      this.inputRef.focus();
    }
  };

  _proto.onChange = function onChange(e) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        onKeyDownQuestionMark = _this$props2.onKeyDownQuestionMark;
    var dateString = e.target.value; // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
    // special case the `?` key so that it always triggers the appropriate callback, instead of
    // modifying the input value

    if (dateString[dateString.length - 1] === '?') {
      onKeyDownQuestionMark(e);
    } else {
      this.setState({
        dateString: dateString
      }, function () {
        return onChange(dateString);
      });
    }
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();

    if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
      this.throttledKeyDown(e);
    }
  };

  _proto.onFinalKeyDown = function onFinalKeyDown(e) {
    var _this$props3 = this.props,
        onKeyDownShiftTab = _this$props3.onKeyDownShiftTab,
        onKeyDownTab = _this$props3.onKeyDownTab,
        onKeyDownArrowDown = _this$props3.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props3.onKeyDownQuestionMark;
    var key = e.key;

    if (key === 'Tab') {
      if (e.shiftKey) {
        onKeyDownShiftTab(e);
      } else {
        onKeyDownTab(e);
      }
    } else if (key === 'ArrowDown') {
      onKeyDownArrowDown(e);
    } else if (key === '?') {
      e.preventDefault();
      onKeyDownQuestionMark(e);
    }
  };

  _proto.setInputRef = function setInputRef(ref) {
    this.inputRef = ref;
  };

  _proto.render = function render() {
    var _this$state = this.state,
        dateString = _this$state.dateString,
        isTouch = _this$state.isTouchDevice;
    var _this$props4 = this.props,
        id = _this$props4.id,
        placeholder = _this$props4.placeholder,
        ariaLabel = _this$props4.ariaLabel,
        displayValue = _this$props4.displayValue,
        screenReaderMessage = _this$props4.screenReaderMessage,
        focused = _this$props4.focused,
        showCaret = _this$props4.showCaret,
        onFocus = _this$props4.onFocus,
        disabled = _this$props4.disabled,
        required = _this$props4.required,
        readOnly = _this$props4.readOnly,
        openDirection = _this$props4.openDirection,
        verticalSpacing = _this$props4.verticalSpacing,
        small = _this$props4.small,
        regular = _this$props4.regular,
        block = _this$props4.block,
        styles = _this$props4.styles,
        reactDates = _this$props4.theme.reactDates;
    var value = dateString || displayValue || '';
    var screenReaderMessageId = "DateInput__screen-reader-message-".concat(id);
    var withFang = showCaret && focused;
    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === _constants.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === _constants.OPEN_UP && styles.DateInput__openUp), _react["default"].createElement("input", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
      "aria-label": ariaLabel === undefined ? placeholder : ariaLabel,
      type: "text",
      id: id,
      name: id,
      ref: this.setInputRef,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onFocus: onFocus,
      placeholder: placeholder,
      autoComplete: "off",
      disabled: disabled,
      readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
      required: required,
      "aria-describedby": screenReaderMessage && screenReaderMessageId
    })), withFang && _react["default"].createElement("svg", (0, _extends2["default"])({
      role: "presentation",
      focusable: "false"
    }, (0, _reactWithStyles.css)(styles.DateInput_fang, openDirection === _constants.OPEN_DOWN && {
      top: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
    }, openDirection === _constants.OPEN_UP && {
      bottom: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateInput_fangShape), {
      d: openDirection === _constants.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
    })), _react["default"].createElement("path", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateInput_fangStroke), {
      d: openDirection === _constants.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
    }))), screenReaderMessage && _react["default"].createElement("p", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateInput_screenReaderMessage), {
      id: screenReaderMessageId
    }), screenReaderMessage));
  };

  return DateInput;
}(_react["default"].PureComponent || _react["default"].Component);

DateInput.propTypes =  false ? propTypes : {};
DateInput.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color,
      sizing = _ref2$reactDates.sizing,
      spacing = _ref2$reactDates.spacing,
      font = _ref2$reactDates.font,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateInput: {
      margin: 0,
      padding: spacing.inputPadding,
      background: color.background,
      position: 'relative',
      display: 'inline-block',
      width: sizing.inputWidth,
      verticalAlign: 'middle'
    },
    DateInput__small: {
      width: sizing.inputWidth_small
    },
    DateInput__block: {
      width: '100%'
    },
    DateInput__disabled: {
      background: color.disabled,
      color: color.textDisabled
    },
    DateInput_input: {
      fontWeight: font.input.weight,
      fontSize: font.input.size,
      lineHeight: font.input.lineHeight,
      color: color.text,
      backgroundColor: color.background,
      width: '100%',
      padding: "".concat(spacing.displayTextPaddingVertical, "px ").concat(spacing.displayTextPaddingHorizontal, "px"),
      paddingTop: spacing.displayTextPaddingTop,
      paddingBottom: spacing.displayTextPaddingBottom,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight),
      border: border.input.border,
      borderTop: border.input.borderTop,
      borderRight: (0, _noflip["default"])(border.input.borderRight),
      borderBottom: border.input.borderBottom,
      borderLeft: (0, _noflip["default"])(border.input.borderLeft),
      borderRadius: border.input.borderRadius
    },
    DateInput_input__small: {
      fontSize: font.input.size_small,
      lineHeight: font.input.lineHeight_small,
      letterSpacing: font.input.letterSpacing_small,
      padding: "".concat(spacing.displayTextPaddingVertical_small, "px ").concat(spacing.displayTextPaddingHorizontal_small, "px"),
      paddingTop: spacing.displayTextPaddingTop_small,
      paddingBottom: spacing.displayTextPaddingBottom_small,
      paddingLeft: (0, _noflip["default"])(spacing.displayTextPaddingLeft_small),
      paddingRight: (0, _noflip["default"])(spacing.displayTextPaddingRight_small)
    },
    DateInput_input__regular: {
      fontWeight: 'auto'
    },
    DateInput_input__readOnly: {
      userSelect: 'none'
    },
    DateInput_input__focused: {
      outline: border.input.outlineFocused,
      background: color.backgroundFocused,
      border: border.input.borderFocused,
      borderTop: border.input.borderTopFocused,
      borderRight: (0, _noflip["default"])(border.input.borderRightFocused),
      borderBottom: border.input.borderBottomFocused,
      borderLeft: (0, _noflip["default"])(border.input.borderLeftFocused)
    },
    DateInput_input__disabled: {
      background: color.disabled,
      fontStyle: font.input.styleDisabled
    },
    DateInput_screenReaderMessage: {
      border: 0,
      clip: 'rect(0, 0, 0, 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    },
    DateInput_fang: {
      position: 'absolute',
      width: _constants.FANG_WIDTH_PX,
      height: _constants.FANG_HEIGHT_PX,
      left: 22,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      zIndex: zIndex + 2
    },
    DateInput_fangShape: {
      fill: color.background
    },
    DateInput_fangStroke: {
      stroke: color.core.border,
      fill: 'transparent'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateInput);

exports["default"] = _default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(502),
    isObject = __webpack_require__(106);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(504);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(207);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var RightArrow = function RightArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z"
  }));
};

RightArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = RightArrow;
exports["default"] = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var LeftArrow = function LeftArrow(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M336 275L126 485h806c13 0 23 10 23 23s-10 23-23 23H126l210 210c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7L55 524c-11-11-11-21 0-32l249-249c21-22 53 10 32 32z"
  }));
};

LeftArrow.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = LeftArrow;
exports["default"] = _default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var CalendarIcon = function CalendarIcon(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "m107 1393h241v-241h-241zm295 0h268v-241h-268zm-295-295h241v-268h-241zm295 0h268v-268h-268zm-295-321h241v-241h-241zm616 616h268v-241h-268zm-321-616h268v-241h-268zm643 616h241v-241h-241zm-322-295h268v-268h-268zm-294-723v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm616 723h241v-268h-241zm-322-321h268v-241h-268zm322 0h241v-241h-241zm27-402v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm321-54v1072c0 29-11 54-32 75s-46 32-75 32h-1179c-29 0-54-11-75-32s-32-46-32-75v-1072c0-29 11-54 32-75s46-32 75-32h107v-80c0-37 13-68 40-95s57-39 94-39h54c37 0 68 13 95 39 26 26 39 58 39 95v80h321v-80c0-37 13-69 40-95 26-26 57-39 94-39h54c37 0 68 13 94 39s40 58 40 95v80h107c29 0 54 11 75 32s32 46 32 75z"
  }));
};

CalendarIcon.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1393.1 1500"
};
var _default = CalendarIcon;
exports["default"] = _default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(213));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _object = _interopRequireDefault(__webpack_require__(72));

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _isNextDay = _interopRequireDefault(__webpack_require__(214));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

var _isAfterDay = _interopRequireDefault(__webpack_require__(76));

var _isBeforeDay = _interopRequireDefault(__webpack_require__(60));

var _isPreviousDay = _interopRequireDefault(__webpack_require__(516));

var _getVisibleDays = _interopRequireDefault(__webpack_require__(215));

var _isDayVisible = _interopRequireDefault(__webpack_require__(108));

var _getSelectedDateOffset = _interopRequireDefault(__webpack_require__(517));

var _toISODateString = _interopRequireDefault(__webpack_require__(57));

var _modifiers = __webpack_require__(216);

var _DisabledShape = _interopRequireDefault(__webpack_require__(58));

var _FocusedInputShape = _interopRequireDefault(__webpack_require__(197));

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(59));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _constants = __webpack_require__(7);

var _DayPicker = _interopRequireDefault(__webpack_require__(109));

var _getPooledMoment = _interopRequireDefault(__webpack_require__(217));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes["default"].momentObj,
  endDate: _reactMomentProptypes["default"].momentObj,
  onDatesChange: _propTypes["default"].func,
  startDateOffset: _propTypes["default"].func,
  endDateOffset: _propTypes["default"].func,
  minDate: _reactMomentProptypes["default"].momentObj,
  maxDate: _reactMomentProptypes["default"].momentObj,
  focusedInput: _FocusedInputShape["default"],
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  minimumNights: _propTypes["default"].number,
  disabled: _DisabledShape["default"],
  isOutsideRange: _propTypes["default"].func,
  isDayBlocked: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  getMinNightsForHoverDate: _propTypes["default"].func,
  daysViolatingMinNightsCanBeClicked: _propTypes["default"].bool,
  // DayPicker props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onOutsideClick: _propTypes["default"].func,
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderCalendarInfo: _propTypes["default"].func,
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  firstDayOfWeek: _DayOfWeekShape["default"],
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  // accessibility
  onBlur: _propTypes["default"].func,
  isFocused: _propTypes["default"].bool,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // i18n
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string,
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  startDate: undefined,
  // TODO: use null
  endDate: undefined,
  // TODO: use null
  minDate: null,
  maxDate: null,
  onDatesChange: function onDatesChange() {},
  startDateOffset: undefined,
  endDateOffset: undefined,
  focusedInput: null,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  disabled: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  getMinNightsForHoverDate: function getMinNightsForHoverDate() {},
  daysViolatingMinNightsCanBeClicked: false,
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: _constants.DAY_SIZE,
  dayPickerNavigationInlineStyles: null,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  firstDayOfWeek: null,
  verticalHeight: null,
  noBorder: false,
  transitionDuration: undefined,
  verticalBorderSpacing: undefined,
  horizontalMonthPadding: 13,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
  if (focusedInput === _constants.START_DATE) {
    return phrases.chooseAvailableStartDate;
  }

  if (focusedInput === _constants.END_DATE) {
    return phrases.chooseAvailableEndDate;
  }

  return phrases.chooseAvailableDate;
};

var DayPickerRangeController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerRangeController, _ref);
  var _proto = DayPickerRangeController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerRangeController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = (0, _isTouchDevice["default"])();
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      'selected-start': function selectedStart(day) {
        return _this.isStartDate(day);
      },
      'selected-end': function selectedEnd(day) {
        return _this.isEndDate(day);
      },
      'blocked-minimum-nights': function blockedMinimumNights(day) {
        return _this.doesNotMeetMinimumNights(day);
      },
      'selected-span': function selectedSpan(day) {
        return _this.isInSelectedSpan(day);
      },
      'last-in-range': function lastInRange(day) {
        return _this.isLastInRange(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      'hovered-span': function hoveredSpan(day) {
        return _this.isInHoveredSpan(day);
      },
      'hovered-offset': function hoveredOffset(day) {
        return _this.isInHoveredSpan(day);
      },
      'after-hovered-start': function afterHoveredStart(day) {
        return _this.isDayAfterHoveredStartDate(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      },
      'hovered-start-first-possible-end': function hoveredStartFirstPossibleEnd(day, hoverDate) {
        return _this.isFirstPossibleEndDateForHoveredStartDate(day, hoverDate);
      },
      'hovered-start-blocked-minimum-nights': function hoveredStartBlockedMinimumNights(day, hoverDate) {
        return _this.doesNotMeetMinNightsForHoveredStartDate(day, hoverDate);
      },
      'before-hovered-end': function beforeHoveredEnd(day) {
        return _this.isDayBeforeHoveredEndDate(day);
      },
      'no-selected-start-before-selected-end': function noSelectedStartBeforeSelectedEnd(day) {
        return _this.beforeSelectedEnd(day) && !props.startDate;
      },
      'selected-start-in-hovered-span': function selectedStartInHoveredSpan(day, hoverDate) {
        return _this.isStartDate(day) && (0, _isAfterDay["default"])(hoverDate, day);
      },
      'selected-start-no-selected-end': function selectedStartNoSelectedEnd(day) {
        return _this.isStartDate(day) && !props.endDate;
      },
      'selected-end-no-selected-start': function selectedEndNoSelectedStart(day) {
        return _this.isEndDate(day) && !props.startDate;
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays; // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      phrases: _objectSpread({}, props.phrases, {
        chooseAvailableDate: chooseAvailableDate
      }),
      visibleDays: visibleDays,
      disablePrev: _this.shouldDisableMonthNavigation(props.minDate, currentMonth),
      disableNext: _this.shouldDisableMonthNavigation(props.maxDate, currentMonth)
    };
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var startDate = nextProps.startDate,
        endDate = nextProps.endDate,
        focusedInput = nextProps.focusedInput,
        getMinNightsForHoverDate = nextProps.getMinNightsForHoverDate,
        minimumNights = nextProps.minimumNights,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        phrases = nextProps.phrases,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevStartDate = _this$props.startDate,
        prevEndDate = _this$props.endDate,
        prevFocusedInput = _this$props.focusedInput,
        prevMinimumNights = _this$props.minimumNights,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevPhrases = _this$props.phrases,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays;
    var hoverDate = this.state.hoverDate;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
    var didStartDateChange = startDate !== prevStartDate;
    var didEndDateChange = endDate !== prevEndDate;
    var didFocusChange = focusedInput !== prevFocusedInput;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var modifiers = {};

    if (didStartDateChange) {
      modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
      modifiers = this.addModifier(modifiers, startDate, 'selected-start');

      if (prevStartDate) {
        var startSpan = prevStartDate.clone().add(1, 'day');
        var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
        modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');

        if (!endDate || !prevEndDate) {
          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start-no-selected-end');
        }
      }

      if (!prevStartDate && endDate && startDate) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-no-selected-start');
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
          });
        });
      }
    }

    if (didEndDateChange) {
      modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
      modifiers = this.addModifier(modifiers, endDate, 'selected-end');

      if (prevEndDate && (!startDate || !prevStartDate)) {
        modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end-no-selected-start');
      }
    }

    if (didStartDateChange || didEndDateChange) {
      if (prevStartDate && prevEndDate) {
        modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
      }

      if (startDate && endDate) {
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
        modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
      }

      if (startDate && !endDate) {
        modifiers = this.addModifier(modifiers, startDate, 'selected-start-no-selected-end');
      }

      if (endDate && !startDate) {
        modifiers = this.addModifier(modifiers, endDate, 'selected-end-no-selected-start');
      }

      if (!startDate && endDate) {
        (0, _object["default"])(visibleDays).forEach(function (days) {
          Object.keys(days).forEach(function (day) {
            var momentObj = (0, _moment["default"])(day);

            if ((0, _isBeforeDay["default"])(momentObj, endDate)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'no-selected-start-before-selected-end');
            }
          });
        });
      }
    }

    if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
      var _startSpan = startDate.clone().add(1, 'day');

      var _endSpan = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
    }

    if (!this.isTouchDevice && didEndDateChange && !startDate && endDate) {
      var _startSpan2 = endDate.clone().subtract(minimumNights, 'days');

      var _endSpan2 = endDate.clone();

      modifiers = this.addModifierToRange(modifiers, _startSpan2, _endSpan2, 'before-hovered-end');
    }

    if (prevMinimumNights > 0) {
      if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
        var _startSpan3 = prevStartDate || this.today;

        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
        modifiers = this.deleteModifierFromRange(modifiers, _startSpan3, _startSpan3.clone().add(prevMinimumNights, 'days'), 'blocked');
      }
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);
          var isBlocked = false;

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
              isBlocked = true;
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (isBlocked) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    if (!this.isTouchDevice && didFocusChange && hoverDate && !this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === _constants.END_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }

      if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
        modifiers = this.addModifierToRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.addModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    if (minimumNights > 0 && startDate && focusedInput === _constants.END_DATE) {
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
      modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked');
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }

    if (didFocusChange || phrases !== prevPhrases) {
      // set the appropriate CalendarDay phrase based on focusedInput
      var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
      this.setState({
        phrases: _objectSpread({}, phrases, {
          chooseAvailableDate: chooseAvailableDate
        })
      });
    }
  };

  _proto.onDayClick = function onDayClick(day, e) {
    var _this$props2 = this.props,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        minimumNights = _this$props2.minimumNights,
        onBlur = _this$props2.onBlur,
        focusedInput = _this$props2.focusedInput,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose,
        onDatesChange = _this$props2.onDatesChange,
        startDateOffset = _this$props2.startDateOffset,
        endDateOffset = _this$props2.endDateOffset,
        disabled = _this$props2.disabled,
        daysViolatingMinNightsCanBeClicked = _this$props2.daysViolatingMinNightsCanBeClicked;
    if (e) e.preventDefault();
    if (this.isBlocked(day, !daysViolatingMinNightsCanBeClicked)) return;
    var _this$props3 = this.props,
        startDate = _this$props3.startDate,
        endDate = _this$props3.endDate;

    if (startDateOffset || endDateOffset) {
      startDate = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
      endDate = (0, _getSelectedDateOffset["default"])(endDateOffset, day);

      if (this.isBlocked(startDate) || this.isBlocked(endDate)) {
        return;
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (!keepOpenOnDateSelect) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else if (focusedInput === _constants.START_DATE) {
      var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
      var isStartDateAfterEndDate = (0, _isBeforeDay["default"])(lastAllowedStartDate, day) || (0, _isAfterDay["default"])(startDate, endDate);
      var isEndDateDisabled = disabled === _constants.END_DATE;

      if (!isEndDateDisabled || !isStartDateAfterEndDate) {
        startDate = day;

        if (isStartDateAfterEndDate) {
          endDate = null;
        }
      }

      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });

      if (isEndDateDisabled && !isStartDateAfterEndDate) {
        onFocusChange(null);
        onClose({
          startDate: startDate,
          endDate: endDate
        });
      } else if (!isEndDateDisabled) {
        onFocusChange(_constants.END_DATE);
      }
    } else if (focusedInput === _constants.END_DATE) {
      var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

      if (!startDate) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
        onFocusChange(_constants.START_DATE);
      } else if ((0, _isInclusivelyAfterDay["default"])(day, firstAllowedEndDate)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });

        if (!keepOpenOnDateSelect) {
          onFocusChange(null);
          onClose({
            startDate: startDate,
            endDate: endDate
          });
        }
      } else if (daysViolatingMinNightsCanBeClicked && this.doesNotMeetMinimumNights(day)) {
        endDate = day;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else if (disabled !== _constants.START_DATE) {
        startDate = day;
        endDate = null;
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      } else {
        onDatesChange({
          startDate: startDate,
          endDate: endDate
        });
      }
    } else {
      onDatesChange({
        startDate: startDate,
        endDate: endDate
      });
    }

    onBlur();
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    /* eslint react/destructuring-assignment: 1 */
    if (this.isTouchDevice) return;
    var _this$props4 = this.props,
        startDate = _this$props4.startDate,
        endDate = _this$props4.endDate,
        focusedInput = _this$props4.focusedInput,
        getMinNightsForHoverDate = _this$props4.getMinNightsForHoverDate,
        minimumNights = _this$props4.minimumNights,
        startDateOffset = _this$props4.startDateOffset,
        endDateOffset = _this$props4.endDateOffset;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays,
        dateOffset = _this$state.dateOffset;
    var nextDateOffset = null;

    if (focusedInput) {
      var hasOffset = startDateOffset || endDateOffset;
      var modifiers = {};

      if (hasOffset) {
        var start = (0, _getSelectedDateOffset["default"])(startDateOffset, day);
        var end = (0, _getSelectedDateOffset["default"])(endDateOffset, day, function (rangeDay) {
          return rangeDay.add(1, 'day');
        });
        nextDateOffset = {
          start: start,
          end: end
        }; // eslint-disable-next-line react/destructuring-assignment

        if (dateOffset && dateOffset.start && dateOffset.end) {
          modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
        }

        modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
      }

      if (!hasOffset) {
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
        modifiers = this.addModifier(modifiers, day, 'hovered');

        if (startDate && !endDate && focusedInput === _constants.END_DATE) {
          if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
            var endSpan = hoverDate.clone().add(1, 'day');
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
          }

          if ((0, _isBeforeDay["default"])(day, startDate) || (0, _isSameDay["default"])(day, startDate)) {
            modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isAfterDay["default"])(day, startDate)) {
            var _endSpan3 = day.clone().add(1, 'day');

            modifiers = this.addModifierToRange(modifiers, startDate, _endSpan3, 'hovered-span');
            modifiers = this.addModifier(modifiers, startDate, 'selected-start-in-hovered-span');
          }
        }

        if (!startDate && endDate && focusedInput === _constants.START_DATE) {
          if ((0, _isBeforeDay["default"])(hoverDate, endDate)) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
          }

          if ((0, _isAfterDay["default"])(day, endDate) || (0, _isSameDay["default"])(day, endDate)) {
            modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }

          if (!this.isBlocked(day) && (0, _isBeforeDay["default"])(day, endDate)) {
            modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
            modifiers = this.addModifier(modifiers, endDate, 'selected-end-in-hovered-span');
          }
        }

        if (startDate) {
          var startSpan = startDate.clone().add(1, 'day');

          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');

          if ((0, _isSameDay["default"])(day, startDate)) {
            var newStartSpan = startDate.clone().add(1, 'day');
            var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
            modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
          }
        }

        if (endDate) {
          var _startSpan4 = endDate.clone().subtract(minimumNights, 'days');

          modifiers = this.deleteModifierFromRange(modifiers, _startSpan4, endDate, 'before-hovered-end');

          if ((0, _isSameDay["default"])(day, endDate)) {
            var _newStartSpan = endDate.clone().subtract(minimumNights, 'days');

            modifiers = this.addModifierToRange(modifiers, _newStartSpan, endDate, 'before-hovered-end');
          }
        }

        if (hoverDate && !this.isBlocked(hoverDate)) {
          var minNightsForPrevHoverDate = getMinNightsForHoverDate(hoverDate);

          if (minNightsForPrevHoverDate > 0 && focusedInput === _constants.START_DATE) {
            modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForPrevHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }

        if (!this.isBlocked(day)) {
          var minNightsForHoverDate = getMinNightsForHoverDate(day);

          if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
            modifiers = this.addModifierToRange(modifiers, day.clone().add(1, 'days'), day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
            modifiers = this.addModifier(modifiers, day.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
          }
        }
      }

      this.setState({
        hoverDate: day,
        dateOffset: nextDateOffset,
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.onDayMouseLeave = function onDayMouseLeave(day) {
    var _this$props5 = this.props,
        startDate = _this$props5.startDate,
        endDate = _this$props5.endDate,
        focusedInput = _this$props5.focusedInput,
        getMinNightsForHoverDate = _this$props5.getMinNightsForHoverDate,
        minimumNights = _this$props5.minimumNights;
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays,
        dateOffset = _this$state2.dateOffset;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = {};
    modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

    if (dateOffset) {
      modifiers = this.deleteModifierFromRange(modifiers, dateOffset.start, dateOffset.end, 'hovered-offset');
    }

    if (startDate && !endDate) {
      if ((0, _isAfterDay["default"])(hoverDate, startDate)) {
        var endSpan = hoverDate.clone().add(1, 'day');
        modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
      }

      if ((0, _isAfterDay["default"])(day, startDate)) {
        modifiers = this.deleteModifier(modifiers, startDate, 'selected-start-in-hovered-span');
      }
    }

    if (!startDate && endDate) {
      if ((0, _isAfterDay["default"])(endDate, hoverDate)) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
      }

      if ((0, _isBeforeDay["default"])(day, endDate)) {
        modifiers = this.deleteModifier(modifiers, endDate, 'selected-end-in-hovered-span');
      }
    }

    if (startDate && (0, _isSameDay["default"])(day, startDate)) {
      var startSpan = startDate.clone().add(1, 'day');

      var _endSpan5 = startDate.clone().add(minimumNights + 1, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan5, 'after-hovered-start');
    }

    if (endDate && (0, _isSameDay["default"])(day, endDate)) {
      var _startSpan5 = endDate.clone().subtract(minimumNights, 'days');

      modifiers = this.deleteModifierFromRange(modifiers, _startSpan5, endDate, 'before-hovered-end');
    }

    if (!this.isBlocked(hoverDate)) {
      var minNightsForHoverDate = getMinNightsForHoverDate(hoverDate);

      if (minNightsForHoverDate > 0 && focusedInput === _constants.START_DATE) {
        modifiers = this.deleteModifierFromRange(modifiers, hoverDate.clone().add(1, 'days'), hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-blocked-minimum-nights');
        modifiers = this.deleteModifier(modifiers, hoverDate.clone().add(minNightsForHoverDate, 'days'), 'hovered-start-first-possible-end');
      }
    }

    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props6 = this.props,
        enableOutsideDays = _this$props6.enableOutsideDays,
        maxDate = _this$props6.maxDate,
        minDate = _this$props6.minDate,
        numberOfMonths = _this$props6.numberOfMonths,
        onPrevMonthClick = _this$props6.onPrevMonthClick;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(2, 'months');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props7 = this.props,
        enableOutsideDays = _this$props7.enableOutsideDays,
        maxDate = _this$props7.maxDate,
        minDate = _this$props7.minDate,
        numberOfMonths = _this$props7.numberOfMonths,
        onNextMonthClick = _this$props7.onNextMonthClick;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays, true);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      disablePrev: this.shouldDisableMonthNavigation(minDate, newCurrentMonth),
      disableNext: this.shouldDisableMonthNavigation(maxDate, newCurrentMonth),
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays,
        orientation = _this$props8.orientation;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props9 = this.props,
        numberOfMonths = _this$props9.numberOfMonths,
        enableOutsideDays = _this$props9.enableOutsideDays,
        orientation = _this$props9.orientation;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props10 = this.props,
        numberOfMonths = _this$props10.numberOfMonths,
        enableOutsideDays = _this$props10.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        enableOutsideDays = _this$props11.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props12 = this.props,
        startDate = _this$props12.startDate,
        endDate = _this$props12.endDate,
        focusedInput = _this$props12.focusedInput,
        minimumNights = _this$props12.minimumNights,
        numberOfMonths = _this$props12.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (focusedInput === _constants.START_DATE && startDate) {
      focusedDate = startDate.clone();
    } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
      focusedDate = startDate.clone().add(minimumNights, 'days');
    } else if (focusedInput === _constants.END_DATE && endDate) {
      focusedDate = endDate.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays,
        orientation = nextProps.orientation,
        startDate = nextProps.startDate;
    var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
      return startDate;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.shouldDisableMonthNavigation = function shouldDisableMonthNavigation(date, visibleMonth) {
    if (!date) return false;
    var _this$props13 = this.props,
        numberOfMonths = _this$props13.numberOfMonths,
        enableOutsideDays = _this$props13.enableOutsideDays;
    return (0, _isDayVisible["default"])(date, visibleMonth, numberOfMonths, enableOutsideDays);
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, _modifiers.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.addModifierToRange = function addModifierToRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.addModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, _modifiers.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifierFromRange = function deleteModifierFromRange(updatedDays, start, end, modifier) {
    var days = updatedDays;
    var spanStart = start.clone();

    while ((0, _isBeforeDay["default"])(spanStart, end)) {
      days = this.deleteModifier(days, spanStart, modifier);
      spanStart = spanStart.clone().add(1, 'day');
    }

    return days;
  };

  _proto.doesNotMeetMinimumNights = function doesNotMeetMinimumNights(day) {
    var _this$props14 = this.props,
        startDate = _this$props14.startDate,
        isOutsideRange = _this$props14.isOutsideRange,
        focusedInput = _this$props14.focusedInput,
        minimumNights = _this$props14.minimumNights;
    if (focusedInput !== _constants.END_DATE) return false;

    if (startDate) {
      var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minimumNights && dayDiff >= 0;
    }

    return isOutsideRange((0, _moment["default"])(day).subtract(minimumNights, 'days'));
  };

  _proto.doesNotMeetMinNightsForHoveredStartDate = function doesNotMeetMinNightsForHoveredStartDate(day, hoverDate) {
    var _this$props15 = this.props,
        focusedInput = _this$props15.focusedInput,
        getMinNightsForHoverDate = _this$props15.getMinNightsForHoverDate;
    if (focusedInput !== _constants.END_DATE) return false;

    if (hoverDate && !this.isBlocked(hoverDate)) {
      var minNights = getMinNightsForHoverDate(hoverDate);
      var dayDiff = day.diff(hoverDate.clone().startOf('day').hour(12), 'days');
      return dayDiff < minNights && dayDiff >= 0;
    }

    return false;
  };

  _proto.isDayAfterHoveredStartDate = function isDayAfterHoveredStartDate(day) {
    var _this$props16 = this.props,
        startDate = _this$props16.startDate,
        endDate = _this$props16.endDate,
        minimumNights = _this$props16.minimumNights;

    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, startDate);
  };

  _proto.isEndDate = function isEndDate(day) {
    var endDate = this.props.endDate;
    return (0, _isSameDay["default"])(day, endDate);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref3 = this.state || {},
        hoverDate = _ref3.hoverDate;

    var focusedInput = this.props.focusedInput;
    return !!focusedInput && (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isInHoveredSpan = function isInHoveredSpan(day) {
    var _this$props17 = this.props,
        startDate = _this$props17.startDate,
        endDate = _this$props17.endDate;

    var _ref4 = this.state || {},
        hoverDate = _ref4.hoverDate;

    var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay["default"])(hoverDate, day));
    var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
    return (isForwardRange || isBackwardRange) && isValidDayHovered;
  };

  _proto.isInSelectedSpan = function isInSelectedSpan(day) {
    var _this$props18 = this.props,
        startDate = _this$props18.startDate,
        endDate = _this$props18.endDate;
    return day.isBetween(startDate, endDate, 'days');
  };

  _proto.isLastInRange = function isLastInRange(day) {
    var endDate = this.props.endDate;
    return this.isInSelectedSpan(day) && (0, _isNextDay["default"])(day, endDate);
  };

  _proto.isStartDate = function isStartDate(day) {
    var startDate = this.props.startDate;
    return (0, _isSameDay["default"])(day, startDate);
  };

  _proto.isBlocked = function isBlocked(day) {
    var blockDaysViolatingMinNights = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _this$props19 = this.props,
        isDayBlocked = _this$props19.isDayBlocked,
        isOutsideRange = _this$props19.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day) || blockDaysViolatingMinNights && this.doesNotMeetMinimumNights(day);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.isFirstPossibleEndDateForHoveredStartDate = function isFirstPossibleEndDateForHoveredStartDate(day, hoverDate) {
    var _this$props20 = this.props,
        focusedInput = _this$props20.focusedInput,
        getMinNightsForHoverDate = _this$props20.getMinNightsForHoverDate;
    if (focusedInput !== _constants.END_DATE || !hoverDate || this.isBlocked(hoverDate)) return false;
    var minNights = getMinNightsForHoverDate(hoverDate);
    var firstAvailableEndDate = hoverDate.clone().add(minNights, 'days');
    return (0, _isSameDay["default"])(day, firstAvailableEndDate);
  };

  _proto.beforeSelectedEnd = function beforeSelectedEnd(day) {
    var endDate = this.props.endDate;
    return (0, _isBeforeDay["default"])(day, endDate);
  };

  _proto.isDayBeforeHoveredEndDate = function isDayBeforeHoveredEndDate(day) {
    var _this$props21 = this.props,
        startDate = _this$props21.startDate,
        endDate = _this$props21.endDate,
        minimumNights = _this$props21.minimumNights;

    var _ref5 = this.state || {},
        hoverDate = _ref5.hoverDate;

    return !!endDate && !startDate && !this.isBlocked(day) && (0, _isPreviousDay["default"])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay["default"])(hoverDate, endDate);
  };

  _proto.render = function render() {
    var _this$props22 = this.props,
        numberOfMonths = _this$props22.numberOfMonths,
        orientation = _this$props22.orientation,
        monthFormat = _this$props22.monthFormat,
        renderMonthText = _this$props22.renderMonthText,
        renderWeekHeaderElement = _this$props22.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props22.dayPickerNavigationInlineStyles,
        navPosition = _this$props22.navPosition,
        navPrev = _this$props22.navPrev,
        navNext = _this$props22.navNext,
        renderNavPrevButton = _this$props22.renderNavPrevButton,
        renderNavNextButton = _this$props22.renderNavNextButton,
        noNavButtons = _this$props22.noNavButtons,
        noNavNextButton = _this$props22.noNavNextButton,
        noNavPrevButton = _this$props22.noNavPrevButton,
        onOutsideClick = _this$props22.onOutsideClick,
        withPortal = _this$props22.withPortal,
        enableOutsideDays = _this$props22.enableOutsideDays,
        firstDayOfWeek = _this$props22.firstDayOfWeek,
        renderKeyboardShortcutsButton = _this$props22.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props22.renderKeyboardShortcutsPanel,
        hideKeyboardShortcutsPanel = _this$props22.hideKeyboardShortcutsPanel,
        daySize = _this$props22.daySize,
        focusedInput = _this$props22.focusedInput,
        renderCalendarDay = _this$props22.renderCalendarDay,
        renderDayContents = _this$props22.renderDayContents,
        renderCalendarInfo = _this$props22.renderCalendarInfo,
        renderMonthElement = _this$props22.renderMonthElement,
        calendarInfoPosition = _this$props22.calendarInfoPosition,
        onBlur = _this$props22.onBlur,
        onShiftTab = _this$props22.onShiftTab,
        onTab = _this$props22.onTab,
        isFocused = _this$props22.isFocused,
        showKeyboardShortcuts = _this$props22.showKeyboardShortcuts,
        isRTL = _this$props22.isRTL,
        weekDayFormat = _this$props22.weekDayFormat,
        dayAriaLabelFormat = _this$props22.dayAriaLabelFormat,
        verticalHeight = _this$props22.verticalHeight,
        noBorder = _this$props22.noBorder,
        transitionDuration = _this$props22.transitionDuration,
        verticalBorderSpacing = _this$props22.verticalBorderSpacing,
        horizontalMonthPadding = _this$props22.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        phrases = _this$state7.phrases,
        visibleDays = _this$state7.visibleDays,
        disablePrev = _this$state7.disablePrev,
        disableNext = _this$state7.disableNext;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onTab: onTab,
      onShiftTab: onShiftTab,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withPortal,
      hidden: !focusedInput,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      daySize: daySize,
      onOutsideClick: onOutsideClick,
      disablePrev: disablePrev,
      disableNext: disableNext,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavPrevButton: noNavPrevButton,
      noNavNextButton: noNavNextButton,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      renderKeyboardShortcutsButton: renderKeyboardShortcutsButton,
      renderKeyboardShortcutsPanel: renderKeyboardShortcutsPanel,
      calendarInfoPosition: calendarInfoPosition,
      firstDayOfWeek: firstDayOfWeek,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      showKeyboardShortcuts: showKeyboardShortcuts,
      phrases: phrases,
      isRTL: isRTL,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      verticalBorderSpacing: verticalBorderSpacing,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerRangeController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerRangeController;
DayPickerRangeController.propTypes =  false ? propTypes : {};
DayPickerRangeController.defaultProps = defaultProps;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(513);
var iterableToArrayLimit = __webpack_require__(514);
var unsupportedIterableToArray = __webpack_require__(187);
var nonIterableRest = __webpack_require__(515);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

function isNextDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var nextDay = (0, _moment["default"])(a).add(1, 'day');
  return (0, _isSameDay["default"])(nextDay, b);
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getVisibleDays;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _toISOMonthString = _interopRequireDefault(__webpack_require__(75));

function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
  if (!_moment["default"].isMoment(month)) return {};
  var visibleDaysByMonth = {};
  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    var visibleDays = []; // set utc offset to get correct dates in future (when timezone changes)

    var baseDate = currentMonth.clone();
    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
    var currentDay = firstOfMonth.clone(); // days belonging to the previous month

    if (enableOutsideDays) {
      for (var j = 0; j < currentDay.weekday(); j += 1) {
        var prevDay = currentDay.clone().subtract(j + 1, 'day');
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(currentDay.clone());
      currentDay.add(1, 'day');
    }

    if (enableOutsideDays) {
      // weekday() returns the index of the day of the week according to the locale
      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
      if (currentDay.weekday() !== 0) {
        // days belonging to the next month
        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
          var nextDay = currentDay.clone().add(count, 'day');
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[(0, _toISOMonthString["default"])(currentMonth)] = visibleDays;
    currentMonth = currentMonth.clone().add(1, 'month');
  }

  return visibleDaysByMonth;
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addModifier = addModifier;
exports.deleteModifier = deleteModifier;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _isDayVisible = _interopRequireDefault(__webpack_require__(108));

var _toISODateString = _interopRequireDefault(__webpack_require__(57));

var _toISOMonthString = _interopRequireDefault(__webpack_require__(75));

var _getPreviousMonthMemoLast = _interopRequireDefault(__webpack_require__(518));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function addModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === _constants.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterAddition = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (!month[iso] || !month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers.add(modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterAddition);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (!month[iso] || !month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers.add(modifier);
      updatedDaysAfterAddition[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterAddition;
}

function deleteModifier(updatedDays, day, modifier, props, state) {
  var numberOfVisibleMonths = props.numberOfMonths,
      enableOutsideDays = props.enableOutsideDays,
      orientation = props.orientation;
  var firstVisibleMonth = state.currentMonth,
      visibleDays = state.visibleDays;
  var currentMonth = firstVisibleMonth;
  var numberOfMonths = numberOfVisibleMonths;

  if (orientation === _constants.VERTICAL_SCROLLABLE) {
    numberOfMonths = Object.keys(visibleDays).length;
  } else {
    currentMonth = (0, _getPreviousMonthMemoLast["default"])(currentMonth);
    numberOfMonths += 2;
  }

  if (!day || !(0, _isDayVisible["default"])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
    return updatedDays;
  }

  var iso = (0, _toISODateString["default"])(day);

  var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

  if (enableOutsideDays) {
    var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
      return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
    });
    updatedDaysAfterDeletion = monthsToUpdate.reduce(function (acc, monthIso) {
      var month = updatedDays[monthIso] || visibleDays[monthIso];

      if (month[iso] && month[iso].has(modifier)) {
        var modifiers = new Set(month[iso]);
        modifiers["delete"](modifier);
        acc[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
      }

      return acc;
    }, updatedDaysAfterDeletion);
  } else {
    var monthIso = (0, _toISOMonthString["default"])(day);
    var month = updatedDays[monthIso] || visibleDays[monthIso] || {};

    if (month[iso] && month[iso].has(modifier)) {
      var modifiers = new Set(month[iso]);
      modifiers["delete"](modifier);
      updatedDaysAfterDeletion[monthIso] = _objectSpread({}, month, (0, _defineProperty2["default"])({}, iso, modifiers));
    }
  }

  return updatedDaysAfterDeletion;
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPooledMoment;

var _moment = _interopRequireDefault(__webpack_require__(5));

var momentPool = new Map();

function getPooledMoment(dayString) {
  if (!momentPool.has(dayString)) {
    momentPool.set(dayString, (0, _moment["default"])(dayString));
  }

  return momentPool.get(dayString);
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(213));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _moment = _interopRequireDefault(__webpack_require__(5));

var _object = _interopRequireDefault(__webpack_require__(72));

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

var _isAfterDay = _interopRequireDefault(__webpack_require__(76));

var _getVisibleDays = _interopRequireDefault(__webpack_require__(215));

var _toISODateString = _interopRequireDefault(__webpack_require__(57));

var _modifiers = __webpack_require__(216);

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(59));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _constants = __webpack_require__(7);

var _DayPicker = _interopRequireDefault(__webpack_require__(109));

var _getPooledMoment = _interopRequireDefault(__webpack_require__(217));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  isOutsideRange: _propTypes["default"].func,
  isDayBlocked: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // DayPicker props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  numberOfMonths: _propTypes["default"].number,
  orientation: _ScrollableOrientationShape["default"],
  withPortal: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  noBorder: _propTypes["default"].bool,
  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  noNavButtons: _propTypes["default"].bool,
  noNavNextButton: _propTypes["default"].bool,
  noNavPrevButton: _propTypes["default"].bool,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onOutsideClick: _propTypes["default"].func,
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  // accessibility
  onBlur: _propTypes["default"].func,
  isFocused: _propTypes["default"].bool,
  showKeyboardShortcuts: _propTypes["default"].bool,
  onTab: _propTypes["default"].func,
  onShiftTab: _propTypes["default"].func,
  // i18n
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string,
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  date: undefined,
  // TODO: use null
  onDateChange: function onDateChange() {},
  focused: false,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  // DayPicker props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  daySize: _constants.DAY_SIZE,
  verticalHeight: null,
  noBorder: false,
  verticalBorderSpacing: undefined,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  dayPickerNavigationInlineStyles: null,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  noNavButtons: false,
  noNavNextButton: false,
  noNavPrevButton: false,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderCalendarInfo: null,
  renderMonthElement: null,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  onTab: function onTab() {},
  onShiftTab: function onShiftTab() {},
  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,
  dayAriaLabelFormat: undefined,
  isRTL: false
};

var DayPickerSingleDateController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerSingleDateController, _ref);
  var _proto = DayPickerSingleDateController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerSingleDateController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.today = (0, _moment["default"])();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      'blocked-calendar': function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      'blocked-out-of-range': function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      'highlighted-calendar': function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      selected: function selected(day) {
        return _this.isSelected(day);
      },
      'first-day-of-week': function firstDayOfWeek(day) {
        return _this.isFirstDayOfWeek(day);
      },
      'last-day-of-week': function lastDayOfWeek(day) {
        return _this.isLastDayOfWeek(day);
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayClick = _this.onDayClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMonthChange = _this.onMonthChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onYearChange = _this.onYearChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetNextScrollableMonths = _this.onGetNextScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onGetPrevScrollableMonths = _this.onGetPrevScrollableMonths.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var date = nextProps.date,
        focused = nextProps.focused,
        isOutsideRange = nextProps.isOutsideRange,
        isDayBlocked = nextProps.isDayBlocked,
        isDayHighlighted = nextProps.isDayHighlighted,
        initialVisibleMonth = nextProps.initialVisibleMonth,
        numberOfMonths = nextProps.numberOfMonths,
        enableOutsideDays = nextProps.enableOutsideDays;
    var _this$props = this.props,
        prevIsOutsideRange = _this$props.isOutsideRange,
        prevIsDayBlocked = _this$props.isDayBlocked,
        prevIsDayHighlighted = _this$props.isDayHighlighted,
        prevNumberOfMonths = _this$props.numberOfMonths,
        prevEnableOutsideDays = _this$props.enableOutsideDays,
        prevInitialVisibleMonth = _this$props.initialVisibleMonth,
        prevFocused = _this$props.focused,
        prevDate = _this$props.date;
    var visibleDays = this.state.visibleDays;
    var recomputeOutsideRange = false;
    var recomputeDayBlocked = false;
    var recomputeDayHighlighted = false;

    if (isOutsideRange !== prevIsOutsideRange) {
      this.modifiers['blocked-out-of-range'] = function (day) {
        return isOutsideRange(day);
      };

      recomputeOutsideRange = true;
    }

    if (isDayBlocked !== prevIsDayBlocked) {
      this.modifiers['blocked-calendar'] = function (day) {
        return isDayBlocked(day);
      };

      recomputeDayBlocked = true;
    }

    if (isDayHighlighted !== prevIsDayHighlighted) {
      this.modifiers['highlighted-calendar'] = function (day) {
        return isDayHighlighted(day);
      };

      recomputeDayHighlighted = true;
    }

    var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

    if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocused && focused) {
      var newMonthState = this.getStateForNewMonth(nextProps);
      var currentMonth = newMonthState.currentMonth;
      visibleDays = newMonthState.visibleDays;
      this.setState({
        currentMonth: currentMonth,
        visibleDays: visibleDays
      });
    }

    var didDateChange = date !== prevDate;
    var didFocusChange = focused !== prevFocused;
    var modifiers = {};

    if (didDateChange) {
      modifiers = this.deleteModifier(modifiers, prevDate, 'selected');
      modifiers = this.addModifier(modifiers, date, 'selected');
    }

    if (didFocusChange || recomputePropModifiers) {
      (0, _object["default"])(visibleDays).forEach(function (days) {
        Object.keys(days).forEach(function (day) {
          var momentObj = (0, _getPooledMoment["default"])(day);

          if (_this2.isBlocked(momentObj)) {
            modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
          } else {
            modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
          }

          if (didFocusChange || recomputeOutsideRange) {
            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
            }
          }

          if (didFocusChange || recomputeDayBlocked) {
            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
            }
          }

          if (didFocusChange || recomputeDayHighlighted) {
            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
            }
          }
        });
      });
    }

    var today = (0, _moment["default"])();

    if (!(0, _isSameDay["default"])(this.today, today)) {
      modifiers = this.deleteModifier(modifiers, this.today, 'today');
      modifiers = this.addModifier(modifiers, today, 'today');
      this.today = today;
    }

    if (Object.keys(modifiers).length > 0) {
      this.setState({
        visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
      });
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    this.today = (0, _moment["default"])();
  };

  _proto.onDayClick = function onDayClick(day, e) {
    if (e) e.preventDefault();
    if (this.isBlocked(day)) return;
    var _this$props2 = this.props,
        onDateChange = _this$props2.onDateChange,
        keepOpenOnDateSelect = _this$props2.keepOpenOnDateSelect,
        onFocusChange = _this$props2.onFocusChange,
        onClose = _this$props2.onClose;
    onDateChange(day);

    if (!keepOpenOnDateSelect) {
      onFocusChange({
        focused: false
      });
      onClose({
        date: day
      });
    }
  };

  _proto.onDayMouseEnter = function onDayMouseEnter(day) {
    if (this.isTouchDevice) return;
    var _this$state = this.state,
        hoverDate = _this$state.hoverDate,
        visibleDays = _this$state.visibleDays;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    modifiers = this.addModifier(modifiers, day, 'hovered');
    this.setState({
      hoverDate: day,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onDayMouseLeave = function onDayMouseLeave() {
    var _this$state2 = this.state,
        hoverDate = _this$state2.hoverDate,
        visibleDays = _this$state2.visibleDays;
    if (this.isTouchDevice || !hoverDate) return;
    var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
    this.setState({
      hoverDate: null,
      visibleDays: _objectSpread({}, visibleDays, {}, modifiers)
    });
  };

  _proto.onPrevMonthClick = function onPrevMonthClick() {
    var _this$props3 = this.props,
        onPrevMonthClick = _this$props3.onPrevMonthClick,
        numberOfMonths = _this$props3.numberOfMonths,
        enableOutsideDays = _this$props3.enableOutsideDays;
    var _this$state3 = this.state,
        currentMonth = _this$state3.currentMonth,
        visibleDays = _this$state3.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var prevMonth = currentMonth.clone().subtract(1, 'month');
    var prevMonthVisibleDays = (0, _getVisibleDays["default"])(prevMonth, 1, enableOutsideDays);
    this.setState({
      currentMonth: prevMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(prevMonthVisibleDays))
    }, function () {
      onPrevMonthClick(prevMonth.clone());
    });
  };

  _proto.onNextMonthClick = function onNextMonthClick() {
    var _this$props4 = this.props,
        onNextMonthClick = _this$props4.onNextMonthClick,
        numberOfMonths = _this$props4.numberOfMonths,
        enableOutsideDays = _this$props4.enableOutsideDays;
    var _this$state4 = this.state,
        currentMonth = _this$state4.currentMonth,
        visibleDays = _this$state4.visibleDays;
    var newVisibleDays = {};
    Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
      newVisibleDays[month] = visibleDays[month];
    });
    var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
    var nextMonthVisibleDays = (0, _getVisibleDays["default"])(nextMonth, 1, enableOutsideDays);
    var newCurrentMonth = currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth: newCurrentMonth,
      visibleDays: _objectSpread({}, newVisibleDays, {}, this.getModifiers(nextMonthVisibleDays))
    }, function () {
      onNextMonthClick(newCurrentMonth.clone());
    });
  };

  _proto.onMonthChange = function onMonthChange(newMonth) {
    var _this$props5 = this.props,
        numberOfMonths = _this$props5.numberOfMonths,
        enableOutsideDays = _this$props5.enableOutsideDays,
        orientation = _this$props5.orientation;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onYearChange = function onYearChange(newMonth) {
    var _this$props6 = this.props,
        numberOfMonths = _this$props6.numberOfMonths,
        enableOutsideDays = _this$props6.enableOutsideDays,
        orientation = _this$props6.orientation;
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var newVisibleDays = (0, _getVisibleDays["default"])(newMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths);
    this.setState({
      currentMonth: newMonth.clone(),
      visibleDays: this.getModifiers(newVisibleDays)
    });
  };

  _proto.onGetNextScrollableMonths = function onGetNextScrollableMonths() {
    var _this$props7 = this.props,
        numberOfMonths = _this$props7.numberOfMonths,
        enableOutsideDays = _this$props7.enableOutsideDays;
    var _this$state5 = this.state,
        currentMonth = _this$state5.currentMonth,
        visibleDays = _this$state5.visibleDays;
    var numberOfVisibleMonths = Object.keys(visibleDays).length;
    var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(nextMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.onGetPrevScrollableMonths = function onGetPrevScrollableMonths() {
    var _this$props8 = this.props,
        numberOfMonths = _this$props8.numberOfMonths,
        enableOutsideDays = _this$props8.enableOutsideDays;
    var _this$state6 = this.state,
        currentMonth = _this$state6.currentMonth,
        visibleDays = _this$state6.visibleDays;
    var firstPreviousMonth = currentMonth.clone().subtract(numberOfMonths, 'month');
    var newVisibleDays = (0, _getVisibleDays["default"])(firstPreviousMonth, numberOfMonths, enableOutsideDays, true);
    this.setState({
      currentMonth: firstPreviousMonth.clone(),
      visibleDays: _objectSpread({}, visibleDays, {}, this.getModifiers(newVisibleDays))
    });
  };

  _proto.getFirstFocusableDay = function getFirstFocusableDay(newMonth) {
    var _this3 = this;

    var _this$props9 = this.props,
        date = _this$props9.date,
        numberOfMonths = _this$props9.numberOfMonths;
    var focusedDate = newMonth.clone().startOf('month');

    if (date) {
      focusedDate = date.clone();
    }

    if (this.isBlocked(focusedDate)) {
      var days = [];
      var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
      var currentDay = focusedDate.clone();

      while (!(0, _isAfterDay["default"])(currentDay, lastVisibleDay)) {
        currentDay = currentDay.clone().add(1, 'day');
        days.push(currentDay);
      }

      var viableDays = days.filter(function (day) {
        return !_this3.isBlocked(day) && (0, _isAfterDay["default"])(day, focusedDate);
      });

      if (viableDays.length > 0) {
        var _viableDays = (0, _slicedToArray2["default"])(viableDays, 1);

        focusedDate = _viableDays[0];
      }
    }

    return focusedDate;
  };

  _proto.getModifiers = function getModifiers(visibleDays) {
    var _this4 = this;

    var modifiers = {};
    Object.keys(visibleDays).forEach(function (month) {
      modifiers[month] = {};
      visibleDays[month].forEach(function (day) {
        modifiers[month][(0, _toISODateString["default"])(day)] = _this4.getModifiersForDay(day);
      });
    });
    return modifiers;
  };

  _proto.getModifiersForDay = function getModifiersForDay(day) {
    var _this5 = this;

    return new Set(Object.keys(this.modifiers).filter(function (modifier) {
      return _this5.modifiers[modifier](day);
    }));
  };

  _proto.getStateForNewMonth = function getStateForNewMonth(nextProps) {
    var _this6 = this;

    var initialVisibleMonth = nextProps.initialVisibleMonth,
        date = nextProps.date,
        numberOfMonths = nextProps.numberOfMonths,
        orientation = nextProps.orientation,
        enableOutsideDays = nextProps.enableOutsideDays;
    var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
      return date;
    } : function () {
      return _this6.today;
    });
    var currentMonth = initialVisibleMonthThunk();
    var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
    var visibleDays = this.getModifiers((0, _getVisibleDays["default"])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
    return {
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
  };

  _proto.addModifier = function addModifier(updatedDays, day, modifier) {
    return (0, _modifiers.addModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.deleteModifier = function deleteModifier(updatedDays, day, modifier) {
    return (0, _modifiers.deleteModifier)(updatedDays, day, modifier, this.props, this.state);
  };

  _proto.isBlocked = function isBlocked(day) {
    var _this$props10 = this.props,
        isDayBlocked = _this$props10.isDayBlocked,
        isOutsideRange = _this$props10.isOutsideRange;
    return isDayBlocked(day) || isOutsideRange(day);
  };

  _proto.isHovered = function isHovered(day) {
    var _ref2 = this.state || {},
        hoverDate = _ref2.hoverDate;

    return (0, _isSameDay["default"])(day, hoverDate);
  };

  _proto.isSelected = function isSelected(day) {
    var date = this.props.date;
    return (0, _isSameDay["default"])(day, date);
  };

  _proto.isToday = function isToday(day) {
    return (0, _isSameDay["default"])(day, this.today);
  };

  _proto.isFirstDayOfWeek = function isFirstDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === (firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek());
  };

  _proto.isLastDayOfWeek = function isLastDayOfWeek(day) {
    var firstDayOfWeek = this.props.firstDayOfWeek;
    return day.day() === ((firstDayOfWeek || _moment["default"].localeData().firstDayOfWeek()) + 6) % 7;
  };

  _proto.render = function render() {
    var _this$props11 = this.props,
        numberOfMonths = _this$props11.numberOfMonths,
        orientation = _this$props11.orientation,
        monthFormat = _this$props11.monthFormat,
        renderMonthText = _this$props11.renderMonthText,
        renderWeekHeaderElement = _this$props11.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props11.dayPickerNavigationInlineStyles,
        navPosition = _this$props11.navPosition,
        navPrev = _this$props11.navPrev,
        navNext = _this$props11.navNext,
        renderNavPrevButton = _this$props11.renderNavPrevButton,
        renderNavNextButton = _this$props11.renderNavNextButton,
        noNavButtons = _this$props11.noNavButtons,
        noNavPrevButton = _this$props11.noNavPrevButton,
        noNavNextButton = _this$props11.noNavNextButton,
        onOutsideClick = _this$props11.onOutsideClick,
        onShiftTab = _this$props11.onShiftTab,
        onTab = _this$props11.onTab,
        withPortal = _this$props11.withPortal,
        focused = _this$props11.focused,
        enableOutsideDays = _this$props11.enableOutsideDays,
        hideKeyboardShortcutsPanel = _this$props11.hideKeyboardShortcutsPanel,
        daySize = _this$props11.daySize,
        firstDayOfWeek = _this$props11.firstDayOfWeek,
        renderCalendarDay = _this$props11.renderCalendarDay,
        renderDayContents = _this$props11.renderDayContents,
        renderCalendarInfo = _this$props11.renderCalendarInfo,
        renderMonthElement = _this$props11.renderMonthElement,
        calendarInfoPosition = _this$props11.calendarInfoPosition,
        isFocused = _this$props11.isFocused,
        isRTL = _this$props11.isRTL,
        phrases = _this$props11.phrases,
        dayAriaLabelFormat = _this$props11.dayAriaLabelFormat,
        onBlur = _this$props11.onBlur,
        showKeyboardShortcuts = _this$props11.showKeyboardShortcuts,
        weekDayFormat = _this$props11.weekDayFormat,
        verticalHeight = _this$props11.verticalHeight,
        noBorder = _this$props11.noBorder,
        transitionDuration = _this$props11.transitionDuration,
        verticalBorderSpacing = _this$props11.verticalBorderSpacing,
        horizontalMonthPadding = _this$props11.horizontalMonthPadding;
    var _this$state7 = this.state,
        currentMonth = _this$state7.currentMonth,
        visibleDays = _this$state7.visibleDays;
    return _react["default"].createElement(_DayPicker["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      modifiers: visibleDays,
      numberOfMonths: numberOfMonths,
      onDayClick: this.onDayClick,
      onDayMouseEnter: this.onDayMouseEnter,
      onDayMouseLeave: this.onDayMouseLeave,
      onPrevMonthClick: this.onPrevMonthClick,
      onNextMonthClick: this.onNextMonthClick,
      onMonthChange: this.onMonthChange,
      onYearChange: this.onYearChange,
      onGetNextScrollableMonths: this.onGetNextScrollableMonths,
      onGetPrevScrollableMonths: this.onGetPrevScrollableMonths,
      monthFormat: monthFormat,
      withPortal: withPortal,
      hidden: !focused,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: function initialVisibleMonth() {
        return currentMonth;
      },
      firstDayOfWeek: firstDayOfWeek,
      onOutsideClick: onOutsideClick,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      noNavButtons: noNavButtons,
      noNavNextButton: noNavNextButton,
      noNavPrevButton: noNavPrevButton,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isFocused,
      getFirstFocusableDay: this.getFirstFocusableDay,
      onBlur: onBlur,
      onTab: onTab,
      onShiftTab: onShiftTab,
      phrases: phrases,
      daySize: daySize,
      isRTL: isRTL,
      showKeyboardShortcuts: showKeyboardShortcuts,
      weekDayFormat: weekDayFormat,
      dayAriaLabelFormat: dayAriaLabelFormat,
      verticalHeight: verticalHeight,
      noBorder: noBorder,
      transitionDuration: transitionDuration,
      verticalBorderSpacing: verticalBorderSpacing,
      horizontalMonthPadding: horizontalMonthPadding
    });
  };

  return DayPickerSingleDateController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = DayPickerSingleDateController;
DayPickerSingleDateController.propTypes =  false ? propTypes : {};
DayPickerSingleDateController.defaultProps = defaultProps;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _OrientationShape = _interopRequireDefault(__webpack_require__(198));

var _AnchorDirectionShape = _interopRequireDefault(__webpack_require__(199));

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _DayOfWeekShape = _interopRequireDefault(__webpack_require__(44));

var _CalendarInfoPositionShape = _interopRequireDefault(__webpack_require__(59));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _default = {
  // required props for a functional interactive SingleDatePicker
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func.isRequired,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func.isRequired,
  // input related props
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  screenReaderInputMessage: _propTypes["default"].string,
  showClearDate: _propTypes["default"].bool,
  customCloseIcon: _propTypes["default"].node,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  keepFocusOnInput: _propTypes["default"].bool,
  // calendar presentation and interaction related props
  renderMonthText: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderMonthElement: (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes["default"].func, 'renderMonthText', 'renderMonthElement'),
  renderWeekHeaderElement: _propTypes["default"].func,
  orientation: _OrientationShape["default"],
  anchorDirection: _AnchorDirectionShape["default"],
  openDirection: _OpenDirectionShape["default"],
  horizontalMargin: _propTypes["default"].number,
  withPortal: _propTypes["default"].bool,
  withFullScreenPortal: _propTypes["default"].bool,
  appendToBody: _propTypes["default"].bool,
  disableScroll: _propTypes["default"].bool,
  initialVisibleMonth: _propTypes["default"].func,
  firstDayOfWeek: _DayOfWeekShape["default"],
  numberOfMonths: _propTypes["default"].number,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDate: _propTypes["default"].bool,
  renderCalendarInfo: _propTypes["default"].func,
  calendarInfoPosition: _CalendarInfoPositionShape["default"],
  hideKeyboardShortcutsPanel: _propTypes["default"].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes["default"].bool,
  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
  horizontalMonthPadding: _airbnbPropTypes.nonNegativeInteger,
  // navigation related props
  dayPickerNavigationInlineStyles: _propTypes["default"].object,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  // day presentation and interaction related props
  renderCalendarDay: _propTypes["default"].func,
  renderDayContents: _propTypes["default"].func,
  enableOutsideDays: _propTypes["default"].bool,
  isDayBlocked: _propTypes["default"].func,
  isOutsideRange: _propTypes["default"].func,
  isDayHighlighted: _propTypes["default"].func,
  // internationalization props
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  monthFormat: _propTypes["default"].string,
  weekDayFormat: _propTypes["default"].string,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerPhrases)),
  dayAriaLabelFormat: _propTypes["default"].string
};
exports["default"] = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _DateInput = _interopRequireDefault(__webpack_require__(205));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _CloseButton = _interopRequireDefault(__webpack_require__(61));

var _CalendarIcon = _interopRequireDefault(__webpack_require__(211));

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  id: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  displayValue: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  focused: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  // describes actual DOM focus
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  showCaret: _propTypes["default"].bool,
  showClearDate: _propTypes["default"].bool,
  customCloseIcon: _propTypes["default"].node,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  customInputIcon: _propTypes["default"].node,
  isRTL: _propTypes["default"].bool,
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  onChange: _propTypes["default"].func,
  onClearDate: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDownShiftTab: _propTypes["default"].func,
  onKeyDownTab: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerInputPhrases))
})) : {};
var defaultProps = {
  children: null,
  placeholder: 'Select Date',
  ariaLabel: undefined,
  displayValue: '',
  screenReaderMessage: '',
  focused: false,
  isFocused: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customCloseIcon: null,
  customInputIcon: null,
  isRTL: false,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  onChange: function onChange() {},
  onClearDate: function onClearDate() {},
  onFocus: function onFocus() {},
  onKeyDownShiftTab: function onKeyDownShiftTab() {},
  onKeyDownTab: function onKeyDownTab() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  // i18n
  phrases: _defaultPhrases.SingleDatePickerInputPhrases
};

function SingleDatePickerInput(_ref) {
  var id = _ref.id,
      children = _ref.children,
      placeholder = _ref.placeholder,
      ariaLabel = _ref.ariaLabel,
      displayValue = _ref.displayValue,
      focused = _ref.focused,
      isFocused = _ref.isFocused,
      disabled = _ref.disabled,
      required = _ref.required,
      readOnly = _ref.readOnly,
      showCaret = _ref.showCaret,
      showClearDate = _ref.showClearDate,
      showDefaultInputIcon = _ref.showDefaultInputIcon,
      inputIconPosition = _ref.inputIconPosition,
      phrases = _ref.phrases,
      onClearDate = _ref.onClearDate,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
      onKeyDownTab = _ref.onKeyDownTab,
      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
      screenReaderMessage = _ref.screenReaderMessage,
      customCloseIcon = _ref.customCloseIcon,
      customInputIcon = _ref.customInputIcon,
      openDirection = _ref.openDirection,
      isRTL = _ref.isRTL,
      noBorder = _ref.noBorder,
      block = _ref.block,
      small = _ref.small,
      regular = _ref.regular,
      verticalSpacing = _ref.verticalSpacing,
      styles = _ref.styles;

  var calendarIcon = customInputIcon || _react["default"].createElement(_CalendarIcon["default"], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon_svg));

  var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));

  var screenReaderText = screenReaderMessage || phrases.keyboardForwardNavigationInstructions;

  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon), {
    type: "button",
    disabled: disabled,
    "aria-label": phrases.focusStartDate,
    onClick: onFocus
  }), calendarIcon);

  return _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate), inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react["default"].createElement(_DateInput["default"], {
    id: id,
    placeholder: placeholder,
    ariaLabel: ariaLabel,
    displayValue: displayValue,
    screenReaderMessage: screenReaderText,
    focused: focused,
    isFocused: isFocused,
    disabled: disabled,
    required: required,
    readOnly: readOnly,
    showCaret: showCaret,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDownShiftTab: onKeyDownShiftTab,
    onKeyDownTab: onKeyDownTab,
    onKeyDownArrowDown: onKeyDownArrowDown,
    onKeyDownQuestionMark: onKeyDownQuestionMark,
    openDirection: openDirection,
    verticalSpacing: verticalSpacing,
    small: small,
    regular: regular,
    block: block
  }), children, showClearDate && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
    type: "button",
    "aria-label": phrases.clearDate,
    disabled: disabled,
    onClick: onClearDate
  }), closeIcon), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
}

SingleDatePickerInput.propTypes =  false ? propTypes : {};
SingleDatePickerInput.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      border = _ref2$reactDates.border,
      color = _ref2$reactDates.color;
  return {
    SingleDatePickerInput: {
      display: 'inline-block',
      backgroundColor: color.background
    },
    SingleDatePickerInput__withBorder: {
      borderColor: color.border,
      borderWidth: border.pickerInput.borderWidth,
      borderStyle: border.pickerInput.borderStyle,
      borderRadius: border.pickerInput.borderRadius
    },
    SingleDatePickerInput__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePickerInput__disabled: {
      backgroundColor: color.disabled
    },
    SingleDatePickerInput__block: {
      display: 'block'
    },
    SingleDatePickerInput__showClearDate: {
      paddingRight: 30 // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_clearDate: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      padding: 10,
      margin: '0 10px 0 5px',
      // TODO: should be noflip wrapped and handled by an isRTL prop
      position: 'absolute',
      right: 0,
      // TODO: should be noflip wrapped and handled by an isRTL prop
      top: '50%',
      transform: 'translateY(-50%)'
    },
    SingleDatePickerInput_clearDate__default: {
      ':focus': {
        background: color.core.border,
        borderRadius: '50%'
      },
      ':hover': {
        background: color.core.border,
        borderRadius: '50%'
      }
    },
    SingleDatePickerInput_clearDate__small: {
      padding: 6
    },
    SingleDatePickerInput_clearDate__hide: {
      visibility: 'hidden'
    },
    SingleDatePickerInput_clearDate_svg: {
      fill: color.core.grayLight,
      height: 12,
      width: 15,
      verticalAlign: 'middle'
    },
    SingleDatePickerInput_clearDate_svg__small: {
      height: 9
    },
    SingleDatePickerInput_calendarIcon: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: 10,
      margin: '0 5px 0 10px' // TODO: should be noflip wrapped and handled by an isRTL prop

    },
    SingleDatePickerInput_calendarIcon_svg: {
      fill: color.core.grayLight,
      height: 15,
      width: 14,
      verticalAlign: 'middle'
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePickerInput);

exports["default"] = _default;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Request = __webpack_require__(222);
var extractResponseProps = __webpack_require__(223);

function Response(props) {
  this.request = props.request;
  this.xhr = props.xhr;
  this.headers = props.headers || {};
  this.status = props.status || 0;
  this.text = props.text;
  this.body = props.body;
  this.contentType = props.contentType;
  this.isHttpError = props.status >= 400;
}

Response.prototype.header = Request.prototype.header;

Response.fromRequest = function(req) {
  return new Response(extractResponseProps(req));
};


module.exports = Response;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Request(optsOrUrl) {
  var opts = typeof optsOrUrl === 'string' ? {url: optsOrUrl} : optsOrUrl || {};
  this.method = opts.method ? opts.method.toUpperCase() : 'GET';
  this.url = opts.url;
  this.headers = opts.headers || {};
  this.body = opts.body;
  this.timeout = opts.timeout || 0;
  this.errorOn404 = opts.errorOn404 != null ? opts.errorOn404 : true;
  this.onload = opts.onload;
  this.onerror = opts.onerror;
}

Request.prototype.abort = function() {
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  return this;
};

Request.prototype.header = function(name, value) {
  var k;
  for (k in this.headers) {
    if (this.headers.hasOwnProperty(k)) {
      if (name.toLowerCase() === k.toLowerCase()) {
        if (arguments.length === 1) {
          return this.headers[k];
        }

        delete this.headers[k];
        break;
      }
    }
  }
  if (value != null) {
    this.headers[name] = value;
    return value;
  }
};


module.exports = Request;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(110);

module.exports = function(req) {
  var xhr = req.xhr;
  var props = {request: req, xhr: xhr};

  // Try to create the response from the request. If the request was aborted,
  // accesssing properties of the XHR may throw an error, so we wrap in a
  // try/catch.
  try {
    var lines, i, m, headers = {};
    if (xhr.getAllResponseHeaders) {
      lines = xhr.getAllResponseHeaders().split('\n');
      for (i = 0; i < lines.length; i++) {
        if ((m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/))) {
          headers[m[1]] = m[2];
        }
      }
    }

    props = extend(props, {
      status: xhr.status,
      contentType: xhr.contentType || (xhr.getResponseHeader && xhr.getResponseHeader('Content-Type')),
      headers: headers,
      text: xhr.responseText,
      body: xhr.response || xhr.responseText
    });
  } catch (err) {}

  return props;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A "once" utility.
module.exports = function(fn) {
  var result, called = false;
  return function() {
    if (!called) {
      called = true;
      result = fn.apply(this, arguments);
    }
    return result;
  };
};


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Blur_scss__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Blur_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Blur_scss__);
var cov_12w8xipjq7=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Blur\\index.js',hash='8f21b971755297838c0576503e2a905d6034b07c',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Blur\\index.js',statementMap:{'0':{start:{line:10,column:2},end:{line:10,column:35}},'1':{start:{line:13,column:5},end:{line:13,column:38}},'2':{start:{line:16,column:19},end:{line:16,column:32}},'3':{start:{line:17,column:2},end:{line:19,column:3}},'4':{start:{line:18,column:3},end:{line:18,column:49}},'5':{start:{line:21,column:5},end:{line:23,column:3}},'6':{start:{line:27,column:27},end:{line:32,column:1}},'7':{start:{line:28,column:4},end:{line:31,column:5}},'8':{start:{line:29,column:35},end:{line:29,column:79}},'9':{start:{line:30,column:35},end:{line:30,column:79}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:9,column:21},end:{line:9,column:22}},loc:{start:{line:9,column:27},end:{line:11,column:2}},line:9},'1':{name:'(anonymous_1)',decl:{start:{line:12,column:27},end:{line:12,column:28}},loc:{start:{line:12,column:33},end:{line:14,column:5}},line:12},'2':{name:'(anonymous_2)',decl:{start:{line:15,column:1},end:{line:15,column:2}},loc:{start:{line:15,column:10},end:{line:24,column:2}},line:15},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:27},end:{line:27,column:28}},loc:{start:{line:27,column:39},end:{line:32,column:1}},line:27},'4':{name:'(anonymous_4)',decl:{start:{line:29,column:29},end:{line:29,column:30}},loc:{start:{line:29,column:35},end:{line:29,column:79}},line:29},'5':{name:'(anonymous_5)',decl:{start:{line:30,column:29},end:{line:30,column:30}},loc:{start:{line:30,column:35},end:{line:30,column:79}},line:30}},branchMap:{'0':{loc:{start:{line:17,column:2},end:{line:19,column:3}},type:'if',locations:[{start:{line:17,column:2},end:{line:19,column:3}},{start:{line:17,column:2},end:{line:19,column:3}}],line:17}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Blur=function(_ref){_inherits(Blur,_ref);function Blur(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Blur);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Blur.__proto__||Object.getPrototypeOf(Blur)).call.apply(_ref2,[this].concat(args))),_this),_this.componentDidMount=function(){cov_12w8xipjq7.f[0]++;cov_12w8xipjq7.s[0]++;_this.props.onHelpersBlurAppend();},_this.componentWillUnmount=function(){cov_12w8xipjq7.f[1]++;cov_12w8xipjq7.s[1]++;_this.props.onHelpersBlurRemove();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Blur,[{key:'render',value:function render(){cov_12w8xipjq7.f[2]++;var classNames=(cov_12w8xipjq7.s[2]++,__WEBPACK_IMPORTED_MODULE_4__Blur_scss___default.a.a_blur);cov_12w8xipjq7.s[3]++;if(this.props.theme=='light'){cov_12w8xipjq7.b[0][0]++;cov_12w8xipjq7.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__Blur_scss___default.a.isLight;}else{cov_12w8xipjq7.b[0][1]++;}cov_12w8xipjq7.s[5]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__Blur_scss___default.a.background,onClick:this.props.clicked}),this.props.children);}}]);return Blur;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_12w8xipjq7.s[6]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_12w8xipjq7.f[3]++;cov_12w8xipjq7.s[7]++;return{onHelpersBlurAppend:function onHelpersBlurAppend(){cov_12w8xipjq7.f[4]++;cov_12w8xipjq7.s[8]++;return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_index__["U" /* helpersBlurAppend */]());},onHelpersBlurRemove:function onHelpersBlurRemove(){cov_12w8xipjq7.f[5]++;cov_12w8xipjq7.s[9]++;return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_index__["V" /* helpersBlurRemove */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(null,mapDispatchToProps)(Blur));

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"comparisonTable":"ScrollTable__comparisonTable___2L0As","comparisonTableRow":"ScrollTable__comparisonTableRow___1pZHT","comparisonTableColumn":"ScrollTable__comparisonTableColumn___2sp66","isRight":"ScrollTable__isRight___39i7_","isBold":"ScrollTable__isBold___1SJZ8","comparisonNote":"ScrollTable__comparisonNote___2Gr2x","content":"ScrollTable__content___3OcZw","icon":"ScrollTable__icon___359Dy","isHiddenDesktop":"ScrollTable__isHiddenDesktop___1hhBx","isHiddenMobile":"ScrollTable__isHiddenMobile___1g8LA","jobList":"ScrollTable__jobList___3xDRV","jobListRow":"ScrollTable__jobListRow___3SOdT","average":"ScrollTable__average___3ewZb","jobListCell":"ScrollTable__jobListCell___6TmhI","spacer":"ScrollTable__spacer___vhShu","jobListCellTitle":"ScrollTable__jobListCellTitle___2SVL1","jobListCellHelp":"ScrollTable__jobListCellHelp___3OE4k","jobListRowActive":"ScrollTable__jobListRowActive___1AoTT","jobListCellLineLeft":"ScrollTable__jobListCellLineLeft___3cV-b","textWrap":"ScrollTable__textWrap____z3mK","helpIcon":"ScrollTable__helpIcon___3Xdf2","subLine":"ScrollTable__subLine___1Vm9t","titleColumn":"ScrollTable__titleColumn___15Vb-","shadow":"ScrollTable__shadow___1YjJk","hasHelpIcon":"ScrollTable__hasHelpIcon___2N4tZ","lastColumn":"ScrollTable__lastColumn___2GTUu","firstCellMover":"ScrollTable__firstCellMover___3rwvg","cellIcon":"ScrollTable__cellIcon___19D1w","tendencyUp":"ScrollTable__tendencyUp___2f_vq","tendencyEven":"ScrollTable__tendencyEven___2SO_O","tendencyDown":"ScrollTable__tendencyDown___38WjF","iconWithHint":"ScrollTable__iconWithHint___2Jb1A","small":"ScrollTable__small___3D5En","grey":"ScrollTable__grey___1XbAJ","recommended":"ScrollTable__recommended___2N88X","parent":"ScrollTable__parent___1nv9G","noPrint":"ScrollTable__noPrint___d9x4T"};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(229);
module.exports = __webpack_require__(114);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(230).enable();
  window.Promise = __webpack_require__(232);
}

// fetch() polyfill for making API calls.
__webpack_require__(233);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(62);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(113);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(113);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(62),n=__webpack_require__(77),p=__webpack_require__(78),q=__webpack_require__(79),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(77),ea=__webpack_require__(0),m=__webpack_require__(236),A=__webpack_require__(62),C=__webpack_require__(79),fa=__webpack_require__(237),ha=__webpack_require__(238),ja=__webpack_require__(239),ka=__webpack_require__(78);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(240);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(241);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(246);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(244);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34)))

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(116);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(248);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(252);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(34), __webpack_require__(251)(module)))

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(117);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxToastr = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(6);

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _ToastrBox = __webpack_require__(268);

var _ToastrBox2 = _interopRequireDefault(_ToastrBox);

var _ToastrConfirm = __webpack_require__(272);

var _ToastrConfirm2 = _interopRequireDefault(_ToastrConfirm);

var _actions = __webpack_require__(124);

var actions = _interopRequireWildcard(_actions);

var _toastrEmitter = __webpack_require__(126);

var _utils = __webpack_require__(46);

var _constants = __webpack_require__(84);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ReduxToastr = exports.ReduxToastr = function (_React$Component) {
  _inherits(ReduxToastr, _React$Component);

  function ReduxToastr(props) {
    _classCallCheck(this, ReduxToastr);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.toastrFired = {};
    _this.toastrPositions = ['top-left', 'top-right', 'top-center', 'bottom-left', 'bottom-right', 'bottom-center'];

    (0, _utils.updateConfig)(props);
    return _this;
  }

  ReduxToastr.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        add = _props.add,
        showConfirm = _props.showConfirm,
        clean = _props.clean,
        removeByType = _props.removeByType,
        remove = _props.remove;

    _toastrEmitter.EE.on('toastr/confirm', showConfirm);
    _toastrEmitter.EE.on('add/toastr', add);
    _toastrEmitter.EE.on('clean/toastr', clean);
    _toastrEmitter.EE.on('removeByType/toastr', removeByType);
    _toastrEmitter.EE.on('remove/toastr', remove);
  };

  ReduxToastr.prototype.componentWillUnmount = function componentWillUnmount() {
    _toastrEmitter.EE.removeListener('toastr/confirm');
    _toastrEmitter.EE.removeListener('add/toastr');
    _toastrEmitter.EE.removeListener('clean/toastr');
    _toastrEmitter.EE.removeListener('removeByType/toastr');
    _toastrEmitter.EE.removeListener('remove/toastr');
    this.toastrFired = {};
  };

  ReduxToastr.prototype._addToMemory = function _addToMemory(id) {
    this.toastrFired[id] = true;
  };

  ReduxToastr.prototype._renderToastrForPosition = function _renderToastrForPosition(position) {
    var _this2 = this;

    var toastrs = this.props.toastr.toastrs;


    if (toastrs) {
      return toastrs.filter(function (item) {
        return item.position === position;
      }).map(function (item) {
        var mergedItem = _extends({}, item, {
          options: _extends({
            progressBar: _this2.props.progressBar,
            transitionIn: _this2.props.transitionIn,
            transitionOut: _this2.props.transitionOut
          }, item.options)
        });

        return _react2.default.createElement(
          'span',
          { key: item.id },
          _react2.default.createElement(_ToastrBox2.default, _extends({
            inMemory: _this2.toastrFired,
            addToMemory: function addToMemory() {
              return _this2._addToMemory(item.id);
            },
            item: mergedItem
          }, _this2.props)),
          item.options && item.options.attention && _react2.default.createElement('div', {
            onClick: function onClick() {
              if (typeof item.options.onAttentionClick === 'function') {
                item.options.onAttentionClick(item.id);
              } else {
                _this2.props.remove(item.id);
              }
            },
            className: 'toastr-attention' })
        );
      });
    }
  };

  ReduxToastr.prototype._renderToastrs = function _renderToastrs() {
    var _this3 = this;

    var toastr = this.props.toastr;

    var width = toastr.toastrs && toastr.toastrs[0] && toastr.toastrs[0].options && toastr.toastrs[0].options.width;
    var style = width ? { width: width } : {};
    return _react2.default.createElement(
      'span',
      null,
      this.toastrPositions.map(function (position) {
        return _react2.default.createElement(
          'div',
          { key: position, className: position, style: style },
          _this3._renderToastrForPosition(position)
        );
      })
    );
  };

  ReduxToastr.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        toastr = _props2.toastr;

    return _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)('redux-toastr', className), 'aria-live': 'assertive' },
      toastr.confirm && _react2.default.createElement(_ToastrConfirm2.default, _extends({
        confirm: toastr.confirm
      }, this.props)),
      this._renderToastrs()
    );
  };

  return ReduxToastr;
}(_react2.default.Component);

ReduxToastr.displayName = 'ReduxToastr';
ReduxToastr.propTypes = {
  toastr: _propTypes2.default.object,
  position: _propTypes2.default.string,
  newestOnTop: _propTypes2.default.bool,
  timeOut: _propTypes2.default.number,
  confirmOptions: _propTypes2.default.object,
  progressBar: _propTypes2.default.bool,
  transitionIn: _propTypes2.default.oneOf(_constants.TRANSITIONS.in),
  transitionOut: _propTypes2.default.oneOf(_constants.TRANSITIONS.out),
  preventDuplicates: _propTypes2.default.bool
};
ReduxToastr.defaultProps = {
  position: 'top-right',
  newestOnTop: true,
  timeOut: 5000,
  progressBar: false,
  transitionIn: _constants.TRANSITIONS.in[0],
  transitionOut: _constants.TRANSITIONS.out[0],
  preventDuplicates: false,
  confirmOptions: {
    okText: 'ok',
    cancelText: 'cancel'
  }
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    toastr: state.toastr ? state.toastr : state.get('toastr')
  };
}, actions)(ReduxToastr);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(258);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(82);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(266);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(122);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(122);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(123);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(267);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(82);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressBar = __webpack_require__(269);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Icon = __webpack_require__(270);

var _Icon2 = _interopRequireDefault(_Icon);

var _utils = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } //  eslint-disable-line no-unused-vars


var ToastrBox = function (_React$Component) {
  _inherits(ToastrBox, _React$Component);

  function ToastrBox(props) {
    _classCallCheck(this, ToastrBox);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _props$item$options = props.item.options,
        transitionIn = _props$item$options.transitionIn,
        transitionOut = _props$item$options.transitionOut;


    _this.isHiding = false;
    _this.shouldClose = false;
    _this.intervalId = null;
    _this.ignoreIsHiding = false;

    _this.transitionIn = transitionIn || _this.props.transitionIn;
    _this.transitionOut = transitionOut || _this.props.transitionOut;

    _this.state = { progressBar: null };

    (0, _utils._bind)(['renderSubComponent', 'renderIcon', 'renderToastr', 'renderCloseButton', 'renderMessage', '_onAnimationComplete', '_removeToastr', '_setTransition', '_clearTransition', '_setIntervalId', '_setIsHiding', '_setShouldClose'], _this);
    return _this;
  }

  ToastrBox.prototype.componentDidMount = function componentDidMount() {
    var item = this.props.item;

    if (this.props.inMemory[item.id]) return;

    var timeOut = this._getItemTimeOut();

    if (timeOut) {
      this._setIntervalId(setTimeout(this._removeToastr, timeOut));
    }

    if (timeOut && item.options.progressBar) {
      this.setState({ progressBar: { duration: this._getItemTimeOut() } });
    }

    this._setTransition();
    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    this.props.addToMemory(item.id);
  };

  ToastrBox.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ToastrBox.prototype.handleClick = function handleClick() {
    var onCloseButtonClick = this.props.item.options.onCloseButtonClick;

    this.ignoreIsHiding = true;

    if (onCloseButtonClick) {
      onCloseButtonClick();
    }

    this._setShouldClose(true);
    this._removeToastr();
  };

  ToastrBox.prototype.mouseEnter = function mouseEnter() {
    clearTimeout(this.intervalId);

    this._setIntervalId(null);
    this._setIsHiding(false);

    var progressBar = this.props.item.options.progressBar;

    var timeOut = this._getItemTimeOut();

    if (timeOut && progressBar) {
      this.setState({ progressBar: null });
    }
  };

  ToastrBox.prototype.mouseLeave = function mouseLeave() {
    var removeOnHover = this.props.item.options.removeOnHover;


    if (!this.isHiding && (removeOnHover || this.shouldClose)) {
      var interval = removeOnHover === true ? 1000 : removeOnHover;
      this._setIntervalId(setTimeout(this._removeToastr, interval));

      var progressBar = this.props.item.options.progressBar;

      var timeOut = this._getItemTimeOut();

      if (timeOut && progressBar) {
        this.setState({ progressBar: { duration: interval } });
      }
    }
  };

  ToastrBox.prototype.renderSubComponent = function renderSubComponent() {
    var _this2 = this;

    var _props$item = this.props.item,
        id = _props$item.id,
        options = _props$item.options;


    var removeCurrentToastrFunc = function removeCurrentToastrFunc() {
      return _this2.props.remove(id);
    };

    if ((0, _react.isValidElement)(options.component)) {
      return _react2.default.cloneElement(options.component, {
        remove: removeCurrentToastrFunc
      });
    }

    return _react2.default.createElement(options.component, { remove: removeCurrentToastrFunc });
  };

  ToastrBox.prototype.renderIcon = function renderIcon() {
    var _props$item2 = this.props.item,
        type = _props$item2.type,
        options = _props$item2.options;


    if ((0, _react.isValidElement)(options.icon)) {
      return _react2.default.cloneElement(options.icon);
    }

    var iconName = type === 'light' ? options.icon : type;
    return _react2.default.createElement(_Icon2.default, { name: iconName });
  };

  ToastrBox.prototype.renderCloseButton = function renderCloseButton() {
    return _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'close-toastr',
        onClick: this.handleClick.bind(this)
      },
      '\u2715'
    );
  };

  ToastrBox.prototype.renderToastr = function renderToastr() {
    var _props$item3 = this.props.item,
        type = _props$item3.type,
        options = _props$item3.options,
        message = _props$item3.message,
        title = _props$item3.title;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-left-container' },
        _react2.default.createElement(
          'div',
          { className: 'rrt-holder' },
          this.renderIcon()
        )
      ),
      options.status && type === 'light' && _react2.default.createElement('div', { className: (0, _classnames2.default)('toastr-status', options.status) }),
      _react2.default.createElement(
        'div',
        { className: 'rrt-middle-container' },
        title && _react2.default.createElement(
          'div',
          { className: 'rrt-title' },
          title
        ),
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-text' },
          message
        ),
        options.component && this.renderSubComponent()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-right-container' },
        options.showCloseButton && this.renderCloseButton()
      ),
      this.state.progressBar ? _react2.default.createElement(_ProgressBar2.default, this.state.progressBar) : null
    );
  };

  ToastrBox.prototype.renderMessage = function renderMessage() {
    var _props$item4 = this.props.item,
        title = _props$item4.title,
        message = _props$item4.message,
        options = _props$item4.options;


    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'rrt-title' },
        title,
        this.renderCloseButton()
      ),
      _react2.default.createElement(
        'div',
        { className: 'rrt-text' },
        message,
        options.component && this.renderSubComponent()
      )
    );
  };

  ToastrBox.prototype.toastr = function toastr() {
    if (this.props.item.type === 'message') {
      return this.renderMessage();
    }

    return this.renderToastr();
  };

  ToastrBox.prototype._getItemTimeOut = function _getItemTimeOut() {
    var item = this.props.item;
    var timeOut = item.options.timeOut;

    if (typeof timeOut === 'undefined') {
      timeOut = this.props.timeOut;
    }

    return timeOut;
  };

  ToastrBox.prototype._onAnimationComplete = function _onAnimationComplete() {
    var _props = this.props,
        remove = _props.remove,
        item = _props.item;
    var options = item.options,
        id = item.id;


    if (this.isHiding || this.ignoreIsHiding) {
      this._setIsHiding(false);
      this.ignoreIsHiding = false;
      remove(id);
      if (options.onHideComplete) {
        options.onHideComplete();
      }
    } else if (!this.isHiding && options.onShowComplete) {
      options.onShowComplete();
    }
  };

  ToastrBox.prototype._removeToastr = function _removeToastr() {
    if (!this.isHiding) {
      this._setIsHiding(true);
      this._setTransition(true);
      (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, this._onAnimationComplete);
    }
  };

  ToastrBox.prototype._setTransition = function _setTransition(hide) {
    var _this3 = this;

    var animationType = hide ? this.transitionOut : this.transitionIn;

    var onEndListener = function onEndListener(e) {
      if (e && e.target == _this3.toastrBoxElement) {
        _this3.toastrBoxElement.classList.remove(animationType);
      }
    };

    (0, _utils.onCSSTransitionEnd)(this.toastrBoxElement, onEndListener);
    this.toastrBoxElement.classList.add(animationType);
  };

  ToastrBox.prototype._clearTransition = function _clearTransition() {
    this.toastrBoxElement.classList.remove(this.transitionIn, this.transitionOut);
  };

  ToastrBox.prototype._setIntervalId = function _setIntervalId(intervalId) {
    this.intervalId = intervalId;
  };

  ToastrBox.prototype._setIsHiding = function _setIsHiding(val) {
    this.isHiding = val;
  };

  ToastrBox.prototype._setShouldClose = function _setShouldClose(val) {
    this.shouldClose = val;
  };

  ToastrBox.prototype.render = function render() {
    var _this4 = this;

    var _props$item5 = this.props.item,
        options = _props$item5.options,
        type = _props$item5.type;


    return _react2.default.createElement(
      'div',
      {
        ref: function ref(_ref) {
          return _this4.toastrBoxElement = _ref;
        },
        className: (0, _classnames2.default)('toastr', 'animated', 'rrt-' + type, options.className),
        onMouseEnter: this.mouseEnter.bind(this),
        onMouseLeave: this.mouseLeave.bind(this)
      },
      this.toastr()
    );
  };

  return ToastrBox;
}(_react2.default.Component);

ToastrBox.displayName = 'ToastrBox';
ToastrBox.propTypes = {
  item: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrBox;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ProgressBar = function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = { percent: 100 };
    _this.intervalId = null;
    return _this;
  }

  ProgressBar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var distance = 100 / (this.props.duration / 10);
    this.intervalId = setInterval(function () {
      var percent = _this2.state.percent - distance;

      _this2.setState({ percent: percent > 0 ? percent : 0 });
    }, 10);
  };

  ProgressBar.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.state.percent <= 0 && this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  };

  ProgressBar.prototype.render = function render() {
    var percent = this.state.percent;


    return _react2.default.createElement(
      'div',
      { className: 'rrt-progress-container' },
      _react2.default.createElement('div', { className: 'rrt-progressbar', style: { width: percent + '%' } })
    );
  };

  return ProgressBar;
}(_react2.default.Component);

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  duration: _propTypes2.default.number.isRequired
};
exports.default = ProgressBar;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = __webpack_require__(271);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var size = this.props.size;

    var styles = {
      width: size,
      height: size
    };

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(this.props.className, 'toastr-icon'),
        xmlns: 'http://www.w3.org/2000/svg',
        preserveAspectRatio: 'xMidYMid meet',
        viewBox: '0 0 ' + this.props.size + ' ' + this.props.size,
        style: styles
      },
      (0, _icons2.default)(this.props.name)
    );
  };

  return Icon;
}(_react2.default.Component);

Icon.displayName = 'ReduxToastrIcon';
Icon.defaultProps = {
  size: 32
};
exports.default = Icon;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  switch (name) {
    case 'success':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M27 4l-15 15-7-7-5 5 12 12 20-20z' })
      );
    case 'info':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M14 9.5c0-0.825 0.675-1.5 1.5-1.5h1c0.825 0 1.5 0.675 1.5 1.5v1c0 0.825-0.675 1.5-1.5 1.5h-1c-0.825 0-1.5-0.675-1.5-1.5v-1z' }),
        _react2.default.createElement('path', { d: 'M20 24h-8v-2h2v-6h-2v-2h6v8h2z' }),
        _react2.default.createElement('path', { d: 'M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13z' })
      );
    case 'warning':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M16 2.899l13.409 26.726h-26.819l13.409-26.726zM16 0c-0.69 0-1.379 0.465-1.903 1.395l-13.659 27.222c-1.046 1.86-0.156 3.383 1.978 3.383h27.166c2.134 0 3.025-1.522 1.978-3.383h0l-13.659-27.222c-0.523-0.93-1.213-1.395-1.903-1.395v0z' }),
        _react2.default.createElement('path', { d: 'M18 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z' }),
        _react2.default.createElement('path', { d: 'M16 22c-1.105 0-2-0.895-2-2v-6c0-1.105 0.895-2 2-2s2 0.895 2 2v6c0 1.105-0.895 2-2 2z' })
      );
    case 'error':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { d: 'M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0z M12,19.66 c-0.938,0-1.58-0.723-1.58-1.66c0-0.964,0.669-1.66,1.58-1.66c0.963,0,1.58,0.696,1.58,1.66C13.58,18.938,12.963,19.66,12,19.66z M12.622,13.321c-0.239,0.815-0.992,0.829-1.243,0c-0.289-0.956-1.316-4.585-1.316-6.942c0-3.11,3.891-3.125,3.891,0 C13.953,8.75,12.871,12.473,12.622,13.321z' })
      );
    default:
      return null;
  }
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(46);

var _Button = __webpack_require__(273);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var ENTER = 13;
var ESC = 27;

var ToastrConfirm = function (_React$Component) {
  _inherits(ToastrConfirm, _React$Component);

  function ToastrConfirm(props) {
    _classCallCheck(this, ToastrConfirm);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    var _this$props = _this.props,
        confirmOptions = _this$props.confirmOptions,
        confirm = _this$props.confirm;
    var _confirm$options = confirm.options,
        okText = _confirm$options.okText,
        cancelText = _confirm$options.cancelText,
        transitionIn = _confirm$options.transitionIn,
        transitionOut = _confirm$options.transitionOut,
        disableCancel = _confirm$options.disableCancel;


    _this.okText = okText || confirmOptions.okText;
    _this.cancelText = cancelText || confirmOptions.cancelText;
    _this.transitionIn = transitionIn || confirmOptions.transitionIn || props.transitionIn;
    _this.transitionOut = transitionOut || confirmOptions.transitionOut || props.transitionOut;
    _this.disableCancel = disableCancel || confirmOptions.disableCancel;
    (0, _utils._bind)('setTransition removeConfirm handleOnKeyUp handleOnKeyDown', _this);
    _this.isKeyDown = false;
    return _this;
  }

  ToastrConfirm.prototype.componentDidMount = function componentDidMount() {
    this.isHiding = false;
    this.hasClicked = false;
    this.confirmHolderElement.focus();

    if (this.props.confirm.show) {
      this.setTransition(true);
    }
  };

  ToastrConfirm.prototype.handleOnKeyDown = function handleOnKeyDown(e) {
    if ((0, _utils.keyCode)(e) == ENTER) {
      e.preventDefault();
    }
    this.isKeyDown = true;
  };

  ToastrConfirm.prototype.handleButtonClick = function handleButtonClick(callback) {
    var _this2 = this;

    if (this.hasClicked) return;
    this.hasClicked = true;

    var onAnimationEnd = function onAnimationEnd() {
      _this2.removeConfirm();
      if (callback) {
        callback();
      }
    };

    this.setTransition();
    (0, _utils.onCSSTransitionEnd)(this.confirmElement, onAnimationEnd);
  };

  ToastrConfirm.prototype.handleConfirmClick = function handleConfirmClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onOk : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.handleCancelClick = function handleCancelClick() {
    var callback = this.props.confirm.options ? this.props.confirm.options.onCancel : null;
    this.handleButtonClick(callback);
  };

  ToastrConfirm.prototype.setTransition = function setTransition(add) {
    if (add) {
      this.isHiding = false;
      this.confirmElement.classList.add(this.transitionIn);
      if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.add('toastr-confirm-active');
    }

    this.isHiding = true;
    this.confirmElement.classList.remove(this.transitionIn);
    this.confirmElement.classList.add(this.transitionOut);
  };

  ToastrConfirm.prototype.removeConfirm = function removeConfirm() {
    this.isHiding = false;
    this.props.hideConfirm();
    if ((0, _utils.isBrowser)()) return document.querySelector('body').classList.remove('toastr-confirm-active');
  };

  ToastrConfirm.prototype.handleOnKeyUp = function handleOnKeyUp(e) {
    var code = (0, _utils.keyCode)(e);
    if (code == ESC && !this.disableCancel) {
      this.handleCancelClick();
    } else if (code == ESC && this.disableCancel) {
      this.handleConfirmClick();
    } else if (code == ENTER && this.isKeyDown) {
      this.isKeyDown = false;
      this.handleConfirmClick();
    }
  };

  ToastrConfirm.prototype.containsOkButton = function containsOkButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.ok === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.containsCancelButton = function containsCancelButton(buttons) {
    return buttons && buttons.filter(function (button) {
      return button.cancel === true;
    }).length > 0;
  };

  ToastrConfirm.prototype.getCustomButtonHandler = function getCustomButtonHandler(config) {
    var _this3 = this;

    if (config.ok === true) {
      return this.handleConfirmClick.bind(this);
    }
    if (config.cancel === true) {
      return this.handleCancelClick.bind(this);
    }
    return function () {
      return _this3.handleButtonClick(config.handler);
    };
  };

  ToastrConfirm.prototype.getCustomButtonText = function getCustomButtonText(config) {
    if (config.ok === true) {
      return this.okText;
    }
    if (config.cancel === true) {
      return this.cancelText;
    }
    return config.text;
  };

  ToastrConfirm.prototype.getCustomButtonClassName = function getCustomButtonClassName(config) {
    if (config.ok === true) {
      return 'rrt-ok-btn';
    }
    if (config.cancel === true) {
      return 'rrt-cancel-btn';
    }
    return config.className;
  };

  ToastrConfirm.prototype.render = function render() {
    var _this4 = this;

    var _props$confirm = this.props.confirm,
        options = _props$confirm.options,
        message = _props$confirm.message;


    return _react2.default.createElement(
      'div',
      {
        className: 'rrt-confirm-holder',
        tabIndex: '-1',
        ref: function ref(_ref2) {
          return _this4.confirmHolderElement = _ref2;
        },
        onKeyDown: this.handleOnKeyDown,
        onKeyUp: this.handleOnKeyUp,
        role: 'alert'
      },
      _react2.default.createElement(
        'div',
        { className: 'rrt-confirm animated', ref: function ref(_ref) {
            return _this4.confirmElement = _ref;
          } },
        message && _react2.default.createElement(
          'div',
          { className: 'rrt-message' },
          message
        ),
        options.component && _react2.default.createElement(options.component, null),
        _react2.default.createElement(
          'div',
          { className: 'rrt-buttons-holder' },
          !this.containsOkButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-ok-btn', onClick: function onClick() {
                return _this4.handleConfirmClick();
              } },
            this.okText
          ),
          !this.disableCancel && !this.containsCancelButton(options.buttons) && _react2.default.createElement(
            _Button2.default,
            { className: 'rrt-cancel-btn', onClick: this.handleCancelClick.bind(this) },
            this.cancelText
          ),
          options.buttons && options.buttons.map(function (button, index) {
            if (button.cancel === true && _this4.disableCancel) {
              return null;
            }

            var handler = _this4.getCustomButtonHandler(button);
            var text = _this4.getCustomButtonText(button);
            var className = _this4.getCustomButtonClassName(button);

            return _react2.default.createElement(
              _Button2.default,
              { className: className, onClick: handler, key: index },
              text
            );
          })
        )
      ),
      _react2.default.createElement('div', { className: 'shadow' })
    );
  };

  return ToastrConfirm;
}(_react2.default.Component);

ToastrConfirm.displayName = 'ToastrConfirm';
ToastrConfirm.propTypes = {
  confirm: _propTypes2.default.shape({
    options: _propTypes2.default.shape({
      transitionIn: _propTypes2.default.string,
      transitionOut: _propTypes2.default.string
    })
  })
};
exports.default = ToastrConfirm;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  return _react2.default.createElement(
    'button',
    { type: 'button', onClick: function onClick() {
        return props.onClick();
      }, className: 'rrt-button ' + props.className },
    props.children
  );
};

Button.displayName = 'ReduxConfirmButton';

exports.default = Button;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(26);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(85);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(86);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(26);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(85);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(86);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(281);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(88);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(54);

var _LocationUtils = __webpack_require__(85);

var _createTransitionManager = __webpack_require__(86);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(285)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(287);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(289);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(290);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(291);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(292);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(293);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(64);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(55);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(133);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(133);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(90);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(295);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(297);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(89);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(89);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(300);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(132);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1b83yxq3k5=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\menu.js',hash='388959d6a4e466234fbbedc2c0d4936758f87bc4',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\menu.js',statementMap:{'0':{start:{line:4,column:21},end:{line:6,column:1}},'1':{start:{line:8,column:24},end:{line:10,column:1}},'2':{start:{line:9,column:4},end:{line:9,column:50}},'3':{start:{line:12,column:25},end:{line:14,column:1}},'4':{start:{line:13,column:4},end:{line:13,column:51}},'5':{start:{line:16,column:16},end:{line:22,column:1}},'6':{start:{line:17,column:4},end:{line:21,column:5}},'7':{start:{line:18,column:41},end:{line:18,column:81}},'8':{start:{line:19,column:42},end:{line:19,column:83}},'9':{start:{line:20,column:17},end:{line:20,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:24},end:{line:8,column:25}},loc:{start:{line:8,column:45},end:{line:10,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:12,column:25},end:{line:12,column:26}},loc:{start:{line:12,column:46},end:{line:14,column:1}},line:12},'2':{name:'(anonymous_2)',decl:{start:{line:16,column:16},end:{line:16,column:17}},loc:{start:{line:16,column:52},end:{line:22,column:1}},line:16}},branchMap:{'0':{loc:{start:{line:16,column:18},end:{line:16,column:38}},type:'default-arg',locations:[{start:{line:16,column:26},end:{line:16,column:38}}],line:16},'1':{loc:{start:{line:17,column:4},end:{line:21,column:5}},type:'switch',locations:[{start:{line:18,column:5},end:{line:18,column:81}},{start:{line:19,column:5},end:{line:19,column:83}},{start:{line:20,column:8},end:{line:20,column:30}}],line:17}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0},b:{'0':[0],'1':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1b83yxq3k5.s[0]++,{open:false});cov_1b83yxq3k5.s[1]++;var helpersMenuOpen=function helpersMenuOpen(state,action){cov_1b83yxq3k5.f[0]++;cov_1b83yxq3k5.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{open:true});};cov_1b83yxq3k5.s[3]++;var helpersMenuClose=function helpersMenuClose(state,action){cov_1b83yxq3k5.f[1]++;cov_1b83yxq3k5.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{open:false});};cov_1b83yxq3k5.s[5]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1b83yxq3k5.b[0][0]++,initialState);var action=arguments[1];cov_1b83yxq3k5.f[2]++;cov_1b83yxq3k5.s[6]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_59" /* HELPERS_MENU_OPEN */]:cov_1b83yxq3k5.b[1][0]++;cov_1b83yxq3k5.s[7]++;return helpersMenuOpen(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_58" /* HELPERS_MENU_CLOSE */]:cov_1b83yxq3k5.b[1][1]++;cov_1b83yxq3k5.s[8]++;return helpersMenuClose(state,action);default:cov_1b83yxq3k5.b[1][2]++;cov_1b83yxq3k5.s[9]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_2g46ry3ee6=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\blur.js',hash='08678b49092b5e8c84902d5322091a3525026da1',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\blur.js',statementMap:{'0':{start:{line:4,column:21},end:{line:6,column:1}},'1':{start:{line:8,column:26},end:{line:10,column:1}},'2':{start:{line:9,column:4},end:{line:9,column:80}},'3':{start:{line:12,column:26},end:{line:14,column:1}},'4':{start:{line:13,column:4},end:{line:13,column:80}},'5':{start:{line:16,column:16},end:{line:22,column:1}},'6':{start:{line:17,column:4},end:{line:21,column:5}},'7':{start:{line:18,column:43},end:{line:18,column:85}},'8':{start:{line:19,column:43},end:{line:19,column:85}},'9':{start:{line:20,column:17},end:{line:20,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:26},end:{line:8,column:27}},loc:{start:{line:8,column:47},end:{line:10,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:12,column:26},end:{line:12,column:27}},loc:{start:{line:12,column:47},end:{line:14,column:1}},line:12},'2':{name:'(anonymous_2)',decl:{start:{line:16,column:16},end:{line:16,column:17}},loc:{start:{line:16,column:52},end:{line:22,column:1}},line:16}},branchMap:{'0':{loc:{start:{line:16,column:18},end:{line:16,column:38}},type:'default-arg',locations:[{start:{line:16,column:26},end:{line:16,column:38}}],line:16},'1':{loc:{start:{line:17,column:4},end:{line:21,column:5}},type:'switch',locations:[{start:{line:18,column:5},end:{line:18,column:85}},{start:{line:19,column:5},end:{line:19,column:85}},{start:{line:20,column:8},end:{line:20,column:30}}],line:17}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0},b:{'0':[0],'1':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_2g46ry3ee6.s[0]++,{appended_blurs:0});cov_2g46ry3ee6.s[1]++;var helpersBlurAppend=function helpersBlurAppend(state,action){cov_2g46ry3ee6.f[0]++;cov_2g46ry3ee6.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{appended_blurs:state.appended_blurs+1});};cov_2g46ry3ee6.s[3]++;var helpersBlurRemove=function helpersBlurRemove(state,action){cov_2g46ry3ee6.f[1]++;cov_2g46ry3ee6.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{appended_blurs:state.appended_blurs-1});};cov_2g46ry3ee6.s[5]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_2g46ry3ee6.b[0][0]++,initialState);var action=arguments[1];cov_2g46ry3ee6.f[2]++;cov_2g46ry3ee6.s[6]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_48" /* HELPERS_BLUR_APPEND */]:cov_2g46ry3ee6.b[1][0]++;cov_2g46ry3ee6.s[7]++;return helpersBlurAppend(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_49" /* HELPERS_BLUR_REMOVE */]:cov_2g46ry3ee6.b[1][1]++;cov_2g46ry3ee6.s[8]++;return helpersBlurRemove(state,action);default:cov_2g46ry3ee6.b[1][2]++;cov_2g46ry3ee6.s[9]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_2esgt60yx8=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\countriesstates.js',hash='c4ec42fbf7d0a81f8e6a2082146ecb35c7a56c00',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\countriesstates.js',statementMap:{'0':{start:{line:4,column:21},end:{line:9,column:1}},'1':{start:{line:12,column:41},end:{line:14,column:1}},'2':{start:{line:13,column:4},end:{line:13,column:94}},'3':{start:{line:16,column:43},end:{line:23,column:1}},'4':{start:{line:17,column:4},end:{line:22,column:8}},'5':{start:{line:25,column:40},end:{line:27,column:1}},'6':{start:{line:26,column:4},end:{line:26,column:74}},'7':{start:{line:29,column:16},end:{line:36,column:1}},'8':{start:{line:30,column:4},end:{line:35,column:5}},'9':{start:{line:31,column:63},end:{line:31,column:120}},'10':{start:{line:32,column:65},end:{line:32,column:124}},'11':{start:{line:33,column:62},end:{line:33,column:118}},'12':{start:{line:34,column:17},end:{line:34,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:12,column:41},end:{line:12,column:42}},loc:{start:{line:12,column:62},end:{line:14,column:1}},line:12},'1':{name:'(anonymous_1)',decl:{start:{line:16,column:43},end:{line:16,column:44}},loc:{start:{line:16,column:64},end:{line:23,column:1}},line:16},'2':{name:'(anonymous_2)',decl:{start:{line:25,column:40},end:{line:25,column:41}},loc:{start:{line:25,column:61},end:{line:27,column:1}},line:25},'3':{name:'(anonymous_3)',decl:{start:{line:29,column:16},end:{line:29,column:17}},loc:{start:{line:29,column:52},end:{line:36,column:1}},line:29}},branchMap:{'0':{loc:{start:{line:29,column:18},end:{line:29,column:38}},type:'default-arg',locations:[{start:{line:29,column:26},end:{line:29,column:38}}],line:29},'1':{loc:{start:{line:30,column:4},end:{line:35,column:5}},type:'switch',locations:[{start:{line:31,column:8},end:{line:31,column:120}},{start:{line:32,column:8},end:{line:32,column:124}},{start:{line:33,column:8},end:{line:33,column:118}},{start:{line:34,column:8},end:{line:34,column:30}}],line:30}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_2esgt60yx8.s[0]++,{states:[],error:false,loading:false,fetched:false/* ------------------ Countries States Fetch ------------------- */});cov_2esgt60yx8.s[1]++;var helpersCountriesStatesFetchStart=function helpersCountriesStatesFetchStart(state,action){cov_2esgt60yx8.f[0]++;cov_2esgt60yx8.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,fetched:false,states:[]});};cov_2esgt60yx8.s[3]++;var helpersCountriesStatesFetchSuccess=function helpersCountriesStatesFetchSuccess(state,action){cov_2esgt60yx8.f[1]++;cov_2esgt60yx8.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{states:action.states,loading:false,error:false,fetched:true});};cov_2esgt60yx8.s[5]++;var helpersCountriesStatesFetchFail=function helpersCountriesStatesFetchFail(state,action){cov_2esgt60yx8.f[2]++;cov_2esgt60yx8.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_2esgt60yx8.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_2esgt60yx8.b[0][0]++,initialState);var action=arguments[1];cov_2esgt60yx8.f[3]++;cov_2esgt60yx8.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_51" /* HELPERS_COUNTRIES_STATES_FETCH_START */]:cov_2esgt60yx8.b[1][0]++;cov_2esgt60yx8.s[9]++;return helpersCountriesStatesFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_52" /* HELPERS_COUNTRIES_STATES_FETCH_SUCCESS */]:cov_2esgt60yx8.b[1][1]++;cov_2esgt60yx8.s[10]++;return helpersCountriesStatesFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_50" /* HELPERS_COUNTRIES_STATES_FETCH_FAIL */]:cov_2esgt60yx8.b[1][2]++;cov_2esgt60yx8.s[11]++;return helpersCountriesStatesFetchFail(state,action);default:cov_2esgt60yx8.b[1][3]++;cov_2esgt60yx8.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_29z1kuhpx1=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\notifications.js',hash='12539a01f1743043ff27feffc01cf60e8b4b8b57',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\notifications.js',statementMap:{'0':{start:{line:4,column:21},end:{line:11,column:1}},'1':{start:{line:14,column:47},end:{line:16,column:1}},'2':{start:{line:15,column:4},end:{line:15,column:115}},'3':{start:{line:18,column:49},end:{line:28,column:1}},'4':{start:{line:19,column:4},end:{line:27,column:8}},'5':{start:{line:30,column:46},end:{line:32,column:1}},'6':{start:{line:31,column:4},end:{line:31,column:107}},'7':{start:{line:34,column:16},end:{line:41,column:1}},'8':{start:{line:35,column:4},end:{line:40,column:5}},'9':{start:{line:36,column:69},end:{line:36,column:132}},'10':{start:{line:37,column:71},end:{line:37,column:136}},'11':{start:{line:38,column:68},end:{line:38,column:130}},'12':{start:{line:39,column:17},end:{line:39,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:14,column:47},end:{line:14,column:48}},loc:{start:{line:14,column:68},end:{line:16,column:1}},line:14},'1':{name:'(anonymous_1)',decl:{start:{line:18,column:49},end:{line:18,column:50}},loc:{start:{line:18,column:70},end:{line:28,column:1}},line:18},'2':{name:'(anonymous_2)',decl:{start:{line:30,column:46},end:{line:30,column:47}},loc:{start:{line:30,column:67},end:{line:32,column:1}},line:30},'3':{name:'(anonymous_3)',decl:{start:{line:34,column:16},end:{line:34,column:17}},loc:{start:{line:34,column:52},end:{line:41,column:1}},line:34}},branchMap:{'0':{loc:{start:{line:34,column:18},end:{line:34,column:38}},type:'default-arg',locations:[{start:{line:34,column:26},end:{line:34,column:38}}],line:34},'1':{loc:{start:{line:35,column:4},end:{line:40,column:5}},type:'switch',locations:[{start:{line:36,column:8},end:{line:36,column:132}},{start:{line:37,column:8},end:{line:37,column:136}},{start:{line:38,column:8},end:{line:38,column:130}},{start:{line:39,column:8},end:{line:39,column:30}}],line:35}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_29z1kuhpx1.s[0]++,{machines:{error:false,loading:false,fetched:false,list:[]}/* ------------------  Notifications Machines Fetch ------------------- */});cov_29z1kuhpx1.s[1]++;var helpersNotificationsMachinesFetchStart=function helpersNotificationsMachinesFetchStart(state,action){cov_29z1kuhpx1.f[0]++;cov_29z1kuhpx1.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machines:Object.assign({},state.machines,{loading:true,error:false,fetched:false})});};cov_29z1kuhpx1.s[3]++;var helpersNotificationsMachinesFetchSuccess=function helpersNotificationsMachinesFetchSuccess(state,action){cov_29z1kuhpx1.f[1]++;cov_29z1kuhpx1.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machines:Object.assign({},state.machines,{list:action.list,loading:false,error:false,fetched:true})});};cov_29z1kuhpx1.s[5]++;var helpersNotificationsMachinesFetchFail=function helpersNotificationsMachinesFetchFail(state,action){cov_29z1kuhpx1.f[2]++;cov_29z1kuhpx1.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machines:Object.assign({},state.machines,{loading:false,error:action.error})});};cov_29z1kuhpx1.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_29z1kuhpx1.b[0][0]++,initialState);var action=arguments[1];cov_29z1kuhpx1.f[3]++;cov_29z1kuhpx1.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_61" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_START */]:cov_29z1kuhpx1.b[1][0]++;cov_29z1kuhpx1.s[9]++;return helpersNotificationsMachinesFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_62" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS */]:cov_29z1kuhpx1.b[1][1]++;cov_29z1kuhpx1.s[10]++;return helpersNotificationsMachinesFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_60" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL */]:cov_29z1kuhpx1.b[1][2]++;cov_29z1kuhpx1.s[11]++;return helpersNotificationsMachinesFetchFail(state,action);default:cov_29z1kuhpx1.b[1][3]++;cov_29z1kuhpx1.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_6pwy5npzz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\design.js',hash='f51f830baec1aff3bfe42353930a89e04abb1041',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\helpers\\design.js',statementMap:{'0':{start:{line:4,column:21},end:{line:10,column:1}},'1':{start:{line:13,column:33},end:{line:15,column:1}},'2':{start:{line:14,column:4},end:{line:14,column:108}},'3':{start:{line:17,column:35},end:{line:24,column:1}},'4':{start:{line:18,column:4},end:{line:23,column:8}},'5':{start:{line:26,column:32},end:{line:28,column:1}},'6':{start:{line:27,column:4},end:{line:27,column:74}},'7':{start:{line:30,column:33},end:{line:32,column:1}},'8':{start:{line:31,column:4},end:{line:31,column:93}},'9':{start:{line:34,column:36},end:{line:36,column:1}},'10':{start:{line:35,column:4},end:{line:35,column:62}},'11':{start:{line:38,column:16},end:{line:47,column:1}},'12':{start:{line:39,column:4},end:{line:46,column:5}},'13':{start:{line:40,column:53},end:{line:40,column:102}},'14':{start:{line:41,column:55},end:{line:41,column:106}},'15':{start:{line:42,column:52},end:{line:42,column:100}},'16':{start:{line:43,column:53},end:{line:43,column:102}},'17':{start:{line:44,column:56},end:{line:44,column:108}},'18':{start:{line:45,column:17},end:{line:45,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:33},end:{line:13,column:34}},loc:{start:{line:13,column:54},end:{line:15,column:1}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:35},end:{line:17,column:36}},loc:{start:{line:17,column:56},end:{line:24,column:1}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:26,column:32},end:{line:26,column:33}},loc:{start:{line:26,column:53},end:{line:28,column:1}},line:26},'3':{name:'(anonymous_3)',decl:{start:{line:30,column:33},end:{line:30,column:34}},loc:{start:{line:30,column:54},end:{line:32,column:1}},line:30},'4':{name:'(anonymous_4)',decl:{start:{line:34,column:36},end:{line:34,column:37}},loc:{start:{line:34,column:57},end:{line:36,column:1}},line:34},'5':{name:'(anonymous_5)',decl:{start:{line:38,column:16},end:{line:38,column:17}},loc:{start:{line:38,column:52},end:{line:47,column:1}},line:38}},branchMap:{'0':{loc:{start:{line:38,column:18},end:{line:38,column:38}},type:'default-arg',locations:[{start:{line:38,column:26},end:{line:38,column:38}}],line:38},'1':{loc:{start:{line:39,column:4},end:{line:46,column:5}},type:'switch',locations:[{start:{line:40,column:8},end:{line:40,column:102}},{start:{line:41,column:8},end:{line:41,column:106}},{start:{line:42,column:8},end:{line:42,column:100}},{start:{line:43,column:8},end:{line:43,column:102}},{start:{line:44,column:8},end:{line:44,column:108}},{start:{line:45,column:8},end:{line:45,column:30}}],line:39}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},b:{'0':[0],'1':[0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_6pwy5npzz.s[0]++,{error:false,loading:false,uploaded:false,percent:0,details:{}});/* ------------------ Design Upload ------------------- */cov_6pwy5npzz.s[1]++;var helpersDesignuploadStart=function helpersDesignuploadStart(state,action){cov_6pwy5npzz.f[0]++;cov_6pwy5npzz.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,uploaded:false,percent:0,details:{}});};cov_6pwy5npzz.s[3]++;var helpersDesignuploadSuccess=function helpersDesignuploadSuccess(state,action){cov_6pwy5npzz.f[1]++;cov_6pwy5npzz.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,uploaded:true,details:action.details});};cov_6pwy5npzz.s[5]++;var helpersDesignuploadFail=function helpersDesignuploadFail(state,action){cov_6pwy5npzz.f[2]++;cov_6pwy5npzz.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_6pwy5npzz.s[7]++;var helpersDesignuploadReset=function helpersDesignuploadReset(state,action){cov_6pwy5npzz.f[3]++;cov_6pwy5npzz.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{uploaded:false,error:false,details:{},percent:0});};cov_6pwy5npzz.s[9]++;var helpersDesignuploadProgress=function helpersDesignuploadProgress(state,action){cov_6pwy5npzz.f[4]++;cov_6pwy5npzz.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{percent:action.percent});};cov_6pwy5npzz.s[11]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_6pwy5npzz.b[0][0]++,initialState);var action=arguments[1];cov_6pwy5npzz.f[5]++;cov_6pwy5npzz.s[12]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_56" /* HELPERS_DESIGNUPLOAD_START */]:cov_6pwy5npzz.b[1][0]++;cov_6pwy5npzz.s[13]++;return helpersDesignuploadStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_57" /* HELPERS_DESIGNUPLOAD_SUCCESS */]:cov_6pwy5npzz.b[1][1]++;cov_6pwy5npzz.s[14]++;return helpersDesignuploadSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_53" /* HELPERS_DESIGNUPLOAD_FAIL */]:cov_6pwy5npzz.b[1][2]++;cov_6pwy5npzz.s[15]++;return helpersDesignuploadFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_55" /* HELPERS_DESIGNUPLOAD_RESET */]:cov_6pwy5npzz.b[1][3]++;cov_6pwy5npzz.s[16]++;return helpersDesignuploadReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_54" /* HELPERS_DESIGNUPLOAD_PROGRESS */]:cov_6pwy5npzz.b[1][4]++;cov_6pwy5npzz.s[17]++;return helpersDesignuploadProgress(state,action);default:cov_6pwy5npzz.b[1][5]++;cov_6pwy5npzz.s[18]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_bc1rxv0ov=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\fetching.js',hash='1e0230303d706c067c457aa0cf369d46efb68443',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\fetching.js',statementMap:{'0':{start:{line:4,column:21},end:{line:7,column:1}},'1':{start:{line:9,column:17},end:{line:11,column:1}},'2':{start:{line:10,column:4},end:{line:10,column:130}},'3':{start:{line:13,column:21},end:{line:15,column:1}},'4':{start:{line:14,column:4},end:{line:14,column:109}},'5':{start:{line:17,column:16},end:{line:23,column:1}},'6':{start:{line:18,column:4},end:{line:22,column:5}},'7':{start:{line:19,column:32},end:{line:19,column:65}},'8':{start:{line:20,column:36},end:{line:20,column:73}},'9':{start:{line:21,column:17},end:{line:21,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:9,column:17},end:{line:9,column:18}},loc:{start:{line:9,column:53},end:{line:11,column:1}},line:9},'1':{name:'(anonymous_1)',decl:{start:{line:13,column:21},end:{line:13,column:22}},loc:{start:{line:13,column:57},end:{line:15,column:1}},line:13},'2':{name:'(anonymous_2)',decl:{start:{line:17,column:16},end:{line:17,column:17}},loc:{start:{line:17,column:52},end:{line:23,column:1}},line:17}},branchMap:{'0':{loc:{start:{line:9,column:19},end:{line:9,column:39}},type:'default-arg',locations:[{start:{line:9,column:27},end:{line:9,column:39}}],line:9},'1':{loc:{start:{line:13,column:23},end:{line:13,column:43}},type:'default-arg',locations:[{start:{line:13,column:31},end:{line:13,column:43}}],line:13},'2':{loc:{start:{line:17,column:18},end:{line:17,column:38}},type:'default-arg',locations:[{start:{line:17,column:26},end:{line:17,column:38}}],line:17},'3':{loc:{start:{line:18,column:4},end:{line:22,column:5}},type:'switch',locations:[{start:{line:19,column:5},end:{line:19,column:65}},{start:{line:20,column:5},end:{line:20,column:73}},{start:{line:21,column:8},end:{line:21,column:30}}],line:18}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0},b:{'0':[0],'1':[0],'2':[0],'3':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_bc1rxv0ov.s[0]++,{running_requests:0,show_globalSpinner:true});cov_bc1rxv0ov.s[1]++;var fetching=function fetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_bc1rxv0ov.b[0][0]++,initialState);var action=arguments[1];cov_bc1rxv0ov.f[0]++;cov_bc1rxv0ov.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{running_requests:state.running_requests+1,show_globalSpinner:action.show_globalSpinner});};cov_bc1rxv0ov.s[3]++;var not_fetching=function not_fetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_bc1rxv0ov.b[1][0]++,initialState);var action=arguments[1];cov_bc1rxv0ov.f[1]++;cov_bc1rxv0ov.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{running_requests:state.running_requests-1,show_globalSpinner:true});};cov_bc1rxv0ov.s[5]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_bc1rxv0ov.b[2][0]++,initialState);var action=arguments[1];cov_bc1rxv0ov.f[2]++;cov_bc1rxv0ov.s[6]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_47" /* FETCHING */]:cov_bc1rxv0ov.b[3][0]++;cov_bc1rxv0ov.s[7]++;return fetching(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_63" /* NOT_FETCHING */]:cov_bc1rxv0ov.b[3][1]++;cov_bc1rxv0ov.s[8]++;return not_fetching(state,action);default:cov_bc1rxv0ov.b[3][2]++;cov_bc1rxv0ov.s[9]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_269we9topu=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\printing.js',hash='76b443e1717bfeec60091251f6f4f6e6bcafa9a1',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\printing.js',statementMap:{'0':{start:{line:4,column:21},end:{line:6,column:1}},'1':{start:{line:8,column:17},end:{line:10,column:1}},'2':{start:{line:9,column:4},end:{line:9,column:52}},'3':{start:{line:12,column:21},end:{line:14,column:1}},'4':{start:{line:13,column:4},end:{line:13,column:53}},'5':{start:{line:16,column:16},end:{line:22,column:1}},'6':{start:{line:17,column:4},end:{line:21,column:5}},'7':{start:{line:18,column:32},end:{line:18,column:65}},'8':{start:{line:19,column:36},end:{line:19,column:73}},'9':{start:{line:20,column:17},end:{line:20,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:17},end:{line:8,column:18}},loc:{start:{line:8,column:53},end:{line:10,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:12,column:21},end:{line:12,column:22}},loc:{start:{line:12,column:57},end:{line:14,column:1}},line:12},'2':{name:'(anonymous_2)',decl:{start:{line:16,column:16},end:{line:16,column:17}},loc:{start:{line:16,column:52},end:{line:22,column:1}},line:16}},branchMap:{'0':{loc:{start:{line:8,column:19},end:{line:8,column:39}},type:'default-arg',locations:[{start:{line:8,column:27},end:{line:8,column:39}}],line:8},'1':{loc:{start:{line:12,column:23},end:{line:12,column:43}},type:'default-arg',locations:[{start:{line:12,column:31},end:{line:12,column:43}}],line:12},'2':{loc:{start:{line:16,column:18},end:{line:16,column:38}},type:'default-arg',locations:[{start:{line:16,column:26},end:{line:16,column:38}}],line:16},'3':{loc:{start:{line:17,column:4},end:{line:21,column:5}},type:'switch',locations:[{start:{line:18,column:5},end:{line:18,column:65}},{start:{line:19,column:5},end:{line:19,column:73}},{start:{line:20,column:8},end:{line:20,column:30}}],line:17}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0},b:{'0':[0],'1':[0],'2':[0],'3':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_269we9topu.s[0]++,{printing:false});cov_269we9topu.s[1]++;var printing=function printing(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_269we9topu.b[0][0]++,initialState);var action=arguments[1];cov_269we9topu.f[0]++;cov_269we9topu.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{printing:true});};cov_269we9topu.s[3]++;var not_printing=function not_printing(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_269we9topu.b[1][0]++,initialState);var action=arguments[1];cov_269we9topu.f[1]++;cov_269we9topu.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{printing:false});};cov_269we9topu.s[5]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_269we9topu.b[2][0]++,initialState);var action=arguments[1];cov_269we9topu.f[2]++;cov_269we9topu.s[6]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_65" /* PRINTING */]:cov_269we9topu.b[3][0]++;cov_269we9topu.s[7]++;return printing(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_64" /* NOT_PRINTING */]:cov_269we9topu.b[3][1]++;cov_269we9topu.s[8]++;return not_printing(state,action);default:cov_269we9topu.b[3][2]++;cov_269we9topu.s[9]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_2il30f35r7=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\tokenRestore.js',hash='b287d47480b29822a92d2f8ab8187fad87169a77',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\tokenRestore.js',statementMap:{'0':{start:{line:4,column:21},end:{line:8,column:1}},'1':{start:{line:11,column:26},end:{line:13,column:1}},'2':{start:{line:12,column:4},end:{line:12,column:73}},'3':{start:{line:15,column:28},end:{line:17,column:1}},'4':{start:{line:16,column:4},end:{line:16,column:75}},'5':{start:{line:19,column:25},end:{line:21,column:1}},'6':{start:{line:20,column:4},end:{line:20,column:71}},'7':{start:{line:23,column:16},end:{line:30,column:1}},'8':{start:{line:24,column:4},end:{line:29,column:5}},'9':{start:{line:25,column:46},end:{line:25,column:88}},'10':{start:{line:26,column:48},end:{line:26,column:91}},'11':{start:{line:27,column:45},end:{line:27,column:85}},'12':{start:{line:28,column:17},end:{line:28,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:26},end:{line:11,column:27}},loc:{start:{line:11,column:47},end:{line:13,column:1}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:15,column:28},end:{line:15,column:29}},loc:{start:{line:15,column:49},end:{line:17,column:1}},line:15},'2':{name:'(anonymous_2)',decl:{start:{line:19,column:25},end:{line:19,column:26}},loc:{start:{line:19,column:46},end:{line:21,column:1}},line:19},'3':{name:'(anonymous_3)',decl:{start:{line:23,column:16},end:{line:23,column:17}},loc:{start:{line:23,column:52},end:{line:30,column:1}},line:23}},branchMap:{'0':{loc:{start:{line:23,column:18},end:{line:23,column:38}},type:'default-arg',locations:[{start:{line:23,column:26},end:{line:23,column:38}}],line:23},'1':{loc:{start:{line:24,column:4},end:{line:29,column:5}},type:'switch',locations:[{start:{line:25,column:8},end:{line:25,column:88}},{start:{line:26,column:8},end:{line:26,column:91}},{start:{line:27,column:8},end:{line:27,column:85}},{start:{line:28,column:8},end:{line:28,column:30}}],line:24}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_2il30f35r7.s[0]++,{isRestoring:false,successful:false,failed:false});/* ----------------- Token ------------------ */cov_2il30f35r7.s[1]++;var tokenRestoreStart=function tokenRestoreStart(state,action){cov_2il30f35r7.f[0]++;cov_2il30f35r7.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,Object.assign({},initialState,{isRestoring:true}));};cov_2il30f35r7.s[3]++;var tokenRestoreSuccess=function tokenRestoreSuccess(state,action){cov_2il30f35r7.f[1]++;cov_2il30f35r7.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{isRestoring:false,successful:true});};cov_2il30f35r7.s[5]++;var tokenRestoreFail=function tokenRestoreFail(state,action){cov_2il30f35r7.f[2]++;cov_2il30f35r7.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{isRestoring:false,failed:true});};cov_2il30f35r7.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_2il30f35r7.b[0][0]++,initialState);var action=arguments[1];cov_2il30f35r7.f[3]++;cov_2il30f35r7.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_75" /* TOKEN_RESTORE_START */]:cov_2il30f35r7.b[1][0]++;cov_2il30f35r7.s[9]++;return tokenRestoreStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_76" /* TOKEN_RESTORE_SUCCESS */]:cov_2il30f35r7.b[1][1]++;cov_2il30f35r7.s[10]++;return tokenRestoreSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* TOKEN_RESTORE_FAIL */]:cov_2il30f35r7.b[1][2]++;cov_2il30f35r7.s[11]++;return tokenRestoreFail(state,action);default:cov_2il30f35r7.b[1][3]++;cov_2il30f35r7.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1wjxp0tm7l=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\appStartup.js',hash='1f7f26665b4a944e342882aa7c8a658da894f203',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\appStartup.js',statementMap:{'0':{start:{line:4,column:21},end:{line:9,column:1}},'1':{start:{line:11,column:24},end:{line:13,column:1}},'2':{start:{line:12,column:4},end:{line:12,column:69}},'3':{start:{line:15,column:26},end:{line:21,column:1}},'4':{start:{line:16,column:4},end:{line:20,column:8}},'5':{start:{line:23,column:23},end:{line:25,column:1}},'6':{start:{line:24,column:4},end:{line:24,column:67}},'7':{start:{line:27,column:16},end:{line:34,column:1}},'8':{start:{line:28,column:4},end:{line:33,column:5}},'9':{start:{line:29,column:41},end:{line:29,column:81}},'10':{start:{line:30,column:43},end:{line:30,column:85}},'11':{start:{line:31,column:40},end:{line:31,column:79}},'12':{start:{line:32,column:17},end:{line:32,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:24},end:{line:11,column:25}},loc:{start:{line:11,column:45},end:{line:13,column:1}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:15,column:26},end:{line:15,column:27}},loc:{start:{line:15,column:47},end:{line:21,column:1}},line:15},'2':{name:'(anonymous_2)',decl:{start:{line:23,column:23},end:{line:23,column:24}},loc:{start:{line:23,column:44},end:{line:25,column:1}},line:23},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:16},end:{line:27,column:17}},loc:{start:{line:27,column:52},end:{line:34,column:1}},line:27}},branchMap:{'0':{loc:{start:{line:27,column:18},end:{line:27,column:38}},type:'default-arg',locations:[{start:{line:27,column:26},end:{line:27,column:38}}],line:27},'1':{loc:{start:{line:28,column:4},end:{line:33,column:5}},type:'switch',locations:[{start:{line:29,column:5},end:{line:29,column:81}},{start:{line:30,column:5},end:{line:30,column:85}},{start:{line:31,column:5},end:{line:31,column:79}},{start:{line:32,column:8},end:{line:32,column:30}}],line:28}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1wjxp0tm7l.s[0]++,{show_service_terms:false,loading:false,successful:false,failed:false});cov_1wjxp0tm7l.s[1]++;var appStartupStart=function appStartupStart(state,action){cov_1wjxp0tm7l.f[0]++;cov_1wjxp0tm7l.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,Object.assign({},initialState,{loading:true}));};cov_1wjxp0tm7l.s[3]++;var appStartupSuccess=function appStartupSuccess(state,action){cov_1wjxp0tm7l.f[1]++;cov_1wjxp0tm7l.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{show_service_terms:action.show_service_terms,loading:false,successful:true});};cov_1wjxp0tm7l.s[5]++;var appStartupFail=function appStartupFail(state,action){cov_1wjxp0tm7l.f[2]++;cov_1wjxp0tm7l.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,failed:true});};cov_1wjxp0tm7l.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1wjxp0tm7l.b[0][0]++,initialState);var action=arguments[1];cov_1wjxp0tm7l.f[3]++;cov_1wjxp0tm7l.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["b" /* APP_STARTUP_START */]:cov_1wjxp0tm7l.b[1][0]++;cov_1wjxp0tm7l.s[9]++;return appStartupStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* APP_STARTUP_SUCCESS */]:cov_1wjxp0tm7l.b[1][1]++;cov_1wjxp0tm7l.s[10]++;return appStartupSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["a" /* APP_STARTUP_FAIL */]:cov_1wjxp0tm7l.b[1][2]++;cov_1wjxp0tm7l.s[11]++;return appStartupFail(state,action);default:cov_1wjxp0tm7l.b[1][3]++;cov_1wjxp0tm7l.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_23jdznsd99=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\translationLoad.js',hash='849ba7185fd91b8f526a2764c6b7fdd451d3203a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\translationLoad.js',statementMap:{'0':{start:{line:4,column:21},end:{line:8,column:1}},'1':{start:{line:10,column:29},end:{line:12,column:1}},'2':{start:{line:11,column:4},end:{line:11,column:69}},'3':{start:{line:14,column:31},end:{line:19,column:1}},'4':{start:{line:15,column:4},end:{line:18,column:8}},'5':{start:{line:21,column:28},end:{line:23,column:1}},'6':{start:{line:22,column:4},end:{line:22,column:67}},'7':{start:{line:25,column:16},end:{line:32,column:1}},'8':{start:{line:26,column:4},end:{line:31,column:5}},'9':{start:{line:27,column:46},end:{line:27,column:91}},'10':{start:{line:28,column:48},end:{line:28,column:95}},'11':{start:{line:29,column:45},end:{line:29,column:89}},'12':{start:{line:30,column:17},end:{line:30,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:29},end:{line:10,column:30}},loc:{start:{line:10,column:50},end:{line:12,column:1}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:31},end:{line:14,column:32}},loc:{start:{line:14,column:52},end:{line:19,column:1}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:21,column:28},end:{line:21,column:29}},loc:{start:{line:21,column:49},end:{line:23,column:1}},line:21},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:16},end:{line:25,column:17}},loc:{start:{line:25,column:52},end:{line:32,column:1}},line:25}},branchMap:{'0':{loc:{start:{line:25,column:18},end:{line:25,column:38}},type:'default-arg',locations:[{start:{line:25,column:26},end:{line:25,column:38}}],line:25},'1':{loc:{start:{line:26,column:4},end:{line:31,column:5}},type:'switch',locations:[{start:{line:27,column:5},end:{line:27,column:91}},{start:{line:28,column:5},end:{line:28,column:95}},{start:{line:29,column:5},end:{line:29,column:89}},{start:{line:30,column:8},end:{line:30,column:30}}],line:26}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_23jdznsd99.s[0]++,{loading:false,successful:false,failed:false});cov_23jdznsd99.s[1]++;var translationLoadStart=function translationLoadStart(state,action){cov_23jdznsd99.f[0]++;cov_23jdznsd99.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,Object.assign({},initialState,{loading:true}));};cov_23jdznsd99.s[3]++;var translationLoadSuccess=function translationLoadSuccess(state,action){cov_23jdznsd99.f[1]++;cov_23jdznsd99.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,successful:true});};cov_23jdznsd99.s[5]++;var translationLoadFail=function translationLoadFail(state,action){cov_23jdznsd99.f[2]++;cov_23jdznsd99.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,failed:true});};cov_23jdznsd99.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_23jdznsd99.b[0][0]++,initialState);var action=arguments[1];cov_23jdznsd99.f[3]++;cov_23jdznsd99.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes_js__["_78" /* TRANSLATION_LOAD_START */]:cov_23jdznsd99.b[1][0]++;cov_23jdznsd99.s[9]++;return translationLoadStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes_js__["_79" /* TRANSLATION_LOAD_SUCCESS */]:cov_23jdznsd99.b[1][1]++;cov_23jdznsd99.s[10]++;return translationLoadSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes_js__["_77" /* TRANSLATION_LOAD_FAIL */]:cov_23jdznsd99.b[1][2]++;cov_23jdznsd99.s[11]++;return translationLoadFail(state,action);default:cov_23jdznsd99.b[1][3]++;cov_23jdznsd99.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_17og9mwos4=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\auth.js',hash='466b4b561fe63a5df692560dba6775934eeeb915',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\auth.js',statementMap:{'0':{start:{line:4,column:18},end:{line:4,column:61}},'1':{start:{line:5,column:0},end:{line:8,column:1}},'2':{start:{line:6,column:4},end:{line:6,column:62}},'3':{start:{line:7,column:4},end:{line:7,column:61}},'4':{start:{line:10,column:21},end:{line:25,column:1}},'5':{start:{line:28,column:30},end:{line:42,column:1}},'6':{start:{line:29,column:4},end:{line:41,column:8}},'7':{start:{line:44,column:32},end:{line:46,column:1}},'8':{start:{line:45,column:4},end:{line:45,column:37}},'9':{start:{line:48,column:35},end:{line:50,column:1}},'10':{start:{line:49,column:4},end:{line:49,column:37}},'11':{start:{line:52,column:32},end:{line:54,column:1}},'12':{start:{line:53,column:4},end:{line:53,column:66}},'13':{start:{line:56,column:34},end:{line:70,column:1}},'14':{start:{line:57,column:4},end:{line:69,column:8}},'15':{start:{line:72,column:31},end:{line:74,column:1}},'16':{start:{line:73,column:4},end:{line:73,column:74}},'17':{start:{line:76,column:16},end:{line:86,column:1}},'18':{start:{line:77,column:4},end:{line:85,column:5}},'19':{start:{line:78,column:54},end:{line:78,column:101}},'20':{start:{line:79,column:57},end:{line:79,column:107}},'21':{start:{line:80,column:51},end:{line:80,column:97}},'22':{start:{line:81,column:54},end:{line:81,column:101}},'23':{start:{line:82,column:56},end:{line:82,column:105}},'24':{start:{line:83,column:53},end:{line:83,column:99}},'25':{start:{line:84,column:17},end:{line:84,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:28,column:30},end:{line:28,column:31}},loc:{start:{line:28,column:49},end:{line:42,column:1}},line:28},'1':{name:'(anonymous_1)',decl:{start:{line:44,column:32},end:{line:44,column:33}},loc:{start:{line:44,column:53},end:{line:46,column:1}},line:44},'2':{name:'(anonymous_2)',decl:{start:{line:48,column:35},end:{line:48,column:36}},loc:{start:{line:48,column:56},end:{line:50,column:1}},line:48},'3':{name:'(anonymous_3)',decl:{start:{line:52,column:32},end:{line:52,column:33}},loc:{start:{line:52,column:53},end:{line:54,column:1}},line:52},'4':{name:'(anonymous_4)',decl:{start:{line:56,column:34},end:{line:56,column:35}},loc:{start:{line:56,column:55},end:{line:70,column:1}},line:56},'5':{name:'(anonymous_5)',decl:{start:{line:72,column:31},end:{line:72,column:32}},loc:{start:{line:72,column:52},end:{line:74,column:1}},line:72},'6':{name:'(anonymous_6)',decl:{start:{line:76,column:16},end:{line:76,column:17}},loc:{start:{line:76,column:52},end:{line:86,column:1}},line:76}},branchMap:{'0':{loc:{start:{line:5,column:0},end:{line:8,column:1}},type:'if',locations:[{start:{line:5,column:0},end:{line:8,column:1}},{start:{line:5,column:0},end:{line:8,column:1}}],line:5},'1':{loc:{start:{line:5,column:3},end:{line:5,column:56}},type:'binary-expr',locations:[{start:{line:5,column:3},end:{line:5,column:29}},{start:{line:5,column:33},end:{line:5,column:56}}],line:5},'2':{loc:{start:{line:13,column:22},end:{line:13,column:66}},type:'cond-expr',locations:[{start:{line:13,column:54},end:{line:13,column:58}},{start:{line:13,column:61},end:{line:13,column:66}}],line:13},'3':{loc:{start:{line:36,column:24},end:{line:36,column:81}},type:'cond-expr',locations:[{start:{line:36,column:48},end:{line:36,column:69}},{start:{line:36,column:72},end:{line:36,column:81}}],line:36},'4':{loc:{start:{line:37,column:30},end:{line:37,column:99}},type:'cond-expr',locations:[{start:{line:37,column:60},end:{line:37,column:87}},{start:{line:37,column:90},end:{line:37,column:99}}],line:37},'5':{loc:{start:{line:38,column:25},end:{line:38,column:52}},type:'cond-expr',locations:[{start:{line:38,column:40},end:{line:38,column:44}},{start:{line:38,column:47},end:{line:38,column:52}}],line:38},'6':{loc:{start:{line:76,column:18},end:{line:76,column:38}},type:'default-arg',locations:[{start:{line:76,column:26},end:{line:76,column:38}}],line:76},'7':{loc:{start:{line:77,column:4},end:{line:85,column:5}},type:'switch',locations:[{start:{line:78,column:8},end:{line:78,column:101}},{start:{line:79,column:8},end:{line:79,column:107}},{start:{line:80,column:8},end:{line:80,column:97}},{start:{line:81,column:8},end:{line:81,column:101}},{start:{line:82,column:8},end:{line:82,column:105}},{start:{line:83,column:8},end:{line:83,column:99}},{start:{line:84,column:8},end:{line:84,column:30}}],line:77}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0],'7':[0,0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var urlParams=(cov_17og9mwos4.s[0]++,new URLSearchParams(window.location.search));cov_17og9mwos4.s[1]++;if((cov_17og9mwos4.b[1][0]++,urlParams.get('AuthToken'))&&(cov_17og9mwos4.b[1][1]++,urlParams.get('UserId'))){cov_17og9mwos4.b[0][0]++;cov_17og9mwos4.s[2]++;localStorage.setItem('token',urlParams.get('AuthToken'));cov_17og9mwos4.s[3]++;localStorage.setItem('user_id',urlParams.get('UserId'));}else{cov_17og9mwos4.b[0][1]++;}var initialState=(cov_17og9mwos4.s[4]++,{token:localStorage.getItem("token"),user_id:localStorage.getItem("user_id"),isAuthenticated:localStorage.getItem("token")?(cov_17og9mwos4.b[2][0]++,true):(cov_17og9mwos4.b[2][1]++,false),warning:false,first_name:false,last_name:false,account_name:undefined,parent_user_id:undefined,impersonation_for_id:undefined,loading:false,error:false,user_name:false,expired:false,deleted:false});/* ----------------- Auth ------------------ */cov_17og9mwos4.s[5]++;var authChangeCurrentUser=function authChangeCurrentUser(state,action){cov_17og9mwos4.f[0]++;cov_17og9mwos4.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{token:action.token,user_id:action.user_id,warning:action.warning,first_name:action.first_name,last_name:action.last_name,account_name:action.account_name,parent_user_id:action.parent_user_id?(cov_17og9mwos4.b[3][0]++,action.parent_user_id):(cov_17og9mwos4.b[3][1]++,undefined),impersonation_for_id:action.impersonation_for_id?(cov_17og9mwos4.b[4][0]++,action.impersonation_for_id):(cov_17og9mwos4.b[4][1]++,undefined),isAuthenticated:action.token?(cov_17og9mwos4.b[5][0]++,true):(cov_17og9mwos4.b[5][1]++,false),loading:false,error:false});};cov_17og9mwos4.s[7]++;var authSetMelcoAccountData=function authSetMelcoAccountData(state,action){cov_17og9mwos4.f[1]++;cov_17og9mwos4.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{});};cov_17og9mwos4.s[9]++;var authRemoveMelcoAccountData=function authRemoveMelcoAccountData(state,action){cov_17og9mwos4.f[2]++;cov_17og9mwos4.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{});};cov_17og9mwos4.s[11]++;var authLogoutOnServerStart=function authLogoutOnServerStart(state,action){cov_17og9mwos4.f[3]++;cov_17og9mwos4.s[12]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false});};cov_17og9mwos4.s[13]++;var authLogoutOnServerSuccess=function authLogoutOnServerSuccess(state,action){cov_17og9mwos4.f[4]++;cov_17og9mwos4.s[14]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{token:null,user_id:null,warning:false,first_name:false,last_name:false,account_name:false,parent_user_id:undefined,impersonation_for_id:undefined,isAuthenticated:false,loading:false,error:false});};cov_17og9mwos4.s[15]++;var authLogoutOnServerFail=function authLogoutOnServerFail(state,action){cov_17og9mwos4.f[5]++;cov_17og9mwos4.s[16]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_17og9mwos4.s[17]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_17og9mwos4.b[6][0]++,initialState);var action=arguments[1];cov_17og9mwos4.f[6]++;cov_17og9mwos4.s[18]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["i" /* AUTH_SET_MELCO_ACCOUNT_DATA */]:cov_17og9mwos4.b[7][0]++;cov_17og9mwos4.s[19]++;return authSetMelcoAccountData(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["h" /* AUTH_REMOVE_MELCO_ACCOUNT_DATA */]:cov_17og9mwos4.b[7][1]++;cov_17og9mwos4.s[20]++;return authRemoveMelcoAccountData(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* AUTH_CHANGE_CURRENT_USER */]:cov_17og9mwos4.b[7][2]++;cov_17og9mwos4.s[21]++;return authChangeCurrentUser(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["f" /* AUTH_LOGOUT_ON_SERVER_START */]:cov_17og9mwos4.b[7][3]++;cov_17og9mwos4.s[22]++;return authLogoutOnServerStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["g" /* AUTH_LOGOUT_ON_SERVER_SUCCESS */]:cov_17og9mwos4.b[7][4]++;cov_17og9mwos4.s[23]++;return authLogoutOnServerSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["e" /* AUTH_LOGOUT_ON_SERVER_FAIL */]:cov_17og9mwos4.b[7][5]++;cov_17og9mwos4.s[24]++;return authLogoutOnServerFail(state,action);default:cov_17og9mwos4.b[7][6]++;cov_17og9mwos4.s[25]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1w6u0100nm=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\defaults.js',hash='34c003a10004a877fd6c5770bda7e88b4e2b2266',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\defaults.js',statementMap:{'0':{start:{line:4,column:21},end:{line:10,column:1}},'1':{start:{line:12,column:20},end:{line:14,column:1}},'2':{start:{line:13,column:4},end:{line:13,column:16}},'3':{start:{line:16,column:27},end:{line:18,column:1}},'4':{start:{line:17,column:4},end:{line:17,column:66}},'5':{start:{line:20,column:29},end:{line:28,column:1}},'6':{start:{line:21,column:4},end:{line:27,column:8}},'7':{start:{line:30,column:26},end:{line:32,column:1}},'8':{start:{line:31,column:4},end:{line:31,column:74}},'9':{start:{line:34,column:16},end:{line:42,column:1}},'10':{start:{line:35,column:4},end:{line:41,column:5}},'11':{start:{line:36,column:39},end:{line:36,column:75}},'12':{start:{line:37,column:44},end:{line:37,column:87}},'13':{start:{line:38,column:46},end:{line:38,column:91}},'14':{start:{line:39,column:43},end:{line:39,column:85}},'15':{start:{line:40,column:17},end:{line:40,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:12,column:20},end:{line:12,column:21}},loc:{start:{line:12,column:41},end:{line:14,column:1}},line:12},'1':{name:'(anonymous_1)',decl:{start:{line:16,column:27},end:{line:16,column:28}},loc:{start:{line:16,column:48},end:{line:18,column:1}},line:16},'2':{name:'(anonymous_2)',decl:{start:{line:20,column:29},end:{line:20,column:30}},loc:{start:{line:20,column:50},end:{line:28,column:1}},line:20},'3':{name:'(anonymous_3)',decl:{start:{line:30,column:26},end:{line:30,column:27}},loc:{start:{line:30,column:47},end:{line:32,column:1}},line:30},'4':{name:'(anonymous_4)',decl:{start:{line:34,column:16},end:{line:34,column:17}},loc:{start:{line:34,column:52},end:{line:42,column:1}},line:34}},branchMap:{'0':{loc:{start:{line:34,column:18},end:{line:34,column:38}},type:'default-arg',locations:[{start:{line:34,column:26},end:{line:34,column:38}}],line:34},'1':{loc:{start:{line:35,column:4},end:{line:41,column:5}},type:'switch',locations:[{start:{line:36,column:8},end:{line:36,column:75}},{start:{line:37,column:5},end:{line:37,column:87}},{start:{line:38,column:5},end:{line:38,column:91}},{start:{line:39,column:5},end:{line:39,column:85}},{start:{line:40,column:8},end:{line:40,column:30}}],line:35}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0],'1':[0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1w6u0100nm.s[0]++,{countries:[],currencies:[],genders:[],loading:false,error:false});cov_1w6u0100nm.s[1]++;var defaultsGet=function defaultsGet(state,action){cov_1w6u0100nm.f[0]++;cov_1w6u0100nm.s[2]++;return state;};cov_1w6u0100nm.s[3]++;var defaultsFetchStart=function defaultsFetchStart(state,action){cov_1w6u0100nm.f[1]++;cov_1w6u0100nm.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false});};cov_1w6u0100nm.s[5]++;var defaultsFetchSuccess=function defaultsFetchSuccess(state,action){cov_1w6u0100nm.f[2]++;cov_1w6u0100nm.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{countries:action.countries,currencies:action.currencies,genders:action.genders,loading:false,error:false});};cov_1w6u0100nm.s[7]++;var defaultsFetchFail=function defaultsFetchFail(state,action){cov_1w6u0100nm.f[3]++;cov_1w6u0100nm.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_1w6u0100nm.s[9]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1w6u0100nm.b[0][0]++,initialState);var action=arguments[1];cov_1w6u0100nm.f[4]++;cov_1w6u0100nm.s[10]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_46" /* DEFAULTS_GET */]:cov_1w6u0100nm.b[1][0]++;cov_1w6u0100nm.s[11]++;return defaultsGet(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_44" /* DEFAULTS_FETCH_START */]:cov_1w6u0100nm.b[1][1]++;cov_1w6u0100nm.s[12]++;return defaultsFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_45" /* DEFAULTS_FETCH_SUCCESS */]:cov_1w6u0100nm.b[1][2]++;cov_1w6u0100nm.s[13]++;return defaultsFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_43" /* DEFAULTS_FETCH_FAIL */]:cov_1w6u0100nm.b[1][3]++;cov_1w6u0100nm.s[14]++;return defaultsFetchFail(state,action);default:cov_1w6u0100nm.b[1][4]++;cov_1w6u0100nm.s[15]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_5czdblo9b=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\settings\\company.js',hash='d782c997e4af900a34e15dae5d1b55237e37677a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\settings\\company.js',statementMap:{'0':{start:{line:4,column:21},end:{line:10,column:1}},'1':{start:{line:13,column:35},end:{line:15,column:1}},'2':{start:{line:14,column:4},end:{line:14,column:82}},'3':{start:{line:17,column:35},end:{line:19,column:1}},'4':{start:{line:18,column:4},end:{line:18,column:83}},'5':{start:{line:21,column:37},end:{line:28,column:1}},'6':{start:{line:22,column:4},end:{line:27,column:8}},'7':{start:{line:30,column:34},end:{line:32,column:1}},'8':{start:{line:31,column:4},end:{line:31,column:74}},'9':{start:{line:35,column:34},end:{line:37,column:1}},'10':{start:{line:36,column:4},end:{line:36,column:96}},'11':{start:{line:39,column:34},end:{line:41,column:1}},'12':{start:{line:40,column:4},end:{line:40,column:97}},'13':{start:{line:43,column:36},end:{line:50,column:1}},'14':{start:{line:44,column:4},end:{line:49,column:8}},'15':{start:{line:52,column:33},end:{line:54,column:1}},'16':{start:{line:53,column:4},end:{line:53,column:74}},'17':{start:{line:56,column:16},end:{line:68,column:1}},'18':{start:{line:57,column:4},end:{line:67,column:5}},'19':{start:{line:58,column:53},end:{line:58,column:104}},'20':{start:{line:59,column:55},end:{line:59,column:108}},'21':{start:{line:60,column:52},end:{line:60,column:102}},'22':{start:{line:61,column:56},end:{line:61,column:107}},'23':{start:{line:62,column:55},end:{line:62,column:105}},'24':{start:{line:63,column:57},end:{line:63,column:109}},'25':{start:{line:64,column:54},end:{line:64,column:104}},'26':{start:{line:65,column:55},end:{line:65,column:104}},'27':{start:{line:66,column:17},end:{line:66,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:35},end:{line:13,column:36}},loc:{start:{line:13,column:56},end:{line:15,column:1}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:35},end:{line:17,column:36}},loc:{start:{line:17,column:56},end:{line:19,column:1}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:21,column:37},end:{line:21,column:38}},loc:{start:{line:21,column:58},end:{line:28,column:1}},line:21},'3':{name:'(anonymous_3)',decl:{start:{line:30,column:34},end:{line:30,column:35}},loc:{start:{line:30,column:55},end:{line:32,column:1}},line:30},'4':{name:'(anonymous_4)',decl:{start:{line:35,column:34},end:{line:35,column:35}},loc:{start:{line:35,column:55},end:{line:37,column:1}},line:35},'5':{name:'(anonymous_5)',decl:{start:{line:39,column:34},end:{line:39,column:35}},loc:{start:{line:39,column:55},end:{line:41,column:1}},line:39},'6':{name:'(anonymous_6)',decl:{start:{line:43,column:36},end:{line:43,column:37}},loc:{start:{line:43,column:57},end:{line:50,column:1}},line:43},'7':{name:'(anonymous_7)',decl:{start:{line:52,column:33},end:{line:52,column:34}},loc:{start:{line:52,column:54},end:{line:54,column:1}},line:52},'8':{name:'(anonymous_8)',decl:{start:{line:56,column:16},end:{line:56,column:17}},loc:{start:{line:56,column:52},end:{line:68,column:1}},line:56}},branchMap:{'0':{loc:{start:{line:56,column:18},end:{line:56,column:38}},type:'default-arg',locations:[{start:{line:56,column:26},end:{line:56,column:38}}],line:56},'1':{loc:{start:{line:57,column:4},end:{line:67,column:5}},type:'switch',locations:[{start:{line:58,column:5},end:{line:58,column:104}},{start:{line:59,column:5},end:{line:59,column:108}},{start:{line:60,column:5},end:{line:60,column:102}},{start:{line:61,column:8},end:{line:61,column:107}},{start:{line:62,column:8},end:{line:62,column:105}},{start:{line:63,column:8},end:{line:63,column:109}},{start:{line:64,column:8},end:{line:64,column:104}},{start:{line:65,column:8},end:{line:65,column:104}},{start:{line:66,column:8},end:{line:66,column:30}}],line:57}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},b:{'0':[0],'1':[0,0,0,0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_5czdblo9b.s[0]++,{settings:{},updated:false,error:false,loading:false,fetched:false});/* ------------------ Company Update ------------------- */cov_5czdblo9b.s[1]++;var settingsCompanyUpdateStart=function settingsCompanyUpdateStart(state,action){cov_5czdblo9b.f[0]++;cov_5czdblo9b.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,updated:false});};cov_5czdblo9b.s[3]++;var settingsCompanyUpdateReset=function settingsCompanyUpdateReset(state,action){cov_5czdblo9b.f[1]++;cov_5czdblo9b.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,updated:false});};cov_5czdblo9b.s[5]++;var settingsCompanyUpdateSuccess=function settingsCompanyUpdateSuccess(state,action){cov_5czdblo9b.f[2]++;cov_5czdblo9b.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{settings:action.settings,loading:false,error:false,updated:true});};cov_5czdblo9b.s[7]++;var settingsCompanyUpdateFail=function settingsCompanyUpdateFail(state,action){cov_5czdblo9b.f[3]++;cov_5czdblo9b.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};/* ------------------ Company Fetch ------------------- */cov_5czdblo9b.s[9]++;var settingsCompanyFetchStart=function settingsCompanyFetchStart(state,action){cov_5czdblo9b.f[4]++;cov_5czdblo9b.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,fetched:false,settings:{}});};cov_5czdblo9b.s[11]++;var settingsCompanyFetchReset=function settingsCompanyFetchReset(state,action){cov_5czdblo9b.f[5]++;cov_5czdblo9b.s[12]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,fetched:false,settings:{}});};cov_5czdblo9b.s[13]++;var settingsCompanyFetchSuccess=function settingsCompanyFetchSuccess(state,action){cov_5czdblo9b.f[6]++;cov_5czdblo9b.s[14]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{settings:action.settings,loading:false,error:false,fetched:true});};cov_5czdblo9b.s[15]++;var settingsCompanyFetchFail=function settingsCompanyFetchFail(state,action){cov_5czdblo9b.f[7]++;cov_5czdblo9b.s[16]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_5czdblo9b.s[17]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_5czdblo9b.b[0][0]++,initialState);var action=arguments[1];cov_5czdblo9b.f[8]++;cov_5czdblo9b.s[18]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_72" /* SETTINGS_COMPANY_UPDATE_START */]:cov_5czdblo9b.b[1][0]++;cov_5czdblo9b.s[19]++;return settingsCompanyUpdateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_73" /* SETTINGS_COMPANY_UPDATE_SUCCESS */]:cov_5czdblo9b.b[1][1]++;cov_5czdblo9b.s[20]++;return settingsCompanyUpdateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_70" /* SETTINGS_COMPANY_UPDATE_FAIL */]:cov_5czdblo9b.b[1][2]++;cov_5czdblo9b.s[21]++;return settingsCompanyUpdateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_71" /* SETTINGS_COMPANY_UPDATE_RESET */]:cov_5czdblo9b.b[1][3]++;cov_5czdblo9b.s[22]++;return settingsCompanyUpdateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_68" /* SETTINGS_COMPANY_FETCH_START */]:cov_5czdblo9b.b[1][4]++;cov_5czdblo9b.s[23]++;return settingsCompanyFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_69" /* SETTINGS_COMPANY_FETCH_SUCCESS */]:cov_5czdblo9b.b[1][5]++;cov_5czdblo9b.s[24]++;return settingsCompanyFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_66" /* SETTINGS_COMPANY_FETCH_FAIL */]:cov_5czdblo9b.b[1][6]++;cov_5czdblo9b.s[25]++;return settingsCompanyFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_67" /* SETTINGS_COMPANY_FETCH_RESET */]:cov_5czdblo9b.b[1][7]++;cov_5czdblo9b.s[26]++;return settingsCompanyFetchFail(state,action);default:cov_5czdblo9b.b[1][8]++;cov_5czdblo9b.s[27]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_18yxvzm46z=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\jobs.js',hash='809022bc0c590f6a09d84d1488c37abfa634779a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\jobs.js',statementMap:{'0':{start:{line:4,column:21},end:{line:9,column:1}},'1':{start:{line:11,column:33},end:{line:13,column:1}},'2':{start:{line:12,column:4},end:{line:12,column:93}},'3':{start:{line:15,column:35},end:{line:21,column:1}},'4':{start:{line:16,column:4},end:{line:20,column:8}},'5':{start:{line:23,column:32},end:{line:25,column:1}},'6':{start:{line:24,column:4},end:{line:24,column:74}},'7':{start:{line:27,column:16},end:{line:34,column:1}},'8':{start:{line:28,column:4},end:{line:33,column:5}},'9':{start:{line:29,column:51},end:{line:29,column:100}},'10':{start:{line:30,column:53},end:{line:30,column:104}},'11':{start:{line:31,column:50},end:{line:31,column:98}},'12':{start:{line:32,column:17},end:{line:32,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:33},end:{line:11,column:34}},loc:{start:{line:11,column:54},end:{line:13,column:1}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:15,column:35},end:{line:15,column:36}},loc:{start:{line:15,column:56},end:{line:21,column:1}},line:15},'2':{name:'(anonymous_2)',decl:{start:{line:23,column:32},end:{line:23,column:33}},loc:{start:{line:23,column:53},end:{line:25,column:1}},line:23},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:16},end:{line:27,column:17}},loc:{start:{line:27,column:52},end:{line:34,column:1}},line:27}},branchMap:{'0':{loc:{start:{line:27,column:18},end:{line:27,column:38}},type:'default-arg',locations:[{start:{line:27,column:26},end:{line:27,column:38}}],line:27},'1':{loc:{start:{line:28,column:4},end:{line:33,column:5}},type:'switch',locations:[{start:{line:29,column:5},end:{line:29,column:100}},{start:{line:30,column:5},end:{line:30,column:104}},{start:{line:31,column:5},end:{line:31,column:98}},{start:{line:32,column:8},end:{line:32,column:30}}],line:28}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_18yxvzm46z.s[0]++,{jobs:[],loading:false,error:false,searched:false});cov_18yxvzm46z.s[1]++;var calculatorJobsFetchStart=function calculatorJobsFetchStart(state,action){cov_18yxvzm46z.f[0]++;cov_18yxvzm46z.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,searched:action.searched});};cov_18yxvzm46z.s[3]++;var calculatorJobsFetchSuccess=function calculatorJobsFetchSuccess(state,action){cov_18yxvzm46z.f[1]++;cov_18yxvzm46z.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{jobs:action.jobs,loading:false,error:false});};cov_18yxvzm46z.s[5]++;var calculatorJobsFetchFail=function calculatorJobsFetchFail(state,action){cov_18yxvzm46z.f[2]++;cov_18yxvzm46z.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_18yxvzm46z.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_18yxvzm46z.b[0][0]++,initialState);var action=arguments[1];cov_18yxvzm46z.f[3]++;cov_18yxvzm46z.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["r" /* CALCULATOR_JOBS_FETCH_START */]:cov_18yxvzm46z.b[1][0]++;cov_18yxvzm46z.s[9]++;return calculatorJobsFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["s" /* CALCULATOR_JOBS_FETCH_SUCCESS */]:cov_18yxvzm46z.b[1][1]++;cov_18yxvzm46z.s[10]++;return calculatorJobsFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["q" /* CALCULATOR_JOBS_FETCH_FAIL */]:cov_18yxvzm46z.b[1][2]++;cov_18yxvzm46z.s[11]++;return calculatorJobsFetchFail(state,action);default:cov_18yxvzm46z.b[1][3]++;cov_18yxvzm46z.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_r8y2sa8j9=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\defaults.js',hash='8f35e74aec8ff9f0d178ec6772ef7e6291a1a74b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\defaults.js',statementMap:{'0':{start:{line:4,column:21},end:{line:9,column:1}},'1':{start:{line:12,column:42},end:{line:14,column:1}},'2':{start:{line:13,column:4},end:{line:13,column:82}},'3':{start:{line:16,column:44},end:{line:23,column:1}},'4':{start:{line:17,column:4},end:{line:22,column:8}},'5':{start:{line:25,column:41},end:{line:27,column:1}},'6':{start:{line:26,column:4},end:{line:26,column:74}},'7':{start:{line:29,column:42},end:{line:31,column:1}},'8':{start:{line:30,column:4},end:{line:30,column:83}},'9':{start:{line:34,column:41},end:{line:36,column:1}},'10':{start:{line:35,column:4},end:{line:35,column:66}},'11':{start:{line:38,column:43},end:{line:44,column:1}},'12':{start:{line:39,column:4},end:{line:43,column:8}},'13':{start:{line:46,column:40},end:{line:48,column:1}},'14':{start:{line:47,column:4},end:{line:47,column:74}},'15':{start:{line:50,column:16},end:{line:61,column:1}},'16':{start:{line:51,column:4},end:{line:60,column:5}},'17':{start:{line:52,column:63},end:{line:52,column:120}},'18':{start:{line:53,column:65},end:{line:53,column:124}},'19':{start:{line:54,column:62},end:{line:54,column:118}},'20':{start:{line:55,column:64},end:{line:55,column:122}},'21':{start:{line:56,column:66},end:{line:56,column:126}},'22':{start:{line:57,column:63},end:{line:57,column:120}},'23':{start:{line:58,column:64},end:{line:58,column:122}},'24':{start:{line:59,column:17},end:{line:59,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:12,column:42},end:{line:12,column:43}},loc:{start:{line:12,column:63},end:{line:14,column:1}},line:12},'1':{name:'(anonymous_1)',decl:{start:{line:16,column:44},end:{line:16,column:45}},loc:{start:{line:16,column:65},end:{line:23,column:1}},line:16},'2':{name:'(anonymous_2)',decl:{start:{line:25,column:41},end:{line:25,column:42}},loc:{start:{line:25,column:62},end:{line:27,column:1}},line:25},'3':{name:'(anonymous_3)',decl:{start:{line:29,column:42},end:{line:29,column:43}},loc:{start:{line:29,column:63},end:{line:31,column:1}},line:29},'4':{name:'(anonymous_4)',decl:{start:{line:34,column:41},end:{line:34,column:42}},loc:{start:{line:34,column:62},end:{line:36,column:1}},line:34},'5':{name:'(anonymous_5)',decl:{start:{line:38,column:43},end:{line:38,column:44}},loc:{start:{line:38,column:64},end:{line:44,column:1}},line:38},'6':{name:'(anonymous_6)',decl:{start:{line:46,column:40},end:{line:46,column:41}},loc:{start:{line:46,column:61},end:{line:48,column:1}},line:46},'7':{name:'(anonymous_7)',decl:{start:{line:50,column:16},end:{line:50,column:17}},loc:{start:{line:50,column:52},end:{line:61,column:1}},line:50}},branchMap:{'0':{loc:{start:{line:50,column:18},end:{line:50,column:38}},type:'default-arg',locations:[{start:{line:50,column:26},end:{line:50,column:38}}],line:50},'1':{loc:{start:{line:51,column:4},end:{line:60,column:5}},type:'switch',locations:[{start:{line:52,column:8},end:{line:52,column:120}},{start:{line:53,column:8},end:{line:53,column:124}},{start:{line:54,column:8},end:{line:54,column:118}},{start:{line:55,column:8},end:{line:55,column:122}},{start:{line:56,column:8},end:{line:56,column:126}},{start:{line:57,column:8},end:{line:57,column:120}},{start:{line:58,column:8},end:{line:58,column:122}},{start:{line:59,column:8},end:{line:59,column:30}}],line:51}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},b:{'0':[0],'1':[0,0,0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_r8y2sa8j9.s[0]++,{defaults:{},loading:false,error:false,updated:false});/* ------------------ Defaults Update ------------------- */cov_r8y2sa8j9.s[1]++;var calculatorJobsDefaultsUpdateStart=function calculatorJobsDefaultsUpdateStart(state,action){cov_r8y2sa8j9.f[0]++;cov_r8y2sa8j9.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,updated:false});};cov_r8y2sa8j9.s[3]++;var calculatorJobsDefaultsUpdateSuccess=function calculatorJobsDefaultsUpdateSuccess(state,action){cov_r8y2sa8j9.f[1]++;cov_r8y2sa8j9.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{defaults:action.defaults,loading:false,error:false,updated:true});};cov_r8y2sa8j9.s[5]++;var calculatorJobsDefaultsUpdateFail=function calculatorJobsDefaultsUpdateFail(state,action){cov_r8y2sa8j9.f[2]++;cov_r8y2sa8j9.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_r8y2sa8j9.s[7]++;var calculatorJobsDefaultsUpdateReset=function calculatorJobsDefaultsUpdateReset(state,action){cov_r8y2sa8j9.f[3]++;cov_r8y2sa8j9.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,updated:false});};/* ------------------- Defaults Fetch -------------------- */cov_r8y2sa8j9.s[9]++;var calculatorJobsDefaultsFetchStart=function calculatorJobsDefaultsFetchStart(state,action){cov_r8y2sa8j9.f[4]++;cov_r8y2sa8j9.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false});};cov_r8y2sa8j9.s[11]++;var calculatorJobsDefaultsFetchSuccess=function calculatorJobsDefaultsFetchSuccess(state,action){cov_r8y2sa8j9.f[5]++;cov_r8y2sa8j9.s[12]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{defaults:action.defaults,loading:false,error:false});};cov_r8y2sa8j9.s[13]++;var calculatorJobsDefaultsFetchFail=function calculatorJobsDefaultsFetchFail(state,action){cov_r8y2sa8j9.f[6]++;cov_r8y2sa8j9.s[14]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_r8y2sa8j9.s[15]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_r8y2sa8j9.b[0][0]++,initialState);var action=arguments[1];cov_r8y2sa8j9.f[7]++;cov_r8y2sa8j9.s[16]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["k" /* CALCULATOR_JOBS_DEFAULTS_FETCH_START */]:cov_r8y2sa8j9.b[1][0]++;cov_r8y2sa8j9.s[17]++;return calculatorJobsDefaultsFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["l" /* CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS */]:cov_r8y2sa8j9.b[1][1]++;cov_r8y2sa8j9.s[18]++;return calculatorJobsDefaultsFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["j" /* CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL */]:cov_r8y2sa8j9.b[1][2]++;cov_r8y2sa8j9.s[19]++;return calculatorJobsDefaultsFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["o" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_START */]:cov_r8y2sa8j9.b[1][3]++;cov_r8y2sa8j9.s[20]++;return calculatorJobsDefaultsUpdateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["p" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS */]:cov_r8y2sa8j9.b[1][4]++;cov_r8y2sa8j9.s[21]++;return calculatorJobsDefaultsUpdateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["m" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL */]:cov_r8y2sa8j9.b[1][5]++;cov_r8y2sa8j9.s[22]++;return calculatorJobsDefaultsUpdateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["n" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET */]:cov_r8y2sa8j9.b[1][6]++;cov_r8y2sa8j9.s[23]++;return calculatorJobsDefaultsUpdateReset(state,action);default:cov_r8y2sa8j9.b[1][7]++;cov_r8y2sa8j9.s[24]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_75olp58gb=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\job.js',hash='e8712b30a1630b5b7e30e81dc702d7445716aedb',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\jobs\\job.js',statementMap:{'0':{start:{line:4,column:21},end:{line:45,column:1}},'1':{start:{line:48,column:33},end:{line:50,column:1}},'2':{start:{line:49,column:4},end:{line:49,column:117}},'3':{start:{line:52,column:33},end:{line:54,column:1}},'4':{start:{line:53,column:4},end:{line:53,column:117}},'5':{start:{line:56,column:35},end:{line:66,column:1}},'6':{start:{line:57,column:4},end:{line:65,column:8}},'7':{start:{line:68,column:32},end:{line:70,column:1}},'8':{start:{line:69,column:4},end:{line:69,column:96}},'9':{start:{line:73,column:41},end:{line:75,column:1}},'10':{start:{line:74,column:4},end:{line:74,column:131}},'11':{start:{line:77,column:43},end:{line:85,column:1}},'12':{start:{line:78,column:4},end:{line:84,column:8}},'13':{start:{line:87,column:40},end:{line:89,column:1}},'14':{start:{line:88,column:4},end:{line:88,column:96}},'15':{start:{line:91,column:41},end:{line:93,column:1}},'16':{start:{line:92,column:4},end:{line:92,column:102}},'17':{start:{line:96,column:32},end:{line:98,column:1}},'18':{start:{line:97,column:4},end:{line:97,column:117}},'19':{start:{line:100,column:32},end:{line:102,column:1}},'20':{start:{line:101,column:4},end:{line:101,column:118}},'21':{start:{line:104,column:34},end:{line:114,column:1}},'22':{start:{line:105,column:4},end:{line:113,column:8}},'23':{start:{line:116,column:31},end:{line:118,column:1}},'24':{start:{line:117,column:4},end:{line:117,column:96}},'25':{start:{line:121,column:32},end:{line:123,column:1}},'26':{start:{line:122,column:4},end:{line:122,column:84}},'27':{start:{line:124,column:34},end:{line:126,column:1}},'28':{start:{line:125,column:4},end:{line:125,column:75}},'29':{start:{line:129,column:39},end:{line:131,column:1}},'30':{start:{line:130,column:4},end:{line:130,column:125}},'31':{start:{line:133,column:39},end:{line:135,column:1}},'32':{start:{line:134,column:4},end:{line:134,column:126}},'33':{start:{line:137,column:41},end:{line:147,column:1}},'34':{start:{line:138,column:4},end:{line:146,column:8}},'35':{start:{line:149,column:38},end:{line:151,column:1}},'36':{start:{line:150,column:4},end:{line:150,column:114}},'37':{start:{line:154,column:44},end:{line:156,column:1}},'38':{start:{line:155,column:4},end:{line:155,column:135}},'39':{start:{line:158,column:44},end:{line:160,column:1}},'40':{start:{line:159,column:4},end:{line:159,column:136}},'41':{start:{line:162,column:46},end:{line:172,column:1}},'42':{start:{line:163,column:4},end:{line:171,column:8}},'43':{start:{line:174,column:43},end:{line:176,column:1}},'44':{start:{line:175,column:4},end:{line:175,column:114}},'45':{start:{line:179,column:38},end:{line:181,column:1}},'46':{start:{line:180,column:4},end:{line:180,column:138}},'47':{start:{line:183,column:38},end:{line:185,column:1}},'48':{start:{line:184,column:4},end:{line:184,column:139}},'49':{start:{line:187,column:40},end:{line:198,column:1}},'50':{start:{line:188,column:4},end:{line:197,column:8}},'51':{start:{line:200,column:37},end:{line:202,column:1}},'52':{start:{line:201,column:4},end:{line:201,column:102}},'53':{start:{line:205,column:33},end:{line:207,column:1}},'54':{start:{line:206,column:4},end:{line:206,column:105}},'55':{start:{line:209,column:33},end:{line:211,column:1}},'56':{start:{line:210,column:4},end:{line:210,column:105}},'57':{start:{line:213,column:35},end:{line:223,column:1}},'58':{start:{line:214,column:4},end:{line:222,column:8}},'59':{start:{line:225,column:32},end:{line:227,column:1}},'60':{start:{line:226,column:4},end:{line:226,column:96}},'61':{start:{line:230,column:40},end:{line:232,column:1}},'62':{start:{line:231,column:4},end:{line:231,column:113}},'63':{start:{line:234,column:40},end:{line:236,column:1}},'64':{start:{line:235,column:4},end:{line:235,column:113}},'65':{start:{line:238,column:42},end:{line:251,column:1}},'66':{start:{line:239,column:4},end:{line:250,column:8}},'67':{start:{line:253,column:39},end:{line:255,column:1}},'68':{start:{line:254,column:4},end:{line:254,column:104}},'69':{start:{line:258,column:33},end:{line:260,column:1}},'70':{start:{line:259,column:4},end:{line:259,column:103}},'71':{start:{line:262,column:33},end:{line:264,column:1}},'72':{start:{line:263,column:4},end:{line:263,column:105}},'73':{start:{line:266,column:35},end:{line:275,column:1}},'74':{start:{line:267,column:4},end:{line:274,column:8}},'75':{start:{line:277,column:32},end:{line:279,column:1}},'76':{start:{line:278,column:4},end:{line:278,column:96}},'77':{start:{line:282,column:39},end:{line:284,column:1}},'78':{start:{line:283,column:4},end:{line:283,column:108}},'79':{start:{line:286,column:39},end:{line:288,column:1}},'80':{start:{line:287,column:4},end:{line:287,column:110}},'81':{start:{line:290,column:41},end:{line:299,column:1}},'82':{start:{line:291,column:4},end:{line:298,column:8}},'83':{start:{line:301,column:38},end:{line:303,column:1}},'84':{start:{line:302,column:4},end:{line:302,column:96}},'85':{start:{line:306,column:38},end:{line:308,column:1}},'86':{start:{line:307,column:4},end:{line:307,column:108}},'87':{start:{line:310,column:38},end:{line:312,column:1}},'88':{start:{line:311,column:4},end:{line:311,column:110}},'89':{start:{line:314,column:40},end:{line:323,column:1}},'90':{start:{line:315,column:4},end:{line:322,column:8}},'91':{start:{line:325,column:37},end:{line:327,column:1}},'92':{start:{line:326,column:4},end:{line:326,column:96}},'93':{start:{line:330,column:46},end:{line:332,column:1}},'94':{start:{line:331,column:4},end:{line:331,column:166}},'95':{start:{line:334,column:46},end:{line:336,column:1}},'96':{start:{line:335,column:4},end:{line:335,column:168}},'97':{start:{line:338,column:48},end:{line:348,column:1}},'98':{start:{line:339,column:4},end:{line:347,column:8}},'99':{start:{line:350,column:45},end:{line:352,column:1}},'100':{start:{line:351,column:4},end:{line:351,column:130}},'101':{start:{line:354,column:16},end:{line:408,column:1}},'102':{start:{line:355,column:4},end:{line:407,column:5}},'103':{start:{line:356,column:51},end:{line:356,column:100}},'104':{start:{line:357,column:53},end:{line:357,column:104}},'105':{start:{line:358,column:50},end:{line:358,column:98}},'106':{start:{line:359,column:54},end:{line:359,column:103}},'107':{start:{line:360,column:62},end:{line:360,column:119}},'108':{start:{line:361,column:64},end:{line:361,column:123}},'109':{start:{line:362,column:61},end:{line:362,column:117}},'110':{start:{line:363,column:62},end:{line:363,column:119}},'111':{start:{line:364,column:53},end:{line:364,column:101}},'112':{start:{line:365,column:55},end:{line:365,column:105}},'113':{start:{line:366,column:52},end:{line:366,column:99}},'114':{start:{line:367,column:53},end:{line:367,column:101}},'115':{start:{line:368,column:53},end:{line:368,column:101}},'116':{start:{line:369,column:55},end:{line:369,column:105}},'117':{start:{line:370,column:54},end:{line:370,column:103}},'118':{start:{line:371,column:56},end:{line:371,column:107}},'119':{start:{line:372,column:53},end:{line:372,column:101}},'120':{start:{line:373,column:54},end:{line:373,column:103}},'121':{start:{line:374,column:62},end:{line:374,column:118}},'122':{start:{line:375,column:64},end:{line:375,column:122}},'123':{start:{line:376,column:61},end:{line:376,column:116}},'124':{start:{line:377,column:62},end:{line:377,column:118}},'125':{start:{line:378,column:61},end:{line:378,column:116}},'126':{start:{line:379,column:63},end:{line:379,column:120}},'127':{start:{line:380,column:60},end:{line:380,column:114}},'128':{start:{line:381,column:61},end:{line:381,column:116}},'129':{start:{line:382,column:66},end:{line:382,column:126}},'130':{start:{line:383,column:68},end:{line:383,column:130}},'131':{start:{line:384,column:65},end:{line:384,column:124}},'132':{start:{line:385,column:66},end:{line:385,column:126}},'133':{start:{line:386,column:60},end:{line:386,column:114}},'134':{start:{line:387,column:62},end:{line:387,column:118}},'135':{start:{line:388,column:59},end:{line:388,column:112}},'136':{start:{line:389,column:60},end:{line:389,column:114}},'137':{start:{line:390,column:54},end:{line:390,column:103}},'138':{start:{line:391,column:56},end:{line:391,column:107}},'139':{start:{line:392,column:53},end:{line:392,column:101}},'140':{start:{line:393,column:54},end:{line:393,column:103}},'141':{start:{line:394,column:60},end:{line:394,column:115}},'142':{start:{line:395,column:62},end:{line:395,column:119}},'143':{start:{line:396,column:59},end:{line:396,column:113}},'144':{start:{line:397,column:60},end:{line:397,column:115}},'145':{start:{line:398,column:59},end:{line:398,column:113}},'146':{start:{line:399,column:61},end:{line:399,column:117}},'147':{start:{line:400,column:58},end:{line:400,column:111}},'148':{start:{line:401,column:59},end:{line:401,column:113}},'149':{start:{line:402,column:68},end:{line:402,column:130}},'150':{start:{line:403,column:70},end:{line:403,column:134}},'151':{start:{line:404,column:67},end:{line:404,column:128}},'152':{start:{line:405,column:68},end:{line:405,column:130}},'153':{start:{line:406,column:17},end:{line:406,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:48,column:33},end:{line:48,column:34}},loc:{start:{line:48,column:54},end:{line:50,column:1}},line:48},'1':{name:'(anonymous_1)',decl:{start:{line:52,column:33},end:{line:52,column:34}},loc:{start:{line:52,column:54},end:{line:54,column:1}},line:52},'2':{name:'(anonymous_2)',decl:{start:{line:56,column:35},end:{line:56,column:36}},loc:{start:{line:56,column:56},end:{line:66,column:1}},line:56},'3':{name:'(anonymous_3)',decl:{start:{line:68,column:32},end:{line:68,column:33}},loc:{start:{line:68,column:53},end:{line:70,column:1}},line:68},'4':{name:'(anonymous_4)',decl:{start:{line:73,column:41},end:{line:73,column:42}},loc:{start:{line:73,column:62},end:{line:75,column:1}},line:73},'5':{name:'(anonymous_5)',decl:{start:{line:77,column:43},end:{line:77,column:44}},loc:{start:{line:77,column:64},end:{line:85,column:1}},line:77},'6':{name:'(anonymous_6)',decl:{start:{line:87,column:40},end:{line:87,column:41}},loc:{start:{line:87,column:61},end:{line:89,column:1}},line:87},'7':{name:'(anonymous_7)',decl:{start:{line:91,column:41},end:{line:91,column:42}},loc:{start:{line:91,column:62},end:{line:93,column:1}},line:91},'8':{name:'(anonymous_8)',decl:{start:{line:96,column:32},end:{line:96,column:33}},loc:{start:{line:96,column:53},end:{line:98,column:1}},line:96},'9':{name:'(anonymous_9)',decl:{start:{line:100,column:32},end:{line:100,column:33}},loc:{start:{line:100,column:53},end:{line:102,column:1}},line:100},'10':{name:'(anonymous_10)',decl:{start:{line:104,column:34},end:{line:104,column:35}},loc:{start:{line:104,column:55},end:{line:114,column:1}},line:104},'11':{name:'(anonymous_11)',decl:{start:{line:116,column:31},end:{line:116,column:32}},loc:{start:{line:116,column:52},end:{line:118,column:1}},line:116},'12':{name:'(anonymous_12)',decl:{start:{line:121,column:32},end:{line:121,column:33}},loc:{start:{line:121,column:53},end:{line:123,column:1}},line:121},'13':{name:'(anonymous_13)',decl:{start:{line:124,column:34},end:{line:124,column:35}},loc:{start:{line:124,column:55},end:{line:126,column:1}},line:124},'14':{name:'(anonymous_14)',decl:{start:{line:129,column:39},end:{line:129,column:40}},loc:{start:{line:129,column:60},end:{line:131,column:1}},line:129},'15':{name:'(anonymous_15)',decl:{start:{line:133,column:39},end:{line:133,column:40}},loc:{start:{line:133,column:60},end:{line:135,column:1}},line:133},'16':{name:'(anonymous_16)',decl:{start:{line:137,column:41},end:{line:137,column:42}},loc:{start:{line:137,column:62},end:{line:147,column:1}},line:137},'17':{name:'(anonymous_17)',decl:{start:{line:149,column:38},end:{line:149,column:39}},loc:{start:{line:149,column:59},end:{line:151,column:1}},line:149},'18':{name:'(anonymous_18)',decl:{start:{line:154,column:44},end:{line:154,column:45}},loc:{start:{line:154,column:65},end:{line:156,column:1}},line:154},'19':{name:'(anonymous_19)',decl:{start:{line:158,column:44},end:{line:158,column:45}},loc:{start:{line:158,column:65},end:{line:160,column:1}},line:158},'20':{name:'(anonymous_20)',decl:{start:{line:162,column:46},end:{line:162,column:47}},loc:{start:{line:162,column:67},end:{line:172,column:1}},line:162},'21':{name:'(anonymous_21)',decl:{start:{line:174,column:43},end:{line:174,column:44}},loc:{start:{line:174,column:64},end:{line:176,column:1}},line:174},'22':{name:'(anonymous_22)',decl:{start:{line:179,column:38},end:{line:179,column:39}},loc:{start:{line:179,column:59},end:{line:181,column:1}},line:179},'23':{name:'(anonymous_23)',decl:{start:{line:183,column:38},end:{line:183,column:39}},loc:{start:{line:183,column:59},end:{line:185,column:1}},line:183},'24':{name:'(anonymous_24)',decl:{start:{line:187,column:40},end:{line:187,column:41}},loc:{start:{line:187,column:61},end:{line:198,column:1}},line:187},'25':{name:'(anonymous_25)',decl:{start:{line:200,column:37},end:{line:200,column:38}},loc:{start:{line:200,column:58},end:{line:202,column:1}},line:200},'26':{name:'(anonymous_26)',decl:{start:{line:205,column:33},end:{line:205,column:34}},loc:{start:{line:205,column:54},end:{line:207,column:1}},line:205},'27':{name:'(anonymous_27)',decl:{start:{line:209,column:33},end:{line:209,column:34}},loc:{start:{line:209,column:54},end:{line:211,column:1}},line:209},'28':{name:'(anonymous_28)',decl:{start:{line:213,column:35},end:{line:213,column:36}},loc:{start:{line:213,column:56},end:{line:223,column:1}},line:213},'29':{name:'(anonymous_29)',decl:{start:{line:225,column:32},end:{line:225,column:33}},loc:{start:{line:225,column:53},end:{line:227,column:1}},line:225},'30':{name:'(anonymous_30)',decl:{start:{line:230,column:40},end:{line:230,column:41}},loc:{start:{line:230,column:61},end:{line:232,column:1}},line:230},'31':{name:'(anonymous_31)',decl:{start:{line:234,column:40},end:{line:234,column:41}},loc:{start:{line:234,column:61},end:{line:236,column:1}},line:234},'32':{name:'(anonymous_32)',decl:{start:{line:238,column:42},end:{line:238,column:43}},loc:{start:{line:238,column:63},end:{line:251,column:1}},line:238},'33':{name:'(anonymous_33)',decl:{start:{line:253,column:39},end:{line:253,column:40}},loc:{start:{line:253,column:60},end:{line:255,column:1}},line:253},'34':{name:'(anonymous_34)',decl:{start:{line:258,column:33},end:{line:258,column:34}},loc:{start:{line:258,column:54},end:{line:260,column:1}},line:258},'35':{name:'(anonymous_35)',decl:{start:{line:262,column:33},end:{line:262,column:34}},loc:{start:{line:262,column:54},end:{line:264,column:1}},line:262},'36':{name:'(anonymous_36)',decl:{start:{line:266,column:35},end:{line:266,column:36}},loc:{start:{line:266,column:56},end:{line:275,column:1}},line:266},'37':{name:'(anonymous_37)',decl:{start:{line:277,column:32},end:{line:277,column:33}},loc:{start:{line:277,column:53},end:{line:279,column:1}},line:277},'38':{name:'(anonymous_38)',decl:{start:{line:282,column:39},end:{line:282,column:40}},loc:{start:{line:282,column:60},end:{line:284,column:1}},line:282},'39':{name:'(anonymous_39)',decl:{start:{line:286,column:39},end:{line:286,column:40}},loc:{start:{line:286,column:60},end:{line:288,column:1}},line:286},'40':{name:'(anonymous_40)',decl:{start:{line:290,column:41},end:{line:290,column:42}},loc:{start:{line:290,column:62},end:{line:299,column:1}},line:290},'41':{name:'(anonymous_41)',decl:{start:{line:301,column:38},end:{line:301,column:39}},loc:{start:{line:301,column:59},end:{line:303,column:1}},line:301},'42':{name:'(anonymous_42)',decl:{start:{line:306,column:38},end:{line:306,column:39}},loc:{start:{line:306,column:59},end:{line:308,column:1}},line:306},'43':{name:'(anonymous_43)',decl:{start:{line:310,column:38},end:{line:310,column:39}},loc:{start:{line:310,column:59},end:{line:312,column:1}},line:310},'44':{name:'(anonymous_44)',decl:{start:{line:314,column:40},end:{line:314,column:41}},loc:{start:{line:314,column:61},end:{line:323,column:1}},line:314},'45':{name:'(anonymous_45)',decl:{start:{line:325,column:37},end:{line:325,column:38}},loc:{start:{line:325,column:58},end:{line:327,column:1}},line:325},'46':{name:'(anonymous_46)',decl:{start:{line:330,column:46},end:{line:330,column:47}},loc:{start:{line:330,column:67},end:{line:332,column:1}},line:330},'47':{name:'(anonymous_47)',decl:{start:{line:334,column:46},end:{line:334,column:47}},loc:{start:{line:334,column:67},end:{line:336,column:1}},line:334},'48':{name:'(anonymous_48)',decl:{start:{line:338,column:48},end:{line:338,column:49}},loc:{start:{line:338,column:69},end:{line:348,column:1}},line:338},'49':{name:'(anonymous_49)',decl:{start:{line:350,column:45},end:{line:350,column:46}},loc:{start:{line:350,column:66},end:{line:352,column:1}},line:350},'50':{name:'(anonymous_50)',decl:{start:{line:354,column:16},end:{line:354,column:17}},loc:{start:{line:354,column:52},end:{line:408,column:1}},line:354}},branchMap:{'0':{loc:{start:{line:354,column:18},end:{line:354,column:38}},type:'default-arg',locations:[{start:{line:354,column:26},end:{line:354,column:38}}],line:354},'1':{loc:{start:{line:355,column:4},end:{line:407,column:5}},type:'switch',locations:[{start:{line:356,column:5},end:{line:356,column:100}},{start:{line:357,column:5},end:{line:357,column:104}},{start:{line:358,column:5},end:{line:358,column:98}},{start:{line:359,column:8},end:{line:359,column:103}},{start:{line:360,column:8},end:{line:360,column:119}},{start:{line:361,column:8},end:{line:361,column:123}},{start:{line:362,column:8},end:{line:362,column:117}},{start:{line:363,column:8},end:{line:363,column:119}},{start:{line:364,column:8},end:{line:364,column:101}},{start:{line:365,column:8},end:{line:365,column:105}},{start:{line:366,column:8},end:{line:366,column:99}},{start:{line:367,column:8},end:{line:367,column:101}},{start:{line:368,column:8},end:{line:368,column:101}},{start:{line:369,column:8},end:{line:369,column:105}},{start:{line:370,column:8},end:{line:370,column:103}},{start:{line:371,column:8},end:{line:371,column:107}},{start:{line:372,column:8},end:{line:372,column:101}},{start:{line:373,column:8},end:{line:373,column:103}},{start:{line:374,column:8},end:{line:374,column:118}},{start:{line:375,column:8},end:{line:375,column:122}},{start:{line:376,column:8},end:{line:376,column:116}},{start:{line:377,column:8},end:{line:377,column:118}},{start:{line:378,column:8},end:{line:378,column:116}},{start:{line:379,column:8},end:{line:379,column:120}},{start:{line:380,column:8},end:{line:380,column:114}},{start:{line:381,column:8},end:{line:381,column:116}},{start:{line:382,column:8},end:{line:382,column:126}},{start:{line:383,column:8},end:{line:383,column:130}},{start:{line:384,column:8},end:{line:384,column:124}},{start:{line:385,column:8},end:{line:385,column:126}},{start:{line:386,column:8},end:{line:386,column:114}},{start:{line:387,column:8},end:{line:387,column:118}},{start:{line:388,column:8},end:{line:388,column:112}},{start:{line:389,column:8},end:{line:389,column:114}},{start:{line:390,column:8},end:{line:390,column:103}},{start:{line:391,column:8},end:{line:391,column:107}},{start:{line:392,column:8},end:{line:392,column:101}},{start:{line:393,column:8},end:{line:393,column:103}},{start:{line:394,column:8},end:{line:394,column:115}},{start:{line:395,column:8},end:{line:395,column:119}},{start:{line:396,column:8},end:{line:396,column:113}},{start:{line:397,column:8},end:{line:397,column:115}},{start:{line:398,column:8},end:{line:398,column:113}},{start:{line:399,column:8},end:{line:399,column:117}},{start:{line:400,column:8},end:{line:400,column:111}},{start:{line:401,column:8},end:{line:401,column:113}},{start:{line:402,column:8},end:{line:402,column:130}},{start:{line:403,column:8},end:{line:403,column:134}},{start:{line:404,column:8},end:{line:404,column:128}},{start:{line:405,column:8},end:{line:405,column:130}},{start:{line:406,column:8},end:{line:406,column:30}}],line:355}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0,'115':0,'116':0,'117':0,'118':0,'119':0,'120':0,'121':0,'122':0,'123':0,'124':0,'125':0,'126':0,'127':0,'128':0,'129':0,'130':0,'131':0,'132':0,'133':0,'134':0,'135':0,'136':0,'137':0,'138':0,'139':0,'140':0,'141':0,'142':0,'143':0,'144':0,'145':0,'146':0,'147':0,'148':0,'149':0,'150':0,'151':0,'152':0,'153':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0},b:{'0':[0],'1':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_75olp58gb.s[0]++,{job:{loading:false,error:false,created:false,updated:false,fetched:false,deleted:false,name_available:true,name_checked:false,changed_used:false,details:{},message:false,recalculated:false},detailed_calculation:{loading:false,error:false,fetched:false,details:{}},machine:{loading:false,error:false,fetched:false,updated:false,details:{}},calculations:{loading:false,error:false,fetched:false,details:[]},export:{loading:false,error:false,fetched:false,filename:"",filebody:[]}});/* ------------------ Job Create ------------------- */cov_75olp58gb.s[1]++;var calculatorJobCreateStart=function calculatorJobCreateStart(state,action){cov_75olp58gb.f[0]++;cov_75olp58gb.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,error:false,created:false,details:{}})});};cov_75olp58gb.s[3]++;var calculatorJobCreateReset=function calculatorJobCreateReset(state,action){cov_75olp58gb.f[1]++;cov_75olp58gb.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,created:false,details:{}})});};cov_75olp58gb.s[5]++;var calculatorJobCreateSuccess=function calculatorJobCreateSuccess(state,action){cov_75olp58gb.f[2]++;cov_75olp58gb.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{details:action.details,loading:false,error:false,created:true})});};cov_75olp58gb.s[7]++;var calculatorJobCreateFail=function calculatorJobCreateFail(state,action){cov_75olp58gb.f[3]++;cov_75olp58gb.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ----------------- Job Duplicate ------------------ */cov_75olp58gb.s[9]++;var calculatorJobDuplicateCheckStart=function calculatorJobDuplicateCheckStart(state,action){cov_75olp58gb.f[4]++;cov_75olp58gb.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,name_available:true,error:false,name_checked:false})});};cov_75olp58gb.s[11]++;var calculatorJobDuplicateCheckSuccess=function calculatorJobDuplicateCheckSuccess(state,action){cov_75olp58gb.f[5]++;cov_75olp58gb.s[12]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{name_available:!action.name_duplicate,name_checked:true})});};cov_75olp58gb.s[13]++;var calculatorJobDuplicateCheckFail=function calculatorJobDuplicateCheckFail(state,action){cov_75olp58gb.f[6]++;cov_75olp58gb.s[14]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};cov_75olp58gb.s[15]++;var calculatorJobDuplicateCheckReset=function calculatorJobDuplicateCheckReset(state,action){cov_75olp58gb.f[7]++;cov_75olp58gb.s[16]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{name_available:true,name_checked:false})});};/* ------------------ Job Fetch ------------------- */cov_75olp58gb.s[17]++;var calculatorJobFetchStart=function calculatorJobFetchStart(state,action){cov_75olp58gb.f[8]++;cov_75olp58gb.s[18]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,error:false,fetched:false,details:{}})});};cov_75olp58gb.s[19]++;var calculatorJobFetchReset=function calculatorJobFetchReset(state,action){cov_75olp58gb.f[9]++;cov_75olp58gb.s[20]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,fetched:false,details:{}})});};cov_75olp58gb.s[21]++;var calculatorJobFetchSuccess=function calculatorJobFetchSuccess(state,action){cov_75olp58gb.f[10]++;cov_75olp58gb.s[22]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{details:action.details,loading:false,error:false,fetched:true})});};cov_75olp58gb.s[23]++;var calculatorJobFetchFail=function calculatorJobFetchFail(state,action){cov_75olp58gb.f[11]++;cov_75olp58gb.s[24]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ------------------ Job Message ------------------- */cov_75olp58gb.s[25]++;var calculatorJobMessageSet=function calculatorJobMessageSet(state,action){cov_75olp58gb.f[12]++;cov_75olp58gb.s[26]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{message:action.message})});};cov_75olp58gb.s[27]++;var calculatorJobMessageReset=function calculatorJobMessageReset(state,action){cov_75olp58gb.f[13]++;cov_75olp58gb.s[28]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{message:false})});};/* ------------------ Job Machine Fetch ------------------- */cov_75olp58gb.s[29]++;var calculatorJobMachineFetchStart=function calculatorJobMachineFetchStart(state,action){cov_75olp58gb.f[14]++;cov_75olp58gb.s[30]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{loading:true,error:false,fetched:false,details:{}})});};cov_75olp58gb.s[31]++;var calculatorJobMachineFetchReset=function calculatorJobMachineFetchReset(state,action){cov_75olp58gb.f[15]++;cov_75olp58gb.s[32]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{loading:false,error:false,fetched:false,details:{}})});};cov_75olp58gb.s[33]++;var calculatorJobMachineFetchSuccess=function calculatorJobMachineFetchSuccess(state,action){cov_75olp58gb.f[16]++;cov_75olp58gb.s[34]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{details:action.details,loading:false,error:false,fetched:true})});};cov_75olp58gb.s[35]++;var calculatorJobMachineFetchFail=function calculatorJobMachineFetchFail(state,action){cov_75olp58gb.f[17]++;cov_75olp58gb.s[36]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{calculations:Object.assign({},state.calculations,{loading:false,error:action.error})});};/* ------------------ Job Calculations Fetch ------------------- */cov_75olp58gb.s[37]++;var calculatorJobCalculationsFetchStart=function calculatorJobCalculationsFetchStart(state,action){cov_75olp58gb.f[18]++;cov_75olp58gb.s[38]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{calculations:Object.assign({},state.calculations,{loading:true,error:false,fetched:false,details:[]})});};cov_75olp58gb.s[39]++;var calculatorJobCalculationsFetchReset=function calculatorJobCalculationsFetchReset(state,action){cov_75olp58gb.f[19]++;cov_75olp58gb.s[40]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{calculations:Object.assign({},state.calculations,{loading:false,error:false,fetched:false,details:[]})});};cov_75olp58gb.s[41]++;var calculatorJobCalculationsFetchSuccess=function calculatorJobCalculationsFetchSuccess(state,action){cov_75olp58gb.f[20]++;cov_75olp58gb.s[42]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{calculations:Object.assign({},state.calculations,{details:action.details,loading:false,error:false,fetched:true})});};cov_75olp58gb.s[43]++;var calculatorJobCalculationsFetchFail=function calculatorJobCalculationsFetchFail(state,action){cov_75olp58gb.f[21]++;cov_75olp58gb.s[44]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{calculations:Object.assign({},state.calculations,{loading:false,error:action.error})});};/* ------------------ Job Export Fetch ------------------- */cov_75olp58gb.s[45]++;var calculatorJobExportFetchStart=function calculatorJobExportFetchStart(state,action){cov_75olp58gb.f[22]++;cov_75olp58gb.s[46]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{export:Object.assign({},state.export,{loading:true,error:false,fetched:false,filename:"",filebody:[]})});};cov_75olp58gb.s[47]++;var calculatorJobExportFetchReset=function calculatorJobExportFetchReset(state,action){cov_75olp58gb.f[23]++;cov_75olp58gb.s[48]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{export:Object.assign({},state.export,{loading:false,error:false,fetched:false,filename:"",filebody:[]})});};cov_75olp58gb.s[49]++;var calculatorJobExportFetchSuccess=function calculatorJobExportFetchSuccess(state,action){cov_75olp58gb.f[24]++;cov_75olp58gb.s[50]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{export:Object.assign({},state.export,{filebody:action.filebody,filename:action.filename,loading:false,error:false,fetched:true})});};cov_75olp58gb.s[51]++;var calculatorJobExportFetchFail=function calculatorJobExportFetchFail(state,action){cov_75olp58gb.f[25]++;cov_75olp58gb.s[52]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{export:Object.assign({},state.export,{loading:false,error:action.error})});};/* ------------------ Job Update ------------------- */cov_75olp58gb.s[53]++;var calculatorJobUpdateStart=function calculatorJobUpdateStart(state,action){cov_75olp58gb.f[26]++;cov_75olp58gb.s[54]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,updated:false})});};cov_75olp58gb.s[55]++;var calculatorJobUpdateReset=function calculatorJobUpdateReset(state,action){cov_75olp58gb.f[27]++;cov_75olp58gb.s[56]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,updated:false})});};cov_75olp58gb.s[57]++;var calculatorJobUpdateSuccess=function calculatorJobUpdateSuccess(state,action){cov_75olp58gb.f[28]++;cov_75olp58gb.s[58]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{filebody:action.filebody,loading:false,error:false,updated:true})});};cov_75olp58gb.s[59]++;var calculatorJobUpdateFail=function calculatorJobUpdateFail(state,action){cov_75olp58gb.f[29]++;cov_75olp58gb.s[60]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ------------------ Job Machine Update ------------------- */cov_75olp58gb.s[61]++;var calculatorJobMachineUpdateStart=function calculatorJobMachineUpdateStart(state,action){cov_75olp58gb.f[30]++;cov_75olp58gb.s[62]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{loading:false,error:false,updated:false})});};cov_75olp58gb.s[63]++;var calculatorJobMachineUpdateReset=function calculatorJobMachineUpdateReset(state,action){cov_75olp58gb.f[31]++;cov_75olp58gb.s[64]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{loading:false,error:false,updated:false})});};cov_75olp58gb.s[65]++;var calculatorJobMachineUpdateSuccess=function calculatorJobMachineUpdateSuccess(state,action){cov_75olp58gb.f[32]++;cov_75olp58gb.s[66]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{details:Object.assign({},state.machine.details,{settings:action.settings}),loading:false,error:false,updated:true})});};cov_75olp58gb.s[67]++;var calculatorJobMachineUpdateFail=function calculatorJobMachineUpdateFail(state,action){cov_75olp58gb.f[33]++;cov_75olp58gb.s[68]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:Object.assign({},state.machine,{loading:false,error:action.error})});};/* ------------------ Job Delete ------------------- */cov_75olp58gb.s[69]++;var calculatorJobDeleteStart=function calculatorJobDeleteStart(state,action){cov_75olp58gb.f[34]++;cov_75olp58gb.s[70]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,error:false,deleted:false})});};cov_75olp58gb.s[71]++;var calculatorJobDeleteReset=function calculatorJobDeleteReset(state,action){cov_75olp58gb.f[35]++;cov_75olp58gb.s[72]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,deleted:false})});};cov_75olp58gb.s[73]++;var calculatorJobDeleteSuccess=function calculatorJobDeleteSuccess(state,action){cov_75olp58gb.f[36]++;cov_75olp58gb.s[74]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,deleted:true})});};cov_75olp58gb.s[75]++;var calculatorJobDeleteFail=function calculatorJobDeleteFail(state,action){cov_75olp58gb.f[37]++;cov_75olp58gb.s[76]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ------------------ Job Change Active ------------------- */cov_75olp58gb.s[77]++;var calculatorJobChangeActiveStart=function calculatorJobChangeActiveStart(state,action){cov_75olp58gb.f[38]++;cov_75olp58gb.s[78]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,error:false,changed_used:false})});};cov_75olp58gb.s[79]++;var calculatorJobChangeActiveReset=function calculatorJobChangeActiveReset(state,action){cov_75olp58gb.f[39]++;cov_75olp58gb.s[80]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,changed_used:false})});};cov_75olp58gb.s[81]++;var calculatorJobChangeActiveSuccess=function calculatorJobChangeActiveSuccess(state,action){cov_75olp58gb.f[40]++;cov_75olp58gb.s[82]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,changed_used:true})});};cov_75olp58gb.s[83]++;var calculatorJobChangeActiveFail=function calculatorJobChangeActiveFail(state,action){cov_75olp58gb.f[41]++;cov_75olp58gb.s[84]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ------------------ Job Recalculate ------------------- */cov_75olp58gb.s[85]++;var calculatorJobRecalculateStart=function calculatorJobRecalculateStart(state,action){cov_75olp58gb.f[42]++;cov_75olp58gb.s[86]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:true,error:false,recalculated:false})});};cov_75olp58gb.s[87]++;var calculatorJobRecalculateReset=function calculatorJobRecalculateReset(state,action){cov_75olp58gb.f[43]++;cov_75olp58gb.s[88]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,recalculated:false})});};cov_75olp58gb.s[89]++;var calculatorJobRecalculateSuccess=function calculatorJobRecalculateSuccess(state,action){cov_75olp58gb.f[44]++;cov_75olp58gb.s[90]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:false,recalculated:true})});};cov_75olp58gb.s[91]++;var calculatorJobRecalculateFail=function calculatorJobRecalculateFail(state,action){cov_75olp58gb.f[45]++;cov_75olp58gb.s[92]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{job:Object.assign({},state.job,{loading:false,error:action.error})});};/* ------------------ Job Detailed Calculation ------------------- */cov_75olp58gb.s[93]++;var calculatorJobDetailedCalculationStart=function calculatorJobDetailedCalculationStart(state,action){cov_75olp58gb.f[46]++;cov_75olp58gb.s[94]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{detailed_calculation:Object.assign({},state.detailed_calculation,{loading:true,error:false,fetched:false,detailed_calculation:false})});};cov_75olp58gb.s[95]++;var calculatorJobDetailedCalculationReset=function calculatorJobDetailedCalculationReset(state,action){cov_75olp58gb.f[47]++;cov_75olp58gb.s[96]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{detailed_calculation:Object.assign({},state.detailed_calculation,{loading:false,error:false,fetched:false,detailed_calculation:false})});};cov_75olp58gb.s[97]++;var calculatorJobDetailedCalculationSuccess=function calculatorJobDetailedCalculationSuccess(state,action){cov_75olp58gb.f[48]++;cov_75olp58gb.s[98]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{detailed_calculation:Object.assign({},state.detailed_calculation,{loading:false,error:false,fetched:true,details:action.details})});};cov_75olp58gb.s[99]++;var calculatorJobDetailedCalculationFail=function calculatorJobDetailedCalculationFail(state,action){cov_75olp58gb.f[49]++;cov_75olp58gb.s[100]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{detailed_calculation:Object.assign({},state.detailed_calculation,{loading:false,error:action.error})});};cov_75olp58gb.s[101]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_75olp58gb.b[0][0]++,initialState);var action=arguments[1];cov_75olp58gb.f[50]++;cov_75olp58gb.s[102]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["D" /* CALCULATOR_JOB_CREATE_START */]:cov_75olp58gb.b[1][0]++;cov_75olp58gb.s[103]++;return calculatorJobCreateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["E" /* CALCULATOR_JOB_CREATE_SUCCESS */]:cov_75olp58gb.b[1][1]++;cov_75olp58gb.s[104]++;return calculatorJobCreateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["B" /* CALCULATOR_JOB_CREATE_FAIL */]:cov_75olp58gb.b[1][2]++;cov_75olp58gb.s[105]++;return calculatorJobCreateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["C" /* CALCULATOR_JOB_CREATE_RESET */]:cov_75olp58gb.b[1][3]++;cov_75olp58gb.s[106]++;return calculatorJobCreateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["P" /* CALCULATOR_JOB_DUPLICATECHECK_START */]:cov_75olp58gb.b[1][4]++;cov_75olp58gb.s[107]++;return calculatorJobDuplicateCheckStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Q" /* CALCULATOR_JOB_DUPLICATECHECK_SUCCESS */]:cov_75olp58gb.b[1][5]++;cov_75olp58gb.s[108]++;return calculatorJobDuplicateCheckSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["N" /* CALCULATOR_JOB_DUPLICATECHECK_FAIL */]:cov_75olp58gb.b[1][6]++;cov_75olp58gb.s[109]++;return calculatorJobDuplicateCheckFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["O" /* CALCULATOR_JOB_DUPLICATECHECK_RESET */]:cov_75olp58gb.b[1][7]++;cov_75olp58gb.s[110]++;return calculatorJobDuplicateCheckReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["X" /* CALCULATOR_JOB_FETCH_START */]:cov_75olp58gb.b[1][8]++;cov_75olp58gb.s[111]++;return calculatorJobFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Y" /* CALCULATOR_JOB_FETCH_SUCCESS */]:cov_75olp58gb.b[1][9]++;cov_75olp58gb.s[112]++;return calculatorJobFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["V" /* CALCULATOR_JOB_FETCH_FAIL */]:cov_75olp58gb.b[1][10]++;cov_75olp58gb.s[113]++;return calculatorJobFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["W" /* CALCULATOR_JOB_FETCH_RESET */]:cov_75olp58gb.b[1][11]++;cov_75olp58gb.s[114]++;return calculatorJobFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_8" /* CALCULATOR_JOB_MESSAGE_SET */]:cov_75olp58gb.b[1][12]++;cov_75olp58gb.s[115]++;return calculatorJobMessageSet(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_7" /* CALCULATOR_JOB_MESSAGE_RESET */]:cov_75olp58gb.b[1][13]++;cov_75olp58gb.s[116]++;return calculatorJobMessageReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_15" /* CALCULATOR_JOB_UPDATE_START */]:cov_75olp58gb.b[1][14]++;cov_75olp58gb.s[117]++;return calculatorJobUpdateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_16" /* CALCULATOR_JOB_UPDATE_SUCCESS */]:cov_75olp58gb.b[1][15]++;cov_75olp58gb.s[118]++;return calculatorJobUpdateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_13" /* CALCULATOR_JOB_UPDATE_FAIL */]:cov_75olp58gb.b[1][16]++;cov_75olp58gb.s[119]++;return calculatorJobUpdateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_14" /* CALCULATOR_JOB_UPDATE_RESET */]:cov_75olp58gb.b[1][17]++;cov_75olp58gb.s[120]++;return calculatorJobUpdateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_5" /* CALCULATOR_JOB_MACHINE_UPDATE_START */]:cov_75olp58gb.b[1][18]++;cov_75olp58gb.s[121]++;return calculatorJobMachineUpdateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_6" /* CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS */]:cov_75olp58gb.b[1][19]++;cov_75olp58gb.s[122]++;return calculatorJobMachineUpdateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_3" /* CALCULATOR_JOB_MACHINE_UPDATE_FAIL */]:cov_75olp58gb.b[1][20]++;cov_75olp58gb.s[123]++;return calculatorJobMachineUpdateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_4" /* CALCULATOR_JOB_MACHINE_UPDATE_RESET */]:cov_75olp58gb.b[1][21]++;cov_75olp58gb.s[124]++;return calculatorJobMachineUpdateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_1" /* CALCULATOR_JOB_MACHINE_FETCH_START */]:cov_75olp58gb.b[1][22]++;cov_75olp58gb.s[125]++;return calculatorJobMachineFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_2" /* CALCULATOR_JOB_MACHINE_FETCH_SUCCESS */]:cov_75olp58gb.b[1][23]++;cov_75olp58gb.s[126]++;return calculatorJobMachineFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Z" /* CALCULATOR_JOB_MACHINE_FETCH_FAIL */]:cov_75olp58gb.b[1][24]++;cov_75olp58gb.s[127]++;return calculatorJobMachineFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_0" /* CALCULATOR_JOB_MACHINE_FETCH_RESET */]:cov_75olp58gb.b[1][25]++;cov_75olp58gb.s[128]++;return calculatorJobMachineFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["v" /* CALCULATOR_JOB_CALCULATIONS_FETCH_START */]:cov_75olp58gb.b[1][26]++;cov_75olp58gb.s[129]++;return calculatorJobCalculationsFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["w" /* CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS */]:cov_75olp58gb.b[1][27]++;cov_75olp58gb.s[130]++;return calculatorJobCalculationsFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["t" /* CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL */]:cov_75olp58gb.b[1][28]++;cov_75olp58gb.s[131]++;return calculatorJobCalculationsFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["u" /* CALCULATOR_JOB_CALCULATIONS_FETCH_RESET */]:cov_75olp58gb.b[1][29]++;cov_75olp58gb.s[132]++;return calculatorJobCalculationsFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["T" /* CALCULATOR_JOB_EXPORT_FETCH_START */]:cov_75olp58gb.b[1][30]++;cov_75olp58gb.s[133]++;return calculatorJobExportFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["U" /* CALCULATOR_JOB_EXPORT_FETCH_SUCCESS */]:cov_75olp58gb.b[1][31]++;cov_75olp58gb.s[134]++;return calculatorJobExportFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["R" /* CALCULATOR_JOB_EXPORT_FETCH_FAIL */]:cov_75olp58gb.b[1][32]++;cov_75olp58gb.s[135]++;return calculatorJobExportFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["S" /* CALCULATOR_JOB_EXPORT_FETCH_RESET */]:cov_75olp58gb.b[1][33]++;cov_75olp58gb.s[136]++;return calculatorJobExportFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["H" /* CALCULATOR_JOB_DELETE_START */]:cov_75olp58gb.b[1][34]++;cov_75olp58gb.s[137]++;return calculatorJobDeleteStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["I" /* CALCULATOR_JOB_DELETE_SUCCESS */]:cov_75olp58gb.b[1][35]++;cov_75olp58gb.s[138]++;return calculatorJobDeleteSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["F" /* CALCULATOR_JOB_DELETE_FAIL */]:cov_75olp58gb.b[1][36]++;cov_75olp58gb.s[139]++;return calculatorJobDeleteFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["G" /* CALCULATOR_JOB_DELETE_RESET */]:cov_75olp58gb.b[1][37]++;cov_75olp58gb.s[140]++;return calculatorJobDeleteReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["z" /* CALCULATOR_JOB_CHANGEACTIVE_START */]:cov_75olp58gb.b[1][38]++;cov_75olp58gb.s[141]++;return calculatorJobChangeActiveStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["A" /* CALCULATOR_JOB_CHANGEACTIVE_SUCCESS */]:cov_75olp58gb.b[1][39]++;cov_75olp58gb.s[142]++;return calculatorJobChangeActiveSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["x" /* CALCULATOR_JOB_CHANGEACTIVE_FAIL */]:cov_75olp58gb.b[1][40]++;cov_75olp58gb.s[143]++;return calculatorJobChangeActiveFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["y" /* CALCULATOR_JOB_CHANGEACTIVE_RESET */]:cov_75olp58gb.b[1][41]++;cov_75olp58gb.s[144]++;return calculatorJobChangeActiveReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_11" /* CALCULATOR_JOB_RECALCULATE_START */]:cov_75olp58gb.b[1][42]++;cov_75olp58gb.s[145]++;return calculatorJobRecalculateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_12" /* CALCULATOR_JOB_RECALCULATE_SUCCESS */]:cov_75olp58gb.b[1][43]++;cov_75olp58gb.s[146]++;return calculatorJobRecalculateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_9" /* CALCULATOR_JOB_RECALCULATE_FAIL */]:cov_75olp58gb.b[1][44]++;cov_75olp58gb.s[147]++;return calculatorJobRecalculateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_10" /* CALCULATOR_JOB_RECALCULATE_RESET */]:cov_75olp58gb.b[1][45]++;cov_75olp58gb.s[148]++;return calculatorJobRecalculateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["L" /* CALCULATOR_JOB_DETAILED_CALCULATION_START */]:cov_75olp58gb.b[1][46]++;cov_75olp58gb.s[149]++;return calculatorJobDetailedCalculationStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["M" /* CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS */]:cov_75olp58gb.b[1][47]++;cov_75olp58gb.s[150]++;return calculatorJobDetailedCalculationSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["J" /* CALCULATOR_JOB_DETAILED_CALCULATION_FAIL */]:cov_75olp58gb.b[1][48]++;cov_75olp58gb.s[151]++;return calculatorJobDetailedCalculationFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["K" /* CALCULATOR_JOB_DETAILED_CALCULATION_RESET */]:cov_75olp58gb.b[1][49]++;cov_75olp58gb.s[152]++;return calculatorJobDetailedCalculationReset(state,action);default:cov_75olp58gb.b[1][50]++;cov_75olp58gb.s[153]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1v25vgmkfb=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\machines.js',hash='c7dbb7f4a65a0bdc6f066097efcc8cacb6668b23',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\machines.js',statementMap:{'0':{start:{line:4,column:21},end:{line:8,column:1}},'1':{start:{line:10,column:37},end:{line:12,column:1}},'2':{start:{line:11,column:4},end:{line:11,column:66}},'3':{start:{line:14,column:39},end:{line:20,column:1}},'4':{start:{line:15,column:4},end:{line:19,column:8}},'5':{start:{line:22,column:36},end:{line:24,column:1}},'6':{start:{line:23,column:4},end:{line:23,column:74}},'7':{start:{line:26,column:16},end:{line:33,column:1}},'8':{start:{line:27,column:4},end:{line:32,column:5}},'9':{start:{line:28,column:55},end:{line:28,column:108}},'10':{start:{line:29,column:57},end:{line:29,column:112}},'11':{start:{line:30,column:54},end:{line:30,column:106}},'12':{start:{line:31,column:17},end:{line:31,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:37},end:{line:10,column:38}},loc:{start:{line:10,column:58},end:{line:12,column:1}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:39},end:{line:14,column:40}},loc:{start:{line:14,column:60},end:{line:20,column:1}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:22,column:36},end:{line:22,column:37}},loc:{start:{line:22,column:57},end:{line:24,column:1}},line:22},'3':{name:'(anonymous_3)',decl:{start:{line:26,column:16},end:{line:26,column:17}},loc:{start:{line:26,column:52},end:{line:33,column:1}},line:26}},branchMap:{'0':{loc:{start:{line:26,column:18},end:{line:26,column:38}},type:'default-arg',locations:[{start:{line:26,column:26},end:{line:26,column:38}}],line:26},'1':{loc:{start:{line:27,column:4},end:{line:32,column:5}},type:'switch',locations:[{start:{line:28,column:5},end:{line:28,column:108}},{start:{line:29,column:5},end:{line:29,column:112}},{start:{line:30,column:5},end:{line:30,column:106}},{start:{line:31,column:8},end:{line:31,column:30}}],line:27}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1v25vgmkfb.s[0]++,{machines:[],loading:false,error:false});cov_1v25vgmkfb.s[1]++;var calculatorMachinesFetchStart=function calculatorMachinesFetchStart(state,action){cov_1v25vgmkfb.f[0]++;cov_1v25vgmkfb.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false});};cov_1v25vgmkfb.s[3]++;var calculatorMachinesFetchSuccess=function calculatorMachinesFetchSuccess(state,action){cov_1v25vgmkfb.f[1]++;cov_1v25vgmkfb.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machines:action.machines,loading:false,error:false});};cov_1v25vgmkfb.s[5]++;var calculatorMachinesFetchFail=function calculatorMachinesFetchFail(state,action){cov_1v25vgmkfb.f[2]++;cov_1v25vgmkfb.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_1v25vgmkfb.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1v25vgmkfb.b[0][0]++,initialState);var action=arguments[1];cov_1v25vgmkfb.f[3]++;cov_1v25vgmkfb.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_21" /* CALCULATOR_MACHINES_FETCH_START */]:cov_1v25vgmkfb.b[1][0]++;cov_1v25vgmkfb.s[9]++;return calculatorMachinesFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_22" /* CALCULATOR_MACHINES_FETCH_SUCCESS */]:cov_1v25vgmkfb.b[1][1]++;cov_1v25vgmkfb.s[10]++;return calculatorMachinesFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_20" /* CALCULATOR_MACHINES_FETCH_FAIL */]:cov_1v25vgmkfb.b[1][2]++;cov_1v25vgmkfb.s[11]++;return calculatorMachinesFetchFail(state,action);default:cov_1v25vgmkfb.b[1][3]++;cov_1v25vgmkfb.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1l9r98zmvb=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\defaults.js',hash='bbf04a10601a3e6c3f0c14d7a3ddd0056fd0fc9d',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\defaults.js',statementMap:{'0':{start:{line:4,column:21},end:{line:8,column:1}},'1':{start:{line:11,column:45},end:{line:13,column:1}},'2':{start:{line:12,column:4},end:{line:12,column:66}},'3':{start:{line:15,column:47},end:{line:21,column:1}},'4':{start:{line:16,column:4},end:{line:20,column:8}},'5':{start:{line:23,column:44},end:{line:25,column:1}},'6':{start:{line:24,column:4},end:{line:24,column:74}},'7':{start:{line:27,column:16},end:{line:34,column:1}},'8':{start:{line:28,column:4},end:{line:33,column:5}},'9':{start:{line:29,column:67},end:{line:29,column:128}},'10':{start:{line:30,column:69},end:{line:30,column:132}},'11':{start:{line:31,column:66},end:{line:31,column:126}},'12':{start:{line:32,column:17},end:{line:32,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:45},end:{line:11,column:46}},loc:{start:{line:11,column:66},end:{line:13,column:1}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:15,column:47},end:{line:15,column:48}},loc:{start:{line:15,column:68},end:{line:21,column:1}},line:15},'2':{name:'(anonymous_2)',decl:{start:{line:23,column:44},end:{line:23,column:45}},loc:{start:{line:23,column:65},end:{line:25,column:1}},line:23},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:16},end:{line:27,column:17}},loc:{start:{line:27,column:52},end:{line:34,column:1}},line:27}},branchMap:{'0':{loc:{start:{line:27,column:18},end:{line:27,column:38}},type:'default-arg',locations:[{start:{line:27,column:26},end:{line:27,column:38}}],line:27},'1':{loc:{start:{line:28,column:4},end:{line:33,column:5}},type:'switch',locations:[{start:{line:29,column:8},end:{line:29,column:128}},{start:{line:30,column:8},end:{line:30,column:132}},{start:{line:31,column:8},end:{line:31,column:126}},{start:{line:32,column:8},end:{line:32,column:30}}],line:28}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0],'1':[0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1l9r98zmvb.s[0]++,{machines:[],loading:false,error:false});/* ------------------- Machine Defaults -------------------- */cov_1l9r98zmvb.s[1]++;var calculatorMachinesDefaultsFetchStart=function calculatorMachinesDefaultsFetchStart(state,action){cov_1l9r98zmvb.f[0]++;cov_1l9r98zmvb.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false});};cov_1l9r98zmvb.s[3]++;var calculatorMachinesDefaultsFetchSuccess=function calculatorMachinesDefaultsFetchSuccess(state,action){cov_1l9r98zmvb.f[1]++;cov_1l9r98zmvb.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machines:action.machines,loading:false,error:false});};cov_1l9r98zmvb.s[5]++;var calculatorMachinesDefaultsFetchFail=function calculatorMachinesDefaultsFetchFail(state,action){cov_1l9r98zmvb.f[2]++;cov_1l9r98zmvb.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_1l9r98zmvb.s[7]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1l9r98zmvb.b[0][0]++,initialState);var action=arguments[1];cov_1l9r98zmvb.f[3]++;cov_1l9r98zmvb.s[8]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_18" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_START */]:cov_1l9r98zmvb.b[1][0]++;cov_1l9r98zmvb.s[9]++;return calculatorMachinesDefaultsFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_19" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS */]:cov_1l9r98zmvb.b[1][1]++;cov_1l9r98zmvb.s[10]++;return calculatorMachinesDefaultsFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_17" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL */]:cov_1l9r98zmvb.b[1][2]++;cov_1l9r98zmvb.s[11]++;return calculatorMachinesDefaultsFetchFail(state,action);default:cov_1l9r98zmvb.b[1][3]++;cov_1l9r98zmvb.s[12]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_xigbovpc7=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\machine.js',hash='d1c61a7c6c9bfffc483a0cba0b81fe6b928211b6',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\calculator\\machines\\machine.js',statementMap:{'0':{start:{line:4,column:21},end:{line:13,column:1}},'1':{start:{line:16,column:37},end:{line:18,column:1}},'2':{start:{line:17,column:4},end:{line:17,column:95}},'3':{start:{line:20,column:37},end:{line:22,column:1}},'4':{start:{line:21,column:4},end:{line:21,column:96}},'5':{start:{line:24,column:39},end:{line:31,column:1}},'6':{start:{line:25,column:4},end:{line:30,column:8}},'7':{start:{line:33,column:36},end:{line:35,column:1}},'8':{start:{line:34,column:4},end:{line:34,column:74}},'9':{start:{line:38,column:45},end:{line:40,column:1}},'10':{start:{line:39,column:4},end:{line:39,column:109}},'11':{start:{line:42,column:47},end:{line:47,column:1}},'12':{start:{line:43,column:4},end:{line:46,column:8}},'13':{start:{line:49,column:44},end:{line:51,column:1}},'14':{start:{line:50,column:4},end:{line:50,column:74}},'15':{start:{line:53,column:45},end:{line:55,column:1}},'16':{start:{line:54,column:4},end:{line:54,column:80}},'17':{start:{line:58,column:37},end:{line:60,column:1}},'18':{start:{line:59,column:4},end:{line:59,column:82}},'19':{start:{line:62,column:37},end:{line:64,column:1}},'20':{start:{line:63,column:4},end:{line:63,column:83}},'21':{start:{line:66,column:39},end:{line:73,column:1}},'22':{start:{line:67,column:4},end:{line:72,column:8}},'23':{start:{line:75,column:36},end:{line:77,column:1}},'24':{start:{line:76,column:4},end:{line:76,column:74}},'25':{start:{line:80,column:37},end:{line:82,column:1}},'26':{start:{line:81,column:4},end:{line:81,column:81}},'27':{start:{line:84,column:37},end:{line:86,column:1}},'28':{start:{line:85,column:4},end:{line:85,column:83}},'29':{start:{line:88,column:39},end:{line:94,column:1}},'30':{start:{line:89,column:4},end:{line:93,column:8}},'31':{start:{line:96,column:36},end:{line:98,column:1}},'32':{start:{line:97,column:4},end:{line:97,column:74}},'33':{start:{line:101,column:36},end:{line:103,column:1}},'34':{start:{line:102,column:4},end:{line:102,column:95}},'35':{start:{line:105,column:36},end:{line:107,column:1}},'36':{start:{line:106,column:4},end:{line:106,column:96}},'37':{start:{line:109,column:38},end:{line:116,column:1}},'38':{start:{line:110,column:4},end:{line:115,column:8}},'39':{start:{line:118,column:35},end:{line:120,column:1}},'40':{start:{line:119,column:4},end:{line:119,column:74}},'41':{start:{line:122,column:16},end:{line:146,column:1}},'42':{start:{line:123,column:4},end:{line:145,column:5}},'43':{start:{line:124,column:55},end:{line:124,column:108}},'44':{start:{line:125,column:57},end:{line:125,column:112}},'45':{start:{line:126,column:54},end:{line:126,column:106}},'46':{start:{line:127,column:58},end:{line:127,column:111}},'47':{start:{line:128,column:66},end:{line:128,column:127}},'48':{start:{line:129,column:68},end:{line:129,column:131}},'49':{start:{line:130,column:65},end:{line:130,column:125}},'50':{start:{line:131,column:66},end:{line:131,column:127}},'51':{start:{line:132,column:58},end:{line:132,column:111}},'52':{start:{line:133,column:60},end:{line:133,column:115}},'53':{start:{line:134,column:57},end:{line:134,column:109}},'54':{start:{line:135,column:58},end:{line:135,column:111}},'55':{start:{line:136,column:57},end:{line:136,column:109}},'56':{start:{line:137,column:59},end:{line:137,column:113}},'57':{start:{line:138,column:56},end:{line:138,column:107}},'58':{start:{line:139,column:57},end:{line:139,column:109}},'59':{start:{line:140,column:58},end:{line:140,column:111}},'60':{start:{line:141,column:60},end:{line:141,column:115}},'61':{start:{line:142,column:57},end:{line:142,column:109}},'62':{start:{line:143,column:58},end:{line:143,column:111}},'63':{start:{line:144,column:17},end:{line:144,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:16,column:37},end:{line:16,column:38}},loc:{start:{line:16,column:58},end:{line:18,column:1}},line:16},'1':{name:'(anonymous_1)',decl:{start:{line:20,column:37},end:{line:20,column:38}},loc:{start:{line:20,column:58},end:{line:22,column:1}},line:20},'2':{name:'(anonymous_2)',decl:{start:{line:24,column:39},end:{line:24,column:40}},loc:{start:{line:24,column:60},end:{line:31,column:1}},line:24},'3':{name:'(anonymous_3)',decl:{start:{line:33,column:36},end:{line:33,column:37}},loc:{start:{line:33,column:57},end:{line:35,column:1}},line:33},'4':{name:'(anonymous_4)',decl:{start:{line:38,column:45},end:{line:38,column:46}},loc:{start:{line:38,column:66},end:{line:40,column:1}},line:38},'5':{name:'(anonymous_5)',decl:{start:{line:42,column:47},end:{line:42,column:48}},loc:{start:{line:42,column:68},end:{line:47,column:1}},line:42},'6':{name:'(anonymous_6)',decl:{start:{line:49,column:44},end:{line:49,column:45}},loc:{start:{line:49,column:65},end:{line:51,column:1}},line:49},'7':{name:'(anonymous_7)',decl:{start:{line:53,column:45},end:{line:53,column:46}},loc:{start:{line:53,column:66},end:{line:55,column:1}},line:53},'8':{name:'(anonymous_8)',decl:{start:{line:58,column:37},end:{line:58,column:38}},loc:{start:{line:58,column:58},end:{line:60,column:1}},line:58},'9':{name:'(anonymous_9)',decl:{start:{line:62,column:37},end:{line:62,column:38}},loc:{start:{line:62,column:58},end:{line:64,column:1}},line:62},'10':{name:'(anonymous_10)',decl:{start:{line:66,column:39},end:{line:66,column:40}},loc:{start:{line:66,column:60},end:{line:73,column:1}},line:66},'11':{name:'(anonymous_11)',decl:{start:{line:75,column:36},end:{line:75,column:37}},loc:{start:{line:75,column:57},end:{line:77,column:1}},line:75},'12':{name:'(anonymous_12)',decl:{start:{line:80,column:37},end:{line:80,column:38}},loc:{start:{line:80,column:58},end:{line:82,column:1}},line:80},'13':{name:'(anonymous_13)',decl:{start:{line:84,column:37},end:{line:84,column:38}},loc:{start:{line:84,column:58},end:{line:86,column:1}},line:84},'14':{name:'(anonymous_14)',decl:{start:{line:88,column:39},end:{line:88,column:40}},loc:{start:{line:88,column:60},end:{line:94,column:1}},line:88},'15':{name:'(anonymous_15)',decl:{start:{line:96,column:36},end:{line:96,column:37}},loc:{start:{line:96,column:57},end:{line:98,column:1}},line:96},'16':{name:'(anonymous_16)',decl:{start:{line:101,column:36},end:{line:101,column:37}},loc:{start:{line:101,column:57},end:{line:103,column:1}},line:101},'17':{name:'(anonymous_17)',decl:{start:{line:105,column:36},end:{line:105,column:37}},loc:{start:{line:105,column:57},end:{line:107,column:1}},line:105},'18':{name:'(anonymous_18)',decl:{start:{line:109,column:38},end:{line:109,column:39}},loc:{start:{line:109,column:59},end:{line:116,column:1}},line:109},'19':{name:'(anonymous_19)',decl:{start:{line:118,column:35},end:{line:118,column:36}},loc:{start:{line:118,column:56},end:{line:120,column:1}},line:118},'20':{name:'(anonymous_20)',decl:{start:{line:122,column:16},end:{line:122,column:17}},loc:{start:{line:122,column:52},end:{line:146,column:1}},line:122}},branchMap:{'0':{loc:{start:{line:122,column:18},end:{line:122,column:38}},type:'default-arg',locations:[{start:{line:122,column:26},end:{line:122,column:38}}],line:122},'1':{loc:{start:{line:123,column:4},end:{line:145,column:5}},type:'switch',locations:[{start:{line:124,column:5},end:{line:124,column:108}},{start:{line:125,column:5},end:{line:125,column:112}},{start:{line:126,column:5},end:{line:126,column:106}},{start:{line:127,column:8},end:{line:127,column:111}},{start:{line:128,column:8},end:{line:128,column:127}},{start:{line:129,column:8},end:{line:129,column:131}},{start:{line:130,column:8},end:{line:130,column:125}},{start:{line:131,column:8},end:{line:131,column:127}},{start:{line:132,column:8},end:{line:132,column:111}},{start:{line:133,column:8},end:{line:133,column:115}},{start:{line:134,column:8},end:{line:134,column:109}},{start:{line:135,column:8},end:{line:135,column:111}},{start:{line:136,column:8},end:{line:136,column:109}},{start:{line:137,column:8},end:{line:137,column:113}},{start:{line:138,column:8},end:{line:138,column:107}},{start:{line:139,column:8},end:{line:139,column:109}},{start:{line:140,column:8},end:{line:140,column:111}},{start:{line:141,column:8},end:{line:141,column:115}},{start:{line:142,column:8},end:{line:142,column:109}},{start:{line:143,column:8},end:{line:143,column:111}},{start:{line:144,column:8},end:{line:144,column:30}}],line:123}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0},b:{'0':[0],'1':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_xigbovpc7.s[0]++,{machine:{},loading:false,error:false,created:false,fetched:false,deleted:false,name_available:true,name_checked:false});/* ------------------ Machine Create ------------------- */cov_xigbovpc7.s[1]++;var calculatorMachineCreateStart=function calculatorMachineCreateStart(state,action){cov_xigbovpc7.f[0]++;cov_xigbovpc7.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,created:false,machine:{}});};cov_xigbovpc7.s[3]++;var calculatorMachineCreateReset=function calculatorMachineCreateReset(state,action){cov_xigbovpc7.f[1]++;cov_xigbovpc7.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,created:false,machine:{}});};cov_xigbovpc7.s[5]++;var calculatorMachineCreateSuccess=function calculatorMachineCreateSuccess(state,action){cov_xigbovpc7.f[2]++;cov_xigbovpc7.s[6]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:action.machine,loading:false,error:false,created:true});};cov_xigbovpc7.s[7]++;var calculatorMachineCreateFail=function calculatorMachineCreateFail(state,action){cov_xigbovpc7.f[3]++;cov_xigbovpc7.s[8]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};/* ----------------- Machine Duplicate ------------------ */cov_xigbovpc7.s[9]++;var calculatorMachineDuplicateCheckStart=function calculatorMachineDuplicateCheckStart(state,action){cov_xigbovpc7.f[4]++;cov_xigbovpc7.s[10]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,name_available:true,error:false,name_checked:false});};cov_xigbovpc7.s[11]++;var calculatorMachineDuplicateCheckSuccess=function calculatorMachineDuplicateCheckSuccess(state,action){cov_xigbovpc7.f[5]++;cov_xigbovpc7.s[12]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{name_available:!action.name_duplicate,name_checked:true});};cov_xigbovpc7.s[13]++;var calculatorMachineDuplicateCheckFail=function calculatorMachineDuplicateCheckFail(state,action){cov_xigbovpc7.f[6]++;cov_xigbovpc7.s[14]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_xigbovpc7.s[15]++;var calculatorMachineDuplicateCheckReset=function calculatorMachineDuplicateCheckReset(state,action){cov_xigbovpc7.f[7]++;cov_xigbovpc7.s[16]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{name_available:true,name_checked:false});};/* ------------------ Machine Update ------------------- */cov_xigbovpc7.s[17]++;var calculatorMachineUpdateStart=function calculatorMachineUpdateStart(state,action){cov_xigbovpc7.f[8]++;cov_xigbovpc7.s[18]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,updated:false});};cov_xigbovpc7.s[19]++;var calculatorMachineUpdateReset=function calculatorMachineUpdateReset(state,action){cov_xigbovpc7.f[9]++;cov_xigbovpc7.s[20]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,updated:false});};cov_xigbovpc7.s[21]++;var calculatorMachineUpdateSuccess=function calculatorMachineUpdateSuccess(state,action){cov_xigbovpc7.f[10]++;cov_xigbovpc7.s[22]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:action.machine,loading:false,error:false,updated:true});};cov_xigbovpc7.s[23]++;var calculatorMachineUpdateFail=function calculatorMachineUpdateFail(state,action){cov_xigbovpc7.f[11]++;cov_xigbovpc7.s[24]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};/* ------------------ Machine Delete ------------------- */cov_xigbovpc7.s[25]++;var calculatorMachineDeleteStart=function calculatorMachineDeleteStart(state,action){cov_xigbovpc7.f[12]++;cov_xigbovpc7.s[26]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,deleted:false});};cov_xigbovpc7.s[27]++;var calculatorMachineDeleteReset=function calculatorMachineDeleteReset(state,action){cov_xigbovpc7.f[13]++;cov_xigbovpc7.s[28]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,deleted:false});};cov_xigbovpc7.s[29]++;var calculatorMachineDeleteSuccess=function calculatorMachineDeleteSuccess(state,action){cov_xigbovpc7.f[14]++;cov_xigbovpc7.s[30]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,deleted:true});};cov_xigbovpc7.s[31]++;var calculatorMachineDeleteFail=function calculatorMachineDeleteFail(state,action){cov_xigbovpc7.f[15]++;cov_xigbovpc7.s[32]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};/* ------------------ Machine Fetch ------------------- */cov_xigbovpc7.s[33]++;var calculatorMachineFetchStart=function calculatorMachineFetchStart(state,action){cov_xigbovpc7.f[16]++;cov_xigbovpc7.s[34]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:true,error:false,fetched:false,machine:{}});};cov_xigbovpc7.s[35]++;var calculatorMachineFetchReset=function calculatorMachineFetchReset(state,action){cov_xigbovpc7.f[17]++;cov_xigbovpc7.s[36]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:false,fetched:false,machine:{}});};cov_xigbovpc7.s[37]++;var calculatorMachineFetchSuccess=function calculatorMachineFetchSuccess(state,action){cov_xigbovpc7.f[18]++;cov_xigbovpc7.s[38]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{machine:action.machine,loading:false,error:false,fetched:true});};cov_xigbovpc7.s[39]++;var calculatorMachineFetchFail=function calculatorMachineFetchFail(state,action){cov_xigbovpc7.f[19]++;cov_xigbovpc7.s[40]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{loading:false,error:action.error});};cov_xigbovpc7.s[41]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_xigbovpc7.b[0][0]++,initialState);var action=arguments[1];cov_xigbovpc7.f[20]++;cov_xigbovpc7.s[42]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_25" /* CALCULATOR_MACHINE_CREATE_START */]:cov_xigbovpc7.b[1][0]++;cov_xigbovpc7.s[43]++;return calculatorMachineCreateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_26" /* CALCULATOR_MACHINE_CREATE_SUCCESS */]:cov_xigbovpc7.b[1][1]++;cov_xigbovpc7.s[44]++;return calculatorMachineCreateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_23" /* CALCULATOR_MACHINE_CREATE_FAIL */]:cov_xigbovpc7.b[1][2]++;cov_xigbovpc7.s[45]++;return calculatorMachineCreateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_24" /* CALCULATOR_MACHINE_CREATE_RESET */]:cov_xigbovpc7.b[1][3]++;cov_xigbovpc7.s[46]++;return calculatorMachineCreateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_33" /* CALCULATOR_MACHINE_DUPLICATECHECK_START */]:cov_xigbovpc7.b[1][4]++;cov_xigbovpc7.s[47]++;return calculatorMachineDuplicateCheckStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_34" /* CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS */]:cov_xigbovpc7.b[1][5]++;cov_xigbovpc7.s[48]++;return calculatorMachineDuplicateCheckSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_31" /* CALCULATOR_MACHINE_DUPLICATECHECK_FAIL */]:cov_xigbovpc7.b[1][6]++;cov_xigbovpc7.s[49]++;return calculatorMachineDuplicateCheckFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_32" /* CALCULATOR_MACHINE_DUPLICATECHECK_RESET */]:cov_xigbovpc7.b[1][7]++;cov_xigbovpc7.s[50]++;return calculatorMachineDuplicateCheckReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_41" /* CALCULATOR_MACHINE_UPDATE_START */]:cov_xigbovpc7.b[1][8]++;cov_xigbovpc7.s[51]++;return calculatorMachineUpdateStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_42" /* CALCULATOR_MACHINE_UPDATE_SUCCESS */]:cov_xigbovpc7.b[1][9]++;cov_xigbovpc7.s[52]++;return calculatorMachineUpdateSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_39" /* CALCULATOR_MACHINE_UPDATE_FAIL */]:cov_xigbovpc7.b[1][10]++;cov_xigbovpc7.s[53]++;return calculatorMachineUpdateFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_40" /* CALCULATOR_MACHINE_UPDATE_RESET */]:cov_xigbovpc7.b[1][11]++;cov_xigbovpc7.s[54]++;return calculatorMachineUpdateReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_37" /* CALCULATOR_MACHINE_FETCH_START */]:cov_xigbovpc7.b[1][12]++;cov_xigbovpc7.s[55]++;return calculatorMachineFetchStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_38" /* CALCULATOR_MACHINE_FETCH_SUCCESS */]:cov_xigbovpc7.b[1][13]++;cov_xigbovpc7.s[56]++;return calculatorMachineFetchSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_35" /* CALCULATOR_MACHINE_FETCH_FAIL */]:cov_xigbovpc7.b[1][14]++;cov_xigbovpc7.s[57]++;return calculatorMachineFetchFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_36" /* CALCULATOR_MACHINE_FETCH_RESET */]:cov_xigbovpc7.b[1][15]++;cov_xigbovpc7.s[58]++;return calculatorMachineFetchReset(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_29" /* CALCULATOR_MACHINE_DELETE_START */]:cov_xigbovpc7.b[1][16]++;cov_xigbovpc7.s[59]++;return calculatorMachineDeleteStart(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_30" /* CALCULATOR_MACHINE_DELETE_SUCCESS */]:cov_xigbovpc7.b[1][17]++;cov_xigbovpc7.s[60]++;return calculatorMachineDeleteSuccess(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_27" /* CALCULATOR_MACHINE_DELETE_FAIL */]:cov_xigbovpc7.b[1][18]++;cov_xigbovpc7.s[61]++;return calculatorMachineDeleteFail(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_28" /* CALCULATOR_MACHINE_DELETE_RESET */]:cov_xigbovpc7.b[1][19]++;cov_xigbovpc7.s[62]++;return calculatorMachineDeleteReset(state,action);default:cov_xigbovpc7.b[1][20]++;cov_xigbovpc7.s[63]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility_js__ = __webpack_require__(14);
var cov_1tbp7sdnl0=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\visualMessage.js',hash='2283ab39f9022a5ee92a6dd88a2d15b5c5137238',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\reducers\\visualMessage.js',statementMap:{'0':{start:{line:4,column:21},end:{line:10,column:1}},'1':{start:{line:13,column:25},end:{line:21,column:1}},'2':{start:{line:14,column:4},end:{line:20,column:8}},'3':{start:{line:23,column:27},end:{line:31,column:1}},'4':{start:{line:24,column:4},end:{line:30,column:8}},'5':{start:{line:33,column:16},end:{line:39,column:1}},'6':{start:{line:34,column:4},end:{line:38,column:5}},'7':{start:{line:35,column:44},end:{line:35,column:85}},'8':{start:{line:36,column:46},end:{line:36,column:89}},'9':{start:{line:37,column:17},end:{line:37,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:25},end:{line:13,column:26}},loc:{start:{line:13,column:46},end:{line:21,column:1}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:23,column:27},end:{line:23,column:28}},loc:{start:{line:23,column:48},end:{line:31,column:1}},line:23},'2':{name:'(anonymous_2)',decl:{start:{line:33,column:16},end:{line:33,column:17}},loc:{start:{line:33,column:52},end:{line:39,column:1}},line:33}},branchMap:{'0':{loc:{start:{line:19,column:13},end:{line:19,column:57}},type:'cond-expr',locations:[{start:{line:19,column:34},end:{line:19,column:52}},{start:{line:19,column:55},end:{line:19,column:57}}],line:19},'1':{loc:{start:{line:33,column:18},end:{line:33,column:38}},type:'default-arg',locations:[{start:{line:33,column:26},end:{line:33,column:38}}],line:33},'2':{loc:{start:{line:34,column:4},end:{line:38,column:5}},type:'switch',locations:[{start:{line:35,column:8},end:{line:35,column:85}},{start:{line:36,column:8},end:{line:36,column:89}},{start:{line:37,column:8},end:{line:37,column:30}}],line:34}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0],'2':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var initialState=(cov_1tbp7sdnl0.s[0]++,{message:false,scope:false,key:false,type:false,obj:{}});/* ----------------- Registration ------------------ */cov_1tbp7sdnl0.s[1]++;var visualMessageSet=function visualMessageSet(state,action){cov_1tbp7sdnl0.f[0]++;cov_1tbp7sdnl0.s[2]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{message:action.payload.message,scope:action.payload.scope,key:action.payload.key,type:action.payload.type,obj:action.payload.obj?(cov_1tbp7sdnl0.b[0][0]++,action.payload.obj):(cov_1tbp7sdnl0.b[0][1]++,{})});};cov_1tbp7sdnl0.s[3]++;var visualMessageReset=function visualMessageReset(state,action){cov_1tbp7sdnl0.f[1]++;cov_1tbp7sdnl0.s[4]++;return Object(__WEBPACK_IMPORTED_MODULE_1__utility_js__["a" /* updateObject */])(state,{message:false,scope:false,key:false,type:false,obj:{}});};/* ----------------- Reducer ------------------ */cov_1tbp7sdnl0.s[5]++;var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_1tbp7sdnl0.b[1][0]++,initialState);var action=arguments[1];cov_1tbp7sdnl0.f[2]++;cov_1tbp7sdnl0.s[6]++;switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_81" /* VISUALMESSAGE_SET */]:cov_1tbp7sdnl0.b[2][0]++;cov_1tbp7sdnl0.s[7]++;return visualMessageSet(state,action);case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_80" /* VISUALMESSAGE_RESET */]:cov_1tbp7sdnl0.b[2][1]++;cov_1tbp7sdnl0.s[8]++;return visualMessageReset(state,action);default:cov_1tbp7sdnl0.b[2][2]++;cov_1tbp7sdnl0.s[9]++;return state;}};/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export localize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(65);





var mapStateToProps = function mapStateToProps(slice, getStateSlice) {
  return function (state) {
    var scopedState = getStateSlice ? getStateSlice(state) : slice && state[slice] || state;

    var language = Object(__WEBPACK_IMPORTED_MODULE_2__locale__["c" /* getActiveLanguage */])(scopedState);
    var currentLanguage = language ? language.code : undefined;
    var translate = Object(__WEBPACK_IMPORTED_MODULE_2__locale__["f" /* getTranslate */])(scopedState);

    return {
      currentLanguage: currentLanguage,
      translate: translate
    };
  };
};

var localize = function localize(Component) {
  var slice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var getStateSlice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps(slice, getStateSlice))(Component);
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(134)

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Translate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(135);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DEFAULT_LOCALE_STATE_NAME = 'locale';
var DEFAULT_REDUX_STORE_KEY = 'store';

var Translate = function (_React$Component) {
  _inherits(Translate, _React$Component);

  function Translate(props, context) {
    _classCallCheck(this, Translate);

    var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

    if (!_this.getStore()) {
      throw new Error('react-localize-redux: Unable to locate redux store in context. Ensure your app is wrapped with <Provider />.');
    }

    if (!_this.getStateSlice().languages) {
      throw new Error('react-localize-redux: cannot find languages ensure you have correctly dispatched initialize action.');
    }

    _this.state = {
      hasUpdated: false
    };

    _this.onStateDidChange = _this.onStateDidChange.bind(_this);
    _this.addDefaultTranslation();
    return _this;
  }

  _createClass(Translate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.unsubscribeFromStore = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* storeDidChange */])(this.getStore(), this.onStateDidChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribeFromStore();
    }
  }, {
    key: 'onStateDidChange',
    value: function onStateDidChange(prevState) {
      var prevLocaleState = this.getStateSlice(prevState);
      var curLocaleState = this.getStateSlice();

      var prevActiveLanguage = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["c" /* getActiveLanguage */])(prevLocaleState);
      var curActiveLanguage = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["c" /* getActiveLanguage */])(curLocaleState);

      var prevOptions = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["e" /* getOptions */])(prevLocaleState);
      var curOptions = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["e" /* getOptions */])(curLocaleState);

      var prevTranslations = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["g" /* getTranslationsForActiveLanguage */])(prevLocaleState);
      var curTranslations = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["g" /* getTranslationsForActiveLanguage */])(curLocaleState);

      var hasActiveLangaugeChanged = prevActiveLanguage.code !== curActiveLanguage.code;
      var hasOptionsChanged = prevOptions !== curOptions;
      var hasTranslationsChanged = prevTranslations !== curTranslations;

      if (hasActiveLangaugeChanged || hasOptionsChanged || hasTranslationsChanged) {
        this.setState({ hasUpdated: true });
      }
    }
  }, {
    key: 'addDefaultTranslation',
    value: function addDefaultTranslation() {
      var locale = this.getStateSlice();
      var _props = this.props,
          id = _props.id,
          children = _props.children;


      if (children === undefined || typeof children === 'function') {
        return;
      }

      if (locale.options.ignoreTranslateChildren) {
        return;
      }

      if (id !== undefined) {
        var store = this.getStore();
        var translation = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToStaticMarkup(children);
        var defaultLanguage = locale.options.defaultLanguage || locale.languages[0].code;
        store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* addTranslationForLanguage */])(_defineProperty({}, id, translation), defaultLanguage));
      }
    }
  }, {
    key: 'getStore',
    value: function getStore() {
      var storeKey = this.context.storeKey;

      return this.context[storeKey || DEFAULT_REDUX_STORE_KEY];
    }
  }, {
    key: 'getStateSlice',
    value: function getStateSlice(myState) {
      var _context = this.context,
          getLocaleState = _context.getLocaleState,
          storeKey = _context.storeKey;

      var state = myState || this.getStore().getState();
      return getLocaleState !== undefined ? getLocaleState(state) : state[DEFAULT_LOCALE_STATE_NAME] || state;
    }
  }, {
    key: 'render',
    value: function render() {
      var translateFn = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["f" /* getTranslate */])(this.getStateSlice());
      var activeLanguage = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["c" /* getActiveLanguage */])(this.getStateSlice());
      var languages = Object(__WEBPACK_IMPORTED_MODULE_3__locale__["d" /* getLanguages */])(this.getStateSlice());
      var _props2 = this.props,
          _props2$id = _props2.id,
          id = _props2$id === undefined ? '' : _props2$id,
          data = _props2.data,
          options = _props2.options;

      return typeof this.props.children === 'function' ? this.props.children(translateFn, activeLanguage, languages) : translateFn(id, data, options);
    }
  }]);

  return Translate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Translate.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  }),
  getLocaleState: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  storeKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(326);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(77),q=__webpack_require__(62),t=__webpack_require__(0),w=__webpack_require__(79),x=__webpack_require__(78),y=__webpack_require__(327),z=__webpack_require__(329);
function A(a){for(var b=arguments.length-1,d="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);p(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var C="function"===typeof Symbol&&Symbol["for"],aa=C?Symbol["for"]("react.call"):60104,ba=C?Symbol["for"]("react.return"):60105,ca=C?Symbol["for"]("react.portal"):60106,E=C?Symbol["for"]("react.fragment"):60107,da=C?Symbol["for"]("react.strict_mode"):60108,F=C?Symbol["for"]("react.provider"):60109,ea=C?Symbol["for"]("react.context"):60110,fa=C?Symbol["for"]("react.async_mode"):60111,ha=C?Symbol["for"]("react.forward_ref"):60112,ia=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
G={},H={};function ja(a){if(H.hasOwnProperty(a))return!0;if(G.hasOwnProperty(a))return!1;if(ia.test(a))return H[a]=!0;G[a]=!0;return!1}function ka(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function la(a,b,d,c){if(null===b||"undefined"===typeof b||ka(a,b,d,c))return!0;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,k){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=k;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);var ma=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ma.exec(a);if(b){var d="",c,k=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="\x26quot;";break;case 38:b="\x26amp;";break;case 39:b="\x26#x27;";break;case 60:b="\x26lt;";break;case 62:b="\x26gt;";break;default:continue}k!==c&&(d+=a.substring(k,c));k=c+1;d+=b}a=k!==c?d+a.substring(k,c):d}return a}var N={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function O(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var P={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},na=q({menuitem:!0},P),Q={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,
fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},oa=["Webkit","ms","Moz","O"];Object.keys(Q).forEach(function(a){oa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Q[b]=Q[a]})});var R=t.Children.toArray,S=w.thatReturns("");w.thatReturns("");var pa={listing:!0,pre:!0,textarea:!0};
function T(a){return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}var qa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,U={},ra=z(function(a){return y(a)});function sa(a){var b="";t.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ta(a,b){if(a=a.contextTypes){var d={},c;for(c in a)d[c]=b[c];b=d}else b=x;return b}var ua={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};
function V(a,b){void 0===a&&A("152",T(b)||"Component")}
function va(a,b){function d(c,k){var d=ta(k,b),f=[],h=!1,g={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===f)return null},enqueueReplaceState:function(a,b){h=!0;f=[b]},enqueueSetState:function(a,b){if(null===f)return null;f.push(b)}},e=void 0;if(k.prototype&&k.prototype.isReactComponent){if(e=new k(c.props,d,g),"function"===typeof k.getDerivedStateFromProps){var v=k.getDerivedStateFromProps.call(null,c.props,e.state);null!=v&&(e.state=q({},e.state,v))}}else if(e=k(c.props,
d,g),null==e||null==e.render){a=e;V(a,k);return}e.props=c.props;e.context=d;e.updater=g;g=e.state;void 0===g&&(e.state=g=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof k.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),f.length){g=f;var u=h;f=null;h=!1;if(u&&
1===g.length)e.state=g[0];else{v=u?g[0]:e.state;var m=!0;for(u=u?1:0;u<g.length;u++){var n=g[u];n="function"===typeof n?n.call(e,v,c.props,d):n;null!=n&&(m?(m=!1,v=q({},v,n)):q(v,n))}e.state=v}}else f=null;a=e.render();V(a,k);c=void 0;if("function"===typeof e.getChildContext&&(d=k.childContextTypes,"object"===typeof d)){c=e.getChildContext();for(var r in c)r in d?void 0:A("108",T(k)||"Unknown",r)}c&&(b=q({},b,c))}for(;t.isValidElement(a);){var c=a,k=c.type;if("function"!==typeof k)break;d(c,k)}return{child:a,
context:b}}
var W=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");t.isValidElement(b)?b.type!==E?b=[b]:(b=b.props.children,b=t.isValidElement(b)?[b]:R(b)):b=R(b);this.stack=[{type:null,domNamespace:N.html,children:b,childIndex:0,context:x,footer:""}];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.providerStack=[];this.providerIndex=-1}a.prototype.pushProvider=function(a){this.providerIndex+=1;
this.providerStack[this.providerIndex]=a;a.type._context._currentValue=a.props.value};a.prototype.popProvider=function(a){this.providerStack[this.providerIndex]=null;--this.providerIndex;a=a.type._context;a._currentValue=0>this.providerIndex?a._defaultValue:this.providerStack[this.providerIndex].props.value};a.prototype.read=function(a){if(this.exhausted)return null;for(var b="";b.length<a;){if(0===this.stack.length){this.exhausted=!0;break}var c=this.stack[this.stack.length-1];if(c.childIndex>=c.children.length){var k=
c.footer;b+=k;""!==k&&(this.previousWasTextNode=!1);this.stack.pop();"select"===c.type?this.currentSelectValue=null:null!=c.type&&null!=c.type.type&&c.type.type.$$typeof===F&&this.popProvider(c.type)}else k=c.children[c.childIndex++],b+=this.render(k,c.context,c.domNamespace)}return b};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=
!0;return M(c)}d=va(a,d);a=d.child;d=d.context;if(null===a||!1===a)return"";if(!t.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ca?A("257"):void 0;A("258",b.toString())}a=R(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case da:case fa:case E:return a=R(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),
"";case aa:case ba:A("259")}if("object"===typeof b&&null!==b)switch(b.$$typeof){case ha:return a=R(b.render(a.props,a.ref)),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case F:return b=R(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),"";case ea:return b=R(a.props.children(a.type._currentValue)),this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""}),
""}A("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===N.html&&O(b);U.hasOwnProperty(b)||(qa.test(b)?void 0:A("65",b),U[b]=!0);var f=a.props;if("input"===b)f=q({type:void 0},f,{defaultChecked:void 0,defaultValue:void 0,value:null!=f.value?f.value:f.defaultValue,checked:null!=f.checked?f.checked:f.defaultChecked});else if("textarea"===b){var h=f.value;if(null==h){h=f.defaultValue;var l=f.children;null!=l&&(null!=h?A("92"):void 0,Array.isArray(l)&&(1>=
l.length?void 0:A("93"),l=l[0]),h=""+l);null==h&&(h="")}f=q({},f,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=f.value?f.value:f.defaultValue,f=q({},f,{value:void 0});else if("option"===b){l=this.currentSelectValue;var D=sa(f.children);if(null!=l){var B=null!=f.value?f.value+"":D;h=!1;if(Array.isArray(l))for(var g=0;g<l.length;g++){if(""+l[g]===B){h=!0;break}}else h=""+l===B;f=q({selected:void 0,children:void 0},f,{selected:h,children:D})}}if(h=f)na[b]&&(null!=h.children||
null!=h.dangerouslySetInnerHTML?A("137",b,S()):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?A("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:A("61")),null!=h.style&&"object"!==typeof h.style?A("62",S()):void 0;h=f;l=this.makeStaticMarkup;D=1===this.stack.length;B="\x3c"+a.type;for(r in h)if(h.hasOwnProperty(r)){var e=h[r];if(null!=e){if("style"===r){g=void 0;var v="",u="";for(g in e)if(e.hasOwnProperty(g)){var m=0===g.indexOf("--"),
n=e[g];null!=n&&(v+=u+ra(g)+":",u=g,m=null==n||"boolean"===typeof n||""===n?"":m||"number"!==typeof n||0===n||Q.hasOwnProperty(u)&&Q[u]?(""+n).trim():n+"px",v+=m,u=";")}e=v||null}g=null;b:if(m=b,n=h,-1===m.indexOf("-"))m="string"===typeof n.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)ua.hasOwnProperty(r)||(g=r,g=ja(g)&&null!=
e?g+"\x3d"+('"'+M(e)+'"'):"");else{m=r;g=e;e=J.hasOwnProperty(m)?J[m]:null;if(n="style"!==m)n=null!==e?0===e.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;n||la(m,g,e,!1)?g="":null!==e?(m=e.attributeName,e=e.type,g=3===e||4===e&&!0===g?m+'\x3d""':m+"\x3d"+('"'+M(g)+'"')):g=m+"\x3d"+('"'+M(g)+'"')}g&&(B+=" "+g)}}l||D&&(B+=' data-reactroot\x3d""');var r=B;h="";P.hasOwnProperty(b)?r+="/\x3e":(r+="\x3e",h="\x3c/"+a.type+"\x3e");a:{l=f.dangerouslySetInnerHTML;if(null!=l){if(null!=
l.__html){l=l.__html;break a}}else if(l=f.children,"string"===typeof l||"number"===typeof l){l=M(l);break a}l=null}null!=l?(f=[],pa[b]&&"\n"===l.charAt(0)&&(r+="\n"),r+=l):f=R(f.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===c?O(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:f,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return r};return a}(),X={renderToString:function(a){return(new W(a,
!1)).read(Infinity)},renderToStaticMarkup:function(a){return(new W(a,!0)).read(Infinity)},renderToNodeStream:function(){A("207")},renderToStaticNodeStream:function(){A("208")},version:"16.3.2"},Y=Object.freeze({default:X}),Z=Y&&X||Y;module.exports=Z["default"]?Z["default"]:Z;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(328);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(331)
var ieee754 = __webpack_require__(332)
var isArray = __webpack_require__(333)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 333 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/**
 * This is meant to wrap configuration objects that should be left as is,
 * meaning that the object or its protoype will not be modified in any way
 */
function RawConfig () {
}

function raw(rawObj) {
  var obj = Object.create(RawConfig.prototype);
  obj.resolve = function () { return rawObj; }
  return obj;
}

module.exports.RawConfig = RawConfig;
module.exports.raw = raw;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ACCOUNT_URL":"https://test-account.melcocloud.com/","REACT_APP_API_BASE_URL":"https://test-apis.melcocloud.com","REACT_APP_API_KEY":"0ATiqUzfRHuB3uMmyfD1Wlj","REACT_APP_APP_URL":"https://test-calculator.melcocloud.com/","REACT_APP_PRODUCT_CODE":"MATTERHORN"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(336);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(337);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34), __webpack_require__(56)))

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 339 */
/***/ (function(module, exports) {



/***/ }),
/* 340 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_App__ = __webpack_require__(680);
var cov_1zc21q2p3=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\RestoreToken.js',hash='8b9c59155e09f35635405d4fe31eab3717728010',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\RestoreToken.js',statementMap:{'0':{start:{line:15,column:8},end:{line:15,column:85}},'1':{start:{line:19,column:8},end:{line:21,column:9}},'2':{start:{line:20,column:12},end:{line:20,column:30}},'3':{start:{line:23,column:8},end:{line:25,column:9}},'4':{start:{line:24,column:12},end:{line:24,column:25}},'5':{start:{line:27,column:8},end:{line:29,column:9}},'6':{start:{line:28,column:12},end:{line:28,column:118}},'7':{start:{line:31,column:8},end:{line:31,column:20}},'8':{start:{line:35,column:24},end:{line:40,column:1}},'9':{start:{line:36,column:4},end:{line:39,column:6}},'10':{start:{line:42,column:27},end:{line:46,column:1}},'11':{start:{line:43,column:4},end:{line:45,column:5}},'12':{start:{line:44,column:47},end:{line:44,column:105}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:14,column:4},end:{line:14,column:5}},loc:{start:{line:14,column:24},end:{line:16,column:5}},line:14},'1':{name:'(anonymous_1)',decl:{start:{line:18,column:4},end:{line:18,column:5}},loc:{start:{line:18,column:13},end:{line:32,column:5}},line:18},'2':{name:'(anonymous_2)',decl:{start:{line:35,column:24},end:{line:35,column:25}},loc:{start:{line:35,column:33},end:{line:40,column:1}},line:35},'3':{name:'(anonymous_3)',decl:{start:{line:42,column:27},end:{line:42,column:28}},loc:{start:{line:42,column:39},end:{line:46,column:1}},line:42},'4':{name:'(anonymous_4)',decl:{start:{line:44,column:27},end:{line:44,column:28}},loc:{start:{line:44,column:47},end:{line:44,column:105}},line:44}},branchMap:{'0':{loc:{start:{line:19,column:8},end:{line:21,column:9}},type:'if',locations:[{start:{line:19,column:8},end:{line:21,column:9}},{start:{line:19,column:8},end:{line:21,column:9}}],line:19},'1':{loc:{start:{line:23,column:8},end:{line:25,column:9}},type:'if',locations:[{start:{line:23,column:8},end:{line:25,column:9}},{start:{line:23,column:8},end:{line:25,column:9}}],line:23},'2':{loc:{start:{line:27,column:8},end:{line:29,column:9}},type:'if',locations:[{start:{line:27,column:8},end:{line:29,column:9}},{start:{line:27,column:8},end:{line:29,column:9}}],line:27}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0,0],'1':[0,0],'2':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RestoreToken=function(_ref){_inherits(RestoreToken,_ref);function RestoreToken(){_classCallCheck(this,RestoreToken);return _possibleConstructorReturn(this,(RestoreToken.__proto__||Object.getPrototypeOf(RestoreToken)).apply(this,arguments));}_createClass(RestoreToken,[{key:'componentDidMount',value:function componentDidMount(){cov_1zc21q2p3.f[0]++;cov_1zc21q2p3.s[0]++;this.props.tokenRestoreToken(this.props.auth.token,this.props.auth.user_id);}},{key:'render',value:function render(){cov_1zc21q2p3.f[1]++;cov_1zc21q2p3.s[1]++;if(this.props.tokenRestore.isRestoring){cov_1zc21q2p3.b[0][0]++;cov_1zc21q2p3.s[2]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Loading"],null);}else{cov_1zc21q2p3.b[0][1]++;}cov_1zc21q2p3.s[3]++;if(this.props.tokenRestore.successful){cov_1zc21q2p3.b[1][0]++;cov_1zc21q2p3.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_App__["a" /* default */],null);}else{cov_1zc21q2p3.b[1][1]++;}cov_1zc21q2p3.s[5]++;if(this.props.tokenRestore.failed){cov_1zc21q2p3.b[2][0]++;cov_1zc21q2p3.s[6]++;window.location.href="https://test-account.melcocloud.com/"+'?redirectTo='+"https://test-calculator.melcocloud.com/";}else{cov_1zc21q2p3.b[2][1]++;}cov_1zc21q2p3.s[7]++;return null;}}]);return RestoreToken;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));;cov_1zc21q2p3.s[8]++;var mapStateToProps=function mapStateToProps(state){cov_1zc21q2p3.f[2]++;cov_1zc21q2p3.s[9]++;return{tokenRestore:state.tokenRestore,auth:state.auth};};cov_1zc21q2p3.s[10]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_1zc21q2p3.f[3]++;cov_1zc21q2p3.s[11]++;return{tokenRestoreToken:function tokenRestoreToken(token,user_id){cov_1zc21q2p3.f[4]++;cov_1zc21q2p3.s[12]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["_5" /* tokenRestoreToken */](token,user_id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__["a" /* default */])(RestoreToken,__WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */])));

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);
var bind = __webpack_require__(139);
var Axios = __webpack_require__(343);
var defaults = __webpack_require__(91);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(143);
axios.CancelToken = __webpack_require__(357);
axios.isCancel = __webpack_require__(142);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(358);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(91);
var utils = __webpack_require__(27);
var InterceptorManager = __webpack_require__(352);
var dispatchRequest = __webpack_require__(353);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(141);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);
var transformData = __webpack_require__(354);
var isCancel = __webpack_require__(142);
var defaults = __webpack_require__(91);
var isAbsoluteURL = __webpack_require__(355);
var combineURLs = __webpack_require__(356);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(143);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return helpersMenuOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helpersMenuClose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
var cov_ccyznux9g=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\menu.js',hash='4a7c9c3db2a4cf171300c7083711d272b9f753c2',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\menu.js',statementMap:{'0':{start:{line:3,column:31},end:{line:7,column:1}},'1':{start:{line:4,column:4},end:{line:6,column:6}},'2':{start:{line:9,column:32},end:{line:13,column:1}},'3':{start:{line:10,column:4},end:{line:12,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:31},end:{line:3,column:32}},loc:{start:{line:3,column:37},end:{line:7,column:1}},line:3},'1':{name:'(anonymous_1)',decl:{start:{line:9,column:32},end:{line:9,column:33}},loc:{start:{line:9,column:38},end:{line:13,column:1}},line:9}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0},f:{'0':0,'1':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_ccyznux9g.s[0]++;var helpersMenuOpen=function helpersMenuOpen(){cov_ccyznux9g.f[0]++;cov_ccyznux9g.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_59" /* HELPERS_MENU_OPEN */]};};cov_ccyznux9g.s[2]++;var helpersMenuClose=function helpersMenuClose(){cov_ccyznux9g.f[1]++;cov_ccyznux9g.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_58" /* HELPERS_MENU_CLOSE */]};};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helpersBlurAppend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return helpersBlurRemove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
var cov_2q6plu1mur=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\blur.js',hash='bbc434c73a9df370db6e6c47e3008489f3038ce9',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\blur.js',statementMap:{'0':{start:{line:3,column:33},end:{line:7,column:1}},'1':{start:{line:4,column:4},end:{line:6,column:6}},'2':{start:{line:9,column:33},end:{line:13,column:1}},'3':{start:{line:10,column:4},end:{line:12,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:33},end:{line:3,column:34}},loc:{start:{line:3,column:39},end:{line:7,column:1}},line:3},'1':{name:'(anonymous_1)',decl:{start:{line:9,column:33},end:{line:9,column:34}},loc:{start:{line:9,column:39},end:{line:13,column:1}},line:9}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0},f:{'0':0,'1':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2q6plu1mur.s[0]++;var helpersBlurAppend=function helpersBlurAppend(){cov_2q6plu1mur.f[0]++;cov_2q6plu1mur.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_48" /* HELPERS_BLUR_APPEND */]};};cov_2q6plu1mur.s[2]++;var helpersBlurRemove=function helpersBlurRemove(){cov_2q6plu1mur.f[1]++;cov_2q6plu1mur.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_49" /* HELPERS_BLUR_REMOVE */]};};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export helpersCountriesStatesFetchStart */
/* unused harmony export helpersCountriesStatesFetchSuccess */
/* unused harmony export helpersCountriesStatesFetchFail */
/* unused harmony export helpersCountriesStatesFetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_1z921myi8s=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\countriesstates.js',hash='937ddf2b03ce4ab9c5a6803b6c8460f869319f18',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\countriesstates.js',statementMap:{'0':{start:{line:5,column:48},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:50},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:47},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:43},end:{line:42,column:1}},'7':{start:{line:26,column:4},end:{line:41,column:6}},'8':{start:{line:27,column:8},end:{line:27,column:53}},'9':{start:{line:28,column:8},end:{line:40,column:16}},'10':{start:{line:30,column:16},end:{line:30,column:85}},'11':{start:{line:33,column:16},end:{line:38,column:17}},'12':{start:{line:34,column:20},end:{line:34,column:163}},'13':{start:{line:37,column:20},end:{line:37,column:204}},'14':{start:{line:39,column:16},end:{line:39,column:78}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:48},end:{line:5,column:49}},loc:{start:{line:5,column:54},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:50},end:{line:11,column:51}},loc:{start:{line:11,column:62},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:47},end:{line:18,column:48}},loc:{start:{line:18,column:60},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:43},end:{line:25,column:44}},loc:{start:{line:25,column:60},end:{line:42,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:26,column:11},end:{line:26,column:12}},loc:{start:{line:26,column:23},end:{line:41,column:5}},line:26},'5':{name:'(anonymous_5)',decl:{start:{line:29,column:19},end:{line:29,column:20}},loc:{start:{line:29,column:31},end:{line:31,column:13}},line:29},'6':{name:'(anonymous_6)',decl:{start:{line:32,column:20},end:{line:32,column:21}},loc:{start:{line:32,column:29},end:{line:40,column:13}},line:32}},branchMap:{'0':{loc:{start:{line:33,column:16},end:{line:38,column:17}},type:'if',locations:[{start:{line:33,column:16},end:{line:38,column:17}},{start:{line:33,column:16},end:{line:38,column:17}}],line:33},'1':{loc:{start:{line:33,column:19},end:{line:33,column:53}},type:'binary-expr',locations:[{start:{line:33,column:19},end:{line:33,column:31}},{start:{line:33,column:35},end:{line:33,column:53}}],line:33}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Countries States Fetch ------------------- */cov_1z921myi8s.s[0]++;var helpersCountriesStatesFetchStart=function helpersCountriesStatesFetchStart(){cov_1z921myi8s.f[0]++;cov_1z921myi8s.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_51" /* HELPERS_COUNTRIES_STATES_FETCH_START */]};};cov_1z921myi8s.s[2]++;var helpersCountriesStatesFetchSuccess=function helpersCountriesStatesFetchSuccess(states){cov_1z921myi8s.f[1]++;cov_1z921myi8s.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_52" /* HELPERS_COUNTRIES_STATES_FETCH_SUCCESS */],states:states};};cov_1z921myi8s.s[4]++;var helpersCountriesStatesFetchFail=function helpersCountriesStatesFetchFail(error){cov_1z921myi8s.f[2]++;cov_1z921myi8s.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_50" /* HELPERS_COUNTRIES_STATES_FETCH_FAIL */],error:error};};cov_1z921myi8s.s[6]++;var helpersCountriesStatesFetch=function helpersCountriesStatesFetch(countryList){cov_1z921myi8s.f[3]++;cov_1z921myi8s.s[7]++;return function(dispatch){cov_1z921myi8s.f[4]++;cov_1z921myi8s.s[8]++;dispatch(helpersCountriesStatesFetchStart());cov_1z921myi8s.s[9]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/defaults/countries/states?CountryList='+countryList).then(function(response){cov_1z921myi8s.f[5]++;cov_1z921myi8s.s[10]++;dispatch(helpersCountriesStatesFetchSuccess(response.data.list));}).catch(function(error){cov_1z921myi8s.f[6]++;cov_1z921myi8s.s[11]++;if((cov_1z921myi8s.b[1][0]++,error.length)&&(cov_1z921myi8s.b[1][1]++,error.length===1)){cov_1z921myi8s.b[0][0]++;cov_1z921myi8s.s[12]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"countries",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_1z921myi8s.b[0][1]++;cov_1z921myi8s.s[13]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"countries",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_1z921myi8s.s[14]++;dispatch(helpersCountriesStatesFetchFail(error.response));});};};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export helpersNotificationsMachinesFetchStart */
/* unused harmony export helpersNotificationsMachinesFetchSuccess */
/* unused harmony export helpersNotificationsMachinesFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helpersNotificationsMachinesFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_2pfupxqnno=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\notifications.js',hash='04f951e3ee226259b5bbe13123b14b4788d43161',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\notifications.js',statementMap:{'0':{start:{line:5,column:54},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:56},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:53},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:49},end:{line:36,column:1}},'7':{start:{line:26,column:4},end:{line:35,column:6}},'8':{start:{line:27,column:8},end:{line:27,column:59}},'9':{start:{line:28,column:8},end:{line:34,column:16}},'10':{start:{line:30,column:16},end:{line:30,column:91}},'11':{start:{line:33,column:16},end:{line:33,column:84}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:54},end:{line:5,column:55}},loc:{start:{line:5,column:60},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:56},end:{line:11,column:57}},loc:{start:{line:11,column:66},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:53},end:{line:18,column:54}},loc:{start:{line:18,column:66},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:49},end:{line:25,column:50}},loc:{start:{line:25,column:55},end:{line:36,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:26,column:11},end:{line:26,column:12}},loc:{start:{line:26,column:23},end:{line:35,column:5}},line:26},'5':{name:'(anonymous_5)',decl:{start:{line:29,column:19},end:{line:29,column:20}},loc:{start:{line:29,column:31},end:{line:31,column:13}},line:29},'6':{name:'(anonymous_6)',decl:{start:{line:32,column:20},end:{line:32,column:21}},loc:{start:{line:32,column:29},end:{line:34,column:13}},line:32}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Notifications Machines Fetch ------------------- */cov_2pfupxqnno.s[0]++;var helpersNotificationsMachinesFetchStart=function helpersNotificationsMachinesFetchStart(){cov_2pfupxqnno.f[0]++;cov_2pfupxqnno.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_61" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_START */]};};cov_2pfupxqnno.s[2]++;var helpersNotificationsMachinesFetchSuccess=function helpersNotificationsMachinesFetchSuccess(list){cov_2pfupxqnno.f[1]++;cov_2pfupxqnno.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_62" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_SUCCESS */],list:list};};cov_2pfupxqnno.s[4]++;var helpersNotificationsMachinesFetchFail=function helpersNotificationsMachinesFetchFail(error){cov_2pfupxqnno.f[2]++;cov_2pfupxqnno.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_60" /* HELPERS_NOTIFICATIONS_MACHINES_FETCH_FAIL */],error:error};};cov_2pfupxqnno.s[6]++;var helpersNotificationsMachinesFetch=function helpersNotificationsMachinesFetch(){cov_2pfupxqnno.f[3]++;cov_2pfupxqnno.s[7]++;return function(dispatch){cov_2pfupxqnno.f[4]++;cov_2pfupxqnno.s[8]++;dispatch(helpersNotificationsMachinesFetchStart());cov_2pfupxqnno.s[9]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/machines/notifications').then(function(response){cov_2pfupxqnno.f[5]++;cov_2pfupxqnno.s[10]++;dispatch(helpersNotificationsMachinesFetchSuccess(response.data.list));}).catch(function(error){cov_2pfupxqnno.f[6]++;cov_2pfupxqnno.s[11]++;dispatch(helpersNotificationsMachinesFetchFail(error.response));});};};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export helpersDesignuploadStart */
/* unused harmony export helpersDesignuploadSuccess */
/* unused harmony export helpersDesignuploadFail */
/* unused harmony export helpersDesignuploadProgress */
/* unused harmony export helpersDesignuploadReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helpersDesignupload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_2ce9sx7wyi=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\design.js',hash='a650439bc380b04171fb455faa90afdd4d80866f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\helpers\\design.js',statementMap:{'0':{start:{line:5,column:40},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:42},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:39},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:43},end:{line:30,column:1}},'7':{start:{line:26,column:4},end:{line:29,column:6}},'8':{start:{line:32,column:40},end:{line:36,column:1}},'9':{start:{line:33,column:4},end:{line:35,column:6}},'10':{start:{line:38,column:35},end:{line:56,column:1}},'11':{start:{line:39,column:4},end:{line:55,column:6}},'12':{start:{line:40,column:8},end:{line:40,column:45}},'13':{start:{line:41,column:8},end:{line:54,column:16}},'14':{start:{line:46,column:20},end:{line:46,column:76}},'15':{start:{line:50,column:16},end:{line:50,column:72}},'16':{start:{line:53,column:16},end:{line:53,column:61}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:40},end:{line:5,column:41}},loc:{start:{line:5,column:46},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:42},end:{line:11,column:43}},loc:{start:{line:11,column:55},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:39},end:{line:18,column:40}},loc:{start:{line:18,column:52},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:43},end:{line:25,column:44}},loc:{start:{line:25,column:64},end:{line:30,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:32,column:40},end:{line:32,column:41}},loc:{start:{line:32,column:47},end:{line:36,column:1}},line:32},'5':{name:'(anonymous_5)',decl:{start:{line:38,column:35},end:{line:38,column:36}},loc:{start:{line:38,column:49},end:{line:56,column:1}},line:38},'6':{name:'(anonymous_6)',decl:{start:{line:39,column:11},end:{line:39,column:12}},loc:{start:{line:39,column:23},end:{line:55,column:5}},line:39},'7':{name:'(anonymous_7)',decl:{start:{line:45,column:34},end:{line:45,column:35}},loc:{start:{line:45,column:58},end:{line:47,column:17}},line:45},'8':{name:'(anonymous_8)',decl:{start:{line:49,column:19},end:{line:49,column:20}},loc:{start:{line:49,column:31},end:{line:51,column:13}},line:49},'9':{name:'(anonymous_9)',decl:{start:{line:52,column:20},end:{line:52,column:21}},loc:{start:{line:52,column:29},end:{line:54,column:13}},line:52}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Design Upload ------------------- */cov_2ce9sx7wyi.s[0]++;var helpersDesignuploadStart=function helpersDesignuploadStart(){cov_2ce9sx7wyi.f[0]++;cov_2ce9sx7wyi.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_56" /* HELPERS_DESIGNUPLOAD_START */]};};cov_2ce9sx7wyi.s[2]++;var helpersDesignuploadSuccess=function helpersDesignuploadSuccess(details){cov_2ce9sx7wyi.f[1]++;cov_2ce9sx7wyi.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_57" /* HELPERS_DESIGNUPLOAD_SUCCESS */],details:details};};cov_2ce9sx7wyi.s[4]++;var helpersDesignuploadFail=function helpersDesignuploadFail(error){cov_2ce9sx7wyi.f[2]++;cov_2ce9sx7wyi.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_53" /* HELPERS_DESIGNUPLOAD_FAIL */],error:error};};cov_2ce9sx7wyi.s[6]++;var helpersDesignuploadProgress=function helpersDesignuploadProgress(progressEvent){cov_2ce9sx7wyi.f[3]++;cov_2ce9sx7wyi.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_54" /* HELPERS_DESIGNUPLOAD_PROGRESS */],percent:Math.round(progressEvent.loaded*100/progressEvent.total)};};cov_2ce9sx7wyi.s[8]++;var helpersDesignuploadReset=function helpersDesignuploadReset(){cov_2ce9sx7wyi.f[4]++;cov_2ce9sx7wyi.s[9]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_55" /* HELPERS_DESIGNUPLOAD_RESET */]};};cov_2ce9sx7wyi.s[10]++;var helpersDesignupload=function helpersDesignupload(formData){cov_2ce9sx7wyi.f[5]++;cov_2ce9sx7wyi.s[11]++;return function(dispatch){cov_2ce9sx7wyi.f[6]++;cov_2ce9sx7wyi.s[12]++;dispatch(helpersDesignuploadStart());cov_2ce9sx7wyi.s[13]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].post('/production/calculator/designs/metadata',formData,{headers:{'Content-type':'multipart/form-data'},onUploadProgress:function onUploadProgress(progressEvent){cov_2ce9sx7wyi.f[7]++;cov_2ce9sx7wyi.s[14]++;dispatch(helpersDesignuploadProgress(progressEvent));}}).then(function(response){cov_2ce9sx7wyi.f[8]++;cov_2ce9sx7wyi.s[15]++;dispatch(helpersDesignuploadSuccess(response.data));}).catch(function(error){cov_2ce9sx7wyi.f[9]++;cov_2ce9sx7wyi.s[16]++;dispatch(helpersDesignuploadFail(error));});};};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetching */
/* unused harmony export not_fetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchingStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchingStop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
var cov_1p1biq1ihx=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\fetching.js',hash='ef9d36cdb7f80bdf821950aa07d315cf7ca32a30',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\fetching.js',statementMap:{'0':{start:{line:3,column:24},end:{line:8,column:1}},'1':{start:{line:4,column:4},end:{line:7,column:6}},'2':{start:{line:10,column:28},end:{line:14,column:1}},'3':{start:{line:11,column:4},end:{line:13,column:6}},'4':{start:{line:16,column:29},end:{line:20,column:1}},'5':{start:{line:17,column:1},end:{line:19,column:3}},'6':{start:{line:18,column:5},end:{line:18,column:46}},'7':{start:{line:22,column:28},end:{line:26,column:1}},'8':{start:{line:23,column:4},end:{line:25,column:2}},'9':{start:{line:24,column:5},end:{line:24,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:24},end:{line:3,column:25}},loc:{start:{line:3,column:50},end:{line:8,column:1}},line:3},'1':{name:'(anonymous_1)',decl:{start:{line:10,column:28},end:{line:10,column:29}},loc:{start:{line:10,column:34},end:{line:14,column:1}},line:10},'2':{name:'(anonymous_2)',decl:{start:{line:16,column:29},end:{line:16,column:30}},loc:{start:{line:16,column:53},end:{line:20,column:1}},line:16},'3':{name:'(anonymous_3)',decl:{start:{line:17,column:8},end:{line:17,column:9}},loc:{start:{line:17,column:20},end:{line:19,column:2}},line:17},'4':{name:'(anonymous_4)',decl:{start:{line:22,column:28},end:{line:22,column:29}},loc:{start:{line:22,column:34},end:{line:26,column:1}},line:22},'5':{name:'(anonymous_5)',decl:{start:{line:23,column:11},end:{line:23,column:12}},loc:{start:{line:23,column:23},end:{line:25,column:2}},line:23}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1p1biq1ihx.s[0]++;var fetching=function fetching(show_globalSpinner){cov_1p1biq1ihx.f[0]++;cov_1p1biq1ihx.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_47" /* FETCHING */],show_globalSpinner:show_globalSpinner};};cov_1p1biq1ihx.s[2]++;var not_fetching=function not_fetching(){cov_1p1biq1ihx.f[1]++;cov_1p1biq1ihx.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_63" /* NOT_FETCHING */]};};cov_1p1biq1ihx.s[4]++;var fetchingStart=function fetchingStart(show_globalSpinner){cov_1p1biq1ihx.f[2]++;cov_1p1biq1ihx.s[5]++;return function(dispatch){cov_1p1biq1ihx.f[3]++;cov_1p1biq1ihx.s[6]++;dispatch(fetching(show_globalSpinner));};};cov_1p1biq1ihx.s[7]++;var fetchingStop=function fetchingStop(){cov_1p1biq1ihx.f[4]++;cov_1p1biq1ihx.s[8]++;return function(dispatch){cov_1p1biq1ihx.f[5]++;cov_1p1biq1ihx.s[9]++;dispatch(not_fetching());};};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export printing */
/* unused harmony export not_printing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return printingStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return printingStop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
var cov_1spkmsbz8g=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\printing.js',hash='2cae92ba1cd637c0b362f57842f0d5792fb8bbe8',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\printing.js',statementMap:{'0':{start:{line:3,column:24},end:{line:7,column:1}},'1':{start:{line:4,column:4},end:{line:6,column:6}},'2':{start:{line:9,column:28},end:{line:13,column:1}},'3':{start:{line:10,column:4},end:{line:12,column:6}},'4':{start:{line:15,column:29},end:{line:19,column:1}},'5':{start:{line:16,column:1},end:{line:18,column:3}},'6':{start:{line:17,column:5},end:{line:17,column:27}},'7':{start:{line:21,column:28},end:{line:25,column:1}},'8':{start:{line:22,column:4},end:{line:24,column:2}},'9':{start:{line:23,column:5},end:{line:23,column:30}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:3,column:24},end:{line:3,column:25}},loc:{start:{line:3,column:31},end:{line:7,column:1}},line:3},'1':{name:'(anonymous_1)',decl:{start:{line:9,column:28},end:{line:9,column:29}},loc:{start:{line:9,column:34},end:{line:13,column:1}},line:9},'2':{name:'(anonymous_2)',decl:{start:{line:15,column:29},end:{line:15,column:30}},loc:{start:{line:15,column:35},end:{line:19,column:1}},line:15},'3':{name:'(anonymous_3)',decl:{start:{line:16,column:8},end:{line:16,column:9}},loc:{start:{line:16,column:20},end:{line:18,column:2}},line:16},'4':{name:'(anonymous_4)',decl:{start:{line:21,column:28},end:{line:21,column:29}},loc:{start:{line:21,column:34},end:{line:25,column:1}},line:21},'5':{name:'(anonymous_5)',decl:{start:{line:22,column:11},end:{line:22,column:12}},loc:{start:{line:22,column:23},end:{line:24,column:2}},line:22}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1spkmsbz8g.s[0]++;var printing=function printing(){cov_1spkmsbz8g.f[0]++;cov_1spkmsbz8g.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_65" /* PRINTING */]};};cov_1spkmsbz8g.s[2]++;var not_printing=function not_printing(){cov_1spkmsbz8g.f[1]++;cov_1spkmsbz8g.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_64" /* NOT_PRINTING */]};};cov_1spkmsbz8g.s[4]++;var printingStart=function printingStart(){cov_1spkmsbz8g.f[2]++;cov_1spkmsbz8g.s[5]++;return function(dispatch){cov_1spkmsbz8g.f[3]++;cov_1spkmsbz8g.s[6]++;dispatch(printing());};};cov_1spkmsbz8g.s[7]++;var printingStop=function printingStop(){cov_1spkmsbz8g.f[4]++;cov_1spkmsbz8g.s[8]++;return function(dispatch){cov_1spkmsbz8g.f[5]++;cov_1spkmsbz8g.s[9]++;dispatch(not_printing());};};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export visualMessageSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return visualMessageReset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
var cov_291d3fn6m1=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\visualMessage.js',hash='a6e74789b53d9bf4329d3f69a4471453a164c53b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\visualMessage.js',statementMap:{'0':{start:{line:4,column:32},end:{line:13,column:1}},'1':{start:{line:5,column:4},end:{line:12,column:6}},'2':{start:{line:15,column:34},end:{line:19,column:1}},'3':{start:{line:16,column:4},end:{line:18,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:32},end:{line:4,column:33}},loc:{start:{line:4,column:70},end:{line:13,column:1}},line:4},'1':{name:'(anonymous_1)',decl:{start:{line:15,column:34},end:{line:15,column:35}},loc:{start:{line:15,column:40},end:{line:19,column:1}},line:15}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0},f:{'0':0,'1':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ----------------- Registration ------------------ */cov_291d3fn6m1.s[0]++;var visualMessageSet=function visualMessageSet(message,scope,key,type,obj){var _ref;cov_291d3fn6m1.f[0]++;cov_291d3fn6m1.s[1]++;return _ref={type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],message:message,scope:scope,key:key},_defineProperty(_ref,'type',type),_defineProperty(_ref,'obj',obj),_ref;};cov_291d3fn6m1.s[2]++;var visualMessageReset=function visualMessageReset(){cov_291d3fn6m1.f[1]++;cov_291d3fn6m1.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_80" /* VISUALMESSAGE_RESET */]};};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tokenRestoreSuccess */
/* unused harmony export tokenRestoreFail */
/* unused harmony export tokenRestoreStart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenRestoreToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useSupportToken__ = __webpack_require__(370);
var cov_1wss71wbfm=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\tokenRestore.js',hash='e64148fa4269e195919d1ca1e379bd271d1c9d42',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\tokenRestore.js',statementMap:{'0':{start:{line:8,column:35},end:{line:12,column:1}},'1':{start:{line:9,column:4},end:{line:11,column:6}},'2':{start:{line:14,column:32},end:{line:18,column:1}},'3':{start:{line:15,column:4},end:{line:17,column:6}},'4':{start:{line:20,column:33},end:{line:24,column:1}},'5':{start:{line:21,column:4},end:{line:23,column:6}},'6':{start:{line:26,column:33},end:{line:86,column:1}},'7':{start:{line:27,column:4},end:{line:85,column:6}},'8':{start:{line:28,column:8},end:{line:28,column:38}},'9':{start:{line:30,column:37},end:{line:30,column:54}},'10':{start:{line:32,column:29},end:{line:32,column:72}},'11':{start:{line:33,column:29},end:{line:33,column:54}},'12':{start:{line:35,column:8},end:{line:48,column:9}},'13':{start:{line:36,column:43},end:{line:38,column:13}},'14':{start:{line:40,column:12},end:{line:47,column:13}},'15':{start:{line:41,column:118},end:{line:41,column:122}},'16':{start:{line:43,column:16},end:{line:43,column:139}},'17':{start:{line:45,column:16},end:{line:45,column:48}},'18':{start:{line:46,column:16},end:{line:46,column:23}},'19':{start:{line:50,column:32},end:{line:50,column:36}},'20':{start:{line:52,column:8},end:{line:66,column:9}},'21':{start:{line:53,column:12},end:{line:65,column:13}},'22':{start:{line:55,column:33},end:{line:55,column:121}},'23':{start:{line:56,column:80},end:{line:56,column:93}},'24':{start:{line:57,column:16},end:{line:57,column:42}},'25':{start:{line:59,column:16},end:{line:59,column:117}},'26':{start:{line:60,column:16},end:{line:60,column:48}},'27':{start:{line:61,column:16},end:{line:61,column:23}},'28':{start:{line:63,column:16},end:{line:63,column:33}},'29':{start:{line:64,column:16},end:{line:64,column:55}},'30':{start:{line:68,column:8},end:{line:82,column:9}},'31':{start:{line:69,column:12},end:{line:81,column:13}},'32':{start:{line:70,column:33},end:{line:70,column:141}},'33':{start:{line:71,column:96},end:{line:71,column:109}},'34':{start:{line:72,column:16},end:{line:72,column:117}},'35':{start:{line:74,column:16},end:{line:78,column:17}},'36':{start:{line:75,column:20},end:{line:75,column:93}},'37':{start:{line:76,column:20},end:{line:76,column:52}},'38':{start:{line:77,column:20},end:{line:77,column:27}},'39':{start:{line:80,column:16},end:{line:80,column:33}},'40':{start:{line:84,column:8},end:{line:84,column:37}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:35},end:{line:8,column:36}},loc:{start:{line:8,column:41},end:{line:12,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:32},end:{line:14,column:33}},loc:{start:{line:14,column:38},end:{line:18,column:1}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:20,column:33},end:{line:20,column:34}},loc:{start:{line:20,column:39},end:{line:24,column:1}},line:20},'3':{name:'(anonymous_3)',decl:{start:{line:26,column:33},end:{line:26,column:34}},loc:{start:{line:26,column:53},end:{line:86,column:1}},line:26},'4':{name:'(anonymous_4)',decl:{start:{line:27,column:11},end:{line:27,column:12}},loc:{start:{line:27,column:31},end:{line:85,column:5}},line:27}},branchMap:{'0':{loc:{start:{line:35,column:8},end:{line:48,column:9}},type:'if',locations:[{start:{line:35,column:8},end:{line:48,column:9}},{start:{line:35,column:8},end:{line:48,column:9}}],line:35},'1':{loc:{start:{line:40,column:12},end:{line:47,column:13}},type:'if',locations:[{start:{line:40,column:12},end:{line:47,column:13}},{start:{line:40,column:12},end:{line:47,column:13}}],line:40},'2':{loc:{start:{line:40,column:16},end:{line:40,column:36}},type:'binary-expr',locations:[{start:{line:40,column:16},end:{line:40,column:28}},{start:{line:40,column:32},end:{line:40,column:36}}],line:40},'3':{loc:{start:{line:52,column:8},end:{line:66,column:9}},type:'if',locations:[{start:{line:52,column:8},end:{line:66,column:9}},{start:{line:52,column:8},end:{line:66,column:9}}],line:52},'4':{loc:{start:{line:52,column:12},end:{line:52,column:28}},type:'binary-expr',locations:[{start:{line:52,column:12},end:{line:52,column:17}},{start:{line:52,column:21},end:{line:52,column:28}}],line:52},'5':{loc:{start:{line:68,column:8},end:{line:82,column:9}},type:'if',locations:[{start:{line:68,column:8},end:{line:82,column:9}},{start:{line:68,column:8},end:{line:82,column:9}}],line:68},'6':{loc:{start:{line:74,column:16},end:{line:78,column:17}},type:'if',locations:[{start:{line:74,column:16},end:{line:78,column:17}},{start:{line:74,column:16},end:{line:78,column:17}}],line:74},'7':{loc:{start:{line:74,column:20},end:{line:74,column:36}},type:'binary-expr',locations:[{start:{line:74,column:20},end:{line:74,column:25}},{start:{line:74,column:29},end:{line:74,column:36}}],line:74}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* ----------------- Token Restore ------------------ */cov_1wss71wbfm.s[0]++;var tokenRestoreSuccess=function tokenRestoreSuccess(){cov_1wss71wbfm.f[0]++;cov_1wss71wbfm.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_76" /* TOKEN_RESTORE_SUCCESS */]};};cov_1wss71wbfm.s[2]++;var tokenRestoreFail=function tokenRestoreFail(){cov_1wss71wbfm.f[1]++;cov_1wss71wbfm.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_74" /* TOKEN_RESTORE_FAIL */]};};cov_1wss71wbfm.s[4]++;var tokenRestoreStart=function tokenRestoreStart(){cov_1wss71wbfm.f[2]++;cov_1wss71wbfm.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["_75" /* TOKEN_RESTORE_START */]};};cov_1wss71wbfm.s[6]++;var tokenRestoreToken=function tokenRestoreToken(token,user_id){cov_1wss71wbfm.f[3]++;cov_1wss71wbfm.s[7]++;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var loginViaSupportToken,searchParams,supportToken,_ref2,isValidToken,user,_ref3,_token,_user_id,first_name,last_name,account_name,parent_user_id,impersonation_for_id,tryToRefreshToken,response,_ref4,_first_name,_last_name,_account_name,_parent_user_id,_response,_ref5,_token2,_user_id2,_first_name2,_last_name2,_account_name2,_parent_user_id2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cov_1wss71wbfm.f[4]++;cov_1wss71wbfm.s[8]++;dispatch(tokenRestoreStart());loginViaSupportToken=(cov_1wss71wbfm.s[9]++,Object(__WEBPACK_IMPORTED_MODULE_4__hooks_useSupportToken__["a" /* useSupportToken */])());searchParams=(cov_1wss71wbfm.s[10]++,new URLSearchParams(window.location.search));supportToken=(cov_1wss71wbfm.s[11]++,searchParams.get("token"));cov_1wss71wbfm.s[12]++;if(!supportToken){_context.next=30;break;}cov_1wss71wbfm.b[0][0]++;cov_1wss71wbfm.s[13]++;_context.next=12;return loginViaSupportToken(supportToken);case 12:_ref2=_context.sent;isValidToken=_ref2.isValidToken;user=_ref2.user;cov_1wss71wbfm.s[14]++;if(!((cov_1wss71wbfm.b[2][0]++,isValidToken)&&(cov_1wss71wbfm.b[2][1]++,user))){_context.next=27;break;}cov_1wss71wbfm.b[1][0]++;_ref3=(cov_1wss71wbfm.s[15]++,user),_token=_ref3.token,_user_id=_ref3.user_id,first_name=_ref3.first_name,last_name=_ref3.last_name,account_name=_ref3.account_name,parent_user_id=_ref3.parent_user_id,impersonation_for_id=_ref3.impersonation_for_id;cov_1wss71wbfm.s[16]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* authChangeCurrentUser */])(_token,_user_id,first_name,last_name,account_name,parent_user_id,impersonation_for_id));cov_1wss71wbfm.s[17]++;dispatch(tokenRestoreSuccess());cov_1wss71wbfm.s[18]++;return _context.abrupt('return');case 27:cov_1wss71wbfm.b[1][1]++;case 28:_context.next=31;break;case 30:cov_1wss71wbfm.b[0][1]++;case 31:tryToRefreshToken=(cov_1wss71wbfm.s[19]++,true);cov_1wss71wbfm.s[20]++;if(!((cov_1wss71wbfm.b[4][0]++,token)&&(cov_1wss71wbfm.b[4][1]++,user_id))){_context.next=60;break;}cov_1wss71wbfm.b[3][0]++;cov_1wss71wbfm.s[21]++;_context.prev=36;cov_1wss71wbfm.s[22]++;_context.next=40;return __WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */].get('/users/'+user_id,{skipRedirectToLoginIfUnauthorized:true,token:token});case 40:response=_context.sent;_ref4=(cov_1wss71wbfm.s[23]++,response.data),_first_name=_ref4.first_name,_last_name=_ref4.last_name,_account_name=_ref4.account_name,_parent_user_id=_ref4.parent_user_id;cov_1wss71wbfm.s[24]++;tryToRefreshToken=false;cov_1wss71wbfm.s[25]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* authChangeCurrentUser */])(token,user_id,_first_name,_last_name,_account_name,_parent_user_id));cov_1wss71wbfm.s[26]++;dispatch(tokenRestoreSuccess());cov_1wss71wbfm.s[27]++;return _context.abrupt('return');case 52:_context.prev=52;_context.t0=_context['catch'](36);cov_1wss71wbfm.s[28]++;console.error(_context.t0);cov_1wss71wbfm.s[29]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__auth__["c" /* authRemoveMelcoAccountData */])());case 58:_context.next=61;break;case 60:cov_1wss71wbfm.b[3][1]++;case 61:cov_1wss71wbfm.s[30]++;if(!tryToRefreshToken){_context.next=93;break;}cov_1wss71wbfm.b[5][0]++;cov_1wss71wbfm.s[31]++;_context.prev=65;cov_1wss71wbfm.s[32]++;_context.next=69;return __WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */].get('/auth/melco/refresh',{withCredentials:true,skipRedirectToLoginIfUnauthorized:true});case 69:_response=_context.sent;_ref5=(cov_1wss71wbfm.s[33]++,_response.data),_token2=_ref5.token,_user_id2=_ref5.user_id,_first_name2=_ref5.first_name,_last_name2=_ref5.last_name,_account_name2=_ref5.account_name,_parent_user_id2=_ref5.parent_user_id;cov_1wss71wbfm.s[34]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* authChangeCurrentUser */])(_token2,_user_id2,_first_name2,_last_name2,_account_name2,_parent_user_id2));cov_1wss71wbfm.s[35]++;if(!((cov_1wss71wbfm.b[7][0]++,_token2)&&(cov_1wss71wbfm.b[7][1]++,_user_id2))){_context.next=84;break;}cov_1wss71wbfm.b[6][0]++;cov_1wss71wbfm.s[36]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__auth__["d" /* authSetMelcoAccountData */])(_token2,_user_id2,_first_name2,_last_name2));cov_1wss71wbfm.s[37]++;dispatch(tokenRestoreSuccess());cov_1wss71wbfm.s[38]++;return _context.abrupt('return');case 84:cov_1wss71wbfm.b[6][1]++;case 85:_context.next=91;break;case 87:_context.prev=87;_context.t1=_context['catch'](65);cov_1wss71wbfm.s[39]++;console.error(_context.t1);case 91:_context.next=94;break;case 93:cov_1wss71wbfm.b[5][1]++;case 94:cov_1wss71wbfm.s[40]++;dispatch(tokenRestoreFail());case 96:case'end':return _context.stop();}}},_callee,_this,[[36,52],[65,87]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(369);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSupportToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_1q75tgtbgp=function(){var path="D:\\a\\1\\s\\app\\browser\\src\\hooks\\useSupportToken.js",hash="a3e0142960e6d44e21a62056f2c9bdb0880bdf13",Function=function(){}.constructor,global=new Function('return this')(),gcv="__coverage__",coverageData={path:"D:\\a\\1\\s\\app\\browser\\src\\hooks\\useSupportToken.js",statementMap:{"0":{start:{line:3,column:31},end:{line:68,column:1}},"1":{start:{line:4,column:2},end:{line:67,column:4}},"2":{start:{line:5,column:4},end:{line:64,column:5}},"3":{start:{line:6,column:23},end:{line:8,column:8}},"4":{start:{line:19,column:10},end:{line:19,column:23}},"5":{start:{line:21,column:6},end:{line:45,column:7}},"6":{start:{line:22,column:33},end:{line:25,column:9}},"7":{start:{line:27,column:8},end:{line:27,column:75}},"8":{start:{line:29,column:8},end:{line:29,column:44}},"9":{start:{line:30,column:8},end:{line:32,column:15}},"10":{start:{line:34,column:8},end:{line:36,column:15}},"11":{start:{line:38,column:8},end:{line:40,column:13}},"12":{start:{line:42,column:8},end:{line:44,column:19}},"13":{start:{line:47,column:6},end:{line:61,column:8}},"14":{start:{line:63,column:6},end:{line:63,column:23}},"15":{start:{line:66,column:4},end:{line:66,column:35}}},fnMap:{"0":{name:"(anonymous_0)",decl:{start:{line:3,column:31},end:{line:3,column:32}},loc:{start:{line:3,column:37},end:{line:68,column:1}},line:3},"1":{name:"(anonymous_1)",decl:{start:{line:4,column:9},end:{line:4,column:10}},loc:{start:{line:4,column:33},end:{line:67,column:3}},line:4}},branchMap:{"0":{loc:{start:{line:21,column:6},end:{line:45,column:7}},type:"if",locations:[{start:{line:21,column:6},end:{line:45,column:7}},{start:{line:21,column:6},end:{line:45,column:7}}],line:21},"1":{loc:{start:{line:21,column:10},end:{line:21,column:39}},type:"binary-expr",locations:[{start:{line:21,column:10},end:{line:21,column:30}},{start:{line:21,column:34},end:{line:21,column:39}}],line:21},"2":{loc:{start:{line:27,column:18},end:{line:27,column:74}},type:"cond-expr",locations:[{start:{line:27,column:45},end:{line:27,column:69}},{start:{line:27,column:72},end:{line:27,column:74}}],line:27},"3":{loc:{start:{line:30,column:21},end:{line:32,column:14}},type:"cond-expr",locations:[{start:{line:31,column:12},end:{line:31,column:44}},{start:{line:32,column:12},end:{line:32,column:14}}],line:30},"4":{loc:{start:{line:34,column:20},end:{line:36,column:14}},type:"cond-expr",locations:[{start:{line:35,column:12},end:{line:35,column:43}},{start:{line:36,column:12},end:{line:36,column:14}}],line:34},"5":{loc:{start:{line:38,column:23},end:{line:40,column:12}},type:"cond-expr",locations:[{start:{line:39,column:10},end:{line:39,column:44}},{start:{line:40,column:10},end:{line:40,column:12}}],line:38},"6":{loc:{start:{line:42,column:25},end:{line:44,column:19}},type:"cond-expr",locations:[{start:{line:43,column:10},end:{line:43,column:46}},{start:{line:44,column:10},end:{line:44,column:19}}],line:42},"7":{loc:{start:{line:50,column:17},end:{line:50,column:35}},type:"cond-expr",locations:[{start:{line:50,column:25},end:{line:50,column:30}},{start:{line:50,column:33},end:{line:50,column:35}}],line:50},"8":{loc:{start:{line:51,column:17},end:{line:51,column:35}},type:"cond-expr",locations:[{start:{line:51,column:25},end:{line:51,column:30}},{start:{line:51,column:33},end:{line:51,column:35}}],line:51},"9":{loc:{start:{line:52,column:19},end:{line:52,column:41}},type:"cond-expr",locations:[{start:{line:52,column:29},end:{line:52,column:36}},{start:{line:52,column:39},end:{line:52,column:41}}],line:52},"10":{loc:{start:{line:53,column:22},end:{line:53,column:50}},type:"cond-expr",locations:[{start:{line:53,column:35},end:{line:53,column:45}},{start:{line:53,column:48},end:{line:53,column:50}}],line:53},"11":{loc:{start:{line:54,column:21},end:{line:54,column:47}},type:"cond-expr",locations:[{start:{line:54,column:33},end:{line:54,column:42}},{start:{line:54,column:45},end:{line:54,column:47}}],line:54},"12":{loc:{start:{line:55,column:24},end:{line:55,column:56}},type:"cond-expr",locations:[{start:{line:55,column:39},end:{line:55,column:51}},{start:{line:55,column:54},end:{line:55,column:56}}],line:55},"13":{loc:{start:{line:56,column:26},end:{line:56,column:69}},type:"cond-expr",locations:[{start:{line:56,column:43},end:{line:56,column:57}},{start:{line:56,column:60},end:{line:56,column:69}}],line:56},"14":{loc:{start:{line:57,column:32},end:{line:59,column:23}},type:"cond-expr",locations:[{start:{line:58,column:14},end:{line:58,column:34}},{start:{line:59,column:14},end:{line:59,column:23}}],line:57}},s:{"0":0,"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0},f:{"0":0,"1":0},b:{"0":[0,0],"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0]},_coverageSchema:"332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}cov_1q75tgtbgp.s[0]++;var useSupportToken=function useSupportToken(){cov_1q75tgtbgp.f[0]++;cov_1q75tgtbgp.s[1]++;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(supportToken){var response,_ref2,email,token,user_id,first_name,last_name,account_name,parent_user_id,impersonation_for_id,impersonatedUser;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cov_1q75tgtbgp.f[1]++;cov_1q75tgtbgp.s[2]++;_context.prev=2;cov_1q75tgtbgp.s[3]++;_context.next=6;return __WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].post("/auth/support/token",{token:supportToken});case 6:response=_context.sent;_ref2=(cov_1q75tgtbgp.s[4]++,response.data),email=_ref2.user_name,token=_ref2.token,user_id=_ref2.user_id,first_name=_ref2.first_name,last_name=_ref2.last_name,account_name=_ref2.account_name,parent_user_id=_ref2.parent_user_id,impersonation_for_id=_ref2.impersonation_for_id;cov_1q75tgtbgp.s[5]++;if(!((cov_1q75tgtbgp.b[1][0]++,impersonation_for_id)&&(cov_1q75tgtbgp.b[1][1]++,token))){_context.next=29;break;}cov_1q75tgtbgp.b[0][0]++;cov_1q75tgtbgp.s[6]++;_context.next=14;return __WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get("/users/"+impersonation_for_id,{skipRedirectToLoginIfUnauthorized:true,token:token,impersonation_for_id:impersonation_for_id});case 14:impersonatedUser=_context.sent;cov_1q75tgtbgp.s[7]++;user_id=impersonatedUser.data.id?(cov_1q75tgtbgp.b[2][0]++,impersonatedUser.data.id):(cov_1q75tgtbgp.b[2][1]++,"");cov_1q75tgtbgp.s[8]++;email=impersonatedUser.data.email;cov_1q75tgtbgp.s[9]++;first_name=impersonatedUser.data.first_name?(cov_1q75tgtbgp.b[3][0]++,impersonatedUser.data.first_name):(cov_1q75tgtbgp.b[3][1]++,"");cov_1q75tgtbgp.s[10]++;last_name=impersonatedUser.data.last_name?(cov_1q75tgtbgp.b[4][0]++,impersonatedUser.data.last_name):(cov_1q75tgtbgp.b[4][1]++,"");cov_1q75tgtbgp.s[11]++;account_name=impersonatedUser.data.account_name?(cov_1q75tgtbgp.b[5][0]++,impersonatedUser.data.account_name):(cov_1q75tgtbgp.b[5][1]++,"");cov_1q75tgtbgp.s[12]++;parent_user_id=impersonatedUser.data.parent_user_id?(cov_1q75tgtbgp.b[6][0]++,impersonatedUser.data.parent_user_id):(cov_1q75tgtbgp.b[6][1]++,undefined);_context.next=30;break;case 29:cov_1q75tgtbgp.b[0][1]++;case 30:cov_1q75tgtbgp.s[13]++;return _context.abrupt("return",{isValidToken:true,user:{email:email?(cov_1q75tgtbgp.b[7][0]++,email):(cov_1q75tgtbgp.b[7][1]++,""),token:token?(cov_1q75tgtbgp.b[8][0]++,token):(cov_1q75tgtbgp.b[8][1]++,""),user_id:user_id?(cov_1q75tgtbgp.b[9][0]++,user_id):(cov_1q75tgtbgp.b[9][1]++,""),first_name:first_name?(cov_1q75tgtbgp.b[10][0]++,first_name):(cov_1q75tgtbgp.b[10][1]++,""),last_name:last_name?(cov_1q75tgtbgp.b[11][0]++,last_name):(cov_1q75tgtbgp.b[11][1]++,""),account_name:account_name?(cov_1q75tgtbgp.b[12][0]++,account_name):(cov_1q75tgtbgp.b[12][1]++,""),parent_user_id:parent_user_id?(cov_1q75tgtbgp.b[13][0]++,parent_user_id):(cov_1q75tgtbgp.b[13][1]++,undefined),impersonation_for_id:impersonation_for_id?(cov_1q75tgtbgp.b[14][0]++,impersonation_for_id):(cov_1q75tgtbgp.b[14][1]++,undefined)}});case 34:_context.prev=34;_context.t0=_context["catch"](2);cov_1q75tgtbgp.s[14]++;console.error(_context.t0);case 38:cov_1q75tgtbgp.s[15]++;return _context.abrupt("return",{isValidToken:false});case 40:case"end":return _context.stop();}}},_callee,_this,[[2,34]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appStartupStart */
/* unused harmony export appStartupSuccess */
/* unused harmony export appStartupFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appStartup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translationLoad__ = __webpack_require__(145);
var cov_27c726oyq5=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\appStartup.js',hash='a4b936004813bbefdca085ecc06992cace6bb45f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\appStartup.js',statementMap:{'0':{start:{line:5,column:31},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:33},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:30},end:{line:22,column:1}},'5':{start:{line:19,column:4},end:{line:21,column:6}},'6':{start:{line:24,column:26},end:{line:51,column:1}},'7':{start:{line:25,column:41},end:{line:28,column:5}},'8':{start:{line:26,column:28},end:{line:26,column:119}},'9':{start:{line:27,column:8},end:{line:27,column:43}},'10':{start:{line:30,column:30},end:{line:33,column:5}},'11':{start:{line:31,column:28},end:{line:31,column:66}},'12':{start:{line:32,column:8},end:{line:32,column:43}},'13':{start:{line:35,column:4},end:{line:50,column:6}},'14':{start:{line:36,column:8},end:{line:36,column:36}},'15':{start:{line:37,column:8},end:{line:49,column:9}},'16':{start:{line:38,column:29},end:{line:38,column:113}},'17':{start:{line:39,column:12},end:{line:43,column:13}},'18':{start:{line:40,column:16},end:{line:40,column:47}},'19':{start:{line:41,column:16},end:{line:41,column:45}},'20':{start:{line:42,column:16},end:{line:42,column:23}},'21':{start:{line:44,column:12},end:{line:44,column:70}},'22':{start:{line:45,column:12},end:{line:45,column:78}},'23':{start:{line:47,column:12},end:{line:47,column:32}},'24':{start:{line:48,column:12},end:{line:48,column:57}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:31},end:{line:5,column:32}},loc:{start:{line:5,column:37},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:33},end:{line:11,column:34}},loc:{start:{line:11,column:57},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:30},end:{line:18,column:31}},loc:{start:{line:18,column:36},end:{line:22,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:24,column:26},end:{line:24,column:27}},loc:{start:{line:24,column:32},end:{line:51,column:1}},line:24},'4':{name:'(anonymous_4)',decl:{start:{line:25,column:41},end:{line:25,column:42}},loc:{start:{line:25,column:47},end:{line:28,column:5}},line:25},'5':{name:'(anonymous_5)',decl:{start:{line:30,column:30},end:{line:30,column:31}},loc:{start:{line:30,column:36},end:{line:33,column:5}},line:30},'6':{name:'(anonymous_6)',decl:{start:{line:35,column:11},end:{line:35,column:12}},loc:{start:{line:35,column:31},end:{line:50,column:5}},line:35}},branchMap:{'0':{loc:{start:{line:39,column:12},end:{line:43,column:13}},type:'if',locations:[{start:{line:39,column:12},end:{line:43,column:13}},{start:{line:39,column:12},end:{line:43,column:13}}],line:39}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}cov_27c726oyq5.s[0]++;var appStartupStart=function appStartupStart(){cov_27c726oyq5.f[0]++;cov_27c726oyq5.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["b" /* APP_STARTUP_START */]};};cov_27c726oyq5.s[2]++;var appStartupSuccess=function appStartupSuccess(show_service_terms){cov_27c726oyq5.f[1]++;cov_27c726oyq5.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["c" /* APP_STARTUP_SUCCESS */],show_service_terms:show_service_terms};};cov_27c726oyq5.s[4]++;var appStartupFail=function appStartupFail(){cov_27c726oyq5.f[2]++;cov_27c726oyq5.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_1__actionTypes__["a" /* APP_STARTUP_FAIL */]};};cov_27c726oyq5.s[6]++;var appStartup=function appStartup(){cov_27c726oyq5.f[3]++;cov_27c726oyq5.s[7]++;var redirectToAcceptServiceTerms=function redirectToAcceptServiceTerms(){cov_27c726oyq5.f[4]++;var redirectURL=(cov_27c726oyq5.s[8]++,"https://test-account.melcocloud.com/"+'dashboard/terms/'+"MATTERHORN");cov_27c726oyq5.s[9]++;window.location.href=redirectURL;};cov_27c726oyq5.s[10]++;var redirectToAccount=function redirectToAccount(){cov_27c726oyq5.f[5]++;var redirectURL=(cov_27c726oyq5.s[11]++,''+"https://test-account.melcocloud.com/");cov_27c726oyq5.s[12]++;window.location.href=redirectURL;};cov_27c726oyq5.s[13]++;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cov_27c726oyq5.f[6]++;cov_27c726oyq5.s[14]++;dispatch(appStartupStart());cov_27c726oyq5.s[15]++;_context.prev=4;cov_27c726oyq5.s[16]++;_context.next=8;return __WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */].get('/account/products/'+"MATTERHORN"+'/startup');case 8:response=_context.sent;cov_27c726oyq5.s[17]++;if(!response.data.show_service_terms){_context.next=20;break;}cov_27c726oyq5.b[0][0]++;cov_27c726oyq5.s[18]++;redirectToAcceptServiceTerms();cov_27c726oyq5.s[19]++;dispatch(appStartupFail());cov_27c726oyq5.s[20]++;return _context.abrupt('return');case 20:cov_27c726oyq5.b[0][1]++;case 21:cov_27c726oyq5.s[21]++;dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__translationLoad__["a" /* translationLoad */])(response.data.default_language));cov_27c726oyq5.s[22]++;dispatch(appStartupSuccess(response.data.show_service_terms));_context.next=33;break;case 27:_context.prev=27;_context.t0=_context['catch'](4);cov_27c726oyq5.s[23]++;redirectToAccount();cov_27c726oyq5.s[24]++;dispatch(appStartupFail(_context.t0.response));case 33:case'end':return _context.stop();}}},_callee,_this,[[4,27]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultsFetchStart */
/* unused harmony export defaultsFetchSuccess */
/* unused harmony export defaultsFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultsFetch; });
/* unused harmony export defaultsGet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_1oruzw7t8v=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\defaults.js',hash='b2e80feae98ec4fd74163fa3cd1f692ecbeff0d0',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\defaults.js',statementMap:{'0':{start:{line:4,column:34},end:{line:8,column:1}},'1':{start:{line:5,column:4},end:{line:7,column:6}},'2':{start:{line:10,column:36},end:{line:17,column:1}},'3':{start:{line:11,column:4},end:{line:16,column:6}},'4':{start:{line:19,column:33},end:{line:23,column:1}},'5':{start:{line:20,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:21},end:{line:27,column:1}},'7':{start:{line:26,column:1},end:{line:26,column:45}},'8':{start:{line:29,column:22},end:{line:31,column:1}},'9':{start:{line:30,column:1},end:{line:30,column:46}},'10':{start:{line:33,column:19},end:{line:35,column:1}},'11':{start:{line:34,column:1},end:{line:34,column:43}},'12':{start:{line:37,column:29},end:{line:49,column:1}},'13':{start:{line:38,column:4},end:{line:48,column:6}},'14':{start:{line:39,column:8},end:{line:39,column:39}},'15':{start:{line:40,column:8},end:{line:47,column:8}},'16':{start:{line:42,column:6},end:{line:42,column:102}},'17':{start:{line:45,column:12},end:{line:45,column:198}},'18':{start:{line:46,column:12},end:{line:46,column:60}},'19':{start:{line:51,column:27},end:{line:55,column:1}},'20':{start:{line:52,column:4},end:{line:54,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:34},end:{line:4,column:35}},loc:{start:{line:4,column:40},end:{line:8,column:1}},line:4},'1':{name:'(anonymous_1)',decl:{start:{line:10,column:36},end:{line:10,column:37}},loc:{start:{line:10,column:72},end:{line:17,column:1}},line:10},'2':{name:'(anonymous_2)',decl:{start:{line:19,column:33},end:{line:19,column:34}},loc:{start:{line:19,column:39},end:{line:23,column:1}},line:19},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:21},end:{line:25,column:22}},loc:{start:{line:25,column:27},end:{line:27,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:29,column:22},end:{line:29,column:23}},loc:{start:{line:29,column:28},end:{line:31,column:1}},line:29},'5':{name:'(anonymous_5)',decl:{start:{line:33,column:19},end:{line:33,column:20}},loc:{start:{line:33,column:25},end:{line:35,column:1}},line:33},'6':{name:'(anonymous_6)',decl:{start:{line:37,column:29},end:{line:37,column:30}},loc:{start:{line:37,column:35},end:{line:49,column:1}},line:37},'7':{name:'(anonymous_7)',decl:{start:{line:38,column:11},end:{line:38,column:12}},loc:{start:{line:38,column:23},end:{line:48,column:5}},line:38},'8':{name:'(anonymous_8)',decl:{start:{line:41,column:11},end:{line:41,column:12}},loc:{start:{line:41,column:50},end:{line:43,column:6}},line:41},'9':{name:'(anonymous_9)',decl:{start:{line:44,column:12},end:{line:44,column:13}},loc:{start:{line:44,column:21},end:{line:47,column:6}},line:44},'10':{name:'(anonymous_10)',decl:{start:{line:51,column:27},end:{line:51,column:28}},loc:{start:{line:51,column:33},end:{line:55,column:1}},line:51}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();cov_1oruzw7t8v.s[0]++;var defaultsFetchStart=function defaultsFetchStart(){cov_1oruzw7t8v.f[0]++;cov_1oruzw7t8v.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_44" /* DEFAULTS_FETCH_START */]};};cov_1oruzw7t8v.s[2]++;var defaultsFetchSuccess=function defaultsFetchSuccess(countries,currencies,genders){cov_1oruzw7t8v.f[1]++;cov_1oruzw7t8v.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_45" /* DEFAULTS_FETCH_SUCCESS */],countries:countries,currencies:currencies,genders:genders};};cov_1oruzw7t8v.s[4]++;var defaultsFetchFail=function defaultsFetchFail(){cov_1oruzw7t8v.f[2]++;cov_1oruzw7t8v.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_43" /* DEFAULTS_FETCH_FAIL */]};};cov_1oruzw7t8v.s[6]++;var getCountries=function getCountries(){cov_1oruzw7t8v.f[3]++;cov_1oruzw7t8v.s[7]++;return __WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/defaults/countries');};cov_1oruzw7t8v.s[8]++;var getCurrencies=function getCurrencies(){cov_1oruzw7t8v.f[4]++;cov_1oruzw7t8v.s[9]++;return __WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/defaults/currencies');};cov_1oruzw7t8v.s[10]++;var getGenders=function getGenders(){cov_1oruzw7t8v.f[5]++;cov_1oruzw7t8v.s[11]++;return __WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/defaults/genders');};cov_1oruzw7t8v.s[12]++;var defaultsFetch=function defaultsFetch(){cov_1oruzw7t8v.f[6]++;cov_1oruzw7t8v.s[13]++;return function(dispatch){cov_1oruzw7t8v.f[7]++;cov_1oruzw7t8v.s[14]++;dispatch(defaultsFetchStart());cov_1oruzw7t8v.s[15]++;Promise.all([getCountries(),getCurrencies(),getGenders()]).then(function(_ref){var _ref2=_slicedToArray(_ref,3),countries=_ref2[0],currencies=_ref2[1],genders=_ref2[2];cov_1oruzw7t8v.f[8]++;cov_1oruzw7t8v.s[16]++;dispatch(defaultsFetchSuccess(countries.data.list,currencies.data.list,genders.data.list));}).catch(function(error){cov_1oruzw7t8v.f[9]++;cov_1oruzw7t8v.s[17]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"defauts",key:"default",message:"Resource not available, please try it again later.",type:'error',obj:error}});cov_1oruzw7t8v.s[18]++;dispatch(defaultsFetchFail(error.response));});};};cov_1oruzw7t8v.s[19]++;var defaultsGet=function defaultsGet(){cov_1oruzw7t8v.f[10]++;cov_1oruzw7t8v.s[20]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_46" /* DEFAULTS_GET */]};};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export settingsCompanyUpdateStart */
/* unused harmony export settingsCompanyUpdateSuccess */
/* unused harmony export settingsCompanyUpdateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return settingsCompanyUpdateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return settingsCompanyUpdate; });
/* unused harmony export settingsCompanyFetchStart */
/* unused harmony export settingsCompanyFetchSuccess */
/* unused harmony export settingsCompanyFetchFail */
/* unused harmony export settingsCompanyFetchReset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsCompanyFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_ry8g5sxjo=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\settings\\company.js',hash='e5be3a4e41d583b1f8476d19bc1a74c13fc58172',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\settings\\company.js',statementMap:{'0':{start:{line:5,column:42},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:44},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:41},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:42},end:{line:30,column:1}},'7':{start:{line:26,column:4},end:{line:29,column:6}},'8':{start:{line:32,column:37},end:{line:43,column:1}},'9':{start:{line:33,column:4},end:{line:42,column:6}},'10':{start:{line:34,column:8},end:{line:34,column:47}},'11':{start:{line:35,column:8},end:{line:41,column:16}},'12':{start:{line:37,column:16},end:{line:37,column:74}},'13':{start:{line:40,column:16},end:{line:40,column:63}},'14':{start:{line:46,column:41},end:{line:50,column:1}},'15':{start:{line:47,column:4},end:{line:49,column:6}},'16':{start:{line:52,column:43},end:{line:57,column:1}},'17':{start:{line:53,column:4},end:{line:56,column:6}},'18':{start:{line:59,column:40},end:{line:64,column:1}},'19':{start:{line:60,column:4},end:{line:63,column:6}},'20':{start:{line:66,column:41},end:{line:71,column:1}},'21':{start:{line:67,column:4},end:{line:70,column:6}},'22':{start:{line:73,column:36},end:{line:90,column:1}},'23':{start:{line:74,column:4},end:{line:89,column:6}},'24':{start:{line:75,column:8},end:{line:75,column:46}},'25':{start:{line:76,column:8},end:{line:88,column:16}},'26':{start:{line:78,column:16},end:{line:78,column:73}},'27':{start:{line:81,column:16},end:{line:86,column:17}},'28':{start:{line:82,column:20},end:{line:82,column:161}},'29':{start:{line:85,column:20},end:{line:85,column:202}},'30':{start:{line:87,column:16},end:{line:87,column:62}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:42},end:{line:5,column:43}},loc:{start:{line:5,column:48},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:44},end:{line:11,column:45}},loc:{start:{line:11,column:58},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:41},end:{line:18,column:42}},loc:{start:{line:18,column:54},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:42},end:{line:25,column:43}},loc:{start:{line:25,column:55},end:{line:30,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:32,column:37},end:{line:32,column:38}},loc:{start:{line:32,column:51},end:{line:43,column:1}},line:32},'5':{name:'(anonymous_5)',decl:{start:{line:33,column:11},end:{line:33,column:12}},loc:{start:{line:33,column:23},end:{line:42,column:5}},line:33},'6':{name:'(anonymous_6)',decl:{start:{line:36,column:19},end:{line:36,column:20}},loc:{start:{line:36,column:31},end:{line:38,column:13}},line:36},'7':{name:'(anonymous_7)',decl:{start:{line:39,column:20},end:{line:39,column:21}},loc:{start:{line:39,column:29},end:{line:41,column:13}},line:39},'8':{name:'(anonymous_8)',decl:{start:{line:46,column:41},end:{line:46,column:42}},loc:{start:{line:46,column:47},end:{line:50,column:1}},line:46},'9':{name:'(anonymous_9)',decl:{start:{line:52,column:43},end:{line:52,column:44}},loc:{start:{line:52,column:57},end:{line:57,column:1}},line:52},'10':{name:'(anonymous_10)',decl:{start:{line:59,column:40},end:{line:59,column:41}},loc:{start:{line:59,column:53},end:{line:64,column:1}},line:59},'11':{name:'(anonymous_11)',decl:{start:{line:66,column:41},end:{line:66,column:42}},loc:{start:{line:66,column:54},end:{line:71,column:1}},line:66},'12':{name:'(anonymous_12)',decl:{start:{line:73,column:36},end:{line:73,column:37}},loc:{start:{line:73,column:42},end:{line:90,column:1}},line:73},'13':{name:'(anonymous_13)',decl:{start:{line:74,column:11},end:{line:74,column:12}},loc:{start:{line:74,column:23},end:{line:89,column:5}},line:74},'14':{name:'(anonymous_14)',decl:{start:{line:77,column:19},end:{line:77,column:20}},loc:{start:{line:77,column:31},end:{line:79,column:13}},line:77},'15':{name:'(anonymous_15)',decl:{start:{line:80,column:20},end:{line:80,column:21}},loc:{start:{line:80,column:29},end:{line:88,column:13}},line:80}},branchMap:{'0':{loc:{start:{line:81,column:16},end:{line:86,column:17}},type:'if',locations:[{start:{line:81,column:16},end:{line:86,column:17}},{start:{line:81,column:16},end:{line:86,column:17}}],line:81},'1':{loc:{start:{line:81,column:19},end:{line:81,column:53}},type:'binary-expr',locations:[{start:{line:81,column:19},end:{line:81,column:31}},{start:{line:81,column:35},end:{line:81,column:53}}],line:81}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Company Update ------------------- */cov_ry8g5sxjo.s[0]++;var settingsCompanyUpdateStart=function settingsCompanyUpdateStart(){cov_ry8g5sxjo.f[0]++;cov_ry8g5sxjo.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_72" /* SETTINGS_COMPANY_UPDATE_START */]};};cov_ry8g5sxjo.s[2]++;var settingsCompanyUpdateSuccess=function settingsCompanyUpdateSuccess(settings){cov_ry8g5sxjo.f[1]++;cov_ry8g5sxjo.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_73" /* SETTINGS_COMPANY_UPDATE_SUCCESS */],settings:settings};};cov_ry8g5sxjo.s[4]++;var settingsCompanyUpdateFail=function settingsCompanyUpdateFail(error){cov_ry8g5sxjo.f[2]++;cov_ry8g5sxjo.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_70" /* SETTINGS_COMPANY_UPDATE_FAIL */],error:error};};cov_ry8g5sxjo.s[6]++;var settingsCompanyUpdateReset=function settingsCompanyUpdateReset(error){cov_ry8g5sxjo.f[3]++;cov_ry8g5sxjo.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_71" /* SETTINGS_COMPANY_UPDATE_RESET */],error:error};};cov_ry8g5sxjo.s[8]++;var settingsCompanyUpdate=function settingsCompanyUpdate(formData){cov_ry8g5sxjo.f[4]++;cov_ry8g5sxjo.s[9]++;return function(dispatch){cov_ry8g5sxjo.f[5]++;cov_ry8g5sxjo.s[10]++;dispatch(settingsCompanyUpdateStart());cov_ry8g5sxjo.s[11]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/settings',formData).then(function(response){cov_ry8g5sxjo.f[6]++;cov_ry8g5sxjo.s[12]++;dispatch(settingsCompanyUpdateSuccess(response.data));}).catch(function(error){cov_ry8g5sxjo.f[7]++;cov_ry8g5sxjo.s[13]++;dispatch(settingsCompanyUpdateFail(error));});};};/* ------------------ Company Fetch ------------------- */cov_ry8g5sxjo.s[14]++;var settingsCompanyFetchStart=function settingsCompanyFetchStart(){cov_ry8g5sxjo.f[8]++;cov_ry8g5sxjo.s[15]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_68" /* SETTINGS_COMPANY_FETCH_START */]};};cov_ry8g5sxjo.s[16]++;var settingsCompanyFetchSuccess=function settingsCompanyFetchSuccess(settings){cov_ry8g5sxjo.f[9]++;cov_ry8g5sxjo.s[17]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_69" /* SETTINGS_COMPANY_FETCH_SUCCESS */],settings:settings};};cov_ry8g5sxjo.s[18]++;var settingsCompanyFetchFail=function settingsCompanyFetchFail(error){cov_ry8g5sxjo.f[10]++;cov_ry8g5sxjo.s[19]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_66" /* SETTINGS_COMPANY_FETCH_FAIL */],error:error};};cov_ry8g5sxjo.s[20]++;var settingsCompanyFetchReset=function settingsCompanyFetchReset(error){cov_ry8g5sxjo.f[11]++;cov_ry8g5sxjo.s[21]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_67" /* SETTINGS_COMPANY_FETCH_RESET */],error:error};};cov_ry8g5sxjo.s[22]++;var settingsCompanyFetch=function settingsCompanyFetch(){cov_ry8g5sxjo.f[12]++;cov_ry8g5sxjo.s[23]++;return function(dispatch){cov_ry8g5sxjo.f[13]++;cov_ry8g5sxjo.s[24]++;dispatch(settingsCompanyFetchStart());cov_ry8g5sxjo.s[25]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/settings').then(function(response){cov_ry8g5sxjo.f[14]++;cov_ry8g5sxjo.s[26]++;dispatch(settingsCompanyFetchSuccess(response.data));}).catch(function(error){cov_ry8g5sxjo.f[15]++;cov_ry8g5sxjo.s[27]++;if((cov_ry8g5sxjo.b[1][0]++,error.length)&&(cov_ry8g5sxjo.b[1][1]++,error.length===1)){cov_ry8g5sxjo.b[0][0]++;cov_ry8g5sxjo.s[28]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"company",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_ry8g5sxjo.b[0][1]++;cov_ry8g5sxjo.s[29]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"company",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_ry8g5sxjo.s[30]++;dispatch(settingsCompanyFetchFail(error));});};};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorJobsFetchStart */
/* unused harmony export calculatorJobsFetchSuccess */
/* unused harmony export calculatorJobsFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorJobsFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_3nh9zdikr=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\jobs.js',hash='5e0f93eb46480eb85ffb3347fc55f103d073a546',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\jobs.js',statementMap:{'0':{start:{line:4,column:40},end:{line:9,column:1}},'1':{start:{line:5,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:42},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:39},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:35},end:{line:58,column:1}},'7':{start:{line:26,column:4},end:{line:57,column:6}},'8':{start:{line:27,column:27},end:{line:27,column:29}},'9':{start:{line:28,column:32},end:{line:28,column:34}},'10':{start:{line:29,column:23},end:{line:29,column:28}},'11':{start:{line:30,column:8},end:{line:32,column:9}},'12':{start:{line:31,column:12},end:{line:31,column:72}},'13':{start:{line:33,column:8},end:{line:35,column:9}},'14':{start:{line:34,column:12},end:{line:34,column:72}},'15':{start:{line:36,column:8},end:{line:38,column:9}},'16':{start:{line:37,column:12},end:{line:37,column:68}},'17':{start:{line:39,column:8},end:{line:42,column:9}},'18':{start:{line:40,column:12},end:{line:40,column:61}},'19':{start:{line:41,column:12},end:{line:41,column:28}},'20':{start:{line:43,column:8},end:{line:43,column:53}},'21':{start:{line:44,column:8},end:{line:56,column:16}},'22':{start:{line:46,column:16},end:{line:46,column:76}},'23':{start:{line:49,column:16},end:{line:54,column:17}},'24':{start:{line:50,column:20},end:{line:50,column:158}},'25':{start:{line:53,column:20},end:{line:53,column:199}},'26':{start:{line:55,column:16},end:{line:55,column:61}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:40},end:{line:4,column:41}},loc:{start:{line:4,column:62},end:{line:9,column:1}},line:4},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:42},end:{line:11,column:43}},loc:{start:{line:11,column:52},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:39},end:{line:18,column:40}},loc:{start:{line:18,column:52},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:35},end:{line:25,column:36}},loc:{start:{line:25,column:56},end:{line:58,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:26,column:11},end:{line:26,column:12}},loc:{start:{line:26,column:23},end:{line:57,column:5}},line:26},'5':{name:'(anonymous_5)',decl:{start:{line:45,column:19},end:{line:45,column:20}},loc:{start:{line:45,column:31},end:{line:47,column:13}},line:45},'6':{name:'(anonymous_6)',decl:{start:{line:48,column:20},end:{line:48,column:21}},loc:{start:{line:48,column:29},end:{line:56,column:13}},line:48}},branchMap:{'0':{loc:{start:{line:4,column:41},end:{line:4,column:57}},type:'default-arg',locations:[{start:{line:4,column:52},end:{line:4,column:57}}],line:4},'1':{loc:{start:{line:25,column:36},end:{line:25,column:51}},type:'default-arg',locations:[{start:{line:25,column:49},end:{line:25,column:51}}],line:25},'2':{loc:{start:{line:30,column:8},end:{line:32,column:9}},type:'if',locations:[{start:{line:30,column:8},end:{line:32,column:9}},{start:{line:30,column:8},end:{line:32,column:9}}],line:30},'3':{loc:{start:{line:33,column:8},end:{line:35,column:9}},type:'if',locations:[{start:{line:33,column:8},end:{line:35,column:9}},{start:{line:33,column:8},end:{line:35,column:9}}],line:33},'4':{loc:{start:{line:36,column:8},end:{line:38,column:9}},type:'if',locations:[{start:{line:36,column:8},end:{line:38,column:9}},{start:{line:36,column:8},end:{line:38,column:9}}],line:36},'5':{loc:{start:{line:39,column:8},end:{line:42,column:9}},type:'if',locations:[{start:{line:39,column:8},end:{line:42,column:9}},{start:{line:39,column:8},end:{line:42,column:9}}],line:39},'6':{loc:{start:{line:49,column:16},end:{line:54,column:17}},type:'if',locations:[{start:{line:49,column:16},end:{line:54,column:17}},{start:{line:49,column:16},end:{line:54,column:17}}],line:49},'7':{loc:{start:{line:49,column:19},end:{line:49,column:53}},type:'binary-expr',locations:[{start:{line:49,column:19},end:{line:49,column:31}},{start:{line:49,column:35},end:{line:49,column:53}}],line:49}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0],'1':[0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_3nh9zdikr.s[0]++;var calculatorJobsFetchStart=function calculatorJobsFetchStart(){var searched=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_3nh9zdikr.b[0][0]++,false);cov_3nh9zdikr.f[0]++;cov_3nh9zdikr.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["r" /* CALCULATOR_JOBS_FETCH_START */],searched:searched};};cov_3nh9zdikr.s[2]++;var calculatorJobsFetchSuccess=function calculatorJobsFetchSuccess(jobs){cov_3nh9zdikr.f[1]++;cov_3nh9zdikr.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["s" /* CALCULATOR_JOBS_FETCH_SUCCESS */],jobs:jobs};};cov_3nh9zdikr.s[4]++;var calculatorJobsFetchFail=function calculatorJobsFetchFail(error){cov_3nh9zdikr.f[2]++;cov_3nh9zdikr.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["q" /* CALCULATOR_JOBS_FETCH_FAIL */],error:error};};cov_3nh9zdikr.s[6]++;var calculatorJobsFetch=function calculatorJobsFetch(){var searchData=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(cov_3nh9zdikr.b[1][0]++,{});cov_3nh9zdikr.f[3]++;cov_3nh9zdikr.s[7]++;return function(dispatch){cov_3nh9zdikr.f[4]++;var searchParams=(cov_3nh9zdikr.s[8]++,"");var searchParamsArray=(cov_3nh9zdikr.s[9]++,[]);var searched=(cov_3nh9zdikr.s[10]++,false);cov_3nh9zdikr.s[11]++;if(searchData.searchText){cov_3nh9zdikr.b[2][0]++;cov_3nh9zdikr.s[12]++;searchParamsArray.push("searchText="+searchData.searchText);}else{cov_3nh9zdikr.b[2][1]++;}cov_3nh9zdikr.s[13]++;if(searchData.start_date){cov_3nh9zdikr.b[3][0]++;cov_3nh9zdikr.s[14]++;searchParamsArray.push("start_date="+searchData.start_date);}else{cov_3nh9zdikr.b[3][1]++;}cov_3nh9zdikr.s[15]++;if(searchData.end_date){cov_3nh9zdikr.b[4][0]++;cov_3nh9zdikr.s[16]++;searchParamsArray.push("end_date="+searchData.end_date);}else{cov_3nh9zdikr.b[4][1]++;}cov_3nh9zdikr.s[17]++;if(searchParamsArray.length){cov_3nh9zdikr.b[5][0]++;cov_3nh9zdikr.s[18]++;searchParams='?'+searchParamsArray.join('&');cov_3nh9zdikr.s[19]++;searched=true;}else{cov_3nh9zdikr.b[5][1]++;}cov_3nh9zdikr.s[20]++;dispatch(calculatorJobsFetchStart(searched));cov_3nh9zdikr.s[21]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs'+searchParams).then(function(response){cov_3nh9zdikr.f[5]++;cov_3nh9zdikr.s[22]++;dispatch(calculatorJobsFetchSuccess(response.data.list));}).catch(function(error){cov_3nh9zdikr.f[6]++;cov_3nh9zdikr.s[23]++;if((cov_3nh9zdikr.b[7][0]++,error.length)&&(cov_3nh9zdikr.b[7][1]++,error.length===1)){cov_3nh9zdikr.b[6][0]++;cov_3nh9zdikr.s[24]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"jobs",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_3nh9zdikr.b[6][1]++;cov_3nh9zdikr.s[25]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"jobs",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_3nh9zdikr.s[26]++;dispatch(calculatorJobsFetchFail(error));});};};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorJobsDefaultsUpdateStart */
/* unused harmony export calculatorJobsDefaultsUpdateSuccess */
/* unused harmony export calculatorJobsDefaultsUpdateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculatorJobsDefaultsUpdateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculatorJobsDefaultsUpdate; });
/* unused harmony export calculatorJobsDefaultsFetchStart */
/* unused harmony export calculatorJobsDefaultsFetchSuccess */
/* unused harmony export calculatorJobsDefaultsFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorJobsDefaultsFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_9nruqo17u=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\defaults.js',hash='230903a4028115d3fbe206bd308d634812a935f4',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\defaults.js',statementMap:{'0':{start:{line:5,column:49},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:51},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:48},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:49},end:{line:29,column:1}},'7':{start:{line:26,column:4},end:{line:28,column:6}},'8':{start:{line:31,column:44},end:{line:42,column:1}},'9':{start:{line:32,column:4},end:{line:41,column:6}},'10':{start:{line:33,column:8},end:{line:33,column:54}},'11':{start:{line:34,column:8},end:{line:40,column:16}},'12':{start:{line:36,column:16},end:{line:36,column:81}},'13':{start:{line:39,column:16},end:{line:39,column:70}},'14':{start:{line:45,column:48},end:{line:49,column:1}},'15':{start:{line:46,column:4},end:{line:48,column:6}},'16':{start:{line:51,column:50},end:{line:56,column:1}},'17':{start:{line:52,column:4},end:{line:55,column:6}},'18':{start:{line:58,column:47},end:{line:62,column:1}},'19':{start:{line:59,column:4},end:{line:61,column:6}},'20':{start:{line:64,column:43},end:{line:81,column:1}},'21':{start:{line:65,column:4},end:{line:80,column:6}},'22':{start:{line:66,column:8},end:{line:66,column:53}},'23':{start:{line:67,column:8},end:{line:79,column:16}},'24':{start:{line:69,column:16},end:{line:69,column:80}},'25':{start:{line:72,column:16},end:{line:77,column:17}},'26':{start:{line:73,column:20},end:{line:73,column:165}},'27':{start:{line:76,column:20},end:{line:76,column:206}},'28':{start:{line:78,column:16},end:{line:78,column:69}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:49},end:{line:5,column:50}},loc:{start:{line:5,column:55},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:51},end:{line:11,column:52}},loc:{start:{line:11,column:65},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:48},end:{line:18,column:49}},loc:{start:{line:18,column:61},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:49},end:{line:25,column:50}},loc:{start:{line:25,column:56},end:{line:29,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:31,column:44},end:{line:31,column:45}},loc:{start:{line:31,column:58},end:{line:42,column:1}},line:31},'5':{name:'(anonymous_5)',decl:{start:{line:32,column:11},end:{line:32,column:12}},loc:{start:{line:32,column:23},end:{line:41,column:5}},line:32},'6':{name:'(anonymous_6)',decl:{start:{line:35,column:19},end:{line:35,column:20}},loc:{start:{line:35,column:31},end:{line:37,column:13}},line:35},'7':{name:'(anonymous_7)',decl:{start:{line:38,column:20},end:{line:38,column:21}},loc:{start:{line:38,column:29},end:{line:40,column:13}},line:38},'8':{name:'(anonymous_8)',decl:{start:{line:45,column:48},end:{line:45,column:49}},loc:{start:{line:45,column:54},end:{line:49,column:1}},line:45},'9':{name:'(anonymous_9)',decl:{start:{line:51,column:50},end:{line:51,column:51}},loc:{start:{line:51,column:64},end:{line:56,column:1}},line:51},'10':{name:'(anonymous_10)',decl:{start:{line:58,column:47},end:{line:58,column:48}},loc:{start:{line:58,column:54},end:{line:62,column:1}},line:58},'11':{name:'(anonymous_11)',decl:{start:{line:64,column:43},end:{line:64,column:44}},loc:{start:{line:64,column:49},end:{line:81,column:1}},line:64},'12':{name:'(anonymous_12)',decl:{start:{line:65,column:11},end:{line:65,column:12}},loc:{start:{line:65,column:23},end:{line:80,column:5}},line:65},'13':{name:'(anonymous_13)',decl:{start:{line:68,column:19},end:{line:68,column:20}},loc:{start:{line:68,column:31},end:{line:70,column:13}},line:68},'14':{name:'(anonymous_14)',decl:{start:{line:71,column:20},end:{line:71,column:21}},loc:{start:{line:71,column:29},end:{line:79,column:13}},line:71}},branchMap:{'0':{loc:{start:{line:72,column:16},end:{line:77,column:17}},type:'if',locations:[{start:{line:72,column:16},end:{line:77,column:17}},{start:{line:72,column:16},end:{line:77,column:17}}],line:72},'1':{loc:{start:{line:72,column:19},end:{line:72,column:53}},type:'binary-expr',locations:[{start:{line:72,column:19},end:{line:72,column:31}},{start:{line:72,column:35},end:{line:72,column:53}}],line:72}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Defaults Update ------------------- */cov_9nruqo17u.s[0]++;var calculatorJobsDefaultsUpdateStart=function calculatorJobsDefaultsUpdateStart(){cov_9nruqo17u.f[0]++;cov_9nruqo17u.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["o" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_START */]};};cov_9nruqo17u.s[2]++;var calculatorJobsDefaultsUpdateSuccess=function calculatorJobsDefaultsUpdateSuccess(defaults){cov_9nruqo17u.f[1]++;cov_9nruqo17u.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["p" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_SUCCESS */],defaults:defaults};};cov_9nruqo17u.s[4]++;var calculatorJobsDefaultsUpdateFail=function calculatorJobsDefaultsUpdateFail(error){cov_9nruqo17u.f[2]++;cov_9nruqo17u.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["m" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_FAIL */],error:error};};cov_9nruqo17u.s[6]++;var calculatorJobsDefaultsUpdateReset=function calculatorJobsDefaultsUpdateReset(){cov_9nruqo17u.f[3]++;cov_9nruqo17u.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["n" /* CALCULATOR_JOBS_DEFAULTS_UPDATE_RESET */]};};cov_9nruqo17u.s[8]++;var calculatorJobsDefaultsUpdate=function calculatorJobsDefaultsUpdate(formData){cov_9nruqo17u.f[4]++;cov_9nruqo17u.s[9]++;return function(dispatch){cov_9nruqo17u.f[5]++;cov_9nruqo17u.s[10]++;dispatch(calculatorJobsDefaultsUpdateStart());cov_9nruqo17u.s[11]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/jobs/defaults',formData).then(function(response){cov_9nruqo17u.f[6]++;cov_9nruqo17u.s[12]++;dispatch(calculatorJobsDefaultsUpdateSuccess(response.data));}).catch(function(error){cov_9nruqo17u.f[7]++;cov_9nruqo17u.s[13]++;dispatch(calculatorJobsDefaultsUpdateFail(error));});};};/* ------------------ Defaults Fetch ------------------- */cov_9nruqo17u.s[14]++;var calculatorJobsDefaultsFetchStart=function calculatorJobsDefaultsFetchStart(){cov_9nruqo17u.f[8]++;cov_9nruqo17u.s[15]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["k" /* CALCULATOR_JOBS_DEFAULTS_FETCH_START */]};};cov_9nruqo17u.s[16]++;var calculatorJobsDefaultsFetchSuccess=function calculatorJobsDefaultsFetchSuccess(defaults){cov_9nruqo17u.f[9]++;cov_9nruqo17u.s[17]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* CALCULATOR_JOBS_DEFAULTS_FETCH_SUCCESS */],defaults:defaults};};cov_9nruqo17u.s[18]++;var calculatorJobsDefaultsFetchFail=function calculatorJobsDefaultsFetchFail(){cov_9nruqo17u.f[10]++;cov_9nruqo17u.s[19]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["j" /* CALCULATOR_JOBS_DEFAULTS_FETCH_FAIL */]};};cov_9nruqo17u.s[20]++;var calculatorJobsDefaultsFetch=function calculatorJobsDefaultsFetch(){cov_9nruqo17u.f[11]++;cov_9nruqo17u.s[21]++;return function(dispatch){cov_9nruqo17u.f[12]++;cov_9nruqo17u.s[22]++;dispatch(calculatorJobsDefaultsFetchStart());cov_9nruqo17u.s[23]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/defaults').then(function(response){cov_9nruqo17u.f[13]++;cov_9nruqo17u.s[24]++;dispatch(calculatorJobsDefaultsFetchSuccess(response.data));}).catch(function(error){cov_9nruqo17u.f[14]++;cov_9nruqo17u.s[25]++;if((cov_9nruqo17u.b[1][0]++,error.length)&&(cov_9nruqo17u.b[1][1]++,error.length===1)){cov_9nruqo17u.b[0][0]++;cov_9nruqo17u.s[26]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"jobdefaults",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_9nruqo17u.b[0][1]++;cov_9nruqo17u.s[27]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"jobdefaults",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_9nruqo17u.s[28]++;dispatch(calculatorJobsDefaultsFetchFail(error));});};};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorJobCreateStart */
/* unused harmony export calculatorJobCreateSuccess */
/* unused harmony export calculatorJobCreateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return calculatorJobCreateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return calculatorJobCreate; });
/* unused harmony export calculatorJobDuplicateCheckSuccess */
/* unused harmony export calculatorJobDuplicateCheckFail */
/* unused harmony export calculatorJobDuplicateCheckStart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return calculatorJobDuplicateCheckReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return calculatorJobDuplicateCheck; });
/* unused harmony export calculatorJobFetchStart */
/* unused harmony export calculatorJobFetchSuccess */
/* unused harmony export calculatorJobFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return calculatorJobFetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return calculatorJobFetch; });
/* unused harmony export calculatorJobMessageSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return calculatorJobMessageReset; });
/* unused harmony export calculatorJobMachineFetchStart */
/* unused harmony export calculatorJobMachineFetchSuccess */
/* unused harmony export calculatorJobMachineFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return calculatorJobMachineFetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return calculatorJobMachineFetch; });
/* unused harmony export calculatorJobCalculationsFetchStart */
/* unused harmony export calculatorJobCalculationsFetchSuccess */
/* unused harmony export calculatorJobCalculationsFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculatorJobCalculationsFetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorJobCalculationsFetch; });
/* unused harmony export calculatorJobExportFetchStart */
/* unused harmony export calculatorJobExportFetchSuccess */
/* unused harmony export calculatorJobExportFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return calculatorJobExportFetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return calculatorJobExportFetch; });
/* unused harmony export calculatorJobUpdateStart */
/* unused harmony export calculatorJobUpdateSuccess */
/* unused harmony export calculatorJobUpdateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return calculatorJobUpdateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return calculatorJobUpdate; });
/* unused harmony export calculatorJobMachineUpdateStart */
/* unused harmony export calculatorJobMachineUpdateSuccess */
/* unused harmony export calculatorJobMachineUpdateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return calculatorJobMachineUpdateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return calculatorJobMachineUpdate; });
/* unused harmony export calculatorJobDeleteStart */
/* unused harmony export calculatorJobDeleteSuccess */
/* unused harmony export calculatorJobDeleteFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return calculatorJobDeleteReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return calculatorJobDelete; });
/* unused harmony export calculatorJobChangeActiveStart */
/* unused harmony export calculatorJobChangeActiveSuccess */
/* unused harmony export calculatorJobChangeActiveFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calculatorJobChangeActiveReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculatorJobChangeActive; });
/* unused harmony export calculatorJobRecalculateStart */
/* unused harmony export calculatorJobRecalculateSuccess */
/* unused harmony export calculatorJobRecalculateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return calculatorJobRecalculateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return calculatorJobRecalculate; });
/* unused harmony export calculatorJobDetailedCalculationStart */
/* unused harmony export calculatorJobDetailedCalculationSuccess */
/* unused harmony export calculatorJobDetailedCalculationFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return calculatorJobDetailedCalculationReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return calculatorJobDetailedCalculation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_2bdijtr5u8=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\job.js',hash='da5371e3fc957fe0ee580d4d243f40eaf7d5366b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\jobs\\job.js',statementMap:{'0':{start:{line:5,column:40},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:42},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:39},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:40},end:{line:29,column:1}},'7':{start:{line:26,column:4},end:{line:28,column:6}},'8':{start:{line:31,column:35},end:{line:46,column:1}},'9':{start:{line:32,column:4},end:{line:45,column:6}},'10':{start:{line:33,column:8},end:{line:33,column:45}},'11':{start:{line:34,column:8},end:{line:44,column:16}},'12':{start:{line:36,column:16},end:{line:39,column:21}},'13':{start:{line:40,column:16},end:{line:40,column:72}},'14':{start:{line:43,column:16},end:{line:43,column:61}},'15':{start:{line:49,column:50},end:{line:54,column:1}},'16':{start:{line:50,column:4},end:{line:53,column:6}},'17':{start:{line:56,column:47},end:{line:61,column:1}},'18':{start:{line:57,column:4},end:{line:60,column:6}},'19':{start:{line:63,column:48},end:{line:67,column:1}},'20':{start:{line:64,column:4},end:{line:66,column:6}},'21':{start:{line:69,column:48},end:{line:73,column:1}},'22':{start:{line:70,column:4},end:{line:72,column:6}},'23':{start:{line:75,column:43},end:{line:90,column:1}},'24':{start:{line:76,column:4},end:{line:89,column:6}},'25':{start:{line:77,column:8},end:{line:77,column:53}},'26':{start:{line:78,column:25},end:{line:78,column:84}},'27':{start:{line:79,column:8},end:{line:81,column:9}},'28':{start:{line:80,column:12},end:{line:80,column:60}},'29':{start:{line:82,column:8},end:{line:88,column:16}},'30':{start:{line:84,column:16},end:{line:84,column:87}},'31':{start:{line:87,column:16},end:{line:87,column:69}},'32':{start:{line:93,column:39},end:{line:97,column:1}},'33':{start:{line:94,column:4},end:{line:96,column:6}},'34':{start:{line:99,column:41},end:{line:104,column:1}},'35':{start:{line:100,column:4},end:{line:103,column:6}},'36':{start:{line:106,column:38},end:{line:111,column:1}},'37':{start:{line:107,column:4},end:{line:110,column:6}},'38':{start:{line:113,column:39},end:{line:117,column:1}},'39':{start:{line:114,column:4},end:{line:116,column:6}},'40':{start:{line:119,column:34},end:{line:130,column:1}},'41':{start:{line:120,column:4},end:{line:129,column:6}},'42':{start:{line:121,column:8},end:{line:121,column:44}},'43':{start:{line:122,column:8},end:{line:128,column:16}},'44':{start:{line:124,column:16},end:{line:124,column:71}},'45':{start:{line:127,column:16},end:{line:127,column:60}},'46':{start:{line:132,column:39},end:{line:137,column:1}},'47':{start:{line:133,column:4},end:{line:136,column:6}},'48':{start:{line:138,column:41},end:{line:142,column:1}},'49':{start:{line:139,column:4},end:{line:141,column:6}},'50':{start:{line:145,column:46},end:{line:149,column:1}},'51':{start:{line:146,column:4},end:{line:148,column:6}},'52':{start:{line:151,column:48},end:{line:156,column:1}},'53':{start:{line:152,column:4},end:{line:155,column:6}},'54':{start:{line:158,column:45},end:{line:163,column:1}},'55':{start:{line:159,column:4},end:{line:162,column:6}},'56':{start:{line:165,column:46},end:{line:169,column:1}},'57':{start:{line:166,column:4},end:{line:168,column:6}},'58':{start:{line:171,column:41},end:{line:182,column:1}},'59':{start:{line:172,column:4},end:{line:181,column:6}},'60':{start:{line:173,column:8},end:{line:173,column:51}},'61':{start:{line:174,column:8},end:{line:180,column:16}},'62':{start:{line:176,column:16},end:{line:176,column:78}},'63':{start:{line:179,column:16},end:{line:179,column:67}},'64':{start:{line:185,column:51},end:{line:189,column:1}},'65':{start:{line:186,column:4},end:{line:188,column:6}},'66':{start:{line:191,column:53},end:{line:196,column:1}},'67':{start:{line:192,column:4},end:{line:195,column:6}},'68':{start:{line:198,column:50},end:{line:203,column:1}},'69':{start:{line:199,column:4},end:{line:202,column:6}},'70':{start:{line:205,column:51},end:{line:209,column:1}},'71':{start:{line:206,column:4},end:{line:208,column:6}},'72':{start:{line:211,column:46},end:{line:222,column:1}},'73':{start:{line:212,column:4},end:{line:221,column:6}},'74':{start:{line:213,column:8},end:{line:213,column:56}},'75':{start:{line:214,column:8},end:{line:220,column:16}},'76':{start:{line:216,column:16},end:{line:216,column:88}},'77':{start:{line:219,column:16},end:{line:219,column:72}},'78':{start:{line:225,column:45},end:{line:229,column:1}},'79':{start:{line:226,column:4},end:{line:228,column:6}},'80':{start:{line:231,column:47},end:{line:237,column:1}},'81':{start:{line:232,column:4},end:{line:236,column:6}},'82':{start:{line:239,column:44},end:{line:244,column:1}},'83':{start:{line:240,column:4},end:{line:243,column:6}},'84':{start:{line:246,column:45},end:{line:250,column:1}},'85':{start:{line:247,column:4},end:{line:249,column:6}},'86':{start:{line:252,column:40},end:{line:275,column:1}},'87':{start:{line:253,column:4},end:{line:274,column:6}},'88':{start:{line:254,column:8},end:{line:254,column:50}},'89':{start:{line:255,column:8},end:{line:273,column:16}},'90':{start:{line:263,column:16},end:{line:263,column:109}},'91':{start:{line:266,column:16},end:{line:271,column:17}},'92':{start:{line:267,column:20},end:{line:267,column:157}},'93':{start:{line:270,column:20},end:{line:270,column:198}},'94':{start:{line:272,column:16},end:{line:272,column:66}},'95':{start:{line:278,column:40},end:{line:282,column:1}},'96':{start:{line:279,column:4},end:{line:281,column:6}},'97':{start:{line:284,column:42},end:{line:289,column:1}},'98':{start:{line:285,column:4},end:{line:288,column:6}},'99':{start:{line:291,column:39},end:{line:296,column:1}},'100':{start:{line:292,column:4},end:{line:295,column:6}},'101':{start:{line:298,column:40},end:{line:302,column:1}},'102':{start:{line:299,column:4},end:{line:301,column:6}},'103':{start:{line:304,column:35},end:{line:315,column:1}},'104':{start:{line:305,column:4},end:{line:314,column:6}},'105':{start:{line:306,column:8},end:{line:306,column:45}},'106':{start:{line:307,column:8},end:{line:313,column:16}},'107':{start:{line:309,column:16},end:{line:309,column:72}},'108':{start:{line:312,column:16},end:{line:312,column:61}},'109':{start:{line:318,column:47},end:{line:322,column:1}},'110':{start:{line:319,column:4},end:{line:321,column:6}},'111':{start:{line:324,column:49},end:{line:329,column:1}},'112':{start:{line:325,column:4},end:{line:328,column:6}},'113':{start:{line:331,column:46},end:{line:336,column:1}},'114':{start:{line:332,column:4},end:{line:335,column:6}},'115':{start:{line:338,column:47},end:{line:342,column:1}},'116':{start:{line:339,column:4},end:{line:341,column:6}},'117':{start:{line:344,column:42},end:{line:355,column:1}},'118':{start:{line:345,column:4},end:{line:354,column:6}},'119':{start:{line:346,column:8},end:{line:346,column:52}},'120':{start:{line:347,column:8},end:{line:353,column:16}},'121':{start:{line:349,column:16},end:{line:349,column:79}},'122':{start:{line:352,column:16},end:{line:352,column:68}},'123':{start:{line:358,column:40},end:{line:362,column:1}},'124':{start:{line:359,column:4},end:{line:361,column:6}},'125':{start:{line:364,column:42},end:{line:368,column:1}},'126':{start:{line:365,column:4},end:{line:367,column:6}},'127':{start:{line:370,column:39},end:{line:375,column:1}},'128':{start:{line:371,column:4},end:{line:374,column:6}},'129':{start:{line:377,column:40},end:{line:381,column:1}},'130':{start:{line:378,column:4},end:{line:380,column:6}},'131':{start:{line:383,column:35},end:{line:404,column:1}},'132':{start:{line:384,column:4},end:{line:403,column:6}},'133':{start:{line:385,column:8},end:{line:385,column:45}},'134':{start:{line:386,column:8},end:{line:402,column:16}},'135':{start:{line:388,column:16},end:{line:391,column:21}},'136':{start:{line:392,column:16},end:{line:392,column:58}},'137':{start:{line:395,column:16},end:{line:400,column:17}},'138':{start:{line:396,column:20},end:{line:396,column:157}},'139':{start:{line:399,column:20},end:{line:399,column:198}},'140':{start:{line:401,column:16},end:{line:401,column:61}},'141':{start:{line:407,column:46},end:{line:411,column:1}},'142':{start:{line:408,column:4},end:{line:410,column:6}},'143':{start:{line:413,column:48},end:{line:417,column:1}},'144':{start:{line:414,column:4},end:{line:416,column:6}},'145':{start:{line:419,column:45},end:{line:424,column:1}},'146':{start:{line:420,column:4},end:{line:423,column:6}},'147':{start:{line:426,column:46},end:{line:430,column:1}},'148':{start:{line:427,column:4},end:{line:429,column:6}},'149':{start:{line:432,column:41},end:{line:453,column:1}},'150':{start:{line:433,column:4},end:{line:452,column:6}},'151':{start:{line:434,column:8},end:{line:434,column:51}},'152':{start:{line:435,column:8},end:{line:451,column:16}},'153':{start:{line:437,column:16},end:{line:440,column:21}},'154':{start:{line:441,column:16},end:{line:441,column:64}},'155':{start:{line:444,column:16},end:{line:449,column:17}},'156':{start:{line:445,column:20},end:{line:445,column:157}},'157':{start:{line:448,column:20},end:{line:448,column:198}},'158':{start:{line:450,column:16},end:{line:450,column:67}},'159':{start:{line:456,column:45},end:{line:460,column:1}},'160':{start:{line:457,column:4},end:{line:459,column:6}},'161':{start:{line:462,column:47},end:{line:466,column:1}},'162':{start:{line:463,column:4},end:{line:465,column:6}},'163':{start:{line:468,column:44},end:{line:473,column:1}},'164':{start:{line:469,column:4},end:{line:472,column:6}},'165':{start:{line:475,column:45},end:{line:479,column:1}},'166':{start:{line:476,column:4},end:{line:478,column:6}},'167':{start:{line:481,column:40},end:{line:502,column:1}},'168':{start:{line:482,column:4},end:{line:501,column:6}},'169':{start:{line:483,column:8},end:{line:483,column:50}},'170':{start:{line:484,column:8},end:{line:500,column:16}},'171':{start:{line:486,column:16},end:{line:489,column:21}},'172':{start:{line:490,column:16},end:{line:490,column:63}},'173':{start:{line:493,column:16},end:{line:498,column:17}},'174':{start:{line:494,column:20},end:{line:494,column:157}},'175':{start:{line:497,column:20},end:{line:497,column:198}},'176':{start:{line:499,column:16},end:{line:499,column:66}},'177':{start:{line:505,column:53},end:{line:509,column:1}},'178':{start:{line:506,column:4},end:{line:508,column:6}},'179':{start:{line:511,column:55},end:{line:516,column:1}},'180':{start:{line:512,column:4},end:{line:515,column:6}},'181':{start:{line:518,column:52},end:{line:523,column:1}},'182':{start:{line:519,column:4},end:{line:522,column:6}},'183':{start:{line:525,column:53},end:{line:529,column:1}},'184':{start:{line:526,column:4},end:{line:528,column:6}},'185':{start:{line:531,column:48},end:{line:548,column:1}},'186':{start:{line:532,column:4},end:{line:547,column:6}},'187':{start:{line:533,column:8},end:{line:533,column:58}},'188':{start:{line:534,column:8},end:{line:546,column:16}},'189':{start:{line:536,column:16},end:{line:536,column:85}},'190':{start:{line:539,column:16},end:{line:544,column:17}},'191':{start:{line:540,column:20},end:{line:540,column:157}},'192':{start:{line:543,column:20},end:{line:543,column:198}},'193':{start:{line:545,column:16},end:{line:545,column:74}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:40},end:{line:5,column:41}},loc:{start:{line:5,column:46},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:42},end:{line:11,column:43}},loc:{start:{line:11,column:55},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:39},end:{line:18,column:40}},loc:{start:{line:18,column:52},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:40},end:{line:25,column:41}},loc:{start:{line:25,column:47},end:{line:29,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:31,column:35},end:{line:31,column:36}},loc:{start:{line:31,column:49},end:{line:46,column:1}},line:31},'5':{name:'(anonymous_5)',decl:{start:{line:32,column:11},end:{line:32,column:12}},loc:{start:{line:32,column:23},end:{line:45,column:5}},line:32},'6':{name:'(anonymous_6)',decl:{start:{line:35,column:19},end:{line:35,column:20}},loc:{start:{line:35,column:31},end:{line:41,column:13}},line:35},'7':{name:'(anonymous_7)',decl:{start:{line:42,column:20},end:{line:42,column:21}},loc:{start:{line:42,column:29},end:{line:44,column:13}},line:42},'8':{name:'(anonymous_8)',decl:{start:{line:49,column:50},end:{line:49,column:51}},loc:{start:{line:49,column:72},end:{line:54,column:1}},line:49},'9':{name:'(anonymous_9)',decl:{start:{line:56,column:47},end:{line:56,column:48}},loc:{start:{line:56,column:60},end:{line:61,column:1}},line:56},'10':{name:'(anonymous_10)',decl:{start:{line:63,column:48},end:{line:63,column:49}},loc:{start:{line:63,column:54},end:{line:67,column:1}},line:63},'11':{name:'(anonymous_11)',decl:{start:{line:69,column:48},end:{line:69,column:49}},loc:{start:{line:69,column:54},end:{line:73,column:1}},line:69},'12':{name:'(anonymous_12)',decl:{start:{line:75,column:43},end:{line:75,column:44}},loc:{start:{line:75,column:57},end:{line:90,column:1}},line:75},'13':{name:'(anonymous_13)',decl:{start:{line:76,column:11},end:{line:76,column:12}},loc:{start:{line:76,column:23},end:{line:89,column:5}},line:76},'14':{name:'(anonymous_14)',decl:{start:{line:83,column:19},end:{line:83,column:20}},loc:{start:{line:83,column:31},end:{line:85,column:13}},line:83},'15':{name:'(anonymous_15)',decl:{start:{line:86,column:20},end:{line:86,column:21}},loc:{start:{line:86,column:29},end:{line:88,column:13}},line:86},'16':{name:'(anonymous_16)',decl:{start:{line:93,column:39},end:{line:93,column:40}},loc:{start:{line:93,column:45},end:{line:97,column:1}},line:93},'17':{name:'(anonymous_17)',decl:{start:{line:99,column:41},end:{line:99,column:42}},loc:{start:{line:99,column:54},end:{line:104,column:1}},line:99},'18':{name:'(anonymous_18)',decl:{start:{line:106,column:38},end:{line:106,column:39}},loc:{start:{line:106,column:51},end:{line:111,column:1}},line:106},'19':{name:'(anonymous_19)',decl:{start:{line:113,column:39},end:{line:113,column:40}},loc:{start:{line:113,column:46},end:{line:117,column:1}},line:113},'20':{name:'(anonymous_20)',decl:{start:{line:119,column:34},end:{line:119,column:35}},loc:{start:{line:119,column:42},end:{line:130,column:1}},line:119},'21':{name:'(anonymous_21)',decl:{start:{line:120,column:11},end:{line:120,column:12}},loc:{start:{line:120,column:23},end:{line:129,column:5}},line:120},'22':{name:'(anonymous_22)',decl:{start:{line:123,column:19},end:{line:123,column:20}},loc:{start:{line:123,column:31},end:{line:125,column:13}},line:123},'23':{name:'(anonymous_23)',decl:{start:{line:126,column:20},end:{line:126,column:21}},loc:{start:{line:126,column:29},end:{line:128,column:13}},line:126},'24':{name:'(anonymous_24)',decl:{start:{line:132,column:39},end:{line:132,column:40}},loc:{start:{line:132,column:54},end:{line:137,column:1}},line:132},'25':{name:'(anonymous_25)',decl:{start:{line:138,column:41},end:{line:138,column:42}},loc:{start:{line:138,column:48},end:{line:142,column:1}},line:138},'26':{name:'(anonymous_26)',decl:{start:{line:145,column:46},end:{line:145,column:47}},loc:{start:{line:145,column:52},end:{line:149,column:1}},line:145},'27':{name:'(anonymous_27)',decl:{start:{line:151,column:48},end:{line:151,column:49}},loc:{start:{line:151,column:61},end:{line:156,column:1}},line:151},'28':{name:'(anonymous_28)',decl:{start:{line:158,column:45},end:{line:158,column:46}},loc:{start:{line:158,column:58},end:{line:163,column:1}},line:158},'29':{name:'(anonymous_29)',decl:{start:{line:165,column:46},end:{line:165,column:47}},loc:{start:{line:165,column:53},end:{line:169,column:1}},line:165},'30':{name:'(anonymous_30)',decl:{start:{line:171,column:41},end:{line:171,column:42}},loc:{start:{line:171,column:49},end:{line:182,column:1}},line:171},'31':{name:'(anonymous_31)',decl:{start:{line:172,column:11},end:{line:172,column:12}},loc:{start:{line:172,column:23},end:{line:181,column:5}},line:172},'32':{name:'(anonymous_32)',decl:{start:{line:175,column:19},end:{line:175,column:20}},loc:{start:{line:175,column:31},end:{line:177,column:13}},line:175},'33':{name:'(anonymous_33)',decl:{start:{line:178,column:20},end:{line:178,column:21}},loc:{start:{line:178,column:29},end:{line:180,column:13}},line:178},'34':{name:'(anonymous_34)',decl:{start:{line:185,column:51},end:{line:185,column:52}},loc:{start:{line:185,column:57},end:{line:189,column:1}},line:185},'35':{name:'(anonymous_35)',decl:{start:{line:191,column:53},end:{line:191,column:54}},loc:{start:{line:191,column:66},end:{line:196,column:1}},line:191},'36':{name:'(anonymous_36)',decl:{start:{line:198,column:50},end:{line:198,column:51}},loc:{start:{line:198,column:63},end:{line:203,column:1}},line:198},'37':{name:'(anonymous_37)',decl:{start:{line:205,column:51},end:{line:205,column:52}},loc:{start:{line:205,column:58},end:{line:209,column:1}},line:205},'38':{name:'(anonymous_38)',decl:{start:{line:211,column:46},end:{line:211,column:47}},loc:{start:{line:211,column:54},end:{line:222,column:1}},line:211},'39':{name:'(anonymous_39)',decl:{start:{line:212,column:11},end:{line:212,column:12}},loc:{start:{line:212,column:23},end:{line:221,column:5}},line:212},'40':{name:'(anonymous_40)',decl:{start:{line:215,column:19},end:{line:215,column:20}},loc:{start:{line:215,column:31},end:{line:217,column:13}},line:215},'41':{name:'(anonymous_41)',decl:{start:{line:218,column:20},end:{line:218,column:21}},loc:{start:{line:218,column:29},end:{line:220,column:13}},line:218},'42':{name:'(anonymous_42)',decl:{start:{line:225,column:45},end:{line:225,column:46}},loc:{start:{line:225,column:51},end:{line:229,column:1}},line:225},'43':{name:'(anonymous_43)',decl:{start:{line:231,column:47},end:{line:231,column:48}},loc:{start:{line:231,column:70},end:{line:237,column:1}},line:231},'44':{name:'(anonymous_44)',decl:{start:{line:239,column:44},end:{line:239,column:45}},loc:{start:{line:239,column:57},end:{line:244,column:1}},line:239},'45':{name:'(anonymous_45)',decl:{start:{line:246,column:45},end:{line:246,column:46}},loc:{start:{line:246,column:52},end:{line:250,column:1}},line:246},'46':{name:'(anonymous_46)',decl:{start:{line:252,column:40},end:{line:252,column:41}},loc:{start:{line:252,column:71},end:{line:275,column:1}},line:252},'47':{name:'(anonymous_47)',decl:{start:{line:253,column:11},end:{line:253,column:12}},loc:{start:{line:253,column:23},end:{line:274,column:5}},line:253},'48':{name:'(anonymous_48)',decl:{start:{line:262,column:19},end:{line:262,column:20}},loc:{start:{line:262,column:31},end:{line:264,column:13}},line:262},'49':{name:'(anonymous_49)',decl:{start:{line:265,column:20},end:{line:265,column:21}},loc:{start:{line:265,column:29},end:{line:273,column:13}},line:265},'50':{name:'(anonymous_50)',decl:{start:{line:278,column:40},end:{line:278,column:41}},loc:{start:{line:278,column:46},end:{line:282,column:1}},line:278},'51':{name:'(anonymous_51)',decl:{start:{line:284,column:42},end:{line:284,column:43}},loc:{start:{line:284,column:55},end:{line:289,column:1}},line:284},'52':{name:'(anonymous_52)',decl:{start:{line:291,column:39},end:{line:291,column:40}},loc:{start:{line:291,column:52},end:{line:296,column:1}},line:291},'53':{name:'(anonymous_53)',decl:{start:{line:298,column:40},end:{line:298,column:41}},loc:{start:{line:298,column:47},end:{line:302,column:1}},line:298},'54':{name:'(anonymous_54)',decl:{start:{line:304,column:35},end:{line:304,column:36}},loc:{start:{line:304,column:53},end:{line:315,column:1}},line:304},'55':{name:'(anonymous_55)',decl:{start:{line:305,column:11},end:{line:305,column:12}},loc:{start:{line:305,column:23},end:{line:314,column:5}},line:305},'56':{name:'(anonymous_56)',decl:{start:{line:308,column:19},end:{line:308,column:20}},loc:{start:{line:308,column:31},end:{line:310,column:13}},line:308},'57':{name:'(anonymous_57)',decl:{start:{line:311,column:20},end:{line:311,column:21}},loc:{start:{line:311,column:29},end:{line:313,column:13}},line:311},'58':{name:'(anonymous_58)',decl:{start:{line:318,column:47},end:{line:318,column:48}},loc:{start:{line:318,column:53},end:{line:322,column:1}},line:318},'59':{name:'(anonymous_59)',decl:{start:{line:324,column:49},end:{line:324,column:50}},loc:{start:{line:324,column:63},end:{line:329,column:1}},line:324},'60':{name:'(anonymous_60)',decl:{start:{line:331,column:46},end:{line:331,column:47}},loc:{start:{line:331,column:59},end:{line:336,column:1}},line:331},'61':{name:'(anonymous_61)',decl:{start:{line:338,column:47},end:{line:338,column:48}},loc:{start:{line:338,column:54},end:{line:342,column:1}},line:338},'62':{name:'(anonymous_62)',decl:{start:{line:344,column:42},end:{line:344,column:43}},loc:{start:{line:344,column:60},end:{line:355,column:1}},line:344},'63':{name:'(anonymous_63)',decl:{start:{line:345,column:11},end:{line:345,column:12}},loc:{start:{line:345,column:23},end:{line:354,column:5}},line:345},'64':{name:'(anonymous_64)',decl:{start:{line:348,column:19},end:{line:348,column:20}},loc:{start:{line:348,column:31},end:{line:350,column:13}},line:348},'65':{name:'(anonymous_65)',decl:{start:{line:351,column:20},end:{line:351,column:21}},loc:{start:{line:351,column:29},end:{line:353,column:13}},line:351},'66':{name:'(anonymous_66)',decl:{start:{line:358,column:40},end:{line:358,column:41}},loc:{start:{line:358,column:47},end:{line:362,column:1}},line:358},'67':{name:'(anonymous_67)',decl:{start:{line:364,column:42},end:{line:364,column:43}},loc:{start:{line:364,column:49},end:{line:368,column:1}},line:364},'68':{name:'(anonymous_68)',decl:{start:{line:370,column:39},end:{line:370,column:40}},loc:{start:{line:370,column:52},end:{line:375,column:1}},line:370},'69':{name:'(anonymous_69)',decl:{start:{line:377,column:40},end:{line:377,column:41}},loc:{start:{line:377,column:47},end:{line:381,column:1}},line:377},'70':{name:'(anonymous_70)',decl:{start:{line:383,column:35},end:{line:383,column:36}},loc:{start:{line:383,column:53},end:{line:404,column:1}},line:383},'71':{name:'(anonymous_71)',decl:{start:{line:384,column:11},end:{line:384,column:12}},loc:{start:{line:384,column:23},end:{line:403,column:5}},line:384},'72':{name:'(anonymous_72)',decl:{start:{line:387,column:19},end:{line:387,column:20}},loc:{start:{line:387,column:31},end:{line:393,column:13}},line:387},'73':{name:'(anonymous_73)',decl:{start:{line:394,column:20},end:{line:394,column:21}},loc:{start:{line:394,column:29},end:{line:402,column:13}},line:394},'74':{name:'(anonymous_74)',decl:{start:{line:407,column:46},end:{line:407,column:47}},loc:{start:{line:407,column:53},end:{line:411,column:1}},line:407},'75':{name:'(anonymous_75)',decl:{start:{line:413,column:48},end:{line:413,column:49}},loc:{start:{line:413,column:55},end:{line:417,column:1}},line:413},'76':{name:'(anonymous_76)',decl:{start:{line:419,column:45},end:{line:419,column:46}},loc:{start:{line:419,column:58},end:{line:424,column:1}},line:419},'77':{name:'(anonymous_77)',decl:{start:{line:426,column:46},end:{line:426,column:47}},loc:{start:{line:426,column:53},end:{line:430,column:1}},line:426},'78':{name:'(anonymous_78)',decl:{start:{line:432,column:41},end:{line:432,column:42}},loc:{start:{line:432,column:59},end:{line:453,column:1}},line:432},'79':{name:'(anonymous_79)',decl:{start:{line:433,column:11},end:{line:433,column:12}},loc:{start:{line:433,column:23},end:{line:452,column:5}},line:433},'80':{name:'(anonymous_80)',decl:{start:{line:436,column:19},end:{line:436,column:20}},loc:{start:{line:436,column:31},end:{line:442,column:13}},line:436},'81':{name:'(anonymous_81)',decl:{start:{line:443,column:20},end:{line:443,column:21}},loc:{start:{line:443,column:29},end:{line:451,column:13}},line:443},'82':{name:'(anonymous_82)',decl:{start:{line:456,column:45},end:{line:456,column:46}},loc:{start:{line:456,column:52},end:{line:460,column:1}},line:456},'83':{name:'(anonymous_83)',decl:{start:{line:462,column:47},end:{line:462,column:48}},loc:{start:{line:462,column:54},end:{line:466,column:1}},line:462},'84':{name:'(anonymous_84)',decl:{start:{line:468,column:44},end:{line:468,column:45}},loc:{start:{line:468,column:57},end:{line:473,column:1}},line:468},'85':{name:'(anonymous_85)',decl:{start:{line:475,column:45},end:{line:475,column:46}},loc:{start:{line:475,column:52},end:{line:479,column:1}},line:475},'86':{name:'(anonymous_86)',decl:{start:{line:481,column:40},end:{line:481,column:41}},loc:{start:{line:481,column:48},end:{line:502,column:1}},line:481},'87':{name:'(anonymous_87)',decl:{start:{line:482,column:11},end:{line:482,column:12}},loc:{start:{line:482,column:23},end:{line:501,column:5}},line:482},'88':{name:'(anonymous_88)',decl:{start:{line:485,column:19},end:{line:485,column:20}},loc:{start:{line:485,column:31},end:{line:491,column:13}},line:485},'89':{name:'(anonymous_89)',decl:{start:{line:492,column:20},end:{line:492,column:21}},loc:{start:{line:492,column:29},end:{line:500,column:13}},line:492},'90':{name:'(anonymous_90)',decl:{start:{line:505,column:53},end:{line:505,column:54}},loc:{start:{line:505,column:60},end:{line:509,column:1}},line:505},'91':{name:'(anonymous_91)',decl:{start:{line:511,column:55},end:{line:511,column:56}},loc:{start:{line:511,column:70},end:{line:516,column:1}},line:511},'92':{name:'(anonymous_92)',decl:{start:{line:518,column:52},end:{line:518,column:53}},loc:{start:{line:518,column:65},end:{line:523,column:1}},line:518},'93':{name:'(anonymous_93)',decl:{start:{line:525,column:53},end:{line:525,column:54}},loc:{start:{line:525,column:60},end:{line:529,column:1}},line:525},'94':{name:'(anonymous_94)',decl:{start:{line:531,column:48},end:{line:531,column:49}},loc:{start:{line:531,column:74},end:{line:548,column:1}},line:531},'95':{name:'(anonymous_95)',decl:{start:{line:532,column:11},end:{line:532,column:12}},loc:{start:{line:532,column:23},end:{line:547,column:5}},line:532},'96':{name:'(anonymous_96)',decl:{start:{line:535,column:19},end:{line:535,column:20}},loc:{start:{line:535,column:31},end:{line:537,column:13}},line:535},'97':{name:'(anonymous_97)',decl:{start:{line:538,column:20},end:{line:538,column:21}},loc:{start:{line:538,column:29},end:{line:546,column:13}},line:538}},branchMap:{'0':{loc:{start:{line:79,column:8},end:{line:81,column:9}},type:'if',locations:[{start:{line:79,column:8},end:{line:81,column:9}},{start:{line:79,column:8},end:{line:81,column:9}}],line:79},'1':{loc:{start:{line:252,column:51},end:{line:252,column:66}},type:'default-arg',locations:[{start:{line:252,column:62},end:{line:252,column:66}}],line:252},'2':{loc:{start:{line:266,column:16},end:{line:271,column:17}},type:'if',locations:[{start:{line:266,column:16},end:{line:271,column:17}},{start:{line:266,column:16},end:{line:271,column:17}}],line:266},'3':{loc:{start:{line:266,column:19},end:{line:266,column:53}},type:'binary-expr',locations:[{start:{line:266,column:19},end:{line:266,column:31}},{start:{line:266,column:35},end:{line:266,column:53}}],line:266},'4':{loc:{start:{line:395,column:16},end:{line:400,column:17}},type:'if',locations:[{start:{line:395,column:16},end:{line:400,column:17}},{start:{line:395,column:16},end:{line:400,column:17}}],line:395},'5':{loc:{start:{line:395,column:19},end:{line:395,column:53}},type:'binary-expr',locations:[{start:{line:395,column:19},end:{line:395,column:31}},{start:{line:395,column:35},end:{line:395,column:53}}],line:395},'6':{loc:{start:{line:444,column:16},end:{line:449,column:17}},type:'if',locations:[{start:{line:444,column:16},end:{line:449,column:17}},{start:{line:444,column:16},end:{line:449,column:17}}],line:444},'7':{loc:{start:{line:444,column:19},end:{line:444,column:53}},type:'binary-expr',locations:[{start:{line:444,column:19},end:{line:444,column:31}},{start:{line:444,column:35},end:{line:444,column:53}}],line:444},'8':{loc:{start:{line:493,column:16},end:{line:498,column:17}},type:'if',locations:[{start:{line:493,column:16},end:{line:498,column:17}},{start:{line:493,column:16},end:{line:498,column:17}}],line:493},'9':{loc:{start:{line:493,column:19},end:{line:493,column:53}},type:'binary-expr',locations:[{start:{line:493,column:19},end:{line:493,column:31}},{start:{line:493,column:35},end:{line:493,column:53}}],line:493},'10':{loc:{start:{line:539,column:16},end:{line:544,column:17}},type:'if',locations:[{start:{line:539,column:16},end:{line:544,column:17}},{start:{line:539,column:16},end:{line:544,column:17}}],line:539},'11':{loc:{start:{line:539,column:19},end:{line:539,column:53}},type:'binary-expr',locations:[{start:{line:539,column:19},end:{line:539,column:31}},{start:{line:539,column:35},end:{line:539,column:53}}],line:539}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0,'115':0,'116':0,'117':0,'118':0,'119':0,'120':0,'121':0,'122':0,'123':0,'124':0,'125':0,'126':0,'127':0,'128':0,'129':0,'130':0,'131':0,'132':0,'133':0,'134':0,'135':0,'136':0,'137':0,'138':0,'139':0,'140':0,'141':0,'142':0,'143':0,'144':0,'145':0,'146':0,'147':0,'148':0,'149':0,'150':0,'151':0,'152':0,'153':0,'154':0,'155':0,'156':0,'157':0,'158':0,'159':0,'160':0,'161':0,'162':0,'163':0,'164':0,'165':0,'166':0,'167':0,'168':0,'169':0,'170':0,'171':0,'172':0,'173':0,'174':0,'175':0,'176':0,'177':0,'178':0,'179':0,'180':0,'181':0,'182':0,'183':0,'184':0,'185':0,'186':0,'187':0,'188':0,'189':0,'190':0,'191':0,'192':0,'193':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0},b:{'0':[0,0],'1':[0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Job Create ------------------- */cov_2bdijtr5u8.s[0]++;var calculatorJobCreateStart=function calculatorJobCreateStart(){cov_2bdijtr5u8.f[0]++;cov_2bdijtr5u8.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["D" /* CALCULATOR_JOB_CREATE_START */]};};cov_2bdijtr5u8.s[2]++;var calculatorJobCreateSuccess=function calculatorJobCreateSuccess(details){cov_2bdijtr5u8.f[1]++;cov_2bdijtr5u8.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["E" /* CALCULATOR_JOB_CREATE_SUCCESS */],details:details};};cov_2bdijtr5u8.s[4]++;var calculatorJobCreateFail=function calculatorJobCreateFail(error){cov_2bdijtr5u8.f[2]++;cov_2bdijtr5u8.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["B" /* CALCULATOR_JOB_CREATE_FAIL */],error:error};};cov_2bdijtr5u8.s[6]++;var calculatorJobCreateReset=function calculatorJobCreateReset(){cov_2bdijtr5u8.f[3]++;cov_2bdijtr5u8.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["C" /* CALCULATOR_JOB_CREATE_RESET */]};};cov_2bdijtr5u8.s[8]++;var calculatorJobCreate=function calculatorJobCreate(formData){cov_2bdijtr5u8.f[4]++;cov_2bdijtr5u8.s[9]++;return function(dispatch){cov_2bdijtr5u8.f[5]++;cov_2bdijtr5u8.s[10]++;dispatch(calculatorJobCreateStart());cov_2bdijtr5u8.s[11]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].post('/production/calculator/jobs',formData).then(function(response){cov_2bdijtr5u8.f[6]++;cov_2bdijtr5u8.s[12]++;dispatch(calculatorJobMessageSet({key:'created',type:'success'}));cov_2bdijtr5u8.s[13]++;dispatch(calculatorJobCreateSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[7]++;cov_2bdijtr5u8.s[14]++;dispatch(calculatorJobCreateFail(error));});};};/* ----------------- Job Duplicate ------------------ */cov_2bdijtr5u8.s[15]++;var calculatorJobDuplicateCheckSuccess=function calculatorJobDuplicateCheckSuccess(name_duplicate){cov_2bdijtr5u8.f[8]++;cov_2bdijtr5u8.s[16]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Q" /* CALCULATOR_JOB_DUPLICATECHECK_SUCCESS */],name_duplicate:name_duplicate};};cov_2bdijtr5u8.s[17]++;var calculatorJobDuplicateCheckFail=function calculatorJobDuplicateCheckFail(error){cov_2bdijtr5u8.f[9]++;cov_2bdijtr5u8.s[18]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["N" /* CALCULATOR_JOB_DUPLICATECHECK_FAIL */],error:error};};cov_2bdijtr5u8.s[19]++;var calculatorJobDuplicateCheckStart=function calculatorJobDuplicateCheckStart(){cov_2bdijtr5u8.f[10]++;cov_2bdijtr5u8.s[20]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["P" /* CALCULATOR_JOB_DUPLICATECHECK_START */]};};cov_2bdijtr5u8.s[21]++;var calculatorJobDuplicateCheckReset=function calculatorJobDuplicateCheckReset(){cov_2bdijtr5u8.f[11]++;cov_2bdijtr5u8.s[22]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["O" /* CALCULATOR_JOB_DUPLICATECHECK_RESET */]};};cov_2bdijtr5u8.s[23]++;var calculatorJobDuplicateCheck=function calculatorJobDuplicateCheck(formData){cov_2bdijtr5u8.f[12]++;cov_2bdijtr5u8.s[24]++;return function(dispatch){cov_2bdijtr5u8.f[13]++;cov_2bdijtr5u8.s[25]++;dispatch(calculatorJobDuplicateCheckStart());var urlString=(cov_2bdijtr5u8.s[26]++,'/production/calculator/jobs/duplicate?name='+formData.name);cov_2bdijtr5u8.s[27]++;if(formData.id){cov_2bdijtr5u8.b[0][0]++;cov_2bdijtr5u8.s[28]++;urlString=urlString+"&jobId="+formData.id;}else{cov_2bdijtr5u8.b[0][1]++;}cov_2bdijtr5u8.s[29]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get(urlString,{hideGlobalSpinner:true}).then(function(response){cov_2bdijtr5u8.f[14]++;cov_2bdijtr5u8.s[30]++;dispatch(calculatorJobDuplicateCheckSuccess(response.data.result));}).catch(function(error){cov_2bdijtr5u8.f[15]++;cov_2bdijtr5u8.s[31]++;dispatch(calculatorJobDuplicateCheckFail(error));});};};/* ------------------ Job Fetch ------------------- */cov_2bdijtr5u8.s[32]++;var calculatorJobFetchStart=function calculatorJobFetchStart(){cov_2bdijtr5u8.f[16]++;cov_2bdijtr5u8.s[33]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["X" /* CALCULATOR_JOB_FETCH_START */]};};cov_2bdijtr5u8.s[34]++;var calculatorJobFetchSuccess=function calculatorJobFetchSuccess(details){cov_2bdijtr5u8.f[17]++;cov_2bdijtr5u8.s[35]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Y" /* CALCULATOR_JOB_FETCH_SUCCESS */],details:details};};cov_2bdijtr5u8.s[36]++;var calculatorJobFetchFail=function calculatorJobFetchFail(error){cov_2bdijtr5u8.f[18]++;cov_2bdijtr5u8.s[37]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["V" /* CALCULATOR_JOB_FETCH_FAIL */],error:error};};cov_2bdijtr5u8.s[38]++;var calculatorJobFetchReset=function calculatorJobFetchReset(){cov_2bdijtr5u8.f[19]++;cov_2bdijtr5u8.s[39]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["W" /* CALCULATOR_JOB_FETCH_RESET */]};};cov_2bdijtr5u8.s[40]++;var calculatorJobFetch=function calculatorJobFetch(id){cov_2bdijtr5u8.f[20]++;cov_2bdijtr5u8.s[41]++;return function(dispatch){cov_2bdijtr5u8.f[21]++;cov_2bdijtr5u8.s[42]++;dispatch(calculatorJobFetchStart());cov_2bdijtr5u8.s[43]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+id).then(function(response){cov_2bdijtr5u8.f[22]++;cov_2bdijtr5u8.s[44]++;dispatch(calculatorJobFetchSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[23]++;cov_2bdijtr5u8.s[45]++;dispatch(calculatorJobFetchFail(error));});};};/* ------------------ Job Message ------------------- */cov_2bdijtr5u8.s[46]++;var calculatorJobMessageSet=function calculatorJobMessageSet(message){cov_2bdijtr5u8.f[24]++;cov_2bdijtr5u8.s[47]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_8" /* CALCULATOR_JOB_MESSAGE_SET */],message:message};};cov_2bdijtr5u8.s[48]++;var calculatorJobMessageReset=function calculatorJobMessageReset(){cov_2bdijtr5u8.f[25]++;cov_2bdijtr5u8.s[49]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_7" /* CALCULATOR_JOB_MESSAGE_RESET */]};};/* ------------------ Job Machine Fetch ------------------- */cov_2bdijtr5u8.s[50]++;var calculatorJobMachineFetchStart=function calculatorJobMachineFetchStart(){cov_2bdijtr5u8.f[26]++;cov_2bdijtr5u8.s[51]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_1" /* CALCULATOR_JOB_MACHINE_FETCH_START */]};};cov_2bdijtr5u8.s[52]++;var calculatorJobMachineFetchSuccess=function calculatorJobMachineFetchSuccess(details){cov_2bdijtr5u8.f[27]++;cov_2bdijtr5u8.s[53]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_2" /* CALCULATOR_JOB_MACHINE_FETCH_SUCCESS */],details:details};};cov_2bdijtr5u8.s[54]++;var calculatorJobMachineFetchFail=function calculatorJobMachineFetchFail(error){cov_2bdijtr5u8.f[28]++;cov_2bdijtr5u8.s[55]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Z" /* CALCULATOR_JOB_MACHINE_FETCH_FAIL */],error:error};};cov_2bdijtr5u8.s[56]++;var calculatorJobMachineFetchReset=function calculatorJobMachineFetchReset(){cov_2bdijtr5u8.f[29]++;cov_2bdijtr5u8.s[57]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_0" /* CALCULATOR_JOB_MACHINE_FETCH_RESET */]};};cov_2bdijtr5u8.s[58]++;var calculatorJobMachineFetch=function calculatorJobMachineFetch(id){cov_2bdijtr5u8.f[30]++;cov_2bdijtr5u8.s[59]++;return function(dispatch){cov_2bdijtr5u8.f[31]++;cov_2bdijtr5u8.s[60]++;dispatch(calculatorJobMachineFetchStart());cov_2bdijtr5u8.s[61]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+id+'/machine').then(function(response){cov_2bdijtr5u8.f[32]++;cov_2bdijtr5u8.s[62]++;dispatch(calculatorJobMachineFetchSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[33]++;cov_2bdijtr5u8.s[63]++;dispatch(calculatorJobMachineFetchFail(error));});};};/* ------------------ Job Calculations Fetch ------------------- */cov_2bdijtr5u8.s[64]++;var calculatorJobCalculationsFetchStart=function calculatorJobCalculationsFetchStart(){cov_2bdijtr5u8.f[34]++;cov_2bdijtr5u8.s[65]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["v" /* CALCULATOR_JOB_CALCULATIONS_FETCH_START */]};};cov_2bdijtr5u8.s[66]++;var calculatorJobCalculationsFetchSuccess=function calculatorJobCalculationsFetchSuccess(details){cov_2bdijtr5u8.f[35]++;cov_2bdijtr5u8.s[67]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["w" /* CALCULATOR_JOB_CALCULATIONS_FETCH_SUCCESS */],details:details};};cov_2bdijtr5u8.s[68]++;var calculatorJobCalculationsFetchFail=function calculatorJobCalculationsFetchFail(error){cov_2bdijtr5u8.f[36]++;cov_2bdijtr5u8.s[69]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["t" /* CALCULATOR_JOB_CALCULATIONS_FETCH_FAIL */],error:error};};cov_2bdijtr5u8.s[70]++;var calculatorJobCalculationsFetchReset=function calculatorJobCalculationsFetchReset(){cov_2bdijtr5u8.f[37]++;cov_2bdijtr5u8.s[71]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["u" /* CALCULATOR_JOB_CALCULATIONS_FETCH_RESET */]};};cov_2bdijtr5u8.s[72]++;var calculatorJobCalculationsFetch=function calculatorJobCalculationsFetch(id){cov_2bdijtr5u8.f[38]++;cov_2bdijtr5u8.s[73]++;return function(dispatch){cov_2bdijtr5u8.f[39]++;cov_2bdijtr5u8.s[74]++;dispatch(calculatorJobCalculationsFetchStart());cov_2bdijtr5u8.s[75]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+id+'/calculations').then(function(response){cov_2bdijtr5u8.f[40]++;cov_2bdijtr5u8.s[76]++;dispatch(calculatorJobCalculationsFetchSuccess(response.data.list));}).catch(function(error){cov_2bdijtr5u8.f[41]++;cov_2bdijtr5u8.s[77]++;dispatch(calculatorJobCalculationsFetchFail(error));});};};/* ------------------ Job Export Fetch ------------------- */cov_2bdijtr5u8.s[78]++;var calculatorJobExportFetchStart=function calculatorJobExportFetchStart(){cov_2bdijtr5u8.f[42]++;cov_2bdijtr5u8.s[79]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["T" /* CALCULATOR_JOB_EXPORT_FETCH_START */]};};cov_2bdijtr5u8.s[80]++;var calculatorJobExportFetchSuccess=function calculatorJobExportFetchSuccess(filebody,filename){cov_2bdijtr5u8.f[43]++;cov_2bdijtr5u8.s[81]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["U" /* CALCULATOR_JOB_EXPORT_FETCH_SUCCESS */],filebody:filebody,filename:filename};};cov_2bdijtr5u8.s[82]++;var calculatorJobExportFetchFail=function calculatorJobExportFetchFail(error){cov_2bdijtr5u8.f[44]++;cov_2bdijtr5u8.s[83]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["R" /* CALCULATOR_JOB_EXPORT_FETCH_FAIL */],error:error};};cov_2bdijtr5u8.s[84]++;var calculatorJobExportFetchReset=function calculatorJobExportFetchReset(){cov_2bdijtr5u8.f[45]++;cov_2bdijtr5u8.s[85]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["S" /* CALCULATOR_JOB_EXPORT_FETCH_RESET */]};};cov_2bdijtr5u8.s[86]++;var calculatorJobExportFetch=function calculatorJobExportFetch(id,type){var language=arguments.length>2&&arguments[2]!==undefined?arguments[2]:(cov_2bdijtr5u8.b[1][0]++,'en');cov_2bdijtr5u8.f[46]++;cov_2bdijtr5u8.s[87]++;return function(dispatch){cov_2bdijtr5u8.f[47]++;cov_2bdijtr5u8.s[88]++;dispatch(calculatorJobExportFetchStart());cov_2bdijtr5u8.s[89]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+id+'/export?culture='+language,{data:{},responseType:'arraybuffer',headers:{'Content-Type':'application/'+type}}).then(function(response){cov_2bdijtr5u8.f[48]++;cov_2bdijtr5u8.s[90]++;dispatch(calculatorJobExportFetchSuccess(response.data,response.headers["x-filename"]));}).catch(function(error){cov_2bdijtr5u8.f[49]++;cov_2bdijtr5u8.s[91]++;if((cov_2bdijtr5u8.b[3][0]++,error.length)&&(cov_2bdijtr5u8.b[3][1]++,error.length===1)){cov_2bdijtr5u8.b[2][0]++;cov_2bdijtr5u8.s[92]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bdijtr5u8.b[2][1]++;cov_2bdijtr5u8.s[93]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bdijtr5u8.s[94]++;dispatch(calculatorJobExportFetchFail(error));});};};/* ------------------ Job Update ------------------- */cov_2bdijtr5u8.s[95]++;var calculatorJobUpdateStart=function calculatorJobUpdateStart(){cov_2bdijtr5u8.f[50]++;cov_2bdijtr5u8.s[96]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_15" /* CALCULATOR_JOB_UPDATE_START */]};};cov_2bdijtr5u8.s[97]++;var calculatorJobUpdateSuccess=function calculatorJobUpdateSuccess(details){cov_2bdijtr5u8.f[51]++;cov_2bdijtr5u8.s[98]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_16" /* CALCULATOR_JOB_UPDATE_SUCCESS */],details:details};};cov_2bdijtr5u8.s[99]++;var calculatorJobUpdateFail=function calculatorJobUpdateFail(error){cov_2bdijtr5u8.f[52]++;cov_2bdijtr5u8.s[100]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_13" /* CALCULATOR_JOB_UPDATE_FAIL */],error:error};};cov_2bdijtr5u8.s[101]++;var calculatorJobUpdateReset=function calculatorJobUpdateReset(){cov_2bdijtr5u8.f[53]++;cov_2bdijtr5u8.s[102]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_14" /* CALCULATOR_JOB_UPDATE_RESET */]};};cov_2bdijtr5u8.s[103]++;var calculatorJobUpdate=function calculatorJobUpdate(id,formData){cov_2bdijtr5u8.f[54]++;cov_2bdijtr5u8.s[104]++;return function(dispatch){cov_2bdijtr5u8.f[55]++;cov_2bdijtr5u8.s[105]++;dispatch(calculatorJobUpdateStart());cov_2bdijtr5u8.s[106]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/jobs/'+id,formData).then(function(response){cov_2bdijtr5u8.f[56]++;cov_2bdijtr5u8.s[107]++;dispatch(calculatorJobUpdateSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[57]++;cov_2bdijtr5u8.s[108]++;dispatch(calculatorJobUpdateFail(error));});};};/* ------------------ Job Machine Update ------------------- */cov_2bdijtr5u8.s[109]++;var calculatorJobMachineUpdateStart=function calculatorJobMachineUpdateStart(){cov_2bdijtr5u8.f[58]++;cov_2bdijtr5u8.s[110]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_5" /* CALCULATOR_JOB_MACHINE_UPDATE_START */]};};cov_2bdijtr5u8.s[111]++;var calculatorJobMachineUpdateSuccess=function calculatorJobMachineUpdateSuccess(settings){cov_2bdijtr5u8.f[59]++;cov_2bdijtr5u8.s[112]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_6" /* CALCULATOR_JOB_MACHINE_UPDATE_SUCCESS */],settings:settings};};cov_2bdijtr5u8.s[113]++;var calculatorJobMachineUpdateFail=function calculatorJobMachineUpdateFail(error){cov_2bdijtr5u8.f[60]++;cov_2bdijtr5u8.s[114]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_3" /* CALCULATOR_JOB_MACHINE_UPDATE_FAIL */],error:error};};cov_2bdijtr5u8.s[115]++;var calculatorJobMachineUpdateReset=function calculatorJobMachineUpdateReset(){cov_2bdijtr5u8.f[61]++;cov_2bdijtr5u8.s[116]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_4" /* CALCULATOR_JOB_MACHINE_UPDATE_RESET */]};};cov_2bdijtr5u8.s[117]++;var calculatorJobMachineUpdate=function calculatorJobMachineUpdate(id,formData){cov_2bdijtr5u8.f[62]++;cov_2bdijtr5u8.s[118]++;return function(dispatch){cov_2bdijtr5u8.f[63]++;cov_2bdijtr5u8.s[119]++;dispatch(calculatorJobMachineUpdateStart());cov_2bdijtr5u8.s[120]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/jobs/'+id+'/machine/settings',formData).then(function(response){cov_2bdijtr5u8.f[64]++;cov_2bdijtr5u8.s[121]++;dispatch(calculatorJobMachineUpdateSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[65]++;cov_2bdijtr5u8.s[122]++;dispatch(calculatorJobMachineUpdateFail(error));});};};/* ------------------ Job Delete ------------------- */cov_2bdijtr5u8.s[123]++;var calculatorJobDeleteStart=function calculatorJobDeleteStart(){cov_2bdijtr5u8.f[66]++;cov_2bdijtr5u8.s[124]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["H" /* CALCULATOR_JOB_DELETE_START */]};};cov_2bdijtr5u8.s[125]++;var calculatorJobDeleteSuccess=function calculatorJobDeleteSuccess(){cov_2bdijtr5u8.f[67]++;cov_2bdijtr5u8.s[126]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["I" /* CALCULATOR_JOB_DELETE_SUCCESS */]};};cov_2bdijtr5u8.s[127]++;var calculatorJobDeleteFail=function calculatorJobDeleteFail(error){cov_2bdijtr5u8.f[68]++;cov_2bdijtr5u8.s[128]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["F" /* CALCULATOR_JOB_DELETE_FAIL */],error:error};};cov_2bdijtr5u8.s[129]++;var calculatorJobDeleteReset=function calculatorJobDeleteReset(){cov_2bdijtr5u8.f[69]++;cov_2bdijtr5u8.s[130]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["G" /* CALCULATOR_JOB_DELETE_RESET */]};};cov_2bdijtr5u8.s[131]++;var calculatorJobDelete=function calculatorJobDelete(id,formData){cov_2bdijtr5u8.f[70]++;cov_2bdijtr5u8.s[132]++;return function(dispatch){cov_2bdijtr5u8.f[71]++;cov_2bdijtr5u8.s[133]++;dispatch(calculatorJobDeleteStart());cov_2bdijtr5u8.s[134]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].delete('/production/calculator/jobs/'+id,formData).then(function(response){cov_2bdijtr5u8.f[72]++;cov_2bdijtr5u8.s[135]++;dispatch(calculatorJobMessageSet({key:'deleted',type:'success'}));cov_2bdijtr5u8.s[136]++;dispatch(calculatorJobDeleteSuccess());}).catch(function(error){cov_2bdijtr5u8.f[73]++;cov_2bdijtr5u8.s[137]++;if((cov_2bdijtr5u8.b[5][0]++,error.length)&&(cov_2bdijtr5u8.b[5][1]++,error.length===1)){cov_2bdijtr5u8.b[4][0]++;cov_2bdijtr5u8.s[138]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bdijtr5u8.b[4][1]++;cov_2bdijtr5u8.s[139]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bdijtr5u8.s[140]++;dispatch(calculatorJobDeleteFail(error));});};};/* ------------------ Job Change Active ------------------- */cov_2bdijtr5u8.s[141]++;var calculatorJobChangeActiveStart=function calculatorJobChangeActiveStart(){cov_2bdijtr5u8.f[74]++;cov_2bdijtr5u8.s[142]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* CALCULATOR_JOB_CHANGEACTIVE_START */]};};cov_2bdijtr5u8.s[143]++;var calculatorJobChangeActiveSuccess=function calculatorJobChangeActiveSuccess(){cov_2bdijtr5u8.f[75]++;cov_2bdijtr5u8.s[144]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["A" /* CALCULATOR_JOB_CHANGEACTIVE_SUCCESS */]};};cov_2bdijtr5u8.s[145]++;var calculatorJobChangeActiveFail=function calculatorJobChangeActiveFail(error){cov_2bdijtr5u8.f[76]++;cov_2bdijtr5u8.s[146]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["x" /* CALCULATOR_JOB_CHANGEACTIVE_FAIL */],error:error};};cov_2bdijtr5u8.s[147]++;var calculatorJobChangeActiveReset=function calculatorJobChangeActiveReset(){cov_2bdijtr5u8.f[77]++;cov_2bdijtr5u8.s[148]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["y" /* CALCULATOR_JOB_CHANGEACTIVE_RESET */]};};cov_2bdijtr5u8.s[149]++;var calculatorJobChangeActive=function calculatorJobChangeActive(id,formData){cov_2bdijtr5u8.f[78]++;cov_2bdijtr5u8.s[150]++;return function(dispatch){cov_2bdijtr5u8.f[79]++;cov_2bdijtr5u8.s[151]++;dispatch(calculatorJobChangeActiveStart());cov_2bdijtr5u8.s[152]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/jobs/'+id+'/machine/changeactive',formData).then(function(response){cov_2bdijtr5u8.f[80]++;cov_2bdijtr5u8.s[153]++;dispatch(calculatorJobMessageSet({key:'used_machine',type:'success'}));cov_2bdijtr5u8.s[154]++;dispatch(calculatorJobChangeActiveSuccess());}).catch(function(error){cov_2bdijtr5u8.f[81]++;cov_2bdijtr5u8.s[155]++;if((cov_2bdijtr5u8.b[7][0]++,error.length)&&(cov_2bdijtr5u8.b[7][1]++,error.length===1)){cov_2bdijtr5u8.b[6][0]++;cov_2bdijtr5u8.s[156]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bdijtr5u8.b[6][1]++;cov_2bdijtr5u8.s[157]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bdijtr5u8.s[158]++;dispatch(calculatorJobChangeActiveFail(error));});};};/* ------------------ Recalculate Active ------------------- */cov_2bdijtr5u8.s[159]++;var calculatorJobRecalculateStart=function calculatorJobRecalculateStart(){cov_2bdijtr5u8.f[82]++;cov_2bdijtr5u8.s[160]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_11" /* CALCULATOR_JOB_RECALCULATE_START */]};};cov_2bdijtr5u8.s[161]++;var calculatorJobRecalculateSuccess=function calculatorJobRecalculateSuccess(){cov_2bdijtr5u8.f[83]++;cov_2bdijtr5u8.s[162]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_12" /* CALCULATOR_JOB_RECALCULATE_SUCCESS */]};};cov_2bdijtr5u8.s[163]++;var calculatorJobRecalculateFail=function calculatorJobRecalculateFail(error){cov_2bdijtr5u8.f[84]++;cov_2bdijtr5u8.s[164]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_9" /* CALCULATOR_JOB_RECALCULATE_FAIL */],error:error};};cov_2bdijtr5u8.s[165]++;var calculatorJobRecalculateReset=function calculatorJobRecalculateReset(){cov_2bdijtr5u8.f[85]++;cov_2bdijtr5u8.s[166]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_10" /* CALCULATOR_JOB_RECALCULATE_RESET */]};};cov_2bdijtr5u8.s[167]++;var calculatorJobRecalculate=function calculatorJobRecalculate(id){cov_2bdijtr5u8.f[86]++;cov_2bdijtr5u8.s[168]++;return function(dispatch){cov_2bdijtr5u8.f[87]++;cov_2bdijtr5u8.s[169]++;dispatch(calculatorJobRecalculateStart());cov_2bdijtr5u8.s[170]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+id+'/applyglobalsettings').then(function(response){cov_2bdijtr5u8.f[88]++;cov_2bdijtr5u8.s[171]++;dispatch(calculatorJobMessageSet({key:'recalculated',type:'success'}));cov_2bdijtr5u8.s[172]++;dispatch(calculatorJobRecalculateSuccess());}).catch(function(error){cov_2bdijtr5u8.f[89]++;cov_2bdijtr5u8.s[173]++;if((cov_2bdijtr5u8.b[9][0]++,error.length)&&(cov_2bdijtr5u8.b[9][1]++,error.length===1)){cov_2bdijtr5u8.b[8][0]++;cov_2bdijtr5u8.s[174]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bdijtr5u8.b[8][1]++;cov_2bdijtr5u8.s[175]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bdijtr5u8.s[176]++;dispatch(calculatorJobRecalculateFail(error));});};};/* ------------------ Detailed Calculation ------------------- */cov_2bdijtr5u8.s[177]++;var calculatorJobDetailedCalculationStart=function calculatorJobDetailedCalculationStart(){cov_2bdijtr5u8.f[90]++;cov_2bdijtr5u8.s[178]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* CALCULATOR_JOB_DETAILED_CALCULATION_START */]};};cov_2bdijtr5u8.s[179]++;var calculatorJobDetailedCalculationSuccess=function calculatorJobDetailedCalculationSuccess(details){cov_2bdijtr5u8.f[91]++;cov_2bdijtr5u8.s[180]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* CALCULATOR_JOB_DETAILED_CALCULATION_SUCCESS */],details:details};};cov_2bdijtr5u8.s[181]++;var calculatorJobDetailedCalculationFail=function calculatorJobDetailedCalculationFail(error){cov_2bdijtr5u8.f[92]++;cov_2bdijtr5u8.s[182]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["J" /* CALCULATOR_JOB_DETAILED_CALCULATION_FAIL */],error:error};};cov_2bdijtr5u8.s[183]++;var calculatorJobDetailedCalculationReset=function calculatorJobDetailedCalculationReset(){cov_2bdijtr5u8.f[93]++;cov_2bdijtr5u8.s[184]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["K" /* CALCULATOR_JOB_DETAILED_CALCULATION_RESET */]};};cov_2bdijtr5u8.s[185]++;var calculatorJobDetailedCalculation=function calculatorJobDetailedCalculation(jobId,calculationId){cov_2bdijtr5u8.f[94]++;cov_2bdijtr5u8.s[186]++;return function(dispatch){cov_2bdijtr5u8.f[95]++;cov_2bdijtr5u8.s[187]++;dispatch(calculatorJobDetailedCalculationStart());cov_2bdijtr5u8.s[188]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/jobs/'+jobId+'/calculations/'+calculationId+'/details').then(function(response){cov_2bdijtr5u8.f[96]++;cov_2bdijtr5u8.s[189]++;dispatch(calculatorJobDetailedCalculationSuccess(response.data));}).catch(function(error){cov_2bdijtr5u8.f[97]++;cov_2bdijtr5u8.s[190]++;if((cov_2bdijtr5u8.b[11][0]++,error.length)&&(cov_2bdijtr5u8.b[11][1]++,error.length===1)){cov_2bdijtr5u8.b[10][0]++;cov_2bdijtr5u8.s[191]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bdijtr5u8.b[10][1]++;cov_2bdijtr5u8.s[192]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"job",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bdijtr5u8.s[193]++;dispatch(calculatorJobDetailedCalculationFail(error));});};};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorMachinesFetchStart */
/* unused harmony export calculatorMachinesFetchSuccess */
/* unused harmony export calculatorMachinesFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorMachinesFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_14on7xmk29=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\machines.js',hash='d23ba2bb8a98778be85b060ea7310efb7621a3b0',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\machines.js',statementMap:{'0':{start:{line:4,column:44},end:{line:8,column:1}},'1':{start:{line:5,column:4},end:{line:7,column:6}},'2':{start:{line:10,column:46},end:{line:15,column:1}},'3':{start:{line:11,column:4},end:{line:14,column:6}},'4':{start:{line:17,column:43},end:{line:22,column:1}},'5':{start:{line:18,column:4},end:{line:21,column:6}},'6':{start:{line:24,column:39},end:{line:41,column:1}},'7':{start:{line:25,column:4},end:{line:40,column:6}},'8':{start:{line:26,column:8},end:{line:26,column:49}},'9':{start:{line:27,column:8},end:{line:39,column:16}},'10':{start:{line:29,column:16},end:{line:29,column:81}},'11':{start:{line:32,column:16},end:{line:37,column:17}},'12':{start:{line:33,column:20},end:{line:33,column:162}},'13':{start:{line:36,column:20},end:{line:36,column:203}},'14':{start:{line:38,column:16},end:{line:38,column:65}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:44},end:{line:4,column:45}},loc:{start:{line:4,column:50},end:{line:8,column:1}},line:4},'1':{name:'(anonymous_1)',decl:{start:{line:10,column:46},end:{line:10,column:47}},loc:{start:{line:10,column:60},end:{line:15,column:1}},line:10},'2':{name:'(anonymous_2)',decl:{start:{line:17,column:43},end:{line:17,column:44}},loc:{start:{line:17,column:56},end:{line:22,column:1}},line:17},'3':{name:'(anonymous_3)',decl:{start:{line:24,column:39},end:{line:24,column:40}},loc:{start:{line:24,column:45},end:{line:41,column:1}},line:24},'4':{name:'(anonymous_4)',decl:{start:{line:25,column:11},end:{line:25,column:12}},loc:{start:{line:25,column:23},end:{line:40,column:5}},line:25},'5':{name:'(anonymous_5)',decl:{start:{line:28,column:19},end:{line:28,column:20}},loc:{start:{line:28,column:31},end:{line:30,column:13}},line:28},'6':{name:'(anonymous_6)',decl:{start:{line:31,column:20},end:{line:31,column:21}},loc:{start:{line:31,column:29},end:{line:39,column:13}},line:31}},branchMap:{'0':{loc:{start:{line:32,column:16},end:{line:37,column:17}},type:'if',locations:[{start:{line:32,column:16},end:{line:37,column:17}},{start:{line:32,column:16},end:{line:37,column:17}}],line:32},'1':{loc:{start:{line:32,column:19},end:{line:32,column:53}},type:'binary-expr',locations:[{start:{line:32,column:19},end:{line:32,column:31}},{start:{line:32,column:35},end:{line:32,column:53}}],line:32}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_14on7xmk29.s[0]++;var calculatorMachinesFetchStart=function calculatorMachinesFetchStart(){cov_14on7xmk29.f[0]++;cov_14on7xmk29.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_21" /* CALCULATOR_MACHINES_FETCH_START */]};};cov_14on7xmk29.s[2]++;var calculatorMachinesFetchSuccess=function calculatorMachinesFetchSuccess(machines){cov_14on7xmk29.f[1]++;cov_14on7xmk29.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_22" /* CALCULATOR_MACHINES_FETCH_SUCCESS */],machines:machines};};cov_14on7xmk29.s[4]++;var calculatorMachinesFetchFail=function calculatorMachinesFetchFail(error){cov_14on7xmk29.f[2]++;cov_14on7xmk29.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_20" /* CALCULATOR_MACHINES_FETCH_FAIL */],error:error};};cov_14on7xmk29.s[6]++;var calculatorMachinesFetch=function calculatorMachinesFetch(){cov_14on7xmk29.f[3]++;cov_14on7xmk29.s[7]++;return function(dispatch){cov_14on7xmk29.f[4]++;cov_14on7xmk29.s[8]++;dispatch(calculatorMachinesFetchStart());cov_14on7xmk29.s[9]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/machines').then(function(response){cov_14on7xmk29.f[5]++;cov_14on7xmk29.s[10]++;dispatch(calculatorMachinesFetchSuccess(response.data.list));}).catch(function(error){cov_14on7xmk29.f[6]++;cov_14on7xmk29.s[11]++;if((cov_14on7xmk29.b[1][0]++,error.length)&&(cov_14on7xmk29.b[1][1]++,error.length===1)){cov_14on7xmk29.b[0][0]++;cov_14on7xmk29.s[12]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machines",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_14on7xmk29.b[0][1]++;cov_14on7xmk29.s[13]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machines",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_14on7xmk29.s[14]++;dispatch(calculatorMachinesFetchFail(error));});};};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorMachinesDefaultsFetchStart */
/* unused harmony export calculatorMachinesDefaultsFetchSuccess */
/* unused harmony export calculatorMachinesDefaultsFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorMachinesDefaultsFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_2bwmbwu10e=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\defaults.js',hash='e5e280cd00e3462b2cd37aed72f20d62c80778ba',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\defaults.js',statementMap:{'0':{start:{line:4,column:52},end:{line:8,column:1}},'1':{start:{line:5,column:4},end:{line:7,column:6}},'2':{start:{line:10,column:54},end:{line:15,column:1}},'3':{start:{line:11,column:4},end:{line:14,column:6}},'4':{start:{line:17,column:51},end:{line:22,column:1}},'5':{start:{line:18,column:4},end:{line:21,column:6}},'6':{start:{line:24,column:47},end:{line:41,column:1}},'7':{start:{line:25,column:4},end:{line:40,column:6}},'8':{start:{line:26,column:8},end:{line:26,column:57}},'9':{start:{line:27,column:8},end:{line:39,column:16}},'10':{start:{line:29,column:16},end:{line:29,column:89}},'11':{start:{line:32,column:16},end:{line:37,column:17}},'12':{start:{line:33,column:20},end:{line:33,column:169}},'13':{start:{line:36,column:20},end:{line:36,column:210}},'14':{start:{line:38,column:16},end:{line:38,column:73}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:52},end:{line:4,column:53}},loc:{start:{line:4,column:58},end:{line:8,column:1}},line:4},'1':{name:'(anonymous_1)',decl:{start:{line:10,column:54},end:{line:10,column:55}},loc:{start:{line:10,column:68},end:{line:15,column:1}},line:10},'2':{name:'(anonymous_2)',decl:{start:{line:17,column:51},end:{line:17,column:52}},loc:{start:{line:17,column:64},end:{line:22,column:1}},line:17},'3':{name:'(anonymous_3)',decl:{start:{line:24,column:47},end:{line:24,column:48}},loc:{start:{line:24,column:53},end:{line:41,column:1}},line:24},'4':{name:'(anonymous_4)',decl:{start:{line:25,column:11},end:{line:25,column:12}},loc:{start:{line:25,column:23},end:{line:40,column:5}},line:25},'5':{name:'(anonymous_5)',decl:{start:{line:28,column:19},end:{line:28,column:20}},loc:{start:{line:28,column:31},end:{line:30,column:13}},line:28},'6':{name:'(anonymous_6)',decl:{start:{line:31,column:20},end:{line:31,column:21}},loc:{start:{line:31,column:29},end:{line:39,column:13}},line:31}},branchMap:{'0':{loc:{start:{line:32,column:16},end:{line:37,column:17}},type:'if',locations:[{start:{line:32,column:16},end:{line:37,column:17}},{start:{line:32,column:16},end:{line:37,column:17}}],line:32},'1':{loc:{start:{line:32,column:19},end:{line:32,column:53}},type:'binary-expr',locations:[{start:{line:32,column:19},end:{line:32,column:31}},{start:{line:32,column:35},end:{line:32,column:53}}],line:32}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2bwmbwu10e.s[0]++;var calculatorMachinesDefaultsFetchStart=function calculatorMachinesDefaultsFetchStart(){cov_2bwmbwu10e.f[0]++;cov_2bwmbwu10e.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_18" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_START */]};};cov_2bwmbwu10e.s[2]++;var calculatorMachinesDefaultsFetchSuccess=function calculatorMachinesDefaultsFetchSuccess(machines){cov_2bwmbwu10e.f[1]++;cov_2bwmbwu10e.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_19" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_SUCCESS */],machines:machines};};cov_2bwmbwu10e.s[4]++;var calculatorMachinesDefaultsFetchFail=function calculatorMachinesDefaultsFetchFail(error){cov_2bwmbwu10e.f[2]++;cov_2bwmbwu10e.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_17" /* CALCULATOR_MACHINES_DEFAULTS_FETCH_FAIL */],error:error};};cov_2bwmbwu10e.s[6]++;var calculatorMachinesDefaultsFetch=function calculatorMachinesDefaultsFetch(){cov_2bwmbwu10e.f[3]++;cov_2bwmbwu10e.s[7]++;return function(dispatch){cov_2bwmbwu10e.f[4]++;cov_2bwmbwu10e.s[8]++;dispatch(calculatorMachinesDefaultsFetchStart());cov_2bwmbwu10e.s[9]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/defaults/machines').then(function(response){cov_2bwmbwu10e.f[5]++;cov_2bwmbwu10e.s[10]++;dispatch(calculatorMachinesDefaultsFetchSuccess(response.data.list));}).catch(function(error){cov_2bwmbwu10e.f[6]++;cov_2bwmbwu10e.s[11]++;if((cov_2bwmbwu10e.b[1][0]++,error.length)&&(cov_2bwmbwu10e.b[1][1]++,error.length===1)){cov_2bwmbwu10e.b[0][0]++;cov_2bwmbwu10e.s[12]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machinedefaults",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_2bwmbwu10e.b[0][1]++;cov_2bwmbwu10e.s[13]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machinedefaults",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_2bwmbwu10e.s[14]++;dispatch(calculatorMachinesDefaultsFetchFail(error));});};};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export calculatorMachineCreateStart */
/* unused harmony export calculatorMachineCreateSuccess */
/* unused harmony export calculatorMachineCreateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculatorMachineCreateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculatorMachineCreate; });
/* unused harmony export calculatorMachineDuplicateCheckSuccess */
/* unused harmony export calculatorMachineDuplicateCheckFail */
/* unused harmony export calculatorMachineDuplicateCheckStart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return calculatorMachineDuplicateCheckReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return calculatorMachineDuplicateCheck; });
/* unused harmony export calculatorMachineUpdateStart */
/* unused harmony export calculatorMachineUpdateSuccess */
/* unused harmony export calculatorMachineUpdateFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return calculatorMachineUpdateReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return calculatorMachineUpdate; });
/* unused harmony export calculatorMachineDeleteStart */
/* unused harmony export calculatorMachineDeleteSuccess */
/* unused harmony export calculatorMachineDeleteFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return calculatorMachineDeleteReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculatorMachineDelete; });
/* unused harmony export calculatorMachineFetchStart */
/* unused harmony export calculatorMachineFetchSuccess */
/* unused harmony export calculatorMachineFetchFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return calculatorMachineFetchReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return calculatorMachineFetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_axios__ = __webpack_require__(9);
var cov_5bfrpgxep=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\machine.js',hash='25f8223f9afa67f3d61a80d218df73ca511751aa',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_store\\actions\\calculator\\machines\\machine.js',statementMap:{'0':{start:{line:5,column:44},end:{line:9,column:1}},'1':{start:{line:6,column:4},end:{line:8,column:6}},'2':{start:{line:11,column:46},end:{line:16,column:1}},'3':{start:{line:12,column:4},end:{line:15,column:6}},'4':{start:{line:18,column:43},end:{line:23,column:1}},'5':{start:{line:19,column:4},end:{line:22,column:6}},'6':{start:{line:25,column:44},end:{line:29,column:1}},'7':{start:{line:26,column:4},end:{line:28,column:6}},'8':{start:{line:31,column:39},end:{line:42,column:1}},'9':{start:{line:32,column:4},end:{line:41,column:6}},'10':{start:{line:33,column:8},end:{line:33,column:49}},'11':{start:{line:34,column:8},end:{line:40,column:16}},'12':{start:{line:36,column:16},end:{line:36,column:76}},'13':{start:{line:39,column:16},end:{line:39,column:65}},'14':{start:{line:45,column:54},end:{line:50,column:1}},'15':{start:{line:46,column:4},end:{line:49,column:6}},'16':{start:{line:52,column:51},end:{line:57,column:1}},'17':{start:{line:53,column:4},end:{line:56,column:6}},'18':{start:{line:59,column:52},end:{line:63,column:1}},'19':{start:{line:60,column:4},end:{line:62,column:6}},'20':{start:{line:65,column:52},end:{line:69,column:1}},'21':{start:{line:66,column:4},end:{line:68,column:6}},'22':{start:{line:71,column:47},end:{line:86,column:1}},'23':{start:{line:72,column:4},end:{line:85,column:6}},'24':{start:{line:73,column:8},end:{line:73,column:57}},'25':{start:{line:74,column:25},end:{line:74,column:88}},'26':{start:{line:75,column:8},end:{line:77,column:9}},'27':{start:{line:76,column:12},end:{line:76,column:64}},'28':{start:{line:78,column:8},end:{line:84,column:16}},'29':{start:{line:80,column:16},end:{line:80,column:91}},'30':{start:{line:83,column:16},end:{line:83,column:73}},'31':{start:{line:89,column:44},end:{line:93,column:1}},'32':{start:{line:90,column:4},end:{line:92,column:6}},'33':{start:{line:95,column:46},end:{line:100,column:1}},'34':{start:{line:96,column:4},end:{line:99,column:6}},'35':{start:{line:102,column:43},end:{line:107,column:1}},'36':{start:{line:103,column:4},end:{line:106,column:6}},'37':{start:{line:109,column:44},end:{line:113,column:1}},'38':{start:{line:110,column:4},end:{line:112,column:6}},'39':{start:{line:115,column:39},end:{line:126,column:1}},'40':{start:{line:116,column:4},end:{line:125,column:6}},'41':{start:{line:117,column:8},end:{line:117,column:49}},'42':{start:{line:118,column:8},end:{line:124,column:16}},'43':{start:{line:120,column:16},end:{line:120,column:76}},'44':{start:{line:123,column:16},end:{line:123,column:65}},'45':{start:{line:129,column:44},end:{line:133,column:1}},'46':{start:{line:130,column:4},end:{line:132,column:6}},'47':{start:{line:135,column:46},end:{line:139,column:1}},'48':{start:{line:136,column:4},end:{line:138,column:6}},'49':{start:{line:141,column:43},end:{line:146,column:1}},'50':{start:{line:142,column:4},end:{line:145,column:6}},'51':{start:{line:148,column:44},end:{line:152,column:1}},'52':{start:{line:149,column:4},end:{line:151,column:6}},'53':{start:{line:154,column:39},end:{line:171,column:1}},'54':{start:{line:155,column:4},end:{line:170,column:6}},'55':{start:{line:156,column:8},end:{line:156,column:49}},'56':{start:{line:157,column:8},end:{line:169,column:16}},'57':{start:{line:159,column:16},end:{line:159,column:62}},'58':{start:{line:162,column:16},end:{line:167,column:17}},'59':{start:{line:163,column:20},end:{line:163,column:161}},'60':{start:{line:166,column:20},end:{line:166,column:202}},'61':{start:{line:168,column:16},end:{line:168,column:65}},'62':{start:{line:174,column:43},end:{line:178,column:1}},'63':{start:{line:175,column:4},end:{line:177,column:6}},'64':{start:{line:180,column:45},end:{line:185,column:1}},'65':{start:{line:181,column:4},end:{line:184,column:6}},'66':{start:{line:187,column:42},end:{line:192,column:1}},'67':{start:{line:188,column:4},end:{line:191,column:6}},'68':{start:{line:194,column:43},end:{line:198,column:1}},'69':{start:{line:195,column:4},end:{line:197,column:6}},'70':{start:{line:200,column:38},end:{line:217,column:1}},'71':{start:{line:201,column:4},end:{line:216,column:6}},'72':{start:{line:202,column:8},end:{line:202,column:48}},'73':{start:{line:203,column:8},end:{line:215,column:16}},'74':{start:{line:205,column:16},end:{line:205,column:75}},'75':{start:{line:208,column:16},end:{line:213,column:17}},'76':{start:{line:209,column:20},end:{line:209,column:161}},'77':{start:{line:212,column:20},end:{line:212,column:175}},'78':{start:{line:214,column:16},end:{line:214,column:64}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:44},end:{line:5,column:45}},loc:{start:{line:5,column:50},end:{line:9,column:1}},line:5},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:46},end:{line:11,column:47}},loc:{start:{line:11,column:59},end:{line:16,column:1}},line:11},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:43},end:{line:18,column:44}},loc:{start:{line:18,column:56},end:{line:23,column:1}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:44},end:{line:25,column:45}},loc:{start:{line:25,column:51},end:{line:29,column:1}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:31,column:39},end:{line:31,column:40}},loc:{start:{line:31,column:53},end:{line:42,column:1}},line:31},'5':{name:'(anonymous_5)',decl:{start:{line:32,column:11},end:{line:32,column:12}},loc:{start:{line:32,column:23},end:{line:41,column:5}},line:32},'6':{name:'(anonymous_6)',decl:{start:{line:35,column:19},end:{line:35,column:20}},loc:{start:{line:35,column:31},end:{line:37,column:13}},line:35},'7':{name:'(anonymous_7)',decl:{start:{line:38,column:20},end:{line:38,column:21}},loc:{start:{line:38,column:29},end:{line:40,column:13}},line:38},'8':{name:'(anonymous_8)',decl:{start:{line:45,column:54},end:{line:45,column:55}},loc:{start:{line:45,column:76},end:{line:50,column:1}},line:45},'9':{name:'(anonymous_9)',decl:{start:{line:52,column:51},end:{line:52,column:52}},loc:{start:{line:52,column:64},end:{line:57,column:1}},line:52},'10':{name:'(anonymous_10)',decl:{start:{line:59,column:52},end:{line:59,column:53}},loc:{start:{line:59,column:58},end:{line:63,column:1}},line:59},'11':{name:'(anonymous_11)',decl:{start:{line:65,column:52},end:{line:65,column:53}},loc:{start:{line:65,column:58},end:{line:69,column:1}},line:65},'12':{name:'(anonymous_12)',decl:{start:{line:71,column:47},end:{line:71,column:48}},loc:{start:{line:71,column:61},end:{line:86,column:1}},line:71},'13':{name:'(anonymous_13)',decl:{start:{line:72,column:11},end:{line:72,column:12}},loc:{start:{line:72,column:23},end:{line:85,column:5}},line:72},'14':{name:'(anonymous_14)',decl:{start:{line:79,column:19},end:{line:79,column:20}},loc:{start:{line:79,column:31},end:{line:81,column:13}},line:79},'15':{name:'(anonymous_15)',decl:{start:{line:82,column:20},end:{line:82,column:21}},loc:{start:{line:82,column:29},end:{line:84,column:13}},line:82},'16':{name:'(anonymous_16)',decl:{start:{line:89,column:44},end:{line:89,column:45}},loc:{start:{line:89,column:50},end:{line:93,column:1}},line:89},'17':{name:'(anonymous_17)',decl:{start:{line:95,column:46},end:{line:95,column:47}},loc:{start:{line:95,column:59},end:{line:100,column:1}},line:95},'18':{name:'(anonymous_18)',decl:{start:{line:102,column:43},end:{line:102,column:44}},loc:{start:{line:102,column:56},end:{line:107,column:1}},line:102},'19':{name:'(anonymous_19)',decl:{start:{line:109,column:44},end:{line:109,column:45}},loc:{start:{line:109,column:51},end:{line:113,column:1}},line:109},'20':{name:'(anonymous_20)',decl:{start:{line:115,column:39},end:{line:115,column:40}},loc:{start:{line:115,column:57},end:{line:126,column:1}},line:115},'21':{name:'(anonymous_21)',decl:{start:{line:116,column:11},end:{line:116,column:12}},loc:{start:{line:116,column:23},end:{line:125,column:5}},line:116},'22':{name:'(anonymous_22)',decl:{start:{line:119,column:19},end:{line:119,column:20}},loc:{start:{line:119,column:31},end:{line:121,column:13}},line:119},'23':{name:'(anonymous_23)',decl:{start:{line:122,column:20},end:{line:122,column:21}},loc:{start:{line:122,column:29},end:{line:124,column:13}},line:122},'24':{name:'(anonymous_24)',decl:{start:{line:129,column:44},end:{line:129,column:45}},loc:{start:{line:129,column:51},end:{line:133,column:1}},line:129},'25':{name:'(anonymous_25)',decl:{start:{line:135,column:46},end:{line:135,column:47}},loc:{start:{line:135,column:53},end:{line:139,column:1}},line:135},'26':{name:'(anonymous_26)',decl:{start:{line:141,column:43},end:{line:141,column:44}},loc:{start:{line:141,column:56},end:{line:146,column:1}},line:141},'27':{name:'(anonymous_27)',decl:{start:{line:148,column:44},end:{line:148,column:45}},loc:{start:{line:148,column:51},end:{line:152,column:1}},line:148},'28':{name:'(anonymous_28)',decl:{start:{line:154,column:39},end:{line:154,column:40}},loc:{start:{line:154,column:57},end:{line:171,column:1}},line:154},'29':{name:'(anonymous_29)',decl:{start:{line:155,column:11},end:{line:155,column:12}},loc:{start:{line:155,column:23},end:{line:170,column:5}},line:155},'30':{name:'(anonymous_30)',decl:{start:{line:158,column:19},end:{line:158,column:20}},loc:{start:{line:158,column:31},end:{line:160,column:13}},line:158},'31':{name:'(anonymous_31)',decl:{start:{line:161,column:20},end:{line:161,column:21}},loc:{start:{line:161,column:29},end:{line:169,column:13}},line:161},'32':{name:'(anonymous_32)',decl:{start:{line:174,column:43},end:{line:174,column:44}},loc:{start:{line:174,column:49},end:{line:178,column:1}},line:174},'33':{name:'(anonymous_33)',decl:{start:{line:180,column:45},end:{line:180,column:46}},loc:{start:{line:180,column:58},end:{line:185,column:1}},line:180},'34':{name:'(anonymous_34)',decl:{start:{line:187,column:42},end:{line:187,column:43}},loc:{start:{line:187,column:55},end:{line:192,column:1}},line:187},'35':{name:'(anonymous_35)',decl:{start:{line:194,column:43},end:{line:194,column:44}},loc:{start:{line:194,column:50},end:{line:198,column:1}},line:194},'36':{name:'(anonymous_36)',decl:{start:{line:200,column:38},end:{line:200,column:39}},loc:{start:{line:200,column:46},end:{line:217,column:1}},line:200},'37':{name:'(anonymous_37)',decl:{start:{line:201,column:11},end:{line:201,column:12}},loc:{start:{line:201,column:23},end:{line:216,column:5}},line:201},'38':{name:'(anonymous_38)',decl:{start:{line:204,column:19},end:{line:204,column:20}},loc:{start:{line:204,column:31},end:{line:206,column:13}},line:204},'39':{name:'(anonymous_39)',decl:{start:{line:207,column:20},end:{line:207,column:21}},loc:{start:{line:207,column:29},end:{line:215,column:13}},line:207}},branchMap:{'0':{loc:{start:{line:75,column:8},end:{line:77,column:9}},type:'if',locations:[{start:{line:75,column:8},end:{line:77,column:9}},{start:{line:75,column:8},end:{line:77,column:9}}],line:75},'1':{loc:{start:{line:162,column:16},end:{line:167,column:17}},type:'if',locations:[{start:{line:162,column:16},end:{line:167,column:17}},{start:{line:162,column:16},end:{line:167,column:17}}],line:162},'2':{loc:{start:{line:162,column:19},end:{line:162,column:53}},type:'binary-expr',locations:[{start:{line:162,column:19},end:{line:162,column:31}},{start:{line:162,column:35},end:{line:162,column:53}}],line:162},'3':{loc:{start:{line:208,column:16},end:{line:213,column:17}},type:'if',locations:[{start:{line:208,column:16},end:{line:213,column:17}},{start:{line:208,column:16},end:{line:213,column:17}}],line:208},'4':{loc:{start:{line:208,column:19},end:{line:208,column:53}},type:'binary-expr',locations:[{start:{line:208,column:19},end:{line:208,column:31}},{start:{line:208,column:35},end:{line:208,column:53}}],line:208}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();/* ------------------ Machine Create ------------------- */cov_5bfrpgxep.s[0]++;var calculatorMachineCreateStart=function calculatorMachineCreateStart(){cov_5bfrpgxep.f[0]++;cov_5bfrpgxep.s[1]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_25" /* CALCULATOR_MACHINE_CREATE_START */]};};cov_5bfrpgxep.s[2]++;var calculatorMachineCreateSuccess=function calculatorMachineCreateSuccess(machine){cov_5bfrpgxep.f[1]++;cov_5bfrpgxep.s[3]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_26" /* CALCULATOR_MACHINE_CREATE_SUCCESS */],machine:machine};};cov_5bfrpgxep.s[4]++;var calculatorMachineCreateFail=function calculatorMachineCreateFail(error){cov_5bfrpgxep.f[2]++;cov_5bfrpgxep.s[5]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_23" /* CALCULATOR_MACHINE_CREATE_FAIL */],error:error};};cov_5bfrpgxep.s[6]++;var calculatorMachineCreateReset=function calculatorMachineCreateReset(){cov_5bfrpgxep.f[3]++;cov_5bfrpgxep.s[7]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_24" /* CALCULATOR_MACHINE_CREATE_RESET */]};};cov_5bfrpgxep.s[8]++;var calculatorMachineCreate=function calculatorMachineCreate(formData){cov_5bfrpgxep.f[4]++;cov_5bfrpgxep.s[9]++;return function(dispatch){cov_5bfrpgxep.f[5]++;cov_5bfrpgxep.s[10]++;dispatch(calculatorMachineCreateStart());cov_5bfrpgxep.s[11]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].post('/production/calculator/machines',formData).then(function(response){cov_5bfrpgxep.f[6]++;cov_5bfrpgxep.s[12]++;dispatch(calculatorMachineCreateSuccess(response.data));}).catch(function(error){cov_5bfrpgxep.f[7]++;cov_5bfrpgxep.s[13]++;dispatch(calculatorMachineCreateFail(error));});};};/* ----------------- Machine Duplicate ------------------ */cov_5bfrpgxep.s[14]++;var calculatorMachineDuplicateCheckSuccess=function calculatorMachineDuplicateCheckSuccess(name_duplicate){cov_5bfrpgxep.f[8]++;cov_5bfrpgxep.s[15]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_34" /* CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS */],name_duplicate:name_duplicate};};cov_5bfrpgxep.s[16]++;var calculatorMachineDuplicateCheckFail=function calculatorMachineDuplicateCheckFail(error){cov_5bfrpgxep.f[9]++;cov_5bfrpgxep.s[17]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_31" /* CALCULATOR_MACHINE_DUPLICATECHECK_FAIL */],error:error};};cov_5bfrpgxep.s[18]++;var calculatorMachineDuplicateCheckStart=function calculatorMachineDuplicateCheckStart(){cov_5bfrpgxep.f[10]++;cov_5bfrpgxep.s[19]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_33" /* CALCULATOR_MACHINE_DUPLICATECHECK_START */]};};cov_5bfrpgxep.s[20]++;var calculatorMachineDuplicateCheckReset=function calculatorMachineDuplicateCheckReset(){cov_5bfrpgxep.f[11]++;cov_5bfrpgxep.s[21]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_32" /* CALCULATOR_MACHINE_DUPLICATECHECK_RESET */]};};cov_5bfrpgxep.s[22]++;var calculatorMachineDuplicateCheck=function calculatorMachineDuplicateCheck(formData){cov_5bfrpgxep.f[12]++;cov_5bfrpgxep.s[23]++;return function(dispatch){cov_5bfrpgxep.f[13]++;cov_5bfrpgxep.s[24]++;dispatch(calculatorMachineDuplicateCheckStart());var urlString=(cov_5bfrpgxep.s[25]++,'/production/calculator/machines/duplicate?name='+formData.name);cov_5bfrpgxep.s[26]++;if(formData.id){cov_5bfrpgxep.b[0][0]++;cov_5bfrpgxep.s[27]++;urlString=urlString+"&machineId="+formData.id;}else{cov_5bfrpgxep.b[0][1]++;}cov_5bfrpgxep.s[28]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get(urlString,{hideGlobalSpinner:true}).then(function(response){cov_5bfrpgxep.f[14]++;cov_5bfrpgxep.s[29]++;dispatch(calculatorMachineDuplicateCheckSuccess(response.data.result));}).catch(function(error){cov_5bfrpgxep.f[15]++;cov_5bfrpgxep.s[30]++;dispatch(calculatorMachineDuplicateCheckFail(error));});};};/* ------------------ Machine Update ------------------- */cov_5bfrpgxep.s[31]++;var calculatorMachineUpdateStart=function calculatorMachineUpdateStart(){cov_5bfrpgxep.f[16]++;cov_5bfrpgxep.s[32]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_41" /* CALCULATOR_MACHINE_UPDATE_START */]};};cov_5bfrpgxep.s[33]++;var calculatorMachineUpdateSuccess=function calculatorMachineUpdateSuccess(machine){cov_5bfrpgxep.f[17]++;cov_5bfrpgxep.s[34]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_42" /* CALCULATOR_MACHINE_UPDATE_SUCCESS */],machine:machine};};cov_5bfrpgxep.s[35]++;var calculatorMachineUpdateFail=function calculatorMachineUpdateFail(error){cov_5bfrpgxep.f[18]++;cov_5bfrpgxep.s[36]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_39" /* CALCULATOR_MACHINE_UPDATE_FAIL */],error:error};};cov_5bfrpgxep.s[37]++;var calculatorMachineUpdateReset=function calculatorMachineUpdateReset(){cov_5bfrpgxep.f[19]++;cov_5bfrpgxep.s[38]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_40" /* CALCULATOR_MACHINE_UPDATE_RESET */]};};cov_5bfrpgxep.s[39]++;var calculatorMachineUpdate=function calculatorMachineUpdate(id,formData){cov_5bfrpgxep.f[20]++;cov_5bfrpgxep.s[40]++;return function(dispatch){cov_5bfrpgxep.f[21]++;cov_5bfrpgxep.s[41]++;dispatch(calculatorMachineUpdateStart());cov_5bfrpgxep.s[42]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].put('/production/calculator/machines/'+id,formData).then(function(response){cov_5bfrpgxep.f[22]++;cov_5bfrpgxep.s[43]++;dispatch(calculatorMachineUpdateSuccess(response.data));}).catch(function(error){cov_5bfrpgxep.f[23]++;cov_5bfrpgxep.s[44]++;dispatch(calculatorMachineUpdateFail(error));});};};/* ------------------ Machine Delete ------------------- */cov_5bfrpgxep.s[45]++;var calculatorMachineDeleteStart=function calculatorMachineDeleteStart(){cov_5bfrpgxep.f[24]++;cov_5bfrpgxep.s[46]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_29" /* CALCULATOR_MACHINE_DELETE_START */]};};cov_5bfrpgxep.s[47]++;var calculatorMachineDeleteSuccess=function calculatorMachineDeleteSuccess(){cov_5bfrpgxep.f[25]++;cov_5bfrpgxep.s[48]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_30" /* CALCULATOR_MACHINE_DELETE_SUCCESS */]};};cov_5bfrpgxep.s[49]++;var calculatorMachineDeleteFail=function calculatorMachineDeleteFail(error){cov_5bfrpgxep.f[26]++;cov_5bfrpgxep.s[50]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_27" /* CALCULATOR_MACHINE_DELETE_FAIL */],error:error};};cov_5bfrpgxep.s[51]++;var calculatorMachineDeleteReset=function calculatorMachineDeleteReset(){cov_5bfrpgxep.f[27]++;cov_5bfrpgxep.s[52]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_28" /* CALCULATOR_MACHINE_DELETE_RESET */]};};cov_5bfrpgxep.s[53]++;var calculatorMachineDelete=function calculatorMachineDelete(id,formData){cov_5bfrpgxep.f[28]++;cov_5bfrpgxep.s[54]++;return function(dispatch){cov_5bfrpgxep.f[29]++;cov_5bfrpgxep.s[55]++;dispatch(calculatorMachineDeleteStart());cov_5bfrpgxep.s[56]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].delete('/production/calculator/machines/'+id,formData).then(function(response){cov_5bfrpgxep.f[30]++;cov_5bfrpgxep.s[57]++;dispatch(calculatorMachineDeleteSuccess());}).catch(function(error){cov_5bfrpgxep.f[31]++;cov_5bfrpgxep.s[58]++;if((cov_5bfrpgxep.b[2][0]++,error.length)&&(cov_5bfrpgxep.b[2][1]++,error.length===1)){cov_5bfrpgxep.b[1][0]++;cov_5bfrpgxep.s[59]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machine",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_5bfrpgxep.b[1][1]++;cov_5bfrpgxep.s[60]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machine",key:"default",message:"There was an error, please try it again later.",type:'error',obj:error}});}cov_5bfrpgxep.s[61]++;dispatch(calculatorMachineDeleteFail(error));});};};/* ------------------ Machine Fetch ------------------- */cov_5bfrpgxep.s[62]++;var calculatorMachineFetchStart=function calculatorMachineFetchStart(){cov_5bfrpgxep.f[32]++;cov_5bfrpgxep.s[63]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_37" /* CALCULATOR_MACHINE_FETCH_START */]};};cov_5bfrpgxep.s[64]++;var calculatorMachineFetchSuccess=function calculatorMachineFetchSuccess(machine){cov_5bfrpgxep.f[33]++;cov_5bfrpgxep.s[65]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_38" /* CALCULATOR_MACHINE_FETCH_SUCCESS */],machine:machine};};cov_5bfrpgxep.s[66]++;var calculatorMachineFetchFail=function calculatorMachineFetchFail(error){cov_5bfrpgxep.f[34]++;cov_5bfrpgxep.s[67]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_35" /* CALCULATOR_MACHINE_FETCH_FAIL */],error:error};};cov_5bfrpgxep.s[68]++;var calculatorMachineFetchReset=function calculatorMachineFetchReset(){cov_5bfrpgxep.f[35]++;cov_5bfrpgxep.s[69]++;return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_36" /* CALCULATOR_MACHINE_FETCH_RESET */]};};cov_5bfrpgxep.s[70]++;var calculatorMachineFetch=function calculatorMachineFetch(id){cov_5bfrpgxep.f[36]++;cov_5bfrpgxep.s[71]++;return function(dispatch){cov_5bfrpgxep.f[37]++;cov_5bfrpgxep.s[72]++;dispatch(calculatorMachineFetchStart());cov_5bfrpgxep.s[73]++;__WEBPACK_IMPORTED_MODULE_1__services_api_axios__["a" /* default */].get('/production/calculator/machines/'+id).then(function(response){cov_5bfrpgxep.f[38]++;cov_5bfrpgxep.s[74]++;dispatch(calculatorMachineFetchSuccess(response.data));}).catch(function(error){cov_5bfrpgxep.f[39]++;cov_5bfrpgxep.s[75]++;if((cov_5bfrpgxep.b[4][0]++,error.length)&&(cov_5bfrpgxep.b[4][1]++,error.length===1)){cov_5bfrpgxep.b[3][0]++;cov_5bfrpgxep.s[76]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machine",key:error[0].key,message:error[0].message,type:'error'}});}else{cov_5bfrpgxep.b[3][1]++;cov_5bfrpgxep.s[77]++;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* VISUALMESSAGE_SET */],payload:{scope:"machine",key:"not_exist",message:"Machine not found",type:'error',obj:error}});}cov_5bfrpgxep.s[78]++;dispatch(calculatorMachineFetchFail(error));});};};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./atoms/AccordionSection/index.js": 381,
	"./atoms/BoxTitle/index.js": 383,
	"./atoms/Button/index.js": 385,
	"./atoms/DatePicker/index.js": 387,
	"./atoms/DonutChart/index.js": 536,
	"./atoms/Flex/index.js": 538,
	"./atoms/FlexColumn/index.js": 540,
	"./atoms/GreyBoxContent/index.js": 542,
	"./atoms/GreyBoxExtra/index.js": 544,
	"./atoms/GreyBoxMessage/index.js": 546,
	"./atoms/Hint/index.js": 548,
	"./atoms/Icon/index.js": 550,
	"./atoms/InfoText/index.js": 590,
	"./atoms/Input/index.js": 592,
	"./atoms/Label/index.js": 594,
	"./atoms/Logo/index.js": 596,
	"./atoms/PageTitle/index.js": 599,
	"./atoms/Radio/index.js": 601,
	"./atoms/Select/index.js": 603,
	"./atoms/Spacer/index.js": 605,
	"./atoms/Spinner/index.js": 607,
	"./atoms/Text/index.js": 609,
	"./atoms/Toggle/index.js": 611,
	"./atoms/UploadButton/index.js": 614,
	"./molecules/Accordion/index.js": 616,
	"./molecules/ActionsNav/index.js": 618,
	"./molecules/Blur/index.js": 225,
	"./molecules/CodeVerifier/index.js": 621,
	"./molecules/InputRow/index.js": 623,
	"./molecules/MainNav/index.js": 636,
	"./molecules/MetaNav/index.js": 638,
	"./molecules/Steps/index.js": 640,
	"./molecules/Tabs/index.js": 642,
	"./molecules/UserNavItem/index.js": 644,
	"./molecules/UserNavItemPopover/index.js": 646,
	"./organisms/Box/index.js": 648,
	"./organisms/Confirm/index.js": 650,
	"./organisms/Form/index.js": 651,
	"./organisms/GreyBox/index.js": 653,
	"./organisms/Header/index.js": 655,
	"./organisms/Loading/index.js": 657,
	"./organisms/Machine/index.js": 658,
	"./organisms/Menu/index.js": 660,
	"./organisms/Modal/index.js": 662,
	"./pages/JobPage/index.js": 664,
	"./pages/JobsNewPage/index.js": 670,
	"./pages/JobsPage/index.js": 671,
	"./pages/MachinesNewPage/index.js": 672,
	"./pages/MachinesPage/index.js": 673,
	"./pages/NotFoundPage/index.js": 675,
	"./pages/SettingsCompanyPage/index.js": 676,
	"./pages/SettingsJobPresetsPage/index.js": 677,
	"./templates/PageTemplate/index.js": 678
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 380;

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss__);
var cov_2j7r0hsf5v=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\AccordionSection\\index.js',hash='d38eaeb570b899fa6332dc62a3808c95a236d10c',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\AccordionSection\\index.js',statementMap:{'0':{start:{line:14,column:4},end:{line:26,column:5}},'1':{start:{line:15,column:6},end:{line:25,column:7}},'2':{start:{line:16,column:8},end:{line:19,column:11}},'3':{start:{line:21,column:8},end:{line:24,column:11}},'4':{start:{line:30,column:4},end:{line:40,column:5}},'5':{start:{line:31,column:6},end:{line:34,column:9}},'6':{start:{line:36,column:6},end:{line:39,column:9}},'7':{start:{line:45,column:21},end:{line:45,column:37}},'8':{start:{line:47,column:4},end:{line:49,column:5}},'9':{start:{line:48,column:6},end:{line:48,column:53}},'10':{start:{line:50,column:4},end:{line:52,column:5}},'11':{start:{line:51,column:6},end:{line:51,column:59}},'12':{start:{line:54,column:5},end:{line:65,column:6}},'13':{start:{line:55,column:8},end:{line:60,column:25}},'14':{start:{line:62,column:8},end:{line:64,column:25}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:23},end:{line:13,column:24}},loc:{start:{line:13,column:59},end:{line:27,column:3}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:29,column:15},end:{line:29,column:16}},loc:{start:{line:29,column:21},end:{line:41,column:3}},line:29},'2':{name:'(anonymous_2)',decl:{start:{line:44,column:2},end:{line:44,column:3}},loc:{start:{line:44,column:11},end:{line:66,column:3}},line:44}},branchMap:{'0':{loc:{start:{line:14,column:4},end:{line:26,column:5}},type:'if',locations:[{start:{line:14,column:4},end:{line:26,column:5}},{start:{line:14,column:4},end:{line:26,column:5}}],line:14},'1':{loc:{start:{line:15,column:6},end:{line:25,column:7}},type:'if',locations:[{start:{line:15,column:6},end:{line:25,column:7}},{start:{line:15,column:6},end:{line:25,column:7}}],line:15},'2':{loc:{start:{line:30,column:4},end:{line:40,column:5}},type:'if',locations:[{start:{line:30,column:4},end:{line:40,column:5}},{start:{line:30,column:4},end:{line:40,column:5}}],line:30},'3':{loc:{start:{line:47,column:4},end:{line:49,column:5}},type:'if',locations:[{start:{line:47,column:4},end:{line:49,column:5}},{start:{line:47,column:4},end:{line:49,column:5}}],line:47},'4':{loc:{start:{line:50,column:4},end:{line:52,column:5}},type:'if',locations:[{start:{line:50,column:4},end:{line:52,column:5}},{start:{line:50,column:4},end:{line:52,column:5}}],line:50},'5':{loc:{start:{line:54,column:5},end:{line:65,column:6}},type:'if',locations:[{start:{line:54,column:5},end:{line:65,column:6}},{start:{line:54,column:5},end:{line:65,column:6}}],line:54}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionSection=function(_ref){_inherits(AccordionSection,_ref);function AccordionSection(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,AccordionSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=AccordionSection.__proto__||Object.getPrototypeOf(AccordionSection)).call.apply(_ref2,[this].concat(args))),_this),_this.state={open:false,class:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionSection},_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_2j7r0hsf5v.f[0]++;cov_2j7r0hsf5v.s[0]++;if(prevProps.globalState!==_this.props.globalState){cov_2j7r0hsf5v.b[0][0]++;cov_2j7r0hsf5v.s[1]++;if(_this.props.globalState=='closed'){cov_2j7r0hsf5v.b[1][0]++;cov_2j7r0hsf5v.s[2]++;_this.setState({open:false,class:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionSection});}else{cov_2j7r0hsf5v.b[1][1]++;cov_2j7r0hsf5v.s[3]++;_this.setState({open:true,class:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionSection+' '+__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.open});}}else{cov_2j7r0hsf5v.b[0][1]++;}},_this.handleClick=function(){cov_2j7r0hsf5v.f[1]++;cov_2j7r0hsf5v.s[4]++;if(_this.state.open){cov_2j7r0hsf5v.b[2][0]++;cov_2j7r0hsf5v.s[5]++;_this.setState({open:false,class:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionSection});}else{cov_2j7r0hsf5v.b[2][1]++;cov_2j7r0hsf5v.s[6]++;_this.setState({open:true,class:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionSection+' '+__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.open});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccordionSection,[{key:'render',value:function render(){cov_2j7r0hsf5v.f[2]++;var classNames=(cov_2j7r0hsf5v.s[7]++,this.state.class);cov_2j7r0hsf5v.s[8]++;if(this.props.theme=="total"){cov_2j7r0hsf5v.b[3][0]++;cov_2j7r0hsf5v.s[9]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.isTotal;}else{cov_2j7r0hsf5v.b[3][1]++;}cov_2j7r0hsf5v.s[10]++;if(this.props.theme=="totalDouble"){cov_2j7r0hsf5v.b[4][0]++;cov_2j7r0hsf5v.s[11]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.isTotalDouble;}else{cov_2j7r0hsf5v.b[4][1]++;}cov_2j7r0hsf5v.s[12]++;if(this.props.children){cov_2j7r0hsf5v.b[5][0]++;cov_2j7r0hsf5v.s[13]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.title,onClick:this.handleClick},this.props.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.titleValue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.accordionContent},this.props.children));}else{cov_2j7r0hsf5v.b[5][1]++;cov_2j7r0hsf5v.s[14]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames+' '+__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.notExpandable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_1__AccordionSection_scss___default.a.title},this.props.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.titleValue)));}}}]);return AccordionSection;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (AccordionSection);

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"accordionSection":"AccordionSection__accordionSection___1WKdL","isTotal":"AccordionSection__isTotal___2mV-y","title":"AccordionSection__title___1fRQ0","isTotalDouble":"AccordionSection__isTotalDouble___3j-A_","accordionContent":"AccordionSection__accordionContent___Hmnqu","notExpandable":"AccordionSection__notExpandable___30FAI","open":"AccordionSection__open___9LfGl"};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss__);
var cov_6gyjxr3pw=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\BoxTitle\\index.js',hash='6c96e7edac04b82e421f7dccde5ad83f80fe871a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\BoxTitle\\index.js',statementMap:{'0':{start:{line:5,column:17},end:{line:31,column:1}},'1':{start:{line:6,column:18},end:{line:6,column:33}},'2':{start:{line:7,column:21},end:{line:7,column:23}},'3':{start:{line:10,column:1},end:{line:12,column:2}},'4':{start:{line:11,column:2},end:{line:11,column:50}},'5':{start:{line:14,column:2},end:{line:17,column:3}},'6':{start:{line:15,column:4},end:{line:15,column:51}},'7':{start:{line:16,column:4},end:{line:16,column:42}},'8':{start:{line:19,column:2},end:{line:21,column:3}},'9':{start:{line:20,column:4},end:{line:20,column:50}},'10':{start:{line:24,column:2},end:{line:30,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:17},end:{line:5,column:18}},loc:{start:{line:5,column:28},end:{line:31,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:10,column:1},end:{line:12,column:2}},type:'if',locations:[{start:{line:10,column:1},end:{line:12,column:2}},{start:{line:10,column:1},end:{line:12,column:2}}],line:10},'1':{loc:{start:{line:14,column:2},end:{line:17,column:3}},type:'if',locations:[{start:{line:14,column:2},end:{line:17,column:3}},{start:{line:14,column:2},end:{line:17,column:3}}],line:14},'2':{loc:{start:{line:19,column:2},end:{line:21,column:3}},type:'if',locations:[{start:{line:19,column:2},end:{line:21,column:3}},{start:{line:19,column:2},end:{line:21,column:3}}],line:19}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_6gyjxr3pw.s[0]++;var BoxTitle=function BoxTitle(props){cov_6gyjxr3pw.f[0]++;var classNames=(cov_6gyjxr3pw.s[1]++,__WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss___default.a.boxTitle);var customStyles=(cov_6gyjxr3pw.s[2]++,{});cov_6gyjxr3pw.s[3]++;if(props.type=='nopadding'){cov_6gyjxr3pw.b[0][0]++;cov_6gyjxr3pw.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss___default.a.noPadding;}else{cov_6gyjxr3pw.b[0][1]++;}cov_6gyjxr3pw.s[5]++;if(props.ellipsis){cov_6gyjxr3pw.b[1][0]++;cov_6gyjxr3pw.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss___default.a.ellipsis;cov_6gyjxr3pw.s[7]++;customStyles={width:props.ellipsis};}else{cov_6gyjxr3pw.b[1][1]++;}cov_6gyjxr3pw.s[8]++;if(props.small){cov_6gyjxr3pw.b[2][0]++;cov_6gyjxr3pw.s[9]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__BoxTitle_scss___default.a.isSmall;}else{cov_6gyjxr3pw.b[2][1]++;}cov_6gyjxr3pw.s[10]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:classNames,style:customStyles},props.children);};/* harmony default export */ __webpack_exports__["default"] = (BoxTitle);

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"boxTitle":"BoxTitle__boxTitle___3QiG7","isSmall":"BoxTitle__isSmall___1fSd9","ellipsis":"BoxTitle__ellipsis___j43w6","noPadding":"BoxTitle__noPadding___2MKfY"};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_scss__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Button_scss__);
var cov_1qhyapgat6=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Button\\index.js',hash='e0944716f9f57db67397174617f1ffd6ebbcfed9',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Button\\index.js',statementMap:{'0':{start:{line:7,column:15},end:{line:61,column:1}},'1':{start:{line:8,column:18},end:{line:8,column:33}},'2':{start:{line:9,column:2},end:{line:11,column:3}},'3':{start:{line:10,column:4},end:{line:10,column:49}},'4':{start:{line:13,column:2},end:{line:15,column:3}},'5':{start:{line:14,column:4},end:{line:14,column:50}},'6':{start:{line:17,column:2},end:{line:19,column:3}},'7':{start:{line:18,column:4},end:{line:18,column:55}},'8':{start:{line:21,column:2},end:{line:23,column:3}},'9':{start:{line:22,column:4},end:{line:22,column:49}},'10':{start:{line:25,column:2},end:{line:27,column:3}},'11':{start:{line:26,column:4},end:{line:26,column:54}},'12':{start:{line:29,column:2},end:{line:31,column:3}},'13':{start:{line:30,column:4},end:{line:30,column:51}},'14':{start:{line:32,column:2},end:{line:34,column:3}},'15':{start:{line:33,column:4},end:{line:33,column:57}},'16':{start:{line:36,column:2},end:{line:38,column:3}},'17':{start:{line:37,column:4},end:{line:37,column:54}},'18':{start:{line:40,column:2},end:{line:60,column:3}},'19':{start:{line:41,column:4},end:{line:49,column:5}},'20':{start:{line:52,column:4},end:{line:59,column:5}},'21':{start:{line:63,column:0},end:{line:65,column:1}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:15},end:{line:7,column:16}},loc:{start:{line:7,column:28},end:{line:61,column:1}},line:7}},branchMap:{'0':{loc:{start:{line:9,column:2},end:{line:11,column:3}},type:'if',locations:[{start:{line:9,column:2},end:{line:11,column:3}},{start:{line:9,column:2},end:{line:11,column:3}}],line:9},'1':{loc:{start:{line:13,column:2},end:{line:15,column:3}},type:'if',locations:[{start:{line:13,column:2},end:{line:15,column:3}},{start:{line:13,column:2},end:{line:15,column:3}}],line:13},'2':{loc:{start:{line:17,column:2},end:{line:19,column:3}},type:'if',locations:[{start:{line:17,column:2},end:{line:19,column:3}},{start:{line:17,column:2},end:{line:19,column:3}}],line:17},'3':{loc:{start:{line:21,column:2},end:{line:23,column:3}},type:'if',locations:[{start:{line:21,column:2},end:{line:23,column:3}},{start:{line:21,column:2},end:{line:23,column:3}}],line:21},'4':{loc:{start:{line:25,column:2},end:{line:27,column:3}},type:'if',locations:[{start:{line:25,column:2},end:{line:27,column:3}},{start:{line:25,column:2},end:{line:27,column:3}}],line:25},'5':{loc:{start:{line:29,column:2},end:{line:31,column:3}},type:'if',locations:[{start:{line:29,column:2},end:{line:31,column:3}},{start:{line:29,column:2},end:{line:31,column:3}}],line:29},'6':{loc:{start:{line:32,column:2},end:{line:34,column:3}},type:'if',locations:[{start:{line:32,column:2},end:{line:34,column:3}},{start:{line:32,column:2},end:{line:34,column:3}}],line:32},'7':{loc:{start:{line:36,column:2},end:{line:38,column:3}},type:'if',locations:[{start:{line:36,column:2},end:{line:38,column:3}},{start:{line:36,column:2},end:{line:38,column:3}}],line:36},'8':{loc:{start:{line:40,column:2},end:{line:60,column:3}},type:'if',locations:[{start:{line:40,column:2},end:{line:60,column:3}},{start:{line:40,column:2},end:{line:60,column:3}}],line:40},'9':{loc:{start:{line:44,column:17},end:{line:44,column:51}},type:'cond-expr',locations:[{start:{line:44,column:31},end:{line:44,column:42}},{start:{line:44,column:45},end:{line:44,column:51}}],line:44},'10':{loc:{start:{line:55,column:25},end:{line:55,column:59}},type:'cond-expr',locations:[{start:{line:55,column:39},end:{line:55,column:50}},{start:{line:55,column:53},end:{line:55,column:59}}],line:55}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1qhyapgat6.s[0]++;var Button=function Button(props){cov_1qhyapgat6.f[0]++;var classNames=(cov_1qhyapgat6.s[1]++,__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.a_button);cov_1qhyapgat6.s[2]++;if(props.theme=='dark'){cov_1qhyapgat6.b[0][0]++;cov_1qhyapgat6.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.isDark;}else{cov_1qhyapgat6.b[0][1]++;}cov_1qhyapgat6.s[4]++;if(props.theme=='light'){cov_1qhyapgat6.b[1][0]++;cov_1qhyapgat6.s[5]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.isLight;}else{cov_1qhyapgat6.b[1][1]++;}cov_1qhyapgat6.s[6]++;if(props.theme=='primelight'){cov_1qhyapgat6.b[2][0]++;cov_1qhyapgat6.s[7]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.isPrimeLight;}else{cov_1qhyapgat6.b[2][1]++;}cov_1qhyapgat6.s[8]++;if(props.margin){cov_1qhyapgat6.b[3][0]++;cov_1qhyapgat6.s[9]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.margin;}else{cov_1qhyapgat6.b[3][1]++;}cov_1qhyapgat6.s[10]++;if(props.outerMargin){cov_1qhyapgat6.b[4][0]++;cov_1qhyapgat6.s[11]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.outerMargin;}else{cov_1qhyapgat6.b[4][1]++;}cov_1qhyapgat6.s[12]++;if(props.nomargin){cov_1qhyapgat6.b[5][0]++;cov_1qhyapgat6.s[13]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.noMargin;}else{cov_1qhyapgat6.b[5][1]++;}cov_1qhyapgat6.s[14]++;if(props.nomargin){cov_1qhyapgat6.b[6][0]++;cov_1qhyapgat6.s[15]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.noMarginMobile;}else{cov_1qhyapgat6.b[6][1]++;}cov_1qhyapgat6.s[16]++;if(props.multiline){cov_1qhyapgat6.b[7][0]++;cov_1qhyapgat6.s[17]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.isMultiline;}else{cov_1qhyapgat6.b[7][1]++;}cov_1qhyapgat6.s[18]++;if(props.href){cov_1qhyapgat6.b[8][0]++;cov_1qhyapgat6.s[19]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],Object.assign({className:[classNames,__WEBPACK_IMPORTED_MODULE_3__Button_scss___default.a.isLink].join(' ')},props,{style:{width:props.width?(cov_1qhyapgat6.b[9][0]++,props.width):(cov_1qhyapgat6.b[9][1]++,'100%')},to:props.href}),props.value);}else{cov_1qhyapgat6.b[8][1]++;cov_1qhyapgat6.s[20]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({className:classNames},props,{style:{width:props.width?(cov_1qhyapgat6.b[10][0]++,props.width):(cov_1qhyapgat6.b[10][1]++,'100%')}}),props.value);}};cov_1qhyapgat6.s[21]++;Button.propTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["default"] = (Button);

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a_button":"Button__a_button___3p3iA","outerMargin":"Button__outerMargin___1CBsp","noMargin":"Button__noMargin___1a4iv","noMarginMobile":"Button__noMarginMobile___1dUxs","isLight":"Button__isLight___2YWRI","margin":"Button__margin___3XIpI","isPrimeLight":"Button__isPrimeLight___ewLzg","isDark":"Button__isDark___2Qt0Y","isLink":"Button__isLink___28ZPC","isMultiline":"Button__isMultiline___7_AlH"};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dates_initialize__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dates_initialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dates_initialize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dates__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_de__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_nl__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_locale_nl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_locale_nl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_es__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_fr__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_locale_it__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_locale_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_locale_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_locale_pt__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_locale_pt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment_locale_pt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DatePicker_scss_nomodule__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DatePicker_scss_nomodule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__DatePicker_scss_nomodule__);
var cov_15fodv7c1y=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\DatePicker\\index.js',hash='a81814c2a7a1c32a9365f036d51a078d7152cb23',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\DatePicker\\index.js',statementMap:{'0':{start:{line:18,column:4},end:{line:18,column:17}},'1':{start:{line:19,column:4},end:{line:23,column:6}},'2':{start:{line:27,column:29},end:{line:27,column:39}},'3':{start:{line:29,column:3},end:{line:29,column:34}},'4':{start:{line:34,column:70},end:{line:34,column:80}},'5':{start:{line:36,column:4},end:{line:61,column:6}},'6':{start:{line:45,column:12},end:{line:45,column:50}},'7':{start:{line:46,column:12},end:{line:46,column:39}},'8':{start:{line:49,column:44},end:{line:49,column:75}},'9':{start:{line:50,column:31},end:{line:50,column:36}},'10':{start:{line:65,column:24},end:{line:69,column:1}},'11':{start:{line:66,column:4},end:{line:68,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:17,column:2},end:{line:17,column:3}},loc:{start:{line:17,column:21},end:{line:24,column:3}},line:17},'1':{name:'(anonymous_1)',decl:{start:{line:26,column:2},end:{line:26,column:3}},loc:{start:{line:26,column:22},end:{line:30,column:3}},line:26},'2':{name:'(anonymous_2)',decl:{start:{line:33,column:2},end:{line:33,column:3}},loc:{start:{line:33,column:11},end:{line:62,column:3}},line:33},'3':{name:'(anonymous_3)',decl:{start:{line:44,column:25},end:{line:44,column:26}},loc:{start:{line:44,column:53},end:{line:47,column:11}},line:44},'4':{name:'(anonymous_4)',decl:{start:{line:49,column:24},end:{line:49,column:25}},loc:{start:{line:49,column:42},end:{line:49,column:76}},line:49},'5':{name:'(anonymous_5)',decl:{start:{line:50,column:25},end:{line:50,column:26}},loc:{start:{line:50,column:31},end:{line:50,column:36}},line:50},'6':{name:'(anonymous_6)',decl:{start:{line:65,column:24},end:{line:65,column:25}},loc:{start:{line:65,column:33},end:{line:69,column:1}},line:65}},branchMap:{},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DatePicker=function(_ref){_inherits(DatePicker,_ref);function DatePicker(props){_classCallCheck(this,DatePicker);cov_15fodv7c1y.f[0]++;cov_15fodv7c1y.s[0]++;var _this=_possibleConstructorReturn(this,(DatePicker.__proto__||Object.getPrototypeOf(DatePicker)).call(this,props));cov_15fodv7c1y.s[1]++;_this.state={startDate:props.startDate,endDate:props.endDate,focusedInput:null};return _this;}_createClass(DatePicker,[{key:'componentDidMount',value:function componentDidMount(){cov_15fodv7c1y.f[1]++;var _ref2=(cov_15fodv7c1y.s[2]++,this.props),currentLanguage=_ref2.currentLanguage;cov_15fodv7c1y.s[3]++;__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale(currentLanguage);}},{key:'render',value:function render(){var _this2=this;cov_15fodv7c1y.f[2]++;var _ref3=(cov_15fodv7c1y.s[4]++,this.props),currentLanguage=_ref3.currentLanguage,startDateLabel=_ref3.startDateLabel,endDateLabel=_ref3.endDateLabel,changed=_ref3.changed;cov_15fodv7c1y.s[5]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_dates__["DateRangePicker"],{startDateId:'start_date',endDateId:'end_date',startDate:this.state.startDate,endDate:this.state.endDate,onDatesChange:function onDatesChange(_ref4){var startDate=_ref4.startDate,endDate=_ref4.endDate;cov_15fodv7c1y.f[3]++;cov_15fodv7c1y.s[6]++;_this2.setState({startDate:startDate,endDate:endDate});cov_15fodv7c1y.s[7]++;changed(startDate,endDate);},focusedInput:this.state.focusedInput,onFocusChange:function onFocusChange(focusedInput){cov_15fodv7c1y.f[4]++;cov_15fodv7c1y.s[8]++;_this2.setState({focusedInput:focusedInput});},isOutsideRange:function isOutsideRange(){cov_15fodv7c1y.f[5]++;cov_15fodv7c1y.s[9]++;return false;},locale:currentLanguage,startDatePlaceholderText:startDateLabel,endDatePlaceholderText:endDateLabel,showDefaultInputIcon:true,readOnly:true,inputIconPosition:'after'}));}}]);return DatePicker;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_15fodv7c1y.s[10]++;var mapStateToProps=function mapStateToProps(state){cov_15fodv7c1y.f[6]++;cov_15fodv7c1y.s[11]++;return{currentLanguage:Object(__WEBPACK_IMPORTED_MODULE_1_react_localize_redux__["c" /* getActiveLanguage */])(state.locale).code};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(DatePicker));

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
__webpack_require__(389);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(390));

(0, _registerCSSInterfaceWithDefaultTheme["default"])();

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerCSSInterfaceWithDefaultTheme;

var _reactWithStylesInterfaceCss = _interopRequireDefault(__webpack_require__(391));

var _registerInterfaceWithDefaultTheme = _interopRequireDefault(__webpack_require__(445));

function registerCSSInterfaceWithDefaultTheme() {
  (0, _registerInterfaceWithDefaultTheme["default"])(_reactWithStylesInterfaceCss["default"]);
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
module.exports = __webpack_require__(392).default;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _arrayPrototype = _interopRequireDefault(__webpack_require__(393));

var _globalCache = _interopRequireDefault(__webpack_require__(441));

var _constants = __webpack_require__(442);

var _getClassName = _interopRequireDefault(__webpack_require__(443));

var _separateStyles2 = _interopRequireDefault(__webpack_require__(444));

/**
 * Function required as part of the react-with-styles interface. Parses the styles provided by
 * react-with-styles to produce class names based on the style name and optionally the namespace if
 * available.
 *
 * stylesObject {Object} The styles object passed to withStyles.
 *
 * Return an object mapping style names to class names.
 */
function create(stylesObject) {
  var stylesToClasses = {};
  var styleNames = Object.keys(stylesObject);
  var sharedState = _globalCache["default"].get(_constants.GLOBAL_CACHE_KEY) || {};
  var _sharedState$namespac = sharedState.namespace,
      namespace = _sharedState$namespac === void 0 ? '' : _sharedState$namespac;
  styleNames.forEach(function (styleName) {
    var className = (0, _getClassName["default"])(namespace, styleName);
    stylesToClasses[styleName] = className;
  });
  return stylesToClasses;
}
/**
 * Process styles to be consumed by a component.
 *
 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
 * representing inline styles, or arrays thereof.
 *
 * Return an object with optional className and style properties to be spread on a component.
 */


function resolve(stylesArray) {
  var flattenedStyles = (0, _arrayPrototype["default"])(stylesArray, Infinity);

  var _separateStyles = (0, _separateStyles2["default"])(flattenedStyles),
      classNames = _separateStyles.classNames,
      hasInlineStyles = _separateStyles.hasInlineStyles,
      inlineStyles = _separateStyles.inlineStyles;

  var specificClassNames = classNames.map(function (name, index) {
    return "".concat(name, " ").concat(name, "_").concat(index + 1);
  });
  var className = specificClassNames.join(' ');
  var result = {
    className: className
  };
  if (hasInlineStyles) result.style = inlineStyles;
  return result;
}

var _default = {
  create: create,
  resolve: resolve
};
exports["default"] = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var callBind = __webpack_require__(42);

var implementation = __webpack_require__(154);
var getPolyfill = __webpack_require__(171);
var polyfill = getPolyfill();
var shim = __webpack_require__(439);

var boundFlat = callBind(polyfill);

define(boundFlat, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFlat;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(149); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);
var define = __webpack_require__(150);
var hasDescriptors = __webpack_require__(95)();
var gOPD = __webpack_require__(94);

var $TypeError = __webpack_require__(8);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = __webpack_require__(8);

var ArrayCreate = __webpack_require__(402);
var Get = __webpack_require__(70);
var IsArray = __webpack_require__(96);
var IsConstructor = __webpack_require__(406);
var Type = __webpack_require__(32);

var isInteger = __webpack_require__(155);

// https://262.ecma-international.org/12.0/#sec-arrayspeciescreate

module.exports = function ArraySpeciesCreate(originalArray, length) {
	if (!isInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};



/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
var $RangeError = __webpack_require__(151);
var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(8);

var isInteger = __webpack_require__(155);

var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var hasProto = __webpack_require__(153)();

var $setProto = GetIntrinsic('%Object.setPrototypeOf%', true) || (
	hasProto
		? function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
		: null
);

// https://262.ecma-international.org/12.0/#sec-arraycreate

module.exports = function ArrayCreate(length) {
	if (!isInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(404);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === global) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 404 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(407);

var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = __webpack_require__(408);
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://262.ecma-international.org/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: remove, semver-major

module.exports = __webpack_require__(17);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var isPropertyDescriptor = __webpack_require__(39);
var DefineOwnProperty = __webpack_require__(158);

var FromPropertyDescriptor = __webpack_require__(159);
var IsDataDescriptor = __webpack_require__(97);
var IsPropertyKey = __webpack_require__(38);
var SameValue = __webpack_require__(98);
var ToPropertyDescriptor = __webpack_require__(160);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor(desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var MAX_SAFE_INTEGER = __webpack_require__(163);

var Call = __webpack_require__(412);
var CreateDataPropertyOrThrow = __webpack_require__(413);
var Get = __webpack_require__(70);
var HasProperty = __webpack_require__(420);
var IsArray = __webpack_require__(96);
var LengthOfArrayLike = __webpack_require__(421);
var ToString = __webpack_require__(435);

// https://262.ecma-international.org/11.0/#sec-flattenintoarray

module.exports = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= MAX_SAFE_INTEGER) {
					throw new $TypeError('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);
var callBound = __webpack_require__(33);

var $TypeError = __webpack_require__(8);

var IsArray = __webpack_require__(96);

var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('Function.prototype.apply');

// https://262.ecma-international.org/6.0/#sec-call

module.exports = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var CreateDataProperty = __webpack_require__(414);
var IsPropertyKey = __webpack_require__(38);
var Type = __webpack_require__(32);

// // https://262.ecma-international.org/14.0/#sec-createdatapropertyorthrow

module.exports = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError('unable to create data property');
	}
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var IsPropertyKey = __webpack_require__(38);
var OrdinaryDefineOwnProperty = __webpack_require__(415);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/6.0/#sec-createdataproperty

module.exports = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var newDesc = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Value]]': V,
		'[[Writable]]': true
	};
	return OrdinaryDefineOwnProperty(O, P, newDesc);
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $gOPD = __webpack_require__(94);
var $SyntaxError = __webpack_require__(68);
var $TypeError = __webpack_require__(8);

var isPropertyDescriptor = __webpack_require__(39);

var IsAccessorDescriptor = __webpack_require__(99);
var IsExtensible = __webpack_require__(416);
var IsPropertyKey = __webpack_require__(38);
var ToPropertyDescriptor = __webpack_require__(160);
var SameValue = __webpack_require__(98);
var Type = __webpack_require__(32);
var ValidateAndApplyPropertyDescriptor = __webpack_require__(417);

// https://262.ecma-international.org/6.0/#sec-ordinarydefineownproperty

module.exports = function OrdinaryDefineOwnProperty(O, P, Desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (!$gOPD) {
		// ES3/IE 8 fallback
		if (IsAccessorDescriptor(Desc)) {
			throw new $SyntaxError('This environment does not support accessor property descriptors.');
		}
		var creatingNormalDataProperty = !(P in O)
			&& Desc['[[Writable]]']
			&& Desc['[[Enumerable]]']
			&& Desc['[[Configurable]]']
			&& '[[Value]]' in Desc;
		var settingExistingDataProperty = (P in O)
			&& (!('[[Configurable]]' in Desc) || Desc['[[Configurable]]'])
			&& (!('[[Enumerable]]' in Desc) || Desc['[[Enumerable]]'])
			&& (!('[[Writable]]' in Desc) || Desc['[[Writable]]'])
			&& '[[Value]]' in Desc;
		if (creatingNormalDataProperty || settingExistingDataProperty) {
			O[P] = Desc['[[Value]]']; // eslint-disable-line no-param-reassign
			return SameValue(O[P], Desc['[[Value]]']);
		}
		throw new $SyntaxError('This environment does not support defining non-writable, non-enumerable, or non-configurable properties');
	}
	var desc = $gOPD(O, P);
	var current = desc && ToPropertyDescriptor(desc);
	var extensible = IsExtensible(O);
	return ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $preventExtensions = GetIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = GetIntrinsic('%Object.isExtensible%', true);

var isPrimitive = __webpack_require__(164);

// https://262.ecma-international.org/6.0/#sec-isextensible-o

module.exports = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var DefineOwnProperty = __webpack_require__(158);
var isFullyPopulatedPropertyDescriptor = __webpack_require__(418);
var isPropertyDescriptor = __webpack_require__(39);

var FromPropertyDescriptor = __webpack_require__(159);
var IsAccessorDescriptor = __webpack_require__(99);
var IsDataDescriptor = __webpack_require__(97);
var IsGenericDescriptor = __webpack_require__(419);
var IsPropertyKey = __webpack_require__(38);
var SameValue = __webpack_require__(98);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/13.0/#sec-validateandapplypropertydescriptor

// see https://github.com/tc39/ecma262/pull/2468 for ES2022 changes

// eslint-disable-next-line max-lines-per-function, max-statements
module.exports = function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
	var oType = Type(O);
	if (oType !== 'Undefined' && oType !== 'Object') {
		throw new $TypeError('Assertion failed: O must be undefined or an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (typeof extensible !== 'boolean') {
		throw new $TypeError('Assertion failed: extensible must be a Boolean');
	}
	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (typeof current !== 'undefined' && !isPropertyDescriptor(current)) {
		throw new $TypeError('Assertion failed: current must be a Property Descriptor, or undefined');
	}

	if (typeof current === 'undefined') { // step 2
		if (!extensible) {
			return false; // step 2.a
		}
		if (oType === 'Undefined') {
			return true; // step 2.b
		}
		if (IsAccessorDescriptor(Desc)) { // step 2.c
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				Desc
			);
		}
		// step 2.d
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			{
				'[[Configurable]]': !!Desc['[[Configurable]]'],
				'[[Enumerable]]': !!Desc['[[Enumerable]]'],
				'[[Value]]': Desc['[[Value]]'],
				'[[Writable]]': !!Desc['[[Writable]]']
			}
		);
	}

	// 3. Assert: current is a fully populated Property Descriptor.
	if (
		!isFullyPopulatedPropertyDescriptor(
			{
				IsAccessorDescriptor: IsAccessorDescriptor,
				IsDataDescriptor: IsDataDescriptor
			},
			current
		)
	) {
		throw new $TypeError('`current`, when present, must be a fully populated and valid Property Descriptor');
	}

	// 4. If every field in Desc is absent, return true.
	// this can't really match the assertion that it's a Property Descriptor in our JS implementation

	// 5. If current.[[Configurable]] is false, then
	if (!current['[[Configurable]]']) {
		if ('[[Configurable]]' in Desc && Desc['[[Configurable]]']) {
			// step 5.a
			return false;
		}
		if ('[[Enumerable]]' in Desc && !SameValue(Desc['[[Enumerable]]'], current['[[Enumerable]]'])) {
			// step 5.b
			return false;
		}
		if (!IsGenericDescriptor(Desc) && !SameValue(IsAccessorDescriptor(Desc), IsAccessorDescriptor(current))) {
			// step 5.c
			return false;
		}
		if (IsAccessorDescriptor(current)) { // step 5.d
			if ('[[Get]]' in Desc && !SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
				return false;
			}
			if ('[[Set]]' in Desc && !SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
				return false;
			}
		} else if (!current['[[Writable]]']) { // step 5.e
			if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
				return false;
			}
			if ('[[Value]]' in Desc && !SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
				return false;
			}
		}
	}

	// 6. If O is not undefined, then
	if (oType !== 'Undefined') {
		var configurable;
		var enumerable;
		if (IsDataDescriptor(current) && IsAccessorDescriptor(Desc)) { // step 6.a
			configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
			enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
			// Replace the property named P of object O with an accessor property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': !!configurable,
					'[[Enumerable]]': !!enumerable,
					'[[Get]]': ('[[Get]]' in Desc ? Desc : current)['[[Get]]'],
					'[[Set]]': ('[[Set]]' in Desc ? Desc : current)['[[Set]]']
				}
			);
		} else if (IsAccessorDescriptor(current) && IsDataDescriptor(Desc)) {
			configurable = ('[[Configurable]]' in Desc ? Desc : current)['[[Configurable]]'];
			enumerable = ('[[Enumerable]]' in Desc ? Desc : current)['[[Enumerable]]'];
			// i. Replace the property named P of object O with a data property having [[Configurable]] and [[Enumerable]] attributes as described by current and each other attribute set to its default value.
			return DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': !!configurable,
					'[[Enumerable]]': !!enumerable,
					'[[Value]]': ('[[Value]]' in Desc ? Desc : current)['[[Value]]'],
					'[[Writable]]': !!('[[Writable]]' in Desc ? Desc : current)['[[Writable]]']
				}
			);
		}

		// For each field of Desc that is present, set the corresponding attribute of the property named P of object O to the value of the field.
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			Desc
		);
	}

	return true; // step 7
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPropertyDescriptor = __webpack_require__(39);

module.exports = function isFullyPopulatedPropertyDescriptor(ES, Desc) {
	return isPropertyDescriptor(Desc)
		&& typeof Desc === 'object'
		&& '[[Enumerable]]' in Desc
		&& '[[Configurable]]' in Desc
		&& (ES.IsAccessorDescriptor(Desc) || ES.IsDataDescriptor(Desc));
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var IsAccessorDescriptor = __webpack_require__(99);
var IsDataDescriptor = __webpack_require__(97);

var isPropertyDescriptor = __webpack_require__(39);

// https://262.ecma-international.org/6.0/#sec-isgenericdescriptor

module.exports = function IsGenericDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	if (!isPropertyDescriptor(Desc)) {
		throw new $TypeError('Assertion failed: `Desc` must be a Property Descriptor');
	}

	if (!IsAccessorDescriptor(Desc) && !IsDataDescriptor(Desc)) {
		return true;
	}

	return false;
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var IsPropertyKey = __webpack_require__(38);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var Get = __webpack_require__(70);
var ToLength = __webpack_require__(165);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

module.exports = function LengthOfArrayLike(obj) {
	if (Type(obj) !== 'Object') {
		throw new $TypeError('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

// TODO: use this all over


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $TypeError = __webpack_require__(8);
var $Number = GetIntrinsic('%Number%');
var isPrimitive = __webpack_require__(164);

var ToPrimitive = __webpack_require__(423);
var StringToNumber = __webpack_require__(427);

// https://262.ecma-international.org/13.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		return StringToNumber(value);
	}
	return $Number(value);
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toPrimitive = __webpack_require__(424);

// https://262.ecma-international.org/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(425);
var isCallable = __webpack_require__(162);
var isDate = __webpack_require__(426);
var isSymbol = __webpack_require__(168);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(167)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $TypeError = __webpack_require__(8);
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = __webpack_require__(33);
var regexTester = __webpack_require__(428);

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

var $trim = __webpack_require__(430);

// https://262.ecma-international.org/13.0/#sec-stringtonumber

module.exports = function StringToNumber(argument) {
	if (typeof argument !== 'string') {
		throw new $TypeError('Assertion failed: `argument` is not a String');
	}
	if (isBinary(argument)) {
		return $Number($parseInteger($strSlice(argument, 2), 2));
	}
	if (isOctal(argument)) {
		return $Number($parseInteger($strSlice(argument, 2), 8));
	}
	if (hasNonWS(argument) || isInvalidHexLiteral(argument)) {
		return NaN;
	}
	var trimmed = $trim(argument);
	if (trimmed !== argument) {
		return StringToNumber(trimmed);
	}
	return $Number(argument);
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(33);
var isRegex = __webpack_require__(429);

var $exec = callBound('RegExp.prototype.exec');
var $TypeError = __webpack_require__(8);

module.exports = function regexTester(regex) {
	if (!isRegex(regex)) {
		throw new $TypeError('`regex` must be a RegExp');
	}
	return function test(s) {
		return $exec(regex, s) !== null;
	};
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(33);
var hasToStringTag = __webpack_require__(167)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(42);
var define = __webpack_require__(20);
var RequireObjectCoercible = __webpack_require__(71);

var implementation = __webpack_require__(169);
var getPolyfill = __webpack_require__(170);
var shim = __webpack_require__(432);

var bound = callBind(getPolyfill());
var boundMethod = function trim(receiver) {
	RequireObjectCoercible(receiver);
	return bound(receiver);
};

define(boundMethod, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundMethod;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $String = GetIntrinsic('%String%');
var $TypeError = __webpack_require__(8);

// https://262.ecma-international.org/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var getPolyfill = __webpack_require__(170);

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(434);

var $TypeError = __webpack_require__(8);

// https://262.ecma-international.org/14.0/#eqn-truncate

module.exports = function truncate(x) {
	if (typeof x !== 'number' && typeof x !== 'bigint') {
		throw new $TypeError('argument must be a Number or a BigInt');
	}
	var result = x < 0 ? -floor(-x) : floor(x);
	return result === 0 ? 0 : result; // in the spec, these are math values, so we filter out -0 here
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/11.0/#eqn-floor

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	if (typeof x === 'bigint') {
		return x;
	}
	return $floor(x);
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(17);

var $String = GetIntrinsic('%String%');
var $TypeError = __webpack_require__(8);

// https://262.ecma-international.org/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = __webpack_require__(437);


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(438);
var RequireObjectCoercible = __webpack_require__(71);

/** @type {import('./ToObject')} */
module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var shimUnscopables = __webpack_require__(440);

var getPolyfill = __webpack_require__(171);

module.exports = function shimFlat() {
	var polyfill = getPolyfill();

	define(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);

	shimUnscopables('flat');

	return polyfill;
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = __webpack_require__(37);

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError = TypeError;

module.exports = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError('method must be a non-empty string');
	}
	if (!hasOwn(Array.prototype, method)) {
		throw new $TypeError('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map[method] = true;
	}
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var define = __webpack_require__(20);
var isSymbol = __webpack_require__(168);

var globalKey = '__ global cache key __';
/* istanbul ignore else */
// eslint-disable-next-line no-restricted-properties
if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
	// eslint-disable-next-line no-restricted-properties
	globalKey = Symbol['for'](globalKey);
}

var trueThunk = function () {
	return true;
};

var ensureCache = function ensureCache() {
	if (!global[globalKey]) {
		var properties = {};
		properties[globalKey] = {};
		var predicates = {};
		predicates[globalKey] = trueThunk;
		define(global, properties, predicates);
	}
	return global[globalKey];
};

var cache = ensureCache();

var isPrimitive = function isPrimitive(val) {
	return val === null || (typeof val !== 'object' && typeof val !== 'function');
};

var getPrimitiveKey = function getPrimitiveKey(val) {
	if (isSymbol(val)) {
		return Symbol.prototype.valueOf.call(val);
	}
	return typeof val + ' | ' + String(val);
};

var requirePrimitiveKey = function requirePrimitiveKey(val) {
	if (!isPrimitive(val)) {
		throw new TypeError('key must not be an object');
	}
};

var globalCache = {
	clear: function clear() {
		delete global[globalKey];
		cache = ensureCache();
	},

	'delete': function deleteKey(key) {
		requirePrimitiveKey(key);
		delete cache[getPrimitiveKey(key)];
		return !globalCache.has(key);
	},

	get: function get(key) {
		requirePrimitiveKey(key);
		return cache[getPrimitiveKey(key)];
	},

	has: function has(key) {
		requirePrimitiveKey(key);
		return getPrimitiveKey(key) in cache;
	},

	set: function set(key, value) {
		requirePrimitiveKey(key);
		var primitiveKey = getPrimitiveKey(key);
		var props = {};
		props[primitiveKey] = value;
		var predicates = {};
		predicates[primitiveKey] = trueThunk;
		define(cache, props, predicates);
		return globalCache.has(key);
	},

	setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
		if (globalCache.has(key)) {
			return globalCache.get(key);
		}
		var item = valueThunk();
		globalCache.set(key, item);
		return item;
	}
};

module.exports = globalCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_SPECIFICITY = exports.GLOBAL_CACHE_KEY = void 0;
var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
var MAX_SPECIFICITY = 20;
exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getClassName;

/**
 * Construct a class name.
 *
 * namespace {String} Used to construct unique class names.
 * styleName {String} Name identifying the specific style.
 *
 * Return the class name.
 */
function getClassName(namespace, styleName) {
  var namespaceSegment = namespace.length > 0 ? "".concat(namespace, "__") : '';
  return "".concat(namespaceSegment).concat(styleName);
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// This function takes an array of styles and separates them into styles that
// are handled by Aphrodite and inline styles.
function separateStyles(stylesArray) {
  var classNames = []; // Since determining if an Object is empty requires collecting all of its
  // keys, and we want the best performance in this code because we are in the
  // render path, we are going to do a little bookkeeping ourselves.

  var hasInlineStyles = false;
  var inlineStyles = {}; // This is run on potentially every node in the tree when rendering, where
  // performance is critical. Normally we would prefer using `forEach`, but
  // old-fashioned for loops are faster so that's what we have chosen here.

  for (var i = 0; i < stylesArray.length; i++) {
    // eslint-disable-line no-plusplus
    var style = stylesArray[i]; // If this  style is falsy, we just want to disregard it. This allows for
    // syntax like:
    //
    //   css(isFoo && styles.foo)

    if (style) {
      if (typeof style === 'string') {
        classNames.push(style);
      } else {
        Object.assign(inlineStyles, style);
        hasInlineStyles = true;
      }
    }
  }

  return {
    classNames: classNames,
    hasInlineStyles: hasInlineStyles,
    inlineStyles: inlineStyles
  };
}

var _default = separateStyles;
exports["default"] = _default;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = registerInterfaceWithDefaultTheme;

var _ThemedStyleSheet = _interopRequireDefault(__webpack_require__(172));

var _DefaultTheme = _interopRequireDefault(__webpack_require__(446));

function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
  _ThemedStyleSheet["default"].registerInterface(reactWithStylesInterface);

  _ThemedStyleSheet["default"].registerTheme(_DefaultTheme["default"]);
}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var core = {
  white: '#fff',
  gray: '#484848',
  grayLight: '#82888a',
  grayLighter: '#cacccd',
  grayLightest: '#f2f2f2',
  borderMedium: '#c4c4c4',
  border: '#dbdbdb',
  borderLight: '#e4e7e7',
  borderLighter: '#eceeee',
  borderBright: '#f4f5f5',
  primary: '#00a699',
  primaryShade_1: '#33dacd',
  primaryShade_2: '#66e2da',
  primaryShade_3: '#80e8e0',
  primaryShade_4: '#b2f1ec',
  primary_dark: '#008489',
  secondary: '#007a87',
  yellow: '#ffe8bc',
  yellow_dark: '#ffce71'
};
var _default = {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: '2px solid transparent',
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: "2px solid ".concat(core.primary_dark),
        borderRightFocused: 0,
        borderRadius: 0
      },
      pickerInput: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 2
      }
    },
    color: {
      core: core,
      disabled: core.grayLightest,
      background: core.white,
      backgroundDark: '#f2f2f2',
      backgroundFocused: core.white,
      border: 'rgb(219, 219, 219)',
      text: core.gray,
      textDisabled: core.border,
      textFocused: '#007a87',
      placeholderText: '#757575',
      outside: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      highlighted: {
        backgroundColor: core.yellow,
        backgroundColor_active: core.yellow_dark,
        backgroundColor_hover: core.yellow_dark,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },
      minimumNights: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLighter,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },
      hoveredSpan: {
        backgroundColor: core.primaryShade_4,
        backgroundColor_active: core.primaryShade_3,
        backgroundColor_hover: core.primaryShade_4,
        borderColor: core.primaryShade_3,
        borderColor_active: core.primaryShade_3,
        borderColor_hover: core.primaryShade_3,
        color: core.secondary,
        color_active: core.secondary,
        color_hover: core.secondary
      },
      selectedSpan: {
        backgroundColor: core.primaryShade_2,
        backgroundColor_active: core.primaryShade_1,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primaryShade_1,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      selected: {
        backgroundColor: core.primary,
        backgroundColor_active: core.primary,
        backgroundColor_hover: core.primary,
        borderColor: core.primary,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },
      blocked_calendar: {
        backgroundColor: core.grayLighter,
        backgroundColor_active: core.grayLighter,
        backgroundColor_hover: core.grayLighter,
        borderColor: core.grayLighter,
        borderColor_active: core.grayLighter,
        borderColor_hover: core.grayLighter,
        color: core.grayLight,
        color_active: core.grayLight,
        color_hover: core.grayLight
      },
      blocked_out_of_range: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      }
    },
    spacing: {
      dayPickerHorizontalPadding: 9,
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      displayTextPaddingVertical: undefined,
      displayTextPaddingTop: 11,
      displayTextPaddingBottom: 9,
      displayTextPaddingHorizontal: undefined,
      displayTextPaddingLeft: 11,
      displayTextPaddingRight: 11,
      displayTextPaddingVertical_small: undefined,
      displayTextPaddingTop_small: 7,
      displayTextPaddingBottom_small: 5,
      displayTextPaddingHorizontal_small: undefined,
      displayTextPaddingLeft_small: 7,
      displayTextPaddingRight_small: 7
    },
    sizing: {
      inputWidth: 130,
      inputWidth_small: 97,
      arrowWidth: 24
    },
    noScrollBarOnVerticalScrollable: false,
    font: {
      size: 14,
      captionSize: 18,
      input: {
        size: 19,
        weight: 200,
        lineHeight: '24px',
        size_small: 15,
        lineHeight_small: '18px',
        letterSpacing_small: '0.2px',
        styleDisabled: 'italic'
      }
    }
  }
};
exports["default"] = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// eslint-disable-next-line import/no-unresolved
module.exports = __webpack_require__(448);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CalendarDay", {
  enumerable: true,
  get: function get() {
    return _CalendarDay["default"];
  }
});
Object.defineProperty(exports, "CalendarMonth", {
  enumerable: true,
  get: function get() {
    return _CalendarMonth["default"];
  }
});
Object.defineProperty(exports, "CalendarMonthGrid", {
  enumerable: true,
  get: function get() {
    return _CalendarMonthGrid["default"];
  }
});
Object.defineProperty(exports, "DateRangePicker", {
  enumerable: true,
  get: function get() {
    return _DateRangePicker["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInput", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInput["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerInputController", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerInputController["default"];
  }
});
Object.defineProperty(exports, "DateRangePickerShape", {
  enumerable: true,
  get: function get() {
    return _DateRangePickerShape["default"];
  }
});
Object.defineProperty(exports, "DayPicker", {
  enumerable: true,
  get: function get() {
    return _DayPicker["default"];
  }
});
Object.defineProperty(exports, "DayPickerRangeController", {
  enumerable: true,
  get: function get() {
    return _DayPickerRangeController["default"];
  }
});
Object.defineProperty(exports, "DayPickerSingleDateController", {
  enumerable: true,
  get: function get() {
    return _DayPickerSingleDateController["default"];
  }
});
Object.defineProperty(exports, "SingleDatePicker", {
  enumerable: true,
  get: function get() {
    return _SingleDatePicker["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerInput", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerInput["default"];
  }
});
Object.defineProperty(exports, "SingleDatePickerShape", {
  enumerable: true,
  get: function get() {
    return _SingleDatePickerShape["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyAfterDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyAfterDay["default"];
  }
});
Object.defineProperty(exports, "isInclusivelyBeforeDay", {
  enumerable: true,
  get: function get() {
    return _isInclusivelyBeforeDay["default"];
  }
});
Object.defineProperty(exports, "isNextDay", {
  enumerable: true,
  get: function get() {
    return _isNextDay["default"];
  }
});
Object.defineProperty(exports, "isSameDay", {
  enumerable: true,
  get: function get() {
    return _isSameDay["default"];
  }
});
Object.defineProperty(exports, "toISODateString", {
  enumerable: true,
  get: function get() {
    return _toISODateString["default"];
  }
});
Object.defineProperty(exports, "toLocalizedDateString", {
  enumerable: true,
  get: function get() {
    return _toLocalizedDateString["default"];
  }
});
Object.defineProperty(exports, "toMomentObject", {
  enumerable: true,
  get: function get() {
    return _toMomentObject["default"];
  }
});

var _CalendarDay = _interopRequireDefault(__webpack_require__(173));

var _CalendarMonth = _interopRequireDefault(__webpack_require__(188));

var _CalendarMonthGrid = _interopRequireDefault(__webpack_require__(190));

var _DateRangePicker = _interopRequireDefault(__webpack_require__(494));

var _DateRangePickerInput = _interopRequireDefault(__webpack_require__(204));

var _DateRangePickerInputController = _interopRequireDefault(__webpack_require__(203));

var _DateRangePickerShape = _interopRequireDefault(__webpack_require__(196));

var _DayPicker = _interopRequireDefault(__webpack_require__(109));

var _DayPickerRangeController = _interopRequireDefault(__webpack_require__(212));

var _DayPickerSingleDateController = _interopRequireDefault(__webpack_require__(218));

var _SingleDatePicker = _interopRequireDefault(__webpack_require__(526));

var _SingleDatePickerInput = _interopRequireDefault(__webpack_require__(220));

var _SingleDatePickerShape = _interopRequireDefault(__webpack_require__(219));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _isInclusivelyBeforeDay = _interopRequireDefault(__webpack_require__(528));

var _isNextDay = _interopRequireDefault(__webpack_require__(214));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

var _toISODateString = _interopRequireDefault(__webpack_require__(57));

var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(107));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var callBind = __webpack_require__(42);

var implementation = __webpack_require__(174);
var getPolyfill = __webpack_require__(175);
var shim = __webpack_require__(450);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(175);
var define = __webpack_require__(20);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

function _setPrototypeOf(t, e) {
  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(100)["default"];
var toPrimitive = __webpack_require__(453);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(100)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(5);

function isValidMoment(testMoment) {
  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
    return false;
  }

  /* istanbul ignore else  */
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  /* istanbul ignore next */
  return !isNaN(testMoment);
}

module.exports = {
  isValidMoment : isValidMoment,
};


/***/ }),
/* 455 */
/***/ (function(module, exports) {

var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid ',
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` ' + messages.requiredCore +
    ' in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;

    var preValidationRequireCheckValue = preValidationRequireCheck(
      isRequired, componentName, propFullName, propValue
    );

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (!validator(propValue)) {
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  return constructPropValidatorVariations(propValidator);

}

module.exports = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages,
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function noop() {
  return null;
}

noop.isRequired = noop;

function noopThunk() {
  return noop;
}

module.exports = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  predicate: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringEndsWith: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(458);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(101);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var callBind = __webpack_require__(42);

var implementation = __webpack_require__(178);
var getPolyfill = __webpack_require__(180);
var shim = __webpack_require__(463);

var bound = callBind(implementation);

define(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(8);

var hasOwn = __webpack_require__(37);

var IsPropertyKey = __webpack_require__(38);
var Type = __webpack_require__(32);

// https://262.ecma-international.org/6.0/#sec-hasownproperty

module.exports = function HasOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return hasOwn(O, P);
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(20).supportsDescriptors;
var functionsHaveNames = __webpack_require__(179)();
var getPolyfill = __webpack_require__(180);
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;

module.exports = function shimName() {
	var polyfill = getPolyfill();
	if (functionsHaveNames) {
		return polyfill;
	}
	if (!supportsDescriptors) {
		throw new TypeErr('Shimming Function.prototype.name support requires ES5 property descriptor support.');
	}
	var functionProto = Function.prototype;
	defineProperty(functionProto, 'name', {
		configurable: true,
		enumerable: false,
		get: function () {
			var name = polyfill.call(this);
			if (this !== functionProto) {
				defineProperty(this, 'name', {
					configurable: true,
					enumerable: false,
					value: name,
					writable: false
				});
			}
			return name;
		}
	});
	return polyfill;
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _isPlainObject = _interopRequireDefault(__webpack_require__(465));

var _wrapValidator = _interopRequireDefault(__webpack_require__(468));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isPrototypeOf = Object.prototype.isPrototypeOf;

function isNewRef(prop) {
  if (!(0, _isPlainObject["default"])(prop)) {
    return false;
  }

  var ownProperties = Object.keys(prop);
  return ownProperties.length === 1 && ownProperties[0] === 'current';
}

function isCallbackRef(prop) {
  return typeof prop === 'function' && !isPrototypeOf.call(_react.Component, prop) && (!_react.PureComponent || !isPrototypeOf.call(_react.PureComponent, prop));
}

function requiredRef(props, propName, componentName) {
  var propValue = props[propName];

  if (isCallbackRef(propValue) || isNewRef(propValue)) {
    return null;
  }

  return new TypeError("".concat(propName, " in ").concat(componentName, " must be a ref"));
}

function ref(props, propName, componentName) {
  var propValue = props[propName];

  if (propValue == null) {
    return null;
  }

  for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    rest[_key - 3] = arguments[_key];
  }

  return requiredRef.apply(void 0, [props, propName, componentName].concat(rest));
}

ref.isRequired = requiredRef;

var _default = function _default() {
  return (0, _wrapValidator["default"])(ref, 'ref');
};

exports["default"] = _default;
//# sourceMappingURL=ref.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(__webpack_require__(466));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _isPlainObject["default"];
exports["default"] = _default;
//# sourceMappingURL=isPlainObject.js.map

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(467);

// TODO: inline, semver-major

/** @type {(x: unknown) => x is object} */
module.exports = function isPlainObject(x) {
	return x && typeof x === 'object' && !isArray(x);
};


/***/ }),
/* 467 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapValidator;

var _object = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function wrapValidator(validator, typeName) {
  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _object["default"])(validator.bind(), {
    typeName: typeName,
    typeChecker: typeChecker,
    isRequired: (0, _object["default"])(validator.isRequired.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
}
//# sourceMappingURL=wrapValidator.js.map

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperties = __webpack_require__(20);
var callBind = __webpack_require__(42);

var implementation = __webpack_require__(181);
var getPolyfill = __webpack_require__(182);
var shim = __webpack_require__(470);

var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var getPolyfill = __webpack_require__(182);

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EMPTY_STYLES = {};

var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
  return EMPTY_STYLES;
};

var _default = EMPTY_STYLES_FN;
exports["default"] = _default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.perfStart = perfStart;
exports.perfEnd = perfEnd;
exports["default"] = withPerf;

function perfStart(startMark) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function' && startMark) {
    performance.clearMarks(startMark);
    performance.mark(startMark);
  }
}

function perfEnd(startMark, endMark, measureName) {
  if (typeof performance !== 'undefined' && performance.mark !== undefined && typeof performance.clearMarks === 'function') {
    performance.clearMarks(endMark);
    performance.mark(endMark);
    performance.measure(measureName, startMark, endMark);
    performance.clearMarks(measureName);
  }
}

function withPerf(methodName) {
  var startMark = "react-with-styles.".concat(methodName, ".start");
  var endMark = "react-with-styles.".concat(methodName, ".end");
  var measureName = "\uD83D\uDC69\u200D\uD83C\uDFA8 [".concat(methodName, "]");
  return function (fn) {
    return function () {
      if (false) {
        perfStart(startMark);
      }

      var result = fn.apply(void 0, arguments);

      if (false) {
        perfEnd(startMark, endMark, measureName);
      }

      return result;
    };
  };
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DIRECTIONS", {
  enumerable: true,
  get: function get() {
    return _reactWithDirection.DIRECTIONS;
  }
});
exports["default"] = void 0;

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _reactWithDirection = __webpack_require__(474);

function detectAndCreateContext(defaultValue) {
  if (_react.createContext) {
    return /*#__PURE__*/(0, _react.createContext)(defaultValue);
  }

  return {
    Provider: function Provider() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    },
    Consumer: function Consumer() {
      throw new ReferenceError('WithStylesContext requires React 16.3 or later');
    }
  };
}

var WithStylesContext = detectAndCreateContext({
  stylesInterface: null,
  stylesTheme: null,
  direction: null
});
WithStylesContext.Provider.propTypes = {
  stylesInterface: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  stylesTheme: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  direction: _propTypes["default"].oneOf([_reactWithDirection.DIRECTIONS.LTR, _reactWithDirection.DIRECTIONS.RTL])
};
var _default = WithStylesContext;
exports["default"] = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDirectionPropTypes = exports.DIRECTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = withDirection;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(475);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _deepmerge = __webpack_require__(476);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _getComponentName = __webpack_require__(177);

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _constants = __webpack_require__(183);

var _brcast = __webpack_require__(477);

var _brcast2 = _interopRequireDefault(_brcast);

var _direction = __webpack_require__(478);

var _direction2 = _interopRequireDefault(_direction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/forbid-foreign-prop-types */
// This higher-order component consumes a string from React context that is
// provided by the DirectionProvider component.
// We can use this to conditionally switch layout/direction for right-to-left layouts.

var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);

exports.DIRECTIONS = _constants.DIRECTIONS;

// set a default direction so that a component wrapped with this HOC can be
// used even without a DirectionProvider ancestor in its react tree.

var defaultDirection = _constants.DIRECTIONS.LTR;

// export for convenience, in order for components to spread these onto their propTypes
var withDirectionPropTypes = exports.withDirectionPropTypes = {
  direction: _direction2['default'].isRequired
};

function withDirection(WrappedComponent) {
  var WithDirection = function (_React$Component) {
    _inherits(WithDirection, _React$Component);

    function WithDirection(props, context) {
      _classCallCheck(this, WithDirection);

      var _this = _possibleConstructorReturn(this, (WithDirection.__proto__ || Object.getPrototypeOf(WithDirection)).call(this, props, context));

      _this.state = {
        direction: context[_constants.CHANNEL] ? context[_constants.CHANNEL].getState() : defaultDirection
      };
      return _this;
    }

    _createClass(WithDirection, [{
      key: 'componentDidMount',
      value: function () {
        function componentDidMount() {
          var _this2 = this;

          if (this.context[_constants.CHANNEL]) {
            // subscribe to future direction changes
            this.channelUnsubscribe = this.context[_constants.CHANNEL].subscribe(function (direction) {
              _this2.setState({ direction: direction });
            });
          }
        }

        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function () {
        function componentWillUnmount() {
          if (this.channelUnsubscribe) {
            this.channelUnsubscribe();
          }
        }

        return componentWillUnmount;
      }()
    }, {
      key: 'render',
      value: function () {
        function render() {
          var direction = this.state.direction;


          return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
            direction: direction
          }));
        }

        return render;
      }()
    }]);

    return WithDirection;
  }(_react2['default'].Component);

  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';

  WithDirection.WrappedComponent = WrappedComponent;
  WithDirection.contextTypes = contextTypes;
  WithDirection.displayName = 'withDirection(' + String(wrappedComponentName) + ')';
  if (WrappedComponent.propTypes) {
    WithDirection.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
    delete WithDirection.propTypes.direction;
  }
  if (WrappedComponent.defaultProps) {
    WithDirection.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
  }

  return (0, _hoistNonReactStatics2['default'])(WithDirection, WrappedComponent);
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(101);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function(key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function(key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument)
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].shape({
  getState: _propTypes2['default'].func,
  setState: _propTypes2['default'].func,
  subscribe: _propTypes2['default'].func
});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _object = __webpack_require__(72);

var _object2 = _interopRequireDefault(_object);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(183);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf((0, _object2['default'])(_constants.DIRECTIONS));

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(185);
var define = __webpack_require__(20);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withStylesPropTypes = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var withStylesPropTypes = {
  styles: _propTypes["default"].object.isRequired,
  theme: _propTypes["default"].object.isRequired,
  css: _propTypes["default"].func.isRequired
};
exports.withStylesPropTypes = withStylesPropTypes;
var _default = withStylesPropTypes;
exports["default"] = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(482)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarDaySettings;

var _getPhrase = _interopRequireDefault(__webpack_require__(484));

var _constants = __webpack_require__(7);

function isSelected(modifiers) {
  return modifiers.has('selected') || modifiers.has('selected-span') || modifiers.has('selected-start') || modifiers.has('selected-end');
}

function shouldUseDefaultCursor(modifiers) {
  return modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
}

function isHoveredSpan(modifiers) {
  if (isSelected(modifiers)) return false;
  return modifiers.has('hovered-span') || modifiers.has('after-hovered-start') || modifiers.has('before-hovered-end');
}

function getAriaLabel(phrases, modifiers, day, ariaLabelFormat) {
  var chooseAvailableDate = phrases.chooseAvailableDate,
      dateIsUnavailable = phrases.dateIsUnavailable,
      dateIsSelected = phrases.dateIsSelected,
      dateIsSelectedAsStartDate = phrases.dateIsSelectedAsStartDate,
      dateIsSelectedAsEndDate = phrases.dateIsSelectedAsEndDate;
  var formattedDate = {
    date: day.format(ariaLabelFormat)
  };

  if (modifiers.has('selected-start') && dateIsSelectedAsStartDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsStartDate, formattedDate);
  }

  if (modifiers.has('selected-end') && dateIsSelectedAsEndDate) {
    return (0, _getPhrase["default"])(dateIsSelectedAsEndDate, formattedDate);
  }

  if (isSelected(modifiers) && dateIsSelected) {
    return (0, _getPhrase["default"])(dateIsSelected, formattedDate);
  }

  if (modifiers.has(_constants.BLOCKED_MODIFIER)) {
    return (0, _getPhrase["default"])(dateIsUnavailable, formattedDate);
  }

  return (0, _getPhrase["default"])(chooseAvailableDate, formattedDate);
}

function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
  return {
    ariaLabel: getAriaLabel(phrases, modifiers, day, ariaLabelFormat),
    hoveredSpan: isHoveredSpan(modifiers),
    isOutsideRange: modifiers.has('blocked-out-of-range'),
    selected: isSelected(modifiers),
    useDefaultCursor: shouldUseDefaultCursor(modifiers),
    daySizeStyles: {
      width: daySize,
      height: daySize - 1
    }
  };
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrase;

function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(186);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CalendarWeek;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node.isRequired
}) : {};

function CalendarWeek(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("tr", null, children);
}

CalendarWeek.propTypes =  false ? propTypes : {};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWeeks;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _constants = __webpack_require__(7);

function getCalendarMonthWeeks(month, enableOutsideDays) {
  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment["default"].localeData().firstDayOfWeek();

  if (!_moment["default"].isMoment(month) || !month.isValid()) {
    throw new TypeError('`month` must be a valid moment object');
  }

  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
  } // set utc offset to get correct dates in future (when timezone changes)


  var firstOfMonth = month.clone().startOf('month').hour(12);
  var lastOfMonth = month.clone().endOf('month').hour(12); // calculate the exact first and last days to fill the entire matrix
  // (considering days outside month)

  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
  var totalDays = lastDay.diff(firstDay, 'days') + 1;
  var currentDay = firstDay.clone();
  var weeksInMonth = [];

  for (var i = 0; i < totalDays; i += 1) {
    if (i % 7 === 0) {
      weeksInMonth.push([]);
    }

    var day = null;

    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
      day = currentDay.clone();
    }

    weeksInMonth[weeksInMonth.length - 1].push(day);
    currentDay.add(1, 'day');
  }

  return weeksInMonth;
}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isTransitionEndSupported;

function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;

function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPrevMonth;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isSameMonth = _interopRequireDefault(__webpack_require__(103));

function isPrevMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().subtract(1, 'month'), b);
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNextMonth;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isSameMonth = _interopRequireDefault(__webpack_require__(103));

function isNextMonth(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return (0, _isSameMonth["default"])(a.clone().add(1, 'month'), b);
}

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureDateRangePicker = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _moment = _interopRequireDefault(__webpack_require__(5));

var _reactWithStyles = __webpack_require__(29);

var _reactPortal = __webpack_require__(192);

var _airbnbPropTypes = __webpack_require__(13);

var _consolidatedEvents = __webpack_require__(74);

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(104));

var _DateRangePickerShape = _interopRequireDefault(__webpack_require__(196));

var _defaultPhrases = __webpack_require__(18);

var _getResponsiveContainerStyles = _interopRequireDefault(__webpack_require__(200));

var _getDetachedContainerStyles = _interopRequireDefault(__webpack_require__(201));

var _getInputHeight = _interopRequireDefault(__webpack_require__(105));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _disableScroll2 = _interopRequireDefault(__webpack_require__(202));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _DateRangePickerInputController = _interopRequireDefault(__webpack_require__(203));

var _DayPickerRangeController = _interopRequireDefault(__webpack_require__(212));

var _CloseButton = _interopRequireDefault(__webpack_require__(61));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {}, _DateRangePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive DateRangePicker
  startDate: null,
  endDate: null,
  focusedInput: null,
  // input related props
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  startDateAriaLabel: undefined,
  endDateAriaLabel: undefined,
  startDateOffset: undefined,
  endDateOffset: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  renderCalendarInfo: null,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,
  firstDayOfWeek: null,
  verticalHeight: null,
  transitionDuration: undefined,
  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
  horizontalMonthPadding: undefined,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {
    return false;
  },
  minDate: undefined,
  maxDate: undefined,
  // internationalization
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DateRangePickerPhrases,
  dayAriaLabelFormat: undefined
};

var DateRangePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DateRangePicker, _ref);
  var _proto = DateRangePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DateRangePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.state = {
      dayPickerContainerStyles: {},
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    };
    _this.isTouchDevice = false;
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocusOut = _this.onDayPickerFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focusedInput = this.props.focusedInput;

    if (focusedInput) {
      this.setState({
        isDateRangePickerInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focusedInput = this.props.focusedInput;

    if (!prevProps.focusedInput && focusedInput && this.isOpened()) {
      // The date picker just changed from being closed to being open.
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focusedInput && !focusedInput && !this.isOpened()) {
      // The date picker just changed from being open to being closed.
      if (this.enableScroll) this.enableScroll();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeDayPickerEventListeners();
    if (this.removeEventListener) this.removeEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        appendToBody = _this$props.appendToBody;
    if (!this.isOpened()) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange(null);
    onClose({
      startDate: startDate,
      endDate: endDate
    });
  };

  _proto.onDateRangePickerInputFocus = function onDateRangePickerInputFocus(focusedInput) {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focusedInput) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange(focusedInput);
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    var _this$props3 = this.props,
        focusedInput = _this$props3.focusedInput,
        onFocusChange = _this$props3.onFocusChange;
    if (!focusedInput) onFocusChange(_constants.START_DATE);
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerFocusOut = function onDayPickerFocusOut(event) {
    // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.
    var relatedTarget = event.relatedTarget === document.body ? event.target : event.relatedTarget || event.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    this.onOutsideClick(event);
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isDateRangePickerInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    if (this.dayPickerContainer) this.removeDayPickerEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addDayPickerEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addDayPickerEventListeners = function addDayPickerEventListeners() {
    // NOTE: We are using a manual event listener here, because React doesn't
    // provide FocusOut, while blur and keydown don't provide the information
    // needed in order to know whether we have left focus or not.
    //
    // For reference, this issue is further described here:
    // - https://github.com/facebook/react/issues/6410
    this.removeDayPickerFocusOut = (0, _consolidatedEvents.addEventListener)(this.dayPickerContainer, 'focusout', this.onDayPickerFocusOut);
  };

  _proto.removeDayPickerEventListeners = function removeDayPickerEventListeners() {
    if (this.removeDayPickerFocusOut) this.removeDayPickerFocusOut();
  };

  _proto.isOpened = function isOpened() {
    var focusedInput = this.props.focusedInput;
    return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props4 = this.props,
        appendToBody = _this$props4.appendToBody,
        propDisableScroll = _this$props4.disableScroll;
    if (!appendToBody && !propDisableScroll) return;
    if (!this.isOpened()) return; // Disable scroll for every ancestor of this DateRangePicker up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  };

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (Object.keys(dayPickerContainerStyles).length > 0) {
      this.setState({
        dayPickerContainerStyles: {}
      });
    }

    if (!this.isOpened()) {
      return;
    }

    var _this$props5 = this.props,
        openDirection = _this$props5.openDirection,
        anchorDirection = _this$props5.anchorDirection,
        horizontalMargin = _this$props5.horizontalMargin,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;
    var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props6 = this.props,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        appendToBody = _this$props6.appendToBody;

    if (!this.isOpened()) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(_reactPortal.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props7 = this.props,
        anchorDirection = _this$props7.anchorDirection,
        openDirection = _this$props7.openDirection,
        isDayBlocked = _this$props7.isDayBlocked,
        isDayHighlighted = _this$props7.isDayHighlighted,
        isOutsideRange = _this$props7.isOutsideRange,
        numberOfMonths = _this$props7.numberOfMonths,
        orientation = _this$props7.orientation,
        monthFormat = _this$props7.monthFormat,
        renderMonthText = _this$props7.renderMonthText,
        renderWeekHeaderElement = _this$props7.renderWeekHeaderElement,
        dayPickerNavigationInlineStyles = _this$props7.dayPickerNavigationInlineStyles,
        navPosition = _this$props7.navPosition,
        navPrev = _this$props7.navPrev,
        navNext = _this$props7.navNext,
        renderNavPrevButton = _this$props7.renderNavPrevButton,
        renderNavNextButton = _this$props7.renderNavNextButton,
        onPrevMonthClick = _this$props7.onPrevMonthClick,
        onNextMonthClick = _this$props7.onNextMonthClick,
        onDatesChange = _this$props7.onDatesChange,
        onFocusChange = _this$props7.onFocusChange,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        daySize = _this$props7.daySize,
        enableOutsideDays = _this$props7.enableOutsideDays,
        focusedInput = _this$props7.focusedInput,
        startDate = _this$props7.startDate,
        startDateOffset = _this$props7.startDateOffset,
        endDate = _this$props7.endDate,
        endDateOffset = _this$props7.endDateOffset,
        minDate = _this$props7.minDate,
        maxDate = _this$props7.maxDate,
        minimumNights = _this$props7.minimumNights,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        renderCalendarDay = _this$props7.renderCalendarDay,
        renderDayContents = _this$props7.renderDayContents,
        renderCalendarInfo = _this$props7.renderCalendarInfo,
        renderMonthElement = _this$props7.renderMonthElement,
        calendarInfoPosition = _this$props7.calendarInfoPosition,
        firstDayOfWeek = _this$props7.firstDayOfWeek,
        initialVisibleMonth = _this$props7.initialVisibleMonth,
        hideKeyboardShortcutsPanel = _this$props7.hideKeyboardShortcutsPanel,
        customCloseIcon = _this$props7.customCloseIcon,
        onClose = _this$props7.onClose,
        phrases = _this$props7.phrases,
        dayAriaLabelFormat = _this$props7.dayAriaLabelFormat,
        isRTL = _this$props7.isRTL,
        weekDayFormat = _this$props7.weekDayFormat,
        styles = _this$props7.styles,
        verticalHeight = _this$props7.verticalHeight,
        transitionDuration = _this$props7.transitionDuration,
        verticalSpacing = _this$props7.verticalSpacing,
        horizontalMonthPadding = _this$props7.horizontalMonthPadding,
        small = _this$props7.small,
        disabled = _this$props7.disabled,
        reactDates = _this$props7.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var initialVisibleMonthThunk = initialVisibleMonth || function () {
      return startDate || endDate || (0, _moment["default"])();
    };

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton_svg));

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, _reactWithStyles.css)(styles.DateRangePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === _constants.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerRangeController["default"], {
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onDatesChange: onDatesChange,
      onFocusChange: onFocusChange,
      onClose: onClose,
      focusedInput: focusedInput,
      startDate: startDate,
      startDateOffset: startDateOffset,
      endDate: endDate,
      endDateOffset: endDateOffset,
      minDate: minDate,
      maxDate: maxDate,
      monthFormat: monthFormat,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      withPortal: withAnyPortal,
      daySize: daySize,
      initialVisibleMonth: initialVisibleMonthThunk,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      minimumNights: minimumNights,
      isOutsideRange: isOutsideRange,
      isDayHighlighted: isDayHighlighted,
      isDayBlocked: isDayBlocked,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      isRTL: isRTL,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      disabled: disabled,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton), {
      type: "button",
      onClick: this.onOutsideClick,
      "aria-label": phrases.closeDatePicker
    }), closeIcon));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props8 = this.props,
        startDate = _this$props8.startDate,
        startDateId = _this$props8.startDateId,
        startDatePlaceholderText = _this$props8.startDatePlaceholderText,
        startDateAriaLabel = _this$props8.startDateAriaLabel,
        endDate = _this$props8.endDate,
        endDateId = _this$props8.endDateId,
        endDatePlaceholderText = _this$props8.endDatePlaceholderText,
        endDateAriaLabel = _this$props8.endDateAriaLabel,
        focusedInput = _this$props8.focusedInput,
        screenReaderInputMessage = _this$props8.screenReaderInputMessage,
        showClearDates = _this$props8.showClearDates,
        showDefaultInputIcon = _this$props8.showDefaultInputIcon,
        inputIconPosition = _this$props8.inputIconPosition,
        customInputIcon = _this$props8.customInputIcon,
        customArrowIcon = _this$props8.customArrowIcon,
        customCloseIcon = _this$props8.customCloseIcon,
        disabled = _this$props8.disabled,
        required = _this$props8.required,
        readOnly = _this$props8.readOnly,
        openDirection = _this$props8.openDirection,
        phrases = _this$props8.phrases,
        isOutsideRange = _this$props8.isOutsideRange,
        minimumNights = _this$props8.minimumNights,
        withPortal = _this$props8.withPortal,
        withFullScreenPortal = _this$props8.withFullScreenPortal,
        displayFormat = _this$props8.displayFormat,
        reopenPickerOnClearDates = _this$props8.reopenPickerOnClearDates,
        keepOpenOnDateSelect = _this$props8.keepOpenOnDateSelect,
        onDatesChange = _this$props8.onDatesChange,
        onClose = _this$props8.onClose,
        isRTL = _this$props8.isRTL,
        noBorder = _this$props8.noBorder,
        block = _this$props8.block,
        verticalSpacing = _this$props8.verticalSpacing,
        small = _this$props8.small,
        regular = _this$props8.regular,
        styles = _this$props8.styles;
    var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_DateRangePickerInputController["default"], {
      startDate: startDate,
      startDateId: startDateId,
      startDatePlaceholderText: startDatePlaceholderText,
      isStartDateFocused: focusedInput === _constants.START_DATE,
      startDateAriaLabel: startDateAriaLabel,
      endDate: endDate,
      endDateId: endDateId,
      endDatePlaceholderText: endDatePlaceholderText,
      isEndDateFocused: focusedInput === _constants.END_DATE,
      endDateAriaLabel: endDateAriaLabel,
      displayFormat: displayFormat,
      showClearDates: showClearDates,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customInputIcon: customInputIcon,
      customArrowIcon: customArrowIcon,
      customCloseIcon: customCloseIcon,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      reopenPickerOnClearDates: reopenPickerOnClearDates,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      isOutsideRange: isOutsideRange,
      minimumNights: minimumNights,
      withFullScreenPortal: withFullScreenPortal,
      onDatesChange: onDatesChange,
      onFocusChange: this.onDateRangePickerInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      onClose: onClose,
      phrases: phrases,
      screenReaderMessage: screenReaderInputMessage,
      isFocused: isDateRangePickerInputFocused,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, _reactWithStyles.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return DateRangePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureDateRangePicker = DateRangePicker;
DateRangePicker.propTypes =  false ? propTypes : {};
DateRangePicker.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DateRangePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    DateRangePicker__block: {
      display: 'block'
    },
    DateRangePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    DateRangePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    DateRangePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    DateRangePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    DateRangePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    DateRangePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    DateRangePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DateRangePicker);

exports["default"] = _default;

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(496);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* canUseDOM */]) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children);
      }

      this.portal = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Portal);


Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PortalCompat__ = __webpack_require__(193);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck(this, PortalWithState);

    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__PortalCompat__["a" /* default */],
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWithState.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  closeOnOutsideClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

/* harmony default export */ __webpack_exports__["a"] = (PortalWithState);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(13);

var _consolidatedEvents = __webpack_require__(74);

var _object = __webpack_require__(72);

var _object2 = _interopRequireDefault(_object);

var _document = __webpack_require__(500);

var _document2 = _interopRequireDefault(_document);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DISPLAY = {
  BLOCK: 'block',
  FLEX: 'flex',
  INLINE: 'inline',
  INLINE_BLOCK: 'inline-block',
  CONTENTS: 'contents'
};

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  children: _propTypes2['default'].node.isRequired,
  onOutsideClick: _propTypes2['default'].func.isRequired,
  disabled: _propTypes2['default'].bool,
  useCapture: _propTypes2['default'].bool,
  display: _propTypes2['default'].oneOf((0, _object2['default'])(DISPLAY))
});

var defaultProps = {
  disabled: false,

  // `useCapture` is set to true by default so that a `stopPropagation` in the
  // children will not prevent all outside click handlers from firing - maja
  useCapture: true,
  display: DISPLAY.BLOCK
};

var OutsideClickHandler = function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _ref;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _props = this.props,
            disabled = _props.disabled,
            useCapture = _props.useCapture;


        if (!disabled) this.addMouseDownEventListener(useCapture);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(_ref2) {
        var prevDisabled = _ref2.disabled;
        var _props2 = this.props,
            disabled = _props2.disabled,
            useCapture = _props2.useCapture;

        if (prevDisabled !== disabled) {
          if (disabled) {
            this.removeEventListeners();
          } else {
            this.addMouseDownEventListener(useCapture);
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.removeEventListeners();
      }

      return componentWillUnmount;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseDown',
    value: function () {
      function onMouseDown(e) {
        var useCapture = this.props.useCapture;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (!isDescendantOfRoot) {
          if (this.removeMouseUp) {
            this.removeMouseUp();
            this.removeMouseUp = null;
          }
          this.removeMouseUp = (0, _consolidatedEvents.addEventListener)(document, 'mouseup', this.onMouseUp, { capture: useCapture });
        }
      }

      return onMouseDown;
    }()

    // Use mousedown/mouseup to enforce that clicks remain outside the root's
    // descendant tree, even when dragged. This should also get triggered on
    // touch devices.

  }, {
    key: 'onMouseUp',
    value: function () {
      function onMouseUp(e) {
        var onOutsideClick = this.props.onOutsideClick;


        var isDescendantOfRoot = this.childNode && (0, _document2['default'])(this.childNode, e.target);
        if (this.removeMouseUp) {
          this.removeMouseUp();
          this.removeMouseUp = null;
        }

        if (!isDescendantOfRoot) {
          onOutsideClick(e);
        }
      }

      return onMouseUp;
    }()
  }, {
    key: 'setChildNodeRef',
    value: function () {
      function setChildNodeRef(ref) {
        this.childNode = ref;
      }

      return setChildNodeRef;
    }()
  }, {
    key: 'addMouseDownEventListener',
    value: function () {
      function addMouseDownEventListener(useCapture) {
        this.removeMouseDown = (0, _consolidatedEvents.addEventListener)(document, 'mousedown', this.onMouseDown, { capture: useCapture });
      }

      return addMouseDownEventListener;
    }()
  }, {
    key: 'removeEventListeners',
    value: function () {
      function removeEventListeners() {
        if (this.removeMouseDown) this.removeMouseDown();
        if (this.removeMouseUp) this.removeMouseUp();
      }

      return removeEventListeners;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props3 = this.props,
            children = _props3.children,
            display = _props3.display;


        return _react2['default'].createElement(
          'div',
          {
            ref: this.setChildNodeRef,
            style: display !== DISPLAY.BLOCK && (0, _object2['default'])(DISPLAY).includes(display) ? { display: display } : undefined
          },
          children
        );
      }

      return render;
    }()
  }]);

  return OutsideClickHandler;
}(_react2['default'].Component);

exports['default'] = OutsideClickHandler;


OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);

var implementation = __webpack_require__(194);
var getPolyfill = __webpack_require__(195);
var polyfill = getPolyfill();
var shim = __webpack_require__(501);

var boundContains = function contains(node, other) {
	return polyfill.apply(node, [other]);
};

define(boundContains, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundContains;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(20);
var getPolyfill = __webpack_require__(195);

module.exports = function shimContains() {
	var polyfill = getPolyfill();
	if (typeof document !== 'undefined') {
		define(
			document,
			{ contains: polyfill },
			{ contains: function () { return document.contains !== polyfill; } }
		);
		if (typeof Element !== 'undefined') {
			define(
				Element.prototype,
				{ contains: polyfill },
				{ contains: function () { return Element.prototype.contains !== polyfill; } }
			);
		}
	}
	return polyfill;
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106),
    now = __webpack_require__(503),
    toNumber = __webpack_require__(505);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(207);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(506),
    isObject = __webpack_require__(106),
    isSymbol = __webpack_require__(508);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(507);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(509),
    isObjectLike = __webpack_require__(512);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(208),
    getRawTag = __webpack_require__(510),
    objectToString = __webpack_require__(511);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(208);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 513 */
/***/ (function(module, exports) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isPreviousDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isSameDay = _interopRequireDefault(__webpack_require__(43));

function isPreviousDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  var dayBefore = (0, _moment["default"])(a).subtract(1, 'day');
  return (0, _isSameDay["default"])(dayBefore, b);
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedDateOffset;

var defaultModifier = function defaultModifier(day) {
  return day;
};

function getSelectedDateOffset(fn, day) {
  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
  if (!fn) return day;
  return modifier(fn(day.clone()));
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPreviousMonthMemoLast;
var getPreviousMonthMemoKey;
var getPreviousMonthMemoValue;

function getPreviousMonthMemoLast(month) {
  if (month !== getPreviousMonthMemoKey) {
    getPreviousMonthMemoKey = month;
    getPreviousMonthMemoValue = month.clone().subtract(1, 'month');
  }

  return getPreviousMonthMemoValue;
}

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(102));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _LeftArrow = _interopRequireDefault(__webpack_require__(210));

var _RightArrow = _interopRequireDefault(__webpack_require__(209));

var _ChevronUp = _interopRequireDefault(__webpack_require__(520));

var _ChevronDown = _interopRequireDefault(__webpack_require__(521));

var _NavPositionShape = _interopRequireDefault(__webpack_require__(51));

var _ScrollableOrientationShape = _interopRequireDefault(__webpack_require__(48));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  disablePrev: _propTypes["default"].bool,
  disableNext: _propTypes["default"].bool,
  inlineStyles: _propTypes["default"].object,
  isRTL: _propTypes["default"].bool,
  navPosition: _NavPositionShape["default"],
  navPrev: _propTypes["default"].node,
  navNext: _propTypes["default"].node,
  orientation: _ScrollableOrientationShape["default"],
  onPrevMonthClick: _propTypes["default"].func,
  onNextMonthClick: _propTypes["default"].func,
  // internationalization
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerNavigationPhrases)),
  renderNavPrevButton: _propTypes["default"].func,
  renderNavNextButton: _propTypes["default"].func,
  showNavPrevButton: _propTypes["default"].bool,
  showNavNextButton: _propTypes["default"].bool
})) : {};
var defaultProps = {
  disablePrev: false,
  disableNext: false,
  inlineStyles: null,
  isRTL: false,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  // internationalization
  phrases: _defaultPhrases.DayPickerNavigationPhrases,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  showNavPrevButton: true,
  showNavNextButton: true
};

var DayPickerNavigation =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerNavigation, _ref);

  function DayPickerNavigation() {
    return _ref.apply(this, arguments) || this;
  }

  var _proto = DayPickerNavigation.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        inlineStyles = _this$props.inlineStyles,
        isRTL = _this$props.isRTL,
        disablePrev = _this$props.disablePrev,
        disableNext = _this$props.disableNext,
        navPosition = _this$props.navPosition,
        navPrev = _this$props.navPrev,
        navNext = _this$props.navNext,
        onPrevMonthClick = _this$props.onPrevMonthClick,
        onNextMonthClick = _this$props.onNextMonthClick,
        orientation = _this$props.orientation,
        phrases = _this$props.phrases,
        renderNavPrevButton = _this$props.renderNavPrevButton,
        renderNavNextButton = _this$props.renderNavNextButton,
        showNavPrevButton = _this$props.showNavPrevButton,
        showNavNextButton = _this$props.showNavNextButton,
        styles = _this$props.styles;

    if (!showNavNextButton && !showNavPrevButton) {
      return null;
    }

    var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
    var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
    var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
    var isBottomNavPosition = navPosition === _constants.NAV_POSITION_BOTTOM;
    var hasInlineStyles = !!inlineStyles;
    var navPrevIcon = navPrev;
    var navNextIcon = navNext;
    var isDefaultNavPrev = false;
    var isDefaultNavNext = false;
    var navPrevTabIndex = {};
    var navNextTabIndex = {};

    if (!navPrevIcon && !renderNavPrevButton && showNavPrevButton) {
      navPrevTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavPrev = true;
      var Icon = isVertical ? _ChevronUp["default"] : _LeftArrow["default"];

      if (isRTL && !isVertical) {
        Icon = _RightArrow["default"];
      }

      navPrevIcon = _react["default"].createElement(Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disablePrev && styles.DayPickerNavigation_svg__disabled));
    }

    if (!navNextIcon && !renderNavNextButton && showNavNextButton) {
      navNextTabIndex = {
        tabIndex: '0'
      };
      isDefaultNavNext = true;

      var _Icon = isVertical ? _ChevronDown["default"] : _RightArrow["default"];

      if (isRTL && !isVertical) {
        _Icon = _LeftArrow["default"];
      }

      navNextIcon = _react["default"].createElement(_Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical, disableNext && styles.DayPickerNavigation_svg__disabled));
    }

    var isDefaultNav = isDefaultNavNext || isDefaultNavPrev;
    return _react["default"].createElement("div", _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation, isHorizontal && styles.DayPickerNavigation__horizontal].concat((0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation__vertical, isDefaultNav && styles.DayPickerNavigation__verticalDefault] : []), (0, _toConsumableArray2["default"])(isVerticalScrollable ? [styles.DayPickerNavigation__verticalScrollable, isDefaultNav && styles.DayPickerNavigation__verticalScrollableDefault, showNavPrevButton && styles.DayPickerNavigation__verticalScrollable_prevNav] : []), (0, _toConsumableArray2["default"])(isBottomNavPosition ? [styles.DayPickerNavigation__bottom, isDefaultNav && styles.DayPickerNavigation__bottomDefault] : []), [hasInlineStyles && inlineStyles])), showNavPrevButton && (renderNavPrevButton ? renderNavPrevButton({
      ariaLabel: phrases.jumpToPrevMonth,
      disabled: disablePrev,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navPrevTabIndex, _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default, disablePrev && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavPrev ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_prevButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_prevButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disablePrev ? true : undefined,
      "aria-label": phrases.jumpToPrevMonth,
      onClick: disablePrev ? undefined : onPrevMonthClick,
      onKeyUp: disablePrev ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onPrevMonthClick(e);
        }
      },
      onMouseUp: disablePrev ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navPrevIcon)), showNavNextButton && (renderNavNextButton ? renderNavNextButton({
      ariaLabel: phrases.jumpToNextMonth,
      disabled: disableNext,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }) : _react["default"].createElement("div", (0, _extends2["default"])({
      // eslint-disable-line jsx-a11y/interactive-supports-focus
      role: "button"
    }, navNextTabIndex, _reactWithStyles.css.apply(void 0, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default, disableNext && styles.DayPickerNavigation_button__disabled].concat((0, _toConsumableArray2["default"])(isHorizontal ? [styles.DayPickerNavigation_button__horizontal].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__horizontalDefault, isBottomNavPosition && styles.DayPickerNavigation_bottomButton__horizontalDefault, isRTL && styles.DayPickerNavigation_leftButton__horizontalDefault, !isRTL && styles.DayPickerNavigation_rightButton__horizontalDefault] : [])) : []), (0, _toConsumableArray2["default"])(isVertical ? [styles.DayPickerNavigation_button__vertical].concat((0, _toConsumableArray2["default"])(isDefaultNavNext ? [styles.DayPickerNavigation_button__verticalDefault, styles.DayPickerNavigation_nextButton__verticalDefault, isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollableDefault] : [])) : []))), {
      "aria-disabled": disableNext ? true : undefined,
      "aria-label": phrases.jumpToNextMonth,
      onClick: disableNext ? undefined : onNextMonthClick,
      onKeyUp: disableNext ? undefined : function (e) {
        var key = e.key;

        if (key === 'Enter' || key === ' ') {
          onNextMonthClick(e);
        }
      },
      onMouseUp: disableNext ? undefined : function (e) {
        e.currentTarget.blur();
      }
    }), navNextIcon)));
  };

  return DayPickerNavigation;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerNavigation.propTypes =  false ? propTypes : {};
DayPickerNavigation.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var _ref2$reactDates = _ref2.reactDates,
      color = _ref2$reactDates.color,
      zIndex = _ref2$reactDates.zIndex;
  return {
    DayPickerNavigation: {
      position: 'relative',
      zIndex: zIndex + 2
    },
    DayPickerNavigation__horizontal: {
      height: 0
    },
    DayPickerNavigation__vertical: {},
    DayPickerNavigation__verticalScrollable: {},
    DayPickerNavigation__verticalScrollable_prevNav: {
      zIndex: zIndex + 1 // zIndex + 2 causes the button to show on top of the day of week headers

    },
    DayPickerNavigation__verticalDefault: {
      position: 'absolute',
      width: '100%',
      height: 52,
      bottom: 0,
      left: (0, _noflip["default"])(0)
    },
    DayPickerNavigation__verticalScrollableDefault: {
      position: 'relative'
    },
    DayPickerNavigation__bottom: {
      height: 'auto'
    },
    DayPickerNavigation__bottomDefault: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    DayPickerNavigation_button: {
      cursor: 'pointer',
      userSelect: 'none',
      border: 0,
      padding: 0,
      margin: 0
    },
    DayPickerNavigation_button__default: {
      border: "1px solid ".concat(color.core.borderLight),
      backgroundColor: color.background,
      color: color.placeholderText,
      ':focus': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':hover': {
        border: "1px solid ".concat(color.core.borderMedium)
      },
      ':active': {
        background: color.backgroundDark
      }
    },
    DayPickerNavigation_button__disabled: {
      cursor: 'default',
      border: "1px solid ".concat(color.disabled),
      ':focus': {
        border: "1px solid ".concat(color.disabled)
      },
      ':hover': {
        border: "1px solid ".concat(color.disabled)
      },
      ':active': {
        background: 'none'
      }
    },
    DayPickerNavigation_button__horizontal: {},
    DayPickerNavigation_button__horizontalDefault: {
      position: 'absolute',
      top: 18,
      lineHeight: 0.78,
      borderRadius: 3,
      padding: '6px 9px'
    },
    DayPickerNavigation_bottomButton__horizontalDefault: {
      position: 'static',
      marginLeft: 22,
      marginRight: 22,
      marginBottom: 30,
      marginTop: -10
    },
    DayPickerNavigation_leftButton__horizontalDefault: {
      left: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_rightButton__horizontalDefault: {
      right: (0, _noflip["default"])(22)
    },
    DayPickerNavigation_button__vertical: {},
    DayPickerNavigation_button__verticalDefault: {
      padding: 5,
      background: color.background,
      boxShadow: (0, _noflip["default"])('0 0 5px 2px rgba(0, 0, 0, 0.1)'),
      position: 'relative',
      display: 'inline-block',
      textAlign: 'center',
      height: '100%',
      width: '50%'
    },
    DayPickerNavigation_prevButton__verticalDefault: {},
    DayPickerNavigation_nextButton__verticalDefault: {
      borderLeft: (0, _noflip["default"])(0)
    },
    DayPickerNavigation_nextButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_prevButton__verticalScrollableDefault: {
      width: '100%'
    },
    DayPickerNavigation_svg__horizontal: {
      height: 19,
      width: 19,
      fill: color.core.grayLight,
      display: 'block'
    },
    DayPickerNavigation_svg__vertical: {
      height: 42,
      width: 42,
      fill: color.text
    },
    DayPickerNavigation_svg__disabled: {
      fill: color.disabled
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerNavigation);

exports["default"] = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var ChevronUp = function ChevronUp(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M32 713l453-453c11-11 21-11 32 0l453 453c5 5 7 10 7 16 0 13-10 23-22 23-7 0-12-2-16-7L501 309 64 745c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32z"
  }));
};

ChevronUp.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronUp;
exports["default"] = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var ChevronDown = function ChevronDown(props) {
  return _react["default"].createElement("svg", props, _react["default"].createElement("path", {
    d: "M968 289L514 741c-11 11-21 11-32 0L29 289c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437 436 438-436c4-5 9-7 16-7 6 0 11 2 16 7 9 10 9 21 0 32z"
  }));
};

ChevronDown.defaultProps = {
  focusable: "false",
  viewBox: "0 0 1000 1000"
};
var _default = ChevronDown;
exports["default"] = _default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _KeyboardShortcutRow = _interopRequireDefault(__webpack_require__(523));

var _CloseButton = _interopRequireDefault(__webpack_require__(61));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TOP_LEFT = 'top-left';
exports.TOP_LEFT = TOP_LEFT;
var TOP_RIGHT = 'top-right';
exports.TOP_RIGHT = TOP_RIGHT;
var BOTTOM_RIGHT = 'bottom-right';
exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  block: _propTypes["default"].bool,
  // TODO: rename button location to be direction-agnostic
  buttonLocation: _propTypes["default"].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: _propTypes["default"].bool,
  openKeyboardShortcutsPanel: _propTypes["default"].func,
  closeKeyboardShortcutsPanel: _propTypes["default"].func,
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases)),
  renderKeyboardShortcutsButton: _propTypes["default"].func,
  renderKeyboardShortcutsPanel: _propTypes["default"].func
})) : {};
var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function openKeyboardShortcutsPanel() {},
  closeKeyboardShortcutsPanel: function closeKeyboardShortcutsPanel() {},
  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases,
  renderKeyboardShortcutsButton: undefined,
  renderKeyboardShortcutsPanel: undefined
};

function getKeyboardShortcuts(phrases) {
  return [{
    unicode: '↵',
    label: phrases.enterKey,
    action: phrases.selectFocusedDate
  }, {
    unicode: '←/→',
    label: phrases.leftArrowRightArrow,
    action: phrases.moveFocusByOneDay
  }, {
    unicode: '↑/↓',
    label: phrases.upArrowDownArrow,
    action: phrases.moveFocusByOneWeek
  }, {
    unicode: 'PgUp/PgDn',
    label: phrases.pageUpPageDown,
    action: phrases.moveFocusByOneMonth
  }, {
    unicode: 'Home/End',
    label: phrases.homeEnd,
    action: phrases.moveFocustoStartAndEndOfWeek
  }, {
    unicode: 'Esc',
    label: phrases.escape,
    action: phrases.returnFocusToInput
  }, {
    unicode: '?',
    label: phrases.questionMark,
    action: phrases.openThisPanel
  }];
}

var DayPickerKeyboardShortcuts =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(DayPickerKeyboardShortcuts, _ref);
  var _proto = DayPickerKeyboardShortcuts.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function DayPickerKeyboardShortcuts() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _ref.call.apply(_ref, [this].concat(args)) || this;
    var phrases = _this.props.phrases;
    _this.keyboardShortcuts = getKeyboardShortcuts(phrases);
    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onKeyDown = _this.onKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var phrases = this.props.phrases;

    if (nextProps.phrases !== phrases) {
      this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.handleFocus();
  };

  _proto.onKeyDown = function onKeyDown(e) {
    e.stopPropagation();
    var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel; // Because the close button is the only focusable element inside of the panel, this
    // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
    // close button or hitting escape

    switch (e.key) {
      case 'Escape':
        closeKeyboardShortcutsPanel();
        break;
      // do nothing - this allows the up and down arrows continue their
      // default behavior of scrolling the content of the Keyboard Shortcuts Panel
      // which is needed when only a single month is shown for instance.

      case 'ArrowUp':
      case 'ArrowDown':
        break;
      // completely block the rest of the keys that have functionality outside of this panel

      case 'Tab':
      case 'Home':
      case 'End':
      case 'PageUp':
      case 'PageDown':
      case 'ArrowLeft':
      case 'ArrowRight':
        e.preventDefault();
        break;

      default:
        break;
    }
  };

  _proto.onShowKeyboardShortcutsButtonClick = function onShowKeyboardShortcutsButtonClick() {
    var _this2 = this;

    var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel; // we want to return focus to this button after closing the keyboard shortcuts panel

    openKeyboardShortcutsPanel(function () {
      _this2.showKeyboardShortcutsButton.focus();
    });
  };

  _proto.setShowKeyboardShortcutsButtonRef = function setShowKeyboardShortcutsButtonRef(ref) {
    this.showKeyboardShortcutsButton = ref;
  };

  _proto.setHideKeyboardShortcutsButtonRef = function setHideKeyboardShortcutsButtonRef(ref) {
    this.hideKeyboardShortcutsButton = ref;
  };

  _proto.handleFocus = function handleFocus() {
    if (this.hideKeyboardShortcutsButton) {
      // automatically move focus into the dialog by moving
      // to the only interactive element, the hide button
      this.hideKeyboardShortcutsButton.focus();
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        buttonLocation = _this$props.buttonLocation,
        showKeyboardShortcutsPanel = _this$props.showKeyboardShortcutsPanel,
        closeKeyboardShortcutsPanel = _this$props.closeKeyboardShortcutsPanel,
        styles = _this$props.styles,
        phrases = _this$props.phrases,
        renderKeyboardShortcutsButton = _this$props.renderKeyboardShortcutsButton,
        renderKeyboardShortcutsPanel = _this$props.renderKeyboardShortcutsPanel;
    var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
    var bottomRight = buttonLocation === BOTTOM_RIGHT;
    var topRight = buttonLocation === TOP_RIGHT;
    var topLeft = buttonLocation === TOP_LEFT;
    return _react["default"].createElement("div", null, renderKeyboardShortcutsButton && renderKeyboardShortcutsButton({
      // passing in context-specific props
      ref: this.setShowKeyboardShortcutsButtonRef,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      ariaLabel: toggleButtonText
    }), !renderKeyboardShortcutsButton && _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setShowKeyboardShortcutsButtonRef
    }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
      type: "button",
      "aria-label": toggleButtonText,
      onClick: this.onShowKeyboardShortcutsButtonClick,
      onMouseUp: function onMouseUp(e) {
        e.currentTarget.blur();
      }
    }), _react["default"].createElement("span", (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft), "?")), showKeyboardShortcutsPanel && (renderKeyboardShortcutsPanel ? renderKeyboardShortcutsPanel({
      closeButtonAriaLabel: phrases.hideKeyboardShortcutsPanel,
      keyboardShortcuts: this.keyboardShortcuts,
      onCloseButtonClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown,
      title: phrases.keyboardShortcuts
    }) : _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_panel), {
      role: "dialog",
      "aria-labelledby": "DayPickerKeyboardShortcuts_title",
      "aria-describedby": "DayPickerKeyboardShortcuts_description"
    }), _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_title), {
      id: "DayPickerKeyboardShortcuts_title"
    }), phrases.keyboardShortcuts), _react["default"].createElement("button", (0, _extends2["default"])({
      ref: this.setHideKeyboardShortcutsButtonRef
    }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
      type: "button",
      tabIndex: "0",
      "aria-label": phrases.hideKeyboardShortcutsPanel,
      onClick: closeKeyboardShortcutsPanel,
      onKeyDown: this.onKeyDown
    }), _react["default"].createElement(_CloseButton["default"], (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_closeSvg))), _react["default"].createElement("ul", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_list), {
      id: "DayPickerKeyboardShortcuts_description"
    }), this.keyboardShortcuts.map(function (_ref2) {
      var unicode = _ref2.unicode,
          label = _ref2.label,
          action = _ref2.action;
      return _react["default"].createElement(_KeyboardShortcutRow["default"], {
        key: label,
        unicode: unicode,
        label: label,
        action: action,
        block: block
      });
    })))));
  };

  return DayPickerKeyboardShortcuts;
}(_react["default"].PureComponent || _react["default"].Component);

DayPickerKeyboardShortcuts.propTypes =  false ? propTypes : {};
DayPickerKeyboardShortcuts.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      font = _ref3$reactDates.font,
      zIndex = _ref3$reactDates.zIndex;
  return {
    DayPickerKeyboardShortcuts_buttonReset: {
      background: 'none',
      border: 0,
      borderRadius: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      padding: 0,
      cursor: 'pointer',
      fontSize: font.size,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_show: {
      width: 33,
      height: 26,
      position: 'absolute',
      zIndex: zIndex + 2,
      '::before': {
        content: '""',
        display: 'block',
        position: 'absolute'
      }
    },
    DayPickerKeyboardShortcuts_show__bottomRight: {
      bottom: 0,
      right: 0,
      '::before': {
        borderTop: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        bottom: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topRight: {
      top: 0,
      right: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderRight: "33px solid ".concat(color.core.primary),
        top: 0,
        right: 0
      },
      ':hover::before': {
        borderRight: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_show__topLeft: {
      top: 0,
      left: 0,
      '::before': {
        borderBottom: '26px solid transparent',
        borderLeft: "33px solid ".concat(color.core.primary),
        top: 0,
        left: 0
      },
      ':hover::before': {
        borderLeft: "33px solid ".concat(color.core.primary_dark)
      }
    },
    DayPickerKeyboardShortcuts_showSpan: {
      color: color.core.white,
      position: 'absolute'
    },
    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
      bottom: 0,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topRight: {
      top: 1,
      right: 5
    },
    DayPickerKeyboardShortcuts_showSpan__topLeft: {
      top: 1,
      left: 5
    },
    DayPickerKeyboardShortcuts_panel: {
      overflow: 'auto',
      background: color.background,
      border: "1px solid ".concat(color.core.border),
      borderRadius: 2,
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      zIndex: zIndex + 2,
      padding: 22,
      margin: 33,
      textAlign: 'left' // TODO: investigate use of text-align throughout the library

    },
    DayPickerKeyboardShortcuts_title: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: 0
    },
    DayPickerKeyboardShortcuts_list: {
      listStyle: 'none',
      padding: 0,
      fontSize: font.size
    },
    DayPickerKeyboardShortcuts_close: {
      position: 'absolute',
      right: 22,
      top: 22,
      zIndex: zIndex + 2,
      ':active': {
        outline: 'none'
      }
    },
    DayPickerKeyboardShortcuts_closeSvg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter,
      ':hover': {
        fill: color.core.grayLight
      },
      ':focus': {
        fill: color.core.grayLight
      }
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(DayPickerKeyboardShortcuts);

exports["default"] = _default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _airbnbPropTypes = __webpack_require__(13);

var _reactWithStyles = __webpack_require__(29);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {
  unicode: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  action: _propTypes["default"].string.isRequired,
  block: _propTypes["default"].bool
})) : {};
var defaultProps = {
  block: false
};

function KeyboardShortcutRow(_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action,
      block = _ref.block,
      styles = _ref.styles;
  return _react["default"].createElement("li", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block), _react["default"].createElement("span", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_key), {
    role: "img",
    "aria-label": "".concat(label, ",") // add comma so screen readers will pause before reading action

  }), unicode)), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_action), action));
}

KeyboardShortcutRow.propTypes =  false ? propTypes : {};
KeyboardShortcutRow.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref2) {
  var color = _ref2.reactDates.color;
  return {
    KeyboardShortcutRow: {
      listStyle: 'none',
      margin: '6px 0'
    },
    KeyboardShortcutRow__block: {
      marginBottom: 16
    },
    KeyboardShortcutRow_keyContainer: {
      display: 'inline-block',
      whiteSpace: 'nowrap',
      textAlign: 'right',
      // is not handled by isRTL
      marginRight: 6 // is not handled by isRTL

    },
    KeyboardShortcutRow_keyContainer__block: {
      textAlign: 'left',
      // is not handled by isRTL
      display: 'inline'
    },
    KeyboardShortcutRow_key: {
      fontFamily: 'monospace',
      fontSize: 12,
      textTransform: 'uppercase',
      background: color.core.grayLightest,
      padding: '2px 6px'
    },
    KeyboardShortcutRow_action: {
      display: 'inline',
      wordBreak: 'break-word',
      marginLeft: 8 // is not handled by isRTL

    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(KeyboardShortcutRow);

exports["default"] = _default;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNumberOfCalendarMonthWeeks;

var _moment = _interopRequireDefault(__webpack_require__(5));

function getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek) {
  var weekDayDiff = firstDayOfMonth.day() - firstDayOfWeek;
  return (weekDayDiff + 7) % 7;
}

function getNumberOfCalendarMonthWeeks(month) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment["default"].localeData().firstDayOfWeek();
  var firstDayOfMonth = month.clone().startOf('month');
  var numBlankDays = getBlankDaysBeforeFirstDay(firstDayOfMonth, firstDayOfWeek);
  return Math.ceil((numBlankDays + month.daysInMonth()) / 7);
}

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getActiveElement;

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PureSingleDatePicker = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _extends2 = _interopRequireDefault(__webpack_require__(25));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(15));

var _react = _interopRequireDefault(__webpack_require__(0));

var _moment = _interopRequireDefault(__webpack_require__(5));

var _reactWithStyles = __webpack_require__(29);

var _reactPortal = __webpack_require__(192);

var _airbnbPropTypes = __webpack_require__(13);

var _consolidatedEvents = __webpack_require__(74);

var _isTouchDevice = _interopRequireDefault(__webpack_require__(49));

var _reactOutsideClickHandler = _interopRequireDefault(__webpack_require__(104));

var _SingleDatePickerShape = _interopRequireDefault(__webpack_require__(219));

var _defaultPhrases = __webpack_require__(18);

var _getResponsiveContainerStyles = _interopRequireDefault(__webpack_require__(200));

var _getDetachedContainerStyles = _interopRequireDefault(__webpack_require__(201));

var _getInputHeight = _interopRequireDefault(__webpack_require__(105));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _disableScroll2 = _interopRequireDefault(__webpack_require__(202));

var _noflip = _interopRequireDefault(__webpack_require__(40));

var _SingleDatePickerInputController = _interopRequireDefault(__webpack_require__(527));

var _DayPickerSingleDateController = _interopRequireDefault(__webpack_require__(218));

var _CloseButton = _interopRequireDefault(__webpack_require__(61));

var _constants = __webpack_require__(7);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)(_objectSpread({}, _reactWithStyles.withStylesPropTypes, {}, _SingleDatePickerShape["default"])) : {};
var defaultProps = {
  // required props for a functional interactive SingleDatePicker
  date: null,
  focused: false,
  // input related props
  id: 'date',
  placeholder: 'Date',
  ariaLabel: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customCloseIcon: null,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
  keepFocusOnInput: false,
  // calendar presentation and interaction related props
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  appendToBody: false,
  disableScroll: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  renderCalendarInfo: null,
  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,
  verticalHeight: null,
  transitionDuration: undefined,
  horizontalMonthPadding: 13,
  // navigation related props
  dayPickerNavigationInlineStyles: null,
  navPosition: _constants.NAV_POSITION_TOP,
  navPrev: null,
  navNext: null,
  renderNavPrevButton: null,
  renderNavNextButton: null,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onClose: function onClose() {},
  // month presentation and interaction related props
  renderMonthText: null,
  renderWeekHeaderElement: null,
  // day presentation and interaction related props
  renderCalendarDay: undefined,
  renderDayContents: null,
  renderMonthElement: null,
  enableOutsideDays: false,
  isDayBlocked: function isDayBlocked() {
    return false;
  },
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  isDayHighlighted: function isDayHighlighted() {},
  // internationalization props
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.SingleDatePickerPhrases,
  dayAriaLabelFormat: undefined
};

var SingleDatePicker =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePicker, _ref);
  var _proto = SingleDatePicker.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePicker(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.isTouchDevice = false;
    _this.state = {
      dayPickerContainerStyles: {},
      isDayPickerFocused: false,
      isInputFocused: false,
      showKeyboardShortcuts: false
    };
    _this.onFocusOut = _this.onFocusOut.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onOutsideClick = _this.onOutsideClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onInputFocus = _this.onInputFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind((0, _assertThisInitialized2["default"])(_this));
    _this.disableScroll = _this.disableScroll.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setContainerRef = _this.setContainerRef.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  /* istanbul ignore next */


  _proto.componentDidMount = function componentDidMount() {
    this.removeResizeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, {
      passive: true
    });
    this.responsivizePickerPosition();
    this.disableScroll();
    var focused = this.props.focused;

    if (focused) {
      this.setState({
        isInputFocused: true
      });
    }

    this.isTouchDevice = (0, _isTouchDevice["default"])();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var focused = this.props.focused;

    if (!prevProps.focused && focused) {
      this.responsivizePickerPosition();
      this.disableScroll();
    } else if (prevProps.focused && !focused) {
      if (this.enableScroll) this.enableScroll();
    }
  }
  /* istanbul ignore next */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeResizeEventListener) this.removeResizeEventListener();
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
    if (this.enableScroll) this.enableScroll();
  };

  _proto.onOutsideClick = function onOutsideClick(event) {
    var _this$props = this.props,
        focused = _this$props.focused,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose,
        date = _this$props.date,
        appendToBody = _this$props.appendToBody;
    if (!focused) return;
    if (appendToBody && this.dayPickerContainer.contains(event.target)) return;
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.onInputFocus = function onInputFocus(_ref2) {
    var focused = _ref2.focused;
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        readOnly = _this$props2.readOnly,
        withPortal = _this$props2.withPortal,
        withFullScreenPortal = _this$props2.withFullScreenPortal,
        keepFocusOnInput = _this$props2.keepFocusOnInput;

    if (focused) {
      var withAnyPortal = withPortal || withFullScreenPortal;
      var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;

      if (moveFocusToDayPicker) {
        this.onDayPickerFocus();
      } else {
        this.onDayPickerBlur();
      }
    }

    onFocusChange({
      focused: focused
    });
  };

  _proto.onDayPickerFocus = function onDayPickerFocus() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: false
    });
  };

  _proto.onDayPickerBlur = function onDayPickerBlur() {
    this.setState({
      isInputFocused: true,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    });
  };

  _proto.onFocusOut = function onFocusOut(e) {
    var onFocusChange = this.props.onFocusChange; // In cases where **relatedTarget** is not null, it points to the right
    // element here. However, in cases where it is null (such as clicking on a
    // specific day) or it is **document.body** (IE11), the appropriate value is **event.target**.
    //
    // We handle both situations here by using the ` || ` operator to fallback
    // to *event.target** when **relatedTarget** is not provided.

    var relatedTarget = e.relatedTarget === document.body ? e.target : e.relatedTarget || e.target;
    if (this.dayPickerContainer.contains(relatedTarget)) return;
    onFocusChange({
      focused: false
    });
  };

  _proto.setDayPickerContainerRef = function setDayPickerContainerRef(ref) {
    if (ref === this.dayPickerContainer) return;
    this.removeEventListeners();
    this.dayPickerContainer = ref;
    if (!ref) return;
    this.addEventListeners();
  };

  _proto.setContainerRef = function setContainerRef(ref) {
    this.container = ref;
  };

  _proto.addEventListeners = function addEventListeners() {
    // We manually set event because React has not implemented onFocusIn/onFocusOut.
    // Keep an eye on https://github.com/facebook/react/issues/6410 for updates
    // We use "blur w/ useCapture param" vs "onfocusout" for FF browser support
    this.removeFocusOutEventListener = (0, _consolidatedEvents.addEventListener)(this.dayPickerContainer, 'focusout', this.onFocusOut);
  };

  _proto.removeEventListeners = function removeEventListeners() {
    if (this.removeFocusOutEventListener) this.removeFocusOutEventListener();
  };

  _proto.disableScroll = function disableScroll() {
    var _this$props3 = this.props,
        appendToBody = _this$props3.appendToBody,
        propDisableScroll = _this$props3.disableScroll,
        focused = _this$props3.focused;
    if (!appendToBody && !propDisableScroll) return;
    if (!focused) return; // Disable scroll for every ancestor of this <SingleDatePicker> up to the
    // document level. This ensures the input and the picker never move. Other
    // sibling elements or the picker itself can scroll.

    this.enableScroll = (0, _disableScroll2["default"])(this.container);
  }
  /* istanbul ignore next */
  ;

  _proto.responsivizePickerPosition = function responsivizePickerPosition() {
    // It's possible the portal props have been changed in response to window resizes
    // So let's ensure we reset this back to the base state each time
    this.setState({
      dayPickerContainerStyles: {}
    });
    var _this$props4 = this.props,
        openDirection = _this$props4.openDirection,
        anchorDirection = _this$props4.anchorDirection,
        horizontalMargin = _this$props4.horizontalMargin,
        withPortal = _this$props4.withPortal,
        withFullScreenPortal = _this$props4.withFullScreenPortal,
        appendToBody = _this$props4.appendToBody,
        focused = _this$props4.focused;
    var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

    if (!focused) {
      return;
    }

    var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;

    if (!withPortal && !withFullScreenPortal) {
      var containerRect = this.dayPickerContainer.getBoundingClientRect();
      var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
      var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
      this.setState({
        dayPickerContainerStyles: _objectSpread({}, (0, _getResponsiveContainerStyles["default"])(anchorDirection, currentOffset, containerEdge, horizontalMargin), {}, appendToBody && (0, _getDetachedContainerStyles["default"])(openDirection, anchorDirection, this.container))
      });
    }
  };

  _proto.showKeyboardShortcutsPanel = function showKeyboardShortcutsPanel() {
    this.setState({
      isInputFocused: false,
      isDayPickerFocused: true,
      showKeyboardShortcuts: true
    });
  };

  _proto.maybeRenderDayPickerWithPortal = function maybeRenderDayPickerWithPortal() {
    var _this$props5 = this.props,
        focused = _this$props5.focused,
        withPortal = _this$props5.withPortal,
        withFullScreenPortal = _this$props5.withFullScreenPortal,
        appendToBody = _this$props5.appendToBody;

    if (!focused) {
      return null;
    }

    if (withPortal || withFullScreenPortal || appendToBody) {
      return _react["default"].createElement(_reactPortal.Portal, null, this.renderDayPicker());
    }

    return this.renderDayPicker();
  };

  _proto.renderDayPicker = function renderDayPicker() {
    var _this$props6 = this.props,
        anchorDirection = _this$props6.anchorDirection,
        openDirection = _this$props6.openDirection,
        onDateChange = _this$props6.onDateChange,
        date = _this$props6.date,
        onFocusChange = _this$props6.onFocusChange,
        focused = _this$props6.focused,
        enableOutsideDays = _this$props6.enableOutsideDays,
        numberOfMonths = _this$props6.numberOfMonths,
        orientation = _this$props6.orientation,
        monthFormat = _this$props6.monthFormat,
        dayPickerNavigationInlineStyles = _this$props6.dayPickerNavigationInlineStyles,
        navPosition = _this$props6.navPosition,
        navPrev = _this$props6.navPrev,
        navNext = _this$props6.navNext,
        renderNavPrevButton = _this$props6.renderNavPrevButton,
        renderNavNextButton = _this$props6.renderNavNextButton,
        onPrevMonthClick = _this$props6.onPrevMonthClick,
        onNextMonthClick = _this$props6.onNextMonthClick,
        onClose = _this$props6.onClose,
        withPortal = _this$props6.withPortal,
        withFullScreenPortal = _this$props6.withFullScreenPortal,
        keepOpenOnDateSelect = _this$props6.keepOpenOnDateSelect,
        initialVisibleMonth = _this$props6.initialVisibleMonth,
        renderMonthText = _this$props6.renderMonthText,
        renderWeekHeaderElement = _this$props6.renderWeekHeaderElement,
        renderCalendarDay = _this$props6.renderCalendarDay,
        renderDayContents = _this$props6.renderDayContents,
        renderCalendarInfo = _this$props6.renderCalendarInfo,
        renderMonthElement = _this$props6.renderMonthElement,
        calendarInfoPosition = _this$props6.calendarInfoPosition,
        hideKeyboardShortcutsPanel = _this$props6.hideKeyboardShortcutsPanel,
        firstDayOfWeek = _this$props6.firstDayOfWeek,
        customCloseIcon = _this$props6.customCloseIcon,
        phrases = _this$props6.phrases,
        dayAriaLabelFormat = _this$props6.dayAriaLabelFormat,
        daySize = _this$props6.daySize,
        isRTL = _this$props6.isRTL,
        isOutsideRange = _this$props6.isOutsideRange,
        isDayBlocked = _this$props6.isDayBlocked,
        isDayHighlighted = _this$props6.isDayHighlighted,
        weekDayFormat = _this$props6.weekDayFormat,
        styles = _this$props6.styles,
        verticalHeight = _this$props6.verticalHeight,
        transitionDuration = _this$props6.transitionDuration,
        verticalSpacing = _this$props6.verticalSpacing,
        horizontalMonthPadding = _this$props6.horizontalMonthPadding,
        small = _this$props6.small,
        reactDates = _this$props6.theme.reactDates;
    var _this$state = this.state,
        dayPickerContainerStyles = _this$state.dayPickerContainerStyles,
        isDayPickerFocused = _this$state.isDayPickerFocused,
        showKeyboardShortcuts = _this$state.showKeyboardShortcuts;
    var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;

    var closeIcon = customCloseIcon || _react["default"].createElement(_CloseButton["default"], null);

    var inputHeight = (0, _getInputHeight["default"])(reactDates, small);
    var withAnyPortal = withPortal || withFullScreenPortal;
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setDayPickerContainerRef
    }, (0, _reactWithStyles.css)(styles.SingleDatePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === _constants.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
      top: inputHeight + verticalSpacing
    }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
      bottom: inputHeight + verticalSpacing
    }, orientation === _constants.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
      onClick: onOutsideClick
    }), _react["default"].createElement(_DayPickerSingleDateController["default"], {
      date: date,
      onDateChange: onDateChange,
      onFocusChange: onFocusChange,
      orientation: orientation,
      enableOutsideDays: enableOutsideDays,
      numberOfMonths: numberOfMonths,
      monthFormat: monthFormat,
      withPortal: withAnyPortal,
      focused: focused,
      keepOpenOnDateSelect: keepOpenOnDateSelect,
      hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
      initialVisibleMonth: initialVisibleMonth,
      dayPickerNavigationInlineStyles: dayPickerNavigationInlineStyles,
      navPosition: navPosition,
      navPrev: navPrev,
      navNext: navNext,
      renderNavPrevButton: renderNavPrevButton,
      renderNavNextButton: renderNavNextButton,
      onPrevMonthClick: onPrevMonthClick,
      onNextMonthClick: onNextMonthClick,
      onClose: onClose,
      renderMonthText: renderMonthText,
      renderWeekHeaderElement: renderWeekHeaderElement,
      renderCalendarDay: renderCalendarDay,
      renderDayContents: renderDayContents,
      renderCalendarInfo: renderCalendarInfo,
      renderMonthElement: renderMonthElement,
      calendarInfoPosition: calendarInfoPosition,
      isFocused: isDayPickerFocused,
      showKeyboardShortcuts: showKeyboardShortcuts,
      onBlur: this.onDayPickerBlur,
      phrases: phrases,
      dayAriaLabelFormat: dayAriaLabelFormat,
      daySize: daySize,
      isRTL: isRTL,
      isOutsideRange: isOutsideRange,
      isDayBlocked: isDayBlocked,
      isDayHighlighted: isDayHighlighted,
      firstDayOfWeek: firstDayOfWeek,
      weekDayFormat: weekDayFormat,
      verticalHeight: verticalHeight,
      transitionDuration: transitionDuration,
      horizontalMonthPadding: horizontalMonthPadding
    }), withFullScreenPortal && _react["default"].createElement("button", (0, _extends2["default"])({}, (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton), {
      "aria-label": phrases.closeDatePicker,
      type: "button",
      onClick: this.onOutsideClick
    }), _react["default"].createElement("div", (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton_svg), closeIcon)));
    /* eslint-enable jsx-a11y/no-static-element-interactions */

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  };

  _proto.render = function render() {
    var _this$props7 = this.props,
        id = _this$props7.id,
        placeholder = _this$props7.placeholder,
        ariaLabel = _this$props7.ariaLabel,
        disabled = _this$props7.disabled,
        focused = _this$props7.focused,
        required = _this$props7.required,
        readOnly = _this$props7.readOnly,
        openDirection = _this$props7.openDirection,
        showClearDate = _this$props7.showClearDate,
        showDefaultInputIcon = _this$props7.showDefaultInputIcon,
        inputIconPosition = _this$props7.inputIconPosition,
        customCloseIcon = _this$props7.customCloseIcon,
        customInputIcon = _this$props7.customInputIcon,
        date = _this$props7.date,
        onDateChange = _this$props7.onDateChange,
        displayFormat = _this$props7.displayFormat,
        phrases = _this$props7.phrases,
        withPortal = _this$props7.withPortal,
        withFullScreenPortal = _this$props7.withFullScreenPortal,
        screenReaderInputMessage = _this$props7.screenReaderInputMessage,
        isRTL = _this$props7.isRTL,
        noBorder = _this$props7.noBorder,
        block = _this$props7.block,
        small = _this$props7.small,
        regular = _this$props7.regular,
        verticalSpacing = _this$props7.verticalSpacing,
        reopenPickerOnClearDate = _this$props7.reopenPickerOnClearDate,
        keepOpenOnDateSelect = _this$props7.keepOpenOnDateSelect,
        styles = _this$props7.styles,
        isOutsideRange = _this$props7.isOutsideRange;
    var isInputFocused = this.state.isInputFocused;
    var enableOutsideClick = !withPortal && !withFullScreenPortal;
    var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;

    var input = _react["default"].createElement(_SingleDatePickerInputController["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isInputFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: !withPortal && !withFullScreenPortal && !hideFang,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      isOutsideRange: isOutsideRange,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      date: date,
      onDateChange: onDateChange,
      displayFormat: displayFormat,
      onFocusChange: this.onInputFocus,
      onKeyDownArrowDown: this.onDayPickerFocus,
      onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
      screenReaderMessage: screenReaderInputMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing,
      reopenPickerOnClearDate: reopenPickerOnClearDate,
      keepOpenOnDateSelect: keepOpenOnDateSelect
    }, this.maybeRenderDayPickerWithPortal());

    return _react["default"].createElement("div", (0, _extends2["default"])({
      ref: this.setContainerRef
    }, (0, _reactWithStyles.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)), enableOutsideClick && _react["default"].createElement(_reactOutsideClickHandler["default"], {
      onOutsideClick: this.onOutsideClick
    }, input), enableOutsideClick || input);
  };

  return SingleDatePicker;
}(_react["default"].PureComponent || _react["default"].Component);

exports.PureSingleDatePicker = SingleDatePicker;
SingleDatePicker.propTypes =  false ? propTypes : {};
SingleDatePicker.defaultProps = defaultProps;

var _default = (0, _reactWithStyles.withStyles)(function (_ref3) {
  var _ref3$reactDates = _ref3.reactDates,
      color = _ref3$reactDates.color,
      zIndex = _ref3$reactDates.zIndex;
  return {
    SingleDatePicker: {
      position: 'relative',
      display: 'inline-block'
    },
    SingleDatePicker__block: {
      display: 'block'
    },
    SingleDatePicker_picker: {
      zIndex: zIndex + 1,
      backgroundColor: color.background,
      position: 'absolute'
    },
    SingleDatePicker_picker__rtl: {
      direction: (0, _noflip["default"])('rtl')
    },
    SingleDatePicker_picker__directionLeft: {
      left: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__directionRight: {
      right: (0, _noflip["default"])(0)
    },
    SingleDatePicker_picker__portal: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      position: 'fixed',
      top: 0,
      left: (0, _noflip["default"])(0),
      height: '100%',
      width: '100%'
    },
    SingleDatePicker_picker__fullScreenPortal: {
      backgroundColor: color.background
    },
    SingleDatePicker_closeButton: {
      background: 'none',
      border: 0,
      color: 'inherit',
      font: 'inherit',
      lineHeight: 'normal',
      overflow: 'visible',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      right: (0, _noflip["default"])(0),
      padding: 15,
      zIndex: zIndex + 2,
      ':hover': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      },
      ':focus': {
        color: "darken(".concat(color.core.grayLighter, ", 10%)"),
        textDecoration: 'none'
      }
    },
    SingleDatePicker_closeButton_svg: {
      height: 15,
      width: 15,
      fill: color.core.grayLighter
    }
  };
}, {
  pureComponent: typeof _react["default"].PureComponent !== 'undefined'
})(SingleDatePicker);

exports["default"] = _default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _enzymeShallowEqual = _interopRequireDefault(__webpack_require__(24));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(28));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _moment = _interopRequireDefault(__webpack_require__(5));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(35));

var _airbnbPropTypes = __webpack_require__(13);

var _OpenDirectionShape = _interopRequireDefault(__webpack_require__(45));

var _defaultPhrases = __webpack_require__(18);

var _getPhrasePropTypes = _interopRequireDefault(__webpack_require__(23));

var _SingleDatePickerInput = _interopRequireDefault(__webpack_require__(220));

var _IconPositionShape = _interopRequireDefault(__webpack_require__(50));

var _DisabledShape = _interopRequireDefault(__webpack_require__(58));

var _toMomentObject = _interopRequireDefault(__webpack_require__(47));

var _toLocalizedDateString = _interopRequireDefault(__webpack_require__(107));

var _isInclusivelyAfterDay = _interopRequireDefault(__webpack_require__(52));

var _constants = __webpack_require__(7);

var propTypes =  false ? (0, _airbnbPropTypes.forbidExtraProps)({
  children: _propTypes["default"].node,
  date: _reactMomentProptypes["default"].momentObj,
  onDateChange: _propTypes["default"].func.isRequired,
  focused: _propTypes["default"].bool,
  onFocusChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  screenReaderMessage: _propTypes["default"].string,
  showClearDate: _propTypes["default"].bool,
  showCaret: _propTypes["default"].bool,
  showDefaultInputIcon: _propTypes["default"].bool,
  inputIconPosition: _IconPositionShape["default"],
  disabled: _DisabledShape["default"],
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  openDirection: _OpenDirectionShape["default"],
  noBorder: _propTypes["default"].bool,
  block: _propTypes["default"].bool,
  small: _propTypes["default"].bool,
  regular: _propTypes["default"].bool,
  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
  keepOpenOnDateSelect: _propTypes["default"].bool,
  reopenPickerOnClearDate: _propTypes["default"].bool,
  isOutsideRange: _propTypes["default"].func,
  displayFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  onClose: _propTypes["default"].func,
  onKeyDownArrowDown: _propTypes["default"].func,
  onKeyDownQuestionMark: _propTypes["default"].func,
  customInputIcon: _propTypes["default"].node,
  customCloseIcon: _propTypes["default"].node,
  // accessibility
  isFocused: _propTypes["default"].bool,
  // i18n
  phrases: _propTypes["default"].shape((0, _getPhrasePropTypes["default"])(_defaultPhrases.SingleDatePickerInputPhrases)),
  isRTL: _propTypes["default"].bool
}) : {};
var defaultProps = {
  children: null,
  date: null,
  focused: false,
  placeholder: '',
  ariaLabel: undefined,
  screenReaderMessage: 'Date',
  showClearDate: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  noBorder: false,
  block: false,
  small: false,
  regular: false,
  verticalSpacing: undefined,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  isOutsideRange: function isOutsideRange(day) {
    return !(0, _isInclusivelyAfterDay["default"])(day, (0, _moment["default"])());
  },
  displayFormat: function displayFormat() {
    return _moment["default"].localeData().longDateFormat('L');
  },
  onClose: function onClose() {},
  onKeyDownArrowDown: function onKeyDownArrowDown() {},
  onKeyDownQuestionMark: function onKeyDownQuestionMark() {},
  customInputIcon: null,
  customCloseIcon: null,
  // accessibility
  isFocused: false,
  // i18n
  phrases: _defaultPhrases.SingleDatePickerInputPhrases,
  isRTL: false
};

var SingleDatePickerInputController =
/*#__PURE__*/
function (_ref) {
  (0, _inheritsLoose2["default"])(SingleDatePickerInputController, _ref);
  var _proto = SingleDatePickerInputController.prototype;

  _proto[!_react["default"].PureComponent && "shouldComponentUpdate"] = function (nextProps, nextState) {
    return !(0, _enzymeShallowEqual["default"])(this.props, nextProps) || !(0, _enzymeShallowEqual["default"])(this.state, nextState);
  };

  function SingleDatePickerInputController(props) {
    var _this;

    _this = _ref.call(this, props) || this;
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onClearFocus = _this.onClearFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearDate = _this.clearDate.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  _proto.onChange = function onChange(dateString) {
    var _this$props = this.props,
        isOutsideRange = _this$props.isOutsideRange,
        keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
        onDateChange = _this$props.onDateChange,
        onFocusChange = _this$props.onFocusChange,
        onClose = _this$props.onClose;
    var newDate = (0, _toMomentObject["default"])(dateString, this.getDisplayFormat());
    var isValid = newDate && !isOutsideRange(newDate);

    if (isValid) {
      onDateChange(newDate);

      if (!keepOpenOnDateSelect) {
        onFocusChange({
          focused: false
        });
        onClose({
          date: newDate
        });
      }
    } else {
      onDateChange(null);
    }
  };

  _proto.onFocus = function onFocus() {
    var _this$props2 = this.props,
        onFocusChange = _this$props2.onFocusChange,
        disabled = _this$props2.disabled;

    if (!disabled) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.onClearFocus = function onClearFocus() {
    var _this$props3 = this.props,
        focused = _this$props3.focused,
        onFocusChange = _this$props3.onFocusChange,
        onClose = _this$props3.onClose,
        date = _this$props3.date;
    if (!focused) return;
    onFocusChange({
      focused: false
    });
    onClose({
      date: date
    });
  };

  _proto.getDisplayFormat = function getDisplayFormat() {
    var displayFormat = this.props.displayFormat;
    return typeof displayFormat === 'string' ? displayFormat : displayFormat();
  };

  _proto.getDateString = function getDateString(date) {
    var displayFormat = this.getDisplayFormat();

    if (date && displayFormat) {
      return date && date.format(displayFormat);
    }

    return (0, _toLocalizedDateString["default"])(date);
  };

  _proto.clearDate = function clearDate() {
    var _this$props4 = this.props,
        onDateChange = _this$props4.onDateChange,
        reopenPickerOnClearDate = _this$props4.reopenPickerOnClearDate,
        onFocusChange = _this$props4.onFocusChange;
    onDateChange(null);

    if (reopenPickerOnClearDate) {
      onFocusChange({
        focused: true
      });
    }
  };

  _proto.render = function render() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        id = _this$props5.id,
        placeholder = _this$props5.placeholder,
        ariaLabel = _this$props5.ariaLabel,
        disabled = _this$props5.disabled,
        focused = _this$props5.focused,
        isFocused = _this$props5.isFocused,
        required = _this$props5.required,
        readOnly = _this$props5.readOnly,
        openDirection = _this$props5.openDirection,
        showClearDate = _this$props5.showClearDate,
        showCaret = _this$props5.showCaret,
        showDefaultInputIcon = _this$props5.showDefaultInputIcon,
        inputIconPosition = _this$props5.inputIconPosition,
        customCloseIcon = _this$props5.customCloseIcon,
        customInputIcon = _this$props5.customInputIcon,
        date = _this$props5.date,
        phrases = _this$props5.phrases,
        onKeyDownArrowDown = _this$props5.onKeyDownArrowDown,
        onKeyDownQuestionMark = _this$props5.onKeyDownQuestionMark,
        screenReaderMessage = _this$props5.screenReaderMessage,
        isRTL = _this$props5.isRTL,
        noBorder = _this$props5.noBorder,
        block = _this$props5.block,
        small = _this$props5.small,
        regular = _this$props5.regular,
        verticalSpacing = _this$props5.verticalSpacing;
    var displayValue = this.getDateString(date);
    return _react["default"].createElement(_SingleDatePickerInput["default"], {
      id: id,
      placeholder: placeholder,
      ariaLabel: ariaLabel,
      focused: focused,
      isFocused: isFocused,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      openDirection: openDirection,
      showCaret: showCaret,
      onClearDate: this.clearDate,
      showClearDate: showClearDate,
      showDefaultInputIcon: showDefaultInputIcon,
      inputIconPosition: inputIconPosition,
      customCloseIcon: customCloseIcon,
      customInputIcon: customInputIcon,
      displayValue: displayValue,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onKeyDownShiftTab: this.onClearFocus,
      onKeyDownArrowDown: onKeyDownArrowDown,
      onKeyDownQuestionMark: onKeyDownQuestionMark,
      screenReaderMessage: screenReaderMessage,
      phrases: phrases,
      isRTL: isRTL,
      noBorder: noBorder,
      block: block,
      small: small,
      regular: regular,
      verticalSpacing: verticalSpacing
    }, children);
  };

  return SingleDatePickerInputController;
}(_react["default"].PureComponent || _react["default"].Component);

exports["default"] = SingleDatePickerInputController;
SingleDatePickerInputController.propTypes =  false ? propTypes : {};
SingleDatePickerInputController.defaultProps = defaultProps;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isInclusivelyBeforeDay;

var _moment = _interopRequireDefault(__webpack_require__(5));

var _isAfterDay = _interopRequireDefault(__webpack_require__(76));

function isInclusivelyBeforeDay(a, b) {
  if (!_moment["default"].isMoment(a) || !_moment["default"].isMoment(b)) return false;
  return !(0, _isAfterDay["default"])(a, b);
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^(maart|mrt\.?)$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                  ? ' '
                                  : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonutChart_scss__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_290x7orxmp=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\DonutChart\\index.js',hash='1606e43244843cbe1ca42a75498808598b11b51b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\DonutChart\\index.js',statementMap:{'0':{start:{line:7,column:19},end:{line:64,column:1}},'1':{start:{line:11,column:15},end:{line:11,column:30}},'2':{start:{line:12,column:19},end:{line:12,column:60}},'3':{start:{line:14,column:18},end:{line:14,column:34}},'4':{start:{line:15,column:15},end:{line:15,column:51}},'5':{start:{line:16,column:22},end:{line:16,column:42}},'6':{start:{line:17,column:19},end:{line:17,column:53}},'7':{start:{line:18,column:17},end:{line:18,column:48}},'8':{start:{line:20,column:19},end:{line:20,column:51}},'9':{start:{line:21,column:23},end:{line:21,column:81}},'10':{start:{line:22,column:18},end:{line:22,column:57}},'11':{start:{line:26,column:21},end:{line:28,column:3}},'12':{start:{line:30,column:22},end:{line:33,column:28}},'13':{start:{line:35,column:2},end:{line:40,column:3}},'14':{start:{line:36,column:4},end:{line:39,column:26}},'15':{start:{line:42,column:19},end:{line:42,column:31}},'16':{start:{line:43,column:2},end:{line:45,column:3}},'17':{start:{line:44,column:4},end:{line:44,column:51}},'18':{start:{line:47,column:2},end:{line:49,column:3}},'19':{start:{line:48,column:4},end:{line:48,column:54}},'20':{start:{line:51,column:2},end:{line:53,column:3}},'21':{start:{line:52,column:4},end:{line:52,column:50}},'22':{start:{line:55,column:2},end:{line:63,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:19},end:{line:7,column:20}},loc:{start:{line:7,column:30},end:{line:64,column:1}},line:7}},branchMap:{'0':{loc:{start:{line:35,column:2},end:{line:40,column:3}},type:'if',locations:[{start:{line:35,column:2},end:{line:40,column:3}},{start:{line:35,column:2},end:{line:40,column:3}}],line:35},'1':{loc:{start:{line:43,column:2},end:{line:45,column:3}},type:'if',locations:[{start:{line:43,column:2},end:{line:45,column:3}},{start:{line:43,column:2},end:{line:45,column:3}}],line:43},'2':{loc:{start:{line:47,column:2},end:{line:49,column:3}},type:'if',locations:[{start:{line:47,column:2},end:{line:49,column:3}},{start:{line:47,column:2},end:{line:49,column:3}}],line:47},'3':{loc:{start:{line:51,column:2},end:{line:53,column:3}},type:'if',locations:[{start:{line:51,column:2},end:{line:53,column:3}},{start:{line:51,column:2},end:{line:53,column:3}}],line:51}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_290x7orxmp.s[0]++;var DonutChart=function DonutChart(props){cov_290x7orxmp.f[0]++;var factor=(cov_290x7orxmp.s[1]++,Math.pow(10,0));var percentage=(cov_290x7orxmp.s[2]++,Math.round(props.value*factor)/factor);var halfsize=(cov_290x7orxmp.s[3]++,props.size*0.5);var radius=(cov_290x7orxmp.s[4]++,halfsize-props.strokewidth*0.5);var circumference=(cov_290x7orxmp.s[5]++,2*Math.PI*radius);var strokeval=(cov_290x7orxmp.s[6]++,percentage*circumference/100);var dashval=(cov_290x7orxmp.s[7]++,strokeval+' '+circumference);var trackstyle=(cov_290x7orxmp.s[8]++,{strokeWidth:props.strokewidth});var indicatorstyle=(cov_290x7orxmp.s[9]++,{strokeWidth:props.strokewidth,strokeDasharray:dashval});var rotateval=(cov_290x7orxmp.s[10]++,'rotate(-90 '+halfsize+','+halfsize+')');var extraStyles=(cov_290x7orxmp.s[11]++,{marginTop:'-'+(props.size/2-25)+'px'});var overlay=(cov_290x7orxmp.s[12]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.content,style:extraStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:props.fontSizeL}},percentage,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:props.fontSizeS}},props.valuelabel)));cov_290x7orxmp.s[13]++;if(props.value==0){cov_290x7orxmp.b[0][0]++;cov_290x7orxmp.s[14]++;overlay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.content,style:extraStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Spacer"],{height:'24px',style:{fontSize:props.fontSizeL}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:props.fontSizeS}},props.value0label));}else{cov_290x7orxmp.b[0][1]++;}var classNames=(cov_290x7orxmp.s[15]++,__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.chart);cov_290x7orxmp.s[16]++;if(props.align=='center'){cov_290x7orxmp.b[1][0]++;cov_290x7orxmp.s[17]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.isCenter;}else{cov_290x7orxmp.b[1][1]++;}cov_290x7orxmp.s[18]++;if(props.font=='large'){cov_290x7orxmp.b[2][0]++;cov_290x7orxmp.s[19]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.isLargeFont;}else{cov_290x7orxmp.b[2][1]++;}cov_290x7orxmp.s[20]++;if(props.noPrint){cov_290x7orxmp.b[3][0]++;cov_290x7orxmp.s[21]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.noPrint;}else{cov_290x7orxmp.b[3][1]++;}cov_290x7orxmp.s[22]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:props.size,height:props.size,className:__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.donutchart},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{r:radius,cx:halfsize,cy:halfsize,transform:rotateval,style:trackstyle,className:__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.donutchartTrack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{r:radius,cx:halfsize,cy:halfsize,transform:rotateval,style:indicatorstyle,className:__WEBPACK_IMPORTED_MODULE_1__DonutChart_scss___default.a.donutchartIndicator})),overlay);};/* harmony default export */ __webpack_exports__["default"] = (DonutChart);

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chart":"DonutChart__chart___3Oqve","isLargeFont":"DonutChart__isLargeFont___26pcP","content":"DonutChart__content___XELOb","isCenter":"DonutChart__isCenter___2rcBr","donutchartTrack":"DonutChart__donutchartTrack___1Wq4c","donutchartIndicator":"DonutChart__donutchartIndicator___2Gnju","donutchart":"DonutChart__donutchart___1gZCm","donutchartText":"DonutChart__donutchartText___2R2k-","donutchartTextVal":"DonutChart__donutchartTextVal___1xDXT","donutchartTextPercent":"DonutChart__donutchartTextPercent___1RvW6","donutchartTextLabel":"DonutChart__donutchartTextLabel___37Cls"};

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Flex_scss__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Flex_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Flex_scss__);
var cov_2nxwddfukm=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Flex\\index.js',hash='cc4ad6747294a107ea08f29479105180bd759b06',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Flex\\index.js',statementMap:{'0':{start:{line:5,column:13},end:{line:41,column:1}},'1':{start:{line:6,column:18},end:{line:6,column:29}},'2':{start:{line:7,column:20},end:{line:7,column:22}},'3':{start:{line:9,column:2},end:{line:11,column:3}},'4':{start:{line:10,column:4},end:{line:10,column:47}},'5':{start:{line:13,column:2},end:{line:15,column:3}},'6':{start:{line:14,column:4},end:{line:14,column:64}},'7':{start:{line:17,column:2},end:{line:19,column:3}},'8':{start:{line:18,column:4},end:{line:18,column:68}},'9':{start:{line:21,column:2},end:{line:23,column:3}},'10':{start:{line:22,column:4},end:{line:22,column:51}},'11':{start:{line:24,column:2},end:{line:26,column:3}},'12':{start:{line:25,column:4},end:{line:25,column:50}},'13':{start:{line:28,column:2},end:{line:33,column:3}},'14':{start:{line:29,column:4},end:{line:32,column:5}},'15':{start:{line:35,column:2},end:{line:40,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:13},end:{line:5,column:14}},loc:{start:{line:5,column:24},end:{line:41,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:9,column:2},end:{line:11,column:3}},type:'if',locations:[{start:{line:9,column:2},end:{line:11,column:3}},{start:{line:9,column:2},end:{line:11,column:3}}],line:9},'1':{loc:{start:{line:13,column:2},end:{line:15,column:3}},type:'if',locations:[{start:{line:13,column:2},end:{line:15,column:3}},{start:{line:13,column:2},end:{line:15,column:3}}],line:13},'2':{loc:{start:{line:17,column:2},end:{line:19,column:3}},type:'if',locations:[{start:{line:17,column:2},end:{line:19,column:3}},{start:{line:17,column:2},end:{line:19,column:3}}],line:17},'3':{loc:{start:{line:21,column:2},end:{line:23,column:3}},type:'if',locations:[{start:{line:21,column:2},end:{line:23,column:3}},{start:{line:21,column:2},end:{line:23,column:3}}],line:21},'4':{loc:{start:{line:24,column:2},end:{line:26,column:3}},type:'if',locations:[{start:{line:24,column:2},end:{line:26,column:3}},{start:{line:24,column:2},end:{line:26,column:3}}],line:24},'5':{loc:{start:{line:28,column:2},end:{line:33,column:3}},type:'if',locations:[{start:{line:28,column:2},end:{line:33,column:3}},{start:{line:28,column:2},end:{line:33,column:3}}],line:28}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2nxwddfukm.s[0]++;var Flex=function Flex(props){cov_2nxwddfukm.f[0]++;var classNames=(cov_2nxwddfukm.s[1]++,__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a.flex);var extraStyles=(cov_2nxwddfukm.s[2]++,{});cov_2nxwddfukm.s[3]++;if(props.move){cov_2nxwddfukm.b[0][0]++;cov_2nxwddfukm.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a.move;}else{cov_2nxwddfukm.b[0][1]++;}cov_2nxwddfukm.s[5]++;if(props.break){cov_2nxwddfukm.b[1][0]++;cov_2nxwddfukm.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a['break-'+props.break];}else{cov_2nxwddfukm.b[1][1]++;}cov_2nxwddfukm.s[7]++;if(props.reverse){cov_2nxwddfukm.b[2][0]++;cov_2nxwddfukm.s[8]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a['reverse-'+props.reverse];}else{cov_2nxwddfukm.b[2][1]++;}cov_2nxwddfukm.s[9]++;if(props.align=='center'){cov_2nxwddfukm.b[3][0]++;cov_2nxwddfukm.s[10]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a.isCenter;}else{cov_2nxwddfukm.b[3][1]++;}cov_2nxwddfukm.s[11]++;if(props.align=='start'){cov_2nxwddfukm.b[4][0]++;cov_2nxwddfukm.s[12]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Flex_scss___default.a.isStart;}else{cov_2nxwddfukm.b[4][1]++;}cov_2nxwddfukm.s[13]++;if(props.gutter){cov_2nxwddfukm.b[5][0]++;cov_2nxwddfukm.s[14]++;extraStyles={marginLeft:'-'+props.gutter+'px',marginRight:'-'+props.gutter+'px'};}else{cov_2nxwddfukm.b[5][1]++;}cov_2nxwddfukm.s[15]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames,style:extraStyles},props.children);};/* harmony default export */ __webpack_exports__["default"] = (Flex);

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flex":"Flex__flex___dhbc9","isCenter":"Flex__isCenter___By8ie","reverse-m":"Flex__reverse-m___2T6LL","isStart":"Flex__isStart___3V_hz","move":"Flex__move___hLNyA","break-xs":"Flex__break-xs___1qkKd","break-m":"Flex__break-m___1ESqn","break-sm":"Flex__break-sm___2nyHR","break-l":"Flex__break-l___1Lhn1"};

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss__);
var cov_v60k8xixz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\FlexColumn\\index.js',hash='a486f73cbeabdd53d0a62a9758a4579ddaa7398b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\FlexColumn\\index.js',statementMap:{'0':{start:{line:4,column:19},end:{line:47,column:1}},'1':{start:{line:5,column:17},end:{line:8,column:13}},'2':{start:{line:10,column:19},end:{line:10,column:21}},'3':{start:{line:12,column:2},end:{line:14,column:3}},'4':{start:{line:13,column:4},end:{line:13,column:55}},'5':{start:{line:15,column:2},end:{line:17,column:3}},'6':{start:{line:16,column:4},end:{line:16,column:32}},'7':{start:{line:20,column:2},end:{line:22,column:3}},'8':{start:{line:21,column:4},end:{line:21,column:55}},'9':{start:{line:24,column:2},end:{line:26,column:3}},'10':{start:{line:25,column:4},end:{line:25,column:53}},'11':{start:{line:28,column:2},end:{line:30,column:3}},'12':{start:{line:29,column:4},end:{line:29,column:50}},'13':{start:{line:32,column:2},end:{line:34,column:3}},'14':{start:{line:33,column:4},end:{line:33,column:49}},'15':{start:{line:37,column:2},end:{line:39,column:3}},'16':{start:{line:38,column:4},end:{line:38,column:39}},'17':{start:{line:41,column:2},end:{line:46,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:19},end:{line:4,column:20}},loc:{start:{line:4,column:30},end:{line:47,column:1}},line:4}},branchMap:{'0':{loc:{start:{line:12,column:2},end:{line:14,column:3}},type:'if',locations:[{start:{line:12,column:2},end:{line:14,column:3}},{start:{line:12,column:2},end:{line:14,column:3}}],line:12},'1':{loc:{start:{line:15,column:2},end:{line:17,column:3}},type:'if',locations:[{start:{line:15,column:2},end:{line:17,column:3}},{start:{line:15,column:2},end:{line:17,column:3}}],line:15},'2':{loc:{start:{line:20,column:2},end:{line:22,column:3}},type:'if',locations:[{start:{line:20,column:2},end:{line:22,column:3}},{start:{line:20,column:2},end:{line:22,column:3}}],line:20},'3':{loc:{start:{line:24,column:2},end:{line:26,column:3}},type:'if',locations:[{start:{line:24,column:2},end:{line:26,column:3}},{start:{line:24,column:2},end:{line:26,column:3}}],line:24},'4':{loc:{start:{line:28,column:2},end:{line:30,column:3}},type:'if',locations:[{start:{line:28,column:2},end:{line:30,column:3}},{start:{line:28,column:2},end:{line:30,column:3}}],line:28},'5':{loc:{start:{line:32,column:2},end:{line:34,column:3}},type:'if',locations:[{start:{line:32,column:2},end:{line:34,column:3}},{start:{line:32,column:2},end:{line:34,column:3}}],line:32},'6':{loc:{start:{line:37,column:2},end:{line:39,column:3}},type:'if',locations:[{start:{line:37,column:2},end:{line:39,column:3}},{start:{line:37,column:2},end:{line:39,column:3}}],line:37}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_v60k8xixz.s[0]++;var FlexColumn=function FlexColumn(props){cov_v60k8xixz.f[0]++;var styleAdd=(cov_v60k8xixz.s[1]++,{width:'50%',minWidth:"0"});var classNames=(cov_v60k8xixz.s[2]++,'');cov_v60k8xixz.s[3]++;if(props.col){cov_v60k8xixz.b[0][0]++;cov_v60k8xixz.s[4]++;styleAdd.width='calc(100% / '+props.col+' - 2%)';}else{cov_v60k8xixz.b[0][1]++;}cov_v60k8xixz.s[5]++;if(props.width){cov_v60k8xixz.b[1][0]++;cov_v60k8xixz.s[6]++;styleAdd.width=props.width;}else{cov_v60k8xixz.b[1][1]++;}cov_v60k8xixz.s[7]++;if(props.valign==="bottom"){cov_v60k8xixz.b[2][0]++;cov_v60k8xixz.s[8]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss___default.a.valignBottom;}else{cov_v60k8xixz.b[2][1]++;}cov_v60k8xixz.s[9]++;if(props.align==="right"){cov_v60k8xixz.b[3][0]++;cov_v60k8xixz.s[10]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss___default.a.alignRight;}else{cov_v60k8xixz.b[3][1]++;}cov_v60k8xixz.s[11]++;if(props.noPrint){cov_v60k8xixz.b[4][0]++;cov_v60k8xixz.s[12]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss___default.a.noPrint;}else{cov_v60k8xixz.b[4][1]++;}cov_v60k8xixz.s[13]++;if(props.growSM){cov_v60k8xixz.b[5][0]++;cov_v60k8xixz.s[14]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__FlexColumn_scss___default.a.growSM;}else{cov_v60k8xixz.b[5][1]++;}cov_v60k8xixz.s[15]++;if(props.minWidth){cov_v60k8xixz.b[6][0]++;cov_v60k8xixz.s[16]++;styleAdd.minWidth=props.minWidth;}else{cov_v60k8xixz.b[6][1]++;}cov_v60k8xixz.s[17]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames,style:styleAdd},props.children);};/* harmony default export */ __webpack_exports__["default"] = (FlexColumn);

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"valignBottom":"FlexColumn__valignBottom___Rh75z","alignRight":"FlexColumn__alignRight___8-77G","noPrint":"FlexColumn__noPrint___3bBgp","growSM":"FlexColumn__growSM___2Av8a"};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxContent_scss__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxContent_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GreyBoxContent_scss__);
var cov_2rqfm9y6lu=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxContent\\index.js',hash='38d51a6672533b97aec53364ae142e387a8043e2',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxContent\\index.js',statementMap:{'0':{start:{line:4,column:23},end:{line:11,column:1}},'1':{start:{line:6,column:3},end:{line:10,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:23},end:{line:4,column:24}},loc:{start:{line:4,column:34},end:{line:11,column:1}},line:4}},branchMap:{'0':{loc:{start:{line:7,column:18},end:{line:7,column:68}},type:'cond-expr',locations:[{start:{line:7,column:34},end:{line:7,column:50}},{start:{line:7,column:53},end:{line:7,column:68}}],line:7}},s:{'0':0,'1':0},f:{'0':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2rqfm9y6lu.s[0]++;var GreyBoxContent=function GreyBoxContent(props){cov_2rqfm9y6lu.f[0]++;cov_2rqfm9y6lu.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.visible?(cov_2rqfm9y6lu.b[0][0]++,__WEBPACK_IMPORTED_MODULE_1__GreyBoxContent_scss___default.a.isVisible):(cov_2rqfm9y6lu.b[0][1]++,__WEBPACK_IMPORTED_MODULE_1__GreyBoxContent_scss___default.a.isHidden)},props.children);};/* harmony default export */ __webpack_exports__["default"] = (GreyBoxContent);

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isHidden":"GreyBoxContent__isHidden___2HvE_"};

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxExtra_scss__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxExtra_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GreyBoxExtra_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_7x6cwzqti=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxExtra\\index.js',hash='2001b63c3041fb4fb54eea15c6b9a797a5287b83',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxExtra\\index.js',statementMap:{'0':{start:{line:5,column:21},end:{line:12,column:1}},'1':{start:{line:7,column:3},end:{line:11,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:21},end:{line:5,column:22}},loc:{start:{line:5,column:32},end:{line:12,column:1}},line:5}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_7x6cwzqti.s[0]++;var GreyBoxExtra=function GreyBoxExtra(props){cov_7x6cwzqti.f[0]++;cov_7x6cwzqti.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__GreyBoxExtra_scss___default.a.box},props.children);};/* harmony default export */ __webpack_exports__["default"] = (GreyBoxExtra);

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"box":"GreyBoxExtra__box___3RkNc"};

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_hztyhyhj0=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxMessage\\index.js',hash='cc0796917848ecc762ab009afa0bc9400e16547a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\GreyBoxMessage\\index.js',statementMap:{'0':{start:{line:5,column:23},end:{line:22,column:1}},'1':{start:{line:6,column:17},end:{line:6,column:44}},'2':{start:{line:7,column:1},end:{line:9,column:2}},'3':{start:{line:8,column:2},end:{line:8,column:39}},'4':{start:{line:11,column:18},end:{line:11,column:41}},'5':{start:{line:12,column:1},end:{line:14,column:2}},'6':{start:{line:13,column:2},end:{line:13,column:49}},'7':{start:{line:16,column:3},end:{line:21,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:23},end:{line:5,column:24}},loc:{start:{line:5,column:34},end:{line:22,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:7,column:1},end:{line:9,column:2}},type:'if',locations:[{start:{line:7,column:1},end:{line:9,column:2}},{start:{line:7,column:1},end:{line:9,column:2}}],line:7},'1':{loc:{start:{line:12,column:1},end:{line:14,column:2}},type:'if',locations:[{start:{line:12,column:1},end:{line:14,column:2}},{start:{line:12,column:1},end:{line:14,column:2}}],line:12}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},f:{'0':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_hztyhyhj0.s[0]++;var GreyBoxMessage=function GreyBoxMessage(props){cov_hztyhyhj0.f[0]++;var styleName=(cov_hztyhyhj0.s[1]++,"a_greyboxmessage__success");cov_hztyhyhj0.s[2]++;if(props.type==="error"){cov_hztyhyhj0.b[0][0]++;cov_hztyhyhj0.s[3]++;styleName="a_greyboxmessage__error";}else{cov_hztyhyhj0.b[0][1]++;}var classNames=(cov_hztyhyhj0.s[4]++,__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default.a.a_greyboxmessage);cov_hztyhyhj0.s[5]++;if(props.position==='inside'){cov_hztyhyhj0.b[1][0]++;cov_hztyhyhj0.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default.a.isInside;}else{cov_hztyhyhj0.b[1][1]++;}cov_hztyhyhj0.s[7]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default.a[styleName]+' '+classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default.a["a_greyboxmessage__icon"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:props.type,width:'25px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__GreyBoxMessage_scss___default.a["a_greyboxmessage__text"]},props.children));};/* harmony default export */ __webpack_exports__["default"] = (GreyBoxMessage);

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a_greyboxmessage__error":"GreyBoxMessage__a_greyboxmessage__error___3gWQU","a_greyboxmessage__success":"GreyBoxMessage__a_greyboxmessage__success___2Jaic","a_greyboxmessage":"GreyBoxMessage__a_greyboxmessage___11B-N","isInside":"GreyBoxMessage__isInside___1e-Tm","a_greyboxmessage__icon":"GreyBoxMessage__a_greyboxmessage__icon___MCV68","a_greyboxmessage__text":"GreyBoxMessage__a_greyboxmessage__text___13Ojf"};

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hint_scss__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hint_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Hint_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_1n5zpgj0wj=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Hint\\index.js',hash='83535c71558b2d63070de418c2ea137b552086f5',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Hint\\index.js',statementMap:{'0':{start:{line:5,column:13},end:{line:39,column:1}},'1':{start:{line:6,column:17},end:{line:6,column:26}},'2':{start:{line:7,column:1},end:{line:9,column:2}},'3':{start:{line:8,column:2},end:{line:8,column:21}},'4':{start:{line:11,column:18},end:{line:11,column:29}},'5':{start:{line:13,column:1},end:{line:15,column:2}},'6':{start:{line:14,column:2},end:{line:14,column:49}},'7':{start:{line:18,column:3},end:{line:38,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:13},end:{line:5,column:14}},loc:{start:{line:5,column:24},end:{line:39,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:7,column:1},end:{line:9,column:2}},type:'if',locations:[{start:{line:7,column:1},end:{line:9,column:2}},{start:{line:7,column:1},end:{line:9,column:2}}],line:7},'1':{loc:{start:{line:13,column:1},end:{line:15,column:2}},type:'if',locations:[{start:{line:13,column:1},end:{line:15,column:2}},{start:{line:13,column:1},end:{line:15,column:2}}],line:13}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},f:{'0':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1n5zpgj0wj.s[0]++;var Hint=function Hint(props){cov_1n5zpgj0wj.f[0]++;var styleName=(cov_1n5zpgj0wj.s[1]++,"success");cov_1n5zpgj0wj.s[2]++;if(props.type==="error"){cov_1n5zpgj0wj.b[0][0]++;cov_1n5zpgj0wj.s[3]++;styleName="error";}else{cov_1n5zpgj0wj.b[0][1]++;}var classNames=(cov_1n5zpgj0wj.s[4]++,__WEBPACK_IMPORTED_MODULE_1__Hint_scss___default.a.hint);cov_1n5zpgj0wj.s[5]++;if(props.noPrint){cov_1n5zpgj0wj.b[1][0]++;cov_1n5zpgj0wj.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Hint_scss___default.a.noPrint;}else{cov_1n5zpgj0wj.b[1][1]++;}cov_1n5zpgj0wj.s[7]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__Hint_scss___default.a[styleName]+' '+classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'4*4 - 264px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'10*1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__Hint_scss___default.a.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:props.type,width:'25px'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'10*9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__Hint_scss___default.a.text},props.text)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{width:'264px',align:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Button"],{width:'264px',value:props.buttonText,onClick:props.buttonClicked,theme:'dark'}))));};/* harmony default export */ __webpack_exports__["default"] = (Hint);

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"error":"Hint__error___1EpIH","success":"Hint__success___2JUe_","hint":"Hint__hint___37ojo","icon":"Hint__icon___3d5mg","text":"Hint__text___i8EUZ","noPrint":"Hint__noPrint___3DY3N"};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_scss__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Icon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_hamburger_svg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_hamburger_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_hamburger_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_settingsmenu_svg__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_settingsmenu_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_settingsmenu_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_input_success_svg__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_input_success_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_input_success_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_input_warning_svg__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_input_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_input_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_input_error_svg__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_input_error_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_input_error_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_input_hint_svg__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_input_hint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_input_hint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_yes_svg__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_yes_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_yes_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_no_svg__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_no_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_no_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_cost_svg__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_cost_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_cost_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_time_svg__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_time_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_time_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_content_settings_svg__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_content_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_content_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_menu_settings_svg__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_menu_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_menu_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_profile_svg__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_profile_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_profile_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_password_svg__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_password_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_password_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_company_svg__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_company_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_company_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_content_edit_svg__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_content_edit_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_content_edit_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_content_export_svg__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_content_export_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_content_export_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_content_delete_svg__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_content_delete_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_content_delete_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_input_search_svg__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_input_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_input_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_input_calendar_svg__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_input_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_input_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_close_svg__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_logout_svg__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_logout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_logout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_questionmark_svg__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_questionmark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_questionmark_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_hint_svg__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_hint_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_hint_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_average_svg__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_average_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_average_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_account_svg__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_account_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_account_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_info_svg__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_info_svg__);
var cov_22gc02u306=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Icon\\index.js',hash='4cdccebbff72c559dcadaa8d3d6388fe3591a457',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Icon\\index.js',statementMap:{'0':{start:{line:39,column:13},end:{line:166,column:1}},'1':{start:{line:40,column:1},end:{line:165,column:2}},'2':{start:{line:41,column:13},end:{line:41,column:15}},'3':{start:{line:42,column:2},end:{line:126,column:3}},'4':{start:{line:44,column:4},end:{line:44,column:21}},'5':{start:{line:45,column:3},end:{line:45,column:9}},'6':{start:{line:47,column:4},end:{line:47,column:24}},'7':{start:{line:48,column:3},end:{line:48,column:9}},'8':{start:{line:50,column:4},end:{line:50,column:19}},'9':{start:{line:51,column:3},end:{line:51,column:9}},'10':{start:{line:53,column:4},end:{line:53,column:19}},'11':{start:{line:54,column:3},end:{line:54,column:9}},'12':{start:{line:56,column:4},end:{line:56,column:17}},'13':{start:{line:57,column:3},end:{line:57,column:9}},'14':{start:{line:59,column:4},end:{line:59,column:16}},'15':{start:{line:60,column:3},end:{line:60,column:9}},'16':{start:{line:62,column:4},end:{line:62,column:15}},'17':{start:{line:63,column:3},end:{line:63,column:9}},'18':{start:{line:65,column:4},end:{line:65,column:14}},'19':{start:{line:66,column:3},end:{line:66,column:9}},'20':{start:{line:68,column:4},end:{line:68,column:16}},'21':{start:{line:69,column:3},end:{line:69,column:9}},'22':{start:{line:71,column:4},end:{line:71,column:16}},'23':{start:{line:72,column:3},end:{line:72,column:9}},'24':{start:{line:74,column:4},end:{line:74,column:20}},'25':{start:{line:75,column:3},end:{line:75,column:9}},'26':{start:{line:77,column:4},end:{line:77,column:24}},'27':{start:{line:78,column:3},end:{line:78,column:9}},'28':{start:{line:80,column:4},end:{line:80,column:19}},'29':{start:{line:81,column:3},end:{line:81,column:9}},'30':{start:{line:83,column:4},end:{line:83,column:20}},'31':{start:{line:84,column:3},end:{line:84,column:9}},'32':{start:{line:86,column:4},end:{line:86,column:19}},'33':{start:{line:87,column:3},end:{line:87,column:9}},'34':{start:{line:89,column:4},end:{line:89,column:17}},'35':{start:{line:90,column:3},end:{line:90,column:9}},'36':{start:{line:92,column:4},end:{line:92,column:19}},'37':{start:{line:93,column:3},end:{line:93,column:9}},'38':{start:{line:95,column:4},end:{line:95,column:19}},'39':{start:{line:96,column:3},end:{line:96,column:9}},'40':{start:{line:98,column:4},end:{line:98,column:18}},'41':{start:{line:99,column:3},end:{line:99,column:9}},'42':{start:{line:101,column:4},end:{line:101,column:20}},'43':{start:{line:102,column:3},end:{line:102,column:9}},'44':{start:{line:104,column:4},end:{line:104,column:17}},'45':{start:{line:105,column:3},end:{line:105,column:9}},'46':{start:{line:107,column:4},end:{line:107,column:18}},'47':{start:{line:108,column:3},end:{line:108,column:9}},'48':{start:{line:110,column:4},end:{line:110,column:24}},'49':{start:{line:111,column:3},end:{line:111,column:9}},'50':{start:{line:113,column:4},end:{line:113,column:20}},'51':{start:{line:114,column:3},end:{line:114,column:9}},'52':{start:{line:116,column:4},end:{line:116,column:19}},'53':{start:{line:117,column:3},end:{line:117,column:9}},'54':{start:{line:119,column:4},end:{line:119,column:19}},'55':{start:{line:120,column:3},end:{line:120,column:9}},'56':{start:{line:122,column:4},end:{line:122,column:16}},'57':{start:{line:123,column:3},end:{line:123,column:9}},'58':{start:{line:125,column:4},end:{line:125,column:21}},'59':{start:{line:128,column:19},end:{line:128,column:30}},'60':{start:{line:130,column:2},end:{line:132,column:3}},'61':{start:{line:131,column:3},end:{line:131,column:50}},'62':{start:{line:133,column:2},end:{line:135,column:3}},'63':{start:{line:134,column:3},end:{line:134,column:57}},'64':{start:{line:136,column:2},end:{line:138,column:3}},'65':{start:{line:137,column:3},end:{line:137,column:56}},'66':{start:{line:140,column:17},end:{line:143,column:15}},'67':{start:{line:145,column:2},end:{line:150,column:3}},'68':{start:{line:146,column:3},end:{line:149,column:15}},'69':{start:{line:151,column:4},end:{line:160,column:5}},'70':{start:{line:161,column:7},end:{line:165,column:2}},'71':{start:{line:162,column:2},end:{line:164,column:3}},'72':{start:{line:169,column:24},end:{line:173,column:1}},'73':{start:{line:170,column:4},end:{line:172,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:39,column:13},end:{line:39,column:14}},loc:{start:{line:39,column:24},end:{line:166,column:1}},line:39},'1':{name:'(anonymous_1)',decl:{start:{line:169,column:24},end:{line:169,column:25}},loc:{start:{line:169,column:33},end:{line:173,column:1}},line:169}},branchMap:{'0':{loc:{start:{line:40,column:1},end:{line:165,column:2}},type:'if',locations:[{start:{line:40,column:1},end:{line:165,column:2}},{start:{line:40,column:1},end:{line:165,column:2}}],line:40},'1':{loc:{start:{line:42,column:2},end:{line:126,column:3}},type:'switch',locations:[{start:{line:43,column:3},end:{line:45,column:9}},{start:{line:46,column:3},end:{line:48,column:9}},{start:{line:49,column:3},end:{line:51,column:9}},{start:{line:52,column:3},end:{line:54,column:9}},{start:{line:55,column:3},end:{line:57,column:9}},{start:{line:58,column:3},end:{line:60,column:9}},{start:{line:61,column:3},end:{line:63,column:9}},{start:{line:64,column:3},end:{line:66,column:9}},{start:{line:67,column:3},end:{line:69,column:9}},{start:{line:70,column:3},end:{line:72,column:9}},{start:{line:73,column:3},end:{line:75,column:9}},{start:{line:76,column:3},end:{line:78,column:9}},{start:{line:79,column:3},end:{line:81,column:9}},{start:{line:82,column:3},end:{line:84,column:9}},{start:{line:85,column:3},end:{line:87,column:9}},{start:{line:88,column:3},end:{line:90,column:9}},{start:{line:91,column:3},end:{line:93,column:9}},{start:{line:94,column:3},end:{line:96,column:9}},{start:{line:97,column:3},end:{line:99,column:9}},{start:{line:100,column:3},end:{line:102,column:9}},{start:{line:103,column:3},end:{line:105,column:9}},{start:{line:106,column:3},end:{line:108,column:9}},{start:{line:109,column:3},end:{line:111,column:9}},{start:{line:112,column:3},end:{line:114,column:9}},{start:{line:115,column:3},end:{line:117,column:9}},{start:{line:118,column:3},end:{line:120,column:9}},{start:{line:121,column:3},end:{line:123,column:9}},{start:{line:124,column:3},end:{line:125,column:21}}],line:42},'2':{loc:{start:{line:130,column:2},end:{line:132,column:3}},type:'if',locations:[{start:{line:130,column:2},end:{line:132,column:3}},{start:{line:130,column:2},end:{line:132,column:3}}],line:130},'3':{loc:{start:{line:133,column:2},end:{line:135,column:3}},type:'if',locations:[{start:{line:133,column:2},end:{line:135,column:3}},{start:{line:133,column:2},end:{line:135,column:3}}],line:133},'4':{loc:{start:{line:136,column:2},end:{line:138,column:3}},type:'if',locations:[{start:{line:136,column:2},end:{line:138,column:3}},{start:{line:136,column:2},end:{line:138,column:3}}],line:136},'5':{loc:{start:{line:145,column:2},end:{line:150,column:3}},type:'if',locations:[{start:{line:145,column:2},end:{line:150,column:3}},{start:{line:145,column:2},end:{line:150,column:3}}],line:145},'6':{loc:{start:{line:161,column:7},end:{line:165,column:2}},type:'if',locations:[{start:{line:161,column:7},end:{line:165,column:2}},{start:{line:161,column:7},end:{line:165,column:2}}],line:161}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0},f:{'0':0,'1':0},b:{'0':[0,0],'1':[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_22gc02u306.s[0]++;var Icon=function Icon(props){cov_22gc02u306.f[0]++;cov_22gc02u306.s[1]++;if(props.type=='image'){cov_22gc02u306.b[0][0]++;var icon=(cov_22gc02u306.s[2]++,'');cov_22gc02u306.s[3]++;switch(props.content){case'hamburger':cov_22gc02u306.b[1][0]++;cov_22gc02u306.s[4]++;icon=__WEBPACK_IMPORTED_MODULE_5__assets_hamburger_svg___default.a;cov_22gc02u306.s[5]++;break;case'settingsmenu':cov_22gc02u306.b[1][1]++;cov_22gc02u306.s[6]++;icon=__WEBPACK_IMPORTED_MODULE_6__assets_settingsmenu_svg___default.a;cov_22gc02u306.s[7]++;break;case'success':cov_22gc02u306.b[1][2]++;cov_22gc02u306.s[8]++;icon=__WEBPACK_IMPORTED_MODULE_7__assets_input_success_svg___default.a;cov_22gc02u306.s[9]++;break;case'warning':cov_22gc02u306.b[1][3]++;cov_22gc02u306.s[10]++;icon=__WEBPACK_IMPORTED_MODULE_8__assets_input_warning_svg___default.a;cov_22gc02u306.s[11]++;break;case'error':cov_22gc02u306.b[1][4]++;cov_22gc02u306.s[12]++;icon=__WEBPACK_IMPORTED_MODULE_9__assets_input_error_svg___default.a;cov_22gc02u306.s[13]++;break;case'hint':cov_22gc02u306.b[1][5]++;cov_22gc02u306.s[14]++;icon=__WEBPACK_IMPORTED_MODULE_10__assets_input_hint_svg___default.a;cov_22gc02u306.s[15]++;break;case'yes':cov_22gc02u306.b[1][6]++;cov_22gc02u306.s[16]++;icon=__WEBPACK_IMPORTED_MODULE_11__assets_yes_svg___default.a;cov_22gc02u306.s[17]++;break;case'no':cov_22gc02u306.b[1][7]++;cov_22gc02u306.s[18]++;icon=__WEBPACK_IMPORTED_MODULE_12__assets_no_svg___default.a;cov_22gc02u306.s[19]++;break;case'cost':cov_22gc02u306.b[1][8]++;cov_22gc02u306.s[20]++;icon=__WEBPACK_IMPORTED_MODULE_13__assets_cost_svg___default.a;cov_22gc02u306.s[21]++;break;case'time':cov_22gc02u306.b[1][9]++;cov_22gc02u306.s[22]++;icon=__WEBPACK_IMPORTED_MODULE_14__assets_time_svg___default.a;cov_22gc02u306.s[23]++;break;case'settings':cov_22gc02u306.b[1][10]++;cov_22gc02u306.s[24]++;icon=__WEBPACK_IMPORTED_MODULE_15__assets_content_settings_svg___default.a;cov_22gc02u306.s[25]++;break;case'menusettings':cov_22gc02u306.b[1][11]++;cov_22gc02u306.s[26]++;icon=__WEBPACK_IMPORTED_MODULE_16__assets_menu_settings_svg___default.a;cov_22gc02u306.s[27]++;break;case'profile':cov_22gc02u306.b[1][12]++;cov_22gc02u306.s[28]++;icon=__WEBPACK_IMPORTED_MODULE_17__assets_profile_svg___default.a;cov_22gc02u306.s[29]++;break;case'password':cov_22gc02u306.b[1][13]++;cov_22gc02u306.s[30]++;icon=__WEBPACK_IMPORTED_MODULE_18__assets_password_svg___default.a;cov_22gc02u306.s[31]++;break;case'company':cov_22gc02u306.b[1][14]++;cov_22gc02u306.s[32]++;icon=__WEBPACK_IMPORTED_MODULE_19__assets_company_svg___default.a;cov_22gc02u306.s[33]++;break;case'edit':cov_22gc02u306.b[1][15]++;cov_22gc02u306.s[34]++;icon=__WEBPACK_IMPORTED_MODULE_20__assets_content_edit_svg___default.a;cov_22gc02u306.s[35]++;break;case'export':cov_22gc02u306.b[1][16]++;cov_22gc02u306.s[36]++;icon=__WEBPACK_IMPORTED_MODULE_21__assets_content_export_svg___default.a;cov_22gc02u306.s[37]++;break;case'delete':cov_22gc02u306.b[1][17]++;cov_22gc02u306.s[38]++;icon=__WEBPACK_IMPORTED_MODULE_22__assets_content_delete_svg___default.a;cov_22gc02u306.s[39]++;break;case'search':cov_22gc02u306.b[1][18]++;cov_22gc02u306.s[40]++;icon=__WEBPACK_IMPORTED_MODULE_23__assets_input_search_svg___default.a;cov_22gc02u306.s[41]++;break;case'calendar':cov_22gc02u306.b[1][19]++;cov_22gc02u306.s[42]++;icon=__WEBPACK_IMPORTED_MODULE_24__assets_input_calendar_svg___default.a;cov_22gc02u306.s[43]++;break;case'close':cov_22gc02u306.b[1][20]++;cov_22gc02u306.s[44]++;icon=__WEBPACK_IMPORTED_MODULE_25__assets_close_svg___default.a;cov_22gc02u306.s[45]++;break;case'logout':cov_22gc02u306.b[1][21]++;cov_22gc02u306.s[46]++;icon=__WEBPACK_IMPORTED_MODULE_26__assets_logout_svg___default.a;cov_22gc02u306.s[47]++;break;case'questionmark':cov_22gc02u306.b[1][22]++;cov_22gc02u306.s[48]++;icon=__WEBPACK_IMPORTED_MODULE_27__assets_questionmark_svg___default.a;cov_22gc02u306.s[49]++;break;case'hintbulb':cov_22gc02u306.b[1][23]++;cov_22gc02u306.s[50]++;icon=__WEBPACK_IMPORTED_MODULE_28__assets_hint_svg___default.a;cov_22gc02u306.s[51]++;break;case'average':cov_22gc02u306.b[1][24]++;cov_22gc02u306.s[52]++;icon=__WEBPACK_IMPORTED_MODULE_29__assets_average_svg___default.a;cov_22gc02u306.s[53]++;break;case'account':cov_22gc02u306.b[1][25]++;cov_22gc02u306.s[54]++;icon=__WEBPACK_IMPORTED_MODULE_30__assets_account_svg___default.a;cov_22gc02u306.s[55]++;break;case'info':cov_22gc02u306.b[1][26]++;cov_22gc02u306.s[56]++;icon=__WEBPACK_IMPORTED_MODULE_31__assets_info_svg___default.a;cov_22gc02u306.s[57]++;break;default:cov_22gc02u306.b[1][27]++;cov_22gc02u306.s[58]++;icon=__WEBPACK_IMPORTED_MODULE_5__assets_hamburger_svg___default.a;}var classNames=(cov_22gc02u306.s[59]++,__WEBPACK_IMPORTED_MODULE_3__Icon_scss___default.a.icon);cov_22gc02u306.s[60]++;if(props.display=='inline'){cov_22gc02u306.b[2][0]++;cov_22gc02u306.s[61]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Icon_scss___default.a.isInline;}else{cov_22gc02u306.b[2][1]++;}cov_22gc02u306.s[62]++;if(props.isHiddenDesktop){cov_22gc02u306.b[3][0]++;cov_22gc02u306.s[63]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Icon_scss___default.a.isHiddenDesktop;}else{cov_22gc02u306.b[3][1]++;}cov_22gc02u306.s[64]++;if(props.isHiddenMobile){cov_22gc02u306.b[4][0]++;cov_22gc02u306.s[65]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Icon_scss___default.a.isHiddenMobile;}else{cov_22gc02u306.b[4][1]++;}var styleAdd=(cov_22gc02u306.s[66]++,{width:'25px',height:'25px'});cov_22gc02u306.s[67]++;if(props.size){cov_22gc02u306.b[5][0]++;cov_22gc02u306.s[68]++;styleAdd={width:props.size,height:props.size};}else{cov_22gc02u306.b[5][1]++;}cov_22gc02u306.s[69]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:props.translate('global.icons.'+props.content)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_inlinesvg__["a" /* default */],{src:icon,className:classNames,style:styleAdd},'>'));}else{cov_22gc02u306.b[0][1]++;cov_22gc02u306.s[70]++;if(props.type=='text'){cov_22gc02u306.b[6][0]++;cov_22gc02u306.s[71]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Icon_scss___default.a.iconText},props.text);}else{cov_22gc02u306.b[6][1]++;}}};cov_22gc02u306.s[72]++;var mapStateToProps=function mapStateToProps(state){cov_22gc02u306.f[1]++;cov_22gc02u306.s[73]++;return{translate:Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* getTranslate */])(state.locale)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Icon));

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"Icon__icon___2HswS","isInline":"Icon__isInline___VPseI","iconText":"Icon__iconText___2L7iT","isHiddenDesktop":"Icon__isHiddenDesktop___2ZdVR","isHiddenMobile":"Icon__isHiddenMobile___1-x06"};

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_httpplease__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_httpplease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_httpplease__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(560);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var http = __WEBPACK_IMPORTED_MODULE_2_httpplease___default.a.use(__WEBPACK_IMPORTED_MODULE_3_httpplease_plugins_oldiexdomain___default.a);

var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  UNSUPPORTED: 'unsupported'
};

var getRequestsByUrl = {};
var loadedIcons = {};

var InlineSVG = function (_React$PureComponent) {
  _inherits(InlineSVG, _React$PureComponent);

  function InlineSVG(props) {
    _classCallCheck(this, InlineSVG);

    var _this = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

    _this.handleLoad = function (err, res) {
      var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (err) {
        _this.fail(err);
        return;
      }

      if (_this.isActive) {
        _this.setState({
          loadedText: res.text,
          status: Status.LOADED
        }, function () {
          _this.props.onLoad(_this.props.src, isCached);
        });
      }
    };

    _this.state = {
      status: Status.PENDING
    };

    _this.isActive = false;
    return _this;
  }

  _createClass(InlineSVG, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isActive = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* istanbul ignore else */
      if (this.state.status === Status.PENDING) {
        if (this.props.supportTest()) {
          if (this.props.src) {
            this.startLoad();
          } else {
            this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* configurationError */])('Missing source'));
          }
        } else {
          this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* unsupportedBrowserError */])());
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.src !== this.props.src) {
        if (this.props.src) {
          this.startLoad();
        } else {
          this.fail(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* configurationError */])('Missing source'));
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isActive = false;
    }
  }, {
    key: 'getFile',
    value: function getFile(callback) {
      var _this2 = this;

      var _props = this.props,
          cacheGetRequests = _props.cacheGetRequests,
          src = _props.src;


      if (cacheGetRequests) {
        if (loadedIcons[src]) {
          var _loadedIcons$src = _slicedToArray(loadedIcons[src], 2),
              err = _loadedIcons$src[0],
              res = _loadedIcons$src[1];

          callback(err, res, true);
        }

        if (!getRequestsByUrl[src]) {
          getRequestsByUrl[src] = [];

          http.get(src, function (err, res) {
            getRequestsByUrl[src].forEach(function (cb) {
              loadedIcons[src] = [err, res];

              if (src === _this2.props.src) {
                cb(err, res);
              }
            });
          });
        }

        getRequestsByUrl[src].push(callback);
      } else {
        http.get(src, function (err, res) {
          if (src === _this2.props.src) {
            callback(err, res);
          }
        });
      }
    }
  }, {
    key: 'fail',
    value: function fail(error) {
      var _this3 = this;

      var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;

      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({ status: status }, function () {
          if (typeof _this3.props.onError === 'function') {
            _this3.props.onError(error);
          }
        });
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({
          status: Status.LOADING
        }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var match = this.props.src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);

      if (match) {
        return this.handleLoad(null, {
          text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
        });
      }

      return this.getFile(this.handleLoad);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var className = 'isvg ' + this.state.status;

      if (this.props.className) {
        className += ' ' + this.props.className;
      }

      return className;
    }
  }, {
    key: 'processSVG',
    value: function processSVG(svgText) {
      var _props2 = this.props,
          uniquifyIDs = _props2.uniquifyIDs,
          uniqueHash = _props2.uniqueHash,
          baseURL = _props2.baseURL;


      if (uniquifyIDs) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* uniquifySVGIDs */])(svgText, uniqueHash || Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* randomString */])(), baseURL);
      }

      return svgText;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      switch (this.state.status) {
        case Status.UNSUPPORTED:
        case Status.FAILED:
          return this.props.children;
        default:
          return this.props.preloader;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var content = void 0;
      var html = void 0;

      if (this.state.loadedText) {
        html = {
          __html: this.processSVG(this.state.loadedText)
        };
      } else {
        content = this.renderContents();
      }

      return this.props.wrapper({
        style: this.props.style,
        className: this.getClassName(),
        dangerouslySetInnerHTML: html
      }, content);
    }
  }]);

  return InlineSVG;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

InlineSVG.propTypes = {
  baseURL: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cacheGetRequests: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  preloader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  src: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  supportTest: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  uniqueHash: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  uniquifyIDs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapper: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
InlineSVG.defaultProps = {
  baseURL: '',
  cacheGetRequests: false,
  onLoad: function onLoad() {},
  supportTest: __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* isSupportedEnvironment */],
  uniquifyIDs: true,
  wrapper: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createFactory('span')
};
/* harmony default export */ __webpack_exports__["a"] = (InlineSVG);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  cleanURL = __webpack_require__(554),
  XHR = __webpack_require__(555),
  delay = __webpack_require__(556),
  RequestError = __webpack_require__(557),
  Response = __webpack_require__(221),
  Request = __webpack_require__(222),
  extend = __webpack_require__(110),
  once = __webpack_require__(224);

var i,
    createError = RequestError.create;

function factory(defaults, plugins) {
  defaults = defaults || {};
  plugins = plugins || [];

  function http(req, cb) {
    var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;

    req = new Request(extend(defaults, req));

    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.processRequest) {
        plugin.processRequest(req);
      }
    }

    // Give the plugins a chance to create the XHR object
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.createXHR) {
        xhr = plugin.createXHR(req);
        break; // First come, first serve
      }
    }
    xhr = xhr || new XHR();

    req.xhr = xhr;

    // Use a single completion callback. This can be called with or without
    // an error. If no error is passed, the request will be examined to see
    // if it was successful.
    done = once(delay(function(rawError) {
      clearTimeout(timeoutId);
      xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;

      var err = getError(req, rawError);

      var res = err || Response.fromRequest(req);
      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];
        if (plugin.processResponse) {
          plugin.processResponse(res);
        }
      }

      // Invoke callbacks
      if (err && req.onerror) req.onerror(err);
      if (!err && req.onload) req.onload(res);
      if (cb) cb(err, err ? undefined : res);

    }));

    supportsLoadAndErrorEvents = ('onload' in xhr) && ('onerror' in xhr);
    xhr.onload = function() { done(); };
    xhr.onerror = done;
    xhr.onabort = function() { done(); };

    // We'd rather use `onload`, `onerror`, and `onabort` since they're the
    // only way to reliably detect successes and failures but, if they
    // aren't available, we fall back to using `onreadystatechange`.
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;

      if (req.aborted) return done();

      if (!supportsLoadAndErrorEvents) {
        // Assume a status of 0 is an error. This could be a false
        // positive, but there's no way to tell when using
        // `onreadystatechange` ):
        // See matthewwithanm/react-inlinesvg#10.

        // Some browsers don't like you reading XHR properties when the
        // XHR has been aborted. In case we've gotten here as a result
        // of that (either our calling `about()` in the timeout handler
        // or the user calling it directly even though they shouldn't),
        // be careful about accessing it.
        var status;
        try {
          status = xhr.status;
        } catch (err) {}
        var err = status === 0 ? new Error('Internal XHR Error') : null;
        return done(err);
      }
    };

    // IE sometimes fails if you don't specify every handler.
    // See http://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
    xhr.ontimeout = function() { /* noop */ };
    xhr.onprogress = function() { /* noop */ };

    xhr.open(req.method, req.url);

    if (req.timeout) {
      // If we use the normal XHR timeout mechanism (`xhr.timeout` and
      // `xhr.ontimeout`), `onreadystatechange` will be triggered before
      // `ontimeout`. There's no way to recognize that it was triggered by
      // a timeout, and we'd be unable to dispatch the right error.
      timeoutId = setTimeout(function() {
        req.timedOut = true;
        done();
        try {
          xhr.abort();
        } catch (err) {}
      }, req.timeout);
    }

    for (k in req.headers) {
      if (req.headers.hasOwnProperty(k)) {
        xhr.setRequestHeader(k, req.headers[k]);
      }
    }

    xhr.send(req.body);

    return req;
  }

  var method,
    methods = ['get', 'post', 'put', 'head', 'patch', 'delete'],
    verb = function(method) {
      return function(req, cb) {
        req = new Request(req);
        req.method = method;
        return http(req, cb);
      };
    };
  for (i = 0; i < methods.length; i++) {
    method = methods[i];
    http[method] = verb(method);
  }

  http.plugins = function() {
    return plugins;
  };

  http.defaults = function(newValues) {
    if (newValues) {
      return factory(extend(defaults, newValues), plugins);
    }
    return defaults;
  };

  http.use = function() {
    var newPlugins = Array.prototype.slice.call(arguments, 0);
    return factory(defaults, plugins.concat(newPlugins));
  };

  http.bare = function() {
    return factory();
  };

  http.Request = Request;
  http.Response = Response;
  http.RequestError = RequestError;

  return http;
}

module.exports = factory({}, [cleanURL]);

/**
 * Analyze the request to see if it represents an error. If so, return it! An
 * original error object can be passed as a hint.
 */
function getError(req, err) {
  if (req.aborted) return createError('Request aborted', req, {name: 'Abort'});

  if (req.timedOut) return createError('Request timeout', req, {name: 'Timeout'});

  var xhr = req.xhr;
  var type = Math.floor(xhr.status / 100);

  var kind;
  switch (type) {
    case 0:
    case 2:
      // These don't represent errors unless the function was passed an
      // error object explicitly.
      if (!err) return;
      return createError(err.message, req);
    case 4:
      // Sometimes 4XX statuses aren't errors.
      if (xhr.status === 404 && !req.errorOn404) return;
      kind = 'Client';
      break;
    case 5:
      kind = 'Server';
      break;
    default:
      kind = 'HTTP';
  }
  var msg = kind + ' Error: ' +
        'The server returned a status of ' + xhr.status +
        ' for the request "' +
        req.method.toUpperCase() + ' ' + req.url + '"';
  return createError(msg, req);
}


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  processRequest: function(req) {
    req.url = req.url.replace(/[^%]+/g, function(s) {
      return encodeURI(s);
    });
  }
};


/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = window.XMLHttpRequest;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function(fn) {
  return function() {
    var
      args = Array.prototype.slice.call(arguments, 0),
      newFunc = function() {
        return fn.apply(null, args);
      };
    setTimeout(newFunc, 0);
  };
};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Response = __webpack_require__(221);
var extractResponseProps = __webpack_require__(223);
var extend = __webpack_require__(110);

function RequestError(message, props) {
  var err = new Error(message);
  err.name = 'RequestError';
  this.name = err.name;
  this.message = err.message;
  if (err.stack) {
    this.stack = err.stack;
  }

  this.toString = function() {
    return this.message;
  };

  for (var k in props) {
    if (props.hasOwnProperty(k)) {
      this[k] = props[k];
    }
  }
}

RequestError.prototype = extend(Error.prototype);
RequestError.prototype.constructor = RequestError;

RequestError.create = function(message, req, props) {
  var err = new RequestError(message, props);
  Response.call(err, extractResponseProps(req));
  return err;
};

module.exports = RequestError;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var
  urllite = __webpack_require__(559),
  once = __webpack_require__(224);

var warningShown = false;

var supportsXHR = once(function() {
  return (
    typeof window !== 'undefined' &&
    window !== null &&
    window.XMLHttpRequest &&
    'withCredentials' in new window.XMLHttpRequest()
  );
});

// This plugin creates a Microsoft `XDomainRequest` in supporting browsers when
// the URL being requested is on a different domain. This is necessary to
// support IE9, which only supports CORS via its proprietary `XDomainRequest`
// object. We need to check the URL because `XDomainRequest` *doesn't* work for
// same domain requests (unless your server sends CORS headers).
// `XDomainRequest` also has other limitations (no custom headers), so we try to
// catch those and error.
module.exports = {
  createXHR: function(req) {
    var a, b, k;

    if (typeof window === 'undefined' || window === null) {
      return;
    }

    a = urllite(req.url);
    b = urllite(window.location.href);

    // Don't do anything for same-domain requests.
    if (!a.host) {
      return;
    }
    if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
      return;
    }

    // Show a warning if there are custom headers. We do this even in
    // browsers that won't use XDomainRequest so that users know there's an
    // issue right away, instead of if/when they test in IE9.
    if (!warningShown && req.headers) {
      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          warningShown = true;
          if (window && window.console && window.console.warn) {
            window.console.warn('Request headers are ignored in old IE when using the oldiexdomain plugin.');
          }
          break;
        }
      }
    }

    // Don't do anything if we can't do anything (:
    // Don't do anything if the browser supports proper XHR.
    if (window.XDomainRequest && !supportsXHR()) {
      // We've come this far. Might as well make an XDomainRequest.
      var xdr = new window.XDomainRequest();
      xdr.setRequestHeader = function() {}; // Ignore request headers.
      return xdr;
    }
  }
};


/***/ }),
/* 559 */
/***/ (function(module, exports) {

(function() {
  var URL, URL_PATTERN, defaults, urllite,
    __hasProp = {}.hasOwnProperty;

  URL_PATTERN = /^(?:(?:([^:\/?\#]+:)\/+|(\/\/))(?:([a-z0-9-\._~%]+)(?::([a-z0-9-\._~%]+))?@)?(([a-z0-9-\._~%!$&'()*+,;=]+)(?::([0-9]+))?)?)?([^?\#]*?)(\?[^\#]*)?(\#.*)?$/;

  urllite = function(raw, opts) {
    return urllite.URL.parse(raw, opts);
  };

  urllite.URL = URL = (function() {
    function URL(props) {
      var k, v, _ref;
      for (k in defaults) {
        if (!__hasProp.call(defaults, k)) continue;
        v = defaults[k];
        this[k] = (_ref = props[k]) != null ? _ref : v;
      }
      this.host || (this.host = this.hostname && this.port ? "" + this.hostname + ":" + this.port : this.hostname ? this.hostname : '');
      this.origin || (this.origin = this.protocol ? "" + this.protocol + "//" + this.host : '');
      this.isAbsolutePathRelative = !this.host && this.pathname.charAt(0) === '/';
      this.isPathRelative = !this.host && this.pathname.charAt(0) !== '/';
      this.isRelative = this.isSchemeRelative || this.isAbsolutePathRelative || this.isPathRelative;
      this.isAbsolute = !this.isRelative;
    }

    URL.parse = function(raw) {
      var m, pathname, protocol;
      m = raw.toString().match(URL_PATTERN);
      pathname = m[8] || '';
      protocol = m[1];
      return new urllite.URL({
        protocol: protocol,
        username: m[3],
        password: m[4],
        hostname: m[6],
        port: m[7],
        pathname: protocol && pathname.charAt(0) !== '/' ? "/" + pathname : pathname,
        search: m[9],
        hash: m[10],
        isSchemeRelative: m[2] != null
      });
    };

    return URL;

  })();

  defaults = {
    protocol: '',
    username: '',
    password: '',
    host: '',
    hostname: '',
    port: '',
    pathname: '',
    search: '',
    hash: '',
    origin: '',
    isSchemeRelative: false
  };

  module.exports = urllite;

}).call(this);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsInlineSVG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSupportedEnvironment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return randomString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uniquifySVGIDs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return unsupportedBrowserError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configurationError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_once__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_once__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var supportsInlineSVG = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
  /* istanbul ignore next */
  if (!document) {
    return false;
  }

  var div = document.createElement('div');
  div.innerHTML = '<svg />';
  return div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
});

var isSupportedEnvironment = __WEBPACK_IMPORTED_MODULE_0_once___default()(function () {
  return supportsInlineSVG() && typeof window !== 'undefined' && window !== null ? window.XMLHttpRequest || window.XDomainRequest : false;
});

var randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  var letters = 'abcdefghijklmnopqrstuvwxyz';
  var numbers = '1234567890';
  var charset = letters + letters.toUpperCase() + numbers;

  var randomCharacter = function randomCharacter(array) {
    return array[Math.floor(Math.random() * array.length)];
  };

  var R = '';
  for (var i = 0; i < length; i++) {
    R += randomCharacter(charset);
  }
  return R;
};

var uniquifySVGIDs = function () {
  var mkAttributePattern = function mkAttributePattern(attr) {
    return '(?:(?:\\s|\\:)' + attr + ')';
  };

  var idPattern = new RegExp('(?:(' + mkAttributePattern('id') + ')="([^"]+)")|(?:(' + mkAttributePattern('href') + '|' + mkAttributePattern('role') + '|' + mkAttributePattern('arcrole') + ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")|(?:url\\(\\#([^\\)]+)\\))', 'g');

  return function (svgText, svgID, baseURL) {
    var uniquifyID = function uniquifyID(id) {
      return id + '___' + svgID;
    };

    return svgText.replace(idPattern, function (m, p1, p2, p3, p4, p5, p6) {
      //eslint-disable-line consistent-return
      /* istanbul ignore else */
      if (p2) {
        return p1 + '="' + uniquifyID(p2) + '"';
      } else if (p4) {
        return p3 + '="' + baseURL + '#' + uniquifyID(p4) + '"';
      } else if (p5) {
        return '="url(' + baseURL + '#' + uniquifyID(p5) + ')"';
      } else if (p6) {
        return 'url(' + baseURL + '#' + uniquifyID(p6) + ')';
      }
    });
  };
}();

var InlineSVGError = function (_Error) {
  _inherits(InlineSVGError, _Error);

  function InlineSVGError(message) {
    var _ret;

    _classCallCheck(this, InlineSVGError);

    var _this = _possibleConstructorReturn(this, (InlineSVGError.__proto__ || Object.getPrototypeOf(InlineSVGError)).call(this));

    _this.name = 'InlineSVGError';
    _this.isSupportedBrowser = true;
    _this.isConfigurationError = false;
    _this.isUnsupportedBrowserError = false;
    _this.message = message;

    return _ret = _this, _possibleConstructorReturn(_this, _ret);
  }

  return InlineSVGError;
}(Error);

var createError = function createError(message, attrs) {
  var err = new InlineSVGError(message);

  return _extends({}, err, attrs);
};

var unsupportedBrowserError = function unsupportedBrowserError(message) {
  var newMessage = message;

  /* istanbul ignore else */
  if (!newMessage) {
    newMessage = 'Unsupported Browser';
  }

  return createError(newMessage, {
    isSupportedBrowser: false,
    isUnsupportedBrowserError: true
  });
};

var configurationError = function configurationError(message) {
  return createError(message, {
    isConfigurationError: true
  });
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(562)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hamburger.e0a07e48.svg";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/settingsmenu.4e731071.svg";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-success.bf6b83b7.svg";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-warning.a2f33a6f.svg";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-error.be1ae36e.svg";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-hint.bcc8f75f.svg";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yes.44be6465.svg";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/no.e82600ee.svg";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cost.9adbfa7a.svg";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/time.ae5e93b5.svg";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/content-settings.481be7cb.svg";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/menu-settings.e7a553b7.svg";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/profile.fc318b0f.svg";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/password.c9845e44.svg";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/company.bb822ffd.svg";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/content-edit.892854c5.svg";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/content-export.7377fb15.svg";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/content-delete.e0c67d6e.svg";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-search.d3b50075.svg";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/input-calendar.8d74c7b7.svg";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.d9a25b88.svg";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logout.878d5262.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/questionmark.3ffd0fab.svg";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hint.b8109b11.svg";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/average.b03f3557.svg";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/account.10756428.svg";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/info.56acac05.svg";

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfoText_scss__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InfoText_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__InfoText_scss__);
var cov_26lamgq52s=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\InfoText\\index.js',hash='79984b1bbe4cf7243ba2d5e0edb3b3245f07b3fc',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\InfoText\\index.js',statementMap:{'0':{start:{line:4,column:17},end:{line:17,column:1}},'1':{start:{line:5,column:3},end:{line:16,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:4,column:17},end:{line:4,column:18}},loc:{start:{line:4,column:28},end:{line:17,column:1}},line:4}},branchMap:{'0':{loc:{start:{line:7,column:4},end:{line:11,column:4}},type:'binary-expr',locations:[{start:{line:7,column:4},end:{line:7,column:14}},{start:{line:8,column:4},end:{line:10,column:10}}],line:7}},s:{'0':0,'1':0},f:{'0':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_26lamgq52s.s[0]++;var InfoText=function InfoText(props){cov_26lamgq52s.f[0]++;cov_26lamgq52s.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__InfoText_scss___default.a.infotext},(cov_26lamgq52s.b[0][0]++,props.icon)&&(cov_26lamgq52s.b[0][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__InfoText_scss___default.a.icon},props.icon)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.text));};/* harmony default export */ __webpack_exports__["default"] = (InfoText);

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"infotext":"InfoText__infotext___25F-H","icon":"InfoText__icon___2YhB3"};

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_scss__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Input_scss__);
var cov_14xfnw6a3y=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Input\\index.js',hash='291e8d4bcde9c64754b94e9d943d551486079db8',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Input\\index.js',statementMap:{'0':{start:{line:30,column:4},end:{line:35,column:5}},'1':{start:{line:31,column:20},end:{line:31,column:65}},'2':{start:{line:32,column:6},end:{line:34,column:7}},'3':{start:{line:33,column:8},end:{line:33,column:86}},'4':{start:{line:36,column:4},end:{line:36,column:52}},'5':{start:{line:41,column:4},end:{line:58,column:5}},'6':{start:{line:44,column:37},end:{line:44,column:83}},'7':{start:{line:45,column:58},end:{line:45,column:107}},'8':{start:{line:46,column:56},end:{line:46,column:104}},'9':{start:{line:47,column:57},end:{line:47,column:105}},'10':{start:{line:48,column:56},end:{line:48,column:103}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:9,column:16},end:{line:9,column:17}},loc:{start:{line:9,column:35},end:{line:37,column:3}},line:9},'1':{name:'(anonymous_1)',decl:{start:{line:39,column:2},end:{line:39,column:3}},loc:{start:{line:39,column:11},end:{line:59,column:3}},line:39},'2':{name:'(anonymous_2)',decl:{start:{line:44,column:26},end:{line:44,column:27}},loc:{start:{line:44,column:37},end:{line:44,column:83}},line:44},'3':{name:'(anonymous_3)',decl:{start:{line:45,column:47},end:{line:45,column:48}},loc:{start:{line:45,column:58},end:{line:45,column:107}},line:45},'4':{name:'(anonymous_4)',decl:{start:{line:46,column:45},end:{line:46,column:46}},loc:{start:{line:46,column:56},end:{line:46,column:104}},line:46},'5':{name:'(anonymous_5)',decl:{start:{line:47,column:46},end:{line:47,column:47}},loc:{start:{line:47,column:57},end:{line:47,column:105}},line:47},'6':{name:'(anonymous_6)',decl:{start:{line:48,column:45},end:{line:48,column:46}},loc:{start:{line:48,column:56},end:{line:48,column:103}},line:48}},branchMap:{'0':{loc:{start:{line:30,column:4},end:{line:35,column:5}},type:'if',locations:[{start:{line:30,column:4},end:{line:35,column:5}},{start:{line:30,column:4},end:{line:35,column:5}}],line:30},'1':{loc:{start:{line:32,column:6},end:{line:34,column:7}},type:'if',locations:[{start:{line:32,column:6},end:{line:34,column:7}},{start:{line:32,column:6},end:{line:34,column:7}}],line:32},'2':{loc:{start:{line:45,column:25},end:{line:45,column:114}},type:'cond-expr',locations:[{start:{line:45,column:47},end:{line:45,column:107}},{start:{line:45,column:110},end:{line:45,column:114}}],line:45},'3':{loc:{start:{line:46,column:24},end:{line:46,column:111}},type:'cond-expr',locations:[{start:{line:46,column:45},end:{line:46,column:104}},{start:{line:46,column:107},end:{line:46,column:111}}],line:46},'4':{loc:{start:{line:47,column:25},end:{line:47,column:112}},type:'cond-expr',locations:[{start:{line:47,column:46},end:{line:47,column:105}},{start:{line:47,column:108},end:{line:47,column:112}}],line:47},'5':{loc:{start:{line:48,column:25},end:{line:48,column:110}},type:'cond-expr',locations:[{start:{line:48,column:45},end:{line:48,column:103}},{start:{line:48,column:106},end:{line:48,column:110}}],line:48},'6':{loc:{start:{line:51,column:26},end:{line:51,column:60}},type:'cond-expr',locations:[{start:{line:51,column:48},end:{line:51,column:52}},{start:{line:51,column:55},end:{line:51,column:60}}],line:51},'7':{loc:{start:{line:53,column:31},end:{line:53,column:98}},type:'cond-expr',locations:[{start:{line:53,column:86},end:{line:53,column:90}},{start:{line:53,column:93},end:{line:53,column:98}}],line:53},'8':{loc:{start:{line:53,column:31},end:{line:53,column:83}},type:'binary-expr',locations:[{start:{line:53,column:31},end:{line:53,column:56}},{start:{line:53,column:60},end:{line:53,column:83}}],line:53},'9':{loc:{start:{line:54,column:26},end:{line:54,column:60}},type:'cond-expr',locations:[{start:{line:54,column:48},end:{line:54,column:52}},{start:{line:54,column:55},end:{line:54,column:60}}],line:54},'10':{loc:{start:{line:55,column:22},end:{line:55,column:94}},type:'cond-expr',locations:[{start:{line:55,column:72},end:{line:55,column:87}},{start:{line:55,column:90},end:{line:55,column:94}}],line:55},'11':{loc:{start:{line:55,column:22},end:{line:55,column:69}},type:'binary-expr',locations:[{start:{line:55,column:22},end:{line:55,column:50}},{start:{line:55,column:54},end:{line:55,column:69}}],line:55}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import PropTypes from 'prop-types'*/var Input=function(_ref){_inherits(Input,_ref);function Input(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Input);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Input.__proto__||Object.getPrototypeOf(Input)).call.apply(_ref2,[this].concat(args))),_this),_this.checkValues=function(event,target){cov_14xfnw6a3y.f[0]++;cov_14xfnw6a3y.s[0]++;/*if(this.props.type=="number"){
      if(event.target.value){
        if(this.props.minValue){
          if(event.target.value<this.props.minValue){
            event.target.value = this.props.minValue;
            if(this.props.onCheckValuesError) {
              this.props.onCheckValuesError(this.props.minValue ? this.props.minValue : null, this.props.maxValue ? this.props.maxValue : null);
            }
          }
        }
        if(this.props.maxValue){
          if(event.target.value>this.props.maxValue){
            event.target.value = event.target.value.substr(0,event.target.value.length-1);
            if(this.props.onCheckValuesError) {
              this.props.onCheckValuesError(this.props.minValue ? this.props.minValue : null, this.props.maxValue ? this.props.maxValue : null);
            }
          }
        }
      }
    }*/if(_this.props.validationPattern){cov_14xfnw6a3y.b[0][0]++;var regex=(cov_14xfnw6a3y.s[1]++,new RegExp(_this.props.validationPattern,'g'));cov_14xfnw6a3y.s[2]++;if(!regex.test(event.target.value)){cov_14xfnw6a3y.b[1][0]++;cov_14xfnw6a3y.s[3]++;event.target.value=event.target.value.substr(0,event.target.value.length-1);}else{cov_14xfnw6a3y.b[1][1]++;}}else{cov_14xfnw6a3y.b[0][1]++;}cov_14xfnw6a3y.s[4]++;_this.props.changed(event,_this.props.identifier);},_temp),_possibleConstructorReturn(_this,_ret);}// Backspace-Funktion
_createClass(Input,[{key:'render',value:function render(){var _this2=this;cov_14xfnw6a3y.f[1]++;cov_14xfnw6a3y.s[5]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:__WEBPACK_IMPORTED_MODULE_2__Input_scss___default.a.defaultInput,onChange:function onChange(event){cov_14xfnw6a3y.f[2]++;cov_14xfnw6a3y.s[6]++;return _this2.checkValues(event,_this2.props.identifier);},onKeyUp:this.props.keyupped?(cov_14xfnw6a3y.b[2][0]++,function(event){cov_14xfnw6a3y.f[3]++;cov_14xfnw6a3y.s[7]++;return _this2.props.keyupped(event,_this2.props.identifier);}):(cov_14xfnw6a3y.b[2][1]++,null),onBlur:this.props.blurred?(cov_14xfnw6a3y.b[3][0]++,function(event){cov_14xfnw6a3y.f[4]++;cov_14xfnw6a3y.s[8]++;return _this2.props.blurred(event,_this2.props.identifier);}):(cov_14xfnw6a3y.b[3][1]++,null),onFocus:this.props.focused?(cov_14xfnw6a3y.b[4][0]++,function(event){cov_14xfnw6a3y.f[5]++;cov_14xfnw6a3y.s[9]++;return _this2.props.focused(event,_this2.props.identifier);}):(cov_14xfnw6a3y.b[4][1]++,null),onPaste:this.props.pasted?(cov_14xfnw6a3y.b[5][0]++,function(event){cov_14xfnw6a3y.f[6]++;cov_14xfnw6a3y.s[10]++;return _this2.props.pasted(event,_this2.props.identifier);}):(cov_14xfnw6a3y.b[5][1]++,null),value:this.props.value,type:this.props.type,selected:this.props.selected?(cov_14xfnw6a3y.b[6][0]++,true):(cov_14xfnw6a3y.b[6][1]++,false),placeholder:this.props.placeholder,'data-hasvalue':(cov_14xfnw6a3y.b[8][0]++,this.props.value!==null)&&(cov_14xfnw6a3y.b[8][1]++,this.props.value!=="")?(cov_14xfnw6a3y.b[7][0]++,true):(cov_14xfnw6a3y.b[7][1]++,false),disabled:this.props.disabled?(cov_14xfnw6a3y.b[9][0]++,true):(cov_14xfnw6a3y.b[9][1]++,false),step:(cov_14xfnw6a3y.b[11][0]++,this.props.type==="number")&&(cov_14xfnw6a3y.b[11][1]++,this.props.step)?(cov_14xfnw6a3y.b[10][0]++,this.props.step):(cov_14xfnw6a3y.b[10][1]++,null)}));}}]);return Input;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/*
Input.propTypes = {
  value: PropTypes.node.isRequired,
  changed: PropTypes.any.isRequired,
  elementConfig: PropTypes.any.isRequired,
  elementType: PropTypes.any.isRequired,
}*//* harmony default export */ __webpack_exports__["default"] = (Input);

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"Input__defaultInput___-dJ1M"};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label_scss__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Label_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Label_scss__);
var cov_22pphvj63e=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Label\\index.js',hash='a14d5ee4e229e6df0c5567f38a900639d55c7e63',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Label\\index.js',statementMap:{'0':{start:{line:5,column:14},end:{line:21,column:1}},'1':{start:{line:6,column:18},end:{line:6,column:30}},'2':{start:{line:8,column:2},end:{line:10,column:3}},'3':{start:{line:9,column:4},end:{line:9,column:55}},'4':{start:{line:12,column:2},end:{line:14,column:3}},'5':{start:{line:13,column:4},end:{line:13,column:56}},'6':{start:{line:15,column:2},end:{line:20,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:14},end:{line:5,column:15}},loc:{start:{line:5,column:25},end:{line:21,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:8,column:2},end:{line:10,column:3}},type:'if',locations:[{start:{line:8,column:2},end:{line:10,column:3}},{start:{line:8,column:2},end:{line:10,column:3}}],line:8},'1':{loc:{start:{line:12,column:2},end:{line:14,column:3}},type:'if',locations:[{start:{line:12,column:2},end:{line:14,column:3}},{start:{line:12,column:2},end:{line:14,column:3}}],line:12}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},f:{'0':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_22pphvj63e.s[0]++;var Label=function Label(props){cov_22pphvj63e.f[0]++;var classNames=(cov_22pphvj63e.s[1]++,__WEBPACK_IMPORTED_MODULE_1__Label_scss___default.a.label);cov_22pphvj63e.s[2]++;if(props.styles=='toggleLeft'){cov_22pphvj63e.b[0][0]++;cov_22pphvj63e.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Label_scss___default.a.isToggleLeft;}else{cov_22pphvj63e.b[0][1]++;}cov_22pphvj63e.s[4]++;if(props.styles=='toggleRight'){cov_22pphvj63e.b[1][0]++;cov_22pphvj63e.s[5]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Label_scss___default.a.isToggleRight;}else{cov_22pphvj63e.b[1][1]++;}cov_22pphvj63e.s[6]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:classNames},props.label);};/* harmony default export */ __webpack_exports__["default"] = (Label);

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"Label__label___2vykN","isToggleLeft":"Label__isToggleLeft___1HFBk","isToggleRight":"Label__isToggleRight___3EJez"};

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logo_scss__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Logo_scss__);
var cov_28gbbat1t4=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Logo\\index.js',hash='225af0c766cba3dd5ec66a797eaf2591932ce49d',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Logo\\index.js',statementMap:{'0':{start:{line:6,column:13},end:{line:6,column:102}},'1':{start:{line:6,column:22},end:{line:6,column:102}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:6,column:13},end:{line:6,column:14}},loc:{start:{line:6,column:22},end:{line:6,column:102}},line:6}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_28gbbat1t4.s[0]++;var Logo=function Logo(props){cov_28gbbat1t4.f[0]++;cov_28gbbat1t4.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',Object.assign({alt:'Logo',src:__WEBPACK_IMPORTED_MODULE_1__assets_logo_svg___default.a,className:__WEBPACK_IMPORTED_MODULE_2__Logo_scss___default.a.logo},props)));};/* harmony default export */ __webpack_exports__["default"] = (Logo);

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.80df3783.svg";

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"Logo__logo___WNaPm"};

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageTitle_scss__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PageTitle_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PageTitle_scss__);
var cov_1m1a7udie8=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\PageTitle\\index.js',hash='de405937db6efad680f300e475da21c912129d15',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\PageTitle\\index.js',statementMap:{'0':{start:{line:5,column:18},end:{line:27,column:1}},'1':{start:{line:6,column:18},end:{line:6,column:34}},'2':{start:{line:7,column:21},end:{line:7,column:23}},'3':{start:{line:9,column:1},end:{line:11,column:2}},'4':{start:{line:10,column:2},end:{line:10,column:48}},'5':{start:{line:14,column:2},end:{line:17,column:3}},'6':{start:{line:15,column:4},end:{line:15,column:51}},'7':{start:{line:16,column:4},end:{line:16,column:42}},'8':{start:{line:20,column:2},end:{line:26,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:18},end:{line:5,column:19}},loc:{start:{line:5,column:29},end:{line:27,column:1}},line:5}},branchMap:{'0':{loc:{start:{line:9,column:1},end:{line:11,column:2}},type:'if',locations:[{start:{line:9,column:1},end:{line:11,column:2}},{start:{line:9,column:1},end:{line:11,column:2}}],line:9},'1':{loc:{start:{line:14,column:2},end:{line:17,column:3}},type:'if',locations:[{start:{line:14,column:2},end:{line:17,column:3}},{start:{line:14,column:2},end:{line:17,column:3}}],line:14}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},f:{'0':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1m1a7udie8.s[0]++;var PageTitle=function PageTitle(props){cov_1m1a7udie8.f[0]++;var classNames=(cov_1m1a7udie8.s[1]++,__WEBPACK_IMPORTED_MODULE_1__PageTitle_scss___default.a.pageTitle);var customStyles=(cov_1m1a7udie8.s[2]++,{});cov_1m1a7udie8.s[3]++;if(props.theme=='light'){cov_1m1a7udie8.b[0][0]++;cov_1m1a7udie8.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__PageTitle_scss___default.a.isLight;}else{cov_1m1a7udie8.b[0][1]++;}cov_1m1a7udie8.s[5]++;if(props.ellipsis){cov_1m1a7udie8.b[1][0]++;cov_1m1a7udie8.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__PageTitle_scss___default.a.ellipsis;cov_1m1a7udie8.s[7]++;customStyles={width:props.ellipsis};}else{cov_1m1a7udie8.b[1][1]++;}cov_1m1a7udie8.s[8]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:classNames,style:customStyles},props.children);};/* harmony default export */ __webpack_exports__["default"] = (PageTitle);

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"PageTitle__pageTitle___19rR9","ellipsis":"PageTitle__ellipsis___1ZLP3","isLight":"PageTitle__isLight___27Vg5"};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Radio_scss__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Radio_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Radio_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_newId__ = __webpack_require__(111);
var cov_2bcjuvwdjg=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Radio\\index.js',hash='0a32a8f91f57f40f3f635d0856184296e756e11a',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Radio\\index.js',statementMap:{'0':{start:{line:10,column:6},end:{line:10,column:24}},'1':{start:{line:13,column:4},end:{line:27,column:5}},'2':{start:{line:16,column:37},end:{line:16,column:85}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:9,column:2},end:{line:9,column:3}},loc:{start:{line:9,column:23},end:{line:11,column:3}},line:9},'1':{name:'(anonymous_1)',decl:{start:{line:12,column:2},end:{line:12,column:3}},loc:{start:{line:12,column:11},end:{line:28,column:3}},line:12},'2':{name:'(anonymous_2)',decl:{start:{line:16,column:26},end:{line:16,column:27}},loc:{start:{line:16,column:37},end:{line:16,column:85}},line:16}},branchMap:{'0':{loc:{start:{line:19,column:25},end:{line:19,column:58}},type:'cond-expr',locations:[{start:{line:19,column:46},end:{line:19,column:50}},{start:{line:19,column:53},end:{line:19,column:58}}],line:19},'1':{loc:{start:{line:20,column:31},end:{line:20,column:98}},type:'cond-expr',locations:[{start:{line:20,column:86},end:{line:20,column:90}},{start:{line:20,column:93},end:{line:20,column:98}}],line:20},'2':{loc:{start:{line:20,column:31},end:{line:20,column:83}},type:'binary-expr',locations:[{start:{line:20,column:31},end:{line:20,column:56}},{start:{line:20,column:60},end:{line:20,column:83}}],line:20},'3':{loc:{start:{line:21,column:26},end:{line:21,column:60}},type:'cond-expr',locations:[{start:{line:21,column:48},end:{line:21,column:52}},{start:{line:21,column:55},end:{line:21,column:60}}],line:21}},s:{'0':0,'1':0,'2':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import PropTypes from 'prop-types'*/var Radio=function(_ref){_inherits(Radio,_ref);function Radio(){_classCallCheck(this,Radio);return _possibleConstructorReturn(this,(Radio.__proto__||Object.getPrototypeOf(Radio)).apply(this,arguments));}_createClass(Radio,[{key:'componentWillMount',value:function componentWillMount(){cov_2bcjuvwdjg.f[0]++;cov_2bcjuvwdjg.s[0]++;this.id=Object(__WEBPACK_IMPORTED_MODULE_3__util_newId__["a" /* default */])();}},{key:'render',value:function render(){var _this2=this;cov_2bcjuvwdjg.f[1]++;cov_2bcjuvwdjg.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:__WEBPACK_IMPORTED_MODULE_2__Radio_scss___default.a.defaultInput,onChange:function onChange(event){cov_2bcjuvwdjg.f[2]++;cov_2bcjuvwdjg.s[2]++;return _this2.props.changed(event,_this2.props.identifier);},value:this.props.value,type:'radio',checked:this.props.checked?(cov_2bcjuvwdjg.b[0][0]++,true):(cov_2bcjuvwdjg.b[0][1]++,false),'data-hasvalue':(cov_2bcjuvwdjg.b[2][0]++,this.props.value!==null)&&(cov_2bcjuvwdjg.b[2][1]++,this.props.value!=="")?(cov_2bcjuvwdjg.b[1][0]++,true):(cov_2bcjuvwdjg.b[1][1]++,false),disabled:this.props.disabled?(cov_2bcjuvwdjg.b[3][0]++,true):(cov_2bcjuvwdjg.b[3][1]++,false),id:this.id,name:this.props.identifier}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\xA0')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.id},this.props.label));}}]);return Radio;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (Radio);

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_scss__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_scss__);
var cov_1cwhxb7tsq=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Select\\index.js',hash='057c56d9912ebe24a0842986203d0995eef5974f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Select\\index.js',statementMap:{'0':{start:{line:9,column:4},end:{line:9,column:17}},'1':{start:{line:10,column:4},end:{line:12,column:5}},'2':{start:{line:15,column:4},end:{line:15,column:36}},'3':{start:{line:18,column:4},end:{line:18,column:53}},'4':{start:{line:19,column:4},end:{line:19,column:38}},'5':{start:{line:22,column:4},end:{line:22,column:38}},'6':{start:{line:25,column:4},end:{line:39,column:5}},'7':{start:{line:36,column:8},end:{line:36,column:71}},'8':{start:{line:43,column:24},end:{line:47,column:1}},'9':{start:{line:44,column:4},end:{line:46,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:2},end:{line:8,column:3}},loc:{start:{line:8,column:21},end:{line:13,column:3}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:17},end:{line:14,column:18}},loc:{start:{line:14,column:23},end:{line:16,column:3}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:17,column:19},end:{line:17,column:20}},loc:{start:{line:17,column:30},end:{line:20,column:3}},line:17},'3':{name:'(anonymous_3)',decl:{start:{line:21,column:16},end:{line:21,column:17}},loc:{start:{line:21,column:27},end:{line:23,column:3}},line:21},'4':{name:'(anonymous_4)',decl:{start:{line:24,column:2},end:{line:24,column:3}},loc:{start:{line:24,column:11},end:{line:40,column:3}},line:24},'5':{name:'(anonymous_5)',decl:{start:{line:35,column:30},end:{line:35,column:31}},loc:{start:{line:36,column:8},end:{line:36,column:71}},line:36},'6':{name:'(anonymous_6)',decl:{start:{line:43,column:24},end:{line:43,column:25}},loc:{start:{line:43,column:33},end:{line:47,column:1}},line:43}},branchMap:{'0':{loc:{start:{line:30,column:29},end:{line:30,column:120}},type:'cond-expr',locations:[{start:{line:30,column:108},end:{line:30,column:112}},{start:{line:30,column:115},end:{line:30,column:120}}],line:30},'1':{loc:{start:{line:30,column:29},end:{line:30,column:105}},type:'binary-expr',locations:[{start:{line:30,column:30},end:{line:30,column:55}},{start:{line:30,column:59},end:{line:30,column:82}},{start:{line:30,column:87},end:{line:30,column:105}}],line:30},'2':{loc:{start:{line:31,column:24},end:{line:31,column:58}},type:'cond-expr',locations:[{start:{line:31,column:46},end:{line:31,column:50}},{start:{line:31,column:53},end:{line:31,column:58}}],line:31},'3':{loc:{start:{line:34,column:15},end:{line:34,column:127}},type:'cond-expr',locations:[{start:{line:34,column:41},end:{line:34,column:119}},{start:{line:34,column:123},end:{line:34,column:127}}],line:34}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},b:{'0':[0,0],'1':[0,0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=function(_ref){_inherits(Select,_ref);function Select(props){_classCallCheck(this,Select);cov_1cwhxb7tsq.f[0]++;cov_1cwhxb7tsq.s[0]++;var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));_this.focusHandler=function(){cov_1cwhxb7tsq.f[1]++;cov_1cwhxb7tsq.s[2]++;_this.setState({focused:true});};_this.changedHandler=function(event){cov_1cwhxb7tsq.f[2]++;cov_1cwhxb7tsq.s[3]++;_this.props.changed(event,_this.props.identifier);cov_1cwhxb7tsq.s[4]++;__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(_this).blur();};_this.blurHandler=function(event){cov_1cwhxb7tsq.f[3]++;cov_1cwhxb7tsq.s[5]++;_this.setState({focused:false});};cov_1cwhxb7tsq.s[1]++;_this.state={focused:false};return _this;}_createClass(Select,[{key:'render',value:function render(){cov_1cwhxb7tsq.f[4]++;cov_1cwhxb7tsq.s[6]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:__WEBPACK_IMPORTED_MODULE_4__Select_scss___default.a.defaultSelect,onChange:this.changedHandler,placeholder:this.props.placeholder,value:this.props.value,'data-hasvalue':(cov_1cwhxb7tsq.b[1][0]++,this.props.value!==null)&&(cov_1cwhxb7tsq.b[1][1]++,this.props.value!=="")||(cov_1cwhxb7tsq.b[1][2]++,this.state.focused)?(cov_1cwhxb7tsq.b[0][0]++,true):(cov_1cwhxb7tsq.b[0][1]++,false),disabled:this.props.disabled?(cov_1cwhxb7tsq.b[2][0]++,true):(cov_1cwhxb7tsq.b[2][1]++,false),onFocus:this.focusHandler,onBlur:this.blurHandler},!this.props.isRequired?(cov_1cwhxb7tsq.b[3][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},this.props.translate('global.form.select.default'))):(cov_1cwhxb7tsq.b[3][1]++,null),this.props.options.map(function(option,index){cov_1cwhxb7tsq.f[5]++;cov_1cwhxb7tsq.s[7]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index,value:option.value},option.name);}));}}]);return Select;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1cwhxb7tsq.s[8]++;var mapStateToProps=function mapStateToProps(state){cov_1cwhxb7tsq.f[6]++;cov_1cwhxb7tsq.s[9]++;return{translate:Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* getTranslate */])(state.locale)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Select));

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"defaultSelect":"Select__defaultSelect___3yBtZ"};

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spacer_scss__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spacer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Spacer_scss__);
var cov_ttl674ku8=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Spacer\\index.js',hash='342175eb8a11af4e63a55fb45054d72fda36a66c',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Spacer\\index.js',statementMap:{'0':{start:{line:5,column:15},end:{line:13,column:1}},'1':{start:{line:6,column:2},end:{line:12,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:15},end:{line:5,column:16}},loc:{start:{line:5,column:26},end:{line:13,column:1}},line:5}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_ttl674ku8.s[0]++;var Spacer=function Spacer(props){cov_ttl674ku8.f[0]++;cov_ttl674ku8.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__Spacer_scss___default.a.spacer,style:{height:props.height}});};/* harmony default export */ __webpack_exports__["default"] = (Spacer);

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spacer":"Spacer__spacer___212HK"};

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_scss__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Spinner_scss__);
var cov_2o4fzlog0s=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Spinner\\index.js',hash='a7434e6524e0c1873cb535cf034f91f2e805c093',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Spinner\\index.js',statementMap:{'0':{start:{line:7,column:16},end:{line:18,column:1}},'1':{start:{line:8,column:18},end:{line:8,column:29}},'2':{start:{line:9,column:1},end:{line:11,column:2}},'3':{start:{line:10,column:2},end:{line:10,column:48}},'4':{start:{line:12,column:2},end:{line:17,column:3}},'5':{start:{line:20,column:24},end:{line:24,column:1}},'6':{start:{line:21,column:4},end:{line:23,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:16},end:{line:7,column:17}},loc:{start:{line:7,column:27},end:{line:18,column:1}},line:7},'1':{name:'(anonymous_1)',decl:{start:{line:20,column:24},end:{line:20,column:25}},loc:{start:{line:20,column:33},end:{line:24,column:1}},line:20}},branchMap:{'0':{loc:{start:{line:9,column:1},end:{line:11,column:2}},type:'if',locations:[{start:{line:9,column:1},end:{line:11,column:2}},{start:{line:9,column:1},end:{line:11,column:2}}],line:9},'1':{loc:{start:{line:15,column:34},end:{line:15,column:127}},type:'cond-expr',locations:[{start:{line:15,column:78},end:{line:15,column:111}},{start:{line:15,column:114},end:{line:15,column:127}}],line:15}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},f:{'0':0,'1':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2o4fzlog0s.s[0]++;var Spinner=function Spinner(props){cov_2o4fzlog0s.f[0]++;var classNames=(cov_2o4fzlog0s.s[1]++,__WEBPACK_IMPORTED_MODULE_3__Spinner_scss___default.a.text);cov_2o4fzlog0s.s[2]++;if(props.theme==='light'){cov_2o4fzlog0s.b[0][0]++;cov_2o4fzlog0s.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Spinner_scss___default.a.isLight;}else{cov_2o4fzlog0s.b[0][1]++;}cov_2o4fzlog0s.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Spinner_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Spinner_scss___default.a.ldsRing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},props.translate('global.loading')!=='-'?(cov_2o4fzlog0s.b[1][0]++,props.translate('global.loading')):(cov_2o4fzlog0s.b[1][1]++,'Please wait')));};cov_2o4fzlog0s.s[5]++;var mapStateToProps=function mapStateToProps(state){cov_2o4fzlog0s.f[1]++;cov_2o4fzlog0s.s[6]++;return{translate:Object(__WEBPACK_IMPORTED_MODULE_2_react_localize_redux__["d" /* getTranslate */])(state.locale)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Spinner));

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Spinner__wrapper___2hsB2","text":"Spinner__text___3Xkn5","isLight":"Spinner__isLight____K5Vs","ldsRing":"Spinner__ldsRing___2TaoS","lds-ring":"Spinner__lds-ring___3debS"};

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Text_scss__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Text_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Text_scss__);
var cov_nhz91e0hu=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Text\\index.js',hash='729d197f9fa00141b5dd7bdb4214639871c5edb6',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Text\\index.js',statementMap:{'0':{start:{line:7,column:13},end:{line:43,column:1}},'1':{start:{line:8,column:20},end:{line:8,column:22}},'2':{start:{line:9,column:18},end:{line:9,column:29}},'3':{start:{line:10,column:1},end:{line:12,column:2}},'4':{start:{line:11,column:2},end:{line:11,column:48}},'5':{start:{line:13,column:1},end:{line:15,column:2}},'6':{start:{line:14,column:2},end:{line:14,column:49}},'7':{start:{line:16,column:1},end:{line:18,column:2}},'8':{start:{line:17,column:2},end:{line:17,column:53}},'9':{start:{line:20,column:1},end:{line:22,column:2}},'10':{start:{line:21,column:2},end:{line:21,column:48}},'11':{start:{line:24,column:1},end:{line:26,column:2}},'12':{start:{line:25,column:2},end:{line:25,column:49}},'13':{start:{line:28,column:1},end:{line:30,column:2}},'14':{start:{line:29,column:2},end:{line:29,column:48}},'15':{start:{line:32,column:1},end:{line:34,column:2}},'16':{start:{line:33,column:2},end:{line:33,column:38}},'17':{start:{line:36,column:3},end:{line:42,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:13},end:{line:7,column:14}},loc:{start:{line:7,column:24},end:{line:43,column:1}},line:7}},branchMap:{'0':{loc:{start:{line:10,column:1},end:{line:12,column:2}},type:'if',locations:[{start:{line:10,column:1},end:{line:12,column:2}},{start:{line:10,column:1},end:{line:12,column:2}}],line:10},'1':{loc:{start:{line:13,column:1},end:{line:15,column:2}},type:'if',locations:[{start:{line:13,column:1},end:{line:15,column:2}},{start:{line:13,column:1},end:{line:15,column:2}}],line:13},'2':{loc:{start:{line:16,column:1},end:{line:18,column:2}},type:'if',locations:[{start:{line:16,column:1},end:{line:18,column:2}},{start:{line:16,column:1},end:{line:18,column:2}}],line:16},'3':{loc:{start:{line:20,column:1},end:{line:22,column:2}},type:'if',locations:[{start:{line:20,column:1},end:{line:22,column:2}},{start:{line:20,column:1},end:{line:22,column:2}}],line:20},'4':{loc:{start:{line:24,column:1},end:{line:26,column:2}},type:'if',locations:[{start:{line:24,column:1},end:{line:26,column:2}},{start:{line:24,column:1},end:{line:26,column:2}}],line:24},'5':{loc:{start:{line:28,column:1},end:{line:30,column:2}},type:'if',locations:[{start:{line:28,column:1},end:{line:30,column:2}},{start:{line:28,column:1},end:{line:30,column:2}}],line:28},'6':{loc:{start:{line:32,column:1},end:{line:34,column:2}},type:'if',locations:[{start:{line:32,column:1},end:{line:34,column:2}},{start:{line:32,column:1},end:{line:34,column:2}}],line:32}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_nhz91e0hu.s[0]++;var Text=function Text(props){cov_nhz91e0hu.f[0]++;var customStyles=(cov_nhz91e0hu.s[1]++,{});var classNames=(cov_nhz91e0hu.s[2]++,__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.Text);cov_nhz91e0hu.s[3]++;if(props.align==='right'){cov_nhz91e0hu.b[0][0]++;cov_nhz91e0hu.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isRight;}else{cov_nhz91e0hu.b[0][1]++;}cov_nhz91e0hu.s[5]++;if(props.align==='center'){cov_nhz91e0hu.b[1][0]++;cov_nhz91e0hu.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isCenter;}else{cov_nhz91e0hu.b[1][1]++;}cov_nhz91e0hu.s[7]++;if(props.type==='afterInput'){cov_nhz91e0hu.b[2][0]++;cov_nhz91e0hu.s[8]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isAfterInput;}else{cov_nhz91e0hu.b[2][1]++;}cov_nhz91e0hu.s[9]++;if(props.size==='small'){cov_nhz91e0hu.b[3][0]++;cov_nhz91e0hu.s[10]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isSmall;}else{cov_nhz91e0hu.b[3][1]++;}cov_nhz91e0hu.s[11]++;if(props.size==='middle'){cov_nhz91e0hu.b[4][0]++;cov_nhz91e0hu.s[12]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isMiddle;}else{cov_nhz91e0hu.b[4][1]++;}cov_nhz91e0hu.s[13]++;if(props.fontCut==='light'){cov_nhz91e0hu.b[5][0]++;cov_nhz91e0hu.s[14]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Text_scss___default.a.isLight;}else{cov_nhz91e0hu.b[5][1]++;}cov_nhz91e0hu.s[15]++;if(props.color){cov_nhz91e0hu.b[6][0]++;cov_nhz91e0hu.s[16]++;customStyles={color:props.color};}else{cov_nhz91e0hu.b[6][1]++;}cov_nhz91e0hu.s[17]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames,style:customStyles},props.children);};/* harmony default export */ __webpack_exports__["default"] = (Text);

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Text":"Text__Text___hOWmZ","isRight":"Text__isRight___1Off0","isCenter":"Text__isCenter___1xA12","isLight":"Text__isLight___2Rkui","isAfterInput":"Text__isAfterInput___xFSJG","isSmall":"Text__isSmall___3P53u","isMiddle":"Text__isMiddle___2lAgV"};

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle_button__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggle_scss__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Toggle_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Toggle_scss__);
var cov_oipgj0vcr=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Toggle\\index.js',hash='bebfa9518c6f2183a1ebe5e8fcefa84664f017fa',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\Toggle\\index.js',statementMap:{'0':{start:{line:6,column:16},end:{line:6,column:41}},'1':{start:{line:7,column:16},end:{line:7,column:54}},'2':{start:{line:11,column:21},end:{line:11,column:34}},'3':{start:{line:13,column:4},end:{line:15,column:5}},'4':{start:{line:14,column:6},end:{line:14,column:56}},'5':{start:{line:17,column:4},end:{line:19,column:5}},'6':{start:{line:18,column:6},end:{line:18,column:51}},'7':{start:{line:20,column:4},end:{line:48,column:5}},'8':{start:{line:45,column:31},end:{line:45,column:80}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:2},end:{line:10,column:3}},loc:{start:{line:10,column:11},end:{line:49,column:3}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:45,column:20},end:{line:45,column:21}},loc:{start:{line:45,column:31},end:{line:45,column:80}},line:45}},branchMap:{'0':{loc:{start:{line:13,column:4},end:{line:15,column:5}},type:'if',locations:[{start:{line:13,column:4},end:{line:15,column:5}},{start:{line:13,column:4},end:{line:15,column:5}}],line:13},'1':{loc:{start:{line:17,column:4},end:{line:19,column:5}},type:'if',locations:[{start:{line:17,column:4},end:{line:19,column:5}},{start:{line:17,column:4},end:{line:19,column:5}}],line:17}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},f:{'0':0,'1':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var trStyle=(cov_oipgj0vcr.s[0]++,{height:25,width:48});var thStyle=(cov_oipgj0vcr.s[1]++,{height:21,width:21,boxShadow:0});var Toggle=function(_ref){_inherits(Toggle,_ref);function Toggle(){_classCallCheck(this,Toggle);return _possibleConstructorReturn(this,(Toggle.__proto__||Object.getPrototypeOf(Toggle)).apply(this,arguments));}_createClass(Toggle,[{key:'render',value:function render(){var _this2=this;cov_oipgj0vcr.f[0]++;var classNames=(cov_oipgj0vcr.s[2]++,__WEBPACK_IMPORTED_MODULE_2__Toggle_scss___default.a.toggle);cov_oipgj0vcr.s[3]++;if(this.props.multiLine){cov_oipgj0vcr.b[0][0]++;cov_oipgj0vcr.s[4]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Toggle_scss___default.a.isMultiLine;}else{cov_oipgj0vcr.b[0][1]++;}cov_oipgj0vcr.s[5]++;if(this.props.align==='left'){cov_oipgj0vcr.b[1][0]++;cov_oipgj0vcr.s[6]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Toggle_scss___default.a.isLeft;}else{cov_oipgj0vcr.b[1][1]++;}cov_oipgj0vcr.s[7]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_toggle_button___default.a,{colors:{activeThumb:{base:'#FFFFFF'},inactiveThumb:{base:'#FFFFFF'},active:{base:'#60C325',hover:'#71bf42'},inactive:{base:'#D8D8D8',hover:'#cacaca'}},trackStyle:trStyle,thumbStyle:thStyle,inactiveLabel:'',activeLabel:'',thumbAnimateRange:[3,25],value:this.props.value,onToggle:function onToggle(value){cov_oipgj0vcr.f[1]++;cov_oipgj0vcr.s[8]++;return _this2.props.changed(!value,_this2.props.identifier);}}));}}]);return Toggle;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (Toggle);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-toggle-button"]=t(require("react")):e["react-toggle-button"]=t(e.React)}(this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={exports:{},id:r,loaded:!1};return e[r].call(a.exports,a,a.exports,t),a.loaded=!0,a.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){e.exports=n(12)},function(e,t,n){e.exports=n(17)()},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]="number"==typeof e[n]?e[n]:e[n].val);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(t,n){t.exports=e},function(e,t,n){(function(t){(function(){var n,r,a;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-a)/1e6},r=t.hrtime,n=function(){var e;return e=r(),1e9*e[0]+e[1]},a=n()):Date.now?(e.exports=function(){return Date.now()-a},a=Date.now()):(e.exports=function(){return(new Date).getTime()-a},a=(new Date).getTime())}).call(this)}).call(t,n(9))},function(e,t,n){(function(t){for(var r=n(19),a="undefined"==typeof window?t:window,o=["moz","webkit"],i="AnimationFrame",l=a["request"+i],u=a["cancel"+i]||a["cancelRequest"+i],s=0;!l&&s<o.length;s++)l=a[o[s]+"Request"+i],u=a[o[s]+"Cancel"+i]||a[o[s]+"CancelRequest"+i];if(!l||!u){var c=0,f=0,p=[],d=1e3/60;l=function(e){if(0===p.length){var t=r(),n=Math.max(0,d-(t-c));c=n+t,setTimeout(function(){var e=p.slice(0);p.length=0;for(var t=0;t<e.length;t++)if(!e[t].cancelled)try{e[t].callback(c)}catch(e){setTimeout(function(){throw e},0)}},Math.round(n))}return p.push({handle:++f,callback:e,cancelled:!1}),f},u=function(e){for(var t=0;t<p.length;t++)p[t].handle===e&&(p[t].cancelled=!0)}}e.exports=function(e){return l.call(a,e)},e.exports.cancel=function(){u.apply(a,arguments)},e.exports.polyfill=function(e){e||(e=a),e.requestAnimationFrame=l,e.cancelAnimationFrame=u}}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=0);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var r in t)if(Object.prototype.hasOwnProperty.call(t,r)){if(0!==n[r])return!1;var a="number"==typeof t[r]?t[r]:t[r].val;if(e[r]!==a)return!1}return!0}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n,a,o,i,l){var u=-o*(t-a),s=-i*n,c=u+s,f=n+c*e,p=t+f*e;return Math.abs(f)<l&&Math.abs(p-a)<l?(r[0]=a,r[1]=0,r):(r[0]=p,r[1]=f,r)}t.__esModule=!0,t.default=n;var r=[0,0];e.exports=t.default},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function a(e){if(c===setTimeout)return setTimeout(e,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(e,0);try{return c(e,0)}catch(t){try{return c.call(null,e,0)}catch(t){return c.call(this,e,0)}}}function o(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function i(){h&&d&&(h=!1,d.length?y=d.concat(y):m=-1,y.length&&l())}function l(){if(!h){var e=a(i);h=!0;for(var t=y.length;t;){for(d=y,y=[];++m<t;)d&&d[m].run();m=-1,t=y.length}d=null,h=!1,o(e)}}function u(e,t){this.fun=e,this.array=t}function s(){}var c,f,p=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(e){c=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var d,y=[],h=!1,m=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];y.push(new u(e,t)),1!==y.length||h||a(l)},u.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=s,p.addListener=s,p.once=s,p.off=s,p.removeListener=s,p.removeAllListeners=s,p.emit=s,p.prependListener=s,p.prependOnceListener=s,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";t.__esModule=!0,t.default={noWobble:{stiffness:170,damping:26},gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}},e.exports=t.default},function(e,t){"use strict";function n(e){var t=e;if(l[t])return l[t];t=t.replace("#",""),3===t.length&&(t=t[0]+t[0]+t[1]+t[1]+t[2]+t[2]);var n=t.match(/.{2}/g),r={r:parseInt(n[0],16),g:parseInt(n[1],16),b:parseInt(n[2],16)};return l[t]=r,r}function r(e){var t=e.indexOf("rgb")!=-1,n=e.indexOf("rgba")!=-1,r=e.match(/\d+/g);if(t&&!n)return{r:parseInt(r[0]),g:parseInt(r[1]),b:parseInt(r[2])};if(t&&n){var a="0"==r[3]?"0."+r[4]:r[3];return{r:parseInt(r[0]),g:parseInt(r[1]),b:parseInt(r[2]),a:parseFloat(a)}}return null}function a(e,t,n){var r=e.toString(16),a=t.toString(16),o=n.toString(16);return r=r.length<2?"0"+r:r,a=a.length<2?"0"+a:a,o=o.length<2?"0"+o:o,"#"+r+a+o}function o(e,t,n,r,a){var o=n-t,i=a-r,l=(e-t)/o;return r+l*i}function i(e,t,n,a,i,l){var u=void 0===a?0:a,s=void 0===i?1:i,c=r(t),f=r(n),p=Math.floor(o(e,u,s,c.r,f.r)),d=Math.floor(o(e,u,s,c.g,f.g)),y=Math.floor(o(e,u,s,c.b,f.b)),h=!1,m=null;return c.a&&f.a&&(h=!0,m=o(e,u,s,c.a,f.a)),m?"rgb("+p+","+d+","+y+","+m+")":"rgb("+p+","+d+","+y+")"}Object.defineProperty(t,"__esModule",{value:!0}),t.hexToRGB=n,t.rgbToObj=r,t.rgbToHex=a,t.mapValueInRange=o,t.interpolateColor=i;var l={}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var a=n(13),o=r(a);e.exports=o.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(3),c=r(s),f=n(24),p=n(1),d=r(p),y=n(14),h=n(11),m={active:{base:"rgb(1,124,66)",hover:"rgb(1,124,66)"},inactive:{base:"rgb(65,66,68)",hover:"rgb(65,66,68)"},activeThumb:{base:"rgb(250,250,250)",hover:"rgb(250,250,250)"},inactiveThumb:{base:"rgb(250,250,250)",hover:"rgb(250,250,250)"}},v={},b=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={isHover:!1},n}return i(t,e),u(t,[{key:"onMouseOver",value:function(){this.setState({isHover:!0})}},{key:"onMouseOut",value:function(){this.setState({isHover:!1})}},{key:"_convertToRgb",value:function(e,t){if(e.indexOf("#")!=-1){var n=(0,h.hexToRGB)(e);return"rgb("+n.r+", "+n.g+", "+n.b+")"}return e.indexOf("rgb")==-1?t:e}},{key:"checkAllColors",value:function(e){var t=this;return Object.keys(e).forEach(function(n){t.checkColors(e,n)}),e}},{key:"checkColors",value:function(e,t){e[t]?e[t].hover?(e[t].base=this._convertToRgb(e[t].base,m[t].base),e[t].hover=this._convertToRgb(e[t].hover,m[t].hover)):e[t].base?(e[t].base=this._convertToRgb(e[t].base,m[t].base),e[t].hover=e[t].base):(console.warn('Color prop should have a "base" style and a "hover" style!'),e[t]=m[t]):e[t]=m[t]}},{key:"interpolateColorWithHover",value:function(e,t,n){var r=this.props.colors;return this.checkColors(r,t),this.checkColors(r,n),this.state.isHover?{backgroundColor:(0,h.interpolateColor)(e,r[t].hover,r[n].hover,0,400)}:{backgroundColor:(0,h.interpolateColor)(e,r[t].base,r[n].base,0,400)}}},{key:"makeStyle",value:function(e,t){return this.state.isHover?l({},e,t):e}},{key:"handleClick",value:function(e){e.target!==this._input&&(e.preventDefault(),this._input.focus(),this._input.click())}},{key:"render",value:function(){var e=this,t=this.props,n=t.internalSpringSetting,r=t.internalHoverSpringSetting,a=t.value,o=t.thumbAnimateRange,i=(t.isHover,t.containerStyle),u=t.trackStyle,s=t.animateTrackStyleToggle,p=t.animateTrackStyleHover,d=t.thumbStyleHover,h=t.trackStyleHover,m=t.activeLabelStyle,v=t.activeLabelStyleHover,b=t.activeLabel,g=t.inactiveLabelStyle,S=t.inactiveLabelStyleHover,T=t.inactiveLabel,O=t.thumbStyle,k=t.animateThumbStyleHover,w=t.animateThumbStyleToggle,I=t.thumbIcon,P=t.onClick,j=t.onToggle,_=t.passThroughInputProps,x=n,M=r;return c.default.createElement(f.Motion,{style:{opacity:(0,f.spring)(a?1:0,x),left:(0,f.spring)(a?10*o[1]:10*o[0],x),colorNumber:(0,f.spring)(a?0:400,x),toggleNumber:(0,f.spring)(a?400:0,x),hoverNumber:(0,f.spring)(this.state.isHover?400:0,M)}},function(t){var n=t.opacity,r=t.left,o=t.colorNumber,f=t.hoverNumber,x=t.toggleNumber;return c.default.createElement("div",{style:l({},e.makeStyle(l({},y.reactToggle,i))),onMouseOver:e.onMouseOver.bind(e),onMouseOut:e.onMouseOut.bind(e),onClick:e.handleClick.bind(e)},c.default.createElement("div",{style:l({},e.makeStyle(l({},y.reactToggleTrack,u,e.interpolateColorWithHover(o,"active","inactive"),s(x/400)),l({},h,p(f/400))))},c.default.createElement("div",{style:l({},e.makeStyle(l({},y.reactToggleOn,m),v),{opacity:n})},b),c.default.createElement("div",{style:l({},e.makeStyle(l({},y.reactToggleOff,g),S),{opacity:1-n})},T)),c.default.createElement("div",{style:y.reactThumbCenteringContainer},c.default.createElement("div",{style:l({},e.makeStyle(l({},y.reactToggleThumb,O,e.interpolateColorWithHover(o,"activeThumb","inactiveThumb"),w(x/400)),l({},d,k(f/400))),{position:"relative",left:Math.round(r/10)})},I)),c.default.createElement("input",l({ref:function(t){e._input=t},type:"checkbox",style:y.reactToggleScreenReaderOnly,onClick:function(e){P&&P(e),j(a)},value:a},_)))})}}]),t}(s.Component);b.defaultProps={value:!1,onToggle:function(){},colors:m,passThroughInputProps:{},activeLabel:"ON",containerStyle:v,activeLabelStyle:v,activeLabelStyleHover:v,inactiveLabel:"OFF",inactiveLabelStyle:v,inactiveLabelStyleHover:v,thumbStyle:v,thumbStyleHover:v,animateThumbStyleHover:function(){return{}},animateThumbStyleToggle:function(){return{}},trackStyle:v,trackStyleHover:v,animateTrackStyleHover:function(){return{}},animateTrackStyleToggle:function(){return{}},thumbAnimateRange:[1,33],internalSpringSetting:{stiffness:180,damping:22},internalHoverSpringSetting:{stiffness:180,damping:20}},b.displayName="Toggle",t.default=b,b.propTypes={value:d.default.bool.isRequired,onToggle:d.default.func.isRequired,passThroughInputProps:d.default.object,onClick:d.default.func,colors:d.default.object,activeLabel:d.default.oneOfType([d.default.string,d.default.object]),containerStyle:d.default.object,activeLabelStyle:d.default.object,activeLabelStyleHover:d.default.object,activeThumbStyle:d.default.object,activeThumbStyleHover:d.default.object,inactiveLabel:d.default.oneOfType([d.default.string,d.default.object]),inactiveLabelStyle:d.default.object,inactiveLabelStyleHover:d.default.object,thumbStyle:d.default.object,thumbStyleHover:d.default.object,trackStyle:d.default.object,trackStyleHover:d.default.object,animateThumbStyleHover:d.default.func,animateTrackStyleHover:d.default.func,animateTrackStyleToggle:d.default.func,animateThumbStyleToggle:d.default.func,internalSpringSetting:d.default.object,internalHoverSpringSetting:d.default.object,thumbIcon:d.default.oneOfType([d.default.string,d.default.object]),thumbAnimateRange:d.default.array}},function(e,t){"use strict";function n(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0});var r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},a=(t.reactToggle=n({display:"flex",width:52,alignItems:"center",justifyContent:"flex-start",position:"relative",cursor:"pointer",backgroundColor:"transparent",border:0,padding:0,WebkitTouchCallout:"none",WebkitUserSelect:"none",KhtmlUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none",WebkitTapHighlightColor:"rgba(0,0,0,0)"},"WebkitTapHighlightColor","transparent"),{fontSize:11,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Helvetica Neue', Helvetica, sans-serif"});t.reactToggleScreenReaderOnly={border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1},t.reactToggleTrack={width:"52px",height:"20px",padding:0,borderRadius:"26px",display:"flex",alignItems:"center",justifyContent:"center"},t.reactToggleOn=r({},a,{position:"relative",color:"#FAFAFA",marginTop:"auto",marginBottom:"auto",lineHeight:0,opacity:0,width:26,height:20,left:4}),t.reactToggleOff=r({},a,{position:"relative",color:"rgba(255,255,255,0.6)",bottom:"0px",marginTop:"auto",marginBottom:"auto",paddingRight:5,lineHeight:0,width:26,height:20}),t.reactToggleThumb={width:"18px",height:"18px",display:"flex",alignSelf:"center",boxShadow:"0 0 0 1px rgba(0,0,0,0.3)",borderRadius:"50%",WebkitBoxSizing:"border-box",MozBoxSizing:"border-box",boxSizing:"border-box"},t.reactThumbCenteringContainer={position:"absolute",height:"100%",top:0,left:0,display:"flex",flex:1,alignSelf:"stretch",alignItems:"center",justifyContent:"flex-start"}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,o,i,l,u){if(a(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,o,i,l,u],f=0;s=new Error(t.replace(/%s/g,function(){return c[f++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var a=function(e){};e.exports=r},function(e,t,n){"use strict";var r=n(15),a=n(16),o=n(18);e.exports=function(){function e(e,t,n,r,i,l){l!==o&&a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){(function(){var n,r,a,o,i,l;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-i)/1e6},r=t.hrtime,n=function(){var e;return e=r(),1e9*e[0]+e[1]},o=n(),l=1e9*t.uptime(),i=o-l):Date.now?(e.exports=function(){return Date.now()-a},a=Date.now()):(e.exports=function(){return(new Date).getTime()-a},a=(new Date).getTime())}).call(this)}).call(t,n(9))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(6),s=r(u),c=n(2),f=r(c),p=n(8),d=r(p),y=n(4),h=r(y),m=n(5),v=r(m),b=n(7),g=r(b),S=n(3),T=r(S),O=n(1),k=r(O),w=1e3/60,I=function(e){function t(n){var r=this;a(this,t),e.call(this,n),this.wasAnimating=!1,this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyle=null,this.clearUnreadPropStyle=function(e){var t=!1,n=r.state,a=n.currentStyle,o=n.currentVelocity,l=n.lastIdealStyle,u=n.lastIdealVelocity;for(var s in e)if(Object.prototype.hasOwnProperty.call(e,s)){var c=e[s];"number"==typeof c&&(t||(t=!0,a=i({},a),o=i({},o),l=i({},l),u=i({},u)),a[s]=c,o[s]=0,l[s]=c,u[s]=0)}t&&r.setState({currentStyle:a,currentVelocity:o,lastIdealStyle:l,lastIdealVelocity:u})},this.startAnimationIfNecessary=function(){r.animationID=v.default(function(e){var t=r.props.style;if(g.default(r.state.currentStyle,t,r.state.currentVelocity))return r.wasAnimating&&r.props.onRest&&r.props.onRest(),r.animationID=null,r.wasAnimating=!1,void(r.accumulatedTime=0);r.wasAnimating=!0;var n=e||h.default(),a=n-r.prevTime;if(r.prevTime=n,r.accumulatedTime=r.accumulatedTime+a,r.accumulatedTime>10*w&&(r.accumulatedTime=0),0===r.accumulatedTime)return r.animationID=null,void r.startAnimationIfNecessary();var o=(r.accumulatedTime-Math.floor(r.accumulatedTime/w)*w)/w,i=Math.floor(r.accumulatedTime/w),l={},u={},s={},c={};for(var f in t)if(Object.prototype.hasOwnProperty.call(t,f)){var p=t[f];if("number"==typeof p)s[f]=p,c[f]=0,l[f]=p,u[f]=0;else{for(var y=r.state.lastIdealStyle[f],m=r.state.lastIdealVelocity[f],v=0;v<i;v++){var b=d.default(w/1e3,y,m,p.val,p.stiffness,p.damping,p.precision);y=b[0],m=b[1]}var S=d.default(w/1e3,y,m,p.val,p.stiffness,p.damping,p.precision),T=S[0],O=S[1];s[f]=y+(T-y)*o,c[f]=m+(O-m)*o,l[f]=y,u[f]=m}}r.animationID=null,r.accumulatedTime-=i*w,r.setState({currentStyle:s,currentVelocity:c,lastIdealStyle:l,lastIdealVelocity:u}),r.unreadPropStyle=null,r.startAnimationIfNecessary()})},this.state=this.defaultState()}return o(t,e),l(t,null,[{key:"propTypes",value:{defaultStyle:k.default.objectOf(k.default.number),style:k.default.objectOf(k.default.oneOfType([k.default.number,k.default.object])).isRequired,children:k.default.func.isRequired,onRest:k.default.func},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyle,n=e.style,r=t||f.default(n),a=s.default(r);return{currentStyle:r,currentVelocity:a,lastIdealStyle:r,lastIdealVelocity:a}},t.prototype.componentDidMount=function(){this.prevTime=h.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){null!=this.unreadPropStyle&&this.clearUnreadPropStyle(this.unreadPropStyle),this.unreadPropStyle=e.style,null==this.animationID&&(this.prevTime=h.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){null!=this.animationID&&(v.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=this.props.children(this.state.currentStyle);return e&&T.default.Children.only(e)},t}(T.default.Component);t.default=I,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function i(e,t,n){for(var r=0;r<e.length;r++)if(!S.default(e[r],t[r],n[r]))return!1;return!0}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),s=n(6),c=r(s),f=n(2),p=r(f),d=n(8),y=r(d),h=n(4),m=r(h),v=n(5),b=r(v),g=n(7),S=r(g),T=n(3),O=r(T),k=n(1),w=r(k),I=1e3/60,P=function(e){function t(n){var r=this;a(this,t),e.call(this,n),this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyles=null,this.clearUnreadPropStyle=function(e){for(var t=r.state,n=t.currentStyles,a=t.currentVelocities,o=t.lastIdealStyles,i=t.lastIdealVelocities,u=!1,s=0;s<e.length;s++){var c=e[s],f=!1;for(var p in c)if(Object.prototype.hasOwnProperty.call(c,p)){var d=c[p];"number"==typeof d&&(f||(f=!0,u=!0,n[s]=l({},n[s]),a[s]=l({},a[s]),o[s]=l({},o[s]),i[s]=l({},i[s])),n[s][p]=d,a[s][p]=0,o[s][p]=d,i[s][p]=0)}}u&&r.setState({currentStyles:n,currentVelocities:a,lastIdealStyles:o,lastIdealVelocities:i})},this.startAnimationIfNecessary=function(){r.animationID=b.default(function(e){var t=r.props.styles(r.state.lastIdealStyles);if(i(r.state.currentStyles,t,r.state.currentVelocities))return r.animationID=null,void(r.accumulatedTime=0);var n=e||m.default(),a=n-r.prevTime;if(r.prevTime=n,r.accumulatedTime=r.accumulatedTime+a,r.accumulatedTime>10*I&&(r.accumulatedTime=0),0===r.accumulatedTime)return r.animationID=null,void r.startAnimationIfNecessary();for(var o=(r.accumulatedTime-Math.floor(r.accumulatedTime/I)*I)/I,l=Math.floor(r.accumulatedTime/I),u=[],s=[],c=[],f=[],p=0;p<t.length;p++){var d=t[p],h={},v={},b={},g={};for(var S in d)if(Object.prototype.hasOwnProperty.call(d,S)){var T=d[S];if("number"==typeof T)h[S]=T,v[S]=0,b[S]=T,g[S]=0;else{for(var O=r.state.lastIdealStyles[p][S],k=r.state.lastIdealVelocities[p][S],w=0;w<l;w++){var P=y.default(I/1e3,O,k,T.val,T.stiffness,T.damping,T.precision);O=P[0],k=P[1]}var j=y.default(I/1e3,O,k,T.val,T.stiffness,T.damping,T.precision),_=j[0],x=j[1];h[S]=O+(_-O)*o,v[S]=k+(x-k)*o,b[S]=O,g[S]=k}}c[p]=h,f[p]=v,u[p]=b,s[p]=g}r.animationID=null,r.accumulatedTime-=l*I,r.setState({currentStyles:c,currentVelocities:f,lastIdealStyles:u,lastIdealVelocities:s}),r.unreadPropStyles=null,r.startAnimationIfNecessary()})},this.state=this.defaultState()}return o(t,e),u(t,null,[{key:"propTypes",value:{defaultStyles:w.default.arrayOf(w.default.objectOf(w.default.number)),styles:w.default.func.isRequired,children:w.default.func.isRequired},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyles,n=e.styles,r=t||n().map(p.default),a=r.map(function(e){return c.default(e)});return{currentStyles:r,currentVelocities:a,lastIdealStyles:r,lastIdealVelocities:a}},t.prototype.componentDidMount=function(){this.prevTime=m.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){null!=this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles),this.unreadPropStyles=e.styles(this.state.lastIdealStyles),null==this.animationID&&(this.prevTime=m.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){null!=this.animationID&&(b.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=this.props.children(this.state.currentStyles);return e&&O.default.Children.only(e)},t}(O.default.Component);t.default=P,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function i(e,t,n){var r=t;return null==r?e.map(function(e,t){return{key:e.key,data:e.data,style:n[t]}}):e.map(function(e,t){for(var a=0;a<r.length;a++)if(r[a].key===e.key)return{key:r[a].key,data:r[a].data,style:n[t]};return{key:e.key,data:e.data,style:n[t]}})}function l(e,t,n,r){if(r.length!==t.length)return!1;for(var a=0;a<r.length;a++)if(r[a].key!==t[a].key)return!1;for(var a=0;a<r.length;a++)if(!w.default(e[a],t[a].style,n[a]))return!1;return!0}function u(e,t,n,r,a,o,i,l,u){for(var s=b.default(r,a,function(e,r){var a=t(r);return null==a?(n({key:r.key,data:r.data}),null):w.default(o[e],a,i[e])?(n({key:r.key,data:r.data}),null):{key:r.key,data:r.data,style:a}}),c=[],f=[],d=[],y=[],h=0;h<s.length;h++){for(var m=s[h],v=null,g=0;g<r.length;g++)if(r[g].key===m.key){v=g;break}if(null==v){var S=e(m);c[h]=S,d[h]=S;var T=p.default(m.style);f[h]=T,y[h]=T}else c[h]=o[v],d[h]=l[v],f[h]=i[v],y[h]=u[v]}return[s,c,f,d,y]}t.__esModule=!0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(6),p=r(f),d=n(2),y=r(d),h=n(8),m=r(h),v=n(23),b=r(v),g=n(4),S=r(g),T=n(5),O=r(T),k=n(7),w=r(k),I=n(3),P=r(I),j=n(1),_=r(j),x=1e3/60,M=function(e){function t(n){var r=this;a(this,t),e.call(this,n),this.unmounting=!1,this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyles=null,this.clearUnreadPropStyle=function(e){for(var t=u(r.props.willEnter,r.props.willLeave,r.props.didLeave,r.state.mergedPropsStyles,e,r.state.currentStyles,r.state.currentVelocities,r.state.lastIdealStyles,r.state.lastIdealVelocities),n=t[0],a=t[1],o=t[2],i=t[3],l=t[4],c=0;c<e.length;c++){var f=e[c].style,p=!1;for(var d in f)if(Object.prototype.hasOwnProperty.call(f,d)){var y=f[d];"number"==typeof y&&(p||(p=!0,a[c]=s({},a[c]),o[c]=s({},o[c]),i[c]=s({},i[c]),l[c]=s({},l[c]),n[c]={key:n[c].key,data:n[c].data,style:s({},n[c].style)}),a[c][d]=y,o[c][d]=0,i[c][d]=y,l[c][d]=0,n[c].style[d]=y)}}r.setState({currentStyles:a,currentVelocities:o,mergedPropsStyles:n,lastIdealStyles:i,lastIdealVelocities:l})},this.startAnimationIfNecessary=function(){r.unmounting||(r.animationID=O.default(function(e){if(!r.unmounting){var t=r.props.styles,n="function"==typeof t?t(i(r.state.mergedPropsStyles,r.unreadPropStyles,r.state.lastIdealStyles)):t;if(l(r.state.currentStyles,n,r.state.currentVelocities,r.state.mergedPropsStyles))return r.animationID=null,void(r.accumulatedTime=0);var a=e||S.default(),o=a-r.prevTime;if(r.prevTime=a,r.accumulatedTime=r.accumulatedTime+o,r.accumulatedTime>10*x&&(r.accumulatedTime=0),0===r.accumulatedTime)return r.animationID=null,void r.startAnimationIfNecessary();for(var s=(r.accumulatedTime-Math.floor(r.accumulatedTime/x)*x)/x,c=Math.floor(r.accumulatedTime/x),f=u(r.props.willEnter,r.props.willLeave,r.props.didLeave,r.state.mergedPropsStyles,n,r.state.currentStyles,r.state.currentVelocities,r.state.lastIdealStyles,r.state.lastIdealVelocities),p=f[0],d=f[1],y=f[2],h=f[3],v=f[4],b=0;b<p.length;b++){var g=p[b].style,T={},O={},k={},w={};for(var I in g)if(Object.prototype.hasOwnProperty.call(g,I)){var P=g[I];if("number"==typeof P)T[I]=P,O[I]=0,k[I]=P,w[I]=0;else{for(var j=h[b][I],_=v[b][I],M=0;M<c;M++){var R=m.default(x/1e3,j,_,P.val,P.stiffness,P.damping,P.precision);j=R[0],_=R[1]}var C=m.default(x/1e3,j,_,P.val,P.stiffness,P.damping,P.precision),D=C[0],H=C[1];T[I]=j+(D-j)*s,O[I]=_+(H-_)*s,k[I]=j,w[I]=_}}h[b]=k,v[b]=w,d[b]=T,y[b]=O}r.animationID=null,r.accumulatedTime-=c*x,r.setState({currentStyles:d,currentVelocities:y,lastIdealStyles:h,lastIdealVelocities:v,mergedPropsStyles:p}),r.unreadPropStyles=null,r.startAnimationIfNecessary()}}))},this.state=this.defaultState()}return o(t,e),c(t,null,[{key:"propTypes",value:{defaultStyles:_.default.arrayOf(_.default.shape({key:_.default.string.isRequired,data:_.default.any,style:_.default.objectOf(_.default.number).isRequired})),styles:_.default.oneOfType([_.default.func,_.default.arrayOf(_.default.shape({key:_.default.string.isRequired,data:_.default.any,style:_.default.objectOf(_.default.oneOfType([_.default.number,_.default.object])).isRequired}))]).isRequired,children:_.default.func.isRequired,willEnter:_.default.func,willLeave:_.default.func,didLeave:_.default.func},enumerable:!0},{key:"defaultProps",value:{willEnter:function(e){return y.default(e.style)},willLeave:function(){return null},didLeave:function(){}},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyles,n=e.styles,r=e.willEnter,a=e.willLeave,o=e.didLeave,i="function"==typeof n?n(t):n,l=void 0;l=null==t?i:t.map(function(e){for(var t=0;t<i.length;t++)if(i[t].key===e.key)return i[t];return e});var s=null==t?i.map(function(e){return y.default(e.style)}):t.map(function(e){return y.default(e.style)}),c=null==t?i.map(function(e){return p.default(e.style)}):t.map(function(e){return p.default(e.style)}),f=u(r,a,o,l,i,s,c,s,c),d=f[0],h=f[1],m=f[2],v=f[3],b=f[4];return{currentStyles:h,currentVelocities:m,lastIdealStyles:v,lastIdealVelocities:b,mergedPropsStyles:d}},t.prototype.componentDidMount=function(){this.prevTime=S.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles);var t=e.styles;"function"==typeof t?this.unreadPropStyles=t(i(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles)):this.unreadPropStyles=t,null==this.animationID&&(this.prevTime=S.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){this.unmounting=!0,null!=this.animationID&&(O.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=i(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles),t=this.props.children(e);return t&&P.default.Children.only(t)},t}(P.default.Component);t.default=M,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var r={},a=0;a<e.length;a++)r[e[a].key]=a;for(var o={},a=0;a<t.length;a++)o[t[a].key]=a;for(var i=[],a=0;a<t.length;a++)i[a]=t[a];for(var a=0;a<e.length;a++)if(!Object.prototype.hasOwnProperty.call(o,e[a].key)){var l=n(a,e[a]);null!=l&&i.push(l)}return i.sort(function(e,n){var a=o[e.key],i=o[n.key],l=r[e.key],u=r[n.key];if(null!=a&&null!=i)return o[e.key]-o[n.key];if(null!=l&&null!=u)return r[e.key]-r[n.key];if(null!=a){for(var s=0;s<t.length;s++){var c=t[s].key;if(Object.prototype.hasOwnProperty.call(r,c)){if(a<o[c]&&u>r[c])return-1;if(a>o[c]&&u<r[c])return 1}}return 1}for(var s=0;s<t.length;s++){var c=t[s].key;if(Object.prototype.hasOwnProperty.call(r,c)){if(i<o[c]&&l>r[c])return 1;if(i>o[c]&&l<r[c])return-1}}return-1})}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var a=n(20);t.Motion=r(a);var o=n(21);t.StaggeredMotion=r(o);var i=n(22);t.TransitionMotion=r(i);var l=n(26);t.spring=r(l);var u=n(10);t.presets=r(u);var s=n(2);t.stripStyle=r(s);var c=n(25);
t.reorderKeys=r(c)},function(e,t,n){"use strict";function r(){}t.__esModule=!0,t.default=r,e.exports=t.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){return o({},u,t,{val:e})}t.__esModule=!0;var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=a;var i=n(10),l=r(i),u=o({},l.default.noWobble,{precision:.01});e.exports=t.default}])});

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"toggle":"Toggle__toggle___1AQV9","isMultiLine":"Toggle__isMultiLine___fhnS8","isLeft":"Toggle__isLeft___3rGGv"};

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadButton_scss__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_newId__ = __webpack_require__(111);
var cov_q7mzwz8n4=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\UploadButton\\index.js',hash='134a1c7773b7cffef83c32556f16d3169da8dea9',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\atoms\\UploadButton\\index.js',statementMap:{'0':{start:{line:11,column:6},end:{line:11,column:24}},'1':{start:{line:14,column:20},end:{line:14,column:35}},'2':{start:{line:15,column:4},end:{line:17,column:5}},'3':{start:{line:16,column:6},end:{line:16,column:51}},'4':{start:{line:19,column:4},end:{line:21,column:5}},'5':{start:{line:20,column:6},end:{line:20,column:52}},'6':{start:{line:23,column:4},end:{line:25,column:5}},'7':{start:{line:24,column:6},end:{line:24,column:53}},'8':{start:{line:27,column:4},end:{line:29,column:5}},'9':{start:{line:28,column:6},end:{line:28,column:56}},'10':{start:{line:31,column:4},end:{line:38,column:5}},'11':{start:{line:36,column:148},end:{line:36,column:196}},'12':{start:{line:42,column:0},end:{line:45,column:1}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:2},end:{line:10,column:3}},loc:{start:{line:10,column:23},end:{line:12,column:3}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:13,column:2},end:{line:13,column:3}},loc:{start:{line:13,column:12},end:{line:39,column:3}},line:13},'2':{name:'(anonymous_2)',decl:{start:{line:36,column:137},end:{line:36,column:138}},loc:{start:{line:36,column:148},end:{line:36,column:196}},line:36}},branchMap:{'0':{loc:{start:{line:15,column:4},end:{line:17,column:5}},type:'if',locations:[{start:{line:15,column:4},end:{line:17,column:5}},{start:{line:15,column:4},end:{line:17,column:5}}],line:15},'1':{loc:{start:{line:19,column:4},end:{line:21,column:5}},type:'if',locations:[{start:{line:19,column:4},end:{line:21,column:5}},{start:{line:19,column:4},end:{line:21,column:5}}],line:19},'2':{loc:{start:{line:23,column:4},end:{line:25,column:5}},type:'if',locations:[{start:{line:23,column:4},end:{line:25,column:5}},{start:{line:23,column:4},end:{line:25,column:5}}],line:23},'3':{loc:{start:{line:27,column:4},end:{line:29,column:5}},type:'if',locations:[{start:{line:27,column:4},end:{line:29,column:5}},{start:{line:27,column:4},end:{line:29,column:5}}],line:27},'4':{loc:{start:{line:36,column:79},end:{line:36,column:123}},type:'cond-expr',locations:[{start:{line:36,column:98},end:{line:36,column:114}},{start:{line:36,column:117},end:{line:36,column:123}}],line:36}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UploadButton=function(_ref){_inherits(UploadButton,_ref);function UploadButton(){_classCallCheck(this,UploadButton);return _possibleConstructorReturn(this,(UploadButton.__proto__||Object.getPrototypeOf(UploadButton)).apply(this,arguments));}_createClass(UploadButton,[{key:'componentWillMount',value:function componentWillMount(){cov_q7mzwz8n4.f[0]++;cov_q7mzwz8n4.s[0]++;this.id=Object(__WEBPACK_IMPORTED_MODULE_4__util_newId__["a" /* default */])();}},{key:'render',value:function render(){var _this2=this;cov_q7mzwz8n4.f[1]++;var classNames=(cov_q7mzwz8n4.s[1]++,__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.a_button);cov_q7mzwz8n4.s[2]++;if(this.props.theme=='dark'){cov_q7mzwz8n4.b[0][0]++;cov_q7mzwz8n4.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.isDark;}else{cov_q7mzwz8n4.b[0][1]++;}cov_q7mzwz8n4.s[4]++;if(this.props.theme=='light'){cov_q7mzwz8n4.b[1][0]++;cov_q7mzwz8n4.s[5]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.isLight;}else{cov_q7mzwz8n4.b[1][1]++;}cov_q7mzwz8n4.s[6]++;if(this.props.nomargin){cov_q7mzwz8n4.b[2][0]++;cov_q7mzwz8n4.s[7]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.noMargin;}else{cov_q7mzwz8n4.b[2][1]++;}cov_q7mzwz8n4.s[8]++;if(this.props.multiline){cov_q7mzwz8n4.b[3][0]++;cov_q7mzwz8n4.s[9]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.isMultiline;}else{cov_q7mzwz8n4.b[3][1]++;}cov_q7mzwz8n4.s[10]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.uploadWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__UploadButton_scss___default.a.centerer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.id},this.props.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:this.id,type:'file',className:classNames,style:{width:this.props.width?(cov_q7mzwz8n4.b[4][0]++,this.props.width):(cov_q7mzwz8n4.b[4][1]++,'100%')},onChange:function onChange(event){cov_q7mzwz8n4.f[2]++;cov_q7mzwz8n4.s[11]++;return _this2.props.changed(event,_this2.props.identifier);},accept:this.props.accept}));}}]);return UploadButton;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_q7mzwz8n4.s[12]++;UploadButton.propTypes={label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,identifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["default"] = (UploadButton);

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a_button":"UploadButton__a_button___16aF4","outerMargin":"UploadButton__outerMargin___1spLv","noMargin":"UploadButton__noMargin___102jZ","noMarginMobile":"UploadButton__noMarginMobile___1e3ox","isLight":"UploadButton__isLight___1N_7S","margin":"UploadButton__margin___3RJkS","isPrimeLight":"UploadButton__isPrimeLight___3CJxg","isDark":"UploadButton__isDark___3d8Nw","isLink":"UploadButton__isLink___y-vps","isMultiline":"UploadButton__isMultiline___1Fuc8","uploadWrapper":"UploadButton__uploadWrapper___3o-EU","centerer":"UploadButton__centerer___2jOjF"};

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_scss__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Accordion_scss__);
var cov_t842plxfq=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Accordion\\index.js',hash='6a5834a30b4166f0fe1ed22ac91c3b49f94a8941',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Accordion\\index.js',statementMap:{'0':{start:{line:9,column:4},end:{line:13,column:5}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:1},end:{line:8,column:2}},loc:{start:{line:8,column:11},end:{line:14,column:3}},line:8}},branchMap:{},s:{'0':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accordion=function(_ref){_inherits(Accordion,_ref);function Accordion(){_classCallCheck(this,Accordion);return _possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).apply(this,arguments));}_createClass(Accordion,[{key:'render',value:function render(){cov_t842plxfq.f[0]++;cov_t842plxfq.s[0]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__Accordion_scss___default.a.accordion},this.props.children);}}]);return Accordion;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (Accordion);

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"accordion":"Accordion__accordion___3froJ"};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionsNav_scss__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionsNav_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ActionsNav_scss__);
var cov_8elnr7po1=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\ActionsNav\\index.js',hash='2cba7e18a0a6ec536eb52d8b331f972f3d650153',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\ActionsNav\\index.js',statementMap:{'0':{start:{line:13,column:20},end:{line:13,column:37}},'1':{start:{line:15,column:3},end:{line:17,column:4}},'2':{start:{line:16,column:4},end:{line:16,column:51}},'3':{start:{line:19,column:4},end:{line:23,column:5}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:2},end:{line:11,column:3}},loc:{start:{line:11,column:11},end:{line:24,column:3}},line:11}},branchMap:{'0':{loc:{start:{line:15,column:3},end:{line:17,column:4}},type:'if',locations:[{start:{line:15,column:3},end:{line:17,column:4}},{start:{line:15,column:3},end:{line:17,column:4}}],line:15}},s:{'0':0,'1':0,'2':0,'3':0},f:{'0':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActionsNav=function(_ref){_inherits(ActionsNav,_ref);function ActionsNav(){_classCallCheck(this,ActionsNav);return _possibleConstructorReturn(this,(ActionsNav.__proto__||Object.getPrototypeOf(ActionsNav)).apply(this,arguments));}_createClass(ActionsNav,[{key:'render',value:function render(){cov_8elnr7po1.f[0]++;var classNames=(cov_8elnr7po1.s[0]++,__WEBPACK_IMPORTED_MODULE_4__ActionsNav_scss___default.a.actionsNav);cov_8elnr7po1.s[1]++;if(this.props.inModal){cov_8elnr7po1.b[0][0]++;cov_8elnr7po1.s[2]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__ActionsNav_scss___default.a.inModal;}else{cov_8elnr7po1.b[0][1]++;}cov_8elnr7po1.s[3]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:classNames},this.props.children);}}]);return ActionsNav;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (ActionsNav);

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"actionsNav":"ActionsNav__actionsNav___1fiTq","inModal":"ActionsNav__inModal___3kAUt"};

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a_blur":"Blur__a_blur___1n_6p","isLight":"Blur__isLight___24xL4","background":"Blur__background___2YjOb"};

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CodeVerifier_scss__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CodeVerifier_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CodeVerifier_scss__);
var cov_2a8rs66tek=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\CodeVerifier\\index.js',hash='1b7dea93009d8673085c4e9b4eba8779e57fde5f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\CodeVerifier\\index.js',statementMap:{'0':{start:{line:14,column:4},end:{line:31,column:5}},'1':{start:{line:15,column:25},end:{line:15,column:66}},'2':{start:{line:16,column:3},end:{line:29,column:7}},'3':{start:{line:18,column:4},end:{line:28,column:5}},'4':{start:{line:20,column:6},end:{line:25,column:13}},'5':{start:{line:27,column:17},end:{line:27,column:47}},'6':{start:{line:38,column:8},end:{line:50,column:9}},'7':{start:{line:40,column:9},end:{line:49,column:7}},'8':{start:{line:41,column:11},end:{line:46,column:6}},'9':{start:{line:48,column:13},end:{line:48,column:43}},'10':{start:{line:55,column:14},end:{line:55,column:32}},'11':{start:{line:58,column:2},end:{line:79,column:3}},'12':{start:{line:59,column:9},end:{line:68,column:7}},'13':{start:{line:60,column:11},end:{line:65,column:6}},'14':{start:{line:67,column:13},end:{line:67,column:43}},'15':{start:{line:70,column:14},end:{line:70,column:46}},'16':{start:{line:71,column:9},end:{line:78,column:10}},'17':{start:{line:72,column:13},end:{line:73,column:23}},'18':{start:{line:73,column:17},end:{line:73,column:23}},'19':{start:{line:74,column:13},end:{line:77,column:14}},'20':{start:{line:75,column:17},end:{line:75,column:30}},'21':{start:{line:76,column:17},end:{line:76,column:23}},'22':{start:{line:84,column:4},end:{line:99,column:5}},'23':{start:{line:87,column:3},end:{line:95,column:77}},'24':{start:{line:90,column:34},end:{line:90,column:61}},'25':{start:{line:95,column:33},end:{line:95,column:72}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:12,column:13},end:{line:12,column:14}},loc:{start:{line:12,column:34},end:{line:34,column:2}},line:12},'1':{name:'(anonymous_1)',decl:{start:{line:16,column:36},end:{line:16,column:37}},loc:{start:{line:18,column:4},end:{line:28,column:5}},line:18},'2':{name:'(anonymous_2)',decl:{start:{line:19,column:5},end:{line:19,column:6}},loc:{start:{line:20,column:6},end:{line:25,column:13}},line:20},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:11},end:{line:27,column:12}},loc:{start:{line:27,column:17},end:{line:27,column:47}},line:27},'4':{name:'(anonymous_4)',decl:{start:{line:37,column:11},end:{line:37,column:12}},loc:{start:{line:37,column:26},end:{line:52,column:2}},line:37},'5':{name:'(anonymous_5)',decl:{start:{line:40,column:23},end:{line:40,column:24}},loc:{start:{line:41,column:11},end:{line:46,column:6}},line:41},'6':{name:'(anonymous_6)',decl:{start:{line:48,column:7},end:{line:48,column:8}},loc:{start:{line:48,column:13},end:{line:48,column:43}},line:48},'7':{name:'(anonymous_7)',decl:{start:{line:54,column:23},end:{line:54,column:24}},loc:{start:{line:54,column:42},end:{line:80,column:2}},line:54},'8':{name:'(anonymous_8)',decl:{start:{line:59,column:23},end:{line:59,column:24}},loc:{start:{line:60,column:11},end:{line:65,column:6}},line:60},'9':{name:'(anonymous_9)',decl:{start:{line:67,column:7},end:{line:67,column:8}},loc:{start:{line:67,column:13},end:{line:67,column:43}},line:67},'10':{name:'(anonymous_10)',decl:{start:{line:82,column:1},end:{line:82,column:2}},loc:{start:{line:82,column:10},end:{line:100,column:3}},line:82},'11':{name:'(anonymous_11)',decl:{start:{line:86,column:36},end:{line:86,column:37}},loc:{start:{line:87,column:3},end:{line:95,column:77}},line:87},'12':{name:'(anonymous_12)',decl:{start:{line:90,column:14},end:{line:90,column:15}},loc:{start:{line:90,column:33},end:{line:90,column:62}},line:90},'13':{name:'(anonymous_13)',decl:{start:{line:95,column:13},end:{line:95,column:14}},loc:{start:{line:95,column:32},end:{line:95,column:73}},line:95}},branchMap:{'0':{loc:{start:{line:14,column:4},end:{line:31,column:5}},type:'if',locations:[{start:{line:14,column:4},end:{line:31,column:5}},{start:{line:14,column:4},end:{line:31,column:5}}],line:14},'1':{loc:{start:{line:38,column:8},end:{line:50,column:9}},type:'if',locations:[{start:{line:38,column:8},end:{line:50,column:9}},{start:{line:38,column:8},end:{line:50,column:9}}],line:38},'2':{loc:{start:{line:58,column:2},end:{line:79,column:3}},type:'if',locations:[{start:{line:58,column:2},end:{line:79,column:3}},{start:{line:58,column:2},end:{line:79,column:3}}],line:58},'3':{loc:{start:{line:70,column:14},end:{line:70,column:46}},type:'binary-expr',locations:[{start:{line:70,column:14},end:{line:70,column:30}},{start:{line:70,column:34},end:{line:70,column:46}}],line:70},'4':{loc:{start:{line:72,column:13},end:{line:73,column:23}},type:'if',locations:[{start:{line:72,column:13},end:{line:73,column:23}},{start:{line:72,column:13},end:{line:73,column:23}}],line:72},'5':{loc:{start:{line:74,column:13},end:{line:77,column:14}},type:'if',locations:[{start:{line:74,column:13},end:{line:77,column:14}},{start:{line:74,column:13},end:{line:77,column:14}}],line:74}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CodeVerifier=function(_ref){_inherits(CodeVerifier,_ref);function CodeVerifier(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,CodeVerifier);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=CodeVerifier.__proto__||Object.getPrototypeOf(CodeVerifier)).call.apply(_ref2,[this].concat(args))),_this),_this.state={form:_this.props.form},_this.onPaste=function(e,identifier){cov_2a8rs66tek.f[0]++;cov_2a8rs66tek.s[0]++;if(identifier=='code_1'){cov_2a8rs66tek.b[0][0]++;var clipBoardData=(cov_2a8rs66tek.s[1]++,e.clipboardData.getData('Text').split(''));cov_2a8rs66tek.s[2]++;Object.keys(_this.state.form).map(function(input,index){cov_2a8rs66tek.f[1]++;cov_2a8rs66tek.s[3]++;return _this.setState(function(prevState){cov_2a8rs66tek.f[2]++;cov_2a8rs66tek.s[4]++;return{form:Object.assign({},prevState.form,_defineProperty({},'code_'+(index+1),clipBoardData[index]))};},function(){cov_2a8rs66tek.f[3]++;cov_2a8rs66tek.s[5]++;return _this.props.changed(_this.state);});});}else{cov_2a8rs66tek.b[0][1]++;}},_this.onKeyUp=function(e,target){cov_2a8rs66tek.f[4]++;cov_2a8rs66tek.s[6]++;if(e.keyCode===8){cov_2a8rs66tek.b[1][0]++;cov_2a8rs66tek.s[7]++;_this.setState(function(prevState,props){cov_2a8rs66tek.f[5]++;cov_2a8rs66tek.s[8]++;return{form:Object.assign({},prevState.form,_defineProperty({},target,''))};},function(){cov_2a8rs66tek.f[6]++;cov_2a8rs66tek.s[9]++;return _this.props.changed(_this.state);});}else{cov_2a8rs66tek.b[1][1]++;}},_this.inputChangedHandler=function(event,target){cov_2a8rs66tek.f[7]++;var value=(cov_2a8rs66tek.s[10]++,event.target.value);/*		let key = event;
		console.log(key);*/cov_2a8rs66tek.s[11]++;if(value.length==1){cov_2a8rs66tek.b[2][0]++;cov_2a8rs66tek.s[12]++;_this.setState(function(prevState,props){cov_2a8rs66tek.f[8]++;cov_2a8rs66tek.s[13]++;return{form:Object.assign({},prevState.form,_defineProperty({},target,value))};},function(){cov_2a8rs66tek.f[9]++;cov_2a8rs66tek.s[14]++;return _this.props.changed(_this.state);});// Focus next element
var next=(cov_2a8rs66tek.s[15]++,(cov_2a8rs66tek.b[3][0]++,event.srcElement)||(cov_2a8rs66tek.b[3][1]++,event.target));cov_2a8rs66tek.s[16]++;while(next=next.nextElementSibling){cov_2a8rs66tek.s[17]++;if(next==null){cov_2a8rs66tek.b[4][0]++;cov_2a8rs66tek.s[18]++;break;}else{cov_2a8rs66tek.b[4][1]++;}cov_2a8rs66tek.s[19]++;if(next.tagName.toLowerCase()==="input"){cov_2a8rs66tek.b[5][0]++;cov_2a8rs66tek.s[20]++;next.focus();cov_2a8rs66tek.s[21]++;break;}else{cov_2a8rs66tek.b[5][1]++;}}}else{cov_2a8rs66tek.b[2][1]++;}},_temp),_possibleConstructorReturn(_this,_ret);}// Backspace-Funktion
_createClass(CodeVerifier,[{key:'render',value:function render(){var _this2=this;cov_2a8rs66tek.f[10]++;cov_2a8rs66tek.s[22]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__CodeVerifier_scss___default.a.codeVerifier},Object.keys(this.props.form).map(function(input,index){cov_2a8rs66tek.f[11]++;cov_2a8rs66tek.s[23]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["Input"],{key:index,placeholder:'0',keyupped:function keyupped(event,target){cov_2a8rs66tek.f[12]++;cov_2a8rs66tek.s[24]++;_this2.onKeyUp(event,target);},identifier:"code_"+(index+1),type:'number',value:_this2.state.form['code_'+(index+1)],pasted:_this2.onPaste,changed:function changed(event,target){cov_2a8rs66tek.f[13]++;cov_2a8rs66tek.s[25]++;_this2.inputChangedHandler(event,target);}});}));}}]);return CodeVerifier;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (CodeVerifier);

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"codeVerifier":"CodeVerifier__codeVerifier___2EaBN"};

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputRow_scss__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InputRow_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_newId__ = __webpack_require__(111);
var cov_26ehrs1ppy=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\InputRow\\index.js',hash='7364b108e2471e486ff8b9f0179ffcf16b03b5b4',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\InputRow\\index.js',statementMap:{'0':{start:{line:14,column:4},end:{line:14,column:17}},'1':{start:{line:18,column:6},end:{line:20,column:7}},'2':{start:{line:19,column:8},end:{line:19,column:31}},'3':{start:{line:23,column:4},end:{line:23,column:22}},'4':{start:{line:26,column:4},end:{line:28,column:11}},'5':{start:{line:27,column:6},end:{line:27,column:56}},'6':{start:{line:31,column:4},end:{line:33,column:11}},'7':{start:{line:32,column:6},end:{line:32,column:56}},'8':{start:{line:36,column:21},end:{line:36,column:36}},'9':{start:{line:37,column:4},end:{line:39,column:5}},'10':{start:{line:38,column:6},end:{line:38,column:52}},'11':{start:{line:41,column:4},end:{line:44,column:5}},'12':{start:{line:42,column:21},end:{line:42,column:45}},'13':{start:{line:43,column:6},end:{line:43,column:54}},'14':{start:{line:46,column:22},end:{line:46,column:24}},'15':{start:{line:47,column:4},end:{line:57,column:5}},'16':{start:{line:49,column:6},end:{line:49,column:53}},'17':{start:{line:51,column:6},end:{line:56,column:7}},'18':{start:{line:52,column:8},end:{line:52,column:149}},'19':{start:{line:55,column:8},end:{line:55,column:106}},'20':{start:{line:59,column:21},end:{line:59,column:23}},'21':{start:{line:60,column:4},end:{line:74,column:5}},'22':{start:{line:61,column:26},end:{line:61,column:28}},'23':{start:{line:63,column:6},end:{line:69,column:7}},'24':{start:{line:64,column:8},end:{line:64,column:39}},'25':{start:{line:66,column:8},end:{line:68,column:9}},'26':{start:{line:67,column:10},end:{line:67,column:41}},'27':{start:{line:71,column:6},end:{line:73,column:26}},'28':{start:{line:76,column:21},end:{line:76,column:23}},'29':{start:{line:77,column:4},end:{line:86,column:5}},'30':{start:{line:78,column:23},end:{line:78,column:34}},'31':{start:{line:79,column:6},end:{line:79,column:52}},'32':{start:{line:81,column:6},end:{line:83,column:7}},'33':{start:{line:82,column:8},end:{line:82,column:56}},'34':{start:{line:85,column:6},end:{line:85,column:70}},'35':{start:{line:88,column:21},end:{line:88,column:23}},'36':{start:{line:89,column:4},end:{line:103,column:5}},'37':{start:{line:90,column:6},end:{line:102,column:7}},'38':{start:{line:91,column:25},end:{line:91,column:36}},'39':{start:{line:92,column:8},end:{line:92,column:54}},'40':{start:{line:94,column:8},end:{line:96,column:9}},'41':{start:{line:95,column:10},end:{line:95,column:58}},'42':{start:{line:98,column:8},end:{line:100,column:28}},'43':{start:{line:105,column:4},end:{line:107,column:5}},'44':{start:{line:106,column:6},end:{line:106,column:52}},'45':{start:{line:109,column:4},end:{line:111,column:5}},'46':{start:{line:110,column:6},end:{line:110,column:53}},'47':{start:{line:114,column:4},end:{line:123,column:5}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:2},end:{line:13,column:3}},loc:{start:{line:13,column:21},end:{line:15,column:3}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:23},end:{line:17,column:24}},loc:{start:{line:17,column:59},end:{line:21,column:3}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:22,column:2},end:{line:22,column:3}},loc:{start:{line:22,column:23},end:{line:24,column:3}},line:22},'3':{name:'(anonymous_3)',decl:{start:{line:25,column:2},end:{line:25,column:3}},loc:{start:{line:25,column:16},end:{line:29,column:3}},line:25},'4':{name:'(anonymous_4)',decl:{start:{line:26,column:15},end:{line:26,column:16}},loc:{start:{line:26,column:21},end:{line:28,column:5}},line:26},'5':{name:'(anonymous_5)',decl:{start:{line:30,column:2},end:{line:30,column:3}},loc:{start:{line:30,column:16},end:{line:34,column:3}},line:30},'6':{name:'(anonymous_6)',decl:{start:{line:31,column:15},end:{line:31,column:16}},loc:{start:{line:31,column:21},end:{line:33,column:5}},line:31},'7':{name:'(anonymous_7)',decl:{start:{line:35,column:2},end:{line:35,column:3}},loc:{start:{line:35,column:11},end:{line:124,column:3}},line:35}},branchMap:{'0':{loc:{start:{line:18,column:6},end:{line:20,column:7}},type:'if',locations:[{start:{line:18,column:6},end:{line:20,column:7}},{start:{line:18,column:6},end:{line:20,column:7}}],line:18},'1':{loc:{start:{line:37,column:4},end:{line:39,column:5}},type:'if',locations:[{start:{line:37,column:4},end:{line:39,column:5}},{start:{line:37,column:4},end:{line:39,column:5}}],line:37},'2':{loc:{start:{line:41,column:4},end:{line:44,column:5}},type:'if',locations:[{start:{line:41,column:4},end:{line:44,column:5}},{start:{line:41,column:4},end:{line:44,column:5}}],line:41},'3':{loc:{start:{line:47,column:4},end:{line:57,column:5}},type:'if',locations:[{start:{line:47,column:4},end:{line:57,column:5}},{start:{line:47,column:4},end:{line:57,column:5}}],line:47},'4':{loc:{start:{line:51,column:6},end:{line:56,column:7}},type:'if',locations:[{start:{line:51,column:6},end:{line:56,column:7}},{start:{line:51,column:6},end:{line:56,column:7}}],line:51},'5':{loc:{start:{line:60,column:4},end:{line:74,column:5}},type:'if',locations:[{start:{line:60,column:4},end:{line:74,column:5}},{start:{line:60,column:4},end:{line:74,column:5}}],line:60},'6':{loc:{start:{line:63,column:6},end:{line:69,column:7}},type:'if',locations:[{start:{line:63,column:6},end:{line:69,column:7}},{start:{line:63,column:6},end:{line:69,column:7}}],line:63},'7':{loc:{start:{line:63,column:9},end:{line:63,column:44}},type:'binary-expr',locations:[{start:{line:63,column:9},end:{line:63,column:25}},{start:{line:63,column:29},end:{line:63,column:44}}],line:63},'8':{loc:{start:{line:66,column:8},end:{line:68,column:9}},type:'if',locations:[{start:{line:66,column:8},end:{line:68,column:9}},{start:{line:66,column:8},end:{line:68,column:9}}],line:66},'9':{loc:{start:{line:66,column:11},end:{line:66,column:46}},type:'binary-expr',locations:[{start:{line:66,column:11},end:{line:66,column:27}},{start:{line:66,column:31},end:{line:66,column:46}}],line:66},'10':{loc:{start:{line:77,column:4},end:{line:86,column:5}},type:'if',locations:[{start:{line:77,column:4},end:{line:86,column:5}},{start:{line:77,column:4},end:{line:86,column:5}}],line:77},'11':{loc:{start:{line:81,column:6},end:{line:83,column:7}},type:'if',locations:[{start:{line:81,column:6},end:{line:83,column:7}},{start:{line:81,column:6},end:{line:83,column:7}}],line:81},'12':{loc:{start:{line:89,column:4},end:{line:103,column:5}},type:'if',locations:[{start:{line:89,column:4},end:{line:103,column:5}},{start:{line:89,column:4},end:{line:103,column:5}}],line:89},'13':{loc:{start:{line:90,column:6},end:{line:102,column:7}},type:'if',locations:[{start:{line:90,column:6},end:{line:102,column:7}},{start:{line:90,column:6},end:{line:102,column:7}}],line:90},'14':{loc:{start:{line:94,column:8},end:{line:96,column:9}},type:'if',locations:[{start:{line:94,column:8},end:{line:96,column:9}},{start:{line:94,column:8},end:{line:96,column:9}}],line:94},'15':{loc:{start:{line:105,column:4},end:{line:107,column:5}},type:'if',locations:[{start:{line:105,column:4},end:{line:107,column:5}},{start:{line:105,column:4},end:{line:107,column:5}}],line:105},'16':{loc:{start:{line:109,column:4},end:{line:111,column:5}},type:'if',locations:[{start:{line:109,column:4},end:{line:111,column:5}},{start:{line:109,column:4},end:{line:111,column:5}}],line:109}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputRow=function(_ref){_inherits(InputRow,_ref);function InputRow(props){_classCallCheck(this,InputRow);cov_26ehrs1ppy.f[0]++;cov_26ehrs1ppy.s[0]++;var _this=_possibleConstructorReturn(this,(InputRow.__proto__||Object.getPrototypeOf(InputRow)).call(this,props));_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_26ehrs1ppy.f[1]++;cov_26ehrs1ppy.s[1]++;if(prevProps.tip!==_this.props.tip){cov_26ehrs1ppy.b[0][0]++;cov_26ehrs1ppy.s[2]++;__WEBPACK_IMPORTED_MODULE_3_react_tooltip___default.a.rebuild();}else{cov_26ehrs1ppy.b[0][1]++;}};return _this;}_createClass(InputRow,[{key:'componentWillMount',value:function componentWillMount(){cov_26ehrs1ppy.f[2]++;cov_26ehrs1ppy.s[3]++;this.id=Object(__WEBPACK_IMPORTED_MODULE_5__util_newId__["a" /* default */])();}},{key:'showTooltip',value:function showTooltip(){var _this2=this;cov_26ehrs1ppy.f[3]++;cov_26ehrs1ppy.s[4]++;setTimeout(function(){cov_26ehrs1ppy.f[4]++;cov_26ehrs1ppy.s[5]++;__WEBPACK_IMPORTED_MODULE_3_react_tooltip___default.a.show(Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this2.refs[_this2.id]));},100);}},{key:'hideTooltip',value:function hideTooltip(){var _this3=this;cov_26ehrs1ppy.f[5]++;cov_26ehrs1ppy.s[6]++;setTimeout(function(){cov_26ehrs1ppy.f[6]++;cov_26ehrs1ppy.s[7]++;__WEBPACK_IMPORTED_MODULE_3_react_tooltip___default.a.hide(Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this3.refs[_this3.id]));},100);}},{key:'render',value:function render(){cov_26ehrs1ppy.f[7]++;var classNames=(cov_26ehrs1ppy.s[8]++,__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.inputRow);cov_26ehrs1ppy.s[9]++;if(this.props.theme=='light'){cov_26ehrs1ppy.b[1][0]++;cov_26ehrs1ppy.s[10]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.isLight;}else{cov_26ehrs1ppy.b[1][1]++;}cov_26ehrs1ppy.s[11]++;if(this.props.cols){cov_26ehrs1ppy.b[2][0]++;var colClass=(cov_26ehrs1ppy.s[12]++,'col-'+this.props.cols);cov_26ehrs1ppy.s[13]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a[colClass];}else{cov_26ehrs1ppy.b[2][1]++;}var stateString=(cov_26ehrs1ppy.s[14]++,'');cov_26ehrs1ppy.s[15]++;if(this.props.state){cov_26ehrs1ppy.b[3][0]++;cov_26ehrs1ppy.s[16]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.hasState;cov_26ehrs1ppy.s[17]++;if(this.props.state==='loading'){cov_26ehrs1ppy.b[4][0]++;cov_26ehrs1ppy.s[18]++;stateString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.state},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.stateLoadingRing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)));}else{cov_26ehrs1ppy.b[4][1]++;cov_26ehrs1ppy.s[19]++;stateString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.state},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:this.props.state}));}}else{cov_26ehrs1ppy.b[3][1]++;}var iconString=(cov_26ehrs1ppy.s[20]++,'');cov_26ehrs1ppy.s[21]++;if(this.props.icon){cov_26ehrs1ppy.b[5][0]++;var specialStyles=(cov_26ehrs1ppy.s[22]++,{});cov_26ehrs1ppy.s[23]++;if((cov_26ehrs1ppy.b[7][0]++,this.props.state)||(cov_26ehrs1ppy.b[7][1]++,this.props.unit)){cov_26ehrs1ppy.b[6][0]++;cov_26ehrs1ppy.s[24]++;specialStyles={right:'38px'};cov_26ehrs1ppy.s[25]++;if((cov_26ehrs1ppy.b[9][0]++,this.props.state)&&(cov_26ehrs1ppy.b[9][1]++,this.props.unit)){cov_26ehrs1ppy.b[8][0]++;cov_26ehrs1ppy.s[26]++;specialStyles={right:'63px'};}else{cov_26ehrs1ppy.b[8][1]++;}}else{cov_26ehrs1ppy.b[6][1]++;}cov_26ehrs1ppy.s[27]++;iconString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.icon,style:specialStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:this.props.icon}));}else{cov_26ehrs1ppy.b[5][1]++;}var unitString=(cov_26ehrs1ppy.s[28]++,'');cov_26ehrs1ppy.s[29]++;if(this.props.unit){cov_26ehrs1ppy.b[10][0]++;var unitStyles=(cov_26ehrs1ppy.s[30]++,__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.unit);cov_26ehrs1ppy.s[31]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.hasUnit;cov_26ehrs1ppy.s[32]++;if(this.props.state){cov_26ehrs1ppy.b[11][0]++;cov_26ehrs1ppy.s[33]++;unitStyles=unitStyles+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.unitState;}else{cov_26ehrs1ppy.b[11][1]++;}cov_26ehrs1ppy.s[34]++;unitString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:unitStyles},this.props.unit);}else{cov_26ehrs1ppy.b[10][1]++;}var hintString=(cov_26ehrs1ppy.s[35]++,'');cov_26ehrs1ppy.s[36]++;if(this.props.hint){cov_26ehrs1ppy.b[12][0]++;cov_26ehrs1ppy.s[37]++;if(!this.props.state){cov_26ehrs1ppy.b[13][0]++;var hintStyles=(cov_26ehrs1ppy.s[38]++,__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.hint);cov_26ehrs1ppy.s[39]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.hasHint;cov_26ehrs1ppy.s[40]++;if(this.props.state){cov_26ehrs1ppy.b[14][0]++;cov_26ehrs1ppy.s[41]++;hintStyles=hintStyles+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.hintState;}else{cov_26ehrs1ppy.b[14][1]++;}cov_26ehrs1ppy.s[42]++;hintString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-tip':this.props.hint,'data-event':'click','data-for':'GlobalTooltip',className:hintStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:'hint',size:'13px'}));}else{cov_26ehrs1ppy.b[13][1]++;}}else{cov_26ehrs1ppy.b[12][1]++;}cov_26ehrs1ppy.s[43]++;if(this.props.isRight){cov_26ehrs1ppy.b[15][0]++;cov_26ehrs1ppy.s[44]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.isRight;}else{cov_26ehrs1ppy.b[15][1]++;}cov_26ehrs1ppy.s[45]++;if(this.props.noMargin){cov_26ehrs1ppy.b[16][0]++;cov_26ehrs1ppy.s[46]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_4__InputRow_scss___default.a.noMargin;}else{cov_26ehrs1ppy.b[16][1]++;}cov_26ehrs1ppy.s[47]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames,'data-tip':this.props.tip,'data-event':'click focus',ref:this.id,'data-for':'GlobalTooltip'},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Label"],{label:this.props.label,styles:this.props.labelStyle}),stateString,unitString,iconString,hintString);}}]);return InputRow;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (InputRow);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__(226);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatibale with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__(226);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];
    if (map !== undefined) {
      return map[event];
    }
  }
};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's nessesary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  // Judge if the tooltip has over the window(screen)
  var outsideVertical = function outsideVertical() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideLeft = function outsideLeft() {
    var _outsideVertical = outsideVertical(),
        result = _outsideVertical.result,
        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority


    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
      result = true; // If vertical ok, but let out of side and right won't out of side
      newPlace = 'right';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideRight = function outsideRight() {
    var _outsideVertical2 = outsideVertical(),
        result = _outsideVertical2.result,
        newPlace = _outsideVertical2.newPlace;

    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };

  var outsideHorizontal = function outsideHorizontal() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
      result = true;
      newPlace = 'right';
    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideTop = function outsideTop() {
    var _outsideHorizontal = outsideHorizontal(),
        result = _outsideHorizontal.result,
        newPlace = _outsideHorizontal.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideBottom = function outsideBottom() {
    var _outsideHorizontal2 = outsideHorizontal(),
        result = _outsideHorizontal2.result,
        newPlace = _outsideHorizontal2.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };

  // Return new state to change the placement to the reverse if possible
  var outsideLeftResult = outsideLeft();
  var outsideRightResult = outsideRight();
  var outsideTopResult = outsideTop();
  var outsideBottomResult = outsideBottom();

  if (place === 'left' && outsideLeftResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideLeftResult.newPlace }
    };
  } else if (place === 'right' && outsideRightResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideRightResult.newPlace }
    };
  } else if (place === 'top' && outsideTopResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideTopResult.newPlace }
    };
  } else if (place === 'bottom' && outsideBottomResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideBottomResult.newPlace }
    };
  }

  // Change back to original place if possible
  if (place !== desiredPlace) {
    if (desiredPlace === 'top' && !outsideTopResult.result) {
      return {
        isNewState: true,
        newState: { place: 'top' }
      };
    } else if (desiredPlace === 'left' && !outsideLeftResult.result) {
      return {
        isNewState: true,
        newState: { place: 'left' }
      };
    } else if (desiredPlace === 'right' && !outsideRightResult.result) {
      return {
        isNewState: true,
        newState: { place: 'right' }
      };
    } else if (desiredPlace === 'bottom' && !outsideBottomResult.result) {
      return {
        isNewState: true,
        newState: { place: 'bottom' }
      };
    }
  }

  // Return tooltip offset position
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
};

// Get current mouse offset
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {OBject} {left: {Number}, top: {Number}}
 */
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and childern is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement(
      'span',
      { key: i, className: 'multi-line' },
      d
    );
  });
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inputRow":"InputRow__inputRow___bkqlu","noMargin":"InputRow__noMargin___16p9t","col-2":"InputRow__col-2___f-jx5","col-4":"InputRow__col-4___W5yXs","unit":"InputRow__unit___1a9sq","state":"InputRow__state___3HpK7","hint":"InputRow__hint___wBGcb","unitState":"InputRow__unitState___1cp5G","hasState":"InputRow__hasState___yXtSX","hasHint":"InputRow__hasHint___l5wNM","hasUnit":"InputRow__hasUnit___3s9Rp","isLight":"InputRow__isLight___30rwP","isRight":"InputRow__isRight___2lH6Z","icon":"InputRow__icon___39oly","stateLoadingRing":"InputRow__stateLoadingRing___1XRYS","state-loading-ring":"InputRow__state-loading-ring___jWGHg"};

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainNav_scss__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MainNav_scss__);
var cov_2o121ucnzn=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\MainNav\\index.js',hash='cd6e707d9edd2e79c6a099ab8cda98778f7f3732',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\MainNav\\index.js',statementMap:{'0':{start:{line:12,column:4},end:{line:14,column:5}},'1':{start:{line:13,column:6},end:{line:13,column:55}},'2':{start:{line:18,column:20},end:{line:18,column:25}},'3':{start:{line:19,column:4},end:{line:23,column:6}},'4':{start:{line:20,column:6},end:{line:22,column:7}},'5':{start:{line:21,column:8},end:{line:21,column:25}},'6':{start:{line:24,column:18},end:{line:24,column:20}},'7':{start:{line:25,column:4},end:{line:33,column:5}},'8':{start:{line:26,column:6},end:{line:32,column:13}},'9':{start:{line:35,column:4},end:{line:35,column:18}},'10':{start:{line:40,column:24},end:{line:47,column:1}},'11':{start:{line:41,column:4},end:{line:46,column:6}},'12':{start:{line:49,column:27},end:{line:53,column:1}},'13':{start:{line:50,column:4},end:{line:52,column:5}},'14':{start:{line:51,column:51},end:{line:51,column:111}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:2},end:{line:11,column:3}},loc:{start:{line:11,column:22},end:{line:15,column:3}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:2},end:{line:17,column:3}},loc:{start:{line:17,column:11},end:{line:36,column:3}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:19,column:58},end:{line:19,column:59}},loc:{start:{line:19,column:77},end:{line:23,column:5}},line:19},'3':{name:'(anonymous_3)',decl:{start:{line:40,column:24},end:{line:40,column:25}},loc:{start:{line:40,column:33},end:{line:47,column:1}},line:40},'4':{name:'(anonymous_4)',decl:{start:{line:49,column:27},end:{line:49,column:28}},loc:{start:{line:49,column:39},end:{line:53,column:1}},line:49},'5':{name:'(anonymous_5)',decl:{start:{line:51,column:45},end:{line:51,column:46}},loc:{start:{line:51,column:51},end:{line:51,column:111}},line:51}},branchMap:{'0':{loc:{start:{line:12,column:4},end:{line:14,column:5}},type:'if',locations:[{start:{line:12,column:4},end:{line:14,column:5}},{start:{line:12,column:4},end:{line:14,column:5}}],line:12},'1':{loc:{start:{line:20,column:6},end:{line:22,column:7}},type:'if',locations:[{start:{line:20,column:6},end:{line:22,column:7}},{start:{line:20,column:6},end:{line:22,column:7}}],line:20},'2':{loc:{start:{line:25,column:4},end:{line:33,column:5}},type:'if',locations:[{start:{line:25,column:4},end:{line:33,column:5}},{start:{line:25,column:4},end:{line:33,column:5}}],line:25},'3':{loc:{start:{line:29,column:27},end:{line:29,column:107}},type:'cond-expr',locations:[{start:{line:29,column:40},end:{line:29,column:82}},{start:{line:29,column:86},end:{line:29,column:107}}],line:29}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainNav=function(_ref){_inherits(MainNav,_ref);function MainNav(){_classCallCheck(this,MainNav);return _possibleConstructorReturn(this,(MainNav.__proto__||Object.getPrototypeOf(MainNav)).apply(this,arguments));}_createClass(MainNav,[{key:'componentDidMount',value:function componentDidMount(){cov_2o121ucnzn.f[0]++;cov_2o121ucnzn.s[0]++;if(this.props.auth.isAuthenticated){cov_2o121ucnzn.b[0][0]++;cov_2o121ucnzn.s[1]++;this.props.onHelpersNotificationsMachinesFetch();}else{cov_2o121ucnzn.b[0][1]++;}}},{key:'render',value:function render(){cov_2o121ucnzn.f[1]++;var showBatch=(cov_2o121ucnzn.s[2]++,false);cov_2o121ucnzn.s[3]++;this.props.helpersNotifications.machines.list.forEach(function(machine,index){cov_2o121ucnzn.f[2]++;cov_2o121ucnzn.s[4]++;if(machine.incomplete){cov_2o121ucnzn.b[1][0]++;cov_2o121ucnzn.s[5]++;showBatch=true;}else{cov_2o121ucnzn.b[1][1]++;}});var content=(cov_2o121ucnzn.s[6]++,"");cov_2o121ucnzn.s[7]++;if(this.props.auth.isAuthenticated){cov_2o121ucnzn.b[2][0]++;cov_2o121ucnzn.s[8]++;content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.mainNav},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isHiddenMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:'/jobs',activeClassName:__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isActive},this.props.translate('menu.jobs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:showBatch?(cov_2o121ucnzn.b[3][0]++,__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.batch+' '+__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isHiddenMobile):(cov_2o121ucnzn.b[3][1]++,__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isHiddenMobile)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:'/machines',activeClassName:__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isActive},this.props.translate('menu.machines'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isHighlighted+' '+__WEBPACK_IMPORTED_MODULE_6__MainNav_scss___default.a.isHiddenMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:'/jobs/new'},this.props.translate('menu.new_job')))));}else{cov_2o121ucnzn.b[2][1]++;}cov_2o121ucnzn.s[9]++;return content;}}]);return MainNav;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_2o121ucnzn.s[10]++;var mapStateToProps=function mapStateToProps(state){cov_2o121ucnzn.f[3]++;cov_2o121ucnzn.s[11]++;return{defaults:state.defaults,auth:state.auth,helpersNotifications:state.helpersNotifications,translate:Object(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_2o121ucnzn.s[12]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_2o121ucnzn.f[4]++;cov_2o121ucnzn.s[13]++;return{onHelpersNotificationsMachinesFetch:function onHelpersNotificationsMachinesFetch(){cov_2o121ucnzn.f[5]++;cov_2o121ucnzn.s[14]++;return dispatch(__WEBPACK_IMPORTED_MODULE_3__store_actions_index__["Z" /* helpersNotificationsMachinesFetch */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(MainNav));

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mainNav":"MainNav__mainNav___2RzWL","batch":"MainNav__batch___1WL7F","isHighlighted":"MainNav__isHighlighted___2FqaC","isHiddenMobile":"MainNav__isHiddenMobile___2yqEA","isActive":"MainNav__isActive___2AWpm"};

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetaNav_scss__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
var cov_12sxz3j3pl=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\MetaNav\\index.js',hash='3e2402741a5f2ce1fa1cbb8b681c58eeaaedca55',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\MetaNav\\index.js',statementMap:{'0':{start:{line:12,column:3},end:{line:24,column:4}},'1':{start:{line:28,column:24},end:{line:33,column:1}},'2':{start:{line:29,column:4},end:{line:32,column:6}},'3':{start:{line:35,column:27},end:{line:39,column:1}},'4':{start:{line:36,column:4},end:{line:38,column:5}},'5':{start:{line:37,column:26},end:{line:37,column:68}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:3},end:{line:11,column:4}},loc:{start:{line:11,column:12},end:{line:25,column:2}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:28,column:24},end:{line:28,column:25}},loc:{start:{line:28,column:33},end:{line:33,column:1}},line:28},'2':{name:'(anonymous_2)',decl:{start:{line:35,column:27},end:{line:35,column:28}},loc:{start:{line:35,column:39},end:{line:39,column:1}},line:35},'3':{name:'(anonymous_3)',decl:{start:{line:37,column:20},end:{line:37,column:21}},loc:{start:{line:37,column:26},end:{line:37,column:68}},line:37}},branchMap:{'0':{loc:{start:{line:14,column:5},end:{line:22,column:15}},type:'cond-expr',locations:[{start:{line:15,column:6},end:{line:21,column:14}},{start:{line:22,column:11},end:{line:22,column:15}}],line:14}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0},f:{'0':0,'1':0,'2':0,'3':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MetaNav=function(_ref){_inherits(MetaNav,_ref);function MetaNav(){_classCallCheck(this,MetaNav);return _possibleConstructorReturn(this,(MetaNav.__proto__||Object.getPrototypeOf(MetaNav)).apply(this,arguments));}_createClass(MetaNav,[{key:'render',value:function render(){cov_12sxz3j3pl.f[0]++;cov_12sxz3j3pl.s[0]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.metaNav},this.props.auth.isAuthenticated?(cov_12sxz3j3pl.b[0][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'data-cy':'floating-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.rounded+' '+__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.addJob+' '+__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.isHiddenDesktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:'/jobs/new',activeClassName:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.rounded+' '+__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.isHiddenMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.translate('menu.help_link'),target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.rounded+' '+__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.roundedWithIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"https://test-account.melcocloud.com/"+'dashboard',activeClassName:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.isActive,'data-cy':'account-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Icon"],{type:'image',content:'account',size:'20px'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:__WEBPACK_IMPORTED_MODULE_4__MetaNav_scss___default.a.selfStyled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["UserNavItem"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:this.props.onOpenMenu,'data-cy':'secondary-navigation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Icon"],{isHiddenDesktop:'true',type:'image',content:'hamburger'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Icon"],{isHiddenMobile:'true',type:'image',content:'settingsmenu'})))):(cov_12sxz3j3pl.b[0][1]++,null));}}]);return MetaNav;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_12sxz3j3pl.s[1]++;var mapStateToProps=function mapStateToProps(state){cov_12sxz3j3pl.f[1]++;cov_12sxz3j3pl.s[2]++;return{auth:state.auth,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_12sxz3j3pl.s[3]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_12sxz3j3pl.f[2]++;cov_12sxz3j3pl.s[4]++;return{onOpenMenu:function onOpenMenu(){cov_12sxz3j3pl.f[3]++;cov_12sxz3j3pl.s[5]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["Y" /* helpersMenuOpen */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(MetaNav));

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"metaNav":"MetaNav__metaNav___3etjy","isHiddenDesktop":"MetaNav__isHiddenDesktop___c9puy","isHiddenMobile":"MetaNav__isHiddenMobile___1W4kx","selfStyled":"MetaNav__selfStyled___2Zgij","rounded":"MetaNav__rounded___2MBmC","addJob":"MetaNav__addJob___3Dq-e","roundedWithIcon":"MetaNav__roundedWithIcon___1PgY8"};

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Steps_scss__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Steps_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Steps_scss__);
var cov_x1ojuwzcz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Steps\\index.js',hash='44bd45db7072077a5c138f4935dd65b8c42a97b4',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Steps\\index.js',statementMap:{'0':{start:{line:8,column:14},end:{line:52,column:1}},'1':{start:{line:9,column:19},end:{line:9,column:73}},'2':{start:{line:10,column:2},end:{line:12,column:3}},'3':{start:{line:11,column:4},end:{line:11,column:50}},'4':{start:{line:15,column:18},end:{line:15,column:22}},'5':{start:{line:16,column:18},end:{line:28,column:4}},'6':{start:{line:17,column:4},end:{line:27,column:5}},'7':{start:{line:18,column:24},end:{line:18,column:42}},'8':{start:{line:19,column:6},end:{line:22,column:7}},'9':{start:{line:20,column:8},end:{line:20,column:26}},'10':{start:{line:21,column:8},end:{line:21,column:41}},'11':{start:{line:24,column:6},end:{line:24,column:71}},'12':{start:{line:26,column:6},end:{line:26,column:48}},'13':{start:{line:30,column:19},end:{line:30,column:23}},'14':{start:{line:31,column:18},end:{line:39,column:4}},'15':{start:{line:33,column:4},end:{line:38,column:5}},'16':{start:{line:34,column:6},end:{line:36,column:7}},'17':{start:{line:35,column:8},end:{line:35,column:27}},'18':{start:{line:37,column:6},end:{line:37,column:37}},'19':{start:{line:42,column:2},end:{line:51,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:14},end:{line:8,column:15}},loc:{start:{line:8,column:25},end:{line:52,column:1}},line:8},'1':{name:'(anonymous_1)',decl:{start:{line:16,column:32},end:{line:16,column:33}},loc:{start:{line:16,column:53},end:{line:28,column:3}},line:16},'2':{name:'(anonymous_2)',decl:{start:{line:31,column:32},end:{line:31,column:33}},loc:{start:{line:31,column:53},end:{line:39,column:3}},line:31}},branchMap:{'0':{loc:{start:{line:10,column:2},end:{line:12,column:3}},type:'if',locations:[{start:{line:10,column:2},end:{line:12,column:3}},{start:{line:10,column:2},end:{line:12,column:3}}],line:10},'1':{loc:{start:{line:17,column:4},end:{line:27,column:5}},type:'if',locations:[{start:{line:17,column:4},end:{line:27,column:5}},{start:{line:17,column:4},end:{line:27,column:5}}],line:17},'2':{loc:{start:{line:19,column:6},end:{line:22,column:7}},type:'if',locations:[{start:{line:19,column:6},end:{line:22,column:7}},{start:{line:19,column:6},end:{line:22,column:7}}],line:19},'3':{loc:{start:{line:33,column:4},end:{line:38,column:5}},type:'if',locations:[{start:{line:33,column:4},end:{line:38,column:5}},{start:{line:33,column:4},end:{line:38,column:5}}],line:33},'4':{loc:{start:{line:34,column:6},end:{line:36,column:7}},type:'if',locations:[{start:{line:34,column:6},end:{line:36,column:7}},{start:{line:34,column:6},end:{line:36,column:7}}],line:34}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_x1ojuwzcz.s[0]++;var Steps=function Steps(props){cov_x1ojuwzcz.f[0]++;var classNames=(cov_x1ojuwzcz.s[1]++,__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.steps+' '+__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a['steps-'+props.val.length]);cov_x1ojuwzcz.s[2]++;if(props.theme=='light'){cov_x1ojuwzcz.b[0][0]++;cov_x1ojuwzcz.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.isLight;}else{cov_x1ojuwzcz.b[0][1]++;}var tmpActive=(cov_x1ojuwzcz.s[4]++,true);var stepNames=(cov_x1ojuwzcz.s[5]++,props.val.map(function(step,index){cov_x1ojuwzcz.f[1]++;cov_x1ojuwzcz.s[6]++;if(tmpActive){cov_x1ojuwzcz.b[1][0]++;var activeClass=(cov_x1ojuwzcz.s[7]++,__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.stepsBefore);cov_x1ojuwzcz.s[8]++;if(step.active){cov_x1ojuwzcz.b[2][0]++;cov_x1ojuwzcz.s[9]++;tmpActive=false;cov_x1ojuwzcz.s[10]++;activeClass=__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.stepsActive;}else{cov_x1ojuwzcz.b[2][1]++;}cov_x1ojuwzcz.s[11]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:activeClass},step.name);}else{cov_x1ojuwzcz.b[1][1]++;cov_x1ojuwzcz.s[12]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},step.name);}}));var tmpActive2=(cov_x1ojuwzcz.s[13]++,true);var stepLines=(cov_x1ojuwzcz.s[14]++,props.val.map(function(step,index){cov_x1ojuwzcz.f[2]++;cov_x1ojuwzcz.s[15]++;if(tmpActive2){cov_x1ojuwzcz.b[3][0]++;cov_x1ojuwzcz.s[16]++;if(step.active){cov_x1ojuwzcz.b[4][0]++;cov_x1ojuwzcz.s[17]++;tmpActive2=false;}else{cov_x1ojuwzcz.b[4][1]++;}cov_x1ojuwzcz.s[18]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index});}else{cov_x1ojuwzcz.b[3][1]++;}}));cov_x1ojuwzcz.s[19]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},stepNames),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.stepLine},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a.lineActive+' '+__WEBPACK_IMPORTED_MODULE_3__Steps_scss___default.a['lineActive-'+props.val.length]},stepLines)));};/* harmony default export */ __webpack_exports__["default"] = (Steps);

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Steps__wrapper___3snLB","steps":"Steps__steps___hOddT","steps-2":"Steps__steps-2___2MYdD","steps-3":"Steps__steps-3___2xXIn","stepsBefore":"Steps__stepsBefore___3MKCi","stepsActive":"Steps__stepsActive___1ooQm","stepLine":"Steps__stepLine___35Omd","lineActive":"Steps__lineActive___3dnLB","lineActive-2":"Steps__lineActive-2___2_-6V","lineActive-3":"Steps__lineActive-3____zYYT"};

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tabs_scss__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tabs_scss__);
var cov_zfc5ht44z=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Tabs\\index.js',hash='d8cbaa75feb60e0153a5de7e0d825261ba8f96bf',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\Tabs\\index.js',statementMap:{'0':{start:{line:7,column:13},end:{line:38,column:1}},'1':{start:{line:8,column:19},end:{line:8,column:33}},'2':{start:{line:9,column:2},end:{line:11,column:3}},'3':{start:{line:10,column:4},end:{line:10,column:50}},'4':{start:{line:13,column:22},end:{line:13,column:24}},'5':{start:{line:14,column:13},end:{line:29,column:4}},'6':{start:{line:15,column:6},end:{line:15,column:25}},'7':{start:{line:16,column:6},end:{line:18,column:7}},'8':{start:{line:17,column:8},end:{line:17,column:61}},'9':{start:{line:20,column:6},end:{line:23,column:7}},'10':{start:{line:22,column:8},end:{line:22,column:58}},'11':{start:{line:25,column:6},end:{line:27,column:7}},'12':{start:{line:26,column:8},end:{line:26,column:60}},'13':{start:{line:28,column:6},end:{line:28,column:115}},'14':{start:{line:28,column:33},end:{line:28,column:58}},'15':{start:{line:33,column:2},end:{line:37,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:13},end:{line:7,column:14}},loc:{start:{line:7,column:24},end:{line:38,column:1}},line:7},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:27},end:{line:14,column:28}},loc:{start:{line:14,column:47},end:{line:29,column:3}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:28,column:27},end:{line:28,column:28}},loc:{start:{line:28,column:33},end:{line:28,column:58}},line:28}},branchMap:{'0':{loc:{start:{line:9,column:2},end:{line:11,column:3}},type:'if',locations:[{start:{line:9,column:2},end:{line:11,column:3}},{start:{line:9,column:2},end:{line:11,column:3}}],line:9},'1':{loc:{start:{line:16,column:6},end:{line:18,column:7}},type:'if',locations:[{start:{line:16,column:6},end:{line:18,column:7}},{start:{line:16,column:6},end:{line:18,column:7}}],line:16},'2':{loc:{start:{line:20,column:6},end:{line:23,column:7}},type:'if',locations:[{start:{line:20,column:6},end:{line:23,column:7}},{start:{line:20,column:6},end:{line:23,column:7}}],line:20},'3':{loc:{start:{line:25,column:6},end:{line:27,column:7}},type:'if',locations:[{start:{line:25,column:6},end:{line:27,column:7}},{start:{line:25,column:6},end:{line:27,column:7}}],line:25}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},f:{'0':0,'1':0,'2':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_zfc5ht44z.s[0]++;var Tabs=function Tabs(props){cov_zfc5ht44z.f[0]++;var classNames=(cov_zfc5ht44z.s[1]++,__WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default.a.wrapper);cov_zfc5ht44z.s[2]++;if(props.theme==='light'){cov_zfc5ht44z.b[0][0]++;cov_zfc5ht44z.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default.a.isLight;}else{cov_zfc5ht44z.b[0][1]++;}var tabClassNames=(cov_zfc5ht44z.s[4]++,"");var tabs=(cov_zfc5ht44z.s[5]++,props.val.map(function(tab,index){cov_zfc5ht44z.f[1]++;cov_zfc5ht44z.s[6]++;tabClassNames="";cov_zfc5ht44z.s[7]++;if(tab.active){cov_zfc5ht44z.b[1][0]++;cov_zfc5ht44z.s[8]++;tabClassNames=tabClassNames+' '+__WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default.a.isActive;}else{cov_zfc5ht44z.b[1][1]++;}cov_zfc5ht44z.s[9]++;if(tab.batch){cov_zfc5ht44z.b[2][0]++;cov_zfc5ht44z.s[10]++;tabClassNames=tabClassNames+' '+__WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default.a.batch;}else{cov_zfc5ht44z.b[2][1]++;}cov_zfc5ht44z.s[11]++;if(props.theme==='light'){cov_zfc5ht44z.b[3][0]++;cov_zfc5ht44z.s[12]++;tabClassNames=tabClassNames+' '+__WEBPACK_IMPORTED_MODULE_2__Tabs_scss___default.a.isLight;}else{cov_zfc5ht44z.b[3][1]++;}cov_zfc5ht44z.s[13]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){cov_zfc5ht44z.f[2]++;cov_zfc5ht44z.s[14]++;return props.onTabClicked(index);},key:index,className:tabClassNames},tab.name);}));cov_zfc5ht44z.s[15]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},tabs);};/* harmony default export */ __webpack_exports__["default"] = (Tabs);

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Tabs__wrapper___1Gffo","isLight":"Tabs__isLight___dtdp1","isActive":"Tabs__isActive___3TadX","batch":"Tabs__batch___3x1-X"};

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components__);
var cov_2nr6r7omrh=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\UserNavItem\\index.js',hash='cfab63dc9505128c3009e3a9d62ca1b2f3101904',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\UserNavItem\\index.js',statementMap:{'0':{start:{line:14,column:2},end:{line:14,column:25}},'1':{start:{line:19,column:2},end:{line:24,column:3}},'2':{start:{line:20,column:3},end:{line:23,column:7}},'3':{start:{line:20,column:31},end:{line:23,column:4}},'4':{start:{line:26,column:8},end:{line:31,column:9}},'5':{start:{line:27,column:12},end:{line:30,column:7}},'6':{start:{line:27,column:40},end:{line:30,column:4}},'7':{start:{line:35,column:8},end:{line:38,column:12}},'8':{start:{line:35,column:36},end:{line:38,column:9}},'9':{start:{line:42,column:8},end:{line:44,column:9}},'10':{start:{line:43,column:12},end:{line:43,column:24}},'11':{start:{line:45,column:8},end:{line:57,column:10}},'12':{start:{line:61,column:24},end:{line:65,column:1}},'13':{start:{line:62,column:4},end:{line:64,column:6}},'14':{start:{line:67,column:27},end:{line:69,column:1}},'15':{start:{line:68,column:4},end:{line:68,column:13}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:1},end:{line:13,column:2}},loc:{start:{line:13,column:21},end:{line:15,column:2}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:19},end:{line:17,column:20}},loc:{start:{line:17,column:25},end:{line:32,column:2}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:20,column:17},end:{line:20,column:18}},loc:{start:{line:20,column:31},end:{line:23,column:4}},line:20},'3':{name:'(anonymous_3)',decl:{start:{line:27,column:26},end:{line:27,column:27}},loc:{start:{line:27,column:40},end:{line:30,column:4}},line:27},'4':{name:'(anonymous_4)',decl:{start:{line:34,column:17},end:{line:34,column:18}},loc:{start:{line:34,column:23},end:{line:39,column:5}},line:34},'5':{name:'(anonymous_5)',decl:{start:{line:35,column:22},end:{line:35,column:23}},loc:{start:{line:35,column:36},end:{line:38,column:9}},line:35},'6':{name:'(anonymous_6)',decl:{start:{line:41,column:3},end:{line:41,column:4}},loc:{start:{line:41,column:12},end:{line:58,column:2}},line:41},'7':{name:'(anonymous_7)',decl:{start:{line:61,column:24},end:{line:61,column:25}},loc:{start:{line:61,column:33},end:{line:65,column:1}},line:61},'8':{name:'(anonymous_8)',decl:{start:{line:67,column:27},end:{line:67,column:28}},loc:{start:{line:67,column:39},end:{line:69,column:1}},line:67}},branchMap:{'0':{loc:{start:{line:19,column:2},end:{line:24,column:3}},type:'if',locations:[{start:{line:19,column:2},end:{line:24,column:3}},{start:{line:19,column:2},end:{line:24,column:3}}],line:19},'1':{loc:{start:{line:19,column:6},end:{line:19,column:61}},type:'binary-expr',locations:[{start:{line:19,column:6},end:{line:19,column:32}},{start:{line:19,column:36},end:{line:19,column:61}}],line:19},'2':{loc:{start:{line:26,column:8},end:{line:31,column:9}},type:'if',locations:[{start:{line:26,column:8},end:{line:31,column:9}},{start:{line:26,column:8},end:{line:31,column:9}}],line:26},'3':{loc:{start:{line:42,column:8},end:{line:44,column:9}},type:'if',locations:[{start:{line:42,column:8},end:{line:44,column:9}},{start:{line:42,column:8},end:{line:44,column:9}}],line:42},'4':{loc:{start:{line:47,column:17},end:{line:51,column:17}},type:'binary-expr',locations:[{start:{line:47,column:17},end:{line:47,column:40}},{start:{line:48,column:20},end:{line:50,column:26}}],line:47}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserNavItem=function(_ref){_inherits(UserNavItem,_ref);function UserNavItem(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,UserNavItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=UserNavItem.__proto__||Object.getPrototypeOf(UserNavItem)).call.apply(_ref2,[this].concat(args))),_this),_this.state={initials:"",account_name:"",open:false},_this.initialsHandler=function(){cov_2nr6r7omrh.f[1]++;cov_2nr6r7omrh.s[1]++;//get the first name from auth
if((cov_2nr6r7omrh.b[1][0]++,_this.props.auth.first_name)&&(cov_2nr6r7omrh.b[1][1]++,_this.props.auth.last_name)){cov_2nr6r7omrh.b[0][0]++;cov_2nr6r7omrh.s[2]++;_this.setState(function(prevState){cov_2nr6r7omrh.f[2]++;cov_2nr6r7omrh.s[3]++;return Object.assign({},prevState,{initials:_this.props.auth.first_name.substr(0,1).toUpperCase()+_this.props.auth.last_name.substr(0,1).toUpperCase()});});}else{cov_2nr6r7omrh.b[0][1]++;}//get account name from auth
cov_2nr6r7omrh.s[4]++;if(_this.props.auth.account_name){cov_2nr6r7omrh.b[2][0]++;cov_2nr6r7omrh.s[5]++;_this.setState(function(prevState){cov_2nr6r7omrh.f[3]++;cov_2nr6r7omrh.s[6]++;return Object.assign({},prevState,{account_name:_this.props.auth.account_name});});}else{cov_2nr6r7omrh.b[2][1]++;}},_this.toggleOpen=function(){cov_2nr6r7omrh.f[4]++;cov_2nr6r7omrh.s[7]++;_this.setState(function(prevState){cov_2nr6r7omrh.f[5]++;cov_2nr6r7omrh.s[8]++;return Object.assign({},prevState,{open:!prevState.open});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserNavItem,[{key:'componentDidMount',value:function componentDidMount(){cov_2nr6r7omrh.f[0]++;cov_2nr6r7omrh.s[0]++;this.initialsHandler();}},{key:'render',value:function render(){cov_2nr6r7omrh.f[6]++;cov_2nr6r7omrh.s[9]++;if(!this.state.initials.length){cov_2nr6r7omrh.b[3][0]++;cov_2nr6r7omrh.s[10]++;return null;}else{cov_2nr6r7omrh.b[3][1]++;}cov_2nr6r7omrh.s[11]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss___default.a.userNavItemOuter},(cov_2nr6r7omrh.b[4][0]++,this.state.account_name)&&(cov_2nr6r7omrh.b[4][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss___default.a.userNavItemAccountName,'data-cy-id':'floating-navigation-user-account-name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss___default.a.inner},this.state.account_name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItem_scss___default.a.userNavItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.toggleOpen,'data-cy-id':'floating-navigation-user-initials'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.initials)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["UserNavItemPopover"],{open:this.state.open,onClickOutside:this.toggleOpen})));}}]);return UserNavItem;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_2nr6r7omrh.s[12]++;var mapStateToProps=function mapStateToProps(state){cov_2nr6r7omrh.f[7]++;cov_2nr6r7omrh.s[13]++;return{auth:state.auth};};cov_2nr6r7omrh.s[14]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_2nr6r7omrh.f[8]++;cov_2nr6r7omrh.s[15]++;return{};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(UserNavItem));

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"userNavItemAccountName":"UserNavItem__userNavItemAccountName___2ohQ1","inner":"UserNavItem__inner___30cPi","userNavItemOuter":"UserNavItem__userNavItemOuter___2ijHT","userNavItem":"UserNavItem__userNavItem___2hZ31","popover":"UserNavItem__popover___1qW5G","popoverItem":"UserNavItem__popoverItem___1sIVF","popoverItemIcon":"UserNavItem__popoverItemIcon___KkoXD"};

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
var cov_24glixhpkj=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\UserNavItemPopover\\index.js',hash='68bb9f505d05df6c6b7f518d8a552aca4600144d',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\molecules\\UserNavItemPopover\\index.js',statementMap:{'0':{start:{line:11,column:8},end:{line:11,column:21}},'1':{start:{line:13,column:8},end:{line:13,column:44}},'2':{start:{line:14,column:8},end:{line:14,column:69}},'3':{start:{line:18,column:8},end:{line:18,column:72}},'4':{start:{line:22,column:6},end:{line:22,column:73}},'5':{start:{line:27,column:8},end:{line:29,column:9}},'6':{start:{line:28,column:12},end:{line:28,column:40}},'7':{start:{line:33,column:8},end:{line:35,column:9}},'8':{start:{line:34,column:12},end:{line:34,column:24}},'9':{start:{line:36,column:8},end:{line:45,column:10}},'10':{start:{line:49,column:24},end:{line:53,column:1}},'11':{start:{line:50,column:4},end:{line:52,column:6}},'12':{start:{line:55,column:27},end:{line:59,column:1}},'13':{start:{line:56,column:4},end:{line:58,column:5}},'14':{start:{line:57,column:36},end:{line:57,column:81}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:4},end:{line:10,column:5}},loc:{start:{line:10,column:23},end:{line:15,column:5}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:17,column:1},end:{line:17,column:2}},loc:{start:{line:17,column:21},end:{line:19,column:2}},line:17},'2':{name:'(anonymous_2)',decl:{start:{line:21,column:4},end:{line:21,column:5}},loc:{start:{line:21,column:27},end:{line:23,column:5}},line:21},'3':{name:'(anonymous_3)',decl:{start:{line:26,column:4},end:{line:26,column:5}},loc:{start:{line:26,column:30},end:{line:30,column:5}},line:26},'4':{name:'(anonymous_4)',decl:{start:{line:32,column:3},end:{line:32,column:4}},loc:{start:{line:32,column:12},end:{line:46,column:2}},line:32},'5':{name:'(anonymous_5)',decl:{start:{line:49,column:24},end:{line:49,column:25}},loc:{start:{line:49,column:33},end:{line:53,column:1}},line:49},'6':{name:'(anonymous_6)',decl:{start:{line:55,column:27},end:{line:55,column:28}},loc:{start:{line:55,column:39},end:{line:59,column:1}},line:55},'7':{name:'(anonymous_7)',decl:{start:{line:57,column:30},end:{line:57,column:31}},loc:{start:{line:57,column:36},end:{line:57,column:81}},line:57}},branchMap:{'0':{loc:{start:{line:27,column:8},end:{line:29,column:9}},type:'if',locations:[{start:{line:27,column:8},end:{line:29,column:9}},{start:{line:27,column:8},end:{line:29,column:9}}],line:27},'1':{loc:{start:{line:27,column:12},end:{line:27,column:105}},type:'binary-expr',locations:[{start:{line:27,column:12},end:{line:27,column:27}},{start:{line:27,column:31},end:{line:27,column:54}},{start:{line:27,column:58},end:{line:27,column:105}}],line:27},'2':{loc:{start:{line:33,column:8},end:{line:35,column:9}},type:'if',locations:[{start:{line:33,column:8},end:{line:35,column:9}},{start:{line:33,column:8},end:{line:35,column:9}}],line:33}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},b:{'0':[0,0],'1':[0,0,0],'2':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserNavItemPopover=function(_ref){_inherits(UserNavItemPopover,_ref);function UserNavItemPopover(props){_classCallCheck(this,UserNavItemPopover);cov_24glixhpkj.f[0]++;cov_24glixhpkj.s[0]++;var _this=_possibleConstructorReturn(this,(UserNavItemPopover.__proto__||Object.getPrototypeOf(UserNavItemPopover)).call(this,props));cov_24glixhpkj.s[1]++;_this.wrapperRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();cov_24glixhpkj.s[2]++;_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(UserNavItemPopover,[{key:'componentDidMount',value:function componentDidMount(){cov_24glixhpkj.f[1]++;cov_24glixhpkj.s[3]++;document.addEventListener("mousedown",this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){cov_24glixhpkj.f[2]++;cov_24glixhpkj.s[4]++;document.removeEventListener("mousedown",this.handleClickOutside);}},{key:'handleClickOutside',value:function handleClickOutside(event){cov_24glixhpkj.f[3]++;cov_24glixhpkj.s[5]++;if((cov_24glixhpkj.b[1][0]++,this.wrapperRef)&&(cov_24glixhpkj.b[1][1]++,this.wrapperRef.current)&&(cov_24glixhpkj.b[1][2]++,!this.wrapperRef.current.contains(event.target))){cov_24glixhpkj.b[0][0]++;cov_24glixhpkj.s[6]++;this.props.onClickOutside();}else{cov_24glixhpkj.b[0][1]++;}}},{key:'render',value:function render(){cov_24glixhpkj.f[4]++;cov_24glixhpkj.s[7]++;if(!this.props.open){cov_24glixhpkj.b[2][0]++;cov_24glixhpkj.s[8]++;return null;}else{cov_24glixhpkj.b[2][1]++;}cov_24glixhpkj.s[9]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss___default.a.userNavItemPopover,ref:this.wrapperRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.onAuthLogoutOnServer,className:__WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss___default.a.userNavItemPopoverInner,'data-cy':'logout-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss___default.a.userNavItemPopoverIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Icon"],{content:'logout',type:'image',size:'16px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__UserNavItemPopover_scss___default.a.userNavItemPopoverText},this.props.translate('menu.logout'))));}}]);return UserNavItemPopover;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_24glixhpkj.s[10]++;var mapStateToProps=function mapStateToProps(state){cov_24glixhpkj.f[5]++;cov_24glixhpkj.s[11]++;return{translate:Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_24glixhpkj.s[12]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_24glixhpkj.f[6]++;cov_24glixhpkj.s[13]++;return{onAuthLogoutOnServer:function onAuthLogoutOnServer(){cov_24glixhpkj.f[7]++;cov_24glixhpkj.s[14]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["b" /* authLogoutOnServer */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(UserNavItemPopover));

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"userNavItemPopover":"UserNavItemPopover__userNavItemPopover___20624","userNavItemPopoverInner":"UserNavItemPopover__userNavItemPopoverInner___UKwWA","userNavItemPopoverIcon":"UserNavItemPopover__userNavItemPopoverIcon___3dQZH"};

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_scss__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Box_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Box_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_1hsf8k6k7s=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Box\\index.js',hash='b6c1419d9321dc7c1464e15167302963d1835f4c',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Box\\index.js',statementMap:{'0':{start:{line:8,column:12},end:{line:21,column:1}},'1':{start:{line:9,column:19},end:{line:9,column:33}},'2':{start:{line:11,column:2},end:{line:13,column:3}},'3':{start:{line:12,column:4},end:{line:12,column:53}},'4':{start:{line:16,column:2},end:{line:20,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:12},end:{line:8,column:13}},loc:{start:{line:8,column:23},end:{line:21,column:1}},line:8}},branchMap:{'0':{loc:{start:{line:11,column:2},end:{line:13,column:3}},type:'if',locations:[{start:{line:11,column:2},end:{line:13,column:3}},{start:{line:11,column:2},end:{line:13,column:3}}],line:11}},s:{'0':0,'1':0,'2':0,'3':0,'4':0},f:{'0':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1hsf8k6k7s.s[0]++;var Box=function Box(props){cov_1hsf8k6k7s.f[0]++;var classNames=(cov_1hsf8k6k7s.s[1]++,__WEBPACK_IMPORTED_MODULE_1__Box_scss___default.a.wrapper);cov_1hsf8k6k7s.s[2]++;if(props.align=='center'){cov_1hsf8k6k7s.b[0][0]++;cov_1hsf8k6k7s.s[3]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__Box_scss___default.a.isCentered;}else{cov_1hsf8k6k7s.b[0][1]++;}cov_1hsf8k6k7s.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},props.children);};/* harmony default export */ __webpack_exports__["default"] = (Box);

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Box__wrapper___1RWIo","isCentered":"Box__isCentered___mDR5-"};

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_localize_redux__ = __webpack_require__(10);
var cov_zazopp90t=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Confirm\\index.js',hash='471266462ff88601ae79e0f894afe936c49b18b0',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Confirm\\index.js',statementMap:{'0':{start:{line:10,column:8},end:{line:39,column:9}},'1':{start:{line:43,column:0},end:{line:45,column:2}},'2':{start:{line:47,column:0},end:{line:52,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:9,column:4},end:{line:9,column:5}},loc:{start:{line:9,column:14},end:{line:40,column:5}},line:9}},branchMap:{'0':{loc:{start:{line:12,column:53},end:{line:12,column:105}},type:'cond-expr',locations:[{start:{line:12,column:77},end:{line:12,column:98}},{start:{line:12,column:101},end:{line:12,column:105}}],line:12},'1':{loc:{start:{line:12,column:113},end:{line:12,column:150}},type:'cond-expr',locations:[{start:{line:12,column:131},end:{line:12,column:146}},{start:{line:12,column:149},end:{line:12,column:150}}],line:12},'2':{loc:{start:{line:16,column:25},end:{line:27,column:25}},type:'cond-expr',locations:[{start:{line:17,column:24},end:{line:24,column:30}},{start:{line:26,column:28},end:{line:26,column:120}}],line:16},'3':{loc:{start:{line:29,column:21},end:{line:36,column:28}},type:'cond-expr',locations:[{start:{line:30,column:22},end:{line:35,column:28}},{start:{line:36,column:24},end:{line:36,column:28}}],line:29}},s:{'0':0,'1':0,'2':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Confirm=function(_ref){_inherits(Confirm,_ref);function Confirm(){_classCallCheck(this,Confirm);return _possibleConstructorReturn(this,(Confirm.__proto__||Object.getPrototypeOf(Confirm)).apply(this,arguments));}_createClass(Confirm,[{key:'render',value:function render(){cov_zazopp90t.f[0]++;cov_zazopp90t.s[0]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Modal"],{blurClicked:this.props.onCancel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["GreyBox"],{valign:'center',msg_inside:this.props.msg_inside?(cov_zazopp90t.b[0][0]++,this.props.msg_inside):(cov_zazopp90t.b[0][1]++,null),cols:this.props.cols?(cov_zazopp90t.b[1][0]++,this.props.cols):(cov_zazopp90t.b[1][1]++,1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["BoxTitle"],null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Text"],null,this.props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Flex"],null,this.props.onCancel?(cov_zazopp90t.b[2][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Button"],{value:this.props.cancelButtonValue,onClick:this.props.onCancel,theme:'light',type:'button'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Button"],{value:this.props.confirmButtonValue,onClick:this.props.onConfirm,type:'button'})))):(cov_zazopp90t.b[2][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Button"],{value:this.props.confirmButtonValue,onClick:this.props.onConfirm,type:'button'}))),this.props.smallText?(cov_zazopp90t.b[3][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Text"],{size:'small',align:'center'},this.props.smallText))):(cov_zazopp90t.b[3][1]++,null)));}}]);return Confirm;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_zazopp90t.s[1]++;Confirm.propTypes={onConfirm:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};cov_zazopp90t.s[2]++;Confirm.defaultProps={title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["a" /* Translate */],{id:'global.confirm.title'}),text:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["a" /* Translate */],{id:'global.confirm.text'}),cancelButtonValue:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["a" /* Translate */],{id:'global.confirm.cancel'}),confirmButtonValue:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_localize_redux__["a" /* Translate */],{id:'global.confirm.confirm'})};/* harmony default export */ __webpack_exports__["default"] = (Confirm);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_scss__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_scss__);
var cov_2e50njywxi=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Form\\index.js',hash='0091a577a28bb9204d0cb876838544de1d58d5dd',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Form\\index.js',statementMap:{'0':{start:{line:6,column:13},end:{line:12,column:1}},'1':{start:{line:7,column:2},end:{line:11,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:6,column:13},end:{line:6,column:14}},loc:{start:{line:6,column:24},end:{line:12,column:1}},line:6}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_2e50njywxi.s[0]++;var Form=function Form(props){cov_2e50njywxi.f[0]++;cov_2e50njywxi.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:props.onSubmit},props.children);};/* harmony default export */ __webpack_exports__["default"] = (Form);

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"a_inputtext":"Form__a_inputtext___2SfX3"};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBox_scss__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_1pwfk8oscc=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\GreyBox\\index.js',hash='6ccbde81c81dbf08a86549990bdb794c3092376e',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\GreyBox\\index.js',statementMap:{'0':{start:{line:7,column:16},end:{line:100,column:1}},'1':{start:{line:8,column:20},end:{line:8,column:22}},'2':{start:{line:9,column:19},end:{line:9,column:33}},'3':{start:{line:10,column:20},end:{line:10,column:22}},'4':{start:{line:11,column:19},end:{line:11,column:21}},'5':{start:{line:13,column:2},end:{line:15,column:3}},'6':{start:{line:14,column:4},end:{line:14,column:45}},'7':{start:{line:19,column:2},end:{line:21,column:3}},'8':{start:{line:20,column:3},end:{line:20,column:78}},'9':{start:{line:23,column:20},end:{line:23,column:50}},'10':{start:{line:24,column:21},end:{line:35,column:29}},'11':{start:{line:38,column:22},end:{line:38,column:24}},'12':{start:{line:39,column:28},end:{line:39,column:30}},'13':{start:{line:40,column:20},end:{line:43,column:21}},'14':{start:{line:44,column:2},end:{line:46,column:3}},'15':{start:{line:45,column:4},end:{line:45,column:94}},'16':{start:{line:48,column:2},end:{line:50,column:3}},'17':{start:{line:49,column:4},end:{line:49,column:132}},'18':{start:{line:52,column:2},end:{line:54,column:3}},'19':{start:{line:53,column:4},end:{line:53,column:53}},'20':{start:{line:56,column:2},end:{line:58,column:3}},'21':{start:{line:57,column:4},end:{line:57,column:55}},'22':{start:{line:60,column:2},end:{line:62,column:3}},'23':{start:{line:61,column:4},end:{line:61,column:57}},'24':{start:{line:64,column:2},end:{line:66,column:3}},'25':{start:{line:65,column:4},end:{line:65,column:48}},'26':{start:{line:68,column:2},end:{line:70,column:3}},'27':{start:{line:69,column:4},end:{line:69,column:56}},'28':{start:{line:72,column:2},end:{line:74,column:3}},'29':{start:{line:73,column:4},end:{line:73,column:52}},'30':{start:{line:76,column:2},end:{line:78,column:3}},'31':{start:{line:77,column:4},end:{line:77,column:48}},'32':{start:{line:80,column:2},end:{line:82,column:3}},'33':{start:{line:81,column:4},end:{line:81,column:50}},'34':{start:{line:84,column:2},end:{line:86,column:3}},'35':{start:{line:85,column:4},end:{line:85,column:100}},'36':{start:{line:88,column:2},end:{line:99,column:2}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:16},end:{line:7,column:17}},loc:{start:{line:7,column:27},end:{line:100,column:1}},line:7}},branchMap:{'0':{loc:{start:{line:13,column:2},end:{line:15,column:3}},type:'if',locations:[{start:{line:13,column:2},end:{line:15,column:3}},{start:{line:13,column:2},end:{line:15,column:3}}],line:13},'1':{loc:{start:{line:19,column:2},end:{line:21,column:3}},type:'if',locations:[{start:{line:19,column:2},end:{line:21,column:3}},{start:{line:19,column:2},end:{line:21,column:3}}],line:19},'2':{loc:{start:{line:23,column:20},end:{line:23,column:50}},type:'cond-expr',locations:[{start:{line:23,column:38},end:{line:23,column:44}},{start:{line:23,column:47},end:{line:23,column:50}}],line:23},'3':{loc:{start:{line:28,column:25},end:{line:34,column:29}},type:'cond-expr',locations:[{start:{line:29,column:24},end:{line:33,column:37}},{start:{line:34,column:26},end:{line:34,column:29}}],line:28},'4':{loc:{start:{line:44,column:2},end:{line:46,column:3}},type:'if',locations:[{start:{line:44,column:2},end:{line:46,column:3}},{start:{line:44,column:2},end:{line:46,column:3}}],line:44},'5':{loc:{start:{line:48,column:2},end:{line:50,column:3}},type:'if',locations:[{start:{line:48,column:2},end:{line:50,column:3}},{start:{line:48,column:2},end:{line:50,column:3}}],line:48},'6':{loc:{start:{line:52,column:2},end:{line:54,column:3}},type:'if',locations:[{start:{line:52,column:2},end:{line:54,column:3}},{start:{line:52,column:2},end:{line:54,column:3}}],line:52},'7':{loc:{start:{line:56,column:2},end:{line:58,column:3}},type:'if',locations:[{start:{line:56,column:2},end:{line:58,column:3}},{start:{line:56,column:2},end:{line:58,column:3}}],line:56},'8':{loc:{start:{line:60,column:2},end:{line:62,column:3}},type:'if',locations:[{start:{line:60,column:2},end:{line:62,column:3}},{start:{line:60,column:2},end:{line:62,column:3}}],line:60},'9':{loc:{start:{line:64,column:2},end:{line:66,column:3}},type:'if',locations:[{start:{line:64,column:2},end:{line:66,column:3}},{start:{line:64,column:2},end:{line:66,column:3}}],line:64},'10':{loc:{start:{line:68,column:2},end:{line:70,column:3}},type:'if',locations:[{start:{line:68,column:2},end:{line:70,column:3}},{start:{line:68,column:2},end:{line:70,column:3}}],line:68},'11':{loc:{start:{line:72,column:2},end:{line:74,column:3}},type:'if',locations:[{start:{line:72,column:2},end:{line:74,column:3}},{start:{line:72,column:2},end:{line:74,column:3}}],line:72},'12':{loc:{start:{line:76,column:2},end:{line:78,column:3}},type:'if',locations:[{start:{line:76,column:2},end:{line:78,column:3}},{start:{line:76,column:2},end:{line:78,column:3}}],line:76},'13':{loc:{start:{line:80,column:2},end:{line:82,column:3}},type:'if',locations:[{start:{line:80,column:2},end:{line:82,column:3}},{start:{line:80,column:2},end:{line:82,column:3}}],line:80},'14':{loc:{start:{line:84,column:2},end:{line:86,column:3}},type:'if',locations:[{start:{line:84,column:2},end:{line:86,column:3}},{start:{line:84,column:2},end:{line:86,column:3}}],line:84}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0},f:{'0':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1pwfk8oscc.s[0]++;var GreyBox=function GreyBox(props){cov_1pwfk8oscc.f[0]++;var titleString=(cov_1pwfk8oscc.s[1]++,'');var classNames=(cov_1pwfk8oscc.s[2]++,__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.wrapper);var stepsString=(cov_1pwfk8oscc.s[3]++,'');var tabsString=(cov_1pwfk8oscc.s[4]++,'');cov_1pwfk8oscc.s[5]++;if(props.steps){cov_1pwfk8oscc.b[0][0]++;cov_1pwfk8oscc.s[6]++;stepsString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Steps"],{val:props.steps});}else{cov_1pwfk8oscc.b[0][1]++;}cov_1pwfk8oscc.s[7]++;if(props.title){cov_1pwfk8oscc.b[1][0]++;cov_1pwfk8oscc.s[8]++;titleString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["PageTitle"],{theme:props.titleTheme},props.title);}else{cov_1pwfk8oscc.b[1][1]++;}var headerWidth=(cov_1pwfk8oscc.s[9]++,props.closeIcon?(cov_1pwfk8oscc.b[2][0]++,'10*9'):(cov_1pwfk8oscc.b[2][1]++,'1'));var headerString=(cov_1pwfk8oscc.s[10]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:headerWidth},titleString),props.closeIcon?(cov_1pwfk8oscc.b[3][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["FlexColumn"],{col:'10*1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["ActionsNav"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:props.closeIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Icon"],{type:'image',content:'close',size:'16px'}))))):(cov_1pwfk8oscc.b[3][1]++,' ')));var messageString=(cov_1pwfk8oscc.s[11]++,'');var insideMessageString=(cov_1pwfk8oscc.s[12]++,'');var extraStyles=(cov_1pwfk8oscc.s[13]++,{backgroundColor:'',border:"none"});cov_1pwfk8oscc.s[14]++;if(props.msg){cov_1pwfk8oscc.b[4][0]++;cov_1pwfk8oscc.s[15]++;messageString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["GreyBoxMessage"],{type:props.msg.type},props.msg.message);}else{cov_1pwfk8oscc.b[4][1]++;}cov_1pwfk8oscc.s[16]++;if(props.msg_inside){cov_1pwfk8oscc.b[5][0]++;cov_1pwfk8oscc.s[17]++;insideMessageString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["GreyBoxMessage"],{type:props.msg_inside.type,position:'inside'},props.msg_inside.message);}else{cov_1pwfk8oscc.b[5][1]++;}cov_1pwfk8oscc.s[18]++;if(props.type=="fullWidth"){cov_1pwfk8oscc.b[6][0]++;cov_1pwfk8oscc.s[19]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.fullWidth;}else{cov_1pwfk8oscc.b[6][1]++;}cov_1pwfk8oscc.s[20]++;if(props.outerMargin){cov_1pwfk8oscc.b[7][0]++;cov_1pwfk8oscc.s[21]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.outerMargin;}else{cov_1pwfk8oscc.b[7][1]++;}cov_1pwfk8oscc.s[22]++;if(props.smallMargin){cov_1pwfk8oscc.b[8][0]++;cov_1pwfk8oscc.s[23]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.isSmallMargin;}else{cov_1pwfk8oscc.b[8][1]++;}cov_1pwfk8oscc.s[24]++;if(props.bgColor){cov_1pwfk8oscc.b[9][0]++;cov_1pwfk8oscc.s[25]++;extraStyles.backgroundColor=props.bgColor;}else{cov_1pwfk8oscc.b[9][1]++;}cov_1pwfk8oscc.s[26]++;if(props.borderColor){cov_1pwfk8oscc.b[10][0]++;cov_1pwfk8oscc.s[27]++;extraStyles.border="1px solid "+props.borderColor;}else{cov_1pwfk8oscc.b[10][1]++;}cov_1pwfk8oscc.s[28]++;if(props.valign=="center"){cov_1pwfk8oscc.b[11][0]++;cov_1pwfk8oscc.s[29]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.isCenter;}else{cov_1pwfk8oscc.b[11][1]++;}cov_1pwfk8oscc.s[30]++;if(props.cols=="2"){cov_1pwfk8oscc.b[12][0]++;cov_1pwfk8oscc.s[31]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.col2;}else{cov_1pwfk8oscc.b[12][1]++;}cov_1pwfk8oscc.s[32]++;if(props.noPrint){cov_1pwfk8oscc.b[13][0]++;cov_1pwfk8oscc.s[33]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.noPrint;}else{cov_1pwfk8oscc.b[13][1]++;}cov_1pwfk8oscc.s[34]++;if(props.tabs){cov_1pwfk8oscc.b[14][0]++;cov_1pwfk8oscc.s[35]++;tabsString=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components__["Tabs"],{val:props.tabs,onTabClicked:props.onTabClicked,theme:props.titleTheme});}else{cov_1pwfk8oscc.b[14][1]++;}cov_1pwfk8oscc.s[36]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},headerString,stepsString,messageString,tabsString,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1__GreyBox_scss___default.a.greybox,style:extraStyles},insideMessageString,props.children));};/* harmony default export */ __webpack_exports__["default"] = (GreyBox);

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GreyBox__wrapper___33Nwk","isSmallMargin":"GreyBox__isSmallMargin___2d-xy","greybox":"GreyBox__greybox___3770U","outerMargin":"GreyBox__outerMargin___1LW2w","col2":"GreyBox__col2___1zjdu","fullWidth":"GreyBox__fullWidth___1VoCn","isCenter":"GreyBox__isCenter___35eXV","noPrint":"GreyBox__noPrint___iWaHu"};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_scss__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_scss__);
var cov_29tdki08c4=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Header\\index.js',hash='9cf63da44270a23136432ff6624e49e9dce80da2',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Header\\index.js',statementMap:{'0':{start:{line:8,column:15},end:{line:16,column:1}},'1':{start:{line:9,column:2},end:{line:15,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:8,column:15},end:{line:8,column:16}},loc:{start:{line:8,column:26},end:{line:16,column:1}},line:8}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_29tdki08c4.s[0]++;var Header=function Header(props){cov_29tdki08c4.f[0]++;cov_29tdki08c4.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__Header_scss___default.a.header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["Logo"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["MainNav"],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["MetaNav"],null));};/* harmony default export */ __webpack_exports__["default"] = (Header);

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header___34z-4","column":"Header__column___2Mj4G"};

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
var cov_19d668faw6=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Loading\\index.js',hash='a71af9f9673024778e836d02398fabb3e11da96f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Loading\\index.js',statementMap:{'0':{start:{line:8,column:8},end:{line:8,column:96}},'1':{start:{line:12,column:8},end:{line:16,column:9}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:7,column:4},end:{line:7,column:5}},loc:{start:{line:7,column:51},end:{line:9,column:5}},line:7},'1':{name:'(anonymous_1)',decl:{start:{line:11,column:4},end:{line:11,column:5}},loc:{start:{line:11,column:14},end:{line:17,column:5}},line:11}},branchMap:{'0':{loc:{start:{line:8,column:15},end:{line:8,column:95}},type:'binary-expr',locations:[{start:{line:8,column:15},end:{line:8,column:49}},{start:{line:8,column:53},end:{line:8,column:95}}],line:8}},s:{'0':0,'1':0},f:{'0':0,'1':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loading=function(_ref){_inherits(Loading,_ref);function Loading(){_classCallCheck(this,Loading);return _possibleConstructorReturn(this,(Loading.__proto__||Object.getPrototypeOf(Loading)).apply(this,arguments));}_createClass(Loading,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){cov_19d668faw6.f[0]++;cov_19d668faw6.s[0]++;return(cov_19d668faw6.b[0][0]++,nextProps.show!==this.props.show)||(cov_19d668faw6.b[0][1]++,nextProps.children!==this.props.children);}},{key:'render',value:function render(){cov_19d668faw6.f[1]++;cov_19d668faw6.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["Blur"],{show:'true',theme:'light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["Spinner"],{theme:'light'}));}}]);return Loading;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (Loading);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Machine_scss__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Machine_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Machine_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
var cov_1fhkb4pkws=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Machine\\index.js',hash='4e483dc18d13b3b25df9fa1e310f5fddf95ea006',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Machine\\index.js',statementMap:{'0':{start:{line:12,column:21},end:{line:12,column:35}},'1':{start:{line:13,column:4},end:{line:15,column:5}},'2':{start:{line:14,column:6},end:{line:14,column:52}},'3':{start:{line:17,column:4},end:{line:46,column:5}},'4':{start:{line:19,column:6},end:{line:24,column:7}},'5':{start:{line:27,column:6},end:{line:45,column:7}},'6':{start:{line:50,column:24},end:{line:54,column:1}},'7':{start:{line:51,column:4},end:{line:53,column:6}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:11,column:2},end:{line:11,column:3}},loc:{start:{line:11,column:11},end:{line:47,column:3}},line:11},'1':{name:'(anonymous_1)',decl:{start:{line:50,column:24},end:{line:50,column:25}},loc:{start:{line:50,column:33},end:{line:54,column:1}},line:50}},branchMap:{'0':{loc:{start:{line:13,column:4},end:{line:15,column:5}},type:'if',locations:[{start:{line:13,column:4},end:{line:15,column:5}},{start:{line:13,column:4},end:{line:15,column:5}}],line:13},'1':{loc:{start:{line:17,column:4},end:{line:46,column:5}},type:'if',locations:[{start:{line:17,column:4},end:{line:46,column:5}},{start:{line:17,column:4},end:{line:46,column:5}}],line:17},'2':{loc:{start:{line:29,column:26},end:{line:29,column:109}},type:'cond-expr',locations:[{start:{line:29,column:58},end:{line:29,column:96}},{start:{line:29,column:99},end:{line:29,column:109}}],line:29},'3':{loc:{start:{line:31,column:82},end:{line:31,column:215}},type:'cond-expr',locations:[{start:{line:31,column:113},end:{line:31,column:165}},{start:{line:31,column:168},end:{line:31,column:215}}],line:31}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0},f:{'0':0,'1':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Machine=function(_ref){_inherits(Machine,_ref);function Machine(){_classCallCheck(this,Machine);return _possibleConstructorReturn(this,(Machine.__proto__||Object.getPrototypeOf(Machine)).apply(this,arguments));}_createClass(Machine,[{key:'render',value:function render(){cov_1fhkb4pkws.f[0]++;var classNames=(cov_1fhkb4pkws.s[0]++,__WEBPACK_IMPORTED_MODULE_2__Machine_scss___default.a.machine);cov_1fhkb4pkws.s[1]++;if(this.props.theme=='light'){cov_1fhkb4pkws.b[0][0]++;cov_1fhkb4pkws.s[2]++;classNames=classNames+' '+__WEBPACK_IMPORTED_MODULE_2__Machine_scss___default.a.isLight;}else{cov_1fhkb4pkws.b[0][1]++;}cov_1fhkb4pkws.s[3]++;if(this.props.type=='addnew'){cov_1fhkb4pkws.b[1][0]++;cov_1fhkb4pkws.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Spacer"],{height:'30px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Button"],{'data-cy':'new-machine-btn',value:this.props.translate('machinespage.new.label'),href:'/machines/new'}));}else{cov_1fhkb4pkws.b[1][1]++;cov_1fhkb4pkws.s[5]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_2__Machine_scss___default.a.machineLink,to:'/machines/'+this.props.machine.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.machine.incomplete?(cov_1fhkb4pkws.b[2][0]++,[classNames,__WEBPACK_IMPORTED_MODULE_2__Machine_scss___default.a.batch].join(' ')):(cov_1fhkb4pkws.b[2][1]++,classNames)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["BoxTitle"],{ellipsis:'140px',type:'nopadding'},this.props.machine.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Text"],{fontCut:'light',color:'#2F2D2F'},this.props.machine.heads,' ',this.props.machine.heads>1?(cov_1fhkb4pkws.b[3][0]++,this.props.translate('global.machine.head.multiple')):(cov_1fhkb4pkws.b[3][1]++,this.props.translate('global.machine.head.one'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Spacer"],{height:'12px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["DonutChart"],{size:'115',align:'center',fontSizeL:'30px',fontSizeS:'10px',value:this.props.machine.avg_efficiency,valuelabel:this.props.translate('global.machine.avg_efficiency'),value0label:this.props.translate('global.machine.not_used'),strokewidth:'12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2__Machine_scss___default.a.delete,onClick:this.props.onDeleteHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components__["Icon"],{type:'image',size:'23px',content:'delete'}))));}}}]);return Machine;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1fhkb4pkws.s[6]++;var mapStateToProps=function mapStateToProps(state){cov_1fhkb4pkws.f[1]++;cov_1fhkb4pkws.s[7]++;return{translate:Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* getTranslate */])(state.locale)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Machine));

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"machineLink":"Machine__machineLink___2Q5LD","machine":"Machine__machine___24l8E","batch":"Machine__batch___1BrhW","delete":"Machine__delete___3KqA1","isLight":"Machine__isLight___1XU2X"};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_scss__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Menu_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
var cov_1ud2g0tciz=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Menu\\index.js',hash='a9f45cbba8be67e47e8d5986a8f1395b8e615cb6',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Menu\\index.js',statementMap:{'0':{start:{line:14,column:2},end:{line:16,column:3}},'1':{start:{line:15,column:12},end:{line:15,column:88}},'2':{start:{line:20,column:8},end:{line:56,column:9}},'3':{start:{line:21,column:12},end:{line:52,column:13}},'4':{start:{line:55,column:12},end:{line:55,column:24}},'5':{start:{line:60,column:24},end:{line:66,column:1}},'6':{start:{line:61,column:4},end:{line:65,column:6}},'7':{start:{line:68,column:27},end:{line:72,column:1}},'8':{start:{line:69,column:4},end:{line:71,column:5}},'9':{start:{line:70,column:27},end:{line:70,column:70}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:4},end:{line:13,column:5}},loc:{start:{line:13,column:25},end:{line:17,column:2}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:19,column:4},end:{line:19,column:5}},loc:{start:{line:19,column:14},end:{line:57,column:5}},line:19},'2':{name:'(anonymous_2)',decl:{start:{line:60,column:24},end:{line:60,column:25}},loc:{start:{line:60,column:33},end:{line:66,column:1}},line:60},'3':{name:'(anonymous_3)',decl:{start:{line:68,column:27},end:{line:68,column:28}},loc:{start:{line:68,column:39},end:{line:72,column:1}},line:68},'4':{name:'(anonymous_4)',decl:{start:{line:70,column:21},end:{line:70,column:22}},loc:{start:{line:70,column:27},end:{line:70,column:70}},line:70}},branchMap:{'0':{loc:{start:{line:14,column:2},end:{line:16,column:3}},type:'if',locations:[{start:{line:14,column:2},end:{line:16,column:3}},{start:{line:14,column:2},end:{line:16,column:3}}],line:14},'1':{loc:{start:{line:20,column:8},end:{line:56,column:9}},type:'if',locations:[{start:{line:20,column:8},end:{line:56,column:9}},{start:{line:20,column:8},end:{line:56,column:9}}],line:20}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0,0],'1':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Menu=function(_ref){_inherits(Menu,_ref);function Menu(){_classCallCheck(this,Menu);return _possibleConstructorReturn(this,(Menu.__proto__||Object.getPrototypeOf(Menu)).apply(this,arguments));}_createClass(Menu,[{key:'componentDidUpdate',value:function componentDidUpdate(){cov_1ud2g0tciz.f[0]++;cov_1ud2g0tciz.s[0]++;if(this.props.auth.error){cov_1ud2g0tciz.b[0][0]++;cov_1ud2g0tciz.s[1]++;__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].error("Internal server error","We're sorry, but an error occurred");}else{cov_1ud2g0tciz.b[0][1]++;}}},{key:'render',value:function render(){cov_1ud2g0tciz.f[1]++;cov_1ud2g0tciz.s[2]++;if(this.props.state.open){cov_1ud2g0tciz.b[1][0]++;cov_1ud2g0tciz.s[3]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Modal"],{blurClicked:this.props.onCloseMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.menu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["ActionsNav"],{inModal:'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.props.onCloseMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Icon"],{type:'image',content:'close',size:'16px'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.item__fullWidth+' '+__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.isHiddenDesktop,to:'/jobs',onClick:this.props.onCloseMenu},this.props.translate('menu.jobs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.item__fullWidth+' '+__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.isHiddenDesktop,to:'/machines',onClick:this.props.onCloseMenu},this.props.translate('menu.machines')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.translate('menu.help_link'),target:'_blank',className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.item__fullWidth+' '+__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.isHiddenDesktop,onClick:this.props.onCloseMenu},this.props.translate('menu.help')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.isHiddenDesktop},this.props.translate('menu.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.item,to:'/settings/jobpresets',onClick:this.props.onCloseMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Icon"],{type:'image',content:'menusettings',size:'41px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.translate('menu.job_presets'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:__WEBPACK_IMPORTED_MODULE_4__Menu_scss___default.a.item,to:'/settings/company',onClick:this.props.onCloseMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Icon"],{type:'image',content:'company',size:'41px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.translate('menu.company')))));}else{cov_1ud2g0tciz.b[1][1]++;cov_1ud2g0tciz.s[4]++;return null;}}}]);return Menu;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1ud2g0tciz.s[5]++;var mapStateToProps=function mapStateToProps(state){cov_1ud2g0tciz.f[2]++;cov_1ud2g0tciz.s[6]++;return{state:state.helpersMenu,auth:state.auth,translate:Object(__WEBPACK_IMPORTED_MODULE_3_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_1ud2g0tciz.s[7]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_1ud2g0tciz.f[3]++;cov_1ud2g0tciz.s[8]++;return{onCloseMenu:function onCloseMenu(){cov_1ud2g0tciz.f[4]++;cov_1ud2g0tciz.s[9]++;return dispatch(__WEBPACK_IMPORTED_MODULE_6__store_actions_index__["X" /* helpersMenuClose */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Menu));

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menu":"Menu__menu___2qsLh","isHiddenDesktop":"Menu__isHiddenDesktop___2iZT5","item":"Menu__item___1F8ui","item__double":"Menu__item__double___aB-eU","item__fullWidth":"Menu__item__fullWidth___17JVs"};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_scss__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__molecules_Blur__ = __webpack_require__(225);
var cov_29o4roxvdp=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Modal\\index.js',hash='d48df6b24b52b9c43220003b5af2104b7c4d9804',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\organisms\\Modal\\index.js',statementMap:{'0':{start:{line:11,column:8},end:{line:11,column:58}},'1':{start:{line:19,column:8},end:{line:19,column:75}},'2':{start:{line:23,column:8},end:{line:23,column:73}},'3':{start:{line:27,column:25},end:{line:27,column:27}},'4':{start:{line:28,column:8},end:{line:30,column:9}},'5':{start:{line:29,column:12},end:{line:29,column:37}},'6':{start:{line:31,column:8},end:{line:39,column:9}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:10,column:4},end:{line:10,column:5}},loc:{start:{line:10,column:51},end:{line:12,column:5}},line:10},'1':{name:'(anonymous_1)',decl:{start:{line:14,column:4},end:{line:14,column:5}},loc:{start:{line:14,column:27},end:{line:16,column:5}},line:14},'2':{name:'(anonymous_2)',decl:{start:{line:18,column:4},end:{line:18,column:5}},loc:{start:{line:18,column:25},end:{line:20,column:5}},line:18},'3':{name:'(anonymous_3)',decl:{start:{line:22,column:4},end:{line:22,column:5}},loc:{start:{line:22,column:28},end:{line:24,column:5}},line:22},'4':{name:'(anonymous_4)',decl:{start:{line:26,column:4},end:{line:26,column:5}},loc:{start:{line:26,column:14},end:{line:40,column:5}},line:26}},branchMap:{'0':{loc:{start:{line:28,column:8},end:{line:30,column:9}},type:'if',locations:[{start:{line:28,column:8},end:{line:30,column:9}},{start:{line:28,column:8},end:{line:30,column:9}}],line:28}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_ref){_inherits(Modal,_ref);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){cov_29o4roxvdp.f[0]++;cov_29o4roxvdp.s[0]++;return nextProps.children!==this.props.children;}},{key:'componentWillUpdate',value:function componentWillUpdate(){//console.log('[Modal] WillUpdate');
cov_29o4roxvdp.f[1]++;}},{key:'componentDidMount',value:function componentDidMount(){cov_29o4roxvdp.f[2]++;cov_29o4roxvdp.s[1]++;document.getElementsByTagName("body")[0].style.overflow="hidden";}},{key:'componentWillUnmount',value:function componentWillUnmount(){cov_29o4roxvdp.f[3]++;cov_29o4roxvdp.s[2]++;document.getElementsByTagName("body")[0].style.overflow="auto";}},{key:'render',value:function render(){cov_29o4roxvdp.f[4]++;var classNames=(cov_29o4roxvdp.s[3]++,"");cov_29o4roxvdp.s[4]++;if(this.props.theme=="light"){cov_29o4roxvdp.b[0][0]++;cov_29o4roxvdp.s[5]++;classNames=__WEBPACK_IMPORTED_MODULE_1__Modal_scss___default.a.light;}else{cov_29o4roxvdp.b[0][1]++;}cov_29o4roxvdp.s[6]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__molecules_Blur__["default"],{clicked:this.props.blurClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classNames},this.props.children)));}}]);return Modal;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),
/* 663 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"light":"Modal__light___pABDf"};

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EditJobModal__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExportJobModal__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DetailedCalculationModal__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__ = __webpack_require__(112);
var cov_sqsn1mzg0=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\index.js',hash='76345cb0b19a13cf8a512f08864928e15fa1865f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\index.js',statementMap:{'0':{start:{line:44,column:2},end:{line:44,column:33}},'1':{start:{line:47,column:2},end:{line:47,column:41}},'2':{start:{line:48,column:2},end:{line:48,column:53}},'3':{start:{line:49,column:2},end:{line:49,column:42}},'4':{start:{line:50,column:2},end:{line:50,column:48}},'5':{start:{line:51,column:2},end:{line:51,column:43}},'6':{start:{line:52,column:2},end:{line:52,column:47}},'7':{start:{line:55,column:2},end:{line:80,column:3}},'8':{start:{line:56,column:3},end:{line:61,column:6}},'9':{start:{line:63,column:7},end:{line:80,column:3}},'10':{start:{line:64,column:3},end:{line:66,column:6}},'11':{start:{line:68,column:7},end:{line:80,column:3}},'12':{start:{line:69,column:3},end:{line:74,column:6}},'13':{start:{line:76,column:7},end:{line:80,column:3}},'14':{start:{line:77,column:3},end:{line:79,column:6}},'15':{start:{line:81,column:2},end:{line:86,column:3}},'16':{start:{line:83,column:3},end:{line:85,column:16}},'17':{start:{line:83,column:31},end:{line:85,column:13}},'18':{start:{line:84,column:102},end:{line:84,column:120}},'19':{start:{line:87,column:2},end:{line:90,column:3}},'20':{start:{line:88,column:3},end:{line:88,column:34}},'21':{start:{line:89,column:3},end:{line:89,column:49}},'22':{start:{line:91,column:2},end:{line:94,column:3}},'23':{start:{line:92,column:3},end:{line:92,column:34}},'24':{start:{line:93,column:3},end:{line:93,column:48}},'25':{start:{line:95,column:2},end:{line:98,column:3}},'26':{start:{line:96,column:3},end:{line:96,column:312}},'27':{start:{line:97,column:3},end:{line:97,column:44}},'28':{start:{line:99,column:2},end:{line:101,column:3}},'29':{start:{line:100,column:3},end:{line:100,column:26}},'30':{start:{line:105,column:2},end:{line:105,column:62}},'31':{start:{line:106,column:2},end:{line:106,column:74}},'32':{start:{line:109,column:5},end:{line:109,column:28}},'33':{start:{line:110,column:5},end:{line:110,column:41}},'34':{start:{line:113,column:5},end:{line:113,column:28}},'35':{start:{line:114,column:5},end:{line:114,column:40}},'36':{start:{line:117,column:5},end:{line:117,column:28}},'37':{start:{line:118,column:5},end:{line:118,column:79}},'38':{start:{line:121,column:20},end:{line:121,column:38}},'39':{start:{line:122,column:8},end:{line:122,column:114}},'40':{start:{line:125,column:3},end:{line:127,column:12}},'41':{start:{line:125,column:31},end:{line:127,column:9}},'42':{start:{line:126,column:98},end:{line:126,column:119}},'43':{start:{line:130,column:5},end:{line:130,column:28}},'44':{start:{line:131,column:3},end:{line:131,column:82}},'45':{start:{line:134,column:3},end:{line:134,column:26}},'46':{start:{line:135,column:3},end:{line:140,column:5}},'47':{start:{line:143,column:3},end:{line:145,column:5}},'48':{start:{line:149,column:2},end:{line:172,column:3}},'49':{start:{line:150,column:6},end:{line:156,column:7}},'50':{start:{line:151,column:7},end:{line:151,column:58}},'51':{start:{line:152,column:13},end:{line:156,column:7}},'52':{start:{line:153,column:7},end:{line:153,column:58}},'53':{start:{line:155,column:7},end:{line:155,column:58}},'54':{start:{line:160,column:21},end:{line:160,column:26}},'55':{start:{line:161,column:6},end:{line:165,column:7}},'56':{start:{line:162,column:7},end:{line:162,column:24}},'57':{start:{line:164,column:7},end:{line:164,column:23}},'58':{start:{line:167,column:3},end:{line:169,column:13}},'59':{start:{line:167,column:31},end:{line:169,column:10}},'60':{start:{line:171,column:6},end:{line:171,column:25}},'61':{start:{line:177,column:16},end:{line:177,column:36}},'62':{start:{line:178,column:17},end:{line:178,column:53}},'63':{start:{line:179,column:3},end:{line:179,column:17}},'64':{start:{line:182,column:2},end:{line:182,column:43}},'65':{start:{line:183,column:2},end:{line:436,column:3}},'66':{start:{line:184,column:6},end:{line:186,column:7}},'67':{start:{line:189,column:3},end:{line:193,column:10}},'68':{start:{line:190,column:13},end:{line:192,column:14}},'69':{start:{line:191,column:14},end:{line:191,column:38}},'70':{start:{line:194,column:24},end:{line:194,column:26}},'71':{start:{line:195,column:3},end:{line:203,column:4}},'72':{start:{line:196,column:4},end:{line:196,column:74}},'73':{start:{line:198,column:8},end:{line:203,column:4}},'74':{start:{line:199,column:4},end:{line:199,column:35}},'75':{start:{line:201,column:8},end:{line:203,column:4}},'76':{start:{line:202,column:4},end:{line:202,column:195}},'77':{start:{line:204,column:17},end:{line:204,column:19}},'78':{start:{line:205,column:3},end:{line:209,column:4}},'79':{start:{line:206,column:4},end:{line:208,column:5}},'80':{start:{line:210,column:29},end:{line:210,column:31}},'81':{start:{line:211,column:3},end:{line:215,column:4}},'82':{start:{line:212,column:4},end:{line:214,column:5}},'83':{start:{line:216,column:3},end:{line:435,column:4}},'84':{start:{line:298,column:67},end:{line:298,column:80}},'85':{start:{line:393,column:9},end:{line:426,column:27}},'86':{start:{line:440,column:24},end:{line:448,column:1}},'87':{start:{line:441,column:4},end:{line:447,column:6}},'88':{start:{line:450,column:27},end:{line:464,column:1}},'89':{start:{line:451,column:4},end:{line:463,column:5}},'90':{start:{line:452,column:38},end:{line:452,column:85}},'91':{start:{line:453,column:41},end:{line:453,column:91}},'92':{start:{line:454,column:43},end:{line:454,column:95}},'93':{start:{line:455,column:50},end:{line:455,column:109}},'94':{start:{line:456,column:53},end:{line:456,column:115}},'95':{start:{line:457,column:42},end:{line:457,column:93}},'96':{start:{line:458,column:39},end:{line:458,column:87}},'97':{start:{line:459,column:55},end:{line:459,column:119}},'98':{start:{line:460,column:48},end:{line:460,column:105}},'99':{start:{line:461,column:44},end:{line:461,column:98}},'100':{start:{line:462,column:47},end:{line:462,column:103}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:43,column:1},end:{line:43,column:2}},loc:{start:{line:43,column:21},end:{line:45,column:2}},line:43},'1':{name:'(anonymous_1)',decl:{start:{line:46,column:1},end:{line:46,column:2}},loc:{start:{line:46,column:24},end:{line:53,column:2}},line:46},'2':{name:'(anonymous_2)',decl:{start:{line:54,column:22},end:{line:54,column:23}},loc:{start:{line:54,column:58},end:{line:102,column:2}},line:54},'3':{name:'(anonymous_3)',decl:{start:{line:83,column:17},end:{line:83,column:18}},loc:{start:{line:83,column:31},end:{line:85,column:13}},line:83},'4':{name:'(anonymous_4)',decl:{start:{line:84,column:87},end:{line:84,column:88}},loc:{start:{line:84,column:102},end:{line:84,column:120}},line:84},'5':{name:'(anonymous_5)',decl:{start:{line:104,column:27},end:{line:104,column:28}},loc:{start:{line:104,column:33},end:{line:107,column:2}},line:104},'6':{name:'(anonymous_6)',decl:{start:{line:108,column:28},end:{line:108,column:29}},loc:{start:{line:108,column:41},end:{line:111,column:5}},line:108},'7':{name:'(anonymous_7)',decl:{start:{line:112,column:29},end:{line:112,column:30}},loc:{start:{line:112,column:42},end:{line:115,column:5}},line:112},'8':{name:'(anonymous_8)',decl:{start:{line:116,column:22},end:{line:116,column:23}},loc:{start:{line:116,column:35},end:{line:119,column:5}},line:116},'9':{name:'(anonymous_9)',decl:{start:{line:120,column:21},end:{line:120,column:22}},loc:{start:{line:120,column:49},end:{line:123,column:3}},line:120},'10':{name:'(anonymous_10)',decl:{start:{line:124,column:27},end:{line:124,column:28}},loc:{start:{line:124,column:45},end:{line:128,column:3}},line:124},'11':{name:'(anonymous_11)',decl:{start:{line:125,column:17},end:{line:125,column:18}},loc:{start:{line:125,column:31},end:{line:127,column:9}},line:125},'12':{name:'(anonymous_12)',decl:{start:{line:126,column:83},end:{line:126,column:84}},loc:{start:{line:126,column:98},end:{line:126,column:119}},line:126},'13':{name:'(anonymous_13)',decl:{start:{line:129,column:23},end:{line:129,column:24}},loc:{start:{line:129,column:34},end:{line:132,column:3}},line:129},'14':{name:'(anonymous_14)',decl:{start:{line:133,column:33},end:{line:133,column:34}},loc:{start:{line:133,column:44},end:{line:141,column:3}},line:133},'15':{name:'(anonymous_15)',decl:{start:{line:142,column:39},end:{line:142,column:40}},loc:{start:{line:142,column:45},end:{line:146,column:3}},line:142},'16':{name:'(anonymous_16)',decl:{start:{line:148,column:1},end:{line:148,column:2}},loc:{start:{line:148,column:10},end:{line:173,column:2}},line:148},'17':{name:'(anonymous_17)',decl:{start:{line:167,column:17},end:{line:167,column:18}},loc:{start:{line:167,column:31},end:{line:169,column:10}},line:167},'18':{name:'(anonymous_18)',decl:{start:{line:175,column:1},end:{line:175,column:2}},loc:{start:{line:175,column:23},end:{line:180,column:2}},line:175},'19':{name:'(anonymous_19)',decl:{start:{line:181,column:1},end:{line:181,column:2}},loc:{start:{line:181,column:10},end:{line:437,column:2}},line:181},'20':{name:'(anonymous_20)',decl:{start:{line:298,column:60},end:{line:298,column:61}},loc:{start:{line:298,column:67},end:{line:298,column:80}},line:298},'21':{name:'(anonymous_21)',decl:{start:{line:392,column:60},end:{line:392,column:61}},loc:{start:{line:393,column:9},end:{line:426,column:27}},line:393},'22':{name:'(anonymous_22)',decl:{start:{line:440,column:24},end:{line:440,column:25}},loc:{start:{line:440,column:33},end:{line:448,column:1}},line:440},'23':{name:'(anonymous_23)',decl:{start:{line:450,column:27},end:{line:450,column:28}},loc:{start:{line:450,column:39},end:{line:464,column:1}},line:450},'24':{name:'(anonymous_24)',decl:{start:{line:452,column:30},end:{line:452,column:31}},loc:{start:{line:452,column:38},end:{line:452,column:85}},line:452},'25':{name:'(anonymous_25)',decl:{start:{line:453,column:35},end:{line:453,column:36}},loc:{start:{line:453,column:41},end:{line:453,column:91}},line:453},'26':{name:'(anonymous_26)',decl:{start:{line:454,column:37},end:{line:454,column:38}},loc:{start:{line:454,column:43},end:{line:454,column:95}},line:454},'27':{name:'(anonymous_27)',decl:{start:{line:455,column:42},end:{line:455,column:43}},loc:{start:{line:455,column:50},end:{line:455,column:109}},line:455},'28':{name:'(anonymous_28)',decl:{start:{line:456,column:47},end:{line:456,column:48}},loc:{start:{line:456,column:53},end:{line:456,column:115}},line:456},'29':{name:'(anonymous_29)',decl:{start:{line:457,column:36},end:{line:457,column:37}},loc:{start:{line:457,column:42},end:{line:457,column:93}},line:457},'30':{name:'(anonymous_30)',decl:{start:{line:458,column:31},end:{line:458,column:32}},loc:{start:{line:458,column:39},end:{line:458,column:87}},line:458},'31':{name:'(anonymous_31)',decl:{start:{line:459,column:37},end:{line:459,column:38}},loc:{start:{line:459,column:55},end:{line:459,column:119}},line:459},'32':{name:'(anonymous_32)',decl:{start:{line:460,column:42},end:{line:460,column:43}},loc:{start:{line:460,column:48},end:{line:460,column:105}},line:460},'33':{name:'(anonymous_33)',decl:{start:{line:461,column:36},end:{line:461,column:37}},loc:{start:{line:461,column:44},end:{line:461,column:98}},line:461},'34':{name:'(anonymous_34)',decl:{start:{line:462,column:41},end:{line:462,column:42}},loc:{start:{line:462,column:47},end:{line:462,column:103}},line:462}},branchMap:{'0':{loc:{start:{line:55,column:2},end:{line:80,column:3}},type:'if',locations:[{start:{line:55,column:2},end:{line:80,column:3}},{start:{line:55,column:2},end:{line:80,column:3}}],line:55},'1':{loc:{start:{line:55,column:5},end:{line:55,column:72}},type:'binary-expr',locations:[{start:{line:55,column:5},end:{line:55,column:26}},{start:{line:55,column:30},end:{line:55,column:72}}],line:55},'2':{loc:{start:{line:63,column:7},end:{line:80,column:3}},type:'if',locations:[{start:{line:63,column:7},end:{line:80,column:3}},{start:{line:63,column:7},end:{line:80,column:3}}],line:63},'3':{loc:{start:{line:63,column:10},end:{line:63,column:76}},type:'binary-expr',locations:[{start:{line:63,column:10},end:{line:63,column:30}},{start:{line:63,column:34},end:{line:63,column:76}}],line:63},'4':{loc:{start:{line:68,column:7},end:{line:80,column:3}},type:'if',locations:[{start:{line:68,column:7},end:{line:80,column:3}},{start:{line:68,column:7},end:{line:80,column:3}}],line:68},'5':{loc:{start:{line:68,column:10},end:{line:68,column:81}},type:'binary-expr',locations:[{start:{line:68,column:10},end:{line:68,column:33}},{start:{line:68,column:37},end:{line:68,column:81}}],line:68},'6':{loc:{start:{line:76,column:7},end:{line:80,column:3}},type:'if',locations:[{start:{line:76,column:7},end:{line:80,column:3}},{start:{line:76,column:7},end:{line:80,column:3}}],line:76},'7':{loc:{start:{line:76,column:10},end:{line:76,column:80}},type:'binary-expr',locations:[{start:{line:76,column:10},end:{line:76,column:32}},{start:{line:76,column:36},end:{line:76,column:80}}],line:76},'8':{loc:{start:{line:81,column:2},end:{line:86,column:3}},type:'if',locations:[{start:{line:81,column:2},end:{line:86,column:3}},{start:{line:81,column:2},end:{line:86,column:3}}],line:81},'9':{loc:{start:{line:81,column:5},end:{line:81,column:99}},type:'binary-expr',locations:[{start:{line:81,column:5},end:{line:81,column:50}},{start:{line:81,column:54},end:{line:81,column:99}}],line:81},'10':{loc:{start:{line:87,column:2},end:{line:90,column:3}},type:'if',locations:[{start:{line:87,column:2},end:{line:90,column:3}},{start:{line:87,column:2},end:{line:90,column:3}}],line:87},'11':{loc:{start:{line:87,column:5},end:{line:87,column:91}},type:'binary-expr',locations:[{start:{line:87,column:5},end:{line:87,column:46}},{start:{line:87,column:50},end:{line:87,column:91}}],line:87},'12':{loc:{start:{line:91,column:2},end:{line:94,column:3}},type:'if',locations:[{start:{line:91,column:2},end:{line:94,column:3}},{start:{line:91,column:2},end:{line:94,column:3}}],line:91},'13':{loc:{start:{line:91,column:5},end:{line:91,column:91}},type:'binary-expr',locations:[{start:{line:91,column:5},end:{line:91,column:46}},{start:{line:91,column:50},end:{line:91,column:91}}],line:91},'14':{loc:{start:{line:95,column:2},end:{line:98,column:3}},type:'if',locations:[{start:{line:95,column:2},end:{line:98,column:3}},{start:{line:95,column:2},end:{line:98,column:3}}],line:95},'15':{loc:{start:{line:95,column:5},end:{line:95,column:122}},type:'binary-expr',locations:[{start:{line:95,column:5},end:{line:95,column:82}},{start:{line:95,column:86},end:{line:95,column:122}}],line:95},'16':{loc:{start:{line:99,column:2},end:{line:101,column:3}},type:'if',locations:[{start:{line:99,column:2},end:{line:101,column:3}},{start:{line:99,column:2},end:{line:101,column:3}}],line:99},'17':{loc:{start:{line:149,column:2},end:{line:172,column:3}},type:'if',locations:[{start:{line:149,column:2},end:{line:172,column:3}},{start:{line:149,column:2},end:{line:172,column:3}}],line:149},'18':{loc:{start:{line:150,column:6},end:{line:156,column:7}},type:'if',locations:[{start:{line:150,column:6},end:{line:156,column:7}},{start:{line:150,column:6},end:{line:156,column:7}}],line:150},'19':{loc:{start:{line:152,column:13},end:{line:156,column:7}},type:'if',locations:[{start:{line:152,column:13},end:{line:156,column:7}},{start:{line:152,column:13},end:{line:156,column:7}}],line:152},'20':{loc:{start:{line:161,column:6},end:{line:165,column:7}},type:'if',locations:[{start:{line:161,column:6},end:{line:165,column:7}},{start:{line:161,column:6},end:{line:165,column:7}}],line:161},'21':{loc:{start:{line:183,column:2},end:{line:436,column:3}},type:'if',locations:[{start:{line:183,column:2},end:{line:436,column:3}},{start:{line:183,column:2},end:{line:436,column:3}}],line:183},'22':{loc:{start:{line:189,column:3},end:{line:193,column:10}},type:'if',locations:[{start:{line:189,column:3},end:{line:193,column:10}},{start:{line:189,column:3},end:{line:193,column:10}}],line:189},'23':{loc:{start:{line:189,column:6},end:{line:189,column:85}},type:'binary-expr',locations:[{start:{line:189,column:6},end:{line:189,column:40}},{start:{line:189,column:44},end:{line:189,column:85}}],line:189},'24':{loc:{start:{line:190,column:13},end:{line:192,column:14}},type:'if',locations:[{start:{line:190,column:13},end:{line:192,column:14}},{start:{line:190,column:13},end:{line:192,column:14}}],line:190},'25':{loc:{start:{line:195,column:3},end:{line:203,column:4}},type:'if',locations:[{start:{line:195,column:3},end:{line:203,column:4}},{start:{line:195,column:3},end:{line:203,column:4}}],line:195},'26':{loc:{start:{line:198,column:8},end:{line:203,column:4}},type:'if',locations:[{start:{line:198,column:8},end:{line:203,column:4}},{start:{line:198,column:8},end:{line:203,column:4}}],line:198},'27':{loc:{start:{line:201,column:8},end:{line:203,column:4}},type:'if',locations:[{start:{line:201,column:8},end:{line:203,column:4}},{start:{line:201,column:8},end:{line:203,column:4}}],line:201},'28':{loc:{start:{line:205,column:3},end:{line:209,column:4}},type:'if',locations:[{start:{line:205,column:3},end:{line:209,column:4}},{start:{line:205,column:3},end:{line:209,column:4}}],line:205},'29':{loc:{start:{line:211,column:3},end:{line:215,column:4}},type:'if',locations:[{start:{line:211,column:3},end:{line:215,column:4}},{start:{line:211,column:3},end:{line:215,column:4}}],line:211},'30':{loc:{start:{line:211,column:6},end:{line:211,column:120}},type:'binary-expr',locations:[{start:{line:211,column:6},end:{line:211,column:63}},{start:{line:211,column:67},end:{line:211,column:120}}],line:211},'31':{loc:{start:{line:217,column:55},end:{line:217,column:83}},type:'cond-expr',locations:[{start:{line:217,column:65},end:{line:217,column:72}},{start:{line:217,column:75},end:{line:217,column:83}}],line:217},'32':{loc:{start:{line:234,column:84},end:{line:234,column:226}},type:'cond-expr',locations:[{start:{line:234,column:124},end:{line:234,column:176}},{start:{line:234,column:179},end:{line:234,column:226}}],line:234},'33':{loc:{start:{line:244,column:84},end:{line:244,column:226}},type:'cond-expr',locations:[{start:{line:244,column:124},end:{line:244,column:176}},{start:{line:244,column:179},end:{line:244,column:226}}],line:244},'34':{loc:{start:{line:277,column:110},end:{line:277,column:270}},type:'cond-expr',locations:[{start:{line:277,column:191},end:{line:277,column:264}},{start:{line:277,column:267},end:{line:277,column:270}}],line:277},'35':{loc:{start:{line:282,column:75},end:{line:282,column:243}},type:'cond-expr',locations:[{start:{line:282,column:160},end:{line:282,column:237}},{start:{line:282,column:240},end:{line:282,column:243}}],line:282},'36':{loc:{start:{line:303,column:112},end:{line:303,column:160}},type:'cond-expr',locations:[{start:{line:303,column:141},end:{line:303,column:154}},{start:{line:303,column:157},end:{line:303,column:160}}],line:303},'37':{loc:{start:{line:360,column:113},end:{line:360,column:161}},type:'cond-expr',locations:[{start:{line:360,column:142},end:{line:360,column:155}},{start:{line:360,column:158},end:{line:360,column:161}}],line:360},'38':{loc:{start:{line:394,column:49},end:{line:394,column:129}},type:'cond-expr',locations:[{start:{line:394,column:101},end:{line:394,column:124}},{start:{line:394,column:127},end:{line:394,column:129}}],line:394},'39':{loc:{start:{line:396,column:81},end:{line:396,column:129}},type:'cond-expr',locations:[{start:{line:396,column:110},end:{line:396,column:123}},{start:{line:396,column:126},end:{line:396,column:129}}],line:396},'40':{loc:{start:{line:398,column:12},end:{line:398,column:142}},type:'cond-expr',locations:[{start:{line:398,column:38},end:{line:398,column:137}},{start:{line:398,column:140},end:{line:398,column:142}}],line:398},'41':{loc:{start:{line:405,column:12},end:{line:405,column:172}},type:'cond-expr',locations:[{start:{line:405,column:38},end:{line:405,column:102}},{start:{line:405,column:107},end:{line:405,column:171}}],line:405},'42':{loc:{start:{line:417,column:26},end:{line:417,column:342}},type:'cond-expr',locations:[{start:{line:417,column:69},end:{line:417,column:136}},{start:{line:417,column:139},end:{line:417,column:342}}],line:417},'43':{loc:{start:{line:417,column:139},end:{line:417,column:342}},type:'cond-expr',locations:[{start:{line:417,column:181},end:{line:417,column:248}},{start:{line:417,column:251},end:{line:417,column:342}}],line:417},'44':{loc:{start:{line:418,column:12},end:{line:418,column:142}},type:'cond-expr',locations:[{start:{line:418,column:78},end:{line:418,column:136}},{start:{line:418,column:139},end:{line:418,column:142}}],line:418},'45':{loc:{start:{line:420,column:26},end:{line:420,column:341}},type:'cond-expr',locations:[{start:{line:420,column:69},end:{line:420,column:136}},{start:{line:420,column:139},end:{line:420,column:341}}],line:420},'46':{loc:{start:{line:420,column:139},end:{line:420,column:341}},type:'cond-expr',locations:[{start:{line:420,column:181},end:{line:420,column:248}},{start:{line:420,column:251},end:{line:420,column:341}}],line:420},'47':{loc:{start:{line:424,column:77},end:{line:424,column:198}},type:'cond-expr',locations:[{start:{line:424,column:98},end:{line:424,column:143}},{start:{line:424,column:146},end:{line:424,column:198}}],line:424}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JobPage=function(_ref){_inherits(JobPage,_ref);function JobPage(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,JobPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=JobPage.__proto__||Object.getPrototypeOf(JobPage)).call.apply(_ref2,[this].concat(args))),_this),_this.state={jobToEdit:false,jobToDelete:false,jobToExport:false,jobToDetailedCalculation:false,gradiantOverlay:false,shownCalculation:{Id:false,efficiency:0,name:"",heads:0,total_production_time:0,potential_total_production_time:0,production_time_per_piece:0,potential_production_time_per_piece:0,total_production_cost:0,potential_total_production_cost:0,production_cost_per_piece:0,potential_production_cost_per_piece:0}},_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_sqsn1mzg0.f[2]++;cov_sqsn1mzg0.s[7]++;if((cov_sqsn1mzg0.b[1][0]++,!_this.state.jobToEdit)&&(cov_sqsn1mzg0.b[1][1]++,_this.props.match.path==='/jobs/:id/edit')){cov_sqsn1mzg0.b[0][0]++;cov_sqsn1mzg0.s[8]++;_this.setState({jobToEdit:true,jobToDelete:false,jobToExport:false,jobToDetailedCalculation:false});}else{cov_sqsn1mzg0.b[0][1]++;cov_sqsn1mzg0.s[9]++;if((cov_sqsn1mzg0.b[3][0]++,_this.state.jobToEdit)&&(cov_sqsn1mzg0.b[3][1]++,_this.props.match.path!=='/jobs/:id/edit')){cov_sqsn1mzg0.b[2][0]++;cov_sqsn1mzg0.s[10]++;_this.setState({jobToEdit:false});}else{cov_sqsn1mzg0.b[2][1]++;cov_sqsn1mzg0.s[11]++;if((cov_sqsn1mzg0.b[5][0]++,!_this.state.jobToExport)&&(cov_sqsn1mzg0.b[5][1]++,_this.props.match.path==='/jobs/:id/export')){cov_sqsn1mzg0.b[4][0]++;cov_sqsn1mzg0.s[12]++;_this.setState({jobToEdit:false,jobToDelete:false,jobToExport:true,jobToDetailedCalculation:false});}else{cov_sqsn1mzg0.b[4][1]++;cov_sqsn1mzg0.s[13]++;if((cov_sqsn1mzg0.b[7][0]++,_this.state.jobToExport)&&(cov_sqsn1mzg0.b[7][1]++,_this.props.match.path!=='/jobs/:id/export')){cov_sqsn1mzg0.b[6][0]++;cov_sqsn1mzg0.s[14]++;_this.setState({jobToExport:false});}else{cov_sqsn1mzg0.b[6][1]++;}}}}cov_sqsn1mzg0.s[15]++;if((cov_sqsn1mzg0.b[9][0]++,!prevProps.calculatorJob.calculations.fetched)&&(cov_sqsn1mzg0.b[9][1]++,_this.props.calculatorJob.calculations.fetched)){cov_sqsn1mzg0.b[8][0]++;cov_sqsn1mzg0.s[16]++;_this.setState(function(prevState){cov_sqsn1mzg0.f[3]++;cov_sqsn1mzg0.s[17]++;return{shownCalculation:_this.props.calculatorJob.calculations.details.filter(function(calculation){cov_sqsn1mzg0.f[4]++;cov_sqsn1mzg0.s[18]++;return calculation.active;})[0]};});}else{cov_sqsn1mzg0.b[8][1]++;}cov_sqsn1mzg0.s[19]++;if((cov_sqsn1mzg0.b[11][0]++,!prevProps.calculatorJob.job.changed_used)&&(cov_sqsn1mzg0.b[11][1]++,_this.props.calculatorJob.job.changed_used)){cov_sqsn1mzg0.b[10][0]++;cov_sqsn1mzg0.s[20]++;_this.onFetchJobDetailHandler();cov_sqsn1mzg0.s[21]++;_this.props.onCalculatorJobChangeActiveReset();}else{cov_sqsn1mzg0.b[10][1]++;}cov_sqsn1mzg0.s[22]++;if((cov_sqsn1mzg0.b[13][0]++,!prevProps.calculatorJob.job.recalculated)&&(cov_sqsn1mzg0.b[13][1]++,_this.props.calculatorJob.job.recalculated)){cov_sqsn1mzg0.b[12][0]++;cov_sqsn1mzg0.s[23]++;_this.onFetchJobDetailHandler();cov_sqsn1mzg0.s[24]++;_this.props.onCalculatorJobRecalculateReset();}else{cov_sqsn1mzg0.b[12][1]++;}cov_sqsn1mzg0.s[25]++;if((cov_sqsn1mzg0.b[15][0]++,!prevProps.calculatorJob.job.message!==_this.props.calculatorJob.job.message)&&(cov_sqsn1mzg0.b[15][1]++,_this.props.calculatorJob.job.message)){cov_sqsn1mzg0.b[14][0]++;cov_sqsn1mzg0.s[26]++;__WEBPACK_IMPORTED_MODULE_8_react_redux_toastr__["toastr"][_this.props.calculatorJob.job.message.type](_this.props.translate('jobpage.'+_this.props.calculatorJob.job.message.type+'.'+_this.props.calculatorJob.job.message.key+'.title'),_this.props.translate('jobpage.'+_this.props.calculatorJob.job.message.type+'.'+_this.props.calculatorJob.job.message.key+'.text'));cov_sqsn1mzg0.s[27]++;_this.props.onCalculatorJobMessageReset();}else{cov_sqsn1mzg0.b[14][1]++;}cov_sqsn1mzg0.s[28]++;if(_this.state.jobToEdit){cov_sqsn1mzg0.b[16][0]++;cov_sqsn1mzg0.s[29]++;__WEBPACK_IMPORTED_MODULE_9_react_tooltip___default.a.rebuild();}else{cov_sqsn1mzg0.b[16][1]++;}},_this.onFetchJobDetailHandler=function(){cov_sqsn1mzg0.f[5]++;cov_sqsn1mzg0.s[30]++;_this.props.onCalculatorJobFetch(_this.props.match.params.id);cov_sqsn1mzg0.s[31]++;_this.props.onCalculatorJobCalculationsFetch(_this.props.match.params.id);},_this.onDeleteCancelHandler=function(event){cov_sqsn1mzg0.f[6]++;cov_sqsn1mzg0.s[32]++;event.preventDefault();cov_sqsn1mzg0.s[33]++;_this.setState({jobToDelete:false});},_this.onDeleteConfirmHandler=function(event){cov_sqsn1mzg0.f[7]++;cov_sqsn1mzg0.s[34]++;event.preventDefault();cov_sqsn1mzg0.s[35]++;_this.setState({jobToDelete:true});},_this.onDeleteHandler=function(event){cov_sqsn1mzg0.f[8]++;cov_sqsn1mzg0.s[36]++;event.preventDefault();cov_sqsn1mzg0.s[37]++;_this.props.onCalculatorJobDelete(_this.props.calculatorJob.job.details.Id);},_this.setAsUsedHandler=function(event,inputIdentifier){cov_sqsn1mzg0.f[9]++;var value=(cov_sqsn1mzg0.s[38]++,event.target.value);cov_sqsn1mzg0.s[39]++;_this.props.onCalculatorJobChangeActive(_this.props.calculatorJob.job.details.Id,{calculation_id:value});},_this.showCalculationHandler=function(id,event){cov_sqsn1mzg0.f[10]++;cov_sqsn1mzg0.s[40]++;_this.setState(function(prevState){cov_sqsn1mzg0.f[11]++;cov_sqsn1mzg0.s[41]++;return{shownCalculation:_this.props.calculatorJob.calculations.details.filter(function(calculation){cov_sqsn1mzg0.f[12]++;cov_sqsn1mzg0.s[42]++;return calculation.Id===id;})[0]};});},_this.recalculateHandler=function(event){cov_sqsn1mzg0.f[13]++;cov_sqsn1mzg0.s[43]++;event.preventDefault();cov_sqsn1mzg0.s[44]++;_this.props.onCalculatorJobRecalculate(_this.props.calculatorJob.job.details.Id);},_this.onDetailedCalculationHandler=function(event){cov_sqsn1mzg0.f[14]++;cov_sqsn1mzg0.s[45]++;event.preventDefault();cov_sqsn1mzg0.s[46]++;_this.setState({jobToEdit:false,jobToDelete:false,jobToExport:false,jobToDetailedCalculation:true});},_this.onDetailedCalculationClosedHandler=function(){cov_sqsn1mzg0.f[15]++;cov_sqsn1mzg0.s[47]++;_this.setState({jobToDetailedCalculation:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JobPage,[{key:'componentDidMount',value:function componentDidMount(){cov_sqsn1mzg0.f[0]++;cov_sqsn1mzg0.s[0]++;this.onFetchJobDetailHandler();}},{key:'componentWillUnmount',value:function componentWillUnmount(){cov_sqsn1mzg0.f[1]++;cov_sqsn1mzg0.s[1]++;this.props.onCalculatorJobFetchReset();cov_sqsn1mzg0.s[2]++;this.props.onCalculatorJobCalculationsFetchReset();cov_sqsn1mzg0.s[3]++;this.props.onCalculatorJobDeleteReset();cov_sqsn1mzg0.s[4]++;this.props.onCalculatorJobChangeActiveReset();cov_sqsn1mzg0.s[5]++;this.props.onCalculatorJobMessageReset();cov_sqsn1mzg0.s[6]++;this.props.onCalculatorJobRecalculateReset();}},{key:'wheel',value:function wheel(e){cov_sqsn1mzg0.f[16]++;cov_sqsn1mzg0.s[48]++;if(e.deltaX===0){cov_sqsn1mzg0.b[17][0]++;cov_sqsn1mzg0.s[49]++;if(e.deltaY>=0){cov_sqsn1mzg0.b[18][0]++;cov_sqsn1mzg0.s[50]++;document.getElementById('scroll').scrollLeft+=40;}else{cov_sqsn1mzg0.b[18][1]++;cov_sqsn1mzg0.s[51]++;if(e.deltaY>=0){cov_sqsn1mzg0.b[19][0]++;cov_sqsn1mzg0.s[52]++;document.getElementById('scroll').scrollLeft-=40;}else{cov_sqsn1mzg0.b[19][1]++;cov_sqsn1mzg0.s[53]++;document.getElementById('scroll').scrollLeft-=40;}}var tmpState=(cov_sqsn1mzg0.s[54]++,false);cov_sqsn1mzg0.s[55]++;if(document.getElementById('scroll').scrollLeft==0){cov_sqsn1mzg0.b[20][0]++;cov_sqsn1mzg0.s[56]++;tmpState=false;}else{cov_sqsn1mzg0.b[20][1]++;cov_sqsn1mzg0.s[57]++;tmpState=true;}cov_sqsn1mzg0.s[58]++;this.setState(function(prevState){cov_sqsn1mzg0.f[17]++;cov_sqsn1mzg0.s[59]++;return{gradiantOverlay:tmpState};});cov_sqsn1mzg0.s[60]++;e.preventDefault();}else{cov_sqsn1mzg0.b[17][1]++;}}},{key:'round',value:function round(number,length){cov_sqsn1mzg0.f[18]++;var factor=(cov_sqsn1mzg0.s[61]++,Math.pow(10,length));var rounded=(cov_sqsn1mzg0.s[62]++,Math.round(number*factor)/factor);cov_sqsn1mzg0.s[63]++;return rounded;}},{key:'render',value:function render(){var _this2=this;cov_sqsn1mzg0.f[19]++;cov_sqsn1mzg0.s[64]++;console.log(this.state.shownCalculation);cov_sqsn1mzg0.s[65]++;if(this.props.calculatorJob.job.deleted){cov_sqsn1mzg0.b[21][0]++;cov_sqsn1mzg0.s[66]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/jobs'});}else{cov_sqsn1mzg0.b[21][1]++;cov_sqsn1mzg0.s[67]++;if((cov_sqsn1mzg0.b[23][0]++,this.props.calculatorJob.job.error)&&(cov_sqsn1mzg0.b[23][1]++,this.props.calculatorJob.job.error.length)){cov_sqsn1mzg0.b[22][0]++;cov_sqsn1mzg0.s[68]++;if(this.props.calculatorJob.job.error[0].key==='NOT_EXIST'){cov_sqsn1mzg0.b[24][0]++;cov_sqsn1mzg0.s[69]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["NotFoundPage"],null);}else{cov_sqsn1mzg0.b[24][1]++;}}else{cov_sqsn1mzg0.b[22][1]++;}var jobModal=(cov_sqsn1mzg0.s[70]++,"");cov_sqsn1mzg0.s[71]++;if(this.state.jobToEdit){cov_sqsn1mzg0.b[25][0]++;cov_sqsn1mzg0.s[72]++;jobModal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EditJobModal__["a" /* default */],{onUpdated:this.onFetchJobDetailHandler});}else{cov_sqsn1mzg0.b[25][1]++;cov_sqsn1mzg0.s[73]++;if(this.state.jobToExport){cov_sqsn1mzg0.b[26][0]++;cov_sqsn1mzg0.s[74]++;jobModal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ExportJobModal__["a" /* default */],null);}else{cov_sqsn1mzg0.b[26][1]++;cov_sqsn1mzg0.s[75]++;if(this.state.jobToDetailedCalculation){cov_sqsn1mzg0.b[27][0]++;cov_sqsn1mzg0.s[76]++;jobModal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__DetailedCalculationModal__["a" /* default */],{onCloseModal:this.onDetailedCalculationClosedHandler,jobId:this.props.calculatorJob.job.details.Id,calculationId:this.state.shownCalculation.Id});}else{cov_sqsn1mzg0.b[27][1]++;}}}var confirm=(cov_sqsn1mzg0.s[77]++,"");cov_sqsn1mzg0.s[78]++;if(this.state.jobToDelete){cov_sqsn1mzg0.b[28][0]++;cov_sqsn1mzg0.s[79]++;confirm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Confirm"],{onCancel:this.onDeleteCancelHandler,onConfirm:this.onDeleteHandler,title:this.props.translate('jobpage.delete.label'),text:this.props.translate('jobpage.delete.text')});}else{cov_sqsn1mzg0.b[28][1]++;}var changedMachineSetup=(cov_sqsn1mzg0.s[80]++,"");cov_sqsn1mzg0.s[81]++;if((cov_sqsn1mzg0.b[30][0]++,'global_settings'in this.props.calculatorJob.job.details)&&(cov_sqsn1mzg0.b[30][1]++,!this.props.calculatorJob.job.details.global_settings)){cov_sqsn1mzg0.b[29][0]++;cov_sqsn1mzg0.s[82]++;changedMachineSetup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Hint"],{type:'error',text:this.props.translate('jobpage.machinesetup.text'),buttonText:this.props.translate('jobpage.machinesetup.recalculate'),buttonClicked:this.recalculateHandler,noPrint:true});}else{cov_sqsn1mzg0.b[29][1]++;}cov_sqsn1mzg0.s[83]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Header"],null),appendComponent:confirm?(cov_sqsn1mzg0.b[31][0]++,confirm):(cov_sqsn1mzg0.b[31][1]++,jobModal)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["PageTitle"],{ellipsis:'60%'},this.props.calculatorJob.job.details.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'0px',align:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["ActionsNav"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/jobs/'+this.props.calculatorJob.job.details.Id+'/edit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'edit',size:'16px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/jobs/'+this.props.calculatorJob.job.details.Id+'/export'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'export',size:'16px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:this.onDeleteConfirmHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'delete',size:'16px'}))))),changedMachineSetup,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{type:'fullWidth',noPrint:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'m',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'190px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isHiddenDesktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["BoxTitle"],null,this.state.shownCalculation.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#2F2D2F',fontCut:'light'},this.state.shownCalculation.heads,' ',this.state.shownCalculation.heads>1?(cov_sqsn1mzg0.b[32][0]++,this.props.translate('global.machine.head.multiple')):(cov_sqsn1mzg0.b[32][1]++,this.props.translate('global.machine.head.one'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'28px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["DonutChart"],{size:'164',font:'large',value:this.state.shownCalculation.efficiency,valuelabel:this.props.translate('jobpage.calculation.efficiency'),strokewidth:'22'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'447px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'5px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isHiddenMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["BoxTitle"],null,this.state.shownCalculation.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#2F2D2F',fontCut:'light'},this.state.shownCalculation.heads,' ',this.state.shownCalculation.heads>1?(cov_sqsn1mzg0.b[33][0]++,this.props.translate('global.machine.head.multiple')):(cov_sqsn1mzg0.b[33][1]++,this.props.translate('global.machine.head.one'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'28px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'xs',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'48px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'time',size:'30px',display:'inline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'139px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.small},Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(this.state.shownCalculation.total_production_time,true),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#AAAAAA',size:'small'},this.props.translate('jobpage.calculation.potential',{value:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(this.state.shownCalculation.potential_total_production_time,true)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'5px'}),this.props.translate('jobpage.calculation.per_piece',{value:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(this.state.shownCalculation.production_time_per_piece,true)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#AAAAAA',size:'small'},this.props.translate('jobpage.calculation.potential',{value:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(this.state.shownCalculation.potential_production_time_per_piece,true)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'20px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'48px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'cost',size:'30px',display:'inline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'139px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.small},this.round(this.state.shownCalculation.total_production_cost,2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#AAAAAA',size:'small'},this.props.translate('jobpage.calculation.potential',{value:this.round(this.state.shownCalculation.potential_total_production_cost,2)!=0?(cov_sqsn1mzg0.b[34][0]++,this.round(this.state.shownCalculation.potential_total_production_cost,2)):(cov_sqsn1mzg0.b[34][1]++,'-')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'5px'}),this.props.translate('jobpage.calculation.per_piece',{value:this.round(this.state.shownCalculation.production_cost_per_piece,2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{color:'#AAAAAA',size:'small'},this.props.translate('jobpage.calculation.potential',{value:this.round(this.state.shownCalculation.potential_production_cost_per_piece,2)!=0?(cov_sqsn1mzg0.b[35][0]++,this.round(this.state.shownCalculation.potential_production_cost_per_piece,2)):(cov_sqsn1mzg0.b[35][1]++,'-')})))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{width:'264px',valign:'bottom',noPrint:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'20px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{width:'264px',onClick:this.onDetailedCalculationHandler,value:this.props.translate('jobpage.calculation.detailed_calculation'),theme:'dark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'20px'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.parent,id:'scroll',onWheel:function onWheel(e){cov_sqsn1mzg0.f[20]++;cov_sqsn1mzg0.s[84]++;return _this2.wheel(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.noPrint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(this.state.gradiantOverlay?(cov_sqsn1mzg0.b[36][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_sqsn1mzg0.b[36][1]++,' '))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.machine'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.efficiency'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.modular'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.actual_heads'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.actual_cost'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.actual_time'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.potential_cost'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.jobdetailtable.potential_time'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellLineLeft})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.spacer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.noPrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(this.state.gradiantOverlay?(cov_sqsn1mzg0.b[37][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_sqsn1mzg0.b[37][1]++,' '))},this.props.translate('global.job.table.header_machine')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_efficiency')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_modular')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_heads')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_potential'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_potential'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellLineLeft+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.noPrint})),this.props.calculatorJob.calculations.details.map(function(calculation,index){cov_sqsn1mzg0.f[21]++;cov_sqsn1mzg0.s[85]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+(_this2.state.shownCalculation.Id===calculation.Id?(cov_sqsn1mzg0.b[38][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRowActive):(cov_sqsn1mzg0.b[38][1]++,'')),onClick:_this2.showCalculationHandler.bind(_this2,calculation.Id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(_this2.state.gradiantOverlay?(cov_sqsn1mzg0.b[39][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_sqsn1mzg0.b[39][1]++,' '))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.textWrap},calculation.name,calculation.recommended?(cov_sqsn1mzg0.b[40][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.recommended},_this2.props.translate('global.job.table.recommendation'))):(cov_sqsn1mzg0.b[40][1]++,''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.firstCellMover},Math.round(calculation.efficiency*Math.pow(10,0))/Math.pow(10,0),'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},!calculation.multihead?(cov_sqsn1mzg0.b[41][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'yes',size:'10px',display:'inline'})):(cov_sqsn1mzg0.b[41][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'no',size:'10px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},calculation.heads),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},_this2.round(calculation.total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(calculation.total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:calculation.performance_cost==='worse'?(cov_sqsn1mzg0.b[42][0]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyDown].join(' ')):(cov_sqsn1mzg0.b[42][1]++,calculation.performance_cost==='same'?(cov_sqsn1mzg0.b[43][0]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyEven].join(' ')):(cov_sqsn1mzg0.b[43][1]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobPotentialCosts,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyUp].join(' ')))},_this2.round(calculation.potential_total_production_cost,2)!=0?(cov_sqsn1mzg0.b[44][0]++,_this2.round(calculation.potential_total_production_cost,2)):(cov_sqsn1mzg0.b[44][1]++,'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:calculation.performance_time==='worse'?(cov_sqsn1mzg0.b[45][0]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyDown].join(' ')):(cov_sqsn1mzg0.b[45][1]++,calculation.performance_time==='same'?(cov_sqsn1mzg0.b[46][0]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyEven].join(' ')):(cov_sqsn1mzg0.b[46][1]++,[__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobPotentialTime,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.tendencyUp].join(' ')))},Object(__WEBPACK_IMPORTED_MODULE_14__helpers_DateTime_js__["b" /* secondsFormatter */])(calculation.potential_total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellLineLeft+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.noPrint},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Radio"],{checked:calculation.active,value:calculation.Id,label:calculation.active?(cov_sqsn1mzg0.b[47][0]++,_this2.props.translate('global.job.table.used')):(cov_sqsn1mzg0.b[47][1]++,_this2.props.translate('global.job.table.set_as_used')),identifier:'set_as_used',changed:_this2.setAsUsedHandler})));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InfoText"],{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Icon"],{type:'image',content:'info',size:'17px'}),text:this.props.translate('jobpage.info.list')}));}}}]);return JobPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_sqsn1mzg0.s[86]++;var mapStateToProps=function mapStateToProps(state){cov_sqsn1mzg0.f[22]++;cov_sqsn1mzg0.s[87]++;return{defaults:state.defaults,calculatorJob:state.calculatorJob,fetching:state.fetching,translate:Object(__WEBPACK_IMPORTED_MODULE_7_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_sqsn1mzg0.s[88]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_sqsn1mzg0.f[23]++;cov_sqsn1mzg0.s[89]++;return{onCalculatorJobFetch:function onCalculatorJobFetch(id){cov_sqsn1mzg0.f[24]++;cov_sqsn1mzg0.s[90]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["q" /* calculatorJobFetch */](id));},onCalculatorJobFetchReset:function onCalculatorJobFetchReset(){cov_sqsn1mzg0.f[25]++;cov_sqsn1mzg0.s[91]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["r" /* calculatorJobFetchReset */]());},onCalculatorJobMessageReset:function onCalculatorJobMessageReset(){cov_sqsn1mzg0.f[26]++;cov_sqsn1mzg0.s[92]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["w" /* calculatorJobMessageReset */]());},onCalculatorJobCalculationsFetch:function onCalculatorJobCalculationsFetch(id){cov_sqsn1mzg0.f[27]++;cov_sqsn1mzg0.s[93]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["c" /* calculatorJobCalculationsFetch */](id));},onCalculatorJobCalculationsFetchReset:function onCalculatorJobCalculationsFetchReset(){cov_sqsn1mzg0.f[28]++;cov_sqsn1mzg0.s[94]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["d" /* calculatorJobCalculationsFetchReset */]());},onCalculatorJobDeleteReset:function onCalculatorJobDeleteReset(){cov_sqsn1mzg0.f[29]++;cov_sqsn1mzg0.s[95]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["j" /* calculatorJobDeleteReset */]());},onCalculatorJobDelete:function onCalculatorJobDelete(id){cov_sqsn1mzg0.f[30]++;cov_sqsn1mzg0.s[96]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["i" /* calculatorJobDelete */](id));},onCalculatorJobChangeActive:function onCalculatorJobChangeActive(id,formData){cov_sqsn1mzg0.f[31]++;cov_sqsn1mzg0.s[97]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["e" /* calculatorJobChangeActive */](id,formData));},onCalculatorJobChangeActiveReset:function onCalculatorJobChangeActiveReset(){cov_sqsn1mzg0.f[32]++;cov_sqsn1mzg0.s[98]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["f" /* calculatorJobChangeActiveReset */]());},onCalculatorJobRecalculate:function onCalculatorJobRecalculate(id){cov_sqsn1mzg0.f[33]++;cov_sqsn1mzg0.s[99]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["x" /* calculatorJobRecalculate */](id));},onCalculatorJobRecalculateReset:function onCalculatorJobRecalculateReset(){cov_sqsn1mzg0.f[34]++;cov_sqsn1mzg0.s[100]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["y" /* calculatorJobRecalculateReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(JobPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components__);
var cov_14vbwvwk0=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\EditJobModal\\index.js',hash='4bba1757bf610982fda6206dbab7852be2c23a05',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\EditJobModal\\index.js',statementMap:{'0':{start:{line:135,column:8},end:{line:135,column:21}},'1':{start:{line:136,column:8},end:{line:153,column:9}},'2':{start:{line:156,column:8},end:{line:158,column:9}},'3':{start:{line:157,column:12},end:{line:157,column:84}},'4':{start:{line:161,column:8},end:{line:161,column:54}},'5':{start:{line:162,column:8},end:{line:162,column:48}},'6':{start:{line:163,column:8},end:{line:163,column:55}},'7':{start:{line:164,column:8},end:{line:164,column:56}},'8':{start:{line:167,column:8},end:{line:180,column:9}},'9':{start:{line:168,column:12},end:{line:179,column:15}},'10':{start:{line:168,column:40},end:{line:179,column:13}},'11':{start:{line:182,column:8},end:{line:226,column:9}},'12':{start:{line:183,column:12},end:{line:183,column:84}},'13':{start:{line:185,column:12},end:{line:203,column:16}},'14':{start:{line:185,column:40},end:{line:203,column:13}},'15':{start:{line:206,column:13},end:{line:226,column:9}},'16':{start:{line:208,column:12},end:{line:225,column:16}},'17':{start:{line:208,column:40},end:{line:225,column:13}},'18':{start:{line:228,column:8},end:{line:242,column:9}},'19':{start:{line:229,column:12},end:{line:241,column:16}},'20':{start:{line:229,column:40},end:{line:241,column:13}},'21':{start:{line:243,column:8},end:{line:297,column:9}},'22':{start:{line:244,column:12},end:{line:244,column:35}},'23':{start:{line:245,column:12},end:{line:245,column:52}},'24':{start:{line:246,column:12},end:{line:255,column:15}},'25':{start:{line:246,column:40},end:{line:253,column:13}},'26':{start:{line:254,column:16},end:{line:254,column:39}},'27':{start:{line:257,column:13},end:{line:297,column:9}},'28':{start:{line:258,column:12},end:{line:279,column:13}},'29':{start:{line:259,column:16},end:{line:278,column:19}},'30':{start:{line:259,column:44},end:{line:261,column:17}},'31':{start:{line:262,column:20},end:{line:277,column:22}},'32':{start:{line:263,column:24},end:{line:276,column:25}},'33':{start:{line:264,column:28},end:{line:275,column:31}},'34':{start:{line:264,column:56},end:{line:275,column:29}},'35':{start:{line:280,column:12},end:{line:296,column:13}},'36':{start:{line:281,column:16},end:{line:286,column:20}},'37':{start:{line:281,column:44},end:{line:286,column:17}},'38':{start:{line:290,column:16},end:{line:295,column:20}},'39':{start:{line:290,column:44},end:{line:295,column:17}},'40':{start:{line:299,column:8},end:{line:362,column:9}},'41':{start:{line:300,column:12},end:{line:300,column:35}},'42':{start:{line:301,column:12},end:{line:301,column:59}},'43':{start:{line:302,column:12},end:{line:308,column:16}},'44':{start:{line:302,column:40},end:{line:308,column:13}},'45':{start:{line:309,column:12},end:{line:317,column:16}},'46':{start:{line:309,column:40},end:{line:317,column:13}},'47':{start:{line:318,column:12},end:{line:320,column:16}},'48':{start:{line:318,column:40},end:{line:320,column:13}},'49':{start:{line:322,column:13},end:{line:362,column:9}},'50':{start:{line:323,column:12},end:{line:344,column:13}},'51':{start:{line:324,column:16},end:{line:343,column:19}},'52':{start:{line:324,column:44},end:{line:326,column:17}},'53':{start:{line:327,column:20},end:{line:342,column:22}},'54':{start:{line:328,column:24},end:{line:341,column:25}},'55':{start:{line:329,column:28},end:{line:340,column:31}},'56':{start:{line:329,column:56},end:{line:340,column:29}},'57':{start:{line:345,column:12},end:{line:361,column:13}},'58':{start:{line:346,column:16},end:{line:351,column:20}},'59':{start:{line:346,column:44},end:{line:351,column:17}},'60':{start:{line:355,column:16},end:{line:360,column:20}},'61':{start:{line:355,column:44},end:{line:360,column:17}},'62':{start:{line:366,column:19},end:{line:366,column:39}},'63':{start:{line:368,column:8},end:{line:370,column:10}},'64':{start:{line:369,column:12},end:{line:369,column:31}},'65':{start:{line:371,column:8},end:{line:371,column:34}},'66':{start:{line:372,column:8},end:{line:376,column:11}},'67':{start:{line:372,column:36},end:{line:374,column:9}},'68':{start:{line:375,column:12},end:{line:375,column:35}},'69':{start:{line:380,column:8},end:{line:380,column:31}},'70':{start:{line:381,column:8},end:{line:408,column:9}},'71':{start:{line:382,column:29},end:{line:394,column:13}},'72':{start:{line:395,column:12},end:{line:397,column:16}},'73':{start:{line:395,column:40},end:{line:397,column:13}},'74':{start:{line:398,column:12},end:{line:398,column:87}},'75':{start:{line:401,column:12},end:{line:407,column:16}},'76':{start:{line:401,column:40},end:{line:407,column:13}},'77':{start:{line:412,column:8},end:{line:412,column:31}},'78':{start:{line:413,column:8},end:{line:440,column:9}},'79':{start:{line:414,column:29},end:{line:426,column:13}},'80':{start:{line:427,column:12},end:{line:429,column:16}},'81':{start:{line:427,column:40},end:{line:429,column:13}},'82':{start:{line:430,column:12},end:{line:430,column:94}},'83':{start:{line:433,column:12},end:{line:439,column:16}},'84':{start:{line:433,column:40},end:{line:439,column:13}},'85':{start:{line:444,column:20},end:{line:444,column:38}},'86':{start:{line:445,column:8},end:{line:453,column:12}},'87':{start:{line:445,column:36},end:{line:453,column:9}},'88':{start:{line:457,column:20},end:{line:457,column:38}},'89':{start:{line:458,column:8},end:{line:466,column:12}},'90':{start:{line:458,column:36},end:{line:466,column:9}},'91':{start:{line:470,column:8},end:{line:478,column:12}},'92':{start:{line:470,column:36},end:{line:478,column:9}},'93':{start:{line:482,column:8},end:{line:484,column:11}},'94':{start:{line:482,column:36},end:{line:484,column:9}},'95':{start:{line:488,column:20},end:{line:488,column:38}},'96':{start:{line:489,column:8},end:{line:516,column:9}},'97':{start:{line:490,column:12},end:{line:515,column:13}},'98':{start:{line:491,column:16},end:{line:502,column:20}},'99':{start:{line:491,column:44},end:{line:502,column:17}},'100':{start:{line:503,column:16},end:{line:503,column:109}},'101':{start:{line:506,column:16},end:{line:514,column:20}},'102':{start:{line:506,column:44},end:{line:514,column:17}},'103':{start:{line:517,column:8},end:{line:522,column:9}},'104':{start:{line:518,column:12},end:{line:518,column:78}},'105':{start:{line:521,column:12},end:{line:521,column:82}},'106':{start:{line:523,column:8},end:{line:525,column:9}},'107':{start:{line:524,column:12},end:{line:524,column:66}},'108':{start:{line:528,column:8},end:{line:530,column:9}},'109':{start:{line:529,column:12},end:{line:529,column:66}},'110':{start:{line:534,column:8},end:{line:536,column:9}},'111':{start:{line:535,column:12},end:{line:535,column:80}},'112':{start:{line:538,column:8},end:{line:540,column:9}},'113':{start:{line:539,column:12},end:{line:539,column:44}},'114':{start:{line:541,column:8},end:{line:968,column:9}},'115':{start:{line:972,column:24},end:{line:979,column:1}},'116':{start:{line:973,column:4},end:{line:978,column:6}},'117':{start:{line:981,column:27},end:{line:992,column:1}},'118':{start:{line:982,column:4},end:{line:991,column:5}},'119':{start:{line:983,column:45},end:{line:983,column:99}},'120':{start:{line:984,column:50},end:{line:984,column:109}},'121':{start:{line:985,column:49},end:{line:985,column:107}},'122':{start:{line:986,column:42},end:{line:986,column:93}},'123':{start:{line:987,column:56},end:{line:987,column:121}},'124':{start:{line:988,column:49},end:{line:988,column:107}},'125':{start:{line:989,column:53},end:{line:989,column:115}},'126':{start:{line:990,column:50},end:{line:990,column:109}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:134,column:4},end:{line:134,column:5}},loc:{start:{line:134,column:23},end:{line:154,column:5}},line:134},'1':{name:'(anonymous_1)',decl:{start:{line:155,column:24},end:{line:155,column:25}},loc:{start:{line:155,column:30},end:{line:159,column:5}},line:155},'2':{name:'(anonymous_2)',decl:{start:{line:160,column:27},end:{line:160,column:28}},loc:{start:{line:160,column:33},end:{line:165,column:5}},line:160},'3':{name:'(anonymous_3)',decl:{start:{line:166,column:25},end:{line:166,column:26}},loc:{start:{line:166,column:61},end:{line:363,column:5}},line:166},'4':{name:'(anonymous_4)',decl:{start:{line:168,column:26},end:{line:168,column:27}},loc:{start:{line:168,column:40},end:{line:179,column:13}},line:168},'5':{name:'(anonymous_5)',decl:{start:{line:185,column:26},end:{line:185,column:27}},loc:{start:{line:185,column:40},end:{line:203,column:13}},line:185},'6':{name:'(anonymous_6)',decl:{start:{line:208,column:26},end:{line:208,column:27}},loc:{start:{line:208,column:40},end:{line:225,column:13}},line:208},'7':{name:'(anonymous_7)',decl:{start:{line:229,column:26},end:{line:229,column:27}},loc:{start:{line:229,column:40},end:{line:241,column:13}},line:229},'8':{name:'(anonymous_8)',decl:{start:{line:246,column:26},end:{line:246,column:27}},loc:{start:{line:246,column:40},end:{line:253,column:13}},line:246},'9':{name:'(anonymous_9)',decl:{start:{line:253,column:16},end:{line:253,column:17}},loc:{start:{line:253,column:22},end:{line:255,column:13}},line:253},'10':{name:'(anonymous_10)',decl:{start:{line:259,column:30},end:{line:259,column:31}},loc:{start:{line:259,column:44},end:{line:261,column:17}},line:259},'11':{name:'(anonymous_11)',decl:{start:{line:261,column:20},end:{line:261,column:21}},loc:{start:{line:261,column:26},end:{line:278,column:17}},line:261},'12':{name:'(anonymous_12)',decl:{start:{line:262,column:55},end:{line:262,column:56}},loc:{start:{line:262,column:73},end:{line:277,column:21}},line:262},'13':{name:'(anonymous_13)',decl:{start:{line:264,column:42},end:{line:264,column:43}},loc:{start:{line:264,column:56},end:{line:275,column:29}},line:264},'14':{name:'(anonymous_14)',decl:{start:{line:281,column:30},end:{line:281,column:31}},loc:{start:{line:281,column:44},end:{line:286,column:17}},line:281},'15':{name:'(anonymous_15)',decl:{start:{line:290,column:30},end:{line:290,column:31}},loc:{start:{line:290,column:44},end:{line:295,column:17}},line:290},'16':{name:'(anonymous_16)',decl:{start:{line:302,column:26},end:{line:302,column:27}},loc:{start:{line:302,column:40},end:{line:308,column:13}},line:302},'17':{name:'(anonymous_17)',decl:{start:{line:309,column:26},end:{line:309,column:27}},loc:{start:{line:309,column:40},end:{line:317,column:13}},line:309},'18':{name:'(anonymous_18)',decl:{start:{line:318,column:26},end:{line:318,column:27}},loc:{start:{line:318,column:40},end:{line:320,column:13}},line:318},'19':{name:'(anonymous_19)',decl:{start:{line:324,column:30},end:{line:324,column:31}},loc:{start:{line:324,column:44},end:{line:326,column:17}},line:324},'20':{name:'(anonymous_20)',decl:{start:{line:326,column:20},end:{line:326,column:21}},loc:{start:{line:326,column:26},end:{line:343,column:17}},line:326},'21':{name:'(anonymous_21)',decl:{start:{line:327,column:59},end:{line:327,column:60}},loc:{start:{line:327,column:77},end:{line:342,column:21}},line:327},'22':{name:'(anonymous_22)',decl:{start:{line:329,column:42},end:{line:329,column:43}},loc:{start:{line:329,column:56},end:{line:340,column:29}},line:329},'23':{name:'(anonymous_23)',decl:{start:{line:346,column:30},end:{line:346,column:31}},loc:{start:{line:346,column:44},end:{line:351,column:17}},line:346},'24':{name:'(anonymous_24)',decl:{start:{line:355,column:30},end:{line:355,column:31}},loc:{start:{line:355,column:44},end:{line:360,column:17}},line:355},'25':{name:'(anonymous_25)',decl:{start:{line:365,column:26},end:{line:365,column:27}},loc:{start:{line:365,column:37},end:{line:377,column:5}},line:365},'26':{name:'(anonymous_26)',decl:{start:{line:368,column:17},end:{line:368,column:18}},loc:{start:{line:368,column:37},end:{line:370,column:9}},line:368},'27':{name:'(anonymous_27)',decl:{start:{line:372,column:22},end:{line:372,column:23}},loc:{start:{line:372,column:36},end:{line:374,column:9}},line:372},'28':{name:'(anonymous_28)',decl:{start:{line:374,column:12},end:{line:374,column:13}},loc:{start:{line:374,column:18},end:{line:376,column:9}},line:374},'29':{name:'(anonymous_29)',decl:{start:{line:379,column:23},end:{line:379,column:24}},loc:{start:{line:379,column:36},end:{line:409,column:5}},line:379},'30':{name:'(anonymous_30)',decl:{start:{line:395,column:26},end:{line:395,column:27}},loc:{start:{line:395,column:40},end:{line:397,column:13}},line:395},'31':{name:'(anonymous_31)',decl:{start:{line:401,column:26},end:{line:401,column:27}},loc:{start:{line:401,column:40},end:{line:407,column:13}},line:401},'32':{name:'(anonymous_32)',decl:{start:{line:411,column:27},end:{line:411,column:28}},loc:{start:{line:411,column:40},end:{line:441,column:5}},line:411},'33':{name:'(anonymous_33)',decl:{start:{line:427,column:26},end:{line:427,column:27}},loc:{start:{line:427,column:40},end:{line:429,column:13}},line:427},'34':{name:'(anonymous_34)',decl:{start:{line:433,column:26},end:{line:433,column:27}},loc:{start:{line:433,column:40},end:{line:439,column:13}},line:433},'35':{name:'(anonymous_35)',decl:{start:{line:443,column:28},end:{line:443,column:29}},loc:{start:{line:443,column:56},end:{line:454,column:5}},line:443},'36':{name:'(anonymous_36)',decl:{start:{line:445,column:22},end:{line:445,column:23}},loc:{start:{line:445,column:36},end:{line:453,column:9}},line:445},'37':{name:'(anonymous_37)',decl:{start:{line:456,column:32},end:{line:456,column:33}},loc:{start:{line:456,column:60},end:{line:467,column:5}},line:456},'38':{name:'(anonymous_38)',decl:{start:{line:458,column:22},end:{line:458,column:23}},loc:{start:{line:458,column:36},end:{line:466,column:9}},line:458},'39':{name:'(anonymous_39)',decl:{start:{line:469,column:32},end:{line:469,column:33}},loc:{start:{line:469,column:60},end:{line:479,column:5}},line:469},'40':{name:'(anonymous_40)',decl:{start:{line:470,column:22},end:{line:470,column:23}},loc:{start:{line:470,column:36},end:{line:478,column:9}},line:470},'41':{name:'(anonymous_41)',decl:{start:{line:481,column:19},end:{line:481,column:20}},loc:{start:{line:481,column:25},end:{line:485,column:5}},line:481},'42':{name:'(anonymous_42)',decl:{start:{line:482,column:22},end:{line:482,column:23}},loc:{start:{line:482,column:36},end:{line:484,column:9}},line:482},'43':{name:'(anonymous_43)',decl:{start:{line:487,column:26},end:{line:487,column:27}},loc:{start:{line:487,column:54},end:{line:526,column:5}},line:487},'44':{name:'(anonymous_44)',decl:{start:{line:491,column:30},end:{line:491,column:31}},loc:{start:{line:491,column:44},end:{line:502,column:17}},line:491},'45':{name:'(anonymous_45)',decl:{start:{line:506,column:30},end:{line:506,column:31}},loc:{start:{line:506,column:44},end:{line:514,column:17}},line:506},'46':{name:'(anonymous_46)',decl:{start:{line:527,column:24},end:{line:527,column:25}},loc:{start:{line:527,column:52},end:{line:531,column:5}},line:527},'47':{name:'(anonymous_47)',decl:{start:{line:533,column:4},end:{line:533,column:5}},loc:{start:{line:533,column:14},end:{line:969,column:5}},line:533},'48':{name:'(anonymous_48)',decl:{start:{line:972,column:24},end:{line:972,column:25}},loc:{start:{line:972,column:33},end:{line:979,column:1}},line:972},'49':{name:'(anonymous_49)',decl:{start:{line:981,column:27},end:{line:981,column:28}},loc:{start:{line:981,column:39},end:{line:992,column:1}},line:981},'50':{name:'(anonymous_50)',decl:{start:{line:983,column:37},end:{line:983,column:38}},loc:{start:{line:983,column:45},end:{line:983,column:99}},line:983},'51':{name:'(anonymous_51)',decl:{start:{line:984,column:42},end:{line:984,column:43}},loc:{start:{line:984,column:50},end:{line:984,column:109}},line:984},'52':{name:'(anonymous_52)',decl:{start:{line:985,column:31},end:{line:985,column:32}},loc:{start:{line:985,column:49},end:{line:985,column:107}},line:985},'53':{name:'(anonymous_53)',decl:{start:{line:986,column:36},end:{line:986,column:37}},loc:{start:{line:986,column:42},end:{line:986,column:93}},line:986},'54':{name:'(anonymous_54)',decl:{start:{line:987,column:38},end:{line:987,column:39}},loc:{start:{line:987,column:56},end:{line:987,column:121}},line:987},'55':{name:'(anonymous_55)',decl:{start:{line:988,column:43},end:{line:988,column:44}},loc:{start:{line:988,column:49},end:{line:988,column:107}},line:988},'56':{name:'(anonymous_56)',decl:{start:{line:989,column:39},end:{line:989,column:40}},loc:{start:{line:989,column:53},end:{line:989,column:115}},line:989},'57':{name:'(anonymous_57)',decl:{start:{line:990,column:44},end:{line:990,column:45}},loc:{start:{line:990,column:50},end:{line:990,column:109}},line:990}},branchMap:{'0':{loc:{start:{line:156,column:8},end:{line:158,column:9}},type:'if',locations:[{start:{line:156,column:8},end:{line:158,column:9}},{start:{line:156,column:8},end:{line:158,column:9}}],line:156},'1':{loc:{start:{line:167,column:8},end:{line:180,column:9}},type:'if',locations:[{start:{line:167,column:8},end:{line:180,column:9}},{start:{line:167,column:8},end:{line:180,column:9}}],line:167},'2':{loc:{start:{line:182,column:8},end:{line:226,column:9}},type:'if',locations:[{start:{line:182,column:8},end:{line:226,column:9}},{start:{line:182,column:8},end:{line:226,column:9}}],line:182},'3':{loc:{start:{line:182,column:11},end:{line:182,column:71}},type:'binary-expr',locations:[{start:{line:182,column:11},end:{line:182,column:39}},{start:{line:182,column:43},end:{line:182,column:71}}],line:182},'4':{loc:{start:{line:206,column:13},end:{line:226,column:9}},type:'if',locations:[{start:{line:206,column:13},end:{line:226,column:9}},{start:{line:206,column:13},end:{line:226,column:9}}],line:206},'5':{loc:{start:{line:206,column:16},end:{line:206,column:84}},type:'binary-expr',locations:[{start:{line:206,column:16},end:{line:206,column:48}},{start:{line:206,column:52},end:{line:206,column:84}}],line:206},'6':{loc:{start:{line:228,column:8},end:{line:242,column:9}},type:'if',locations:[{start:{line:228,column:8},end:{line:242,column:9}},{start:{line:228,column:8},end:{line:242,column:9}}],line:228},'7':{loc:{start:{line:228,column:11},end:{line:228,column:81}},type:'binary-expr',locations:[{start:{line:228,column:11},end:{line:228,column:44}},{start:{line:228,column:48},end:{line:228,column:81}}],line:228},'8':{loc:{start:{line:236,column:36},end:{line:236,column:93}},type:'cond-expr',locations:[{start:{line:236,column:74},end:{line:236,column:83}},{start:{line:236,column:86},end:{line:236,column:93}}],line:236},'9':{loc:{start:{line:237,column:38},end:{line:237,column:138}},type:'cond-expr',locations:[{start:{line:237,column:77},end:{line:237,column:131}},{start:{line:237,column:134},end:{line:237,column:138}}],line:237},'10':{loc:{start:{line:243,column:8},end:{line:297,column:9}},type:'if',locations:[{start:{line:243,column:8},end:{line:297,column:9}},{start:{line:243,column:8},end:{line:297,column:9}}],line:243},'11':{loc:{start:{line:257,column:13},end:{line:297,column:9}},type:'if',locations:[{start:{line:257,column:13},end:{line:297,column:9}},{start:{line:257,column:13},end:{line:297,column:9}}],line:257},'12':{loc:{start:{line:258,column:12},end:{line:279,column:13}},type:'if',locations:[{start:{line:258,column:12},end:{line:279,column:13}},{start:{line:258,column:12},end:{line:279,column:13}}],line:258},'13':{loc:{start:{line:263,column:24},end:{line:276,column:25}},type:'if',locations:[{start:{line:263,column:24},end:{line:276,column:25}},{start:{line:263,column:24},end:{line:276,column:25}}],line:263},'14':{loc:{start:{line:280,column:12},end:{line:296,column:13}},type:'if',locations:[{start:{line:280,column:12},end:{line:296,column:13}},{start:{line:280,column:12},end:{line:296,column:13}}],line:280},'15':{loc:{start:{line:299,column:8},end:{line:362,column:9}},type:'if',locations:[{start:{line:299,column:8},end:{line:362,column:9}},{start:{line:299,column:8},end:{line:362,column:9}}],line:299},'16':{loc:{start:{line:322,column:13},end:{line:362,column:9}},type:'if',locations:[{start:{line:322,column:13},end:{line:362,column:9}},{start:{line:322,column:13},end:{line:362,column:9}}],line:322},'17':{loc:{start:{line:323,column:12},end:{line:344,column:13}},type:'if',locations:[{start:{line:323,column:12},end:{line:344,column:13}},{start:{line:323,column:12},end:{line:344,column:13}}],line:323},'18':{loc:{start:{line:328,column:24},end:{line:341,column:25}},type:'if',locations:[{start:{line:328,column:24},end:{line:341,column:25}},{start:{line:328,column:24},end:{line:341,column:25}}],line:328},'19':{loc:{start:{line:345,column:12},end:{line:361,column:13}},type:'if',locations:[{start:{line:345,column:12},end:{line:361,column:13}},{start:{line:345,column:12},end:{line:361,column:13}}],line:345},'20':{loc:{start:{line:381,column:8},end:{line:408,column:9}},type:'if',locations:[{start:{line:381,column:8},end:{line:408,column:9}},{start:{line:381,column:8},end:{line:408,column:9}}],line:381},'21':{loc:{start:{line:413,column:8},end:{line:440,column:9}},type:'if',locations:[{start:{line:413,column:8},end:{line:440,column:9}},{start:{line:413,column:8},end:{line:440,column:9}}],line:413},'22':{loc:{start:{line:489,column:8},end:{line:516,column:9}},type:'if',locations:[{start:{line:489,column:8},end:{line:516,column:9}},{start:{line:489,column:8},end:{line:516,column:9}}],line:489},'23':{loc:{start:{line:490,column:12},end:{line:515,column:13}},type:'if',locations:[{start:{line:490,column:12},end:{line:515,column:13}},{start:{line:490,column:12},end:{line:515,column:13}}],line:490},'24':{loc:{start:{line:517,column:8},end:{line:522,column:9}},type:'if',locations:[{start:{line:517,column:8},end:{line:522,column:9}},{start:{line:517,column:8},end:{line:522,column:9}}],line:517},'25':{loc:{start:{line:523,column:8},end:{line:525,column:9}},type:'if',locations:[{start:{line:523,column:8},end:{line:525,column:9}},{start:{line:523,column:8},end:{line:525,column:9}}],line:523},'26':{loc:{start:{line:528,column:8},end:{line:530,column:9}},type:'if',locations:[{start:{line:528,column:8},end:{line:530,column:9}},{start:{line:528,column:8},end:{line:530,column:9}}],line:528},'27':{loc:{start:{line:534,column:8},end:{line:536,column:9}},type:'if',locations:[{start:{line:534,column:8},end:{line:536,column:9}},{start:{line:534,column:8},end:{line:536,column:9}}],line:534},'28':{loc:{start:{line:538,column:8},end:{line:540,column:9}},type:'if',locations:[{start:{line:538,column:8},end:{line:540,column:9}},{start:{line:538,column:8},end:{line:540,column:9}}],line:538},'29':{loc:{start:{line:544,column:21},end:{line:965,column:21}},type:'cond-expr',locations:[{start:{line:545,column:24},end:{line:764,column:31}},{start:{line:766,column:24},end:{line:964,column:31}}],line:544},'30':{loc:{start:{line:553,column:59},end:{line:553,column:141}},type:'cond-expr',locations:[{start:{line:553,column:98},end:{line:553,column:134}},{start:{line:553,column:137},end:{line:553,column:141}}],line:553},'31':{loc:{start:{line:554,column:57},end:{line:554,column:143}},type:'cond-expr',locations:[{start:{line:554,column:98},end:{line:554,column:136}},{start:{line:554,column:139},end:{line:554,column:143}}],line:554},'32':{loc:{start:{line:568,column:59},end:{line:568,column:149}},type:'cond-expr',locations:[{start:{line:568,column:102},end:{line:568,column:142}},{start:{line:568,column:145},end:{line:568,column:149}}],line:568},'33':{loc:{start:{line:569,column:57},end:{line:569,column:151}},type:'cond-expr',locations:[{start:{line:569,column:102},end:{line:569,column:144}},{start:{line:569,column:147},end:{line:569,column:151}}],line:569},'34':{loc:{start:{line:587,column:63},end:{line:587,column:149}},type:'cond-expr',locations:[{start:{line:587,column:104},end:{line:587,column:142}},{start:{line:587,column:145},end:{line:587,column:149}}],line:587},'35':{loc:{start:{line:588,column:61},end:{line:588,column:151}},type:'cond-expr',locations:[{start:{line:588,column:104},end:{line:588,column:144}},{start:{line:588,column:147},end:{line:588,column:151}}],line:588},'36':{loc:{start:{line:605,column:63},end:{line:605,column:163}},type:'cond-expr',locations:[{start:{line:605,column:111},end:{line:605,column:156}},{start:{line:605,column:159},end:{line:605,column:163}}],line:605},'37':{loc:{start:{line:606,column:61},end:{line:606,column:165}},type:'cond-expr',locations:[{start:{line:606,column:111},end:{line:606,column:158}},{start:{line:606,column:161},end:{line:606,column:165}}],line:606},'38':{loc:{start:{line:623,column:63},end:{line:623,column:147}},type:'cond-expr',locations:[{start:{line:623,column:103},end:{line:623,column:140}},{start:{line:623,column:143},end:{line:623,column:147}}],line:623},'39':{loc:{start:{line:624,column:61},end:{line:624,column:149}},type:'cond-expr',locations:[{start:{line:624,column:103},end:{line:624,column:142}},{start:{line:624,column:145},end:{line:624,column:149}}],line:624},'40':{loc:{start:{line:641,column:63},end:{line:641,column:161}},type:'cond-expr',locations:[{start:{line:641,column:110},end:{line:641,column:154}},{start:{line:641,column:157},end:{line:641,column:161}}],line:641},'41':{loc:{start:{line:642,column:61},end:{line:642,column:163}},type:'cond-expr',locations:[{start:{line:642,column:110},end:{line:642,column:156}},{start:{line:642,column:159},end:{line:642,column:163}}],line:642},'42':{loc:{start:{line:666,column:59},end:{line:666,column:145}},type:'cond-expr',locations:[{start:{line:666,column:100},end:{line:666,column:138}},{start:{line:666,column:141},end:{line:666,column:145}}],line:666},'43':{loc:{start:{line:667,column:57},end:{line:667,column:147}},type:'cond-expr',locations:[{start:{line:667,column:100},end:{line:667,column:140}},{start:{line:667,column:143},end:{line:667,column:147}}],line:667},'44':{loc:{start:{line:684,column:59},end:{line:684,column:145}},type:'cond-expr',locations:[{start:{line:684,column:100},end:{line:684,column:138}},{start:{line:684,column:141},end:{line:684,column:145}}],line:684},'45':{loc:{start:{line:685,column:57},end:{line:685,column:147}},type:'cond-expr',locations:[{start:{line:685,column:100},end:{line:685,column:140}},{start:{line:685,column:143},end:{line:685,column:147}}],line:685},'46':{loc:{start:{line:703,column:59},end:{line:703,column:147}},type:'cond-expr',locations:[{start:{line:703,column:101},end:{line:703,column:140}},{start:{line:703,column:143},end:{line:703,column:147}}],line:703},'47':{loc:{start:{line:704,column:57},end:{line:704,column:149}},type:'cond-expr',locations:[{start:{line:704,column:101},end:{line:704,column:142}},{start:{line:704,column:145},end:{line:704,column:149}}],line:704},'48':{loc:{start:{line:722,column:59},end:{line:722,column:165}},type:'cond-expr',locations:[{start:{line:722,column:110},end:{line:722,column:158}},{start:{line:722,column:161},end:{line:722,column:165}}],line:722},'49':{loc:{start:{line:723,column:57},end:{line:723,column:167}},type:'cond-expr',locations:[{start:{line:723,column:110},end:{line:723,column:160}},{start:{line:723,column:163},end:{line:723,column:167}}],line:723},'50':{loc:{start:{line:740,column:59},end:{line:740,column:153}},type:'cond-expr',locations:[{start:{line:740,column:104},end:{line:740,column:146}},{start:{line:740,column:149},end:{line:740,column:153}}],line:740},'51':{loc:{start:{line:741,column:57},end:{line:741,column:155}},type:'cond-expr',locations:[{start:{line:741,column:104},end:{line:741,column:148}},{start:{line:741,column:151},end:{line:741,column:155}}],line:741},'52':{loc:{start:{line:776,column:59},end:{line:776,column:151}},type:'cond-expr',locations:[{start:{line:776,column:103},end:{line:776,column:144}},{start:{line:776,column:147},end:{line:776,column:151}}],line:776},'53':{loc:{start:{line:777,column:57},end:{line:777,column:153}},type:'cond-expr',locations:[{start:{line:777,column:103},end:{line:777,column:146}},{start:{line:777,column:149},end:{line:777,column:153}}],line:777},'54':{loc:{start:{line:795,column:59},end:{line:795,column:175}},type:'cond-expr',locations:[{start:{line:795,column:115},end:{line:795,column:168}},{start:{line:795,column:171},end:{line:795,column:175}}],line:795},'55':{loc:{start:{line:796,column:57},end:{line:796,column:177}},type:'cond-expr',locations:[{start:{line:796,column:115},end:{line:796,column:170}},{start:{line:796,column:173},end:{line:796,column:177}}],line:796},'56':{loc:{start:{line:814,column:59},end:{line:814,column:173}},type:'cond-expr',locations:[{start:{line:814,column:114},end:{line:814,column:166}},{start:{line:814,column:169},end:{line:814,column:173}}],line:814},'57':{loc:{start:{line:815,column:57},end:{line:815,column:175}},type:'cond-expr',locations:[{start:{line:815,column:114},end:{line:815,column:168}},{start:{line:815,column:171},end:{line:815,column:175}}],line:815},'58':{loc:{start:{line:833,column:59},end:{line:833,column:167}},type:'cond-expr',locations:[{start:{line:833,column:111},end:{line:833,column:160}},{start:{line:833,column:163},end:{line:833,column:167}}],line:833},'59':{loc:{start:{line:834,column:57},end:{line:834,column:169}},type:'cond-expr',locations:[{start:{line:834,column:111},end:{line:834,column:162}},{start:{line:834,column:165},end:{line:834,column:169}}],line:834},'60':{loc:{start:{line:852,column:59},end:{line:852,column:173}},type:'cond-expr',locations:[{start:{line:852,column:114},end:{line:852,column:166}},{start:{line:852,column:169},end:{line:852,column:173}}],line:852},'61':{loc:{start:{line:853,column:57},end:{line:853,column:175}},type:'cond-expr',locations:[{start:{line:853,column:114},end:{line:853,column:168}},{start:{line:853,column:171},end:{line:853,column:175}}],line:853},'62':{loc:{start:{line:871,column:59},end:{line:871,column:177}},type:'cond-expr',locations:[{start:{line:871,column:116},end:{line:871,column:170}},{start:{line:871,column:173},end:{line:871,column:177}}],line:871},'63':{loc:{start:{line:872,column:57},end:{line:872,column:179}},type:'cond-expr',locations:[{start:{line:872,column:116},end:{line:872,column:172}},{start:{line:872,column:175},end:{line:872,column:179}}],line:872},'64':{loc:{start:{line:892,column:59},end:{line:892,column:179}},type:'cond-expr',locations:[{start:{line:892,column:117},end:{line:892,column:172}},{start:{line:892,column:175},end:{line:892,column:179}}],line:892},'65':{loc:{start:{line:893,column:57},end:{line:893,column:181}},type:'cond-expr',locations:[{start:{line:893,column:117},end:{line:893,column:174}},{start:{line:893,column:177},end:{line:893,column:181}}],line:893},'66':{loc:{start:{line:909,column:59},end:{line:909,column:193}},type:'cond-expr',locations:[{start:{line:909,column:124},end:{line:909,column:186}},{start:{line:909,column:189},end:{line:909,column:193}}],line:909},'67':{loc:{start:{line:910,column:57},end:{line:910,column:195}},type:'cond-expr',locations:[{start:{line:910,column:124},end:{line:910,column:188}},{start:{line:910,column:191},end:{line:910,column:195}}],line:910},'68':{loc:{start:{line:926,column:111},end:{line:926,column:241}},type:'cond-expr',locations:[{start:{line:926,column:174},end:{line:926,column:234}},{start:{line:926,column:237},end:{line:926,column:241}}],line:926},'69':{loc:{start:{line:927,column:57},end:{line:927,column:191}},type:'cond-expr',locations:[{start:{line:927,column:122},end:{line:927,column:184}},{start:{line:927,column:187},end:{line:927,column:191}}],line:927}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0,'115':0,'116':0,'117':0,'118':0,'119':0,'120':0,'121':0,'122':0,'123':0,'124':0,'125':0,'126':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0],'48':[0,0],'49':[0,0],'50':[0,0],'51':[0,0],'52':[0,0],'53':[0,0],'54':[0,0],'55':[0,0],'56':[0,0],'57':[0,0],'58':[0,0],'59':[0,0],'60':[0,0],'61':[0,0],'62':[0,0],'63':[0,0],'64':[0,0],'65':[0,0],'66':[0,0],'67':[0,0],'68':[0,0],'69':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditJobModal=function(_ref){_inherits(EditJobModal,_ref);function EditJobModal(props){_classCallCheck(this,EditJobModal);cov_14vbwvwk0.f[0]++;cov_14vbwvwk0.s[0]++;var _this=_possibleConstructorReturn(this,(EditJobModal.__proto__||Object.getPrototypeOf(EditJobModal)).call(this,props));_this.defaultFormState={job:{name:{state:false,message:false},orders:{state:false,message:false},pieces:{state:false,message:false},stitches:{state:false,message:false},colors:{state:false,message:false},color_changes:{state:false,message:false},trims:{state:false,message:false},cone_changes:{state:false,message:false},garment_handling:{state:false,message:false},hooping:{state:false,message:false},other_work:{state:false,message:false}},machine:{speed:{state:false,message:false},color_change_time:{state:false,message:false},bobbin_stitch_count:{state:false,message:false},bobbin_change_time:{state:false,message:false},stitches_next_thread_break:{state:false,message:false},thread_break_fixing_time:{state:false,message:false},hoop_change_time:{state:false,message:false},trimming_time:{state:false,message:false},cone_change_time:{state:false,message:false},maintenance_cost:{state:false,message:false}}};_this.defaultMessageState={show:false,message:null};_this.defaultFormJob={name:_this.props.state.job.details.name,orders:_this.props.state.job.details.orders,pieces:_this.props.state.job.details.pieces,stitches:_this.props.state.job.details.stitches,colors:_this.props.state.job.details.colors,color_changes:_this.props.state.job.details.color_changes,trims:_this.props.state.job.details.trims,cone_changes:_this.props.state.job.details.cone_changes,garment_handling:_this.props.state.job.details.garment_handling,hooping:_this.props.state.job.details.hooping,other_work:_this.props.state.job.details.other_work/60};_this.defaultFormMachine={speed:0,color_change_time:0,bobbin_stitch_count:0,bobbin_change_time:0,stitches_next_thread_break:0,thread_break_fixing_time:0,hoop_change_time:0,trimming_time:0,cone_change_time:0,maintenance_cost:0,apply_to_all_machines:false};_this.componentDidMount=function(){cov_14vbwvwk0.f[1]++;cov_14vbwvwk0.s[2]++;if(_this.props.state.job.details.Id){cov_14vbwvwk0.b[0][0]++;cov_14vbwvwk0.s[3]++;_this.props.onCalculatorJobMachineFetch(_this.props.state.job.details.Id);}else{cov_14vbwvwk0.b[0][1]++;}};_this.componentWillUnmount=function(){cov_14vbwvwk0.f[2]++;cov_14vbwvwk0.s[4]++;_this.props.onCalculatorJobMachineFetchReset();cov_14vbwvwk0.s[5]++;_this.props.onCalculatorJobUpdateReset();cov_14vbwvwk0.s[6]++;_this.props.onCalculatorJobMachineUpdateReset();cov_14vbwvwk0.s[7]++;_this.props.onCalculatorJobDuplicateCheckReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_14vbwvwk0.f[3]++;cov_14vbwvwk0.s[8]++;if(prevProps.defaults!==_this.props.defaults){cov_14vbwvwk0.b[1][0]++;cov_14vbwvwk0.s[9]++;_this.setState(function(prevState){cov_14vbwvwk0.f[4]++;cov_14vbwvwk0.s[10]++;return Object.assign({},prevState.tabs,{tabs:[{name:_this.props.translate('editjobmodal.tab_1.name'),active:true,batch:false},{name:_this.props.translate('editjobmodal.tab_2.name'),active:false,batch:false}]});});}else{cov_14vbwvwk0.b[1][1]++;}//Handle if job fetched
cov_14vbwvwk0.s[11]++;if((cov_14vbwvwk0.b[3][0]++,!prevProps.state.job.fetched)&&(cov_14vbwvwk0.b[3][1]++,_this.props.state.job.fetched)){cov_14vbwvwk0.b[2][0]++;cov_14vbwvwk0.s[12]++;_this.props.onCalculatorJobMachineFetch(_this.props.state.job.details.Id);//Fill out Form fields
cov_14vbwvwk0.s[13]++;_this.setState(function(prevState){cov_14vbwvwk0.f[5]++;cov_14vbwvwk0.s[14]++;return{form:Object.assign({},prevState.form,{job:Object.assign({},prevState.form.job,{name:_this.props.state.job.details.name,orders:_this.props.state.job.details.orders,pieces:_this.props.state.job.details.pieces,stitches:_this.props.state.job.details.stitches,colors:_this.props.state.job.details.colors,color_changes:_this.props.state.job.details.color_changes,trims:_this.props.state.job.details.trims,cone_changes:_this.props.state.job.details.cone_changes,garment_handling:_this.props.state.job.details.garment_handling,hooping:_this.props.state.job.details.hooping,other_work:_this.props.state.job.details.other_work/60})})};});}//Handle if machine fetched
else{cov_14vbwvwk0.b[2][1]++;cov_14vbwvwk0.s[15]++;if((cov_14vbwvwk0.b[5][0]++,!prevProps.state.machine.fetched)&&(cov_14vbwvwk0.b[5][1]++,_this.props.state.machine.fetched)){cov_14vbwvwk0.b[4][0]++;cov_14vbwvwk0.s[16]++;//Fill out form fields
_this.setState(function(prevState){cov_14vbwvwk0.f[6]++;cov_14vbwvwk0.s[17]++;return{form:Object.assign({},prevState.form,{machine:Object.assign({},prevState.form.machine,{speed:_this.props.state.machine.details.settings.speed,color_change_time:_this.props.state.machine.details.settings.color_change_time,bobbin_stitch_count:_this.props.state.machine.details.settings.bobbin_stitch_count,bobbin_change_time:_this.props.state.machine.details.settings.bobbin_change_time,stitches_next_thread_break:_this.props.state.machine.details.settings.stitches_next_thread_break,thread_break_fixing_time:_this.props.state.machine.details.settings.thread_break_fixing_time,hoop_change_time:_this.props.state.machine.details.settings.hoop_change_time,trimming_time:_this.props.state.machine.details.settings.trimming_time,cone_change_time:_this.props.state.machine.details.settings.cone_change_time,maintenance_cost:_this.props.state.machine.details.settings.maintenance_cost})})};});}else{cov_14vbwvwk0.b[4][1]++;}}//Duplicate Check
cov_14vbwvwk0.s[18]++;if((cov_14vbwvwk0.b[7][0]++,!prevProps.state.job.name_checked)&&(cov_14vbwvwk0.b[7][1]++,_this.props.state.job.name_checked)){cov_14vbwvwk0.b[6][0]++;cov_14vbwvwk0.s[19]++;_this.setState(function(prevState){cov_14vbwvwk0.f[7]++;cov_14vbwvwk0.s[20]++;return{form_state:Object.assign({},prevState.form_state,{job:Object.assign({},prevState.form_state.job,{name:Object.assign({},prevState.form_state.name,{state:_this.props.state.job.name_available?(cov_14vbwvwk0.b[8][0]++,'success'):(cov_14vbwvwk0.b[8][1]++,'error'),message:!_this.props.state.job.name_available?(cov_14vbwvwk0.b[9][0]++,_this.props.translate('editjobmodal.error.name_exists')):(cov_14vbwvwk0.b[9][1]++,null)})})})};});}else{cov_14vbwvwk0.b[6][1]++;}cov_14vbwvwk0.s[21]++;if(_this.props.state.job.updated){cov_14vbwvwk0.b[10][0]++;cov_14vbwvwk0.s[22]++;_this.props.onUpdated();cov_14vbwvwk0.s[23]++;_this.props.onCalculatorJobUpdateReset();cov_14vbwvwk0.s[24]++;_this.setState(function(prevState){cov_14vbwvwk0.f[8]++;cov_14vbwvwk0.s[25]++;return{message:{show:true,message:_this.props.translate('editjobmodal.success.job.saved'),type:"success"},form_state:_this.defaultFormState};},function(){cov_14vbwvwk0.f[9]++;cov_14vbwvwk0.s[26]++;__WEBPACK_IMPORTED_MODULE_7_react_tooltip___default.a.rebuild();});}else{cov_14vbwvwk0.b[10][1]++;cov_14vbwvwk0.s[27]++;if(prevProps.state.job.error!==_this.props.state.job.error){cov_14vbwvwk0.b[11][0]++;cov_14vbwvwk0.s[28]++;if(_this.props.state.job.error.length){cov_14vbwvwk0.b[12][0]++;cov_14vbwvwk0.s[29]++;_this.setState(function(prevState){cov_14vbwvwk0.f[10]++;cov_14vbwvwk0.s[30]++;return{form_state:_this.defaultFormState};},function(){cov_14vbwvwk0.f[11]++;cov_14vbwvwk0.s[31]++;_this.props.state.job.error.forEach(function(error,index){cov_14vbwvwk0.f[12]++;cov_14vbwvwk0.s[32]++;if(_this.state.form_state.job[error.source]){cov_14vbwvwk0.b[13][0]++;cov_14vbwvwk0.s[33]++;_this.setState(function(prevState){cov_14vbwvwk0.f[13]++;cov_14vbwvwk0.s[34]++;return{form_state:Object.assign({},prevState.form_state,{job:Object.assign({},prevState.form_state.job,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))})};});}else{cov_14vbwvwk0.b[13][1]++;}});});}else{cov_14vbwvwk0.b[12][1]++;}cov_14vbwvwk0.s[35]++;if(_this.props.state.job.error.length===1){cov_14vbwvwk0.b[14][0]++;cov_14vbwvwk0.s[36]++;_this.setState(function(prevState){cov_14vbwvwk0.f[14]++;cov_14vbwvwk0.s[37]++;return{message:{message:_this.props.translate('editjobmodal.error.'+_this.props.state.job.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('editjobmodal.error.default')}),type:"error"}};});}else{cov_14vbwvwk0.b[14][1]++;cov_14vbwvwk0.s[38]++;_this.setState(function(prevState){cov_14vbwvwk0.f[15]++;cov_14vbwvwk0.s[39]++;return{message:{message:_this.props.translate('editjobmodal.error.default'),type:"error"}};});}}else{cov_14vbwvwk0.b[11][1]++;}}cov_14vbwvwk0.s[40]++;if(_this.props.state.machine.updated){cov_14vbwvwk0.b[15][0]++;cov_14vbwvwk0.s[41]++;_this.props.onUpdated();cov_14vbwvwk0.s[42]++;_this.props.onCalculatorJobMachineUpdateReset();cov_14vbwvwk0.s[43]++;_this.setState(function(prevState){cov_14vbwvwk0.f[16]++;cov_14vbwvwk0.s[44]++;return{message:{show:true,message:_this.props.translate('editjobmodal.success.machine.saved'),type:"success"}};});cov_14vbwvwk0.s[45]++;_this.setState(function(prevState){cov_14vbwvwk0.f[17]++;cov_14vbwvwk0.s[46]++;return{form:Object.assign({},prevState.form,{machine:Object.assign({},prevState.form.machine,{apply_to_all_machines:false})})};});cov_14vbwvwk0.s[47]++;_this.setState(function(prevState){cov_14vbwvwk0.f[18]++;cov_14vbwvwk0.s[48]++;return{form_state:_this.defaultFormState};});}else{cov_14vbwvwk0.b[15][1]++;cov_14vbwvwk0.s[49]++;if(prevProps.state.machine.error!==_this.props.state.machine.error){cov_14vbwvwk0.b[16][0]++;cov_14vbwvwk0.s[50]++;if(_this.props.state.machine.error.length){cov_14vbwvwk0.b[17][0]++;cov_14vbwvwk0.s[51]++;_this.setState(function(prevState){cov_14vbwvwk0.f[19]++;cov_14vbwvwk0.s[52]++;return{form_state:_this.defaultFormState};},function(){cov_14vbwvwk0.f[20]++;cov_14vbwvwk0.s[53]++;_this.props.state.machine.error.forEach(function(error,index){cov_14vbwvwk0.f[21]++;cov_14vbwvwk0.s[54]++;if(_this.state.form_state.machine[error.source]){cov_14vbwvwk0.b[18][0]++;cov_14vbwvwk0.s[55]++;_this.setState(function(prevState){cov_14vbwvwk0.f[22]++;cov_14vbwvwk0.s[56]++;return{form_state:Object.assign({},prevState.form_state,{machine:Object.assign({},prevState.form_state.machine,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))})};});}else{cov_14vbwvwk0.b[18][1]++;}});});}else{cov_14vbwvwk0.b[17][1]++;}cov_14vbwvwk0.s[57]++;if(_this.props.state.machine.error.length===1){cov_14vbwvwk0.b[19][0]++;cov_14vbwvwk0.s[58]++;_this.setState(function(prevState){cov_14vbwvwk0.f[23]++;cov_14vbwvwk0.s[59]++;return{message:{message:_this.props.translate('editjobmodal.error.'+_this.props.state.machine.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('editjobmodal.error.default')}),type:"error"}};});}else{cov_14vbwvwk0.b[19][1]++;cov_14vbwvwk0.s[60]++;_this.setState(function(prevState){cov_14vbwvwk0.f[24]++;cov_14vbwvwk0.s[61]++;return{message:{message:_this.props.translate('editjobmodal.error.default'),type:"error"}};});}}else{cov_14vbwvwk0.b[16][1]++;}}};_this.onTabClickedHandler=function(index){cov_14vbwvwk0.f[25]++;var tabs=(cov_14vbwvwk0.s[62]++,[].concat(_toConsumableArray(_this.state.tabs)));cov_14vbwvwk0.s[63]++;tabs.map(function(tab,index){cov_14vbwvwk0.f[26]++;cov_14vbwvwk0.s[64]++;tab.active=false;});cov_14vbwvwk0.s[65]++;tabs[index].active=true;cov_14vbwvwk0.s[66]++;_this.setState(function(prevState){cov_14vbwvwk0.f[27]++;cov_14vbwvwk0.s[67]++;return{tabs:tabs};},function(){cov_14vbwvwk0.f[28]++;cov_14vbwvwk0.s[68]++;__WEBPACK_IMPORTED_MODULE_7_react_tooltip___default.a.rebuild();});};_this.updateJobHandler=function(event){cov_14vbwvwk0.f[29]++;cov_14vbwvwk0.s[69]++;event.preventDefault();cov_14vbwvwk0.s[70]++;if(__WEBPACK_IMPORTED_MODULE_8__helpers_Form_js__["a" /* validateFields */].apply(_this,[['name','stitches','colors','color_changes','trims','cone_changes','orders','hooping','pieces','other_work','garment_handling'],'job'])){cov_14vbwvwk0.b[20][0]++;var formData=(cov_14vbwvwk0.s[71]++,{name:_this.state.form.job.name,orders:Number.parseInt(_this.state.form.job.orders),pieces:Number.parseInt(_this.state.form.job.pieces),stitches:Number.parseInt(_this.state.form.job.stitches),colors:Number.parseInt(_this.state.form.job.colors),color_changes:Number.parseInt(_this.state.form.job.color_changes),trims:Number.parseInt(_this.state.form.job.trims),cone_changes:Number.parseInt(_this.state.form.job.cone_changes),garment_handling:Number.parseInt(_this.state.form.job.garment_handling),hooping:Number.parseInt(_this.state.form.job.hooping),other_work:Number.parseFloat(_this.state.form.job.other_work)*60});cov_14vbwvwk0.s[72]++;_this.setState(function(prevState){cov_14vbwvwk0.f[30]++;cov_14vbwvwk0.s[73]++;return{form_state:_this.defaultFormState};});cov_14vbwvwk0.s[74]++;_this.props.onCalculatorJobUpdate(_this.props.state.job.details.Id,formData);}else{cov_14vbwvwk0.b[20][1]++;cov_14vbwvwk0.s[75]++;_this.setState(function(prevState){cov_14vbwvwk0.f[31]++;cov_14vbwvwk0.s[76]++;return{message:{show:true,message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}};_this.updateMachineHandler=function(event){cov_14vbwvwk0.f[32]++;cov_14vbwvwk0.s[77]++;event.preventDefault();cov_14vbwvwk0.s[78]++;if(__WEBPACK_IMPORTED_MODULE_8__helpers_Form_js__["a" /* validateFields */].apply(_this,[['speed','color_change_time','bobbin_stitch_count','bobbin_change_time','stitches_next_thread_break','thread_break_fixing_time','hoop_change_time','trimming_time','cone_change_time'],'machine'])){cov_14vbwvwk0.b[21][0]++;var formData=(cov_14vbwvwk0.s[79]++,{speed:Number.parseInt(_this.state.form.machine.speed),color_change_time:Number.parseInt(_this.state.form.machine.color_change_time),bobbin_stitch_count:Number.parseInt(_this.state.form.machine.bobbin_stitch_count),bobbin_change_time:Number.parseInt(_this.state.form.machine.bobbin_change_time),stitches_next_thread_break:Number.parseInt(_this.state.form.machine.stitches_next_thread_break),thread_break_fixing_time:Number.parseInt(_this.state.form.machine.thread_break_fixing_time),hoop_change_time:Number.parseInt(_this.state.form.machine.hoop_change_time),trimming_time:Number.parseInt(_this.state.form.machine.trimming_time),cone_change_time:Number.parseInt(_this.state.form.machine.cone_change_time),maintenance_cost:Number.parseInt(_this.state.form.machine.maintenance_cost),apply_to_all_machines:_this.state.form.machine.apply_to_all_machines});cov_14vbwvwk0.s[80]++;_this.setState(function(prevState){cov_14vbwvwk0.f[33]++;cov_14vbwvwk0.s[81]++;return{form_state:_this.defaultFormState};});cov_14vbwvwk0.s[82]++;_this.props.onCalculatorJobMachineUpdate(_this.props.state.job.details.Id,formData);}else{cov_14vbwvwk0.b[21][1]++;cov_14vbwvwk0.s[83]++;_this.setState(function(prevState){cov_14vbwvwk0.f[34]++;cov_14vbwvwk0.s[84]++;return{message:{show:true,message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}};_this.inputChangedHandlerJob=function(event,inputIdentifier){cov_14vbwvwk0.f[35]++;var value=(cov_14vbwvwk0.s[85]++,event.target.value);cov_14vbwvwk0.s[86]++;_this.setState(function(prevState){cov_14vbwvwk0.f[36]++;cov_14vbwvwk0.s[87]++;return{form:Object.assign({},prevState.form,{job:Object.assign({},prevState.form.job,_defineProperty({},inputIdentifier,value))})};});};_this.inputChangedHandlerMachine=function(event,inputIdentifier){cov_14vbwvwk0.f[37]++;var value=(cov_14vbwvwk0.s[88]++,event.target.value);cov_14vbwvwk0.s[89]++;_this.setState(function(prevState){cov_14vbwvwk0.f[38]++;cov_14vbwvwk0.s[90]++;return{form:Object.assign({},prevState.form,{machine:Object.assign({},prevState.form.machine,_defineProperty({},inputIdentifier,value))})};});};_this.inputChangedToggleMachine=function(value,inputIdentifier){cov_14vbwvwk0.f[39]++;cov_14vbwvwk0.s[91]++;_this.setState(function(prevState){cov_14vbwvwk0.f[40]++;cov_14vbwvwk0.s[92]++;return{form:Object.assign({},prevState.form,{machine:Object.assign({},prevState.form.machine,_defineProperty({},inputIdentifier,value))})};});};_this.onCloseModal=function(){cov_14vbwvwk0.f[41]++;cov_14vbwvwk0.s[93]++;_this.setState(function(prevState){cov_14vbwvwk0.f[42]++;cov_14vbwvwk0.s[94]++;return{modalOpen:false};});};_this.inputBlurredHandler=function(event,inputIdentifier){cov_14vbwvwk0.f[43]++;var value=(cov_14vbwvwk0.s[95]++,event.target.value);cov_14vbwvwk0.s[96]++;if(inputIdentifier==='name'){cov_14vbwvwk0.b[22][0]++;cov_14vbwvwk0.s[97]++;if(value.length){cov_14vbwvwk0.b[23][0]++;cov_14vbwvwk0.s[98]++;_this.setState(function(prevState){cov_14vbwvwk0.f[44]++;cov_14vbwvwk0.s[99]++;return{form_state:Object.assign({},prevState.form_state,{job:Object.assign({},prevState.form_state.job,{name:Object.assign({},prevState.form_state.name,{state:'loading'})})})};});cov_14vbwvwk0.s[100]++;_this.props.onCalculatorJobDuplicateCheck({name:value,id:_this.props.state.job.details.Id});}else{cov_14vbwvwk0.b[23][1]++;cov_14vbwvwk0.s[101]++;_this.setState(function(prevState){cov_14vbwvwk0.f[45]++;cov_14vbwvwk0.s[102]++;return{form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:false})})};});}}else{cov_14vbwvwk0.b[22][1]++;}cov_14vbwvwk0.s[103]++;if(_this.state.tabs[0].active){cov_14vbwvwk0.b[24][0]++;cov_14vbwvwk0.s[104]++;__WEBPACK_IMPORTED_MODULE_8__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier],'job']);}else{cov_14vbwvwk0.b[24][1]++;cov_14vbwvwk0.s[105]++;__WEBPACK_IMPORTED_MODULE_8__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier],'machine']);}cov_14vbwvwk0.s[106]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_14vbwvwk0.b[25][0]++;cov_14vbwvwk0.s[107]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_14vbwvwk0.b[25][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_14vbwvwk0.f[46]++;cov_14vbwvwk0.s[108]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_14vbwvwk0.b[26][0]++;cov_14vbwvwk0.s[109]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_14vbwvwk0.b[26][1]++;}};cov_14vbwvwk0.s[1]++;_this.state={form:{job:_this.defaultFormJob,machine:_this.defaultFormMachine},form_state:_this.defaultFormState,message:_this.defaultMessageState,modalOpen:true,tabs:[{name:_this.props.translate('editjobmodal.tab_1.name'),active:true,batch:false},{name:_this.props.translate('editjobmodal.tab_2.name'),active:false,batch:false}]};return _this;}_createClass(EditJobModal,[{key:'render',value:function render(){cov_14vbwvwk0.f[47]++;cov_14vbwvwk0.s[110]++;if(!this.state.modalOpen){cov_14vbwvwk0.b[27][0]++;cov_14vbwvwk0.s[111]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/jobs/'+this.props.state.job.details.Id});}else{cov_14vbwvwk0.b[27][1]++;}var showMessage;cov_14vbwvwk0.s[112]++;if(this.state.message.message){cov_14vbwvwk0.b[28][0]++;cov_14vbwvwk0.s[113]++;showMessage=this.state.message;}else{cov_14vbwvwk0.b[28][1]++;}cov_14vbwvwk0.s[114]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Modal"],{show:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["GreyBox"],{outerMargin:'true',tabs:this.state.tabs,closeIcon:this.onCloseModal,onTabClicked:this.onTabClickedHandler,cols:'2',msg_inside:showMessage,title:this.props.translate('editjobmodal.title'),titleTheme:'light'},this.state.tabs[0].active?(cov_14vbwvwk0.b[29][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Form"],{onSubmit:this.updateJobHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["BoxTitle"],null,this.props.translate('editjobmodal.tab_1.box_title_design')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.name'),ref:'nameInputRow',state:this.state.form_state.job.name.state?(cov_14vbwvwk0.b[30][0]++,this.state.form_state.job.name.state):(cov_14vbwvwk0.b[30][1]++,null),tip:this.state.form_state.job.name.message?(cov_14vbwvwk0.b[31][0]++,this.state.form_state.job.name.message):(cov_14vbwvwk0.b[31][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'name',ref:'name',type:'text',value:this.state.form.job.name,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,maxlength:50,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.stitches'),ref:'stitchesInputRow',state:this.state.form_state.job.stitches.state?(cov_14vbwvwk0.b[32][0]++,this.state.form_state.job.stitches.state):(cov_14vbwvwk0.b[32][1]++,null),tip:this.state.form_state.job.stitches.message?(cov_14vbwvwk0.b[33][0]++,this.state.form_state.job.stitches.message):(cov_14vbwvwk0.b[33][1]++,null),hint:this.props.translate('global.help.job.stitches')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'stitches',ref:'stitches',type:'number',minValue:1,maxValue:999999,value:this.state.form.job.stitches,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.colors'),cols:'2',ref:'colorsInputRow',state:this.state.form_state.job.colors.state?(cov_14vbwvwk0.b[34][0]++,this.state.form_state.job.colors.state):(cov_14vbwvwk0.b[34][1]++,null),tip:this.state.form_state.job.colors.message?(cov_14vbwvwk0.b[35][0]++,this.state.form_state.job.colors.message):(cov_14vbwvwk0.b[35][1]++,null),hint:this.props.translate('global.help.job.colors')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'colors',ref:'colors',type:'number',minValue:1,maxValue:999,value:this.state.form.job.colors,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.color_changes'),cols:'2',ref:'color_changesInputRow',state:this.state.form_state.job.color_changes.state?(cov_14vbwvwk0.b[36][0]++,this.state.form_state.job.color_changes.state):(cov_14vbwvwk0.b[36][1]++,null),tip:this.state.form_state.job.color_changes.message?(cov_14vbwvwk0.b[37][0]++,this.state.form_state.job.color_changes.message):(cov_14vbwvwk0.b[37][1]++,null),hint:this.props.translate('global.help.job.color_changes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'color_changes',ref:'color_changes',type:'number',minValue:0,maxValue:999,value:this.state.form.job.color_changes,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.trims'),cols:'2',ref:'trimsInputRow',state:this.state.form_state.job.trims.state?(cov_14vbwvwk0.b[38][0]++,this.state.form_state.job.trims.state):(cov_14vbwvwk0.b[38][1]++,null),tip:this.state.form_state.job.trims.message?(cov_14vbwvwk0.b[39][0]++,this.state.form_state.job.trims.message):(cov_14vbwvwk0.b[39][1]++,null),hint:this.props.translate('global.help.job.trims')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'trims',ref:'trims',type:'number',minValue:0,maxValue:999,value:this.state.form.job.trims,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.cone_changes'),cols:'2',ref:'cone_changesInputRow',state:this.state.form_state.job.cone_changes.state?(cov_14vbwvwk0.b[40][0]++,this.state.form_state.job.cone_changes.state):(cov_14vbwvwk0.b[40][1]++,null),tip:this.state.form_state.job.cone_changes.message?(cov_14vbwvwk0.b[41][0]++,this.state.form_state.job.cone_changes.message):(cov_14vbwvwk0.b[41][1]++,null),hint:this.props.translate('global.help.job.cone_changes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'cone_changes',ref:'cone_changes',type:'number',minValue:0,maxValue:99,value:this.state.form.job.cone_changes,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["BoxTitle"],null,this.props.translate('editjobmodal.tab_1.box_title_job')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.orders'),cols:'2',ref:'ordersInputRow',state:this.state.form_state.job.orders.state?(cov_14vbwvwk0.b[42][0]++,this.state.form_state.job.orders.state):(cov_14vbwvwk0.b[42][1]++,null),tip:this.state.form_state.job.orders.message?(cov_14vbwvwk0.b[43][0]++,this.state.form_state.job.orders.message):(cov_14vbwvwk0.b[43][1]++,null),hint:this.props.translate('global.help.job.orders')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'orders',ref:'orders',type:'number',minValue:1,maxValue:999999,value:this.state.form.job.orders,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.pieces'),cols:'2',ref:'piecesInputRow',state:this.state.form_state.job.pieces.state?(cov_14vbwvwk0.b[44][0]++,this.state.form_state.job.pieces.state):(cov_14vbwvwk0.b[44][1]++,null),tip:this.state.form_state.job.pieces.message?(cov_14vbwvwk0.b[45][0]++,this.state.form_state.job.pieces.message):(cov_14vbwvwk0.b[45][1]++,null),hint:this.props.translate('global.help.job.pieces')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'pieces',ref:'pieces',type:'number',minValue:1,maxValue:99999,value:this.state.form.job.pieces,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.hooping'),cols:'2',unit:this.props.translate('global.units.seconds'),ref:'hoopingInputRow',state:this.state.form_state.job.hooping.state?(cov_14vbwvwk0.b[46][0]++,this.state.form_state.job.hooping.state):(cov_14vbwvwk0.b[46][1]++,null),tip:this.state.form_state.job.hooping.message?(cov_14vbwvwk0.b[47][0]++,this.state.form_state.job.hooping.message):(cov_14vbwvwk0.b[47][1]++,null),hint:this.props.translate('global.help.job.hooping')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'hooping',ref:'hooping',type:'number',minValue:0,maxValue:1200,value:this.state.form.job.hooping,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.garment_handling'),cols:'2',unit:this.props.translate('global.units.seconds'),ref:'garment_handlingInputRow',state:this.state.form_state.job.garment_handling.state?(cov_14vbwvwk0.b[48][0]++,this.state.form_state.job.garment_handling.state):(cov_14vbwvwk0.b[48][1]++,null),tip:this.state.form_state.job.garment_handling.message?(cov_14vbwvwk0.b[49][0]++,this.state.form_state.job.garment_handling.message):(cov_14vbwvwk0.b[49][1]++,null),hint:this.props.translate('global.help.job.garment_handling')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'garment_handling',ref:'garment_handling',type:'number',minValue:0,maxValue:9999,value:this.state.form.job.garment_handling,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.job.other_work'),unit:this.props.translate('global.units.minutes'),ref:'other_workInputRow',state:this.state.form_state.job.other_work.state?(cov_14vbwvwk0.b[50][0]++,this.state.form_state.job.other_work.state):(cov_14vbwvwk0.b[50][1]++,null),tip:this.state.form_state.job.other_work.message?(cov_14vbwvwk0.b[51][0]++,this.state.form_state.job.other_work.message):(cov_14vbwvwk0.b[51][1]++,null),hint:this.props.translate('global.help.job.other_work')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'other_work',ref:'other_work',type:'number',minValue:0,maxValue:9999,value:this.state.form.job.other_work,changed:this.inputChangedHandlerJob,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any',validationPattern:'^\\d*(\\.\\d{0,1})?$'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{reverse:'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'cancel-edit-job-btn',href:'/jobs/'+this.props.state.job.details.Id,theme:'light',value:this.props.translate('editjobmodal.tab_2.secondary.label'),width:'320px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'save-job-information-edit-job-btn',value:this.props.translate('editjobmodal.tab_1.submit'),type:'submit',width:'320px'})))):(cov_14vbwvwk0.b[29][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Form"],{onSubmit:this.updateMachineHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["BoxTitle"],null,this.props.translate('editjobmodal.tab_2.box_title',{machine:this.props.state.machine.details.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Text"],null,this.props.translate('editjobmodal.tab_2.box_text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.speed'),unit:this.props.translate('global.units.spm'),cols:'2',ref:'speedInputRow',state:this.state.form_state.machine.speed.state?(cov_14vbwvwk0.b[52][0]++,this.state.form_state.machine.speed.state):(cov_14vbwvwk0.b[52][1]++,null),tip:this.state.form_state.machine.speed.message?(cov_14vbwvwk0.b[53][0]++,this.state.form_state.machine.speed.message):(cov_14vbwvwk0.b[53][1]++,null),hint:this.props.translate('global.help.machine.speed')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'speed',ref:'speed',type:'number',minValue:1,maxValue:2000,value:this.state.form.machine.speed,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.color_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'color_change_timeInputRow',state:this.state.form_state.machine.color_change_time.state?(cov_14vbwvwk0.b[54][0]++,this.state.form_state.machine.color_change_time.state):(cov_14vbwvwk0.b[54][1]++,null),tip:this.state.form_state.machine.color_change_time.message?(cov_14vbwvwk0.b[55][0]++,this.state.form_state.machine.color_change_time.message):(cov_14vbwvwk0.b[55][1]++,null),hint:this.props.translate('global.help.machine.color_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'color_change_time',ref:'color_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.color_change_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.hoop_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'hoop_change_timeInputRow',state:this.state.form_state.machine.hoop_change_time.state?(cov_14vbwvwk0.b[56][0]++,this.state.form_state.machine.hoop_change_time.state):(cov_14vbwvwk0.b[56][1]++,null),tip:this.state.form_state.machine.hoop_change_time.message?(cov_14vbwvwk0.b[57][0]++,this.state.form_state.machine.hoop_change_time.message):(cov_14vbwvwk0.b[57][1]++,null),hint:this.props.translate('global.help.machine.hoop_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'hoop_change_time',ref:'hoop_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.hoop_change_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.trimming_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'trimming_timeInputRow',state:this.state.form_state.machine.trimming_time.state?(cov_14vbwvwk0.b[58][0]++,this.state.form_state.machine.trimming_time.state):(cov_14vbwvwk0.b[58][1]++,null),tip:this.state.form_state.machine.trimming_time.message?(cov_14vbwvwk0.b[59][0]++,this.state.form_state.machine.trimming_time.message):(cov_14vbwvwk0.b[59][1]++,null),hint:this.props.translate('global.help.machine.trimming_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'trimming_time',ref:'trimming_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.trimming_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.cone_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'cone_change_timeInputRow',state:this.state.form_state.machine.cone_change_time.state?(cov_14vbwvwk0.b[60][0]++,this.state.form_state.machine.cone_change_time.state):(cov_14vbwvwk0.b[60][1]++,null),tip:this.state.form_state.machine.cone_change_time.message?(cov_14vbwvwk0.b[61][0]++,this.state.form_state.machine.cone_change_time.message):(cov_14vbwvwk0.b[61][1]++,null),hint:this.props.translate('global.help.machine.cone_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'cone_change_time',ref:'cone_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.cone_change_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'bobbin_change_timeInputRow',state:this.state.form_state.machine.bobbin_change_time.state?(cov_14vbwvwk0.b[62][0]++,this.state.form_state.machine.bobbin_change_time.state):(cov_14vbwvwk0.b[62][1]++,null),tip:this.state.form_state.machine.bobbin_change_time.message?(cov_14vbwvwk0.b[63][0]++,this.state.form_state.machine.bobbin_change_time.message):(cov_14vbwvwk0.b[63][1]++,null),hint:this.props.translate('global.help.machine.bobbin_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'bobbin_change_time',ref:'bobbin_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.bobbin_change_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_stitch_count'),ref:'bobbin_stitch_countInputRow',state:this.state.form_state.machine.bobbin_stitch_count.state?(cov_14vbwvwk0.b[64][0]++,this.state.form_state.machine.bobbin_stitch_count.state):(cov_14vbwvwk0.b[64][1]++,null),tip:this.state.form_state.machine.bobbin_stitch_count.message?(cov_14vbwvwk0.b[65][0]++,this.state.form_state.machine.bobbin_stitch_count.message):(cov_14vbwvwk0.b[65][1]++,null),hint:this.props.translate('global.help.machine.bobbin_stitch_count')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'bobbin_stitch_count',ref:'bobbin_stitch_count',type:'number',minValue:1,maxValue:100000,value:this.state.form.machine.bobbin_stitch_count,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.stitches_next_thread_break'),ref:'stitches_next_thread_breakInputRow',state:this.state.form_state.machine.stitches_next_thread_break.state?(cov_14vbwvwk0.b[66][0]++,this.state.form_state.machine.stitches_next_thread_break.state):(cov_14vbwvwk0.b[66][1]++,null),tip:this.state.form_state.machine.stitches_next_thread_break.message?(cov_14vbwvwk0.b[67][0]++,this.state.form_state.machine.stitches_next_thread_break.message):(cov_14vbwvwk0.b[67][1]++,null),hint:this.props.translate('global.help.machine.stitches_next_thread_break')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'stitches_next_thread_break',ref:'stitches_next_thread_break',type:'number',minValue:1,maxValue:999999,value:this.state.form.machine.stitches_next_thread_break,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{label:this.props.translate('global.form.label.machine.thread_break_fixing_time'),ref:'thread_break_fixing_timeInputRow',unit:this.props.translate('global.units.seconds'),state:this.state.form_state.machine.thread_break_fixing_time.state?(cov_14vbwvwk0.b[68][0]++,this.state.form_state.machine.thread_break_fixing_time.state):(cov_14vbwvwk0.b[68][1]++,null),tip:this.state.form_state.machine.thread_break_fixing_time.message?(cov_14vbwvwk0.b[69][0]++,this.state.form_state.machine.thread_break_fixing_time.message):(cov_14vbwvwk0.b[69][1]++,null),hint:this.props.translate('global.help.machine.thread_break_fixing_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'thread_break_fixing_time',ref:'thread_break_fixing_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.machine.thread_break_fixing_time,changed:this.inputChangedHandlerMachine,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Spacer"],{height:'20px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{reverse:true,label:this.props.translate('editjobmodal.tab_2.form.label.apply_to_all_machines'),theme:'light',cols:'2',isRight:'true',labelStyle:'toggleLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Toggle"],{identifier:'apply_to_all_machines',align:'left',multiLine:'true',value:this.state.form.machine.apply_to_all_machines,changed:this.inputChangedToggleMachine}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{reverse:'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'cancel-production-parameter-edit-job-btn',href:'/jobs/'+this.props.state.job.details.Id,theme:'light',value:this.props.translate('editjobmodal.tab_2.secondary.label'),width:'320px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'save-production-parameter-edit-job-btn',value:this.props.translate('editjobmodal.tab_2.submit'),type:'submit',width:'320px'}))))));}}]);return EditJobModal;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_14vbwvwk0.s[115]++;var mapStateToProps=function mapStateToProps(state){cov_14vbwvwk0.f[48]++;cov_14vbwvwk0.s[116]++;return{defaults:state.defaults,state:state.calculatorJob,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_14vbwvwk0.s[117]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_14vbwvwk0.f[49]++;cov_14vbwvwk0.s[118]++;return{onCalculatorJobMachineFetch:function onCalculatorJobMachineFetch(id){cov_14vbwvwk0.f[50]++;cov_14vbwvwk0.s[119]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["s" /* calculatorJobMachineFetch */](id));},onCalculatorJobMachineFetchReset:function onCalculatorJobMachineFetchReset(id){cov_14vbwvwk0.f[51]++;cov_14vbwvwk0.s[120]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["t" /* calculatorJobMachineFetchReset */](id));},onCalculatorJobUpdate:function onCalculatorJobUpdate(id,formData){cov_14vbwvwk0.f[52]++;cov_14vbwvwk0.s[121]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["z" /* calculatorJobUpdate */](id,formData));},onCalculatorJobUpdateReset:function onCalculatorJobUpdateReset(){cov_14vbwvwk0.f[53]++;cov_14vbwvwk0.s[122]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["A" /* calculatorJobUpdateReset */]());},onCalculatorJobMachineUpdate:function onCalculatorJobMachineUpdate(id,formData){cov_14vbwvwk0.f[54]++;cov_14vbwvwk0.s[123]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["u" /* calculatorJobMachineUpdate */](id,formData));},onCalculatorJobMachineUpdateReset:function onCalculatorJobMachineUpdateReset(){cov_14vbwvwk0.f[55]++;cov_14vbwvwk0.s[124]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["v" /* calculatorJobMachineUpdateReset */]());},onCalculatorJobDuplicateCheck:function onCalculatorJobDuplicateCheck(formData){cov_14vbwvwk0.f[56]++;cov_14vbwvwk0.s[125]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["m" /* calculatorJobDuplicateCheck */](formData));},onCalculatorJobDuplicateCheckReset:function onCalculatorJobDuplicateCheckReset(){cov_14vbwvwk0.f[57]++;cov_14vbwvwk0.s[126]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["n" /* calculatorJobDuplicateCheckReset */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(EditJobModal,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_download_js__ = __webpack_require__(667);
var cov_2j0tp4xh6q=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\ExportJobModal\\index.js',hash='825a0b7ccc0190a2ff890b843fbe7fdfb30cf458',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\ExportJobModal\\index.js',statementMap:{'0':{start:{line:14,column:8},end:{line:14,column:21}},'1':{start:{line:15,column:8},end:{line:17,column:9}},'2':{start:{line:20,column:8},end:{line:20,column:53}},'3':{start:{line:21,column:8},end:{line:21,column:63}},'4':{start:{line:21,column:34},end:{line:21,column:63}},'5':{start:{line:24,column:8},end:{line:27,column:9}},'6':{start:{line:25,column:12},end:{line:25,column:93}},'7':{start:{line:26,column:12},end:{line:26,column:57}},'8':{start:{line:31,column:8},end:{line:35,column:11}},'9':{start:{line:31,column:36},end:{line:33,column:9}},'10':{start:{line:34,column:12},end:{line:34,column:80}},'11':{start:{line:39,column:8},end:{line:39,column:113}},'12':{start:{line:43,column:8},end:{line:57,column:9}},'13':{start:{line:61,column:24},end:{line:69,column:1}},'14':{start:{line:62,column:4},end:{line:68,column:6}},'15':{start:{line:71,column:27},end:{line:77,column:1}},'16':{start:{line:72,column:4},end:{line:76,column:5}},'17':{start:{line:73,column:54},end:{line:73,column:117}},'18':{start:{line:74,column:47},end:{line:74,column:103}},'19':{start:{line:75,column:31},end:{line:75,column:71}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:4},end:{line:13,column:5}},loc:{start:{line:13,column:23},end:{line:18,column:2}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:19,column:27},end:{line:19,column:28}},loc:{start:{line:19,column:33},end:{line:22,column:5}},line:19},'2':{name:'(anonymous_2)',decl:{start:{line:23,column:25},end:{line:23,column:26}},loc:{start:{line:23,column:61},end:{line:28,column:5}},line:23},'3':{name:'(anonymous_3)',decl:{start:{line:30,column:14},end:{line:30,column:15}},loc:{start:{line:30,column:20},end:{line:36,column:5}},line:30},'4':{name:'(anonymous_4)',decl:{start:{line:31,column:22},end:{line:31,column:23}},loc:{start:{line:31,column:36},end:{line:33,column:9}},line:31},'5':{name:'(anonymous_5)',decl:{start:{line:33,column:12},end:{line:33,column:13}},loc:{start:{line:33,column:18},end:{line:35,column:9}},line:33},'6':{name:'(anonymous_6)',decl:{start:{line:38,column:15},end:{line:38,column:16}},loc:{start:{line:38,column:25},end:{line:40,column:5}},line:38},'7':{name:'(anonymous_7)',decl:{start:{line:42,column:1},end:{line:42,column:2}},loc:{start:{line:42,column:11},end:{line:58,column:5}},line:42},'8':{name:'(anonymous_8)',decl:{start:{line:61,column:24},end:{line:61,column:25}},loc:{start:{line:61,column:33},end:{line:69,column:1}},line:61},'9':{name:'(anonymous_9)',decl:{start:{line:71,column:27},end:{line:71,column:28}},loc:{start:{line:71,column:39},end:{line:77,column:1}},line:71},'10':{name:'(anonymous_10)',decl:{start:{line:73,column:36},end:{line:73,column:37}},loc:{start:{line:73,column:54},end:{line:73,column:117}},line:73},'11':{name:'(anonymous_11)',decl:{start:{line:74,column:41},end:{line:74,column:42}},loc:{start:{line:74,column:47},end:{line:74,column:103}},line:74},'12':{name:'(anonymous_12)',decl:{start:{line:75,column:25},end:{line:75,column:26}},loc:{start:{line:75,column:31},end:{line:75,column:71}},line:75}},branchMap:{'0':{loc:{start:{line:21,column:8},end:{line:21,column:63}},type:'if',locations:[{start:{line:21,column:8},end:{line:21,column:63}},{start:{line:21,column:8},end:{line:21,column:63}}],line:21},'1':{loc:{start:{line:24,column:8},end:{line:27,column:9}},type:'if',locations:[{start:{line:24,column:8},end:{line:27,column:9}},{start:{line:24,column:8},end:{line:27,column:9}}],line:24},'2':{loc:{start:{line:24,column:11},end:{line:24,column:77}},type:'binary-expr',locations:[{start:{line:24,column:11},end:{line:24,column:42}},{start:{line:24,column:46},end:{line:24,column:77}}],line:24}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0},b:{'0':[0,0],'1':[0,0],'2':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExportJobModal=function(_ref){_inherits(ExportJobModal,_ref);function ExportJobModal(props){_classCallCheck(this,ExportJobModal);cov_2j0tp4xh6q.f[0]++;cov_2j0tp4xh6q.s[0]++;var _this=_possibleConstructorReturn(this,(ExportJobModal.__proto__||Object.getPrototypeOf(ExportJobModal)).call(this,props));_this.componentWillUnmount=function(){cov_2j0tp4xh6q.f[1]++;cov_2j0tp4xh6q.s[2]++;_this.props.onCalculatorJobExportFetchReset();cov_2j0tp4xh6q.s[3]++;if(_this.state.isPrinting){cov_2j0tp4xh6q.b[0][0]++;cov_2j0tp4xh6q.s[4]++;_this.props.onPrintingStart();}else{cov_2j0tp4xh6q.b[0][1]++;}};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_2j0tp4xh6q.f[2]++;cov_2j0tp4xh6q.s[5]++;if((cov_2j0tp4xh6q.b[2][0]++,!prevProps.state.export.fetched)&&(cov_2j0tp4xh6q.b[2][1]++,_this.props.state.export.fetched)){cov_2j0tp4xh6q.b[1][0]++;cov_2j0tp4xh6q.s[6]++;Object(__WEBPACK_IMPORTED_MODULE_8__helpers_download_js__["a" /* fileDownload */])(_this.props.state.export.filebody,_this.props.state.export.filename);cov_2j0tp4xh6q.s[7]++;_this.props.onCalculatorJobExportFetchReset();}else{cov_2j0tp4xh6q.b[1][1]++;}};_this.onPrint=function(){cov_2j0tp4xh6q.f[3]++;cov_2j0tp4xh6q.s[8]++;_this.setState(function(prevState){cov_2j0tp4xh6q.f[4]++;cov_2j0tp4xh6q.s[9]++;return{isPrinting:true};},function(){cov_2j0tp4xh6q.f[5]++;cov_2j0tp4xh6q.s[10]++;_this.props.history.push('/jobs/'+_this.props.state.job.details.Id);});};_this.onExport=function(type){cov_2j0tp4xh6q.f[6]++;cov_2j0tp4xh6q.s[11]++;_this.props.onCalculatorJobExportFetch(_this.props.state.job.details.Id,type,_this.props.currentLanguage);};cov_2j0tp4xh6q.s[1]++;_this.state={isPrinting:false};return _this;}_createClass(ExportJobModal,[{key:'render',value:function render(){cov_2j0tp4xh6q.f[7]++;cov_2j0tp4xh6q.s[12]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Modal"],{show:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["GreyBox"],{outerMargin:'true',title:this.props.translate('exportjobmodal.title'),titleTheme:'light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["FlexColumn"],{col:'100*47'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Button"],{multiline:'true',type:'button',value:this.props.translate('exportjobmodal.print.label'),nomargin:'true',onClick:this.onPrint})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["FlexColumn"],{col:'100*47'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Button"],{multiline:'true',type:'button',value:this.props.translate('exportjobmodal.xlsx.label'),nomargin:'true',onClick:this.onExport.bind(this,'excel')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Button"],{href:'/jobs/'+this.props.state.job.details.Id,theme:'light',value:this.props.translate('exportjobmodal.secondary.label')})));}}]);return ExportJobModal;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_2j0tp4xh6q.s[13]++;var mapStateToProps=function mapStateToProps(state){cov_2j0tp4xh6q.f[8]++;cov_2j0tp4xh6q.s[14]++;return{defaults:state.defaults,state:state.calculatorJob,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale),currentLanguage:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["c" /* getActiveLanguage */])(state.locale).code,printing:state.printing};};cov_2j0tp4xh6q.s[15]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_2j0tp4xh6q.f[9]++;cov_2j0tp4xh6q.s[16]++;return{onCalculatorJobExportFetch:function onCalculatorJobExportFetch(id,type,lang){cov_2j0tp4xh6q.f[10]++;cov_2j0tp4xh6q.s[17]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["o" /* calculatorJobExportFetch */](id,type,lang));},onCalculatorJobExportFetchReset:function onCalculatorJobExportFetchReset(){cov_2j0tp4xh6q.f[11]++;cov_2j0tp4xh6q.s[18]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["p" /* calculatorJobExportFetchReset */]());},onPrintingStart:function onPrintingStart(){cov_2j0tp4xh6q.f[12]++;cov_2j0tp4xh6q.s[19]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["_0" /* printingStart */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(ExportJobModal,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */]))));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fileDownload;
var cov_2nh2yv5djd=function(){var path="D:\\a\\1\\s\\app\\browser\\src\\_helpers\\download.js",hash="345b31d55e1e2d2186fceabcd71388e02017b986",Function=function(){}.constructor,global=new Function('return this')(),gcv="__coverage__",coverageData={path:"D:\\a\\1\\s\\app\\browser\\src\\_helpers\\download.js",statementMap:{"0":{start:{line:3,column:12},end:{line:3,column:18}},"1":{start:{line:4,column:6},end:{line:4,column:32}},"2":{start:{line:5,column:6},end:{line:5,column:22}},"3":{start:{line:6,column:6},end:{line:6,column:10}},"4":{start:{line:7,column:6},end:{line:7,column:14}},"5":{start:{line:8,column:6},end:{line:8,column:26}},"6":{start:{line:9,column:6},end:{line:9,column:36}},"7":{start:{line:9,column:18},end:{line:9,column:35}},"8":{start:{line:12,column:6},end:{line:12,column:55}},"9":{start:{line:13,column:7},end:{line:13,column:71}},"10":{start:{line:14,column:7},end:{line:14,column:32}},"11":{start:{line:22,column:1},end:{line:26,column:2}},"12":{start:{line:23,column:2},end:{line:23,column:11}},"13":{start:{line:24,column:2},end:{line:24,column:9}},"14":{start:{line:25,column:2},end:{line:25,column:9}},"15":{start:{line:31,column:1},end:{line:35,column:2}},"16":{start:{line:32,column:2},end:{line:34,column:13}},"17":{start:{line:37,column:1},end:{line:49,column:2}},"18":{start:{line:39,column:2},end:{line:41,column:26}},"19":{start:{line:43,column:2},end:{line:47,column:3}},"20":{start:{line:44,column:3},end:{line:44,column:16}},"21":{start:{line:45,column:3},end:{line:45,column:17}},"22":{start:{line:46,column:3},end:{line:46,column:23}},"23":{start:{line:54,column:9},end:{line:54,column:25}},"24":{start:{line:55,column:5},end:{line:55,column:9}},"25":{start:{line:56,column:7},end:{line:56,column:51}},"26":{start:{line:57,column:7},end:{line:57,column:19}},"27":{start:{line:58,column:6},end:{line:58,column:16}},"28":{start:{line:59,column:5},end:{line:59,column:6}},"29":{start:{line:60,column:7},end:{line:60,column:25}},"30":{start:{line:62,column:2},end:{line:62,column:44}},"31":{start:{line:62,column:18},end:{line:62,column:44}},"32":{start:{line:64,column:2},end:{line:64,column:33}},"33":{start:{line:70,column:2},end:{line:81,column:3}},"34":{start:{line:71,column:3},end:{line:71,column:16}},"35":{start:{line:72,column:3},end:{line:72,column:34}},"36":{start:{line:73,column:3},end:{line:73,column:34}},"37":{start:{line:74,column:3},end:{line:74,column:25}},"38":{start:{line:75,column:3},end:{line:79,column:10}},"39":{start:{line:76,column:4},end:{line:76,column:14}},"40":{start:{line:77,column:4},end:{line:77,column:26}},"41":{start:{line:78,column:4},end:{line:78,column:89}},"42":{start:{line:78,column:23},end:{line:78,column:88}},"43":{start:{line:78,column:46},end:{line:78,column:79}},"44":{start:{line:80,column:3},end:{line:80,column:15}},"45":{start:{line:84,column:10},end:{line:84,column:35}},"46":{start:{line:85,column:2},end:{line:85,column:24}},"47":{start:{line:86,column:2},end:{line:88,column:3}},"48":{start:{line:87,column:3},end:{line:87,column:53}},"49":{start:{line:91,column:2},end:{line:91,column:14}},"50":{start:{line:92,column:2},end:{line:92,column:56}},"51":{start:{line:92,column:25},end:{line:92,column:47}},"52":{start:{line:97,column:1},end:{line:99,column:2}},"53":{start:{line:98,column:2},end:{line:98,column:40}},"54":{start:{line:101,column:1},end:{line:119,column:2}},"55":{start:{line:102,column:2},end:{line:102,column:46}},"56":{start:{line:105,column:2},end:{line:111,column:3}},"57":{start:{line:106,column:3},end:{line:110,column:4}},"58":{start:{line:107,column:4},end:{line:107,column:69}},"59":{start:{line:109,column:4},end:{line:109,column:69}},"60":{start:{line:114,column:2},end:{line:114,column:22}},"61":{start:{line:115,column:2},end:{line:117,column:4}},"62":{start:{line:116,column:3},end:{line:116,column:22}},"63":{start:{line:118,column:2},end:{line:118,column:25}},"64":{start:{line:120,column:1},end:{line:120,column:13}}},fnMap:{"0":{name:"fileDownload",decl:{start:{line:1,column:16},end:{line:1,column:28}},loc:{start:{line:1,column:61},end:{line:121,column:1}},line:1},"1":{name:"(anonymous_1)",decl:{start:{line:9,column:6},end:{line:9,column:7}},loc:{start:{line:9,column:17},end:{line:9,column:36}},line:9},"2":{name:"d2b",decl:{start:{line:53,column:10},end:{line:53,column:13}},loc:{start:{line:53,column:17},end:{line:65,column:3}},line:53},"3":{name:"saver",decl:{start:{line:67,column:10},end:{line:67,column:15}},loc:{start:{line:67,column:29},end:{line:94,column:2}},line:67},"4":{name:"(anonymous_4)",decl:{start:{line:75,column:14},end:{line:75,column:15}},loc:{start:{line:75,column:25},end:{line:79,column:4}},line:75},"5":{name:"(anonymous_5)",decl:{start:{line:78,column:34},end:{line:78,column:35}},loc:{start:{line:78,column:44},end:{line:78,column:80}},line:78},"6":{name:"(anonymous_6)",decl:{start:{line:92,column:13},end:{line:92,column:14}},loc:{start:{line:92,column:23},end:{line:92,column:49}},line:92},"7":{name:"(anonymous_7)",decl:{start:{line:115,column:12},end:{line:115,column:13}},loc:{start:{line:115,column:23},end:{line:117,column:3}},line:115}},branchMap:{"0":{loc:{start:{line:5,column:6},end:{line:5,column:22}},type:"binary-expr",locations:[{start:{line:5,column:6},end:{line:5,column:17}},{start:{line:5,column:21},end:{line:5,column:22}}],line:5},"1":{loc:{start:{line:12,column:6},end:{line:12,column:55}},type:"binary-expr",locations:[{start:{line:12,column:6},end:{line:12,column:15}},{start:{line:12,column:19},end:{line:12,column:31}},{start:{line:12,column:35},end:{line:12,column:50}},{start:{line:12,column:54},end:{line:12,column:55}}],line:12},"2":{loc:{start:{line:13,column:7},end:{line:13,column:71}},type:"binary-expr",locations:[{start:{line:13,column:7},end:{line:13,column:25}},{start:{line:13,column:29},end:{line:13,column:51}},{start:{line:13,column:55},end:{line:13,column:71}}],line:13},"3":{loc:{start:{line:14,column:7},end:{line:14,column:32}},type:"binary-expr",locations:[{start:{line:14,column:7},end:{line:14,column:18}},{start:{line:14,column:22},end:{line:14,column:32}}],line:14},"4":{loc:{start:{line:22,column:1},end:{line:26,column:2}},type:"if",locations:[{start:{line:22,column:1},end:{line:26,column:2}},{start:{line:22,column:1},end:{line:26,column:2}}],line:22},"5":{loc:{start:{line:31,column:1},end:{line:35,column:2}},type:"if",locations:[{start:{line:31,column:1},end:{line:35,column:2}},{start:{line:31,column:1},end:{line:35,column:2}}],line:31},"6":{loc:{start:{line:32,column:9},end:{line:34,column:11}},type:"cond-expr",locations:[{start:{line:33,column:3},end:{line:33,column:35}},{start:{line:34,column:3},end:{line:34,column:11}}],line:32},"7":{loc:{start:{line:39,column:9},end:{line:41,column:24}},type:"cond-expr",locations:[{start:{line:40,column:3},end:{line:40,column:4}},{start:{line:41,column:3},end:{line:41,column:24}}],line:39},"8":{loc:{start:{line:43,column:2},end:{line:47,column:3}},type:"if",locations:[{start:{line:43,column:2},end:{line:47,column:3}},{start:{line:43,column:2},end:{line:47,column:3}}],line:43},"9":{loc:{start:{line:56,column:7},end:{line:56,column:51}},type:"cond-expr",locations:[{start:{line:56,column:26},end:{line:56,column:30}},{start:{line:56,column:33},end:{line:56,column:51}}],line:56},"10":{loc:{start:{line:70,column:2},end:{line:81,column:3}},type:"if",locations:[{start:{line:70,column:2},end:{line:81,column:3}},{start:{line:70,column:2},end:{line:81,column:3}}],line:70},"11":{loc:{start:{line:78,column:4},end:{line:78,column:89}},type:"if",locations:[{start:{line:78,column:4},end:{line:78,column:89}},{start:{line:78,column:4},end:{line:78,column:89}}],line:78},"12":{loc:{start:{line:86,column:2},end:{line:88,column:3}},type:"if",locations:[{start:{line:86,column:2},end:{line:88,column:3}},{start:{line:86,column:2},end:{line:88,column:3}}],line:86},"13":{loc:{start:{line:97,column:1},end:{line:99,column:2}},type:"if",locations:[{start:{line:97,column:1},end:{line:99,column:2}},{start:{line:97,column:1},end:{line:99,column:2}}],line:97},"14":{loc:{start:{line:101,column:1},end:{line:119,column:2}},type:"if",locations:[{start:{line:101,column:1},end:{line:119,column:2}},{start:{line:101,column:1},end:{line:119,column:2}}],line:101},"15":{loc:{start:{line:105,column:2},end:{line:111,column:3}},type:"if",locations:[{start:{line:105,column:2},end:{line:111,column:3}},{start:{line:105,column:2},end:{line:111,column:3}}],line:105},"16":{loc:{start:{line:105,column:5},end:{line:105,column:53}},type:"binary-expr",locations:[{start:{line:105,column:5},end:{line:105,column:29}},{start:{line:105,column:33},end:{line:105,column:53}}],line:105}},s:{"0":0,"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0,"44":0,"45":0,"46":0,"47":0,"48":0,"49":0,"50":0,"51":0,"52":0,"53":0,"54":0,"55":0,"56":0,"57":0,"58":0,"59":0,"60":0,"61":0,"62":0,"63":0,"64":0},f:{"0":0,"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0},b:{"0":[0,0],"1":[0,0,0,0],"2":[0,0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0],"15":[0,0],"16":[0,0]},_coverageSchema:"332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();function fileDownload(data,strFileName,strMimeType){cov_2nh2yv5djd.f[0]++;cov_2nh2yv5djd.s[6]++;var self=(cov_2nh2yv5djd.s[0]++,window),// this script is only for browsers anyway...
u=(cov_2nh2yv5djd.s[1]++,"application/octet-stream"),// this default mime also triggers iframe downloads
m=(cov_2nh2yv5djd.s[2]++,(cov_2nh2yv5djd.b[0][0]++,strMimeType)||(cov_2nh2yv5djd.b[0][1]++,u)),x=(cov_2nh2yv5djd.s[3]++,data),D=(cov_2nh2yv5djd.s[4]++,document),a=(cov_2nh2yv5djd.s[5]++,D.createElement("a")),z=function z(a){cov_2nh2yv5djd.f[1]++;cov_2nh2yv5djd.s[7]++;return String(a);},B=(cov_2nh2yv5djd.s[8]++,(cov_2nh2yv5djd.b[1][0]++,self.Blob)||(cov_2nh2yv5djd.b[1][1]++,self.MozBlob)||(cov_2nh2yv5djd.b[1][2]++,self.WebKitBlob)||(cov_2nh2yv5djd.b[1][3]++,z)),BB=(cov_2nh2yv5djd.s[9]++,(cov_2nh2yv5djd.b[2][0]++,self.MSBlobBuilder)||(cov_2nh2yv5djd.b[2][1]++,self.WebKitBlobBuilder)||(cov_2nh2yv5djd.b[2][2]++,self.BlobBuilder)),fn=(cov_2nh2yv5djd.s[10]++,(cov_2nh2yv5djd.b[3][0]++,strFileName)||(cov_2nh2yv5djd.b[3][1]++,"download")),blob,b,ua,fr;//if(typeof B.bind === 'function' ){ B=B.bind(self); }
cov_2nh2yv5djd.s[11]++;if(String(this)==="true"){cov_2nh2yv5djd.b[4][0]++;cov_2nh2yv5djd.s[12]++;//reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
x=[x,m];cov_2nh2yv5djd.s[13]++;m=x[0];cov_2nh2yv5djd.s[14]++;x=x[1];}else{cov_2nh2yv5djd.b[4][1]++;}//go ahead and download dataURLs right away
cov_2nh2yv5djd.s[15]++;if(String(x).match(/^data\:[\w+\-]+\/[\w+\-]+[,;]/)){cov_2nh2yv5djd.b[5][0]++;cov_2nh2yv5djd.s[16]++;return navigator.msSaveBlob?(// IE10 can't do a[download], only Blobs:
cov_2nh2yv5djd.b[6][0]++,navigator.msSaveBlob(d2b(x),fn)):(cov_2nh2yv5djd.b[6][1]++,saver(x));// everyone else can save dataURLs un-processed
}else{cov_2nh2yv5djd.b[5][1]++;}//end if dataURL passed?
cov_2nh2yv5djd.s[17]++;try{cov_2nh2yv5djd.s[18]++;blob=x instanceof B?(cov_2nh2yv5djd.b[7][0]++,x):(cov_2nh2yv5djd.b[7][1]++,new B([x],{type:m}));}catch(y){cov_2nh2yv5djd.s[19]++;if(BB){cov_2nh2yv5djd.b[8][0]++;cov_2nh2yv5djd.s[20]++;b=new BB();cov_2nh2yv5djd.s[21]++;b.append([x]);cov_2nh2yv5djd.s[22]++;blob=b.getBlob(m);// the blob
}else{cov_2nh2yv5djd.b[8][1]++;}}function d2b(u){cov_2nh2yv5djd.f[2]++;var p=(cov_2nh2yv5djd.s[23]++,u.split(/[:;,]/)),t=(cov_2nh2yv5djd.s[24]++,p[1]),dec=(cov_2nh2yv5djd.s[25]++,p[2]=="base64"?(cov_2nh2yv5djd.b[9][0]++,atob):(cov_2nh2yv5djd.b[9][1]++,decodeURIComponent)),bin=(cov_2nh2yv5djd.s[26]++,dec(p.pop())),mx=(cov_2nh2yv5djd.s[27]++,bin.length),i=(cov_2nh2yv5djd.s[28]++,0),uia=(cov_2nh2yv5djd.s[29]++,new Uint8Array(mx));cov_2nh2yv5djd.s[30]++;for(i;i<mx;++i){cov_2nh2yv5djd.s[31]++;uia[i]=bin.charCodeAt(i);}cov_2nh2yv5djd.s[32]++;return new B([uia],{type:t});}function saver(url,winMode){cov_2nh2yv5djd.f[3]++;cov_2nh2yv5djd.s[33]++;if('download'in a){cov_2nh2yv5djd.b[10][0]++;cov_2nh2yv5djd.s[34]++;//html5 A[download] 			
a.href=url;cov_2nh2yv5djd.s[35]++;a.setAttribute("download",fn);cov_2nh2yv5djd.s[36]++;a.innerHTML="downloading...";cov_2nh2yv5djd.s[37]++;D.body.appendChild(a);cov_2nh2yv5djd.s[38]++;setTimeout(function(){cov_2nh2yv5djd.f[4]++;cov_2nh2yv5djd.s[39]++;a.click();cov_2nh2yv5djd.s[40]++;D.body.removeChild(a);cov_2nh2yv5djd.s[41]++;if(winMode===true){cov_2nh2yv5djd.b[11][0]++;cov_2nh2yv5djd.s[42]++;setTimeout(function(){cov_2nh2yv5djd.f[5]++;cov_2nh2yv5djd.s[43]++;self.URL.revokeObjectURL(a.href);},250);}else{cov_2nh2yv5djd.b[11][1]++;}},66);cov_2nh2yv5djd.s[44]++;return true;}else{cov_2nh2yv5djd.b[10][1]++;}//do iframe dataURL download (old ch+FF):
var f=(cov_2nh2yv5djd.s[45]++,D.createElement("iframe"));cov_2nh2yv5djd.s[46]++;D.body.appendChild(f);cov_2nh2yv5djd.s[47]++;if(!winMode){cov_2nh2yv5djd.b[12][0]++;cov_2nh2yv5djd.s[48]++;// force a mime that will download:
url="data:"+url.replace(/^data:([\w\/\-\+]+)/,u);}else{cov_2nh2yv5djd.b[12][1]++;}cov_2nh2yv5djd.s[49]++;f.src=url;cov_2nh2yv5djd.s[50]++;setTimeout(function(){cov_2nh2yv5djd.f[6]++;cov_2nh2yv5djd.s[51]++;D.body.removeChild(f);},333);}//end saver 
cov_2nh2yv5djd.s[52]++;if(navigator.msSaveBlob){cov_2nh2yv5djd.b[13][0]++;cov_2nh2yv5djd.s[53]++;// IE10+ : (has Blob, but not a[download] or URL)
return navigator.msSaveBlob(blob,fn);}else{cov_2nh2yv5djd.b[13][1]++;}cov_2nh2yv5djd.s[54]++;if(self.URL){cov_2nh2yv5djd.b[14][0]++;cov_2nh2yv5djd.s[55]++;// simple fast and modern way using Blob and URL:
saver(self.URL.createObjectURL(blob),true);}else{cov_2nh2yv5djd.b[14][1]++;cov_2nh2yv5djd.s[56]++;// handle non-Blob()+non-URL browsers:
if((cov_2nh2yv5djd.b[16][0]++,typeof blob==="string")||(cov_2nh2yv5djd.b[16][1]++,blob.constructor===z)){cov_2nh2yv5djd.b[15][0]++;cov_2nh2yv5djd.s[57]++;try{cov_2nh2yv5djd.s[58]++;return saver("data:"+m+";base64,"+self.btoa(blob));}catch(y){cov_2nh2yv5djd.s[59]++;return saver("data:"+m+","+encodeURIComponent(blob));}}else{cov_2nh2yv5djd.b[15][1]++;}// Blob but not URL:
cov_2nh2yv5djd.s[60]++;fr=new FileReader();cov_2nh2yv5djd.s[61]++;fr.onload=function(e){cov_2nh2yv5djd.f[7]++;cov_2nh2yv5djd.s[62]++;saver(this.result);};cov_2nh2yv5djd.s[63]++;fr.readAsDataURL(blob);}cov_2nh2yv5djd.s[64]++;return true;}

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__ = __webpack_require__(112);
var cov_c6jiygtwq=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\DetailedCalculationModal\\index.js',hash='9eacd353ea873ad5006d3655fd1ef9b873ed2b2b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobPage\\DetailedCalculationModal\\index.js',statementMap:{'0':{start:{line:21,column:8},end:{line:21,column:21}},'1':{start:{line:24,column:8},end:{line:24,column:98}},'2':{start:{line:27,column:5},end:{line:32,column:6}},'3':{start:{line:28,column:6},end:{line:28,column:32}},'4':{start:{line:30,column:10},end:{line:32,column:6}},'5':{start:{line:31,column:6},end:{line:31,column:26}},'6':{start:{line:35,column:2},end:{line:35,column:55}},'7':{start:{line:39,column:8},end:{line:39,column:34}},'8':{start:{line:45,column:5},end:{line:53,column:6}},'9':{start:{line:46,column:6},end:{line:48,column:8}},'10':{start:{line:47,column:7},end:{line:47,column:33}},'11':{start:{line:49,column:11},end:{line:53,column:6}},'12':{start:{line:50,column:6},end:{line:52,column:8}},'13':{start:{line:51,column:7},end:{line:51,column:33}},'14':{start:{line:60,column:16},end:{line:60,column:36}},'15':{start:{line:61,column:17},end:{line:61,column:53}},'16':{start:{line:62,column:3},end:{line:62,column:17}},'17':{start:{line:66,column:5},end:{line:233,column:6}},'18':{start:{line:67,column:6},end:{line:67,column:64}},'19':{start:{line:68,column:6},end:{line:232,column:10}},'20':{start:{line:68,column:34},end:{line:232,column:7}},'21':{start:{line:237,column:6},end:{line:237,column:36}},'22':{start:{line:241,column:24},end:{line:248,column:1}},'23':{start:{line:242,column:4},end:{line:247,column:6}},'24':{start:{line:250,column:27},end:{line:255,column:1}},'25':{start:{line:251,column:4},end:{line:254,column:5}},'26':{start:{line:252,column:70},end:{line:252,column:149}},'27':{start:{line:253,column:55},end:{line:253,column:119}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:20,column:1},end:{line:20,column:2}},loc:{start:{line:20,column:20},end:{line:22,column:5}},line:20},'1':{name:'(anonymous_1)',decl:{start:{line:23,column:24},end:{line:23,column:25}},loc:{start:{line:23,column:30},end:{line:25,column:5}},line:23},'2':{name:'(anonymous_2)',decl:{start:{line:26,column:25},end:{line:26,column:26}},loc:{start:{line:26,column:61},end:{line:33,column:5}},line:26},'3':{name:'(anonymous_3)',decl:{start:{line:34,column:24},end:{line:34,column:25}},loc:{start:{line:34,column:30},end:{line:36,column:2}},line:34},'4':{name:'(anonymous_4)',decl:{start:{line:38,column:19},end:{line:38,column:20}},loc:{start:{line:38,column:25},end:{line:40,column:5}},line:38},'5':{name:'(anonymous_5)',decl:{start:{line:44,column:27},end:{line:44,column:28}},loc:{start:{line:44,column:33},end:{line:56,column:5}},line:44},'6':{name:'(anonymous_6)',decl:{start:{line:46,column:48},end:{line:46,column:49}},loc:{start:{line:46,column:54},end:{line:48,column:7}},line:46},'7':{name:'(anonymous_7)',decl:{start:{line:50,column:46},end:{line:50,column:47}},loc:{start:{line:50,column:52},end:{line:52,column:7}},line:50},'8':{name:'(anonymous_8)',decl:{start:{line:58,column:1},end:{line:58,column:2}},loc:{start:{line:58,column:23},end:{line:63,column:2}},line:58},'9':{name:'(anonymous_9)',decl:{start:{line:65,column:25},end:{line:65,column:26}},loc:{start:{line:65,column:31},end:{line:234,column:5}},line:65},'10':{name:'(anonymous_10)',decl:{start:{line:68,column:20},end:{line:68,column:21}},loc:{start:{line:68,column:34},end:{line:232,column:7}},line:68},'11':{name:'(anonymous_11)',decl:{start:{line:236,column:4},end:{line:236,column:5}},loc:{start:{line:236,column:14},end:{line:238,column:5}},line:236},'12':{name:'(anonymous_12)',decl:{start:{line:241,column:24},end:{line:241,column:25}},loc:{start:{line:241,column:33},end:{line:248,column:1}},line:241},'13':{name:'(anonymous_13)',decl:{start:{line:250,column:27},end:{line:250,column:28}},loc:{start:{line:250,column:39},end:{line:255,column:1}},line:250},'14':{name:'(anonymous_14)',decl:{start:{line:252,column:44},end:{line:252,column:45}},loc:{start:{line:252,column:70},end:{line:252,column:149}},line:252},'15':{name:'(anonymous_15)',decl:{start:{line:253,column:49},end:{line:253,column:50}},loc:{start:{line:253,column:55},end:{line:253,column:119}},line:253}},branchMap:{'0':{loc:{start:{line:27,column:5},end:{line:32,column:6}},type:'if',locations:[{start:{line:27,column:5},end:{line:32,column:6}},{start:{line:27,column:5},end:{line:32,column:6}}],line:27},'1':{loc:{start:{line:27,column:8},end:{line:27,column:151}},type:'binary-expr',locations:[{start:{line:27,column:8},end:{line:27,column:102}},{start:{line:27,column:106},end:{line:27,column:151}}],line:27},'2':{loc:{start:{line:30,column:10},end:{line:32,column:6}},type:'if',locations:[{start:{line:30,column:10},end:{line:32,column:6}},{start:{line:30,column:10},end:{line:32,column:6}}],line:30},'3':{loc:{start:{line:45,column:5},end:{line:53,column:6}},type:'if',locations:[{start:{line:45,column:5},end:{line:53,column:6}},{start:{line:45,column:5},end:{line:53,column:6}}],line:45},'4':{loc:{start:{line:49,column:11},end:{line:53,column:6}},type:'if',locations:[{start:{line:49,column:11},end:{line:53,column:6}},{start:{line:49,column:11},end:{line:53,column:6}}],line:49},'5':{loc:{start:{line:66,column:5},end:{line:233,column:6}},type:'if',locations:[{start:{line:66,column:5},end:{line:233,column:6}},{start:{line:66,column:5},end:{line:233,column:6}}],line:66},'6':{loc:{start:{line:78,column:102},end:{line:78,column:296}},type:'cond-expr',locations:[{start:{line:78,column:140},end:{line:78,column:216}},{start:{line:78,column:219},end:{line:78,column:296}}],line:78},'7':{loc:{start:{line:126,column:15},end:{line:126,column:118}},type:'cond-expr',locations:[{start:{line:126,column:62},end:{line:126,column:113}},{start:{line:126,column:116},end:{line:126,column:118}}],line:126},'8':{loc:{start:{line:130,column:15},end:{line:130,column:118}},type:'cond-expr',locations:[{start:{line:130,column:62},end:{line:130,column:113}},{start:{line:130,column:116},end:{line:130,column:118}}],line:130},'9':{loc:{start:{line:138,column:15},end:{line:138,column:238}},type:'cond-expr',locations:[{start:{line:138,column:82},end:{line:138,column:157}},{start:{line:138,column:162},end:{line:138,column:237}}],line:138},'10':{loc:{start:{line:151,column:107},end:{line:151,column:210}},type:'cond-expr',locations:[{start:{line:151,column:154},end:{line:151,column:205}},{start:{line:151,column:208},end:{line:151,column:210}}],line:151},'11':{loc:{start:{line:154,column:107},end:{line:154,column:210}},type:'cond-expr',locations:[{start:{line:154,column:154},end:{line:154,column:205}},{start:{line:154,column:208},end:{line:154,column:210}}],line:154},'12':{loc:{start:{line:157,column:110},end:{line:157,column:213}},type:'cond-expr',locations:[{start:{line:157,column:157},end:{line:157,column:208}},{start:{line:157,column:211},end:{line:157,column:213}}],line:157},'13':{loc:{start:{line:225,column:183},end:{line:225,column:286}},type:'cond-expr',locations:[{start:{line:225,column:230},end:{line:225,column:281}},{start:{line:225,column:284},end:{line:225,column:286}}],line:225},'14':{loc:{start:{line:227,column:193},end:{line:227,column:296}},type:'cond-expr',locations:[{start:{line:227,column:240},end:{line:227,column:291}},{start:{line:227,column:294},end:{line:227,column:296}}],line:227}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailedCalculationModal=function(_ref){_inherits(DetailedCalculationModal,_ref);function DetailedCalculationModal(props){_classCallCheck(this,DetailedCalculationModal);cov_c6jiygtwq.f[0]++;cov_c6jiygtwq.s[0]++;var _this=_possibleConstructorReturn(this,(DetailedCalculationModal.__proto__||Object.getPrototypeOf(DetailedCalculationModal)).call(this,props));_this.state={modalContent:"",accordionState:"closed",accordionSettingsState:"closed"};_this.componentDidMount=function(){cov_c6jiygtwq.f[1]++;cov_c6jiygtwq.s[1]++;_this.props.onCalculatorJobDetailedCalculation(_this.props.jobId,_this.props.calculationId);};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_c6jiygtwq.f[2]++;cov_c6jiygtwq.s[2]++;if((cov_c6jiygtwq.b[1][0]++,prevProps.state.detailed_calculation.fetched!==_this.props.state.detailed_calculation.fetched)&&(cov_c6jiygtwq.b[1][1]++,_this.props.state.detailed_calculation.fetched)){cov_c6jiygtwq.b[0][0]++;cov_c6jiygtwq.s[3]++;_this.handleModalContent();}else{cov_c6jiygtwq.b[0][1]++;cov_c6jiygtwq.s[4]++;if(prevProps.state.detailed_calculation.error!==_this.props.state.detailed_calculation.error){cov_c6jiygtwq.b[2][0]++;cov_c6jiygtwq.s[5]++;_this.onCloseModal();}else{cov_c6jiygtwq.b[2][1]++;}}};_this.componentWillUnmount=function(){cov_c6jiygtwq.f[3]++;cov_c6jiygtwq.s[6]++;_this.props.onCalculatorJobDetailedCalculationReset();};_this.onCloseModal=function(){cov_c6jiygtwq.f[4]++;cov_c6jiygtwq.s[7]++;_this.props.onCloseModal();};_this.onToggleAllAccorions=function(){cov_c6jiygtwq.f[5]++;cov_c6jiygtwq.s[8]++;if(_this.state.accordionState=="open"){cov_c6jiygtwq.b[3][0]++;cov_c6jiygtwq.s[9]++;_this.setState({accordionState:"closed"},function(){cov_c6jiygtwq.f[6]++;cov_c6jiygtwq.s[10]++;_this.handleModalContent();});}else{cov_c6jiygtwq.b[3][1]++;cov_c6jiygtwq.s[11]++;if(_this.state.accordionState=="closed"){cov_c6jiygtwq.b[4][0]++;cov_c6jiygtwq.s[12]++;_this.setState({accordionState:"open"},function(){cov_c6jiygtwq.f[7]++;cov_c6jiygtwq.s[13]++;_this.handleModalContent();});}else{cov_c6jiygtwq.b[4][1]++;}}};_this.handleModalContent=function(){cov_c6jiygtwq.f[9]++;cov_c6jiygtwq.s[17]++;if(_this.props.state.detailed_calculation.fetched){cov_c6jiygtwq.b[5][0]++;cov_c6jiygtwq.s[18]++;console.log(_this.props.state.detailed_calculation.details);cov_c6jiygtwq.s[19]++;_this.setState(function(prevState){cov_c6jiygtwq.f[10]++;cov_c6jiygtwq.s[20]++;return{modalContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Modal"],{show:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["GreyBox"],{outerMargin:'true',closeIcon:_this.onCloseModal,cols:'2',title:_this.props.translate('detailedcalculationmodal.title'),titleTheme:'light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["FlexColumn"],{col:'5*3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["BoxTitle"],null,_this.props.state.detailed_calculation.details.calculation.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Text"],null,_this.props.translate('detailedcalculationmodal.box_text'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["FlexColumn"],{col:'5*2',align:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Button"],{width:'auto',nomargin:'true',onClick:_this.onToggleAllAccorions,theme:'dark',value:_this.state.accordionState=="open"?(cov_c6jiygtwq.b[6][0]++,_this.props.translate('detailedcalculationmodal.details.accordion_all_close')):(cov_c6jiygtwq.b[6][1]++,_this.props.translate('detailedcalculationmodal.details.accordion_all_expand'))}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Spacer"],{height:'24px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Accordion"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.settings.title')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.heads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.heads,' ',_this.props.translate('global.units.heads'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.speed,' ',_this.props.translate('global.units.spm'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.hoop_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.hoop_change_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.cone_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.cone_change_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.bobbin_stitch_count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.bobbin_stitch_count,' ',_this.props.translate('global.units.stitches'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.color_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.color_change_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.trimming_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.trimming_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.bobbin_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.bobbin_change_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.stitches_next_thread_break'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.stitches_next_thread_break,' ',_this.props.translate('global.units.stitches'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.thread_break_fixing_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.settings.thread_break_fixing_time,' ',_this.props.translate('global.units.seconds'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.maintenance_cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[7][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[7][1]++,""),' ',_this.round(_this.props.state.detailed_calculation.details.machine.settings.maintenance_cost,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.investment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[8][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[8][1]++,""),' ',_this.round(_this.props.state.detailed_calculation.details.machine.investment,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.amortization_months'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.amortization_months,' ',_this.props.translate('global.units.months'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('global.form.label.machine.multihead'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.machine.multihead?(cov_c6jiygtwq.b[9][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Icon"],{type:'image',content:'yes',size:'10px',display:'inline'}))):(cov_c6jiygtwq.b[9][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Icon"],{type:'image',content:'no',size:'10px',display:'inline'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Spacer"],{height:'24px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["BoxTitle"],{small:true},'Calculations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Accordion"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.base_calculations')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.working_hours_per_year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.calculation.working_hours,' ',_this.props.translate('global.units.hours'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.machine_cost_per_hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[10][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[10][1]++,""),' ',_this.round(_this.props.state.detailed_calculation.details.calculation.machine_hourly_cost,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.general_cost_per_hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[11][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[11][1]++,""),' ',_this.round(_this.props.state.detailed_calculation.details.calculation.fixed_hourly_cost,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.production_cost_per_hour'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[12][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[12][1]++,""),' ',_this.round(_this.props.state.detailed_calculation.details.calculation.production_hourly_cost,2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.total_amount_of_pieces'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.calculation.total_pieces,' ',_this.props.translate('global.units.pieces'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.total_amount_of_stitches'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.calculation.total_stitches,' ',_this.props.translate('global.units.stitches'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.total_amount_of_heads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.props.state.detailed_calculation.details.calculation.heads,' ',_this.props.translate('global.units.heads')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.machine_setup'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_setup_time,false,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.setup_time_per_head'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.head_setup_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.amount_of_heads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'x '),_this.props.state.detailed_calculation.details.calculation.heads,' ',_this.props.translate('global.units.heads'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{'class':'total'},_this.props.translate('detailedcalculationmodal.details.needed_time_for_machine_setup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_setup_time,false,true)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.stitches_during_setup'),titleValue:_this.props.state.detailed_calculation.details.calculation.stitches_during_setup+' '+_this.props.translate('global.units.stitches')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.machine_time_after_setup'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_machine_time,false,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.stitching_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_stitch_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.trimming_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+ '),Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_trim_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.color_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+ '),Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_colorchange_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{'class':'total'},_this.props.translate('detailedcalculationmodal.details.needed_time_after_setup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_machine_time,false,true)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.machine_down_time_during_production'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_down_time,false,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.bobbin_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_bobbinchange_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.time_to_fix_thread_breaks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+ '),Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_threadbreak_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.total_hoop_change_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+ '),Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_hoopchange_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.total_idle_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'+ '),Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_idle_time,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{'class':'total'},_this.props.translate('detailedcalculationmodal.details.total_down_time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_down_time,false,true)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.hooping_and_garment_handling'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_working_time,false,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.working_time_per_piece'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.working_time_per_piece,false,true))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,_this.props.translate('detailedcalculationmodal.details.amount_of_pieces'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'x '),_this.props.state.detailed_calculation.details.calculation.total_pieces,' ',_this.props.translate('global.units.pieces'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{'class':'total'},_this.props.translate('detailedcalculationmodal.details.needed_time_for_hooping_and_garment_handling'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_working_time,false,true)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{theme:'totalDouble',globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.total_production_time'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.total_production_time,false,true)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{theme:'total',globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.total_production_cost'),titleValue:(_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[13][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[13][1]++,""))+' '+_this.round(_this.props.state.detailed_calculation.details.calculation.total_production_cost,2)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{theme:'total',globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.total_production_time_per_piece'),titleValue:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_DateTime_js__["b" /* secondsFormatter */])(_this.props.state.detailed_calculation.details.calculation.production_time_per_piece,false,true)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["AccordionSection"],{theme:'total',globalState:_this.state.accordionState,title:_this.props.translate('detailedcalculationmodal.details.total_production_cost_per_piece'),titleValue:(_this.props.settingsCompany.settings.currency?(cov_c6jiygtwq.b[14][0]++,_this.props.settingsCompany.settings.currency.symbol):(cov_c6jiygtwq.b[14][1]++,""))+' '+_this.round(_this.props.state.detailed_calculation.details.calculation.production_cost_per_piece,2)}))))};});}else{cov_c6jiygtwq.b[5][1]++;}};return _this;}_createClass(DetailedCalculationModal,[{key:'round',value:function round(number,length){cov_c6jiygtwq.f[8]++;var factor=(cov_c6jiygtwq.s[14]++,Math.pow(10,length));var rounded=(cov_c6jiygtwq.s[15]++,Math.round(number*factor)/factor);cov_c6jiygtwq.s[16]++;return rounded;}},{key:'render',value:function render(){cov_c6jiygtwq.f[11]++;cov_c6jiygtwq.s[21]++;return this.state.modalContent;}}]);return DetailedCalculationModal;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_c6jiygtwq.s[22]++;var mapStateToProps=function mapStateToProps(state){cov_c6jiygtwq.f[12]++;cov_c6jiygtwq.s[23]++;return{defaults:state.defaults,state:state.calculatorJob,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_c6jiygtwq.s[24]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_c6jiygtwq.f[13]++;cov_c6jiygtwq.s[25]++;return{onCalculatorJobDetailedCalculation:function onCalculatorJobDetailedCalculation(jobId,calculationId){cov_c6jiygtwq.f[14]++;cov_c6jiygtwq.s[26]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["k" /* calculatorJobDetailedCalculation */](jobId,calculationId));},onCalculatorJobDetailedCalculationReset:function onCalculatorJobDetailedCalculationReset(){cov_c6jiygtwq.f[15]++;cov_c6jiygtwq.s[27]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["l" /* calculatorJobDetailedCalculationReset */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(DetailedCalculationModal,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but only CommonJS-like
        // enviroments that support module.exports, like Node.
        try {
            module.exports = factory(require('moment'));
        } catch (e) {
            // If moment is not available, leave the setup up to the user.
            // Like when using moment-timezone or similar moment-based package.
            module.exports = factory;
        }
    }

    if (root) {
        // Globals.
        root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
    }
})(this, function (moment) {
    // `Number#tolocaleString` is tested on plugin initialization.
    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
    // native function will be used to generate formatted output. If the feature
    // test fails, the fallback format function internal to this plugin will be
    // used.
    var toLocaleStringWorks = false;

    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `toLocaleString` will be used for formatting,
    // the plugin will "pre-round" number values using the fallback number format
    // function before passing them to `toLocaleString` for final formatting.
    var toLocaleStringRoundingWorks = false;

    // Token type names in order of descending magnitude.
    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");

    var bubbles = [
        {
            type: "seconds",
            targets: [
                { type: "minutes", value: 60 },
                { type: "hours", value: 3600 },
                { type: "days", value: 86400 },
                { type: "weeks", value: 604800 },
                { type: "months", value: 2678400 },
                { type: "years", value: 31536000 }
            ]
        },
        {
            type: "minutes",
            targets: [
                { type: "hours", value: 60 },
                { type: "days", value: 1440 },
                { type: "weeks", value: 10080 },
                { type: "months", value: 44640 },
                { type: "years", value: 525600 }
            ]
        },
        {
            type: "hours",
            targets: [
                { type: "days", value: 24 },
                { type: "weeks", value: 168 },
                { type: "months", value: 744 },
                { type: "years", value: 8760 }
            ]
        },
        {
            type: "days",
            targets: [
                { type: "weeks", value: 7 },
                { type: "months", value: 31 },
                { type: "years", value: 365 }
            ]
        },
        {
            type: "months",
            targets: [
                { type: "years", value: 12 }
            ]
        }
    ];

    // stringIncludes
    function stringIncludes(str, search) {
        if (search.length > str.length) {
          return false;
        }

        return str.indexOf(search) !== -1;
    }

    // repeatZero(qty)
    // Returns "0" repeated `qty` times.
    // `qty` must be a integer >= 0.
    function repeatZero(qty) {
        var result = "";

        while (qty) {
            result += "0";
            qty -= 1;
        }

        return result;
    }

    function stringRound(digits) {
        var digitsArray = digits.split("").reverse();
        var i = 0;
        var carry = true;

        while (carry && i < digitsArray.length) {
            if (i) {
                if (digitsArray[i] === "9") {
                    digitsArray[i] = "0";
                } else {
                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
                    carry = false;
                }
            } else {
                if (parseInt(digitsArray[i], 10) < 5) {
                    carry = false;
                }

                digitsArray[i] = "0";
            }

            i += 1;
        }

        if (carry) {
            digitsArray.push("1");
        }

        return digitsArray.reverse().join("");
    }

    // formatNumber
    // Formats any number greater than or equal to zero using these options:
    // - userLocale
    // - useToLocaleString
    // - useGrouping
    // - grouping
    // - maximumSignificantDigits
    // - minimumIntegerDigits
    // - fractionDigits
    // - groupingSeparator
    // - decimalSeparator
    //
    // `useToLocaleString` will use `toLocaleString` for formatting.
    // `userLocale` option is passed through to `toLocaleString`.
    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
    function formatNumber(number, options, userLocale) {
        var useToLocaleString = options.useToLocaleString;
        var useGrouping = options.useGrouping;
        var grouping = useGrouping && options.grouping.slice();
        var maximumSignificantDigits = options.maximumSignificantDigits;
        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
        var fractionDigits = options.fractionDigits || 0;
        var groupingSeparator = options.groupingSeparator;
        var decimalSeparator = options.decimalSeparator;

        if (useToLocaleString && userLocale) {
            var localeStringOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                useGrouping: useGrouping
            };

            if (fractionDigits) {
                localeStringOptions.maximumFractionDigits = fractionDigits;
                localeStringOptions.minimumFractionDigits = fractionDigits;
            }

            // toLocaleString output is "0.0" instead of "0" for HTC browsers
            // when maximumSignificantDigits is set. See #96.
            if (maximumSignificantDigits && number > 0) {
                localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
            }

            if (!toLocaleStringRoundingWorks) {
                var roundingOptions = extend({}, options);
                roundingOptions.useGrouping = false;
                roundingOptions.decimalSeparator = ".";
                number = parseFloat(formatNumber(number, roundingOptions), 10);
            }

            return number.toLocaleString(userLocale, localeStringOptions);
        }

        var numberString;

        // Add 1 to digit output length for floating point errors workaround. See below.
        if (maximumSignificantDigits) {
            numberString = number.toPrecision(maximumSignificantDigits + 1);
        } else {
            numberString = number.toFixed(fractionDigits + 1);
        }

        var integerString;
        var fractionString;
        var exponentString;

        var temp = numberString.split("e");

        exponentString = temp[1] || "";

        temp = temp[0].split(".");

        fractionString = temp[1] || "";
        integerString = temp[0] || "";

        // Workaround for floating point errors in `toFixed` and `toPrecision`.
        // (3.55).toFixed(1); --> "3.5"
        // (123.55 - 120).toPrecision(2); --> "3.5"
        // (123.55 - 120); --> 3.549999999999997
        // (123.55 - 120).toFixed(2); --> "3.55"
        // Round by examing the string output of the next digit.

        // *************** Implement String Rounding here ***********************
        // Check integerString + fractionString length of toPrecision before rounding.
        // Check length of fractionString from toFixed output before rounding.
        var integerLength = integerString.length;
        var fractionLength = fractionString.length;
        var digitCount = integerLength + fractionLength;
        var digits = integerString + fractionString;

        if (maximumSignificantDigits && digitCount === (maximumSignificantDigits + 1) || !maximumSignificantDigits && fractionLength === (fractionDigits + 1)) {
            // Round digits.
            digits = stringRound(digits);

            if (digits.length === digitCount + 1) {
                integerLength = integerLength + 1;
            }

            // Discard final fractionDigit.
            if (fractionLength) {
                digits = digits.slice(0, -1);
            }

            // Separate integer and fraction.
            integerString = digits.slice(0, integerLength);
            fractionString = digits.slice(integerLength);
        }

        // Trim trailing zeroes from fractionString because toPrecision outputs
        // precision, not significant digits.
        if (maximumSignificantDigits) {
            fractionString = fractionString.replace(/0*$/, "");
        }

        // Handle exponent.
        var exponent = parseInt(exponentString, 10);

        if (exponent > 0) {
            if (fractionString.length <= exponent) {
                fractionString = fractionString + repeatZero(exponent - fractionString.length);

                integerString = integerString + fractionString;
                fractionString = "";
            } else {
                integerString = integerString + fractionString.slice(0, exponent);
                fractionString = fractionString.slice(exponent);
            }
        } else if (exponent < 0) {
            fractionString = (repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString);

            integerString = "0";
        }

        if (!maximumSignificantDigits) {
            // Trim or pad fraction when not using maximumSignificantDigits.
            fractionString = fractionString.slice(0, fractionDigits);

            if (fractionString.length < fractionDigits) {
                fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
            }

            // Pad integer when using minimumIntegerDigits
            // and not using maximumSignificantDigits.
            if (integerString.length < minimumIntegerDigits) {
                integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
            }
        }

        var formattedString = "";

        // Handle grouping.
        if (useGrouping) {
            temp = integerString;
            var group;

            while (temp.length) {
                if (grouping.length) {
                    group = grouping.shift();
                }

                if (formattedString) {
                    formattedString = groupingSeparator + formattedString;
                }

                formattedString = temp.slice(-group) + formattedString;

                temp = temp.slice(0, -group);
            }
        } else {
            formattedString = integerString;
        }

        // Add decimalSeparator and fraction.
        if (fractionString) {
            formattedString = formattedString + decimalSeparator + fractionString;
        }

        return formattedString;
    }

    // durationLabelCompare
    function durationLabelCompare(a, b) {
        if (a.label.length > b.label.length) {
            return -1;
        }

        if (a.label.length < b.label.length) {
            return 1;
        }

        // a must be equal to b
        return 0;
    }

    // durationGetLabels
    function durationGetLabels(token, localeData) {
        var labels = [];

        each(keys(localeData), function (localeDataKey) {
            if (localeDataKey.slice(0, 15) !== "_durationLabels") {
                return;
            }

            var labelType = localeDataKey.slice(15).toLowerCase();

            each(keys(localeData[localeDataKey]), function (labelKey) {
                if (labelKey.slice(0, 1) === token) {
                    labels.push({
                        type: labelType,
                        key: labelKey,
                        label: localeData[localeDataKey][labelKey]
                    });
                }
            });
        });

        return labels;
    }

    // durationPluralKey
    function durationPluralKey(token, integerValue, decimalValue) {
        // Singular for a value of `1`, but not for `1.0`.
        if (integerValue === 1 && decimalValue === null) {
            return token;
        }

        return token + token;
    }

    var engLocale = {
        durationLabelsStandard: {
            S: 'millisecond',
            SS: 'milliseconds',
            s: 'second',
            ss: 'seconds',
            m: 'minute',
            mm: 'minutes',
            h: 'hour',
            hh: 'hours',
            d: 'day',
            dd: 'days',
            w: 'week',
            ww: 'weeks',
            M: 'month',
            MM: 'months',
            y: 'year',
            yy: 'years'
        },
        durationLabelsShort: {
            S: 'msec',
            SS: 'msecs',
            s: 'sec',
            ss: 'secs',
            m: 'min',
            mm: 'mins',
            h: 'hr',
            hh: 'hrs',
            d: 'dy',
            dd: 'dys',
            w: 'wk',
            ww: 'wks',
            M: 'mo',
            MM: 'mos',
            y: 'yr',
            yy: 'yrs'
        },
        durationTimeTemplates: {
            HMS: 'h:mm:ss',
            HM: 'h:mm',
            MS: 'm:ss'
        },
        durationLabelTypes: [
            { type: "standard", string: "__" },
            { type: "short", string: "_" }
        ],
        durationPluralKey: durationPluralKey
    };

    // isArray
    function isArray(array) {
        return Object.prototype.toString.call(array) === "[object Array]";
    }

    // isObject
    function isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    // findLast
    function findLast(array, callback) {
        var index = array.length;

        while (index -= 1) {
            if (callback(array[index])) { return array[index]; }
        }
    }

    // find
    function find(array, callback) {
        var index = 0;

        var max = array && array.length || 0;

        var match;

        if (typeof callback !== "function") {
            match = callback;
            callback = function (item) {
                return item === match;
            };
        }

        while (index < max) {
            if (callback(array[index])) { return array[index]; }
            index += 1;
        }
    }

    // each
    function each(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return; }

        while (index < max) {
            if (callback(array[index], index) === false) { return; }
            index += 1;
        }
    }

    // map
    function map(array, callback) {
        var index = 0,
            max = array.length,
            ret = [];

        if (!array || !max) { return ret; }

        while (index < max) {
            ret[index] = callback(array[index], index);
            index += 1;
        }

        return ret;
    }

    // pluck
    function pluck(array, prop) {
        return map(array, function (item) {
            return item[prop];
        });
    }

    // compact
    function compact(array) {
        var ret = [];

        each(array, function (item) {
            if (item) { ret.push(item); }
        });

        return ret;
    }

    // unique
    function unique(array) {
        var ret = [];

        each(array, function (_a) {
            if (!find(ret, _a)) { ret.push(_a); }
        });

        return ret;
    }

    // intersection
    function intersection(a, b) {
        var ret = [];

        each(a, function (_a) {
            each(b, function (_b) {
                if (_a === _b) { ret.push(_a); }
            });
        });

        return unique(ret);
    }

    // rest
    function rest(array, callback) {
        var ret = [];

        each(array, function (item, index) {
            if (!callback(item)) {
                ret = array.slice(index);
                return false;
            }
        });

        return ret;
    }

    // initial
    function initial(array, callback) {
        var reversed = array.slice().reverse();

        return rest(reversed, callback).reverse();
    }

    // extend
    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) { a[key] = b[key]; }
        }

        return a;
    }

    // keys
    function keys(a) {
        var ret = [];

        for (var key in a) {
            if (a.hasOwnProperty(key)) { ret.push(key); }
        }

        return ret;
    }

    // any
    function any(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return false; }

        while (index < max) {
            if (callback(array[index], index) === true) { return true; }
            index += 1;
        }

        return false;
    }

    // flatten
    function flatten(array) {
        var ret = [];

        each(array, function(child) {
            ret = ret.concat(child);
        });

        return ret;
    }

    function toLocaleStringSupportsLocales() {
        var number = 0;
        try {
            number.toLocaleString('i');
        } catch (e) {
            return e.name === 'RangeError';
        }
        return false;
    }

    function featureTestToLocaleStringRounding() {
        return (3.55).toLocaleString("en", {
            useGrouping: false,
            minimumIntegerDigits: 1,
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }) === "3.6";
    }

    function featureTestToLocaleString() {
        var passed = true;

        // Test locale.
        passed = passed && toLocaleStringSupportsLocales();
        if (!passed) { return false; }

        // Test minimumIntegerDigits.
        passed = passed && (1).toLocaleString("en", { minimumIntegerDigits: 1 }) === "1";
        passed = passed && (1).toLocaleString("en", { minimumIntegerDigits: 2 }) === "01";
        passed = passed && (1).toLocaleString("en", { minimumIntegerDigits: 3 }) === "001";
        if (!passed) { return false; }

        // Test maximumFractionDigits and minimumFractionDigits.
        passed = passed && (99.99).toLocaleString("en", { maximumFractionDigits: 0, minimumFractionDigits: 0 }) === "100";
        passed = passed && (99.99).toLocaleString("en", { maximumFractionDigits: 1, minimumFractionDigits: 1 }) === "100.0";
        passed = passed && (99.99).toLocaleString("en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }) === "99.99";
        passed = passed && (99.99).toLocaleString("en", { maximumFractionDigits: 3, minimumFractionDigits: 3 }) === "99.990";
        if (!passed) { return false; }

        // Test maximumSignificantDigits.
        passed = passed && (99.99).toLocaleString("en", { maximumSignificantDigits: 1 }) === "100";
        passed = passed && (99.99).toLocaleString("en", { maximumSignificantDigits: 2 }) === "100";
        passed = passed && (99.99).toLocaleString("en", { maximumSignificantDigits: 3 }) === "100";
        passed = passed && (99.99).toLocaleString("en", { maximumSignificantDigits: 4 }) === "99.99";
        passed = passed && (99.99).toLocaleString("en", { maximumSignificantDigits: 5 }) === "99.99";
        if (!passed) { return false; }

        // Test grouping.
        passed = passed && (1000).toLocaleString("en", { useGrouping: true }) === "1,000";
        passed = passed && (1000).toLocaleString("en", { useGrouping: false }) === "1000";
        if (!passed) { return false; }

        return true;
    }

    // durationsFormat(durations [, template] [, precision] [, settings])
    function durationsFormat() {
        var args = [].slice.call(arguments);
        var settings = {};
        var durations;

        // Parse arguments.
        each(args, function (arg, index) {
            if (!index) {
                if (!isArray(arg)) {
                    throw "Expected array as the first argument to durationsFormat.";
                }

                durations = arg;
            }

            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        if (!durations || !durations.length) {
            return [];
        }

        settings.returnMomentTypes = true;

        var formattedDurations = map(durations, function (dur) {
            return dur.format(settings);
        });

        // Merge token types from all durations.
        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));

        var largest = settings.largest;

        if (largest) {
            outputTypes = outputTypes.slice(0, largest);
        }

        settings.returnMomentTypes = false;
        settings.outputTypes = outputTypes;

        return map(durations, function (dur) {
            return dur.format(settings);
        });
    }

    // durationFormat([template] [, precision] [, settings])
    function durationFormat() {

        var args = [].slice.call(arguments);
        var settings = extend({}, this.format.defaults);

        // Keep a shadow copy of this moment for calculating remainders.
        // Perform all calculations on positive duration value, handle negative
        // sign at the very end.
        var asMilliseconds = this.asMilliseconds();
        var asMonths = this.asMonths();

        // Treat invalid durations as having a value of 0 milliseconds.
        if (typeof this.isValid === "function" && this.isValid() === false) {
            asMilliseconds = 0;
            asMonths = 0;
        }

        var isNegative = asMilliseconds < 0;

        // Two shadow copies are needed because of the way moment.js handles
        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
        var remainderMonths = moment.duration(Math.abs(asMonths), "months");

        // Parse arguments.
        each(args, function (arg) {
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        var momentTokens = {
            years: "y",
            months: "M",
            weeks: "w",
            days: "d",
            hours: "h",
            minutes: "m",
            seconds: "s",
            milliseconds: "S"
        };

        var tokenDefs = {
            escape: /\[(.+?)\]/,
            years: /\*?[Yy]+/,
            months: /\*?M+/,
            weeks: /\*?[Ww]+/,
            days: /\*?[Dd]+/,
            hours: /\*?[Hh]+/,
            minutes: /\*?m+/,
            seconds: /\*?s+/,
            milliseconds: /\*?S+/,
            general: /.+?/
        };

        // Types array is available in the template function.
        settings.types = types;

        var typeMap = function (token) {
            return find(types, function (type) {
                return tokenDefs[type].test(token);
            });
        };

        var tokenizer = new RegExp(map(types, function (type) {
            return tokenDefs[type].source;
        }).join("|"), "g");

        // Current duration object is available in the template function.
        settings.duration = this;

        // Eval template function and cache template string.
        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;

        // outputTypes and returnMomentTypes are settings to support durationsFormat().

        // outputTypes is an array of moment token types that determines
        // the tokens returned in formatted output. This option overrides
        // trim, largest, stopTrim, etc.
        var outputTypes = settings.outputTypes;

        // returnMomentTypes is a boolean that sets durationFormat to return
        // the processed momentTypes instead of formatted output.
        var returnMomentTypes = settings.returnMomentTypes;

        var largest = settings.largest;

        // Setup stopTrim array of token types.
        var stopTrim = [];

        if (!outputTypes) {
            if (isArray(settings.stopTrim)) {
                settings.stopTrim = settings.stopTrim.join("");
            }

            // Parse stopTrim string to create token types array.
            if (settings.stopTrim) {
                each(settings.stopTrim.match(tokenizer), function (token) {
                    var type = typeMap(token);

                    if (type === "escape" || type === "general") {
                        return;
                    }

                    stopTrim.push(type);
                });
            }
        }

        // Cache moment's locale data.
        var localeData = moment.localeData();

        if (!localeData) {
            localeData = {};
        }

        // Fall back to this plugin's `eng` extension.
        each(keys(engLocale), function (key) {
            if (typeof engLocale[key] === "function") {
                if (!localeData[key]) {
                    localeData[key] = engLocale[key];
                }

                return;
            }

            if (!localeData["_" + key]) {
                localeData["_" + key] = engLocale[key];
            }
        });

        // Replace Duration Time Template strings.
        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
        each(keys(localeData._durationTimeTemplates), function (item) {
            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
        });

        // Determine user's locale.
        var userLocale = settings.userLocale || moment.locale();

        var useLeftUnits = settings.useLeftUnits;
        var usePlural = settings.usePlural;
        var precision = settings.precision;
        var forceLength = settings.forceLength;
        var useGrouping = settings.useGrouping;
        var trunc = settings.trunc;

        // Use significant digits only when precision is greater than 0.
        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
        var significantDigits = useSignificantDigits ? settings.precision : 0;
        var significantDigitsCache = significantDigits;

        var minValue = settings.minValue;
        var isMinValue = false;

        var maxValue = settings.maxValue;
        var isMaxValue = false;

        // formatNumber fallback options.
        var useToLocaleString = settings.useToLocaleString;
        var groupingSeparator = settings.groupingSeparator;
        var decimalSeparator = settings.decimalSeparator;
        var grouping = settings.grouping;

        useToLocaleString = useToLocaleString && toLocaleStringWorks;

        // Trim options.
        var trim = settings.trim;

        if (isArray(trim)) {
            trim = trim.join(" ");
        }

        if (trim === null && (largest || maxValue || useSignificantDigits)) {
            trim = "all";
        }

        if (trim === null || trim === true || trim === "left" || trim === "right") {
            trim = "large";
        }

        if (trim === false) {
            trim = "";
        }

        var trimIncludes = function (item) {
            return item.test(trim);
        };

        var rLarge = /large/;
        var rSmall = /small/;
        var rBoth = /both/;
        var rMid = /mid/;
        var rAll = /^all|[^sm]all/;
        var rFinal = /final/;

        var trimLarge = largest > 0 || any([rLarge, rBoth, rAll], trimIncludes);
        var trimSmall = any([rSmall, rBoth, rAll], trimIncludes);
        var trimMid = any([rMid, rAll], trimIncludes);
        var trimFinal = any([rFinal, rAll], trimIncludes);

        // Parse format string to create raw tokens array.
        var rawTokens = map(template.match(tokenizer), function (token, index) {
            var type = typeMap(token);

            if (token.slice(0, 1) === "*") {
                token = token.slice(1);

                if (type !== "escape" && type !== "general") {
                    stopTrim.push(type);
                }
            }

            return {
                index: index,
                length: token.length,
                text: "",

                // Replace escaped tokens with the non-escaped token text.
                token: (type === "escape" ? token.replace(tokenDefs.escape, "$1") : token),

                // Ignore type on non-moment tokens.
                type: ((type === "escape" || type === "general") ? null : type)
            };
        });

        // Associate text tokens with moment tokens.
        var currentToken = {
            index: 0,
            length: 0,
            token: "",
            text: "",
            type: null
        };

        var tokens = [];

        if (useLeftUnits) {
            rawTokens.reverse();
        }

        each(rawTokens, function (token) {
            if (token.type) {
                if (currentToken.type || currentToken.text) {
                    tokens.push(currentToken);
                }

                currentToken = token;

                return;
            }

            if (useLeftUnits) {
                currentToken.text = token.token + currentToken.text;
            } else {
                currentToken.text += token.token;
            }
        });

        if (currentToken.type || currentToken.text) {
            tokens.push(currentToken);
        }

        if (useLeftUnits) {
            tokens.reverse();
        }

        // Find unique moment token types in the template in order of
        // descending magnitude.
        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

        // Exit early if there are no moment token types.
        if (!momentTypes.length) {
            return pluck(tokens, "text").join("");
        }

        // Calculate values for each moment type in the template.
        // For processing the settings, values are associated with moment types.
        // Values will be assigned to tokens at the last step in order to
        // assume nothing about frequency or order of tokens in the template.
        momentTypes = map(momentTypes, function (momentType, index) {
            // Is this the least-magnitude moment token found?
            var isSmallest = ((index + 1) === momentTypes.length);

            // Is this the greatest-magnitude moment token found?
            var isLargest = (!index);

            // Get the raw value in the current units.
            var rawValue;

            if (momentType === "years" || momentType === "months") {
                rawValue = remainderMonths.as(momentType);
            } else {
                rawValue = remainder.as(momentType);
            }

            var wholeValue = Math.floor(rawValue);
            var decimalValue = rawValue - wholeValue;

            var token = find(tokens, function (token) {
                return momentType === token.type;
            });

            if (isLargest && maxValue && rawValue > maxValue) {
                isMaxValue = true;
            }

            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) {
                isMinValue = true;
            }

            // Note the length of the largest-magnitude moment token:
            // if it is greater than one and forceLength is not set,
            // then default forceLength to `true`.
            //
            // Rationale is this: If the template is "h:mm:ss" and the
            // moment value is 5 minutes, the user-friendly output is
            // "5:00", not "05:00". We shouldn't pad the `minutes` token
            // even though it has length of two if the template is "h:mm:ss";
            //
            // If the minutes output should always include the leading zero
            // even when the hour is trimmed then set `{ forceLength: true }`
            // to output "05:00". If the template is "hh:mm:ss", the user
            // clearly wanted everything padded so we should output "05:00";
            //
            // If the user wants the full padded output, they can use
            // template "hh:mm:ss" and set `{ trim: false }` to output
            // "00:05:00".
            if (isLargest && forceLength === null && token.length > 1) {
                forceLength = true;
            }

            // Update remainder.
            remainder.subtract(wholeValue, momentType);
            remainderMonths.subtract(wholeValue, momentType);

            return {
                rawValue: rawValue,
                wholeValue: wholeValue,
                // Decimal value is only retained for the least-magnitude
                // moment type in the format template.
                decimalValue: isSmallest ? decimalValue : 0,
                isSmallest: isSmallest,
                isLargest: isLargest,
                type: momentType,
                // Tokens can appear multiple times in a template string,
                // but all instances must share the same length.
                tokenLength: token.length
            };
        });

        var truncMethod = trunc ? Math.floor : Math.round;
        var truncate = function (value, places) {
            var factor = Math.pow(10, places);
            return truncMethod(value * factor) / factor;
        };

        var foundFirst = false;
        var bubbled = false;

        var formatValue = function (momentType, index) {
            var formatOptions = {
                useGrouping: useGrouping,
                groupingSeparator: groupingSeparator,
                decimalSeparator: decimalSeparator,
                grouping: grouping,
                useToLocaleString: useToLocaleString
            };

            if (useSignificantDigits) {
                if (significantDigits <= 0) {
                    momentType.rawValue = 0;
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                } else {
                    formatOptions.maximumSignificantDigits = significantDigits;
                    momentType.significantDigits = significantDigits;
                }
            }

            if (isMaxValue && !bubbled) {
                if (momentType.isLargest) {
                    momentType.wholeValue = maxValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (isMinValue && !bubbled) {
                if (momentType.isSmallest) {
                    momentType.wholeValue = minValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
                // Apply precision to least significant token value.
                if (precision < 0) {
                    momentType.value = truncate(momentType.wholeValue, precision);
                } else if (precision === 0) {
                    momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
                } else { // precision > 0
                    if (useSignificantDigits) {
                        if (trunc) {
                            momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
                        } else {
                            momentType.value = momentType.rawValue;
                        }

                        if (momentType.wholeValue) {
                            significantDigits -= momentType.wholeValue.toString().length;
                        }
                    } else {
                        formatOptions.fractionDigits = precision;

                        if (trunc) {
                            momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
                        } else {
                            momentType.value = momentType.wholeValue + momentType.decimalValue;
                        }
                    }
                }
            } else {
                if (useSignificantDigits && momentType.wholeValue) {
                    // Outer Math.round required here to handle floating point errors.
                    momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));

                    significantDigits -= momentType.wholeValue.toString().length;
                } else {
                    momentType.value = momentType.wholeValue;
                }
            }

            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
                formatOptions.minimumIntegerDigits = momentType.tokenLength;

                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) {
                    delete formatOptions.maximumSignificantDigits;
                }
            }

            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */ || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                foundFirst = true;
            }

            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);

            formatOptions.useGrouping = false;
            formatOptions.decimalSeparator = ".";
            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");

            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") {
                momentType.formattedValueMS = formatNumber(momentType.value, {
                    minimumIntegerDigits: 3,
                    useGrouping: false
                }, "en").slice(0, 2);
            }

            return momentType;
        };

        // Calculate formatted values.
        momentTypes = map(momentTypes, formatValue);
        momentTypes = compact(momentTypes);

        // Bubble rounded values.
        if (momentTypes.length > 1) {
            var findType = function (type) {
                return find(momentTypes, function (momentType) {
                    return momentType.type === type;
                });
            };

            var bubbleTypes = function (bubble) {
                var bubbleMomentType = findType(bubble.type);

                if (!bubbleMomentType) {
                    return;
                }

                each(bubble.targets, function (target) {
                    var targetMomentType = findType(target.type);

                    if (!targetMomentType) {
                        return;
                    }

                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
                        bubbleMomentType.rawValue = 0;
                        bubbleMomentType.wholeValue = 0;
                        bubbleMomentType.decimalValue = 0;
                        targetMomentType.rawValue += 1;
                        targetMomentType.wholeValue += 1;
                        targetMomentType.decimalValue = 0;
                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
                        bubbled = true;
                    }
                });
            };

            each(bubbles, bubbleTypes);
        }

        // Recalculate formatted values.
        if (bubbled) {
            foundFirst = false;
            significantDigits = significantDigitsCache;
            momentTypes = map(momentTypes, formatValue);
            momentTypes = compact(momentTypes);
        }

        if (outputTypes && !(isMaxValue && !settings.trim)) {
            momentTypes = map(momentTypes, function (momentType) {
                if (find(outputTypes, function (outputType) {
                    return momentType.type === outputType;
                })) {
                    return momentType;
                }

                return null;
            });

            momentTypes = compact(momentTypes);
        } else {
            // Trim Large.
            if (trimLarge) {
                momentTypes = rest(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - the smallest moment type
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
                });
            }

            // Largest.
            if (largest && momentTypes.length) {
                momentTypes = momentTypes.slice(0, largest);
            }

            // Trim Small.
            if (trimSmall && momentTypes.length > 1) {
                momentTypes = initial(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    // - the largest momentType
                    return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
                });
            }

            // Trim Mid.
            if (trimMid) {
                momentTypes = map(momentTypes, function (momentType, index) {
                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) {
                        return null;
                    }

                    return momentType;
                });

                momentTypes = compact(momentTypes);
            }

            // Trim Final.
            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) {
                momentTypes = [];
            }
        }

        if (returnMomentTypes) {
            return momentTypes;
        }

        // Localize and pluralize unit labels.
        each(tokens, function (token) {
            var key = momentTokens[token.type];

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!key || !momentType) {
                return;
            }

            var values = momentType.formattedValueEn.split(".");

            values[0] = parseInt(values[0], 10);

            if (values[1]) {
                values[1] = parseFloat("0." + values[1], 10);
            } else {
                values[1] = null;
            }

            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);

            var labels = durationGetLabels(key, localeData);

            var autoLocalized = false;

            var pluralizedLabels = {};

            // Auto-Localized unit labels.
            each(localeData._durationLabelTypes, function (labelType) {
                var label = find(labels, function (label) {
                    return label.type === labelType.type && label.key === pluralKey;
                });

                if (label) {
                    pluralizedLabels[label.type] = label.label;

                    if (stringIncludes(token.text, labelType.string)) {
                        token.text = token.text.replace(labelType.string, label.label);
                        autoLocalized = true;
                    }
                }
            });

            // Auto-pluralized unit labels.
            if (usePlural && !autoLocalized) {
                labels.sort(durationLabelCompare);

                each(labels, function (label) {
                    if (pluralizedLabels[label.type] === label.label) {
                        if (stringIncludes(token.text, label.label)) {
                            // Stop checking this token if its label is already
                            // correctly pluralized.
                            return false;
                        }

                        // Skip this label if it is correct, but not present in
                        // the token's text.
                        return;
                    }

                    if (stringIncludes(token.text, label.label)) {
                        // Replece this token's label and stop checking.
                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
                        return false;
                    }
                });
            }
        });

        // Build ouptut.
        tokens = map(tokens, function (token) {
            if (!token.type) {
                return token.text;
            }

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!momentType) {
                return "";
            }

            var out = "";

            if (useLeftUnits) {
                out += token.text;
            }

            if (isNegative && isMaxValue || !isNegative && isMinValue) {
                out += "< ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && isMinValue || !isNegative && isMaxValue) {
                out += "> ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                out += "-";
                isNegative = false;
            }

            if (token.type === "milliseconds" && momentType.formattedValueMS) {
                out += momentType.formattedValueMS;
            } else {
                out += momentType.formattedValue;
            }

            if (!useLeftUnits) {
                out += token.text;
            }

            return out;
        });

        // Trim leading and trailing comma, space, colon, and dot.
        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
    }

    // defaultFormatTemplate
    function defaultFormatTemplate() {
        var dur = this.duration;

        var findType = function findType(type) {
            return dur._data[type];
        };

        var firstType = find(this.types, findType);

        var lastType = findLast(this.types, findType);

        // Default template strings for each duration dimension type.
        switch (firstType) {
            case "milliseconds":
                return "S __";
            case "seconds": // Fallthrough.
            case "minutes":
                return "*_MS_";
            case "hours":
                return "_HMS_";
            case "days": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "d __";
                }
            case "weeks":
                if (firstType === lastType) {
                    return "w __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "w __, d __, h __";
            case "months": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "M __";
                }
            case "years":
                if (firstType === lastType) {
                    return "y __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, M __, d __";
            default:
                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, d __, h __, m __, s __";
        }
    }

    // init
    function init(context) {
        if (!context) {
            throw "Moment Duration Format init cannot find moment instance.";
        }

        context.duration.format = durationsFormat;
        context.duration.fn.format = durationFormat;

        context.duration.fn.format.defaults = {
            // Many options are defaulted to `null` to distinguish between
            // 'not set' and 'set to `false`'

            // trim
            // Can be a string, a delimited list of strings, an array of strings,
            // or a boolean.
            // "large" - will trim largest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "small" - will trim smallest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "both" - will execute "large" trim then "small" trim.
            // "mid" - will trim any zero-value tokens that are not the first or
            // last tokens. Usually used in conjunction with "large" or "both".
            // e.g. "large mid" or "both mid".
            // "final" - will trim the final token if it is zero-value. Use this
            // option with "large" or "both" to output an empty string when
            // formatting a zero-value duration. e.g. "large final" or "both final".
            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
            // "left" - maps to "large" to support plugin's version 1 API.
            // "right" - maps to "large" to support plugin's version 1 API.
            // `false` - template tokens are not trimmed.
            // `true` - treated as "large".
            // `null` - treated as "large".
            trim: null,

            // stopTrim
            // A moment token string, a delimited set of moment token strings,
            // or an array of moment token strings. Trimming will stop when a token
            // listed in this option is reached. A "*" character in the format
            // template string will also mark a moment token as stopTrim.
            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
            stopTrim: null,

            // largest
            // Set to a positive integer to output only the "n" largest-magnitude
            // moment tokens that have a value. All lesser-magnitude moment tokens
            // will be ignored. This option takes effect even if `trim` is set
            // to `false`.
            largest: null,

            // maxValue
            // Use `maxValue` to render generalized output for large duration values,
            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
            /// applied to the greatest-magnitude moment token in the format template.
            maxValue: null,

            // minValue
            // Use `minValue` to render generalized output for small duration values,
            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
            // applied to the least-magnitude moment token in the format template.
            minValue: null,

            // precision
            // If a positive integer, number of decimal fraction digits to render.
            // If a negative integer, number of integer place digits to truncate to 0.
            // If `useSignificantDigits` is set to `true` and `precision` is a positive
            // integer, sets the maximum number of significant digits used in the
            // formatted output.
            precision: 0,

            // trunc
            // Default behavior rounds final token value. Set to `true` to
            // truncate final token value, which was the default behavior in
            // version 1 of this plugin.
            trunc: false,

            // forceLength
            // Force first moment token with a value to render at full length
            // even when template is trimmed and first moment token has length of 1.
            forceLength: null,

            // userLocale
            // Formatted numerical output is rendered using `toLocaleString`
            // and the locale of the user's environment. Set this option to render
            // numerical output using a different locale. Unit names are rendered
            // and detected using the locale set in moment.js, which can be different
            // from the locale of user's environment.
            userLocale: null,

            // usePlural
            // Will automatically singularize or pluralize unit names when they
            // appear in the text associated with each moment token. Standard and
            // short unit labels are singularized and pluralized, based on locale.
            // e.g. in english, "1 second" or "1 sec" would be rendered instead
            // of "1 seconds" or "1 secs". The default pluralization function
            // renders a plural label for a value with decimal precision.
            // e.g. "1.0 seconds" is never rendered as "1.0 second".
            // Label types and pluralization function are configurable in the
            // localeData extensions.
            usePlural: true,

            // useLeftUnits
            // The text to the right of each moment token in a format string
            // is treated as that token's units for the purposes of trimming,
            // singularizing, and auto-localizing.
            // e.g. "h [hours], m [minutes], s [seconds]".
            // To properly singularize or localize a format string such as
            // "[hours] h, [minutes] m, [seconds] s", where the units appear
            // to the left of each moment token, set useLeftUnits to `true`.
            // This plugin is not tested in the context of rtl text.
            useLeftUnits: false,

            // useGrouping
            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useGrouping: true,

            // useSignificantDigits
            // Treat the `precision` option as the maximum significant digits
            // to be rendered. Precision must be a positive integer. Significant
            // digits extend across unit types,
            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useSignificantDigits: false,

            // template
            // The template string used to format the duration. May be a function
            // or a string. Template functions are executed with the `this` binding
            // of the settings object so that template strings may be dynamically
            // generated based on the duration object (accessible via `this.duration`)
            // or any of the other settings. Leading and trailing space, comma,
            // period, and colon characters are trimmed from the resulting string.
            template: defaultFormatTemplate,

            // useToLocaleString
            // Set this option to `false` to ignore the `toLocaleString` feature
            // test and force the use of the `formatNumber` fallback function
            // included in this plugin.
            useToLocaleString: true,

            // formatNumber fallback options.
            // When `toLocaleString` is detected and passes the feature test, the
            // following options will have no effect: `toLocaleString` will be used
            // for formatting and the grouping separator, decimal separator, and
            // integer digit grouping will be determined by the user locale.

            // groupingSeparator
            // The integer digit grouping separator used when using the fallback
            // formatNumber function.
            groupingSeparator: ",",

            // decimalSeparator
            // The decimal separator used when using the fallback formatNumber
            // function.
            decimalSeparator: ".",

            // grouping
            // The integer digit grouping used when using the fallback formatNumber
            // function. Must be an array. The default value of `[3]` gives the
            // standard 3-digit thousand/million/billion digit groupings for the
            // "en" locale. Setting this option to `[3, 2]` would generate the
            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
            grouping: [3]
        };

        context.updateLocale('en', engLocale);
    }

    // Run feature tests for `Number#toLocaleString`.
    toLocaleStringWorks = featureTestToLocaleString();
    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestToLocaleStringRounding();

    // Initialize duration format on the global moment instance.
    init(moment);

    // Return the init function so that duration format can be
    // initialized on other moment instances.
    return init;
});


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components__);
var cov_u3teeoaa1=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobsNewPage\\index.js',hash='64b2f0a60cd74d886aa341a5b4c0dff4cf38ab22',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobsNewPage\\index.js',statementMap:{'0':{start:{line:66,column:8},end:{line:66,column:21}},'1':{start:{line:67,column:8},end:{line:97,column:3}},'2':{start:{line:101,column:8},end:{line:101,column:41}},'3':{start:{line:105,column:5},end:{line:105,column:29}},'4':{start:{line:106,column:8},end:{line:106,column:56}},'5':{start:{line:110,column:5},end:{line:112,column:6}},'6':{start:{line:111,column:9},end:{line:111,column:36}},'7':{start:{line:113,column:8},end:{line:129,column:9}},'8':{start:{line:114,column:12},end:{line:128,column:15}},'9':{start:{line:114,column:40},end:{line:128,column:13}},'10':{start:{line:131,column:8},end:{line:152,column:9}},'11':{start:{line:132,column:12},end:{line:142,column:16}},'12':{start:{line:132,column:40},end:{line:142,column:13}},'13':{start:{line:143,column:12},end:{line:151,column:13}},'14':{start:{line:144,column:16},end:{line:150,column:19}},'15':{start:{line:144,column:44},end:{line:146,column:17}},'16':{start:{line:147,column:20},end:{line:149,column:21}},'17':{start:{line:148,column:24},end:{line:148,column:45}},'18':{start:{line:154,column:5},end:{line:210,column:9}},'19':{start:{line:155,column:12},end:{line:173,column:13}},'20':{start:{line:156,column:16},end:{line:172,column:19}},'21':{start:{line:156,column:44},end:{line:158,column:17}},'22':{start:{line:159,column:20},end:{line:171,column:22}},'23':{start:{line:160,column:24},end:{line:170,column:25}},'24':{start:{line:161,column:28},end:{line:169,column:31}},'25':{start:{line:161,column:56},end:{line:169,column:29}},'26':{start:{line:174,column:12},end:{line:190,column:13}},'27':{start:{line:175,column:16},end:{line:180,column:20}},'28':{start:{line:175,column:44},end:{line:180,column:17}},'29':{start:{line:184,column:16},end:{line:189,column:20}},'30':{start:{line:184,column:44},end:{line:189,column:17}},'31':{start:{line:192,column:13},end:{line:210,column:9}},'32':{start:{line:193,column:12},end:{line:209,column:13}},'33':{start:{line:194,column:16},end:{line:199,column:20}},'34':{start:{line:194,column:44},end:{line:199,column:17}},'35':{start:{line:203,column:16},end:{line:208,column:20}},'36':{start:{line:203,column:44},end:{line:208,column:17}},'37':{start:{line:212,column:8},end:{line:238,column:9}},'38':{start:{line:213,column:24},end:{line:213,column:52}},'39':{start:{line:214,column:12},end:{line:214,column:36}},'40':{start:{line:215,column:12},end:{line:215,column:35}},'41':{start:{line:216,column:12},end:{line:216,column:36}},'42':{start:{line:217,column:12},end:{line:237,column:15}},'43':{start:{line:217,column:40},end:{line:234,column:13}},'44':{start:{line:235,column:16},end:{line:235,column:117}},'45':{start:{line:236,column:16},end:{line:236,column:39}},'46':{start:{line:242,column:5},end:{line:259,column:3}},'47':{start:{line:243,column:6},end:{line:257,column:9}},'48':{start:{line:243,column:34},end:{line:257,column:7}},'49':{start:{line:263,column:8},end:{line:263,column:31}},'50':{start:{line:264,column:8},end:{line:278,column:9}},'51':{start:{line:265,column:12},end:{line:274,column:13}},'52':{start:{line:266,column:16},end:{line:266,column:37}},'53':{start:{line:269,column:16},end:{line:273,column:19}},'54':{start:{line:269,column:44},end:{line:271,column:17}},'55':{start:{line:272,column:20},end:{line:272,column:49}},'56':{start:{line:277,column:12},end:{line:277,column:33}},'57':{start:{line:282,column:23},end:{line:282,column:37}},'58':{start:{line:283,column:8},end:{line:283,column:53}},'59':{start:{line:284,column:8},end:{line:284,column:51}},'60':{start:{line:288,column:20},end:{line:288,column:38}},'61':{start:{line:289,column:5},end:{line:294,column:12}},'62':{start:{line:289,column:33},end:{line:294,column:9}},'63':{start:{line:298,column:8},end:{line:300,column:9}},'64':{start:{line:299,column:12},end:{line:299,column:41}},'65':{start:{line:301,column:8},end:{line:301,column:67}},'66':{start:{line:302,column:8},end:{line:304,column:9}},'67':{start:{line:303,column:12},end:{line:303,column:66}},'68':{start:{line:307,column:8},end:{line:309,column:9}},'69':{start:{line:308,column:12},end:{line:308,column:66}},'70':{start:{line:313,column:8},end:{line:345,column:9}},'71':{start:{line:314,column:12},end:{line:341,column:13}},'72':{start:{line:315,column:16},end:{line:326,column:19}},'73':{start:{line:315,column:44},end:{line:324,column:17}},'74':{start:{line:325,column:20},end:{line:325,column:97}},'75':{start:{line:329,column:16},end:{line:340,column:19}},'76':{start:{line:329,column:44},end:{line:338,column:17}},'77':{start:{line:339,column:20},end:{line:339,column:41}},'78':{start:{line:343,column:13},end:{line:345,column:9}},'79':{start:{line:344,column:12},end:{line:344,column:33}},'80':{start:{line:348,column:8},end:{line:350,column:12}},'81':{start:{line:348,column:36},end:{line:350,column:9}},'82':{start:{line:351,column:25},end:{line:363,column:9}},'83':{start:{line:365,column:8},end:{line:423,column:9}},'84':{start:{line:366,column:24},end:{line:366,column:52}},'85':{start:{line:367,column:12},end:{line:367,column:36}},'86':{start:{line:368,column:12},end:{line:368,column:35}},'87':{start:{line:369,column:12},end:{line:369,column:36}},'88':{start:{line:370,column:12},end:{line:375,column:46}},'89':{start:{line:370,column:40},end:{line:375,column:13}},'90':{start:{line:375,column:22},end:{line:375,column:44}},'91':{start:{line:377,column:14},end:{line:423,column:9}},'92':{start:{line:378,column:12},end:{line:403,column:14}},'93':{start:{line:378,column:40},end:{line:380,column:17}},'94':{start:{line:381,column:20},end:{line:401,column:21}},'95':{start:{line:382,column:36},end:{line:382,column:64}},'96':{start:{line:383,column:24},end:{line:383,column:47}},'97':{start:{line:384,column:24},end:{line:384,column:48}},'98':{start:{line:385,column:24},end:{line:385,column:48}},'99':{start:{line:386,column:24},end:{line:391,column:58}},'100':{start:{line:386,column:52},end:{line:391,column:25}},'101':{start:{line:391,column:34},end:{line:391,column:56}},'102':{start:{line:394,column:24},end:{line:400,column:27}},'103':{start:{line:394,column:52},end:{line:400,column:25}},'104':{start:{line:405,column:13},end:{line:423,column:9}},'105':{start:{line:406,column:12},end:{line:422,column:14}},'106':{start:{line:406,column:40},end:{line:408,column:17}},'107':{start:{line:409,column:20},end:{line:420,column:21}},'108':{start:{line:410,column:24},end:{line:410,column:57}},'109':{start:{line:413,column:24},end:{line:419,column:27}},'110':{start:{line:413,column:52},end:{line:419,column:25}},'111':{start:{line:428,column:8},end:{line:430,column:9}},'112':{start:{line:429,column:12},end:{line:429,column:44}},'113':{start:{line:431,column:4},end:{line:668,column:3}},'114':{start:{line:672,column:24},end:{line:680,column:1}},'115':{start:{line:673,column:4},end:{line:679,column:6}},'116':{start:{line:682,column:27},end:{line:691,column:1}},'117':{start:{line:683,column:4},end:{line:690,column:5}},'118':{start:{line:684,column:45},end:{line:684,column:99}},'119':{start:{line:685,column:35},end:{line:685,column:89}},'120':{start:{line:686,column:35},end:{line:686,column:89}},'121':{start:{line:687,column:26},end:{line:687,column:77}},'122':{start:{line:688,column:53},end:{line:688,column:115}},'123':{start:{line:689,column:50},end:{line:689,column:109}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:65,column:4},end:{line:65,column:5}},loc:{start:{line:65,column:23},end:{line:98,column:2}},line:65},'1':{name:'(anonymous_1)',decl:{start:{line:100,column:24},end:{line:100,column:25}},loc:{start:{line:100,column:30},end:{line:102,column:5}},line:100},'2':{name:'(anonymous_2)',decl:{start:{line:104,column:27},end:{line:104,column:28}},loc:{start:{line:104,column:33},end:{line:107,column:5}},line:104},'3':{name:'(anonymous_3)',decl:{start:{line:109,column:25},end:{line:109,column:26}},loc:{start:{line:109,column:61},end:{line:239,column:5}},line:109},'4':{name:'(anonymous_4)',decl:{start:{line:114,column:26},end:{line:114,column:27}},loc:{start:{line:114,column:40},end:{line:128,column:13}},line:114},'5':{name:'(anonymous_5)',decl:{start:{line:132,column:26},end:{line:132,column:27}},loc:{start:{line:132,column:40},end:{line:142,column:13}},line:132},'6':{name:'(anonymous_6)',decl:{start:{line:144,column:30},end:{line:144,column:31}},loc:{start:{line:144,column:44},end:{line:146,column:17}},line:144},'7':{name:'(anonymous_7)',decl:{start:{line:146,column:20},end:{line:146,column:21}},loc:{start:{line:146,column:26},end:{line:150,column:17}},line:146},'8':{name:'(anonymous_8)',decl:{start:{line:156,column:30},end:{line:156,column:31}},loc:{start:{line:156,column:44},end:{line:158,column:17}},line:156},'9':{name:'(anonymous_9)',decl:{start:{line:158,column:20},end:{line:158,column:21}},loc:{start:{line:158,column:26},end:{line:172,column:17}},line:158},'10':{name:'(anonymous_10)',decl:{start:{line:159,column:55},end:{line:159,column:56}},loc:{start:{line:159,column:73},end:{line:171,column:21}},line:159},'11':{name:'(anonymous_11)',decl:{start:{line:161,column:42},end:{line:161,column:43}},loc:{start:{line:161,column:56},end:{line:169,column:29}},line:161},'12':{name:'(anonymous_12)',decl:{start:{line:175,column:30},end:{line:175,column:31}},loc:{start:{line:175,column:44},end:{line:180,column:17}},line:175},'13':{name:'(anonymous_13)',decl:{start:{line:184,column:30},end:{line:184,column:31}},loc:{start:{line:184,column:44},end:{line:189,column:17}},line:184},'14':{name:'(anonymous_14)',decl:{start:{line:194,column:30},end:{line:194,column:31}},loc:{start:{line:194,column:44},end:{line:199,column:17}},line:194},'15':{name:'(anonymous_15)',decl:{start:{line:203,column:30},end:{line:203,column:31}},loc:{start:{line:203,column:44},end:{line:208,column:17}},line:203},'16':{name:'(anonymous_16)',decl:{start:{line:217,column:26},end:{line:217,column:27}},loc:{start:{line:217,column:40},end:{line:234,column:13}},line:217},'17':{name:'(anonymous_17)',decl:{start:{line:234,column:16},end:{line:234,column:17}},loc:{start:{line:234,column:22},end:{line:237,column:13}},line:234},'18':{name:'(anonymous_18)',decl:{start:{line:241,column:23},end:{line:241,column:24}},loc:{start:{line:241,column:34},end:{line:260,column:5}},line:241},'19':{name:'(anonymous_19)',decl:{start:{line:243,column:20},end:{line:243,column:21}},loc:{start:{line:243,column:34},end:{line:257,column:7}},line:243},'20':{name:'(anonymous_20)',decl:{start:{line:262,column:20},end:{line:262,column:21}},loc:{start:{line:262,column:33},end:{line:279,column:5}},line:262},'21':{name:'(anonymous_21)',decl:{start:{line:269,column:30},end:{line:269,column:31}},loc:{start:{line:269,column:44},end:{line:271,column:17}},line:269},'22':{name:'(anonymous_22)',decl:{start:{line:271,column:20},end:{line:271,column:21}},loc:{start:{line:271,column:26},end:{line:273,column:17}},line:271},'23':{name:'(anonymous_23)',decl:{start:{line:281,column:26},end:{line:281,column:27}},loc:{start:{line:281,column:54},end:{line:285,column:5}},line:281},'24':{name:'(anonymous_24)',decl:{start:{line:287,column:26},end:{line:287,column:27}},loc:{start:{line:287,column:54},end:{line:295,column:5}},line:287},'25':{name:'(anonymous_25)',decl:{start:{line:289,column:19},end:{line:289,column:20}},loc:{start:{line:289,column:33},end:{line:294,column:9}},line:289},'26':{name:'(anonymous_26)',decl:{start:{line:297,column:26},end:{line:297,column:27}},loc:{start:{line:297,column:54},end:{line:305,column:5}},line:297},'27':{name:'(anonymous_27)',decl:{start:{line:306,column:24},end:{line:306,column:25}},loc:{start:{line:306,column:52},end:{line:310,column:5}},line:306},'28':{name:'(anonymous_28)',decl:{start:{line:312,column:28},end:{line:312,column:29}},loc:{start:{line:312,column:34},end:{line:346,column:5}},line:312},'29':{name:'(anonymous_29)',decl:{start:{line:315,column:30},end:{line:315,column:31}},loc:{start:{line:315,column:44},end:{line:324,column:17}},line:315},'30':{name:'(anonymous_30)',decl:{start:{line:324,column:20},end:{line:324,column:21}},loc:{start:{line:324,column:26},end:{line:326,column:17}},line:324},'31':{name:'(anonymous_31)',decl:{start:{line:329,column:30},end:{line:329,column:31}},loc:{start:{line:329,column:44},end:{line:338,column:17}},line:329},'32':{name:'(anonymous_32)',decl:{start:{line:338,column:20},end:{line:338,column:21}},loc:{start:{line:338,column:26},end:{line:340,column:17}},line:338},'33':{name:'(anonymous_33)',decl:{start:{line:347,column:20},end:{line:347,column:21}},loc:{start:{line:347,column:26},end:{line:424,column:5}},line:347},'34':{name:'(anonymous_34)',decl:{start:{line:348,column:22},end:{line:348,column:23}},loc:{start:{line:348,column:36},end:{line:350,column:9}},line:348},'35':{name:'(anonymous_35)',decl:{start:{line:370,column:26},end:{line:370,column:27}},loc:{start:{line:370,column:40},end:{line:375,column:13}},line:370},'36':{name:'(anonymous_36)',decl:{start:{line:375,column:16},end:{line:375,column:17}},loc:{start:{line:375,column:22},end:{line:375,column:44}},line:375},'37':{name:'(anonymous_37)',decl:{start:{line:378,column:26},end:{line:378,column:27}},loc:{start:{line:378,column:40},end:{line:380,column:17}},line:378},'38':{name:'(anonymous_38)',decl:{start:{line:380,column:20},end:{line:380,column:21}},loc:{start:{line:380,column:26},end:{line:402,column:17}},line:380},'39':{name:'(anonymous_39)',decl:{start:{line:386,column:38},end:{line:386,column:39}},loc:{start:{line:386,column:52},end:{line:391,column:25}},line:386},'40':{name:'(anonymous_40)',decl:{start:{line:391,column:28},end:{line:391,column:29}},loc:{start:{line:391,column:34},end:{line:391,column:56}},line:391},'41':{name:'(anonymous_41)',decl:{start:{line:394,column:38},end:{line:394,column:39}},loc:{start:{line:394,column:52},end:{line:400,column:25}},line:394},'42':{name:'(anonymous_42)',decl:{start:{line:406,column:26},end:{line:406,column:27}},loc:{start:{line:406,column:40},end:{line:408,column:17}},line:406},'43':{name:'(anonymous_43)',decl:{start:{line:408,column:20},end:{line:408,column:21}},loc:{start:{line:408,column:26},end:{line:421,column:17}},line:408},'44':{name:'(anonymous_44)',decl:{start:{line:413,column:38},end:{line:413,column:39}},loc:{start:{line:413,column:52},end:{line:419,column:25}},line:413},'45':{name:'(anonymous_45)',decl:{start:{line:426,column:1},end:{line:426,column:2}},loc:{start:{line:426,column:10},end:{line:669,column:2}},line:426},'46':{name:'(anonymous_46)',decl:{start:{line:672,column:24},end:{line:672,column:25}},loc:{start:{line:672,column:33},end:{line:680,column:1}},line:672},'47':{name:'(anonymous_47)',decl:{start:{line:682,column:27},end:{line:682,column:28}},loc:{start:{line:682,column:39},end:{line:691,column:1}},line:682},'48':{name:'(anonymous_48)',decl:{start:{line:684,column:31},end:{line:684,column:32}},loc:{start:{line:684,column:45},end:{line:684,column:99}},line:684},'49':{name:'(anonymous_49)',decl:{start:{line:685,column:21},end:{line:685,column:22}},loc:{start:{line:685,column:35},end:{line:685,column:89}},line:685},'50':{name:'(anonymous_50)',decl:{start:{line:686,column:29},end:{line:686,column:30}},loc:{start:{line:686,column:35},end:{line:686,column:89}},line:686},'51':{name:'(anonymous_51)',decl:{start:{line:687,column:20},end:{line:687,column:21}},loc:{start:{line:687,column:26},end:{line:687,column:77}},line:687},'52':{name:'(anonymous_52)',decl:{start:{line:688,column:39},end:{line:688,column:40}},loc:{start:{line:688,column:53},end:{line:688,column:115}},line:688},'53':{name:'(anonymous_53)',decl:{start:{line:689,column:44},end:{line:689,column:45}},loc:{start:{line:689,column:50},end:{line:689,column:109}},line:689}},branchMap:{'0':{loc:{start:{line:110,column:5},end:{line:112,column:6}},type:'if',locations:[{start:{line:110,column:5},end:{line:112,column:6}},{start:{line:110,column:5},end:{line:112,column:6}}],line:110},'1':{loc:{start:{line:113,column:8},end:{line:129,column:9}},type:'if',locations:[{start:{line:113,column:8},end:{line:129,column:9}},{start:{line:113,column:8},end:{line:129,column:9}}],line:113},'2':{loc:{start:{line:131,column:8},end:{line:152,column:9}},type:'if',locations:[{start:{line:131,column:8},end:{line:152,column:9}},{start:{line:131,column:8},end:{line:152,column:9}}],line:131},'3':{loc:{start:{line:131,column:11},end:{line:131,column:81}},type:'binary-expr',locations:[{start:{line:131,column:11},end:{line:131,column:44}},{start:{line:131,column:48},end:{line:131,column:81}}],line:131},'4':{loc:{start:{line:133,column:30},end:{line:133,column:81}},type:'cond-expr',locations:[{start:{line:133,column:69},end:{line:133,column:73}},{start:{line:133,column:76},end:{line:133,column:81}}],line:133},'5':{loc:{start:{line:138,column:32},end:{line:138,column:89}},type:'cond-expr',locations:[{start:{line:138,column:70},end:{line:138,column:79}},{start:{line:138,column:82},end:{line:138,column:89}}],line:138},'6':{loc:{start:{line:139,column:34},end:{line:139,column:132}},type:'cond-expr',locations:[{start:{line:139,column:73},end:{line:139,column:125}},{start:{line:139,column:128},end:{line:139,column:132}}],line:139},'7':{loc:{start:{line:143,column:12},end:{line:151,column:13}},type:'if',locations:[{start:{line:143,column:12},end:{line:151,column:13}},{start:{line:143,column:12},end:{line:151,column:13}}],line:143},'8':{loc:{start:{line:147,column:20},end:{line:149,column:21}},type:'if',locations:[{start:{line:147,column:20},end:{line:149,column:21}},{start:{line:147,column:20},end:{line:149,column:21}}],line:147},'9':{loc:{start:{line:154,column:5},end:{line:210,column:9}},type:'if',locations:[{start:{line:154,column:5},end:{line:210,column:9}},{start:{line:154,column:5},end:{line:210,column:9}}],line:154},'10':{loc:{start:{line:155,column:12},end:{line:173,column:13}},type:'if',locations:[{start:{line:155,column:12},end:{line:173,column:13}},{start:{line:155,column:12},end:{line:173,column:13}}],line:155},'11':{loc:{start:{line:160,column:24},end:{line:170,column:25}},type:'if',locations:[{start:{line:160,column:24},end:{line:170,column:25}},{start:{line:160,column:24},end:{line:170,column:25}}],line:160},'12':{loc:{start:{line:174,column:12},end:{line:190,column:13}},type:'if',locations:[{start:{line:174,column:12},end:{line:190,column:13}},{start:{line:174,column:12},end:{line:190,column:13}}],line:174},'13':{loc:{start:{line:192,column:13},end:{line:210,column:9}},type:'if',locations:[{start:{line:192,column:13},end:{line:210,column:9}},{start:{line:192,column:13},end:{line:210,column:9}}],line:192},'14':{loc:{start:{line:192,column:17},end:{line:192,column:115}},type:'binary-expr',locations:[{start:{line:192,column:17},end:{line:192,column:81}},{start:{line:192,column:85},end:{line:192,column:115}}],line:192},'15':{loc:{start:{line:193,column:12},end:{line:209,column:13}},type:'if',locations:[{start:{line:193,column:12},end:{line:209,column:13}},{start:{line:193,column:12},end:{line:209,column:13}}],line:193},'16':{loc:{start:{line:212,column:8},end:{line:238,column:9}},type:'if',locations:[{start:{line:212,column:8},end:{line:238,column:9}},{start:{line:212,column:8},end:{line:238,column:9}}],line:212},'17':{loc:{start:{line:212,column:11},end:{line:212,column:135}},type:'binary-expr',locations:[{start:{line:212,column:11},end:{line:212,column:79}},{start:{line:212,column:83},end:{line:212,column:135}}],line:212},'18':{loc:{start:{line:242,column:5},end:{line:259,column:3}},type:'if',locations:[{start:{line:242,column:5},end:{line:259,column:3}},{start:{line:242,column:5},end:{line:259,column:3}}],line:242},'19':{loc:{start:{line:249,column:22},end:{line:249,column:131}},type:'cond-expr',locations:[{start:{line:249,column:78},end:{line:249,column:127}},{start:{line:249,column:130},end:{line:249,column:131}}],line:249},'20':{loc:{start:{line:264,column:8},end:{line:278,column:9}},type:'if',locations:[{start:{line:264,column:8},end:{line:278,column:9}},{start:{line:264,column:8},end:{line:278,column:9}}],line:264},'21':{loc:{start:{line:265,column:12},end:{line:274,column:13}},type:'if',locations:[{start:{line:265,column:12},end:{line:274,column:13}},{start:{line:265,column:12},end:{line:274,column:13}}],line:265},'22':{loc:{start:{line:265,column:15},end:{line:265,column:87}},type:'binary-expr',locations:[{start:{line:265,column:15},end:{line:265,column:48}},{start:{line:265,column:52},end:{line:265,column:87}}],line:265},'23':{loc:{start:{line:298,column:8},end:{line:300,column:9}},type:'if',locations:[{start:{line:298,column:8},end:{line:300,column:9}},{start:{line:298,column:8},end:{line:300,column:9}}],line:298},'24':{loc:{start:{line:302,column:8},end:{line:304,column:9}},type:'if',locations:[{start:{line:302,column:8},end:{line:304,column:9}},{start:{line:302,column:8},end:{line:304,column:9}}],line:302},'25':{loc:{start:{line:307,column:8},end:{line:309,column:9}},type:'if',locations:[{start:{line:307,column:8},end:{line:309,column:9}},{start:{line:307,column:8},end:{line:309,column:9}}],line:307},'26':{loc:{start:{line:313,column:8},end:{line:345,column:9}},type:'if',locations:[{start:{line:313,column:8},end:{line:345,column:9}},{start:{line:313,column:8},end:{line:345,column:9}}],line:313},'27':{loc:{start:{line:314,column:12},end:{line:341,column:13}},type:'if',locations:[{start:{line:314,column:12},end:{line:341,column:13}},{start:{line:314,column:12},end:{line:341,column:13}}],line:314},'28':{loc:{start:{line:343,column:13},end:{line:345,column:9}},type:'if',locations:[{start:{line:343,column:13},end:{line:345,column:9}},{start:{line:343,column:13},end:{line:345,column:9}}],line:343},'29':{loc:{start:{line:353,column:20},end:{line:353,column:123}},type:'cond-expr',locations:[{start:{line:353,column:80},end:{line:353,column:119}},{start:{line:353,column:122},end:{line:353,column:123}}],line:353},'30':{loc:{start:{line:354,column:20},end:{line:354,column:123}},type:'cond-expr',locations:[{start:{line:354,column:80},end:{line:354,column:119}},{start:{line:354,column:122},end:{line:354,column:123}}],line:354},'31':{loc:{start:{line:355,column:22},end:{line:355,column:129}},type:'cond-expr',locations:[{start:{line:355,column:84},end:{line:355,column:125}},{start:{line:355,column:128},end:{line:355,column:129}}],line:355},'32':{loc:{start:{line:356,column:20},end:{line:356,column:123}},type:'cond-expr',locations:[{start:{line:356,column:80},end:{line:356,column:119}},{start:{line:356,column:122},end:{line:356,column:123}}],line:356},'33':{loc:{start:{line:357,column:27},end:{line:357,column:144}},type:'cond-expr',locations:[{start:{line:357,column:94},end:{line:357,column:140}},{start:{line:357,column:143},end:{line:357,column:144}}],line:357},'34':{loc:{start:{line:358,column:19},end:{line:358,column:120}},type:'cond-expr',locations:[{start:{line:358,column:78},end:{line:358,column:116}},{start:{line:358,column:119},end:{line:358,column:120}}],line:358},'35':{loc:{start:{line:359,column:26},end:{line:359,column:141}},type:'cond-expr',locations:[{start:{line:359,column:92},end:{line:359,column:137}},{start:{line:359,column:140},end:{line:359,column:141}}],line:359},'36':{loc:{start:{line:360,column:30},end:{line:360,column:153}},type:'cond-expr',locations:[{start:{line:360,column:100},end:{line:360,column:149}},{start:{line:360,column:152},end:{line:360,column:153}}],line:360},'37':{loc:{start:{line:361,column:21},end:{line:361,column:126}},type:'cond-expr',locations:[{start:{line:361,column:82},end:{line:361,column:122}},{start:{line:361,column:125},end:{line:361,column:126}}],line:361},'38':{loc:{start:{line:362,column:24},end:{line:362,column:139}},type:'cond-expr',locations:[{start:{line:362,column:87},end:{line:362,column:135}},{start:{line:362,column:138},end:{line:362,column:139}}],line:362},'39':{loc:{start:{line:365,column:8},end:{line:423,column:9}},type:'if',locations:[{start:{line:365,column:8},end:{line:423,column:9}},{start:{line:365,column:8},end:{line:423,column:9}}],line:365},'40':{loc:{start:{line:377,column:14},end:{line:423,column:9}},type:'if',locations:[{start:{line:377,column:14},end:{line:423,column:9}},{start:{line:377,column:14},end:{line:423,column:9}}],line:377},'41':{loc:{start:{line:381,column:20},end:{line:401,column:21}},type:'if',locations:[{start:{line:381,column:20},end:{line:401,column:21}},{start:{line:381,column:20},end:{line:401,column:21}}],line:381},'42':{loc:{start:{line:405,column:13},end:{line:423,column:9}},type:'if',locations:[{start:{line:405,column:13},end:{line:423,column:9}},{start:{line:405,column:13},end:{line:423,column:9}}],line:405},'43':{loc:{start:{line:409,column:20},end:{line:420,column:21}},type:'if',locations:[{start:{line:409,column:20},end:{line:420,column:21}},{start:{line:409,column:20},end:{line:420,column:21}}],line:409},'44':{loc:{start:{line:428,column:8},end:{line:430,column:9}},type:'if',locations:[{start:{line:428,column:8},end:{line:430,column:9}},{start:{line:428,column:8},end:{line:430,column:9}}],line:428},'45':{loc:{start:{line:433,column:17},end:{line:666,column:5}},type:'cond-expr',locations:[{start:{line:433,column:49},end:{line:433,column:108}},{start:{line:434,column:5},end:{line:665,column:23}}],line:433},'46':{loc:{start:{line:436,column:23},end:{line:447,column:30}},type:'cond-expr',locations:[{start:{line:437,column:16},end:{line:446,column:38}},{start:{line:447,column:26},end:{line:447,column:30}}],line:436},'47':{loc:{start:{line:448,column:23},end:{line:558,column:30}},type:'cond-expr',locations:[{start:{line:449,column:16},end:{line:557,column:26}},{start:{line:558,column:26},end:{line:558,column:30}}],line:448},'48':{loc:{start:{line:452,column:33},end:{line:452,column:107}},type:'cond-expr',locations:[{start:{line:452,column:68},end:{line:452,column:100}},{start:{line:452,column:103},end:{line:452,column:107}}],line:452},'49':{loc:{start:{line:453,column:31},end:{line:453,column:109}},type:'cond-expr',locations:[{start:{line:453,column:68},end:{line:453,column:102}},{start:{line:453,column:105},end:{line:453,column:109}}],line:453},'50':{loc:{start:{line:467,column:33},end:{line:467,column:115}},type:'cond-expr',locations:[{start:{line:467,column:72},end:{line:467,column:108}},{start:{line:467,column:111},end:{line:467,column:115}}],line:467},'51':{loc:{start:{line:468,column:31},end:{line:468,column:117}},type:'cond-expr',locations:[{start:{line:468,column:72},end:{line:468,column:110}},{start:{line:468,column:113},end:{line:468,column:117}}],line:468},'52':{loc:{start:{line:486,column:34},end:{line:486,column:112}},type:'cond-expr',locations:[{start:{line:486,column:71},end:{line:486,column:105}},{start:{line:486,column:108},end:{line:486,column:112}}],line:486},'53':{loc:{start:{line:487,column:32},end:{line:487,column:114}},type:'cond-expr',locations:[{start:{line:487,column:71},end:{line:487,column:107}},{start:{line:487,column:110},end:{line:487,column:114}}],line:487},'54':{loc:{start:{line:504,column:34},end:{line:504,column:126}},type:'cond-expr',locations:[{start:{line:504,column:78},end:{line:504,column:119}},{start:{line:504,column:122},end:{line:504,column:126}}],line:504},'55':{loc:{start:{line:505,column:32},end:{line:505,column:128}},type:'cond-expr',locations:[{start:{line:505,column:78},end:{line:505,column:121}},{start:{line:505,column:124},end:{line:505,column:128}}],line:505},'56':{loc:{start:{line:522,column:34},end:{line:522,column:110}},type:'cond-expr',locations:[{start:{line:522,column:70},end:{line:522,column:103}},{start:{line:522,column:106},end:{line:522,column:110}}],line:522},'57':{loc:{start:{line:523,column:32},end:{line:523,column:112}},type:'cond-expr',locations:[{start:{line:523,column:70},end:{line:523,column:105}},{start:{line:523,column:108},end:{line:523,column:112}}],line:523},'58':{loc:{start:{line:540,column:34},end:{line:540,column:124}},type:'cond-expr',locations:[{start:{line:540,column:77},end:{line:540,column:117}},{start:{line:540,column:120},end:{line:540,column:124}}],line:540},'59':{loc:{start:{line:541,column:32},end:{line:541,column:126}},type:'cond-expr',locations:[{start:{line:541,column:77},end:{line:541,column:119}},{start:{line:541,column:122},end:{line:541,column:126}}],line:541},'60':{loc:{start:{line:559,column:8},end:{line:659,column:30}},type:'cond-expr',locations:[{start:{line:560,column:16},end:{line:658,column:26}},{start:{line:659,column:26},end:{line:659,column:30}}],line:559},'61':{loc:{start:{line:565,column:34},end:{line:565,column:112}},type:'cond-expr',locations:[{start:{line:565,column:71},end:{line:565,column:105}},{start:{line:565,column:108},end:{line:565,column:112}}],line:565},'62':{loc:{start:{line:566,column:32},end:{line:566,column:114}},type:'cond-expr',locations:[{start:{line:566,column:71},end:{line:566,column:107}},{start:{line:566,column:110},end:{line:566,column:114}}],line:566},'63':{loc:{start:{line:583,column:34},end:{line:583,column:112}},type:'cond-expr',locations:[{start:{line:583,column:71},end:{line:583,column:105}},{start:{line:583,column:108},end:{line:583,column:112}}],line:583},'64':{loc:{start:{line:584,column:32},end:{line:584,column:114}},type:'cond-expr',locations:[{start:{line:584,column:71},end:{line:584,column:107}},{start:{line:584,column:110},end:{line:584,column:114}}],line:584},'65':{loc:{start:{line:602,column:34},end:{line:602,column:114}},type:'cond-expr',locations:[{start:{line:602,column:72},end:{line:602,column:107}},{start:{line:602,column:110},end:{line:602,column:114}}],line:602},'66':{loc:{start:{line:603,column:32},end:{line:603,column:116}},type:'cond-expr',locations:[{start:{line:603,column:72},end:{line:603,column:109}},{start:{line:603,column:112},end:{line:603,column:116}}],line:603},'67':{loc:{start:{line:621,column:34},end:{line:621,column:132}},type:'cond-expr',locations:[{start:{line:621,column:81},end:{line:621,column:125}},{start:{line:621,column:128},end:{line:621,column:132}}],line:621},'68':{loc:{start:{line:622,column:32},end:{line:622,column:134}},type:'cond-expr',locations:[{start:{line:622,column:81},end:{line:622,column:127}},{start:{line:622,column:130},end:{line:622,column:134}}],line:622},'69':{loc:{start:{line:639,column:55},end:{line:639,column:141}},type:'cond-expr',locations:[{start:{line:639,column:96},end:{line:639,column:134}},{start:{line:639,column:137},end:{line:639,column:141}}],line:639},'70':{loc:{start:{line:640,column:53},end:{line:640,column:143}},type:'cond-expr',locations:[{start:{line:640,column:96},end:{line:640,column:136}},{start:{line:640,column:139},end:{line:640,column:143}}],line:640}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0,'115':0,'116':0,'117':0,'118':0,'119':0,'120':0,'121':0,'122':0,'123':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0],'48':[0,0],'49':[0,0],'50':[0,0],'51':[0,0],'52':[0,0],'53':[0,0],'54':[0,0],'55':[0,0],'56':[0,0],'57':[0,0],'58':[0,0],'59':[0,0],'60':[0,0],'61':[0,0],'62':[0,0],'63':[0,0],'64':[0,0],'65':[0,0],'66':[0,0],'67':[0,0],'68':[0,0],'69':[0,0],'70':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JobsNewPage=function(_ref){_inherits(JobsNewPage,_ref);function JobsNewPage(props){_classCallCheck(this,JobsNewPage);cov_u3teeoaa1.f[0]++;cov_u3teeoaa1.s[0]++;var _this=_possibleConstructorReturn(this,(JobsNewPage.__proto__||Object.getPrototypeOf(JobsNewPage)).call(this,props));_this.defaultFormState={name:{state:false,message:false},orders:{state:false,message:false},pieces:{state:false,message:false},stitches:{state:false,message:false},colors:{state:false,message:false},color_changes:{state:false,message:false},trims:{state:false,message:false},cone_changes:{state:false,message:false},garment_handling:{state:false,message:false},hooping:{state:false,message:false},other_work:{state:false,message:false}};_this.defaultMessageState={show:false,message:null};_this.componentDidMount=function(){cov_u3teeoaa1.f[1]++;cov_u3teeoaa1.s[2]++;_this.props.onFetchJobsDefaults();};_this.componentWillUnmount=function(){cov_u3teeoaa1.f[2]++;cov_u3teeoaa1.s[3]++;_this.props.onResetJob();cov_u3teeoaa1.s[4]++;_this.props.onCalculatorJobDuplicateCheckReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_u3teeoaa1.f[3]++;cov_u3teeoaa1.s[5]++;if(prevProps.calculatorJobsDefaults!==_this.props.calculatorJobsDefaults){cov_u3teeoaa1.b[0][0]++;cov_u3teeoaa1.s[6]++;_this.defaultValueHandler();}else{cov_u3teeoaa1.b[0][1]++;}cov_u3teeoaa1.s[7]++;if(prevProps.defaults!==_this.props.defaults){cov_u3teeoaa1.b[1][0]++;cov_u3teeoaa1.s[8]++;_this.setState(function(prevState){cov_u3teeoaa1.f[4]++;cov_u3teeoaa1.s[9]++;return{wizard:Object.assign({},prevState.wizard,{steps:[{name:_this.props.translate('jobnewpage.step_1.name'),active:true},{name:_this.props.translate('jobnewpage.step_2.name'),active:false},{name:_this.props.translate('jobnewpage.step_3.name'),active:false}]})};});}else{cov_u3teeoaa1.b[1][1]++;}//Duplicate Check
cov_u3teeoaa1.s[10]++;if((cov_u3teeoaa1.b[3][0]++,!prevProps.state.job.name_checked)&&(cov_u3teeoaa1.b[3][1]++,_this.props.state.job.name_checked)){cov_u3teeoaa1.b[2][0]++;cov_u3teeoaa1.s[11]++;_this.setState(function(prevState){cov_u3teeoaa1.f[5]++;cov_u3teeoaa1.s[12]++;return{form_blocked:!_this.props.state.job.name_available?(cov_u3teeoaa1.b[4][0]++,true):(cov_u3teeoaa1.b[4][1]++,false),form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:_this.props.state.job.name_available?(cov_u3teeoaa1.b[5][0]++,'success'):(cov_u3teeoaa1.b[5][1]++,'error'),message:!_this.props.state.job.name_available?(cov_u3teeoaa1.b[6][0]++,_this.props.translate('jobnewpage.error.name_exists')):(cov_u3teeoaa1.b[6][1]++,null)})})};});cov_u3teeoaa1.s[13]++;if(_this.state.willSubmit){cov_u3teeoaa1.b[7][0]++;cov_u3teeoaa1.s[14]++;_this.setState(function(prevState){cov_u3teeoaa1.f[6]++;cov_u3teeoaa1.s[15]++;return{willSubmit:false};},function(){cov_u3teeoaa1.f[7]++;cov_u3teeoaa1.s[16]++;if(_this.props.state.job.name_available){cov_u3teeoaa1.b[8][0]++;cov_u3teeoaa1.s[17]++;_this.submitHandler();}else{cov_u3teeoaa1.b[8][1]++;}});}else{cov_u3teeoaa1.b[7][1]++;}}else{cov_u3teeoaa1.b[2][1]++;}// Errors
cov_u3teeoaa1.s[18]++;if(prevProps.state.job.error!==_this.props.state.job.error){cov_u3teeoaa1.b[9][0]++;cov_u3teeoaa1.s[19]++;if(_this.props.state.job.error.length){cov_u3teeoaa1.b[10][0]++;cov_u3teeoaa1.s[20]++;_this.setState(function(prevState){cov_u3teeoaa1.f[8]++;cov_u3teeoaa1.s[21]++;return{form_state:_this.defaultFormState};},function(){cov_u3teeoaa1.f[9]++;cov_u3teeoaa1.s[22]++;_this.props.state.job.error.forEach(function(error,index){cov_u3teeoaa1.f[10]++;cov_u3teeoaa1.s[23]++;if(_this.state.form_state[error.source]){cov_u3teeoaa1.b[11][0]++;cov_u3teeoaa1.s[24]++;_this.setState(function(prevState){cov_u3teeoaa1.f[11]++;cov_u3teeoaa1.s[25]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))};});}else{cov_u3teeoaa1.b[11][1]++;}});});}else{cov_u3teeoaa1.b[10][1]++;}cov_u3teeoaa1.s[26]++;if(_this.props.state.job.error.length===1){cov_u3teeoaa1.b[12][0]++;cov_u3teeoaa1.s[27]++;_this.setState(function(prevState){cov_u3teeoaa1.f[12]++;cov_u3teeoaa1.s[28]++;return{message:{message:_this.props.translate('jobnewpage.error.'+_this.props.state.job.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('jobnewpage.error.default')}),type:"error"}};});}else{cov_u3teeoaa1.b[12][1]++;cov_u3teeoaa1.s[29]++;_this.setState(function(prevState){cov_u3teeoaa1.f[13]++;cov_u3teeoaa1.s[30]++;return{message:{message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}}else{cov_u3teeoaa1.b[9][1]++;cov_u3teeoaa1.s[31]++;if((cov_u3teeoaa1.b[14][0]++,prevProps.helpersDesign.error!==_this.props.helpersDesign.error)&&(cov_u3teeoaa1.b[14][1]++,_this.props.helpersDesign.error)){cov_u3teeoaa1.b[13][0]++;cov_u3teeoaa1.s[32]++;if(_this.props.helpersDesign.error.length===1){cov_u3teeoaa1.b[15][0]++;cov_u3teeoaa1.s[33]++;_this.setState(function(prevState){cov_u3teeoaa1.f[14]++;cov_u3teeoaa1.s[34]++;return{message:{message:_this.props.translate('jobnewpage.error.'+_this.props.helpersDesign.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('jobnewpage.error.designupload')}),type:"error"}};});}else{cov_u3teeoaa1.b[15][1]++;cov_u3teeoaa1.s[35]++;_this.setState(function(prevState){cov_u3teeoaa1.f[15]++;cov_u3teeoaa1.s[36]++;return{message:{message:_this.props.translate('jobnewpage.error.designupload'),type:"error"}};});}}else{cov_u3teeoaa1.b[13][1]++;}}//Design upload
cov_u3teeoaa1.s[37]++;if((cov_u3teeoaa1.b[17][0]++,prevProps.helpersDesign.details!==_this.props.helpersDesign.details)&&(cov_u3teeoaa1.b[17][1]++,Object.keys(_this.props.helpersDesign.details).length)){cov_u3teeoaa1.b[16][0]++;var steps=(cov_u3teeoaa1.s[38]++,[].concat(_toConsumableArray(_this.state.wizard.steps)));cov_u3teeoaa1.s[39]++;steps[2].active=false;cov_u3teeoaa1.s[40]++;steps[1].active=true;cov_u3teeoaa1.s[41]++;steps[0].active=false;cov_u3teeoaa1.s[42]++;_this.setState(function(prevState){cov_u3teeoaa1.f[16]++;cov_u3teeoaa1.s[43]++;return{wizard:Object.assign({},prevState.wizard,{steps:steps}),message:{message:_this.props.translate('jobnewpage.success.designupload'),type:"success"},form:Object.assign({},prevState.form,{name:_this.props.helpersDesign.details.name.substr(0,50),colors:_this.props.helpersDesign.details.colors,stitches:_this.props.helpersDesign.details.stitches,trims:_this.props.helpersDesign.details.trims,color_changes:_this.props.helpersDesign.details.color_changes})};},function(){cov_u3teeoaa1.f[17]++;cov_u3teeoaa1.s[44]++;_this.props.onCalculatorJobDuplicateCheck({name:_this.props.helpersDesign.details.name.substr(0,50)});cov_u3teeoaa1.s[45]++;__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});}else{cov_u3teeoaa1.b[16][1]++;}};_this.defaultValueHandler=function(event){cov_u3teeoaa1.f[18]++;cov_u3teeoaa1.s[46]++;if(_this.props.calculatorJobsDefaults.defaults){cov_u3teeoaa1.b[18][0]++;cov_u3teeoaa1.s[47]++;_this.setState(function(prevState){cov_u3teeoaa1.f[19]++;cov_u3teeoaa1.s[48]++;return{form:Object.assign({},prevState.form,{orders:_this.props.calculatorJobsDefaults.defaults.orders,pieces:_this.props.calculatorJobsDefaults.defaults.pieces,stitches:_this.props.calculatorJobsDefaults.defaults.stitches,colors:_this.props.calculatorJobsDefaults.defaults.colors>0?(cov_u3teeoaa1.b[19][0]++,_this.props.calculatorJobsDefaults.defaults.colors):(cov_u3teeoaa1.b[19][1]++,1),color_changes:_this.props.calculatorJobsDefaults.defaults.color_changes,trims:_this.props.calculatorJobsDefaults.defaults.trims,cone_changes:_this.props.calculatorJobsDefaults.defaults.cone_changes,garment_handling:_this.props.calculatorJobsDefaults.defaults.garment_handling,hooping:_this.props.calculatorJobsDefaults.defaults.hooping,other_work:_this.props.calculatorJobsDefaults.defaults.other_work/60})};});}else{cov_u3teeoaa1.b[18][1]++;}};_this.newJobHandler=function(event){cov_u3teeoaa1.f[20]++;cov_u3teeoaa1.s[49]++;event.preventDefault();cov_u3teeoaa1.s[50]++;if(_this.state.wizard.steps[1].active){cov_u3teeoaa1.b[20][0]++;cov_u3teeoaa1.s[51]++;if((cov_u3teeoaa1.b[22][0]++,_this.props.state.job.name_checked)&&(cov_u3teeoaa1.b[22][1]++,_this.props.state.job.name_available)){cov_u3teeoaa1.b[21][0]++;cov_u3teeoaa1.s[52]++;_this.submitHandler();}else{cov_u3teeoaa1.b[21][1]++;cov_u3teeoaa1.s[53]++;_this.setState(function(prevState){cov_u3teeoaa1.f[21]++;cov_u3teeoaa1.s[54]++;return{willSubmit:true};},function(){cov_u3teeoaa1.f[22]++;cov_u3teeoaa1.s[55]++;_this.duplicateCheckHandler();});}}else{cov_u3teeoaa1.b[20][1]++;cov_u3teeoaa1.s[56]++;_this.submitHandler();}};_this.designuploadChanged=function(event,inputIdentifier){cov_u3teeoaa1.f[23]++;var formData=(cov_u3teeoaa1.s[57]++,new FormData());cov_u3teeoaa1.s[58]++;formData.append('file',event.target.files[0]);cov_u3teeoaa1.s[59]++;_this.props.onHelpersDesignUpload(formData);};_this.inputChangedHandler=function(event,inputIdentifier){cov_u3teeoaa1.f[24]++;var value=(cov_u3teeoaa1.s[60]++,event.target.value);cov_u3teeoaa1.s[61]++;_this.setState(function(prevState){cov_u3teeoaa1.f[25]++;cov_u3teeoaa1.s[62]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputBlurredHandler=function(event,inputIdentifier){cov_u3teeoaa1.f[26]++;cov_u3teeoaa1.s[63]++;if(inputIdentifier==='name'){cov_u3teeoaa1.b[23][0]++;cov_u3teeoaa1.s[64]++;_this.duplicateCheckHandler();}else{cov_u3teeoaa1.b[23][1]++;}cov_u3teeoaa1.s[65]++;__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier]]);cov_u3teeoaa1.s[66]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_u3teeoaa1.b[24][0]++;cov_u3teeoaa1.s[67]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_u3teeoaa1.b[24][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_u3teeoaa1.f[27]++;cov_u3teeoaa1.s[68]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_u3teeoaa1.b[25][0]++;cov_u3teeoaa1.s[69]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_u3teeoaa1.b[25][1]++;}};_this.duplicateCheckHandler=function(){cov_u3teeoaa1.f[28]++;cov_u3teeoaa1.s[70]++;if(_this.state.wizard.steps[1].active){cov_u3teeoaa1.b[26][0]++;cov_u3teeoaa1.s[71]++;if(_this.refs.name.props.value.length){cov_u3teeoaa1.b[27][0]++;cov_u3teeoaa1.s[72]++;_this.setState(function(prevState){cov_u3teeoaa1.f[29]++;cov_u3teeoaa1.s[73]++;return{form_blocked:true,form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:'loading'})})};},function(){cov_u3teeoaa1.f[30]++;cov_u3teeoaa1.s[74]++;_this.props.onCalculatorJobDuplicateCheck({name:_this.refs.name.props.value});});}else{cov_u3teeoaa1.b[27][1]++;cov_u3teeoaa1.s[75]++;_this.setState(function(prevState){cov_u3teeoaa1.f[31]++;cov_u3teeoaa1.s[76]++;return{form_blocked:false,form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:false})})};},function(){cov_u3teeoaa1.f[32]++;cov_u3teeoaa1.s[77]++;_this.submitHandler();});}}else{cov_u3teeoaa1.b[26][1]++;cov_u3teeoaa1.s[78]++;if(_this.state.willSubmit){cov_u3teeoaa1.b[28][0]++;cov_u3teeoaa1.s[79]++;_this.submitHandler();}else{cov_u3teeoaa1.b[28][1]++;}}};_this.submitHandler=function(){cov_u3teeoaa1.f[33]++;cov_u3teeoaa1.s[80]++;_this.setState(function(prevState){cov_u3teeoaa1.f[34]++;cov_u3teeoaa1.s[81]++;return{message:_this.defaultMessageState};});var formData=(cov_u3teeoaa1.s[82]++,{name:_this.state.form.name,orders:Number.isInteger(Number.parseInt(_this.state.form.orders))?(cov_u3teeoaa1.b[29][0]++,Number.parseInt(_this.state.form.orders)):(cov_u3teeoaa1.b[29][1]++,0),pieces:Number.isInteger(Number.parseInt(_this.state.form.pieces))?(cov_u3teeoaa1.b[30][0]++,Number.parseInt(_this.state.form.pieces)):(cov_u3teeoaa1.b[30][1]++,0),stitches:Number.isInteger(Number.parseInt(_this.state.form.stitches))?(cov_u3teeoaa1.b[31][0]++,Number.parseInt(_this.state.form.stitches)):(cov_u3teeoaa1.b[31][1]++,0),colors:Number.isInteger(Number.parseInt(_this.state.form.colors))?(cov_u3teeoaa1.b[32][0]++,Number.parseInt(_this.state.form.colors)):(cov_u3teeoaa1.b[32][1]++,0),color_changes:Number.isInteger(Number.parseInt(_this.state.form.color_changes))?(cov_u3teeoaa1.b[33][0]++,Number.parseInt(_this.state.form.color_changes)):(cov_u3teeoaa1.b[33][1]++,0),trims:Number.isInteger(Number.parseInt(_this.state.form.trims))?(cov_u3teeoaa1.b[34][0]++,Number.parseInt(_this.state.form.trims)):(cov_u3teeoaa1.b[34][1]++,0),cone_changes:Number.isInteger(Number.parseInt(_this.state.form.cone_changes))?(cov_u3teeoaa1.b[35][0]++,Number.parseInt(_this.state.form.cone_changes)):(cov_u3teeoaa1.b[35][1]++,0),garment_handling:Number.isInteger(Number.parseInt(_this.state.form.garment_handling))?(cov_u3teeoaa1.b[36][0]++,Number.parseInt(_this.state.form.garment_handling)):(cov_u3teeoaa1.b[36][1]++,0),hooping:Number.isInteger(Number.parseInt(_this.state.form.hooping))?(cov_u3teeoaa1.b[37][0]++,Number.parseInt(_this.state.form.hooping)):(cov_u3teeoaa1.b[37][1]++,0),other_work:!Number.isNaN(Number.parseFloat(_this.state.form.other_work))?(cov_u3teeoaa1.b[38][0]++,Number.parseFloat(_this.state.form.other_work)*60):(cov_u3teeoaa1.b[38][1]++,0)});//Step 1
cov_u3teeoaa1.s[83]++;if(_this.state.wizard.steps[0].active){cov_u3teeoaa1.b[39][0]++;var steps=(cov_u3teeoaa1.s[84]++,[].concat(_toConsumableArray(_this.state.wizard.steps)));cov_u3teeoaa1.s[85]++;steps[2].active=false;cov_u3teeoaa1.s[86]++;steps[1].active=true;cov_u3teeoaa1.s[87]++;steps[0].active=false;cov_u3teeoaa1.s[88]++;_this.setState(function(prevState){cov_u3teeoaa1.f[35]++;cov_u3teeoaa1.s[89]++;return{wizard:Object.assign({},prevState.wizard,{steps:steps})};},function(){cov_u3teeoaa1.f[36]++;cov_u3teeoaa1.s[90]++;return __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});}else{cov_u3teeoaa1.b[39][1]++;cov_u3teeoaa1.s[91]++;if(_this.state.wizard.steps[1].active){cov_u3teeoaa1.b[40][0]++;cov_u3teeoaa1.s[92]++;_this.setState(function(prevState){cov_u3teeoaa1.f[37]++;cov_u3teeoaa1.s[93]++;return{willSubmit:false};},function(){cov_u3teeoaa1.f[38]++;cov_u3teeoaa1.s[94]++;if(__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[['name','stitches','colors','color_changes','trims','cone_changes']])){cov_u3teeoaa1.b[41][0]++;var _steps=(cov_u3teeoaa1.s[95]++,[].concat(_toConsumableArray(_this.state.wizard.steps)));cov_u3teeoaa1.s[96]++;_steps[2].active=true;cov_u3teeoaa1.s[97]++;_steps[1].active=false;cov_u3teeoaa1.s[98]++;_steps[0].active=false;cov_u3teeoaa1.s[99]++;_this.setState(function(prevState){cov_u3teeoaa1.f[39]++;cov_u3teeoaa1.s[100]++;return{wizard:Object.assign({},prevState.wizard,{steps:_steps})};},function(){cov_u3teeoaa1.f[40]++;cov_u3teeoaa1.s[101]++;return __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});}else{cov_u3teeoaa1.b[41][1]++;cov_u3teeoaa1.s[102]++;_this.setState(function(prevState){cov_u3teeoaa1.f[41]++;cov_u3teeoaa1.s[103]++;return{message:{show:true,message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}});}else{cov_u3teeoaa1.b[40][1]++;cov_u3teeoaa1.s[104]++;if(_this.state.wizard.steps[2].active){cov_u3teeoaa1.b[42][0]++;cov_u3teeoaa1.s[105]++;_this.setState(function(prevState){cov_u3teeoaa1.f[42]++;cov_u3teeoaa1.s[106]++;return{willSubmit:false};},function(){cov_u3teeoaa1.f[43]++;cov_u3teeoaa1.s[107]++;if(__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[['orders','pieces','hooping','other_work','garment_handling']])){cov_u3teeoaa1.b[43][0]++;cov_u3teeoaa1.s[108]++;_this.props.onCreateJob(formData);}else{cov_u3teeoaa1.b[43][1]++;cov_u3teeoaa1.s[109]++;_this.setState(function(prevState){cov_u3teeoaa1.f[44]++;cov_u3teeoaa1.s[110]++;return{message:{show:true,message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}});}else{cov_u3teeoaa1.b[42][1]++;}}}};cov_u3teeoaa1.s[1]++;_this.state={form:{name:"",orders:0,pieces:0,stitches:0,colors:0,color_changes:0,trims:0,cone_changes:0,garment_handling:0,hooping:0,other_work:0},form_state:_this.defaultFormState,message:_this.defaultMessageState,form_blocked:false,willSubmit:false,wizard:{steps:[{name:_this.props.translate('jobnewpage.step_1.name'),active:true},{name:_this.props.translate('jobnewpage.step_2.name'),active:false},{name:_this.props.translate('jobnewpage.step_3.name'),active:false}]}};return _this;}_createClass(JobsNewPage,[{key:'render',value:function render(){cov_u3teeoaa1.f[45]++;var showMessage;cov_u3teeoaa1.s[111]++;if(this.state.message.message){cov_u3teeoaa1.b[44][0]++;cov_u3teeoaa1.s[112]++;showMessage=this.state.message;}else{cov_u3teeoaa1.b[44][1]++;}cov_u3teeoaa1.s[113]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hoc_Aux__["a" /* default */],null,this.props.state.job.created?(cov_u3teeoaa1.b[45][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/jobs/'+this.props.state.job.details.Id})):(cov_u3teeoaa1.b[45][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Form"],{onSubmit:this.newJobHandler},this.state.wizard.steps[0].active?(cov_u3teeoaa1.b[46][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{title:this.props.translate('jobnewpage.title'),msg:showMessage,steps:this.state.wizard.steps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{col:'100*47'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["UploadButton"],{multiline:'true',label:this.props.translate('jobnewpage.step_1.upload'),identifier:'designupload',changed:this.designuploadChanged,nomargin:'true',accept:'.dst,.ofm,.exp'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["FlexColumn"],{col:'100*47'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{multiline:'true',nomarginmobile:'true',value:this.props.translate('jobnewpage.step_1.manual'),type:'submit',nomargin:'true'}))))):(cov_u3teeoaa1.b[46][1]++,null),this.state.wizard.steps[1].active?(cov_u3teeoaa1.b[47][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{title:this.props.translate('jobnewpage.title'),msg:showMessage,steps:this.state.wizard.steps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.name'),ref:'nameInputRow',state:this.state.form_state.name.state?(cov_u3teeoaa1.b[48][0]++,this.state.form_state.name.state):(cov_u3teeoaa1.b[48][1]++,null),tip:this.state.form_state.name.message?(cov_u3teeoaa1.b[49][0]++,this.state.form_state.name.message):(cov_u3teeoaa1.b[49][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'name',ref:'name',type:'text',value:this.state.form.name,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,maxlength:50,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.stitches'),ref:'stitchesInputRow',state:this.state.form_state.stitches.state?(cov_u3teeoaa1.b[50][0]++,this.state.form_state.stitches.state):(cov_u3teeoaa1.b[50][1]++,null),tip:this.state.form_state.stitches.message?(cov_u3teeoaa1.b[51][0]++,this.state.form_state.stitches.message):(cov_u3teeoaa1.b[51][1]++,null),hint:this.props.translate('global.help.job.stitches')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'stitches',ref:'stitches',type:'number',minValue:1,maxValue:999999,value:this.state.form.stitches,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.colors'),cols:'2',ref:'colorsInputRow',state:this.state.form_state.colors.state?(cov_u3teeoaa1.b[52][0]++,this.state.form_state.colors.state):(cov_u3teeoaa1.b[52][1]++,null),tip:this.state.form_state.colors.message?(cov_u3teeoaa1.b[53][0]++,this.state.form_state.colors.message):(cov_u3teeoaa1.b[53][1]++,null),hint:this.props.translate('global.help.job.colors')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'colors',ref:'colors',type:'number',minValue:1,maxValue:999,value:this.state.form.colors,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.color_changes'),cols:'2',ref:'color_changesInputRow',state:this.state.form_state.color_changes.state?(cov_u3teeoaa1.b[54][0]++,this.state.form_state.color_changes.state):(cov_u3teeoaa1.b[54][1]++,null),tip:this.state.form_state.color_changes.message?(cov_u3teeoaa1.b[55][0]++,this.state.form_state.color_changes.message):(cov_u3teeoaa1.b[55][1]++,null),hint:this.props.translate('global.help.job.color_changes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'color_changes',ref:'color_changes',type:'number',minValue:0,maxValue:999,value:this.state.form.color_changes,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.trims'),cols:'2',ref:'trimsInputRow',state:this.state.form_state.trims.state?(cov_u3teeoaa1.b[56][0]++,this.state.form_state.trims.state):(cov_u3teeoaa1.b[56][1]++,null),tip:this.state.form_state.trims.message?(cov_u3teeoaa1.b[57][0]++,this.state.form_state.trims.message):(cov_u3teeoaa1.b[57][1]++,null),hint:this.props.translate('global.help.job.trims')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'trims',ref:'trims',type:'number',minValue:0,maxValue:999,value:this.state.form.trims,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.cone_changes'),cols:'2',ref:'cone_changesInputRow',state:this.state.form_state.cone_changes.state?(cov_u3teeoaa1.b[58][0]++,this.state.form_state.cone_changes.state):(cov_u3teeoaa1.b[58][1]++,null),tip:this.state.form_state.cone_changes.message?(cov_u3teeoaa1.b[59][0]++,this.state.form_state.cone_changes.message):(cov_u3teeoaa1.b[59][1]++,null),hint:this.props.translate('global.help.job.cone_changes')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'cone_changes',ref:'cone_changes',type:'number',minValue:0,maxValue:99,value:this.state.form.cone_changes,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{value:this.props.translate('jobnewpage.step_2.submit'),type:'submit'}))):(cov_u3teeoaa1.b[47][1]++,null),this.state.wizard.steps[2].active?(cov_u3teeoaa1.b[60][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{title:this.props.translate('jobnewpage.title'),msg:showMessage,steps:this.state.wizard.steps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.orders'),cols:'2',ref:'ordersInputRow',state:this.state.form_state.orders.state?(cov_u3teeoaa1.b[61][0]++,this.state.form_state.orders.state):(cov_u3teeoaa1.b[61][1]++,null),tip:this.state.form_state.orders.message?(cov_u3teeoaa1.b[62][0]++,this.state.form_state.orders.message):(cov_u3teeoaa1.b[62][1]++,null),hint:this.props.translate('global.help.job.orders')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'orders',ref:'orders',type:'number',minValue:1,maxValue:999999,value:this.state.form.orders,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.pieces'),cols:'2',ref:'piecesInputRow',state:this.state.form_state.pieces.state?(cov_u3teeoaa1.b[63][0]++,this.state.form_state.pieces.state):(cov_u3teeoaa1.b[63][1]++,null),tip:this.state.form_state.pieces.message?(cov_u3teeoaa1.b[64][0]++,this.state.form_state.pieces.message):(cov_u3teeoaa1.b[64][1]++,null),hint:this.props.translate('global.help.job.pieces')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'pieces',ref:'pieces',type:'number',minValue:1,maxValue:99999,value:this.state.form.pieces,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.hooping'),cols:'2',unit:this.props.translate('global.units.seconds'),ref:'hoopingInputRow',state:this.state.form_state.hooping.state?(cov_u3teeoaa1.b[65][0]++,this.state.form_state.hooping.state):(cov_u3teeoaa1.b[65][1]++,null),tip:this.state.form_state.hooping.message?(cov_u3teeoaa1.b[66][0]++,this.state.form_state.hooping.message):(cov_u3teeoaa1.b[66][1]++,null),hint:this.props.translate('global.help.job.hooping')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'hooping',ref:'hooping',type:'number',minValue:0,maxValue:1200,value:this.state.form.hooping,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.garment_handling'),cols:'2',unit:this.props.translate('global.units.seconds'),ref:'garment_handlingInputRow',state:this.state.form_state.garment_handling.state?(cov_u3teeoaa1.b[67][0]++,this.state.form_state.garment_handling.state):(cov_u3teeoaa1.b[67][1]++,null),tip:this.state.form_state.garment_handling.message?(cov_u3teeoaa1.b[68][0]++,this.state.form_state.garment_handling.message):(cov_u3teeoaa1.b[68][1]++,null),hint:this.props.translate('global.help.job.garment_handling')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'garment_handling',ref:'garment_handling',type:'number',minValue:0,maxValue:9999,value:this.state.form.garment_handling,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.job.other_work'),unit:this.props.translate('global.units.minutes'),ref:'other_workInputRow',state:this.state.form_state.other_work.state?(cov_u3teeoaa1.b[69][0]++,this.state.form_state.other_work.state):(cov_u3teeoaa1.b[69][1]++,null),tip:this.state.form_state.other_work.message?(cov_u3teeoaa1.b[70][0]++,this.state.form_state.other_work.message):(cov_u3teeoaa1.b[70][1]++,null),hint:this.props.translate('global.help.job.other_work')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'other_work',ref:'other_work',type:'number',minValue:0,maxValue:9999,value:this.state.form.other_work,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any',validationPattern:'^\\d*(\\.\\d{0,1})?$'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{value:this.props.translate('jobnewpage.step_3.submit'),type:'submit'}))):(cov_u3teeoaa1.b[60][1]++,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Box"],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],{size:'small',align:'center'},this.props.translate('jobnewpage.secondary.text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{outerMargin:'true',href:'/jobs',theme:'light',value:this.props.translate('jobnewpage.secondary.label'),width:'320px'}))))));}}]);return JobsNewPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_u3teeoaa1.s[114]++;var mapStateToProps=function mapStateToProps(state){cov_u3teeoaa1.f[46]++;cov_u3teeoaa1.s[115]++;return{defaults:state.defaults,calculatorJobsDefaults:state.calculatorJobsDefaults,state:state.calculatorJob,helpersDesign:state.helpersDesign,translate:Object(__WEBPACK_IMPORTED_MODULE_7_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_u3teeoaa1.s[116]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_u3teeoaa1.f[47]++;cov_u3teeoaa1.s[117]++;return{onHelpersDesignUpload:function onHelpersDesignUpload(formData){cov_u3teeoaa1.f[48]++;cov_u3teeoaa1.s[118]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["W" /* helpersDesignupload */](formData));},onCreateJob:function onCreateJob(formData){cov_u3teeoaa1.f[49]++;cov_u3teeoaa1.s[119]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["g" /* calculatorJobCreate */](formData));},onFetchJobsDefaults:function onFetchJobsDefaults(){cov_u3teeoaa1.f[50]++;cov_u3teeoaa1.s[120]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["B" /* calculatorJobsDefaultsFetch */]());},onResetJob:function onResetJob(){cov_u3teeoaa1.f[51]++;cov_u3teeoaa1.s[121]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["h" /* calculatorJobCreateReset */]());},onCalculatorJobDuplicateCheck:function onCalculatorJobDuplicateCheck(formData){cov_u3teeoaa1.f[52]++;cov_u3teeoaa1.s[122]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["m" /* calculatorJobDuplicateCheck */](formData));},onCalculatorJobDuplicateCheckReset:function onCalculatorJobDuplicateCheckReset(){cov_u3teeoaa1.f[53]++;cov_u3teeoaa1.s[123]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["n" /* calculatorJobDuplicateCheckReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(JobsNewPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components__);
var cov_2e694dwfzq=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobsPage\\index.js',hash='76428ef6af33a909178d46e7239e1cb986d00257',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\JobsPage\\index.js',statementMap:{'0':{start:{line:32,column:2},end:{line:32,column:27}},'1':{start:{line:36,column:2},end:{line:38,column:3}},'2':{start:{line:37,column:3},end:{line:37,column:26}},'3':{start:{line:42,column:20},end:{line:42,column:38}},'4':{start:{line:43,column:5},end:{line:48,column:12}},'5':{start:{line:43,column:33},end:{line:48,column:9}},'6':{start:{line:52,column:2},end:{line:71,column:3}},'7':{start:{line:53,column:28},end:{line:53,column:47}},'8':{start:{line:54,column:4},end:{line:61,column:8}},'9':{start:{line:54,column:34},end:{line:61,column:5}},'10':{start:{line:63,column:4},end:{line:70,column:8}},'11':{start:{line:63,column:34},end:{line:70,column:5}},'12':{start:{line:73,column:2},end:{line:92,column:3}},'13':{start:{line:74,column:27},end:{line:74,column:44}},'14':{start:{line:75,column:4},end:{line:82,column:8}},'15':{start:{line:75,column:34},end:{line:82,column:5}},'16':{start:{line:84,column:4},end:{line:91,column:8}},'17':{start:{line:84,column:34},end:{line:91,column:5}},'18':{start:{line:97,column:5},end:{line:109,column:6}},'19':{start:{line:98,column:23},end:{line:98,column:25}},'20':{start:{line:99,column:6},end:{line:101,column:7}},'21':{start:{line:100,column:7},end:{line:100,column:60}},'22':{start:{line:102,column:6},end:{line:104,column:7}},'23':{start:{line:103,column:7},end:{line:103,column:64}},'24':{start:{line:105,column:6},end:{line:107,column:7}},'25':{start:{line:106,column:7},end:{line:106,column:60}},'26':{start:{line:108,column:6},end:{line:108,column:41}},'27':{start:{line:115,column:2},end:{line:137,column:3}},'28':{start:{line:116,column:6},end:{line:121,column:7}},'29':{start:{line:117,column:7},end:{line:117,column:58}},'30':{start:{line:120,column:7},end:{line:120,column:58}},'31':{start:{line:125,column:21},end:{line:125,column:26}},'32':{start:{line:126,column:6},end:{line:130,column:7}},'33':{start:{line:127,column:7},end:{line:127,column:24}},'34':{start:{line:129,column:7},end:{line:129,column:23}},'35':{start:{line:132,column:3},end:{line:134,column:13}},'36':{start:{line:132,column:31},end:{line:134,column:10}},'37':{start:{line:136,column:6},end:{line:136,column:25}},'38':{start:{line:142,column:16},end:{line:142,column:36}},'39':{start:{line:143,column:17},end:{line:143,column:53}},'40':{start:{line:145,column:3},end:{line:145,column:17}},'41':{start:{line:149,column:2},end:{line:149,column:31}},'42':{start:{line:153,column:13},end:{line:153,column:17}},'43':{start:{line:154,column:16},end:{line:164,column:3}},'44':{start:{line:165,column:14},end:{line:175,column:3}},'45':{start:{line:177,column:2},end:{line:481,column:3}},'46':{start:{line:178,column:3},end:{line:189,column:6}},'47':{start:{line:179,column:4},end:{line:188,column:7}},'48':{start:{line:180,column:5},end:{line:187,column:9}},'49':{start:{line:181,column:9},end:{line:181,column:60}},'50':{start:{line:182,column:9},end:{line:182,column:56}},'51':{start:{line:185,column:9},end:{line:185,column:66}},'52':{start:{line:186,column:9},end:{line:186,column:62}},'53':{start:{line:190,column:3},end:{line:192,column:6}},'54':{start:{line:191,column:6},end:{line:191,column:63}},'55':{start:{line:193,column:3},end:{line:458,column:4}},'56':{start:{line:195,column:66},end:{line:195,column:79}},'57':{start:{line:344,column:7},end:{line:389,column:25}},'58':{start:{line:460,column:7},end:{line:481,column:3}},'59':{start:{line:461,column:3},end:{line:468,column:4}},'60':{start:{line:472,column:3},end:{line:480,column:4}},'61':{start:{line:482,column:2},end:{line:612,column:3}},'62':{start:{line:483,column:5},end:{line:578,column:6}},'63':{start:{line:581,column:3},end:{line:611,column:4}},'64':{start:{line:616,column:24},end:{line:623,column:1}},'65':{start:{line:617,column:4},end:{line:622,column:6}},'66':{start:{line:625,column:27},end:{line:629,column:1}},'67':{start:{line:626,column:4},end:{line:628,column:5}},'68':{start:{line:627,column:37},end:{line:627,column:93}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:31,column:1},end:{line:31,column:2}},loc:{start:{line:31,column:21},end:{line:33,column:2}},line:31},'1':{name:'(anonymous_1)',decl:{start:{line:35,column:22},end:{line:35,column:23}},loc:{start:{line:35,column:58},end:{line:39,column:2}},line:35},'2':{name:'(anonymous_2)',decl:{start:{line:41,column:26},end:{line:41,column:27}},loc:{start:{line:41,column:54},end:{line:49,column:5}},line:41},'3':{name:'(anonymous_3)',decl:{start:{line:43,column:19},end:{line:43,column:20}},loc:{start:{line:43,column:33},end:{line:48,column:9}},line:43},'4':{name:'(anonymous_4)',decl:{start:{line:51,column:27},end:{line:51,column:28}},loc:{start:{line:51,column:53},end:{line:94,column:4}},line:51},'5':{name:'(anonymous_5)',decl:{start:{line:54,column:18},end:{line:54,column:19}},loc:{start:{line:54,column:34},end:{line:61,column:5}},line:54},'6':{name:'(anonymous_6)',decl:{start:{line:63,column:18},end:{line:63,column:19}},loc:{start:{line:63,column:34},end:{line:70,column:5}},line:63},'7':{name:'(anonymous_7)',decl:{start:{line:75,column:18},end:{line:75,column:19}},loc:{start:{line:75,column:34},end:{line:82,column:5}},line:75},'8':{name:'(anonymous_8)',decl:{start:{line:84,column:18},end:{line:84,column:19}},loc:{start:{line:84,column:34},end:{line:91,column:5}},line:84},'9':{name:'(anonymous_9)',decl:{start:{line:96,column:25},end:{line:96,column:26}},loc:{start:{line:96,column:53},end:{line:110,column:5}},line:96},'10':{name:'(anonymous_10)',decl:{start:{line:114,column:1},end:{line:114,column:2}},loc:{start:{line:114,column:10},end:{line:138,column:2}},line:114},'11':{name:'(anonymous_11)',decl:{start:{line:132,column:17},end:{line:132,column:18}},loc:{start:{line:132,column:31},end:{line:134,column:10}},line:132},'12':{name:'(anonymous_12)',decl:{start:{line:140,column:1},end:{line:140,column:2}},loc:{start:{line:140,column:23},end:{line:146,column:2}},line:140},'13':{name:'(anonymous_13)',decl:{start:{line:148,column:11},end:{line:148,column:12}},loc:{start:{line:148,column:20},end:{line:150,column:2}},line:148},'14':{name:'(anonymous_14)',decl:{start:{line:152,column:1},end:{line:152,column:2}},loc:{start:{line:152,column:10},end:{line:613,column:2}},line:152},'15':{name:'(anonymous_15)',decl:{start:{line:178,column:29},end:{line:178,column:30}},loc:{start:{line:178,column:45},end:{line:189,column:4}},line:178},'16':{name:'(anonymous_16)',decl:{start:{line:179,column:29},end:{line:179,column:30}},loc:{start:{line:179,column:45},end:{line:188,column:5}},line:179},'17':{name:'(anonymous_17)',decl:{start:{line:190,column:28},end:{line:190,column:29}},loc:{start:{line:190,column:44},end:{line:192,column:4}},line:190},'18':{name:'(anonymous_18)',decl:{start:{line:195,column:59},end:{line:195,column:60}},loc:{start:{line:195,column:66},end:{line:195,column:79}},line:195},'19':{name:'(anonymous_19)',decl:{start:{line:343,column:34},end:{line:343,column:35}},loc:{start:{line:344,column:7},end:{line:389,column:25}},line:344},'20':{name:'(anonymous_20)',decl:{start:{line:616,column:24},end:{line:616,column:25}},loc:{start:{line:616,column:33},end:{line:623,column:1}},line:616},'21':{name:'(anonymous_21)',decl:{start:{line:625,column:27},end:{line:625,column:28}},loc:{start:{line:625,column:39},end:{line:629,column:1}},line:625},'22':{name:'(anonymous_22)',decl:{start:{line:627,column:21},end:{line:627,column:22}},loc:{start:{line:627,column:37},end:{line:627,column:93}},line:627}},branchMap:{'0':{loc:{start:{line:36,column:2},end:{line:38,column:3}},type:'if',locations:[{start:{line:36,column:2},end:{line:38,column:3}},{start:{line:36,column:2},end:{line:38,column:3}}],line:36},'1':{loc:{start:{line:36,column:5},end:{line:36,column:57}},type:'binary-expr',locations:[{start:{line:36,column:5},end:{line:36,column:30}},{start:{line:36,column:34},end:{line:36,column:57}}],line:36},'2':{loc:{start:{line:52,column:2},end:{line:71,column:3}},type:'if',locations:[{start:{line:52,column:2},end:{line:71,column:3}},{start:{line:52,column:2},end:{line:71,column:3}}],line:52},'3':{loc:{start:{line:73,column:2},end:{line:92,column:3}},type:'if',locations:[{start:{line:73,column:2},end:{line:92,column:3}},{start:{line:73,column:2},end:{line:92,column:3}}],line:73},'4':{loc:{start:{line:97,column:5},end:{line:109,column:6}},type:'if',locations:[{start:{line:97,column:5},end:{line:109,column:6}},{start:{line:97,column:5},end:{line:109,column:6}}],line:97},'5':{loc:{start:{line:97,column:8},end:{line:97,column:48}},type:'binary-expr',locations:[{start:{line:97,column:8},end:{line:97,column:28}},{start:{line:97,column:32},end:{line:97,column:48}}],line:97},'6':{loc:{start:{line:99,column:6},end:{line:101,column:7}},type:'if',locations:[{start:{line:99,column:6},end:{line:101,column:7}},{start:{line:99,column:6},end:{line:101,column:7}}],line:99},'7':{loc:{start:{line:102,column:6},end:{line:104,column:7}},type:'if',locations:[{start:{line:102,column:6},end:{line:104,column:7}},{start:{line:102,column:6},end:{line:104,column:7}}],line:102},'8':{loc:{start:{line:105,column:6},end:{line:107,column:7}},type:'if',locations:[{start:{line:105,column:6},end:{line:107,column:7}},{start:{line:105,column:6},end:{line:107,column:7}}],line:105},'9':{loc:{start:{line:115,column:2},end:{line:137,column:3}},type:'if',locations:[{start:{line:115,column:2},end:{line:137,column:3}},{start:{line:115,column:2},end:{line:137,column:3}}],line:115},'10':{loc:{start:{line:116,column:6},end:{line:121,column:7}},type:'if',locations:[{start:{line:116,column:6},end:{line:121,column:7}},{start:{line:116,column:6},end:{line:121,column:7}}],line:116},'11':{loc:{start:{line:126,column:6},end:{line:130,column:7}},type:'if',locations:[{start:{line:126,column:6},end:{line:130,column:7}},{start:{line:126,column:6},end:{line:130,column:7}}],line:126},'12':{loc:{start:{line:177,column:2},end:{line:481,column:3}},type:'if',locations:[{start:{line:177,column:2},end:{line:481,column:3}},{start:{line:177,column:2},end:{line:481,column:3}}],line:177},'13':{loc:{start:{line:180,column:5},end:{line:187,column:9}},type:'if',locations:[{start:{line:180,column:5},end:{line:187,column:9}},{start:{line:180,column:5},end:{line:187,column:9}}],line:180},'14':{loc:{start:{line:200,column:110},end:{line:200,column:158}},type:'cond-expr',locations:[{start:{line:200,column:139},end:{line:200,column:152}},{start:{line:200,column:155},end:{line:200,column:158}}],line:200},'15':{loc:{start:{line:290,column:111},end:{line:290,column:159}},type:'cond-expr',locations:[{start:{line:290,column:140},end:{line:290,column:153}},{start:{line:290,column:156},end:{line:290,column:159}}],line:290},'16':{loc:{start:{line:345,column:79},end:{line:345,column:127}},type:'cond-expr',locations:[{start:{line:345,column:108},end:{line:345,column:121}},{start:{line:345,column:124},end:{line:345,column:127}}],line:345},'17':{loc:{start:{line:355,column:10},end:{line:355,column:148}},type:'cond-expr',locations:[{start:{line:355,column:80},end:{line:355,column:142}},{start:{line:355,column:145},end:{line:355,column:148}}],line:355},'18':{loc:{start:{line:376,column:10},end:{line:376,column:167}},type:'cond-expr',locations:[{start:{line:376,column:33},end:{line:376,column:97}},{start:{line:376,column:102},end:{line:376,column:166}}],line:376},'19':{loc:{start:{line:384,column:10},end:{line:384,column:174}},type:'cond-expr',locations:[{start:{line:384,column:40},end:{line:384,column:104}},{start:{line:384,column:109},end:{line:384,column:173}}],line:384},'20':{loc:{start:{line:409,column:106},end:{line:409,column:154}},type:'cond-expr',locations:[{start:{line:409,column:135},end:{line:409,column:148}},{start:{line:409,column:151},end:{line:409,column:154}}],line:409},'21':{loc:{start:{line:419,column:11},end:{line:419,column:242}},type:'cond-expr',locations:[{start:{line:419,column:46},end:{line:419,column:145}},{start:{line:419,column:148},end:{line:419,column:242}}],line:419},'22':{loc:{start:{line:427,column:10},end:{line:427,column:132}},type:'cond-expr',locations:[{start:{line:427,column:72},end:{line:427,column:126}},{start:{line:427,column:129},end:{line:427,column:132}}],line:427},'23':{loc:{start:{line:460,column:7},end:{line:481,column:3}},type:'if',locations:[{start:{line:460,column:7},end:{line:481,column:3}},{start:{line:460,column:7},end:{line:481,column:3}}],line:460},'24':{loc:{start:{line:482,column:2},end:{line:612,column:3}},type:'if',locations:[{start:{line:482,column:2},end:{line:612,column:3}},{start:{line:482,column:2},end:{line:612,column:3}}],line:482},'25':{loc:{start:{line:537,column:15},end:{line:537,column:118}},type:'cond-expr',locations:[{start:{line:537,column:62},end:{line:537,column:113}},{start:{line:537,column:116},end:{line:537,column:118}}],line:537},'26':{loc:{start:{line:548,column:15},end:{line:548,column:118}},type:'cond-expr',locations:[{start:{line:548,column:62},end:{line:548,column:113}},{start:{line:548,column:116},end:{line:548,column:118}}],line:548},'27':{loc:{start:{line:559,column:15},end:{line:559,column:118}},type:'cond-expr',locations:[{start:{line:559,column:62},end:{line:559,column:113}},{start:{line:559,column:116},end:{line:559,column:118}}],line:559},'28':{loc:{start:{line:570,column:138},end:{line:570,column:277}},type:'cond-expr',locations:[{start:{line:570,column:177},end:{line:570,column:226}},{start:{line:570,column:229},end:{line:570,column:277}}],line:570}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JobsPage=function(_ref){_inherits(JobsPage,_ref);function JobsPage(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,JobsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=JobsPage.__proto__||Object.getPrototypeOf(JobsPage)).call.apply(_ref2,[this].concat(args))),_this),_this.state={search:{searchText:"",start_date:"",start_date_iso:"",start_date_moment_obj:null,end_date:"",end_date_iso:"",end_date_moment_obj:null},gradiantOverlay:false},_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_2e694dwfzq.f[1]++;cov_2e694dwfzq.s[1]++;if((cov_2e694dwfzq.b[1][0]++,!_this.props.state.loading)&&(cov_2e694dwfzq.b[1][1]++,prevProps.state.loading)){cov_2e694dwfzq.b[0][0]++;cov_2e694dwfzq.s[2]++;__WEBPACK_IMPORTED_MODULE_9_react_tooltip___default.a.rebuild();}else{cov_2e694dwfzq.b[0][1]++;}},_this.inputChangedHandler=function(event,inputIdentifier){cov_2e694dwfzq.f[2]++;var value=(cov_2e694dwfzq.s[3]++,event.target.value);cov_2e694dwfzq.s[4]++;_this.setState(function(prevState){cov_2e694dwfzq.f[3]++;cov_2e694dwfzq.s[5]++;return{search:Object.assign({},prevState.search,_defineProperty({},inputIdentifier,value))};});},_this.inputDateChangedHandler=function(start_date,end_date){cov_2e694dwfzq.f[4]++;cov_2e694dwfzq.s[6]++;if(start_date){cov_2e694dwfzq.b[2][0]++;var start_date_to_date=(cov_2e694dwfzq.s[7]++,start_date.toDate());cov_2e694dwfzq.s[8]++;_this.setState(function(prevState){var _Object$assign2;cov_2e694dwfzq.f[5]++;cov_2e694dwfzq.s[9]++;return{search:Object.assign({},prevState.search,(_Object$assign2={},_defineProperty(_Object$assign2,"start_date",Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["a" /* dateFormatter */])(start_date_to_date)),_defineProperty(_Object$assign2,"start_date"+"_iso",Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["c" /* toIsoDate */])(start_date_to_date)),_defineProperty(_Object$assign2,"start_date"+"_moment_obj",start_date),_Object$assign2))};});}else{cov_2e694dwfzq.b[2][1]++;cov_2e694dwfzq.s[10]++;_this.setState(function(prevState){var _Object$assign3;cov_2e694dwfzq.f[6]++;cov_2e694dwfzq.s[11]++;return{search:Object.assign({},prevState.search,(_Object$assign3={},_defineProperty(_Object$assign3,"start_date",""),_defineProperty(_Object$assign3,"start_date"+"_iso",""),_defineProperty(_Object$assign3,"start_date"+"_moment_obj",null),_Object$assign3))};});}cov_2e694dwfzq.s[12]++;if(end_date){cov_2e694dwfzq.b[3][0]++;var end_date_to_date=(cov_2e694dwfzq.s[13]++,end_date.toDate());cov_2e694dwfzq.s[14]++;_this.setState(function(prevState){var _Object$assign4;cov_2e694dwfzq.f[7]++;cov_2e694dwfzq.s[15]++;return{search:Object.assign({},prevState.search,(_Object$assign4={},_defineProperty(_Object$assign4,"end_date",Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["a" /* dateFormatter */])(end_date_to_date)),_defineProperty(_Object$assign4,"end_date"+"_iso",Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["c" /* toIsoDate */])(end_date_to_date)),_defineProperty(_Object$assign4,"end_date"+"_moment_obj",end_date),_Object$assign4))};});}else{cov_2e694dwfzq.b[3][1]++;cov_2e694dwfzq.s[16]++;_this.setState(function(prevState){var _Object$assign5;cov_2e694dwfzq.f[8]++;cov_2e694dwfzq.s[17]++;return{search:Object.assign({},prevState.search,(_Object$assign5={},_defineProperty(_Object$assign5,"end_date",""),_defineProperty(_Object$assign5,"end_date"+"_iso",""),_defineProperty(_Object$assign5,"end_date"+"_moment_obj",null),_Object$assign5))};});}},_this.inputSubmitHandler=function(event,inputIdentifier){cov_2e694dwfzq.f[9]++;cov_2e694dwfzq.s[18]++;if((cov_2e694dwfzq.b[5][0]++,event.keyCode===13)||(cov_2e694dwfzq.b[5][1]++,!inputIdentifier)){cov_2e694dwfzq.b[4][0]++;var searchData=(cov_2e694dwfzq.s[19]++,{});cov_2e694dwfzq.s[20]++;if(_this.state.search.searchText.length){cov_2e694dwfzq.b[6][0]++;cov_2e694dwfzq.s[21]++;searchData.searchText=_this.state.search.searchText;}else{cov_2e694dwfzq.b[6][1]++;}cov_2e694dwfzq.s[22]++;if(_this.state.search.start_date_iso.length){cov_2e694dwfzq.b[7][0]++;cov_2e694dwfzq.s[23]++;searchData.start_date=_this.state.search.start_date_iso;}else{cov_2e694dwfzq.b[7][1]++;}cov_2e694dwfzq.s[24]++;if(_this.state.search.end_date_iso.length){cov_2e694dwfzq.b[8][0]++;cov_2e694dwfzq.s[25]++;searchData.end_date=_this.state.search.end_date_iso;}else{cov_2e694dwfzq.b[8][1]++;}cov_2e694dwfzq.s[26]++;_this.props.onFetchJobs(searchData);}else{cov_2e694dwfzq.b[4][1]++;}},_this.openJob=function(url){cov_2e694dwfzq.f[13]++;cov_2e694dwfzq.s[41]++;_this.props.history.push(url);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JobsPage,[{key:'componentDidMount',value:function componentDidMount(){cov_2e694dwfzq.f[0]++;cov_2e694dwfzq.s[0]++;this.props.onFetchJobs();}},{key:'wheel',value:function wheel(e){cov_2e694dwfzq.f[10]++;cov_2e694dwfzq.s[27]++;if(e.deltaX===0){cov_2e694dwfzq.b[9][0]++;cov_2e694dwfzq.s[28]++;if(e.deltaY>=0){cov_2e694dwfzq.b[10][0]++;cov_2e694dwfzq.s[29]++;document.getElementById('scroll').scrollLeft+=40;}else{cov_2e694dwfzq.b[10][1]++;cov_2e694dwfzq.s[30]++;document.getElementById('scroll').scrollLeft-=40;}var tmpState=(cov_2e694dwfzq.s[31]++,false);cov_2e694dwfzq.s[32]++;if(document.getElementById('scroll').scrollLeft==0){cov_2e694dwfzq.b[11][0]++;cov_2e694dwfzq.s[33]++;tmpState=false;}else{cov_2e694dwfzq.b[11][1]++;cov_2e694dwfzq.s[34]++;tmpState=true;}cov_2e694dwfzq.s[35]++;this.setState(function(prevState){cov_2e694dwfzq.f[11]++;cov_2e694dwfzq.s[36]++;return{gradiantOverlay:tmpState};});cov_2e694dwfzq.s[37]++;e.preventDefault();}else{cov_2e694dwfzq.b[9][1]++;}}},{key:'round',value:function round(number,length){cov_2e694dwfzq.f[12]++;var factor=(cov_2e694dwfzq.s[38]++,Math.pow(10,length));var rounded=(cov_2e694dwfzq.s[39]++,Math.round(number*factor)/factor);cov_2e694dwfzq.s[40]++;return rounded;}},{key:'render',value:function render(){var _this2=this;cov_2e694dwfzq.f[14]++;var jobs=(cov_2e694dwfzq.s[42]++,null);var average=(cov_2e694dwfzq.s[43]++,{pieces:0,heads:0,total_production_cost:0,total_production_time:0,optimal_total_production_cost:0,optimal_total_production_time:0,optimal_heads:0,potential_total_production_cost:0,potential_total_production_time:0});var total=(cov_2e694dwfzq.s[44]++,{pieces:0,heads:0,total_production_cost:0,total_production_time:0,optimal_total_production_cost:0,optimal_total_production_time:0,optimal_heads:0,potential_total_production_cost:0,potential_total_production_time:0});cov_2e694dwfzq.s[45]++;if(this.props.state.jobs.length){cov_2e694dwfzq.b[12][0]++;cov_2e694dwfzq.s[46]++;this.props.state.jobs.map(function(job,index){cov_2e694dwfzq.f[15]++;cov_2e694dwfzq.s[47]++;Object.keys(average).map(function(key,index){cov_2e694dwfzq.f[16]++;cov_2e694dwfzq.s[48]++;if(key!=='pieces'){cov_2e694dwfzq.b[13][0]++;cov_2e694dwfzq.s[49]++;average[key]=average[key]+job.calculation[key];cov_2e694dwfzq.s[50]++;total[key]=total[key]+job.calculation[key];}else{cov_2e694dwfzq.b[13][1]++;cov_2e694dwfzq.s[51]++;average[key]=average[key]+job[key]*job['orders'];cov_2e694dwfzq.s[52]++;total[key]=total[key]+job[key]*job['orders'];}});});cov_2e694dwfzq.s[53]++;Object.keys(average).map(function(key,index){cov_2e694dwfzq.f[17]++;cov_2e694dwfzq.s[54]++;average[key]=average[key]/_this2.props.state.jobs.length;});cov_2e694dwfzq.s[55]++;jobs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.parent,id:'scroll',onWheel:function onWheel(e){cov_2e694dwfzq.f[18]++;cov_2e694dwfzq.s[56]++;return _this2.wheel(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.wrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobList},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(this.state.gradiantOverlay?(cov_2e694dwfzq.b[14][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_2e694dwfzq.b[14][1]++,' '))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.reference'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.date'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.pieces'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.potential_cost'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.potential_time'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.optimal_heads'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.actual_cost'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.actual_time'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.optimal_cost'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.optimal_time'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.recalculated'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.machine'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.modular'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellHelp+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.actual_heads'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.spacer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(this.state.gradiantOverlay?(cov_2e694dwfzq.b[15][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_2e694dwfzq.b[15][1]++,' '))},this.props.translate('global.job.table.header_reference')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.firstCellMover},this.props.translate('global.job.table.header_date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_pieces')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_potential'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_potential'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_heads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_optimal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_actual'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_actual'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_optimal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_optimal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.translate('global.job.table.header_recalculated')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobMachineName},this.props.translate('global.job.table.header_machine')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.cellIcon},this.props.translate('global.job.table.header_modular')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCellTitle+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.lastColumn},this.props.translate('global.job.table.header_heads'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.subLine},this.props.translate('global.job.table.header_actual')))),this.props.state.jobs.map(function(job,index){cov_2e694dwfzq.f[19]++;cov_2e694dwfzq.s[57]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow,onClick:_this2.openJob.bind(_this2,'/jobs/'+job.Id)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+(_this2.state.gradiantOverlay?(cov_2e694dwfzq.b[16][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_2e694dwfzq.b[16][1]++,' '))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.textWrap},job.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.firstCellMover},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["a" /* dateFormatter */])(job.created_on)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},job.orders*job.pieces),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},_this2.round(job.calculation.potential_total_production_cost,2)!=0?(cov_2e694dwfzq.b[17][0]++,_this2.round(job.calculation.potential_total_production_cost,2)):(cov_2e694dwfzq.b[17][1]++,'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(job.calculation.potential_total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},job.calculation.optimal_heads),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},_this2.round(job.calculation.total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(job.calculation.total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},_this2.round(job.calculation.optimal_total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(job.calculation.optimal_total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},job.global_settings?(cov_2e694dwfzq.b[18][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'yes',size:'10px',display:'inline'})):(cov_2e694dwfzq.b[18][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'no',size:'10px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.textWrap},job.calculation.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.cellIcon},!job.calculation.multihead?(cov_2e694dwfzq.b[19][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'yes',size:'10px',display:'inline'})):(cov_2e694dwfzq.b[19][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'no',size:'10px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.lastColumn},job.calculation.heads));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.spacer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListRow+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.average},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.titleColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.hasHelpIcon+' '+(this.state.gradiantOverlay?(cov_2e694dwfzq.b[20][0]++,__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.shadow):(cov_2e694dwfzq.b[20][1]++,' '))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.helpIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.iconWithHint,'data-tip':this.props.translate('global.help.joblisttable.average'),'data-event':'click','data-for':'GlobalTooltip','data-place':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hint',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.textWrap},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:1,paddingRight:3,float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'average',size:'13px',display:'inline'})),this.props.state.jobs.length>1?(cov_2e694dwfzq.b[21][0]++,this.props.translate('global.job.table.average_title.multiple',{jobs:this.props.state.jobs.length})):(cov_2e694dwfzq.b[21][1]++,this.props.translate('global.job.table.average_title.one',{jobs:this.props.state.jobs.length})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.firstCellMover}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.round(average.pieces,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.round(average.potential_total_production_cost,2)!=0?(cov_2e694dwfzq.b[22][0]++,this.round(average.potential_total_production_cost,2)):(cov_2e694dwfzq.b[22][1]++,'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(average.potential_total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.round(average.optimal_heads,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.round(average.total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(average.total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.round(average.optimal_total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(average.optimal_total_production_time)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.cellIcon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.jobListCell+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.lastColumn},this.round(average.heads,2)))))));}else{cov_2e694dwfzq.b[12][1]++;cov_2e694dwfzq.s[58]++;if(this.props.state.searched){cov_2e694dwfzq.b[23][0]++;cov_2e694dwfzq.s[59]++;jobs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Box"],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Text"],{color:'#AAAAAA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.translate('jobspage.search.no_results'))));}else{cov_2e694dwfzq.b[23][1]++;cov_2e694dwfzq.s[60]++;jobs=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Box"],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Text"],{color:'#AAAAAA'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.translate('jobspage.no_jobs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{value:this.props.translate('jobspage.first_job'),href:'/jobs/new',width:'auto'}));}}cov_2e694dwfzq.s[61]++;if(this.props.state.jobs.length){cov_2e694dwfzq.b[24][0]++;cov_2e694dwfzq.s[62]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["PageTitle"],null,this.props.translate('jobspage.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Flex"],{'break':'l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*13',growSM:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["GreyBox"],{type:'fullWidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["BoxTitle"],null,this.props.translate('jobspage.search.title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('jobspage.search.label.search'),icon:'search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'searchText',type:'text',value:this.state.search.searchText,changed:this.inputChangedHandler,keyupped:this.inputSubmitHandler})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Flex"],{'break':'l'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*9*2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["DatePicker"],{startDateLabel:this.props.translate('jobspage.search.label.date_from'),endDateLabel:this.props.translate('jobspage.search.label.date_to'),changed:this.inputDateChangedHandler,startDate:this.state.search.start_date_moment_obj,endDate:this.state.search.end_date_moment_obj})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{value:this.props.translate('jobspage.search.label.submit'),onClick:this.inputSubmitHandler,type:'button',nomargin:'true'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*11'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["GreyBox"],{type:'fullWidth',bgColor:'#fbfbfb',borderColor:'#F2F2F2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["BoxTitle"],null,this.props.translate('jobspage.comparsion.title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn},this.props.translate('jobspage.comparsion.total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'cost',size:'13px',display:'inline'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn},this.props.translate('jobspage.comparsion.total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'time',size:'13px',display:'inline'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn},this.props.translate('jobspage.comparsion.actual')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.settingsCompany.settings.currency?(cov_2e694dwfzq.b[25][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_2e694dwfzq.b[25][1]++,""),' ',this.round(total.total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(total.total_production_time))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn},this.props.translate('jobspage.comparsion.optimal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},this.props.settingsCompany.settings.currency?(cov_2e694dwfzq.b[26][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_2e694dwfzq.b[26][1]++,""),' ',this.round(total.optimal_total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(total.optimal_total_production_time))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isBold},this.props.translate('jobspage.comparsion.potential')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isBold},this.props.settingsCompany.settings.currency?(cov_2e694dwfzq.b[27][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_2e694dwfzq.b[27][1]++,""),' ',this.round(total.potential_total_production_cost,2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonTableColumn+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isRight+' '+__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isBold},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_DateTime_js__["b" /* secondsFormatter */])(total.potential_total_production_time)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.comparisonNote},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Icon"],{type:'image',content:'hintbulb',size:'20px',display:'inline'})),this.props.translate('jobspage.comparsion.best_setup'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_6__molecules_ScrollTable_ScrollTable_scss___default.a.isBold},Math.ceil(average.optimal_heads),' ',Math.ceil(average.optimal_heads)>1?(cov_2e694dwfzq.b[28][0]++,this.props.translate('jobspage.comparsion.heads')):(cov_2e694dwfzq.b[28][1]++,this.props.translate('jobspage.comparsion.head')))))))),jobs);}else{cov_2e694dwfzq.b[24][1]++;cov_2e694dwfzq.s[63]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["PageTitle"],null,this.props.translate('jobspage.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["GreyBox"],{type:'fullWidth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('jobspage.search.label.search'),icon:'search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'searchText',type:'text',value:this.state.search.searchText,changed:this.inputChangedHandler,keyupped:this.inputSubmitHandler}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*5*2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["DatePicker"],{startDateLabel:this.props.translate('jobspage.search.label.date_from'),endDateLabel:this.props.translate('jobspage.search.label.date_to'),changed:this.inputDateChangedHandler,startDate:this.state.search.start_date_moment_obj,endDate:this.state.search.end_date_moment_obj})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["FlexColumn"],{col:'24*4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{value:this.props.translate('jobspage.search.label.submit'),onClick:this.inputSubmitHandler,type:'button',nomargin:'true'})))),jobs);}}}]);return JobsPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_2e694dwfzq.s[64]++;var mapStateToProps=function mapStateToProps(state){cov_2e694dwfzq.f[20]++;cov_2e694dwfzq.s[65]++;return{defaults:state.defaults,state:state.calculatorJobs,translate:Object(__WEBPACK_IMPORTED_MODULE_8_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_2e694dwfzq.s[66]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_2e694dwfzq.f[21]++;cov_2e694dwfzq.s[67]++;return{onFetchJobs:function onFetchJobs(searchData){cov_2e694dwfzq.f[22]++;cov_2e694dwfzq.s[68]++;return dispatch(__WEBPACK_IMPORTED_MODULE_7__store_actions_index__["E" /* calculatorJobsFetch */](searchData));}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(JobsPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components__);
var cov_5tuao0bxa=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesNewPage\\index.js',hash='1391c5c4801848144ff8a44333d19e068f1c9dc5',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesNewPage\\index.js',statementMap:{'0':{start:{line:83,column:8},end:{line:83,column:21}},'1':{start:{line:84,column:8},end:{line:115,column:3}},'2':{start:{line:119,column:8},end:{line:119,column:45}},'3':{start:{line:123,column:5},end:{line:123,column:33}},'4':{start:{line:124,column:8},end:{line:124,column:60}},'5':{start:{line:128,column:5},end:{line:130,column:6}},'6':{start:{line:129,column:9},end:{line:129,column:36}},'7':{start:{line:131,column:8},end:{line:144,column:9}},'8':{start:{line:132,column:12},end:{line:143,column:15}},'9':{start:{line:132,column:40},end:{line:143,column:13}},'10':{start:{line:146,column:8},end:{line:167,column:9}},'11':{start:{line:147,column:12},end:{line:157,column:16}},'12':{start:{line:147,column:40},end:{line:157,column:13}},'13':{start:{line:158,column:12},end:{line:166,column:13}},'14':{start:{line:159,column:16},end:{line:165,column:19}},'15':{start:{line:159,column:44},end:{line:161,column:17}},'16':{start:{line:162,column:20},end:{line:164,column:21}},'17':{start:{line:163,column:24},end:{line:163,column:45}},'18':{start:{line:168,column:5},end:{line:205,column:9}},'19':{start:{line:169,column:12},end:{line:187,column:13}},'20':{start:{line:170,column:16},end:{line:186,column:19}},'21':{start:{line:170,column:44},end:{line:172,column:17}},'22':{start:{line:173,column:20},end:{line:185,column:22}},'23':{start:{line:174,column:24},end:{line:184,column:25}},'24':{start:{line:175,column:28},end:{line:183,column:31}},'25':{start:{line:175,column:56},end:{line:183,column:29}},'26':{start:{line:188,column:12},end:{line:204,column:13}},'27':{start:{line:189,column:16},end:{line:194,column:20}},'28':{start:{line:189,column:44},end:{line:194,column:17}},'29':{start:{line:198,column:16},end:{line:203,column:20}},'30':{start:{line:198,column:44},end:{line:203,column:17}},'31':{start:{line:206,column:8},end:{line:208,column:9}},'32':{start:{line:207,column:12},end:{line:207,column:146}},'33':{start:{line:212,column:5},end:{line:217,column:6}},'34':{start:{line:213,column:22},end:{line:213,column:44}},'35':{start:{line:216,column:22},end:{line:216,column:23}},'36':{start:{line:218,column:5},end:{line:238,column:3}},'37':{start:{line:219,column:6},end:{line:236,column:9}},'38':{start:{line:219,column:34},end:{line:236,column:7}},'39':{start:{line:242,column:8},end:{line:242,column:31}},'40':{start:{line:243,column:8},end:{line:257,column:9}},'41':{start:{line:244,column:12},end:{line:253,column:13}},'42':{start:{line:245,column:16},end:{line:245,column:37}},'43':{start:{line:248,column:16},end:{line:252,column:19}},'44':{start:{line:248,column:44},end:{line:250,column:17}},'45':{start:{line:251,column:20},end:{line:251,column:49}},'46':{start:{line:256,column:12},end:{line:256,column:33}},'47':{start:{line:261,column:5},end:{line:266,column:12}},'48':{start:{line:261,column:33},end:{line:266,column:9}},'49':{start:{line:270,column:20},end:{line:270,column:38}},'50':{start:{line:271,column:8},end:{line:276,column:12}},'51':{start:{line:271,column:36},end:{line:276,column:9}},'52':{start:{line:277,column:8},end:{line:279,column:9}},'53':{start:{line:278,column:9},end:{line:278,column:43}},'54':{start:{line:283,column:8},end:{line:285,column:9}},'55':{start:{line:284,column:12},end:{line:284,column:41}},'56':{start:{line:286,column:8},end:{line:286,column:67}},'57':{start:{line:287,column:8},end:{line:289,column:9}},'58':{start:{line:288,column:12},end:{line:288,column:66}},'59':{start:{line:292,column:8},end:{line:294,column:9}},'60':{start:{line:293,column:12},end:{line:293,column:66}},'61':{start:{line:298,column:8},end:{line:330,column:9}},'62':{start:{line:299,column:12},end:{line:326,column:13}},'63':{start:{line:300,column:16},end:{line:311,column:19}},'64':{start:{line:300,column:44},end:{line:309,column:17}},'65':{start:{line:310,column:20},end:{line:310,column:101}},'66':{start:{line:314,column:16},end:{line:325,column:19}},'67':{start:{line:314,column:44},end:{line:323,column:17}},'68':{start:{line:324,column:20},end:{line:324,column:41}},'69':{start:{line:328,column:13},end:{line:330,column:9}},'70':{start:{line:329,column:12},end:{line:329,column:33}},'71':{start:{line:334,column:8},end:{line:336,column:12}},'72':{start:{line:334,column:36},end:{line:336,column:9}},'73':{start:{line:337,column:25},end:{line:355,column:9}},'74':{start:{line:357,column:8},end:{line:406,column:9}},'75':{start:{line:358,column:12},end:{line:386,column:14}},'76':{start:{line:358,column:40},end:{line:360,column:17}},'77':{start:{line:361,column:20},end:{line:384,column:21}},'78':{start:{line:362,column:36},end:{line:362,column:64}},'79':{start:{line:363,column:24},end:{line:363,column:47}},'80':{start:{line:364,column:24},end:{line:364,column:48}},'81':{start:{line:365,column:24},end:{line:374,column:58}},'82':{start:{line:365,column:52},end:{line:374,column:25}},'83':{start:{line:374,column:34},end:{line:374,column:56}},'84':{start:{line:377,column:24},end:{line:383,column:27}},'85':{start:{line:377,column:52},end:{line:383,column:25}},'86':{start:{line:388,column:13},end:{line:406,column:9}},'87':{start:{line:389,column:12},end:{line:405,column:14}},'88':{start:{line:389,column:40},end:{line:391,column:17}},'89':{start:{line:392,column:20},end:{line:403,column:21}},'90':{start:{line:393,column:24},end:{line:393,column:61}},'91':{start:{line:396,column:24},end:{line:402,column:27}},'92':{start:{line:396,column:52},end:{line:402,column:25}},'93':{start:{line:410,column:25},end:{line:417,column:5}},'94':{start:{line:411,column:17},end:{line:415,column:7}},'95':{start:{line:412,column:8},end:{line:412,column:27}},'96':{start:{line:412,column:21},end:{line:412,column:27}},'97':{start:{line:413,column:8},end:{line:413,column:13}},'98':{start:{line:414,column:8},end:{line:414,column:20}},'99':{start:{line:416,column:6},end:{line:416,column:21}},'100':{start:{line:420,column:25},end:{line:420,column:27}},'101':{start:{line:421,column:8},end:{line:426,column:10}},'102':{start:{line:422,column:12},end:{line:425,column:14}},'103':{start:{line:429,column:8},end:{line:431,column:9}},'104':{start:{line:430,column:12},end:{line:430,column:44}},'105':{start:{line:432,column:4},end:{line:723,column:5}},'106':{start:{line:727,column:24},end:{line:735,column:1}},'107':{start:{line:728,column:4},end:{line:734,column:6}},'108':{start:{line:737,column:27},end:{line:745,column:1}},'109':{start:{line:738,column:4},end:{line:744,column:5}},'110':{start:{line:739,column:39},end:{line:739,column:97}},'111':{start:{line:740,column:39},end:{line:740,column:97}},'112':{start:{line:741,column:30},end:{line:741,column:85}},'113':{start:{line:742,column:57},end:{line:742,column:123}},'114':{start:{line:743,column:54},end:{line:743,column:117}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:82,column:4},end:{line:82,column:5}},loc:{start:{line:82,column:23},end:{line:116,column:2}},line:82},'1':{name:'(anonymous_1)',decl:{start:{line:118,column:24},end:{line:118,column:25}},loc:{start:{line:118,column:30},end:{line:120,column:5}},line:118},'2':{name:'(anonymous_2)',decl:{start:{line:122,column:27},end:{line:122,column:28}},loc:{start:{line:122,column:33},end:{line:125,column:5}},line:122},'3':{name:'(anonymous_3)',decl:{start:{line:127,column:25},end:{line:127,column:26}},loc:{start:{line:127,column:61},end:{line:209,column:5}},line:127},'4':{name:'(anonymous_4)',decl:{start:{line:132,column:26},end:{line:132,column:27}},loc:{start:{line:132,column:40},end:{line:143,column:13}},line:132},'5':{name:'(anonymous_5)',decl:{start:{line:147,column:26},end:{line:147,column:27}},loc:{start:{line:147,column:40},end:{line:157,column:13}},line:147},'6':{name:'(anonymous_6)',decl:{start:{line:159,column:30},end:{line:159,column:31}},loc:{start:{line:159,column:44},end:{line:161,column:17}},line:159},'7':{name:'(anonymous_7)',decl:{start:{line:161,column:20},end:{line:161,column:21}},loc:{start:{line:161,column:26},end:{line:165,column:17}},line:161},'8':{name:'(anonymous_8)',decl:{start:{line:170,column:30},end:{line:170,column:31}},loc:{start:{line:170,column:44},end:{line:172,column:17}},line:170},'9':{name:'(anonymous_9)',decl:{start:{line:172,column:20},end:{line:172,column:21}},loc:{start:{line:172,column:26},end:{line:186,column:17}},line:172},'10':{name:'(anonymous_10)',decl:{start:{line:173,column:51},end:{line:173,column:52}},loc:{start:{line:173,column:69},end:{line:185,column:21}},line:173},'11':{name:'(anonymous_11)',decl:{start:{line:175,column:42},end:{line:175,column:43}},loc:{start:{line:175,column:56},end:{line:183,column:29}},line:175},'12':{name:'(anonymous_12)',decl:{start:{line:189,column:30},end:{line:189,column:31}},loc:{start:{line:189,column:44},end:{line:194,column:17}},line:189},'13':{name:'(anonymous_13)',decl:{start:{line:198,column:30},end:{line:198,column:31}},loc:{start:{line:198,column:44},end:{line:203,column:17}},line:198},'14':{name:'(anonymous_14)',decl:{start:{line:211,column:26},end:{line:211,column:27}},loc:{start:{line:211,column:37},end:{line:239,column:5}},line:211},'15':{name:'(anonymous_15)',decl:{start:{line:219,column:20},end:{line:219,column:21}},loc:{start:{line:219,column:34},end:{line:236,column:7}},line:219},'16':{name:'(anonymous_16)',decl:{start:{line:241,column:24},end:{line:241,column:25}},loc:{start:{line:241,column:37},end:{line:258,column:5}},line:241},'17':{name:'(anonymous_17)',decl:{start:{line:248,column:30},end:{line:248,column:31}},loc:{start:{line:248,column:44},end:{line:250,column:17}},line:248},'18':{name:'(anonymous_18)',decl:{start:{line:250,column:20},end:{line:250,column:21}},loc:{start:{line:250,column:26},end:{line:252,column:17}},line:250},'19':{name:'(anonymous_19)',decl:{start:{line:260,column:25},end:{line:260,column:26}},loc:{start:{line:260,column:53},end:{line:267,column:5}},line:260},'20':{name:'(anonymous_20)',decl:{start:{line:261,column:19},end:{line:261,column:20}},loc:{start:{line:261,column:33},end:{line:266,column:9}},line:261},'21':{name:'(anonymous_21)',decl:{start:{line:269,column:26},end:{line:269,column:27}},loc:{start:{line:269,column:54},end:{line:280,column:5}},line:269},'22':{name:'(anonymous_22)',decl:{start:{line:271,column:22},end:{line:271,column:23}},loc:{start:{line:271,column:36},end:{line:276,column:9}},line:271},'23':{name:'(anonymous_23)',decl:{start:{line:282,column:26},end:{line:282,column:27}},loc:{start:{line:282,column:54},end:{line:290,column:5}},line:282},'24':{name:'(anonymous_24)',decl:{start:{line:291,column:24},end:{line:291,column:25}},loc:{start:{line:291,column:52},end:{line:295,column:5}},line:291},'25':{name:'(anonymous_25)',decl:{start:{line:297,column:28},end:{line:297,column:29}},loc:{start:{line:297,column:34},end:{line:331,column:5}},line:297},'26':{name:'(anonymous_26)',decl:{start:{line:300,column:30},end:{line:300,column:31}},loc:{start:{line:300,column:44},end:{line:309,column:17}},line:300},'27':{name:'(anonymous_27)',decl:{start:{line:309,column:20},end:{line:309,column:21}},loc:{start:{line:309,column:26},end:{line:311,column:17}},line:309},'28':{name:'(anonymous_28)',decl:{start:{line:314,column:30},end:{line:314,column:31}},loc:{start:{line:314,column:44},end:{line:323,column:17}},line:314},'29':{name:'(anonymous_29)',decl:{start:{line:323,column:20},end:{line:323,column:21}},loc:{start:{line:323,column:26},end:{line:325,column:17}},line:323},'30':{name:'(anonymous_30)',decl:{start:{line:333,column:20},end:{line:333,column:21}},loc:{start:{line:333,column:33},end:{line:407,column:5}},line:333},'31':{name:'(anonymous_31)',decl:{start:{line:334,column:22},end:{line:334,column:23}},loc:{start:{line:334,column:36},end:{line:336,column:9}},line:334},'32':{name:'(anonymous_32)',decl:{start:{line:358,column:26},end:{line:358,column:27}},loc:{start:{line:358,column:40},end:{line:360,column:17}},line:358},'33':{name:'(anonymous_33)',decl:{start:{line:360,column:20},end:{line:360,column:21}},loc:{start:{line:360,column:26},end:{line:385,column:17}},line:360},'34':{name:'(anonymous_34)',decl:{start:{line:365,column:38},end:{line:365,column:39}},loc:{start:{line:365,column:52},end:{line:374,column:25}},line:365},'35':{name:'(anonymous_35)',decl:{start:{line:374,column:28},end:{line:374,column:29}},loc:{start:{line:374,column:34},end:{line:374,column:56}},line:374},'36':{name:'(anonymous_36)',decl:{start:{line:377,column:38},end:{line:377,column:39}},loc:{start:{line:377,column:52},end:{line:383,column:25}},line:377},'37':{name:'(anonymous_37)',decl:{start:{line:389,column:26},end:{line:389,column:27}},loc:{start:{line:389,column:40},end:{line:391,column:17}},line:389},'38':{name:'(anonymous_38)',decl:{start:{line:391,column:20},end:{line:391,column:21}},loc:{start:{line:391,column:26},end:{line:404,column:17}},line:391},'39':{name:'(anonymous_39)',decl:{start:{line:396,column:38},end:{line:396,column:39}},loc:{start:{line:396,column:52},end:{line:402,column:25}},line:396},'40':{name:'(anonymous_40)',decl:{start:{line:410,column:20},end:{line:410,column:21}},loc:{start:{line:410,column:25},end:{line:417,column:5}},line:410},'41':{name:'(anonymous_41)',decl:{start:{line:410,column:25},end:{line:410,column:26}},loc:{start:{line:410,column:30},end:{line:417,column:5}},line:410},'42':{name:'(anonymous_42)',decl:{start:{line:411,column:17},end:{line:411,column:18}},loc:{start:{line:411,column:22},end:{line:415,column:7}},line:411},'43':{name:'(anonymous_43)',decl:{start:{line:419,column:1},end:{line:419,column:2}},loc:{start:{line:419,column:10},end:{line:724,column:2}},line:419},'44':{name:'(anonymous_44)',decl:{start:{line:421,column:33},end:{line:421,column:34}},loc:{start:{line:421,column:38},end:{line:426,column:9}},line:421},'45':{name:'(anonymous_45)',decl:{start:{line:727,column:24},end:{line:727,column:25}},loc:{start:{line:727,column:33},end:{line:735,column:1}},line:727},'46':{name:'(anonymous_46)',decl:{start:{line:737,column:27},end:{line:737,column:28}},loc:{start:{line:737,column:39},end:{line:745,column:1}},line:737},'47':{name:'(anonymous_47)',decl:{start:{line:739,column:25},end:{line:739,column:26}},loc:{start:{line:739,column:39},end:{line:739,column:97}},line:739},'48':{name:'(anonymous_48)',decl:{start:{line:740,column:33},end:{line:740,column:34}},loc:{start:{line:740,column:39},end:{line:740,column:97}},line:740},'49':{name:'(anonymous_49)',decl:{start:{line:741,column:24},end:{line:741,column:25}},loc:{start:{line:741,column:30},end:{line:741,column:85}},line:741},'50':{name:'(anonymous_50)',decl:{start:{line:742,column:43},end:{line:742,column:44}},loc:{start:{line:742,column:57},end:{line:742,column:123}},line:742},'51':{name:'(anonymous_51)',decl:{start:{line:743,column:48},end:{line:743,column:49}},loc:{start:{line:743,column:54},end:{line:743,column:117}},line:743}},branchMap:{'0':{loc:{start:{line:128,column:5},end:{line:130,column:6}},type:'if',locations:[{start:{line:128,column:5},end:{line:130,column:6}},{start:{line:128,column:5},end:{line:130,column:6}}],line:128},'1':{loc:{start:{line:131,column:8},end:{line:144,column:9}},type:'if',locations:[{start:{line:131,column:8},end:{line:144,column:9}},{start:{line:131,column:8},end:{line:144,column:9}}],line:131},'2':{loc:{start:{line:146,column:8},end:{line:167,column:9}},type:'if',locations:[{start:{line:146,column:8},end:{line:167,column:9}},{start:{line:146,column:8},end:{line:167,column:9}}],line:146},'3':{loc:{start:{line:146,column:11},end:{line:146,column:73}},type:'binary-expr',locations:[{start:{line:146,column:11},end:{line:146,column:40}},{start:{line:146,column:44},end:{line:146,column:73}}],line:146},'4':{loc:{start:{line:148,column:30},end:{line:148,column:77}},type:'cond-expr',locations:[{start:{line:148,column:65},end:{line:148,column:69}},{start:{line:148,column:72},end:{line:148,column:77}}],line:148},'5':{loc:{start:{line:153,column:32},end:{line:153,column:85}},type:'cond-expr',locations:[{start:{line:153,column:66},end:{line:153,column:75}},{start:{line:153,column:78},end:{line:153,column:85}}],line:153},'6':{loc:{start:{line:154,column:34},end:{line:154,column:132}},type:'cond-expr',locations:[{start:{line:154,column:69},end:{line:154,column:125}},{start:{line:154,column:128},end:{line:154,column:132}}],line:154},'7':{loc:{start:{line:158,column:12},end:{line:166,column:13}},type:'if',locations:[{start:{line:158,column:12},end:{line:166,column:13}},{start:{line:158,column:12},end:{line:166,column:13}}],line:158},'8':{loc:{start:{line:162,column:20},end:{line:164,column:21}},type:'if',locations:[{start:{line:162,column:20},end:{line:164,column:21}},{start:{line:162,column:20},end:{line:164,column:21}}],line:162},'9':{loc:{start:{line:168,column:5},end:{line:205,column:9}},type:'if',locations:[{start:{line:168,column:5},end:{line:205,column:9}},{start:{line:168,column:5},end:{line:205,column:9}}],line:168},'10':{loc:{start:{line:168,column:8},end:{line:168,column:173}},type:'binary-expr',locations:[{start:{line:168,column:8},end:{line:168,column:56}},{start:{line:168,column:60},end:{line:168,column:82}},{start:{line:168,column:86},end:{line:168,column:115}},{start:{line:168,column:119},end:{line:168,column:173}}],line:168},'11':{loc:{start:{line:169,column:12},end:{line:187,column:13}},type:'if',locations:[{start:{line:169,column:12},end:{line:187,column:13}},{start:{line:169,column:12},end:{line:187,column:13}}],line:169},'12':{loc:{start:{line:174,column:24},end:{line:184,column:25}},type:'if',locations:[{start:{line:174,column:24},end:{line:184,column:25}},{start:{line:174,column:24},end:{line:184,column:25}}],line:174},'13':{loc:{start:{line:188,column:12},end:{line:204,column:13}},type:'if',locations:[{start:{line:188,column:12},end:{line:204,column:13}},{start:{line:188,column:12},end:{line:204,column:13}}],line:188},'14':{loc:{start:{line:206,column:8},end:{line:208,column:9}},type:'if',locations:[{start:{line:206,column:8},end:{line:208,column:9}},{start:{line:206,column:8},end:{line:208,column:9}}],line:206},'15':{loc:{start:{line:212,column:5},end:{line:217,column:6}},type:'if',locations:[{start:{line:212,column:5},end:{line:217,column:6}},{start:{line:212,column:5},end:{line:217,column:6}}],line:212},'16':{loc:{start:{line:218,column:5},end:{line:238,column:3}},type:'if',locations:[{start:{line:218,column:5},end:{line:238,column:3}},{start:{line:218,column:5},end:{line:238,column:3}}],line:218},'17':{loc:{start:{line:243,column:8},end:{line:257,column:9}},type:'if',locations:[{start:{line:243,column:8},end:{line:257,column:9}},{start:{line:243,column:8},end:{line:257,column:9}}],line:243},'18':{loc:{start:{line:244,column:12},end:{line:253,column:13}},type:'if',locations:[{start:{line:244,column:12},end:{line:253,column:13}},{start:{line:244,column:12},end:{line:253,column:13}}],line:244},'19':{loc:{start:{line:244,column:15},end:{line:244,column:79}},type:'binary-expr',locations:[{start:{line:244,column:15},end:{line:244,column:44}},{start:{line:244,column:48},end:{line:244,column:79}}],line:244},'20':{loc:{start:{line:277,column:8},end:{line:279,column:9}},type:'if',locations:[{start:{line:277,column:8},end:{line:279,column:9}},{start:{line:277,column:8},end:{line:279,column:9}}],line:277},'21':{loc:{start:{line:283,column:8},end:{line:285,column:9}},type:'if',locations:[{start:{line:283,column:8},end:{line:285,column:9}},{start:{line:283,column:8},end:{line:285,column:9}}],line:283},'22':{loc:{start:{line:287,column:8},end:{line:289,column:9}},type:'if',locations:[{start:{line:287,column:8},end:{line:289,column:9}},{start:{line:287,column:8},end:{line:289,column:9}}],line:287},'23':{loc:{start:{line:292,column:8},end:{line:294,column:9}},type:'if',locations:[{start:{line:292,column:8},end:{line:294,column:9}},{start:{line:292,column:8},end:{line:294,column:9}}],line:292},'24':{loc:{start:{line:298,column:8},end:{line:330,column:9}},type:'if',locations:[{start:{line:298,column:8},end:{line:330,column:9}},{start:{line:298,column:8},end:{line:330,column:9}}],line:298},'25':{loc:{start:{line:299,column:12},end:{line:326,column:13}},type:'if',locations:[{start:{line:299,column:12},end:{line:326,column:13}},{start:{line:299,column:12},end:{line:326,column:13}}],line:299},'26':{loc:{start:{line:328,column:13},end:{line:330,column:9}},type:'if',locations:[{start:{line:328,column:13},end:{line:330,column:9}},{start:{line:328,column:13},end:{line:330,column:9}}],line:328},'27':{loc:{start:{line:357,column:8},end:{line:406,column:9}},type:'if',locations:[{start:{line:357,column:8},end:{line:406,column:9}},{start:{line:357,column:8},end:{line:406,column:9}}],line:357},'28':{loc:{start:{line:361,column:20},end:{line:384,column:21}},type:'if',locations:[{start:{line:361,column:20},end:{line:384,column:21}},{start:{line:361,column:20},end:{line:384,column:21}}],line:361},'29':{loc:{start:{line:388,column:13},end:{line:406,column:9}},type:'if',locations:[{start:{line:388,column:13},end:{line:406,column:9}},{start:{line:388,column:13},end:{line:406,column:9}}],line:388},'30':{loc:{start:{line:392,column:20},end:{line:403,column:21}},type:'if',locations:[{start:{line:392,column:20},end:{line:403,column:21}},{start:{line:392,column:20},end:{line:403,column:21}}],line:392},'31':{loc:{start:{line:412,column:8},end:{line:412,column:27}},type:'if',locations:[{start:{line:412,column:8},end:{line:412,column:27}},{start:{line:412,column:8},end:{line:412,column:27}}],line:412},'32':{loc:{start:{line:429,column:8},end:{line:431,column:9}},type:'if',locations:[{start:{line:429,column:8},end:{line:431,column:9}},{start:{line:429,column:8},end:{line:431,column:9}}],line:429},'33':{loc:{start:{line:434,column:17},end:{line:721,column:5}},type:'cond-expr',locations:[{start:{line:434,column:45},end:{line:434,column:72}},{start:{line:435,column:8},end:{line:720,column:23}}],line:434},'34':{loc:{start:{line:437,column:23},end:{line:523,column:30}},type:'cond-expr',locations:[{start:{line:438,column:16},end:{line:522,column:26}},{start:{line:523,column:26},end:{line:523,column:30}}],line:437},'35':{loc:{start:{line:441,column:51},end:{line:441,column:125}},type:'cond-expr',locations:[{start:{line:441,column:86},end:{line:441,column:118}},{start:{line:441,column:121},end:{line:441,column:125}}],line:441},'36':{loc:{start:{line:442,column:49},end:{line:442,column:127}},type:'cond-expr',locations:[{start:{line:442,column:86},end:{line:442,column:120}},{start:{line:442,column:123},end:{line:442,column:127}}],line:442},'37':{loc:{start:{line:458,column:55},end:{line:458,column:131}},type:'cond-expr',locations:[{start:{line:458,column:91},end:{line:458,column:124}},{start:{line:458,column:127},end:{line:458,column:131}}],line:458},'38':{loc:{start:{line:459,column:53},end:{line:459,column:133}},type:'cond-expr',locations:[{start:{line:459,column:91},end:{line:459,column:126}},{start:{line:459,column:129},end:{line:459,column:133}}],line:459},'39':{loc:{start:{line:472,column:54},end:{line:472,column:157}},type:'cond-expr',locations:[{start:{line:472,column:101},end:{line:472,column:152}},{start:{line:472,column:155},end:{line:472,column:157}}],line:472},'40':{loc:{start:{line:475,column:55},end:{line:475,column:141}},type:'cond-expr',locations:[{start:{line:475,column:96},end:{line:475,column:134}},{start:{line:475,column:137},end:{line:475,column:141}}],line:475},'41':{loc:{start:{line:476,column:53},end:{line:476,column:143}},type:'cond-expr',locations:[{start:{line:476,column:96},end:{line:476,column:136}},{start:{line:476,column:139},end:{line:476,column:143}}],line:476},'42':{loc:{start:{line:494,column:51},end:{line:494,column:155}},type:'cond-expr',locations:[{start:{line:494,column:101},end:{line:494,column:148}},{start:{line:494,column:151},end:{line:494,column:155}}],line:494},'43':{loc:{start:{line:495,column:49},end:{line:495,column:157}},type:'cond-expr',locations:[{start:{line:495,column:101},end:{line:495,column:150}},{start:{line:495,column:153},end:{line:495,column:157}}],line:495},'44':{loc:{start:{line:511,column:65},end:{line:511,column:149}},type:'cond-expr',locations:[{start:{line:511,column:105},end:{line:511,column:142}},{start:{line:511,column:145},end:{line:511,column:149}}],line:511},'45':{loc:{start:{line:512,column:49},end:{line:512,column:137}},type:'cond-expr',locations:[{start:{line:512,column:91},end:{line:512,column:130}},{start:{line:512,column:133},end:{line:512,column:137}}],line:512},'46':{loc:{start:{line:525,column:8},end:{line:714,column:30}},type:'cond-expr',locations:[{start:{line:526,column:7},end:{line:713,column:26}},{start:{line:714,column:26},end:{line:714,column:30}}],line:525},'47':{loc:{start:{line:532,column:55},end:{line:532,column:131}},type:'cond-expr',locations:[{start:{line:532,column:91},end:{line:532,column:124}},{start:{line:532,column:127},end:{line:532,column:131}}],line:532},'48':{loc:{start:{line:533,column:53},end:{line:533,column:133}},type:'cond-expr',locations:[{start:{line:533,column:91},end:{line:533,column:126}},{start:{line:533,column:129},end:{line:533,column:133}}],line:533},'49':{loc:{start:{line:551,column:55},end:{line:551,column:155}},type:'cond-expr',locations:[{start:{line:551,column:103},end:{line:551,column:148}},{start:{line:551,column:151},end:{line:551,column:155}}],line:551},'50':{loc:{start:{line:552,column:53},end:{line:552,column:157}},type:'cond-expr',locations:[{start:{line:552,column:103},end:{line:552,column:150}},{start:{line:552,column:153},end:{line:552,column:157}}],line:552},'51':{loc:{start:{line:570,column:55},end:{line:570,column:153}},type:'cond-expr',locations:[{start:{line:570,column:102},end:{line:570,column:146}},{start:{line:570,column:149},end:{line:570,column:153}}],line:570},'52':{loc:{start:{line:571,column:53},end:{line:571,column:155}},type:'cond-expr',locations:[{start:{line:571,column:102},end:{line:571,column:148}},{start:{line:571,column:151},end:{line:571,column:155}}],line:571},'53':{loc:{start:{line:588,column:64},end:{line:588,column:156}},type:'cond-expr',locations:[{start:{line:588,column:108},end:{line:588,column:149}},{start:{line:588,column:152},end:{line:588,column:156}}],line:588},'54':{loc:{start:{line:589,column:53},end:{line:589,column:149}},type:'cond-expr',locations:[{start:{line:589,column:99},end:{line:589,column:142}},{start:{line:589,column:145},end:{line:589,column:149}}],line:589},'55':{loc:{start:{line:607,column:55},end:{line:607,column:153}},type:'cond-expr',locations:[{start:{line:607,column:102},end:{line:607,column:146}},{start:{line:607,column:149},end:{line:607,column:153}}],line:607},'56':{loc:{start:{line:608,column:53},end:{line:608,column:155}},type:'cond-expr',locations:[{start:{line:608,column:102},end:{line:608,column:148}},{start:{line:608,column:151},end:{line:608,column:155}}],line:608},'57':{loc:{start:{line:626,column:55},end:{line:626,column:157}},type:'cond-expr',locations:[{start:{line:626,column:104},end:{line:626,column:150}},{start:{line:626,column:153},end:{line:626,column:157}}],line:626},'58':{loc:{start:{line:627,column:53},end:{line:627,column:159}},type:'cond-expr',locations:[{start:{line:627,column:104},end:{line:627,column:152}},{start:{line:627,column:155},end:{line:627,column:159}}],line:627},'59':{loc:{start:{line:644,column:51},end:{line:644,column:155}},type:'cond-expr',locations:[{start:{line:644,column:101},end:{line:644,column:148}},{start:{line:644,column:151},end:{line:644,column:155}}],line:644},'60':{loc:{start:{line:645,column:49},end:{line:645,column:157}},type:'cond-expr',locations:[{start:{line:645,column:101},end:{line:645,column:150}},{start:{line:645,column:153},end:{line:645,column:157}}],line:645},'61':{loc:{start:{line:661,column:51},end:{line:661,column:169}},type:'cond-expr',locations:[{start:{line:661,column:108},end:{line:661,column:162}},{start:{line:661,column:165},end:{line:661,column:169}}],line:661},'62':{loc:{start:{line:662,column:49},end:{line:662,column:171}},type:'cond-expr',locations:[{start:{line:662,column:108},end:{line:662,column:164}},{start:{line:662,column:167},end:{line:662,column:171}}],line:662},'63':{loc:{start:{line:679,column:51},end:{line:679,column:165}},type:'cond-expr',locations:[{start:{line:679,column:106},end:{line:679,column:158}},{start:{line:679,column:161},end:{line:679,column:165}}],line:679},'64':{loc:{start:{line:680,column:49},end:{line:680,column:167}},type:'cond-expr',locations:[{start:{line:680,column:106},end:{line:680,column:160}},{start:{line:680,column:163},end:{line:680,column:167}}],line:680},'65':{loc:{start:{line:695,column:50},end:{line:695,column:153}},type:'cond-expr',locations:[{start:{line:695,column:97},end:{line:695,column:148}},{start:{line:695,column:151},end:{line:695,column:153}}],line:695},'66':{loc:{start:{line:697,column:51},end:{line:697,column:149}},type:'cond-expr',locations:[{start:{line:697,column:98},end:{line:697,column:142}},{start:{line:697,column:145},end:{line:697,column:149}}],line:697},'67':{loc:{start:{line:698,column:49},end:{line:698,column:151}},type:'cond-expr',locations:[{start:{line:698,column:98},end:{line:698,column:144}},{start:{line:698,column:147},end:{line:698,column:151}}],line:698}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0,'103':0,'104':0,'105':0,'106':0,'107':0,'108':0,'109':0,'110':0,'111':0,'112':0,'113':0,'114':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0,0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0],'48':[0,0],'49':[0,0],'50':[0,0],'51':[0,0],'52':[0,0],'53':[0,0],'54':[0,0],'55':[0,0],'56':[0,0],'57':[0,0],'58':[0,0],'59':[0,0],'60':[0,0],'61':[0,0],'62':[0,0],'63':[0,0],'64':[0,0],'65':[0,0],'66':[0,0],'67':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MachinesNewPage=function(_ref){_inherits(MachinesNewPage,_ref);function MachinesNewPage(props){_classCallCheck(this,MachinesNewPage);cov_5tuao0bxa.f[0]++;cov_5tuao0bxa.s[0]++;var _this=_possibleConstructorReturn(this,(MachinesNewPage.__proto__||Object.getPrototypeOf(MachinesNewPage)).call(this,props));_this.defaultFormState={name:{state:false,message:false},multihead:{state:false,message:false},heads:{state:false,message:false},investment:{state:false,message:false},amortization_months:{state:false,message:false},speed:{state:false,message:false},color_change_time:{state:false,message:false},bobbin_stitch_count:{state:false,message:false},bobbin_change_time:{state:false,message:false},stitches_next_thread_break:{state:false,message:false},thread_break_fixing_time:{state:false,message:false},hoop_change_time:{state:false,message:false},trimming_time:{state:false,message:false},cone_change_time:{state:false,message:false},maintenance_cost:{state:false,message:false}};_this.defaultMessageState={show:false,message:null};_this.componentDidMount=function(){cov_5tuao0bxa.f[1]++;cov_5tuao0bxa.s[2]++;_this.props.onFetchMachinesDefaults();};_this.componentWillUnmount=function(){cov_5tuao0bxa.f[2]++;cov_5tuao0bxa.s[3]++;_this.props.onResetMachine();cov_5tuao0bxa.s[4]++;_this.props.onCalculatorMachineDuplicateCheckReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_5tuao0bxa.f[3]++;cov_5tuao0bxa.s[5]++;if(prevProps.calculatorMachinesDefaults!==_this.props.calculatorMachinesDefaults){cov_5tuao0bxa.b[0][0]++;cov_5tuao0bxa.s[6]++;_this.defaultValueHandler();}else{cov_5tuao0bxa.b[0][1]++;}cov_5tuao0bxa.s[7]++;if(prevProps.defaults!==_this.props.defaults){cov_5tuao0bxa.b[1][0]++;cov_5tuao0bxa.s[8]++;_this.setState(function(prevState){cov_5tuao0bxa.f[4]++;cov_5tuao0bxa.s[9]++;return{wizard:Object.assign({},prevState.wizard,{steps:[{name:_this.props.translate('machinenewpage.step_1.name'),active:true},{name:_this.props.translate('machinenewpage.step_2.name'),active:false}]})};});}else{cov_5tuao0bxa.b[1][1]++;}//Duplicate Check
cov_5tuao0bxa.s[10]++;if((cov_5tuao0bxa.b[3][0]++,!prevProps.state.name_checked)&&(cov_5tuao0bxa.b[3][1]++,_this.props.state.name_checked)){cov_5tuao0bxa.b[2][0]++;cov_5tuao0bxa.s[11]++;_this.setState(function(prevState){cov_5tuao0bxa.f[5]++;cov_5tuao0bxa.s[12]++;return{form_blocked:!_this.props.state.name_available?(cov_5tuao0bxa.b[4][0]++,true):(cov_5tuao0bxa.b[4][1]++,false),form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:_this.props.state.name_available?(cov_5tuao0bxa.b[5][0]++,'success'):(cov_5tuao0bxa.b[5][1]++,'error'),message:!_this.props.state.name_available?(cov_5tuao0bxa.b[6][0]++,_this.props.translate('machinenewpage.error.name_exists')):(cov_5tuao0bxa.b[6][1]++,null)})})};});cov_5tuao0bxa.s[13]++;if(_this.state.willSubmit){cov_5tuao0bxa.b[7][0]++;cov_5tuao0bxa.s[14]++;_this.setState(function(prevState){cov_5tuao0bxa.f[6]++;cov_5tuao0bxa.s[15]++;return{willSubmit:false};},function(){cov_5tuao0bxa.f[7]++;cov_5tuao0bxa.s[16]++;if(_this.props.state.name_available){cov_5tuao0bxa.b[8][0]++;cov_5tuao0bxa.s[17]++;_this.submitHandler();}else{cov_5tuao0bxa.b[8][1]++;}});}else{cov_5tuao0bxa.b[7][1]++;}}else{cov_5tuao0bxa.b[2][1]++;}cov_5tuao0bxa.s[18]++;if((cov_5tuao0bxa.b[10][0]++,prevProps.state.error!==_this.props.state.error)&&(cov_5tuao0bxa.b[10][1]++,_this.props.state.error)&&(cov_5tuao0bxa.b[10][2]++,_this.props.state.error.length)&&(cov_5tuao0bxa.b[10][3]++,_this.props.state.error[0].key.toLowerCase()!=='last')){cov_5tuao0bxa.b[9][0]++;cov_5tuao0bxa.s[19]++;if(_this.props.state.error.length){cov_5tuao0bxa.b[11][0]++;cov_5tuao0bxa.s[20]++;_this.setState(function(prevState){cov_5tuao0bxa.f[8]++;cov_5tuao0bxa.s[21]++;return{form_state:_this.defaultFormState};},function(){cov_5tuao0bxa.f[9]++;cov_5tuao0bxa.s[22]++;_this.props.state.error.forEach(function(error,index){cov_5tuao0bxa.f[10]++;cov_5tuao0bxa.s[23]++;if(_this.state.form_state[error.source]){cov_5tuao0bxa.b[12][0]++;cov_5tuao0bxa.s[24]++;_this.setState(function(prevState){cov_5tuao0bxa.f[11]++;cov_5tuao0bxa.s[25]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))};});}else{cov_5tuao0bxa.b[12][1]++;}});});}else{cov_5tuao0bxa.b[11][1]++;}cov_5tuao0bxa.s[26]++;if(_this.props.state.error.length===1){cov_5tuao0bxa.b[13][0]++;cov_5tuao0bxa.s[27]++;_this.setState(function(prevState){cov_5tuao0bxa.f[12]++;cov_5tuao0bxa.s[28]++;return{message:{message:_this.props.translate('machinenewpage.error.'+_this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('machinenewpage.error.default')}),type:"error"}};});}else{cov_5tuao0bxa.b[13][1]++;cov_5tuao0bxa.s[29]++;_this.setState(function(prevState){cov_5tuao0bxa.f[13]++;cov_5tuao0bxa.s[30]++;return{message:{message:_this.props.translate('machinenewpage.error.default'),type:"error"}};});}}else{cov_5tuao0bxa.b[9][1]++;}cov_5tuao0bxa.s[31]++;if(_this.props.state.created){cov_5tuao0bxa.b[14][0]++;cov_5tuao0bxa.s[32]++;__WEBPACK_IMPORTED_MODULE_10_react_redux_toastr__["toastr"].success(_this.props.translate('machinespage.success.created.title'),_this.props.translate('machinespage.success.created.text'));}else{cov_5tuao0bxa.b[14][1]++;}};_this.defaultValueHandler=function(event){cov_5tuao0bxa.f[14]++;cov_5tuao0bxa.s[33]++;if(event){cov_5tuao0bxa.b[15][0]++;var configPos=(cov_5tuao0bxa.s[34]++,event.target.value-1);}else{cov_5tuao0bxa.b[15][1]++;var configPos=(cov_5tuao0bxa.s[35]++,0);}cov_5tuao0bxa.s[36]++;if(_this.props.calculatorMachinesDefaults.machines[configPos]){cov_5tuao0bxa.b[16][0]++;cov_5tuao0bxa.s[37]++;_this.setState(function(prevState){cov_5tuao0bxa.f[15]++;cov_5tuao0bxa.s[38]++;return{form:Object.assign({},prevState.form,{multihead:_this.props.calculatorMachinesDefaults.machines[configPos].multihead,heads:_this.props.calculatorMachinesDefaults.machines[configPos].heads,amortization_months:_this.props.calculatorMachinesDefaults.machines[configPos].amortization_months,speed:_this.props.calculatorMachinesDefaults.machines[configPos].settings.speed,color_change_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.color_change_time,bobbin_stitch_count:_this.props.calculatorMachinesDefaults.machines[configPos].settings.bobbin_stitch_count,bobbin_change_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.bobbin_change_time,stitches_next_thread_break:_this.props.calculatorMachinesDefaults.machines[configPos].settings.stitches_next_thread_break,thread_break_fixing_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.thread_break_fixing_time,hoop_change_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.hoop_change_time,trimming_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.trimming_time,cone_change_time:_this.props.calculatorMachinesDefaults.machines[configPos].settings.cone_change_time,maintenance_cost:_this.props.calculatorMachinesDefaults.machines[configPos].settings.maintenance_cost})};});}else{cov_5tuao0bxa.b[16][1]++;}};_this.newMachineHandler=function(event){cov_5tuao0bxa.f[16]++;cov_5tuao0bxa.s[39]++;event.preventDefault();cov_5tuao0bxa.s[40]++;if(_this.state.wizard.steps[0].active){cov_5tuao0bxa.b[17][0]++;cov_5tuao0bxa.s[41]++;if((cov_5tuao0bxa.b[19][0]++,_this.props.state.name_checked)&&(cov_5tuao0bxa.b[19][1]++,_this.props.state.name_available)){cov_5tuao0bxa.b[18][0]++;cov_5tuao0bxa.s[42]++;_this.submitHandler();}else{cov_5tuao0bxa.b[18][1]++;cov_5tuao0bxa.s[43]++;_this.setState(function(prevState){cov_5tuao0bxa.f[17]++;cov_5tuao0bxa.s[44]++;return{willSubmit:true};},function(){cov_5tuao0bxa.f[18]++;cov_5tuao0bxa.s[45]++;_this.duplicateCheckHandler();});}}else{cov_5tuao0bxa.b[17][1]++;cov_5tuao0bxa.s[46]++;_this.submitHandler();}};_this.inputChangedToggle=function(value,inputIdentifier){cov_5tuao0bxa.f[19]++;cov_5tuao0bxa.s[47]++;_this.setState(function(prevState){cov_5tuao0bxa.f[20]++;cov_5tuao0bxa.s[48]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputChangedHandler=function(event,inputIdentifier){cov_5tuao0bxa.f[21]++;var value=(cov_5tuao0bxa.s[49]++,event.target.value);cov_5tuao0bxa.s[50]++;_this.setState(function(prevState){cov_5tuao0bxa.f[22]++;cov_5tuao0bxa.s[51]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});cov_5tuao0bxa.s[52]++;if(inputIdentifier==="heads"){cov_5tuao0bxa.b[20][0]++;cov_5tuao0bxa.s[53]++;_this.defaultValueHandler(event);}else{cov_5tuao0bxa.b[20][1]++;}};_this.inputBlurredHandler=function(event,inputIdentifier){cov_5tuao0bxa.f[23]++;cov_5tuao0bxa.s[54]++;if(inputIdentifier==='name'){cov_5tuao0bxa.b[21][0]++;cov_5tuao0bxa.s[55]++;_this.duplicateCheckHandler();}else{cov_5tuao0bxa.b[21][1]++;}cov_5tuao0bxa.s[56]++;__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier]]);cov_5tuao0bxa.s[57]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_5tuao0bxa.b[22][0]++;cov_5tuao0bxa.s[58]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_5tuao0bxa.b[22][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_5tuao0bxa.f[24]++;cov_5tuao0bxa.s[59]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_5tuao0bxa.b[23][0]++;cov_5tuao0bxa.s[60]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_5tuao0bxa.b[23][1]++;}};_this.duplicateCheckHandler=function(){cov_5tuao0bxa.f[25]++;cov_5tuao0bxa.s[61]++;if(_this.state.wizard.steps[0].active){cov_5tuao0bxa.b[24][0]++;cov_5tuao0bxa.s[62]++;if(_this.refs.name.props.value.length){cov_5tuao0bxa.b[25][0]++;cov_5tuao0bxa.s[63]++;_this.setState(function(prevState){cov_5tuao0bxa.f[26]++;cov_5tuao0bxa.s[64]++;return{form_blocked:true,form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:'loading'})})};},function(){cov_5tuao0bxa.f[27]++;cov_5tuao0bxa.s[65]++;_this.props.onCalculatorMachineDuplicateCheck({name:_this.refs.name.props.value});});}else{cov_5tuao0bxa.b[25][1]++;cov_5tuao0bxa.s[66]++;_this.setState(function(prevState){cov_5tuao0bxa.f[28]++;cov_5tuao0bxa.s[67]++;return{form_blocked:false,form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:false})})};},function(){cov_5tuao0bxa.f[29]++;cov_5tuao0bxa.s[68]++;_this.submitHandler();});}}else{cov_5tuao0bxa.b[24][1]++;cov_5tuao0bxa.s[69]++;if(_this.state.willSubmit){cov_5tuao0bxa.b[26][0]++;cov_5tuao0bxa.s[70]++;_this.submitHandler();}else{cov_5tuao0bxa.b[26][1]++;}}};_this.submitHandler=function(event){cov_5tuao0bxa.f[30]++;cov_5tuao0bxa.s[71]++;_this.setState(function(prevState){cov_5tuao0bxa.f[31]++;cov_5tuao0bxa.s[72]++;return{message:_this.defaultMessageState};});var formData=(cov_5tuao0bxa.s[73]++,{name:_this.state.form.name,heads:Number.parseInt(_this.state.form.heads),multihead:_this.state.form.multihead,investment:Number.parseInt(_this.state.form.investment),amortization_months:Number.parseInt(_this.state.form.amortization_months),settings:{speed:Number.parseInt(_this.state.form.speed),color_change_time:Number.parseInt(_this.state.form.color_change_time),bobbin_stitch_count:Number.parseInt(_this.state.form.bobbin_stitch_count),bobbin_change_time:Number.parseInt(_this.state.form.bobbin_change_time),stitches_next_thread_break:Number.parseInt(_this.state.form.stitches_next_thread_break),thread_break_fixing_time:Number.parseInt(_this.state.form.thread_break_fixing_time),hoop_change_time:Number.parseInt(_this.state.form.hoop_change_time),trimming_time:Number.parseInt(_this.state.form.trimming_time),cone_change_time:Number.parseInt(_this.state.form.cone_change_time),maintenance_cost:Number.parseInt(_this.state.form.maintenance_cost)}});//Step 1
cov_5tuao0bxa.s[74]++;if(_this.state.wizard.steps[0].active){cov_5tuao0bxa.b[27][0]++;cov_5tuao0bxa.s[75]++;_this.setState(function(prevState){cov_5tuao0bxa.f[32]++;cov_5tuao0bxa.s[76]++;return{willSubmit:false};},function(){cov_5tuao0bxa.f[33]++;cov_5tuao0bxa.s[77]++;if(__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[['name','investment','amortization_months']])){cov_5tuao0bxa.b[28][0]++;var steps=(cov_5tuao0bxa.s[78]++,[].concat(_toConsumableArray(_this.state.wizard.steps)));cov_5tuao0bxa.s[79]++;steps[1].active=true;cov_5tuao0bxa.s[80]++;steps[0].active=false;cov_5tuao0bxa.s[81]++;_this.setState(function(prevState){cov_5tuao0bxa.f[34]++;cov_5tuao0bxa.s[82]++;return{message:Object.assign({},prevState.message,{show:false}),wizard:Object.assign({},prevState.wizard,{steps:steps})};},function(){cov_5tuao0bxa.f[35]++;cov_5tuao0bxa.s[83]++;return __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});}else{cov_5tuao0bxa.b[28][1]++;cov_5tuao0bxa.s[84]++;_this.setState(function(prevState){cov_5tuao0bxa.f[36]++;cov_5tuao0bxa.s[85]++;return{message:{show:true,message:_this.props.translate('machinenewpage.error.default'),type:"error"}};});}});}else{cov_5tuao0bxa.b[27][1]++;cov_5tuao0bxa.s[86]++;if(_this.state.wizard.steps[1].active){cov_5tuao0bxa.b[29][0]++;cov_5tuao0bxa.s[87]++;_this.setState(function(prevState){cov_5tuao0bxa.f[37]++;cov_5tuao0bxa.s[88]++;return{willSubmit:false};},function(){cov_5tuao0bxa.f[38]++;cov_5tuao0bxa.s[89]++;if(__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[['speed','color_change_time','bobbin_stitch_count','bobbin_change_time','stitches_next_thread_break','thread_break_fixing_time','hoop_change_time','trimming_time','cone_change_time','maintenance_cost']])){cov_5tuao0bxa.b[30][0]++;cov_5tuao0bxa.s[90]++;_this.props.onCreateMachine(formData);}else{cov_5tuao0bxa.b[30][1]++;cov_5tuao0bxa.s[91]++;_this.setState(function(prevState){cov_5tuao0bxa.f[39]++;cov_5tuao0bxa.s[92]++;return{message:{show:true,message:_this.props.translate('machinenewpage.error.default'),type:"error"}};});}});}else{cov_5tuao0bxa.b[29][1]++;}}};_this.timesIterator=function(n){cov_5tuao0bxa.f[40]++;cov_5tuao0bxa.s[93]++;return function(f){cov_5tuao0bxa.f[41]++;cov_5tuao0bxa.s[94]++;var iter=function iter(i){cov_5tuao0bxa.f[42]++;cov_5tuao0bxa.s[95]++;if(i===n){cov_5tuao0bxa.b[31][0]++;cov_5tuao0bxa.s[96]++;return;}else{cov_5tuao0bxa.b[31][1]++;}cov_5tuao0bxa.s[97]++;f(i);cov_5tuao0bxa.s[98]++;iter(i+1);};cov_5tuao0bxa.s[99]++;return iter(0);};};cov_5tuao0bxa.s[1]++;_this.state={form:{name:"",multihead:false,heads:1,investment:0,amortization_months:0,speed:0,color_change_time:0,bobbin_stitch_count:0,bobbin_change_time:0,stitches_next_thread_break:0,thread_break_fixing_time:0,hoop_change_time:0,trimming_time:0,cone_change_time:0,maintenance_cost:0},form_state:_this.defaultFormState,message:_this.defaultMessageState,form_blocked:false,willSubmit:false,wizard:{steps:[{name:_this.props.translate('machinenewpage.step_1.name'),active:true},{name:_this.props.translate('machinenewpage.step_2.name'),active:false}]}};return _this;}_createClass(MachinesNewPage,[{key:'render',value:function render(){var _this2=this;cov_5tuao0bxa.f[43]++;var headConfig=(cov_5tuao0bxa.s[100]++,[]);cov_5tuao0bxa.s[101]++;this.timesIterator(20)(function(i){cov_5tuao0bxa.f[44]++;cov_5tuao0bxa.s[102]++;headConfig.push({value:i+1,name:i+1+" "+_this2.props.translate('global.machine.head.multiple')});});var showMessage;cov_5tuao0bxa.s[103]++;if(this.state.message.message){cov_5tuao0bxa.b[32][0]++;cov_5tuao0bxa.s[104]++;showMessage=this.state.message;}else{cov_5tuao0bxa.b[32][1]++;}cov_5tuao0bxa.s[105]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__hoc_Aux__["a" /* default */],null,this.props.state.created?(cov_5tuao0bxa.b[33][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/machines'})):(cov_5tuao0bxa.b[33][1]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Form"],{onSubmit:this.newMachineHandler},this.state.wizard.steps[0].active?(cov_5tuao0bxa.b[34][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["GreyBox"],{title:this.props.translate('machinenewpage.title'),msg:showMessage,steps:this.state.wizard.steps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.name'),ref:'nameInputRow',state:this.state.form_state.name.state?(cov_5tuao0bxa.b[35][0]++,this.state.form_state.name.state):(cov_5tuao0bxa.b[35][1]++,null),tip:this.state.form_state.name.message?(cov_5tuao0bxa.b[36][0]++,this.state.form_state.name.message):(cov_5tuao0bxa.b[36][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'name',ref:'name',type:'text',value:this.state.form.name,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,maxlength:50,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.heads'),cols:'2',ref:'headsInputRow',state:this.state.form_state.heads.state?(cov_5tuao0bxa.b[37][0]++,this.state.form_state.heads.state):(cov_5tuao0bxa.b[37][1]++,null),tip:this.state.form_state.heads.message?(cov_5tuao0bxa.b[38][0]++,this.state.form_state.heads.message):(cov_5tuao0bxa.b[38][1]++,null),hint:this.props.translate('global.help.machine.heads')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Select"],{identifier:'heads',ref:'heads',options:headConfig,value:this.state.form.heads,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.investment'),unit:this.props.settingsCompany.settings.currency?(cov_5tuao0bxa.b[39][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_5tuao0bxa.b[39][1]++,""),cols:'2',ref:'investmentInputRow',state:this.state.form_state.investment.state?(cov_5tuao0bxa.b[40][0]++,this.state.form_state.investment.state):(cov_5tuao0bxa.b[40][1]++,null),tip:this.state.form_state.investment.message?(cov_5tuao0bxa.b[41][0]++,this.state.form_state.investment.message):(cov_5tuao0bxa.b[41][1]++,null),hint:this.props.translate('global.help.machine.investment')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'investment',ref:'investment',type:'number',minValue:0,maxValue:99999999,value:this.state.form.investment,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.amortization_months'),unit:this.props.translate('global.units.months'),ref:'amortization_monthsInputRow',state:this.state.form_state.amortization_months.state?(cov_5tuao0bxa.b[42][0]++,this.state.form_state.amortization_months.state):(cov_5tuao0bxa.b[42][1]++,null),tip:this.state.form_state.amortization_months.message?(cov_5tuao0bxa.b[43][0]++,this.state.form_state.amortization_months.message):(cov_5tuao0bxa.b[43][1]++,null),hint:this.props.translate('global.help.machine.amortization_months')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'amortization_months',ref:'amortization_months',type:'number',minValue:0,maxValue:240,value:this.state.form.amortization_months,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.multihead'),ref:'multiheadInputRow',theme:'light',state:this.state.form_state.multihead.state?(cov_5tuao0bxa.b[44][0]++,this.state.form_state.multihead.state):(cov_5tuao0bxa.b[44][1]++,null),tip:this.state.form_state.multihead.message?(cov_5tuao0bxa.b[45][0]++,this.state.form_state.multihead.message):(cov_5tuao0bxa.b[45][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Toggle"],{identifier:'multihead',ref:'multihead',value:this.state.form.multihead,changed:this.inputChangedToggle,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{'data-cy':'create-new-machine-continue-btn',value:this.props.translate('machinenewpage.step_1.submit'),type:'submit'}))):(cov_5tuao0bxa.b[34][1]++,null),this.state.wizard.steps[1].active?(cov_5tuao0bxa.b[46][0]++,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["GreyBox"],{title:this.props.translate('machinenewpage.title'),msg:showMessage,steps:this.state.wizard.steps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.speed'),unit:this.props.translate('global.units.spm'),cols:'2',ref:'speedInputRow',state:this.state.form_state.speed.state?(cov_5tuao0bxa.b[47][0]++,this.state.form_state.speed.state):(cov_5tuao0bxa.b[47][1]++,null),tip:this.state.form_state.speed.message?(cov_5tuao0bxa.b[48][0]++,this.state.form_state.speed.message):(cov_5tuao0bxa.b[48][1]++,null),hint:this.props.translate('global.help.machine.speed')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'speed',ref:'speed',type:'number',minValue:1,maxValue:2000,value:this.state.form.speed,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.color_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'color_change_timeInputRow',state:this.state.form_state.color_change_time.state?(cov_5tuao0bxa.b[49][0]++,this.state.form_state.color_change_time.state):(cov_5tuao0bxa.b[49][1]++,null),tip:this.state.form_state.color_change_time.message?(cov_5tuao0bxa.b[50][0]++,this.state.form_state.color_change_time.message):(cov_5tuao0bxa.b[50][1]++,null),hint:this.props.translate('global.help.machine.color_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'color_change_time',ref:'color_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.color_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.hoop_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'hoop_change_timeInputRow',state:this.state.form_state.hoop_change_time.state?(cov_5tuao0bxa.b[51][0]++,this.state.form_state.hoop_change_time.state):(cov_5tuao0bxa.b[51][1]++,null),tip:this.state.form_state.hoop_change_time.message?(cov_5tuao0bxa.b[52][0]++,this.state.form_state.hoop_change_time.message):(cov_5tuao0bxa.b[52][1]++,null),hint:this.props.translate('global.help.machine.hoop_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'hoop_change_time',ref:'hoop_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.hoop_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.trimming_time'),unit:this.props.translate('global.units.seconds'),ref:'trimming_timeInputRow',cols:'2',state:this.state.form_state.trimming_time.state?(cov_5tuao0bxa.b[53][0]++,this.state.form_state.trimming_time.state):(cov_5tuao0bxa.b[53][1]++,null),tip:this.state.form_state.trimming_time.message?(cov_5tuao0bxa.b[54][0]++,this.state.form_state.trimming_time.message):(cov_5tuao0bxa.b[54][1]++,null),hint:this.props.translate('global.help.machine.trimming_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'trimming_time',ref:'trimming_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.trimming_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.cone_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'cone_change_timeInputRow',state:this.state.form_state.cone_change_time.state?(cov_5tuao0bxa.b[55][0]++,this.state.form_state.cone_change_time.state):(cov_5tuao0bxa.b[55][1]++,null),tip:this.state.form_state.cone_change_time.message?(cov_5tuao0bxa.b[56][0]++,this.state.form_state.cone_change_time.message):(cov_5tuao0bxa.b[56][1]++,null),hint:this.props.translate('global.help.machine.cone_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'cone_change_time',ref:'cone_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.cone_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'bobbin_change_timeInputRow',state:this.state.form_state.bobbin_change_time.state?(cov_5tuao0bxa.b[57][0]++,this.state.form_state.bobbin_change_time.state):(cov_5tuao0bxa.b[57][1]++,null),tip:this.state.form_state.bobbin_change_time.message?(cov_5tuao0bxa.b[58][0]++,this.state.form_state.bobbin_change_time.message):(cov_5tuao0bxa.b[58][1]++,null),hint:this.props.translate('global.help.machine.bobbin_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'bobbin_change_time',ref:'bobbin_change_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.bobbin_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_stitch_count'),ref:'bobbin_stitch_countInputRow',state:this.state.form_state.bobbin_stitch_count.state?(cov_5tuao0bxa.b[59][0]++,this.state.form_state.bobbin_stitch_count.state):(cov_5tuao0bxa.b[59][1]++,null),tip:this.state.form_state.bobbin_stitch_count.message?(cov_5tuao0bxa.b[60][0]++,this.state.form_state.bobbin_stitch_count.message):(cov_5tuao0bxa.b[60][1]++,null),hint:this.props.translate('global.help.machine.bobbin_stitch_count')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'bobbin_stitch_count',ref:'bobbin_stitch_count',type:'number',minValue:1,maxValue:100000,value:this.state.form.bobbin_stitch_count,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.stitches_next_thread_break'),ref:'stitches_next_thread_breakInputRow',state:this.state.form_state.stitches_next_thread_break.state?(cov_5tuao0bxa.b[61][0]++,this.state.form_state.stitches_next_thread_break.state):(cov_5tuao0bxa.b[61][1]++,null),tip:this.state.form_state.stitches_next_thread_break.message?(cov_5tuao0bxa.b[62][0]++,this.state.form_state.stitches_next_thread_break.message):(cov_5tuao0bxa.b[62][1]++,null),hint:this.props.translate('global.help.machine.stitches_next_thread_break')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'stitches_next_thread_break',ref:'stitches_next_thread_break',type:'number',minValue:1,maxValue:999999,value:this.state.form.stitches_next_thread_break,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.thread_break_fixing_time'),unit:this.props.translate('global.units.seconds'),ref:'thread_break_fixing_timeInputRow',state:this.state.form_state.thread_break_fixing_time.state?(cov_5tuao0bxa.b[63][0]++,this.state.form_state.thread_break_fixing_time.state):(cov_5tuao0bxa.b[63][1]++,null),tip:this.state.form_state.thread_break_fixing_time.message?(cov_5tuao0bxa.b[64][0]++,this.state.form_state.thread_break_fixing_time.message):(cov_5tuao0bxa.b[64][1]++,null),hint:this.props.translate('global.help.machine.thread_break_fixing_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'thread_break_fixing_time',ref:'thread_break_fixing_time',type:'number',minValue:1,maxValue:1200,value:this.state.form.thread_break_fixing_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["InputRow"],{label:this.props.translate('global.form.label.machine.maintenance_cost'),unit:this.props.settingsCompany.settings.currency?(cov_5tuao0bxa.b[65][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_5tuao0bxa.b[65][1]++,""),ref:'maintenance_costInputRow',state:this.state.form_state.maintenance_cost.state?(cov_5tuao0bxa.b[66][0]++,this.state.form_state.maintenance_cost.state):(cov_5tuao0bxa.b[66][1]++,null),tip:this.state.form_state.maintenance_cost.message?(cov_5tuao0bxa.b[67][0]++,this.state.form_state.maintenance_cost.message):(cov_5tuao0bxa.b[67][1]++,null),hint:this.props.translate('global.help.machine.maintenance_cost')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Input"],{identifier:'maintenance_cost',ref:'maintenance_cost',type:'number',minValue:0,maxValue:9999999,value:this.state.form.maintenance_cost,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{'data-cy':'create-new-machine-create-btn',value:this.props.translate('machinenewpage.step_2.submit'),type:'submit'}))):(cov_5tuao0bxa.b[46][1]++,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Box"],{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Text"],{size:'small',align:'center'},this.props.translate('machinenewpage.secondary.text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Button"],{'data-cy':'cancel-new-machine-btn',outerMargin:'true',href:'/machines',theme:'light',value:this.props.translate('machinenewpage.secondary.label'),width:'320px'}))))));}}]);return MachinesNewPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_5tuao0bxa.s[106]++;var mapStateToProps=function mapStateToProps(state){cov_5tuao0bxa.f[45]++;cov_5tuao0bxa.s[107]++;return{defaults:state.defaults,calculatorMachinesDefaults:state.calculatorMachinesDefaults,state:state.calculatorMachine,translate:Object(__WEBPACK_IMPORTED_MODULE_7_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_5tuao0bxa.s[108]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_5tuao0bxa.f[46]++;cov_5tuao0bxa.s[109]++;return{onCreateMachine:function onCreateMachine(formData){cov_5tuao0bxa.f[47]++;cov_5tuao0bxa.s[110]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["F" /* calculatorMachineCreate */](formData));},onFetchMachinesDefaults:function onFetchMachinesDefaults(){cov_5tuao0bxa.f[48]++;cov_5tuao0bxa.s[111]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["P" /* calculatorMachinesDefaultsFetch */]());},onResetMachine:function onResetMachine(){cov_5tuao0bxa.f[49]++;cov_5tuao0bxa.s[112]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["G" /* calculatorMachineCreateReset */]());},onCalculatorMachineDuplicateCheck:function onCalculatorMachineDuplicateCheck(formData){cov_5tuao0bxa.f[50]++;cov_5tuao0bxa.s[113]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["J" /* calculatorMachineDuplicateCheck */](formData));},onCalculatorMachineDuplicateCheckReset:function onCalculatorMachineDuplicateCheckReset(){cov_5tuao0bxa.f[51]++;cov_5tuao0bxa.s[114]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["K" /* calculatorMachineDuplicateCheckReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(MachinesNewPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EditMachineModal__ = __webpack_require__(674);
var cov_16yk30izsp=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesPage\\index.js',hash='5f468e66a4e70529a5e47d5a44e0a402ca29104c',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesPage\\index.js',statementMap:{'0':{start:{line:20,column:2},end:{line:20,column:31}},'1':{start:{line:26,column:2},end:{line:39,column:3}},'2':{start:{line:27,column:3},end:{line:31,column:6}},'3':{start:{line:30,column:4},end:{line:30,column:58}},'4':{start:{line:33,column:7},end:{line:39,column:3}},'5':{start:{line:34,column:3},end:{line:38,column:5}},'6':{start:{line:37,column:4},end:{line:37,column:31}},'7':{start:{line:40,column:2},end:{line:44,column:3}},'8':{start:{line:41,column:12},end:{line:41,column:146}},'9':{start:{line:42,column:6},end:{line:42,column:44}},'10':{start:{line:43,column:3},end:{line:43,column:32}},'11':{start:{line:45,column:2},end:{line:47,column:3}},'12':{start:{line:46,column:3},end:{line:46,column:26}},'13':{start:{line:50,column:5},end:{line:50,column:33}},'14':{start:{line:51,column:5},end:{line:51,column:43}},'15':{start:{line:55,column:5},end:{line:55,column:28}},'16':{start:{line:56,column:5},end:{line:56,column:45}},'17':{start:{line:59,column:5},end:{line:59,column:28}},'18':{start:{line:60,column:5},end:{line:60,column:42}},'19':{start:{line:63,column:5},end:{line:63,column:28}},'20':{start:{line:64,column:5},end:{line:64,column:70}},'21':{start:{line:65,column:5},end:{line:65,column:45}},'22':{start:{line:69,column:21},end:{line:69,column:23}},'23':{start:{line:70,column:2},end:{line:72,column:3}},'24':{start:{line:71,column:3},end:{line:71,column:116}},'25':{start:{line:73,column:16},end:{line:73,column:18}},'26':{start:{line:74,column:2},end:{line:78,column:3}},'27':{start:{line:75,column:3},end:{line:77,column:4}},'28':{start:{line:79,column:4},end:{line:89,column:5}},'29':{start:{line:84,column:8},end:{line:84,column:117}},'30':{start:{line:93,column:24},end:{line:100,column:1}},'31':{start:{line:94,column:4},end:{line:99,column:6}},'32':{start:{line:102,column:27},end:{line:110,column:1}},'33':{start:{line:103,column:4},end:{line:109,column:5}},'34':{start:{line:104,column:31},end:{line:104,column:81}},'35':{start:{line:105,column:32},end:{line:105,column:83}},'36':{start:{line:106,column:30},end:{line:106,column:84}},'37':{start:{line:107,column:43},end:{line:107,column:95}},'38':{start:{line:108,column:40},end:{line:108,column:95}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:19,column:1},end:{line:19,column:2}},loc:{start:{line:19,column:21},end:{line:24,column:2}},line:19},'1':{name:'(anonymous_1)',decl:{start:{line:25,column:1},end:{line:25,column:2}},loc:{start:{line:25,column:22},end:{line:48,column:2}},line:25},'2':{name:'(anonymous_2)',decl:{start:{line:29,column:5},end:{line:29,column:6}},loc:{start:{line:29,column:11},end:{line:31,column:4}},line:29},'3':{name:'(anonymous_3)',decl:{start:{line:36,column:5},end:{line:36,column:6}},loc:{start:{line:37,column:4},end:{line:37,column:31}},line:37},'4':{name:'(anonymous_4)',decl:{start:{line:49,column:27},end:{line:49,column:28}},loc:{start:{line:49,column:33},end:{line:52,column:5}},line:49},'5':{name:'(anonymous_5)',decl:{start:{line:54,column:28},end:{line:54,column:29}},loc:{start:{line:54,column:41},end:{line:57,column:5}},line:54},'6':{name:'(anonymous_6)',decl:{start:{line:58,column:29},end:{line:58,column:30}},loc:{start:{line:58,column:46},end:{line:61,column:5}},line:58},'7':{name:'(anonymous_7)',decl:{start:{line:62,column:22},end:{line:62,column:23}},loc:{start:{line:62,column:35},end:{line:66,column:5}},line:62},'8':{name:'(anonymous_8)',decl:{start:{line:68,column:1},end:{line:68,column:2}},loc:{start:{line:68,column:10},end:{line:90,column:2}},line:68},'9':{name:'(anonymous_9)',decl:{start:{line:83,column:38},end:{line:83,column:39}},loc:{start:{line:84,column:8},end:{line:84,column:117}},line:84},'10':{name:'(anonymous_10)',decl:{start:{line:93,column:24},end:{line:93,column:25}},loc:{start:{line:93,column:33},end:{line:100,column:1}},line:93},'11':{name:'(anonymous_11)',decl:{start:{line:102,column:27},end:{line:102,column:28}},loc:{start:{line:102,column:39},end:{line:110,column:1}},line:102},'12':{name:'(anonymous_12)',decl:{start:{line:104,column:25},end:{line:104,column:26}},loc:{start:{line:104,column:31},end:{line:104,column:81}},line:104},'13':{name:'(anonymous_13)',decl:{start:{line:105,column:24},end:{line:105,column:25}},loc:{start:{line:105,column:32},end:{line:105,column:83}},line:105},'14':{name:'(anonymous_14)',decl:{start:{line:106,column:24},end:{line:106,column:25}},loc:{start:{line:106,column:30},end:{line:106,column:84}},line:106},'15':{name:'(anonymous_15)',decl:{start:{line:107,column:35},end:{line:107,column:36}},loc:{start:{line:107,column:43},end:{line:107,column:95}},line:107},'16':{name:'(anonymous_16)',decl:{start:{line:108,column:34},end:{line:108,column:35}},loc:{start:{line:108,column:40},end:{line:108,column:95}},line:108}},branchMap:{'0':{loc:{start:{line:26,column:2},end:{line:39,column:3}},type:'if',locations:[{start:{line:26,column:2},end:{line:39,column:3}},{start:{line:26,column:2},end:{line:39,column:3}}],line:26},'1':{loc:{start:{line:26,column:5},end:{line:26,column:61}},type:'binary-expr',locations:[{start:{line:26,column:5},end:{line:26,column:31}},{start:{line:26,column:35},end:{line:26,column:61}}],line:26},'2':{loc:{start:{line:33,column:7},end:{line:39,column:3}},type:'if',locations:[{start:{line:33,column:7},end:{line:39,column:3}},{start:{line:33,column:7},end:{line:39,column:3}}],line:33},'3':{loc:{start:{line:33,column:10},end:{line:33,column:66}},type:'binary-expr',locations:[{start:{line:33,column:10},end:{line:33,column:35}},{start:{line:33,column:39},end:{line:33,column:66}}],line:33},'4':{loc:{start:{line:40,column:2},end:{line:44,column:3}},type:'if',locations:[{start:{line:40,column:2},end:{line:44,column:3}},{start:{line:40,column:2},end:{line:44,column:3}}],line:40},'5':{loc:{start:{line:45,column:2},end:{line:47,column:3}},type:'if',locations:[{start:{line:45,column:2},end:{line:47,column:3}},{start:{line:45,column:2},end:{line:47,column:3}}],line:45},'6':{loc:{start:{line:70,column:2},end:{line:72,column:3}},type:'if',locations:[{start:{line:70,column:2},end:{line:72,column:3}},{start:{line:70,column:2},end:{line:72,column:3}}],line:70},'7':{loc:{start:{line:74,column:2},end:{line:78,column:3}},type:'if',locations:[{start:{line:74,column:2},end:{line:78,column:3}},{start:{line:74,column:2},end:{line:78,column:3}}],line:74},'8':{loc:{start:{line:80,column:57},end:{line:80,column:89}},type:'cond-expr',locations:[{start:{line:80,column:67},end:{line:80,column:74}},{start:{line:80,column:77},end:{line:80,column:89}}],line:80}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MachinesPage=function(_ref){_inherits(MachinesPage,_ref);function MachinesPage(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,MachinesPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=MachinesPage.__proto__||Object.getPrototypeOf(MachinesPage)).call.apply(_ref2,[this].concat(args))),_this),_this.state={machineDetails:false,machineToDelete:false},_this.componentWillUnmount=function(){cov_16yk30izsp.f[4]++;cov_16yk30izsp.s[13]++;_this.props.onResetMachine();cov_16yk30izsp.s[14]++;_this.props.onCalculatorMachineReset();},_this.onDeleteCancelHandler=function(event){cov_16yk30izsp.f[5]++;cov_16yk30izsp.s[15]++;event.preventDefault();cov_16yk30izsp.s[16]++;_this.setState({machineToDelete:false});},_this.onDeleteConfirmHandler=function(id,event){cov_16yk30izsp.f[6]++;cov_16yk30izsp.s[17]++;event.preventDefault();cov_16yk30izsp.s[18]++;_this.setState({machineToDelete:id});},_this.onDeleteHandler=function(event){cov_16yk30izsp.f[7]++;cov_16yk30izsp.s[19]++;event.preventDefault();cov_16yk30izsp.s[20]++;_this.props.onCalculatorMachineDelete(_this.state.machineToDelete);cov_16yk30izsp.s[21]++;_this.setState({machineToDelete:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MachinesPage,[{key:'componentDidMount',value:function componentDidMount(){cov_16yk30izsp.f[0]++;cov_16yk30izsp.s[0]++;this.props.onFetchMachines();/*if(this.props.match.params.id) {
			this.props.onFetchMachine(this.props.match.params.id);
		}*/}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;cov_16yk30izsp.f[1]++;cov_16yk30izsp.s[1]++;if((cov_16yk30izsp.b[1][0]++,!this.state.machineDetails)&&(cov_16yk30izsp.b[1][1]++,this.props.match.params.id)){cov_16yk30izsp.b[0][0]++;cov_16yk30izsp.s[2]++;this.setState({machineDetails:this.props.match.params.id},function(){cov_16yk30izsp.f[2]++;cov_16yk30izsp.s[3]++;_this2.props.onFetchMachine(_this2.props.match.params.id);});}else{cov_16yk30izsp.b[0][1]++;cov_16yk30izsp.s[4]++;if((cov_16yk30izsp.b[3][0]++,this.state.machineDetails)&&(cov_16yk30izsp.b[3][1]++,!this.props.match.params.id)){cov_16yk30izsp.b[2][0]++;cov_16yk30izsp.s[5]++;this.setState({machineDetails:false},function(){cov_16yk30izsp.f[3]++;cov_16yk30izsp.s[6]++;return _this2.props.onResetMachine();});}else{cov_16yk30izsp.b[2][1]++;}}cov_16yk30izsp.s[7]++;if(this.props.machine.deleted){cov_16yk30izsp.b[4][0]++;cov_16yk30izsp.s[8]++;__WEBPACK_IMPORTED_MODULE_7_react_redux_toastr__["toastr"].success(this.props.translate('machinespage.success.deleted.title'),this.props.translate('machinespage.success.deleted.text'));cov_16yk30izsp.s[9]++;this.props.onCalculatorMachineReset();cov_16yk30izsp.s[10]++;this.props.onFetchMachines();}else{cov_16yk30izsp.b[4][1]++;}cov_16yk30izsp.s[11]++;if(this.props.machine.fetched){cov_16yk30izsp.b[5][0]++;cov_16yk30izsp.s[12]++;__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();}else{cov_16yk30izsp.b[5][1]++;}}},{key:'render',value:function render(){var _this3=this;cov_16yk30izsp.f[8]++;var machineModal=(cov_16yk30izsp.s[22]++,"");cov_16yk30izsp.s[23]++;if(this.props.machine.fetched){cov_16yk30izsp.b[6][0]++;cov_16yk30izsp.s[24]++;machineModal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__EditMachineModal__["a" /* default */],{machine:this.props.machine.machine,onUpdated:this.props.onFetchMachines});}else{cov_16yk30izsp.b[6][1]++;}var confirm=(cov_16yk30izsp.s[25]++,"");cov_16yk30izsp.s[26]++;if(this.state.machineToDelete){cov_16yk30izsp.b[7][0]++;cov_16yk30izsp.s[27]++;confirm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Confirm"],{onCancel:this.onDeleteCancelHandler,onConfirm:this.onDeleteHandler,title:this.props.translate('machinespage.delete.label'),text:this.props.translate('machinespage.delete.text')});}else{cov_16yk30izsp.b[7][1]++;}cov_16yk30izsp.s[28]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Header"],null),appendComponent:confirm?(cov_16yk30izsp.b[8][0]++,confirm):(cov_16yk30izsp.b[8][1]++,machineModal)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["PageTitle"],null,this.props.translate('machinespage.title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{gutter:'15',move:'true'},this.props.state.machines.map(function(machine,index){cov_16yk30izsp.f[9]++;cov_16yk30izsp.s[29]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Machine"],{key:index,machine:machine,onDeleteHandler:_this3.onDeleteConfirmHandler.bind(_this3,machine.id)});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Machine"],{type:'addnew',theme:'light'})));}}]);return MachinesPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_16yk30izsp.s[30]++;var mapStateToProps=function mapStateToProps(state){cov_16yk30izsp.f[10]++;cov_16yk30izsp.s[31]++;return{defaults:state.defaults,state:state.calculatorMachines,machine:state.calculatorMachine,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_16yk30izsp.s[32]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_16yk30izsp.f[11]++;cov_16yk30izsp.s[33]++;return{onFetchMachines:function onFetchMachines(){cov_16yk30izsp.f[12]++;cov_16yk30izsp.s[34]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["Q" /* calculatorMachinesFetch */]());},onFetchMachine:function onFetchMachine(id){cov_16yk30izsp.f[13]++;cov_16yk30izsp.s[35]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["L" /* calculatorMachineFetch */](id));},onResetMachine:function onResetMachine(){cov_16yk30izsp.f[14]++;cov_16yk30izsp.s[36]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["M" /* calculatorMachineFetchReset */]());},onCalculatorMachineDelete:function onCalculatorMachineDelete(id){cov_16yk30izsp.f[15]++;cov_16yk30izsp.s[37]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["H" /* calculatorMachineDelete */](id));},onCalculatorMachineReset:function onCalculatorMachineReset(){cov_16yk30izsp.f[16]++;cov_16yk30izsp.s[38]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["I" /* calculatorMachineDeleteReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(MachinesPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components__);
var cov_29jzkl1m7i=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesPage\\EditMachineModal\\index.js',hash='f63b072de09a6849502971142c3163747ab4e900',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\MachinesPage\\EditMachineModal\\index.js',statementMap:{'0':{start:{line:83,column:8},end:{line:83,column:21}},'1':{start:{line:84,column:8},end:{line:115,column:3}},'2':{start:{line:119,column:8},end:{line:119,column:33}},'3':{start:{line:122,column:5},end:{line:122,column:49}},'4':{start:{line:123,column:8},end:{line:123,column:60}},'5':{start:{line:127,column:8},end:{line:140,column:9}},'6':{start:{line:128,column:12},end:{line:139,column:15}},'7':{start:{line:128,column:40},end:{line:139,column:13}},'8':{start:{line:142,column:8},end:{line:153,column:9}},'9':{start:{line:143,column:12},end:{line:152,column:16}},'10':{start:{line:143,column:40},end:{line:152,column:13}},'11':{start:{line:154,column:5},end:{line:214,column:9}},'12':{start:{line:155,column:12},end:{line:155,column:35}},'13':{start:{line:156,column:12},end:{line:156,column:56}},'14':{start:{line:157,column:12},end:{line:157,column:61}},'15':{start:{line:158,column:23},end:{line:158,column:43}},'16':{start:{line:159,column:12},end:{line:159,column:58}},'17':{start:{line:160,column:12},end:{line:175,column:15}},'18':{start:{line:160,column:40},end:{line:171,column:13}},'19':{start:{line:172,column:16},end:{line:172,column:86}},'20':{start:{line:173,column:16},end:{line:173,column:39}},'21':{start:{line:174,column:16},end:{line:174,column:41}},'22':{start:{line:177,column:13},end:{line:214,column:9}},'23':{start:{line:178,column:12},end:{line:196,column:13}},'24':{start:{line:179,column:16},end:{line:195,column:19}},'25':{start:{line:179,column:44},end:{line:181,column:17}},'26':{start:{line:182,column:20},end:{line:194,column:22}},'27':{start:{line:183,column:24},end:{line:193,column:25}},'28':{start:{line:184,column:28},end:{line:192,column:31}},'29':{start:{line:184,column:56},end:{line:192,column:29}},'30':{start:{line:197,column:12},end:{line:213,column:13}},'31':{start:{line:198,column:16},end:{line:203,column:20}},'32':{start:{line:198,column:44},end:{line:203,column:17}},'33':{start:{line:207,column:16},end:{line:212,column:20}},'34':{start:{line:207,column:44},end:{line:212,column:17}},'35':{start:{line:218,column:9},end:{line:243,column:9}},'36':{start:{line:219,column:12},end:{line:230,column:13}},'37':{start:{line:220,column:16},end:{line:229,column:20}},'38':{start:{line:220,column:44},end:{line:229,column:17}},'39':{start:{line:231,column:12},end:{line:242,column:13}},'40':{start:{line:232,column:16},end:{line:241,column:20}},'41':{start:{line:232,column:44},end:{line:241,column:17}},'42':{start:{line:247,column:8},end:{line:247,column:31}},'43':{start:{line:248,column:8},end:{line:282,column:9}},'44':{start:{line:249,column:29},end:{line:268,column:13}},'45':{start:{line:269,column:12},end:{line:271,column:16}},'46':{start:{line:269,column:40},end:{line:271,column:13}},'47':{start:{line:272,column:12},end:{line:272,column:87}},'48':{start:{line:275,column:12},end:{line:281,column:16}},'49':{start:{line:275,column:40},end:{line:281,column:13}},'50':{start:{line:286,column:5},end:{line:291,column:12}},'51':{start:{line:286,column:33},end:{line:291,column:9}},'52':{start:{line:295,column:20},end:{line:295,column:38}},'53':{start:{line:296,column:8},end:{line:301,column:12}},'54':{start:{line:296,column:36},end:{line:301,column:9}},'55':{start:{line:305,column:16},end:{line:305,column:36}},'56':{start:{line:307,column:2},end:{line:309,column:4}},'57':{start:{line:308,column:3},end:{line:308,column:22}},'58':{start:{line:310,column:2},end:{line:310,column:28}},'59':{start:{line:311,column:2},end:{line:315,column:11}},'60':{start:{line:311,column:30},end:{line:313,column:9}},'61':{start:{line:314,column:12},end:{line:314,column:35}},'62':{start:{line:319,column:8},end:{line:321,column:11}},'63':{start:{line:319,column:36},end:{line:321,column:9}},'64':{start:{line:325,column:20},end:{line:325,column:38}},'65':{start:{line:326,column:8},end:{line:350,column:9}},'66':{start:{line:327,column:12},end:{line:349,column:13}},'67':{start:{line:328,column:16},end:{line:336,column:20}},'68':{start:{line:328,column:44},end:{line:336,column:17}},'69':{start:{line:337,column:16},end:{line:337,column:109}},'70':{start:{line:340,column:16},end:{line:348,column:20}},'71':{start:{line:340,column:44},end:{line:348,column:17}},'72':{start:{line:351,column:8},end:{line:351,column:67}},'73':{start:{line:352,column:8},end:{line:354,column:9}},'74':{start:{line:353,column:12},end:{line:353,column:66}},'75':{start:{line:357,column:8},end:{line:359,column:9}},'76':{start:{line:358,column:12},end:{line:358,column:66}},'77':{start:{line:362,column:25},end:{line:369,column:5}},'78':{start:{line:363,column:17},end:{line:367,column:7}},'79':{start:{line:364,column:8},end:{line:364,column:27}},'80':{start:{line:364,column:21},end:{line:364,column:27}},'81':{start:{line:365,column:8},end:{line:365,column:13}},'82':{start:{line:366,column:8},end:{line:366,column:20}},'83':{start:{line:368,column:6},end:{line:368,column:21}},'84':{start:{line:372,column:25},end:{line:372,column:27}},'85':{start:{line:373,column:8},end:{line:378,column:10}},'86':{start:{line:374,column:12},end:{line:377,column:14}},'87':{start:{line:380,column:8},end:{line:382,column:9}},'88':{start:{line:381,column:12},end:{line:381,column:48}},'89':{start:{line:384,column:8},end:{line:386,column:9}},'90':{start:{line:385,column:12},end:{line:385,column:45}},'91':{start:{line:387,column:8},end:{line:689,column:9}},'92':{start:{line:684,column:236},end:{line:684,column:329}},'93':{start:{line:693,column:24},end:{line:700,column:1}},'94':{start:{line:694,column:4},end:{line:699,column:6}},'95':{start:{line:702,column:27},end:{line:711,column:1}},'96':{start:{line:703,column:4},end:{line:710,column:5}},'97':{start:{line:704,column:46},end:{line:704,column:101}},'98':{start:{line:705,column:53},end:{line:705,column:115}},'99':{start:{line:706,column:51},end:{line:706,column:111}},'100':{start:{line:707,column:32},end:{line:707,column:83}},'101':{start:{line:708,column:57},end:{line:708,column:123}},'102':{start:{line:709,column:54},end:{line:709,column:117}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:82,column:4},end:{line:82,column:5}},loc:{start:{line:82,column:23},end:{line:116,column:2}},line:82},'1':{name:'(anonymous_1)',decl:{start:{line:118,column:24},end:{line:118,column:25}},loc:{start:{line:118,column:30},end:{line:120,column:5}},line:118},'2':{name:'(anonymous_2)',decl:{start:{line:121,column:27},end:{line:121,column:28}},loc:{start:{line:121,column:33},end:{line:124,column:5}},line:121},'3':{name:'(anonymous_3)',decl:{start:{line:126,column:25},end:{line:126,column:26}},loc:{start:{line:126,column:61},end:{line:215,column:5}},line:126},'4':{name:'(anonymous_4)',decl:{start:{line:128,column:26},end:{line:128,column:27}},loc:{start:{line:128,column:40},end:{line:139,column:13}},line:128},'5':{name:'(anonymous_5)',decl:{start:{line:143,column:26},end:{line:143,column:27}},loc:{start:{line:143,column:40},end:{line:152,column:13}},line:143},'6':{name:'(anonymous_6)',decl:{start:{line:160,column:26},end:{line:160,column:27}},loc:{start:{line:160,column:40},end:{line:171,column:13}},line:160},'7':{name:'(anonymous_7)',decl:{start:{line:171,column:16},end:{line:171,column:17}},loc:{start:{line:171,column:22},end:{line:175,column:13}},line:171},'8':{name:'(anonymous_8)',decl:{start:{line:179,column:30},end:{line:179,column:31}},loc:{start:{line:179,column:44},end:{line:181,column:17}},line:179},'9':{name:'(anonymous_9)',decl:{start:{line:181,column:20},end:{line:181,column:21}},loc:{start:{line:181,column:26},end:{line:195,column:17}},line:181},'10':{name:'(anonymous_10)',decl:{start:{line:182,column:51},end:{line:182,column:52}},loc:{start:{line:182,column:69},end:{line:194,column:21}},line:182},'11':{name:'(anonymous_11)',decl:{start:{line:184,column:42},end:{line:184,column:43}},loc:{start:{line:184,column:56},end:{line:192,column:29}},line:184},'12':{name:'(anonymous_12)',decl:{start:{line:198,column:30},end:{line:198,column:31}},loc:{start:{line:198,column:44},end:{line:203,column:17}},line:198},'13':{name:'(anonymous_13)',decl:{start:{line:207,column:30},end:{line:207,column:31}},loc:{start:{line:207,column:44},end:{line:212,column:17}},line:207},'14':{name:'(anonymous_14)',decl:{start:{line:217,column:24},end:{line:217,column:25}},loc:{start:{line:217,column:30},end:{line:244,column:5}},line:217},'15':{name:'(anonymous_15)',decl:{start:{line:220,column:30},end:{line:220,column:31}},loc:{start:{line:220,column:44},end:{line:229,column:17}},line:220},'16':{name:'(anonymous_16)',decl:{start:{line:232,column:30},end:{line:232,column:31}},loc:{start:{line:232,column:44},end:{line:241,column:17}},line:232},'17':{name:'(anonymous_17)',decl:{start:{line:246,column:20},end:{line:246,column:21}},loc:{start:{line:246,column:33},end:{line:283,column:5}},line:246},'18':{name:'(anonymous_18)',decl:{start:{line:269,column:26},end:{line:269,column:27}},loc:{start:{line:269,column:40},end:{line:271,column:13}},line:269},'19':{name:'(anonymous_19)',decl:{start:{line:275,column:26},end:{line:275,column:27}},loc:{start:{line:275,column:40},end:{line:281,column:13}},line:275},'20':{name:'(anonymous_20)',decl:{start:{line:285,column:25},end:{line:285,column:26}},loc:{start:{line:285,column:53},end:{line:292,column:5}},line:285},'21':{name:'(anonymous_21)',decl:{start:{line:286,column:19},end:{line:286,column:20}},loc:{start:{line:286,column:33},end:{line:291,column:9}},line:286},'22':{name:'(anonymous_22)',decl:{start:{line:294,column:26},end:{line:294,column:27}},loc:{start:{line:294,column:54},end:{line:302,column:5}},line:294},'23':{name:'(anonymous_23)',decl:{start:{line:296,column:22},end:{line:296,column:23}},loc:{start:{line:296,column:36},end:{line:301,column:9}},line:296},'24':{name:'(anonymous_24)',decl:{start:{line:304,column:26},end:{line:304,column:27}},loc:{start:{line:304,column:37},end:{line:316,column:5}},line:304},'25':{name:'(anonymous_25)',decl:{start:{line:307,column:11},end:{line:307,column:12}},loc:{start:{line:307,column:31},end:{line:309,column:3}},line:307},'26':{name:'(anonymous_26)',decl:{start:{line:311,column:16},end:{line:311,column:17}},loc:{start:{line:311,column:30},end:{line:313,column:9}},line:311},'27':{name:'(anonymous_27)',decl:{start:{line:313,column:12},end:{line:313,column:13}},loc:{start:{line:313,column:18},end:{line:315,column:9}},line:313},'28':{name:'(anonymous_28)',decl:{start:{line:318,column:19},end:{line:318,column:20}},loc:{start:{line:318,column:25},end:{line:322,column:5}},line:318},'29':{name:'(anonymous_29)',decl:{start:{line:319,column:22},end:{line:319,column:23}},loc:{start:{line:319,column:36},end:{line:321,column:9}},line:319},'30':{name:'(anonymous_30)',decl:{start:{line:324,column:26},end:{line:324,column:27}},loc:{start:{line:324,column:54},end:{line:355,column:5}},line:324},'31':{name:'(anonymous_31)',decl:{start:{line:328,column:30},end:{line:328,column:31}},loc:{start:{line:328,column:44},end:{line:336,column:17}},line:328},'32':{name:'(anonymous_32)',decl:{start:{line:340,column:30},end:{line:340,column:31}},loc:{start:{line:340,column:44},end:{line:348,column:17}},line:340},'33':{name:'(anonymous_33)',decl:{start:{line:356,column:24},end:{line:356,column:25}},loc:{start:{line:356,column:52},end:{line:360,column:5}},line:356},'34':{name:'(anonymous_34)',decl:{start:{line:362,column:20},end:{line:362,column:21}},loc:{start:{line:362,column:25},end:{line:369,column:5}},line:362},'35':{name:'(anonymous_35)',decl:{start:{line:362,column:25},end:{line:362,column:26}},loc:{start:{line:362,column:30},end:{line:369,column:5}},line:362},'36':{name:'(anonymous_36)',decl:{start:{line:363,column:17},end:{line:363,column:18}},loc:{start:{line:363,column:22},end:{line:367,column:7}},line:363},'37':{name:'(anonymous_37)',decl:{start:{line:371,column:4},end:{line:371,column:5}},loc:{start:{line:371,column:14},end:{line:690,column:5}},line:371},'38':{name:'(anonymous_38)',decl:{start:{line:373,column:33},end:{line:373,column:34}},loc:{start:{line:373,column:38},end:{line:378,column:9}},line:373},'39':{name:'(anonymous_39)',decl:{start:{line:684,column:227},end:{line:684,column:228}},loc:{start:{line:684,column:236},end:{line:684,column:329}},line:684},'40':{name:'(anonymous_40)',decl:{start:{line:693,column:24},end:{line:693,column:25}},loc:{start:{line:693,column:33},end:{line:700,column:1}},line:693},'41':{name:'(anonymous_41)',decl:{start:{line:702,column:27},end:{line:702,column:28}},loc:{start:{line:702,column:39},end:{line:711,column:1}},line:702},'42':{name:'(anonymous_42)',decl:{start:{line:704,column:40},end:{line:704,column:41}},loc:{start:{line:704,column:46},end:{line:704,column:101}},line:704},'43':{name:'(anonymous_43)',decl:{start:{line:705,column:35},end:{line:705,column:36}},loc:{start:{line:705,column:53},end:{line:705,column:115}},line:705},'44':{name:'(anonymous_44)',decl:{start:{line:706,column:45},end:{line:706,column:46}},loc:{start:{line:706,column:51},end:{line:706,column:111}},line:706},'45':{name:'(anonymous_45)',decl:{start:{line:707,column:24},end:{line:707,column:25}},loc:{start:{line:707,column:32},end:{line:707,column:83}},line:707},'46':{name:'(anonymous_46)',decl:{start:{line:708,column:43},end:{line:708,column:44}},loc:{start:{line:708,column:57},end:{line:708,column:123}},line:708},'47':{name:'(anonymous_47)',decl:{start:{line:709,column:48},end:{line:709,column:49}},loc:{start:{line:709,column:54},end:{line:709,column:117}},line:709}},branchMap:{'0':{loc:{start:{line:127,column:8},end:{line:140,column:9}},type:'if',locations:[{start:{line:127,column:8},end:{line:140,column:9}},{start:{line:127,column:8},end:{line:140,column:9}}],line:127},'1':{loc:{start:{line:142,column:8},end:{line:153,column:9}},type:'if',locations:[{start:{line:142,column:8},end:{line:153,column:9}},{start:{line:142,column:8},end:{line:153,column:9}}],line:142},'2':{loc:{start:{line:142,column:11},end:{line:142,column:73}},type:'binary-expr',locations:[{start:{line:142,column:11},end:{line:142,column:40}},{start:{line:142,column:44},end:{line:142,column:73}}],line:142},'3':{loc:{start:{line:148,column:32},end:{line:148,column:85}},type:'cond-expr',locations:[{start:{line:148,column:66},end:{line:148,column:75}},{start:{line:148,column:78},end:{line:148,column:85}}],line:148},'4':{loc:{start:{line:149,column:34},end:{line:149,column:134}},type:'cond-expr',locations:[{start:{line:149,column:69},end:{line:149,column:127}},{start:{line:149,column:130},end:{line:149,column:134}}],line:149},'5':{loc:{start:{line:154,column:5},end:{line:214,column:9}},type:'if',locations:[{start:{line:154,column:5},end:{line:214,column:9}},{start:{line:154,column:5},end:{line:214,column:9}}],line:154},'6':{loc:{start:{line:177,column:13},end:{line:214,column:9}},type:'if',locations:[{start:{line:177,column:13},end:{line:214,column:9}},{start:{line:177,column:13},end:{line:214,column:9}}],line:177},'7':{loc:{start:{line:178,column:12},end:{line:196,column:13}},type:'if',locations:[{start:{line:178,column:12},end:{line:196,column:13}},{start:{line:178,column:12},end:{line:196,column:13}}],line:178},'8':{loc:{start:{line:183,column:24},end:{line:193,column:25}},type:'if',locations:[{start:{line:183,column:24},end:{line:193,column:25}},{start:{line:183,column:24},end:{line:193,column:25}}],line:183},'9':{loc:{start:{line:197,column:12},end:{line:213,column:13}},type:'if',locations:[{start:{line:197,column:12},end:{line:213,column:13}},{start:{line:197,column:12},end:{line:213,column:13}}],line:197},'10':{loc:{start:{line:218,column:9},end:{line:243,column:9}},type:'if',locations:[{start:{line:218,column:9},end:{line:243,column:9}},{start:{line:218,column:9},end:{line:243,column:9}}],line:218},'11':{loc:{start:{line:219,column:12},end:{line:230,column:13}},type:'if',locations:[{start:{line:219,column:12},end:{line:230,column:13}},{start:{line:219,column:12},end:{line:230,column:13}}],line:219},'12':{loc:{start:{line:231,column:12},end:{line:242,column:13}},type:'if',locations:[{start:{line:231,column:12},end:{line:242,column:13}},{start:{line:231,column:12},end:{line:242,column:13}}],line:231},'13':{loc:{start:{line:248,column:8},end:{line:282,column:9}},type:'if',locations:[{start:{line:248,column:8},end:{line:282,column:9}},{start:{line:248,column:8},end:{line:282,column:9}}],line:248},'14':{loc:{start:{line:326,column:8},end:{line:350,column:9}},type:'if',locations:[{start:{line:326,column:8},end:{line:350,column:9}},{start:{line:326,column:8},end:{line:350,column:9}}],line:326},'15':{loc:{start:{line:327,column:12},end:{line:349,column:13}},type:'if',locations:[{start:{line:327,column:12},end:{line:349,column:13}},{start:{line:327,column:12},end:{line:349,column:13}}],line:327},'16':{loc:{start:{line:352,column:8},end:{line:354,column:9}},type:'if',locations:[{start:{line:352,column:8},end:{line:354,column:9}},{start:{line:352,column:8},end:{line:354,column:9}}],line:352},'17':{loc:{start:{line:357,column:8},end:{line:359,column:9}},type:'if',locations:[{start:{line:357,column:8},end:{line:359,column:9}},{start:{line:357,column:8},end:{line:359,column:9}}],line:357},'18':{loc:{start:{line:364,column:8},end:{line:364,column:27}},type:'if',locations:[{start:{line:364,column:8},end:{line:364,column:27}},{start:{line:364,column:8},end:{line:364,column:27}}],line:364},'19':{loc:{start:{line:380,column:8},end:{line:382,column:9}},type:'if',locations:[{start:{line:380,column:8},end:{line:382,column:9}},{start:{line:380,column:8},end:{line:382,column:9}}],line:380},'20':{loc:{start:{line:384,column:8},end:{line:386,column:9}},type:'if',locations:[{start:{line:384,column:8},end:{line:386,column:9}},{start:{line:384,column:8},end:{line:386,column:9}}],line:384},'21':{loc:{start:{line:400,column:41},end:{line:400,column:117}},type:'cond-expr',locations:[{start:{line:400,column:77},end:{line:400,column:110}},{start:{line:400,column:113},end:{line:400,column:117}}],line:400},'22':{loc:{start:{line:401,column:45},end:{line:401,column:125}},type:'cond-expr',locations:[{start:{line:401,column:83},end:{line:401,column:118}},{start:{line:401,column:121},end:{line:401,column:125}}],line:401},'23':{loc:{start:{line:419,column:41},end:{line:419,column:141}},type:'cond-expr',locations:[{start:{line:419,column:89},end:{line:419,column:134}},{start:{line:419,column:137},end:{line:419,column:141}}],line:419},'24':{loc:{start:{line:420,column:45},end:{line:420,column:149}},type:'cond-expr',locations:[{start:{line:420,column:95},end:{line:420,column:142}},{start:{line:420,column:145},end:{line:420,column:149}}],line:420},'25':{loc:{start:{line:438,column:41},end:{line:438,column:139}},type:'cond-expr',locations:[{start:{line:438,column:88},end:{line:438,column:132}},{start:{line:438,column:135},end:{line:438,column:139}}],line:438},'26':{loc:{start:{line:439,column:45},end:{line:439,column:147}},type:'cond-expr',locations:[{start:{line:439,column:94},end:{line:439,column:140}},{start:{line:439,column:143},end:{line:439,column:147}}],line:439},'27':{loc:{start:{line:457,column:41},end:{line:457,column:133}},type:'cond-expr',locations:[{start:{line:457,column:85},end:{line:457,column:126}},{start:{line:457,column:129},end:{line:457,column:133}}],line:457},'28':{loc:{start:{line:458,column:45},end:{line:458,column:141}},type:'cond-expr',locations:[{start:{line:458,column:91},end:{line:458,column:134}},{start:{line:458,column:137},end:{line:458,column:141}}],line:458},'29':{loc:{start:{line:476,column:41},end:{line:476,column:139}},type:'cond-expr',locations:[{start:{line:476,column:88},end:{line:476,column:132}},{start:{line:476,column:135},end:{line:476,column:139}}],line:476},'30':{loc:{start:{line:477,column:45},end:{line:477,column:147}},type:'cond-expr',locations:[{start:{line:477,column:94},end:{line:477,column:140}},{start:{line:477,column:143},end:{line:477,column:147}}],line:477},'31':{loc:{start:{line:495,column:41},end:{line:495,column:143}},type:'cond-expr',locations:[{start:{line:495,column:90},end:{line:495,column:136}},{start:{line:495,column:139},end:{line:495,column:143}}],line:495},'32':{loc:{start:{line:496,column:45},end:{line:496,column:151}},type:'cond-expr',locations:[{start:{line:496,column:96},end:{line:496,column:144}},{start:{line:496,column:147},end:{line:496,column:151}}],line:496},'33':{loc:{start:{line:513,column:41},end:{line:513,column:145}},type:'cond-expr',locations:[{start:{line:513,column:91},end:{line:513,column:138}},{start:{line:513,column:141},end:{line:513,column:145}}],line:513},'34':{loc:{start:{line:514,column:45},end:{line:514,column:153}},type:'cond-expr',locations:[{start:{line:514,column:97},end:{line:514,column:146}},{start:{line:514,column:149},end:{line:514,column:153}}],line:514},'35':{loc:{start:{line:531,column:41},end:{line:531,column:159}},type:'cond-expr',locations:[{start:{line:531,column:98},end:{line:531,column:152}},{start:{line:531,column:155},end:{line:531,column:159}}],line:531},'36':{loc:{start:{line:532,column:45},end:{line:532,column:167}},type:'cond-expr',locations:[{start:{line:532,column:104},end:{line:532,column:160}},{start:{line:532,column:163},end:{line:532,column:167}}],line:532},'37':{loc:{start:{line:550,column:41},end:{line:550,column:155}},type:'cond-expr',locations:[{start:{line:550,column:96},end:{line:550,column:148}},{start:{line:550,column:151},end:{line:550,column:155}}],line:550},'38':{loc:{start:{line:551,column:45},end:{line:551,column:163}},type:'cond-expr',locations:[{start:{line:551,column:102},end:{line:551,column:156}},{start:{line:551,column:159},end:{line:551,column:163}}],line:551},'39':{loc:{start:{line:566,column:46},end:{line:566,column:149}},type:'cond-expr',locations:[{start:{line:566,column:93},end:{line:566,column:144}},{start:{line:566,column:147},end:{line:566,column:149}}],line:566},'40':{loc:{start:{line:570,column:47},end:{line:570,column:145}},type:'cond-expr',locations:[{start:{line:570,column:94},end:{line:570,column:138}},{start:{line:570,column:141},end:{line:570,column:145}}],line:570},'41':{loc:{start:{line:571,column:45},end:{line:571,column:147}},type:'cond-expr',locations:[{start:{line:571,column:94},end:{line:571,column:140}},{start:{line:571,column:143},end:{line:571,column:147}}],line:571},'42':{loc:{start:{line:594,column:21},end:{line:594,column:95}},type:'cond-expr',locations:[{start:{line:594,column:56},end:{line:594,column:88}},{start:{line:594,column:91},end:{line:594,column:95}}],line:594},'43':{loc:{start:{line:595,column:45},end:{line:595,column:123}},type:'cond-expr',locations:[{start:{line:595,column:82},end:{line:595,column:116}},{start:{line:595,column:119},end:{line:595,column:123}}],line:595},'44':{loc:{start:{line:610,column:21},end:{line:610,column:97}},type:'cond-expr',locations:[{start:{line:610,column:57},end:{line:610,column:90}},{start:{line:610,column:93},end:{line:610,column:97}}],line:610},'45':{loc:{start:{line:611,column:45},end:{line:611,column:125}},type:'cond-expr',locations:[{start:{line:611,column:83},end:{line:611,column:118}},{start:{line:611,column:121},end:{line:611,column:125}}],line:611},'46':{loc:{start:{line:624,column:37},end:{line:624,column:140}},type:'cond-expr',locations:[{start:{line:624,column:84},end:{line:624,column:135}},{start:{line:624,column:138},end:{line:624,column:140}}],line:624},'47':{loc:{start:{line:627,column:21},end:{line:627,column:107}},type:'cond-expr',locations:[{start:{line:627,column:62},end:{line:627,column:100}},{start:{line:627,column:103},end:{line:627,column:107}}],line:627},'48':{loc:{start:{line:628,column:45},end:{line:628,column:135}},type:'cond-expr',locations:[{start:{line:628,column:88},end:{line:628,column:128}},{start:{line:628,column:131},end:{line:628,column:135}}],line:628},'49':{loc:{start:{line:646,column:21},end:{line:646,column:125}},type:'cond-expr',locations:[{start:{line:646,column:71},end:{line:646,column:118}},{start:{line:646,column:121},end:{line:646,column:125}}],line:646},'50':{loc:{start:{line:647,column:45},end:{line:647,column:153}},type:'cond-expr',locations:[{start:{line:647,column:97},end:{line:647,column:146}},{start:{line:647,column:149},end:{line:647,column:153}}],line:647},'51':{loc:{start:{line:667,column:38},end:{line:667,column:122}},type:'cond-expr',locations:[{start:{line:667,column:78},end:{line:667,column:115}},{start:{line:667,column:118},end:{line:667,column:122}}],line:667},'52':{loc:{start:{line:668,column:45},end:{line:668,column:133}},type:'cond-expr',locations:[{start:{line:668,column:87},end:{line:668,column:126}},{start:{line:668,column:129},end:{line:668,column:133}}],line:668},'53':{loc:{start:{line:684,column:182},end:{line:684,column:356}},type:'cond-expr',locations:[{start:{line:684,column:344},end:{line:684,column:348}},{start:{line:684,column:351},end:{line:684,column:356}}],line:684},'54':{loc:{start:{line:684,column:236},end:{line:684,column:329}},type:'binary-expr',locations:[{start:{line:684,column:236},end:{line:684,column:270}},{start:{line:684,column:274},end:{line:684,column:299}},{start:{line:684,column:303},end:{line:684,column:329}}],line:684}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0,'57':0,'58':0,'59':0,'60':0,'61':0,'62':0,'63':0,'64':0,'65':0,'66':0,'67':0,'68':0,'69':0,'70':0,'71':0,'72':0,'73':0,'74':0,'75':0,'76':0,'77':0,'78':0,'79':0,'80':0,'81':0,'82':0,'83':0,'84':0,'85':0,'86':0,'87':0,'88':0,'89':0,'90':0,'91':0,'92':0,'93':0,'94':0,'95':0,'96':0,'97':0,'98':0,'99':0,'100':0,'101':0,'102':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0],'31':[0,0],'32':[0,0],'33':[0,0],'34':[0,0],'35':[0,0],'36':[0,0],'37':[0,0],'38':[0,0],'39':[0,0],'40':[0,0],'41':[0,0],'42':[0,0],'43':[0,0],'44':[0,0],'45':[0,0],'46':[0,0],'47':[0,0],'48':[0,0],'49':[0,0],'50':[0,0],'51':[0,0],'52':[0,0],'53':[0,0],'54':[0,0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditMachineModal=function(_ref){_inherits(EditMachineModal,_ref);function EditMachineModal(props){_classCallCheck(this,EditMachineModal);cov_29jzkl1m7i.f[0]++;cov_29jzkl1m7i.s[0]++;var _this=_possibleConstructorReturn(this,(EditMachineModal.__proto__||Object.getPrototypeOf(EditMachineModal)).call(this,props));_this.defaultFormState={name:{state:false,message:false},multihead:{state:false,message:false},heads:{state:false,message:false},investment:{state:false,message:false},amortization_months:{state:false,message:false},speed:{state:false,message:false},color_change_time:{state:false,message:false},bobbin_stitch_count:{state:false,message:false},bobbin_change_time:{state:false,message:false},stitches_next_thread_break:{state:false,message:false},thread_break_fixing_time:{state:false,message:false},hoop_change_time:{state:false,message:false},trimming_time:{state:false,message:false},cone_change_time:{state:false,message:false},maintenance_cost:{state:false,message:false}};_this.defaultMessageState={show:false,message:null};_this.componentDidMount=function(){cov_29jzkl1m7i.f[1]++;cov_29jzkl1m7i.s[2]++;_this.incompleteHandler();};_this.componentWillUnmount=function(){cov_29jzkl1m7i.f[2]++;cov_29jzkl1m7i.s[3]++;_this.props.onCalculatorMachineUpdateReset();cov_29jzkl1m7i.s[4]++;_this.props.onCalculatorMachineDuplicateCheckReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_29jzkl1m7i.f[3]++;cov_29jzkl1m7i.s[5]++;if(prevProps.defaults!==_this.props.defaults){cov_29jzkl1m7i.b[0][0]++;cov_29jzkl1m7i.s[6]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[4]++;cov_29jzkl1m7i.s[7]++;return Object.assign({},prevState.tabs,{tabs:[{name:_this.props.translate('editmachinemodal.tab_1.name'),active:true,batch:false},{name:_this.props.translate('editmachinemodal.tab_2.name'),active:false,batch:_this.props.machine.incomplete}]});});}else{cov_29jzkl1m7i.b[0][1]++;}//Duplicate Check
cov_29jzkl1m7i.s[8]++;if((cov_29jzkl1m7i.b[2][0]++,!prevProps.state.name_checked)&&(cov_29jzkl1m7i.b[2][1]++,_this.props.state.name_checked)){cov_29jzkl1m7i.b[1][0]++;cov_29jzkl1m7i.s[9]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[5]++;cov_29jzkl1m7i.s[10]++;return{form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:_this.props.state.name_available?(cov_29jzkl1m7i.b[3][0]++,'success'):(cov_29jzkl1m7i.b[3][1]++,'error'),message:!_this.props.state.name_available?(cov_29jzkl1m7i.b[4][0]++,_this.props.translate('editmachinemodal.error.name_exists')):(cov_29jzkl1m7i.b[4][1]++,null)})})};});}else{cov_29jzkl1m7i.b[1][1]++;}cov_29jzkl1m7i.s[11]++;if(_this.props.state.updated){cov_29jzkl1m7i.b[5][0]++;cov_29jzkl1m7i.s[12]++;_this.props.onUpdated();cov_29jzkl1m7i.s[13]++;_this.props.onCalculatorMachineUpdateReset();cov_29jzkl1m7i.s[14]++;_this.props.onHelpersNotificationsMachinesFetch();var tabs=(cov_29jzkl1m7i.s[15]++,[].concat(_toConsumableArray(_this.state.tabs)));cov_29jzkl1m7i.s[16]++;tabs[1].batch=_this.props.machine.incomplete;cov_29jzkl1m7i.s[17]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[6]++;cov_29jzkl1m7i.s[18]++;return{form:Object.assign({},prevState.form,{recalculate_all_jobs:false}),message:{show:true,message:_this.props.translate('editmachinemodal.success.saved'),type:"success"},tabs:tabs};},function(){cov_29jzkl1m7i.f[7]++;cov_29jzkl1m7i.s[19]++;_this.props.history.replace("/machines/"+_this.props.state.machine.id);cov_29jzkl1m7i.s[20]++;__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();cov_29jzkl1m7i.s[21]++;_this.incompleteHandler();});}else{cov_29jzkl1m7i.b[5][1]++;cov_29jzkl1m7i.s[22]++;if(prevProps.state.error!==_this.props.state.error){cov_29jzkl1m7i.b[6][0]++;cov_29jzkl1m7i.s[23]++;if(_this.props.state.error.length){cov_29jzkl1m7i.b[7][0]++;cov_29jzkl1m7i.s[24]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[8]++;cov_29jzkl1m7i.s[25]++;return{form_state:_this.defaultFormState};},function(){cov_29jzkl1m7i.f[9]++;cov_29jzkl1m7i.s[26]++;_this.props.state.error.forEach(function(error,index){cov_29jzkl1m7i.f[10]++;cov_29jzkl1m7i.s[27]++;if(_this.state.form_state[error.source]){cov_29jzkl1m7i.b[8][0]++;cov_29jzkl1m7i.s[28]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[11]++;cov_29jzkl1m7i.s[29]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))};});}else{cov_29jzkl1m7i.b[8][1]++;}});});}else{cov_29jzkl1m7i.b[7][1]++;}cov_29jzkl1m7i.s[30]++;if(_this.props.state.error.length===1){cov_29jzkl1m7i.b[9][0]++;cov_29jzkl1m7i.s[31]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[12]++;cov_29jzkl1m7i.s[32]++;return{message:{message:_this.props.translate('editmachinemodal.error.'+_this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('editmachinemodal.error.default')}),type:"error"}};});}else{cov_29jzkl1m7i.b[9][1]++;cov_29jzkl1m7i.s[33]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[13]++;cov_29jzkl1m7i.s[34]++;return{message:{message:_this.props.translate('editmachinemodal.error.default'),type:"error"}};});}}else{cov_29jzkl1m7i.b[6][1]++;}}};_this.incompleteHandler=function(){cov_29jzkl1m7i.f[14]++;cov_29jzkl1m7i.s[35]++;if(_this.props.machine.incomplete){cov_29jzkl1m7i.b[10][0]++;cov_29jzkl1m7i.s[36]++;if(_this.props.machine.investment===0){cov_29jzkl1m7i.b[11][0]++;cov_29jzkl1m7i.s[37]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[15]++;cov_29jzkl1m7i.s[38]++;return{form_state:Object.assign({},prevState.form_state,{investment:Object.assign({},prevState.form_state.investment,{state:'warning',message:_this.props.translate('editmachinemodal.tab_2.error.incomplete')})})};});}else{cov_29jzkl1m7i.b[11][1]++;}cov_29jzkl1m7i.s[39]++;if(_this.props.machine.amortization_months===0){cov_29jzkl1m7i.b[12][0]++;cov_29jzkl1m7i.s[40]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[16]++;cov_29jzkl1m7i.s[41]++;return{form_state:Object.assign({},prevState.form_state,{amortization_months:Object.assign({},prevState.form_state.amortization_months,{state:'warning',message:_this.props.translate('editmachinemodal.tab_2.error.incomplete')})})};});}else{cov_29jzkl1m7i.b[12][1]++;}}else{cov_29jzkl1m7i.b[10][1]++;}};_this.updateHandler=function(event){cov_29jzkl1m7i.f[17]++;cov_29jzkl1m7i.s[42]++;event.preventDefault();cov_29jzkl1m7i.s[43]++;if(__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[['speed','hoop_change_time','cone_change_time','bobbin_stitch_count','thread_break_fixing_time','color_change_time','trimming_time','bobbin_change_time','stitches_next_thread_break','maintenance_cost','name','investment','amortization_months']])){cov_29jzkl1m7i.b[13][0]++;var formData=(cov_29jzkl1m7i.s[44]++,{name:_this.state.form.name,heads:_this.state.form.heads,multihead:_this.state.form.multihead,investment:_this.state.form.investment,amortization_months:_this.state.form.amortization_months,settings:{speed:_this.state.form.speed,color_change_time:_this.state.form.color_change_time,bobbin_stitch_count:_this.state.form.bobbin_stitch_count,bobbin_change_time:_this.state.form.bobbin_change_time,stitches_next_thread_break:_this.state.form.stitches_next_thread_break,thread_break_fixing_time:_this.state.form.thread_break_fixing_time,hoop_change_time:_this.state.form.hoop_change_time,trimming_time:_this.state.form.trimming_time,cone_change_time:_this.state.form.cone_change_time,maintenance_cost:_this.state.form.maintenance_cost},recalculate_all_jobs:true});cov_29jzkl1m7i.s[45]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[18]++;cov_29jzkl1m7i.s[46]++;return{form_state:_this.defaultFormState};});cov_29jzkl1m7i.s[47]++;_this.props.onCalculatorMachineUpdate(_this.props.state.machine.id,formData);}else{cov_29jzkl1m7i.b[13][1]++;cov_29jzkl1m7i.s[48]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[19]++;cov_29jzkl1m7i.s[49]++;return{message:{show:true,message:_this.props.translate('jobnewpage.error.default'),type:"error"}};});}};_this.inputChangedToggle=function(value,inputIdentifier){cov_29jzkl1m7i.f[20]++;cov_29jzkl1m7i.s[50]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[21]++;cov_29jzkl1m7i.s[51]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputChangedHandler=function(event,inputIdentifier){cov_29jzkl1m7i.f[22]++;var value=(cov_29jzkl1m7i.s[52]++,event.target.value);cov_29jzkl1m7i.s[53]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[23]++;cov_29jzkl1m7i.s[54]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.onTabClickedHandler=function(index){cov_29jzkl1m7i.f[24]++;var tabs=(cov_29jzkl1m7i.s[55]++,[].concat(_toConsumableArray(_this.state.tabs)));cov_29jzkl1m7i.s[56]++;tabs.map(function(tab,index){cov_29jzkl1m7i.f[25]++;cov_29jzkl1m7i.s[57]++;tab.active=false;});cov_29jzkl1m7i.s[58]++;tabs[index].active=true;cov_29jzkl1m7i.s[59]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[26]++;cov_29jzkl1m7i.s[60]++;return{tabs:tabs};},function(){cov_29jzkl1m7i.f[27]++;cov_29jzkl1m7i.s[61]++;__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});};_this.onCloseModal=function(){cov_29jzkl1m7i.f[28]++;cov_29jzkl1m7i.s[62]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[29]++;cov_29jzkl1m7i.s[63]++;return{modalOpen:false};});};_this.inputBlurredHandler=function(event,inputIdentifier){cov_29jzkl1m7i.f[30]++;var value=(cov_29jzkl1m7i.s[64]++,event.target.value);cov_29jzkl1m7i.s[65]++;if(inputIdentifier==='name'){cov_29jzkl1m7i.b[14][0]++;cov_29jzkl1m7i.s[66]++;if(value.length){cov_29jzkl1m7i.b[15][0]++;cov_29jzkl1m7i.s[67]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[31]++;cov_29jzkl1m7i.s[68]++;return{form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:'loading'})})};});cov_29jzkl1m7i.s[69]++;_this.props.onCalculatorMachineDuplicateCheck({name:value,id:_this.props.state.machine.id});}else{cov_29jzkl1m7i.b[15][1]++;cov_29jzkl1m7i.s[70]++;_this.setState(function(prevState){cov_29jzkl1m7i.f[32]++;cov_29jzkl1m7i.s[71]++;return{form_state:Object.assign({},prevState.form_state,{name:Object.assign({},prevState.form_state.name,{state:false})})};});}}else{cov_29jzkl1m7i.b[14][1]++;}cov_29jzkl1m7i.s[72]++;__WEBPACK_IMPORTED_MODULE_9__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier]]);cov_29jzkl1m7i.s[73]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_29jzkl1m7i.b[16][0]++;cov_29jzkl1m7i.s[74]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_29jzkl1m7i.b[16][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_29jzkl1m7i.f[33]++;cov_29jzkl1m7i.s[75]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_29jzkl1m7i.b[17][0]++;cov_29jzkl1m7i.s[76]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_29jzkl1m7i.b[17][1]++;}};_this.timesIterator=function(n){cov_29jzkl1m7i.f[34]++;cov_29jzkl1m7i.s[77]++;return function(f){cov_29jzkl1m7i.f[35]++;cov_29jzkl1m7i.s[78]++;var iter=function iter(i){cov_29jzkl1m7i.f[36]++;cov_29jzkl1m7i.s[79]++;if(i===n){cov_29jzkl1m7i.b[18][0]++;cov_29jzkl1m7i.s[80]++;return;}else{cov_29jzkl1m7i.b[18][1]++;}cov_29jzkl1m7i.s[81]++;f(i);cov_29jzkl1m7i.s[82]++;iter(i+1);};cov_29jzkl1m7i.s[83]++;return iter(0);};};cov_29jzkl1m7i.s[1]++;_this.state={form:{name:_this.props.machine.name,multihead:_this.props.machine.multihead,heads:_this.props.machine.heads,investment:_this.props.machine.investment,amortization_months:_this.props.machine.amortization_months,speed:_this.props.machine.settings.speed,color_change_time:_this.props.machine.settings.color_change_time,bobbin_stitch_count:_this.props.machine.settings.bobbin_stitch_count,bobbin_change_time:_this.props.machine.settings.bobbin_change_time,stitches_next_thread_break:_this.props.machine.settings.stitches_next_thread_break,thread_break_fixing_time:_this.props.machine.settings.thread_break_fixing_time,hoop_change_time:_this.props.machine.settings.hoop_change_time,trimming_time:_this.props.machine.settings.trimming_time,cone_change_time:_this.props.machine.settings.cone_change_time,maintenance_cost:_this.props.machine.settings.maintenance_cost,recalculate_all_jobs:false},form_state:_this.defaultFormState,message:_this.defaultMessageState,modalOpen:true,tabs:[{name:_this.props.translate('editmachinemodal.tab_1.name'),active:true,batch:false},{name:_this.props.translate('editmachinemodal.tab_2.name'),active:false,batch:_this.props.machine.incomplete}]};return _this;}_createClass(EditMachineModal,[{key:'render',value:function render(){var _this2=this;cov_29jzkl1m7i.f[37]++;var headConfig=(cov_29jzkl1m7i.s[84]++,[]);cov_29jzkl1m7i.s[85]++;this.timesIterator(20)(function(i){cov_29jzkl1m7i.f[38]++;cov_29jzkl1m7i.s[86]++;headConfig.push({value:i+1,name:i+1+" "+_this2.props.translate('global.machine.head.multiple')});});cov_29jzkl1m7i.s[87]++;if(!this.state.modalOpen){cov_29jzkl1m7i.b[19][0]++;cov_29jzkl1m7i.s[88]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:'/machines'});}else{cov_29jzkl1m7i.b[19][1]++;}var showMessage;cov_29jzkl1m7i.s[89]++;if(this.state.message.message){cov_29jzkl1m7i.b[20][0]++;cov_29jzkl1m7i.s[90]++;showMessage=this.state.message;}else{cov_29jzkl1m7i.b[20][1]++;}cov_29jzkl1m7i.s[91]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Modal"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Form"],{onSubmit:this.updateHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{outerMargin:'true',smallMargin:'true',tabs:this.state.tabs,closeIcon:this.onCloseModal,onTabClicked:this.onTabClickedHandler,cols:'2',msg_inside:showMessage,title:this.props.machine.name,titleTheme:'light'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBoxContent"],{visible:this.state.tabs[0].active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["BoxTitle"],null,this.props.translate('editmachinemodal.tab_1.box_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Text"],null,this.props.translate('editmachinemodal.tab_1.box_text')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'26px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.speed'),unit:this.props.translate('global.units.spm'),cols:'2',ref:'speedInputRow',state:this.state.form_state.speed.state?(cov_29jzkl1m7i.b[21][0]++,this.state.form_state.speed.state):(cov_29jzkl1m7i.b[21][1]++,null),tip:this.state.form_state.speed.message?(cov_29jzkl1m7i.b[22][0]++,this.state.form_state.speed.message):(cov_29jzkl1m7i.b[22][1]++,null),hint:this.props.translate('global.help.machine.speed')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'speed',ref:'speed',minValue:1,maxValue:2000,type:'number',value:this.state.form.speed,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.color_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'color_change_timeInputRow',state:this.state.form_state.color_change_time.state?(cov_29jzkl1m7i.b[23][0]++,this.state.form_state.color_change_time.state):(cov_29jzkl1m7i.b[23][1]++,null),tip:this.state.form_state.color_change_time.message?(cov_29jzkl1m7i.b[24][0]++,this.state.form_state.color_change_time.message):(cov_29jzkl1m7i.b[24][1]++,null),hint:this.props.translate('global.help.machine.color_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'color_change_time',ref:'color_change_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.color_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.hoop_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'hoop_change_timeInputRow',state:this.state.form_state.hoop_change_time.state?(cov_29jzkl1m7i.b[25][0]++,this.state.form_state.hoop_change_time.state):(cov_29jzkl1m7i.b[25][1]++,null),tip:this.state.form_state.hoop_change_time.message?(cov_29jzkl1m7i.b[26][0]++,this.state.form_state.hoop_change_time.message):(cov_29jzkl1m7i.b[26][1]++,null),hint:this.props.translate('global.help.machine.hoop_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'hoop_change_time',ref:'hoop_change_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.hoop_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.trimming_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'trimming_timeInputRow',state:this.state.form_state.trimming_time.state?(cov_29jzkl1m7i.b[27][0]++,this.state.form_state.trimming_time.state):(cov_29jzkl1m7i.b[27][1]++,null),tip:this.state.form_state.trimming_time.message?(cov_29jzkl1m7i.b[28][0]++,this.state.form_state.trimming_time.message):(cov_29jzkl1m7i.b[28][1]++,null),hint:this.props.translate('global.help.machine.trimming_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'trimming_time',ref:'trimming_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.trimming_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.cone_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'cone_change_timeInputRow',state:this.state.form_state.cone_change_time.state?(cov_29jzkl1m7i.b[29][0]++,this.state.form_state.cone_change_time.state):(cov_29jzkl1m7i.b[29][1]++,null),tip:this.state.form_state.cone_change_time.message?(cov_29jzkl1m7i.b[30][0]++,this.state.form_state.cone_change_time.message):(cov_29jzkl1m7i.b[30][1]++,null),hint:this.props.translate('global.help.machine.cone_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'cone_change_time',ref:'cone_change_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.cone_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_change_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'bobbin_change_timeInputRow',state:this.state.form_state.bobbin_change_time.state?(cov_29jzkl1m7i.b[31][0]++,this.state.form_state.bobbin_change_time.state):(cov_29jzkl1m7i.b[31][1]++,null),tip:this.state.form_state.bobbin_change_time.message?(cov_29jzkl1m7i.b[32][0]++,this.state.form_state.bobbin_change_time.message):(cov_29jzkl1m7i.b[32][1]++,null),hint:this.props.translate('global.help.machine.bobbin_change_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'bobbin_change_time',ref:'bobbin_change_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.bobbin_change_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.bobbin_stitch_count'),cols:'2',ref:'bobbin_stitch_countInputRow',state:this.state.form_state.bobbin_stitch_count.state?(cov_29jzkl1m7i.b[33][0]++,this.state.form_state.bobbin_stitch_count.state):(cov_29jzkl1m7i.b[33][1]++,null),tip:this.state.form_state.bobbin_stitch_count.message?(cov_29jzkl1m7i.b[34][0]++,this.state.form_state.bobbin_stitch_count.message):(cov_29jzkl1m7i.b[34][1]++,null),hint:this.props.translate('global.help.machine.bobbin_stitch_count')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'bobbin_stitch_count',ref:'bobbin_stitch_count',minValue:1,maxValue:100000,type:'number',value:this.state.form.bobbin_stitch_count,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.stitches_next_thread_break'),cols:'2',ref:'stitches_next_thread_breakInputRow',state:this.state.form_state.stitches_next_thread_break.state?(cov_29jzkl1m7i.b[35][0]++,this.state.form_state.stitches_next_thread_break.state):(cov_29jzkl1m7i.b[35][1]++,null),tip:this.state.form_state.stitches_next_thread_break.message?(cov_29jzkl1m7i.b[36][0]++,this.state.form_state.stitches_next_thread_break.message):(cov_29jzkl1m7i.b[36][1]++,null),hint:this.props.translate('global.help.machine.stitches_next_thread_break')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'stitches_next_thread_break',ref:'stitches_next_thread_break',minValue:1,maxValue:999999,type:'number',value:this.state.form.stitches_next_thread_break,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.thread_break_fixing_time'),unit:this.props.translate('global.units.seconds'),cols:'2',ref:'thread_break_fixing_timeInputRow',state:this.state.form_state.thread_break_fixing_time.state?(cov_29jzkl1m7i.b[37][0]++,this.state.form_state.thread_break_fixing_time.state):(cov_29jzkl1m7i.b[37][1]++,null),tip:this.state.form_state.thread_break_fixing_time.message?(cov_29jzkl1m7i.b[38][0]++,this.state.form_state.thread_break_fixing_time.message):(cov_29jzkl1m7i.b[38][1]++,null),hint:this.props.translate('global.help.machine.thread_break_fixing_time')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'thread_break_fixing_time',ref:'thread_break_fixing_time',minValue:1,maxValue:1200,type:'number',value:this.state.form.thread_break_fixing_time,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.maintenance_cost'),unit:this.props.settingsCompany.settings.currency?(cov_29jzkl1m7i.b[39][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_29jzkl1m7i.b[39][1]++,""),cols:'2',isRight:'true',ref:'maintenance_costInputRow',state:this.state.form_state.maintenance_cost.state?(cov_29jzkl1m7i.b[40][0]++,this.state.form_state.maintenance_cost.state):(cov_29jzkl1m7i.b[40][1]++,null),tip:this.state.form_state.maintenance_cost.message?(cov_29jzkl1m7i.b[41][0]++,this.state.form_state.maintenance_cost.message):(cov_29jzkl1m7i.b[41][1]++,null),hint:this.props.translate('global.help.machine.maintenance_cost')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'maintenance_cost',ref:'maintenance_cost',minValue:0,maxValue:9999999,type:'number',value:this.state.form.maintenance_cost,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBoxContent"],{visible:this.state.tabs[1].active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["BoxTitle"],null,this.props.translate('editmachinemodal.tab_2.box_title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Spacer"],{height:'26px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.name'),cols:'2',ref:'nameInputRow',state:this.state.form_state.name.state?(cov_29jzkl1m7i.b[42][0]++,this.state.form_state.name.state):(cov_29jzkl1m7i.b[42][1]++,null),tip:this.state.form_state.name.message?(cov_29jzkl1m7i.b[43][0]++,this.state.form_state.name.message):(cov_29jzkl1m7i.b[43][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'name',ref:'name',type:'text',value:this.state.form.name,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,maxlength:50,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.heads'),cols:'2',ref:'headsInputRow',state:this.state.form_state.heads.state?(cov_29jzkl1m7i.b[44][0]++,this.state.form_state.heads.state):(cov_29jzkl1m7i.b[44][1]++,null),tip:this.state.form_state.heads.message?(cov_29jzkl1m7i.b[45][0]++,this.state.form_state.heads.message):(cov_29jzkl1m7i.b[45][1]++,null),hint:this.props.translate('global.help.machine.heads')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Select"],{identifier:'heads',ref:'heads',options:headConfig,value:this.state.form.heads,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.investment'),unit:this.props.settingsCompany.settings.currency?(cov_29jzkl1m7i.b[46][0]++,this.props.settingsCompany.settings.currency.symbol):(cov_29jzkl1m7i.b[46][1]++,""),cols:'2',ref:'investmentInputRow',state:this.state.form_state.investment.state?(cov_29jzkl1m7i.b[47][0]++,this.state.form_state.investment.state):(cov_29jzkl1m7i.b[47][1]++,null),tip:this.state.form_state.investment.message?(cov_29jzkl1m7i.b[48][0]++,this.state.form_state.investment.message):(cov_29jzkl1m7i.b[48][1]++,null),hint:this.props.translate('global.help.machine.investment')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'investment',ref:'investment',type:'number',minValue:0,maxValue:99999999,value:this.state.form.investment,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.amortization_months'),unit:this.props.translate('global.units.months'),cols:'2',ref:'amortization_monthsInputRow',state:this.state.form_state.amortization_months.state?(cov_29jzkl1m7i.b[49][0]++,this.state.form_state.amortization_months.state):(cov_29jzkl1m7i.b[49][1]++,null),tip:this.state.form_state.amortization_months.message?(cov_29jzkl1m7i.b[50][0]++,this.state.form_state.amortization_months.message):(cov_29jzkl1m7i.b[50][1]++,null),hint:this.props.translate('global.help.machine.amortization_months')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Input"],{identifier:'amortization_months',ref:'amortization_months',minValue:0,maxValue:240,type:'number',value:this.state.form.amortization_months,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["InputRow"],{label:this.props.translate('global.form.label.machine.multihead'),theme:'light',cols:'2',isRight:'true',labelStyle:'toggleRight',ref:'multiheadInputRow',state:this.state.form_state.multihead.state?(cov_29jzkl1m7i.b[51][0]++,this.state.form_state.multihead.state):(cov_29jzkl1m7i.b[51][1]++,null),tip:this.state.form_state.multihead.message?(cov_29jzkl1m7i.b[52][0]++,this.state.form_state.multihead.message):(cov_29jzkl1m7i.b[52][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Toggle"],{identifier:'multihead',ref:'multihead',value:this.state.form.multihead,changed:this.inputChangedToggle,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["GreyBox"],{outerMargin:'true',cols:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Flex"],{reverse:'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{'data-cy':'cancel-edit-machine-btn',nomargin:'true',href:'/machines',theme:'light',value:this.props.translate('editmachinemodal.secondary.label'),width:'320px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components__["Button"],{'data-cy':'save-changes-edit-machine-btn',nomargin:'true',value:this.props.translate('editmachinemodal.submit'),type:'submit',width:'320px',disabled:Object.entries(this.state.form_state).filter(function(entry){cov_29jzkl1m7i.f[39]++;cov_29jzkl1m7i.s[92]++;return(cov_29jzkl1m7i.b[54][0]++,entry[0]!=="amortization_months")&&(cov_29jzkl1m7i.b[54][1]++,entry[0]!=="investment")&&(cov_29jzkl1m7i.b[54][2]++,entry[1].state==='error');}).length>0?(cov_29jzkl1m7i.b[53][0]++,true):(cov_29jzkl1m7i.b[53][1]++,false)})))));}}]);return EditMachineModal;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_29jzkl1m7i.s[93]++;var mapStateToProps=function mapStateToProps(state){cov_29jzkl1m7i.f[40]++;cov_29jzkl1m7i.s[94]++;return{defaults:state.defaults,state:state.calculatorMachine,translate:Object(__WEBPACK_IMPORTED_MODULE_7_react_localize_redux__["d" /* getTranslate */])(state.locale),settingsCompany:state.calculatorSettingsCompany};};cov_29jzkl1m7i.s[95]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_29jzkl1m7i.f[41]++;cov_29jzkl1m7i.s[96]++;return{onCalculatorMachineUpdateReset:function onCalculatorMachineUpdateReset(){cov_29jzkl1m7i.f[42]++;cov_29jzkl1m7i.s[97]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["O" /* calculatorMachineUpdateReset */]());},onCalculatorMachineUpdate:function onCalculatorMachineUpdate(id,formData){cov_29jzkl1m7i.f[43]++;cov_29jzkl1m7i.s[98]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["N" /* calculatorMachineUpdate */](id,formData));},onHelpersNotificationsMachinesFetch:function onHelpersNotificationsMachinesFetch(){cov_29jzkl1m7i.f[44]++;cov_29jzkl1m7i.s[99]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["Z" /* helpersNotificationsMachinesFetch */]());},onFetchMachine:function onFetchMachine(id){cov_29jzkl1m7i.f[45]++;cov_29jzkl1m7i.s[100]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["L" /* calculatorMachineFetch */](id));},onCalculatorMachineDuplicateCheck:function onCalculatorMachineDuplicateCheck(formData){cov_29jzkl1m7i.f[46]++;cov_29jzkl1m7i.s[101]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["J" /* calculatorMachineDuplicateCheck */](formData));},onCalculatorMachineDuplicateCheckReset:function onCalculatorMachineDuplicateCheckReset(){cov_29jzkl1m7i.f[47]++;cov_29jzkl1m7i.s[102]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["K" /* calculatorMachineDuplicateCheckReset */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(EditMachineModal,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */]))));

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components__);
var cov_1mbjfzgybu=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\NotFoundPage\\index.js',hash='234bf4bfd2876ba0262ffbad2d1b6b35df3bfd9f',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\NotFoundPage\\index.js',statementMap:{'0':{start:{line:5,column:21},end:{line:11,column:1}},'1':{start:{line:6,column:2},end:{line:10,column:3}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:5,column:21},end:{line:5,column:22}},loc:{start:{line:5,column:27},end:{line:11,column:1}},line:5}},branchMap:{},s:{'0':0,'1':0},f:{'0':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_1mbjfzgybu.s[0]++;var NotFoundPage=function NotFoundPage(){cov_1mbjfzgybu.f[0]++;cov_1mbjfzgybu.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'404 Not Found'));};/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components__);
var cov_1m84qv8cze=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\SettingsCompanyPage\\index.js',hash='a2e239a7eeb6442315f3a3e8516eade8b0900423',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\SettingsCompanyPage\\index.js',statementMap:{'0':{start:{line:53,column:8},end:{line:53,column:21}},'1':{start:{line:54,column:12},end:{line:73,column:9}},'2':{start:{line:77,column:8},end:{line:77,column:44}},'3':{start:{line:81,column:8},end:{line:81,column:50}},'4':{start:{line:85,column:8},end:{line:87,column:9}},'5':{start:{line:86,column:12},end:{line:86,column:39}},'6':{start:{line:88,column:8},end:{line:142,column:9}},'7':{start:{line:89,column:12},end:{line:89,column:54}},'8':{start:{line:90,column:12},end:{line:103,column:15}},'9':{start:{line:90,column:40},end:{line:101,column:13}},'10':{start:{line:102,column:16},end:{line:102,column:39}},'11':{start:{line:105,column:13},end:{line:142,column:9}},'12':{start:{line:106,column:12},end:{line:124,column:13}},'13':{start:{line:107,column:16},end:{line:123,column:19}},'14':{start:{line:107,column:44},end:{line:109,column:17}},'15':{start:{line:110,column:20},end:{line:122,column:22}},'16':{start:{line:111,column:24},end:{line:121,column:25}},'17':{start:{line:112,column:28},end:{line:120,column:31}},'18':{start:{line:112,column:56},end:{line:120,column:29}},'19':{start:{line:125,column:12},end:{line:141,column:13}},'20':{start:{line:126,column:16},end:{line:131,column:20}},'21':{start:{line:126,column:44},end:{line:131,column:17}},'22':{start:{line:135,column:16},end:{line:140,column:20}},'23':{start:{line:135,column:44},end:{line:140,column:17}},'24':{start:{line:146,column:8},end:{line:179,column:9}},'25':{start:{line:147,column:12},end:{line:178,column:13}},'26':{start:{line:148,column:16},end:{line:162,column:19}},'27':{start:{line:148,column:44},end:{line:162,column:17}},'28':{start:{line:165,column:16},end:{line:177,column:19}},'29':{start:{line:165,column:44},end:{line:177,column:17}},'30':{start:{line:183,column:8},end:{line:183,column:31}},'31':{start:{line:184,column:8},end:{line:208,column:9}},'32':{start:{line:185,column:29},end:{line:198,column:13}},'33':{start:{line:199,column:12},end:{line:199,column:57}},'34':{start:{line:202,column:12},end:{line:207,column:16}},'35':{start:{line:202,column:40},end:{line:207,column:13}},'36':{start:{line:212,column:8},end:{line:217,column:11}},'37':{start:{line:212,column:36},end:{line:217,column:9}},'38':{start:{line:221,column:20},end:{line:221,column:38}},'39':{start:{line:222,column:8},end:{line:227,column:11}},'40':{start:{line:222,column:36},end:{line:227,column:9}},'41':{start:{line:231,column:8},end:{line:231,column:67}},'42':{start:{line:232,column:8},end:{line:234,column:9}},'43':{start:{line:233,column:12},end:{line:233,column:66}},'44':{start:{line:237,column:8},end:{line:239,column:9}},'45':{start:{line:238,column:12},end:{line:238,column:66}},'46':{start:{line:244,column:8},end:{line:246,column:9}},'47':{start:{line:245,column:12},end:{line:245,column:44}},'48':{start:{line:247,column:8},end:{line:394,column:10}},'49':{start:{line:260,column:110},end:{line:260,column:160}},'50':{start:{line:398,column:24},end:{line:405,column:1}},'51':{start:{line:399,column:4},end:{line:404,column:6}},'52':{start:{line:407,column:27},end:{line:413,column:1}},'53':{start:{line:408,column:4},end:{line:412,column:5}},'54':{start:{line:409,column:47},end:{line:409,column:103}},'55':{start:{line:410,column:38},end:{line:410,column:85}},'56':{start:{line:411,column:44},end:{line:411,column:97}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:52,column:4},end:{line:52,column:5}},loc:{start:{line:52,column:23},end:{line:74,column:5}},line:52},'1':{name:'(anonymous_1)',decl:{start:{line:76,column:4},end:{line:76,column:5}},loc:{start:{line:76,column:24},end:{line:78,column:5}},line:76},'2':{name:'(anonymous_2)',decl:{start:{line:80,column:27},end:{line:80,column:28}},loc:{start:{line:80,column:33},end:{line:82,column:5}},line:80},'3':{name:'(anonymous_3)',decl:{start:{line:84,column:25},end:{line:84,column:26}},loc:{start:{line:84,column:61},end:{line:143,column:5}},line:84},'4':{name:'(anonymous_4)',decl:{start:{line:90,column:26},end:{line:90,column:27}},loc:{start:{line:90,column:40},end:{line:101,column:13}},line:90},'5':{name:'(anonymous_5)',decl:{start:{line:101,column:16},end:{line:101,column:17}},loc:{start:{line:101,column:22},end:{line:103,column:13}},line:101},'6':{name:'(anonymous_6)',decl:{start:{line:107,column:30},end:{line:107,column:31}},loc:{start:{line:107,column:44},end:{line:109,column:17}},line:107},'7':{name:'(anonymous_7)',decl:{start:{line:109,column:20},end:{line:109,column:21}},loc:{start:{line:109,column:26},end:{line:123,column:17}},line:109},'8':{name:'(anonymous_8)',decl:{start:{line:110,column:51},end:{line:110,column:52}},loc:{start:{line:110,column:69},end:{line:122,column:21}},line:110},'9':{name:'(anonymous_9)',decl:{start:{line:112,column:42},end:{line:112,column:43}},loc:{start:{line:112,column:56},end:{line:120,column:29}},line:112},'10':{name:'(anonymous_10)',decl:{start:{line:126,column:30},end:{line:126,column:31}},loc:{start:{line:126,column:44},end:{line:131,column:17}},line:126},'11':{name:'(anonymous_11)',decl:{start:{line:135,column:30},end:{line:135,column:31}},loc:{start:{line:135,column:44},end:{line:140,column:17}},line:135},'12':{name:'(anonymous_12)',decl:{start:{line:145,column:26},end:{line:145,column:27}},loc:{start:{line:145,column:37},end:{line:180,column:5}},line:145},'13':{name:'(anonymous_13)',decl:{start:{line:148,column:30},end:{line:148,column:31}},loc:{start:{line:148,column:44},end:{line:162,column:17}},line:148},'14':{name:'(anonymous_14)',decl:{start:{line:165,column:30},end:{line:165,column:31}},loc:{start:{line:165,column:44},end:{line:177,column:17}},line:165},'15':{name:'(anonymous_15)',decl:{start:{line:182,column:20},end:{line:182,column:21}},loc:{start:{line:182,column:33},end:{line:209,column:5}},line:182},'16':{name:'(anonymous_16)',decl:{start:{line:202,column:26},end:{line:202,column:27}},loc:{start:{line:202,column:40},end:{line:207,column:13}},line:202},'17':{name:'(anonymous_17)',decl:{start:{line:211,column:25},end:{line:211,column:26}},loc:{start:{line:211,column:53},end:{line:218,column:5}},line:211},'18':{name:'(anonymous_18)',decl:{start:{line:212,column:22},end:{line:212,column:23}},loc:{start:{line:212,column:36},end:{line:217,column:9}},line:212},'19':{name:'(anonymous_19)',decl:{start:{line:220,column:26},end:{line:220,column:27}},loc:{start:{line:220,column:54},end:{line:228,column:5}},line:220},'20':{name:'(anonymous_20)',decl:{start:{line:222,column:22},end:{line:222,column:23}},loc:{start:{line:222,column:36},end:{line:227,column:9}},line:222},'21':{name:'(anonymous_21)',decl:{start:{line:230,column:26},end:{line:230,column:27}},loc:{start:{line:230,column:54},end:{line:235,column:5}},line:230},'22':{name:'(anonymous_22)',decl:{start:{line:236,column:24},end:{line:236,column:25}},loc:{start:{line:236,column:52},end:{line:240,column:5}},line:236},'23':{name:'(anonymous_23)',decl:{start:{line:242,column:4},end:{line:242,column:5}},loc:{start:{line:242,column:13},end:{line:395,column:5}},line:242},'24':{name:'(anonymous_24)',decl:{start:{line:260,column:88},end:{line:260,column:89}},loc:{start:{line:260,column:109},end:{line:260,column:161}},line:260},'25':{name:'(anonymous_25)',decl:{start:{line:398,column:24},end:{line:398,column:25}},loc:{start:{line:398,column:33},end:{line:405,column:1}},line:398},'26':{name:'(anonymous_26)',decl:{start:{line:407,column:27},end:{line:407,column:28}},loc:{start:{line:407,column:39},end:{line:413,column:1}},line:407},'27':{name:'(anonymous_27)',decl:{start:{line:409,column:33},end:{line:409,column:34}},loc:{start:{line:409,column:47},end:{line:409,column:103}},line:409},'28':{name:'(anonymous_28)',decl:{start:{line:410,column:32},end:{line:410,column:33}},loc:{start:{line:410,column:38},end:{line:410,column:85}},line:410},'29':{name:'(anonymous_29)',decl:{start:{line:411,column:38},end:{line:411,column:39}},loc:{start:{line:411,column:44},end:{line:411,column:97}},line:411}},branchMap:{'0':{loc:{start:{line:85,column:8},end:{line:87,column:9}},type:'if',locations:[{start:{line:85,column:8},end:{line:87,column:9}},{start:{line:85,column:8},end:{line:87,column:9}}],line:85},'1':{loc:{start:{line:88,column:8},end:{line:142,column:9}},type:'if',locations:[{start:{line:88,column:8},end:{line:142,column:9}},{start:{line:88,column:8},end:{line:142,column:9}}],line:88},'2':{loc:{start:{line:105,column:13},end:{line:142,column:9}},type:'if',locations:[{start:{line:105,column:13},end:{line:142,column:9}},{start:{line:105,column:13},end:{line:142,column:9}}],line:105},'3':{loc:{start:{line:106,column:12},end:{line:124,column:13}},type:'if',locations:[{start:{line:106,column:12},end:{line:124,column:13}},{start:{line:106,column:12},end:{line:124,column:13}}],line:106},'4':{loc:{start:{line:111,column:24},end:{line:121,column:25}},type:'if',locations:[{start:{line:111,column:24},end:{line:121,column:25}},{start:{line:111,column:24},end:{line:121,column:25}}],line:111},'5':{loc:{start:{line:125,column:12},end:{line:141,column:13}},type:'if',locations:[{start:{line:125,column:12},end:{line:141,column:13}},{start:{line:125,column:12},end:{line:141,column:13}}],line:125},'6':{loc:{start:{line:146,column:8},end:{line:179,column:9}},type:'if',locations:[{start:{line:146,column:8},end:{line:179,column:9}},{start:{line:146,column:8},end:{line:179,column:9}}],line:146},'7':{loc:{start:{line:146,column:11},end:{line:146,column:74}},type:'binary-expr',locations:[{start:{line:146,column:11},end:{line:146,column:36}},{start:{line:146,column:40},end:{line:146,column:74}}],line:146},'8':{loc:{start:{line:147,column:12},end:{line:178,column:13}},type:'if',locations:[{start:{line:147,column:12},end:{line:178,column:13}},{start:{line:147,column:12},end:{line:178,column:13}}],line:147},'9':{loc:{start:{line:184,column:8},end:{line:208,column:9}},type:'if',locations:[{start:{line:184,column:8},end:{line:208,column:9}},{start:{line:184,column:8},end:{line:208,column:9}}],line:184},'10':{loc:{start:{line:232,column:8},end:{line:234,column:9}},type:'if',locations:[{start:{line:232,column:8},end:{line:234,column:9}},{start:{line:232,column:8},end:{line:234,column:9}}],line:232},'11':{loc:{start:{line:237,column:8},end:{line:239,column:9}},type:'if',locations:[{start:{line:237,column:8},end:{line:239,column:9}},{start:{line:237,column:8},end:{line:239,column:9}}],line:237},'12':{loc:{start:{line:244,column:8},end:{line:246,column:9}},type:'if',locations:[{start:{line:244,column:8},end:{line:246,column:9}},{start:{line:244,column:8},end:{line:246,column:9}}],line:244},'13':{loc:{start:{line:256,column:148},end:{line:256,column:240}},type:'cond-expr',locations:[{start:{line:256,column:192},end:{line:256,column:233}},{start:{line:256,column:236},end:{line:256,column:240}}],line:256},'14':{loc:{start:{line:256,column:247},end:{line:256,column:343}},type:'cond-expr',locations:[{start:{line:256,column:293},end:{line:256,column:336}},{start:{line:256,column:339},end:{line:256,column:343}}],line:256},'15':{loc:{start:{line:267,column:270},end:{line:267,column:374}},type:'cond-expr',locations:[{start:{line:267,column:320},end:{line:267,column:367}},{start:{line:267,column:370},end:{line:267,column:374}}],line:267},'16':{loc:{start:{line:267,column:381},end:{line:267,column:489}},type:'cond-expr',locations:[{start:{line:267,column:433},end:{line:267,column:482}},{start:{line:267,column:485},end:{line:267,column:489}}],line:267},'17':{loc:{start:{line:281,column:237},end:{line:281,column:319}},type:'cond-expr',locations:[{start:{line:281,column:276},end:{line:281,column:312}},{start:{line:281,column:315},end:{line:281,column:319}}],line:281},'18':{loc:{start:{line:281,column:326},end:{line:281,column:412}},type:'cond-expr',locations:[{start:{line:281,column:367},end:{line:281,column:405}},{start:{line:281,column:408},end:{line:281,column:412}}],line:281},'19':{loc:{start:{line:295,column:249},end:{line:295,column:339}},type:'cond-expr',locations:[{start:{line:295,column:292},end:{line:295,column:332}},{start:{line:295,column:335},end:{line:295,column:339}}],line:295},'20':{loc:{start:{line:295,column:346},end:{line:295,column:440}},type:'cond-expr',locations:[{start:{line:295,column:391},end:{line:295,column:433}},{start:{line:295,column:436},end:{line:295,column:440}}],line:295},'21':{loc:{start:{line:313,column:252},end:{line:313,column:334}},type:'cond-expr',locations:[{start:{line:313,column:291},end:{line:313,column:327}},{start:{line:313,column:330},end:{line:313,column:334}}],line:313},'22':{loc:{start:{line:313,column:341},end:{line:313,column:427}},type:'cond-expr',locations:[{start:{line:313,column:382},end:{line:313,column:420}},{start:{line:313,column:423},end:{line:313,column:427}}],line:313},'23':{loc:{start:{line:327,column:252},end:{line:327,column:334}},type:'cond-expr',locations:[{start:{line:327,column:291},end:{line:327,column:327}},{start:{line:327,column:330},end:{line:327,column:334}}],line:327},'24':{loc:{start:{line:327,column:341},end:{line:327,column:427}},type:'cond-expr',locations:[{start:{line:327,column:382},end:{line:327,column:420}},{start:{line:327,column:423},end:{line:327,column:427}}],line:327},'25':{loc:{start:{line:341,column:240},end:{line:341,column:314}},type:'cond-expr',locations:[{start:{line:341,column:275},end:{line:341,column:307}},{start:{line:341,column:310},end:{line:341,column:314}}],line:341},'26':{loc:{start:{line:341,column:321},end:{line:341,column:399}},type:'cond-expr',locations:[{start:{line:341,column:358},end:{line:341,column:392}},{start:{line:341,column:395},end:{line:341,column:399}}],line:341},'27':{loc:{start:{line:355,column:252},end:{line:355,column:334}},type:'cond-expr',locations:[{start:{line:355,column:291},end:{line:355,column:327}},{start:{line:355,column:330},end:{line:355,column:334}}],line:355},'28':{loc:{start:{line:355,column:341},end:{line:355,column:427}},type:'cond-expr',locations:[{start:{line:355,column:382},end:{line:355,column:420}},{start:{line:355,column:423},end:{line:355,column:427}}],line:355},'29':{loc:{start:{line:369,column:295},end:{line:369,column:405}},type:'cond-expr',locations:[{start:{line:369,column:348},end:{line:369,column:398}},{start:{line:369,column:401},end:{line:369,column:405}}],line:369},'30':{loc:{start:{line:369,column:412},end:{line:369,column:526}},type:'cond-expr',locations:[{start:{line:369,column:467},end:{line:369,column:519}},{start:{line:369,column:522},end:{line:369,column:526}}],line:369}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0,'51':0,'52':0,'53':0,'54':0,'55':0,'56':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SettingsJobPresetsPage=function(_ref){_inherits(SettingsJobPresetsPage,_ref);function SettingsJobPresetsPage(props){_classCallCheck(this,SettingsJobPresetsPage);cov_1m84qv8cze.f[0]++;cov_1m84qv8cze.s[0]++;var _this=_possibleConstructorReturn(this,(SettingsJobPresetsPage.__proto__||Object.getPrototypeOf(SettingsJobPresetsPage)).call(this,props));_this.defaultFormState={vacation:{state:false,message:false},holidays:{state:false,message:false},sick:{state:false,message:false},training:{state:false,message:false},working_hours_each_day:{state:false,message:false},monthly_rent:{state:false,message:false},overhead:{state:false,message:false},gross_hourly_salary:{state:false,message:false},currency_code:{state:false,message:false}};_this.componentWillUnmount=function(){cov_1m84qv8cze.f[2]++;cov_1m84qv8cze.s[3]++;_this.props.onSettingsCompanyUpdateReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_1m84qv8cze.f[3]++;cov_1m84qv8cze.s[4]++;if(prevProps.state.settings!==_this.props.state.settings){cov_1m84qv8cze.b[0][0]++;cov_1m84qv8cze.s[5]++;_this.defaultValueHandler();}else{cov_1m84qv8cze.b[0][1]++;}cov_1m84qv8cze.s[6]++;if(_this.props.state.updated){cov_1m84qv8cze.b[1][0]++;cov_1m84qv8cze.s[7]++;_this.props.onSettingsCompanyUpdateReset();cov_1m84qv8cze.s[8]++;_this.setState(function(prevState){cov_1m84qv8cze.f[4]++;cov_1m84qv8cze.s[9]++;return{form:Object.assign({},prevState.form,{recalculate_all_jobs:false}),message:{show:true,message:_this.props.translate('settingscompanypage.success.saved'),type:"success"},form_state:_this.defaultFormState};},function(){cov_1m84qv8cze.f[5]++;cov_1m84qv8cze.s[10]++;__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a.rebuild();});}else{cov_1m84qv8cze.b[1][1]++;cov_1m84qv8cze.s[11]++;if(prevProps.state.error!==_this.props.state.error){cov_1m84qv8cze.b[2][0]++;cov_1m84qv8cze.s[12]++;if(_this.props.state.error.length){cov_1m84qv8cze.b[3][0]++;cov_1m84qv8cze.s[13]++;_this.setState(function(prevState){cov_1m84qv8cze.f[6]++;cov_1m84qv8cze.s[14]++;return{form_state:_this.defaultFormState};},function(){cov_1m84qv8cze.f[7]++;cov_1m84qv8cze.s[15]++;_this.props.state.error.forEach(function(error,index){cov_1m84qv8cze.f[8]++;cov_1m84qv8cze.s[16]++;if(_this.state.form_state[error.source]){cov_1m84qv8cze.b[4][0]++;cov_1m84qv8cze.s[17]++;_this.setState(function(prevState){cov_1m84qv8cze.f[9]++;cov_1m84qv8cze.s[18]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))};});}else{cov_1m84qv8cze.b[4][1]++;}});});}else{cov_1m84qv8cze.b[3][1]++;}cov_1m84qv8cze.s[19]++;if(_this.props.state.error.length===1){cov_1m84qv8cze.b[5][0]++;cov_1m84qv8cze.s[20]++;_this.setState(function(prevState){cov_1m84qv8cze.f[10]++;cov_1m84qv8cze.s[21]++;return{message:{message:_this.props.translate('settingscompanypage.error.'+_this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('settingscompanypage.error.default')}),type:"error"}};});}else{cov_1m84qv8cze.b[5][1]++;cov_1m84qv8cze.s[22]++;_this.setState(function(prevState){cov_1m84qv8cze.f[11]++;cov_1m84qv8cze.s[23]++;return{message:{message:_this.props.translate('settingscompanypage.error.default'),type:"error"}};});}}else{cov_1m84qv8cze.b[2][1]++;}}};_this.defaultValueHandler=function(event){cov_1m84qv8cze.f[12]++;cov_1m84qv8cze.s[24]++;if((cov_1m84qv8cze.b[7][0]++,_this.props.state.settings)&&(cov_1m84qv8cze.b[7][1]++,_this.props.state.settings.currency)){cov_1m84qv8cze.b[6][0]++;cov_1m84qv8cze.s[25]++;if(_this.props.state.settings.currency){cov_1m84qv8cze.b[8][0]++;cov_1m84qv8cze.s[26]++;_this.setState(function(prevState){cov_1m84qv8cze.f[13]++;cov_1m84qv8cze.s[27]++;return{form:Object.assign({},prevState.form,{vacation:_this.props.state.settings.vacation,holidays:_this.props.state.settings.holidays,sick:_this.props.state.settings.sick,training:_this.props.state.settings.training,working_hours_each_day:_this.props.state.settings.working_hours_each_day,monthly_rent:_this.props.state.settings.monthly_rent,overhead:_this.props.state.settings.overhead,gross_hourly_salary:_this.props.state.settings.gross_hourly_salary,currency_code:_this.props.state.settings.currency.code}),currency_symbol:_this.props.state.settings.currency.symbol};});}else{cov_1m84qv8cze.b[8][1]++;cov_1m84qv8cze.s[28]++;_this.setState(function(prevState){cov_1m84qv8cze.f[14]++;cov_1m84qv8cze.s[29]++;return{form:Object.assign({},prevState.form,{vacation:_this.props.state.settings.vacation,holidays:_this.props.state.settings.holidays,sick:_this.props.state.settings.sick,training:_this.props.state.settings.training,working_hours_each_day:_this.props.state.settings.working_hours_each_day,monthly_rent:_this.props.state.settings.monthly_rent,overhead:_this.props.state.settings.overhead,gross_hourly_salary:_this.props.state.settings.gross_hourly_salary})};});}}else{cov_1m84qv8cze.b[6][1]++;}};_this.updateHandler=function(event){cov_1m84qv8cze.f[15]++;cov_1m84qv8cze.s[30]++;event.preventDefault();cov_1m84qv8cze.s[31]++;if(__WEBPACK_IMPORTED_MODULE_7__helpers_Form_js__["a" /* validateFields */].apply(_this,[['vacation','holidays','sick','training','working_hours_each_day','monthly_rent','overhead','gross_hourly_salary']])){cov_1m84qv8cze.b[9][0]++;var formData=(cov_1m84qv8cze.s[32]++,{vacation:Number.parseFloat(_this.state.form.vacation),holidays:Number.parseFloat(_this.state.form.holidays),sick:Number.parseFloat(_this.state.form.sick),training:Number.parseFloat(_this.state.form.training),working_hours_each_day:Number.parseFloat(_this.state.form.working_hours_each_day),monthly_rent:Number.parseFloat(_this.state.form.monthly_rent),overhead:Number.parseFloat(_this.state.form.overhead),gross_hourly_salary:Number.parseFloat(_this.state.form.gross_hourly_salary),recalculate_all_jobs:true,currency:{code:_this.state.form.currency_code}});cov_1m84qv8cze.s[33]++;_this.props.onSettingsCompanyUpdate(formData);}else{cov_1m84qv8cze.b[9][1]++;cov_1m84qv8cze.s[34]++;_this.setState(function(prevState){cov_1m84qv8cze.f[16]++;cov_1m84qv8cze.s[35]++;return{message:{message:_this.props.translate('settingscompanypage.error.default'),type:"error"}};});}};_this.inputChangedToggle=function(value,inputIdentifier){cov_1m84qv8cze.f[17]++;cov_1m84qv8cze.s[36]++;_this.setState(function(prevState){cov_1m84qv8cze.f[18]++;cov_1m84qv8cze.s[37]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputChangedHandler=function(event,inputIdentifier){cov_1m84qv8cze.f[19]++;var value=(cov_1m84qv8cze.s[38]++,event.target.value);cov_1m84qv8cze.s[39]++;_this.setState(function(prevState){cov_1m84qv8cze.f[20]++;cov_1m84qv8cze.s[40]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputBlurredHandler=function(event,inputIdentifier){cov_1m84qv8cze.f[21]++;cov_1m84qv8cze.s[41]++;__WEBPACK_IMPORTED_MODULE_7__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier]]);cov_1m84qv8cze.s[42]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_1m84qv8cze.b[10][0]++;cov_1m84qv8cze.s[43]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_1m84qv8cze.b[10][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_1m84qv8cze.f[22]++;cov_1m84qv8cze.s[44]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_1m84qv8cze.b[11][0]++;cov_1m84qv8cze.s[45]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_1m84qv8cze.b[11][1]++;}};cov_1m84qv8cze.s[1]++;_this.state={form:{vacation:0,holidays:0,sick:0,training:0,working_hours_each_day:0,monthly_rent:0,overhead:0,gross_hourly_salary:0,currency_code:"",recalculate_all_jobs:false},form_state:_this.defaultFormState,currency_symbol:"",message:{show:false,message:null}};return _this;}_createClass(SettingsJobPresetsPage,[{key:'componentDidMount',value:function componentDidMount(){cov_1m84qv8cze.f[1]++;cov_1m84qv8cze.s[2]++;this.props.onSettingsCompanyFetch();}},{key:'render',value:function render(){cov_1m84qv8cze.f[23]++;var showMessage;cov_1m84qv8cze.s[46]++;if(this.state.message.message){cov_1m84qv8cze.b[12][0]++;cov_1m84qv8cze.s[47]++;showMessage=this.state.message;}else{cov_1m84qv8cze.b[12][1]++;}cov_1m84qv8cze.s[48]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Form"],{onSubmit:this.updateHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["GreyBox"],{title:this.props.translate('settingscompanypage.title'),msg:showMessage,cols:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["BoxTitle"],null,this.props.translate('global.form.label.company.company_information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'currency_codeInputRow',label:this.props.translate('global.form.label.company.currency'),state:this.state.form_state.currency_code.state?(cov_1m84qv8cze.b[13][0]++,this.state.form_state.currency_code.state):(cov_1m84qv8cze.b[13][1]++,null),tip:this.state.form_state.currency_code.message?(cov_1m84qv8cze.b[14][0]++,this.state.form_state.currency_code.message):(cov_1m84qv8cze.b[14][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Select"],{identifier:'currency_code',ref:'currency_code',options:this.props.defaults.currencies.map(function(currency,index){cov_1m84qv8cze.f[24]++;cov_1m84qv8cze.s[49]++;return{value:currency.code,name:currency.name};}),value:this.state.form.currency_code,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'gross_hourly_salaryInputRow',hint:this.props.translate('global.help.company.gross_hourly_salary'),label:this.props.translate('global.form.label.company.gross_hourly_salary'),unit:this.state.currency_symbol,state:this.state.form_state.gross_hourly_salary.state?(cov_1m84qv8cze.b[15][0]++,this.state.form_state.gross_hourly_salary.state):(cov_1m84qv8cze.b[15][1]++,null),tip:this.state.form_state.gross_hourly_salary.message?(cov_1m84qv8cze.b[16][0]++,this.state.form_state.gross_hourly_salary.message):(cov_1m84qv8cze.b[16][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'gross_hourly_salary',ref:'gross_hourly_salary',type:'number',minValue:0,maxValue:9999,value:this.state.form.gross_hourly_salary,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'overheadInputRow',hint:this.props.translate('global.help.company.overhead'),label:this.props.translate('global.form.label.company.overhead'),unit:this.state.currency_symbol,state:this.state.form_state.overhead.state?(cov_1m84qv8cze.b[17][0]++,this.state.form_state.overhead.state):(cov_1m84qv8cze.b[17][1]++,null),tip:this.state.form_state.overhead.message?(cov_1m84qv8cze.b[18][0]++,this.state.form_state.overhead.message):(cov_1m84qv8cze.b[18][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'overhead',ref:'overhead',type:'number',minValue:0,maxValue:99999999,value:this.state.form.overhead,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'monthly_rentInputRow',hint:this.props.translate('global.help.company.monthly_rent'),label:this.props.translate('global.form.label.company.monthly_rent'),unit:this.state.currency_symbol,state:this.state.form_state.monthly_rent.state?(cov_1m84qv8cze.b[19][0]++,this.state.form_state.monthly_rent.state):(cov_1m84qv8cze.b[19][1]++,null),tip:this.state.form_state.monthly_rent.message?(cov_1m84qv8cze.b[20][0]++,this.state.form_state.monthly_rent.message):(cov_1m84qv8cze.b[20][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'monthly_rent',ref:'monthly_rent',type:'number',minValue:0,maxValue:99999999,value:this.state.form.monthly_rent,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'vacationInputRow',hint:this.props.translate('global.help.company.vacation'),label:this.props.translate('global.form.label.company.vacation'),unit:this.props.translate('global.units.days'),state:this.state.form_state.vacation.state?(cov_1m84qv8cze.b[21][0]++,this.state.form_state.vacation.state):(cov_1m84qv8cze.b[21][1]++,null),tip:this.state.form_state.vacation.message?(cov_1m84qv8cze.b[22][0]++,this.state.form_state.vacation.message):(cov_1m84qv8cze.b[22][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'vacation',ref:'vacation',type:'number',minValue:0,maxValue:9999,value:this.state.form.vacation,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'holidaysInputRow',hint:this.props.translate('global.help.company.holidays'),label:this.props.translate('global.form.label.company.holidays'),unit:this.props.translate('global.units.days'),state:this.state.form_state.holidays.state?(cov_1m84qv8cze.b[23][0]++,this.state.form_state.holidays.state):(cov_1m84qv8cze.b[23][1]++,null),tip:this.state.form_state.holidays.message?(cov_1m84qv8cze.b[24][0]++,this.state.form_state.holidays.message):(cov_1m84qv8cze.b[24][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'holidays',ref:'holidays',type:'number',minValue:0,maxValue:365,value:this.state.form.holidays,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'sickInputRow',hint:this.props.translate('global.help.company.sick'),label:this.props.translate('global.form.label.company.sick'),unit:this.props.translate('global.units.days'),state:this.state.form_state.sick.state?(cov_1m84qv8cze.b[25][0]++,this.state.form_state.sick.state):(cov_1m84qv8cze.b[25][1]++,null),tip:this.state.form_state.sick.message?(cov_1m84qv8cze.b[26][0]++,this.state.form_state.sick.message):(cov_1m84qv8cze.b[26][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'sick',ref:'sick',type:'number',minValue:0,maxValue:365,value:this.state.form.sick,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'trainingInputRow',hint:this.props.translate('global.help.company.training'),label:this.props.translate('global.form.label.company.training'),unit:this.props.translate('global.units.days'),state:this.state.form_state.training.state?(cov_1m84qv8cze.b[27][0]++,this.state.form_state.training.state):(cov_1m84qv8cze.b[27][1]++,null),tip:this.state.form_state.training.message?(cov_1m84qv8cze.b[28][0]++,this.state.form_state.training.message):(cov_1m84qv8cze.b[28][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'training',ref:'training',type:'number',minValue:0,maxValue:365,value:this.state.form.training,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["InputRow"],{ref:'working_hours_each_dayInputRow',hint:this.props.translate('global.help.company.working_hours_each_day'),label:this.props.translate('global.form.label.company.working_hours_each_day'),unit:this.props.translate('global.units.hours'),state:this.state.form_state.working_hours_each_day.state?(cov_1m84qv8cze.b[29][0]++,this.state.form_state.working_hours_each_day.state):(cov_1m84qv8cze.b[29][1]++,null),tip:this.state.form_state.working_hours_each_day.message?(cov_1m84qv8cze.b[30][0]++,this.state.form_state.working_hours_each_day.message):(cov_1m84qv8cze.b[30][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Input"],{identifier:'working_hours_each_day',ref:'working_hours_each_day',type:'number',minValue:0.1,maxValue:24,value:this.state.form.working_hours_each_day,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any',validationPattern:'^\\d*(\\.\\d{0,2})?$'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Flex"],{reverse:'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'cancel-edit-company-btn',href:'/jobs',type:'button',theme:'light',value:this.props.translate('settingscompanypage.secondary.label'),width:'320px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components__["Button"],{'data-cy':'save-changes-edit-company-btn',value:this.props.translate('settingscompanypage.submit'),type:'submit',width:'320px'})))));}}]);return SettingsJobPresetsPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1m84qv8cze.s[50]++;var mapStateToProps=function mapStateToProps(state){cov_1m84qv8cze.f[25]++;cov_1m84qv8cze.s[51]++;return{auth:state.auth,defaults:state.defaults,state:state.calculatorSettingsCompany,translate:Object(__WEBPACK_IMPORTED_MODULE_6_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_1m84qv8cze.s[52]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_1m84qv8cze.f[26]++;cov_1m84qv8cze.s[53]++;return{onSettingsCompanyUpdate:function onSettingsCompanyUpdate(formData){cov_1m84qv8cze.f[27]++;cov_1m84qv8cze.s[54]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["_3" /* settingsCompanyUpdate */](formData));},onSettingsCompanyFetch:function onSettingsCompanyFetch(){cov_1m84qv8cze.f[28]++;cov_1m84qv8cze.s[55]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["_2" /* settingsCompanyFetch */]());},onSettingsCompanyUpdateReset:function onSettingsCompanyUpdateReset(){cov_1m84qv8cze.f[29]++;cov_1m84qv8cze.s[56]++;return dispatch(__WEBPACK_IMPORTED_MODULE_5__store_actions_index__["_4" /* settingsCompanyUpdateReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4__hoc_withErrorHandler__["a" /* default */])(SettingsJobPresetsPage,__WEBPACK_IMPORTED_MODULE_3__services_api_axios__["a" /* default */])));

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_Form_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components__);
var cov_1azc83o6cs=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\SettingsJobPresetsPage\\index.js',hash='edd167fc812a71223dd643a0733a27c12c97b7ac',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\pages\\SettingsJobPresetsPage\\index.js',statementMap:{'0':{start:{line:56,column:8},end:{line:56,column:21}},'1':{start:{line:57,column:8},end:{line:75,column:9}},'2':{start:{line:80,column:2},end:{line:80,column:45}},'3':{start:{line:84,column:5},end:{line:84,column:54}},'4':{start:{line:88,column:5},end:{line:90,column:6}},'5':{start:{line:89,column:9},end:{line:89,column:36}},'6':{start:{line:91,column:8},end:{line:140,column:9}},'7':{start:{line:92,column:12},end:{line:92,column:61}},'8':{start:{line:93,column:12},end:{line:101,column:15}},'9':{start:{line:93,column:40},end:{line:99,column:13}},'10':{start:{line:100,column:16},end:{line:100,column:39}},'11':{start:{line:103,column:13},end:{line:140,column:9}},'12':{start:{line:104,column:12},end:{line:122,column:13}},'13':{start:{line:105,column:16},end:{line:121,column:19}},'14':{start:{line:105,column:44},end:{line:107,column:17}},'15':{start:{line:108,column:20},end:{line:120,column:22}},'16':{start:{line:109,column:24},end:{line:119,column:25}},'17':{start:{line:110,column:28},end:{line:118,column:31}},'18':{start:{line:110,column:56},end:{line:118,column:29}},'19':{start:{line:123,column:12},end:{line:139,column:13}},'20':{start:{line:124,column:16},end:{line:129,column:20}},'21':{start:{line:124,column:44},end:{line:129,column:17}},'22':{start:{line:133,column:16},end:{line:138,column:20}},'23':{start:{line:133,column:44},end:{line:138,column:17}},'24':{start:{line:144,column:5},end:{line:160,column:3}},'25':{start:{line:145,column:6},end:{line:159,column:9}},'26':{start:{line:145,column:34},end:{line:159,column:7}},'27':{start:{line:164,column:8},end:{line:164,column:31}},'28':{start:{line:165,column:8},end:{line:187,column:9}},'29':{start:{line:166,column:29},end:{line:177,column:13}},'30':{start:{line:178,column:12},end:{line:178,column:64}},'31':{start:{line:181,column:12},end:{line:186,column:16}},'32':{start:{line:181,column:40},end:{line:186,column:13}},'33':{start:{line:191,column:20},end:{line:191,column:38}},'34':{start:{line:192,column:8},end:{line:197,column:11}},'35':{start:{line:192,column:36},end:{line:197,column:9}},'36':{start:{line:201,column:8},end:{line:201,column:67}},'37':{start:{line:202,column:8},end:{line:204,column:9}},'38':{start:{line:203,column:12},end:{line:203,column:66}},'39':{start:{line:207,column:8},end:{line:209,column:9}},'40':{start:{line:208,column:12},end:{line:208,column:66}},'41':{start:{line:214,column:8},end:{line:216,column:9}},'42':{start:{line:215,column:12},end:{line:215,column:44}},'43':{start:{line:217,column:5},end:{line:375,column:4}},'44':{start:{line:379,column:24},end:{line:386,column:1}},'45':{start:{line:380,column:4},end:{line:385,column:6}},'46':{start:{line:388,column:27},end:{line:394,column:1}},'47':{start:{line:389,column:4},end:{line:393,column:5}},'48':{start:{line:390,column:54},end:{line:390,column:117}},'49':{start:{line:391,column:45},end:{line:391,column:99}},'50':{start:{line:392,column:51},end:{line:392,column:111}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:55,column:4},end:{line:55,column:5}},loc:{start:{line:55,column:23},end:{line:76,column:2}},line:55},'1':{name:'(anonymous_1)',decl:{start:{line:79,column:1},end:{line:79,column:2}},loc:{start:{line:79,column:21},end:{line:81,column:2}},line:79},'2':{name:'(anonymous_2)',decl:{start:{line:83,column:27},end:{line:83,column:28}},loc:{start:{line:83,column:33},end:{line:85,column:5}},line:83},'3':{name:'(anonymous_3)',decl:{start:{line:87,column:25},end:{line:87,column:26}},loc:{start:{line:87,column:61},end:{line:141,column:5}},line:87},'4':{name:'(anonymous_4)',decl:{start:{line:93,column:26},end:{line:93,column:27}},loc:{start:{line:93,column:40},end:{line:99,column:13}},line:93},'5':{name:'(anonymous_5)',decl:{start:{line:99,column:16},end:{line:99,column:17}},loc:{start:{line:99,column:22},end:{line:101,column:13}},line:99},'6':{name:'(anonymous_6)',decl:{start:{line:105,column:30},end:{line:105,column:31}},loc:{start:{line:105,column:44},end:{line:107,column:17}},line:105},'7':{name:'(anonymous_7)',decl:{start:{line:107,column:20},end:{line:107,column:21}},loc:{start:{line:107,column:26},end:{line:121,column:17}},line:107},'8':{name:'(anonymous_8)',decl:{start:{line:108,column:51},end:{line:108,column:52}},loc:{start:{line:108,column:69},end:{line:120,column:21}},line:108},'9':{name:'(anonymous_9)',decl:{start:{line:110,column:42},end:{line:110,column:43}},loc:{start:{line:110,column:56},end:{line:118,column:29}},line:110},'10':{name:'(anonymous_10)',decl:{start:{line:124,column:30},end:{line:124,column:31}},loc:{start:{line:124,column:44},end:{line:129,column:17}},line:124},'11':{name:'(anonymous_11)',decl:{start:{line:133,column:30},end:{line:133,column:31}},loc:{start:{line:133,column:44},end:{line:138,column:17}},line:133},'12':{name:'(anonymous_12)',decl:{start:{line:143,column:23},end:{line:143,column:24}},loc:{start:{line:143,column:34},end:{line:161,column:5}},line:143},'13':{name:'(anonymous_13)',decl:{start:{line:145,column:20},end:{line:145,column:21}},loc:{start:{line:145,column:34},end:{line:159,column:7}},line:145},'14':{name:'(anonymous_14)',decl:{start:{line:163,column:20},end:{line:163,column:21}},loc:{start:{line:163,column:33},end:{line:188,column:5}},line:163},'15':{name:'(anonymous_15)',decl:{start:{line:181,column:26},end:{line:181,column:27}},loc:{start:{line:181,column:40},end:{line:186,column:13}},line:181},'16':{name:'(anonymous_16)',decl:{start:{line:190,column:26},end:{line:190,column:27}},loc:{start:{line:190,column:54},end:{line:198,column:5}},line:190},'17':{name:'(anonymous_17)',decl:{start:{line:192,column:22},end:{line:192,column:23}},loc:{start:{line:192,column:36},end:{line:197,column:9}},line:192},'18':{name:'(anonymous_18)',decl:{start:{line:200,column:26},end:{line:200,column:27}},loc:{start:{line:200,column:54},end:{line:205,column:5}},line:200},'19':{name:'(anonymous_19)',decl:{start:{line:206,column:24},end:{line:206,column:25}},loc:{start:{line:206,column:52},end:{line:210,column:5}},line:206},'20':{name:'(anonymous_20)',decl:{start:{line:212,column:3},end:{line:212,column:4}},loc:{start:{line:212,column:12},end:{line:376,column:4}},line:212},'21':{name:'(anonymous_21)',decl:{start:{line:379,column:24},end:{line:379,column:25}},loc:{start:{line:379,column:33},end:{line:386,column:1}},line:379},'22':{name:'(anonymous_22)',decl:{start:{line:388,column:27},end:{line:388,column:28}},loc:{start:{line:388,column:39},end:{line:394,column:1}},line:388},'23':{name:'(anonymous_23)',decl:{start:{line:390,column:40},end:{line:390,column:41}},loc:{start:{line:390,column:54},end:{line:390,column:117}},line:390},'24':{name:'(anonymous_24)',decl:{start:{line:391,column:39},end:{line:391,column:40}},loc:{start:{line:391,column:45},end:{line:391,column:99}},line:391},'25':{name:'(anonymous_25)',decl:{start:{line:392,column:45},end:{line:392,column:46}},loc:{start:{line:392,column:51},end:{line:392,column:111}},line:392}},branchMap:{'0':{loc:{start:{line:88,column:5},end:{line:90,column:6}},type:'if',locations:[{start:{line:88,column:5},end:{line:90,column:6}},{start:{line:88,column:5},end:{line:90,column:6}}],line:88},'1':{loc:{start:{line:91,column:8},end:{line:140,column:9}},type:'if',locations:[{start:{line:91,column:8},end:{line:140,column:9}},{start:{line:91,column:8},end:{line:140,column:9}}],line:91},'2':{loc:{start:{line:103,column:13},end:{line:140,column:9}},type:'if',locations:[{start:{line:103,column:13},end:{line:140,column:9}},{start:{line:103,column:13},end:{line:140,column:9}}],line:103},'3':{loc:{start:{line:104,column:12},end:{line:122,column:13}},type:'if',locations:[{start:{line:104,column:12},end:{line:122,column:13}},{start:{line:104,column:12},end:{line:122,column:13}}],line:104},'4':{loc:{start:{line:109,column:24},end:{line:119,column:25}},type:'if',locations:[{start:{line:109,column:24},end:{line:119,column:25}},{start:{line:109,column:24},end:{line:119,column:25}}],line:109},'5':{loc:{start:{line:123,column:12},end:{line:139,column:13}},type:'if',locations:[{start:{line:123,column:12},end:{line:139,column:13}},{start:{line:123,column:12},end:{line:139,column:13}}],line:123},'6':{loc:{start:{line:144,column:5},end:{line:160,column:3}},type:'if',locations:[{start:{line:144,column:5},end:{line:160,column:3}},{start:{line:144,column:5},end:{line:160,column:3}}],line:144},'7':{loc:{start:{line:165,column:8},end:{line:187,column:9}},type:'if',locations:[{start:{line:165,column:8},end:{line:187,column:9}},{start:{line:165,column:8},end:{line:187,column:9}}],line:165},'8':{loc:{start:{line:202,column:8},end:{line:204,column:9}},type:'if',locations:[{start:{line:202,column:8},end:{line:204,column:9}},{start:{line:202,column:8},end:{line:204,column:9}}],line:202},'9':{loc:{start:{line:207,column:8},end:{line:209,column:9}},type:'if',locations:[{start:{line:207,column:8},end:{line:209,column:9}},{start:{line:207,column:8},end:{line:209,column:9}}],line:207},'10':{loc:{start:{line:214,column:8},end:{line:216,column:9}},type:'if',locations:[{start:{line:214,column:8},end:{line:216,column:9}},{start:{line:214,column:8},end:{line:216,column:9}}],line:214},'11':{loc:{start:{line:226,column:139},end:{line:226,column:221}},type:'cond-expr',locations:[{start:{line:226,column:178},end:{line:226,column:214}},{start:{line:226,column:217},end:{line:226,column:221}}],line:226},'12':{loc:{start:{line:226,column:228},end:{line:226,column:314}},type:'cond-expr',locations:[{start:{line:226,column:269},end:{line:226,column:307}},{start:{line:226,column:310},end:{line:226,column:314}}],line:226},'13':{loc:{start:{line:239,column:192},end:{line:239,column:270}},type:'cond-expr',locations:[{start:{line:239,column:229},end:{line:239,column:263}},{start:{line:239,column:266},end:{line:239,column:270}}],line:239},'14':{loc:{start:{line:239,column:277},end:{line:239,column:359}},type:'cond-expr',locations:[{start:{line:239,column:316},end:{line:239,column:352}},{start:{line:239,column:355},end:{line:239,column:359}}],line:239},'15':{loc:{start:{line:252,column:210},end:{line:252,column:302}},type:'cond-expr',locations:[{start:{line:252,column:254},end:{line:252,column:295}},{start:{line:252,column:298},end:{line:252,column:302}}],line:252},'16':{loc:{start:{line:252,column:309},end:{line:252,column:405}},type:'cond-expr',locations:[{start:{line:252,column:355},end:{line:252,column:398}},{start:{line:252,column:401},end:{line:252,column:405}}],line:252},'17':{loc:{start:{line:265,column:186},end:{line:265,column:262}},type:'cond-expr',locations:[{start:{line:265,column:222},end:{line:265,column:255}},{start:{line:265,column:258},end:{line:265,column:262}}],line:265},'18':{loc:{start:{line:265,column:269},end:{line:265,column:349}},type:'cond-expr',locations:[{start:{line:265,column:307},end:{line:265,column:342}},{start:{line:265,column:345},end:{line:265,column:349}}],line:265},'19':{loc:{start:{line:278,column:217},end:{line:278,column:307}},type:'cond-expr',locations:[{start:{line:278,column:260},end:{line:278,column:300}},{start:{line:278,column:303},end:{line:278,column:307}}],line:278},'20':{loc:{start:{line:278,column:314},end:{line:278,column:408}},type:'cond-expr',locations:[{start:{line:278,column:359},end:{line:278,column:401}},{start:{line:278,column:404},end:{line:278,column:408}}],line:278},'21':{loc:{start:{line:297,column:189},end:{line:297,column:267}},type:'cond-expr',locations:[{start:{line:297,column:226},end:{line:297,column:260}},{start:{line:297,column:263},end:{line:297,column:267}}],line:297},'22':{loc:{start:{line:297,column:274},end:{line:297,column:356}},type:'cond-expr',locations:[{start:{line:297,column:313},end:{line:297,column:349}},{start:{line:297,column:352},end:{line:297,column:356}}],line:297},'23':{loc:{start:{line:310,column:189},end:{line:310,column:267}},type:'cond-expr',locations:[{start:{line:310,column:226},end:{line:310,column:260}},{start:{line:310,column:263},end:{line:310,column:267}}],line:310},'24':{loc:{start:{line:310,column:274},end:{line:310,column:356}},type:'cond-expr',locations:[{start:{line:310,column:313},end:{line:310,column:349}},{start:{line:310,column:352},end:{line:310,column:356}}],line:310},'25':{loc:{start:{line:324,column:253},end:{line:324,column:333}},type:'cond-expr',locations:[{start:{line:324,column:291},end:{line:324,column:326}},{start:{line:324,column:329},end:{line:324,column:333}}],line:324},'26':{loc:{start:{line:324,column:340},end:{line:324,column:424}},type:'cond-expr',locations:[{start:{line:324,column:380},end:{line:324,column:417}},{start:{line:324,column:420},end:{line:324,column:424}}],line:324},'27':{loc:{start:{line:337,column:271},end:{line:337,column:369}},type:'cond-expr',locations:[{start:{line:337,column:318},end:{line:337,column:362}},{start:{line:337,column:365},end:{line:337,column:369}}],line:337},'28':{loc:{start:{line:337,column:376},end:{line:337,column:478}},type:'cond-expr',locations:[{start:{line:337,column:425},end:{line:337,column:471}},{start:{line:337,column:474},end:{line:337,column:478}}],line:337},'29':{loc:{start:{line:350,column:244},end:{line:350,column:330}},type:'cond-expr',locations:[{start:{line:350,column:285},end:{line:350,column:323}},{start:{line:350,column:326},end:{line:350,column:330}}],line:350},'30':{loc:{start:{line:350,column:337},end:{line:350,column:427}},type:'cond-expr',locations:[{start:{line:350,column:380},end:{line:350,column:420}},{start:{line:350,column:423},end:{line:350,column:427}}],line:350}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0,'39':0,'40':0,'41':0,'42':0,'43':0,'44':0,'45':0,'46':0,'47':0,'48':0,'49':0,'50':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0],'14':[0,0],'15':[0,0],'16':[0,0],'17':[0,0],'18':[0,0],'19':[0,0],'20':[0,0],'21':[0,0],'22':[0,0],'23':[0,0],'24':[0,0],'25':[0,0],'26':[0,0],'27':[0,0],'28':[0,0],'29':[0,0],'30':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SettingsJobPresetsPage=function(_ref){_inherits(SettingsJobPresetsPage,_ref);function SettingsJobPresetsPage(props){_classCallCheck(this,SettingsJobPresetsPage);cov_1azc83o6cs.f[0]++;cov_1azc83o6cs.s[0]++;var _this=_possibleConstructorReturn(this,(SettingsJobPresetsPage.__proto__||Object.getPrototypeOf(SettingsJobPresetsPage)).call(this,props));_this.defaultFormState={orders:{state:false,message:false},pieces:{state:false,message:false},stitches:{state:false,message:false},colors:{state:false,message:false},color_changes:{state:false,message:false},trims:{state:false,message:false},cone_changes:{state:false,message:false},garment_handling:{state:false,message:false},hooping:{state:false,message:false},other_work:{state:false,message:false}};_this.componentWillUnmount=function(){cov_1azc83o6cs.f[2]++;cov_1azc83o6cs.s[3]++;_this.props.onCalculatorJobsDefaultsUpdateReset();};_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_1azc83o6cs.f[3]++;cov_1azc83o6cs.s[4]++;if(prevProps.state.defaults!==_this.props.state.defaults){cov_1azc83o6cs.b[0][0]++;cov_1azc83o6cs.s[5]++;_this.defaultValueHandler();}else{cov_1azc83o6cs.b[0][1]++;}cov_1azc83o6cs.s[6]++;if(_this.props.state.updated){cov_1azc83o6cs.b[1][0]++;cov_1azc83o6cs.s[7]++;_this.props.onCalculatorJobsDefaultsUpdateReset();cov_1azc83o6cs.s[8]++;_this.setState(function(prevState){cov_1azc83o6cs.f[4]++;cov_1azc83o6cs.s[9]++;return{message:{message:_this.props.translate('settingsjobpresetspage.success.saved'),type:"success"},form_state:_this.defaultFormState};},function(){cov_1azc83o6cs.f[5]++;cov_1azc83o6cs.s[10]++;__WEBPACK_IMPORTED_MODULE_7_react_tooltip___default.a.rebuild();});}else{cov_1azc83o6cs.b[1][1]++;cov_1azc83o6cs.s[11]++;if(prevProps.state.error!==_this.props.state.error){cov_1azc83o6cs.b[2][0]++;cov_1azc83o6cs.s[12]++;if(_this.props.state.error.length){cov_1azc83o6cs.b[3][0]++;cov_1azc83o6cs.s[13]++;_this.setState(function(prevState){cov_1azc83o6cs.f[6]++;cov_1azc83o6cs.s[14]++;return{form_state:_this.defaultFormState};},function(){cov_1azc83o6cs.f[7]++;cov_1azc83o6cs.s[15]++;_this.props.state.error.forEach(function(error,index){cov_1azc83o6cs.f[8]++;cov_1azc83o6cs.s[16]++;if(_this.state.form_state[error.source]){cov_1azc83o6cs.b[4][0]++;cov_1azc83o6cs.s[17]++;_this.setState(function(prevState){cov_1azc83o6cs.f[9]++;cov_1azc83o6cs.s[18]++;return{form_state:Object.assign({},prevState.form_state,_defineProperty({},error.source,{state:'error',message:_this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg:error.message})}))};});}else{cov_1azc83o6cs.b[4][1]++;}});});}else{cov_1azc83o6cs.b[3][1]++;}cov_1azc83o6cs.s[19]++;if(_this.props.state.error.length===1){cov_1azc83o6cs.b[5][0]++;cov_1azc83o6cs.s[20]++;_this.setState(function(prevState){cov_1azc83o6cs.f[10]++;cov_1azc83o6cs.s[21]++;return{message:{message:_this.props.translate('settingsjobpresetspage.error.'+_this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg:_this.props.translate('settingsjobpresetspage.error.default')}),type:"error"}};});}else{cov_1azc83o6cs.b[5][1]++;cov_1azc83o6cs.s[22]++;_this.setState(function(prevState){cov_1azc83o6cs.f[11]++;cov_1azc83o6cs.s[23]++;return{message:{message:_this.props.translate('settingsjobpresetspage.error.default'),type:"error"}};});}}else{cov_1azc83o6cs.b[2][1]++;}}};_this.defaultValueHandler=function(event){cov_1azc83o6cs.f[12]++;cov_1azc83o6cs.s[24]++;if(_this.props.state.defaults){cov_1azc83o6cs.b[6][0]++;cov_1azc83o6cs.s[25]++;_this.setState(function(prevState){cov_1azc83o6cs.f[13]++;cov_1azc83o6cs.s[26]++;return{form:Object.assign({},prevState.form,{orders:_this.props.state.defaults.orders,pieces:_this.props.state.defaults.pieces,stitches:_this.props.state.defaults.stitches,colors:_this.props.state.defaults.colors,color_changes:_this.props.state.defaults.color_changes,trims:_this.props.state.defaults.trims,cone_changes:_this.props.state.defaults.cone_changes,garment_handling:_this.props.state.defaults.garment_handling,hooping:_this.props.state.defaults.hooping,other_work:_this.props.state.defaults.other_work/60})};});}else{cov_1azc83o6cs.b[6][1]++;}};_this.updateHandler=function(event){cov_1azc83o6cs.f[14]++;cov_1azc83o6cs.s[27]++;event.preventDefault();cov_1azc83o6cs.s[28]++;if(__WEBPACK_IMPORTED_MODULE_6__helpers_Form_js__["a" /* validateFields */].apply(_this,[['orders','pieces','stitches','colors','color_changes','trims','cone_changes','garment_handling','hooping','garment_handling']])){cov_1azc83o6cs.b[7][0]++;var formData=(cov_1azc83o6cs.s[29]++,{orders:_this.state.form.orders,pieces:_this.state.form.pieces,stitches:_this.state.form.stitches,colors:_this.state.form.colors,color_changes:_this.state.form.color_changes,trims:_this.state.form.trims,cone_changes:_this.state.form.cone_changes,garment_handling:_this.state.form.garment_handling,hooping:_this.state.form.hooping,other_work:Number.parseFloat(_this.state.form.other_work)*60});cov_1azc83o6cs.s[30]++;_this.props.onCalculatorJobsDefaultsUpdate(formData);}else{cov_1azc83o6cs.b[7][1]++;cov_1azc83o6cs.s[31]++;_this.setState(function(prevState){cov_1azc83o6cs.f[15]++;cov_1azc83o6cs.s[32]++;return{message:{message:_this.props.translate('settingsjobpresetspage.error.default'),type:"error"}};});}};_this.inputChangedHandler=function(event,inputIdentifier){cov_1azc83o6cs.f[16]++;var value=(cov_1azc83o6cs.s[33]++,event.target.value);cov_1azc83o6cs.s[34]++;_this.setState(function(prevState){cov_1azc83o6cs.f[17]++;cov_1azc83o6cs.s[35]++;return{form:Object.assign({},prevState.form,_defineProperty({},inputIdentifier,value))};});};_this.inputBlurredHandler=function(event,inputIdentifier){cov_1azc83o6cs.f[18]++;cov_1azc83o6cs.s[36]++;__WEBPACK_IMPORTED_MODULE_6__helpers_Form_js__["a" /* validateFields */].apply(_this,[[inputIdentifier]]);cov_1azc83o6cs.s[37]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_1azc83o6cs.b[8][0]++;cov_1azc83o6cs.s[38]++;_this.refs[inputIdentifier+"InputRow"].hideTooltip();}else{cov_1azc83o6cs.b[8][1]++;}};_this.inputFocusHandler=function(event,inputIdentifier){cov_1azc83o6cs.f[19]++;cov_1azc83o6cs.s[39]++;if(_this.refs[inputIdentifier+"InputRow"]){cov_1azc83o6cs.b[9][0]++;cov_1azc83o6cs.s[40]++;_this.refs[inputIdentifier+"InputRow"].showTooltip();}else{cov_1azc83o6cs.b[9][1]++;}};cov_1azc83o6cs.s[1]++;_this.state={form:{orders:0,pieces:0,stitches:0,colors:0,color_changes:0,trims:0,cone_changes:0,garment_handling:0,hooping:0,other_work:0},form_state:_this.defaultFormState,message:{message:null,type:false}};return _this;}_createClass(SettingsJobPresetsPage,[{key:'componentDidMount',value:function componentDidMount(){cov_1azc83o6cs.f[1]++;cov_1azc83o6cs.s[2]++;this.props.onCalculatorJobsDefaultsFetch();}},{key:'render',value:function render(){var _React$createElement;cov_1azc83o6cs.f[20]++;var showMessage;cov_1azc83o6cs.s[41]++;if(this.state.message.message){cov_1azc83o6cs.b[10][0]++;cov_1azc83o6cs.s[42]++;showMessage=this.state.message;}else{cov_1azc83o6cs.b[10][1]++;}cov_1azc83o6cs.s[43]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["PageTemplate"],{header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Header"],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Form"],{onSubmit:this.updateHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["GreyBox"],{title:this.props.translate('settingsjobpresetspage.title'),msg:showMessage,cols:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Flex"],{'break':'xs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["BoxTitle"],null,this.props.translate('global.form.label.job.design_information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'stitchesInputRow',label:this.props.translate('global.form.label.job.stitches'),state:this.state.form_state.stitches.state?(cov_1azc83o6cs.b[11][0]++,this.state.form_state.stitches.state):(cov_1azc83o6cs.b[11][1]++,null),tip:this.state.form_state.stitches.message?(cov_1azc83o6cs.b[12][0]++,this.state.form_state.stitches.message):(cov_1azc83o6cs.b[12][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'stitches',ref:'stitches',type:'number',minValue:1,maxValue:999999,value:this.state.form.stitches,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'colorsInputRow',hint:this.props.translate('global.help.job.colors'),label:this.props.translate('global.form.label.job.colors'),cols:'2',state:this.state.form_state.colors.state?(cov_1azc83o6cs.b[13][0]++,this.state.form_state.colors.state):(cov_1azc83o6cs.b[13][1]++,null),tip:this.state.form_state.colors.message?(cov_1azc83o6cs.b[14][0]++,this.state.form_state.colors.message):(cov_1azc83o6cs.b[14][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'colors',ref:'colors',type:'number',minValue:1,maxValue:999,value:this.state.form.colors,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'color_changesInputRow',hint:this.props.translate('global.help.job.color_changes'),label:this.props.translate('global.form.label.job.color_changes'),cols:'2',state:this.state.form_state.color_changes.state?(cov_1azc83o6cs.b[15][0]++,this.state.form_state.color_changes.state):(cov_1azc83o6cs.b[15][1]++,null),tip:this.state.form_state.color_changes.message?(cov_1azc83o6cs.b[16][0]++,this.state.form_state.color_changes.message):(cov_1azc83o6cs.b[16][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'color_changes',ref:'color_changes',type:'number',minValue:1,maxValue:999,value:this.state.form.color_changes,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'trimsInputRow',hint:this.props.translate('global.help.job.trims'),label:this.props.translate('global.form.label.job.trims'),cols:'2',state:this.state.form_state.trims.state?(cov_1azc83o6cs.b[17][0]++,this.state.form_state.trims.state):(cov_1azc83o6cs.b[17][1]++,null),tip:this.state.form_state.trims.message?(cov_1azc83o6cs.b[18][0]++,this.state.form_state.trims.message):(cov_1azc83o6cs.b[18][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'trims',ref:'trims',type:'number',minValue:0,maxValue:999,value:this.state.form.trims,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'cone_changesInputRow',hint:this.props.translate('global.help.job.cone_changes'),label:this.props.translate('global.form.label.job.cone_changes'),cols:'2',state:this.state.form_state.cone_changes.state?(cov_1azc83o6cs.b[19][0]++,this.state.form_state.cone_changes.state):(cov_1azc83o6cs.b[19][1]++,null),tip:this.state.form_state.cone_changes.message?(cov_1azc83o6cs.b[20][0]++,this.state.form_state.cone_changes.message):(cov_1azc83o6cs.b[20][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'cone_changes',ref:'cone_changes',type:'number',minValue:0,maxValue:99,value:this.state.form.cone_changes,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["FlexColumn"],{col:'2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Flex"],{'break':'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["BoxTitle"],null,this.props.translate('global.form.label.job.job_information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Spacer"],{height:'15px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'ordersInputRow',hint:this.props.translate('global.help.job.orders'),label:this.props.translate('global.form.label.job.orders'),cols:'2',state:this.state.form_state.orders.state?(cov_1azc83o6cs.b[21][0]++,this.state.form_state.orders.state):(cov_1azc83o6cs.b[21][1]++,null),tip:this.state.form_state.orders.message?(cov_1azc83o6cs.b[22][0]++,this.state.form_state.orders.message):(cov_1azc83o6cs.b[22][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'orders',ref:'orders',type:'number',minValue:1,maxValue:999999,value:this.state.form.orders,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'piecesInputRow',hint:this.props.translate('global.help.job.pieces'),label:this.props.translate('global.form.label.job.pieces'),cols:'2',state:this.state.form_state.pieces.state?(cov_1azc83o6cs.b[23][0]++,this.state.form_state.pieces.state):(cov_1azc83o6cs.b[23][1]++,null),tip:this.state.form_state.pieces.message?(cov_1azc83o6cs.b[24][0]++,this.state.form_state.pieces.message):(cov_1azc83o6cs.b[24][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],(_React$createElement={identifier:'pieces',ref:'pieces'},_defineProperty(_React$createElement,'ref','pieces'),_defineProperty(_React$createElement,'type','number'),_defineProperty(_React$createElement,'minValue',1),_defineProperty(_React$createElement,'maxValue',99999),_defineProperty(_React$createElement,'value',this.state.form.pieces),_defineProperty(_React$createElement,'changed',this.inputChangedHandler),_defineProperty(_React$createElement,'blurred',this.inputBlurredHandler),_defineProperty(_React$createElement,'focused',this.inputFocusHandler),_defineProperty(_React$createElement,'isRequired',true),_React$createElement))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'hoopingInputRow',hint:this.props.translate('global.help.job.hooping'),label:this.props.translate('global.form.label.job.hooping'),cols:'2',unit:this.props.translate('global.units.seconds'),state:this.state.form_state.hooping.state?(cov_1azc83o6cs.b[25][0]++,this.state.form_state.hooping.state):(cov_1azc83o6cs.b[25][1]++,null),tip:this.state.form_state.hooping.message?(cov_1azc83o6cs.b[26][0]++,this.state.form_state.hooping.message):(cov_1azc83o6cs.b[26][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'hooping',ref:'hooping',type:'number',minValue:0,maxValue:1200,value:this.state.form.hooping,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'garment_handlingInputRow',hint:this.props.translate('global.help.job.garment_handling'),label:this.props.translate('global.form.label.job.garment_handling'),cols:'2',unit:this.props.translate('global.units.seconds'),state:this.state.form_state.garment_handling.state?(cov_1azc83o6cs.b[27][0]++,this.state.form_state.garment_handling.state):(cov_1azc83o6cs.b[27][1]++,null),tip:this.state.form_state.garment_handling.message?(cov_1azc83o6cs.b[28][0]++,this.state.form_state.garment_handling.message):(cov_1azc83o6cs.b[28][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'garment_handling',ref:'garment_handling',type:'number',minValue:0,maxValue:9999,value:this.state.form.garment_handling,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["InputRow"],{ref:'other_workInputRow',hint:this.props.translate('global.help.job.other_work'),label:this.props.translate('global.form.label.job.other_work'),unit:this.props.translate('global.units.minutes'),state:this.state.form_state.other_work.state?(cov_1azc83o6cs.b[29][0]++,this.state.form_state.other_work.state):(cov_1azc83o6cs.b[29][1]++,null),tip:this.state.form_state.other_work.message?(cov_1azc83o6cs.b[30][0]++,this.state.form_state.other_work.message):(cov_1azc83o6cs.b[30][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Input"],{identifier:'other_work',ref:'other_work',type:'number',minValue:0,maxValue:9999,value:this.state.form.other_work,changed:this.inputChangedHandler,blurred:this.inputBlurredHandler,focused:this.inputFocusHandler,isRequired:true,step:'any',validationPattern:'^\\d*(\\.\\d{0,1})?$'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Flex"],{reverse:'m'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Button"],{'data-cy':'cancel-edit-job-preset-btn',href:'/jobs',type:'button',theme:'light',value:this.props.translate('settingsjobpresetspage.secondary.label'),width:'320px'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components__["Button"],{'data-cy':'save-changes-edit-job-preset-btn',value:this.props.translate('settingsjobpresetspage.submit'),type:'submit',width:'320px'})))));}}]);return SettingsJobPresetsPage;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1azc83o6cs.s[44]++;var mapStateToProps=function mapStateToProps(state){cov_1azc83o6cs.f[21]++;cov_1azc83o6cs.s[45]++;return{auth:state.auth,defaults:state.defaults,state:state.calculatorJobsDefaults,translate:Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_1azc83o6cs.s[46]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_1azc83o6cs.f[22]++;cov_1azc83o6cs.s[47]++;return{onCalculatorJobsDefaultsUpdate:function onCalculatorJobsDefaultsUpdate(formData){cov_1azc83o6cs.f[23]++;cov_1azc83o6cs.s[48]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["C" /* calculatorJobsDefaultsUpdate */](formData));},onCalculatorJobsDefaultsFetch:function onCalculatorJobsDefaultsFetch(){cov_1azc83o6cs.f[24]++;cov_1azc83o6cs.s[49]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["B" /* calculatorJobsDefaultsFetch */]());},onCalculatorJobsDefaultsUpdateReset:function onCalculatorJobsDefaultsUpdateReset(){cov_1azc83o6cs.f[25]++;cov_1azc83o6cs.s[50]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["D" /* calculatorJobsDefaultsUpdateReset */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__["a" /* default */])(SettingsJobPresetsPage,__WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */])));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc_Aux__ = __webpack_require__(31);
var cov_2fkhvd57wu=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\templates\\PageTemplate\\index.js',hash='44213c5e2ab21609d5fa8de0888755e2a9baca72',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\templates\\PageTemplate\\index.js',statementMap:{'0':{start:{line:14,column:2},end:{line:14,column:15}},'1':{start:{line:15,column:2},end:{line:15,column:65}},'2':{start:{line:16,column:2},end:{line:16,column:71}},'3':{start:{line:20,column:2},end:{line:20,column:32}},'4':{start:{line:21,column:2},end:{line:21,column:65}},'5':{start:{line:25,column:2},end:{line:25,column:68}},'6':{start:{line:29,column:27},end:{line:29,column:32}},'7':{start:{line:30,column:2},end:{line:30,column:59}},'8':{start:{line:30,column:30},end:{line:30,column:58}},'9':{start:{line:31,column:2},end:{line:31,column:111}},'10':{start:{line:34,column:2},end:{line:37,column:3}},'11':{start:{line:35,column:3},end:{line:35,column:18}},'12':{start:{line:36,column:3},end:{line:36,column:31}},'13':{start:{line:40,column:2},end:{line:57,column:3}},'14':{start:{line:61,column:24},end:{line:67,column:1}},'15':{start:{line:62,column:4},end:{line:66,column:6}},'16':{start:{line:69,column:27},end:{line:73,column:1}},'17':{start:{line:70,column:4},end:{line:72,column:5}},'18':{start:{line:71,column:30},end:{line:71,column:69}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:13,column:1},end:{line:13,column:2}},loc:{start:{line:13,column:20},end:{line:17,column:2}},line:13},'1':{name:'(anonymous_1)',decl:{start:{line:19,column:1},end:{line:19,column:2}},loc:{start:{line:19,column:21},end:{line:22,column:2}},line:19},'2':{name:'(anonymous_2)',decl:{start:{line:24,column:1},end:{line:24,column:2}},loc:{start:{line:24,column:24},end:{line:26,column:2}},line:24},'3':{name:'(anonymous_3)',decl:{start:{line:28,column:1},end:{line:28,column:2}},loc:{start:{line:28,column:26},end:{line:32,column:2}},line:28},'4':{name:'(anonymous_4)',decl:{start:{line:33,column:22},end:{line:33,column:23}},loc:{start:{line:33,column:58},end:{line:38,column:2}},line:33},'5':{name:'(anonymous_5)',decl:{start:{line:39,column:3},end:{line:39,column:4}},loc:{start:{line:39,column:12},end:{line:58,column:2}},line:39},'6':{name:'(anonymous_6)',decl:{start:{line:61,column:24},end:{line:61,column:25}},loc:{start:{line:61,column:33},end:{line:67,column:1}},line:61},'7':{name:'(anonymous_7)',decl:{start:{line:69,column:27},end:{line:69,column:28}},loc:{start:{line:69,column:39},end:{line:73,column:1}},line:69},'8':{name:'(anonymous_8)',decl:{start:{line:71,column:24},end:{line:71,column:25}},loc:{start:{line:71,column:30},end:{line:71,column:69}},line:71}},branchMap:{'0':{loc:{start:{line:30,column:2},end:{line:30,column:59}},type:'if',locations:[{start:{line:30,column:2},end:{line:30,column:59}},{start:{line:30,column:2},end:{line:30,column:59}}],line:30},'1':{loc:{start:{line:34,column:2},end:{line:37,column:3}},type:'if',locations:[{start:{line:34,column:2},end:{line:37,column:3}},{start:{line:34,column:2},end:{line:37,column:3}}],line:34},'2':{loc:{start:{line:34,column:5},end:{line:34,column:65}},type:'binary-expr',locations:[{start:{line:34,column:5},end:{line:34,column:33}},{start:{line:34,column:37},end:{line:34,column:65}}],line:34},'3':{loc:{start:{line:41,column:19},end:{line:41,column:125}},type:'cond-expr',locations:[{start:{line:41,column:104},end:{line:41,column:118}},{start:{line:41,column:121},end:{line:41,column:125}}],line:41},'4':{loc:{start:{line:41,column:19},end:{line:41,column:101}},type:'binary-expr',locations:[{start:{line:41,column:19},end:{line:41,column:59}},{start:{line:41,column:63},end:{line:41,column:101}}],line:41},'5':{loc:{start:{line:42,column:23},end:{line:42,column:126}},type:'cond-expr',locations:[{start:{line:42,column:67},end:{line:42,column:109}},{start:{line:42,column:112},end:{line:42,column:126}}],line:42}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageTemplate=function(_ref){_inherits(PageTemplate,_ref);function PageTemplate(props){_classCallCheck(this,PageTemplate);cov_2fkhvd57wu.f[0]++;cov_2fkhvd57wu.s[0]++;var _this=_possibleConstructorReturn(this,(PageTemplate.__proto__||Object.getPrototypeOf(PageTemplate)).call(this,props));_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_2fkhvd57wu.f[4]++;cov_2fkhvd57wu.s[10]++;if((cov_2fkhvd57wu.b[2][0]++,_this.props.printing.printing)&&(cov_2fkhvd57wu.b[2][1]++,!prevProps.printing.printing)){cov_2fkhvd57wu.b[1][0]++;cov_2fkhvd57wu.s[11]++;window.print();cov_2fkhvd57wu.s[12]++;_this.props.onPrintingStop();}else{cov_2fkhvd57wu.b[1][1]++;}};cov_2fkhvd57wu.s[1]++;_this.state={width:0,height:0,tooltipPosition:'right'};cov_2fkhvd57wu.s[2]++;_this.updateWindowDimensions=_this.updateWindowDimensions.bind(_this);return _this;}_createClass(PageTemplate,[{key:'componentDidMount',value:function componentDidMount(){cov_2fkhvd57wu.f[1]++;cov_2fkhvd57wu.s[3]++;this.updateWindowDimensions();cov_2fkhvd57wu.s[4]++;window.addEventListener('resize',this.updateWindowDimensions);}},{key:'componentWillUnmount',value:function componentWillUnmount(){cov_2fkhvd57wu.f[2]++;cov_2fkhvd57wu.s[5]++;window.removeEventListener('resize',this.updateWindowDimensions);}},{key:'updateWindowDimensions',value:function updateWindowDimensions(){cov_2fkhvd57wu.f[3]++;var tooltipPositionTmp=(cov_2fkhvd57wu.s[6]++,'top');cov_2fkhvd57wu.s[7]++;if(window.innerWidth>600){cov_2fkhvd57wu.b[0][0]++;cov_2fkhvd57wu.s[8]++;tooltipPositionTmp='right';}else{cov_2fkhvd57wu.b[0][1]++;}cov_2fkhvd57wu.s[9]++;this.setState({width:window.innerWidth,height:window.innerHeight,tooltipPosition:tooltipPositionTmp});}},{key:'render',value:function render(){cov_2fkhvd57wu.f[5]++;cov_2fkhvd57wu.s[13]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(cov_2fkhvd57wu.b[4][0]++,this.props.fetching.running_requests>0)&&(cov_2fkhvd57wu.b[4][1]++,this.props.fetching.show_globalSpinner)?(cov_2fkhvd57wu.b[3][0]++,__WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss___default.a.blurred):(cov_2fkhvd57wu.b[3][1]++,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.helpersBlur.appended_blurs>0?(cov_2fkhvd57wu.b[5][0]++,[__WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss___default.a.wrapper,__WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss___default.a.blurred].join(' ')):(cov_2fkhvd57wu.b[5][1]++,__WEBPACK_IMPORTED_MODULE_4__PageTemplate_scss___default.a.wrapper)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},this.props.header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.props.children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components__["Menu"],null,'Men\xFC'),this.props.appendComponent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_tooltip___default.a,{place:this.state.tooltipPosition,type:'',effect:'solid',globalEventOff:'click',id:'GlobalTooltip'}));}}]);return PageTemplate;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_2fkhvd57wu.s[14]++;var mapStateToProps=function mapStateToProps(state){cov_2fkhvd57wu.f[6]++;cov_2fkhvd57wu.s[15]++;return{helpersBlur:state.helpersBlur,fetching:state.fetching,printing:state.printing};};cov_2fkhvd57wu.s[16]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_2fkhvd57wu.f[7]++;cov_2fkhvd57wu.s[17]++;return{onPrintingStop:function onPrintingStop(){cov_2fkhvd57wu.f[8]++;cov_2fkhvd57wu.s[18]++;return dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_index__["_1" /* printingStop */]());}};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(PageTemplate));

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"PageTemplate__wrapper___35ihm","blurred":"PageTemplate__blurred___3QX4y"};

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MainContent__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_Defaults__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hoc_Aux__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components__);
var cov_272amtou78=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\App.js',hash='3beb4f2081469e42cf082be05cae4cfbdd0f01ae',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\App.js',statementMap:{'0':{start:{line:24,column:8},end:{line:24,column:32}},'1':{start:{line:28,column:8},end:{line:30,column:9}},'2':{start:{line:29,column:12},end:{line:29,column:30}},'3':{start:{line:32,column:8},end:{line:51,column:9}},'4':{start:{line:33,column:12},end:{line:50,column:14}},'5':{start:{line:53,column:8},end:{line:53,column:20}},'6':{start:{line:58,column:24},end:{line:63,column:1}},'7':{start:{line:59,column:4},end:{line:62,column:6}},'8':{start:{line:65,column:27},end:{line:69,column:1}},'9':{start:{line:66,column:4},end:{line:68,column:5}},'10':{start:{line:67,column:26},end:{line:67,column:63}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:23,column:4},end:{line:23,column:5}},loc:{start:{line:23,column:24},end:{line:25,column:5}},line:23},'1':{name:'(anonymous_1)',decl:{start:{line:27,column:4},end:{line:27,column:5}},loc:{start:{line:27,column:13},end:{line:54,column:5}},line:27},'2':{name:'(anonymous_2)',decl:{start:{line:58,column:24},end:{line:58,column:25}},loc:{start:{line:58,column:33},end:{line:63,column:1}},line:58},'3':{name:'(anonymous_3)',decl:{start:{line:65,column:27},end:{line:65,column:28}},loc:{start:{line:65,column:39},end:{line:69,column:1}},line:65},'4':{name:'(anonymous_4)',decl:{start:{line:67,column:20},end:{line:67,column:21}},loc:{start:{line:67,column:26},end:{line:67,column:63}},line:67}},branchMap:{'0':{loc:{start:{line:28,column:8},end:{line:30,column:9}},type:'if',locations:[{start:{line:28,column:8},end:{line:30,column:9}},{start:{line:28,column:8},end:{line:30,column:9}}],line:28},'1':{loc:{start:{line:28,column:11},end:{line:28,column:88}},type:'binary-expr',locations:[{start:{line:28,column:11},end:{line:28,column:45}},{start:{line:28,column:49},end:{line:28,column:88}}],line:28},'2':{loc:{start:{line:32,column:8},end:{line:51,column:9}},type:'if',locations:[{start:{line:32,column:8},end:{line:51,column:9}},{start:{line:32,column:8},end:{line:51,column:9}}],line:32},'3':{loc:{start:{line:32,column:11},end:{line:32,column:94}},type:'binary-expr',locations:[{start:{line:32,column:11},end:{line:32,column:48}},{start:{line:32,column:52},end:{line:32,column:94}}],line:32}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_ref){_inherits(App,_ref);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){cov_272amtou78.f[0]++;cov_272amtou78.s[0]++;this.props.appStartup();}},{key:'render',value:function render(){cov_272amtou78.f[1]++;cov_272amtou78.s[1]++;if((cov_272amtou78.b[1][0]++,this.props.appStartupState.loading)||(cov_272amtou78.b[1][1]++,this.props.translationLoadState.loading)){cov_272amtou78.b[0][0]++;cov_272amtou78.s[2]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components__["Loading"],null);}else{cov_272amtou78.b[0][1]++;}cov_272amtou78.s[3]++;if((cov_272amtou78.b[3][0]++,this.props.appStartupState.successful)&&(cov_272amtou78.b[3][1]++,this.props.translationLoadState.successful)){cov_272amtou78.b[2][0]++;cov_272amtou78.s[4]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__hoc_Aux__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux_toastr___default.a,{timeOut:4000,newestOnTop:true,preventDuplicates:true,position:'top-right',transitionIn:'fadeIn',transitionOut:'fadeOut',progressBar:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* BrowserRouter */],{basename:__WEBPACK_IMPORTED_MODULE_7_config__["basename"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MainContent__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__helpers_Defaults__["a" /* default */],null));}else{cov_272amtou78.b[2][1]++;}cov_272amtou78.s[5]++;return null;}}]);return App;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_272amtou78.s[6]++;var mapStateToProps=function mapStateToProps(state){cov_272amtou78.f[2]++;cov_272amtou78.s[7]++;return{appStartupState:state.appStartup,translationLoadState:state.translationLoad};};cov_272amtou78.s[8]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_272amtou78.f[3]++;cov_272amtou78.s[9]++;return{appStartup:function appStartup(){cov_272amtou78.f[4]++;cov_272amtou78.s[10]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["a" /* appStartup */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__["a" /* default */])(App,__WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */])));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components__);
var cov_kjjdlpedm=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\components\\MainContent.js',hash='410a2792d83df31bf0995acac02b6576caf2baac',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\components\\MainContent.js',statementMap:{'0':{start:{line:17,column:20},end:{line:35,column:1}},'1':{start:{line:18,column:2},end:{line:34,column:3}},'2':{start:{line:31,column:38},end:{line:31,column:61}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:17,column:20},end:{line:17,column:21}},loc:{start:{line:17,column:26},end:{line:35,column:1}},line:17},'1':{name:'(anonymous_1)',decl:{start:{line:31,column:32},end:{line:31,column:33}},loc:{start:{line:31,column:38},end:{line:31,column:61}},line:31}},branchMap:{},s:{'0':0,'1':0,'2':0},f:{'0':0,'1':0},b:{},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();cov_kjjdlpedm.s[0]++;var MainContent=function MainContent(){cov_kjjdlpedm.f[0]++;cov_kjjdlpedm.s[1]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/jobs',component:__WEBPACK_IMPORTED_MODULE_2_components__["JobsPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/jobs/new',component:__WEBPACK_IMPORTED_MODULE_2_components__["JobsNewPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/jobs/:id',component:__WEBPACK_IMPORTED_MODULE_2_components__["JobPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/jobs/:id/edit',component:__WEBPACK_IMPORTED_MODULE_2_components__["JobPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/jobs/:id/export',component:__WEBPACK_IMPORTED_MODULE_2_components__["JobPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/machines',component:__WEBPACK_IMPORTED_MODULE_2_components__["MachinesPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/machines/new',component:__WEBPACK_IMPORTED_MODULE_2_components__["MachinesNewPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/machines/:id',component:__WEBPACK_IMPORTED_MODULE_2_components__["MachinesPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/settings/company',component:__WEBPACK_IMPORTED_MODULE_2_components__["SettingsCompanyPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:'/settings/jobpresets',component:__WEBPACK_IMPORTED_MODULE_2_components__["SettingsJobPresetsPage"]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'login/support',element:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/'})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{path:'/',render:function render(){cov_kjjdlpedm.f[1]++;cov_kjjdlpedm.s[2]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:'/jobs'});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_2_components__["NotFoundPage"]}));};/* harmony default export */ __webpack_exports__["a"] = (MainContent);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_index__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_localize_redux__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components__);
var cov_1hcv8w0ljs=function(){var path='D:\\a\\1\\s\\app\\browser\\src\\_helpers\\Defaults.js',hash='87201ea8b642121a5a08c7cc454ca400af8cac3b',Function=function(){}.constructor,global=new Function('return this')(),gcv='__coverage__',coverageData={path:'D:\\a\\1\\s\\app\\browser\\src\\_helpers\\Defaults.js',statementMap:{'0':{start:{line:19,column:4},end:{line:19,column:24}},'1':{start:{line:20,column:4},end:{line:20,column:18}},'2':{start:{line:24,column:4},end:{line:31,column:5}},'3':{start:{line:25,column:6},end:{line:29,column:10}},'4':{start:{line:25,column:34},end:{line:29,column:7}},'5':{start:{line:30,column:6},end:{line:30,column:20}},'6':{start:{line:32,column:4},end:{line:54,column:5}},'7':{start:{line:33,column:30},end:{line:33,column:34}},'8':{start:{line:34,column:6},end:{line:36,column:7}},'9':{start:{line:35,column:8},end:{line:35,column:34}},'10':{start:{line:37,column:6},end:{line:52,column:7}},'11':{start:{line:38,column:8},end:{line:51,column:9}},'12':{start:{line:39,column:22},end:{line:39,column:31}},'13':{start:{line:40,column:24},end:{line:40,column:56}},'14':{start:{line:41,column:10},end:{line:41,column:136}},'15':{start:{line:41,column:75},end:{line:41,column:136}},'16':{start:{line:42,column:10},end:{line:42,column:284}},'17':{start:{line:42,column:148},end:{line:42,column:284}},'18':{start:{line:43,column:10},end:{line:43,column:40}},'19':{start:{line:45,column:13},end:{line:51,column:9}},'20':{start:{line:46,column:22},end:{line:46,column:29}},'21':{start:{line:47,column:24},end:{line:47,column:56}},'22':{start:{line:48,column:10},end:{line:48,column:132}},'23':{start:{line:48,column:73},end:{line:48,column:132}},'24':{start:{line:49,column:10},end:{line:49,column:280}},'25':{start:{line:49,column:146},end:{line:49,column:280}},'26':{start:{line:50,column:10},end:{line:50,column:38}},'27':{start:{line:57,column:4},end:{line:59,column:5}},'28':{start:{line:58,column:6},end:{line:58,column:33}},'29':{start:{line:62,column:4},end:{line:64,column:5}},'30':{start:{line:63,column:6},end:{line:63,column:24}},'31':{start:{line:65,column:4},end:{line:65,column:16}},'32':{start:{line:69,column:24},end:{line:77,column:1}},'33':{start:{line:70,column:4},end:{line:76,column:6}},'34':{start:{line:79,column:27},end:{line:85,column:1}},'35':{start:{line:80,column:4},end:{line:84,column:5}},'36':{start:{line:81,column:22},end:{line:81,column:62}},'37':{start:{line:82,column:29},end:{line:82,column:76}},'38':{start:{line:83,column:36},end:{line:83,column:81}}},fnMap:{'0':{name:'(anonymous_0)',decl:{start:{line:18,column:2},end:{line:18,column:3}},loc:{start:{line:18,column:22},end:{line:21,column:3}},line:18},'1':{name:'(anonymous_1)',decl:{start:{line:22,column:23},end:{line:22,column:24}},loc:{start:{line:22,column:59},end:{line:55,column:3}},line:22},'2':{name:'(anonymous_2)',decl:{start:{line:25,column:20},end:{line:25,column:21}},loc:{start:{line:25,column:34},end:{line:29,column:7}},line:25},'3':{name:'(anonymous_3)',decl:{start:{line:56,column:11},end:{line:56,column:12}},loc:{start:{line:56,column:17},end:{line:60,column:3}},line:56},'4':{name:'(anonymous_4)',decl:{start:{line:61,column:2},end:{line:61,column:3}},loc:{start:{line:61,column:11},end:{line:66,column:3}},line:61},'5':{name:'(anonymous_5)',decl:{start:{line:69,column:24},end:{line:69,column:25}},loc:{start:{line:69,column:33},end:{line:77,column:1}},line:69},'6':{name:'(anonymous_6)',decl:{start:{line:79,column:27},end:{line:79,column:28}},loc:{start:{line:79,column:39},end:{line:85,column:1}},line:79},'7':{name:'(anonymous_7)',decl:{start:{line:81,column:16},end:{line:81,column:17}},loc:{start:{line:81,column:22},end:{line:81,column:62}},line:81},'8':{name:'(anonymous_8)',decl:{start:{line:82,column:23},end:{line:82,column:24}},loc:{start:{line:82,column:29},end:{line:82,column:76}},line:82},'9':{name:'(anonymous_9)',decl:{start:{line:83,column:30},end:{line:83,column:31}},loc:{start:{line:83,column:36},end:{line:83,column:81}},line:83}},branchMap:{'0':{loc:{start:{line:24,column:4},end:{line:31,column:5}},type:'if',locations:[{start:{line:24,column:4},end:{line:31,column:5}},{start:{line:24,column:4},end:{line:31,column:5}}],line:24},'1':{loc:{start:{line:32,column:4},end:{line:54,column:5}},type:'if',locations:[{start:{line:32,column:4},end:{line:54,column:5}},{start:{line:32,column:4},end:{line:54,column:5}}],line:32},'2':{loc:{start:{line:34,column:6},end:{line:36,column:7}},type:'if',locations:[{start:{line:34,column:6},end:{line:36,column:7}},{start:{line:34,column:6},end:{line:36,column:7}}],line:34},'3':{loc:{start:{line:34,column:9},end:{line:34,column:103}},type:'binary-expr',locations:[{start:{line:34,column:9},end:{line:34,column:46}},{start:{line:34,column:50},end:{line:34,column:103}}],line:34},'4':{loc:{start:{line:37,column:6},end:{line:52,column:7}},type:'if',locations:[{start:{line:37,column:6},end:{line:52,column:7}},{start:{line:37,column:6},end:{line:52,column:7}}],line:37},'5':{loc:{start:{line:38,column:8},end:{line:51,column:9}},type:'if',locations:[{start:{line:38,column:8},end:{line:51,column:9}},{start:{line:38,column:8},end:{line:51,column:9}}],line:38},'6':{loc:{start:{line:41,column:10},end:{line:41,column:136}},type:'if',locations:[{start:{line:41,column:10},end:{line:41,column:136}},{start:{line:41,column:10},end:{line:41,column:136}}],line:41},'7':{loc:{start:{line:42,column:10},end:{line:42,column:284}},type:'if',locations:[{start:{line:42,column:10},end:{line:42,column:284}},{start:{line:42,column:10},end:{line:42,column:284}}],line:42},'8':{loc:{start:{line:45,column:13},end:{line:51,column:9}},type:'if',locations:[{start:{line:45,column:13},end:{line:51,column:9}},{start:{line:45,column:13},end:{line:51,column:9}}],line:45},'9':{loc:{start:{line:48,column:10},end:{line:48,column:132}},type:'if',locations:[{start:{line:48,column:10},end:{line:48,column:132}},{start:{line:48,column:10},end:{line:48,column:132}}],line:48},'10':{loc:{start:{line:49,column:10},end:{line:49,column:280}},type:'if',locations:[{start:{line:49,column:10},end:{line:49,column:280}},{start:{line:49,column:10},end:{line:49,column:280}}],line:49},'11':{loc:{start:{line:57,column:4},end:{line:59,column:5}},type:'if',locations:[{start:{line:57,column:4},end:{line:59,column:5}},{start:{line:57,column:4},end:{line:59,column:5}}],line:57},'12':{loc:{start:{line:62,column:4},end:{line:64,column:5}},type:'if',locations:[{start:{line:62,column:4},end:{line:64,column:5}},{start:{line:62,column:4},end:{line:64,column:5}}],line:62},'13':{loc:{start:{line:62,column:7},end:{line:62,column:83}},type:'binary-expr',locations:[{start:{line:62,column:7},end:{line:62,column:44}},{start:{line:62,column:48},end:{line:62,column:83}}],line:62}},s:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0,'11':0,'12':0,'13':0,'14':0,'15':0,'16':0,'17':0,'18':0,'19':0,'20':0,'21':0,'22':0,'23':0,'24':0,'25':0,'26':0,'27':0,'28':0,'29':0,'30':0,'31':0,'32':0,'33':0,'34':0,'35':0,'36':0,'37':0,'38':0},f:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0},b:{'0':[0,0],'1':[0,0],'2':[0,0],'3':[0,0],'4':[0,0],'5':[0,0],'6':[0,0],'7':[0,0],'8':[0,0],'9':[0,0],'10':[0,0],'11':[0,0],'12':[0,0],'13':[0,0]},_coverageSchema:'332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'},coverage=global[gcv]||(global[gcv]={});if(coverage[path]&&coverage[path].hash===hash){return coverage[path];}coverageData.hash=hash;return coverage[path]=coverageData;}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Defaults=function(_ref){_inherits(Defaults,_ref);function Defaults(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Defaults);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Defaults.__proto__||Object.getPrototypeOf(Defaults)).call.apply(_ref2,[this].concat(args))),_this),_this.state={confirmMessage:{message:null}},_this.componentDidUpdate=function(prevProps,prevState,snapshot){cov_1hcv8w0ljs.f[1]++;cov_1hcv8w0ljs.s[2]++;//relogin
if(!Object.is(_this.props.auth,prevProps.auth)){cov_1hcv8w0ljs.b[0][0]++;cov_1hcv8w0ljs.s[3]++;_this.setState(function(prevState){cov_1hcv8w0ljs.f[2]++;cov_1hcv8w0ljs.s[4]++;return{confirmMessage:{message:null}};});cov_1hcv8w0ljs.s[5]++;_this.onInit();}else{cov_1hcv8w0ljs.b[0][1]++;}cov_1hcv8w0ljs.s[6]++;if(!Object.is(_this.props.visualMessage,prevProps.visualMessage)){cov_1hcv8w0ljs.b[1][0]++;var showVisualMessage=(cov_1hcv8w0ljs.s[7]++,true);cov_1hcv8w0ljs.s[8]++;if((cov_1hcv8w0ljs.b[3][0]++,_this.props.visualMessage.obj.response)&&(cov_1hcv8w0ljs.b[3][1]++,_this.props.visualMessage.obj.response.hideVisualError)){cov_1hcv8w0ljs.b[2][0]++;cov_1hcv8w0ljs.s[9]++;showVisualMessage=false;}else{cov_1hcv8w0ljs.b[2][1]++;}cov_1hcv8w0ljs.s[10]++;if(showVisualMessage){cov_1hcv8w0ljs.b[4][0]++;cov_1hcv8w0ljs.s[11]++;if(_this.props.visualMessage.type==='success'){cov_1hcv8w0ljs.b[5][0]++;var title=(cov_1hcv8w0ljs.s[12]++,"Success");var message=(cov_1hcv8w0ljs.s[13]++,_this.props.visualMessage.message);cov_1hcv8w0ljs.s[14]++;if(_this.props.translate('global.success.general.title')!=='-'){cov_1hcv8w0ljs.b[6][0]++;cov_1hcv8w0ljs.s[15]++;title=_this.props.translate('global.success.general.title');}else{cov_1hcv8w0ljs.b[6][1]++;}cov_1hcv8w0ljs.s[16]++;if(_this.props.translate('global.success.general.'+_this.props.visualMessage.scope+'.'+_this.props.visualMessage.key.toLowerCase())!=='-'){cov_1hcv8w0ljs.b[7][0]++;cov_1hcv8w0ljs.s[17]++;message=_this.props.translate('global.success.general.'+_this.props.visualMessage.scope+'.'+_this.props.visualMessage.key.toLowerCase());}else{cov_1hcv8w0ljs.b[7][1]++;}cov_1hcv8w0ljs.s[18]++;__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].success(title,message);}else{cov_1hcv8w0ljs.b[5][1]++;cov_1hcv8w0ljs.s[19]++;if(_this.props.visualMessage.type==='error'){cov_1hcv8w0ljs.b[8][0]++;var _title=(cov_1hcv8w0ljs.s[20]++,"Error");var _message=(cov_1hcv8w0ljs.s[21]++,_this.props.visualMessage.message);cov_1hcv8w0ljs.s[22]++;if(_this.props.translate('global.error.general.title')!=='-'){cov_1hcv8w0ljs.b[9][0]++;cov_1hcv8w0ljs.s[23]++;_title=_this.props.translate('global.error.general.title');}else{cov_1hcv8w0ljs.b[9][1]++;}cov_1hcv8w0ljs.s[24]++;if(_this.props.translate('global.error.general.'+_this.props.visualMessage.scope+'.'+_this.props.visualMessage.key.toLowerCase())!=='-'){cov_1hcv8w0ljs.b[10][0]++;cov_1hcv8w0ljs.s[25]++;_message=_this.props.translate('global.error.general.'+_this.props.visualMessage.scope+'.'+_this.props.visualMessage.key.toLowerCase());}else{cov_1hcv8w0ljs.b[10][1]++;}cov_1hcv8w0ljs.s[26]++;__WEBPACK_IMPORTED_MODULE_6_react_redux_toastr__["toastr"].error(_title,_message);}else{cov_1hcv8w0ljs.b[8][1]++;}}}else{cov_1hcv8w0ljs.b[4][1]++;}//this.props.onVisualMessageReset();
}else{cov_1hcv8w0ljs.b[1][1]++;}},_this.onInit=function(){cov_1hcv8w0ljs.f[3]++;cov_1hcv8w0ljs.s[27]++;if(_this.props.auth.isAuthenticated){cov_1hcv8w0ljs.b[11][0]++;cov_1hcv8w0ljs.s[28]++;_this.props.onInitCompany();}else{cov_1hcv8w0ljs.b[11][1]++;}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Defaults,[{key:'componentDidMount',value:function componentDidMount(){cov_1hcv8w0ljs.f[0]++;cov_1hcv8w0ljs.s[0]++;this.props.onInit();cov_1hcv8w0ljs.s[1]++;this.onInit();}},{key:'render',value:function render(){cov_1hcv8w0ljs.f[4]++;cov_1hcv8w0ljs.s[29]++;if((cov_1hcv8w0ljs.b[13][0]++,this.props.state.running_requests>0)&&(cov_1hcv8w0ljs.b[13][1]++,this.props.state.show_globalSpinner)){cov_1hcv8w0ljs.b[12][0]++;cov_1hcv8w0ljs.s[30]++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components__["Loading"],null);}else{cov_1hcv8w0ljs.b[12][1]++;}cov_1hcv8w0ljs.s[31]++;return null;}}]);return Defaults;}((__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));cov_1hcv8w0ljs.s[32]++;var mapStateToProps=function mapStateToProps(state){cov_1hcv8w0ljs.f[5]++;cov_1hcv8w0ljs.s[33]++;return{defaults:state.defaults,state:state.fetching,auth:state.auth,visualMessage:state.visualMessage,translate:Object(__WEBPACK_IMPORTED_MODULE_5_react_localize_redux__["d" /* getTranslate */])(state.locale)};};cov_1hcv8w0ljs.s[34]++;var mapDispatchToProps=function mapDispatchToProps(dispatch){cov_1hcv8w0ljs.f[6]++;cov_1hcv8w0ljs.s[35]++;return{onInit:function onInit(){cov_1hcv8w0ljs.f[7]++;cov_1hcv8w0ljs.s[36]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["R" /* defaultsFetch */]());},onInitCompany:function onInitCompany(){cov_1hcv8w0ljs.f[8]++;cov_1hcv8w0ljs.s[37]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["_2" /* settingsCompanyFetch */]());},onVisualMessageReset:function onVisualMessageReset(){cov_1hcv8w0ljs.f[9]++;cov_1hcv8w0ljs.s[38]++;return dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_index__["_6" /* visualMessageReset */]());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3__hoc_withErrorHandler__["a" /* default */])(Defaults,__WEBPACK_IMPORTED_MODULE_2__services_api_axios__["a" /* default */])));

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.3686657b.js